
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

/*
ol-mapbox-style - Use Mapbox/MapLibre Style objects with OpenLayers
Copyright 2016-present ol-mapbox-style contributors
License: https://raw.githubusercontent.com/openlayers/ol-mapbox-style/master/LICENSE
*/ var $ed234ca8eb1f5a84$var$$version = 8;
var $ed234ca8eb1f5a84$var$$root = {
    version: {
        required: true,
        type: "enum",
        values: [
            8
        ]
    },
    name: {
        type: "string"
    },
    metadata: {
        type: "*"
    },
    center: {
        type: "array",
        value: "number",
        length: 2
    },
    centerAltitude: {
        type: "number"
    },
    zoom: {
        type: "number"
    },
    bearing: {
        type: "number",
        "default": 0,
        period: 360,
        units: "degrees"
    },
    pitch: {
        type: "number",
        "default": 0,
        units: "degrees"
    },
    roll: {
        type: "number",
        "default": 0,
        units: "degrees"
    },
    state: {
        type: "state",
        "default": {}
    },
    light: {
        type: "light"
    },
    sky: {
        type: "sky"
    },
    projection: {
        type: "projection"
    },
    terrain: {
        type: "terrain"
    },
    sources: {
        required: true,
        type: "sources"
    },
    sprite: {
        type: "sprite"
    },
    glyphs: {
        type: "string"
    },
    "font-faces": {
        type: "fontFaces"
    },
    transition: {
        type: "transition"
    },
    layers: {
        required: true,
        type: "array",
        value: "layer"
    }
};
var $ed234ca8eb1f5a84$var$sources = {
    "*": {
        type: "source"
    }
};
var $ed234ca8eb1f5a84$var$source = [
    "source_vector",
    "source_raster",
    "source_raster_dem",
    "source_geojson",
    "source_video",
    "source_image"
];
var $ed234ca8eb1f5a84$var$source_vector = {
    type: {
        required: true,
        type: "enum",
        values: {
            vector: {}
        }
    },
    url: {
        type: "string"
    },
    tiles: {
        type: "array",
        value: "string"
    },
    bounds: {
        type: "array",
        value: "number",
        length: 4,
        "default": [
            -180,
            -85.051129,
            180,
            85.051129
        ]
    },
    scheme: {
        type: "enum",
        values: {
            xyz: {},
            tms: {}
        },
        "default": "xyz"
    },
    minzoom: {
        type: "number",
        "default": 0
    },
    maxzoom: {
        type: "number",
        "default": 22
    },
    attribution: {
        type: "string"
    },
    promoteId: {
        type: "promoteId"
    },
    volatile: {
        type: "boolean",
        "default": false
    },
    encoding: {
        type: "enum",
        values: {
            mvt: {},
            mlt: {}
        },
        "default": "mvt"
    },
    "*": {
        type: "*"
    }
};
var $ed234ca8eb1f5a84$var$source_raster = {
    type: {
        required: true,
        type: "enum",
        values: {
            raster: {}
        }
    },
    url: {
        type: "string"
    },
    tiles: {
        type: "array",
        value: "string"
    },
    bounds: {
        type: "array",
        value: "number",
        length: 4,
        "default": [
            -180,
            -85.051129,
            180,
            85.051129
        ]
    },
    minzoom: {
        type: "number",
        "default": 0
    },
    maxzoom: {
        type: "number",
        "default": 22
    },
    tileSize: {
        type: "number",
        "default": 512,
        units: "pixels"
    },
    scheme: {
        type: "enum",
        values: {
            xyz: {},
            tms: {}
        },
        "default": "xyz"
    },
    attribution: {
        type: "string"
    },
    volatile: {
        type: "boolean",
        "default": false
    },
    "*": {
        type: "*"
    }
};
var $ed234ca8eb1f5a84$var$source_raster_dem = {
    type: {
        required: true,
        type: "enum",
        values: {
            "raster-dem": {}
        }
    },
    url: {
        type: "string"
    },
    tiles: {
        type: "array",
        value: "string"
    },
    bounds: {
        type: "array",
        value: "number",
        length: 4,
        "default": [
            -180,
            -85.051129,
            180,
            85.051129
        ]
    },
    minzoom: {
        type: "number",
        "default": 0
    },
    maxzoom: {
        type: "number",
        "default": 22
    },
    tileSize: {
        type: "number",
        "default": 512,
        units: "pixels"
    },
    attribution: {
        type: "string"
    },
    encoding: {
        type: "enum",
        values: {
            terrarium: {},
            mapbox: {},
            custom: {}
        },
        "default": "mapbox"
    },
    redFactor: {
        type: "number",
        "default": 1
    },
    blueFactor: {
        type: "number",
        "default": 1
    },
    greenFactor: {
        type: "number",
        "default": 1
    },
    baseShift: {
        type: "number",
        "default": 0
    },
    volatile: {
        type: "boolean",
        "default": false
    },
    "*": {
        type: "*"
    }
};
var $ed234ca8eb1f5a84$var$source_geojson = {
    type: {
        required: true,
        type: "enum",
        values: {
            geojson: {}
        }
    },
    data: {
        required: true,
        type: "*"
    },
    maxzoom: {
        type: "number",
        "default": 18
    },
    attribution: {
        type: "string"
    },
    buffer: {
        type: "number",
        "default": 128,
        maximum: 512,
        minimum: 0
    },
    filter: {
        type: "filter"
    },
    tolerance: {
        type: "number",
        "default": 0.375
    },
    cluster: {
        type: "boolean",
        "default": false
    },
    clusterRadius: {
        type: "number",
        "default": 50,
        minimum: 0
    },
    clusterMaxZoom: {
        type: "number"
    },
    clusterMinPoints: {
        type: "number"
    },
    clusterProperties: {
        type: "*"
    },
    lineMetrics: {
        type: "boolean",
        "default": false
    },
    generateId: {
        type: "boolean",
        "default": false
    },
    promoteId: {
        type: "promoteId"
    }
};
var $ed234ca8eb1f5a84$var$source_video = {
    type: {
        required: true,
        type: "enum",
        values: {
            video: {}
        }
    },
    urls: {
        required: true,
        type: "array",
        value: "string"
    },
    coordinates: {
        required: true,
        type: "array",
        length: 4,
        value: {
            type: "array",
            length: 2,
            value: "number"
        }
    }
};
var $ed234ca8eb1f5a84$var$source_image = {
    type: {
        required: true,
        type: "enum",
        values: {
            image: {}
        }
    },
    url: {
        required: true,
        type: "string"
    },
    coordinates: {
        required: true,
        type: "array",
        length: 4,
        value: {
            type: "array",
            length: 2,
            value: "number"
        }
    }
};
var $ed234ca8eb1f5a84$var$layer = {
    id: {
        type: "string",
        required: true
    },
    type: {
        type: "enum",
        values: {
            fill: {},
            line: {},
            symbol: {},
            circle: {},
            heatmap: {},
            "fill-extrusion": {},
            raster: {},
            hillshade: {},
            "color-relief": {},
            background: {}
        },
        required: true
    },
    metadata: {
        type: "*"
    },
    source: {
        type: "string"
    },
    "source-layer": {
        type: "string"
    },
    minzoom: {
        type: "number",
        minimum: 0,
        maximum: 24
    },
    maxzoom: {
        type: "number",
        minimum: 0,
        maximum: 24
    },
    filter: {
        type: "filter"
    },
    layout: {
        type: "layout"
    },
    paint: {
        type: "paint"
    }
};
var $ed234ca8eb1f5a84$var$layout = [
    "layout_fill",
    "layout_line",
    "layout_circle",
    "layout_heatmap",
    "layout_fill-extrusion",
    "layout_symbol",
    "layout_raster",
    "layout_hillshade",
    "layout_color-relief",
    "layout_background"
];
var $ed234ca8eb1f5a84$var$layout_background = {
    visibility: {
        type: "enum",
        values: {
            visible: {},
            none: {}
        },
        "default": "visible",
        expression: {
            interpolated: false,
            parameters: [
                "global-state"
            ]
        },
        "property-type": "data-constant"
    }
};
var $ed234ca8eb1f5a84$var$layout_fill = {
    "fill-sort-key": {
        type: "number",
        expression: {
            interpolated: false,
            parameters: [
                "zoom",
                "feature"
            ]
        },
        "property-type": "data-driven"
    },
    visibility: {
        type: "enum",
        values: {
            visible: {},
            none: {}
        },
        "default": "visible",
        expression: {
            interpolated: false,
            parameters: [
                "global-state"
            ]
        },
        "property-type": "data-constant"
    }
};
var $ed234ca8eb1f5a84$var$layout_circle = {
    "circle-sort-key": {
        type: "number",
        expression: {
            interpolated: false,
            parameters: [
                "zoom",
                "feature"
            ]
        },
        "property-type": "data-driven"
    },
    visibility: {
        type: "enum",
        values: {
            visible: {},
            none: {}
        },
        "default": "visible",
        expression: {
            interpolated: false,
            parameters: [
                "global-state"
            ]
        },
        "property-type": "data-constant"
    }
};
var $ed234ca8eb1f5a84$var$layout_heatmap = {
    visibility: {
        type: "enum",
        values: {
            visible: {},
            none: {}
        },
        "default": "visible",
        expression: {
            interpolated: false,
            parameters: [
                "global-state"
            ]
        },
        "property-type": "data-constant"
    }
};
var $ed234ca8eb1f5a84$var$layout_line = {
    "line-cap": {
        type: "enum",
        values: {
            butt: {},
            round: {},
            square: {}
        },
        "default": "butt",
        expression: {
            interpolated: false,
            parameters: [
                "zoom",
                "feature"
            ]
        },
        "property-type": "data-driven"
    },
    "line-join": {
        type: "enum",
        values: {
            bevel: {},
            round: {},
            miter: {}
        },
        "default": "miter",
        expression: {
            interpolated: false,
            parameters: [
                "zoom",
                "feature"
            ]
        },
        "property-type": "data-driven"
    },
    "line-miter-limit": {
        type: "number",
        "default": 2,
        requires: [
            {
                "line-join": "miter"
            }
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature"
            ]
        },
        "property-type": "data-driven"
    },
    "line-round-limit": {
        type: "number",
        "default": 1.05,
        requires: [
            {
                "line-join": "round"
            }
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature"
            ]
        },
        "property-type": "data-driven"
    },
    "line-sort-key": {
        type: "number",
        expression: {
            interpolated: false,
            parameters: [
                "zoom",
                "feature"
            ]
        },
        "property-type": "data-driven"
    },
    visibility: {
        type: "enum",
        values: {
            visible: {},
            none: {}
        },
        "default": "visible",
        expression: {
            interpolated: false,
            parameters: [
                "global-state"
            ]
        },
        "property-type": "data-constant"
    }
};
var $ed234ca8eb1f5a84$var$layout_symbol = {
    "symbol-placement": {
        type: "enum",
        values: {
            point: {},
            line: {},
            "line-center": {}
        },
        "default": "point",
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "symbol-spacing": {
        type: "number",
        "default": 250,
        minimum: 1,
        units: "pixels",
        requires: [
            {
                "symbol-placement": "line"
            }
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "symbol-avoid-edges": {
        type: "boolean",
        "default": false,
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "symbol-sort-key": {
        type: "number",
        expression: {
            interpolated: false,
            parameters: [
                "zoom",
                "feature"
            ]
        },
        "property-type": "data-driven"
    },
    "symbol-z-order": {
        type: "enum",
        values: {
            auto: {},
            "viewport-y": {},
            source: {}
        },
        "default": "auto",
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "icon-allow-overlap": {
        type: "boolean",
        "default": false,
        requires: [
            "icon-image",
            {
                "!": "icon-overlap"
            }
        ],
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "icon-overlap": {
        type: "enum",
        values: {
            never: {},
            always: {},
            cooperative: {}
        },
        requires: [
            "icon-image"
        ],
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "icon-ignore-placement": {
        type: "boolean",
        "default": false,
        requires: [
            "icon-image"
        ],
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "icon-optional": {
        type: "boolean",
        "default": false,
        requires: [
            "icon-image",
            "text-field"
        ],
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "icon-rotation-alignment": {
        type: "enum",
        values: {
            map: {},
            viewport: {},
            auto: {}
        },
        "default": "auto",
        requires: [
            "icon-image"
        ],
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "icon-size": {
        type: "number",
        "default": 1,
        minimum: 0,
        units: "factor of the original icon size",
        requires: [
            "icon-image"
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature"
            ]
        },
        "property-type": "data-driven"
    },
    "icon-text-fit": {
        type: "enum",
        values: {
            none: {},
            width: {},
            height: {},
            both: {}
        },
        "default": "none",
        requires: [
            "icon-image",
            "text-field"
        ],
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "icon-text-fit-padding": {
        type: "array",
        value: "number",
        length: 4,
        "default": [
            0,
            0,
            0,
            0
        ],
        units: "pixels",
        requires: [
            "icon-image",
            "text-field",
            {
                "icon-text-fit": [
                    "both",
                    "width",
                    "height"
                ]
            }
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "icon-image": {
        type: "resolvedImage",
        tokens: true,
        expression: {
            interpolated: false,
            parameters: [
                "zoom",
                "feature"
            ]
        },
        "property-type": "data-driven"
    },
    "icon-rotate": {
        type: "number",
        "default": 0,
        period: 360,
        units: "degrees",
        requires: [
            "icon-image"
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature"
            ]
        },
        "property-type": "data-driven"
    },
    "icon-padding": {
        type: "padding",
        "default": [
            2
        ],
        units: "pixels",
        requires: [
            "icon-image"
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature"
            ]
        },
        "property-type": "data-driven"
    },
    "icon-keep-upright": {
        type: "boolean",
        "default": false,
        requires: [
            "icon-image",
            {
                "icon-rotation-alignment": "map"
            },
            {
                "symbol-placement": [
                    "line",
                    "line-center"
                ]
            }
        ],
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "icon-offset": {
        type: "array",
        value: "number",
        length: 2,
        "default": [
            0,
            0
        ],
        requires: [
            "icon-image"
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature"
            ]
        },
        "property-type": "data-driven"
    },
    "icon-anchor": {
        type: "enum",
        values: {
            center: {},
            left: {},
            right: {},
            top: {},
            bottom: {},
            "top-left": {},
            "top-right": {},
            "bottom-left": {},
            "bottom-right": {}
        },
        "default": "center",
        requires: [
            "icon-image"
        ],
        expression: {
            interpolated: false,
            parameters: [
                "zoom",
                "feature"
            ]
        },
        "property-type": "data-driven"
    },
    "icon-pitch-alignment": {
        type: "enum",
        values: {
            map: {},
            viewport: {},
            auto: {}
        },
        "default": "auto",
        requires: [
            "icon-image"
        ],
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "text-pitch-alignment": {
        type: "enum",
        values: {
            map: {},
            viewport: {},
            auto: {}
        },
        "default": "auto",
        requires: [
            "text-field"
        ],
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "text-rotation-alignment": {
        type: "enum",
        values: {
            map: {},
            viewport: {},
            "viewport-glyph": {},
            auto: {}
        },
        "default": "auto",
        requires: [
            "text-field"
        ],
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "text-field": {
        type: "formatted",
        "default": "",
        tokens: true,
        expression: {
            interpolated: false,
            parameters: [
                "zoom",
                "feature"
            ]
        },
        "property-type": "data-driven"
    },
    "text-font": {
        type: "array",
        value: "string",
        "default": [
            "Open Sans Regular",
            "Arial Unicode MS Regular"
        ],
        requires: [
            "text-field"
        ],
        expression: {
            interpolated: false,
            parameters: [
                "zoom",
                "feature"
            ]
        },
        "property-type": "data-driven"
    },
    "text-size": {
        type: "number",
        "default": 16,
        minimum: 0,
        units: "pixels",
        requires: [
            "text-field"
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature"
            ]
        },
        "property-type": "data-driven"
    },
    "text-max-width": {
        type: "number",
        "default": 10,
        minimum: 0,
        units: "ems",
        requires: [
            "text-field"
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature"
            ]
        },
        "property-type": "data-driven"
    },
    "text-line-height": {
        type: "number",
        "default": 1.2,
        units: "ems",
        requires: [
            "text-field"
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "text-letter-spacing": {
        type: "number",
        "default": 0,
        units: "ems",
        requires: [
            "text-field"
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature"
            ]
        },
        "property-type": "data-driven"
    },
    "text-justify": {
        type: "enum",
        values: {
            auto: {},
            left: {},
            center: {},
            right: {}
        },
        "default": "center",
        requires: [
            "text-field"
        ],
        expression: {
            interpolated: false,
            parameters: [
                "zoom",
                "feature"
            ]
        },
        "property-type": "data-driven"
    },
    "text-radial-offset": {
        type: "number",
        units: "ems",
        "default": 0,
        requires: [
            "text-field"
        ],
        "property-type": "data-driven",
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature"
            ]
        }
    },
    "text-variable-anchor": {
        type: "array",
        value: "enum",
        values: {
            center: {},
            left: {},
            right: {},
            top: {},
            bottom: {},
            "top-left": {},
            "top-right": {},
            "bottom-left": {},
            "bottom-right": {}
        },
        requires: [
            "text-field",
            {
                "symbol-placement": [
                    "point"
                ]
            }
        ],
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "text-variable-anchor-offset": {
        type: "variableAnchorOffsetCollection",
        requires: [
            "text-field",
            {
                "symbol-placement": [
                    "point"
                ]
            }
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature"
            ]
        },
        "property-type": "data-driven"
    },
    "text-anchor": {
        type: "enum",
        values: {
            center: {},
            left: {},
            right: {},
            top: {},
            bottom: {},
            "top-left": {},
            "top-right": {},
            "bottom-left": {},
            "bottom-right": {}
        },
        "default": "center",
        requires: [
            "text-field",
            {
                "!": "text-variable-anchor"
            }
        ],
        expression: {
            interpolated: false,
            parameters: [
                "zoom",
                "feature"
            ]
        },
        "property-type": "data-driven"
    },
    "text-max-angle": {
        type: "number",
        "default": 45,
        units: "degrees",
        requires: [
            "text-field",
            {
                "symbol-placement": [
                    "line",
                    "line-center"
                ]
            }
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "text-writing-mode": {
        type: "array",
        value: "enum",
        values: {
            horizontal: {},
            vertical: {}
        },
        requires: [
            "text-field",
            {
                "symbol-placement": [
                    "point"
                ]
            }
        ],
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "text-rotate": {
        type: "number",
        "default": 0,
        period: 360,
        units: "degrees",
        requires: [
            "text-field"
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature"
            ]
        },
        "property-type": "data-driven"
    },
    "text-padding": {
        type: "number",
        "default": 2,
        minimum: 0,
        units: "pixels",
        requires: [
            "text-field"
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "text-keep-upright": {
        type: "boolean",
        "default": true,
        requires: [
            "text-field",
            {
                "text-rotation-alignment": "map"
            },
            {
                "symbol-placement": [
                    "line",
                    "line-center"
                ]
            }
        ],
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "text-transform": {
        type: "enum",
        values: {
            none: {},
            uppercase: {},
            lowercase: {}
        },
        "default": "none",
        requires: [
            "text-field"
        ],
        expression: {
            interpolated: false,
            parameters: [
                "zoom",
                "feature"
            ]
        },
        "property-type": "data-driven"
    },
    "text-offset": {
        type: "array",
        value: "number",
        units: "ems",
        length: 2,
        "default": [
            0,
            0
        ],
        requires: [
            "text-field",
            {
                "!": "text-radial-offset"
            }
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature"
            ]
        },
        "property-type": "data-driven"
    },
    "text-allow-overlap": {
        type: "boolean",
        "default": false,
        requires: [
            "text-field",
            {
                "!": "text-overlap"
            }
        ],
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "text-overlap": {
        type: "enum",
        values: {
            never: {},
            always: {},
            cooperative: {}
        },
        requires: [
            "text-field"
        ],
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "text-ignore-placement": {
        type: "boolean",
        "default": false,
        requires: [
            "text-field"
        ],
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "text-optional": {
        type: "boolean",
        "default": false,
        requires: [
            "text-field",
            "icon-image"
        ],
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    visibility: {
        type: "enum",
        values: {
            visible: {},
            none: {}
        },
        "default": "visible",
        expression: {
            interpolated: false,
            parameters: [
                "global-state"
            ]
        },
        "property-type": "data-constant"
    }
};
var $ed234ca8eb1f5a84$var$layout_raster = {
    visibility: {
        type: "enum",
        values: {
            visible: {},
            none: {}
        },
        "default": "visible",
        expression: {
            interpolated: false,
            parameters: [
                "global-state"
            ]
        },
        "property-type": "data-constant"
    }
};
var $ed234ca8eb1f5a84$var$layout_hillshade = {
    visibility: {
        type: "enum",
        values: {
            visible: {},
            none: {}
        },
        "default": "visible",
        expression: {
            interpolated: false,
            parameters: [
                "global-state"
            ]
        },
        "property-type": "data-constant"
    }
};
var $ed234ca8eb1f5a84$var$filter = {
    type: "boolean",
    expression: {
        interpolated: false,
        parameters: [
            "zoom",
            "feature"
        ]
    },
    "property-type": "data-driven"
};
var $ed234ca8eb1f5a84$var$filter_operator = {
    type: "enum",
    values: {
        "==": {},
        "!=": {},
        ">": {},
        ">=": {},
        "<": {},
        "<=": {},
        "in": {},
        "!in": {},
        all: {},
        any: {},
        none: {},
        has: {},
        "!has": {}
    }
};
var $ed234ca8eb1f5a84$var$geometry_type = {
    type: "enum",
    values: {
        Point: {},
        LineString: {},
        Polygon: {}
    }
};
var $ed234ca8eb1f5a84$var$function_stop = {
    type: "array",
    minimum: 0,
    maximum: 24,
    value: [
        "number",
        "color"
    ],
    length: 2
};
var $ed234ca8eb1f5a84$var$expression$1 = {
    type: "array",
    value: "expression_name",
    minimum: 1
};
var $ed234ca8eb1f5a84$var$light = {
    anchor: {
        type: "enum",
        "default": "viewport",
        values: {
            map: {},
            viewport: {}
        },
        "property-type": "data-constant",
        transition: false,
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        }
    },
    position: {
        type: "array",
        "default": [
            1.15,
            210,
            30
        ],
        length: 3,
        value: "number",
        "property-type": "data-constant",
        transition: true,
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        }
    },
    color: {
        type: "color",
        "property-type": "data-constant",
        "default": "#ffffff",
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        transition: true
    },
    intensity: {
        type: "number",
        "property-type": "data-constant",
        "default": 0.5,
        minimum: 0,
        maximum: 1,
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        transition: true
    }
};
var $ed234ca8eb1f5a84$var$sky = {
    "sky-color": {
        type: "color",
        "property-type": "data-constant",
        "default": "#88C6FC",
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        transition: true
    },
    "horizon-color": {
        type: "color",
        "property-type": "data-constant",
        "default": "#ffffff",
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        transition: true
    },
    "fog-color": {
        type: "color",
        "property-type": "data-constant",
        "default": "#ffffff",
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        transition: true
    },
    "fog-ground-blend": {
        type: "number",
        "property-type": "data-constant",
        "default": 0.5,
        minimum: 0,
        maximum: 1,
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        transition: true
    },
    "horizon-fog-blend": {
        type: "number",
        "property-type": "data-constant",
        "default": 0.8,
        minimum: 0,
        maximum: 1,
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        transition: true
    },
    "sky-horizon-blend": {
        type: "number",
        "property-type": "data-constant",
        "default": 0.8,
        minimum: 0,
        maximum: 1,
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        transition: true
    },
    "atmosphere-blend": {
        type: "number",
        "property-type": "data-constant",
        "default": 0.8,
        minimum: 0,
        maximum: 1,
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        transition: true
    }
};
var $ed234ca8eb1f5a84$var$terrain = {
    source: {
        type: "string",
        required: true
    },
    exaggeration: {
        type: "number",
        minimum: 0,
        "default": 1
    }
};
var $ed234ca8eb1f5a84$var$projection = {
    type: {
        type: "projectionDefinition",
        "default": "mercator",
        "property-type": "data-constant",
        transition: false,
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        }
    }
};
var $ed234ca8eb1f5a84$var$paint = [
    "paint_fill",
    "paint_line",
    "paint_circle",
    "paint_heatmap",
    "paint_fill-extrusion",
    "paint_symbol",
    "paint_raster",
    "paint_hillshade",
    "paint_color-relief",
    "paint_background"
];
var $ed234ca8eb1f5a84$var$paint_fill = {
    "fill-antialias": {
        type: "boolean",
        "default": true,
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "fill-opacity": {
        type: "number",
        "default": 1,
        minimum: 0,
        maximum: 1,
        transition: true,
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature",
                "feature-state"
            ]
        },
        "property-type": "data-driven"
    },
    "fill-color": {
        type: "color",
        "default": "#000000",
        transition: true,
        requires: [
            {
                "!": "fill-pattern"
            }
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature",
                "feature-state"
            ]
        },
        "property-type": "data-driven"
    },
    "fill-outline-color": {
        type: "color",
        transition: true,
        requires: [
            {
                "!": "fill-pattern"
            },
            {
                "fill-antialias": true
            }
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature",
                "feature-state"
            ]
        },
        "property-type": "data-driven"
    },
    "fill-translate": {
        type: "array",
        value: "number",
        length: 2,
        "default": [
            0,
            0
        ],
        transition: true,
        units: "pixels",
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "fill-translate-anchor": {
        type: "enum",
        values: {
            map: {},
            viewport: {}
        },
        "default": "map",
        requires: [
            "fill-translate"
        ],
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "fill-pattern": {
        type: "resolvedImage",
        transition: true,
        expression: {
            interpolated: false,
            parameters: [
                "zoom",
                "feature"
            ]
        },
        "property-type": "cross-faded-data-driven"
    }
};
var $ed234ca8eb1f5a84$var$paint_line = {
    "line-opacity": {
        type: "number",
        "default": 1,
        minimum: 0,
        maximum: 1,
        transition: true,
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature",
                "feature-state"
            ]
        },
        "property-type": "data-driven"
    },
    "line-color": {
        type: "color",
        "default": "#000000",
        transition: true,
        requires: [
            {
                "!": "line-pattern"
            }
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature",
                "feature-state"
            ]
        },
        "property-type": "data-driven"
    },
    "line-translate": {
        type: "array",
        value: "number",
        length: 2,
        "default": [
            0,
            0
        ],
        transition: true,
        units: "pixels",
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "line-translate-anchor": {
        type: "enum",
        values: {
            map: {},
            viewport: {}
        },
        "default": "map",
        requires: [
            "line-translate"
        ],
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "line-width": {
        type: "number",
        "default": 1,
        minimum: 0,
        transition: true,
        units: "pixels",
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature",
                "feature-state"
            ]
        },
        "property-type": "data-driven"
    },
    "line-gap-width": {
        type: "number",
        "default": 0,
        minimum: 0,
        transition: true,
        units: "pixels",
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature",
                "feature-state"
            ]
        },
        "property-type": "data-driven"
    },
    "line-offset": {
        type: "number",
        "default": 0,
        transition: true,
        units: "pixels",
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature",
                "feature-state"
            ]
        },
        "property-type": "data-driven"
    },
    "line-blur": {
        type: "number",
        "default": 0,
        minimum: 0,
        transition: true,
        units: "pixels",
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature",
                "feature-state"
            ]
        },
        "property-type": "data-driven"
    },
    "line-dasharray": {
        type: "array",
        value: "number",
        minimum: 0,
        transition: true,
        units: "line widths",
        requires: [
            {
                "!": "line-pattern"
            }
        ],
        expression: {
            interpolated: false,
            parameters: [
                "zoom",
                "feature"
            ]
        },
        "property-type": "cross-faded-data-driven"
    },
    "line-pattern": {
        type: "resolvedImage",
        transition: true,
        expression: {
            interpolated: false,
            parameters: [
                "zoom",
                "feature"
            ]
        },
        "property-type": "cross-faded-data-driven"
    },
    "line-gradient": {
        type: "color",
        transition: false,
        requires: [
            {
                "!": "line-dasharray"
            },
            {
                "!": "line-pattern"
            },
            {
                source: "geojson",
                has: {
                    lineMetrics: true
                }
            }
        ],
        expression: {
            interpolated: true,
            parameters: [
                "line-progress"
            ]
        },
        "property-type": "color-ramp"
    }
};
var $ed234ca8eb1f5a84$var$paint_circle = {
    "circle-radius": {
        type: "number",
        "default": 5,
        minimum: 0,
        transition: true,
        units: "pixels",
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature",
                "feature-state"
            ]
        },
        "property-type": "data-driven"
    },
    "circle-color": {
        type: "color",
        "default": "#000000",
        transition: true,
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature",
                "feature-state"
            ]
        },
        "property-type": "data-driven"
    },
    "circle-blur": {
        type: "number",
        "default": 0,
        transition: true,
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature",
                "feature-state"
            ]
        },
        "property-type": "data-driven"
    },
    "circle-opacity": {
        type: "number",
        "default": 1,
        minimum: 0,
        maximum: 1,
        transition: true,
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature",
                "feature-state"
            ]
        },
        "property-type": "data-driven"
    },
    "circle-translate": {
        type: "array",
        value: "number",
        length: 2,
        "default": [
            0,
            0
        ],
        transition: true,
        units: "pixels",
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "circle-translate-anchor": {
        type: "enum",
        values: {
            map: {},
            viewport: {}
        },
        "default": "map",
        requires: [
            "circle-translate"
        ],
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "circle-pitch-scale": {
        type: "enum",
        values: {
            map: {},
            viewport: {}
        },
        "default": "map",
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "circle-pitch-alignment": {
        type: "enum",
        values: {
            map: {},
            viewport: {}
        },
        "default": "viewport",
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "circle-stroke-width": {
        type: "number",
        "default": 0,
        minimum: 0,
        transition: true,
        units: "pixels",
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature",
                "feature-state"
            ]
        },
        "property-type": "data-driven"
    },
    "circle-stroke-color": {
        type: "color",
        "default": "#000000",
        transition: true,
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature",
                "feature-state"
            ]
        },
        "property-type": "data-driven"
    },
    "circle-stroke-opacity": {
        type: "number",
        "default": 1,
        minimum: 0,
        maximum: 1,
        transition: true,
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature",
                "feature-state"
            ]
        },
        "property-type": "data-driven"
    }
};
var $ed234ca8eb1f5a84$var$paint_heatmap = {
    "heatmap-radius": {
        type: "number",
        "default": 30,
        minimum: 1,
        transition: true,
        units: "pixels",
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature",
                "feature-state"
            ]
        },
        "property-type": "data-driven"
    },
    "heatmap-weight": {
        type: "number",
        "default": 1,
        minimum: 0,
        transition: false,
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature",
                "feature-state"
            ]
        },
        "property-type": "data-driven"
    },
    "heatmap-intensity": {
        type: "number",
        "default": 1,
        minimum: 0,
        transition: true,
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "heatmap-color": {
        type: "color",
        "default": [
            "interpolate",
            [
                "linear"
            ],
            [
                "heatmap-density"
            ],
            0,
            "rgba(0, 0, 255, 0)",
            0.1,
            "royalblue",
            0.3,
            "cyan",
            0.5,
            "lime",
            0.7,
            "yellow",
            1,
            "red"
        ],
        transition: false,
        expression: {
            interpolated: true,
            parameters: [
                "heatmap-density"
            ]
        },
        "property-type": "color-ramp"
    },
    "heatmap-opacity": {
        type: "number",
        "default": 1,
        minimum: 0,
        maximum: 1,
        transition: true,
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    }
};
var $ed234ca8eb1f5a84$var$paint_symbol = {
    "icon-opacity": {
        type: "number",
        "default": 1,
        minimum: 0,
        maximum: 1,
        transition: true,
        requires: [
            "icon-image"
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature",
                "feature-state"
            ]
        },
        "property-type": "data-driven"
    },
    "icon-color": {
        type: "color",
        "default": "#000000",
        transition: true,
        requires: [
            "icon-image"
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature",
                "feature-state"
            ]
        },
        "property-type": "data-driven"
    },
    "icon-halo-color": {
        type: "color",
        "default": "rgba(0, 0, 0, 0)",
        transition: true,
        requires: [
            "icon-image"
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature",
                "feature-state"
            ]
        },
        "property-type": "data-driven"
    },
    "icon-halo-width": {
        type: "number",
        "default": 0,
        minimum: 0,
        transition: true,
        units: "pixels",
        requires: [
            "icon-image"
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature",
                "feature-state"
            ]
        },
        "property-type": "data-driven"
    },
    "icon-halo-blur": {
        type: "number",
        "default": 0,
        minimum: 0,
        transition: true,
        units: "pixels",
        requires: [
            "icon-image"
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature",
                "feature-state"
            ]
        },
        "property-type": "data-driven"
    },
    "icon-translate": {
        type: "array",
        value: "number",
        length: 2,
        "default": [
            0,
            0
        ],
        transition: true,
        units: "pixels",
        requires: [
            "icon-image"
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "icon-translate-anchor": {
        type: "enum",
        values: {
            map: {},
            viewport: {}
        },
        "default": "map",
        requires: [
            "icon-image",
            "icon-translate"
        ],
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "text-opacity": {
        type: "number",
        "default": 1,
        minimum: 0,
        maximum: 1,
        transition: true,
        requires: [
            "text-field"
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature",
                "feature-state"
            ]
        },
        "property-type": "data-driven"
    },
    "text-color": {
        type: "color",
        "default": "#000000",
        transition: true,
        overridable: true,
        requires: [
            "text-field"
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature",
                "feature-state"
            ]
        },
        "property-type": "data-driven"
    },
    "text-halo-color": {
        type: "color",
        "default": "rgba(0, 0, 0, 0)",
        transition: true,
        requires: [
            "text-field"
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature",
                "feature-state"
            ]
        },
        "property-type": "data-driven"
    },
    "text-halo-width": {
        type: "number",
        "default": 0,
        minimum: 0,
        transition: true,
        units: "pixels",
        requires: [
            "text-field"
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature",
                "feature-state"
            ]
        },
        "property-type": "data-driven"
    },
    "text-halo-blur": {
        type: "number",
        "default": 0,
        minimum: 0,
        transition: true,
        units: "pixels",
        requires: [
            "text-field"
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom",
                "feature",
                "feature-state"
            ]
        },
        "property-type": "data-driven"
    },
    "text-translate": {
        type: "array",
        value: "number",
        length: 2,
        "default": [
            0,
            0
        ],
        transition: true,
        units: "pixels",
        requires: [
            "text-field"
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "text-translate-anchor": {
        type: "enum",
        values: {
            map: {},
            viewport: {}
        },
        "default": "map",
        requires: [
            "text-field",
            "text-translate"
        ],
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    }
};
var $ed234ca8eb1f5a84$var$paint_raster = {
    "raster-opacity": {
        type: "number",
        "default": 1,
        minimum: 0,
        maximum: 1,
        transition: true,
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "raster-hue-rotate": {
        type: "number",
        "default": 0,
        period: 360,
        transition: true,
        units: "degrees",
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "raster-brightness-min": {
        type: "number",
        "default": 0,
        minimum: 0,
        maximum: 1,
        transition: true,
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "raster-brightness-max": {
        type: "number",
        "default": 1,
        minimum: 0,
        maximum: 1,
        transition: true,
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "raster-saturation": {
        type: "number",
        "default": 0,
        minimum: -1,
        maximum: 1,
        transition: true,
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "raster-contrast": {
        type: "number",
        "default": 0,
        minimum: -1,
        maximum: 1,
        transition: true,
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    resampling: {
        type: "enum",
        values: {
            linear: {},
            nearest: {}
        },
        "default": "linear",
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "raster-resampling": {
        type: "enum",
        values: {
            linear: {},
            nearest: {}
        },
        "default": "linear",
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "raster-fade-duration": {
        type: "number",
        "default": 300,
        minimum: 0,
        transition: false,
        units: "milliseconds",
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    }
};
var $ed234ca8eb1f5a84$var$paint_hillshade = {
    "hillshade-illumination-direction": {
        type: "numberArray",
        "default": 335,
        minimum: 0,
        maximum: 359,
        transition: false,
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "hillshade-illumination-altitude": {
        type: "numberArray",
        "default": 45,
        minimum: 0,
        maximum: 90,
        transition: false,
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "hillshade-illumination-anchor": {
        type: "enum",
        values: {
            map: {},
            viewport: {}
        },
        "default": "viewport",
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "hillshade-exaggeration": {
        type: "number",
        "default": 0.5,
        minimum: 0,
        maximum: 1,
        transition: true,
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "hillshade-shadow-color": {
        type: "colorArray",
        "default": "#000000",
        transition: true,
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "hillshade-highlight-color": {
        type: "colorArray",
        "default": "#FFFFFF",
        transition: true,
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "hillshade-accent-color": {
        type: "color",
        "default": "#000000",
        transition: true,
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "hillshade-method": {
        type: "enum",
        values: {
            standard: {},
            basic: {},
            combined: {},
            igor: {},
            multidirectional: {}
        },
        "default": "standard",
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    resampling: {
        type: "enum",
        values: {
            linear: {},
            nearest: {}
        },
        "default": "linear",
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    }
};
var $ed234ca8eb1f5a84$var$paint_background = {
    "background-color": {
        type: "color",
        "default": "#000000",
        transition: true,
        requires: [
            {
                "!": "background-pattern"
            }
        ],
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    },
    "background-pattern": {
        type: "resolvedImage",
        transition: true,
        expression: {
            interpolated: false,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "cross-faded"
    },
    "background-opacity": {
        type: "number",
        "default": 1,
        minimum: 0,
        maximum: 1,
        transition: true,
        expression: {
            interpolated: true,
            parameters: [
                "zoom"
            ]
        },
        "property-type": "data-constant"
    }
};
var $ed234ca8eb1f5a84$var$transition = {
    duration: {
        type: "number",
        "default": 300,
        minimum: 0,
        units: "milliseconds"
    },
    delay: {
        type: "number",
        "default": 0,
        minimum: 0,
        units: "milliseconds"
    }
};
var $ed234ca8eb1f5a84$var$promoteId = {
    "*": {
        type: "string"
    }
};
var $ed234ca8eb1f5a84$var$interpolation = {
    type: "array",
    value: "interpolation_name",
    minimum: 1
};
var $ed234ca8eb1f5a84$var$interpolation_name = {
    type: "enum",
    values: {
        linear: {
            syntax: {
                overloads: [
                    {
                        parameters: [],
                        "output-type": "interpolation"
                    }
                ],
                parameters: []
            }
        },
        exponential: {
            syntax: {
                overloads: [
                    {
                        parameters: [
                            "base"
                        ],
                        "output-type": "interpolation"
                    }
                ],
                parameters: [
                    {
                        name: "base",
                        type: "number literal"
                    }
                ]
            }
        },
        "cubic-bezier": {
            syntax: {
                overloads: [
                    {
                        parameters: [
                            "x1",
                            "y1",
                            "x2",
                            "y2"
                        ],
                        "output-type": "interpolation"
                    }
                ],
                parameters: [
                    {
                        name: "x1",
                        type: "number literal"
                    },
                    {
                        name: "y1",
                        type: "number literal"
                    },
                    {
                        name: "x2",
                        type: "number literal"
                    },
                    {
                        name: "y2",
                        type: "number literal"
                    }
                ]
            }
        }
    }
};
var $ed234ca8eb1f5a84$export$b8064d1c42a6b8 = {
    $version: $ed234ca8eb1f5a84$var$$version,
    $root: $ed234ca8eb1f5a84$var$$root,
    sources: $ed234ca8eb1f5a84$var$sources,
    source: $ed234ca8eb1f5a84$var$source,
    source_vector: $ed234ca8eb1f5a84$var$source_vector,
    source_raster: $ed234ca8eb1f5a84$var$source_raster,
    source_raster_dem: $ed234ca8eb1f5a84$var$source_raster_dem,
    source_geojson: $ed234ca8eb1f5a84$var$source_geojson,
    source_video: $ed234ca8eb1f5a84$var$source_video,
    source_image: $ed234ca8eb1f5a84$var$source_image,
    layer: $ed234ca8eb1f5a84$var$layer,
    layout: $ed234ca8eb1f5a84$var$layout,
    layout_background: $ed234ca8eb1f5a84$var$layout_background,
    layout_fill: $ed234ca8eb1f5a84$var$layout_fill,
    layout_circle: $ed234ca8eb1f5a84$var$layout_circle,
    layout_heatmap: $ed234ca8eb1f5a84$var$layout_heatmap,
    "layout_fill-extrusion": {
        visibility: {
            type: "enum",
            values: {
                visible: {},
                none: {}
            },
            "default": "visible",
            expression: {
                interpolated: false,
                parameters: [
                    "global-state"
                ]
            },
            "property-type": "data-constant"
        }
    },
    layout_line: $ed234ca8eb1f5a84$var$layout_line,
    layout_symbol: $ed234ca8eb1f5a84$var$layout_symbol,
    layout_raster: $ed234ca8eb1f5a84$var$layout_raster,
    layout_hillshade: $ed234ca8eb1f5a84$var$layout_hillshade,
    "layout_color-relief": {
        visibility: {
            type: "enum",
            values: {
                visible: {},
                none: {}
            },
            "default": "visible",
            expression: {
                interpolated: false,
                parameters: [
                    "global-state"
                ]
            },
            "property-type": "data-constant"
        }
    },
    filter: $ed234ca8eb1f5a84$var$filter,
    filter_operator: $ed234ca8eb1f5a84$var$filter_operator,
    geometry_type: $ed234ca8eb1f5a84$var$geometry_type,
    "function": {
        expression: {
            type: "expression"
        },
        stops: {
            type: "array",
            value: "function_stop"
        },
        base: {
            type: "number",
            "default": 1,
            minimum: 0
        },
        property: {
            type: "string",
            "default": "$zoom"
        },
        type: {
            type: "enum",
            values: {
                identity: {},
                exponential: {},
                interval: {},
                categorical: {}
            },
            "default": "exponential"
        },
        colorSpace: {
            type: "enum",
            values: {
                rgb: {},
                lab: {},
                hcl: {}
            },
            "default": "rgb"
        },
        "default": {
            type: "*",
            required: false
        }
    },
    function_stop: $ed234ca8eb1f5a84$var$function_stop,
    expression: $ed234ca8eb1f5a84$var$expression$1,
    light: $ed234ca8eb1f5a84$var$light,
    sky: $ed234ca8eb1f5a84$var$sky,
    terrain: $ed234ca8eb1f5a84$var$terrain,
    projection: $ed234ca8eb1f5a84$var$projection,
    paint: $ed234ca8eb1f5a84$var$paint,
    paint_fill: $ed234ca8eb1f5a84$var$paint_fill,
    "paint_fill-extrusion": {
        "fill-extrusion-opacity": {
            type: "number",
            "default": 1,
            minimum: 0,
            maximum: 1,
            transition: true,
            expression: {
                interpolated: true,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "fill-extrusion-color": {
            type: "color",
            "default": "#000000",
            transition: true,
            requires: [
                {
                    "!": "fill-extrusion-pattern"
                }
            ],
            expression: {
                interpolated: true,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "fill-extrusion-translate": {
            type: "array",
            value: "number",
            length: 2,
            "default": [
                0,
                0
            ],
            transition: true,
            units: "pixels",
            expression: {
                interpolated: true,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "fill-extrusion-translate-anchor": {
            type: "enum",
            values: {
                map: {},
                viewport: {}
            },
            "default": "map",
            requires: [
                "fill-extrusion-translate"
            ],
            expression: {
                interpolated: false,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "fill-extrusion-pattern": {
            type: "resolvedImage",
            transition: true,
            expression: {
                interpolated: false,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "cross-faded-data-driven"
        },
        "fill-extrusion-height": {
            type: "number",
            "default": 0,
            minimum: 0,
            units: "meters",
            transition: true,
            expression: {
                interpolated: true,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "fill-extrusion-base": {
            type: "number",
            "default": 0,
            minimum: 0,
            units: "meters",
            transition: true,
            requires: [
                "fill-extrusion-height"
            ],
            expression: {
                interpolated: true,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "fill-extrusion-vertical-gradient": {
            type: "boolean",
            "default": true,
            transition: false,
            expression: {
                interpolated: false,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        }
    },
    paint_line: $ed234ca8eb1f5a84$var$paint_line,
    paint_circle: $ed234ca8eb1f5a84$var$paint_circle,
    paint_heatmap: $ed234ca8eb1f5a84$var$paint_heatmap,
    paint_symbol: $ed234ca8eb1f5a84$var$paint_symbol,
    paint_raster: $ed234ca8eb1f5a84$var$paint_raster,
    paint_hillshade: $ed234ca8eb1f5a84$var$paint_hillshade,
    "paint_color-relief": {
        "color-relief-opacity": {
            type: "number",
            "default": 1,
            minimum: 0,
            maximum: 1,
            transition: true,
            expression: {
                interpolated: true,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "color-relief-color": {
            type: "color",
            transition: false,
            expression: {
                interpolated: true,
                parameters: [
                    "elevation"
                ]
            },
            "property-type": "color-ramp"
        },
        resampling: {
            type: "enum",
            values: {
                linear: {},
                nearest: {}
            },
            "default": "linear",
            expression: {
                interpolated: false,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        }
    },
    paint_background: $ed234ca8eb1f5a84$var$paint_background,
    transition: $ed234ca8eb1f5a84$var$transition,
    "property-type": {
        "data-driven": {
            type: "property-type"
        },
        "cross-faded": {
            type: "property-type"
        },
        "cross-faded-data-driven": {
            type: "property-type"
        },
        "color-ramp": {
            type: "property-type"
        },
        "data-constant": {
            type: "property-type"
        },
        constant: {
            type: "property-type"
        }
    },
    promoteId: $ed234ca8eb1f5a84$var$promoteId,
    interpolation: $ed234ca8eb1f5a84$var$interpolation,
    interpolation_name: $ed234ca8eb1f5a84$var$interpolation_name
};
const $ed234ca8eb1f5a84$var$refProperties = [
    'type',
    'source',
    'source-layer',
    'minzoom',
    'maxzoom',
    'filter',
    'layout'
];
function $ed234ca8eb1f5a84$var$deref(layer, parent) {
    const result = {};
    for(const k in layer)if (k !== 'ref') result[k] = layer[k];
    $ed234ca8eb1f5a84$var$refProperties.forEach((k)=>{
        if (k in parent) result[k] = parent[k];
    });
    return result;
}
/**
 *
 * The input is not modified. The output may contain references to portions
 * of the input.
 *
 * @param layers - array of layers, some of which may contain `ref` properties
 * whose value is the `id` of another property
 * @returns a new array where such layers have been augmented with the 'type', 'source', etc. properties
 * from the parent layer, and the `ref` property has been removed.
 */ function $ed234ca8eb1f5a84$export$4f143e2847fe5618(layers) {
    layers = layers.slice();
    const map = Object.create(null);
    for(let i = 0; i < layers.length; i++)map[layers[i].id] = layers[i];
    for(let i = 0; i < layers.length; i++)if ('ref' in layers[i]) layers[i] = $ed234ca8eb1f5a84$var$deref(layers[i], map[layers[i].ref]);
    return layers;
}
/**
 * Deeply compares two object literals.
 *
 * @private
 */ function $ed234ca8eb1f5a84$var$deepEqual(a, b) {
    if (Array.isArray(a)) {
        if (!Array.isArray(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!$ed234ca8eb1f5a84$var$deepEqual(a[i], b[i])) return false;
        }
        return true;
    }
    if (typeof a === 'object' && a !== null && b !== null) {
        if (!(typeof b === 'object')) return false;
        const keys = Object.keys(a);
        if (keys.length !== Object.keys(b).length) return false;
        for(const key in a){
            if (!$ed234ca8eb1f5a84$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a === b;
}
/**
 * The main reason for this method is to allow type check when adding a command to the array.
 * @param commands - The commands array to add to
 * @param command - The command to add
 */ function $ed234ca8eb1f5a84$var$addCommand(commands, command) {
    commands.push(command);
}
function $ed234ca8eb1f5a84$var$addSource(sourceId, after, commands) {
    $ed234ca8eb1f5a84$var$addCommand(commands, {
        command: 'addSource',
        args: [
            sourceId,
            after[sourceId]
        ]
    });
}
function $ed234ca8eb1f5a84$var$removeSource(sourceId, commands, sourcesRemoved) {
    $ed234ca8eb1f5a84$var$addCommand(commands, {
        command: 'removeSource',
        args: [
            sourceId
        ]
    });
    sourcesRemoved[sourceId] = true;
}
function $ed234ca8eb1f5a84$var$updateSource(sourceId, after, commands, sourcesRemoved) {
    $ed234ca8eb1f5a84$var$removeSource(sourceId, commands, sourcesRemoved);
    $ed234ca8eb1f5a84$var$addSource(sourceId, after, commands);
}
function $ed234ca8eb1f5a84$var$canUpdateGeoJSON(before, after, sourceId) {
    let prop;
    for(prop in before[sourceId]){
        if (!Object.prototype.hasOwnProperty.call(before[sourceId], prop)) continue;
        if (prop !== 'data' && !$ed234ca8eb1f5a84$var$deepEqual(before[sourceId][prop], after[sourceId][prop])) return false;
    }
    for(prop in after[sourceId]){
        if (!Object.prototype.hasOwnProperty.call(after[sourceId], prop)) continue;
        if (prop !== 'data' && !$ed234ca8eb1f5a84$var$deepEqual(before[sourceId][prop], after[sourceId][prop])) return false;
    }
    return true;
}
function $ed234ca8eb1f5a84$var$diffSources(before, after, commands, sourcesRemoved) {
    before = before || {};
    after = after || {};
    let sourceId;
    // look for sources to remove
    for(sourceId in before){
        if (!Object.prototype.hasOwnProperty.call(before, sourceId)) continue;
        if (!Object.prototype.hasOwnProperty.call(after, sourceId)) $ed234ca8eb1f5a84$var$removeSource(sourceId, commands, sourcesRemoved);
    }
    // look for sources to add/update
    for(sourceId in after){
        if (!Object.prototype.hasOwnProperty.call(after, sourceId)) continue;
        if (!Object.prototype.hasOwnProperty.call(before, sourceId)) $ed234ca8eb1f5a84$var$addSource(sourceId, after, commands);
        else if (!$ed234ca8eb1f5a84$var$deepEqual(before[sourceId], after[sourceId])) {
            if (before[sourceId].type === 'geojson' && after[sourceId].type === 'geojson' && $ed234ca8eb1f5a84$var$canUpdateGeoJSON(before, after, sourceId)) $ed234ca8eb1f5a84$var$addCommand(commands, {
                command: 'setGeoJSONSourceData',
                args: [
                    sourceId,
                    after[sourceId].data
                ]
            });
            else // no update command, must remove then add
            $ed234ca8eb1f5a84$var$updateSource(sourceId, after, commands, sourcesRemoved);
        }
    }
}
function $ed234ca8eb1f5a84$var$diffLayerPropertyChanges(before, after, commands, layerId, klass, command) {
    before = before || {};
    after = after || {};
    for(const prop in before){
        if (!Object.prototype.hasOwnProperty.call(before, prop)) continue;
        if (!$ed234ca8eb1f5a84$var$deepEqual(before[prop], after[prop])) commands.push({
            command: command,
            args: [
                layerId,
                prop,
                after[prop],
                klass
            ]
        });
    }
    for(const prop in after){
        if (!Object.prototype.hasOwnProperty.call(after, prop) || Object.prototype.hasOwnProperty.call(before, prop)) continue;
        if (!$ed234ca8eb1f5a84$var$deepEqual(before[prop], after[prop])) commands.push({
            command: command,
            args: [
                layerId,
                prop,
                after[prop],
                klass
            ]
        });
    }
}
function $ed234ca8eb1f5a84$var$pluckId(layer) {
    return layer.id;
}
function $ed234ca8eb1f5a84$var$indexById(group, layer) {
    group[layer.id] = layer;
    return group;
}
function $ed234ca8eb1f5a84$var$diffLayers(before, after, commands) {
    before = before || [];
    after = after || [];
    // order of layers by id
    const beforeOrder = before.map($ed234ca8eb1f5a84$var$pluckId);
    const afterOrder = after.map($ed234ca8eb1f5a84$var$pluckId);
    // index of layer by id
    const beforeIndex = before.reduce($ed234ca8eb1f5a84$var$indexById, {});
    const afterIndex = after.reduce($ed234ca8eb1f5a84$var$indexById, {});
    // track order of layers as if they have been mutated
    const tracker = beforeOrder.slice();
    // layers that have been added do not need to be diffed
    const clean = Object.create(null);
    let layerId;
    let beforeLayer;
    let afterLayer;
    let insertBeforeLayerId;
    let prop;
    // remove layers
    for(let i = 0, d = 0; i < beforeOrder.length; i++){
        layerId = beforeOrder[i];
        if (!Object.prototype.hasOwnProperty.call(afterIndex, layerId)) {
            $ed234ca8eb1f5a84$var$addCommand(commands, {
                command: 'removeLayer',
                args: [
                    layerId
                ]
            });
            tracker.splice(tracker.indexOf(layerId, d), 1);
        } else // limit where in tracker we need to look for a match
        d++;
    }
    // add/reorder layers
    for(let i = 0, d = 0; i < afterOrder.length; i++){
        // work backwards as insert is before an existing layer
        layerId = afterOrder[afterOrder.length - 1 - i];
        if (tracker[tracker.length - 1 - i] === layerId) continue;
        if (Object.prototype.hasOwnProperty.call(beforeIndex, layerId)) {
            // remove the layer before we insert at the correct position
            $ed234ca8eb1f5a84$var$addCommand(commands, {
                command: 'removeLayer',
                args: [
                    layerId
                ]
            });
            tracker.splice(tracker.lastIndexOf(layerId, tracker.length - d), 1);
        } else // limit where in tracker we need to look for a match
        d++;
        // add layer at correct position
        insertBeforeLayerId = tracker[tracker.length - i];
        $ed234ca8eb1f5a84$var$addCommand(commands, {
            command: 'addLayer',
            args: [
                afterIndex[layerId],
                insertBeforeLayerId
            ]
        });
        tracker.splice(tracker.length - i, 0, layerId);
        clean[layerId] = true;
    }
    // update layers
    for(let i = 0; i < afterOrder.length; i++){
        layerId = afterOrder[i];
        beforeLayer = beforeIndex[layerId];
        afterLayer = afterIndex[layerId];
        // no need to update if previously added (new or moved)
        if (clean[layerId] || $ed234ca8eb1f5a84$var$deepEqual(beforeLayer, afterLayer)) continue;
        // If source, source-layer, or type have changes, then remove the layer
        // and add it back 'from scratch'.
        if (!$ed234ca8eb1f5a84$var$deepEqual(beforeLayer.source, afterLayer.source) || !$ed234ca8eb1f5a84$var$deepEqual(beforeLayer['source-layer'], afterLayer['source-layer']) || !$ed234ca8eb1f5a84$var$deepEqual(beforeLayer.type, afterLayer.type)) {
            $ed234ca8eb1f5a84$var$addCommand(commands, {
                command: 'removeLayer',
                args: [
                    layerId
                ]
            });
            // we add the layer back at the same position it was already in, so
            // there's no need to update the `tracker`
            insertBeforeLayerId = tracker[tracker.lastIndexOf(layerId) + 1];
            $ed234ca8eb1f5a84$var$addCommand(commands, {
                command: 'addLayer',
                args: [
                    afterLayer,
                    insertBeforeLayerId
                ]
            });
            continue;
        }
        // layout, paint, filter, minzoom, maxzoom
        $ed234ca8eb1f5a84$var$diffLayerPropertyChanges(beforeLayer.layout, afterLayer.layout, commands, layerId, null, 'setLayoutProperty');
        $ed234ca8eb1f5a84$var$diffLayerPropertyChanges(beforeLayer.paint, afterLayer.paint, commands, layerId, null, 'setPaintProperty');
        if (!$ed234ca8eb1f5a84$var$deepEqual(beforeLayer.filter, afterLayer.filter)) $ed234ca8eb1f5a84$var$addCommand(commands, {
            command: 'setFilter',
            args: [
                layerId,
                afterLayer.filter
            ]
        });
        if (!$ed234ca8eb1f5a84$var$deepEqual(beforeLayer.minzoom, afterLayer.minzoom) || !$ed234ca8eb1f5a84$var$deepEqual(beforeLayer.maxzoom, afterLayer.maxzoom)) $ed234ca8eb1f5a84$var$addCommand(commands, {
            command: 'setLayerZoomRange',
            args: [
                layerId,
                afterLayer.minzoom,
                afterLayer.maxzoom
            ]
        });
        // handle all other layer props, including paint.*
        for(prop in beforeLayer){
            if (!Object.prototype.hasOwnProperty.call(beforeLayer, prop)) continue;
            if (prop === 'layout' || prop === 'paint' || prop === 'filter' || prop === 'metadata' || prop === 'minzoom' || prop === 'maxzoom') continue;
            if (prop.indexOf('paint.') === 0) $ed234ca8eb1f5a84$var$diffLayerPropertyChanges(beforeLayer[prop], afterLayer[prop], commands, layerId, prop.slice(6), 'setPaintProperty');
            else if (!$ed234ca8eb1f5a84$var$deepEqual(beforeLayer[prop], afterLayer[prop])) $ed234ca8eb1f5a84$var$addCommand(commands, {
                command: 'setLayerProperty',
                args: [
                    layerId,
                    prop,
                    afterLayer[prop]
                ]
            });
        }
        for(prop in afterLayer){
            if (!Object.prototype.hasOwnProperty.call(afterLayer, prop) || Object.prototype.hasOwnProperty.call(beforeLayer, prop)) continue;
            if (prop === 'layout' || prop === 'paint' || prop === 'filter' || prop === 'metadata' || prop === 'minzoom' || prop === 'maxzoom') continue;
            if (prop.indexOf('paint.') === 0) $ed234ca8eb1f5a84$var$diffLayerPropertyChanges(beforeLayer[prop], afterLayer[prop], commands, layerId, prop.slice(6), 'setPaintProperty');
            else if (!$ed234ca8eb1f5a84$var$deepEqual(beforeLayer[prop], afterLayer[prop])) $ed234ca8eb1f5a84$var$addCommand(commands, {
                command: 'setLayerProperty',
                args: [
                    layerId,
                    prop,
                    afterLayer[prop]
                ]
            });
        }
    }
}
/**
 * Diff two stylesheet
 *
 * Creates semanticly aware diffs that can easily be applied at runtime.
 * Operations produced by the diff closely resemble the maplibre-gl-js API. Any
 * error creating the diff will fall back to the 'setStyle' operation.
 *
 * Example diff:
 * [
 *     { command: 'setConstant', args: ['@water', '#0000FF'] },
 *     { command: 'setPaintProperty', args: ['background', 'background-color', 'black'] }
 * ]
 *
 * @private
 * @param {*} [before] stylesheet to compare from
 * @param {*} after stylesheet to compare to
 * @returns Array list of changes
 */ function $ed234ca8eb1f5a84$export$a37e3c603d7117e5(before, after) {
    if (!before) return [
        {
            command: 'setStyle',
            args: [
                after
            ]
        }
    ];
    let commands = [];
    try {
        // Handle changes to top-level properties
        if (!$ed234ca8eb1f5a84$var$deepEqual(before.version, after.version)) return [
            {
                command: 'setStyle',
                args: [
                    after
                ]
            }
        ];
        if (!$ed234ca8eb1f5a84$var$deepEqual(before.center, after.center)) commands.push({
            command: 'setCenter',
            args: [
                after.center
            ]
        });
        if (!$ed234ca8eb1f5a84$var$deepEqual(before.state, after.state)) commands.push({
            command: 'setGlobalState',
            args: [
                after.state
            ]
        });
        if (!$ed234ca8eb1f5a84$var$deepEqual(before.centerAltitude, after.centerAltitude)) commands.push({
            command: 'setCenterAltitude',
            args: [
                after.centerAltitude
            ]
        });
        if (!$ed234ca8eb1f5a84$var$deepEqual(before.zoom, after.zoom)) commands.push({
            command: 'setZoom',
            args: [
                after.zoom
            ]
        });
        if (!$ed234ca8eb1f5a84$var$deepEqual(before.bearing, after.bearing)) commands.push({
            command: 'setBearing',
            args: [
                after.bearing
            ]
        });
        if (!$ed234ca8eb1f5a84$var$deepEqual(before.pitch, after.pitch)) commands.push({
            command: 'setPitch',
            args: [
                after.pitch
            ]
        });
        if (!$ed234ca8eb1f5a84$var$deepEqual(before.roll, after.roll)) commands.push({
            command: 'setRoll',
            args: [
                after.roll
            ]
        });
        if (!$ed234ca8eb1f5a84$var$deepEqual(before.sprite, after.sprite)) commands.push({
            command: 'setSprite',
            args: [
                after.sprite
            ]
        });
        if (!$ed234ca8eb1f5a84$var$deepEqual(before.glyphs, after.glyphs)) commands.push({
            command: 'setGlyphs',
            args: [
                after.glyphs
            ]
        });
        if (!$ed234ca8eb1f5a84$var$deepEqual(before.transition, after.transition)) commands.push({
            command: 'setTransition',
            args: [
                after.transition
            ]
        });
        if (!$ed234ca8eb1f5a84$var$deepEqual(before.light, after.light)) commands.push({
            command: 'setLight',
            args: [
                after.light
            ]
        });
        if (!$ed234ca8eb1f5a84$var$deepEqual(before.terrain, after.terrain)) commands.push({
            command: 'setTerrain',
            args: [
                after.terrain
            ]
        });
        if (!$ed234ca8eb1f5a84$var$deepEqual(before.sky, after.sky)) commands.push({
            command: 'setSky',
            args: [
                after.sky
            ]
        });
        if (!$ed234ca8eb1f5a84$var$deepEqual(before.projection, after.projection)) commands.push({
            command: 'setProjection',
            args: [
                after.projection
            ]
        });
        // Handle changes to `sources`
        // If a source is to be removed, we also--before the removeSource
        // command--need to remove all the style layers that depend on it.
        const sourcesRemoved = {};
        // First collect the {add,remove}Source commands
        const removeOrAddSourceCommands = [];
        $ed234ca8eb1f5a84$var$diffSources(before.sources, after.sources, removeOrAddSourceCommands, sourcesRemoved);
        // Push a removeLayer command for each style layer that depends on a
        // source that's being removed.
        // Also, exclude any such layers them from the input to `diffLayers`
        // below, so that diffLayers produces the appropriate `addLayers`
        // command
        const beforeLayers = [];
        if (before.layers) before.layers.forEach((layer)=>{
            if ('source' in layer && sourcesRemoved[layer.source]) commands.push({
                command: 'removeLayer',
                args: [
                    layer.id
                ]
            });
            else beforeLayers.push(layer);
        });
        commands = commands.concat(removeOrAddSourceCommands);
        // Handle changes to `layers`
        $ed234ca8eb1f5a84$var$diffLayers(beforeLayers, after.layers, commands);
    } catch (e) {
        // fall back to setStyle
        console.warn('Unable to compute style diff:', e);
        commands = [
            {
                command: 'setStyle',
                args: [
                    after
                ]
            }
        ];
    }
    return commands;
}
// Note: Do not inherit from Error. It breaks when transpiling to ES5.
class $ed234ca8eb1f5a84$export$2191b9da168c6cf0 {
    constructor(key, value, message, identifier){
        this.message = (key ? `${key}: ` : '') + message;
        if (identifier) this.identifier = identifier;
        if (value !== null && value !== undefined && value.__line__) this.line = value.__line__;
    }
}
// Note: Do not inherit from Error. It breaks when transpiling to ES5.
class $ed234ca8eb1f5a84$export$6b71bec05ba1a3c6 {
    constructor(error){
        this.error = error;
        this.message = error.message;
        const match = error.message.match(/line (\d+)/);
        this.line = match ? parseInt(match[1], 10) : 0;
    }
}
function $ed234ca8eb1f5a84$var$extendBy(output, ...inputs) {
    for (const input of inputs)for(const k in input)output[k] = input[k];
    return output;
}
class $ed234ca8eb1f5a84$var$ExpressionParsingError extends Error {
    constructor(key, message){
        super(message);
        this.message = message;
        this.key = key;
    }
}
/**
 * Tracks `let` bindings during expression parsing.
 * @private
 */ class $ed234ca8eb1f5a84$var$Scope {
    constructor(parent, bindings = []){
        this.parent = parent;
        this.bindings = {};
        for (const [name, expression] of bindings)this.bindings[name] = expression;
    }
    concat(bindings) {
        return new $ed234ca8eb1f5a84$var$Scope(this, bindings);
    }
    get(name) {
        if (this.bindings[name]) return this.bindings[name];
        if (this.parent) return this.parent.get(name);
        throw new Error(`${name} not found in scope.`);
    }
    has(name) {
        if (this.bindings[name]) return true;
        return this.parent ? this.parent.has(name) : false;
    }
}
const $ed234ca8eb1f5a84$export$95d6ca0ebe20dc35 = {
    kind: 'null'
};
const $ed234ca8eb1f5a84$var$NumberType = {
    kind: 'number'
};
const $ed234ca8eb1f5a84$var$StringType = {
    kind: 'string'
};
const $ed234ca8eb1f5a84$var$BooleanType = {
    kind: 'boolean'
};
const $ed234ca8eb1f5a84$export$2cd82751acc0e609 = {
    kind: 'color'
};
const $ed234ca8eb1f5a84$export$7ec308bb4472cd41 = {
    kind: 'projectionDefinition'
};
const $ed234ca8eb1f5a84$var$ObjectType = {
    kind: 'object'
};
const $ed234ca8eb1f5a84$var$ValueType = {
    kind: 'value'
};
const $ed234ca8eb1f5a84$var$ErrorType = {
    kind: 'error'
};
const $ed234ca8eb1f5a84$var$CollatorType = {
    kind: 'collator'
};
const $ed234ca8eb1f5a84$export$831566e53e7565f9 = {
    kind: 'formatted'
};
const $ed234ca8eb1f5a84$var$PaddingType = {
    kind: 'padding'
};
const $ed234ca8eb1f5a84$var$ColorArrayType = {
    kind: 'colorArray'
};
const $ed234ca8eb1f5a84$var$NumberArrayType = {
    kind: 'numberArray'
};
const $ed234ca8eb1f5a84$var$ResolvedImageType = {
    kind: 'resolvedImage'
};
const $ed234ca8eb1f5a84$var$VariableAnchorOffsetCollectionType = {
    kind: 'variableAnchorOffsetCollection'
};
function $ed234ca8eb1f5a84$var$array(itemType, N) {
    return {
        kind: 'array',
        itemType: itemType,
        N: N
    };
}
function $ed234ca8eb1f5a84$export$f84e8e69fd4488a5(type) {
    if (type.kind === 'array') {
        const itemType = $ed234ca8eb1f5a84$export$f84e8e69fd4488a5(type.itemType);
        return typeof type.N === 'number' ? `array<${itemType}, ${type.N}>` : type.itemType.kind === 'value' ? 'array' : `array<${itemType}>`;
    } else return type.kind;
}
const $ed234ca8eb1f5a84$var$valueMemberTypes = [
    $ed234ca8eb1f5a84$export$95d6ca0ebe20dc35,
    $ed234ca8eb1f5a84$var$NumberType,
    $ed234ca8eb1f5a84$var$StringType,
    $ed234ca8eb1f5a84$var$BooleanType,
    $ed234ca8eb1f5a84$export$2cd82751acc0e609,
    $ed234ca8eb1f5a84$export$7ec308bb4472cd41,
    $ed234ca8eb1f5a84$export$831566e53e7565f9,
    $ed234ca8eb1f5a84$var$ObjectType,
    $ed234ca8eb1f5a84$var$array($ed234ca8eb1f5a84$var$ValueType),
    $ed234ca8eb1f5a84$var$PaddingType,
    $ed234ca8eb1f5a84$var$NumberArrayType,
    $ed234ca8eb1f5a84$var$ColorArrayType,
    $ed234ca8eb1f5a84$var$ResolvedImageType,
    $ed234ca8eb1f5a84$var$VariableAnchorOffsetCollectionType
];
/**
 * Returns null if `t` is a subtype of `expected`; otherwise returns an
 * error message.
 * @private
 */ function $ed234ca8eb1f5a84$var$checkSubtype(expected, t) {
    if (t.kind === 'error') // Error is a subtype of every type
    return null;
    else if (expected.kind === 'array') {
        if (t.kind === 'array' && (t.N === 0 && t.itemType.kind === 'value' || !$ed234ca8eb1f5a84$var$checkSubtype(expected.itemType, t.itemType)) && (typeof expected.N !== 'number' || expected.N === t.N)) return null;
    } else if (expected.kind === t.kind) return null;
    else if (expected.kind === 'value') for (const memberType of $ed234ca8eb1f5a84$var$valueMemberTypes){
        if (!$ed234ca8eb1f5a84$var$checkSubtype(memberType, t)) return null;
    }
    return `Expected ${$ed234ca8eb1f5a84$export$f84e8e69fd4488a5(expected)} but found ${$ed234ca8eb1f5a84$export$f84e8e69fd4488a5(t)} instead.`;
}
function $ed234ca8eb1f5a84$var$isValidType(provided, allowedTypes) {
    return allowedTypes.some((t)=>t.kind === provided.kind);
}
function $ed234ca8eb1f5a84$var$isValidNativeType(provided, allowedTypes) {
    return allowedTypes.some((t)=>{
        if (t === 'null') return provided === null;
        else if (t === 'array') return Array.isArray(provided);
        else if (t === 'object') return provided && !Array.isArray(provided) && typeof provided === 'object';
        else return t === typeof provided;
    });
}
/**
 * Verify whether the specified type is of the same type as the specified sample.
 *
 * @param provided Type to verify
 * @param sample Sample type to reference
 * @returns `true` if both objects are of the same type, `false` otherwise
 * @example basic types
 * if (verifyType(outputType, ValueType)) {
 *     // type narrowed to:
 *     outputType.kind; // 'value'
 * }
 * @example array types
 * if (verifyType(outputType, array(NumberType))) {
 *     // type narrowed to:
 *     outputType.kind; // 'array'
 *     outputType.itemType; // NumberTypeT
 *     outputType.itemType.kind; // 'number'
 * }
 */ function $ed234ca8eb1f5a84$var$verifyType(provided, sample) {
    if (provided.kind === 'array' && sample.kind === 'array') return provided.itemType.kind === sample.itemType.kind && typeof provided.N === 'number';
    return provided.kind === sample.kind;
}
// See https://observablehq.com/@mbostock/lab-and-rgb
const $ed234ca8eb1f5a84$var$Xn = 0.96422, $ed234ca8eb1f5a84$var$Yn = 1, $ed234ca8eb1f5a84$var$Zn = 0.82521, $ed234ca8eb1f5a84$var$t0 = 4 / 29, $ed234ca8eb1f5a84$var$t1 = 6 / 29, $ed234ca8eb1f5a84$var$t2 = 3 * $ed234ca8eb1f5a84$var$t1 * $ed234ca8eb1f5a84$var$t1, $ed234ca8eb1f5a84$var$t3 = $ed234ca8eb1f5a84$var$t1 * $ed234ca8eb1f5a84$var$t1 * $ed234ca8eb1f5a84$var$t1, $ed234ca8eb1f5a84$var$deg2rad = Math.PI / 180, $ed234ca8eb1f5a84$var$rad2deg = 180 / Math.PI;
function $ed234ca8eb1f5a84$var$constrainAngle(angle) {
    angle = angle % 360;
    if (angle < 0) angle += 360;
    return angle;
}
function $ed234ca8eb1f5a84$var$rgbToLab([r, g, b, alpha]) {
    r = $ed234ca8eb1f5a84$var$rgb2xyz(r);
    g = $ed234ca8eb1f5a84$var$rgb2xyz(g);
    b = $ed234ca8eb1f5a84$var$rgb2xyz(b);
    let x, z;
    const y = $ed234ca8eb1f5a84$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $ed234ca8eb1f5a84$var$Yn);
    if (r === g && g === b) x = z = y;
    else {
        x = $ed234ca8eb1f5a84$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $ed234ca8eb1f5a84$var$Xn);
        z = $ed234ca8eb1f5a84$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $ed234ca8eb1f5a84$var$Zn);
    }
    const l = 116 * y - 16;
    return [
        l < 0 ? 0 : l,
        500 * (x - y),
        200 * (y - z),
        alpha
    ];
}
function $ed234ca8eb1f5a84$var$rgb2xyz(x) {
    return x <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $ed234ca8eb1f5a84$var$xyz2lab(t) {
    return t > $ed234ca8eb1f5a84$var$t3 ? Math.pow(t, 1 / 3) : t / $ed234ca8eb1f5a84$var$t2 + $ed234ca8eb1f5a84$var$t0;
}
function $ed234ca8eb1f5a84$var$labToRgb([l, a, b, alpha]) {
    let y = (l + 16) / 116, x = isNaN(a) ? y : y + a / 500, z = isNaN(b) ? y : y - b / 200;
    y = $ed234ca8eb1f5a84$var$Yn * $ed234ca8eb1f5a84$var$lab2xyz(y);
    x = $ed234ca8eb1f5a84$var$Xn * $ed234ca8eb1f5a84$var$lab2xyz(x);
    z = $ed234ca8eb1f5a84$var$Zn * $ed234ca8eb1f5a84$var$lab2xyz(z);
    return [
        $ed234ca8eb1f5a84$var$xyz2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
        $ed234ca8eb1f5a84$var$xyz2rgb(-0.9787684 * x + 1.9161415 * y + 0.033454 * z),
        $ed234ca8eb1f5a84$var$xyz2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
        alpha
    ];
}
function $ed234ca8eb1f5a84$var$xyz2rgb(x) {
    x = x <= 0.00304 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055;
    return x < 0 ? 0 : x > 1 ? 1 : x; // clip to 0..1 range
}
function $ed234ca8eb1f5a84$var$lab2xyz(t) {
    return t > $ed234ca8eb1f5a84$var$t1 ? t * t * t : $ed234ca8eb1f5a84$var$t2 * (t - $ed234ca8eb1f5a84$var$t0);
}
function $ed234ca8eb1f5a84$var$rgbToHcl(rgbColor) {
    const [l, a, b, alpha] = $ed234ca8eb1f5a84$var$rgbToLab(rgbColor);
    const c = Math.sqrt(a * a + b * b);
    const h = Math.round(c * 10000) ? $ed234ca8eb1f5a84$var$constrainAngle(Math.atan2(b, a) * $ed234ca8eb1f5a84$var$rad2deg) : NaN;
    return [
        h,
        c,
        l,
        alpha
    ];
}
function $ed234ca8eb1f5a84$var$hclToRgb([h, c, l, alpha]) {
    h = isNaN(h) ? 0 : h * $ed234ca8eb1f5a84$var$deg2rad;
    return $ed234ca8eb1f5a84$var$labToRgb([
        l,
        Math.cos(h) * c,
        Math.sin(h) * c,
        alpha
    ]);
}
// https://drafts.csswg.org/css-color-4/#hsl-to-rgb
function $ed234ca8eb1f5a84$var$hslToRgb([h, s, l, alpha]) {
    h = $ed234ca8eb1f5a84$var$constrainAngle(h);
    s /= 100;
    l /= 100;
    function f(n) {
        const k = (n + h / 30) % 12;
        const a = s * Math.min(l, 1 - l);
        return l - a * Math.max(-1, Math.min(k - 3, 9 - k, 1));
    }
    return [
        f(0),
        f(8),
        f(4),
        alpha
    ];
}
// polyfill for Object.hasOwn
const $ed234ca8eb1f5a84$var$hasOwnProperty = Object.hasOwn || function hasOwnProperty(object, key) {
    return Object.prototype.hasOwnProperty.call(object, key);
};
function $ed234ca8eb1f5a84$var$getOwn(object, key) {
    return $ed234ca8eb1f5a84$var$hasOwnProperty(object, key) ? object[key] : undefined;
}
/**
 * CSS color parser compliant with CSS Color 4 Specification.
 * Supports: named colors, `transparent` keyword, all rgb hex notations,
 * rgb(), rgba(), hsl() and hsla() functions.
 * Does not round the parsed values to integers from the range 0..255.
 *
 * Syntax:
 *
 * <alpha-value> = <number> | <percentage>
 *         <hue> = <number> | <angle>
 *
 *         rgb() = rgb( <percentage>{3} [ / <alpha-value> ]? ) | rgb( <number>{3} [ / <alpha-value> ]? )
 *         rgb() = rgb( <percentage>#{3} , <alpha-value>? )    | rgb( <number>#{3} , <alpha-value>? )
 *
 *         hsl() = hsl( <hue> <percentage> <percentage> [ / <alpha-value> ]? )
 *         hsl() = hsl( <hue>, <percentage>, <percentage>, <alpha-value>? )
 *
 * Caveats:
 *   - <angle> - <number> with optional `deg` suffix; `grad`, `rad`, `turn` are not supported
 *   - `none` keyword is not supported
 *   - comments inside rgb()/hsl() are not supported
 *   - legacy color syntax rgba() is supported with an identical grammar and behavior to rgb()
 *   - legacy color syntax hsla() is supported with an identical grammar and behavior to hsl()
 *
 * @param input CSS color string to parse.
 * @returns Color in sRGB color space, with `red`, `green`, `blue`
 * and `alpha` channels normalized to the range 0..1,
 * or `undefined` if the input is not a valid color string.
 */ function $ed234ca8eb1f5a84$var$parseCssColor(input) {
    input = input.toLowerCase().trim();
    if (input === 'transparent') return [
        0,
        0,
        0,
        0
    ];
    // 'white', 'black', 'blue'
    const namedColorsMatch = $ed234ca8eb1f5a84$var$getOwn($ed234ca8eb1f5a84$var$namedColors, input);
    if (namedColorsMatch) {
        const [r, g, b] = namedColorsMatch;
        return [
            r / 255,
            g / 255,
            b / 255,
            1
        ];
    }
    // #f0c, #f0cf, #ff00cc, #ff00ccff
    if (input.startsWith('#')) {
        const hexRegexp = /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/;
        if (hexRegexp.test(input)) {
            const step = input.length < 6 ? 1 : 2;
            let i = 1;
            return [
                $ed234ca8eb1f5a84$var$parseHex(input.slice(i, i += step)),
                $ed234ca8eb1f5a84$var$parseHex(input.slice(i, i += step)),
                $ed234ca8eb1f5a84$var$parseHex(input.slice(i, i += step)),
                $ed234ca8eb1f5a84$var$parseHex(input.slice(i, i + step) || 'ff')
            ];
        }
    }
    // rgb(128 0 0), rgb(50% 0% 0%), rgba(255,0,255,0.6), rgb(255 0 255 / 60%), rgb(100% 0% 100% /.6)
    if (input.startsWith('rgb')) {
        const rgbRegExp = /^rgba?\(\s*([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/;
        const rgbMatch = input.match(rgbRegExp);
        if (rgbMatch) {
            const [_, r, rp, f1, g, gp, f2, b, bp, f3, a, ap // %         (optional)
            ] = rgbMatch;
            const argFormat = [
                f1 || ' ',
                f2 || ' ',
                f3
            ].join('');
            if (argFormat === '  ' || argFormat === '  /' || argFormat === ',,' || argFormat === ',,,') {
                const valFormat = [
                    rp,
                    gp,
                    bp
                ].join('');
                const maxValue = valFormat === '%%%' ? 100 : valFormat === '' ? 255 : 0;
                if (maxValue) {
                    const rgba = [
                        $ed234ca8eb1f5a84$var$clamp(+r / maxValue, 0, 1),
                        $ed234ca8eb1f5a84$var$clamp(+g / maxValue, 0, 1),
                        $ed234ca8eb1f5a84$var$clamp(+b / maxValue, 0, 1),
                        a ? $ed234ca8eb1f5a84$var$parseAlpha(+a, ap) : 1
                    ];
                    if ($ed234ca8eb1f5a84$var$validateNumbers(rgba)) return rgba;
                // invalid numbers
                }
            // values must be all numbers or all percentages
            }
            return; // comma optional syntax requires no commas at all
        }
    }
    // hsl(120 50% 80%), hsla(120deg,50%,80%,.9), hsl(12e1 50% 80% / 90%)
    const hslRegExp = /^hsla?\(\s*([\de.+-]+)(?:deg)?(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/;
    const hslMatch = input.match(hslRegExp);
    if (hslMatch) {
        const [_, h, f1, s, f2, l, f3, a, ap // %         (optional)
        ] = hslMatch;
        const argFormat = [
            f1 || ' ',
            f2 || ' ',
            f3
        ].join('');
        if (argFormat === '  ' || argFormat === '  /' || argFormat === ',,' || argFormat === ',,,') {
            const hsla = [
                +h,
                $ed234ca8eb1f5a84$var$clamp(+s, 0, 100),
                $ed234ca8eb1f5a84$var$clamp(+l, 0, 100),
                a ? $ed234ca8eb1f5a84$var$parseAlpha(+a, ap) : 1
            ];
            if ($ed234ca8eb1f5a84$var$validateNumbers(hsla)) return $ed234ca8eb1f5a84$var$hslToRgb(hsla);
        // invalid numbers
        }
    // comma optional syntax requires no commas at all
    }
}
function $ed234ca8eb1f5a84$var$parseHex(hex) {
    return parseInt(hex.padEnd(2, hex), 16) / 255;
}
function $ed234ca8eb1f5a84$var$parseAlpha(a, asPercentage) {
    return $ed234ca8eb1f5a84$var$clamp(asPercentage ? a / 100 : a, 0, 1);
}
function $ed234ca8eb1f5a84$var$clamp(n, min, max) {
    return Math.min(Math.max(min, n), max);
}
/**
 * The regular expression for numeric values is not super specific, and it may
 * happen that it will accept a value that is not a valid number. In order to
 * detect and eliminate such values this function exists.
 *
 * @param array Array of uncertain numbers.
 * @returns `true` if the specified array contains only valid numbers, `false` otherwise.
 */ function $ed234ca8eb1f5a84$var$validateNumbers(array) {
    return !array.some(Number.isNaN);
}
/**
 * To generate:
 * - visit {@link https://www.w3.org/TR/css-color-4/#named-colors}
 * - run in the console:
 * @example
 * copy(`{\n${[...document.querySelector('.named-color-table tbody').children].map((tr) => `${tr.cells[2].textContent.trim()}: [${tr.cells[4].textContent.trim().split(/\s+/).join(', ')}],`).join('\n')}\n}`);
 */ const $ed234ca8eb1f5a84$var$namedColors = {
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        134,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        250,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    grey: [
        128,
        128,
        128
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        221
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    rebeccapurple: [
        102,
        51,
        153
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        112,
        128,
        144
    ],
    slategrey: [
        112,
        128,
        144
    ],
    snow: [
        255,
        250,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        50
    ]
};
function $ed234ca8eb1f5a84$var$interpolateNumber(from, to, t) {
    return from + t * (to - from);
}
function $ed234ca8eb1f5a84$var$interpolateArray(from, to, t) {
    return from.map((d, i)=>{
        return $ed234ca8eb1f5a84$var$interpolateNumber(d, to[i], t);
    });
}
/**
 * Checks whether the specified color space is one of the supported interpolation color spaces.
 *
 * @param colorSpace Color space key to verify.
 * @returns `true` if the specified color space is one of the supported
 * interpolation color spaces, `false` otherwise
 */ function $ed234ca8eb1f5a84$var$isSupportedInterpolationColorSpace(colorSpace) {
    return colorSpace === 'rgb' || colorSpace === 'hcl' || colorSpace === 'lab';
}
/**
 * Color representation used by WebGL.
 * Defined in sRGB color space and pre-blended with alpha.
 * @private
 */ class $ed234ca8eb1f5a84$export$892596cec99bc70e {
    /**
     * @param r Red component premultiplied by `alpha` 0..1
     * @param g Green component premultiplied by `alpha` 0..1
     * @param b Blue component premultiplied by `alpha` 0..1
     * @param [alpha=1] Alpha component 0..1
     * @param [premultiplied=true] Whether the `r`, `g` and `b` values have already
     * been multiplied by alpha. If `true` nothing happens if `false` then they will
     * be multiplied automatically.
     */ constructor(r, g, b, alpha = 1, premultiplied = true){
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = alpha;
        if (!premultiplied) {
            this.r *= alpha;
            this.g *= alpha;
            this.b *= alpha;
            if (!alpha) // alpha = 0 erases completely rgb channels. This behavior is not desirable
            // if this particular color is later used in color interpolation.
            // Because of that, a reference to original color is saved.
            this.overwriteGetter('rgb', [
                r,
                g,
                b,
                alpha
            ]);
        }
    }
    /**
     * Parses CSS color strings and converts colors to sRGB color space if needed.
     * Officially supported color formats:
     * - keyword, e.g. 'aquamarine' or 'steelblue'
     * - hex (with 3, 4, 6 or 8 digits), e.g. '#f0f' or '#e9bebea9'
     * - rgb and rgba, e.g. 'rgb(0,240,120)' or 'rgba(0%,94%,47%,0.1)' or 'rgb(0 240 120 / .3)'
     * - hsl and hsla, e.g. 'hsl(0,0%,83%)' or 'hsla(0,0%,83%,.5)' or 'hsl(0 0% 83% / 20%)'
     *
     * @param input CSS color string to parse.
     * @returns A `Color` instance, or `undefined` if the input is not a valid color string.
     */ static parse(input) {
        // in zoom-and-property function input could be an instance of Color class
        if (input instanceof $ed234ca8eb1f5a84$export$892596cec99bc70e) return input;
        if (typeof input !== 'string') return;
        const rgba = $ed234ca8eb1f5a84$var$parseCssColor(input);
        if (rgba) return new $ed234ca8eb1f5a84$export$892596cec99bc70e(...rgba, false);
    }
    /**
     * Used in color interpolation and by 'to-rgba' expression.
     *
     * @returns Gien color, with reversed alpha blending, in sRGB color space.
     */ get rgb() {
        const { r: r, g: g, b: b, a: a } = this;
        const f = a || Infinity; // reverse alpha blending factor
        return this.overwriteGetter('rgb', [
            r / f,
            g / f,
            b / f,
            a
        ]);
    }
    /**
     * Used in color interpolation.
     *
     * @returns Gien color, with reversed alpha blending, in HCL color space.
     */ get hcl() {
        return this.overwriteGetter('hcl', $ed234ca8eb1f5a84$var$rgbToHcl(this.rgb));
    }
    /**
     * Used in color interpolation.
     *
     * @returns Gien color, with reversed alpha blending, in LAB color space.
     */ get lab() {
        return this.overwriteGetter('lab', $ed234ca8eb1f5a84$var$rgbToLab(this.rgb));
    }
    /**
     * Lazy getter pattern. When getter is called for the first time lazy value
     * is calculated and then overwrites getter function in given object instance.
     *
     * @example:
     * const redColor = Color.parse('red');
     * let x = redColor.hcl; // this will invoke `get hcl()`, which will calculate
     * // the value of red in HCL space and invoke this `overwriteGetter` function
     * // which in turn will set a field with a key 'hcl' in the `redColor` object.
     * // In other words it will override `get hcl()` from its `Color` prototype
     * // with its own property: hcl = [calculated red value in hcl].
     * let y = redColor.hcl; // next call will no longer invoke getter but simply
     * // return the previously calculated value
     * x === y; // true - `x` is exactly the same object as `y`
     *
     * @param getterKey Getter key
     * @param lazyValue Lazily calculated value to be memoized by current instance
     * @private
     */ overwriteGetter(getterKey, lazyValue) {
        Object.defineProperty(this, getterKey, {
            value: lazyValue
        });
        return lazyValue;
    }
    /**
     * Used by 'to-string' expression.
     *
     * @returns Serialized color in format `rgba(r,g,b,a)`
     * where r,g,b are numbers within 0..255 and alpha is number within 1..0
     *
     * @example
     * var purple = new Color.parse('purple');
     * purple.toString; // = "rgba(128,0,128,1)"
     * var translucentGreen = new Color.parse('rgba(26, 207, 26, .73)');
     * translucentGreen.toString(); // = "rgba(26,207,26,0.73)"
     */ toString() {
        const [r, g, b, a] = this.rgb;
        return `rgba(${[
            r,
            g,
            b
        ].map((n)=>Math.round(n * 255)).join(',')},${a})`;
    }
    static interpolate(from, to, t, spaceKey = 'rgb') {
        switch(spaceKey){
            case 'rgb':
                {
                    const [r, g, b, alpha] = $ed234ca8eb1f5a84$var$interpolateArray(from.rgb, to.rgb, t);
                    return new $ed234ca8eb1f5a84$export$892596cec99bc70e(r, g, b, alpha, false);
                }
            case 'hcl':
                {
                    const [hue0, chroma0, light0, alphaF] = from.hcl;
                    const [hue1, chroma1, light1, alphaT] = to.hcl;
                    // https://github.com/gka/chroma.js/blob/cd1b3c0926c7a85cbdc3b1453b3a94006de91a92/src/interpolator/_hsx.js
                    let hue, chroma;
                    if (!isNaN(hue0) && !isNaN(hue1)) {
                        let dh = hue1 - hue0;
                        if (hue1 > hue0 && dh > 180) dh -= 360;
                        else if (hue1 < hue0 && hue0 - hue1 > 180) dh += 360;
                        hue = hue0 + t * dh;
                    } else if (!isNaN(hue0)) {
                        hue = hue0;
                        if (light1 === 1 || light1 === 0) chroma = chroma0;
                    } else if (!isNaN(hue1)) {
                        hue = hue1;
                        if (light0 === 1 || light0 === 0) chroma = chroma1;
                    } else hue = NaN;
                    const [r, g, b, alpha] = $ed234ca8eb1f5a84$var$hclToRgb([
                        hue,
                        chroma !== null && chroma !== void 0 ? chroma : $ed234ca8eb1f5a84$var$interpolateNumber(chroma0, chroma1, t),
                        $ed234ca8eb1f5a84$var$interpolateNumber(light0, light1, t),
                        $ed234ca8eb1f5a84$var$interpolateNumber(alphaF, alphaT, t)
                    ]);
                    return new $ed234ca8eb1f5a84$export$892596cec99bc70e(r, g, b, alpha, false);
                }
            case 'lab':
                {
                    const [r, g, b, alpha] = $ed234ca8eb1f5a84$var$labToRgb($ed234ca8eb1f5a84$var$interpolateArray(from.lab, to.lab, t));
                    return new $ed234ca8eb1f5a84$export$892596cec99bc70e(r, g, b, alpha, false);
                }
        }
    }
}
$ed234ca8eb1f5a84$export$892596cec99bc70e.black = new $ed234ca8eb1f5a84$export$892596cec99bc70e(0, 0, 0, 1);
$ed234ca8eb1f5a84$export$892596cec99bc70e.white = new $ed234ca8eb1f5a84$export$892596cec99bc70e(1, 1, 1, 1);
$ed234ca8eb1f5a84$export$892596cec99bc70e.transparent = new $ed234ca8eb1f5a84$export$892596cec99bc70e(0, 0, 0, 0);
$ed234ca8eb1f5a84$export$892596cec99bc70e.red = new $ed234ca8eb1f5a84$export$892596cec99bc70e(1, 0, 0, 1);
class $ed234ca8eb1f5a84$var$Collator {
    constructor(caseSensitive, diacriticSensitive, locale){
        if (caseSensitive) this.sensitivity = diacriticSensitive ? 'variant' : 'case';
        else this.sensitivity = diacriticSensitive ? 'accent' : 'base';
        this.locale = locale;
        this.collator = new Intl.Collator(this.locale ? this.locale : [], {
            sensitivity: this.sensitivity,
            usage: 'search'
        });
    }
    compare(lhs, rhs) {
        return this.collator.compare(lhs, rhs);
    }
    resolvedLocale() {
        // We create a Collator without "usage: search" because we don't want
        // the search options encoded in our result (e.g. "en-u-co-search")
        return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
    }
}
const $ed234ca8eb1f5a84$var$VERTICAL_ALIGN_OPTIONS = [
    'bottom',
    'center',
    'top'
];
class $ed234ca8eb1f5a84$export$3a6ff7dce00da298 {
    constructor(text, image, scale, fontStack, textColor, verticalAlign){
        this.text = text;
        this.image = image;
        this.scale = scale;
        this.fontStack = fontStack;
        this.textColor = textColor;
        this.verticalAlign = verticalAlign;
    }
}
class $ed234ca8eb1f5a84$export$4eb8fc242550f5dd {
    constructor(sections){
        this.sections = sections;
    }
    static fromString(unformatted) {
        return new $ed234ca8eb1f5a84$export$4eb8fc242550f5dd([
            new $ed234ca8eb1f5a84$export$3a6ff7dce00da298(unformatted, null, null, null, null, null)
        ]);
    }
    isEmpty() {
        if (this.sections.length === 0) return true;
        return !this.sections.some((section)=>section.text.length !== 0 || section.image && section.image.name.length !== 0);
    }
    static factory(text) {
        if (text instanceof $ed234ca8eb1f5a84$export$4eb8fc242550f5dd) return text;
        else return $ed234ca8eb1f5a84$export$4eb8fc242550f5dd.fromString(text);
    }
    toString() {
        if (this.sections.length === 0) return '';
        return this.sections.map((section)=>section.text).join('');
    }
}
/**
 * A set of four numbers representing padding around a box. Create instances from
 * bare arrays or numeric values using the static method `Padding.parse`.
 * @private
 */ class $ed234ca8eb1f5a84$export$8ee6ea94b5aedb49 {
    constructor(values){
        this.values = values.slice();
    }
    /**
     * Numeric padding values
     * @param input A padding value
     * @returns A `Padding` instance, or `undefined` if the input is not a valid padding value.
     */ static parse(input) {
        if (input instanceof $ed234ca8eb1f5a84$export$8ee6ea94b5aedb49) return input;
        // Backwards compatibility: bare number is treated the same as array with single value.
        // Padding applies to all four sides.
        if (typeof input === 'number') return new $ed234ca8eb1f5a84$export$8ee6ea94b5aedb49([
            input,
            input,
            input,
            input
        ]);
        if (!Array.isArray(input)) return undefined;
        if (input.length < 1 || input.length > 4) return undefined;
        for (const val of input){
            if (typeof val !== 'number') return undefined;
        }
        // Expand shortcut properties into explicit 4-sided values
        switch(input.length){
            case 1:
                input = [
                    input[0],
                    input[0],
                    input[0],
                    input[0]
                ];
                break;
            case 2:
                input = [
                    input[0],
                    input[1],
                    input[0],
                    input[1]
                ];
                break;
            case 3:
                input = [
                    input[0],
                    input[1],
                    input[2],
                    input[1]
                ];
                break;
        }
        return new $ed234ca8eb1f5a84$export$8ee6ea94b5aedb49(input);
    }
    toString() {
        return JSON.stringify(this.values);
    }
    static interpolate(from, to, t) {
        return new $ed234ca8eb1f5a84$export$8ee6ea94b5aedb49($ed234ca8eb1f5a84$var$interpolateArray(from.values, to.values, t));
    }
}
/**
 * An array of numbers. Create instances from
 * bare arrays or numeric values using the static method `NumberArray.parse`.
 * @private
 */ class $ed234ca8eb1f5a84$export$70583a403f005a99 {
    constructor(values){
        this.values = values.slice();
    }
    /**
     * Numeric NumberArray values
     * @param input A NumberArray value
     * @returns A `NumberArray` instance, or `undefined` if the input is not a valid NumberArray value.
     */ static parse(input) {
        if (input instanceof $ed234ca8eb1f5a84$export$70583a403f005a99) return input;
        // Backwards compatibility (e.g. hillshade-illumination-direction): bare number is treated the same as array with single value.
        if (typeof input === 'number') return new $ed234ca8eb1f5a84$export$70583a403f005a99([
            input
        ]);
        if (!Array.isArray(input)) return undefined;
        for (const val of input){
            if (typeof val !== 'number') return undefined;
        }
        return new $ed234ca8eb1f5a84$export$70583a403f005a99(input);
    }
    toString() {
        return JSON.stringify(this.values);
    }
    static interpolate(from, to, t) {
        return new $ed234ca8eb1f5a84$export$70583a403f005a99($ed234ca8eb1f5a84$var$interpolateArray(from.values, to.values, t));
    }
}
/**
 * An array of colors. Create instances from
 * bare arrays or strings using the static method `ColorArray.parse`.
 * @private
 */ class $ed234ca8eb1f5a84$export$afb89052b482fa15 {
    constructor(values){
        this.values = values.slice();
    }
    /**
     * ColorArray values
     * @param input A ColorArray value
     * @returns A `ColorArray` instance, or `undefined` if the input is not a valid ColorArray value.
     */ static parse(input) {
        if (input instanceof $ed234ca8eb1f5a84$export$afb89052b482fa15) return input;
        // Backwards compatibility (e.g. hillshade-shadow-color): bare Color is treated the same as array with single value.
        if (typeof input === 'string') {
            const parsed_val = $ed234ca8eb1f5a84$export$892596cec99bc70e.parse(input);
            if (!parsed_val) return undefined;
            return new $ed234ca8eb1f5a84$export$afb89052b482fa15([
                parsed_val
            ]);
        }
        if (!Array.isArray(input)) return undefined;
        const colors = [];
        for (const val of input){
            if (typeof val !== 'string') return undefined;
            const parsed_val = $ed234ca8eb1f5a84$export$892596cec99bc70e.parse(val);
            if (!parsed_val) return undefined;
            colors.push(parsed_val);
        }
        return new $ed234ca8eb1f5a84$export$afb89052b482fa15(colors);
    }
    toString() {
        return JSON.stringify(this.values);
    }
    static interpolate(from, to, t, spaceKey = 'rgb') {
        const colors = [];
        if (from.values.length != to.values.length) throw new Error(`colorArray: Arrays have mismatched length (${from.values.length} vs. ${to.values.length}), cannot interpolate.`);
        for(let i = 0; i < from.values.length; i++)colors.push($ed234ca8eb1f5a84$export$892596cec99bc70e.interpolate(from.values[i], to.values[i], t, spaceKey));
        return new $ed234ca8eb1f5a84$export$afb89052b482fa15(colors);
    }
}
class $ed234ca8eb1f5a84$var$RuntimeError extends Error {
    constructor(message){
        super(message);
        this.name = 'RuntimeError';
    }
    toJSON() {
        return this.message;
    }
}
/** Set of valid anchor positions, as a set for validation */ const $ed234ca8eb1f5a84$var$anchors = new Set([
    'center',
    'left',
    'right',
    'top',
    'bottom',
    'top-left',
    'top-right',
    'bottom-left',
    'bottom-right'
]);
/**
 * Utility class to assist managing values for text-variable-anchor-offset property. Create instances from
 * bare arrays using the static method `VariableAnchorOffsetCollection.parse`.
 * @private
 */ class $ed234ca8eb1f5a84$export$4fdfd474f5d53309 {
    constructor(values){
        this.values = values.slice();
    }
    static parse(input) {
        if (input instanceof $ed234ca8eb1f5a84$export$4fdfd474f5d53309) return input;
        if (!Array.isArray(input) || input.length < 1 || input.length % 2 !== 0) return undefined;
        for(let i = 0; i < input.length; i += 2){
            // Elements in even positions should be anchor positions; Elements in odd positions should be offset values
            const anchorValue = input[i];
            const offsetValue = input[i + 1];
            if (typeof anchorValue !== 'string' || !$ed234ca8eb1f5a84$var$anchors.has(anchorValue)) return undefined;
            if (!Array.isArray(offsetValue) || offsetValue.length !== 2 || typeof offsetValue[0] !== 'number' || typeof offsetValue[1] !== 'number') return undefined;
        }
        return new $ed234ca8eb1f5a84$export$4fdfd474f5d53309(input);
    }
    toString() {
        return JSON.stringify(this.values);
    }
    static interpolate(from, to, t) {
        const fromValues = from.values;
        const toValues = to.values;
        if (fromValues.length !== toValues.length) throw new $ed234ca8eb1f5a84$var$RuntimeError(`Cannot interpolate values of different length. from: ${from.toString()}, to: ${to.toString()}`);
        const output = [];
        for(let i = 0; i < fromValues.length; i += 2){
            // Anchor entries must match
            if (fromValues[i] !== toValues[i]) throw new $ed234ca8eb1f5a84$var$RuntimeError(`Cannot interpolate values containing mismatched anchors. from[${i}]: ${fromValues[i]}, to[${i}]: ${toValues[i]}`);
            output.push(fromValues[i]);
            // Interpolate the offset values for each anchor
            const [fx, fy] = fromValues[i + 1];
            const [tx, ty] = toValues[i + 1];
            output.push([
                $ed234ca8eb1f5a84$var$interpolateNumber(fx, tx, t),
                $ed234ca8eb1f5a84$var$interpolateNumber(fy, ty, t)
            ]);
        }
        return new $ed234ca8eb1f5a84$export$4fdfd474f5d53309(output);
    }
}
class $ed234ca8eb1f5a84$export$8511b53abdedaff9 {
    constructor(options){
        this.name = options.name;
        this.available = options.available;
    }
    toString() {
        return this.name;
    }
    static fromString(name) {
        if (!name) return null; // treat empty values as no image
        return new $ed234ca8eb1f5a84$export$8511b53abdedaff9({
            name: name,
            available: false
        });
    }
}
class $ed234ca8eb1f5a84$export$95891bdb6f673ac1 {
    constructor(from, to, transition){
        this.from = from;
        this.to = to;
        this.transition = transition;
    }
    static interpolate(from, to, t) {
        return new $ed234ca8eb1f5a84$export$95891bdb6f673ac1(from, to, t);
    }
    static parse(input) {
        if (input instanceof $ed234ca8eb1f5a84$export$95891bdb6f673ac1) return input;
        if (Array.isArray(input) && input.length === 3 && typeof input[0] === 'string' && typeof input[1] === 'string' && typeof input[2] === 'number') return new $ed234ca8eb1f5a84$export$95891bdb6f673ac1(input[0], input[1], input[2]);
        if (typeof input === 'object' && typeof input.from === 'string' && typeof input.to === 'string' && typeof input.transition === 'number') return new $ed234ca8eb1f5a84$export$95891bdb6f673ac1(input.from, input.to, input.transition);
        if (typeof input === 'string') return new $ed234ca8eb1f5a84$export$95891bdb6f673ac1(input, input, 1);
        return undefined;
    }
}
function $ed234ca8eb1f5a84$var$validateRGBA(r, g, b, a) {
    if (!(typeof r === 'number' && r >= 0 && r <= 255 && typeof g === 'number' && g >= 0 && g <= 255 && typeof b === 'number' && b >= 0 && b <= 255)) {
        const value = typeof a === 'number' ? [
            r,
            g,
            b,
            a
        ] : [
            r,
            g,
            b
        ];
        return `Invalid rgba value [${value.join(', ')}]: 'r', 'g', and 'b' must be between 0 and 255.`;
    }
    if (!(typeof a === 'undefined' || typeof a === 'number' && a >= 0 && a <= 1)) return `Invalid rgba value [${[
        r,
        g,
        b,
        a
    ].join(', ')}]: 'a' must be between 0 and 1.`;
    return null;
}
function $ed234ca8eb1f5a84$var$isValue(mixed) {
    if (mixed === null || typeof mixed === 'string' || typeof mixed === 'boolean' || typeof mixed === 'number' || mixed instanceof $ed234ca8eb1f5a84$export$95891bdb6f673ac1 || mixed instanceof $ed234ca8eb1f5a84$export$892596cec99bc70e || mixed instanceof $ed234ca8eb1f5a84$var$Collator || mixed instanceof $ed234ca8eb1f5a84$export$4eb8fc242550f5dd || mixed instanceof $ed234ca8eb1f5a84$export$8ee6ea94b5aedb49 || mixed instanceof $ed234ca8eb1f5a84$export$70583a403f005a99 || mixed instanceof $ed234ca8eb1f5a84$export$afb89052b482fa15 || mixed instanceof $ed234ca8eb1f5a84$export$4fdfd474f5d53309 || mixed instanceof $ed234ca8eb1f5a84$export$8511b53abdedaff9) return true;
    else if (Array.isArray(mixed)) {
        for (const item of mixed){
            if (!$ed234ca8eb1f5a84$var$isValue(item)) return false;
        }
        return true;
    } else if (typeof mixed === 'object') {
        for(const key in mixed){
            if (!$ed234ca8eb1f5a84$var$isValue(mixed[key])) return false;
        }
        return true;
    } else return false;
}
function $ed234ca8eb1f5a84$export$f5bbd400c2f4426f(value) {
    if (value === null) return $ed234ca8eb1f5a84$export$95d6ca0ebe20dc35;
    else if (typeof value === 'string') return $ed234ca8eb1f5a84$var$StringType;
    else if (typeof value === 'boolean') return $ed234ca8eb1f5a84$var$BooleanType;
    else if (typeof value === 'number') return $ed234ca8eb1f5a84$var$NumberType;
    else if (value instanceof $ed234ca8eb1f5a84$export$892596cec99bc70e) return $ed234ca8eb1f5a84$export$2cd82751acc0e609;
    else if (value instanceof $ed234ca8eb1f5a84$export$95891bdb6f673ac1) return $ed234ca8eb1f5a84$export$7ec308bb4472cd41;
    else if (value instanceof $ed234ca8eb1f5a84$var$Collator) return $ed234ca8eb1f5a84$var$CollatorType;
    else if (value instanceof $ed234ca8eb1f5a84$export$4eb8fc242550f5dd) return $ed234ca8eb1f5a84$export$831566e53e7565f9;
    else if (value instanceof $ed234ca8eb1f5a84$export$8ee6ea94b5aedb49) return $ed234ca8eb1f5a84$var$PaddingType;
    else if (value instanceof $ed234ca8eb1f5a84$export$70583a403f005a99) return $ed234ca8eb1f5a84$var$NumberArrayType;
    else if (value instanceof $ed234ca8eb1f5a84$export$afb89052b482fa15) return $ed234ca8eb1f5a84$var$ColorArrayType;
    else if (value instanceof $ed234ca8eb1f5a84$export$4fdfd474f5d53309) return $ed234ca8eb1f5a84$var$VariableAnchorOffsetCollectionType;
    else if (value instanceof $ed234ca8eb1f5a84$export$8511b53abdedaff9) return $ed234ca8eb1f5a84$var$ResolvedImageType;
    else if (Array.isArray(value)) {
        const length = value.length;
        let itemType;
        for (const item of value){
            const t = $ed234ca8eb1f5a84$export$f5bbd400c2f4426f(item);
            if (!itemType) itemType = t;
            else if (itemType === t) continue;
            else {
                itemType = $ed234ca8eb1f5a84$var$ValueType;
                break;
            }
        }
        return $ed234ca8eb1f5a84$var$array(itemType || $ed234ca8eb1f5a84$var$ValueType, length);
    } else return $ed234ca8eb1f5a84$var$ObjectType;
}
function $ed234ca8eb1f5a84$var$valueToString(value) {
    const type = typeof value;
    if (value === null) return '';
    else if (type === 'string' || type === 'number' || type === 'boolean') return String(value);
    else if (value instanceof $ed234ca8eb1f5a84$export$892596cec99bc70e || value instanceof $ed234ca8eb1f5a84$export$95891bdb6f673ac1 || value instanceof $ed234ca8eb1f5a84$export$4eb8fc242550f5dd || value instanceof $ed234ca8eb1f5a84$export$8ee6ea94b5aedb49 || value instanceof $ed234ca8eb1f5a84$export$70583a403f005a99 || value instanceof $ed234ca8eb1f5a84$export$afb89052b482fa15 || value instanceof $ed234ca8eb1f5a84$export$4fdfd474f5d53309 || value instanceof $ed234ca8eb1f5a84$export$8511b53abdedaff9) return value.toString();
    else return JSON.stringify(value);
}
class $ed234ca8eb1f5a84$export$e175ae9e414693bc {
    constructor(type, value){
        this.type = type;
        this.value = value;
    }
    static parse(args, context) {
        if (args.length !== 2) return context.error(`'literal' expression requires exactly one argument, but found ${args.length - 1} instead.`);
        if (!$ed234ca8eb1f5a84$var$isValue(args[1])) return context.error('invalid value');
        const value = args[1];
        let type = $ed234ca8eb1f5a84$export$f5bbd400c2f4426f(value);
        // special case: infer the item type if possible for zero-length arrays
        const expected = context.expectedType;
        if (type.kind === 'array' && type.N === 0 && expected && expected.kind === 'array' && (typeof expected.N !== 'number' || expected.N === 0)) type = expected;
        return new $ed234ca8eb1f5a84$export$e175ae9e414693bc(type, value);
    }
    evaluate() {
        return this.value;
    }
    eachChild() {}
    outputDefined() {
        return true;
    }
}
const $ed234ca8eb1f5a84$var$types$1 = {
    string: $ed234ca8eb1f5a84$var$StringType,
    number: $ed234ca8eb1f5a84$var$NumberType,
    boolean: $ed234ca8eb1f5a84$var$BooleanType,
    object: $ed234ca8eb1f5a84$var$ObjectType
};
class $ed234ca8eb1f5a84$var$Assertion {
    constructor(type, args){
        this.type = type;
        this.args = args;
    }
    static parse(args, context) {
        if (args.length < 2) return context.error('Expected at least one argument.');
        let i = 1;
        let type;
        const name = args[0];
        if (name === 'array') {
            let itemType;
            if (args.length > 2) {
                const type = args[1];
                if (typeof type !== 'string' || !(type in $ed234ca8eb1f5a84$var$types$1) || type === 'object') return context.error('The item type argument of "array" must be one of string, number, boolean', 1);
                itemType = $ed234ca8eb1f5a84$var$types$1[type];
                i++;
            } else itemType = $ed234ca8eb1f5a84$var$ValueType;
            let N;
            if (args.length > 3) {
                if (args[2] !== null && (typeof args[2] !== 'number' || args[2] < 0 || args[2] !== Math.floor(args[2]))) return context.error('The length argument to "array" must be a positive integer literal', 2);
                N = args[2];
                i++;
            }
            type = $ed234ca8eb1f5a84$var$array(itemType, N);
        } else {
            if (!$ed234ca8eb1f5a84$var$types$1[name]) throw new Error(`Types doesn't contain name = ${name}`);
            type = $ed234ca8eb1f5a84$var$types$1[name];
        }
        const parsed = [];
        for(; i < args.length; i++){
            const input = context.parse(args[i], i, $ed234ca8eb1f5a84$var$ValueType);
            if (!input) return null;
            parsed.push(input);
        }
        return new $ed234ca8eb1f5a84$var$Assertion(type, parsed);
    }
    evaluate(ctx) {
        for(let i = 0; i < this.args.length; i++){
            const value = this.args[i].evaluate(ctx);
            const error = $ed234ca8eb1f5a84$var$checkSubtype(this.type, $ed234ca8eb1f5a84$export$f5bbd400c2f4426f(value));
            if (!error) return value;
            else if (i === this.args.length - 1) throw new $ed234ca8eb1f5a84$var$RuntimeError(`Expected value to be of type ${$ed234ca8eb1f5a84$export$f84e8e69fd4488a5(this.type)}, but found ${$ed234ca8eb1f5a84$export$f84e8e69fd4488a5($ed234ca8eb1f5a84$export$f5bbd400c2f4426f(value))} instead.`);
        }
        throw new Error();
    }
    eachChild(fn) {
        this.args.forEach(fn);
    }
    outputDefined() {
        return this.args.every((arg)=>arg.outputDefined());
    }
}
const $ed234ca8eb1f5a84$var$types = {
    'to-boolean': $ed234ca8eb1f5a84$var$BooleanType,
    'to-color': $ed234ca8eb1f5a84$export$2cd82751acc0e609,
    'to-number': $ed234ca8eb1f5a84$var$NumberType,
    'to-string': $ed234ca8eb1f5a84$var$StringType
};
/**
 * Special form for error-coalescing coercion expressions "to-number",
 * "to-color".  Since these coercions can fail at runtime, they accept multiple
 * arguments, only evaluating one at a time until one succeeds.
 *
 * @private
 */ class $ed234ca8eb1f5a84$var$Coercion {
    constructor(type, args){
        this.type = type;
        this.args = args;
    }
    static parse(args, context) {
        if (args.length < 2) return context.error('Expected at least one argument.');
        const name = args[0];
        if (!$ed234ca8eb1f5a84$var$types[name]) throw new Error(`Can't parse ${name} as it is not part of the known types`);
        if ((name === 'to-boolean' || name === 'to-string') && args.length !== 2) return context.error('Expected one argument.');
        const type = $ed234ca8eb1f5a84$var$types[name];
        const parsed = [];
        for(let i = 1; i < args.length; i++){
            const input = context.parse(args[i], i, $ed234ca8eb1f5a84$var$ValueType);
            if (!input) return null;
            parsed.push(input);
        }
        return new $ed234ca8eb1f5a84$var$Coercion(type, parsed);
    }
    evaluate(ctx) {
        switch(this.type.kind){
            case 'boolean':
                return Boolean(this.args[0].evaluate(ctx));
            case 'color':
                {
                    let input;
                    let error;
                    for (const arg of this.args){
                        input = arg.evaluate(ctx);
                        error = null;
                        if (input instanceof $ed234ca8eb1f5a84$export$892596cec99bc70e) return input;
                        else if (typeof input === 'string') {
                            const c = ctx.parseColor(input);
                            if (c) return c;
                        } else if (Array.isArray(input)) {
                            if (input.length < 3 || input.length > 4) error = `Invalid rgba value ${JSON.stringify(input)}: expected an array containing either three or four numeric values.`;
                            else error = $ed234ca8eb1f5a84$var$validateRGBA(input[0], input[1], input[2], input[3]);
                            if (!error) return new $ed234ca8eb1f5a84$export$892596cec99bc70e(input[0] / 255, input[1] / 255, input[2] / 255, input[3]);
                        }
                    }
                    throw new $ed234ca8eb1f5a84$var$RuntimeError(error || `Could not parse color from value '${typeof input === 'string' ? input : JSON.stringify(input)}'`);
                }
            case 'padding':
                {
                    let input;
                    for (const arg of this.args){
                        input = arg.evaluate(ctx);
                        const pad = $ed234ca8eb1f5a84$export$8ee6ea94b5aedb49.parse(input);
                        if (pad) return pad;
                    }
                    throw new $ed234ca8eb1f5a84$var$RuntimeError(`Could not parse padding from value '${typeof input === 'string' ? input : JSON.stringify(input)}'`);
                }
            case 'numberArray':
                {
                    let input;
                    for (const arg of this.args){
                        input = arg.evaluate(ctx);
                        const val = $ed234ca8eb1f5a84$export$70583a403f005a99.parse(input);
                        if (val) return val;
                    }
                    throw new $ed234ca8eb1f5a84$var$RuntimeError(`Could not parse numberArray from value '${typeof input === 'string' ? input : JSON.stringify(input)}'`);
                }
            case 'colorArray':
                {
                    let input;
                    for (const arg of this.args){
                        input = arg.evaluate(ctx);
                        const val = $ed234ca8eb1f5a84$export$afb89052b482fa15.parse(input);
                        if (val) return val;
                    }
                    throw new $ed234ca8eb1f5a84$var$RuntimeError(`Could not parse colorArray from value '${typeof input === 'string' ? input : JSON.stringify(input)}'`);
                }
            case 'variableAnchorOffsetCollection':
                {
                    let input;
                    for (const arg of this.args){
                        input = arg.evaluate(ctx);
                        const coll = $ed234ca8eb1f5a84$export$4fdfd474f5d53309.parse(input);
                        if (coll) return coll;
                    }
                    throw new $ed234ca8eb1f5a84$var$RuntimeError(`Could not parse variableAnchorOffsetCollection from value '${typeof input === 'string' ? input : JSON.stringify(input)}'`);
                }
            case 'number':
                {
                    let value = null;
                    for (const arg of this.args){
                        value = arg.evaluate(ctx);
                        if (value === null) return 0;
                        const num = Number(value);
                        if (isNaN(num)) continue;
                        return num;
                    }
                    throw new $ed234ca8eb1f5a84$var$RuntimeError(`Could not convert ${JSON.stringify(value)} to number.`);
                }
            case 'formatted':
                // There is no explicit 'to-formatted' but this coercion can be implicitly
                // created by properties that expect the 'formatted' type.
                return $ed234ca8eb1f5a84$export$4eb8fc242550f5dd.fromString($ed234ca8eb1f5a84$var$valueToString(this.args[0].evaluate(ctx)));
            case 'resolvedImage':
                return $ed234ca8eb1f5a84$export$8511b53abdedaff9.fromString($ed234ca8eb1f5a84$var$valueToString(this.args[0].evaluate(ctx)));
            case 'projectionDefinition':
                return this.args[0].evaluate(ctx);
            default:
                return $ed234ca8eb1f5a84$var$valueToString(this.args[0].evaluate(ctx));
        }
    }
    eachChild(fn) {
        this.args.forEach(fn);
    }
    outputDefined() {
        return this.args.every((arg)=>arg.outputDefined());
    }
}
const $ed234ca8eb1f5a84$var$geometryTypes = [
    'Unknown',
    'Point',
    'LineString',
    'Polygon'
];
class $ed234ca8eb1f5a84$export$37230f824444580 {
    constructor(){
        this.globals = null;
        this.feature = null;
        this.featureState = null;
        this.formattedSection = null;
        this._parseColorCache = new Map();
        this.availableImages = null;
        this.canonical = null;
    }
    id() {
        return this.feature && 'id' in this.feature ? this.feature.id : null;
    }
    geometryType() {
        return this.feature ? typeof this.feature.type === 'number' ? $ed234ca8eb1f5a84$var$geometryTypes[this.feature.type] : this.feature.type : null;
    }
    geometry() {
        return this.feature && 'geometry' in this.feature ? this.feature.geometry : null;
    }
    canonicalID() {
        return this.canonical;
    }
    properties() {
        return this.feature && this.feature.properties || {};
    }
    parseColor(input) {
        let cached = this._parseColorCache.get(input);
        if (!cached) {
            cached = $ed234ca8eb1f5a84$export$892596cec99bc70e.parse(input);
            this._parseColorCache.set(input, cached);
        }
        return cached;
    }
}
/**
 * State associated parsing at a given point in an expression tree.
 * @private
 */ class $ed234ca8eb1f5a84$var$ParsingContext {
    constructor(registry, isConstantFunc, path = [], expectedType, scope = new $ed234ca8eb1f5a84$var$Scope(), errors = []){
        this.registry = registry;
        this.path = path;
        this.key = path.map((part)=>`[${part}]`).join('');
        this.scope = scope;
        this.errors = errors;
        this.expectedType = expectedType;
        this._isConstant = isConstantFunc;
    }
    /**
     * @param expr the JSON expression to parse
     * @param index the optional argument index if this expression is an argument of a parent expression that's being parsed
     * @param options
     * @param options.omitTypeAnnotations set true to omit inferred type annotations.  Caller beware: with this option set, the parsed expression's type will NOT satisfy `expectedType` if it would normally be wrapped in an inferred annotation.
     * @private
     */ parse(expr, index, expectedType, bindings, options = {}) {
        if (index) return this.concat(index, expectedType, bindings)._parse(expr, options);
        return this._parse(expr, options);
    }
    _parse(expr, options) {
        if (expr === null || typeof expr === 'string' || typeof expr === 'boolean' || typeof expr === 'number') expr = [
            'literal',
            expr
        ];
        function annotate(parsed, type, typeAnnotation) {
            if (typeAnnotation === 'assert') return new $ed234ca8eb1f5a84$var$Assertion(type, [
                parsed
            ]);
            else if (typeAnnotation === 'coerce') return new $ed234ca8eb1f5a84$var$Coercion(type, [
                parsed
            ]);
            else return parsed;
        }
        if (Array.isArray(expr)) {
            if (expr.length === 0) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
            const op = expr[0];
            if (typeof op !== 'string') {
                this.error(`Expression name must be a string, but found ${typeof op} instead. If you wanted a literal array, use ["literal", [...]].`, 0);
                return null;
            }
            const Expr = this.registry[op];
            if (Expr) {
                let parsed = Expr.parse(expr, this);
                if (!parsed) return null;
                if (this.expectedType) {
                    const expected = this.expectedType;
                    const actual = parsed.type;
                    // When we expect a number, string, boolean, or array but have a value, wrap it in an assertion.
                    // When we expect a color or formatted string, but have a string or value, wrap it in a coercion.
                    // Otherwise, we do static type-checking.
                    //
                    // These behaviors are overridable for:
                    //   * The "coalesce" operator, which needs to omit type annotations.
                    //   * String-valued properties (e.g. `text-field`), where coercion is more convenient than assertion.
                    //
                    if ((expected.kind === 'string' || expected.kind === 'number' || expected.kind === 'boolean' || expected.kind === 'object' || expected.kind === 'array') && actual.kind === 'value') parsed = annotate(parsed, expected, options.typeAnnotation || 'assert');
                    else if ('projectionDefinition' === expected.kind && [
                        'string',
                        'array'
                    ].includes(actual.kind) || [
                        'color',
                        'formatted',
                        'resolvedImage'
                    ].includes(expected.kind) && [
                        'value',
                        'string'
                    ].includes(actual.kind) || [
                        'padding',
                        'numberArray'
                    ].includes(expected.kind) && [
                        'value',
                        'number',
                        'array'
                    ].includes(actual.kind) || 'colorArray' === expected.kind && [
                        'value',
                        'string',
                        'array'
                    ].includes(actual.kind) || 'variableAnchorOffsetCollection' === expected.kind && [
                        'value',
                        'array'
                    ].includes(actual.kind)) parsed = annotate(parsed, expected, options.typeAnnotation || 'coerce');
                    else if (this.checkSubtype(expected, actual)) return null;
                }
                // If an expression's arguments are all literals, we can evaluate
                // it immediately and replace it with a literal value in the
                // parsed/compiled result. Expressions that expect an image should
                // not be resolved here so we can later get the available images.
                if (!(parsed instanceof $ed234ca8eb1f5a84$export$e175ae9e414693bc) && parsed.type.kind !== 'resolvedImage' && this._isConstant(parsed)) {
                    const ec = new $ed234ca8eb1f5a84$export$37230f824444580();
                    try {
                        parsed = new $ed234ca8eb1f5a84$export$e175ae9e414693bc(parsed.type, parsed.evaluate(ec));
                    } catch (e) {
                        this.error(e.message);
                        return null;
                    }
                }
                return parsed;
            }
            return this.error(`Unknown expression "${op}". If you wanted a literal array, use ["literal", [...]].`, 0);
        } else if (typeof expr === 'undefined') return this.error("'undefined' value invalid. Use null instead.");
        else if (typeof expr === 'object') return this.error('Bare objects invalid. Use ["literal", {...}] instead.');
        else return this.error(`Expected an array, but found ${typeof expr} instead.`);
    }
    /**
     * Returns a copy of this context suitable for parsing the subexpression at
     * index `index`, optionally appending to 'let' binding map.
     *
     * Note that `errors` property, intended for collecting errors while
     * parsing, is copied by reference rather than cloned.
     * @private
     */ concat(index, expectedType, bindings) {
        const path = typeof index === 'number' ? this.path.concat(index) : this.path;
        const scope = bindings ? this.scope.concat(bindings) : this.scope;
        return new $ed234ca8eb1f5a84$var$ParsingContext(this.registry, this._isConstant, path, expectedType || null, scope, this.errors);
    }
    /**
     * Push a parsing (or type checking) error into the `this.errors`
     * @param error The message
     * @param keys Optionally specify the source of the error at a child
     * of the current expression at `this.key`.
     * @private
     */ error(error, ...keys) {
        const key = `${this.key}${keys.map((k)=>`[${k}]`).join('')}`;
        this.errors.push(new $ed234ca8eb1f5a84$var$ExpressionParsingError(key, error));
    }
    /**
     * Returns null if `t` is a subtype of `expected`; otherwise returns an
     * error message and also pushes it to `this.errors`.
     * @param expected The expected type
     * @param t The actual type
     * @returns null if `t` is a subtype of `expected`; otherwise returns an error message
     */ checkSubtype(expected, t) {
        const error = $ed234ca8eb1f5a84$var$checkSubtype(expected, t);
        if (error) this.error(error);
        return error;
    }
}
class $ed234ca8eb1f5a84$var$Let {
    constructor(bindings, result){
        this.type = result.type;
        this.bindings = [].concat(bindings);
        this.result = result;
    }
    evaluate(ctx) {
        return this.result.evaluate(ctx);
    }
    eachChild(fn) {
        for (const binding of this.bindings)fn(binding[1]);
        fn(this.result);
    }
    static parse(args, context) {
        if (args.length < 4) return context.error(`Expected at least 3 arguments, but found ${args.length - 1} instead.`);
        const bindings = [];
        for(let i = 1; i < args.length - 1; i += 2){
            const name = args[i];
            if (typeof name !== 'string') return context.error(`Expected string, but found ${typeof name} instead.`, i);
            if (/[^a-zA-Z0-9_]/.test(name)) return context.error("Variable names must contain only alphanumeric characters or '_'.", i);
            const value = context.parse(args[i + 1], i + 1);
            if (!value) return null;
            bindings.push([
                name,
                value
            ]);
        }
        const result = context.parse(args[args.length - 1], args.length - 1, context.expectedType, bindings);
        if (!result) return null;
        return new $ed234ca8eb1f5a84$var$Let(bindings, result);
    }
    outputDefined() {
        return this.result.outputDefined();
    }
}
class $ed234ca8eb1f5a84$var$Var {
    constructor(name, boundExpression){
        this.type = boundExpression.type;
        this.name = name;
        this.boundExpression = boundExpression;
    }
    static parse(args, context) {
        if (args.length !== 2 || typeof args[1] !== 'string') return context.error("'var' expression requires exactly one string literal argument.");
        const name = args[1];
        if (!context.scope.has(name)) return context.error(`Unknown variable "${name}". Make sure "${name}" has been bound in an enclosing "let" expression before using it.`, 1);
        return new $ed234ca8eb1f5a84$var$Var(name, context.scope.get(name));
    }
    evaluate(ctx) {
        return this.boundExpression.evaluate(ctx);
    }
    eachChild() {}
    outputDefined() {
        return false;
    }
}
class $ed234ca8eb1f5a84$var$At {
    constructor(type, index, input){
        this.type = type;
        this.index = index;
        this.input = input;
    }
    static parse(args, context) {
        if (args.length !== 3) return context.error(`Expected 2 arguments, but found ${args.length - 1} instead.`);
        const index = context.parse(args[1], 1, $ed234ca8eb1f5a84$var$NumberType);
        const input = context.parse(args[2], 2, $ed234ca8eb1f5a84$var$array(context.expectedType || $ed234ca8eb1f5a84$var$ValueType));
        if (!index || !input) return null;
        const t = input.type;
        return new $ed234ca8eb1f5a84$var$At(t.itemType, index, input);
    }
    evaluate(ctx) {
        const index = this.index.evaluate(ctx);
        const array = this.input.evaluate(ctx);
        if (index < 0) throw new $ed234ca8eb1f5a84$var$RuntimeError(`Array index out of bounds: ${index} < 0.`);
        if (index >= array.length) throw new $ed234ca8eb1f5a84$var$RuntimeError(`Array index out of bounds: ${index} > ${array.length - 1}.`);
        if (index !== Math.floor(index)) throw new $ed234ca8eb1f5a84$var$RuntimeError(`Array index must be an integer, but found ${index} instead.`);
        return array[index];
    }
    eachChild(fn) {
        fn(this.index);
        fn(this.input);
    }
    outputDefined() {
        return false;
    }
}
class $ed234ca8eb1f5a84$var$In {
    constructor(needle, haystack){
        this.type = $ed234ca8eb1f5a84$var$BooleanType;
        this.needle = needle;
        this.haystack = haystack;
    }
    static parse(args, context) {
        if (args.length !== 3) return context.error(`Expected 2 arguments, but found ${args.length - 1} instead.`);
        const needle = context.parse(args[1], 1, $ed234ca8eb1f5a84$var$ValueType);
        const haystack = context.parse(args[2], 2, $ed234ca8eb1f5a84$var$ValueType);
        if (!needle || !haystack) return null;
        if (!$ed234ca8eb1f5a84$var$isValidType(needle.type, [
            $ed234ca8eb1f5a84$var$BooleanType,
            $ed234ca8eb1f5a84$var$StringType,
            $ed234ca8eb1f5a84$var$NumberType,
            $ed234ca8eb1f5a84$export$95d6ca0ebe20dc35,
            $ed234ca8eb1f5a84$var$ValueType
        ])) return context.error(`Expected first argument to be of type boolean, string, number or null, but found ${$ed234ca8eb1f5a84$export$f84e8e69fd4488a5(needle.type)} instead`);
        return new $ed234ca8eb1f5a84$var$In(needle, haystack);
    }
    evaluate(ctx) {
        const needle = this.needle.evaluate(ctx);
        const haystack = this.haystack.evaluate(ctx);
        if (!haystack) return false;
        if (!$ed234ca8eb1f5a84$var$isValidNativeType(needle, [
            'boolean',
            'string',
            'number',
            'null'
        ])) throw new $ed234ca8eb1f5a84$var$RuntimeError(`Expected first argument to be of type boolean, string, number or null, but found ${$ed234ca8eb1f5a84$export$f84e8e69fd4488a5($ed234ca8eb1f5a84$export$f5bbd400c2f4426f(needle))} instead.`);
        if (!$ed234ca8eb1f5a84$var$isValidNativeType(haystack, [
            'string',
            'array'
        ])) throw new $ed234ca8eb1f5a84$var$RuntimeError(`Expected second argument to be of type array or string, but found ${$ed234ca8eb1f5a84$export$f84e8e69fd4488a5($ed234ca8eb1f5a84$export$f5bbd400c2f4426f(haystack))} instead.`);
        return haystack.indexOf(needle) >= 0;
    }
    eachChild(fn) {
        fn(this.needle);
        fn(this.haystack);
    }
    outputDefined() {
        return true;
    }
}
class $ed234ca8eb1f5a84$var$IndexOf {
    constructor(needle, haystack, fromIndex){
        this.type = $ed234ca8eb1f5a84$var$NumberType;
        this.needle = needle;
        this.haystack = haystack;
        this.fromIndex = fromIndex;
    }
    static parse(args, context) {
        if (args.length <= 2 || args.length >= 5) return context.error(`Expected 2 or 3 arguments, but found ${args.length - 1} instead.`);
        const needle = context.parse(args[1], 1, $ed234ca8eb1f5a84$var$ValueType);
        const haystack = context.parse(args[2], 2, $ed234ca8eb1f5a84$var$ValueType);
        if (!needle || !haystack) return null;
        if (!$ed234ca8eb1f5a84$var$isValidType(needle.type, [
            $ed234ca8eb1f5a84$var$BooleanType,
            $ed234ca8eb1f5a84$var$StringType,
            $ed234ca8eb1f5a84$var$NumberType,
            $ed234ca8eb1f5a84$export$95d6ca0ebe20dc35,
            $ed234ca8eb1f5a84$var$ValueType
        ])) return context.error(`Expected first argument to be of type boolean, string, number or null, but found ${$ed234ca8eb1f5a84$export$f84e8e69fd4488a5(needle.type)} instead`);
        if (args.length === 4) {
            const fromIndex = context.parse(args[3], 3, $ed234ca8eb1f5a84$var$NumberType);
            if (!fromIndex) return null;
            return new $ed234ca8eb1f5a84$var$IndexOf(needle, haystack, fromIndex);
        } else return new $ed234ca8eb1f5a84$var$IndexOf(needle, haystack);
    }
    evaluate(ctx) {
        const needle = this.needle.evaluate(ctx);
        const haystack = this.haystack.evaluate(ctx);
        if (!$ed234ca8eb1f5a84$var$isValidNativeType(needle, [
            'boolean',
            'string',
            'number',
            'null'
        ])) throw new $ed234ca8eb1f5a84$var$RuntimeError(`Expected first argument to be of type boolean, string, number or null, but found ${$ed234ca8eb1f5a84$export$f84e8e69fd4488a5($ed234ca8eb1f5a84$export$f5bbd400c2f4426f(needle))} instead.`);
        let fromIndex;
        if (this.fromIndex) fromIndex = this.fromIndex.evaluate(ctx);
        if ($ed234ca8eb1f5a84$var$isValidNativeType(haystack, [
            'string'
        ])) {
            const rawIndex = haystack.indexOf(needle, fromIndex);
            if (rawIndex === -1) return -1;
            else // The index may be affected by surrogate pairs, so get the length of the preceding substring.
            return [
                ...haystack.slice(0, rawIndex)
            ].length;
        } else if ($ed234ca8eb1f5a84$var$isValidNativeType(haystack, [
            'array'
        ])) return haystack.indexOf(needle, fromIndex);
        else throw new $ed234ca8eb1f5a84$var$RuntimeError(`Expected second argument to be of type array or string, but found ${$ed234ca8eb1f5a84$export$f84e8e69fd4488a5($ed234ca8eb1f5a84$export$f5bbd400c2f4426f(haystack))} instead.`);
    }
    eachChild(fn) {
        fn(this.needle);
        fn(this.haystack);
        if (this.fromIndex) fn(this.fromIndex);
    }
    outputDefined() {
        return false;
    }
}
class $ed234ca8eb1f5a84$var$Match {
    constructor(inputType, outputType, input, cases, outputs, otherwise){
        this.inputType = inputType;
        this.type = outputType;
        this.input = input;
        this.cases = cases;
        this.outputs = outputs;
        this.otherwise = otherwise;
    }
    static parse(args, context) {
        if (args.length < 5) return context.error(`Expected at least 4 arguments, but found only ${args.length - 1}.`);
        if (args.length % 2 !== 1) return context.error('Expected an even number of arguments.');
        let inputType;
        let outputType;
        if (context.expectedType && context.expectedType.kind !== 'value') outputType = context.expectedType;
        const cases = {};
        const outputs = [];
        for(let i = 2; i < args.length - 1; i += 2){
            let labels = args[i];
            const value = args[i + 1];
            if (!Array.isArray(labels)) labels = [
                labels
            ];
            const labelContext = context.concat(i);
            if (labels.length === 0) return labelContext.error('Expected at least one branch label.');
            for (const label of labels){
                if (typeof label !== 'number' && typeof label !== 'string') return labelContext.error('Branch labels must be numbers or strings.');
                else if (typeof label === 'number' && Math.abs(label) > Number.MAX_SAFE_INTEGER) return labelContext.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                else if (typeof label === 'number' && Math.floor(label) !== label) return labelContext.error('Numeric branch labels must be integer values.');
                else if (!inputType) inputType = $ed234ca8eb1f5a84$export$f5bbd400c2f4426f(label);
                else if (labelContext.checkSubtype(inputType, $ed234ca8eb1f5a84$export$f5bbd400c2f4426f(label))) return null;
                if (typeof cases[String(label)] !== 'undefined') return labelContext.error('Branch labels must be unique.');
                cases[String(label)] = outputs.length;
            }
            const result = context.parse(value, i, outputType);
            if (!result) return null;
            outputType = outputType || result.type;
            outputs.push(result);
        }
        const input = context.parse(args[1], 1, $ed234ca8eb1f5a84$var$ValueType);
        if (!input) return null;
        const otherwise = context.parse(args[args.length - 1], args.length - 1, outputType);
        if (!otherwise) return null;
        if (input.type.kind !== 'value' && context.concat(1).checkSubtype(inputType, input.type)) return null;
        return new $ed234ca8eb1f5a84$var$Match(inputType, outputType, input, cases, outputs, otherwise);
    }
    evaluate(ctx) {
        const input = this.input.evaluate(ctx);
        const output = $ed234ca8eb1f5a84$export$f5bbd400c2f4426f(input) === this.inputType && this.outputs[this.cases[input]] || this.otherwise;
        return output.evaluate(ctx);
    }
    eachChild(fn) {
        fn(this.input);
        this.outputs.forEach(fn);
        fn(this.otherwise);
    }
    outputDefined() {
        return this.outputs.every((out)=>out.outputDefined()) && this.otherwise.outputDefined();
    }
}
class $ed234ca8eb1f5a84$var$Case {
    constructor(type, branches, otherwise){
        this.type = type;
        this.branches = branches;
        this.otherwise = otherwise;
    }
    static parse(args, context) {
        if (args.length < 4) return context.error(`Expected at least 3 arguments, but found only ${args.length - 1}.`);
        if (args.length % 2 !== 0) return context.error('Expected an odd number of arguments.');
        let outputType;
        if (context.expectedType && context.expectedType.kind !== 'value') outputType = context.expectedType;
        const branches = [];
        for(let i = 1; i < args.length - 1; i += 2){
            const test = context.parse(args[i], i, $ed234ca8eb1f5a84$var$BooleanType);
            if (!test) return null;
            const result = context.parse(args[i + 1], i + 1, outputType);
            if (!result) return null;
            branches.push([
                test,
                result
            ]);
            outputType = outputType || result.type;
        }
        const otherwise = context.parse(args[args.length - 1], args.length - 1, outputType);
        if (!otherwise) return null;
        if (!outputType) throw new Error("Can't infer output type");
        return new $ed234ca8eb1f5a84$var$Case(outputType, branches, otherwise);
    }
    evaluate(ctx) {
        for (const [test, expression] of this.branches){
            if (test.evaluate(ctx)) return expression.evaluate(ctx);
        }
        return this.otherwise.evaluate(ctx);
    }
    eachChild(fn) {
        for (const [test, expression] of this.branches){
            fn(test);
            fn(expression);
        }
        fn(this.otherwise);
    }
    outputDefined() {
        return this.branches.every(([_, out])=>out.outputDefined()) && this.otherwise.outputDefined();
    }
}
class $ed234ca8eb1f5a84$var$Slice {
    constructor(type, input, beginIndex, endIndex){
        this.type = type;
        this.input = input;
        this.beginIndex = beginIndex;
        this.endIndex = endIndex;
    }
    static parse(args, context) {
        if (args.length <= 2 || args.length >= 5) return context.error(`Expected 2 or 3 arguments, but found ${args.length - 1} instead.`);
        const input = context.parse(args[1], 1, $ed234ca8eb1f5a84$var$ValueType);
        const beginIndex = context.parse(args[2], 2, $ed234ca8eb1f5a84$var$NumberType);
        if (!input || !beginIndex) return null;
        if (!$ed234ca8eb1f5a84$var$isValidType(input.type, [
            $ed234ca8eb1f5a84$var$array($ed234ca8eb1f5a84$var$ValueType),
            $ed234ca8eb1f5a84$var$StringType,
            $ed234ca8eb1f5a84$var$ValueType
        ])) return context.error(`Expected first argument to be of type array or string, but found ${$ed234ca8eb1f5a84$export$f84e8e69fd4488a5(input.type)} instead`);
        if (args.length === 4) {
            const endIndex = context.parse(args[3], 3, $ed234ca8eb1f5a84$var$NumberType);
            if (!endIndex) return null;
            return new $ed234ca8eb1f5a84$var$Slice(input.type, input, beginIndex, endIndex);
        } else return new $ed234ca8eb1f5a84$var$Slice(input.type, input, beginIndex);
    }
    evaluate(ctx) {
        const input = this.input.evaluate(ctx);
        const beginIndex = this.beginIndex.evaluate(ctx);
        let endIndex;
        if (this.endIndex) endIndex = this.endIndex.evaluate(ctx);
        if ($ed234ca8eb1f5a84$var$isValidNativeType(input, [
            'string'
        ])) // Indices may be affected by surrogate pairs.
        return [
            ...input
        ].slice(beginIndex, endIndex).join('');
        else if ($ed234ca8eb1f5a84$var$isValidNativeType(input, [
            'array'
        ])) return input.slice(beginIndex, endIndex);
        else throw new $ed234ca8eb1f5a84$var$RuntimeError(`Expected first argument to be of type array or string, but found ${$ed234ca8eb1f5a84$export$f84e8e69fd4488a5($ed234ca8eb1f5a84$export$f5bbd400c2f4426f(input))} instead.`);
    }
    eachChild(fn) {
        fn(this.input);
        fn(this.beginIndex);
        if (this.endIndex) fn(this.endIndex);
    }
    outputDefined() {
        return false;
    }
}
/**
 * Returns the index of the last stop <= input, or 0 if it doesn't exist.
 * @private
 */ function $ed234ca8eb1f5a84$var$findStopLessThanOrEqualTo(stops, input) {
    const lastIndex = stops.length - 1;
    let lowerIndex = 0;
    let upperIndex = lastIndex;
    let currentIndex = 0;
    let currentValue, nextValue;
    while(lowerIndex <= upperIndex){
        currentIndex = Math.floor((lowerIndex + upperIndex) / 2);
        currentValue = stops[currentIndex];
        nextValue = stops[currentIndex + 1];
        if (currentValue <= input) {
            if (currentIndex === lastIndex || input < nextValue) // Search complete
            return currentIndex;
            lowerIndex = currentIndex + 1;
        } else if (currentValue > input) upperIndex = currentIndex - 1;
        else throw new $ed234ca8eb1f5a84$var$RuntimeError('Input is not a number.');
    }
    return 0;
}
class $ed234ca8eb1f5a84$export$fd55ce593607084a {
    constructor(type, input, stops){
        this.type = type;
        this.input = input;
        this.labels = [];
        this.outputs = [];
        for (const [label, expression] of stops){
            this.labels.push(label);
            this.outputs.push(expression);
        }
    }
    static parse(args, context) {
        if (args.length - 1 < 4) return context.error(`Expected at least 4 arguments, but found only ${args.length - 1}.`);
        if ((args.length - 1) % 2 !== 0) return context.error('Expected an even number of arguments.');
        const input = context.parse(args[1], 1, $ed234ca8eb1f5a84$var$NumberType);
        if (!input) return null;
        const stops = [];
        let outputType = null;
        if (context.expectedType && context.expectedType.kind !== 'value') outputType = context.expectedType;
        for(let i = 1; i < args.length; i += 2){
            const label = i === 1 ? -Infinity : args[i];
            const value = args[i + 1];
            const labelKey = i;
            const valueKey = i + 1;
            if (typeof label !== 'number') return context.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', labelKey);
            if (stops.length && stops[stops.length - 1][0] >= label) return context.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', labelKey);
            const parsed = context.parse(value, valueKey, outputType);
            if (!parsed) return null;
            outputType = outputType || parsed.type;
            stops.push([
                label,
                parsed
            ]);
        }
        return new $ed234ca8eb1f5a84$export$fd55ce593607084a(outputType, input, stops);
    }
    evaluate(ctx) {
        const labels = this.labels;
        const outputs = this.outputs;
        if (labels.length === 1) return outputs[0].evaluate(ctx);
        const value = this.input.evaluate(ctx);
        if (value <= labels[0]) return outputs[0].evaluate(ctx);
        const stopCount = labels.length;
        if (value >= labels[stopCount - 1]) return outputs[stopCount - 1].evaluate(ctx);
        const index = $ed234ca8eb1f5a84$var$findStopLessThanOrEqualTo(labels, value);
        return outputs[index].evaluate(ctx);
    }
    eachChild(fn) {
        fn(this.input);
        for (const expression of this.outputs)fn(expression);
    }
    outputDefined() {
        return this.outputs.every((out)=>out.outputDefined());
    }
}
function $ed234ca8eb1f5a84$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var $ed234ca8eb1f5a84$var$unitbezier;
var $ed234ca8eb1f5a84$var$hasRequiredUnitbezier;
function $ed234ca8eb1f5a84$var$requireUnitbezier() {
    if ($ed234ca8eb1f5a84$var$hasRequiredUnitbezier) return $ed234ca8eb1f5a84$var$unitbezier;
    $ed234ca8eb1f5a84$var$hasRequiredUnitbezier = 1;
    $ed234ca8eb1f5a84$var$unitbezier = UnitBezier;
    function UnitBezier(p1x, p1y, p2x, p2y) {
        // Calculate the polynomial coefficients, implicit first and last control points are (0,0) and (1,1).
        this.cx = 3.0 * p1x;
        this.bx = 3.0 * (p2x - p1x) - this.cx;
        this.ax = 1.0 - this.cx - this.bx;
        this.cy = 3.0 * p1y;
        this.by = 3.0 * (p2y - p1y) - this.cy;
        this.ay = 1.0 - this.cy - this.by;
        this.p1x = p1x;
        this.p1y = p1y;
        this.p2x = p2x;
        this.p2y = p2y;
    }
    UnitBezier.prototype = {
        sampleCurveX: function(t) {
            // `ax t^3 + bx t^2 + cx t' expanded using Horner's rule.
            return ((this.ax * t + this.bx) * t + this.cx) * t;
        },
        sampleCurveY: function(t) {
            return ((this.ay * t + this.by) * t + this.cy) * t;
        },
        sampleCurveDerivativeX: function(t) {
            return (3.0 * this.ax * t + 2.0 * this.bx) * t + this.cx;
        },
        solveCurveX: function(x, epsilon) {
            if (epsilon === undefined) epsilon = 1e-6;
            if (x < 0.0) return 0.0;
            if (x > 1.0) return 1.0;
            var t = x;
            // First try a few iterations of Newton's method - normally very fast.
            for(var i = 0; i < 8; i++){
                var x2 = this.sampleCurveX(t) - x;
                if (Math.abs(x2) < epsilon) return t;
                var d2 = this.sampleCurveDerivativeX(t);
                if (Math.abs(d2) < 1e-6) break;
                t = t - x2 / d2;
            }
            // Fall back to the bisection method for reliability.
            var t0 = 0.0;
            var t1 = 1.0;
            t = x;
            for(i = 0; i < 20; i++){
                x2 = this.sampleCurveX(t);
                if (Math.abs(x2 - x) < epsilon) break;
                if (x > x2) t0 = t;
                else t1 = t;
                t = (t1 - t0) * 0.5 + t0;
            }
            return t;
        },
        solve: function(x, epsilon) {
            return this.sampleCurveY(this.solveCurveX(x, epsilon));
        }
    };
    return $ed234ca8eb1f5a84$var$unitbezier;
}
var $ed234ca8eb1f5a84$var$unitbezierExports = $ed234ca8eb1f5a84$var$requireUnitbezier();
var $ed234ca8eb1f5a84$var$UnitBezier = /*@__PURE__*/ $ed234ca8eb1f5a84$var$getDefaultExportFromCjs($ed234ca8eb1f5a84$var$unitbezierExports);
class $ed234ca8eb1f5a84$export$6bb252fbb1a22840 {
    constructor(type, operator, interpolation, input, stops){
        this.type = type;
        this.operator = operator;
        this.interpolation = interpolation;
        this.input = input;
        this.labels = [];
        this.outputs = [];
        for (const [label, expression] of stops){
            this.labels.push(label);
            this.outputs.push(expression);
        }
    }
    static interpolationFactor(interpolation, input, lower, upper) {
        let t = 0;
        if (interpolation.name === 'exponential') t = $ed234ca8eb1f5a84$var$exponentialInterpolation(input, interpolation.base, lower, upper);
        else if (interpolation.name === 'linear') t = $ed234ca8eb1f5a84$var$exponentialInterpolation(input, 1, lower, upper);
        else if (interpolation.name === 'cubic-bezier') {
            const c = interpolation.controlPoints;
            const ub = new $ed234ca8eb1f5a84$var$UnitBezier(c[0], c[1], c[2], c[3]);
            t = ub.solve($ed234ca8eb1f5a84$var$exponentialInterpolation(input, 1, lower, upper));
        }
        return t;
    }
    static parse(args, context) {
        let [operator, interpolation, input, ...rest] = args;
        if (!Array.isArray(interpolation) || interpolation.length === 0) return context.error('Expected an interpolation type expression.', 1);
        if (interpolation[0] === 'linear') interpolation = {
            name: 'linear'
        };
        else if (interpolation[0] === 'exponential') {
            const base = interpolation[1];
            if (typeof base !== 'number') return context.error('Exponential interpolation requires a numeric base.', 1, 1);
            interpolation = {
                name: 'exponential',
                base: base
            };
        } else if (interpolation[0] === 'cubic-bezier') {
            const controlPoints = interpolation.slice(1);
            if (controlPoints.length !== 4 || controlPoints.some((t)=>typeof t !== 'number' || t < 0 || t > 1)) return context.error('Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.', 1);
            interpolation = {
                name: 'cubic-bezier',
                controlPoints: controlPoints
            };
        } else return context.error(`Unknown interpolation type ${String(interpolation[0])}`, 1, 0);
        if (args.length - 1 < 4) return context.error(`Expected at least 4 arguments, but found only ${args.length - 1}.`);
        if ((args.length - 1) % 2 !== 0) return context.error('Expected an even number of arguments.');
        input = context.parse(input, 2, $ed234ca8eb1f5a84$var$NumberType);
        if (!input) return null;
        const stops = [];
        let outputType = null;
        if ((operator === 'interpolate-hcl' || operator === 'interpolate-lab') && context.expectedType != $ed234ca8eb1f5a84$var$ColorArrayType) outputType = $ed234ca8eb1f5a84$export$2cd82751acc0e609;
        else if (context.expectedType && context.expectedType.kind !== 'value') outputType = context.expectedType;
        for(let i = 0; i < rest.length; i += 2){
            const label = rest[i];
            const value = rest[i + 1];
            const labelKey = i + 3;
            const valueKey = i + 4;
            if (typeof label !== 'number') return context.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', labelKey);
            if (stops.length && stops[stops.length - 1][0] >= label) return context.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', labelKey);
            const parsed = context.parse(value, valueKey, outputType);
            if (!parsed) return null;
            outputType = outputType || parsed.type;
            stops.push([
                label,
                parsed
            ]);
        }
        if (!$ed234ca8eb1f5a84$var$verifyType(outputType, $ed234ca8eb1f5a84$var$NumberType) && !$ed234ca8eb1f5a84$var$verifyType(outputType, $ed234ca8eb1f5a84$export$7ec308bb4472cd41) && !$ed234ca8eb1f5a84$var$verifyType(outputType, $ed234ca8eb1f5a84$export$2cd82751acc0e609) && !$ed234ca8eb1f5a84$var$verifyType(outputType, $ed234ca8eb1f5a84$var$PaddingType) && !$ed234ca8eb1f5a84$var$verifyType(outputType, $ed234ca8eb1f5a84$var$NumberArrayType) && !$ed234ca8eb1f5a84$var$verifyType(outputType, $ed234ca8eb1f5a84$var$ColorArrayType) && !$ed234ca8eb1f5a84$var$verifyType(outputType, $ed234ca8eb1f5a84$var$VariableAnchorOffsetCollectionType) && !$ed234ca8eb1f5a84$var$verifyType(outputType, $ed234ca8eb1f5a84$var$array($ed234ca8eb1f5a84$var$NumberType))) return context.error(`Type ${$ed234ca8eb1f5a84$export$f84e8e69fd4488a5(outputType)} is not interpolatable.`);
        return new $ed234ca8eb1f5a84$export$6bb252fbb1a22840(outputType, operator, interpolation, input, stops);
    }
    evaluate(ctx) {
        const labels = this.labels;
        const outputs = this.outputs;
        if (labels.length === 1) return outputs[0].evaluate(ctx);
        const value = this.input.evaluate(ctx);
        if (value <= labels[0]) return outputs[0].evaluate(ctx);
        const stopCount = labels.length;
        if (value >= labels[stopCount - 1]) return outputs[stopCount - 1].evaluate(ctx);
        const index = $ed234ca8eb1f5a84$var$findStopLessThanOrEqualTo(labels, value);
        const lower = labels[index];
        const upper = labels[index + 1];
        const t = $ed234ca8eb1f5a84$export$6bb252fbb1a22840.interpolationFactor(this.interpolation, value, lower, upper);
        const outputLower = outputs[index].evaluate(ctx);
        const outputUpper = outputs[index + 1].evaluate(ctx);
        switch(this.operator){
            case 'interpolate':
                switch(this.type.kind){
                    case 'number':
                        return $ed234ca8eb1f5a84$var$interpolateNumber(outputLower, outputUpper, t);
                    case 'color':
                        return $ed234ca8eb1f5a84$export$892596cec99bc70e.interpolate(outputLower, outputUpper, t);
                    case 'padding':
                        return $ed234ca8eb1f5a84$export$8ee6ea94b5aedb49.interpolate(outputLower, outputUpper, t);
                    case 'colorArray':
                        return $ed234ca8eb1f5a84$export$afb89052b482fa15.interpolate(outputLower, outputUpper, t);
                    case 'numberArray':
                        return $ed234ca8eb1f5a84$export$70583a403f005a99.interpolate(outputLower, outputUpper, t);
                    case 'variableAnchorOffsetCollection':
                        return $ed234ca8eb1f5a84$export$4fdfd474f5d53309.interpolate(outputLower, outputUpper, t);
                    case 'array':
                        return $ed234ca8eb1f5a84$var$interpolateArray(outputLower, outputUpper, t);
                    case 'projectionDefinition':
                        return $ed234ca8eb1f5a84$export$95891bdb6f673ac1.interpolate(outputLower, outputUpper, t);
                }
            case 'interpolate-hcl':
                switch(this.type.kind){
                    case 'color':
                        return $ed234ca8eb1f5a84$export$892596cec99bc70e.interpolate(outputLower, outputUpper, t, 'hcl');
                    case 'colorArray':
                        return $ed234ca8eb1f5a84$export$afb89052b482fa15.interpolate(outputLower, outputUpper, t, 'hcl');
                }
            case 'interpolate-lab':
                switch(this.type.kind){
                    case 'color':
                        return $ed234ca8eb1f5a84$export$892596cec99bc70e.interpolate(outputLower, outputUpper, t, 'lab');
                    case 'colorArray':
                        return $ed234ca8eb1f5a84$export$afb89052b482fa15.interpolate(outputLower, outputUpper, t, 'lab');
                }
        }
    }
    eachChild(fn) {
        fn(this.input);
        for (const expression of this.outputs)fn(expression);
    }
    outputDefined() {
        return this.outputs.every((out)=>out.outputDefined());
    }
}
/**
 * Returns a ratio that can be used to interpolate between exponential function
 * stops.
 * How it works: Two consecutive stop values define a (scaled and shifted) exponential function `f(x) = a * base^x + b`, where `base` is the user-specified base,
 * and `a` and `b` are constants affording sufficient degrees of freedom to fit
 * the function to the given stops.
 *
 * Here's a bit of algebra that lets us compute `f(x)` directly from the stop
 * values without explicitly solving for `a` and `b`:
 *
 * First stop value: `f(x0) = y0 = a * base^x0 + b`
 * Second stop value: `f(x1) = y1 = a * base^x1 + b`
 * => `y1 - y0 = a(base^x1 - base^x0)`
 * => `a = (y1 - y0)/(base^x1 - base^x0)`
 *
 * Desired value: `f(x) = y = a * base^x + b`
 * => `f(x) = y0 + a * (base^x - base^x0)`
 *
 * From the above, we can replace the `a` in `a * (base^x - base^x0)` and do a
 * little algebra:
 * ```
 * a * (base^x - base^x0) = (y1 - y0)/(base^x1 - base^x0) * (base^x - base^x0)
 *                     = (y1 - y0) * (base^x - base^x0) / (base^x1 - base^x0)
 * ```
 *
 * If we let `(base^x - base^x0) / (base^x1 base^x0)`, then we have
 * `f(x) = y0 + (y1 - y0) * ratio`.  In other words, `ratio` may be treated as
 * an interpolation factor between the two stops' output values.
 *
 * (Note: a slightly different form for `ratio`,
 * `(base^(x-x0) - 1) / (base^(x1-x0) - 1) `, is equivalent, but requires fewer
 * expensive `Math.pow()` operations.)
 *
 * @private
 */ function $ed234ca8eb1f5a84$var$exponentialInterpolation(input, base, lowerValue, upperValue) {
    const difference = upperValue - lowerValue;
    const progress = input - lowerValue;
    if (difference === 0) return 0;
    else if (base === 1) return progress / difference;
    else return (Math.pow(base, progress) - 1) / (Math.pow(base, difference) - 1);
}
const $ed234ca8eb1f5a84$export$c8fa6e0ca2f32cbf = {
    color: $ed234ca8eb1f5a84$export$892596cec99bc70e.interpolate,
    number: $ed234ca8eb1f5a84$var$interpolateNumber,
    padding: $ed234ca8eb1f5a84$export$8ee6ea94b5aedb49.interpolate,
    numberArray: $ed234ca8eb1f5a84$export$70583a403f005a99.interpolate,
    colorArray: $ed234ca8eb1f5a84$export$afb89052b482fa15.interpolate,
    variableAnchorOffsetCollection: $ed234ca8eb1f5a84$export$4fdfd474f5d53309.interpolate,
    array: $ed234ca8eb1f5a84$var$interpolateArray
};
class $ed234ca8eb1f5a84$var$Coalesce {
    constructor(type, args){
        this.type = type;
        this.args = args;
    }
    static parse(args, context) {
        if (args.length < 2) return context.error('Expected at least one argument.');
        let outputType = null;
        const expectedType = context.expectedType;
        if (expectedType && expectedType.kind !== 'value') outputType = expectedType;
        const parsedArgs = [];
        for (const arg of args.slice(1)){
            const parsed = context.parse(arg, 1 + parsedArgs.length, outputType, undefined, {
                typeAnnotation: 'omit'
            });
            if (!parsed) return null;
            outputType = outputType || parsed.type;
            parsedArgs.push(parsed);
        }
        if (!outputType) throw new Error('No output type');
        // Above, we parse arguments without inferred type annotation so that
        // they don't produce a runtime error for `null` input, which would
        // preempt the desired null-coalescing behavior.
        // Thus, if any of our arguments would have needed an annotation, we
        // need to wrap the enclosing coalesce expression with it instead.
        const needsAnnotation = expectedType && parsedArgs.some((arg)=>$ed234ca8eb1f5a84$var$checkSubtype(expectedType, arg.type));
        return needsAnnotation ? new $ed234ca8eb1f5a84$var$Coalesce($ed234ca8eb1f5a84$var$ValueType, parsedArgs) : new $ed234ca8eb1f5a84$var$Coalesce(outputType, parsedArgs);
    }
    evaluate(ctx) {
        let result = null;
        let argCount = 0;
        let requestedImageName;
        for (const arg of this.args){
            argCount++;
            result = arg.evaluate(ctx);
            // we need to keep track of the first requested image in a coalesce statement
            // if coalesce can't find a valid image, we return the first image name so styleimagemissing can fire
            if (result && result instanceof $ed234ca8eb1f5a84$export$8511b53abdedaff9 && !result.available) {
                if (!requestedImageName) requestedImageName = result.name;
                result = null;
                if (argCount === this.args.length) result = requestedImageName;
            }
            if (result !== null) break;
        }
        return result;
    }
    eachChild(fn) {
        this.args.forEach(fn);
    }
    outputDefined() {
        return this.args.every((arg)=>arg.outputDefined());
    }
}
function $ed234ca8eb1f5a84$var$isComparableType(op, type) {
    if (op === '==' || op === '!=') // equality operator
    return type.kind === 'boolean' || type.kind === 'string' || type.kind === 'number' || type.kind === 'null' || type.kind === 'value';
    else // ordering operator
    return type.kind === 'string' || type.kind === 'number' || type.kind === 'value';
}
function $ed234ca8eb1f5a84$var$eq(ctx, a, b) {
    return a === b;
}
function $ed234ca8eb1f5a84$var$neq(ctx, a, b) {
    return a !== b;
}
function $ed234ca8eb1f5a84$var$lt(ctx, a, b) {
    return a < b;
}
function $ed234ca8eb1f5a84$var$gt(ctx, a, b) {
    return a > b;
}
function $ed234ca8eb1f5a84$var$lteq(ctx, a, b) {
    return a <= b;
}
function $ed234ca8eb1f5a84$var$gteq(ctx, a, b) {
    return a >= b;
}
function $ed234ca8eb1f5a84$var$eqCollate(ctx, a, b, c) {
    return c.compare(a, b) === 0;
}
function $ed234ca8eb1f5a84$var$neqCollate(ctx, a, b, c) {
    return !$ed234ca8eb1f5a84$var$eqCollate(ctx, a, b, c);
}
function $ed234ca8eb1f5a84$var$ltCollate(ctx, a, b, c) {
    return c.compare(a, b) < 0;
}
function $ed234ca8eb1f5a84$var$gtCollate(ctx, a, b, c) {
    return c.compare(a, b) > 0;
}
function $ed234ca8eb1f5a84$var$lteqCollate(ctx, a, b, c) {
    return c.compare(a, b) <= 0;
}
function $ed234ca8eb1f5a84$var$gteqCollate(ctx, a, b, c) {
    return c.compare(a, b) >= 0;
}
/**
 * Special form for comparison operators, implementing the signatures:
 * - (T, T, ?Collator) => boolean
 * - (T, value, ?Collator) => boolean
 * - (value, T, ?Collator) => boolean
 *
 * For inequalities, T must be either value, string, or number. For ==/!=, it
 * can also be boolean or null.
 *
 * Equality semantics are equivalent to Javascript's strict equality (===/!==)
 * -- i.e., when the arguments' types don't match, == evaluates to false, != to
 * true.
 *
 * When types don't match in an ordering comparison, a runtime error is thrown.
 *
 * @private
 */ function $ed234ca8eb1f5a84$var$makeComparison(op, compareBasic, compareWithCollator) {
    const isOrderComparison = op !== '==' && op !== '!=';
    return class Comparison {
        constructor(lhs, rhs, collator){
            this.type = $ed234ca8eb1f5a84$var$BooleanType;
            this.lhs = lhs;
            this.rhs = rhs;
            this.collator = collator;
            this.hasUntypedArgument = lhs.type.kind === 'value' || rhs.type.kind === 'value';
        }
        static parse(args, context) {
            if (args.length !== 3 && args.length !== 4) return context.error('Expected two or three arguments.');
            const op = args[0];
            let lhs = context.parse(args[1], 1, $ed234ca8eb1f5a84$var$ValueType);
            if (!lhs) return null;
            if (!$ed234ca8eb1f5a84$var$isComparableType(op, lhs.type)) return context.concat(1).error(`"${op}" comparisons are not supported for type '${$ed234ca8eb1f5a84$export$f84e8e69fd4488a5(lhs.type)}'.`);
            let rhs = context.parse(args[2], 2, $ed234ca8eb1f5a84$var$ValueType);
            if (!rhs) return null;
            if (!$ed234ca8eb1f5a84$var$isComparableType(op, rhs.type)) return context.concat(2).error(`"${op}" comparisons are not supported for type '${$ed234ca8eb1f5a84$export$f84e8e69fd4488a5(rhs.type)}'.`);
            if (lhs.type.kind !== rhs.type.kind && lhs.type.kind !== 'value' && rhs.type.kind !== 'value') return context.error(`Cannot compare types '${$ed234ca8eb1f5a84$export$f84e8e69fd4488a5(lhs.type)}' and '${$ed234ca8eb1f5a84$export$f84e8e69fd4488a5(rhs.type)}'.`);
            if (isOrderComparison) {
                // typing rules specific to less/greater than operators
                if (lhs.type.kind === 'value' && rhs.type.kind !== 'value') // (value, T)
                lhs = new $ed234ca8eb1f5a84$var$Assertion(rhs.type, [
                    lhs
                ]);
                else if (lhs.type.kind !== 'value' && rhs.type.kind === 'value') // (T, value)
                rhs = new $ed234ca8eb1f5a84$var$Assertion(lhs.type, [
                    rhs
                ]);
            }
            let collator = null;
            if (args.length === 4) {
                if (lhs.type.kind !== 'string' && rhs.type.kind !== 'string' && lhs.type.kind !== 'value' && rhs.type.kind !== 'value') return context.error('Cannot use collator to compare non-string types.');
                collator = context.parse(args[3], 3, $ed234ca8eb1f5a84$var$CollatorType);
                if (!collator) return null;
            }
            return new Comparison(lhs, rhs, collator);
        }
        evaluate(ctx) {
            const lhs = this.lhs.evaluate(ctx);
            const rhs = this.rhs.evaluate(ctx);
            if (isOrderComparison && this.hasUntypedArgument) {
                const lt = $ed234ca8eb1f5a84$export$f5bbd400c2f4426f(lhs);
                const rt = $ed234ca8eb1f5a84$export$f5bbd400c2f4426f(rhs);
                // check that type is string or number, and equal
                if (lt.kind !== rt.kind || !(lt.kind === 'string' || lt.kind === 'number')) throw new $ed234ca8eb1f5a84$var$RuntimeError(`Expected arguments for "${op}" to be (string, string) or (number, number), but found (${lt.kind}, ${rt.kind}) instead.`);
            }
            if (this.collator && !isOrderComparison && this.hasUntypedArgument) {
                const lt = $ed234ca8eb1f5a84$export$f5bbd400c2f4426f(lhs);
                const rt = $ed234ca8eb1f5a84$export$f5bbd400c2f4426f(rhs);
                if (lt.kind !== 'string' || rt.kind !== 'string') return compareBasic(ctx, lhs, rhs);
            }
            return this.collator ? compareWithCollator(ctx, lhs, rhs, this.collator.evaluate(ctx)) : compareBasic(ctx, lhs, rhs);
        }
        eachChild(fn) {
            fn(this.lhs);
            fn(this.rhs);
            if (this.collator) fn(this.collator);
        }
        outputDefined() {
            return true;
        }
    };
}
const $ed234ca8eb1f5a84$var$Equals = $ed234ca8eb1f5a84$var$makeComparison('==', $ed234ca8eb1f5a84$var$eq, $ed234ca8eb1f5a84$var$eqCollate);
const $ed234ca8eb1f5a84$var$NotEquals = $ed234ca8eb1f5a84$var$makeComparison('!=', $ed234ca8eb1f5a84$var$neq, $ed234ca8eb1f5a84$var$neqCollate);
const $ed234ca8eb1f5a84$var$LessThan = $ed234ca8eb1f5a84$var$makeComparison('<', $ed234ca8eb1f5a84$var$lt, $ed234ca8eb1f5a84$var$ltCollate);
const $ed234ca8eb1f5a84$var$GreaterThan = $ed234ca8eb1f5a84$var$makeComparison('>', $ed234ca8eb1f5a84$var$gt, $ed234ca8eb1f5a84$var$gtCollate);
const $ed234ca8eb1f5a84$var$LessThanOrEqual = $ed234ca8eb1f5a84$var$makeComparison('<=', $ed234ca8eb1f5a84$var$lteq, $ed234ca8eb1f5a84$var$lteqCollate);
const $ed234ca8eb1f5a84$var$GreaterThanOrEqual = $ed234ca8eb1f5a84$var$makeComparison('>=', $ed234ca8eb1f5a84$var$gteq, $ed234ca8eb1f5a84$var$gteqCollate);
class $ed234ca8eb1f5a84$var$CollatorExpression {
    constructor(caseSensitive, diacriticSensitive, locale){
        this.type = $ed234ca8eb1f5a84$var$CollatorType;
        this.locale = locale;
        this.caseSensitive = caseSensitive;
        this.diacriticSensitive = diacriticSensitive;
    }
    static parse(args, context) {
        if (args.length !== 2) return context.error('Expected one argument.');
        const options = args[1];
        if (typeof options !== 'object' || Array.isArray(options)) return context.error('Collator options argument must be an object.');
        const caseSensitive = context.parse(options['case-sensitive'] === undefined ? false : options['case-sensitive'], 1, $ed234ca8eb1f5a84$var$BooleanType);
        if (!caseSensitive) return null;
        const diacriticSensitive = context.parse(options['diacritic-sensitive'] === undefined ? false : options['diacritic-sensitive'], 1, $ed234ca8eb1f5a84$var$BooleanType);
        if (!diacriticSensitive) return null;
        let locale = null;
        if (options['locale']) {
            locale = context.parse(options['locale'], 1, $ed234ca8eb1f5a84$var$StringType);
            if (!locale) return null;
        }
        return new $ed234ca8eb1f5a84$var$CollatorExpression(caseSensitive, diacriticSensitive, locale);
    }
    evaluate(ctx) {
        return new $ed234ca8eb1f5a84$var$Collator(this.caseSensitive.evaluate(ctx), this.diacriticSensitive.evaluate(ctx), this.locale ? this.locale.evaluate(ctx) : null);
    }
    eachChild(fn) {
        fn(this.caseSensitive);
        fn(this.diacriticSensitive);
        if (this.locale) fn(this.locale);
    }
    outputDefined() {
        // Technically the set of possible outputs is the combinatoric set of Collators produced
        // by all possible outputs of locale/caseSensitive/diacriticSensitive
        // But for the primary use of Collators in comparison operators, we ignore the Collator's
        // possible outputs anyway, so we can get away with leaving this false for now.
        return false;
    }
}
class $ed234ca8eb1f5a84$var$NumberFormat {
    constructor(number, locale, currency, unit, minFractionDigits, maxFractionDigits){
        this.type = $ed234ca8eb1f5a84$var$StringType;
        this.number = number;
        this.locale = locale;
        this.currency = currency;
        this.unit = unit;
        this.minFractionDigits = minFractionDigits;
        this.maxFractionDigits = maxFractionDigits;
    }
    static parse(args, context) {
        if (args.length !== 3) return context.error('Expected two arguments.');
        const number = context.parse(args[1], 1, $ed234ca8eb1f5a84$var$NumberType);
        if (!number) return null;
        const options = args[2];
        if (typeof options !== 'object' || Array.isArray(options)) return context.error('NumberFormat options argument must be an object.');
        let locale = null;
        if (options['locale']) {
            locale = context.parse(options['locale'], 1, $ed234ca8eb1f5a84$var$StringType);
            if (!locale) return null;
        }
        let currency = null;
        if (options['currency']) {
            currency = context.parse(options['currency'], 1, $ed234ca8eb1f5a84$var$StringType);
            if (!currency) return null;
        }
        let unit = null;
        if (options['unit']) {
            unit = context.parse(options['unit'], 1, $ed234ca8eb1f5a84$var$StringType);
            if (!unit) return null;
        }
        if (currency && unit) return context.error('NumberFormat options `currency` and `unit` are mutually exclusive');
        let minFractionDigits = null;
        if (options['min-fraction-digits']) {
            minFractionDigits = context.parse(options['min-fraction-digits'], 1, $ed234ca8eb1f5a84$var$NumberType);
            if (!minFractionDigits) return null;
        }
        let maxFractionDigits = null;
        if (options['max-fraction-digits']) {
            maxFractionDigits = context.parse(options['max-fraction-digits'], 1, $ed234ca8eb1f5a84$var$NumberType);
            if (!maxFractionDigits) return null;
        }
        return new $ed234ca8eb1f5a84$var$NumberFormat(number, locale, currency, unit, minFractionDigits, maxFractionDigits);
    }
    evaluate(ctx) {
        return new Intl.NumberFormat(this.locale ? this.locale.evaluate(ctx) : [], {
            style: this.currency ? 'currency' : this.unit ? 'unit' : 'decimal',
            currency: this.currency ? this.currency.evaluate(ctx) : undefined,
            unit: this.unit ? this.unit.evaluate(ctx) : undefined,
            minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(ctx) : undefined,
            maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(ctx) : undefined
        }).format(this.number.evaluate(ctx));
    }
    eachChild(fn) {
        fn(this.number);
        if (this.locale) fn(this.locale);
        if (this.currency) fn(this.currency);
        if (this.unit) fn(this.unit);
        if (this.minFractionDigits) fn(this.minFractionDigits);
        if (this.maxFractionDigits) fn(this.maxFractionDigits);
    }
    outputDefined() {
        return false;
    }
}
class $ed234ca8eb1f5a84$export$f1942a50a557e8d4 {
    constructor(sections){
        this.type = $ed234ca8eb1f5a84$export$831566e53e7565f9;
        this.sections = sections;
    }
    static parse(args, context) {
        if (args.length < 2) return context.error('Expected at least one argument.');
        const firstArg = args[1];
        if (!Array.isArray(firstArg) && typeof firstArg === 'object') return context.error('First argument must be an image or text section.');
        const sections = [];
        let nextTokenMayBeObject = false;
        for(let i = 1; i <= args.length - 1; ++i){
            const arg = args[i];
            if (nextTokenMayBeObject && typeof arg === 'object' && !Array.isArray(arg)) {
                nextTokenMayBeObject = false;
                let scale = null;
                if (arg['font-scale']) {
                    scale = context.parse(arg['font-scale'], 1, $ed234ca8eb1f5a84$var$NumberType);
                    if (!scale) return null;
                }
                let font = null;
                if (arg['text-font']) {
                    font = context.parse(arg['text-font'], 1, $ed234ca8eb1f5a84$var$array($ed234ca8eb1f5a84$var$StringType));
                    if (!font) return null;
                }
                let textColor = null;
                if (arg['text-color']) {
                    textColor = context.parse(arg['text-color'], 1, $ed234ca8eb1f5a84$export$2cd82751acc0e609);
                    if (!textColor) return null;
                }
                let verticalAlign = null;
                if (arg['vertical-align']) {
                    if (typeof arg['vertical-align'] === 'string' && !$ed234ca8eb1f5a84$var$VERTICAL_ALIGN_OPTIONS.includes(arg['vertical-align'])) return context.error(`'vertical-align' must be one of: 'bottom', 'center', 'top' but found '${arg['vertical-align']}' instead.`);
                    verticalAlign = context.parse(arg['vertical-align'], 1, $ed234ca8eb1f5a84$var$StringType);
                    if (!verticalAlign) return null;
                }
                const lastExpression = sections[sections.length - 1];
                lastExpression.scale = scale;
                lastExpression.font = font;
                lastExpression.textColor = textColor;
                lastExpression.verticalAlign = verticalAlign;
            } else {
                const content = context.parse(args[i], 1, $ed234ca8eb1f5a84$var$ValueType);
                if (!content) return null;
                const kind = content.type.kind;
                if (kind !== 'string' && kind !== 'value' && kind !== 'null' && kind !== 'resolvedImage') return context.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                nextTokenMayBeObject = true;
                sections.push({
                    content: content,
                    scale: null,
                    font: null,
                    textColor: null,
                    verticalAlign: null
                });
            }
        }
        return new $ed234ca8eb1f5a84$export$f1942a50a557e8d4(sections);
    }
    evaluate(ctx) {
        const evaluateSection = (section)=>{
            const evaluatedContent = section.content.evaluate(ctx);
            if ($ed234ca8eb1f5a84$export$f5bbd400c2f4426f(evaluatedContent) === $ed234ca8eb1f5a84$var$ResolvedImageType) return new $ed234ca8eb1f5a84$export$3a6ff7dce00da298('', evaluatedContent, null, null, null, section.verticalAlign ? section.verticalAlign.evaluate(ctx) : null);
            return new $ed234ca8eb1f5a84$export$3a6ff7dce00da298($ed234ca8eb1f5a84$var$valueToString(evaluatedContent), null, section.scale ? section.scale.evaluate(ctx) : null, section.font ? section.font.evaluate(ctx).join(',') : null, section.textColor ? section.textColor.evaluate(ctx) : null, section.verticalAlign ? section.verticalAlign.evaluate(ctx) : null);
        };
        return new $ed234ca8eb1f5a84$export$4eb8fc242550f5dd(this.sections.map(evaluateSection));
    }
    eachChild(fn) {
        for (const section of this.sections){
            fn(section.content);
            if (section.scale) fn(section.scale);
            if (section.font) fn(section.font);
            if (section.textColor) fn(section.textColor);
            if (section.verticalAlign) fn(section.verticalAlign);
        }
    }
    outputDefined() {
        // Technically the combinatoric set of all children
        // Usually, this.text will be undefined anyway
        return false;
    }
}
class $ed234ca8eb1f5a84$var$ImageExpression {
    constructor(input){
        this.type = $ed234ca8eb1f5a84$var$ResolvedImageType;
        this.input = input;
    }
    static parse(args, context) {
        if (args.length !== 2) return context.error('Expected two arguments.');
        const name = context.parse(args[1], 1, $ed234ca8eb1f5a84$var$StringType);
        if (!name) return context.error('No image name provided.');
        return new $ed234ca8eb1f5a84$var$ImageExpression(name);
    }
    evaluate(ctx) {
        const evaluatedImageName = this.input.evaluate(ctx);
        const value = $ed234ca8eb1f5a84$export$8511b53abdedaff9.fromString(evaluatedImageName);
        if (value && ctx.availableImages) value.available = ctx.availableImages.indexOf(evaluatedImageName) > -1;
        return value;
    }
    eachChild(fn) {
        fn(this.input);
    }
    outputDefined() {
        // The output of image is determined by the list of available images in the evaluation context
        return false;
    }
}
class $ed234ca8eb1f5a84$var$Length {
    constructor(input){
        this.type = $ed234ca8eb1f5a84$var$NumberType;
        this.input = input;
    }
    static parse(args, context) {
        if (args.length !== 2) return context.error(`Expected 1 argument, but found ${args.length - 1} instead.`);
        const input = context.parse(args[1], 1);
        if (!input) return null;
        if (input.type.kind !== 'array' && input.type.kind !== 'string' && input.type.kind !== 'value') return context.error(`Expected argument of type string or array, but found ${$ed234ca8eb1f5a84$export$f84e8e69fd4488a5(input.type)} instead.`);
        return new $ed234ca8eb1f5a84$var$Length(input);
    }
    evaluate(ctx) {
        const input = this.input.evaluate(ctx);
        if (typeof input === 'string') // The length may be affected by surrogate pairs.
        return [
            ...input
        ].length;
        else if (Array.isArray(input)) return input.length;
        else throw new $ed234ca8eb1f5a84$var$RuntimeError(`Expected value to be of type string or array, but found ${$ed234ca8eb1f5a84$export$f84e8e69fd4488a5($ed234ca8eb1f5a84$export$f5bbd400c2f4426f(input))} instead.`);
    }
    eachChild(fn) {
        fn(this.input);
    }
    outputDefined() {
        return false;
    }
}
const $ed234ca8eb1f5a84$var$EXTENT = 8192;
function $ed234ca8eb1f5a84$var$getTileCoordinates(p, canonical) {
    const x = $ed234ca8eb1f5a84$var$mercatorXfromLng(p[0]);
    const y = $ed234ca8eb1f5a84$var$mercatorYfromLat(p[1]);
    const tilesAtZoom = Math.pow(2, canonical.z);
    return [
        Math.round(x * tilesAtZoom * $ed234ca8eb1f5a84$var$EXTENT),
        Math.round(y * tilesAtZoom * $ed234ca8eb1f5a84$var$EXTENT)
    ];
}
function $ed234ca8eb1f5a84$var$getLngLatFromTileCoord(coord, canonical) {
    const tilesAtZoom = Math.pow(2, canonical.z);
    const x = (coord[0] / $ed234ca8eb1f5a84$var$EXTENT + canonical.x) / tilesAtZoom;
    const y = (coord[1] / $ed234ca8eb1f5a84$var$EXTENT + canonical.y) / tilesAtZoom;
    return [
        $ed234ca8eb1f5a84$var$lngFromMercatorXfromLng(x),
        $ed234ca8eb1f5a84$var$latFromMercatorY(y)
    ];
}
function $ed234ca8eb1f5a84$var$mercatorXfromLng(lng) {
    return (180 + lng) / 360;
}
function $ed234ca8eb1f5a84$var$lngFromMercatorXfromLng(mercatorX) {
    return mercatorX * 360 - 180;
}
function $ed234ca8eb1f5a84$var$mercatorYfromLat(lat) {
    return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + lat * Math.PI / 360))) / 360;
}
function $ed234ca8eb1f5a84$var$latFromMercatorY(mercatorY) {
    return 360 / Math.PI * Math.atan(Math.exp((180 - mercatorY * 360) * Math.PI / 180)) - 90;
}
function $ed234ca8eb1f5a84$var$updateBBox(bbox, coord) {
    bbox[0] = Math.min(bbox[0], coord[0]);
    bbox[1] = Math.min(bbox[1], coord[1]);
    bbox[2] = Math.max(bbox[2], coord[0]);
    bbox[3] = Math.max(bbox[3], coord[1]);
}
function $ed234ca8eb1f5a84$var$boxWithinBox(bbox1, bbox2) {
    if (bbox1[0] <= bbox2[0]) return false;
    if (bbox1[2] >= bbox2[2]) return false;
    if (bbox1[1] <= bbox2[1]) return false;
    if (bbox1[3] >= bbox2[3]) return false;
    return true;
}
function $ed234ca8eb1f5a84$var$rayIntersect(p, p1, p2) {
    return p1[1] > p[1] !== p2[1] > p[1] && p[0] < (p2[0] - p1[0]) * (p[1] - p1[1]) / (p2[1] - p1[1]) + p1[0];
}
function $ed234ca8eb1f5a84$var$pointOnBoundary(p, p1, p2) {
    const x1 = p[0] - p1[0];
    const y1 = p[1] - p1[1];
    const x2 = p[0] - p2[0];
    const y2 = p[1] - p2[1];
    return x1 * y2 - x2 * y1 === 0 && x1 * x2 <= 0 && y1 * y2 <= 0;
}
// a, b are end points for line segment1, c and d are end points for line segment2
function $ed234ca8eb1f5a84$var$segmentIntersectSegment(a, b, c, d) {
    // check if two segments are parallel or not
    // precondition is end point a, b is inside polygon, if line a->b is
    // parallel to polygon edge c->d, then a->b won't intersect with c->d
    const vectorP = [
        b[0] - a[0],
        b[1] - a[1]
    ];
    const vectorQ = [
        d[0] - c[0],
        d[1] - c[1]
    ];
    if ($ed234ca8eb1f5a84$var$perp(vectorQ, vectorP) === 0) return false;
    // If lines are intersecting with each other, the relative location should be:
    // a and b lie in different sides of segment c->d
    // c and d lie in different sides of segment a->b
    if ($ed234ca8eb1f5a84$var$twoSided(a, b, c, d) && $ed234ca8eb1f5a84$var$twoSided(c, d, a, b)) return true;
    return false;
}
function $ed234ca8eb1f5a84$var$lineIntersectPolygon(p1, p2, polygon) {
    for (const ring of polygon)// loop through every edge of the ring
    for(let j = 0; j < ring.length - 1; ++j){
        if ($ed234ca8eb1f5a84$var$segmentIntersectSegment(p1, p2, ring[j], ring[j + 1])) return true;
    }
    return false;
}
// ray casting algorithm for detecting if point is in polygon
function $ed234ca8eb1f5a84$var$pointWithinPolygon(point, rings, trueIfOnBoundary = false) {
    let inside = false;
    for (const ring of rings)for(let j = 0; j < ring.length - 1; j++){
        if ($ed234ca8eb1f5a84$var$pointOnBoundary(point, ring[j], ring[j + 1])) return trueIfOnBoundary;
        if ($ed234ca8eb1f5a84$var$rayIntersect(point, ring[j], ring[j + 1])) inside = !inside;
    }
    return inside;
}
function $ed234ca8eb1f5a84$var$pointWithinPolygons(point, polygons) {
    for (const polygon of polygons){
        if ($ed234ca8eb1f5a84$var$pointWithinPolygon(point, polygon)) return true;
    }
    return false;
}
function $ed234ca8eb1f5a84$var$lineStringWithinPolygon(line, polygon) {
    // First, check if geometry points of line segments are all inside polygon
    for (const point of line){
        if (!$ed234ca8eb1f5a84$var$pointWithinPolygon(point, polygon)) return false;
    }
    // Second, check if there is line segment intersecting polygon edge
    for(let i = 0; i < line.length - 1; ++i){
        if ($ed234ca8eb1f5a84$var$lineIntersectPolygon(line[i], line[i + 1], polygon)) return false;
    }
    return true;
}
function $ed234ca8eb1f5a84$var$lineStringWithinPolygons(line, polygons) {
    for (const polygon of polygons){
        if ($ed234ca8eb1f5a84$var$lineStringWithinPolygon(line, polygon)) return true;
    }
    return false;
}
function $ed234ca8eb1f5a84$var$perp(v1, v2) {
    return v1[0] * v2[1] - v1[1] * v2[0];
}
// check if p1 and p2 are in different sides of line segment q1->q2
function $ed234ca8eb1f5a84$var$twoSided(p1, p2, q1, q2) {
    // q1->p1 (x1, y1), q1->p2 (x2, y2), q1->q2 (x3, y3)
    const x1 = p1[0] - q1[0];
    const y1 = p1[1] - q1[1];
    const x2 = p2[0] - q1[0];
    const y2 = p2[1] - q1[1];
    const x3 = q2[0] - q1[0];
    const y3 = q2[1] - q1[1];
    const det1 = x1 * y3 - x3 * y1;
    const det2 = x2 * y3 - x3 * y2;
    if (det1 > 0 && det2 < 0 || det1 < 0 && det2 > 0) return true;
    return false;
}
function $ed234ca8eb1f5a84$var$getTilePolygon(coordinates, bbox, canonical) {
    const polygon = [];
    for(let i = 0; i < coordinates.length; i++){
        const ring = [];
        for(let j = 0; j < coordinates[i].length; j++){
            const coord = $ed234ca8eb1f5a84$var$getTileCoordinates(coordinates[i][j], canonical);
            $ed234ca8eb1f5a84$var$updateBBox(bbox, coord);
            ring.push(coord);
        }
        polygon.push(ring);
    }
    return polygon;
}
function $ed234ca8eb1f5a84$var$getTilePolygons(coordinates, bbox, canonical) {
    const polygons = [];
    for(let i = 0; i < coordinates.length; i++){
        const polygon = $ed234ca8eb1f5a84$var$getTilePolygon(coordinates[i], bbox, canonical);
        polygons.push(polygon);
    }
    return polygons;
}
function $ed234ca8eb1f5a84$var$updatePoint(p, bbox, polyBBox, worldSize) {
    if (p[0] < polyBBox[0] || p[0] > polyBBox[2]) {
        const halfWorldSize = worldSize * 0.5;
        let shift = p[0] - polyBBox[0] > halfWorldSize ? -worldSize : polyBBox[0] - p[0] > halfWorldSize ? worldSize : 0;
        if (shift === 0) shift = p[0] - polyBBox[2] > halfWorldSize ? -worldSize : polyBBox[2] - p[0] > halfWorldSize ? worldSize : 0;
        p[0] += shift;
    }
    $ed234ca8eb1f5a84$var$updateBBox(bbox, p);
}
function $ed234ca8eb1f5a84$var$resetBBox(bbox) {
    bbox[0] = bbox[1] = Infinity;
    bbox[2] = bbox[3] = -Infinity;
}
function $ed234ca8eb1f5a84$var$getTilePoints(geometry, pointBBox, polyBBox, canonical) {
    const worldSize = Math.pow(2, canonical.z) * $ed234ca8eb1f5a84$var$EXTENT;
    const shifts = [
        canonical.x * $ed234ca8eb1f5a84$var$EXTENT,
        canonical.y * $ed234ca8eb1f5a84$var$EXTENT
    ];
    const tilePoints = [];
    for (const points of geometry)for (const point of points){
        const p = [
            point.x + shifts[0],
            point.y + shifts[1]
        ];
        $ed234ca8eb1f5a84$var$updatePoint(p, pointBBox, polyBBox, worldSize);
        tilePoints.push(p);
    }
    return tilePoints;
}
function $ed234ca8eb1f5a84$var$getTileLines(geometry, lineBBox, polyBBox, canonical) {
    const worldSize = Math.pow(2, canonical.z) * $ed234ca8eb1f5a84$var$EXTENT;
    const shifts = [
        canonical.x * $ed234ca8eb1f5a84$var$EXTENT,
        canonical.y * $ed234ca8eb1f5a84$var$EXTENT
    ];
    const tileLines = [];
    for (const line of geometry){
        const tileLine = [];
        for (const point of line){
            const p = [
                point.x + shifts[0],
                point.y + shifts[1]
            ];
            $ed234ca8eb1f5a84$var$updateBBox(lineBBox, p);
            tileLine.push(p);
        }
        tileLines.push(tileLine);
    }
    if (lineBBox[2] - lineBBox[0] <= worldSize / 2) {
        $ed234ca8eb1f5a84$var$resetBBox(lineBBox);
        for (const line of tileLines)for (const p of line)$ed234ca8eb1f5a84$var$updatePoint(p, lineBBox, polyBBox, worldSize);
    }
    return tileLines;
}
function $ed234ca8eb1f5a84$var$pointsWithinPolygons(ctx, polygonGeometry) {
    const pointBBox = [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    const polyBBox = [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    const canonical = ctx.canonicalID();
    if (polygonGeometry.type === 'Polygon') {
        const tilePolygon = $ed234ca8eb1f5a84$var$getTilePolygon(polygonGeometry.coordinates, polyBBox, canonical);
        const tilePoints = $ed234ca8eb1f5a84$var$getTilePoints(ctx.geometry(), pointBBox, polyBBox, canonical);
        if (!$ed234ca8eb1f5a84$var$boxWithinBox(pointBBox, polyBBox)) return false;
        for (const point of tilePoints){
            if (!$ed234ca8eb1f5a84$var$pointWithinPolygon(point, tilePolygon)) return false;
        }
    }
    if (polygonGeometry.type === 'MultiPolygon') {
        const tilePolygons = $ed234ca8eb1f5a84$var$getTilePolygons(polygonGeometry.coordinates, polyBBox, canonical);
        const tilePoints = $ed234ca8eb1f5a84$var$getTilePoints(ctx.geometry(), pointBBox, polyBBox, canonical);
        if (!$ed234ca8eb1f5a84$var$boxWithinBox(pointBBox, polyBBox)) return false;
        for (const point of tilePoints){
            if (!$ed234ca8eb1f5a84$var$pointWithinPolygons(point, tilePolygons)) return false;
        }
    }
    return true;
}
function $ed234ca8eb1f5a84$var$linesWithinPolygons(ctx, polygonGeometry) {
    const lineBBox = [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    const polyBBox = [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    const canonical = ctx.canonicalID();
    if (polygonGeometry.type === 'Polygon') {
        const tilePolygon = $ed234ca8eb1f5a84$var$getTilePolygon(polygonGeometry.coordinates, polyBBox, canonical);
        const tileLines = $ed234ca8eb1f5a84$var$getTileLines(ctx.geometry(), lineBBox, polyBBox, canonical);
        if (!$ed234ca8eb1f5a84$var$boxWithinBox(lineBBox, polyBBox)) return false;
        for (const line of tileLines){
            if (!$ed234ca8eb1f5a84$var$lineStringWithinPolygon(line, tilePolygon)) return false;
        }
    }
    if (polygonGeometry.type === 'MultiPolygon') {
        const tilePolygons = $ed234ca8eb1f5a84$var$getTilePolygons(polygonGeometry.coordinates, polyBBox, canonical);
        const tileLines = $ed234ca8eb1f5a84$var$getTileLines(ctx.geometry(), lineBBox, polyBBox, canonical);
        if (!$ed234ca8eb1f5a84$var$boxWithinBox(lineBBox, polyBBox)) return false;
        for (const line of tileLines){
            if (!$ed234ca8eb1f5a84$var$lineStringWithinPolygons(line, tilePolygons)) return false;
        }
    }
    return true;
}
class $ed234ca8eb1f5a84$var$Within {
    constructor(geojson, geometries){
        this.type = $ed234ca8eb1f5a84$var$BooleanType;
        this.geojson = geojson;
        this.geometries = geometries;
    }
    static parse(args, context) {
        if (args.length !== 2) return context.error(`'within' expression requires exactly one argument, but found ${args.length - 1} instead.`);
        if ($ed234ca8eb1f5a84$var$isValue(args[1])) {
            const geojson = args[1];
            if (geojson.type === 'FeatureCollection') {
                const polygonsCoords = [];
                for (const polygon of geojson.features){
                    const { type: type, coordinates: coordinates } = polygon.geometry;
                    if (type === 'Polygon') polygonsCoords.push(coordinates);
                    if (type === 'MultiPolygon') polygonsCoords.push(...coordinates);
                }
                if (polygonsCoords.length) {
                    const multipolygonWrapper = {
                        type: 'MultiPolygon',
                        coordinates: polygonsCoords
                    };
                    return new $ed234ca8eb1f5a84$var$Within(geojson, multipolygonWrapper);
                }
            } else if (geojson.type === 'Feature') {
                const type = geojson.geometry.type;
                if (type === 'Polygon' || type === 'MultiPolygon') return new $ed234ca8eb1f5a84$var$Within(geojson, geojson.geometry);
            } else if (geojson.type === 'Polygon' || geojson.type === 'MultiPolygon') return new $ed234ca8eb1f5a84$var$Within(geojson, geojson);
        }
        return context.error("'within' expression requires valid geojson object that contains polygon geometry type.");
    }
    evaluate(ctx) {
        if (ctx.geometry() != null && ctx.canonicalID() != null) {
            if (ctx.geometryType() === 'Point') return $ed234ca8eb1f5a84$var$pointsWithinPolygons(ctx, this.geometries);
            else if (ctx.geometryType() === 'LineString') return $ed234ca8eb1f5a84$var$linesWithinPolygons(ctx, this.geometries);
        }
        return false;
    }
    eachChild() {}
    outputDefined() {
        return true;
    }
}
class $ed234ca8eb1f5a84$var$TinyQueue {
    constructor(data = [], compare = (a, b)=>a < b ? -1 : a > b ? 1 : 0){
        this.data = data;
        this.length = this.data.length;
        this.compare = compare;
        if (this.length > 0) for(let i = (this.length >> 1) - 1; i >= 0; i--)this._down(i);
    }
    push(item) {
        this.data.push(item);
        this._up(this.length++);
    }
    pop() {
        if (this.length === 0) return undefined;
        const top = this.data[0];
        const bottom = this.data.pop();
        if (--this.length > 0) {
            this.data[0] = bottom;
            this._down(0);
        }
        return top;
    }
    peek() {
        return this.data[0];
    }
    _up(pos) {
        const { data: data, compare: compare } = this;
        const item = data[pos];
        while(pos > 0){
            const parent = pos - 1 >> 1;
            const current = data[parent];
            if (compare(item, current) >= 0) break;
            data[pos] = current;
            pos = parent;
        }
        data[pos] = item;
    }
    _down(pos) {
        const { data: data, compare: compare } = this;
        const halfLength = this.length >> 1;
        const item = data[pos];
        while(pos < halfLength){
            let bestChild = (pos << 1) + 1; // initially it is the left child
            const right = bestChild + 1;
            if (right < this.length && compare(data[right], data[bestChild]) < 0) bestChild = right;
            if (compare(data[bestChild], item) >= 0) break;
            data[pos] = data[bestChild];
            pos = bestChild;
        }
        data[pos] = item;
    }
}
/**
 * Rearranges items so that all items in the [left, k] are the smallest.
 * The k-th element will have the (k - left + 1)-th smallest value in [left, right].
 *
 * @template T
 * @param {T[]} arr the array to partially sort (in place)
 * @param {number} k middle index for partial sorting (as defined above)
 * @param {number} [left=0] left index of the range to sort
 * @param {number} [right=arr.length-1] right index
 * @param {(a: T, b: T) => number} [compare = (a, b) => a - b] compare function
 */ function $ed234ca8eb1f5a84$var$quickselect(arr, k, left = 0, right = arr.length - 1, compare = $ed234ca8eb1f5a84$var$defaultCompare) {
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $ed234ca8eb1f5a84$var$quickselect(arr, k, newLeft, newRight, compare);
        }
        const t = arr[k];
        let i = left;
        /** @type {number} */ let j = right;
        $ed234ca8eb1f5a84$var$swap(arr, left, k);
        if (compare(arr[right], t) > 0) $ed234ca8eb1f5a84$var$swap(arr, left, right);
        while(i < j){
            $ed234ca8eb1f5a84$var$swap(arr, i, j);
            i++;
            j--;
            while(compare(arr[i], t) < 0)i++;
            while(compare(arr[j], t) > 0)j--;
        }
        if (compare(arr[left], t) === 0) $ed234ca8eb1f5a84$var$swap(arr, left, j);
        else {
            j++;
            $ed234ca8eb1f5a84$var$swap(arr, j, right);
        }
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
}
/**
 * @template T
 * @param {T[]} arr
 * @param {number} i
 * @param {number} j
 */ function $ed234ca8eb1f5a84$var$swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
/**
 * @template T
 * @param {T} a
 * @param {T} b
 * @returns {number}
 */ function $ed234ca8eb1f5a84$var$defaultCompare(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
/**
 * Classifies an array of rings into polygons with outer rings and holes
 * @param rings - the rings to classify
 * @param maxRings - the maximum number of rings to include in a polygon, use 0 to include all rings
 * @returns an array of polygons with internal rings as holes
 */ function $ed234ca8eb1f5a84$export$6663e563ab0af680(rings, maxRings) {
    const len = rings.length;
    if (len <= 1) return [
        rings
    ];
    const polygons = [];
    let polygon;
    let ccw;
    for (const ring of rings){
        const area = $ed234ca8eb1f5a84$var$calculateSignedArea(ring);
        if (area === 0) continue;
        ring.area = Math.abs(area);
        if (ccw === undefined) ccw = area < 0;
        if (ccw === area < 0) {
            if (polygon) polygons.push(polygon);
            polygon = [
                ring
            ];
        } else polygon.push(ring);
    }
    if (polygon) polygons.push(polygon);
    // Earcut performance degrades with the # of rings in a polygon. For this
    // reason, we limit strip out all but the `maxRings` largest rings.
    if (maxRings > 1) for(let j = 0; j < polygons.length; j++){
        if (polygons[j].length <= maxRings) continue;
        $ed234ca8eb1f5a84$var$quickselect(polygons[j], maxRings, 1, polygons[j].length - 1, $ed234ca8eb1f5a84$var$compareAreas);
        polygons[j] = polygons[j].slice(0, maxRings);
    }
    return polygons;
}
function $ed234ca8eb1f5a84$var$compareAreas(a, b) {
    return b.area - a.area;
}
/**
 * Returns the signed area for the polygon ring.  Positive areas are exterior rings and
 * have a clockwise winding.  Negative areas are interior rings and have a counter clockwise
 * ordering.
 *
 * @param ring - Exterior or interior ring
 * @returns Signed area
 */ function $ed234ca8eb1f5a84$var$calculateSignedArea(ring) {
    let sum = 0;
    for(let i = 0, len = ring.length, j = len - 1, p1, p2; i < len; j = i++){
        p1 = ring[i];
        p2 = ring[j];
        sum += (p2.x - p1.x) * (p1.y + p2.y);
    }
    return sum;
}
// This is taken from https://github.com/mapbox/cheap-ruler/ in order to take only the relevant parts
// Values that define WGS84 ellipsoid model of the Earth
const $ed234ca8eb1f5a84$var$RE = 6378.137; // equatorial radius
const $ed234ca8eb1f5a84$var$FE = 1 / 298.257223563; // flattening
const $ed234ca8eb1f5a84$var$E2 = $ed234ca8eb1f5a84$var$FE * (2 - $ed234ca8eb1f5a84$var$FE);
const $ed234ca8eb1f5a84$var$RAD = Math.PI / 180;
class $ed234ca8eb1f5a84$var$CheapRuler {
    constructor(lat){
        // Curvature formulas from https://en.wikipedia.org/wiki/Earth_radius#Meridional
        const m = $ed234ca8eb1f5a84$var$RAD * $ed234ca8eb1f5a84$var$RE * 1000;
        const coslat = Math.cos(lat * $ed234ca8eb1f5a84$var$RAD);
        const w2 = 1 / (1 - $ed234ca8eb1f5a84$var$E2 * (1 - coslat * coslat));
        const w = Math.sqrt(w2);
        // multipliers for converting longitude and latitude degrees into distance
        this.kx = m * w * coslat; // based on normal radius of curvature
        this.ky = m * w * w2 * (1 - $ed234ca8eb1f5a84$var$E2); // based on meridional radius of curvature
    }
    /**
     * Given two points of the form [longitude, latitude], returns the distance.
     *
     * @param a - point [longitude, latitude]
     * @param b - point [longitude, latitude]
     * @returns distance
     * @example
     * const distance = ruler.distance([30.5, 50.5], [30.51, 50.49]);
     * //=distance
     */ distance(a, b) {
        const dx = this.wrap(a[0] - b[0]) * this.kx;
        const dy = (a[1] - b[1]) * this.ky;
        return Math.sqrt(dx * dx + dy * dy);
    }
    /**
     * Returns an object of the form {point, index, t}, where point is closest point on the line
     * from the given point, index is the start index of the segment with the closest point,
     * and t is a parameter from 0 to 1 that indicates where the closest point is on that segment.
     *
     * @param line - an array of points that form the line
     * @param p - point [longitude, latitude]
     * @returns the nearest point, its index in the array and the proportion along the line
     * @example
     * const point = ruler.pointOnLine(line, [-67.04, 50.5]).point;
     * //=point
     */ pointOnLine(line, p) {
        let minDist = Infinity;
        let minX, minY, minI, minT;
        for(let i = 0; i < line.length - 1; i++){
            let x = line[i][0];
            let y = line[i][1];
            let dx = this.wrap(line[i + 1][0] - x) * this.kx;
            let dy = (line[i + 1][1] - y) * this.ky;
            let t = 0;
            if (dx !== 0 || dy !== 0) {
                t = (this.wrap(p[0] - x) * this.kx * dx + (p[1] - y) * this.ky * dy) / (dx * dx + dy * dy);
                if (t > 1) {
                    x = line[i + 1][0];
                    y = line[i + 1][1];
                } else if (t > 0) {
                    x += dx / this.kx * t;
                    y += dy / this.ky * t;
                }
            }
            dx = this.wrap(p[0] - x) * this.kx;
            dy = (p[1] - y) * this.ky;
            const sqDist = dx * dx + dy * dy;
            if (sqDist < minDist) {
                minDist = sqDist;
                minX = x;
                minY = y;
                minI = i;
                minT = t;
            }
        }
        return {
            point: [
                minX,
                minY
            ],
            index: minI,
            t: Math.max(0, Math.min(1, minT))
        };
    }
    wrap(deg) {
        while(deg < -180)deg += 360;
        while(deg > 180)deg -= 360;
        return deg;
    }
}
const $ed234ca8eb1f5a84$var$MinPointsSize = 100;
const $ed234ca8eb1f5a84$var$MinLinePointsSize = 50;
function $ed234ca8eb1f5a84$var$compareDistPair(a, b) {
    return b[0] - a[0];
}
function $ed234ca8eb1f5a84$var$getRangeSize(range) {
    return range[1] - range[0] + 1;
}
function $ed234ca8eb1f5a84$var$isRangeSafe(range, threshold) {
    return range[1] >= range[0] && range[1] < threshold;
}
function $ed234ca8eb1f5a84$var$splitRange(range, isLine) {
    if (range[0] > range[1]) return [
        null,
        null
    ];
    const size = $ed234ca8eb1f5a84$var$getRangeSize(range);
    if (isLine) {
        if (size === 2) return [
            range,
            null
        ];
        const size1 = Math.floor(size / 2);
        return [
            [
                range[0],
                range[0] + size1
            ],
            [
                range[0] + size1,
                range[1]
            ]
        ];
    }
    if (size === 1) return [
        range,
        null
    ];
    const size1 = Math.floor(size / 2) - 1;
    return [
        [
            range[0],
            range[0] + size1
        ],
        [
            range[0] + size1 + 1,
            range[1]
        ]
    ];
}
function $ed234ca8eb1f5a84$var$getBBox(coords, range) {
    if (!$ed234ca8eb1f5a84$var$isRangeSafe(range, coords.length)) return [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    const bbox = [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    for(let i = range[0]; i <= range[1]; ++i)$ed234ca8eb1f5a84$var$updateBBox(bbox, coords[i]);
    return bbox;
}
function $ed234ca8eb1f5a84$var$getPolygonBBox(polygon) {
    const bbox = [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    for (const ring of polygon)for (const coord of ring)$ed234ca8eb1f5a84$var$updateBBox(bbox, coord);
    return bbox;
}
function $ed234ca8eb1f5a84$var$isValidBBox(bbox) {
    return bbox[0] !== -Infinity && bbox[1] !== -Infinity && bbox[2] !== Infinity && bbox[3] !== Infinity;
}
// Calculate the distance between two bounding boxes.
// Calculate the delta in x and y direction, and use two fake points {0.0, 0.0}
// and {dx, dy} to calculate the distance. Distance will be 0.0 if bounding box are overlapping.
function $ed234ca8eb1f5a84$var$bboxToBBoxDistance(bbox1, bbox2, ruler) {
    if (!$ed234ca8eb1f5a84$var$isValidBBox(bbox1) || !$ed234ca8eb1f5a84$var$isValidBBox(bbox2)) return NaN;
    let dx = 0.0;
    let dy = 0.0;
    // bbox1 in left side
    if (bbox1[2] < bbox2[0]) dx = bbox2[0] - bbox1[2];
    // bbox1 in right side
    if (bbox1[0] > bbox2[2]) dx = bbox1[0] - bbox2[2];
    // bbox1 in above side
    if (bbox1[1] > bbox2[3]) dy = bbox1[1] - bbox2[3];
    // bbox1 in down side
    if (bbox1[3] < bbox2[1]) dy = bbox2[1] - bbox1[3];
    return ruler.distance([
        0.0,
        0.0
    ], [
        dx,
        dy
    ]);
}
function $ed234ca8eb1f5a84$var$pointToLineDistance(point, line, ruler) {
    const nearestPoint = ruler.pointOnLine(line, point);
    return ruler.distance(point, nearestPoint.point);
}
function $ed234ca8eb1f5a84$var$segmentToSegmentDistance(p1, p2, q1, q2, ruler) {
    const dist1 = Math.min($ed234ca8eb1f5a84$var$pointToLineDistance(p1, [
        q1,
        q2
    ], ruler), $ed234ca8eb1f5a84$var$pointToLineDistance(p2, [
        q1,
        q2
    ], ruler));
    const dist2 = Math.min($ed234ca8eb1f5a84$var$pointToLineDistance(q1, [
        p1,
        p2
    ], ruler), $ed234ca8eb1f5a84$var$pointToLineDistance(q2, [
        p1,
        p2
    ], ruler));
    return Math.min(dist1, dist2);
}
function $ed234ca8eb1f5a84$var$lineToLineDistance(line1, range1, line2, range2, ruler) {
    const rangeSafe = $ed234ca8eb1f5a84$var$isRangeSafe(range1, line1.length) && $ed234ca8eb1f5a84$var$isRangeSafe(range2, line2.length);
    if (!rangeSafe) return Infinity;
    let dist = Infinity;
    for(let i = range1[0]; i < range1[1]; ++i){
        const p1 = line1[i];
        const p2 = line1[i + 1];
        for(let j = range2[0]; j < range2[1]; ++j){
            const q1 = line2[j];
            const q2 = line2[j + 1];
            if ($ed234ca8eb1f5a84$var$segmentIntersectSegment(p1, p2, q1, q2)) return 0.0;
            dist = Math.min(dist, $ed234ca8eb1f5a84$var$segmentToSegmentDistance(p1, p2, q1, q2, ruler));
        }
    }
    return dist;
}
function $ed234ca8eb1f5a84$var$pointsToPointsDistance(points1, range1, points2, range2, ruler) {
    const rangeSafe = $ed234ca8eb1f5a84$var$isRangeSafe(range1, points1.length) && $ed234ca8eb1f5a84$var$isRangeSafe(range2, points2.length);
    if (!rangeSafe) return NaN;
    let dist = Infinity;
    for(let i = range1[0]; i <= range1[1]; ++i)for(let j = range2[0]; j <= range2[1]; ++j){
        dist = Math.min(dist, ruler.distance(points1[i], points2[j]));
        if (dist === 0.0) return dist;
    }
    return dist;
}
function $ed234ca8eb1f5a84$var$pointToPolygonDistance(point, polygon, ruler) {
    if ($ed234ca8eb1f5a84$var$pointWithinPolygon(point, polygon, true)) return 0.0;
    let dist = Infinity;
    for (const ring of polygon){
        const front = ring[0];
        const back = ring[ring.length - 1];
        if (front !== back) {
            dist = Math.min(dist, $ed234ca8eb1f5a84$var$pointToLineDistance(point, [
                back,
                front
            ], ruler));
            if (dist === 0.0) return dist;
        }
        const nearestPoint = ruler.pointOnLine(ring, point);
        dist = Math.min(dist, ruler.distance(point, nearestPoint.point));
        if (dist === 0.0) return dist;
    }
    return dist;
}
function $ed234ca8eb1f5a84$var$lineToPolygonDistance(line, range, polygon, ruler) {
    if (!$ed234ca8eb1f5a84$var$isRangeSafe(range, line.length)) return NaN;
    for(let i = range[0]; i <= range[1]; ++i){
        if ($ed234ca8eb1f5a84$var$pointWithinPolygon(line[i], polygon, true)) return 0.0;
    }
    let dist = Infinity;
    for(let i = range[0]; i < range[1]; ++i){
        const p1 = line[i];
        const p2 = line[i + 1];
        for (const ring of polygon)for(let j = 0, len = ring.length, k = len - 1; j < len; k = j++){
            const q1 = ring[k];
            const q2 = ring[j];
            if ($ed234ca8eb1f5a84$var$segmentIntersectSegment(p1, p2, q1, q2)) return 0.0;
            dist = Math.min(dist, $ed234ca8eb1f5a84$var$segmentToSegmentDistance(p1, p2, q1, q2, ruler));
        }
    }
    return dist;
}
function $ed234ca8eb1f5a84$var$polygonIntersect(poly1, poly2) {
    for (const ring of poly1)for (const point of ring){
        if ($ed234ca8eb1f5a84$var$pointWithinPolygon(point, poly2, true)) return true;
    }
    return false;
}
function $ed234ca8eb1f5a84$var$polygonToPolygonDistance(polygon1, polygon2, ruler, currentMiniDist = Infinity) {
    const bbox1 = $ed234ca8eb1f5a84$var$getPolygonBBox(polygon1);
    const bbox2 = $ed234ca8eb1f5a84$var$getPolygonBBox(polygon2);
    if (currentMiniDist !== Infinity && $ed234ca8eb1f5a84$var$bboxToBBoxDistance(bbox1, bbox2, ruler) >= currentMiniDist) return currentMiniDist;
    if ($ed234ca8eb1f5a84$var$boxWithinBox(bbox1, bbox2)) {
        if ($ed234ca8eb1f5a84$var$polygonIntersect(polygon1, polygon2)) return 0.0;
    } else if ($ed234ca8eb1f5a84$var$polygonIntersect(polygon2, polygon1)) return 0.0;
    let dist = Infinity;
    for (const ring1 of polygon1)for(let i = 0, len1 = ring1.length, l = len1 - 1; i < len1; l = i++){
        const p1 = ring1[l];
        const p2 = ring1[i];
        for (const ring2 of polygon2)for(let j = 0, len2 = ring2.length, k = len2 - 1; j < len2; k = j++){
            const q1 = ring2[k];
            const q2 = ring2[j];
            if ($ed234ca8eb1f5a84$var$segmentIntersectSegment(p1, p2, q1, q2)) return 0.0;
            dist = Math.min(dist, $ed234ca8eb1f5a84$var$segmentToSegmentDistance(p1, p2, q1, q2, ruler));
        }
    }
    return dist;
}
function $ed234ca8eb1f5a84$var$updateQueue(distQueue, miniDist, ruler, points, polyBBox, rangeA) {
    if (!rangeA) return;
    const tempDist = $ed234ca8eb1f5a84$var$bboxToBBoxDistance($ed234ca8eb1f5a84$var$getBBox(points, rangeA), polyBBox, ruler);
    // Insert new pair to the queue if the bbox distance is less than
    // miniDist, The pair with biggest distance will be at the top
    if (tempDist < miniDist) distQueue.push([
        tempDist,
        rangeA,
        [
            0,
            0
        ]
    ]);
}
function $ed234ca8eb1f5a84$var$updateQueueTwoSets(distQueue, miniDist, ruler, pointSet1, pointSet2, range1, range2) {
    if (!range1 || !range2) return;
    const tempDist = $ed234ca8eb1f5a84$var$bboxToBBoxDistance($ed234ca8eb1f5a84$var$getBBox(pointSet1, range1), $ed234ca8eb1f5a84$var$getBBox(pointSet2, range2), ruler);
    // Insert new pair to the queue if the bbox distance is less than
    // miniDist, The pair with biggest distance will be at the top
    if (tempDist < miniDist) distQueue.push([
        tempDist,
        range1,
        range2
    ]);
}
// Divide and conquer, the time complexity is O(n*lgn), faster than Brute force
// O(n*n) Most of the time, use index for in-place processing.
function $ed234ca8eb1f5a84$var$pointsToPolygonDistance(points, isLine, polygon, ruler, currentMiniDist = Infinity) {
    let miniDist = Math.min(ruler.distance(points[0], polygon[0][0]), currentMiniDist);
    if (miniDist === 0.0) return miniDist;
    const distQueue = new $ed234ca8eb1f5a84$var$TinyQueue([
        [
            0,
            [
                0,
                points.length - 1
            ],
            [
                0,
                0
            ]
        ]
    ], $ed234ca8eb1f5a84$var$compareDistPair);
    const polyBBox = $ed234ca8eb1f5a84$var$getPolygonBBox(polygon);
    while(distQueue.length > 0){
        const distPair = distQueue.pop();
        if (distPair[0] >= miniDist) continue;
        const range = distPair[1];
        // In case the set size are relatively small, we could use brute-force directly
        const threshold = isLine ? $ed234ca8eb1f5a84$var$MinLinePointsSize : $ed234ca8eb1f5a84$var$MinPointsSize;
        if ($ed234ca8eb1f5a84$var$getRangeSize(range) <= threshold) {
            if (!$ed234ca8eb1f5a84$var$isRangeSafe(range, points.length)) return NaN;
            if (isLine) {
                const tempDist = $ed234ca8eb1f5a84$var$lineToPolygonDistance(points, range, polygon, ruler);
                if (isNaN(tempDist) || tempDist === 0.0) return tempDist;
                miniDist = Math.min(miniDist, tempDist);
            } else for(let i = range[0]; i <= range[1]; ++i){
                const tempDist = $ed234ca8eb1f5a84$var$pointToPolygonDistance(points[i], polygon, ruler);
                miniDist = Math.min(miniDist, tempDist);
                if (miniDist === 0.0) return 0.0;
            }
        } else {
            const newRangesA = $ed234ca8eb1f5a84$var$splitRange(range, isLine);
            $ed234ca8eb1f5a84$var$updateQueue(distQueue, miniDist, ruler, points, polyBBox, newRangesA[0]);
            $ed234ca8eb1f5a84$var$updateQueue(distQueue, miniDist, ruler, points, polyBBox, newRangesA[1]);
        }
    }
    return miniDist;
}
function $ed234ca8eb1f5a84$var$pointSetToPointSetDistance(pointSet1, isLine1, pointSet2, isLine2, ruler, currentMiniDist = Infinity) {
    let miniDist = Math.min(currentMiniDist, ruler.distance(pointSet1[0], pointSet2[0]));
    if (miniDist === 0.0) return miniDist;
    const distQueue = new $ed234ca8eb1f5a84$var$TinyQueue([
        [
            0,
            [
                0,
                pointSet1.length - 1
            ],
            [
                0,
                pointSet2.length - 1
            ]
        ]
    ], $ed234ca8eb1f5a84$var$compareDistPair);
    while(distQueue.length > 0){
        const distPair = distQueue.pop();
        if (distPair[0] >= miniDist) continue;
        const rangeA = distPair[1];
        const rangeB = distPair[2];
        const threshold1 = isLine1 ? $ed234ca8eb1f5a84$var$MinLinePointsSize : $ed234ca8eb1f5a84$var$MinPointsSize;
        const threshold2 = isLine2 ? $ed234ca8eb1f5a84$var$MinLinePointsSize : $ed234ca8eb1f5a84$var$MinPointsSize;
        // In case the set size are relatively small, we could use brute-force directly
        if ($ed234ca8eb1f5a84$var$getRangeSize(rangeA) <= threshold1 && $ed234ca8eb1f5a84$var$getRangeSize(rangeB) <= threshold2) {
            if (!$ed234ca8eb1f5a84$var$isRangeSafe(rangeA, pointSet1.length) && $ed234ca8eb1f5a84$var$isRangeSafe(rangeB, pointSet2.length)) return NaN;
            let tempDist;
            if (isLine1 && isLine2) {
                tempDist = $ed234ca8eb1f5a84$var$lineToLineDistance(pointSet1, rangeA, pointSet2, rangeB, ruler);
                miniDist = Math.min(miniDist, tempDist);
            } else if (isLine1 && !isLine2) {
                const sublibe = pointSet1.slice(rangeA[0], rangeA[1] + 1);
                for(let i = rangeB[0]; i <= rangeB[1]; ++i){
                    tempDist = $ed234ca8eb1f5a84$var$pointToLineDistance(pointSet2[i], sublibe, ruler);
                    miniDist = Math.min(miniDist, tempDist);
                    if (miniDist === 0.0) return miniDist;
                }
            } else if (!isLine1 && isLine2) {
                const sublibe = pointSet2.slice(rangeB[0], rangeB[1] + 1);
                for(let i = rangeA[0]; i <= rangeA[1]; ++i){
                    tempDist = $ed234ca8eb1f5a84$var$pointToLineDistance(pointSet1[i], sublibe, ruler);
                    miniDist = Math.min(miniDist, tempDist);
                    if (miniDist === 0.0) return miniDist;
                }
            } else {
                tempDist = $ed234ca8eb1f5a84$var$pointsToPointsDistance(pointSet1, rangeA, pointSet2, rangeB, ruler);
                miniDist = Math.min(miniDist, tempDist);
            }
        } else {
            const newRangesA = $ed234ca8eb1f5a84$var$splitRange(rangeA, isLine1);
            const newRangesB = $ed234ca8eb1f5a84$var$splitRange(rangeB, isLine2);
            $ed234ca8eb1f5a84$var$updateQueueTwoSets(distQueue, miniDist, ruler, pointSet1, pointSet2, newRangesA[0], newRangesB[0]);
            $ed234ca8eb1f5a84$var$updateQueueTwoSets(distQueue, miniDist, ruler, pointSet1, pointSet2, newRangesA[0], newRangesB[1]);
            $ed234ca8eb1f5a84$var$updateQueueTwoSets(distQueue, miniDist, ruler, pointSet1, pointSet2, newRangesA[1], newRangesB[0]);
            $ed234ca8eb1f5a84$var$updateQueueTwoSets(distQueue, miniDist, ruler, pointSet1, pointSet2, newRangesA[1], newRangesB[1]);
        }
    }
    return miniDist;
}
function $ed234ca8eb1f5a84$var$pointToGeometryDistance(ctx, geometries) {
    const tilePoints = ctx.geometry();
    const pointPosition = tilePoints.flat().map((p)=>$ed234ca8eb1f5a84$var$getLngLatFromTileCoord([
            p.x,
            p.y
        ], ctx.canonical));
    if (tilePoints.length === 0) return NaN;
    const ruler = new $ed234ca8eb1f5a84$var$CheapRuler(pointPosition[0][1]);
    let dist = Infinity;
    for (const geometry of geometries){
        switch(geometry.type){
            case 'Point':
                dist = Math.min(dist, $ed234ca8eb1f5a84$var$pointSetToPointSetDistance(pointPosition, false, [
                    geometry.coordinates
                ], false, ruler, dist));
                break;
            case 'LineString':
                dist = Math.min(dist, $ed234ca8eb1f5a84$var$pointSetToPointSetDistance(pointPosition, false, geometry.coordinates, true, ruler, dist));
                break;
            case 'Polygon':
                dist = Math.min(dist, $ed234ca8eb1f5a84$var$pointsToPolygonDistance(pointPosition, false, geometry.coordinates, ruler, dist));
                break;
        }
        if (dist === 0.0) return dist;
    }
    return dist;
}
function $ed234ca8eb1f5a84$var$lineStringToGeometryDistance(ctx, geometries) {
    const tileLine = ctx.geometry();
    const linePositions = tileLine.flat().map((p)=>$ed234ca8eb1f5a84$var$getLngLatFromTileCoord([
            p.x,
            p.y
        ], ctx.canonical));
    if (tileLine.length === 0) return NaN;
    const ruler = new $ed234ca8eb1f5a84$var$CheapRuler(linePositions[0][1]);
    let dist = Infinity;
    for (const geometry of geometries){
        switch(geometry.type){
            case 'Point':
                dist = Math.min(dist, $ed234ca8eb1f5a84$var$pointSetToPointSetDistance(linePositions, true, [
                    geometry.coordinates
                ], false, ruler, dist));
                break;
            case 'LineString':
                dist = Math.min(dist, $ed234ca8eb1f5a84$var$pointSetToPointSetDistance(linePositions, true, geometry.coordinates, true, ruler, dist));
                break;
            case 'Polygon':
                dist = Math.min(dist, $ed234ca8eb1f5a84$var$pointsToPolygonDistance(linePositions, true, geometry.coordinates, ruler, dist));
                break;
        }
        if (dist === 0.0) return dist;
    }
    return dist;
}
function $ed234ca8eb1f5a84$var$polygonToGeometryDistance(ctx, geometries) {
    const tilePolygon = ctx.geometry();
    if (tilePolygon.length === 0 || tilePolygon[0].length === 0) return NaN;
    const polygons = $ed234ca8eb1f5a84$export$6663e563ab0af680(tilePolygon, 0).map((polygon)=>{
        return polygon.map((ring)=>{
            return ring.map((p)=>$ed234ca8eb1f5a84$var$getLngLatFromTileCoord([
                    p.x,
                    p.y
                ], ctx.canonical));
        });
    });
    const ruler = new $ed234ca8eb1f5a84$var$CheapRuler(polygons[0][0][0][1]);
    let dist = Infinity;
    for (const geometry of geometries)for (const polygon of polygons){
        switch(geometry.type){
            case 'Point':
                dist = Math.min(dist, $ed234ca8eb1f5a84$var$pointsToPolygonDistance([
                    geometry.coordinates
                ], false, polygon, ruler, dist));
                break;
            case 'LineString':
                dist = Math.min(dist, $ed234ca8eb1f5a84$var$pointsToPolygonDistance(geometry.coordinates, true, polygon, ruler, dist));
                break;
            case 'Polygon':
                dist = Math.min(dist, $ed234ca8eb1f5a84$var$polygonToPolygonDistance(polygon, geometry.coordinates, ruler, dist));
                break;
        }
        if (dist === 0.0) return dist;
    }
    return dist;
}
function $ed234ca8eb1f5a84$var$toSimpleGeometry(geometry) {
    if (geometry.type === 'MultiPolygon') return geometry.coordinates.map((polygon)=>{
        return {
            type: 'Polygon',
            coordinates: polygon
        };
    });
    if (geometry.type === 'MultiLineString') return geometry.coordinates.map((lineString)=>{
        return {
            type: 'LineString',
            coordinates: lineString
        };
    });
    if (geometry.type === 'MultiPoint') return geometry.coordinates.map((point)=>{
        return {
            type: 'Point',
            coordinates: point
        };
    });
    return [
        geometry
    ];
}
class $ed234ca8eb1f5a84$var$Distance {
    constructor(geojson, geometries){
        this.type = $ed234ca8eb1f5a84$var$NumberType;
        this.geojson = geojson;
        this.geometries = geometries;
    }
    static parse(args, context) {
        if (args.length !== 2) return context.error(`'distance' expression requires exactly one argument, but found ${args.length - 1} instead.`);
        if ($ed234ca8eb1f5a84$var$isValue(args[1])) {
            const geojson = args[1];
            if (geojson.type === 'FeatureCollection') return new $ed234ca8eb1f5a84$var$Distance(geojson, geojson.features.map((feature)=>$ed234ca8eb1f5a84$var$toSimpleGeometry(feature.geometry)).flat());
            else if (geojson.type === 'Feature') return new $ed234ca8eb1f5a84$var$Distance(geojson, $ed234ca8eb1f5a84$var$toSimpleGeometry(geojson.geometry));
            else if ('type' in geojson && 'coordinates' in geojson) return new $ed234ca8eb1f5a84$var$Distance(geojson, $ed234ca8eb1f5a84$var$toSimpleGeometry(geojson));
        }
        return context.error("'distance' expression requires valid geojson object that contains polygon geometry type.");
    }
    evaluate(ctx) {
        if (ctx.geometry() != null && ctx.canonicalID() != null) {
            if (ctx.geometryType() === 'Point') return $ed234ca8eb1f5a84$var$pointToGeometryDistance(ctx, this.geometries);
            else if (ctx.geometryType() === 'LineString') return $ed234ca8eb1f5a84$var$lineStringToGeometryDistance(ctx, this.geometries);
            else if (ctx.geometryType() === 'Polygon') return $ed234ca8eb1f5a84$var$polygonToGeometryDistance(ctx, this.geometries);
        }
        return NaN;
    }
    eachChild() {}
    outputDefined() {
        return true;
    }
}
class $ed234ca8eb1f5a84$var$GlobalState {
    constructor(key){
        this.type = $ed234ca8eb1f5a84$var$ValueType;
        this.key = key;
    }
    static parse(args, context) {
        if (args.length !== 2) return context.error(`Expected 1 argument, but found ${args.length - 1} instead.`);
        const key = args[1];
        if (key === undefined || key === null) return context.error('Global state property must be defined.');
        if (typeof key !== 'string') return context.error(`Global state property must be string, but found ${typeof args[1]} instead.`);
        return new $ed234ca8eb1f5a84$var$GlobalState(key);
    }
    evaluate(ctx) {
        var _a;
        const globalState = (_a = ctx.globals) === null || _a === void 0 ? void 0 : _a.globalState;
        if (!globalState || Object.keys(globalState).length === 0) return null;
        return $ed234ca8eb1f5a84$var$getOwn(globalState, this.key);
    }
    eachChild() {}
    outputDefined() {
        return false;
    }
}
const $ed234ca8eb1f5a84$export$f55ecc93729893d7 = {
    // special forms
    '==': $ed234ca8eb1f5a84$var$Equals,
    '!=': $ed234ca8eb1f5a84$var$NotEquals,
    '>': $ed234ca8eb1f5a84$var$GreaterThan,
    '<': $ed234ca8eb1f5a84$var$LessThan,
    '>=': $ed234ca8eb1f5a84$var$GreaterThanOrEqual,
    '<=': $ed234ca8eb1f5a84$var$LessThanOrEqual,
    array: $ed234ca8eb1f5a84$var$Assertion,
    at: $ed234ca8eb1f5a84$var$At,
    boolean: $ed234ca8eb1f5a84$var$Assertion,
    case: $ed234ca8eb1f5a84$var$Case,
    coalesce: $ed234ca8eb1f5a84$var$Coalesce,
    collator: $ed234ca8eb1f5a84$var$CollatorExpression,
    format: $ed234ca8eb1f5a84$export$f1942a50a557e8d4,
    image: $ed234ca8eb1f5a84$var$ImageExpression,
    in: $ed234ca8eb1f5a84$var$In,
    'index-of': $ed234ca8eb1f5a84$var$IndexOf,
    interpolate: $ed234ca8eb1f5a84$export$6bb252fbb1a22840,
    'interpolate-hcl': $ed234ca8eb1f5a84$export$6bb252fbb1a22840,
    'interpolate-lab': $ed234ca8eb1f5a84$export$6bb252fbb1a22840,
    length: $ed234ca8eb1f5a84$var$Length,
    let: $ed234ca8eb1f5a84$var$Let,
    literal: $ed234ca8eb1f5a84$export$e175ae9e414693bc,
    match: $ed234ca8eb1f5a84$var$Match,
    number: $ed234ca8eb1f5a84$var$Assertion,
    'number-format': $ed234ca8eb1f5a84$var$NumberFormat,
    object: $ed234ca8eb1f5a84$var$Assertion,
    slice: $ed234ca8eb1f5a84$var$Slice,
    step: $ed234ca8eb1f5a84$export$fd55ce593607084a,
    string: $ed234ca8eb1f5a84$var$Assertion,
    'to-boolean': $ed234ca8eb1f5a84$var$Coercion,
    'to-color': $ed234ca8eb1f5a84$var$Coercion,
    'to-number': $ed234ca8eb1f5a84$var$Coercion,
    'to-string': $ed234ca8eb1f5a84$var$Coercion,
    var: $ed234ca8eb1f5a84$var$Var,
    within: $ed234ca8eb1f5a84$var$Within,
    distance: $ed234ca8eb1f5a84$var$Distance,
    'global-state': $ed234ca8eb1f5a84$var$GlobalState
};
class $ed234ca8eb1f5a84$export$a766a6736ff5bbbf {
    constructor(name, type, evaluate, args){
        this.name = name;
        this.type = type;
        this._evaluate = evaluate;
        this.args = args;
    }
    evaluate(ctx) {
        return this._evaluate(ctx, this.args);
    }
    eachChild(fn) {
        this.args.forEach(fn);
    }
    outputDefined() {
        return false;
    }
    static parse(args, context) {
        const op = args[0];
        const definition = $ed234ca8eb1f5a84$export$a766a6736ff5bbbf.definitions[op];
        if (!definition) return context.error(`Unknown expression "${op}". If you wanted a literal array, use ["literal", [...]].`, 0);
        // Now check argument types against each signature
        const type = Array.isArray(definition) ? definition[0] : definition.type;
        const availableOverloads = Array.isArray(definition) ? [
            [
                definition[1],
                definition[2]
            ]
        ] : definition.overloads;
        const overloads = availableOverloads.filter(([signature])=>!Array.isArray(signature) || // varags
            signature.length === args.length - 1 // correct param count
        );
        let signatureContext = null;
        for (const [params, evaluate] of overloads){
            // Use a fresh context for each attempted signature so that, if
            // we eventually succeed, we haven't polluted `context.errors`.
            signatureContext = new $ed234ca8eb1f5a84$var$ParsingContext(context.registry, $ed234ca8eb1f5a84$var$isExpressionConstant, context.path, null, context.scope);
            // First parse all the args, potentially coercing to the
            // types expected by this overload.
            const parsedArgs = [];
            let argParseFailed = false;
            for(let i = 1; i < args.length; i++){
                const arg = args[i];
                const expectedType = Array.isArray(params) ? params[i - 1] : params.type;
                const parsed = signatureContext.parse(arg, 1 + parsedArgs.length, expectedType);
                if (!parsed) {
                    argParseFailed = true;
                    break;
                }
                parsedArgs.push(parsed);
            }
            if (argParseFailed) continue;
            if (Array.isArray(params)) {
                if (params.length !== parsedArgs.length) {
                    signatureContext.error(`Expected ${params.length} arguments, but found ${parsedArgs.length} instead.`);
                    continue;
                }
            }
            for(let i = 0; i < parsedArgs.length; i++){
                const expected = Array.isArray(params) ? params[i] : params.type;
                const arg = parsedArgs[i];
                signatureContext.concat(i + 1).checkSubtype(expected, arg.type);
            }
            if (signatureContext.errors.length === 0) return new $ed234ca8eb1f5a84$export$a766a6736ff5bbbf(op, type, evaluate, parsedArgs);
        }
        if (overloads.length === 1) context.errors.push(...signatureContext.errors);
        else {
            const expected = overloads.length ? overloads : availableOverloads;
            const signatures = expected.map(([params])=>$ed234ca8eb1f5a84$var$stringifySignature(params)).join(' | ');
            const actualTypes = [];
            // For error message, re-parse arguments without trying to
            // apply any coercions
            for(let i = 1; i < args.length; i++){
                const parsed = context.parse(args[i], 1 + actualTypes.length);
                if (!parsed) return null;
                actualTypes.push($ed234ca8eb1f5a84$export$f84e8e69fd4488a5(parsed.type));
            }
            context.error(`Expected arguments of type ${signatures}, but found (${actualTypes.join(', ')}) instead.`);
        }
        return null;
    }
    static register(registry, definitions) {
        $ed234ca8eb1f5a84$export$a766a6736ff5bbbf.definitions = definitions;
        for(const name in definitions)registry[name] = $ed234ca8eb1f5a84$export$a766a6736ff5bbbf;
    }
}
function $ed234ca8eb1f5a84$var$rgba(ctx, [r, g, b, a]) {
    r = r.evaluate(ctx);
    g = g.evaluate(ctx);
    b = b.evaluate(ctx);
    const alpha = a ? a.evaluate(ctx) : 1;
    const error = $ed234ca8eb1f5a84$var$validateRGBA(r, g, b, alpha);
    if (error) throw new $ed234ca8eb1f5a84$var$RuntimeError(error);
    return new $ed234ca8eb1f5a84$export$892596cec99bc70e(r / 255, g / 255, b / 255, alpha, false);
}
function $ed234ca8eb1f5a84$var$has(key, obj) {
    return key in obj;
}
function $ed234ca8eb1f5a84$var$get(key, obj) {
    const v = obj[key];
    return typeof v === 'undefined' ? null : v;
}
function $ed234ca8eb1f5a84$var$binarySearch(v, a, i, j) {
    while(i <= j){
        const m = i + j >> 1;
        if (a[m] === v) return true;
        if (a[m] > v) j = m - 1;
        else i = m + 1;
    }
    return false;
}
function $ed234ca8eb1f5a84$var$varargs(type) {
    return {
        type: type
    };
}
$ed234ca8eb1f5a84$export$a766a6736ff5bbbf.register($ed234ca8eb1f5a84$export$f55ecc93729893d7, {
    error: [
        $ed234ca8eb1f5a84$var$ErrorType,
        [
            $ed234ca8eb1f5a84$var$StringType
        ],
        (ctx, [v])=>{
            throw new $ed234ca8eb1f5a84$var$RuntimeError(v.evaluate(ctx));
        }
    ],
    typeof: [
        $ed234ca8eb1f5a84$var$StringType,
        [
            $ed234ca8eb1f5a84$var$ValueType
        ],
        (ctx, [v])=>$ed234ca8eb1f5a84$export$f84e8e69fd4488a5($ed234ca8eb1f5a84$export$f5bbd400c2f4426f(v.evaluate(ctx)))
    ],
    'to-rgba': [
        $ed234ca8eb1f5a84$var$array($ed234ca8eb1f5a84$var$NumberType, 4),
        [
            $ed234ca8eb1f5a84$export$2cd82751acc0e609
        ],
        (ctx, [v])=>{
            const [r, g, b, a] = v.evaluate(ctx).rgb;
            return [
                r * 255,
                g * 255,
                b * 255,
                a
            ];
        }
    ],
    rgb: [
        $ed234ca8eb1f5a84$export$2cd82751acc0e609,
        [
            $ed234ca8eb1f5a84$var$NumberType,
            $ed234ca8eb1f5a84$var$NumberType,
            $ed234ca8eb1f5a84$var$NumberType
        ],
        $ed234ca8eb1f5a84$var$rgba
    ],
    rgba: [
        $ed234ca8eb1f5a84$export$2cd82751acc0e609,
        [
            $ed234ca8eb1f5a84$var$NumberType,
            $ed234ca8eb1f5a84$var$NumberType,
            $ed234ca8eb1f5a84$var$NumberType,
            $ed234ca8eb1f5a84$var$NumberType
        ],
        $ed234ca8eb1f5a84$var$rgba
    ],
    has: {
        type: $ed234ca8eb1f5a84$var$BooleanType,
        overloads: [
            [
                [
                    $ed234ca8eb1f5a84$var$StringType
                ],
                (ctx, [key])=>$ed234ca8eb1f5a84$var$has(key.evaluate(ctx), ctx.properties())
            ],
            [
                [
                    $ed234ca8eb1f5a84$var$StringType,
                    $ed234ca8eb1f5a84$var$ObjectType
                ],
                (ctx, [key, obj])=>$ed234ca8eb1f5a84$var$has(key.evaluate(ctx), obj.evaluate(ctx))
            ]
        ]
    },
    get: {
        type: $ed234ca8eb1f5a84$var$ValueType,
        overloads: [
            [
                [
                    $ed234ca8eb1f5a84$var$StringType
                ],
                (ctx, [key])=>$ed234ca8eb1f5a84$var$get(key.evaluate(ctx), ctx.properties())
            ],
            [
                [
                    $ed234ca8eb1f5a84$var$StringType,
                    $ed234ca8eb1f5a84$var$ObjectType
                ],
                (ctx, [key, obj])=>$ed234ca8eb1f5a84$var$get(key.evaluate(ctx), obj.evaluate(ctx))
            ]
        ]
    },
    'feature-state': [
        $ed234ca8eb1f5a84$var$ValueType,
        [
            $ed234ca8eb1f5a84$var$StringType
        ],
        (ctx, [key])=>$ed234ca8eb1f5a84$var$get(key.evaluate(ctx), ctx.featureState || {})
    ],
    properties: [
        $ed234ca8eb1f5a84$var$ObjectType,
        [],
        (ctx)=>ctx.properties()
    ],
    'geometry-type': [
        $ed234ca8eb1f5a84$var$StringType,
        [],
        (ctx)=>ctx.geometryType()
    ],
    id: [
        $ed234ca8eb1f5a84$var$ValueType,
        [],
        (ctx)=>ctx.id()
    ],
    zoom: [
        $ed234ca8eb1f5a84$var$NumberType,
        [],
        (ctx)=>ctx.globals.zoom
    ],
    'heatmap-density': [
        $ed234ca8eb1f5a84$var$NumberType,
        [],
        (ctx)=>ctx.globals.heatmapDensity || 0
    ],
    elevation: [
        $ed234ca8eb1f5a84$var$NumberType,
        [],
        (ctx)=>ctx.globals.elevation || 0
    ],
    'line-progress': [
        $ed234ca8eb1f5a84$var$NumberType,
        [],
        (ctx)=>ctx.globals.lineProgress || 0
    ],
    accumulated: [
        $ed234ca8eb1f5a84$var$ValueType,
        [],
        (ctx)=>ctx.globals.accumulated === undefined ? null : ctx.globals.accumulated
    ],
    '+': [
        $ed234ca8eb1f5a84$var$NumberType,
        $ed234ca8eb1f5a84$var$varargs($ed234ca8eb1f5a84$var$NumberType),
        (ctx, args)=>{
            let result = 0;
            for (const arg of args)result += arg.evaluate(ctx);
            return result;
        }
    ],
    '*': [
        $ed234ca8eb1f5a84$var$NumberType,
        $ed234ca8eb1f5a84$var$varargs($ed234ca8eb1f5a84$var$NumberType),
        (ctx, args)=>{
            let result = 1;
            for (const arg of args)result *= arg.evaluate(ctx);
            return result;
        }
    ],
    '-': {
        type: $ed234ca8eb1f5a84$var$NumberType,
        overloads: [
            [
                [
                    $ed234ca8eb1f5a84$var$NumberType,
                    $ed234ca8eb1f5a84$var$NumberType
                ],
                (ctx, [a, b])=>a.evaluate(ctx) - b.evaluate(ctx)
            ],
            [
                [
                    $ed234ca8eb1f5a84$var$NumberType
                ],
                (ctx, [a])=>-a.evaluate(ctx)
            ]
        ]
    },
    '/': [
        $ed234ca8eb1f5a84$var$NumberType,
        [
            $ed234ca8eb1f5a84$var$NumberType,
            $ed234ca8eb1f5a84$var$NumberType
        ],
        (ctx, [a, b])=>a.evaluate(ctx) / b.evaluate(ctx)
    ],
    '%': [
        $ed234ca8eb1f5a84$var$NumberType,
        [
            $ed234ca8eb1f5a84$var$NumberType,
            $ed234ca8eb1f5a84$var$NumberType
        ],
        (ctx, [a, b])=>a.evaluate(ctx) % b.evaluate(ctx)
    ],
    ln2: [
        $ed234ca8eb1f5a84$var$NumberType,
        [],
        ()=>Math.LN2
    ],
    pi: [
        $ed234ca8eb1f5a84$var$NumberType,
        [],
        ()=>Math.PI
    ],
    e: [
        $ed234ca8eb1f5a84$var$NumberType,
        [],
        ()=>Math.E
    ],
    '^': [
        $ed234ca8eb1f5a84$var$NumberType,
        [
            $ed234ca8eb1f5a84$var$NumberType,
            $ed234ca8eb1f5a84$var$NumberType
        ],
        (ctx, [b, e])=>Math.pow(b.evaluate(ctx), e.evaluate(ctx))
    ],
    sqrt: [
        $ed234ca8eb1f5a84$var$NumberType,
        [
            $ed234ca8eb1f5a84$var$NumberType
        ],
        (ctx, [x])=>Math.sqrt(x.evaluate(ctx))
    ],
    log10: [
        $ed234ca8eb1f5a84$var$NumberType,
        [
            $ed234ca8eb1f5a84$var$NumberType
        ],
        (ctx, [n])=>Math.log(n.evaluate(ctx)) / Math.LN10
    ],
    ln: [
        $ed234ca8eb1f5a84$var$NumberType,
        [
            $ed234ca8eb1f5a84$var$NumberType
        ],
        (ctx, [n])=>Math.log(n.evaluate(ctx))
    ],
    log2: [
        $ed234ca8eb1f5a84$var$NumberType,
        [
            $ed234ca8eb1f5a84$var$NumberType
        ],
        (ctx, [n])=>Math.log(n.evaluate(ctx)) / Math.LN2
    ],
    sin: [
        $ed234ca8eb1f5a84$var$NumberType,
        [
            $ed234ca8eb1f5a84$var$NumberType
        ],
        (ctx, [n])=>Math.sin(n.evaluate(ctx))
    ],
    cos: [
        $ed234ca8eb1f5a84$var$NumberType,
        [
            $ed234ca8eb1f5a84$var$NumberType
        ],
        (ctx, [n])=>Math.cos(n.evaluate(ctx))
    ],
    tan: [
        $ed234ca8eb1f5a84$var$NumberType,
        [
            $ed234ca8eb1f5a84$var$NumberType
        ],
        (ctx, [n])=>Math.tan(n.evaluate(ctx))
    ],
    asin: [
        $ed234ca8eb1f5a84$var$NumberType,
        [
            $ed234ca8eb1f5a84$var$NumberType
        ],
        (ctx, [n])=>Math.asin(n.evaluate(ctx))
    ],
    acos: [
        $ed234ca8eb1f5a84$var$NumberType,
        [
            $ed234ca8eb1f5a84$var$NumberType
        ],
        (ctx, [n])=>Math.acos(n.evaluate(ctx))
    ],
    atan: [
        $ed234ca8eb1f5a84$var$NumberType,
        [
            $ed234ca8eb1f5a84$var$NumberType
        ],
        (ctx, [n])=>Math.atan(n.evaluate(ctx))
    ],
    min: [
        $ed234ca8eb1f5a84$var$NumberType,
        $ed234ca8eb1f5a84$var$varargs($ed234ca8eb1f5a84$var$NumberType),
        (ctx, args)=>Math.min(...args.map((arg)=>arg.evaluate(ctx)))
    ],
    max: [
        $ed234ca8eb1f5a84$var$NumberType,
        $ed234ca8eb1f5a84$var$varargs($ed234ca8eb1f5a84$var$NumberType),
        (ctx, args)=>Math.max(...args.map((arg)=>arg.evaluate(ctx)))
    ],
    abs: [
        $ed234ca8eb1f5a84$var$NumberType,
        [
            $ed234ca8eb1f5a84$var$NumberType
        ],
        (ctx, [n])=>Math.abs(n.evaluate(ctx))
    ],
    round: [
        $ed234ca8eb1f5a84$var$NumberType,
        [
            $ed234ca8eb1f5a84$var$NumberType
        ],
        (ctx, [n])=>{
            const v = n.evaluate(ctx);
            // Javascript's Math.round() rounds towards +Infinity for halfway
            // values, even when they're negative. It's more common to round
            // away from 0 (e.g., this is what python and C++ do)
            return v < 0 ? -Math.round(-v) : Math.round(v);
        }
    ],
    floor: [
        $ed234ca8eb1f5a84$var$NumberType,
        [
            $ed234ca8eb1f5a84$var$NumberType
        ],
        (ctx, [n])=>Math.floor(n.evaluate(ctx))
    ],
    ceil: [
        $ed234ca8eb1f5a84$var$NumberType,
        [
            $ed234ca8eb1f5a84$var$NumberType
        ],
        (ctx, [n])=>Math.ceil(n.evaluate(ctx))
    ],
    'filter-==': [
        $ed234ca8eb1f5a84$var$BooleanType,
        [
            $ed234ca8eb1f5a84$var$StringType,
            $ed234ca8eb1f5a84$var$ValueType
        ],
        (ctx, [k, v])=>ctx.properties()[k.value] === v.value
    ],
    'filter-id-==': [
        $ed234ca8eb1f5a84$var$BooleanType,
        [
            $ed234ca8eb1f5a84$var$ValueType
        ],
        (ctx, [v])=>ctx.id() === v.value
    ],
    'filter-type-==': [
        $ed234ca8eb1f5a84$var$BooleanType,
        [
            $ed234ca8eb1f5a84$var$StringType
        ],
        (ctx, [v])=>ctx.geometryType() === v.value
    ],
    'filter-<': [
        $ed234ca8eb1f5a84$var$BooleanType,
        [
            $ed234ca8eb1f5a84$var$StringType,
            $ed234ca8eb1f5a84$var$ValueType
        ],
        (ctx, [k, v])=>{
            const a = ctx.properties()[k.value];
            const b = v.value;
            return typeof a === typeof b && a < b;
        }
    ],
    'filter-id-<': [
        $ed234ca8eb1f5a84$var$BooleanType,
        [
            $ed234ca8eb1f5a84$var$ValueType
        ],
        (ctx, [v])=>{
            const a = ctx.id();
            const b = v.value;
            return typeof a === typeof b && a < b;
        }
    ],
    'filter->': [
        $ed234ca8eb1f5a84$var$BooleanType,
        [
            $ed234ca8eb1f5a84$var$StringType,
            $ed234ca8eb1f5a84$var$ValueType
        ],
        (ctx, [k, v])=>{
            const a = ctx.properties()[k.value];
            const b = v.value;
            return typeof a === typeof b && a > b;
        }
    ],
    'filter-id->': [
        $ed234ca8eb1f5a84$var$BooleanType,
        [
            $ed234ca8eb1f5a84$var$ValueType
        ],
        (ctx, [v])=>{
            const a = ctx.id();
            const b = v.value;
            return typeof a === typeof b && a > b;
        }
    ],
    'filter-<=': [
        $ed234ca8eb1f5a84$var$BooleanType,
        [
            $ed234ca8eb1f5a84$var$StringType,
            $ed234ca8eb1f5a84$var$ValueType
        ],
        (ctx, [k, v])=>{
            const a = ctx.properties()[k.value];
            const b = v.value;
            return typeof a === typeof b && a <= b;
        }
    ],
    'filter-id-<=': [
        $ed234ca8eb1f5a84$var$BooleanType,
        [
            $ed234ca8eb1f5a84$var$ValueType
        ],
        (ctx, [v])=>{
            const a = ctx.id();
            const b = v.value;
            return typeof a === typeof b && a <= b;
        }
    ],
    'filter->=': [
        $ed234ca8eb1f5a84$var$BooleanType,
        [
            $ed234ca8eb1f5a84$var$StringType,
            $ed234ca8eb1f5a84$var$ValueType
        ],
        (ctx, [k, v])=>{
            const a = ctx.properties()[k.value];
            const b = v.value;
            return typeof a === typeof b && a >= b;
        }
    ],
    'filter-id->=': [
        $ed234ca8eb1f5a84$var$BooleanType,
        [
            $ed234ca8eb1f5a84$var$ValueType
        ],
        (ctx, [v])=>{
            const a = ctx.id();
            const b = v.value;
            return typeof a === typeof b && a >= b;
        }
    ],
    'filter-has': [
        $ed234ca8eb1f5a84$var$BooleanType,
        [
            $ed234ca8eb1f5a84$var$ValueType
        ],
        (ctx, [k])=>k.value in ctx.properties()
    ],
    'filter-has-id': [
        $ed234ca8eb1f5a84$var$BooleanType,
        [],
        (ctx)=>ctx.id() !== null && ctx.id() !== undefined
    ],
    'filter-type-in': [
        $ed234ca8eb1f5a84$var$BooleanType,
        [
            $ed234ca8eb1f5a84$var$array($ed234ca8eb1f5a84$var$StringType)
        ],
        (ctx, [v])=>v.value.indexOf(ctx.geometryType()) >= 0
    ],
    'filter-id-in': [
        $ed234ca8eb1f5a84$var$BooleanType,
        [
            $ed234ca8eb1f5a84$var$array($ed234ca8eb1f5a84$var$ValueType)
        ],
        (ctx, [v])=>v.value.indexOf(ctx.id()) >= 0
    ],
    'filter-in-small': [
        $ed234ca8eb1f5a84$var$BooleanType,
        [
            $ed234ca8eb1f5a84$var$StringType,
            $ed234ca8eb1f5a84$var$array($ed234ca8eb1f5a84$var$ValueType)
        ],
        // assumes v is an array literal
        (ctx, [k, v])=>v.value.indexOf(ctx.properties()[k.value]) >= 0
    ],
    'filter-in-large': [
        $ed234ca8eb1f5a84$var$BooleanType,
        [
            $ed234ca8eb1f5a84$var$StringType,
            $ed234ca8eb1f5a84$var$array($ed234ca8eb1f5a84$var$ValueType)
        ],
        // assumes v is a array literal with values sorted in ascending order and of a single type
        (ctx, [k, v])=>$ed234ca8eb1f5a84$var$binarySearch(ctx.properties()[k.value], v.value, 0, v.value.length - 1)
    ],
    all: {
        type: $ed234ca8eb1f5a84$var$BooleanType,
        overloads: [
            [
                [
                    $ed234ca8eb1f5a84$var$BooleanType,
                    $ed234ca8eb1f5a84$var$BooleanType
                ],
                (ctx, [a, b])=>a.evaluate(ctx) && b.evaluate(ctx)
            ],
            [
                $ed234ca8eb1f5a84$var$varargs($ed234ca8eb1f5a84$var$BooleanType),
                (ctx, args)=>{
                    for (const arg of args){
                        if (!arg.evaluate(ctx)) return false;
                    }
                    return true;
                }
            ]
        ]
    },
    any: {
        type: $ed234ca8eb1f5a84$var$BooleanType,
        overloads: [
            [
                [
                    $ed234ca8eb1f5a84$var$BooleanType,
                    $ed234ca8eb1f5a84$var$BooleanType
                ],
                (ctx, [a, b])=>a.evaluate(ctx) || b.evaluate(ctx)
            ],
            [
                $ed234ca8eb1f5a84$var$varargs($ed234ca8eb1f5a84$var$BooleanType),
                (ctx, args)=>{
                    for (const arg of args){
                        if (arg.evaluate(ctx)) return true;
                    }
                    return false;
                }
            ]
        ]
    },
    '!': [
        $ed234ca8eb1f5a84$var$BooleanType,
        [
            $ed234ca8eb1f5a84$var$BooleanType
        ],
        (ctx, [b])=>!b.evaluate(ctx)
    ],
    'is-supported-script': [
        $ed234ca8eb1f5a84$var$BooleanType,
        [
            $ed234ca8eb1f5a84$var$StringType
        ],
        // At parse time this will always return true, so we need to exclude this expression with isGlobalPropertyConstant
        (ctx, [s])=>{
            const isSupportedScript = ctx.globals && ctx.globals.isSupportedScript;
            if (isSupportedScript) return isSupportedScript(s.evaluate(ctx));
            return true;
        }
    ],
    upcase: [
        $ed234ca8eb1f5a84$var$StringType,
        [
            $ed234ca8eb1f5a84$var$StringType
        ],
        (ctx, [s])=>s.evaluate(ctx).toUpperCase()
    ],
    downcase: [
        $ed234ca8eb1f5a84$var$StringType,
        [
            $ed234ca8eb1f5a84$var$StringType
        ],
        (ctx, [s])=>s.evaluate(ctx).toLowerCase()
    ],
    concat: [
        $ed234ca8eb1f5a84$var$StringType,
        $ed234ca8eb1f5a84$var$varargs($ed234ca8eb1f5a84$var$ValueType),
        (ctx, args)=>args.map((arg)=>$ed234ca8eb1f5a84$var$valueToString(arg.evaluate(ctx))).join('')
    ],
    split: [
        $ed234ca8eb1f5a84$var$array($ed234ca8eb1f5a84$var$StringType),
        [
            $ed234ca8eb1f5a84$var$StringType,
            $ed234ca8eb1f5a84$var$StringType
        ],
        (ctx, [s, delim])=>s.evaluate(ctx).split(delim.evaluate(ctx))
    ],
    join: [
        $ed234ca8eb1f5a84$var$StringType,
        [
            $ed234ca8eb1f5a84$var$array($ed234ca8eb1f5a84$var$StringType),
            $ed234ca8eb1f5a84$var$StringType
        ],
        (ctx, [arr, delim])=>arr.evaluate(ctx).join(delim.evaluate(ctx))
    ],
    'resolved-locale': [
        $ed234ca8eb1f5a84$var$StringType,
        [
            $ed234ca8eb1f5a84$var$CollatorType
        ],
        (ctx, [collator])=>collator.evaluate(ctx).resolvedLocale()
    ]
});
function $ed234ca8eb1f5a84$var$stringifySignature(signature) {
    if (Array.isArray(signature)) return `(${signature.map($ed234ca8eb1f5a84$export$f84e8e69fd4488a5).join(', ')})`;
    else return `(${$ed234ca8eb1f5a84$export$f84e8e69fd4488a5(signature.type)}...)`;
}
function $ed234ca8eb1f5a84$var$isExpressionConstant(expression) {
    if (expression instanceof $ed234ca8eb1f5a84$var$Var) return $ed234ca8eb1f5a84$var$isExpressionConstant(expression.boundExpression);
    else if (expression instanceof $ed234ca8eb1f5a84$export$a766a6736ff5bbbf && expression.name === 'error') return false;
    else if (expression instanceof $ed234ca8eb1f5a84$var$CollatorExpression) // Although the results of a Collator expression with fixed arguments
    // generally shouldn't change between executions, we can't serialize them
    // as constant expressions because results change based on environment.
    return false;
    else if (expression instanceof $ed234ca8eb1f5a84$var$Within) return false;
    else if (expression instanceof $ed234ca8eb1f5a84$var$Distance) return false;
    else if (expression instanceof $ed234ca8eb1f5a84$var$GlobalState) return false;
    const isTypeAnnotation = expression instanceof $ed234ca8eb1f5a84$var$Coercion || expression instanceof $ed234ca8eb1f5a84$var$Assertion;
    let childrenConstant = true;
    expression.eachChild((child)=>{
        // We can _almost_ assume that if `expressions` children are constant,
        // they would already have been evaluated to Literal values when they
        // were parsed.  Type annotations are the exception, because they might
        // have been inferred and added after a child was parsed.
        // So we recurse into isConstant() for the children of type annotations,
        // but otherwise simply check whether they are Literals.
        if (isTypeAnnotation) childrenConstant = childrenConstant && $ed234ca8eb1f5a84$var$isExpressionConstant(child);
        else childrenConstant = childrenConstant && child instanceof $ed234ca8eb1f5a84$export$e175ae9e414693bc;
    });
    if (!childrenConstant) return false;
    return $ed234ca8eb1f5a84$var$isFeatureConstant(expression) && $ed234ca8eb1f5a84$var$isGlobalPropertyConstant(expression, [
        'zoom',
        'heatmap-density',
        'elevation',
        'line-progress',
        'accumulated',
        'is-supported-script'
    ]);
}
function $ed234ca8eb1f5a84$var$isFeatureConstant(e) {
    if (e instanceof $ed234ca8eb1f5a84$export$a766a6736ff5bbbf) {
        if (e.name === 'get' && e.args.length === 1) return false;
        else if (e.name === 'feature-state') return false;
        else if (e.name === 'has' && e.args.length === 1) return false;
        else if (e.name === 'properties' || e.name === 'geometry-type' || e.name === 'id') return false;
        else if (/^filter-/.test(e.name)) return false;
    }
    if (e instanceof $ed234ca8eb1f5a84$var$Within) return false;
    if (e instanceof $ed234ca8eb1f5a84$var$Distance) return false;
    let result = true;
    e.eachChild((arg)=>{
        if (result && !$ed234ca8eb1f5a84$var$isFeatureConstant(arg)) result = false;
    });
    return result;
}
function $ed234ca8eb1f5a84$var$isStateConstant(e) {
    if (e instanceof $ed234ca8eb1f5a84$export$a766a6736ff5bbbf) {
        if (e.name === 'feature-state') return false;
    }
    let result = true;
    e.eachChild((arg)=>{
        if (result && !$ed234ca8eb1f5a84$var$isStateConstant(arg)) result = false;
    });
    return result;
}
function $ed234ca8eb1f5a84$var$isGlobalPropertyConstant(e, properties) {
    if (e instanceof $ed234ca8eb1f5a84$export$a766a6736ff5bbbf && properties.indexOf(e.name) >= 0) return false;
    let result = true;
    e.eachChild((arg)=>{
        if (result && !$ed234ca8eb1f5a84$var$isGlobalPropertyConstant(arg, properties)) result = false;
    });
    return result;
}
function $ed234ca8eb1f5a84$var$success(value) {
    return {
        result: 'success',
        value: value
    };
}
function $ed234ca8eb1f5a84$var$error(value) {
    return {
        result: 'error',
        value: value
    };
}
function $ed234ca8eb1f5a84$export$80ae86acfd45595c(spec) {
    return spec['property-type'] === 'data-driven' || spec['property-type'] === 'cross-faded-data-driven';
}
function $ed234ca8eb1f5a84$var$supportsZoomExpression(spec) {
    return !!spec.expression && spec.expression.parameters.indexOf('zoom') > -1;
}
function $ed234ca8eb1f5a84$var$supportsInterpolation(spec) {
    return !!spec.expression && spec.expression.interpolated;
}
function $ed234ca8eb1f5a84$var$getType(val) {
    if (val instanceof Number) return 'number';
    else if (val instanceof String) return 'string';
    else if (val instanceof Boolean) return 'boolean';
    else if (Array.isArray(val)) return 'array';
    else if (val === null) return 'null';
    else return typeof val;
}
function $ed234ca8eb1f5a84$export$f6e2535fb5126e54(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value) && $ed234ca8eb1f5a84$export$f5bbd400c2f4426f(value) === $ed234ca8eb1f5a84$var$ObjectType;
}
function $ed234ca8eb1f5a84$var$identityFunction(x) {
    return x;
}
function $ed234ca8eb1f5a84$var$getParseFunction(propertySpec) {
    switch(propertySpec.type){
        case 'color':
            return $ed234ca8eb1f5a84$export$892596cec99bc70e.parse;
        case 'padding':
            return $ed234ca8eb1f5a84$export$8ee6ea94b5aedb49.parse;
        case 'numberArray':
            return $ed234ca8eb1f5a84$export$70583a403f005a99.parse;
        case 'colorArray':
            return $ed234ca8eb1f5a84$export$afb89052b482fa15.parse;
        default:
            return null;
    }
}
function $ed234ca8eb1f5a84$var$getInnerFunction(type) {
    switch(type){
        case 'exponential':
            return $ed234ca8eb1f5a84$var$evaluateExponentialFunction;
        case 'interval':
            return $ed234ca8eb1f5a84$var$evaluateIntervalFunction;
        case 'categorical':
            return $ed234ca8eb1f5a84$var$evaluateCategoricalFunction;
        case 'identity':
            return $ed234ca8eb1f5a84$var$evaluateIdentityFunction;
        default:
            throw new Error(`Unknown function type "${type}"`);
    }
}
function $ed234ca8eb1f5a84$export$74ab6113d805deb(parameters, propertySpec) {
    const zoomAndFeatureDependent = parameters.stops && typeof parameters.stops[0][0] === 'object';
    const featureDependent = zoomAndFeatureDependent || parameters.property !== undefined;
    const zoomDependent = zoomAndFeatureDependent || !featureDependent;
    const type = parameters.type || ($ed234ca8eb1f5a84$var$supportsInterpolation(propertySpec) ? 'exponential' : 'interval');
    const parseFn = $ed234ca8eb1f5a84$var$getParseFunction(propertySpec);
    if (parseFn) {
        parameters = $ed234ca8eb1f5a84$var$extendBy({}, parameters);
        if (parameters.stops) parameters.stops = parameters.stops.map((stop)=>{
            return [
                stop[0],
                parseFn(stop[1])
            ];
        });
        if (parameters.default) parameters.default = parseFn(parameters.default);
        else parameters.default = parseFn(propertySpec.default);
    }
    if (parameters.colorSpace && !$ed234ca8eb1f5a84$var$isSupportedInterpolationColorSpace(parameters.colorSpace)) throw new Error(`Unknown color space: "${parameters.colorSpace}"`);
    const innerFun = $ed234ca8eb1f5a84$var$getInnerFunction(type);
    let hashedStops;
    let categoricalKeyType;
    if (type === 'categorical') {
        // For categorical functions, generate an Object as a hashmap of the stops for fast searching
        hashedStops = Object.create(null);
        for (const stop of parameters.stops)hashedStops[stop[0]] = stop[1];
        // Infer key type based on first stop key-- used to encforce strict type checking later
        categoricalKeyType = typeof parameters.stops[0][0];
    }
    if (zoomAndFeatureDependent) {
        const featureFunctions = {};
        const zoomStops = [];
        for(let s = 0; s < parameters.stops.length; s++){
            const stop = parameters.stops[s];
            const zoom = stop[0].zoom;
            if (featureFunctions[zoom] === undefined) {
                featureFunctions[zoom] = {
                    zoom: zoom,
                    type: parameters.type,
                    property: parameters.property,
                    default: parameters.default,
                    stops: []
                };
                zoomStops.push(zoom);
            }
            featureFunctions[zoom].stops.push([
                stop[0].value,
                stop[1]
            ]);
        }
        const featureFunctionStops = [];
        for (const z of zoomStops)featureFunctionStops.push([
            featureFunctions[z].zoom,
            $ed234ca8eb1f5a84$export$74ab6113d805deb(featureFunctions[z], propertySpec)
        ]);
        const interpolationType = {
            name: 'linear'
        };
        return {
            kind: 'composite',
            interpolationType: interpolationType,
            interpolationFactor: $ed234ca8eb1f5a84$export$6bb252fbb1a22840.interpolationFactor.bind(undefined, interpolationType),
            zoomStops: featureFunctionStops.map((s)=>s[0]),
            evaluate ({ zoom: zoom }, properties) {
                return $ed234ca8eb1f5a84$var$evaluateExponentialFunction({
                    stops: featureFunctionStops,
                    base: parameters.base
                }, propertySpec, zoom).evaluate(zoom, properties);
            }
        };
    } else if (zoomDependent) {
        const interpolationType = type === 'exponential' ? {
            name: 'exponential',
            base: parameters.base !== undefined ? parameters.base : 1
        } : null;
        return {
            kind: 'camera',
            interpolationType: interpolationType,
            interpolationFactor: $ed234ca8eb1f5a84$export$6bb252fbb1a22840.interpolationFactor.bind(undefined, interpolationType),
            zoomStops: parameters.stops.map((s)=>s[0]),
            evaluate: ({ zoom: zoom })=>innerFun(parameters, propertySpec, zoom, hashedStops, categoricalKeyType)
        };
    } else return {
        kind: 'source',
        evaluate (_, feature) {
            const value = feature && feature.properties ? feature.properties[parameters.property] : undefined;
            if (value === undefined) return $ed234ca8eb1f5a84$var$coalesce$1(parameters.default, propertySpec.default);
            return innerFun(parameters, propertySpec, value, hashedStops, categoricalKeyType);
        }
    };
}
function $ed234ca8eb1f5a84$var$coalesce$1(a, b, c) {
    if (a !== undefined) return a;
    if (b !== undefined) return b;
    if (c !== undefined) return c;
}
function $ed234ca8eb1f5a84$var$evaluateCategoricalFunction(parameters, propertySpec, input, hashedStops, keyType) {
    const evaluated = typeof input === keyType ? hashedStops[input] : undefined; // Enforce strict typing on input
    return $ed234ca8eb1f5a84$var$coalesce$1(evaluated, parameters.default, propertySpec.default);
}
function $ed234ca8eb1f5a84$var$evaluateIntervalFunction(parameters, propertySpec, input) {
    // Edge cases
    if ($ed234ca8eb1f5a84$var$getType(input) !== 'number') return $ed234ca8eb1f5a84$var$coalesce$1(parameters.default, propertySpec.default);
    const n = parameters.stops.length;
    if (n === 1) return parameters.stops[0][1];
    if (input <= parameters.stops[0][0]) return parameters.stops[0][1];
    if (input >= parameters.stops[n - 1][0]) return parameters.stops[n - 1][1];
    const index = $ed234ca8eb1f5a84$var$findStopLessThanOrEqualTo(parameters.stops.map((stop)=>stop[0]), input);
    return parameters.stops[index][1];
}
function $ed234ca8eb1f5a84$var$evaluateExponentialFunction(parameters, propertySpec, input) {
    const base = parameters.base !== undefined ? parameters.base : 1;
    // Edge cases
    if ($ed234ca8eb1f5a84$var$getType(input) !== 'number') return $ed234ca8eb1f5a84$var$coalesce$1(parameters.default, propertySpec.default);
    const n = parameters.stops.length;
    if (n === 1) return parameters.stops[0][1];
    if (input <= parameters.stops[0][0]) return parameters.stops[0][1];
    if (input >= parameters.stops[n - 1][0]) return parameters.stops[n - 1][1];
    const index = $ed234ca8eb1f5a84$var$findStopLessThanOrEqualTo(parameters.stops.map((stop)=>stop[0]), input);
    const t = $ed234ca8eb1f5a84$var$interpolationFactor(input, base, parameters.stops[index][0], parameters.stops[index + 1][0]);
    const outputLower = parameters.stops[index][1];
    const outputUpper = parameters.stops[index + 1][1];
    const interp = $ed234ca8eb1f5a84$export$c8fa6e0ca2f32cbf[propertySpec.type] || $ed234ca8eb1f5a84$var$identityFunction;
    if (typeof outputLower.evaluate === 'function') return {
        evaluate (...args) {
            const evaluatedLower = outputLower.evaluate.apply(undefined, args);
            const evaluatedUpper = outputUpper.evaluate.apply(undefined, args);
            // Special case for fill-outline-color, which has no spec default.
            if (evaluatedLower === undefined || evaluatedUpper === undefined) return undefined;
            return interp(evaluatedLower, evaluatedUpper, t, parameters.colorSpace);
        }
    };
    return interp(outputLower, outputUpper, t, parameters.colorSpace);
}
function $ed234ca8eb1f5a84$var$evaluateIdentityFunction(parameters, propertySpec, input) {
    switch(propertySpec.type){
        case 'color':
            input = $ed234ca8eb1f5a84$export$892596cec99bc70e.parse(input);
            break;
        case 'formatted':
            input = $ed234ca8eb1f5a84$export$4eb8fc242550f5dd.fromString(input.toString());
            break;
        case 'resolvedImage':
            input = $ed234ca8eb1f5a84$export$8511b53abdedaff9.fromString(input.toString());
            break;
        case 'padding':
            input = $ed234ca8eb1f5a84$export$8ee6ea94b5aedb49.parse(input);
            break;
        case 'colorArray':
            input = $ed234ca8eb1f5a84$export$afb89052b482fa15.parse(input);
            break;
        case 'numberArray':
            input = $ed234ca8eb1f5a84$export$70583a403f005a99.parse(input);
            break;
        default:
            if ($ed234ca8eb1f5a84$var$getType(input) !== propertySpec.type && (propertySpec.type !== 'enum' || !propertySpec.values[input])) input = undefined;
    }
    return $ed234ca8eb1f5a84$var$coalesce$1(input, parameters.default, propertySpec.default);
}
/**
 * Returns a ratio that can be used to interpolate between exponential function
 * stops.
 *
 * How it works:
 * Two consecutive stop values define a (scaled and shifted) exponential
 * function `f(x) = a * base^x + b`, where `base` is the user-specified base,
 * and `a` and `b` are constants affording sufficient degrees of freedom to fit
 * the function to the given stops.
 *
 * Here's a bit of algebra that lets us compute `f(x)` directly from the stop
 * values without explicitly solving for `a` and `b`:
 *
 * First stop value: `f(x0) = y0 = a * base^x0 + b`
 * Second stop value: `f(x1) = y1 = a * base^x1 + b`
 * => `y1 - y0 = a(base^x1 - base^x0)`
 * => `a = (y1 - y0)/(base^x1 - base^x0)`
 *
 * Desired value: `f(x) = y = a * base^x + b`
 * => `f(x) = y0 + a * (base^x - base^x0)`
 *
 * From the above, we can replace the `a` in `a * (base^x - base^x0)` and do a
 * little algebra:
 * ```
 * a * (base^x - base^x0) = (y1 - y0)/(base^x1 - base^x0) * (base^x - base^x0)
 *                     = (y1 - y0) * (base^x - base^x0) / (base^x1 - base^x0)
 * ```
 *
 * If we let `(base^x - base^x0) / (base^x1 base^x0)`, then we have
 * `f(x) = y0 + (y1 - y0) * ratio`.  In other words, `ratio` may be treated as
 * an interpolation factor between the two stops' output values.
 *
 * (Note: a slightly different form for `ratio`,
 * `(base^(x-x0) - 1) / (base^(x1-x0) - 1) `, is equivalent, but requires fewer
 * expensive `Math.pow()` operations.)
 *
 * @private
 */ function $ed234ca8eb1f5a84$var$interpolationFactor(input, base, lowerValue, upperValue) {
    const difference = upperValue - lowerValue;
    const progress = input - lowerValue;
    if (difference === 0) return 0;
    else if (base === 1) return progress / difference;
    else return (Math.pow(base, progress) - 1) / (Math.pow(base, difference) - 1);
}
class $ed234ca8eb1f5a84$export$cc950d8c87493baa {
    constructor(expression, propertySpec, globalState){
        this.expression = expression;
        this._warningHistory = {};
        this._evaluator = new $ed234ca8eb1f5a84$export$37230f824444580();
        this._defaultValue = propertySpec ? $ed234ca8eb1f5a84$var$getDefaultValue(propertySpec) : null;
        this._enumValues = propertySpec && propertySpec.type === 'enum' ? propertySpec.values : null;
        this._globalState = globalState;
    }
    evaluateWithoutErrorHandling(globals, feature, featureState, canonical, availableImages, formattedSection) {
        if (this._globalState) globals = $ed234ca8eb1f5a84$var$addGlobalState(globals, this._globalState);
        this._evaluator.globals = globals;
        this._evaluator.feature = feature;
        this._evaluator.featureState = featureState;
        this._evaluator.canonical = canonical;
        this._evaluator.availableImages = availableImages || null;
        this._evaluator.formattedSection = formattedSection;
        return this.expression.evaluate(this._evaluator);
    }
    evaluate(globals, feature, featureState, canonical, availableImages, formattedSection) {
        if (this._globalState) globals = $ed234ca8eb1f5a84$var$addGlobalState(globals, this._globalState);
        this._evaluator.globals = globals;
        this._evaluator.feature = feature || null;
        this._evaluator.featureState = featureState || null;
        this._evaluator.canonical = canonical;
        this._evaluator.availableImages = availableImages || null;
        this._evaluator.formattedSection = formattedSection || null;
        try {
            const val = this.expression.evaluate(this._evaluator);
            if (val === null || val === undefined || typeof val === 'number' && val !== val) return this._defaultValue;
            if (this._enumValues && !(val in this._enumValues)) throw new $ed234ca8eb1f5a84$var$RuntimeError(`Expected value to be one of ${Object.keys(this._enumValues).map((v)=>JSON.stringify(v)).join(', ')}, but found ${JSON.stringify(val)} instead.`);
            return val;
        } catch (e) {
            if (!this._warningHistory[e.message]) {
                this._warningHistory[e.message] = true;
                if (typeof console !== 'undefined') console.warn(e.message);
            }
            return this._defaultValue;
        }
    }
}
function $ed234ca8eb1f5a84$export$3827579d8e65d9ac(expression) {
    return Array.isArray(expression) && expression.length > 0 && typeof expression[0] === 'string' && expression[0] in $ed234ca8eb1f5a84$export$f55ecc93729893d7;
}
/**
 * Parse and typecheck the given style spec JSON expression.  If
 * options.defaultValue is provided, then the resulting StyleExpression's
 * `evaluate()` method will handle errors by logging a warning (once per
 * message) and returning the default value.  Otherwise, it will throw
 * evaluation errors.
 *
 * @private
 */ function $ed234ca8eb1f5a84$export$e2f07551fdfaf6b7(expression, propertySpec, globalState) {
    const parser = new $ed234ca8eb1f5a84$var$ParsingContext($ed234ca8eb1f5a84$export$f55ecc93729893d7, $ed234ca8eb1f5a84$var$isExpressionConstant, [], propertySpec ? $ed234ca8eb1f5a84$var$getExpectedType(propertySpec) : undefined);
    // For string-valued properties, coerce to string at the top level rather than asserting.
    const parsed = parser.parse(expression, undefined, undefined, undefined, propertySpec && propertySpec.type === 'string' ? {
        typeAnnotation: 'coerce'
    } : undefined);
    if (!parsed) return $ed234ca8eb1f5a84$var$error(parser.errors);
    return $ed234ca8eb1f5a84$var$success(new $ed234ca8eb1f5a84$export$cc950d8c87493baa(parsed, propertySpec, globalState));
}
class $ed234ca8eb1f5a84$export$75c155ef6e139073 {
    constructor(kind, expression, globalState){
        this.kind = kind;
        this._styleExpression = expression;
        this.isStateDependent = kind !== 'constant' && !$ed234ca8eb1f5a84$var$isStateConstant(expression.expression);
        this.globalStateRefs = $ed234ca8eb1f5a84$var$findGlobalStateRefs(expression.expression);
        this._globalState = globalState;
    }
    evaluateWithoutErrorHandling(globals, feature, featureState, canonical, availableImages, formattedSection) {
        if (this._globalState) globals = $ed234ca8eb1f5a84$var$addGlobalState(globals, this._globalState);
        return this._styleExpression.evaluateWithoutErrorHandling(globals, feature, featureState, canonical, availableImages, formattedSection);
    }
    evaluate(globals, feature, featureState, canonical, availableImages, formattedSection) {
        if (this._globalState) globals = $ed234ca8eb1f5a84$var$addGlobalState(globals, this._globalState);
        return this._styleExpression.evaluate(globals, feature, featureState, canonical, availableImages, formattedSection);
    }
}
class $ed234ca8eb1f5a84$export$2b27898b9034955 {
    constructor(kind, expression, zoomStops, interpolationType, globalState){
        this.kind = kind;
        this.zoomStops = zoomStops;
        this._styleExpression = expression;
        this.isStateDependent = kind !== 'camera' && !$ed234ca8eb1f5a84$var$isStateConstant(expression.expression);
        this.globalStateRefs = $ed234ca8eb1f5a84$var$findGlobalStateRefs(expression.expression);
        this.interpolationType = interpolationType;
        this._globalState = globalState;
    }
    evaluateWithoutErrorHandling(globals, feature, featureState, canonical, availableImages, formattedSection) {
        if (this._globalState) globals = $ed234ca8eb1f5a84$var$addGlobalState(globals, this._globalState);
        return this._styleExpression.evaluateWithoutErrorHandling(globals, feature, featureState, canonical, availableImages, formattedSection);
    }
    evaluate(globals, feature, featureState, canonical, availableImages, formattedSection) {
        if (this._globalState) globals = $ed234ca8eb1f5a84$var$addGlobalState(globals, this._globalState);
        return this._styleExpression.evaluate(globals, feature, featureState, canonical, availableImages, formattedSection);
    }
    interpolationFactor(input, lower, upper) {
        if (this.interpolationType) return $ed234ca8eb1f5a84$export$6bb252fbb1a22840.interpolationFactor(this.interpolationType, input, lower, upper);
        else return 0;
    }
}
function $ed234ca8eb1f5a84$export$6f0fad737814f2a3(expression) {
    return expression._styleExpression !== undefined;
}
function $ed234ca8eb1f5a84$export$64925a39029a32a(expressionInput, propertySpec, globalState) {
    const expression = $ed234ca8eb1f5a84$export$e2f07551fdfaf6b7(expressionInput, propertySpec, globalState);
    if (expression.result === 'error') return expression;
    const parsed = expression.value.expression;
    const isFeatureConstantResult = $ed234ca8eb1f5a84$var$isFeatureConstant(parsed);
    if (!isFeatureConstantResult && !$ed234ca8eb1f5a84$export$80ae86acfd45595c(propertySpec)) return $ed234ca8eb1f5a84$var$error([
        new $ed234ca8eb1f5a84$var$ExpressionParsingError('', 'data expressions not supported')
    ]);
    const isZoomConstant = $ed234ca8eb1f5a84$var$isGlobalPropertyConstant(parsed, [
        'zoom'
    ]);
    if (!isZoomConstant && !$ed234ca8eb1f5a84$var$supportsZoomExpression(propertySpec)) return $ed234ca8eb1f5a84$var$error([
        new $ed234ca8eb1f5a84$var$ExpressionParsingError('', 'zoom expressions not supported')
    ]);
    const zoomCurve = $ed234ca8eb1f5a84$var$findZoomCurve(parsed);
    if (!zoomCurve && !isZoomConstant) return $ed234ca8eb1f5a84$var$error([
        new $ed234ca8eb1f5a84$var$ExpressionParsingError('', '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')
    ]);
    else if (zoomCurve instanceof $ed234ca8eb1f5a84$var$ExpressionParsingError) return $ed234ca8eb1f5a84$var$error([
        zoomCurve
    ]);
    else if (zoomCurve instanceof $ed234ca8eb1f5a84$export$6bb252fbb1a22840 && !$ed234ca8eb1f5a84$var$supportsInterpolation(propertySpec)) return $ed234ca8eb1f5a84$var$error([
        new $ed234ca8eb1f5a84$var$ExpressionParsingError('', '"interpolate" expressions cannot be used with this property')
    ]);
    if (!zoomCurve) return $ed234ca8eb1f5a84$var$success(isFeatureConstantResult ? new $ed234ca8eb1f5a84$export$75c155ef6e139073('constant', expression.value, globalState) : new $ed234ca8eb1f5a84$export$75c155ef6e139073('source', expression.value, globalState));
    const interpolationType = zoomCurve instanceof $ed234ca8eb1f5a84$export$6bb252fbb1a22840 ? zoomCurve.interpolation : undefined;
    return $ed234ca8eb1f5a84$var$success(isFeatureConstantResult ? new $ed234ca8eb1f5a84$export$2b27898b9034955('camera', expression.value, zoomCurve.labels, interpolationType, globalState) : new $ed234ca8eb1f5a84$export$2b27898b9034955('composite', expression.value, zoomCurve.labels, interpolationType, globalState));
}
// serialization wrapper for old-style stop functions normalized to the
// expression interface
class $ed234ca8eb1f5a84$export$c9163cfd00403256 {
    constructor(parameters, specification){
        this._parameters = parameters;
        this._specification = specification;
        $ed234ca8eb1f5a84$var$extendBy(this, $ed234ca8eb1f5a84$export$74ab6113d805deb(this._parameters, this._specification));
    }
    static deserialize(serialized) {
        return new $ed234ca8eb1f5a84$export$c9163cfd00403256(serialized._parameters, serialized._specification);
    }
    static serialize(input) {
        return {
            _parameters: input._parameters,
            _specification: input._specification
        };
    }
}
function $ed234ca8eb1f5a84$export$b2ea9b0a6124ba04(value, specification, globalState) {
    if ($ed234ca8eb1f5a84$export$f6e2535fb5126e54(value)) return new $ed234ca8eb1f5a84$export$c9163cfd00403256(value, specification);
    else if ($ed234ca8eb1f5a84$export$3827579d8e65d9ac(value)) {
        const expression = $ed234ca8eb1f5a84$export$64925a39029a32a(value, specification, globalState);
        if (expression.result === 'error') // this should have been caught in validation
        throw new Error(expression.value.map((err)=>`${err.key}: ${err.message}`).join(', '));
        return expression.value;
    } else {
        let constant = value;
        if (specification.type === 'color' && typeof value === 'string') constant = $ed234ca8eb1f5a84$export$892596cec99bc70e.parse(value);
        else if (specification.type === 'padding' && (typeof value === 'number' || Array.isArray(value))) constant = $ed234ca8eb1f5a84$export$8ee6ea94b5aedb49.parse(value);
        else if (specification.type === 'numberArray' && (typeof value === 'number' || Array.isArray(value))) constant = $ed234ca8eb1f5a84$export$70583a403f005a99.parse(value);
        else if (specification.type === 'colorArray' && (typeof value === 'string' || Array.isArray(value))) constant = $ed234ca8eb1f5a84$export$afb89052b482fa15.parse(value);
        else if (specification.type === 'variableAnchorOffsetCollection' && Array.isArray(value)) constant = $ed234ca8eb1f5a84$export$4fdfd474f5d53309.parse(value);
        else if (specification.type === 'projectionDefinition' && typeof value === 'string') constant = $ed234ca8eb1f5a84$export$95891bdb6f673ac1.parse(value);
        return {
            globalStateRefs: new Set(),
            _globalState: null,
            kind: 'constant',
            evaluate: ()=>constant
        };
    }
}
// Zoom-dependent expressions may only use ["zoom"] as the input to a top-level "step" or "interpolate"
// expression (collectively referred to as a "curve"). The curve may be wrapped in one or more "let" or
// "coalesce" expressions.
function $ed234ca8eb1f5a84$var$findZoomCurve(expression) {
    let result = null;
    if (expression instanceof $ed234ca8eb1f5a84$var$Let) result = $ed234ca8eb1f5a84$var$findZoomCurve(expression.result);
    else if (expression instanceof $ed234ca8eb1f5a84$var$Coalesce) for (const arg of expression.args){
        result = $ed234ca8eb1f5a84$var$findZoomCurve(arg);
        if (result) break;
    }
    else if ((expression instanceof $ed234ca8eb1f5a84$export$fd55ce593607084a || expression instanceof $ed234ca8eb1f5a84$export$6bb252fbb1a22840) && expression.input instanceof $ed234ca8eb1f5a84$export$a766a6736ff5bbbf && expression.input.name === 'zoom') result = expression;
    if (result instanceof $ed234ca8eb1f5a84$var$ExpressionParsingError) return result;
    expression.eachChild((child)=>{
        const childResult = $ed234ca8eb1f5a84$var$findZoomCurve(child);
        if (childResult instanceof $ed234ca8eb1f5a84$var$ExpressionParsingError) result = childResult;
        else if (!result && childResult) result = new $ed234ca8eb1f5a84$var$ExpressionParsingError('', '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.');
        else if (result && childResult && result !== childResult) result = new $ed234ca8eb1f5a84$var$ExpressionParsingError('', 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.');
    });
    return result;
}
function $ed234ca8eb1f5a84$var$findGlobalStateRefs(expression, results = new Set()) {
    if (expression instanceof $ed234ca8eb1f5a84$var$GlobalState) results.add(expression.key);
    expression.eachChild((childExpression)=>{
        $ed234ca8eb1f5a84$var$findGlobalStateRefs(childExpression, results);
    });
    return results;
}
function $ed234ca8eb1f5a84$var$getExpectedType(spec) {
    const types = {
        color: $ed234ca8eb1f5a84$export$2cd82751acc0e609,
        string: $ed234ca8eb1f5a84$var$StringType,
        number: $ed234ca8eb1f5a84$var$NumberType,
        enum: $ed234ca8eb1f5a84$var$StringType,
        boolean: $ed234ca8eb1f5a84$var$BooleanType,
        formatted: $ed234ca8eb1f5a84$export$831566e53e7565f9,
        padding: $ed234ca8eb1f5a84$var$PaddingType,
        numberArray: $ed234ca8eb1f5a84$var$NumberArrayType,
        colorArray: $ed234ca8eb1f5a84$var$ColorArrayType,
        projectionDefinition: $ed234ca8eb1f5a84$export$7ec308bb4472cd41,
        resolvedImage: $ed234ca8eb1f5a84$var$ResolvedImageType,
        variableAnchorOffsetCollection: $ed234ca8eb1f5a84$var$VariableAnchorOffsetCollectionType
    };
    if (spec.type === 'array') return $ed234ca8eb1f5a84$var$array(types[spec.value] || $ed234ca8eb1f5a84$var$ValueType, spec.length);
    return types[spec.type];
}
function $ed234ca8eb1f5a84$var$getDefaultValue(spec) {
    if (spec.type === 'color' && $ed234ca8eb1f5a84$export$f6e2535fb5126e54(spec.default)) // Special case for heatmap-color: it uses the 'default:' to define a
    // default color ramp, but createExpression expects a simple value to fall
    // back to in case of runtime errors
    return new $ed234ca8eb1f5a84$export$892596cec99bc70e(0, 0, 0, 0);
    switch(spec.type){
        case 'color':
            return $ed234ca8eb1f5a84$export$892596cec99bc70e.parse(spec.default) || null;
        case 'padding':
            return $ed234ca8eb1f5a84$export$8ee6ea94b5aedb49.parse(spec.default) || null;
        case 'numberArray':
            return $ed234ca8eb1f5a84$export$70583a403f005a99.parse(spec.default) || null;
        case 'colorArray':
            return $ed234ca8eb1f5a84$export$afb89052b482fa15.parse(spec.default) || null;
        case 'variableAnchorOffsetCollection':
            return $ed234ca8eb1f5a84$export$4fdfd474f5d53309.parse(spec.default) || null;
        case 'projectionDefinition':
            return $ed234ca8eb1f5a84$export$95891bdb6f673ac1.parse(spec.default) || null;
        default:
            return spec.default === undefined ? null : spec.default;
    }
}
function $ed234ca8eb1f5a84$var$addGlobalState(globals, globalState) {
    const { zoom: zoom, heatmapDensity: heatmapDensity, elevation: elevation, lineProgress: lineProgress, isSupportedScript: isSupportedScript, accumulated: accumulated } = globals !== null && globals !== void 0 ? globals : {};
    return {
        zoom: zoom,
        heatmapDensity: heatmapDensity,
        elevation: elevation,
        lineProgress: lineProgress,
        isSupportedScript: isSupportedScript,
        accumulated: accumulated,
        globalState: globalState
    };
}
function $ed234ca8eb1f5a84$var$isExpressionFilter(filter) {
    if (filter === true || filter === false) return true;
    if (!Array.isArray(filter) || filter.length === 0) return false;
    switch(filter[0]){
        case 'has':
            return filter.length >= 2 && filter[1] !== '$id' && filter[1] !== '$type';
        case 'in':
            return filter.length >= 3 && (typeof filter[1] !== 'string' || Array.isArray(filter[2]));
        case '!in':
        case '!has':
        case 'none':
            return false;
        case '==':
        case '!=':
        case '>':
        case '>=':
        case '<':
        case '<=':
            return filter.length !== 3 || Array.isArray(filter[1]) || Array.isArray(filter[2]);
        case 'any':
        case 'all':
            for (const f of filter.slice(1)){
                if (!$ed234ca8eb1f5a84$var$isExpressionFilter(f) && typeof f !== 'boolean') return false;
            }
            return true;
        default:
            return true;
    }
}
const $ed234ca8eb1f5a84$var$filterSpec = {
    type: 'boolean',
    default: false,
    transition: false,
    'property-type': 'data-driven',
    expression: {
        interpolated: false,
        parameters: [
            'zoom',
            'feature'
        ]
    }
};
/**
 * Given a filter expressed as nested arrays, return a new function
 * that evaluates whether a given feature (with a .properties or .tags property)
 * passes its test.
 *
 * @private
 * @param filter MapLibre filter
 * @param [globalState] Global state object to be used for evaluating 'global-state' expressions
 * @returns filter-evaluating function
 */ function $ed234ca8eb1f5a84$export$51cc184a952b52db(filter, globalState) {
    if (filter === null || filter === undefined) return {
        filter: ()=>true,
        needGeometry: false,
        getGlobalStateRefs: ()=>new Set()
    };
    if (!$ed234ca8eb1f5a84$var$isExpressionFilter(filter)) filter = $ed234ca8eb1f5a84$var$convertFilter$1(filter);
    const compiled = $ed234ca8eb1f5a84$export$e2f07551fdfaf6b7(filter, $ed234ca8eb1f5a84$var$filterSpec, globalState);
    if (compiled.result === 'error') throw new Error(compiled.value.map((err)=>`${err.key}: ${err.message}`).join(', '));
    else {
        const needGeometry = $ed234ca8eb1f5a84$var$geometryNeeded(filter);
        return {
            filter: (globalProperties, feature, canonical)=>compiled.value.evaluate(globalProperties, feature, {}, canonical),
            needGeometry: needGeometry,
            getGlobalStateRefs: ()=>$ed234ca8eb1f5a84$var$findGlobalStateRefs(compiled.value.expression)
        };
    }
}
// Comparison function to sort numbers and strings
function $ed234ca8eb1f5a84$var$compare(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
function $ed234ca8eb1f5a84$var$geometryNeeded(filter) {
    if (!Array.isArray(filter)) return false;
    if (filter[0] === 'within' || filter[0] === 'distance') return true;
    for(let index = 1; index < filter.length; index++){
        if ($ed234ca8eb1f5a84$var$geometryNeeded(filter[index])) return true;
    }
    return false;
}
function $ed234ca8eb1f5a84$var$convertFilter$1(filter) {
    if (!filter) return true;
    const op = filter[0];
    if (filter.length <= 1) return op !== 'any';
    const converted = op === '==' ? $ed234ca8eb1f5a84$var$convertComparisonOp$1(filter[1], filter[2], '==') : op === '!=' ? $ed234ca8eb1f5a84$var$convertNegation($ed234ca8eb1f5a84$var$convertComparisonOp$1(filter[1], filter[2], '==')) : op === '<' || op === '>' || op === '<=' || op === '>=' ? $ed234ca8eb1f5a84$var$convertComparisonOp$1(filter[1], filter[2], op) : op === 'any' ? $ed234ca8eb1f5a84$var$convertDisjunctionOp(filter.slice(1)) : op === 'all' ? [
        'all'
    ].concat(filter.slice(1).map($ed234ca8eb1f5a84$var$convertFilter$1)) : op === 'none' ? [
        'all'
    ].concat(filter.slice(1).map($ed234ca8eb1f5a84$var$convertFilter$1).map($ed234ca8eb1f5a84$var$convertNegation)) : op === 'in' ? $ed234ca8eb1f5a84$var$convertInOp$1(filter[1], filter.slice(2)) : op === '!in' ? $ed234ca8eb1f5a84$var$convertNegation($ed234ca8eb1f5a84$var$convertInOp$1(filter[1], filter.slice(2))) : op === 'has' ? $ed234ca8eb1f5a84$var$convertHasOp$1(filter[1]) : op === '!has' ? $ed234ca8eb1f5a84$var$convertNegation($ed234ca8eb1f5a84$var$convertHasOp$1(filter[1])) : true;
    return converted;
}
function $ed234ca8eb1f5a84$var$convertComparisonOp$1(property, value, op) {
    switch(property){
        case '$type':
            return [
                `filter-type-${op}`,
                value
            ];
        case '$id':
            return [
                `filter-id-${op}`,
                value
            ];
        default:
            return [
                `filter-${op}`,
                property,
                value
            ];
    }
}
function $ed234ca8eb1f5a84$var$convertDisjunctionOp(filters) {
    return [
        'any'
    ].concat(filters.map($ed234ca8eb1f5a84$var$convertFilter$1));
}
function $ed234ca8eb1f5a84$var$convertInOp$1(property, values) {
    if (values.length === 0) return false;
    switch(property){
        case '$type':
            return [
                'filter-type-in',
                [
                    'literal',
                    values
                ]
            ];
        case '$id':
            return [
                'filter-id-in',
                [
                    'literal',
                    values
                ]
            ];
        default:
            if (values.length > 200 && !values.some((v)=>typeof v !== typeof values[0])) return [
                'filter-in-large',
                property,
                [
                    'literal',
                    values.sort($ed234ca8eb1f5a84$var$compare)
                ]
            ];
            else return [
                'filter-in-small',
                property,
                [
                    'literal',
                    values
                ]
            ];
    }
}
function $ed234ca8eb1f5a84$var$convertHasOp$1(property) {
    switch(property){
        case '$type':
            return true;
        case '$id':
            return [
                'filter-has-id'
            ];
        default:
            return [
                'filter-has',
                property
            ];
    }
}
function $ed234ca8eb1f5a84$var$convertNegation(filter) {
    return [
        '!',
        filter
    ];
}
/*
 * Convert the given filter to an expression, storing the expected types for
 * any feature properties referenced in expectedTypes.
 *
 * These expected types are needed in order to construct preflight type checks
 * needed for handling 'any' filters. A preflight type check is necessary in
 * order to mimic legacy filters' semantics around expected type mismatches.
 * For example, consider the legacy filter:
 *
 *     ["any", ["all", [">", "y", 0], [">", "y", 0]], [">", "x", 0]]
 *
 * Naively, we might convert this to the expression:
 *
 *     ["any", ["all", [">", ["get", "y"], 0], [">", ["get", "z"], 0]], [">", ["get", "x"], 0]]
 *
 * But if we tried to evaluate this against, say `{x: 1, y: null, z: 0}`, the
 * [">", ["get", "y"], 0] would cause an evaluation error, leading to the
 * entire filter returning false. Legacy filter semantics, though, ask for
 * [">", "y", 0] to simply return `false` when `y` is of the wrong type,
 * allowing the subsequent terms of the outer "any" expression to be evaluated
 * (resulting, in this case, in a `true` value, because x > 0).
 *
 * We account for this by inserting a preflight type-checking expression before
 * each "any" term, allowing us to avoid evaluating the actual converted filter
 * if any type mismatches would cause it to produce an evaluation error:
 *
 *     ["any",
 *       ["case",
 *         ["all", ["==", ["typeof", ["get", "y"]], "number"], ["==", ["typeof", ["get", "z"], "number]],
 *         ["all", [">", ["get", "y"], 0], [">", ["get", "z"], 0]],
 *         false
 *       ],
 *       ["case",
 *         ["==", ["typeof", ["get", "x"], "number"]],
 *         [">", ["get", "x"], 0],
 *         false
 *       ]
 *     ]
 *
 * An alternative, possibly more direct approach would be to use type checks
 * in the conversion of each comparison operator, so that the converted version
 * of each individual ==, >=, etc. would mimic the legacy filter semantics. The
 * downside of this approach is that it can lead to many more type checks than
 * would otherwise be necessary: outside the context of an "any" expression,
 * bailing out due to a runtime type error (expression semantics) and returning
 * false (legacy filter semantics) are equivalent: they cause the filter to
 * produce a `false` result.
 */ function $ed234ca8eb1f5a84$export$d9541b7df4c07683(filter, expectedTypes = {}) {
    if ($ed234ca8eb1f5a84$var$isExpressionFilter(filter)) return filter;
    if (!filter) return true;
    const legacyFilter = filter;
    const legacyOp = legacyFilter[0];
    if (filter.length <= 1) return legacyOp !== 'any';
    switch(legacyOp){
        case '==':
        case '!=':
        case '<':
        case '>':
        case '<=':
        case '>=':
            {
                const [, property, value] = filter;
                return $ed234ca8eb1f5a84$var$convertComparisonOp(property, value, legacyOp, expectedTypes);
            }
        case 'any':
            {
                const [, ...conditions] = legacyFilter;
                const children = conditions.map((f)=>{
                    const types = {};
                    const child = $ed234ca8eb1f5a84$export$d9541b7df4c07683(f, types);
                    const typechecks = $ed234ca8eb1f5a84$var$runtimeTypeChecks(types);
                    return typechecks === true ? child : [
                        'case',
                        typechecks,
                        child,
                        false
                    ];
                });
                return [
                    'any',
                    ...children
                ];
            }
        case 'all':
            {
                const [, ...conditions] = legacyFilter;
                const children = conditions.map((f)=>$ed234ca8eb1f5a84$export$d9541b7df4c07683(f, expectedTypes));
                return children.length > 1 ? [
                    'all',
                    ...children
                ] : children[0];
            }
        case 'none':
            {
                const [, ...conditions] = legacyFilter;
                return [
                    '!',
                    $ed234ca8eb1f5a84$export$d9541b7df4c07683([
                        'any',
                        ...conditions
                    ], {})
                ];
            }
        case 'in':
            {
                const [, property, ...values] = legacyFilter;
                return $ed234ca8eb1f5a84$var$convertInOp(property, values);
            }
        case '!in':
            {
                const [, property, ...values] = legacyFilter;
                return $ed234ca8eb1f5a84$var$convertInOp(property, values, true);
            }
        case 'has':
            return $ed234ca8eb1f5a84$var$convertHasOp(legacyFilter[1]);
        case '!has':
            return [
                '!',
                $ed234ca8eb1f5a84$var$convertHasOp(legacyFilter[1])
            ];
        default:
            return true;
    }
}
// Given a set of feature properties and an expected type for each one,
// construct an boolean expression that tests whether each property has the
// right type.
// E.g.: for {name: 'string', population: 'number'}, return
// [ 'all',
//   ['==', ['typeof', ['get', 'name'], 'string']],
//   ['==', ['typeof', ['get', 'population'], 'number]]
// ]
function $ed234ca8eb1f5a84$var$runtimeTypeChecks(expectedTypes) {
    const conditions = [];
    for(const property in expectedTypes){
        const get = property === '$id' ? [
            'id'
        ] : [
            'get',
            property
        ];
        conditions.push([
            '==',
            [
                'typeof',
                get
            ],
            expectedTypes[property]
        ]);
    }
    if (conditions.length === 0) return true;
    if (conditions.length === 1) return conditions[0];
    return [
        'all',
        ...conditions
    ];
}
function $ed234ca8eb1f5a84$var$convertComparisonOp(property, value, op, expectedTypes) {
    let get;
    if (property === '$type') return [
        op,
        [
            'geometry-type'
        ],
        value
    ];
    else if (property === '$id') get = [
        'id'
    ];
    else get = [
        'get',
        property
    ];
    if (expectedTypes && value !== null) {
        const type = typeof value;
        expectedTypes[property] = type;
    }
    if (op === '==' && property !== '$id' && value === null) return [
        'all',
        [
            'has',
            property
        ],
        [
            '==',
            get,
            null
        ]
    ];
    else if (op === '!=' && property !== '$id' && value === null) return [
        'any',
        [
            '!',
            [
                'has',
                property
            ]
        ],
        [
            '!=',
            get,
            null
        ]
    ];
    return [
        op,
        get,
        value
    ];
}
function $ed234ca8eb1f5a84$var$convertInOp(property, values, negate = false) {
    if (values.length === 0) return negate;
    let get;
    if (property === '$type') get = [
        'geometry-type'
    ];
    else if (property === '$id') get = [
        'id'
    ];
    else get = [
        'get',
        property
    ];
    // Determine if the list of values to be searched is homogenously typed.
    // If so (and if the type is string or number), then we can use a
    // [match, input, [...values], true, false] construction rather than a
    // bunch of `==` tests.
    let uniformTypes = true;
    const type = typeof values[0];
    for (const value of values)if (typeof value !== type) {
        uniformTypes = false;
        break;
    }
    if (uniformTypes && (type === 'string' || type === 'number')) {
        // Match expressions must have unique values.
        const uniqueValues = values.sort().filter((v, i)=>i === 0 || values[i - 1] !== v);
        return [
            'match',
            get,
            uniqueValues,
            !negate,
            negate
        ];
    }
    if (negate) return [
        'all',
        ...values.map((v)=>[
                '!=',
                get,
                v
            ])
    ];
    else return [
        'any',
        ...values.map((v)=>[
                '==',
                get,
                v
            ])
    ];
}
function $ed234ca8eb1f5a84$var$convertHasOp(property) {
    if (property === '$type') return true;
    else if (property === '$id') return [
        '!=',
        [
            'id'
        ],
        null
    ];
    else return [
        'has',
        property
    ];
}
function $ed234ca8eb1f5a84$var$convertLiteral(value) {
    return typeof value === 'object' ? [
        'literal',
        value
    ] : value;
}
function $ed234ca8eb1f5a84$export$4ffa6b66a9b9e443(parameters, propertySpec) {
    let stops = parameters.stops;
    if (!stops) // identity function
    return $ed234ca8eb1f5a84$var$convertIdentityFunction(parameters, propertySpec);
    const zoomAndFeatureDependent = stops && typeof stops[0][0] === 'object';
    const featureDependent = zoomAndFeatureDependent || parameters.property !== undefined;
    const zoomDependent = zoomAndFeatureDependent || !featureDependent;
    stops = stops.map((stop)=>{
        if (!featureDependent && propertySpec.tokens && typeof stop[1] === 'string') return [
            stop[0],
            $ed234ca8eb1f5a84$var$convertTokenString(stop[1])
        ];
        return [
            stop[0],
            $ed234ca8eb1f5a84$var$convertLiteral(stop[1])
        ];
    });
    if (zoomAndFeatureDependent) return $ed234ca8eb1f5a84$var$convertZoomAndPropertyFunction(parameters, propertySpec, stops);
    else if (zoomDependent) return $ed234ca8eb1f5a84$var$convertZoomFunction(parameters, propertySpec, stops);
    else return $ed234ca8eb1f5a84$var$convertPropertyFunction(parameters, propertySpec, stops);
}
function $ed234ca8eb1f5a84$var$convertIdentityFunction(parameters, propertySpec) {
    const get = [
        'get',
        parameters.property
    ];
    if (parameters.default === undefined) // By default, expressions for string-valued properties get coerced. To preserve
    // legacy function semantics, insert an explicit assertion instead.
    return propertySpec.type === 'string' ? [
        'string',
        get
    ] : get;
    else if (propertySpec.type === 'enum') return [
        'match',
        get,
        Object.keys(propertySpec.values),
        get,
        parameters.default
    ];
    else {
        const expression = [
            propertySpec.type === 'color' ? 'to-color' : propertySpec.type,
            get,
            $ed234ca8eb1f5a84$var$convertLiteral(parameters.default)
        ];
        if (propertySpec.type === 'array') expression.splice(1, 0, propertySpec.value, propertySpec.length || null);
        return expression;
    }
}
function $ed234ca8eb1f5a84$var$getInterpolateOperator(parameters) {
    switch(parameters.colorSpace){
        case 'hcl':
            return 'interpolate-hcl';
        case 'lab':
            return 'interpolate-lab';
        default:
            return 'interpolate';
    }
}
function $ed234ca8eb1f5a84$var$convertZoomAndPropertyFunction(parameters, propertySpec, stops) {
    const featureFunctionParameters = {};
    const featureFunctionStops = {};
    const zoomStops = [];
    for(let s = 0; s < stops.length; s++){
        const stop = stops[s];
        const zoom = stop[0].zoom;
        if (featureFunctionParameters[zoom] === undefined) {
            featureFunctionParameters[zoom] = {
                zoom: zoom,
                type: parameters.type,
                property: parameters.property,
                default: parameters.default
            };
            featureFunctionStops[zoom] = [];
            zoomStops.push(zoom);
        }
        featureFunctionStops[zoom].push([
            stop[0].value,
            stop[1]
        ]);
    }
    // the interpolation type for the zoom dimension of a zoom-and-property
    // function is determined directly from the style property specification
    // for which it's being used: linear for interpolatable properties, step
    // otherwise.
    const functionType = $ed234ca8eb1f5a84$var$getFunctionType({}, propertySpec);
    if (functionType === 'exponential') {
        const expression = [
            $ed234ca8eb1f5a84$var$getInterpolateOperator(parameters),
            [
                'linear'
            ],
            [
                'zoom'
            ]
        ];
        for (const z of zoomStops){
            const output = $ed234ca8eb1f5a84$var$convertPropertyFunction(featureFunctionParameters[z], propertySpec, featureFunctionStops[z]);
            $ed234ca8eb1f5a84$var$appendStopPair(expression, z, output, false);
        }
        return expression;
    } else {
        const expression = [
            'step',
            [
                'zoom'
            ]
        ];
        for (const z of zoomStops){
            const output = $ed234ca8eb1f5a84$var$convertPropertyFunction(featureFunctionParameters[z], propertySpec, featureFunctionStops[z]);
            $ed234ca8eb1f5a84$var$appendStopPair(expression, z, output, true);
        }
        $ed234ca8eb1f5a84$var$fixupDegenerateStepCurve(expression);
        return expression;
    }
}
function $ed234ca8eb1f5a84$var$coalesce(a, b) {
    if (a !== undefined) return a;
    if (b !== undefined) return b;
}
function $ed234ca8eb1f5a84$var$getFallback(parameters, propertySpec) {
    const defaultValue = $ed234ca8eb1f5a84$var$convertLiteral($ed234ca8eb1f5a84$var$coalesce(parameters.default, propertySpec.default));
    /*
     * Some fields with type: resolvedImage have an undefined default.
     * Because undefined is an invalid value for resolvedImage, set fallback to
     * an empty string instead of undefined to ensure output
     * passes validation.
     */ if (defaultValue === undefined && propertySpec.type === 'resolvedImage') return '';
    return defaultValue;
}
function $ed234ca8eb1f5a84$var$convertPropertyFunction(parameters, propertySpec, stops) {
    const type = $ed234ca8eb1f5a84$var$getFunctionType(parameters, propertySpec);
    const get = [
        'get',
        parameters.property
    ];
    if (type === 'categorical' && typeof stops[0][0] === 'boolean') {
        const expression = [
            'case'
        ];
        for (const stop of stops)expression.push([
            '==',
            get,
            stop[0]
        ], stop[1]);
        expression.push($ed234ca8eb1f5a84$var$getFallback(parameters, propertySpec));
        return expression;
    } else if (type === 'categorical') {
        const expression = [
            'match',
            get
        ];
        for (const stop of stops)$ed234ca8eb1f5a84$var$appendStopPair(expression, stop[0], stop[1], false);
        expression.push($ed234ca8eb1f5a84$var$getFallback(parameters, propertySpec));
        return expression;
    } else if (type === 'interval') {
        const expression = [
            'step',
            [
                'number',
                get
            ]
        ];
        for (const stop of stops)$ed234ca8eb1f5a84$var$appendStopPair(expression, stop[0], stop[1], true);
        $ed234ca8eb1f5a84$var$fixupDegenerateStepCurve(expression);
        return parameters.default === undefined ? expression : [
            'case',
            [
                '==',
                [
                    'typeof',
                    get
                ],
                'number'
            ],
            expression,
            $ed234ca8eb1f5a84$var$convertLiteral(parameters.default)
        ];
    } else if (type === 'exponential') {
        const base = parameters.base !== undefined ? parameters.base : 1;
        const expression = [
            $ed234ca8eb1f5a84$var$getInterpolateOperator(parameters),
            base === 1 ? [
                'linear'
            ] : [
                'exponential',
                base
            ],
            [
                'number',
                get
            ]
        ];
        for (const stop of stops)$ed234ca8eb1f5a84$var$appendStopPair(expression, stop[0], stop[1], false);
        return parameters.default === undefined ? expression : [
            'case',
            [
                '==',
                [
                    'typeof',
                    get
                ],
                'number'
            ],
            expression,
            $ed234ca8eb1f5a84$var$convertLiteral(parameters.default)
        ];
    } else throw new Error(`Unknown property function type ${type}`);
}
function $ed234ca8eb1f5a84$var$convertZoomFunction(parameters, propertySpec, stops, input = [
    'zoom'
]) {
    const type = $ed234ca8eb1f5a84$var$getFunctionType(parameters, propertySpec);
    let expression;
    let isStep = false;
    if (type === 'interval') {
        expression = [
            'step',
            input
        ];
        isStep = true;
    } else if (type === 'exponential') {
        const base = parameters.base !== undefined ? parameters.base : 1;
        expression = [
            $ed234ca8eb1f5a84$var$getInterpolateOperator(parameters),
            base === 1 ? [
                'linear'
            ] : [
                'exponential',
                base
            ],
            input
        ];
    } else throw new Error(`Unknown zoom function type "${type}"`);
    for (const stop of stops)$ed234ca8eb1f5a84$var$appendStopPair(expression, stop[0], stop[1], isStep);
    $ed234ca8eb1f5a84$var$fixupDegenerateStepCurve(expression);
    return expression;
}
function $ed234ca8eb1f5a84$var$fixupDegenerateStepCurve(expression) {
    // degenerate step curve (i.e. a constant function): add a noop stop
    if (expression[0] === 'step' && expression.length === 3) {
        expression.push(0);
        expression.push(expression[3]);
    }
}
function $ed234ca8eb1f5a84$var$appendStopPair(curve, input, output, isStep) {
    // Skip duplicate stop values. They were not validated for functions, but they are for expressions.
    // https://github.com/mapbox/mapbox-gl-js/issues/4107
    if (curve.length > 3 && input === curve[curve.length - 2]) return;
    // step curves don't get the first input value, as it is redundant.
    if (!(isStep && curve.length === 2)) curve.push(input);
    curve.push(output);
}
function $ed234ca8eb1f5a84$var$getFunctionType(parameters, propertySpec) {
    if (parameters.type) return parameters.type;
    else return propertySpec.expression.interpolated ? 'exponential' : 'interval';
}
// "String with {name} token" => ["concat", "String with ", ["get", "name"], " token"]
function $ed234ca8eb1f5a84$var$convertTokenString(s) {
    const result = [
        'concat'
    ];
    const re = /{([^{}]+)}/g;
    let pos = 0;
    for(let match = re.exec(s); match !== null; match = re.exec(s)){
        const literal = s.slice(pos, re.lastIndex - match[0].length);
        pos = re.lastIndex;
        if (literal.length > 0) result.push(literal);
        result.push([
            'get',
            match[1]
        ]);
    }
    if (result.length === 1) return s;
    if (pos < s.length) result.push(s.slice(pos));
    else if (result.length === 2) return [
        'to-string',
        result[1]
    ];
    return result;
}
function $ed234ca8eb1f5a84$var$getPropertyReference(propertyName) {
    for(let i = 0; i < $ed234ca8eb1f5a84$export$b8064d1c42a6b8.layout.length; i++)for(const key in $ed234ca8eb1f5a84$export$b8064d1c42a6b8[$ed234ca8eb1f5a84$export$b8064d1c42a6b8.layout[i]]){
        if (key === propertyName) return $ed234ca8eb1f5a84$export$b8064d1c42a6b8[$ed234ca8eb1f5a84$export$b8064d1c42a6b8.layout[i]][key];
    }
    for(let i = 0; i < $ed234ca8eb1f5a84$export$b8064d1c42a6b8.paint.length; i++)for(const key in $ed234ca8eb1f5a84$export$b8064d1c42a6b8[$ed234ca8eb1f5a84$export$b8064d1c42a6b8.paint[i]]){
        if (key === propertyName) return $ed234ca8eb1f5a84$export$b8064d1c42a6b8[$ed234ca8eb1f5a84$export$b8064d1c42a6b8.paint[i]][key];
    }
    return null;
}
function $ed234ca8eb1f5a84$var$eachSource(style, callback) {
    for(const k in style.sources)callback(style.sources[k]);
}
function $ed234ca8eb1f5a84$var$eachLayer(style, callback) {
    for (const layer of style.layers)callback(layer);
}
function $ed234ca8eb1f5a84$var$eachProperty(style, options, callback) {
    function inner(layer, propertyType) {
        const properties = layer[propertyType];
        if (!properties) return;
        Object.keys(properties).forEach((key)=>{
            callback({
                path: [
                    layer.id,
                    propertyType,
                    key
                ],
                key: key,
                value: properties[key],
                reference: $ed234ca8eb1f5a84$var$getPropertyReference(key),
                set (x) {
                    properties[key] = x;
                }
            });
        });
    }
    $ed234ca8eb1f5a84$var$eachLayer(style, (layer)=>{
        if (options.paint) inner(layer, 'paint');
        if (options.layout) inner(layer, 'layout');
    });
}
function $ed234ca8eb1f5a84$var$stringify$1(obj) {
    const type = typeof obj;
    if (type === 'number' || type === 'boolean' || type === 'string' || obj === undefined || obj === null) return JSON.stringify(obj);
    if (Array.isArray(obj)) {
        let str = '[';
        for (const val of obj)str += `${$ed234ca8eb1f5a84$var$stringify$1(val)},`;
        return `${str}]`;
    }
    const keys = Object.keys(obj).sort();
    let str = '{';
    for(let i = 0; i < keys.length; i++)str += `${JSON.stringify(keys[i])}:${$ed234ca8eb1f5a84$var$stringify$1(obj[keys[i]])},`;
    return `${str}}`;
}
function $ed234ca8eb1f5a84$var$getKey(layer) {
    let key = '';
    for (const k of $ed234ca8eb1f5a84$var$refProperties)key += `/${$ed234ca8eb1f5a84$var$stringify$1(layer[k])}`;
    return key;
}
/**
 * Groups layers by their layout-affecting properties.
 * These are the properties that were formerly used by explicit `ref` mechanism
 * for layers: 'type', 'source', 'source-layer', 'minzoom', 'maxzoom',
 * 'filter', and 'layout'.
 *
 * The input is not modified. The output layers are references to the
 * input layers.
 *
 * @param layers - an array of {@link LayerSpecification}.
 * @param cachedKeys - an object to keep already calculated keys.
 * @returns an array of arrays of {@link LayerSpecification} objects, where each inner array
 * contains layers that share the same layout-affecting properties.
 */ function $ed234ca8eb1f5a84$export$18ddc822b4cdc644(layers, cachedKeys) {
    const groups = {};
    for(let i = 0; i < layers.length; i++){
        const k = cachedKeys && cachedKeys[layers[i].id] || $ed234ca8eb1f5a84$var$getKey(layers[i]);
        // update the cache if there is one
        if (cachedKeys) cachedKeys[layers[i].id] = k;
        let group = groups[k];
        if (!group) group = groups[k] = [];
        group.push(layers[i]);
    }
    const result = [];
    for(const k in groups)result.push(groups[k]);
    return result;
}
function $ed234ca8eb1f5a84$export$7e7e15c038f60dc5() {
    const style = {};
    const version = $ed234ca8eb1f5a84$export$b8064d1c42a6b8['$version'];
    for(const styleKey in $ed234ca8eb1f5a84$export$b8064d1c42a6b8['$root']){
        const specification = $ed234ca8eb1f5a84$export$b8064d1c42a6b8['$root'][styleKey];
        if (specification.required) {
            let value = null;
            if (styleKey === 'version') value = version;
            else if (specification.type === 'array') value = [];
            else value = {};
            if (value != null) style[styleKey] = value;
        }
    }
    return style;
}
function $ed234ca8eb1f5a84$var$validateConstants(options) {
    const key = options.key;
    const constants = options.value;
    if (constants) return [
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, constants, 'constants have been deprecated as of v8')
    ];
    else return [];
}
// Turn jsonlint-lines-primitives objects into primitive objects
function $ed234ca8eb1f5a84$var$unbundle(value) {
    if (value instanceof Number || value instanceof String || value instanceof Boolean) return value.valueOf();
    else return value;
}
function $ed234ca8eb1f5a84$var$deepUnbundle(value) {
    if (Array.isArray(value)) return value.map($ed234ca8eb1f5a84$var$deepUnbundle);
    else if (value instanceof Object && !(value instanceof Number || value instanceof String || value instanceof Boolean)) {
        const unbundledValue = {};
        for(const key in value)unbundledValue[key] = $ed234ca8eb1f5a84$var$deepUnbundle(value[key]);
        return unbundledValue;
    }
    return $ed234ca8eb1f5a84$var$unbundle(value);
}
function $ed234ca8eb1f5a84$var$validateObject(options) {
    const key = options.key;
    const object = options.value;
    const elementSpecs = options.valueSpec || {};
    const elementValidators = options.objectElementValidators || {};
    const style = options.style;
    const styleSpec = options.styleSpec;
    const validateSpec = options.validateSpec;
    let errors = [];
    const type = $ed234ca8eb1f5a84$var$getType(object);
    if (type !== 'object') return [
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, object, `object expected, ${type} found`)
    ];
    for(const objectKey in object){
        const elementSpecKey = objectKey.split('.')[0]; // treat 'paint.*' as 'paint'
        // objectKey comes from the user controlled style input, so elementSpecKey may be e.g. "__proto__"
        const elementSpec = $ed234ca8eb1f5a84$var$getOwn(elementSpecs, elementSpecKey) || elementSpecs['*'];
        let validateElement;
        if ($ed234ca8eb1f5a84$var$getOwn(elementValidators, elementSpecKey)) validateElement = elementValidators[elementSpecKey];
        else if ($ed234ca8eb1f5a84$var$getOwn(elementSpecs, elementSpecKey)) {
            if (object[objectKey] === undefined) continue;
            validateElement = validateSpec;
        } else if (elementValidators['*']) validateElement = elementValidators['*'];
        else if (elementSpecs['*']) validateElement = validateSpec;
        else {
            errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, object[objectKey], `unknown property "${objectKey}"`));
            continue;
        }
        errors = errors.concat(validateElement({
            key: (key ? `${key}.` : key) + objectKey,
            value: object[objectKey],
            valueSpec: elementSpec,
            style: style,
            styleSpec: styleSpec,
            object: object,
            objectKey: objectKey,
            validateSpec: validateSpec
        }, object));
    }
    for(const elementSpecKey in elementSpecs){
        // Don't check `required` when there's a custom validator for that property.
        if (elementValidators[elementSpecKey]) continue;
        if (elementSpecs[elementSpecKey].required && elementSpecs[elementSpecKey]['default'] === undefined && object[elementSpecKey] === undefined) errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, object, `missing required property "${elementSpecKey}"`));
    }
    return errors;
}
function $ed234ca8eb1f5a84$var$validateArray(options) {
    const array = options.value;
    const arraySpec = options.valueSpec;
    const validateSpec = options.validateSpec;
    const style = options.style;
    const styleSpec = options.styleSpec;
    const key = options.key;
    const validateArrayElement = options.arrayElementValidator || validateSpec;
    if ($ed234ca8eb1f5a84$var$getType(array) !== 'array') return [
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, array, `array expected, ${$ed234ca8eb1f5a84$var$getType(array)} found`)
    ];
    if (arraySpec.length && array.length !== arraySpec.length) return [
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, array, `array length ${arraySpec.length} expected, length ${array.length} found`)
    ];
    let arrayElementSpec = {
        type: arraySpec.value,
        values: arraySpec.values
    };
    if (styleSpec.$version < 7) arrayElementSpec['function'] = arraySpec.function;
    if ($ed234ca8eb1f5a84$var$getType(arraySpec.value) === 'object') arrayElementSpec = arraySpec.value;
    let errors = [];
    for(let i = 0; i < array.length; i++)errors = errors.concat(validateArrayElement({
        array: array,
        arrayIndex: i,
        value: array[i],
        valueSpec: arrayElementSpec,
        validateSpec: options.validateSpec,
        style: style,
        styleSpec: styleSpec,
        key: `${key}[${i}]`
    }));
    return errors;
}
function $ed234ca8eb1f5a84$var$validateNumber(options) {
    const key = options.key;
    const value = options.value;
    const valueSpec = options.valueSpec;
    let type = $ed234ca8eb1f5a84$var$getType(value);
    if (type === 'number' && value !== value) type = 'NaN';
    if (type !== 'number') return [
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, `number expected, ${type} found`)
    ];
    if ('minimum' in valueSpec && value < valueSpec.minimum) return [
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, `${value} is less than the minimum value ${valueSpec.minimum}`)
    ];
    if ('maximum' in valueSpec && value > valueSpec.maximum) return [
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, `${value} is greater than the maximum value ${valueSpec.maximum}`)
    ];
    return [];
}
function $ed234ca8eb1f5a84$var$validateFunction(options) {
    const functionValueSpec = options.valueSpec;
    const functionType = $ed234ca8eb1f5a84$var$unbundle(options.value.type);
    let stopKeyType;
    let stopDomainValues = {};
    let previousStopDomainValue;
    let previousStopDomainZoom;
    const isZoomFunction = functionType !== 'categorical' && options.value.property === undefined;
    const isPropertyFunction = !isZoomFunction;
    const isZoomAndPropertyFunction = $ed234ca8eb1f5a84$var$getType(options.value.stops) === 'array' && $ed234ca8eb1f5a84$var$getType(options.value.stops[0]) === 'array' && $ed234ca8eb1f5a84$var$getType(options.value.stops[0][0]) === 'object';
    const errors = $ed234ca8eb1f5a84$var$validateObject({
        key: options.key,
        value: options.value,
        valueSpec: options.styleSpec.function,
        validateSpec: options.validateSpec,
        style: options.style,
        styleSpec: options.styleSpec,
        objectElementValidators: {
            stops: validateFunctionStops,
            default: validateFunctionDefault
        }
    });
    if (functionType === 'identity' && isZoomFunction) errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(options.key, options.value, 'missing required property "property"'));
    if (functionType !== 'identity' && !options.value.stops) errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(options.key, options.value, 'missing required property "stops"'));
    if (functionType === 'exponential' && options.valueSpec.expression && !$ed234ca8eb1f5a84$var$supportsInterpolation(options.valueSpec)) errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(options.key, options.value, 'exponential functions not supported'));
    if (options.styleSpec.$version >= 8) {
        if (isPropertyFunction && !$ed234ca8eb1f5a84$export$80ae86acfd45595c(options.valueSpec)) errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(options.key, options.value, 'property functions not supported'));
        else if (isZoomFunction && !$ed234ca8eb1f5a84$var$supportsZoomExpression(options.valueSpec)) errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(options.key, options.value, 'zoom functions not supported'));
    }
    if ((functionType === 'categorical' || isZoomAndPropertyFunction) && options.value.property === undefined) errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(options.key, options.value, '"property" property is required'));
    return errors;
    function validateFunctionStops(options) {
        if (functionType === 'identity') return [
            new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(options.key, options.value, 'identity function may not have a "stops" property')
        ];
        let errors = [];
        const value = options.value;
        errors = errors.concat($ed234ca8eb1f5a84$var$validateArray({
            key: options.key,
            value: value,
            valueSpec: options.valueSpec,
            validateSpec: options.validateSpec,
            style: options.style,
            styleSpec: options.styleSpec,
            arrayElementValidator: validateFunctionStop
        }));
        if ($ed234ca8eb1f5a84$var$getType(value) === 'array' && value.length === 0) errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(options.key, value, 'array must have at least one stop'));
        return errors;
    }
    function validateFunctionStop(options) {
        let errors = [];
        const value = options.value;
        const key = options.key;
        if ($ed234ca8eb1f5a84$var$getType(value) !== 'array') return [
            new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, `array expected, ${$ed234ca8eb1f5a84$var$getType(value)} found`)
        ];
        if (value.length !== 2) return [
            new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, `array length 2 expected, length ${value.length} found`)
        ];
        if (isZoomAndPropertyFunction) {
            if ($ed234ca8eb1f5a84$var$getType(value[0]) !== 'object') return [
                new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, `object expected, ${$ed234ca8eb1f5a84$var$getType(value[0])} found`)
            ];
            if (value[0].zoom === undefined) return [
                new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, 'object stop key must have zoom')
            ];
            if (value[0].value === undefined) return [
                new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, 'object stop key must have value')
            ];
            if (previousStopDomainZoom && previousStopDomainZoom > $ed234ca8eb1f5a84$var$unbundle(value[0].zoom)) return [
                new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value[0].zoom, 'stop zoom values must appear in ascending order')
            ];
            if ($ed234ca8eb1f5a84$var$unbundle(value[0].zoom) !== previousStopDomainZoom) {
                previousStopDomainZoom = $ed234ca8eb1f5a84$var$unbundle(value[0].zoom);
                previousStopDomainValue = undefined;
                stopDomainValues = {};
            }
            errors = errors.concat($ed234ca8eb1f5a84$var$validateObject({
                key: `${key}[0]`,
                value: value[0],
                valueSpec: {
                    zoom: {}
                },
                validateSpec: options.validateSpec,
                style: options.style,
                styleSpec: options.styleSpec,
                objectElementValidators: {
                    zoom: $ed234ca8eb1f5a84$var$validateNumber,
                    value: validateStopDomainValue
                }
            }));
        } else errors = errors.concat(validateStopDomainValue({
            key: `${key}[0]`,
            value: value[0],
            validateSpec: options.validateSpec,
            style: options.style,
            styleSpec: options.styleSpec
        }, value));
        if ($ed234ca8eb1f5a84$export$3827579d8e65d9ac($ed234ca8eb1f5a84$var$deepUnbundle(value[1]))) return errors.concat([
            new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(`${key}[1]`, value[1], 'expressions are not allowed in function stops.')
        ]);
        return errors.concat(options.validateSpec({
            key: `${key}[1]`,
            value: value[1],
            valueSpec: functionValueSpec,
            validateSpec: options.validateSpec,
            style: options.style,
            styleSpec: options.styleSpec
        }));
    }
    function validateStopDomainValue(options, stop) {
        const type = $ed234ca8eb1f5a84$var$getType(options.value);
        const value = $ed234ca8eb1f5a84$var$unbundle(options.value);
        const reportValue = options.value !== null ? options.value : stop;
        if (!stopKeyType) stopKeyType = type;
        else if (type !== stopKeyType) return [
            new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(options.key, reportValue, `${type} stop domain type must match previous stop domain type ${stopKeyType}`)
        ];
        if (type !== 'number' && type !== 'string' && type !== 'boolean') return [
            new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(options.key, reportValue, 'stop domain value must be a number, string, or boolean')
        ];
        if (type !== 'number' && functionType !== 'categorical') {
            let message = `number expected, ${type} found`;
            if ($ed234ca8eb1f5a84$export$80ae86acfd45595c(functionValueSpec) && functionType === undefined) message += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.';
            return [
                new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(options.key, reportValue, message)
            ];
        }
        if (functionType === 'categorical' && type === 'number' && (!isFinite(value) || Math.floor(value) !== value)) return [
            new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(options.key, reportValue, `integer expected, found ${value}`)
        ];
        if (functionType !== 'categorical' && type === 'number' && previousStopDomainValue !== undefined && value < previousStopDomainValue) return [
            new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(options.key, reportValue, 'stop domain values must appear in ascending order')
        ];
        else previousStopDomainValue = value;
        if (functionType === 'categorical' && value in stopDomainValues) return [
            new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(options.key, reportValue, 'stop domain values must be unique')
        ];
        else stopDomainValues[value] = true;
        return [];
    }
    function validateFunctionDefault(options) {
        return options.validateSpec({
            key: options.key,
            value: options.value,
            valueSpec: functionValueSpec,
            validateSpec: options.validateSpec,
            style: options.style,
            styleSpec: options.styleSpec
        });
    }
}
function $ed234ca8eb1f5a84$var$validateExpression(options) {
    const expression = (options.expressionContext === 'property' ? $ed234ca8eb1f5a84$export$64925a39029a32a : $ed234ca8eb1f5a84$export$e2f07551fdfaf6b7)($ed234ca8eb1f5a84$var$deepUnbundle(options.value), options.valueSpec);
    if (expression.result === 'error') return expression.value.map((error)=>{
        return new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(`${options.key}${error.key}`, options.value, error.message);
    });
    const expressionObj = expression.value.expression || expression.value._styleExpression.expression;
    if (options.expressionContext === 'property' && options.propertyKey === 'text-font' && !expressionObj.outputDefined()) return [
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(options.key, options.value, `Invalid data expression for "${options.propertyKey}". Output values must be contained as literals within the expression.`)
    ];
    if (options.expressionContext === 'property' && options.propertyType === 'layout' && !$ed234ca8eb1f5a84$var$isStateConstant(expressionObj)) return [
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(options.key, options.value, '"feature-state" data expressions are not supported with layout properties.')
    ];
    if (options.expressionContext === 'filter' && !$ed234ca8eb1f5a84$var$isStateConstant(expressionObj)) return [
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(options.key, options.value, '"feature-state" data expressions are not supported with filters.')
    ];
    if (options.expressionContext && options.expressionContext.indexOf('cluster') === 0) {
        if (!$ed234ca8eb1f5a84$var$isGlobalPropertyConstant(expressionObj, [
            'zoom',
            'feature-state'
        ])) return [
            new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(options.key, options.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
        ];
        if (options.expressionContext === 'cluster-initial' && !$ed234ca8eb1f5a84$var$isFeatureConstant(expressionObj)) return [
            new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(options.key, options.value, 'Feature data expressions are not supported with initial expression part of cluster properties.')
        ];
    }
    return [];
}
function $ed234ca8eb1f5a84$var$validateBoolean(options) {
    const value = options.value;
    const key = options.key;
    const type = $ed234ca8eb1f5a84$var$getType(value);
    if (type !== 'boolean') return [
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, `boolean expected, ${type} found`)
    ];
    return [];
}
function $ed234ca8eb1f5a84$var$validateColor(options) {
    const key = options.key;
    const value = options.value;
    const type = $ed234ca8eb1f5a84$var$getType(value);
    if (type !== 'string') return [
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, `color expected, ${type} found`)
    ];
    if (!$ed234ca8eb1f5a84$export$892596cec99bc70e.parse(String(value))) // cast String object to string primitive
    return [
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, `color expected, "${value}" found`)
    ];
    return [];
}
function $ed234ca8eb1f5a84$var$validateEnum(options) {
    const key = options.key;
    const value = options.value;
    const valueSpec = options.valueSpec;
    const errors = [];
    if (Array.isArray(valueSpec.values)) // <=v7
    {
        if (valueSpec.values.indexOf($ed234ca8eb1f5a84$var$unbundle(value)) === -1) errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, `expected one of [${valueSpec.values.join(', ')}], ${JSON.stringify(value)} found`));
    } else // >=v8
    if (Object.keys(valueSpec.values).indexOf($ed234ca8eb1f5a84$var$unbundle(value)) === -1) errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, `expected one of [${Object.keys(valueSpec.values).join(', ')}], ${JSON.stringify(value)} found`));
    return errors;
}
function $ed234ca8eb1f5a84$var$validateFilter(options) {
    if ($ed234ca8eb1f5a84$var$isExpressionFilter($ed234ca8eb1f5a84$var$deepUnbundle(options.value))) return $ed234ca8eb1f5a84$var$validateExpression($ed234ca8eb1f5a84$var$extendBy({}, options, {
        expressionContext: 'filter',
        valueSpec: {
            value: 'boolean'
        }
    }));
    else return $ed234ca8eb1f5a84$var$validateNonExpressionFilter(options);
}
function $ed234ca8eb1f5a84$var$validateNonExpressionFilter(options) {
    const value = options.value;
    const key = options.key;
    if ($ed234ca8eb1f5a84$var$getType(value) !== 'array') return [
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, `array expected, ${$ed234ca8eb1f5a84$var$getType(value)} found`)
    ];
    const styleSpec = options.styleSpec;
    let type;
    let errors = [];
    if (value.length < 1) return [
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, 'filter array must have at least 1 element')
    ];
    errors = errors.concat($ed234ca8eb1f5a84$var$validateEnum({
        key: `${key}[0]`,
        value: value[0],
        valueSpec: styleSpec.filter_operator,
        style: options.style,
        styleSpec: options.styleSpec
    }));
    switch($ed234ca8eb1f5a84$var$unbundle(value[0])){
        case '<':
        case '<=':
        case '>':
        case '>=':
            if (value.length >= 2 && $ed234ca8eb1f5a84$var$unbundle(value[1]) === '$type') errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, `"$type" cannot be use with operator "${value[0]}"`));
        /* falls through */ case '==':
        case '!=':
            if (value.length !== 3) errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, `filter array for operator "${value[0]}" must have 3 elements`));
        /* falls through */ case 'in':
        case '!in':
            if (value.length >= 2) {
                type = $ed234ca8eb1f5a84$var$getType(value[1]);
                if (type !== 'string') errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(`${key}[1]`, value[1], `string expected, ${type} found`));
            }
            for(let i = 2; i < value.length; i++){
                type = $ed234ca8eb1f5a84$var$getType(value[i]);
                if ($ed234ca8eb1f5a84$var$unbundle(value[1]) === '$type') errors = errors.concat($ed234ca8eb1f5a84$var$validateEnum({
                    key: `${key}[${i}]`,
                    value: value[i],
                    valueSpec: styleSpec.geometry_type,
                    style: options.style,
                    styleSpec: options.styleSpec
                }));
                else if (type !== 'string' && type !== 'number' && type !== 'boolean') errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(`${key}[${i}]`, value[i], `string, number, or boolean expected, ${type} found`));
            }
            break;
        case 'any':
        case 'all':
        case 'none':
            for(let i = 1; i < value.length; i++)errors = errors.concat($ed234ca8eb1f5a84$var$validateNonExpressionFilter({
                key: `${key}[${i}]`,
                value: value[i],
                style: options.style,
                styleSpec: options.styleSpec
            }));
            break;
        case 'has':
        case '!has':
            type = $ed234ca8eb1f5a84$var$getType(value[1]);
            if (value.length !== 2) errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, `filter array for "${value[0]}" operator must have 2 elements`));
            else if (type !== 'string') errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(`${key}[1]`, value[1], `string expected, ${type} found`));
            break;
    }
    return errors;
}
function $ed234ca8eb1f5a84$var$validateProperty(options, propertyType) {
    const key = options.key;
    const validateSpec = options.validateSpec;
    const style = options.style;
    const styleSpec = options.styleSpec;
    const value = options.value;
    const propertyKey = options.objectKey;
    const layerSpec = styleSpec[`${propertyType}_${options.layerType}`];
    if (!layerSpec) return [];
    const transitionMatch = propertyKey.match(/^(.*)-transition$/);
    if (propertyType === 'paint' && transitionMatch && layerSpec[transitionMatch[1]] && layerSpec[transitionMatch[1]].transition) return validateSpec({
        key: key,
        value: value,
        valueSpec: styleSpec.transition,
        style: style,
        styleSpec: styleSpec
    });
    const valueSpec = options.valueSpec || layerSpec[propertyKey];
    if (!valueSpec) return [
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, `unknown property "${propertyKey}"`)
    ];
    let tokenMatch;
    if ($ed234ca8eb1f5a84$var$getType(value) === 'string' && $ed234ca8eb1f5a84$export$80ae86acfd45595c(valueSpec) && !valueSpec.tokens && (tokenMatch = /^{([^}]+)}$/.exec(value))) return [
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, `"${propertyKey}" does not support interpolation syntax\n` + `Use an identity property function instead: \`{ "type": "identity", "property": ${JSON.stringify(tokenMatch[1])} }\`.`)
    ];
    const errors = [];
    if (options.layerType === 'symbol') {
        if (propertyKey === 'text-font' && $ed234ca8eb1f5a84$export$f6e2535fb5126e54($ed234ca8eb1f5a84$var$deepUnbundle(value)) && $ed234ca8eb1f5a84$var$unbundle(value.type) === 'identity') errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, '"text-font" does not support identity functions'));
    }
    return errors.concat(validateSpec({
        key: options.key,
        value: value,
        valueSpec: valueSpec,
        style: style,
        styleSpec: styleSpec,
        expressionContext: 'property',
        propertyType: propertyType,
        propertyKey: propertyKey
    }));
}
function $ed234ca8eb1f5a84$var$validatePaintProperty(options) {
    return $ed234ca8eb1f5a84$var$validateProperty(options, 'paint');
}
function $ed234ca8eb1f5a84$var$validateLayoutProperty(options) {
    return $ed234ca8eb1f5a84$var$validateProperty(options, 'layout');
}
function $ed234ca8eb1f5a84$var$validateLayer(options) {
    var _a, _b;
    let errors = [];
    const layer = options.value;
    const key = options.key;
    const style = options.style;
    const styleSpec = options.styleSpec;
    if ($ed234ca8eb1f5a84$var$getType(layer) !== 'object') return [
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, layer, `object expected, ${$ed234ca8eb1f5a84$var$getType(layer)} found`)
    ];
    if (!layer.type && !layer.ref) errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, layer, 'either "type" or "ref" is required'));
    let type = $ed234ca8eb1f5a84$var$unbundle(layer.type);
    const ref = $ed234ca8eb1f5a84$var$unbundle(layer.ref);
    if (layer.id) {
        const layerId = $ed234ca8eb1f5a84$var$unbundle(layer.id);
        for(let i = 0; i < options.arrayIndex; i++){
            const otherLayer = style.layers[i];
            if ($ed234ca8eb1f5a84$var$unbundle(otherLayer.id) === layerId) errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, layer.id, `duplicate layer id "${layer.id}", previously used at line ${otherLayer.id.__line__}`));
        }
    }
    if ('ref' in layer) {
        [
            'type',
            'source',
            'source-layer',
            'filter',
            'layout'
        ].forEach((p)=>{
            if (p in layer) errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, layer[p], `"${p}" is prohibited for ref layers`));
        });
        let parent;
        style.layers.forEach((layer)=>{
            if ($ed234ca8eb1f5a84$var$unbundle(layer.id) === ref) parent = layer;
        });
        if (!parent) errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, layer.ref, `ref layer "${ref}" not found`));
        else if (parent.ref) errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, layer.ref, 'ref cannot reference another ref layer'));
        else type = $ed234ca8eb1f5a84$var$unbundle(parent.type);
    } else if (type !== 'background') {
        if (!layer.source) errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, layer, 'missing required property "source"'));
        else {
            const source = style.sources && style.sources[layer.source];
            const sourceType = source && $ed234ca8eb1f5a84$var$unbundle(source.type);
            if (!source) errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, layer.source, `source "${layer.source}" not found`));
            else if (sourceType === 'vector' && type === 'raster') errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, layer.source, `layer "${layer.id}" requires a raster source`));
            else if (sourceType !== 'raster-dem' && type === 'hillshade') errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, layer.source, `layer "${layer.id}" requires a raster-dem source`));
            else if (sourceType !== 'raster-dem' && type === 'color-relief') errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, layer.source, `layer "${layer.id}" requires a raster-dem source`));
            else if (sourceType === 'raster' && type !== 'raster') errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, layer.source, `layer "${layer.id}" requires a vector source`));
            else if (sourceType === 'vector' && !layer['source-layer']) errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, layer, `layer "${layer.id}" must specify a "source-layer"`));
            else if (sourceType === 'raster-dem' && type !== 'hillshade' && type !== 'color-relief') errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, layer.source, "raster-dem source can only be used with layer type 'hillshade' or 'color-relief'."));
            else if (type === 'line' && layer.paint && layer.paint['line-gradient'] && (sourceType !== 'geojson' || !source.lineMetrics)) errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, layer, `layer "${layer.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`));
        }
    }
    if (type === 'raster' && ((_a = layer.paint) === null || _a === void 0 ? void 0 : _a.resampling) && ((_b = layer.paint) === null || _b === void 0 ? void 0 : _b['raster-resampling'])) errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, layer.paint, `layer "${layer.id}" redundantly specifies "resampling" and "raster-resampling" paint properties, but only one is allowed. It is advised to use "resampling".`));
    errors = errors.concat($ed234ca8eb1f5a84$var$validateObject({
        key: key,
        value: layer,
        valueSpec: styleSpec.layer,
        style: options.style,
        styleSpec: options.styleSpec,
        validateSpec: options.validateSpec,
        objectElementValidators: {
            '*' () {
                return [];
            },
            // We don't want to enforce the spec's `"requires": true` for backward compatibility with refs;
            // the actual requirement is validated above. See https://github.com/mapbox/mapbox-gl-js/issues/5772.
            type () {
                return options.validateSpec({
                    key: `${key}.type`,
                    value: layer.type,
                    valueSpec: styleSpec.layer.type,
                    style: options.style,
                    styleSpec: options.styleSpec,
                    validateSpec: options.validateSpec,
                    object: layer,
                    objectKey: 'type'
                });
            },
            filter: $ed234ca8eb1f5a84$var$validateFilter,
            layout (options) {
                return $ed234ca8eb1f5a84$var$validateObject({
                    layer: layer,
                    key: options.key,
                    value: options.value,
                    style: options.style,
                    styleSpec: options.styleSpec,
                    validateSpec: options.validateSpec,
                    objectElementValidators: {
                        '*' (options) {
                            return $ed234ca8eb1f5a84$var$validateLayoutProperty($ed234ca8eb1f5a84$var$extendBy({
                                layerType: type
                            }, options));
                        }
                    }
                });
            },
            paint (options) {
                return $ed234ca8eb1f5a84$var$validateObject({
                    layer: layer,
                    key: options.key,
                    value: options.value,
                    style: options.style,
                    styleSpec: options.styleSpec,
                    validateSpec: options.validateSpec,
                    objectElementValidators: {
                        '*' (options) {
                            return $ed234ca8eb1f5a84$var$validatePaintProperty($ed234ca8eb1f5a84$var$extendBy({
                                layerType: type
                            }, options));
                        }
                    }
                });
            }
        }
    }));
    return errors;
}
function $ed234ca8eb1f5a84$var$validateString(options) {
    const value = options.value;
    const key = options.key;
    const type = $ed234ca8eb1f5a84$var$getType(value);
    if (type !== 'string') return [
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, `string expected, ${type} found`)
    ];
    return [];
}
function $ed234ca8eb1f5a84$var$validateRasterDEMSource(options) {
    var _a;
    const sourceName = (_a = options.sourceName) !== null && _a !== void 0 ? _a : '';
    const rasterDEM = options.value;
    const styleSpec = options.styleSpec;
    const rasterDEMSpec = styleSpec.source_raster_dem;
    const style = options.style;
    let errors = [];
    const rootType = $ed234ca8eb1f5a84$var$getType(rasterDEM);
    if (rasterDEM === undefined) return errors;
    else if (rootType !== 'object') {
        errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0('source_raster_dem', rasterDEM, `object expected, ${rootType} found`));
        return errors;
    }
    const encoding = $ed234ca8eb1f5a84$var$unbundle(rasterDEM.encoding);
    const isCustomEncoding = encoding === 'custom';
    const customEncodingKeys = [
        'redFactor',
        'greenFactor',
        'blueFactor',
        'baseShift'
    ];
    const encodingName = options.value.encoding ? `"${options.value.encoding}"` : 'Default';
    for(const key in rasterDEM){
        if (!isCustomEncoding && customEncodingKeys.includes(key)) errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, rasterDEM[key], `In "${sourceName}": "${key}" is only valid when "encoding" is set to "custom". ${encodingName} encoding found`));
        else if (rasterDEMSpec[key]) errors = errors.concat(options.validateSpec({
            key: key,
            value: rasterDEM[key],
            valueSpec: rasterDEMSpec[key],
            validateSpec: options.validateSpec,
            style: style,
            styleSpec: styleSpec
        }));
        else errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, rasterDEM[key], `unknown property "${key}"`));
    }
    return errors;
}
const $ed234ca8eb1f5a84$var$objectElementValidators = {
    promoteId: $ed234ca8eb1f5a84$var$validatePromoteId
};
function $ed234ca8eb1f5a84$var$validateSource(options) {
    const value = options.value;
    const key = options.key;
    const styleSpec = options.styleSpec;
    const style = options.style;
    const validateSpec = options.validateSpec;
    if (!value.type) return [
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, '"type" is required')
    ];
    const type = $ed234ca8eb1f5a84$var$unbundle(value.type);
    let errors;
    switch(type){
        case 'vector':
        case 'raster':
            errors = $ed234ca8eb1f5a84$var$validateObject({
                key: key,
                value: value,
                valueSpec: styleSpec[`source_${type.replace('-', '_')}`],
                style: options.style,
                styleSpec: styleSpec,
                objectElementValidators: $ed234ca8eb1f5a84$var$objectElementValidators,
                validateSpec: validateSpec
            });
            return errors;
        case 'raster-dem':
            errors = $ed234ca8eb1f5a84$var$validateRasterDEMSource({
                sourceName: key,
                value: value,
                style: options.style,
                styleSpec: styleSpec,
                validateSpec: validateSpec
            });
            return errors;
        case 'geojson':
            errors = $ed234ca8eb1f5a84$var$validateObject({
                key: key,
                value: value,
                valueSpec: styleSpec.source_geojson,
                style: style,
                styleSpec: styleSpec,
                validateSpec: validateSpec,
                objectElementValidators: $ed234ca8eb1f5a84$var$objectElementValidators
            });
            if (value.cluster) for(const prop in value.clusterProperties){
                const [operator, mapExpr] = value.clusterProperties[prop];
                const reduceExpr = typeof operator === 'string' ? [
                    operator,
                    [
                        'accumulated'
                    ],
                    [
                        'get',
                        prop
                    ]
                ] : operator;
                errors.push(...$ed234ca8eb1f5a84$var$validateExpression({
                    key: `${key}.${prop}.map`,
                    value: mapExpr,
                    expressionContext: 'cluster-map'
                }));
                errors.push(...$ed234ca8eb1f5a84$var$validateExpression({
                    key: `${key}.${prop}.reduce`,
                    value: reduceExpr,
                    expressionContext: 'cluster-reduce'
                }));
            }
            return errors;
        case 'video':
            return $ed234ca8eb1f5a84$var$validateObject({
                key: key,
                value: value,
                valueSpec: styleSpec.source_video,
                style: style,
                validateSpec: validateSpec,
                styleSpec: styleSpec
            });
        case 'image':
            return $ed234ca8eb1f5a84$var$validateObject({
                key: key,
                value: value,
                valueSpec: styleSpec.source_image,
                style: style,
                validateSpec: validateSpec,
                styleSpec: styleSpec
            });
        case 'canvas':
            return [
                new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, null, 'Please use runtime APIs to add canvas sources, rather than including them in stylesheets.', 'source.canvas')
            ];
        default:
            return $ed234ca8eb1f5a84$var$validateEnum({
                key: `${key}.type`,
                value: value.type,
                valueSpec: {
                    values: [
                        'vector',
                        'raster',
                        'raster-dem',
                        'geojson',
                        'video',
                        'image'
                    ]
                }
            });
    }
}
function $ed234ca8eb1f5a84$var$validatePromoteId({ key: key, value: value }) {
    if ($ed234ca8eb1f5a84$var$getType(value) === 'string') return $ed234ca8eb1f5a84$var$validateString({
        key: key,
        value: value
    });
    else {
        const errors = [];
        for(const prop in value)errors.push(...$ed234ca8eb1f5a84$var$validateString({
            key: `${key}.${prop}`,
            value: value[prop]
        }));
        return errors;
    }
}
function $ed234ca8eb1f5a84$var$validateLight(options) {
    const light = options.value;
    const styleSpec = options.styleSpec;
    const lightSpec = styleSpec.light;
    const style = options.style;
    let errors = [];
    const rootType = $ed234ca8eb1f5a84$var$getType(light);
    if (light === undefined) return errors;
    else if (rootType !== 'object') {
        errors = errors.concat([
            new $ed234ca8eb1f5a84$export$2191b9da168c6cf0('light', light, `object expected, ${rootType} found`)
        ]);
        return errors;
    }
    for(const key in light){
        const transitionMatch = key.match(/^(.*)-transition$/);
        if (transitionMatch && lightSpec[transitionMatch[1]] && lightSpec[transitionMatch[1]].transition) errors = errors.concat(options.validateSpec({
            key: key,
            value: light[key],
            valueSpec: styleSpec.transition,
            validateSpec: options.validateSpec,
            style: style,
            styleSpec: styleSpec
        }));
        else if (lightSpec[key]) errors = errors.concat(options.validateSpec({
            key: key,
            value: light[key],
            valueSpec: lightSpec[key],
            validateSpec: options.validateSpec,
            style: style,
            styleSpec: styleSpec
        }));
        else errors = errors.concat([
            new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, light[key], `unknown property "${key}"`)
        ]);
    }
    return errors;
}
function $ed234ca8eb1f5a84$var$validateSky(options) {
    const sky = options.value;
    const styleSpec = options.styleSpec;
    const skySpec = styleSpec.sky;
    const style = options.style;
    const rootType = $ed234ca8eb1f5a84$var$getType(sky);
    if (sky === undefined) return [];
    else if (rootType !== 'object') return [
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0('sky', sky, `object expected, ${rootType} found`)
    ];
    let errors = [];
    for(const key in sky)if (skySpec[key]) errors = errors.concat(options.validateSpec({
        key: key,
        value: sky[key],
        valueSpec: skySpec[key],
        style: style,
        styleSpec: styleSpec
    }));
    else errors = errors.concat([
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, sky[key], `unknown property "${key}"`)
    ]);
    return errors;
}
function $ed234ca8eb1f5a84$var$validateTerrain(options) {
    const terrain = options.value;
    const styleSpec = options.styleSpec;
    const terrainSpec = styleSpec.terrain;
    const style = options.style;
    let errors = [];
    const rootType = $ed234ca8eb1f5a84$var$getType(terrain);
    if (terrain === undefined) return errors;
    else if (rootType !== 'object') {
        errors = errors.concat([
            new $ed234ca8eb1f5a84$export$2191b9da168c6cf0('terrain', terrain, `object expected, ${rootType} found`)
        ]);
        return errors;
    }
    for(const key in terrain)if (terrainSpec[key]) errors = errors.concat(options.validateSpec({
        key: key,
        value: terrain[key],
        valueSpec: terrainSpec[key],
        validateSpec: options.validateSpec,
        style: style,
        styleSpec: styleSpec
    }));
    else errors = errors.concat([
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, terrain[key], `unknown property "${key}"`)
    ]);
    return errors;
}
function $ed234ca8eb1f5a84$var$validateFormatted(options) {
    if ($ed234ca8eb1f5a84$var$validateString(options).length === 0) return [];
    return $ed234ca8eb1f5a84$var$validateExpression(options);
}
function $ed234ca8eb1f5a84$var$validateImage(options) {
    if ($ed234ca8eb1f5a84$var$validateString(options).length === 0) return [];
    return $ed234ca8eb1f5a84$var$validateExpression(options);
}
function $ed234ca8eb1f5a84$var$validatePadding(options) {
    const key = options.key;
    const value = options.value;
    const type = $ed234ca8eb1f5a84$var$getType(value);
    if (type === 'array') {
        if (value.length < 1 || value.length > 4) return [
            new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, `padding requires 1 to 4 values; ${value.length} values found`)
        ];
        const arrayElementSpec = {
            type: 'number'
        };
        let errors = [];
        for(let i = 0; i < value.length; i++)errors = errors.concat(options.validateSpec({
            key: `${key}[${i}]`,
            value: value[i],
            validateSpec: options.validateSpec,
            valueSpec: arrayElementSpec
        }));
        return errors;
    } else return $ed234ca8eb1f5a84$var$validateNumber({
        key: key,
        value: value,
        valueSpec: {}
    });
}
function $ed234ca8eb1f5a84$var$validateNumberArray(options) {
    const key = options.key;
    const value = options.value;
    const type = $ed234ca8eb1f5a84$var$getType(value);
    if (type === 'array') {
        const arrayElementSpec = {
            type: 'number'
        };
        if (value.length < 1) return [
            new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, 'array length at least 1 expected, length 0 found')
        ];
        let errors = [];
        for(let i = 0; i < value.length; i++)errors = errors.concat(options.validateSpec({
            key: `${key}[${i}]`,
            value: value[i],
            validateSpec: options.validateSpec,
            valueSpec: arrayElementSpec
        }));
        return errors;
    } else return $ed234ca8eb1f5a84$var$validateNumber({
        key: key,
        value: value,
        valueSpec: {}
    });
}
function $ed234ca8eb1f5a84$var$validateColorArray(options) {
    const key = options.key;
    const value = options.value;
    const type = $ed234ca8eb1f5a84$var$getType(value);
    if (type === 'array') {
        if (value.length < 1) return [
            new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, 'array length at least 1 expected, length 0 found')
        ];
        let errors = [];
        for(let i = 0; i < value.length; i++)errors = errors.concat($ed234ca8eb1f5a84$var$validateColor({
            key: `${key}[${i}]`,
            value: value[i]
        }));
        return errors;
    } else return $ed234ca8eb1f5a84$var$validateColor({
        key: key,
        value: value
    });
}
function $ed234ca8eb1f5a84$var$validateVariableAnchorOffsetCollection(options) {
    const key = options.key;
    const value = options.value;
    const type = $ed234ca8eb1f5a84$var$getType(value);
    const styleSpec = options.styleSpec;
    if (type !== 'array' || value.length < 1 || value.length % 2 !== 0) return [
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, 'variableAnchorOffsetCollection requires a non-empty array of even length')
    ];
    let errors = [];
    for(let i = 0; i < value.length; i += 2){
        // Elements in even positions should be values from text-anchor enum
        errors = errors.concat($ed234ca8eb1f5a84$var$validateEnum({
            key: `${key}[${i}]`,
            value: value[i],
            valueSpec: styleSpec['layout_symbol']['text-anchor']
        }));
        // Elements in odd positions should be points (2-element numeric arrays)
        errors = errors.concat($ed234ca8eb1f5a84$var$validateArray({
            key: `${key}[${i + 1}]`,
            value: value[i + 1],
            valueSpec: {
                length: 2,
                value: 'number'
            },
            validateSpec: options.validateSpec,
            style: options.style,
            styleSpec: styleSpec
        }));
    }
    return errors;
}
function $ed234ca8eb1f5a84$var$validateSprite(options) {
    let errors = [];
    const sprite = options.value;
    const key = options.key;
    if (!Array.isArray(sprite)) return $ed234ca8eb1f5a84$var$validateString({
        key: key,
        value: sprite
    });
    else {
        const allSpriteIds = [];
        const allSpriteURLs = [];
        for(const i in sprite){
            if (sprite[i].id && allSpriteIds.includes(sprite[i].id)) errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, sprite, `all the sprites' ids must be unique, but ${sprite[i].id} is duplicated`));
            allSpriteIds.push(sprite[i].id);
            if (sprite[i].url && allSpriteURLs.includes(sprite[i].url)) errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, sprite, `all the sprites' URLs must be unique, but ${sprite[i].url} is duplicated`));
            allSpriteURLs.push(sprite[i].url);
            const pairSpec = {
                id: {
                    type: 'string',
                    required: true
                },
                url: {
                    type: 'string',
                    required: true
                }
            };
            errors = errors.concat($ed234ca8eb1f5a84$var$validateObject({
                key: `${key}[${i}]`,
                value: sprite[i],
                valueSpec: pairSpec,
                validateSpec: options.validateSpec
            }));
        }
        return errors;
    }
}
function $ed234ca8eb1f5a84$var$validateProjection(options) {
    const projection = options.value;
    const styleSpec = options.styleSpec;
    const projectionSpec = styleSpec.projection;
    const style = options.style;
    const rootType = $ed234ca8eb1f5a84$var$getType(projection);
    if (projection === undefined) return [];
    else if (rootType !== 'object') return [
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0('projection', projection, `object expected, ${rootType} found`)
    ];
    let errors = [];
    for(const key in projection)if (projectionSpec[key]) errors = errors.concat(options.validateSpec({
        key: key,
        value: projection[key],
        valueSpec: projectionSpec[key],
        style: style,
        styleSpec: styleSpec
    }));
    else errors = errors.concat([
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, projection[key], `unknown property "${key}"`)
    ]);
    return errors;
}
function $ed234ca8eb1f5a84$var$validateProjectionDefinition(options) {
    const key = options.key;
    let value = options.value;
    value = value instanceof String ? value.valueOf() : value;
    const type = $ed234ca8eb1f5a84$var$getType(value);
    if (type === 'array' && !$ed234ca8eb1f5a84$var$isProjectionDefinitionValue(value) && !$ed234ca8eb1f5a84$var$isPropertyValueSpecification(value)) return [
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, `projection expected, invalid array ${JSON.stringify(value)} found`)
    ];
    else if (![
        'array',
        'string'
    ].includes(type)) return [
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, `projection expected, invalid type "${type}" found`)
    ];
    return [];
}
function $ed234ca8eb1f5a84$var$isPropertyValueSpecification(value) {
    if ([
        'interpolate',
        'step',
        'literal'
    ].includes(value[0])) return true;
    return false;
}
function $ed234ca8eb1f5a84$var$isProjectionDefinitionValue(value) {
    return Array.isArray(value) && value.length === 3 && typeof value[0] === 'string' && typeof value[1] === 'string' && typeof value[2] === 'number';
}
function $ed234ca8eb1f5a84$var$isObjectLiteral(anything) {
    return Boolean(anything) && anything.constructor === Object;
}
function $ed234ca8eb1f5a84$var$validateState(options) {
    if (!$ed234ca8eb1f5a84$var$isObjectLiteral(options.value)) return [
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(options.key, options.value, `object expected, ${$ed234ca8eb1f5a84$var$getType(options.value)} found`)
    ];
    return [];
}
function $ed234ca8eb1f5a84$var$validateFontFaces(options) {
    const key = options.key;
    const value = options.value;
    const validateSpec = options.validateSpec;
    const styleSpec = options.styleSpec;
    const style = options.style;
    if (!$ed234ca8eb1f5a84$var$isObjectLiteral(value)) return [
        new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, `object expected, ${$ed234ca8eb1f5a84$var$getType(value)} found`)
    ];
    const errors = [];
    for(const fontName in value){
        const fontValue = value[fontName];
        const fontValueType = $ed234ca8eb1f5a84$var$getType(fontValue);
        if (fontValueType === 'string') // Validate as a string URL
        errors.push(...$ed234ca8eb1f5a84$var$validateString({
            key: `${key}.${fontName}`,
            value: fontValue
        }));
        else if (fontValueType === 'array') {
            // Validate as an array of font face objects
            const fontFaceSpec = {
                url: {
                    type: 'string',
                    required: true
                },
                'unicode-range': {
                    type: 'array',
                    value: 'string'
                }
            };
            for (const [i, fontFace] of fontValue.entries())errors.push(...$ed234ca8eb1f5a84$var$validateObject({
                key: `${key}.${fontName}[${i}]`,
                value: fontFace,
                valueSpec: fontFaceSpec,
                styleSpec: styleSpec,
                style: style,
                validateSpec: validateSpec
            }));
        } else errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(`${key}.${fontName}`, fontValue, `string or array expected, ${fontValueType} found`));
    }
    return errors;
}
const $ed234ca8eb1f5a84$var$VALIDATORS = {
    '*' () {
        return [];
    },
    array: $ed234ca8eb1f5a84$var$validateArray,
    boolean: $ed234ca8eb1f5a84$var$validateBoolean,
    number: $ed234ca8eb1f5a84$var$validateNumber,
    color: $ed234ca8eb1f5a84$var$validateColor,
    constants: $ed234ca8eb1f5a84$var$validateConstants,
    enum: $ed234ca8eb1f5a84$var$validateEnum,
    filter: $ed234ca8eb1f5a84$var$validateFilter,
    function: $ed234ca8eb1f5a84$var$validateFunction,
    layer: $ed234ca8eb1f5a84$var$validateLayer,
    object: $ed234ca8eb1f5a84$var$validateObject,
    source: $ed234ca8eb1f5a84$var$validateSource,
    light: $ed234ca8eb1f5a84$var$validateLight,
    sky: $ed234ca8eb1f5a84$var$validateSky,
    terrain: $ed234ca8eb1f5a84$var$validateTerrain,
    projection: $ed234ca8eb1f5a84$var$validateProjection,
    projectionDefinition: $ed234ca8eb1f5a84$var$validateProjectionDefinition,
    string: $ed234ca8eb1f5a84$var$validateString,
    formatted: $ed234ca8eb1f5a84$var$validateFormatted,
    resolvedImage: $ed234ca8eb1f5a84$var$validateImage,
    padding: $ed234ca8eb1f5a84$var$validatePadding,
    numberArray: $ed234ca8eb1f5a84$var$validateNumberArray,
    colorArray: $ed234ca8eb1f5a84$var$validateColorArray,
    variableAnchorOffsetCollection: $ed234ca8eb1f5a84$var$validateVariableAnchorOffsetCollection,
    sprite: $ed234ca8eb1f5a84$var$validateSprite,
    state: $ed234ca8eb1f5a84$var$validateState,
    fontFaces: $ed234ca8eb1f5a84$var$validateFontFaces
};
/**
 * Main recursive validation function used internally.
 * You should use `validateStyleMin` in the browser or `validateStyle` in node env.
 * @param options - the options object
 * @param options.key - string representing location of validation in style tree. Used only
 * for more informative error reporting.
 * @param options.value - current value from style being evaluated. May be anything from a
 * high level object that needs to be descended into deeper or a simple
 * scalar value.
 * @param options.valueSpec - current spec being evaluated. Tracks value.
 * @param options.styleSpec - current full spec being evaluated.
 * @param options.validateSpec - the validate function itself
 * @param options.style - the style object
 * @param options.objectElementValidators - optional object of functions that will be called
 * @returns an array of errors, or an empty array if no errors are found.
 */ function $ed234ca8eb1f5a84$export$a22775fa5e2eebd9(options) {
    const value = options.value;
    const valueSpec = options.valueSpec;
    const styleSpec = options.styleSpec;
    options.validateSpec = $ed234ca8eb1f5a84$export$a22775fa5e2eebd9;
    if (valueSpec.expression && $ed234ca8eb1f5a84$export$f6e2535fb5126e54($ed234ca8eb1f5a84$var$unbundle(value))) return $ed234ca8eb1f5a84$var$validateFunction(options);
    else if (valueSpec.expression && $ed234ca8eb1f5a84$export$3827579d8e65d9ac($ed234ca8eb1f5a84$var$deepUnbundle(value))) return $ed234ca8eb1f5a84$var$validateExpression(options);
    else if (valueSpec.type && $ed234ca8eb1f5a84$var$VALIDATORS[valueSpec.type]) return $ed234ca8eb1f5a84$var$VALIDATORS[valueSpec.type](options);
    else {
        const valid = $ed234ca8eb1f5a84$var$validateObject($ed234ca8eb1f5a84$var$extendBy({}, options, {
            valueSpec: valueSpec.type ? styleSpec[valueSpec.type] : valueSpec
        }));
        return valid;
    }
}
function $ed234ca8eb1f5a84$var$validateGlyphsUrl(options) {
    const value = options.value;
    const key = options.key;
    const errors = $ed234ca8eb1f5a84$var$validateString(options);
    if (errors.length) return errors;
    if (value.indexOf('{fontstack}') === -1) errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, '"glyphs" url must include a "{fontstack}" token'));
    if (value.indexOf('{range}') === -1) errors.push(new $ed234ca8eb1f5a84$export$2191b9da168c6cf0(key, value, '"glyphs" url must include a "{range}" token'));
    return errors;
}
/**
 * Validate a MapLibre style against the style specification.
 * Use this when running in the browser.
 *
 * @param style - The style to be validated.
 * @param styleSpec - The style specification to validate against.
 * If omitted, the latest style spec is used.
 * @returns an array of errors, or an empty array if no errors are found.
 * @example
 *   const validate = require('@maplibre/maplibre-gl-style-spec/').validateStyleMin;
 *   const errors = validate(style);
 */ function $ed234ca8eb1f5a84$export$be83f1dd677d5a48(style, styleSpec = $ed234ca8eb1f5a84$export$b8064d1c42a6b8) {
    let errors = [];
    errors = errors.concat($ed234ca8eb1f5a84$export$a22775fa5e2eebd9({
        key: '',
        value: style,
        valueSpec: styleSpec.$root,
        styleSpec: styleSpec,
        style: style,
        validateSpec: $ed234ca8eb1f5a84$export$a22775fa5e2eebd9,
        objectElementValidators: {
            glyphs: $ed234ca8eb1f5a84$var$validateGlyphsUrl,
            '*' () {
                return [];
            }
        }
    }));
    if (style['constants']) errors = errors.concat($ed234ca8eb1f5a84$var$validateConstants({
        key: 'constants',
        value: style['constants']
    }));
    return $ed234ca8eb1f5a84$var$sortErrors(errors);
}
$ed234ca8eb1f5a84$export$be83f1dd677d5a48.source = $ed234ca8eb1f5a84$var$wrapCleanErrors($ed234ca8eb1f5a84$var$injectValidateSpec($ed234ca8eb1f5a84$var$validateSource));
$ed234ca8eb1f5a84$export$be83f1dd677d5a48.sprite = $ed234ca8eb1f5a84$var$wrapCleanErrors($ed234ca8eb1f5a84$var$injectValidateSpec($ed234ca8eb1f5a84$var$validateSprite));
$ed234ca8eb1f5a84$export$be83f1dd677d5a48.glyphs = $ed234ca8eb1f5a84$var$wrapCleanErrors($ed234ca8eb1f5a84$var$injectValidateSpec($ed234ca8eb1f5a84$var$validateGlyphsUrl));
$ed234ca8eb1f5a84$export$be83f1dd677d5a48.light = $ed234ca8eb1f5a84$var$wrapCleanErrors($ed234ca8eb1f5a84$var$injectValidateSpec($ed234ca8eb1f5a84$var$validateLight));
$ed234ca8eb1f5a84$export$be83f1dd677d5a48.sky = $ed234ca8eb1f5a84$var$wrapCleanErrors($ed234ca8eb1f5a84$var$injectValidateSpec($ed234ca8eb1f5a84$var$validateSky));
$ed234ca8eb1f5a84$export$be83f1dd677d5a48.terrain = $ed234ca8eb1f5a84$var$wrapCleanErrors($ed234ca8eb1f5a84$var$injectValidateSpec($ed234ca8eb1f5a84$var$validateTerrain));
$ed234ca8eb1f5a84$export$be83f1dd677d5a48.state = $ed234ca8eb1f5a84$var$wrapCleanErrors($ed234ca8eb1f5a84$var$injectValidateSpec($ed234ca8eb1f5a84$var$validateState));
$ed234ca8eb1f5a84$export$be83f1dd677d5a48.layer = $ed234ca8eb1f5a84$var$wrapCleanErrors($ed234ca8eb1f5a84$var$injectValidateSpec($ed234ca8eb1f5a84$var$validateLayer));
$ed234ca8eb1f5a84$export$be83f1dd677d5a48.filter = $ed234ca8eb1f5a84$var$wrapCleanErrors($ed234ca8eb1f5a84$var$injectValidateSpec($ed234ca8eb1f5a84$var$validateFilter));
$ed234ca8eb1f5a84$export$be83f1dd677d5a48.paintProperty = $ed234ca8eb1f5a84$var$wrapCleanErrors($ed234ca8eb1f5a84$var$injectValidateSpec($ed234ca8eb1f5a84$var$validatePaintProperty));
$ed234ca8eb1f5a84$export$be83f1dd677d5a48.layoutProperty = $ed234ca8eb1f5a84$var$wrapCleanErrors($ed234ca8eb1f5a84$var$injectValidateSpec($ed234ca8eb1f5a84$var$validateLayoutProperty));
function $ed234ca8eb1f5a84$var$injectValidateSpec(validator) {
    return function(options) {
        return validator(Object.assign({}, options, {
            validateSpec: $ed234ca8eb1f5a84$export$a22775fa5e2eebd9
        }));
    };
}
function $ed234ca8eb1f5a84$var$sortErrors(errors) {
    return [].concat(errors).sort((a, b)=>{
        return a.line - b.line;
    });
}
function $ed234ca8eb1f5a84$var$wrapCleanErrors(inner) {
    return function(...args) {
        return $ed234ca8eb1f5a84$var$sortErrors(inner.apply(this, args));
    };
}
// Note: This regex matches even invalid JSON strings, but since we’re
// working on the output of `JSON.stringify` we know that only valid strings
// are present (unless the user supplied a weird `options.indent` but in
// that case we don’t care since the output would be invalid anyway).
const $ed234ca8eb1f5a84$var$stringOrChar = /("(?:[^\\"]|\\.)*")|[:,]/g;
function $ed234ca8eb1f5a84$var$stringify(passedObj, options = {}) {
    const indent = JSON.stringify([
        1
    ], undefined, options.indent === undefined ? 2 : options.indent).slice(2, -3);
    const maxLength = indent === "" ? Infinity : options.maxLength === undefined ? 80 : options.maxLength;
    let { replacer: replacer } = options;
    return function _stringify(obj, currentIndent, reserved) {
        if (obj && typeof obj.toJSON === "function") obj = obj.toJSON();
        const string = JSON.stringify(obj, replacer);
        if (string === undefined) return string;
        const length = maxLength - currentIndent.length - reserved;
        if (string.length <= length) {
            const prettified = string.replace($ed234ca8eb1f5a84$var$stringOrChar, (match, stringLiteral)=>{
                return stringLiteral || `${match} `;
            });
            if (prettified.length <= length) return prettified;
        }
        if (replacer != null) {
            obj = JSON.parse(string);
            replacer = undefined;
        }
        if (typeof obj === "object" && obj !== null) {
            const nextIndent = currentIndent + indent;
            const items = [];
            let index = 0;
            let start;
            let end;
            if (Array.isArray(obj)) {
                start = "[";
                end = "]";
                const { length: length } = obj;
                for(; index < length; index++)items.push(_stringify(obj[index], nextIndent, index === length - 1 ? 0 : 1) || "null");
            } else {
                start = "{";
                end = "}";
                const keys = Object.keys(obj);
                const { length: length } = keys;
                for(; index < length; index++){
                    const key = keys[index];
                    const keyPart = `${JSON.stringify(key)}: `;
                    const value = _stringify(obj[key], nextIndent, keyPart.length + (index === length - 1 ? 0 : 1));
                    if (value !== undefined) items.push(keyPart + value);
                }
            }
            if (items.length > 0) return [
                start,
                indent + items.join(`,\n${nextIndent}`),
                end
            ].join(`\n${currentIndent}`);
        }
        return string;
    }(passedObj, "", 0);
}
function $ed234ca8eb1f5a84$var$sortKeysBy(obj, reference) {
    const result = {};
    for(const key in reference)if (obj[key] !== undefined) result[key] = obj[key];
    for(const key in obj)if (result[key] === undefined) result[key] = obj[key];
    return result;
}
/**
 * Format a MapLibre Style.  Returns a stringified style with its keys
 * sorted in the same order as the reference style.
 *
 * The optional `space` argument is passed to
 * [`JSON.stringify`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify)
 * to generate formatted output.
 *
 * If `space` is unspecified, a default of `2` spaces will be used.
 *
 * @private
 * @param {Object} style a MapLibre Style
 * @param {number} [space] space argument to pass to `JSON.stringify`
 * @returns {string} stringified formatted JSON
 * @example
 * var fs = require('fs');
 * var format = require('maplibre-gl-style-spec').format;
 * var style = fs.readFileSync('./source.json', 'utf8');
 * fs.writeFileSync('./dest.json', format(style));
 * fs.writeFileSync('./dest.min.json', format(style, 0));
 */ function $ed234ca8eb1f5a84$export$d9468344d3651243(style, space = 2) {
    style = $ed234ca8eb1f5a84$var$sortKeysBy(style, $ed234ca8eb1f5a84$export$b8064d1c42a6b8.$root);
    if (style.layers) style.layers = style.layers.map((layer)=>$ed234ca8eb1f5a84$var$sortKeysBy(layer, $ed234ca8eb1f5a84$export$b8064d1c42a6b8.layer));
    return $ed234ca8eb1f5a84$var$stringify(style, {
        indent: space
    });
}
function $ed234ca8eb1f5a84$var$eachLayout(layer, callback) {
    for(const k in layer)if (k.indexOf('layout') === 0) callback(layer[k], k);
}
function $ed234ca8eb1f5a84$var$eachPaint(layer, callback) {
    for(const k in layer)if (k.indexOf('paint') === 0) callback(layer[k], k);
}
function $ed234ca8eb1f5a84$var$resolveConstant(style, value) {
    if (typeof value === 'string' && value[0] === '@') return $ed234ca8eb1f5a84$var$resolveConstant(style, style.constants[value]);
    else return value;
}
function $ed234ca8eb1f5a84$var$isFunction(value) {
    return Array.isArray(value.stops);
}
function $ed234ca8eb1f5a84$var$renameProperty(obj, from, to) {
    obj[to] = obj[from];
    delete obj[from];
}
function $ed234ca8eb1f5a84$var$migrateV8(style) {
    style.version = 8;
    // Rename properties, reverse coordinates in source and layers
    $ed234ca8eb1f5a84$var$eachSource(style, (source)=>{
        if (source.type === 'video' && source['url'] !== undefined) $ed234ca8eb1f5a84$var$renameProperty(source, 'url', 'urls');
        if (source.type === 'video') source.coordinates.forEach((coord)=>{
            return coord.reverse();
        });
    });
    $ed234ca8eb1f5a84$var$eachLayer(style, (layer)=>{
        $ed234ca8eb1f5a84$var$eachLayout(layer, (layout)=>{
            if (layout['symbol-min-distance'] !== undefined) $ed234ca8eb1f5a84$var$renameProperty(layout, 'symbol-min-distance', 'symbol-spacing');
        });
        $ed234ca8eb1f5a84$var$eachPaint(layer, (paint)=>{
            if (paint['background-image'] !== undefined) $ed234ca8eb1f5a84$var$renameProperty(paint, 'background-image', 'background-pattern');
            if (paint['line-image'] !== undefined) $ed234ca8eb1f5a84$var$renameProperty(paint, 'line-image', 'line-pattern');
            if (paint['fill-image'] !== undefined) $ed234ca8eb1f5a84$var$renameProperty(paint, 'fill-image', 'fill-pattern');
        });
    });
    // Inline Constants
    $ed234ca8eb1f5a84$var$eachProperty(style, {
        paint: true,
        layout: true
    }, (property)=>{
        const value = $ed234ca8eb1f5a84$var$resolveConstant(style, property.value);
        if ($ed234ca8eb1f5a84$var$isFunction(value)) value.stops.forEach((stop)=>{
            stop[1] = $ed234ca8eb1f5a84$var$resolveConstant(style, stop[1]);
        });
        property.set(value);
    });
    delete style['constants'];
    $ed234ca8eb1f5a84$var$eachLayer(style, (layer)=>{
        // get rid of text-max-size, icon-max-size
        // turn text-size, icon-size into layout properties
        // https://github.com/mapbox/mapbox-gl-style-spec/issues/255
        $ed234ca8eb1f5a84$var$eachLayout(layer, (layout)=>{
            delete layout['text-max-size'];
            delete layout['icon-max-size'];
        });
        $ed234ca8eb1f5a84$var$eachPaint(layer, (paint)=>{
            if (paint['text-size']) {
                if (!layer.layout) layer.layout = {};
                layer.layout['text-size'] = paint['text-size'];
                delete paint['text-size'];
            }
            if (paint['icon-size']) {
                if (!layer.layout) layer.layout = {};
                layer.layout['icon-size'] = paint['icon-size'];
                delete paint['icon-size'];
            }
        });
    });
    function migrateFontStack(font) {
        function splitAndTrim(string) {
            return string.split(',').map((s)=>{
                return s.trim();
            });
        }
        if (Array.isArray(font)) // Assume it's a previously migrated font-array.
        return font;
        else if (typeof font === 'string') return splitAndTrim(font);
        else if (typeof font === 'object') {
            font.stops.forEach((stop)=>{
                stop[1] = splitAndTrim(stop[1]);
            });
            return font;
        } else throw new Error('unexpected font value');
    }
    $ed234ca8eb1f5a84$var$eachLayer(style, (layer)=>{
        $ed234ca8eb1f5a84$var$eachLayout(layer, (layout)=>{
            if (layout['text-font']) layout['text-font'] = migrateFontStack(layout['text-font']);
        });
    });
    // Reverse order of symbol layers. This is an imperfect migration.
    //
    // The order of a symbol layer in the layers list affects two things:
    // - how it is drawn relative to other layers (like oneway arrows below bridges)
    // - the placement priority compared to other layers
    //
    // It's impossible to reverse the placement priority without breaking the draw order
    // in some cases. This migration only reverses the order of symbol layers that
    // are above all other types of layers.
    //
    // Symbol layers that are at the top of the map preserve their priority.
    // Symbol layers that are below another type (line, fill) of layer preserve their draw order.
    let firstSymbolLayer = 0;
    for(let i = style.layers.length - 1; i >= 0; i--){
        const layer = style.layers[i];
        if (layer.type !== 'symbol') {
            firstSymbolLayer = i + 1;
            break;
        }
    }
    const symbolLayers = style.layers.splice(firstSymbolLayer);
    symbolLayers.reverse();
    style.layers = style.layers.concat(symbolLayers);
    return style;
}
/**
 * Migrate the given style object in place to use expressions. Specifically,
 * this will convert (a) "stop" functions, and (b) legacy filters to their
 * expression equivalents.
 * @param style The style object to migrate.
 * @returns The migrated style object.
 */ function $ed234ca8eb1f5a84$var$expressions(style) {
    const converted = [];
    $ed234ca8eb1f5a84$var$eachLayer(style, (layer)=>{
        if (layer.filter) layer.filter = $ed234ca8eb1f5a84$export$d9541b7df4c07683(layer.filter);
    });
    $ed234ca8eb1f5a84$var$eachProperty(style, {
        paint: true,
        layout: true
    }, ({ path: path, key: key, value: value, reference: reference, set: set })=>{
        if ($ed234ca8eb1f5a84$export$3827579d8e65d9ac(value) || key.endsWith('-transition') || reference === null) return;
        if (typeof value === 'object' && !Array.isArray(value)) {
            set($ed234ca8eb1f5a84$export$4ffa6b66a9b9e443(value, reference));
            converted.push(path.join('.'));
        } else if (reference.tokens && typeof value === 'string') set($ed234ca8eb1f5a84$var$convertTokenString(value));
    });
    return style;
}
/**
 * Migrate color style values to supported format.
 *
 * @param colorToMigrate Color value to migrate, could be a string or an expression.
 * @returns Color style value in supported format.
 */ function $ed234ca8eb1f5a84$var$migrateColors(colorToMigrate) {
    return JSON.parse($ed234ca8eb1f5a84$var$migrateHslColors(JSON.stringify(colorToMigrate)));
}
/**
 * Created to migrate from colors supported by the former CSS color parsing
 * library `csscolorparser` but not compliant with the CSS Color specification,
 * like `hsl(900, 0.15, 90%)`.
 *
 * @param colorToMigrate Serialized color style value.
 * @returns A serialized color style value in which all non-standard hsl color values
 * have been converted to a format that complies with the CSS Color specification.
 *
 * @example
 * migrateHslColors('"hsl(900, 0.15, 90%)"'); // returns '"hsl(900, 15%, 90%)"'
 * migrateHslColors('"hsla(900, .15, .9)"'); // returns '"hsl(900, 15%, 90%)"'
 * migrateHslColors('"hsl(900, 15%, 90%)"'); // returns '"hsl(900, 15%, 90%)"' - no changes
 */ function $ed234ca8eb1f5a84$var$migrateHslColors(colorToMigrate) {
    return colorToMigrate.replace(/"hsla?\((.+?)\)"/gi, (match, hslArgs)=>{
        const argsMatch = hslArgs.match(/^(.+?)\s*,\s*(.+?)\s*,\s*(.+?)(?:\s*,\s*(.+))?$/i);
        if (argsMatch) {
            let [h, s, l, a] = argsMatch.slice(1);
            [s, l] = [
                s,
                l
            ].map((v)=>v.endsWith('%') ? v : `${parseFloat(v) * 100}%`);
            return `"hsl${typeof a === 'string' ? 'a' : ''}(${[
                h,
                s,
                l,
                a
            ].filter(Boolean).join(',')})"`;
        }
        return match;
    });
}
/**
 * Migrate a Mapbox/MapLibre GL Style to the latest version.
 *
 * @param style - a MapLibre Style
 * @returns a migrated style
 * @example
 * const fs = require('fs');
 * const migrate = require('@maplibre/maplibre-gl-style-spec').migrate;
 * const style = fs.readFileSync('./style.json', 'utf8');
 * fs.writeFileSync('./style.json', JSON.stringify(migrate(style)));
 */ function $ed234ca8eb1f5a84$export$ce7f407e15fce6b5(style) {
    let migrated = false;
    if (style.version === 7) {
        style = $ed234ca8eb1f5a84$var$migrateV8(style);
        migrated = true;
    }
    if (style.version === 8) {
        migrated = !!$ed234ca8eb1f5a84$var$expressions(style);
        migrated = true;
    }
    $ed234ca8eb1f5a84$var$eachProperty(style, {
        paint: true,
        layout: true
    }, ({ value: value, reference: reference, set: set })=>{
        if ((reference === null || reference === void 0 ? void 0 : reference.type) === 'color') set($ed234ca8eb1f5a84$var$migrateColors(value));
    });
    if (!migrated) throw new Error(`Cannot migrate from ${style.version}`);
    return style;
}
const $ed234ca8eb1f5a84$var$visibilitySpec = {
    type: 'enum',
    'property-type': 'data-constant',
    expression: {
        interpolated: false,
        parameters: [
            'global-state'
        ]
    },
    values: {
        visible: {},
        none: {}
    },
    transition: false,
    default: 'visible'
};
class $ed234ca8eb1f5a84$var$VisibilityExpressionClass {
    constructor(visibility, globalState){
        this._globalState = globalState;
        this.setValue(visibility);
    }
    evaluate() {
        var _a;
        return (_a = this._literalValue) !== null && _a !== void 0 ? _a : this._compiledValue.evaluate({});
    }
    setValue(visibility) {
        if (visibility === null || visibility === undefined || visibility === 'visible' || visibility === 'none') {
            this._literalValue = visibility === 'none' ? 'none' : 'visible';
            this._compiledValue = undefined;
            this._globalStateRefs = new Set();
            return;
        }
        const compiled = $ed234ca8eb1f5a84$export$e2f07551fdfaf6b7(visibility, $ed234ca8eb1f5a84$var$visibilitySpec, this._globalState);
        if (compiled.result === 'error') {
            this._literalValue = 'visible';
            this._compiledValue = undefined;
            throw new Error(compiled.value.map((err)=>`${err.key}: ${err.message}`).join(', '));
        }
        this._literalValue = undefined;
        this._compiledValue = compiled.value;
        this._globalStateRefs = $ed234ca8eb1f5a84$var$findGlobalStateRefs(compiled.value.expression);
    }
    getGlobalStateRefs() {
        return this._globalStateRefs;
    }
}
/**
 * Creates a visibility expression from a visibility specification.
 * @param visibility - the visibility specification, literal or expression
 * @param globalState - the global state object
 * @returns visibility expression object
 */ function $ed234ca8eb1f5a84$export$f8a44b273f2b4281(visibility, globalState) {
    return new $ed234ca8eb1f5a84$var$VisibilityExpressionClass(visibility, globalState);
}
const $ed234ca8eb1f5a84$export$f94bee7ded07ee77 = $ed234ca8eb1f5a84$export$b8064d1c42a6b8;
const $ed234ca8eb1f5a84$export$743d82c2fd345b72 = {
    StyleExpression: $ed234ca8eb1f5a84$export$cc950d8c87493baa,
    StylePropertyFunction: $ed234ca8eb1f5a84$export$c9163cfd00403256,
    ZoomConstantExpression: $ed234ca8eb1f5a84$export$75c155ef6e139073,
    ZoomDependentExpression: $ed234ca8eb1f5a84$export$2b27898b9034955,
    createExpression: $ed234ca8eb1f5a84$export$e2f07551fdfaf6b7,
    createPropertyExpression: $ed234ca8eb1f5a84$export$64925a39029a32a,
    isExpression: $ed234ca8eb1f5a84$export$3827579d8e65d9ac,
    isExpressionFilter: $ed234ca8eb1f5a84$var$isExpressionFilter,
    isZoomExpression: $ed234ca8eb1f5a84$export$6f0fad737814f2a3,
    normalizePropertyExpression: $ed234ca8eb1f5a84$export$b2ea9b0a6124ba04
};
const $ed234ca8eb1f5a84$export$44e51c8aac7c2deb = {
    convertFunction: $ed234ca8eb1f5a84$export$4ffa6b66a9b9e443,
    createFunction: $ed234ca8eb1f5a84$export$74ab6113d805deb,
    isFunction: $ed234ca8eb1f5a84$export$f6e2535fb5126e54
};
const $ed234ca8eb1f5a84$export$bf638b60ea8b89b7 = {
    eachLayer: $ed234ca8eb1f5a84$var$eachLayer,
    eachProperty: $ed234ca8eb1f5a84$var$eachProperty,
    eachSource: $ed234ca8eb1f5a84$var$eachSource
};


/**
 * @module ol/Map
 */ /**
 * @module ol/Collection
 */ /**
 * @module ol/CollectionEventType
 */ /**
 * @enum {string}
 */ var $d4ae00bf358e4687$export$2e2bcd8739ae039 = {
    /**
   * Triggered when an item is added to the collection.
   * @event module:ol/Collection.CollectionEvent#add
   * @api
   */ ADD: 'add',
    /**
   * Triggered when an item is removed from the collection.
   * @event module:ol/Collection.CollectionEvent#remove
   * @api
   */ REMOVE: 'remove'
};


/**
 * @module ol/Object
 */ /**
 * @module ol/ObjectEventType
 */ /**
 * @enum {string}
 */ var $026be6c727dde691$export$2e2bcd8739ae039 /**
 * @typedef {'propertychange'} Types
 */  = {
    /**
   * Triggered when a property is changed.
   * @event module:ol/Object.ObjectEvent#propertychange
   * @api
   */ PROPERTYCHANGE: 'propertychange'
};


/**
 * @module ol/Observable
 */ /**
 * @module ol/events
 */ /**
 * @module ol/obj
 */ /**
 * Removes all properties from an object.
 * @param {Object<string, unknown>} object The object to clear.
 */ function $0669c62275461b52$export$42ffd38884aecdac(object) {
    for(const property in object)delete object[property];
}
function $0669c62275461b52$export$dd1bc94b04021eeb(object) {
    let property;
    for(property in object)return false;
    return !property;
}


function $8061a5de9380012b$export$63174c828edd6ff8(target, type, listener, thisArg, once) {
    if (once) {
        const originalListener = listener;
        /**
     * @param {Event|import('./events/Event.js').default} event The event
     * @return {void|boolean} When the function returns `false`, event propagation will stop.
     * @this {typeof target}
     */ listener = function(event) {
            target.removeEventListener(type, listener);
            return originalListener.call(thisArg ?? this, event);
        };
    } else if (thisArg && thisArg !== target) listener = listener.bind(thisArg);
    const eventsKey = {
        target: target,
        type: type,
        listener: listener
    };
    target.addEventListener(type, listener);
    return eventsKey;
}
function $8061a5de9380012b$export$8d2a95bc11b44725(target, type, listener, thisArg) {
    return $8061a5de9380012b$export$63174c828edd6ff8(target, type, listener, thisArg, true);
}
function $8061a5de9380012b$export$b0a21c8b3c1c921(key) {
    if (key && key.target) {
        key.target.removeEventListener(key.type, key.listener);
        (0, $0669c62275461b52$export$42ffd38884aecdac)(key);
    }
}


/**
 * @module ol/events/EventType
 */ /**
 * @enum {string}
 * @const
 */ var $8bf15f3d9474ce85$export$2e2bcd8739ae039 = {
    /**
   * Generic change event. Triggered when the revision counter is increased.
   * @event module:ol/events/Event~BaseEvent#change
   * @api
   */ CHANGE: 'change',
    /**
   * Generic error event. Triggered when an error occurs.
   * @event module:ol/events/Event~BaseEvent#error
   * @api
   */ ERROR: 'error',
    BLUR: 'blur',
    CLEAR: 'clear',
    CONTEXTMENU: 'contextmenu',
    CLICK: 'click',
    DBLCLICK: 'dblclick',
    DRAGENTER: 'dragenter',
    DRAGOVER: 'dragover',
    DROP: 'drop',
    FOCUS: 'focus',
    KEYDOWN: 'keydown',
    KEYPRESS: 'keypress',
    LOAD: 'load',
    RESIZE: 'resize',
    TOUCHMOVE: 'touchmove',
    WHEEL: 'wheel'
};


/**
 * @module ol/events/Target
 */ /**
 * @module ol/Disposable
 */ /**
 * @classdesc
 * Objects that need to clean up after themselves.
 */ class $b54235dad6714a76$var$Disposable {
    constructor(){
        /**
     * The object has already been disposed.
     * @type {boolean}
     * @protected
     */ this.disposed = false;
    }
    /**
   * Clean up.
   */ dispose() {
        if (!this.disposed) {
            this.disposed = true;
            this.disposeInternal();
        }
    }
    /**
   * Extension point for disposable objects.
   * @protected
   */ disposeInternal() {}
}
var $b54235dad6714a76$export$2e2bcd8739ae039 = $b54235dad6714a76$var$Disposable;


/**
 * @module ol/functions
 */ /**
 * @module ol/array
 */ /**
 * Performs a binary search on the provided sorted list and returns the index of the item if found. If it can't be found it'll return -1.
 * https://github.com/darkskyapp/binary-search
 *
 * @param {Array<*>} haystack Items to search through.
 * @param {*} needle The item to look for.
 * @param {Function} [comparator] Comparator function.
 * @return {number} The index of the item if found, -1 if not.
 */ function $db525acb5f2517fc$export$2e0ae67339d5f1ac(haystack, needle, comparator) {
    let mid, cmp;
    comparator = comparator || $db525acb5f2517fc$export$fcb633242ef15540;
    let low = 0;
    let high = haystack.length;
    let found = false;
    while(low < high){
        /* Note that "(low + high) >>> 1" may overflow, and results in a typecast
     * to double (which gives the wrong results). */ mid = low + (high - low >> 1);
        cmp = +comparator(haystack[mid], needle);
        if (cmp < 0.0) /* Too low. */ low = mid + 1;
        else {
            /* Key found or too high */ high = mid;
            found = !cmp;
        }
    }
    /* Key not found. */ return found ? low : ~low;
}
function $db525acb5f2517fc$export$fcb633242ef15540(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
}
function $db525acb5f2517fc$export$4fa3190a997c3d8f(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
}
function $db525acb5f2517fc$export$8a3786cc03fdb777(arr, target, direction) {
    if (arr[0] <= target) return 0;
    const n = arr.length;
    if (target <= arr[n - 1]) return n - 1;
    if (typeof direction === 'function') {
        for(let i = 1; i < n; ++i){
            const candidate = arr[i];
            if (candidate === target) return i;
            if (candidate < target) {
                if (direction(target, arr[i - 1], candidate) > 0) return i - 1;
                return i;
            }
        }
        return n - 1;
    }
    if (direction > 0) {
        for(let i = 1; i < n; ++i){
            if (arr[i] < target) return i - 1;
        }
        return n - 1;
    }
    if (direction < 0) {
        for(let i = 1; i < n; ++i){
            if (arr[i] <= target) return i;
        }
        return n - 1;
    }
    for(let i = 1; i < n; ++i){
        if (arr[i] == target) return i;
        if (arr[i] < target) {
            if (arr[i - 1] - target < target - arr[i]) return i - 1;
            return i;
        }
    }
    return n - 1;
}
function $db525acb5f2517fc$export$292cfa960964f0e0(arr, begin, end) {
    while(begin < end){
        const tmp = arr[begin];
        arr[begin] = arr[end];
        arr[end] = tmp;
        ++begin;
        --end;
    }
}
function $db525acb5f2517fc$export$8b58be045bf06082(arr, data) {
    const extension = Array.isArray(data) ? data : [
        data
    ];
    const length = extension.length;
    for(let i = 0; i < length; i++)arr[arr.length] = extension[i];
}
function $db525acb5f2517fc$export$cd7f480d6b8286c3(arr, obj) {
    const i = arr.indexOf(obj);
    const found = i > -1;
    if (found) arr.splice(i, 1);
    return found;
}
function $db525acb5f2517fc$export$e9bab7fafb253603(arr1, arr2) {
    const len1 = arr1.length;
    if (len1 !== arr2.length) return false;
    for(let i = 0; i < len1; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}
function $db525acb5f2517fc$export$c7d3d1f96a700512(arr, compareFnc) {
    const length = arr.length;
    const tmp = Array(arr.length);
    let i;
    for(i = 0; i < length; i++)tmp[i] = {
        index: i,
        value: arr[i]
    };
    tmp.sort(function(a, b) {
        return compareFnc(a.value, b.value) || a.index - b.index;
    });
    for(i = 0; i < arr.length; i++)arr[i] = tmp[i].value;
}
function $db525acb5f2517fc$export$efa610630f9e181(arr, func, strict) {
    const compare = func || $db525acb5f2517fc$export$fcb633242ef15540;
    return arr.every(function(currentVal, index) {
        if (index === 0) return true;
        const res = compare(arr[index - 1], currentVal);
        return !(res > 0 || strict && res === 0);
    });
}


function $7efea016d660e267$export$22e23a2304399231() {
    return true;
}
function $7efea016d660e267$export$8f11cee4bdc7e668() {
    return false;
}
function $7efea016d660e267$export$1cd1943b3a73bbe8() {}
function $7efea016d660e267$export$ff83df6f9971435f(fn) {
    /** @type {ReturnType} */ let lastResult;
    /** @type {Array<any>|undefined} */ let lastArgs;
    let lastThis;
    /**
   * @this {*} Only need to know if `this` changed, don't care what type
   * @return {ReturnType} Memoized value
   */ return function() {
        const nextArgs = Array.prototype.slice.call(arguments);
        if (!lastArgs || this !== lastThis || !(0, $db525acb5f2517fc$export$e9bab7fafb253603)(nextArgs, lastArgs)) {
            lastThis = this;
            lastArgs = nextArgs;
            lastResult = fn.apply(this, arguments);
        }
        return lastResult;
    };
}
function $7efea016d660e267$export$4dbaaf6c79705e6c(getter) {
    function promiseGetter() {
        let value;
        try {
            value = getter();
        } catch (err) {
            return Promise.reject(err);
        }
        if (value instanceof Promise) return value;
        return Promise.resolve(value);
    }
    return promiseGetter();
}



/**
 * @module ol/events/Event
 */ /**
 * @classdesc
 * Stripped down implementation of the W3C DOM Level 2 Event interface.
 * See https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-interface.
 *
 * This implementation only provides `type` and `target` properties, and
 * `stopPropagation` and `preventDefault` methods. It is meant as base class
 * for higher level events defined in the library, and works with
 * {@link module:ol/events/Target~Target}.
 */ class $bc90848f8b15fa29$var$BaseEvent {
    /**
   * @param {string} type Type.
   */ constructor(type){
        /**
     * @type {boolean}
     */ this.propagationStopped;
        /**
     * @type {boolean}
     */ this.defaultPrevented;
        /**
     * The event type.
     * @type {string}
     * @api
     */ this.type = type;
        /**
     * The event target.
     * @type {Object}
     * @api
     */ this.target = null;
    }
    /**
   * Prevent default. This means that no emulated `click`, `singleclick` or `doubleclick` events
   * will be fired.
   * @api
   */ preventDefault() {
        this.defaultPrevented = true;
    }
    /**
   * Stop event propagation.
   * @api
   */ stopPropagation() {
        this.propagationStopped = true;
    }
}
function $bc90848f8b15fa29$export$51134cce184326b9(evt) {
    evt.stopPropagation();
}
function $bc90848f8b15fa29$export$fa3b29edae795ef4(evt) {
    evt.preventDefault();
}
var $bc90848f8b15fa29$export$2e2bcd8739ae039 = $bc90848f8b15fa29$var$BaseEvent;


/**
 * @typedef {EventTarget|Target} EventTargetLike
 */ /**
 * @classdesc
 * A simplified implementation of the W3C DOM Level 2 EventTarget interface.
 * See https://www.w3.org/TR/2000/REC-DOM-Level-2-Events-20001113/events.html#Events-EventTarget.
 *
 * There are two important simplifications compared to the specification:
 *
 * 1. The handling of `useCapture` in `addEventListener` and
 *    `removeEventListener`. There is no real capture model.
 * 2. The handling of `stopPropagation` and `preventDefault` on `dispatchEvent`.
 *    There is no event target hierarchy. When a listener calls
 *    `stopPropagation` or `preventDefault` on an event object, it means that no
 *    more listeners after this one will be called. Same as when the listener
 *    returns false.
 */ class $8c60cc978e8694f4$var$Target extends (0, $b54235dad6714a76$export$2e2bcd8739ae039) {
    /**
   * @param {*} [target] Default event target for dispatched events.
   */ constructor(target){
        super();
        /**
     * @private
     * @type {*}
     */ this.eventTarget_ = target;
        /**
     * @private
     * @type {Object<string, number>|null}
     */ this.pendingRemovals_ = null;
        /**
     * @private
     * @type {Object<string, number>|null}
     */ this.dispatching_ = null;
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").Listener>>|null}
     */ this.listeners_ = null;
    }
    /**
   * @param {string} type Type.
   * @param {import("../events.js").Listener} listener Listener.
   */ addEventListener(type, listener) {
        if (!type || !listener) return;
        const listeners = this.listeners_ || (this.listeners_ = {});
        const listenersForType = listeners[type] || (listeners[type] = []);
        if (!listenersForType.includes(listener)) listenersForType.push(listener);
    }
    /**
   * Dispatches an event and calls all listeners listening for events
   * of this type. The event parameter can either be a string or an
   * Object with a `type` property.
   *
   * @param {import("./Event.js").default|string} event Event object.
   * @return {boolean|undefined} `false` if anyone called preventDefault on the
   *     event object or if any of the listeners returned false.
   * @api
   */ dispatchEvent(event) {
        const isString = typeof event === 'string';
        const type = isString ? event : event.type;
        const listeners = this.listeners_ && this.listeners_[type];
        if (!listeners) return;
        const evt = isString ? new (0, $bc90848f8b15fa29$export$2e2bcd8739ae039)(event) : /** @type {Event} */ event;
        if (!evt.target) evt.target = this.eventTarget_ || this;
        const dispatching = this.dispatching_ || (this.dispatching_ = {});
        const pendingRemovals = this.pendingRemovals_ || (this.pendingRemovals_ = {});
        if (!(type in dispatching)) {
            dispatching[type] = 0;
            pendingRemovals[type] = 0;
        }
        ++dispatching[type];
        let propagate;
        for(let i = 0, ii = listeners.length; i < ii; ++i){
            if ('handleEvent' in listeners[i]) propagate = /** @type {import("../events.js").ListenerObject} */ listeners[i].handleEvent(evt);
            else propagate = /** @type {import("../events.js").ListenerFunction} */ listeners[i].call(this, evt);
            if (propagate === false || evt.propagationStopped) {
                propagate = false;
                break;
            }
        }
        if (--dispatching[type] === 0) {
            let pr = pendingRemovals[type];
            delete pendingRemovals[type];
            while(pr--)this.removeEventListener(type, (0, $7efea016d660e267$export$1cd1943b3a73bbe8));
            delete dispatching[type];
        }
        return propagate;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.listeners_ && (0, $0669c62275461b52$export$42ffd38884aecdac)(this.listeners_);
    }
    /**
   * Get the listeners for a specified event type. Listeners are returned in the
   * order that they will be called in.
   *
   * @param {string} type Type.
   * @return {Array<import("../events.js").Listener>|undefined} Listeners.
   */ getListeners(type) {
        return this.listeners_ && this.listeners_[type] || undefined;
    }
    /**
   * @param {string} [type] Type. If not provided,
   *     `true` will be returned if this event target has any listeners.
   * @return {boolean} Has listeners.
   */ hasListener(type) {
        if (!this.listeners_) return false;
        return type ? type in this.listeners_ : Object.keys(this.listeners_).length > 0;
    }
    /**
   * @param {string} type Type.
   * @param {import("../events.js").Listener} listener Listener.
   */ removeEventListener(type, listener) {
        if (!this.listeners_) return;
        const listeners = this.listeners_[type];
        if (!listeners) return;
        const index = listeners.indexOf(listener);
        if (index !== -1) {
            if (this.pendingRemovals_ && type in this.pendingRemovals_) {
                // make listener a no-op, and remove later in #dispatchEvent()
                listeners[index] = (0, $7efea016d660e267$export$1cd1943b3a73bbe8);
                ++this.pendingRemovals_[type];
            } else {
                listeners.splice(index, 1);
                if (listeners.length === 0) delete this.listeners_[type];
            }
        }
    }
}
var $8c60cc978e8694f4$export$2e2bcd8739ae039 = $8c60cc978e8694f4$var$Target;


/***
 * @template {string} Type
 * @template {Event|import("./events/Event.js").default} EventClass
 * @template Return
 * @typedef {(type: Type, listener: (event: EventClass) => ?) => Return} OnSignature
 */ /***
 * @template {string} Type
 * @template Return
 * @typedef {(type: Type[], listener: (event: Event|import("./events/Event.js").default) => ?) => Return extends void ? void : Return[]} CombinedOnSignature
 */ /**
 * @typedef {'change'|'error'} EventTypes
 */ /***
 * @template Return
 * @typedef {OnSignature<EventTypes, import("./events/Event.js").default, Return> & CombinedOnSignature<EventTypes, Return>} ObservableOnSignature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * An event target providing convenient methods for listener registration
 * and unregistration. A generic `change` event is always available through
 * {@link module:ol/Observable~Observable#changed}.
 *
 * @fires import("./events/Event.js").default
 * @api
 */ class $efe31481b2126ee6$var$Observable extends (0, $8c60cc978e8694f4$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.on = /** @type {ObservableOnSignature<import("./events.js").EventsKey>} */ this.onInternal;
        this.once = /** @type {ObservableOnSignature<import("./events.js").EventsKey>} */ this.onceInternal;
        this.un = /** @type {ObservableOnSignature<void>} */ this.unInternal;
        /**
     * @private
     * @type {number}
     */ this.revision_ = 0;
    }
    /**
   * Increases the revision counter and dispatches a 'change' event.
   * @api
   */ changed() {
        ++this.revision_;
        this.dispatchEvent((0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CHANGE);
    }
    /**
   * Get the version number for this object.  Each time the object is modified,
   * its version number will be incremented.
   * @return {number} Revision.
   * @api
   */ getRevision() {
        return this.revision_;
    }
    /**
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event.js").default)): ?} listener Listener.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
   * @protected
   */ onInternal(type, listener) {
        if (Array.isArray(type)) {
            const len = type.length;
            const keys = new Array(len);
            for(let i = 0; i < len; ++i)keys[i] = (0, $8061a5de9380012b$export$63174c828edd6ff8)(this, type[i], listener);
            return keys;
        }
        return (0, $8061a5de9380012b$export$63174c828edd6ff8)(this, /** @type {string} */ type, listener);
    }
    /**
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event.js").default)): ?} listener Listener.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
   * @protected
   */ onceInternal(type, listener) {
        let key;
        if (Array.isArray(type)) {
            const len = type.length;
            key = new Array(len);
            for(let i = 0; i < len; ++i)key[i] = (0, $8061a5de9380012b$export$8d2a95bc11b44725)(this, type[i], listener);
        } else key = (0, $8061a5de9380012b$export$8d2a95bc11b44725)(this, /** @type {string} */ type, listener);
        /** @type {Object} */ listener.ol_key = key;
        return key;
    }
    /**
   * Unlisten for a certain type of event.
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event.js").default)): ?} listener Listener.
   * @protected
   */ unInternal(type, listener) {
        const key = /** @type {Object} */ listener.ol_key;
        if (key) $efe31481b2126ee6$export$b7ef3f8527533384(key);
        else if (Array.isArray(type)) for(let i = 0, ii = type.length; i < ii; ++i)this.removeEventListener(type[i], listener);
        else this.removeEventListener(type, listener);
    }
}
/**
 * Listen for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event.js").default)): ?} listener The listener function.
 * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
 *     called with an array of event types as the first argument, the return
 *     will be an array of keys.
 * @api
 */ $efe31481b2126ee6$var$Observable.prototype.on;
/**
 * Listen once for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event.js").default)): ?} listener The listener function.
 * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
 *     called with an array of event types as the first argument, the return
 *     will be an array of keys.
 * @api
 */ $efe31481b2126ee6$var$Observable.prototype.once;
/**
 * Unlisten for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event.js").default)): ?} listener The listener function.
 * @api
 */ $efe31481b2126ee6$var$Observable.prototype.un;
function $efe31481b2126ee6$export$b7ef3f8527533384(key) {
    if (Array.isArray(key)) for(let i = 0, ii = key.length; i < ii; ++i)(0, $8061a5de9380012b$export$b0a21c8b3c1c921)(key[i]);
    else (0, $8061a5de9380012b$export$b0a21c8b3c1c921)(/** @type {import("./events.js").EventsKey} */ key);
}
var $efe31481b2126ee6$export$2e2bcd8739ae039 = $efe31481b2126ee6$var$Observable;




/**
 * @module ol/util
 */ /**
 * @return {never} Any return.
 */ function $01f1986453243423$export$817eb92a8194bab0() {
    throw new Error('Unimplemented abstract method.');
}
/**
 * Counter for getUid.
 * @type {number}
 * @private
 */ let $01f1986453243423$var$uidCounter_ = 0;
function $01f1986453243423$export$5e82334337e0f204(obj) {
    return obj.ol_uid || (obj.ol_uid = String(++$01f1986453243423$var$uidCounter_));
}
const $01f1986453243423$export$a4ad2735b021c132 = '10.9.0';


class $4dd5119c2f9fa355$export$cf395d7c4a2d5a17 extends (0, $bc90848f8b15fa29$export$2e2bcd8739ae039) {
    /**
   * @param {string} type The event type.
   * @param {string} key The property name.
   * @param {*} oldValue The old value for `key`.
   */ constructor(type, key, oldValue){
        super(type);
        /**
     * The name of the property whose value is changing.
     * @type {string}
     * @api
     */ this.key = key;
        /**
     * The old value. To get the new value use `e.target.get(e.key)` where
     * `e` is the event object.
     * @type {*}
     * @api
     */ this.oldValue = oldValue;
    }
}
/***
 * @template Return
 * @typedef {import("./Observable.js").OnSignature<import("./Observable.js").EventTypes, import("./events/Event.js").default, Return> &
 *    import("./Observable.js").OnSignature<import("./ObjectEventType.js").Types, ObjectEvent, Return> &
 *    import("./Observable.js").CombinedOnSignature<import("./Observable.js").EventTypes|import("./ObjectEventType.js").Types, Return>} ObjectOnSignature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Most non-trivial classes inherit from this.
 *
 * This extends {@link module:ol/Observable~Observable} with observable
 * properties, where each property is observable as well as the object as a
 * whole.
 *
 * Classes that inherit from this have pre-defined properties, to which you can
 * add your owns. The pre-defined properties are listed in this documentation as
 * 'Observable Properties', and have their own accessors; for example,
 * {@link module:ol/Map~Map} has a `target` property, accessed with
 * `getTarget()` and changed with `setTarget()`. Not all properties are however
 * settable. There are also general-purpose accessors `get()` and `set()`. For
 * example, `get('target')` is equivalent to `getTarget()`.
 *
 * The `set` accessors trigger a change event, and you can monitor this by
 * registering a listener. For example, {@link module:ol/View~View} has a
 * `center` property, so `view.on('change:center', function(evt) {...});` would
 * call the function whenever the value of the center property changes. Within
 * the function, `evt.target` would be the view, so `evt.target.getCenter()`
 * would return the new center.
 *
 * You can add your own observable properties with
 * `object.set('prop', 'value')`, and retrieve that with `object.get('prop')`.
 * You can listen for changes on that property value with
 * `object.on('change:prop', listener)`. You can get a list of all
 * properties with {@link module:ol/Object~BaseObject#getProperties}.
 *
 * Note that the observable properties are separate from standard JS properties.
 * You can, for example, give your map object a title with
 * `map.title='New title'` and with `map.set('title', 'Another title')`. The
 * first will be a `hasOwnProperty`; the second will appear in
 * `getProperties()`. Only the second is observable.
 *
 * Properties can be deleted by using the unset method. E.g.
 * object.unset('foo').
 *
 * @fires ObjectEvent
 * @template {Object<string, *>} [Properties=Object<string, *>]
 * @api
 */ class $4dd5119c2f9fa355$var$BaseObject extends (0, $efe31481b2126ee6$export$2e2bcd8739ae039) {
    /**
   * @param {NoInfer<Properties>} [values] An object with key-value pairs.
   */ constructor(values){
        super();
        /***
     * @type {ObjectOnSignature<import("./events.js").EventsKey>}
     */ this.on;
        /***
     * @type {ObjectOnSignature<import("./events.js").EventsKey>}
     */ this.once;
        /***
     * @type {ObjectOnSignature<void>}
     */ this.un;
        // Call {@link module:ol/util.getUid} to ensure that the order of objects' ids is
        // the same as the order in which they were created.  This also helps to
        // ensure that object properties are always added in the same order, which
        // helps many JavaScript engines generate faster code.
        (0, $01f1986453243423$export$5e82334337e0f204)(this);
        /**
     * @private
     * @type {Partial<NoInfer<Properties>>|null}
     */ this.values_ = null;
        if (values !== undefined) this.setProperties(values);
    }
    /**
   * Gets a value.
   * @param {string} key Key name.
   * @return {*} Value.
   * @api
   */ get(key) {
        let value;
        if (this.values_ && this.values_.hasOwnProperty(key)) value = this.values_[key];
        return value;
    }
    /**
   * Get a list of object property names.
   * @return {Array<string>} List of property names.
   * @api
   */ getKeys() {
        return this.values_ && Object.keys(this.values_) || [];
    }
    /**
   * Get an object of all property names and values.
   * @return {NoInfer<Properties>} Object.
   * @api
   */ getProperties() {
        return /** @type {NoInfer<Properties>} */ this.values_ && Object.assign({}, this.values_) || {};
    }
    /**
   * Get an object of all property names and values.
   * @return {Partial<NoInfer<Properties>>?} Object.
   */ getPropertiesInternal() {
        return this.values_;
    }
    /**
   * @return {boolean} The object has properties.
   */ hasProperties() {
        return !!this.values_;
    }
    /**
   * @param {string} key Key name.
   * @param {*} oldValue Old value.
   */ notify(key, oldValue) {
        let eventType;
        eventType = `change:${key}`;
        if (this.hasListener(eventType)) this.dispatchEvent(new $4dd5119c2f9fa355$export$cf395d7c4a2d5a17(eventType, key, oldValue));
        eventType = (0, $026be6c727dde691$export$2e2bcd8739ae039).PROPERTYCHANGE;
        if (this.hasListener(eventType)) this.dispatchEvent(new $4dd5119c2f9fa355$export$cf395d7c4a2d5a17(eventType, key, oldValue));
    }
    /**
   * @param {string} key Key name.
   * @param {import("./events.js").Listener} listener Listener.
   */ addChangeListener(key, listener) {
        this.addEventListener(`change:${key}`, listener);
    }
    /**
   * @param {string} key Key name.
   * @param {import("./events.js").Listener} listener Listener.
   */ removeChangeListener(key, listener) {
        this.removeEventListener(`change:${key}`, listener);
    }
    /**
   * Sets a value.
   * @param {string} key Key name.
   * @param {*} value Value.
   * @param {boolean} [silent] Update without triggering an event.
   * @api
   */ set(key, value, silent) {
        const values = this.values_ || (this.values_ = {});
        if (silent) values[key] = value;
        else {
            const oldValue = values[key];
            values[key] = value;
            if (oldValue !== value) this.notify(key, oldValue);
        }
    }
    /**
   * Sets a collection of key-value pairs.  Note that this changes any existing
   * properties and adds new ones (it does not remove any existing properties).
   * @param {Partial<NoInfer<Properties>>} values Values.
   * @param {boolean} [silent] Update without triggering an event.
   * @api
   */ setProperties(values, silent) {
        for(const key in values)this.set(key, values[key], silent);
    }
    /**
   * Apply any properties from another object without triggering events.
   * @param {BaseObject} source The source object.
   * @protected
   */ applyProperties(source) {
        if (!source.values_) return;
        Object.assign(this.values_ || (this.values_ = {}), source.values_);
    }
    /**
   * Unsets a property.
   * @param {string} key Key name.
   * @param {boolean} [silent] Unset without triggering an event.
   * @api
   */ unset(key, silent) {
        if (this.values_ && key in this.values_) {
            const oldValue = this.values_[key];
            delete this.values_[key];
            if ((0, $0669c62275461b52$export$dd1bc94b04021eeb)(this.values_)) this.values_ = null;
            if (!silent) this.notify(key, oldValue);
        }
    }
}
var $4dd5119c2f9fa355$export$2e2bcd8739ae039 = $4dd5119c2f9fa355$var$BaseObject;



/**
 * @enum {string}
 * @private
 */ const $c6078a5bf4414204$var$Property = {
    LENGTH: 'length'
};
class $c6078a5bf4414204$export$a87ae6eb2761ec6d extends (0, $bc90848f8b15fa29$export$2e2bcd8739ae039) {
    /**
   * @param {import("./CollectionEventType.js").default} type Type.
   * @param {T} element Element.
   * @param {number} index The index of the added or removed element.
   */ constructor(type, element, index){
        super(type);
        /**
     * The element that is added to or removed from the collection.
     * @type {T}
     * @api
     */ this.element = element;
        /**
     * The index of the added or removed element.
     * @type {number}
     * @api
     */ this.index = index;
    }
}
/***
 * @template T
 * @template Return
 * @typedef {import("./Observable.js").OnSignature<import("./Observable.js").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable.js").OnSignature<import("./ObjectEventType.js").Types|'change:length', import("./Object.js").ObjectEvent, Return> &
 *   import("./Observable.js").OnSignature<'add'|'remove', CollectionEvent<T>, Return> &
 *   import("./Observable.js").CombinedOnSignature<import("./Observable.js").EventTypes|import("./ObjectEventType.js").Types|
 *     'change:length'|'add'|'remove',Return>} CollectionOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {boolean} [unique=false] Disallow the same item from being added to
 * the collection twice.
 */ /**
 * @classdesc
 * An expanded version of standard JS Array, adding convenience methods for
 * manipulation. Add and remove changes to the Collection trigger a Collection
 * event. Note that this does not cover changes to the objects _within_ the
 * Collection; they trigger events on the appropriate object, not on the
 * Collection as a whole.
 *
 * @fires CollectionEvent
 *
 * @template T
 * @api
 */ class $c6078a5bf4414204$var$Collection extends (0, $4dd5119c2f9fa355$export$2e2bcd8739ae039) {
    /**
   * @param {Array<T>} [array] Array.
   * @param {Options} [options] Collection options.
   */ constructor(array, options){
        super();
        /***
     * @type {CollectionOnSignature<T, import("./events.js").EventsKey>}
     */ this.on;
        /***
     * @type {CollectionOnSignature<T, import("./events.js").EventsKey>}
     */ this.once;
        /***
     * @type {CollectionOnSignature<T, void>}
     */ this.un;
        options = options || {};
        /**
     * @private
     * @type {boolean}
     */ this.unique_ = !!options.unique;
        /**
     * @private
     * @type {!Array<T>}
     */ this.array_ = array ?? [];
        if (this.unique_) for(let i = 1, ii = this.array_.length; i < ii; ++i)this.assertUnique_(this.array_[i], i);
        this.updateLength_();
    }
    /**
   * Remove all elements from the collection.
   * @api
   */ clear() {
        while(this.getLength() > 0)this.pop();
    }
    /**
   * Add elements to the collection.  This pushes each item in the provided array
   * to the end of the collection.
   * @param {!Array<T>} arr Array.
   * @return {Collection<T>} This collection.
   * @api
   */ extend(arr) {
        for(let i = 0, ii = arr.length; i < ii; ++i)this.push(arr[i]);
        return this;
    }
    /**
   * Iterate over each element, calling the provided callback.
   * @param {function(T, number, Array<T>): *} f The function to call
   *     for every element. This function takes 3 arguments (the element, the
   *     index and the array). The return value is ignored.
   * @api
   */ forEach(f) {
        const array = this.array_;
        for(let i = 0, ii = array.length; i < ii; ++i)f(array[i], i, array);
    }
    /**
   * Get a reference to the underlying Array object. Warning: if the array
   * is mutated, no events will be dispatched by the collection, and the
   * collection's "length" property won't be in sync with the actual length
   * of the array.
   * @return {!Array<T>} Array.
   * @api
   */ getArray() {
        return this.array_;
    }
    /**
   * Get the element at the provided index.
   * @param {number} index Index.
   * @return {T} Element.
   * @api
   */ item(index) {
        return this.array_[index];
    }
    /**
   * Get the length of this collection.
   * @return {number} The length of the array.
   * @observable
   * @api
   */ getLength() {
        return this.get($c6078a5bf4414204$var$Property.LENGTH);
    }
    /**
   * Insert an element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */ insertAt(index, elem) {
        if (index < 0 || index > this.getLength()) throw new Error('Index out of bounds: ' + index);
        if (this.unique_) this.assertUnique_(elem);
        this.array_.splice(index, 0, elem);
        this.updateLength_();
        this.dispatchEvent(new $c6078a5bf4414204$export$a87ae6eb2761ec6d((0, $d4ae00bf358e4687$export$2e2bcd8739ae039).ADD, elem, index));
    }
    /**
   * Remove the last element of the collection and return it.
   * Return `undefined` if the collection is empty.
   * @return {T|undefined} Element.
   * @api
   */ pop() {
        return this.removeAt(this.getLength() - 1);
    }
    /**
   * Insert the provided element at the end of the collection.
   * @param {T} elem Element.
   * @return {number} New length of the collection.
   * @api
   */ push(elem) {
        const n = this.getLength();
        this.insertAt(n, elem);
        return this.getLength();
    }
    /**
   * Remove the first occurrence of an element from the collection.
   * @param {T} elem Element.
   * @return {T|undefined} The removed element or undefined if none found.
   * @api
   */ remove(elem) {
        const arr = this.array_;
        for(let i = 0, ii = arr.length; i < ii; ++i){
            if (arr[i] === elem) return this.removeAt(i);
        }
        return undefined;
    }
    /**
   * Remove the element at the provided index and return it.
   * Return `undefined` if the collection does not contain this index.
   * @param {number} index Index.
   * @return {T|undefined} Value.
   * @api
   */ removeAt(index) {
        if (index < 0 || index >= this.getLength()) return undefined;
        const prev = this.array_[index];
        this.array_.splice(index, 1);
        this.updateLength_();
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $c6078a5bf4414204$export$a87ae6eb2761ec6d((0, $d4ae00bf358e4687$export$2e2bcd8739ae039).REMOVE, prev, index));
        return prev;
    }
    /**
   * Set the element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */ setAt(index, elem) {
        const n = this.getLength();
        if (index >= n) {
            this.insertAt(index, elem);
            return;
        }
        if (index < 0) throw new Error('Index out of bounds: ' + index);
        if (this.unique_) this.assertUnique_(elem, index);
        const prev = this.array_[index];
        this.array_[index] = elem;
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $c6078a5bf4414204$export$a87ae6eb2761ec6d((0, $d4ae00bf358e4687$export$2e2bcd8739ae039).REMOVE, prev, index));
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $c6078a5bf4414204$export$a87ae6eb2761ec6d((0, $d4ae00bf358e4687$export$2e2bcd8739ae039).ADD, elem, index));
    }
    /**
   * @private
   */ updateLength_() {
        this.set($c6078a5bf4414204$var$Property.LENGTH, this.array_.length);
    }
    /**
   * @private
   * @param {T} elem Element.
   * @param {number} [except] Optional index to ignore.
   */ assertUnique_(elem, except) {
        const array = this.array_;
        for(let i = 0, ii = array.length; i < ii; ++i){
            if (array[i] === elem && i !== except) throw new Error('Duplicate item added to a unique collection');
        }
    }
}
var $c6078a5bf4414204$export$2e2bcd8739ae039 = $c6078a5bf4414204$var$Collection;



/**
 * @module ol/MapBrowserEvent
 */ /**
 * @module ol/MapEvent
 */ 
/**
 * @classdesc
 * Events emitted as map events are instances of this type.
 * See {@link module:ol/Map~Map} for which events trigger a map event.
 */ class $bbec7b72ddf9c25d$var$MapEvent extends (0, $bc90848f8b15fa29$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Event type.
   * @param {import("./Map.js").default} map Map.
   * @param {?import("./Map.js").FrameState} [frameState] Frame state.
   */ constructor(type, map, frameState){
        super(type);
        /**
     * The map where the event occurred.
     * @type {import("./Map.js").default}
     * @api
     */ this.map = map;
        /**
     * The frame state at the time of the event.
     * @type {?import("./Map.js").FrameState}
     * @api
     */ this.frameState = frameState !== undefined ? frameState : null;
    }
}
var $bbec7b72ddf9c25d$export$2e2bcd8739ae039 = $bbec7b72ddf9c25d$var$MapEvent;


/**
 * @classdesc
 * Events emitted as map browser events are instances of this type.
 * See {@link module:ol/Map~Map} for which events trigger a map browser event.
 * @template {PointerEvent|KeyboardEvent|WheelEvent} [EVENT=PointerEvent|KeyboardEvent|WheelEvent]
 */ class $0b2b68a741a0182d$var$MapBrowserEvent extends (0, $bbec7b72ddf9c25d$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Event type.
   * @param {import("./Map.js").default} map Map.
   * @param {EVENT} originalEvent Original event.
   * @param {boolean} [dragging] Is the map currently being dragged?
   * @param {import("./Map.js").FrameState} [frameState] Frame state.
   * @param {Array<PointerEvent>} [activePointers] Active pointers.
   */ constructor(type, map, originalEvent, dragging, frameState, activePointers){
        super(type, map, frameState);
        /**
     * The original browser event.
     * @const
     * @type {EVENT}
     * @api
     */ this.originalEvent = originalEvent;
        /**
     * The map pixel relative to the viewport corresponding to the original browser event.
     * @type {?import("./pixel.js").Pixel}
     * @private
     */ this.pixel_ = null;
        /**
     * The coordinate in the user projection corresponding to the original browser event.
     * @type {?import("./coordinate.js").Coordinate}
     * @private
     */ this.coordinate_ = null;
        /**
     * Indicates if the map is currently being dragged. Only set for
     * `POINTERDRAG` and `POINTERMOVE` events. Default is `false`.
     *
     * @type {boolean}
     * @api
     */ this.dragging = dragging !== undefined ? dragging : false;
        /**
     * @type {Array<PointerEvent>|undefined}
     */ this.activePointers = activePointers;
    }
    /**
   * The map pixel relative to the viewport corresponding to the original event.
   * @type {import("./pixel.js").Pixel}
   * @api
   */ get pixel() {
        if (!this.pixel_) this.pixel_ = this.map.getEventPixel(this.originalEvent);
        return this.pixel_;
    }
    set pixel(pixel) {
        this.pixel_ = pixel;
    }
    /**
   * The coordinate corresponding to the original browser event.  This will be in the user
   * projection if one is set.  Otherwise it will be in the view projection.
   * @type {import("./coordinate.js").Coordinate}
   * @api
   */ get coordinate() {
        if (!this.coordinate_) this.coordinate_ = this.map.getCoordinateFromPixel(this.pixel);
        return this.coordinate_;
    }
    set coordinate(coordinate) {
        this.coordinate_ = coordinate;
    }
    /**
   * Prevents the default browser action.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.preventDefault.
   * @api
   * @override
   */ preventDefault() {
        super.preventDefault();
        if ('preventDefault' in this.originalEvent) /** @type {UIEvent} */ this.originalEvent.preventDefault();
    }
    /**
   * Prevents further propagation of the current event.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.stopPropagation.
   * @api
   * @override
   */ stopPropagation() {
        super.stopPropagation();
        if ('stopPropagation' in this.originalEvent) /** @type {UIEvent} */ this.originalEvent.stopPropagation();
    }
}
var $0b2b68a741a0182d$export$2e2bcd8739ae039 = $0b2b68a741a0182d$var$MapBrowserEvent;


/**
 * @module ol/MapBrowserEventHandler
 */ 
/**
 * @module ol/MapBrowserEventType
 */ 
var /**
 * Constants for event names.
 * @enum {string}
 */ $1daf9bd643ab3fe0$export$2e2bcd8739ae039 /***
 * @typedef {'singleclick'|'click'|'dblclick'|'pointerdrag'|'pointermove'} Types
 */  = {
    /**
   * A true single click with no dragging and no double click. Note that this
   * event is delayed by 250 ms to ensure that it is not a double click.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#singleclick
   * @api
   */ SINGLECLICK: 'singleclick',
    /**
   * A click with no dragging. A double click will fire two of this.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#click
   * @api
   */ CLICK: (0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CLICK,
    /**
   * A true double click, with no dragging.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#dblclick
   * @api
   */ DBLCLICK: (0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).DBLCLICK,
    /**
   * Triggered when a pointer is dragged.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointerdrag
   * @api
   */ POINTERDRAG: 'pointerdrag',
    /**
   * Triggered when a pointer is moved. Note that on touch devices this is
   * triggered when the map is panned, so is not the same as mousemove.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointermove
   * @api
   */ POINTERMOVE: 'pointermove',
    POINTERDOWN: 'pointerdown',
    POINTERUP: 'pointerup',
    POINTEROVER: 'pointerover',
    POINTEROUT: 'pointerout',
    POINTERENTER: 'pointerenter',
    POINTERLEAVE: 'pointerleave',
    POINTERCANCEL: 'pointercancel'
};





/**
 * @module ol/has
 */ const $013e07c1ef6d00ad$var$ua = typeof navigator !== 'undefined' && typeof navigator.userAgent !== 'undefined' ? navigator.userAgent.toLowerCase() : '';
const $013e07c1ef6d00ad$export$3227bfbdaa9275de = $013e07c1ef6d00ad$var$ua.includes('safari') && !$013e07c1ef6d00ad$var$ua.includes('chrom');
const $013e07c1ef6d00ad$export$b23eed0e325a206a = $013e07c1ef6d00ad$export$3227bfbdaa9275de && ($013e07c1ef6d00ad$var$ua.includes('version/15.4') || /cpu (os|iphone os) 15_4 like mac os x/.test($013e07c1ef6d00ad$var$ua));
const $013e07c1ef6d00ad$export$39dfd62a25e0fe93 = $013e07c1ef6d00ad$var$ua.includes('webkit') && !$013e07c1ef6d00ad$var$ua.includes('edge');
const $013e07c1ef6d00ad$export$76c0a3b101d93136 = $013e07c1ef6d00ad$var$ua.includes('macintosh');
const $013e07c1ef6d00ad$export$6b83a0446fc26f94 = typeof devicePixelRatio !== 'undefined' ? devicePixelRatio : 1;
const $013e07c1ef6d00ad$export$98fcef3dc9973292 = typeof WorkerGlobalScope !== 'undefined' && typeof OffscreenCanvas !== 'undefined' && self instanceof WorkerGlobalScope; //eslint-disable-line
const $013e07c1ef6d00ad$export$716f8695eedb9bad = typeof Image !== 'undefined' && Image.prototype.decode;
const $013e07c1ef6d00ad$export$7478563940788376 = typeof createImageBitmap === 'function';
const $013e07c1ef6d00ad$export$f751ce96c6c4e4fc = function() {
    let passive = false;
    try {
        const options = Object.defineProperty({}, 'passive', {
            get: function() {
                passive = true;
            }
        });
        // @ts-ignore Ignore invalid event type '_'
        window.addEventListener('_', null, options);
        // @ts-ignore Ignore invalid event type '_'
        window.removeEventListener('_', null, options);
    } catch  {
    // passive not supported
    }
    return passive;
}();


/**
 * @module ol/pointer/EventType
 */ /**
 * Constants for event names.
 * @enum {string}
 */ var $d49a55e5017c1935$export$2e2bcd8739ae039 = {
    POINTERMOVE: 'pointermove',
    POINTERDOWN: 'pointerdown',
    POINTERUP: 'pointerup',
    POINTEROVER: 'pointerover',
    POINTEROUT: 'pointerout',
    POINTERENTER: 'pointerenter',
    POINTERLEAVE: 'pointerleave',
    POINTERCANCEL: 'pointercancel'
};


class $289a0e66403793e5$var$MapBrowserEventHandler extends (0, $8c60cc978e8694f4$export$2e2bcd8739ae039) {
    /**
   * @param {import("./Map.js").default} map The map with the viewport to listen to events on.
   * @param {number} [moveTolerance] The minimal distance the pointer must travel to trigger a move.
   */ constructor(map, moveTolerance){
        super(map);
        /**
     * This is the element that we will listen to the real events on.
     * @type {import("./Map.js").default}
     * @private
     */ this.map_ = map;
        /**
     * @type {ReturnType<typeof setTimeout>}
     * @private
     */ this.clickTimeoutId_;
        /**
     * Emulate dblclick and singleclick. Will be true when only one pointer is active.
     * @type {boolean}
     */ this.emulateClicks_ = false;
        /**
     * @type {boolean}
     * @private
     */ this.dragging_ = false;
        /**
     * @type {!Array<import("./events.js").EventsKey>}
     * @private
     */ this.dragListenerKeys_ = [];
        /**
     * @type {number}
     * @private
     */ this.moveTolerance_ = moveTolerance === undefined ? 1 : moveTolerance;
        /**
     * The most recent "down" type event (or null if none have occurred).
     * Set on pointerdown.
     * @type {PointerEvent|null}
     * @private
     */ this.down_ = null;
        const element = this.map_.getViewport();
        /**
     * @type {Array<PointerEvent>}
     * @private
     */ this.activePointers_ = [];
        /**
     * @type {!Object<number, Event>}
     * @private
     */ this.trackedTouches_ = {};
        /**
     * @private
     */ this.element_ = element;
        /**
     * @type {?import("./events.js").EventsKey}
     * @private
     */ this.pointerdownListenerKey_ = (0, $8061a5de9380012b$export$63174c828edd6ff8)(element, (0, $d49a55e5017c1935$export$2e2bcd8739ae039).POINTERDOWN, this.handlePointerDown_, this);
        /**
     * @type {PointerEvent}
     * @private
     */ this.originalPointerMoveEvent_;
        /**
     * @type {?import("./events.js").EventsKey}
     * @private
     */ this.relayedListenerKey_ = (0, $8061a5de9380012b$export$63174c828edd6ff8)(element, (0, $d49a55e5017c1935$export$2e2bcd8739ae039).POINTERMOVE, this.relayMoveEvent_, this);
        /**
     * @private
     */ this.boundHandleTouchMove_ = this.handleTouchMove_.bind(this);
        this.element_.addEventListener((0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).TOUCHMOVE, this.boundHandleTouchMove_, (0, $013e07c1ef6d00ad$export$f751ce96c6c4e4fc) ? {
            passive: false
        } : false);
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ emulateClick_(pointerEvent) {
        let newEvent = new (0, $0b2b68a741a0182d$export$2e2bcd8739ae039)((0, $1daf9bd643ab3fe0$export$2e2bcd8739ae039).CLICK, this.map_, pointerEvent);
        this.dispatchEvent(newEvent);
        if (this.clickTimeoutId_ !== undefined) {
            // double-click
            clearTimeout(this.clickTimeoutId_);
            this.clickTimeoutId_ = undefined;
            newEvent = new (0, $0b2b68a741a0182d$export$2e2bcd8739ae039)((0, $1daf9bd643ab3fe0$export$2e2bcd8739ae039).DBLCLICK, this.map_, pointerEvent);
            this.dispatchEvent(newEvent);
        } else // click
        this.clickTimeoutId_ = setTimeout(()=>{
            this.clickTimeoutId_ = undefined;
            const newEvent = new (0, $0b2b68a741a0182d$export$2e2bcd8739ae039)((0, $1daf9bd643ab3fe0$export$2e2bcd8739ae039).SINGLECLICK, this.map_, pointerEvent);
            this.dispatchEvent(newEvent);
        }, 250);
    }
    /**
   * Keeps track on how many pointers are currently active.
   *
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ updateActivePointers_(pointerEvent) {
        const event = pointerEvent;
        const id = event.pointerId;
        if (event.type == (0, $1daf9bd643ab3fe0$export$2e2bcd8739ae039).POINTERUP || event.type == (0, $1daf9bd643ab3fe0$export$2e2bcd8739ae039).POINTERCANCEL) {
            delete this.trackedTouches_[id];
            for(const pointerId in this.trackedTouches_)if (this.trackedTouches_[pointerId].target !== event.target) {
                // Some platforms assign a new pointerId when the target changes.
                // If this happens, delete one tracked pointer. If there is more
                // than one tracked pointer for the old target, it will be cleared
                // by subsequent POINTERUP events from other pointers.
                delete this.trackedTouches_[pointerId];
                break;
            }
        } else if (event.type == (0, $1daf9bd643ab3fe0$export$2e2bcd8739ae039).POINTERDOWN || event.type == (0, $1daf9bd643ab3fe0$export$2e2bcd8739ae039).POINTERMOVE) this.trackedTouches_[id] = event;
        this.activePointers_ = Object.values(this.trackedTouches_);
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerUp_(pointerEvent) {
        this.updateActivePointers_(pointerEvent);
        const newEvent = new (0, $0b2b68a741a0182d$export$2e2bcd8739ae039)((0, $1daf9bd643ab3fe0$export$2e2bcd8739ae039).POINTERUP, this.map_, pointerEvent, undefined, undefined, this.activePointers_);
        this.dispatchEvent(newEvent);
        // We emulate click events on left mouse button click, touch contact, and pen
        // contact. isMouseActionButton returns true in these cases (evt.button is set
        // to 0).
        // See http://www.w3.org/TR/pointerevents/#button-states
        // We only fire click, singleclick, and doubleclick if nobody has called
        // event.preventDefault().
        if (this.emulateClicks_ && !newEvent.defaultPrevented && !this.dragging_ && this.isMouseActionButton_(pointerEvent)) this.emulateClick_(this.down_);
        if (this.activePointers_.length === 0) {
            this.dragListenerKeys_.forEach((0, $8061a5de9380012b$export$b0a21c8b3c1c921));
            this.dragListenerKeys_.length = 0;
            this.dragging_ = false;
            this.down_ = null;
        }
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @return {boolean} If the left mouse button was pressed.
   * @private
   */ isMouseActionButton_(pointerEvent) {
        return pointerEvent.button === 0;
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerDown_(pointerEvent) {
        this.emulateClicks_ = this.activePointers_.length === 0;
        this.updateActivePointers_(pointerEvent);
        const newEvent = new (0, $0b2b68a741a0182d$export$2e2bcd8739ae039)((0, $1daf9bd643ab3fe0$export$2e2bcd8739ae039).POINTERDOWN, this.map_, pointerEvent, undefined, undefined, this.activePointers_);
        this.dispatchEvent(newEvent);
        this.down_ = new PointerEvent(pointerEvent.type, pointerEvent);
        Object.defineProperty(this.down_, 'target', {
            writable: false,
            value: pointerEvent.target
        });
        if (this.dragListenerKeys_.length === 0) {
            const doc = this.map_.getOwnerDocument();
            this.dragListenerKeys_.push((0, $8061a5de9380012b$export$63174c828edd6ff8)(doc, (0, $1daf9bd643ab3fe0$export$2e2bcd8739ae039).POINTERMOVE, this.handlePointerMove_, this), (0, $8061a5de9380012b$export$63174c828edd6ff8)(doc, (0, $1daf9bd643ab3fe0$export$2e2bcd8739ae039).POINTERUP, this.handlePointerUp_, this), /* Note that the listener for `pointercancel is set up on
         * `pointerEventHandler_` and not `documentPointerEventHandler_` like
         * the `pointerup` and `pointermove` listeners.
         *
         * The reason for this is the following: `TouchSource.vacuumTouches_()`
         * issues `pointercancel` events, when there was no `touchend` for a
         * `touchstart`. Now, let's say a first `touchstart` is registered on
         * `pointerEventHandler_`. The `documentPointerEventHandler_` is set up.
         * But `documentPointerEventHandler_` doesn't know about the first
         * `touchstart`. If there is no `touchend` for the `touchstart`, we can
         * only receive a `touchcancel` from `pointerEventHandler_`, because it is
         * only registered there.
         */ (0, $8061a5de9380012b$export$63174c828edd6ff8)(this.element_, (0, $1daf9bd643ab3fe0$export$2e2bcd8739ae039).POINTERCANCEL, this.handlePointerUp_, this));
            if (this.element_.getRootNode && this.element_.getRootNode() !== doc) this.dragListenerKeys_.push((0, $8061a5de9380012b$export$63174c828edd6ff8)(this.element_.getRootNode(), (0, $1daf9bd643ab3fe0$export$2e2bcd8739ae039).POINTERUP, this.handlePointerUp_, this));
        }
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerMove_(pointerEvent) {
        // Between pointerdown and pointerup, pointermove events are triggered.
        // To avoid a 'false' touchmove event to be dispatched, we test if the pointer
        // moved a significant distance.
        if (this.isMoving_(pointerEvent)) {
            this.updateActivePointers_(pointerEvent);
            this.dragging_ = true;
            const newEvent = new (0, $0b2b68a741a0182d$export$2e2bcd8739ae039)((0, $1daf9bd643ab3fe0$export$2e2bcd8739ae039).POINTERDRAG, this.map_, pointerEvent, this.dragging_, undefined, this.activePointers_);
            this.dispatchEvent(newEvent);
        }
    }
    /**
   * Wrap and relay a pointermove event.
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ relayMoveEvent_(pointerEvent) {
        this.originalPointerMoveEvent_ = pointerEvent;
        const dragging = !!(this.down_ && this.isMoving_(pointerEvent));
        this.dispatchEvent(new (0, $0b2b68a741a0182d$export$2e2bcd8739ae039)((0, $1daf9bd643ab3fe0$export$2e2bcd8739ae039).POINTERMOVE, this.map_, pointerEvent, dragging));
    }
    /**
   * Flexible handling of a `touch-action: none` css equivalent: because calling
   * `preventDefault()` on a `pointermove` event does not stop native page scrolling
   * and zooming, we also listen for `touchmove` and call `preventDefault()` on it
   * when an interaction (currently `DragPan` handles the event.
   * @param {TouchEvent} event Event.
   * @private
   */ handleTouchMove_(event) {
        // Due to https://github.com/mpizenberg/elm-pep/issues/2, `this.originalPointerMoveEvent_`
        // may not be initialized yet when we get here on a platform without native pointer events,
        // when elm-pep is used as pointer events polyfill.
        const originalEvent = this.originalPointerMoveEvent_;
        if ((!originalEvent || originalEvent.defaultPrevented) && (typeof event.cancelable !== 'boolean' || event.cancelable === true)) event.preventDefault();
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @return {boolean} Is moving.
   * @private
   */ isMoving_(pointerEvent) {
        return this.dragging_ || Math.abs(pointerEvent.clientX - this.down_.clientX) > this.moveTolerance_ || Math.abs(pointerEvent.clientY - this.down_.clientY) > this.moveTolerance_;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.relayedListenerKey_) {
            (0, $8061a5de9380012b$export$b0a21c8b3c1c921)(this.relayedListenerKey_);
            this.relayedListenerKey_ = null;
        }
        this.element_.removeEventListener((0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).TOUCHMOVE, this.boundHandleTouchMove_);
        if (this.pointerdownListenerKey_) {
            (0, $8061a5de9380012b$export$b0a21c8b3c1c921)(this.pointerdownListenerKey_);
            this.pointerdownListenerKey_ = null;
        }
        this.dragListenerKeys_.forEach((0, $8061a5de9380012b$export$b0a21c8b3c1c921));
        this.dragListenerKeys_.length = 0;
        this.element_ = null;
        super.disposeInternal();
    }
}
var $289a0e66403793e5$export$2e2bcd8739ae039 = $289a0e66403793e5$var$MapBrowserEventHandler;




/**
 * @module ol/MapEventType
 */ /**
 * @enum {string}
 */ var $f13f0d102103b0f4$export$2e2bcd8739ae039 /***
 * @typedef {'postrender'|'movestart'|'moveend'|'loadstart'|'loadend'} Types
 */  = {
    /**
   * Triggered after a map frame is rendered.
   * @event module:ol/MapEvent~MapEvent#postrender
   * @api
   */ POSTRENDER: 'postrender',
    /**
   * Triggered when the map starts moving.
   * @event module:ol/MapEvent~MapEvent#movestart
   * @api
   */ MOVESTART: 'movestart',
    /**
   * Triggered after the map is moved.
   * @event module:ol/MapEvent~MapEvent#moveend
   * @api
   */ MOVEEND: 'moveend',
    /**
   * Triggered when loading of additional map data (tiles, images, features) starts.
   * @event module:ol/MapEvent~MapEvent#loadstart
   * @api
   */ LOADSTART: 'loadstart',
    /**
   * Triggered when loading of additional map data has completed.
   * @event module:ol/MapEvent~MapEvent#loadend
   * @api
   */ LOADEND: 'loadend'
};


/**
 * @module ol/MapProperty
 */ /**
 * @enum {string}
 */ var $3460d904c594f91b$export$2e2bcd8739ae039 = {
    LAYERGROUP: 'layergroup',
    SIZE: 'size',
    TARGET: 'target',
    VIEW: 'view'
};




/**
 * @module ol/TileQueue
 */ /**
 * @module ol/TileState
 */ /**
 * @enum {number}
 */ var $b91d4eaa5c4015a3$export$2e2bcd8739ae039 = {
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    /**
   * Indicates that tile loading failed
   * @type {number}
   */ ERROR: 3,
    EMPTY: 4
};



/**
 * @module ol/structs/PriorityQueue
 */ /**
 * @module ol/asserts
 */ /**
 * @param {*} assertion Assertion we expected to be truthy.
 * @param {string} errorMessage Error message.
 */ function $5bf8d54622bcd4c6$export$a7a9523472993e97(assertion, errorMessage) {
    if (!assertion) throw new Error(errorMessage);
}



const $1717cc2c2a98dd9c$export$b4af72c40fd57063 = Infinity;
/**
 * @classdesc
 * Priority queue.
 *
 * The implementation is inspired from the Closure Library's Heap class and
 * Python's heapq module.
 *
 * See https://github.com/google/closure-library/blob/master/closure/goog/structs/heap.js
 * and https://hg.python.org/cpython/file/2.7/Lib/heapq.py.
 *
 * @template T
 */ class $1717cc2c2a98dd9c$var$PriorityQueue {
    /**
   * @param {function(T): number} priorityFunction Priority function.
   * @param {function(T): string} keyFunction Key function.
   */ constructor(priorityFunction, keyFunction){
        /**
     * @type {function(T): number}
     * @private
     */ this.priorityFunction_ = priorityFunction;
        /**
     * @type {function(T): string}
     * @private
     */ this.keyFunction_ = keyFunction;
        /**
     * @type {Array<T>}
     * @private
     */ this.elements_ = [];
        /**
     * @type {Array<number>}
     * @private
     */ this.priorities_ = [];
        /**
     * @type {!Object<string, boolean>}
     * @private
     */ this.queuedElements_ = {};
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        this.elements_.length = 0;
        this.priorities_.length = 0;
        (0, $0669c62275461b52$export$42ffd38884aecdac)(this.queuedElements_);
    }
    /**
   * Remove and return the highest-priority element. O(log N).
   * @return {T} Element.
   */ dequeue() {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const element = elements[0];
        if (elements.length == 1) {
            elements.length = 0;
            priorities.length = 0;
        } else {
            elements[0] = /** @type {T} */ elements.pop();
            priorities[0] = /** @type {number} */ priorities.pop();
            this.siftUp_(0);
        }
        const elementKey = this.keyFunction_(element);
        delete this.queuedElements_[elementKey];
        return element;
    }
    /**
   * Enqueue an element. O(log N).
   * @param {T} element Element.
   * @return {boolean} The element was added to the queue.
   */ enqueue(element) {
        (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(!(this.keyFunction_(element) in this.queuedElements_), 'Tried to enqueue an `element` that was already added to the queue');
        const priority = this.priorityFunction_(element);
        if (priority != $1717cc2c2a98dd9c$export$b4af72c40fd57063) {
            this.elements_.push(element);
            this.priorities_.push(priority);
            this.queuedElements_[this.keyFunction_(element)] = true;
            this.siftDown_(0, this.elements_.length - 1);
            return true;
        }
        return false;
    }
    /**
   * @return {number} Count.
   */ getCount() {
        return this.elements_.length;
    }
    /**
   * Gets the index of the left child of the node at the given index.
   * @param {number} index The index of the node to get the left child for.
   * @return {number} The index of the left child.
   * @private
   */ getLeftChildIndex_(index) {
        return index * 2 + 1;
    }
    /**
   * Gets the index of the right child of the node at the given index.
   * @param {number} index The index of the node to get the right child for.
   * @return {number} The index of the right child.
   * @private
   */ getRightChildIndex_(index) {
        return index * 2 + 2;
    }
    /**
   * Gets the index of the parent of the node at the given index.
   * @param {number} index The index of the node to get the parent for.
   * @return {number} The index of the parent.
   * @private
   */ getParentIndex_(index) {
        return index - 1 >> 1;
    }
    /**
   * Make this a heap. O(N).
   * @private
   */ heapify_() {
        let i;
        for(i = (this.elements_.length >> 1) - 1; i >= 0; i--)this.siftUp_(i);
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return this.elements_.length === 0;
    }
    /**
   * @param {string} key Key.
   * @return {boolean} Is key queued.
   */ isKeyQueued(key) {
        return key in this.queuedElements_;
    }
    /**
   * @param {T} element Element.
   * @return {boolean} Is queued.
   */ isQueued(element) {
        return this.isKeyQueued(this.keyFunction_(element));
    }
    /**
   * @param {number} index The index of the node to move down.
   * @private
   */ siftUp_(index) {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const count = elements.length;
        const element = elements[index];
        const priority = priorities[index];
        const startIndex = index;
        while(index < count >> 1){
            const lIndex = this.getLeftChildIndex_(index);
            const rIndex = this.getRightChildIndex_(index);
            const smallerChildIndex = rIndex < count && priorities[rIndex] < priorities[lIndex] ? rIndex : lIndex;
            elements[index] = elements[smallerChildIndex];
            priorities[index] = priorities[smallerChildIndex];
            index = smallerChildIndex;
        }
        elements[index] = element;
        priorities[index] = priority;
        this.siftDown_(startIndex, index);
    }
    /**
   * @param {number} startIndex The index of the root.
   * @param {number} index The index of the node to move up.
   * @private
   */ siftDown_(startIndex, index) {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const element = elements[index];
        const priority = priorities[index];
        while(index > startIndex){
            const parentIndex = this.getParentIndex_(index);
            if (priorities[parentIndex] > priority) {
                elements[index] = elements[parentIndex];
                priorities[index] = priorities[parentIndex];
                index = parentIndex;
            } else break;
        }
        elements[index] = element;
        priorities[index] = priority;
    }
    /**
   * FIXME empty description for jsdoc
   */ reprioritize() {
        const priorityFunction = this.priorityFunction_;
        const elements = this.elements_;
        const priorities = this.priorities_;
        let index = 0;
        const n = elements.length;
        let element, i, priority;
        for(i = 0; i < n; ++i){
            element = elements[i];
            priority = priorityFunction(element);
            if (priority == $1717cc2c2a98dd9c$export$b4af72c40fd57063) delete this.queuedElements_[this.keyFunction_(element)];
            else {
                priorities[index] = priority;
                elements[index++] = element;
            }
        }
        elements.length = index;
        priorities.length = index;
        this.heapify_();
    }
}
var $1717cc2c2a98dd9c$export$2e2bcd8739ae039 = $1717cc2c2a98dd9c$var$PriorityQueue;


/**
 * @typedef {function(import("./Tile.js").default, string, import('./tilecoord.js').TileCoord, number): number} PriorityFunction
 */ /**
 * @typedef {[import('./Tile.js').default, string, import('./tilecoord.js').TileCoord, number]} TileQueueElement
 */ /**
 * @extends PriorityQueue<TileQueueElement>}
 */ class $0492c075e7d7702c$var$TileQueue extends (0, $1717cc2c2a98dd9c$export$2e2bcd8739ae039) {
    /**
   * @param {PriorityFunction} tilePriorityFunction Tile priority function.
   * @param {function(): ?} tileChangeCallback Function called on each tile change event.
   */ constructor(tilePriorityFunction, tileChangeCallback){
        super((element)=>tilePriorityFunction.apply(null, element), (element)=>element[0].getKey());
        /** @private */ this.boundHandleTileChange_ = this.handleTileChange.bind(this);
        /**
     * @private
     * @type {function(): ?}
     */ this.tileChangeCallback_ = tileChangeCallback;
        /**
     * @private
     * @type {number}
     */ this.tilesLoading_ = 0;
        /**
     * @private
     * @type {!Object<string,boolean>}
     */ this.tilesLoadingKeys_ = {};
    }
    /**
   * @param {TileQueueElement} element Element.
   * @return {boolean} The element was added to the queue.
   * @override
   */ enqueue(element) {
        const added = super.enqueue(element);
        if (added) {
            const tile = element[0];
            tile.addEventListener((0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CHANGE, this.boundHandleTileChange_);
        }
        return added;
    }
    /**
   * @return {number} Number of tiles loading.
   */ getTilesLoading() {
        return this.tilesLoading_;
    }
    /**
   * @param {import("./events/Event.js").default} event Event.
   * @protected
   */ handleTileChange(event) {
        const tile = /** @type {import("./Tile.js").default} */ event.target;
        const state = tile.getState();
        if (state === (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADED || state === (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).ERROR || state === (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).EMPTY) {
            if (state !== (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).ERROR) tile.removeEventListener((0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CHANGE, this.boundHandleTileChange_);
            const tileKey = tile.getKey();
            if (tileKey in this.tilesLoadingKeys_) {
                delete this.tilesLoadingKeys_[tileKey];
                --this.tilesLoading_;
            }
            this.tileChangeCallback_();
        }
    }
    /**
   * @param {number} maxTotalLoading Maximum number tiles to load simultaneously.
   * @param {number} maxNewLoads Maximum number of new tiles to load.
   */ loadMoreTiles(maxTotalLoading, maxNewLoads) {
        let newLoads = 0;
        while(this.tilesLoading_ < maxTotalLoading && newLoads < maxNewLoads && this.getCount() > 0){
            const tile = this.dequeue()[0];
            const tileKey = tile.getKey();
            const state = tile.getState();
            if (state === (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).IDLE && !(tileKey in this.tilesLoadingKeys_)) {
                this.tilesLoadingKeys_[tileKey] = true;
                ++this.tilesLoading_;
                ++newLoads;
                tile.load();
            }
        }
    }
}
var $0492c075e7d7702c$export$2e2bcd8739ae039 = $0492c075e7d7702c$var$TileQueue;
function $0492c075e7d7702c$export$f08ad5eceeff5d45(frameState, tile, tileSourceKey, tileCenter, tileResolution) {
    // Filter out tiles at higher zoom levels than the current zoom level, or that
    // are outside the visible extent.
    if (!frameState || !(tileSourceKey in frameState.wantedTiles)) return 0, $1717cc2c2a98dd9c$export$b4af72c40fd57063;
    if (!frameState.wantedTiles[tileSourceKey][tile.getKey()]) return 0, $1717cc2c2a98dd9c$export$b4af72c40fd57063;
    // Prioritize the highest zoom level tiles closest to the focus.
    // Tiles at higher zoom levels are prioritized using Math.log(tileResolution).
    // Within a zoom level, tiles are prioritized by the distance in pixels between
    // the center of the tile and the center of the viewport.  The factor of 65536
    // means that the prioritization should behave as desired for tiles up to
    // 65536 * Math.log(2) = 45426 pixels from the focus.
    const center = frameState.viewState.center;
    const deltaX = tileCenter[0] - center[0];
    const deltaY = tileCenter[1] - center[1];
    return 65536 * Math.log(tileResolution) + Math.sqrt(deltaX * deltaX + deltaY * deltaY) / tileResolution;
}


/**
 * @module ol/View
 */ 
/**
 * @module ol/ViewHint
 */ /**
 * @enum {number}
 */ var $08bf132ff3931200$export$2e2bcd8739ae039 = {
    ANIMATING: 0,
    INTERACTING: 1
};


/**
 * @module ol/ViewProperty
 */ /**
 * @enum {string}
 */ var $79a5ddcb45312553$export$2e2bcd8739ae039 = {
    CENTER: 'center',
    RESOLUTION: 'resolution',
    ROTATION: 'rotation'
};




/**
 * @module ol/centerconstraint
 */ /**
 * @module ol/math
 */ /**
 * Takes a number and clamps it to within the provided bounds.
 * @param {number} value The input number.
 * @param {number} min The minimum value to return.
 * @param {number} max The maximum value to return.
 * @return {number} The input number if it is within bounds, or the nearest
 *     number within the bounds.
 */ function $912ac838ff50d1cd$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
function $912ac838ff50d1cd$export$251bb0a9cef172e6(x, y, x1, y1, x2, y2) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    if (dx !== 0 || dy !== 0) {
        const t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) {
            x1 = x2;
            y1 = y2;
        } else if (t > 0) {
            x1 += dx * t;
            y1 += dy * t;
        }
    }
    return $912ac838ff50d1cd$export$88e6ebb4fe54f538(x, y, x1, y1);
}
function $912ac838ff50d1cd$export$88e6ebb4fe54f538(x1, y1, x2, y2) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    return dx * dx + dy * dy;
}
function $912ac838ff50d1cd$export$8240f01c446270e6(mat) {
    const n = mat.length;
    for(let i = 0; i < n; i++){
        // Find max in the i-th column (ignoring i - 1 first rows)
        let maxRow = i;
        let maxEl = Math.abs(mat[i][i]);
        for(let r = i + 1; r < n; r++){
            const absValue = Math.abs(mat[r][i]);
            if (absValue > maxEl) {
                maxEl = absValue;
                maxRow = r;
            }
        }
        if (maxEl === 0) return null; // matrix is singular
        // Swap max row with i-th (current) row
        const tmp = mat[maxRow];
        mat[maxRow] = mat[i];
        mat[i] = tmp;
        // Subtract the i-th row to make all the remaining rows 0 in the i-th column
        for(let j = i + 1; j < n; j++){
            const coef = -mat[j][i] / mat[i][i];
            for(let k = i; k < n + 1; k++)if (i == k) mat[j][k] = 0;
            else mat[j][k] += coef * mat[i][k];
        }
    }
    // Solve Ax=b for upper triangular matrix A (mat)
    const x = new Array(n);
    for(let l = n - 1; l >= 0; l--){
        x[l] = mat[l][n] / mat[l][l];
        for(let m = l - 1; m >= 0; m--)mat[m][n] -= mat[m][l] * x[l];
    }
    return x;
}
function $912ac838ff50d1cd$export$56cb859c01fa134d(angleInRadians) {
    return angleInRadians * 180 / Math.PI;
}
function $912ac838ff50d1cd$export$cba01ba138429a1d(angleInDegrees) {
    return angleInDegrees * Math.PI / 180;
}
function $912ac838ff50d1cd$export$ba467bec01d66def(a, b) {
    const r = a % b;
    return r * b < 0 ? r + b : r;
}
function $912ac838ff50d1cd$export$3a89f8d6f6bf6c9f(a, b, x) {
    return a + x * (b - a);
}
function $912ac838ff50d1cd$export$a81f732198733497(n, decimals) {
    const factor = Math.pow(10, decimals);
    return Math.round(n * factor) / factor;
}
function $912ac838ff50d1cd$export$2077e0241d6afd3c(n, decimals) {
    return Math.round($912ac838ff50d1cd$export$a81f732198733497(n, decimals));
}
function $912ac838ff50d1cd$export$a3fe094919f356fd(n, decimals) {
    return Math.floor($912ac838ff50d1cd$export$a81f732198733497(n, decimals));
}
function $912ac838ff50d1cd$export$803ce6b71a0a94b2(n, decimals) {
    return Math.ceil($912ac838ff50d1cd$export$a81f732198733497(n, decimals));
}
function $912ac838ff50d1cd$export$4997ffc0176396a6(n, min, max) {
    if (n >= min && n < max) return n;
    const range = max - min;
    return ((n - min) % range + range) % range + min;
}


function $fbfd57abbff90523$export$c2f0af2c946f6897(extent, onlyCenter, smooth) {
    return(/**
     * @param {import("./coordinate.js").Coordinate|undefined} center Center.
     * @param {number|undefined} resolution Resolution.
     * @param {import("./size.js").Size} size Viewport size; unused if `onlyCenter` was specified.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @param {Array<number>} [centerShift] Shift between map center and viewport center.
     * @return {import("./coordinate.js").Coordinate|undefined} Center.
     */ function(center, resolution, size, isMoving, centerShift) {
        if (!center) return undefined;
        if (!resolution && !onlyCenter) return center;
        const viewWidth = onlyCenter ? 0 : size[0] * resolution;
        const viewHeight = onlyCenter ? 0 : size[1] * resolution;
        const shiftX = centerShift ? centerShift[0] : 0;
        const shiftY = centerShift ? centerShift[1] : 0;
        let minX = extent[0] + viewWidth / 2 + shiftX;
        let maxX = extent[2] - viewWidth / 2 + shiftX;
        let minY = extent[1] + viewHeight / 2 + shiftY;
        let maxY = extent[3] - viewHeight / 2 + shiftY;
        // note: when zooming out of bounds, min and max values for x and y may
        // end up inverted (min > max); this has to be accounted for
        if (minX > maxX) {
            minX = (maxX + minX) / 2;
            maxX = minX;
        }
        if (minY > maxY) {
            minY = (maxY + minY) / 2;
            maxY = minY;
        }
        let x = (0, $912ac838ff50d1cd$export$7d15b64cf5a3a4c4)(center[0], minX, maxX);
        let y = (0, $912ac838ff50d1cd$export$7d15b64cf5a3a4c4)(center[1], minY, maxY);
        // during an interaction, allow some overscroll
        if (isMoving && smooth && resolution) {
            const ratio = 30 * resolution;
            x += -ratio * Math.log(1 + Math.max(0, minX - center[0]) / ratio) + ratio * Math.log(1 + Math.max(0, center[0] - maxX) / ratio);
            y += -ratio * Math.log(1 + Math.max(0, minY - center[1]) / ratio) + ratio * Math.log(1 + Math.max(0, center[1] - maxY) / ratio);
        }
        return [
            x,
            y
        ];
    });
}
function $fbfd57abbff90523$export$f883a24d5edde77c(center) {
    return center;
}


/**
 * @module ol/coordinate
 */ /**
 * @module ol/extent
 */ /**
 * @module ol/extent/Relationship
 */ /**
 * Relationship to an extent.
 * @enum {number}
 */ var $c5827132adbdcac8$export$2e2bcd8739ae039 = {
    UNKNOWN: 0,
    INTERSECTING: 1,
    ABOVE: 2,
    RIGHT: 4,
    BELOW: 8,
    LEFT: 16
};


function $3412ad7bd362b04c$export$8aceca7c77505534(coordinates) {
    const extent = $3412ad7bd362b04c$export$fe201bb3bbe031e9();
    for(let i = 0, ii = coordinates.length; i < ii; ++i)$3412ad7bd362b04c$export$1f820e3920fa5715(extent, coordinates[i]);
    return extent;
}
/**
 * @param {Array<number>} xs Xs.
 * @param {Array<number>} ys Ys.
 * @param {Extent} [dest] Destination extent.
 * @private
 * @return {Extent} Extent.
 */ function $3412ad7bd362b04c$var$_boundingExtentXYs(xs, ys, dest) {
    const minX = Math.min.apply(null, xs);
    const minY = Math.min.apply(null, ys);
    const maxX = Math.max.apply(null, xs);
    const maxY = Math.max.apply(null, ys);
    return $3412ad7bd362b04c$export$958e3e1a02eac4b6(minX, minY, maxX, maxY, dest);
}
function $3412ad7bd362b04c$export$ab1029bcae9ddb4a(extent, value, dest) {
    if (dest) {
        dest[0] = extent[0] - value;
        dest[1] = extent[1] - value;
        dest[2] = extent[2] + value;
        dest[3] = extent[3] + value;
        return dest;
    }
    return [
        extent[0] - value,
        extent[1] - value,
        extent[2] + value,
        extent[3] + value
    ];
}
function $3412ad7bd362b04c$export$9cd59f9826255e47(extent, dest) {
    if (dest) {
        dest[0] = extent[0];
        dest[1] = extent[1];
        dest[2] = extent[2];
        dest[3] = extent[3];
        return dest;
    }
    return extent.slice();
}
function $3412ad7bd362b04c$export$cbe64c389534206f(extent, x, y) {
    let dx, dy;
    if (x < extent[0]) dx = extent[0] - x;
    else if (extent[2] < x) dx = x - extent[2];
    else dx = 0;
    if (y < extent[1]) dy = extent[1] - y;
    else if (extent[3] < y) dy = y - extent[3];
    else dy = 0;
    return dx * dx + dy * dy;
}
function $3412ad7bd362b04c$export$ac68c24d37ca240f(extent, coordinate) {
    return $3412ad7bd362b04c$export$805bdfd6d6690e97(extent, coordinate[0], coordinate[1]);
}
function $3412ad7bd362b04c$export$be866b1e0809b17e(extent1, extent2) {
    return extent1[0] <= extent2[0] && extent2[2] <= extent1[2] && extent1[1] <= extent2[1] && extent2[3] <= extent1[3];
}
function $3412ad7bd362b04c$export$805bdfd6d6690e97(extent, x, y) {
    return extent[0] <= x && x <= extent[2] && extent[1] <= y && y <= extent[3];
}
function $3412ad7bd362b04c$export$f97905ead28c61a8(extent, coordinate) {
    const minX = extent[0];
    const minY = extent[1];
    const maxX = extent[2];
    const maxY = extent[3];
    const x = coordinate[0];
    const y = coordinate[1];
    let relationship = (0, $c5827132adbdcac8$export$2e2bcd8739ae039).UNKNOWN;
    if (x < minX) relationship = relationship | (0, $c5827132adbdcac8$export$2e2bcd8739ae039).LEFT;
    else if (x > maxX) relationship = relationship | (0, $c5827132adbdcac8$export$2e2bcd8739ae039).RIGHT;
    if (y < minY) relationship = relationship | (0, $c5827132adbdcac8$export$2e2bcd8739ae039).BELOW;
    else if (y > maxY) relationship = relationship | (0, $c5827132adbdcac8$export$2e2bcd8739ae039).ABOVE;
    if (relationship === (0, $c5827132adbdcac8$export$2e2bcd8739ae039).UNKNOWN) relationship = (0, $c5827132adbdcac8$export$2e2bcd8739ae039).INTERSECTING;
    return relationship;
}
function $3412ad7bd362b04c$export$fe201bb3bbe031e9() {
    return [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
}
function $3412ad7bd362b04c$export$958e3e1a02eac4b6(minX, minY, maxX, maxY, dest) {
    if (dest) {
        dest[0] = minX;
        dest[1] = minY;
        dest[2] = maxX;
        dest[3] = maxY;
        return dest;
    }
    return [
        minX,
        minY,
        maxX,
        maxY
    ];
}
function $3412ad7bd362b04c$export$3e2152b047719fa1(dest) {
    return $3412ad7bd362b04c$export$958e3e1a02eac4b6(Infinity, Infinity, -Infinity, -Infinity, dest);
}
function $3412ad7bd362b04c$export$4838bf78d04a9440(coordinate, dest) {
    const x = coordinate[0];
    const y = coordinate[1];
    return $3412ad7bd362b04c$export$958e3e1a02eac4b6(x, y, x, y, dest);
}
function $3412ad7bd362b04c$export$29e3ad4dbd0cb863(coordinates, dest) {
    const extent = $3412ad7bd362b04c$export$3e2152b047719fa1(dest);
    return $3412ad7bd362b04c$export$795cd48be4d5f252(extent, coordinates);
}
function $3412ad7bd362b04c$export$be0ab0bf96ca59ca(flatCoordinates, offset, end, stride, dest) {
    const extent = $3412ad7bd362b04c$export$3e2152b047719fa1(dest);
    return $3412ad7bd362b04c$export$30570204156ffd18(extent, flatCoordinates, offset, end, stride);
}
function $3412ad7bd362b04c$export$73b4897e93bc5c83(rings, dest) {
    const extent = $3412ad7bd362b04c$export$3e2152b047719fa1(dest);
    return $3412ad7bd362b04c$export$9b319549574402d7(extent, rings);
}
function $3412ad7bd362b04c$export$e9bab7fafb253603(extent1, extent2) {
    return extent1[0] == extent2[0] && extent1[2] == extent2[2] && extent1[1] == extent2[1] && extent1[3] == extent2[3];
}
function $3412ad7bd362b04c$export$998afeab28643bd6(extent1, extent2, tolerance) {
    return Math.abs(extent1[0] - extent2[0]) < tolerance && Math.abs(extent1[2] - extent2[2]) < tolerance && Math.abs(extent1[1] - extent2[1]) < tolerance && Math.abs(extent1[3] - extent2[3]) < tolerance;
}
function $3412ad7bd362b04c$export$8b58be045bf06082(extent1, extent2) {
    if (extent2[0] < extent1[0]) extent1[0] = extent2[0];
    if (extent2[2] > extent1[2]) extent1[2] = extent2[2];
    if (extent2[1] < extent1[1]) extent1[1] = extent2[1];
    if (extent2[3] > extent1[3]) extent1[3] = extent2[3];
    return extent1;
}
function $3412ad7bd362b04c$export$1f820e3920fa5715(extent, coordinate) {
    if (coordinate[0] < extent[0]) extent[0] = coordinate[0];
    if (coordinate[0] > extent[2]) extent[2] = coordinate[0];
    if (coordinate[1] < extent[1]) extent[1] = coordinate[1];
    if (coordinate[1] > extent[3]) extent[3] = coordinate[1];
}
function $3412ad7bd362b04c$export$795cd48be4d5f252(extent, coordinates) {
    for(let i = 0, ii = coordinates.length; i < ii; ++i)$3412ad7bd362b04c$export$1f820e3920fa5715(extent, coordinates[i]);
    return extent;
}
function $3412ad7bd362b04c$export$30570204156ffd18(extent, flatCoordinates, offset, end, stride) {
    for(; offset < end; offset += stride)$3412ad7bd362b04c$export$f1dab130b92b85a9(extent, flatCoordinates[offset], flatCoordinates[offset + 1]);
    return extent;
}
function $3412ad7bd362b04c$export$9b319549574402d7(extent, rings) {
    for(let i = 0, ii = rings.length; i < ii; ++i)$3412ad7bd362b04c$export$795cd48be4d5f252(extent, rings[i]);
    return extent;
}
function $3412ad7bd362b04c$export$f1dab130b92b85a9(extent, x, y) {
    extent[0] = Math.min(extent[0], x);
    extent[1] = Math.min(extent[1], y);
    extent[2] = Math.max(extent[2], x);
    extent[3] = Math.max(extent[3], y);
}
function $3412ad7bd362b04c$export$f9ed8a3d123a08e2(extent, callback) {
    let val;
    val = callback($3412ad7bd362b04c$export$8d09f5e2e1bf560d(extent));
    if (val) return val;
    val = callback($3412ad7bd362b04c$export$e77c1cf70445e168(extent));
    if (val) return val;
    val = callback($3412ad7bd362b04c$export$b84fa077c8b05295(extent));
    if (val) return val;
    val = callback($3412ad7bd362b04c$export$cb1538b07e6964ff(extent));
    if (val) return val;
    return false;
}
function $3412ad7bd362b04c$export$520c40045967cb15(extent) {
    let area = 0;
    if (!$3412ad7bd362b04c$export$dd1bc94b04021eeb(extent)) area = $3412ad7bd362b04c$export$3c49c185de0c2bfc(extent) * $3412ad7bd362b04c$export$c08559766941f856(extent);
    return area;
}
function $3412ad7bd362b04c$export$8d09f5e2e1bf560d(extent) {
    return [
        extent[0],
        extent[1]
    ];
}
function $3412ad7bd362b04c$export$e77c1cf70445e168(extent) {
    return [
        extent[2],
        extent[1]
    ];
}
function $3412ad7bd362b04c$export$c91255cadecfe081(extent) {
    return [
        (extent[0] + extent[2]) / 2,
        (extent[1] + extent[3]) / 2
    ];
}
function $3412ad7bd362b04c$export$a1cfd206661d0801(extent, corner) {
    let coordinate;
    if (corner === 'bottom-left') coordinate = $3412ad7bd362b04c$export$8d09f5e2e1bf560d(extent);
    else if (corner === 'bottom-right') coordinate = $3412ad7bd362b04c$export$e77c1cf70445e168(extent);
    else if (corner === 'top-left') coordinate = $3412ad7bd362b04c$export$cb1538b07e6964ff(extent);
    else if (corner === 'top-right') coordinate = $3412ad7bd362b04c$export$b84fa077c8b05295(extent);
    else throw new Error('Invalid corner');
    return coordinate;
}
function $3412ad7bd362b04c$export$7d6fa884b32a3751(extent1, extent2) {
    const minX = Math.min(extent1[0], extent2[0]);
    const minY = Math.min(extent1[1], extent2[1]);
    const maxX = Math.max(extent1[2], extent2[2]);
    const maxY = Math.max(extent1[3], extent2[3]);
    return (maxX - minX) * (maxY - minY);
}
function $3412ad7bd362b04c$export$13ba650faf8308(center, resolution, rotation, size, dest) {
    const [x0, y0, x1, y1, x2, y2, x3, y3] = $3412ad7bd362b04c$export$4b7a6fb4002cd6ac(center, resolution, rotation, size);
    return $3412ad7bd362b04c$export$958e3e1a02eac4b6(Math.min(x0, x1, x2, x3), Math.min(y0, y1, y2, y3), Math.max(x0, x1, x2, x3), Math.max(y0, y1, y2, y3), dest);
}
function $3412ad7bd362b04c$export$4b7a6fb4002cd6ac(center, resolution, rotation, size) {
    const dx = resolution * size[0] / 2;
    const dy = resolution * size[1] / 2;
    const cosRotation = Math.cos(rotation);
    const sinRotation = Math.sin(rotation);
    const xCos = dx * cosRotation;
    const xSin = dx * sinRotation;
    const yCos = dy * cosRotation;
    const ySin = dy * sinRotation;
    const x = center[0];
    const y = center[1];
    return [
        x - xCos + ySin,
        y - xSin - yCos,
        x - xCos - ySin,
        y - xSin + yCos,
        x + xCos - ySin,
        y + xSin + yCos,
        x + xCos + ySin,
        y + xSin - yCos,
        x - xCos + ySin,
        y - xSin - yCos
    ];
}
function $3412ad7bd362b04c$export$c08559766941f856(extent) {
    return extent[3] - extent[1];
}
function $3412ad7bd362b04c$export$f3fe0e9a60cde324(extent1, extent2) {
    const intersection = $3412ad7bd362b04c$export$72209efa88586d42(extent1, extent2);
    return $3412ad7bd362b04c$export$520c40045967cb15(intersection);
}
function $3412ad7bd362b04c$export$72209efa88586d42(extent1, extent2, dest) {
    const intersection = dest ? dest : $3412ad7bd362b04c$export$fe201bb3bbe031e9();
    if ($3412ad7bd362b04c$export$7b0a31e10bbff018(extent1, extent2)) {
        if (extent1[0] > extent2[0]) intersection[0] = extent1[0];
        else intersection[0] = extent2[0];
        if (extent1[1] > extent2[1]) intersection[1] = extent1[1];
        else intersection[1] = extent2[1];
        if (extent1[2] < extent2[2]) intersection[2] = extent1[2];
        else intersection[2] = extent2[2];
        if (extent1[3] < extent2[3]) intersection[3] = extent1[3];
        else intersection[3] = extent2[3];
    } else $3412ad7bd362b04c$export$3e2152b047719fa1(intersection);
    return intersection;
}
function $3412ad7bd362b04c$export$1bc603050bd777b1(extent) {
    return $3412ad7bd362b04c$export$3c49c185de0c2bfc(extent) + $3412ad7bd362b04c$export$c08559766941f856(extent);
}
function $3412ad7bd362b04c$export$31b21d0167753bb4(extent) {
    return [
        extent[2] - extent[0],
        extent[3] - extent[1]
    ];
}
function $3412ad7bd362b04c$export$cb1538b07e6964ff(extent) {
    return [
        extent[0],
        extent[3]
    ];
}
function $3412ad7bd362b04c$export$b84fa077c8b05295(extent) {
    return [
        extent[2],
        extent[3]
    ];
}
function $3412ad7bd362b04c$export$3c49c185de0c2bfc(extent) {
    return extent[2] - extent[0];
}
function $3412ad7bd362b04c$export$7b0a31e10bbff018(extent1, extent2) {
    return extent1[0] <= extent2[2] && extent1[2] >= extent2[0] && extent1[1] <= extent2[3] && extent1[3] >= extent2[1];
}
function $3412ad7bd362b04c$export$dd1bc94b04021eeb(extent) {
    return extent[2] < extent[0] || extent[3] < extent[1];
}
function $3412ad7bd362b04c$export$6a4fe494c558c238(extent, dest) {
    if (dest) {
        dest[0] = extent[0];
        dest[1] = extent[1];
        dest[2] = extent[2];
        dest[3] = extent[3];
        return dest;
    }
    return extent;
}
function $3412ad7bd362b04c$export$80cbab86674143b6(extent, value) {
    const deltaX = (extent[2] - extent[0]) / 2 * (value - 1);
    const deltaY = (extent[3] - extent[1]) / 2 * (value - 1);
    extent[0] -= deltaX;
    extent[2] += deltaX;
    extent[1] -= deltaY;
    extent[3] += deltaY;
}
function $3412ad7bd362b04c$export$a6a5a7a461419425(extent, start, end) {
    let intersects = false;
    const startRel = $3412ad7bd362b04c$export$f97905ead28c61a8(extent, start);
    const endRel = $3412ad7bd362b04c$export$f97905ead28c61a8(extent, end);
    if (startRel === (0, $c5827132adbdcac8$export$2e2bcd8739ae039).INTERSECTING || endRel === (0, $c5827132adbdcac8$export$2e2bcd8739ae039).INTERSECTING) intersects = true;
    else {
        const minX = extent[0];
        const minY = extent[1];
        const maxX = extent[2];
        const maxY = extent[3];
        const startX = start[0];
        const startY = start[1];
        const endX = end[0];
        const endY = end[1];
        const slope = (endY - startY) / (endX - startX);
        let x, y;
        if (!!(endRel & (0, $c5827132adbdcac8$export$2e2bcd8739ae039).ABOVE) && !(startRel & (0, $c5827132adbdcac8$export$2e2bcd8739ae039).ABOVE)) {
            // potentially intersects top
            x = endX - (endY - maxY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects && !!(endRel & (0, $c5827132adbdcac8$export$2e2bcd8739ae039).RIGHT) && !(startRel & (0, $c5827132adbdcac8$export$2e2bcd8739ae039).RIGHT)) {
            // potentially intersects right
            y = endY - (endX - maxX) * slope;
            intersects = y >= minY && y <= maxY;
        }
        if (!intersects && !!(endRel & (0, $c5827132adbdcac8$export$2e2bcd8739ae039).BELOW) && !(startRel & (0, $c5827132adbdcac8$export$2e2bcd8739ae039).BELOW)) {
            // potentially intersects bottom
            x = endX - (endY - minY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects && !!(endRel & (0, $c5827132adbdcac8$export$2e2bcd8739ae039).LEFT) && !(startRel & (0, $c5827132adbdcac8$export$2e2bcd8739ae039).LEFT)) {
            // potentially intersects left
            y = endY - (endX - minX) * slope;
            intersects = y >= minY && y <= maxY;
        }
    }
    return intersects;
}
function $3412ad7bd362b04c$export$9f9dcb98c894b623(extent, transformFn, dest, stops) {
    if ($3412ad7bd362b04c$export$dd1bc94b04021eeb(extent)) return $3412ad7bd362b04c$export$3e2152b047719fa1(dest);
    let coordinates = [];
    if (stops > 1) {
        const width = extent[2] - extent[0];
        const height = extent[3] - extent[1];
        for(let i = 0; i < stops; ++i)coordinates.push(extent[0] + width * i / stops, extent[1], extent[2], extent[1] + height * i / stops, extent[2] - width * i / stops, extent[3], extent[0], extent[3] - height * i / stops);
    } else coordinates = [
        extent[0],
        extent[1],
        extent[2],
        extent[1],
        extent[2],
        extent[3],
        extent[0],
        extent[3]
    ];
    transformFn(coordinates, coordinates, 2);
    const xs = [];
    const ys = [];
    for(let i = 0, l = coordinates.length; i < l; i += 2){
        xs.push(coordinates[i]);
        ys.push(coordinates[i + 1]);
    }
    return $3412ad7bd362b04c$var$_boundingExtentXYs(xs, ys, dest);
}
function $3412ad7bd362b04c$export$39a9ce3624977b84(extent, projection) {
    const projectionExtent = projection.getExtent();
    const center = $3412ad7bd362b04c$export$c91255cadecfe081(extent);
    if (projection.canWrapX() && (center[0] < projectionExtent[0] || center[0] >= projectionExtent[2])) {
        const worldWidth = $3412ad7bd362b04c$export$3c49c185de0c2bfc(projectionExtent);
        const worldsAway = Math.floor((center[0] - projectionExtent[0]) / worldWidth);
        const offset = worldsAway * worldWidth;
        extent[0] -= offset;
        extent[2] -= offset;
    }
    return extent;
}
function $3412ad7bd362b04c$export$9031237f01de0947(extent, projection, multiWorld) {
    if (projection.canWrapX()) {
        const projectionExtent = projection.getExtent();
        if (!isFinite(extent[0]) || !isFinite(extent[2])) return [
            [
                projectionExtent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ]
        ];
        $3412ad7bd362b04c$export$39a9ce3624977b84(extent, projection);
        const worldWidth = $3412ad7bd362b04c$export$3c49c185de0c2bfc(projectionExtent);
        if ($3412ad7bd362b04c$export$3c49c185de0c2bfc(extent) > worldWidth && !multiWorld) // the extent wraps around on itself
        return [
            [
                projectionExtent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ]
        ];
        if (extent[0] < projectionExtent[0]) // the extent crosses the anti meridian, so it needs to be sliced
        return [
            [
                extent[0] + worldWidth,
                extent[1],
                projectionExtent[2],
                extent[3]
            ],
            [
                projectionExtent[0],
                extent[1],
                extent[2],
                extent[3]
            ]
        ];
        if (extent[2] > projectionExtent[2]) // the extent crosses the anti meridian, so it needs to be sliced
        return [
            [
                extent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ],
            [
                projectionExtent[0],
                extent[1],
                extent[2] - worldWidth,
                extent[3]
            ]
        ];
    }
    return [
        extent
    ];
}



/**
 * @module ol/string
 */ /**
 * @param {number} number Number to be formatted
 * @param {number} width The desired width
 * @param {number} [precision] Precision of the output string (i.e. number of decimal places)
 * @return {string} Formatted string
 */ function $8b1052a20e477eb8$export$24be126cb0a7bbeb(number, width, precision) {
    const numberString = precision !== undefined ? number.toFixed(precision) : '' + number;
    let decimal = numberString.indexOf('.');
    decimal = decimal === -1 ? numberString.length : decimal;
    return decimal > width ? numberString : new Array(1 + width - decimal).join('0') + numberString;
}
function $8b1052a20e477eb8$export$66e1c0999abad646(v1, v2) {
    const s1 = ('' + v1).split('.');
    const s2 = ('' + v2).split('.');
    for(let i = 0; i < Math.max(s1.length, s2.length); i++){
        const n1 = parseInt(s1[i] || '0', 10);
        const n2 = parseInt(s2[i] || '0', 10);
        if (n1 > n2) return 1;
        if (n2 > n1) return -1;
    }
    return 0;
}


function $6542087bee114e8c$export$e16d8520af44a096(coordinate, delta) {
    coordinate[0] += +delta[0];
    coordinate[1] += +delta[1];
    return coordinate;
}
function $6542087bee114e8c$export$cbe80a3fcd2b99b7(coordinate, circle) {
    const r = circle.getRadius();
    const center = circle.getCenter();
    const x0 = center[0];
    const y0 = center[1];
    const x1 = coordinate[0];
    const y1 = coordinate[1];
    let dx = x1 - x0;
    const dy = y1 - y0;
    if (dx === 0 && dy === 0) dx = 1;
    const d = Math.sqrt(dx * dx + dy * dy);
    const x = x0 + r * dx / d;
    const y = y0 + r * dy / d;
    return [
        x,
        y
    ];
}
function $6542087bee114e8c$export$18cdd31d17f97131(coordinate, segment) {
    const x0 = coordinate[0];
    const y0 = coordinate[1];
    const start = segment[0];
    const end = segment[1];
    const x1 = start[0];
    const y1 = start[1];
    const x2 = end[0];
    const y2 = end[1];
    const dx = x2 - x1;
    const dy = y2 - y1;
    const along = dx === 0 && dy === 0 ? 0 : (dx * (x0 - x1) + dy * (y0 - y1)) / (dx * dx + dy * dy || 0);
    let x, y;
    if (along <= 0) {
        x = x1;
        y = y1;
    } else if (along >= 1) {
        x = x2;
        y = y2;
    } else {
        x = x1 + along * dx;
        y = y1 + along * dy;
    }
    return [
        x,
        y
    ];
}
function $6542087bee114e8c$export$35ad6765fe262b6(fractionDigits) {
    return(/**
     * @param {Coordinate} coordinate Coordinate.
     * @return {string} String XY.
     */ function(coordinate) {
        return $6542087bee114e8c$export$9ff8f16060979e0a(coordinate, fractionDigits);
    });
}
function $6542087bee114e8c$export$6eb0ac5f024d8590(hemispheres, degrees, fractionDigits) {
    const normalizedDegrees = (0, $912ac838ff50d1cd$export$ba467bec01d66def)(degrees + 180, 360) - 180;
    const x = Math.abs(3600 * normalizedDegrees);
    const decimals = fractionDigits || 0;
    let deg = Math.floor(x / 3600);
    let min = Math.floor((x - deg * 3600) / 60);
    let sec = (0, $912ac838ff50d1cd$export$a81f732198733497)(x - deg * 3600 - min * 60, decimals);
    if (sec >= 60) {
        sec = 0;
        min += 1;
    }
    if (min >= 60) {
        min = 0;
        deg += 1;
    }
    let hdms = deg + '\u00b0';
    if (min !== 0 || sec !== 0) hdms += ' ' + (0, $8b1052a20e477eb8$export$24be126cb0a7bbeb)(min, 2) + '\u2032';
    if (sec !== 0) hdms += ' ' + (0, $8b1052a20e477eb8$export$24be126cb0a7bbeb)(sec, 2, decimals) + '\u2033';
    if (normalizedDegrees !== 0) hdms += ' ' + hemispheres.charAt(normalizedDegrees < 0 ? 1 : 0);
    return hdms;
}
function $6542087bee114e8c$export$d9468344d3651243(coordinate, template, fractionDigits) {
    if (coordinate) return template.replace('{x}', coordinate[0].toFixed(fractionDigits)).replace('{y}', coordinate[1].toFixed(fractionDigits));
    return '';
}
function $6542087bee114e8c$export$e9bab7fafb253603(coordinate1, coordinate2) {
    let equals = true;
    for(let i = coordinate1.length - 1; i >= 0; --i)if (coordinate1[i] != coordinate2[i]) {
        equals = false;
        break;
    }
    return equals;
}
function $6542087bee114e8c$export$bb628a54ab399bc9(coordinate, angle) {
    const cosAngle = Math.cos(angle);
    const sinAngle = Math.sin(angle);
    const x = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
    const y = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
    coordinate[0] = x;
    coordinate[1] = y;
    return coordinate;
}
function $6542087bee114e8c$export$dcdf75081b88279d(coordinate, scale) {
    coordinate[0] *= scale;
    coordinate[1] *= scale;
    return coordinate;
}
function $6542087bee114e8c$export$88e6ebb4fe54f538(coord1, coord2) {
    const dx = coord1[0] - coord2[0];
    const dy = coord1[1] - coord2[1];
    return dx * dx + dy * dy;
}
function $6542087bee114e8c$export$9f17032d917177de(coord1, coord2) {
    return Math.sqrt($6542087bee114e8c$export$88e6ebb4fe54f538(coord1, coord2));
}
function $6542087bee114e8c$export$6985570514055196(coordinate, segment) {
    return $6542087bee114e8c$export$88e6ebb4fe54f538(coordinate, $6542087bee114e8c$export$18cdd31d17f97131(coordinate, segment));
}
function $6542087bee114e8c$export$c883fd238161f841(coordinate, fractionDigits) {
    if (coordinate) return $6542087bee114e8c$export$6eb0ac5f024d8590('NS', coordinate[1], fractionDigits) + ' ' + $6542087bee114e8c$export$6eb0ac5f024d8590('EW', coordinate[0], fractionDigits);
    return '';
}
function $6542087bee114e8c$export$9ff8f16060979e0a(coordinate, fractionDigits) {
    return $6542087bee114e8c$export$d9468344d3651243(coordinate, '{x}, {y}', fractionDigits);
}
function $6542087bee114e8c$export$39a9ce3624977b84(coordinate, projection) {
    if (projection.canWrapX()) {
        const worldWidth = (0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(projection.getExtent());
        const worldsAway = $6542087bee114e8c$export$24e2b27d1ff0c1d5(coordinate, projection, worldWidth);
        if (worldsAway) coordinate[0] -= worldsAway * worldWidth;
    }
    return coordinate;
}
function $6542087bee114e8c$export$24e2b27d1ff0c1d5(coordinate, projection, sourceExtentWidth) {
    const projectionExtent = projection.getExtent();
    let worldsAway = 0;
    if (projection.canWrapX() && (coordinate[0] < projectionExtent[0] || coordinate[0] > projectionExtent[2])) {
        sourceExtentWidth = sourceExtentWidth || (0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(projectionExtent);
        worldsAway = Math.floor((coordinate[0] - projectionExtent[0]) / sourceExtentWidth);
    }
    return worldsAway;
}
function $6542087bee114e8c$export$47cb7eb79666608a(p0, pA, pB) {
    const lenA = Math.sqrt((pA[0] - p0[0]) * (pA[0] - p0[0]) + (pA[1] - p0[1]) * (pA[1] - p0[1]));
    const tangentA = [
        (pA[0] - p0[0]) / lenA,
        (pA[1] - p0[1]) / lenA
    ];
    const orthoA = [
        -tangentA[1],
        tangentA[0]
    ];
    const lenB = Math.sqrt((pB[0] - p0[0]) * (pB[0] - p0[0]) + (pB[1] - p0[1]) * (pB[1] - p0[1]));
    const tangentB = [
        (pB[0] - p0[0]) / lenB,
        (pB[1] - p0[1]) / lenB
    ];
    // this angle can be clockwise or anticlockwise; hence the computation afterwards
    let angle = lenA === 0 || lenB === 0 ? 0 : Math.acos((0, $912ac838ff50d1cd$export$7d15b64cf5a3a4c4)(tangentB[0] * tangentA[0] + tangentB[1] * tangentA[1], -1, 1));
    angle = Math.max(angle, 0.00001); // avoid a zero angle otherwise this is detected as a line cap
    const isClockwise = tangentB[0] * orthoA[0] + tangentB[1] * orthoA[1] > 0;
    return !isClockwise ? Math.PI * 2 - angle : angle;
}


/**
 * @module ol/easing
 */ /**
 * Start slow and speed up.
 * @param {number} t Input between 0 and 1.
 * @return {number} Output between 0 and 1.
 * @api
 */ function $6aa29dc5b469ae30$export$929e5a82286172a6(t) {
    return Math.pow(t, 3);
}
function $6aa29dc5b469ae30$export$57636bb43b1ccbb0(t) {
    return 1 - $6aa29dc5b469ae30$export$929e5a82286172a6(1 - t);
}
function $6aa29dc5b469ae30$export$9b47139b511b56e4(t) {
    return 3 * t * t - 2 * t * t * t;
}
function $6aa29dc5b469ae30$export$45db2fc2f15997e7(t) {
    return t;
}
function $6aa29dc5b469ae30$export$7f4472f6708afaf3(t) {
    if (t < 0.5) return $6aa29dc5b469ae30$export$9b47139b511b56e4(2 * t);
    return 1 - $6aa29dc5b469ae30$export$9b47139b511b56e4(2 * (t - 0.5));
}




/**
 * @module ol/geom/Polygon
 */ 


/**
 * @module ol/sphere
 */ 
const $662150a3b787a9f8$export$63f2df7bd7371262 = 6371008.8;
function $662150a3b787a9f8$export$79376507b09a66f(c1, c2, radius) {
    radius = radius || $662150a3b787a9f8$export$63f2df7bd7371262;
    const lat1 = (0, $912ac838ff50d1cd$export$cba01ba138429a1d)(c1[1]);
    const lat2 = (0, $912ac838ff50d1cd$export$cba01ba138429a1d)(c2[1]);
    const deltaLatBy2 = (lat2 - lat1) / 2;
    const deltaLonBy2 = (0, $912ac838ff50d1cd$export$cba01ba138429a1d)(c2[0] - c1[0]) / 2;
    const a = Math.sin(deltaLatBy2) * Math.sin(deltaLatBy2) + Math.sin(deltaLonBy2) * Math.sin(deltaLonBy2) * Math.cos(lat1) * Math.cos(lat2);
    return 2 * radius * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
/**
 * Get the cumulative great circle length of linestring coordinates (geographic).
 * @param {Array} coordinates Linestring coordinates.
 * @param {number} radius The sphere radius to use.
 * @return {number} The length (in meters).
 */ function $662150a3b787a9f8$var$getLengthInternal(coordinates, radius) {
    let length = 0;
    for(let i = 0, ii = coordinates.length; i < ii - 1; ++i)length += $662150a3b787a9f8$export$79376507b09a66f(coordinates[i], coordinates[i + 1], radius);
    return length;
}
function $662150a3b787a9f8$export$f0d11c074a923179(geometry, options) {
    options = options || {};
    const radius = options.radius || $662150a3b787a9f8$export$63f2df7bd7371262;
    const projection = options.projection || 'EPSG:3857';
    const type = geometry.getType();
    if (type !== 'GeometryCollection') geometry = geometry.clone().transform(projection, 'EPSG:4326');
    let length = 0;
    let coordinates, coords, i, ii, j, jj;
    switch(type){
        case 'Point':
        case 'MultiPoint':
            break;
        case 'LineString':
        case 'LinearRing':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            length = $662150a3b787a9f8$var$getLengthInternal(coordinates, radius);
            break;
        case 'MultiLineString':
        case 'Polygon':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i)length += $662150a3b787a9f8$var$getLengthInternal(coordinates[i], radius);
            break;
        case 'MultiPolygon':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i){
                coords = coordinates[i];
                for(j = 0, jj = coords.length; j < jj; ++j)length += $662150a3b787a9f8$var$getLengthInternal(coords[j], radius);
            }
            break;
        case 'GeometryCollection':
            {
                const geometries = /** @type {import("./geom/GeometryCollection.js").default} */ geometry.getGeometries();
                for(i = 0, ii = geometries.length; i < ii; ++i)length += $662150a3b787a9f8$export$f0d11c074a923179(geometries[i], options);
                break;
            }
        default:
            throw new Error('Unsupported geometry type: ' + type);
    }
    return length;
}
/**
 * Returns the spherical area for a list of coordinates.
 *
 * [Reference](https://trs.jpl.nasa.gov/handle/2014/40409)
 * Robert. G. Chamberlain and William H. Duquette, "Some Algorithms for
 * Polygons on a Sphere", JPL Publication 07-03, Jet Propulsion
 * Laboratory, Pasadena, CA, June 2007
 *
 * @param {Array<import("./coordinate.js").Coordinate>} coordinates List of coordinates of a linear
 * ring. If the ring is oriented clockwise, the area will be positive,
 * otherwise it will be negative.
 * @param {number} radius The sphere radius.
 * @return {number} Area (in square meters).
 */ function $662150a3b787a9f8$var$getAreaInternal(coordinates, radius) {
    let area = 0;
    const len = coordinates.length;
    let x1 = coordinates[len - 1][0];
    let y1 = coordinates[len - 1][1];
    for(let i = 0; i < len; i++){
        const x2 = coordinates[i][0];
        const y2 = coordinates[i][1];
        area += (0, $912ac838ff50d1cd$export$cba01ba138429a1d)(x2 - x1) * (2 + Math.sin((0, $912ac838ff50d1cd$export$cba01ba138429a1d)(y1)) + Math.sin((0, $912ac838ff50d1cd$export$cba01ba138429a1d)(y2)));
        x1 = x2;
        y1 = y2;
    }
    return area * radius * radius / 2.0;
}
function $662150a3b787a9f8$export$520c40045967cb15(geometry, options) {
    options = options || {};
    const radius = options.radius || $662150a3b787a9f8$export$63f2df7bd7371262;
    const projection = options.projection || 'EPSG:3857';
    const type = geometry.getType();
    if (type !== 'GeometryCollection') geometry = geometry.clone().transform(projection, 'EPSG:4326');
    let area = 0;
    let coordinates, coords, i, ii, j, jj;
    switch(type){
        case 'Point':
        case 'MultiPoint':
        case 'LineString':
        case 'MultiLineString':
        case 'LinearRing':
            break;
        case 'Polygon':
            coordinates = /** @type {import("./geom/Polygon.js").default} */ geometry.getCoordinates();
            area = Math.abs($662150a3b787a9f8$var$getAreaInternal(coordinates[0], radius));
            for(i = 1, ii = coordinates.length; i < ii; ++i)area -= Math.abs($662150a3b787a9f8$var$getAreaInternal(coordinates[i], radius));
            break;
        case 'MultiPolygon':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i){
                coords = coordinates[i];
                area += Math.abs($662150a3b787a9f8$var$getAreaInternal(coords[0], radius));
                for(j = 1, jj = coords.length; j < jj; ++j)area -= Math.abs($662150a3b787a9f8$var$getAreaInternal(coords[j], radius));
            }
            break;
        case 'GeometryCollection':
            {
                const geometries = /** @type {import("./geom/GeometryCollection.js").default} */ geometry.getGeometries();
                for(i = 0, ii = geometries.length; i < ii; ++i)area += $662150a3b787a9f8$export$520c40045967cb15(geometries[i], options);
                break;
            }
        default:
            throw new Error('Unsupported geometry type: ' + type);
    }
    return area;
}
function $662150a3b787a9f8$export$cc800923e997bb8(c1, distance, bearing, radius) {
    radius = radius || $662150a3b787a9f8$export$63f2df7bd7371262;
    const lat1 = (0, $912ac838ff50d1cd$export$cba01ba138429a1d)(c1[1]);
    const lon1 = (0, $912ac838ff50d1cd$export$cba01ba138429a1d)(c1[0]);
    const dByR = distance / radius;
    const lat = Math.asin(Math.sin(lat1) * Math.cos(dByR) + Math.cos(lat1) * Math.sin(dByR) * Math.cos(bearing));
    const lon = lon1 + Math.atan2(Math.sin(bearing) * Math.sin(dByR) * Math.cos(lat1), Math.cos(dByR) - Math.sin(lat1) * Math.sin(lat));
    return [
        (0, $912ac838ff50d1cd$export$56cb859c01fa134d)(lon),
        (0, $912ac838ff50d1cd$export$56cb859c01fa134d)(lat)
    ];
}


/**
 * @module ol/geom/LinearRing
 */ 
/**
 * @module ol/geom/SimpleGeometry
 */ 

/**
 * @module ol/geom/Geometry
 */ 


/**
 * @module ol/proj
 */ /**
 * The ol/proj module stores:
 * a list of {@link module:ol/proj/Projection~Projection}
 * objects, one for each projection supported by the application
 * a list of transform functions needed to convert coordinates in one projection
 * into another.
 *
 * The static functions are the methods used to maintain these.
 * Each transform function can handle not only simple coordinate pairs, but also
 * large arrays of coordinates such as vector geometries.
 *
 * When loaded, the library adds projection objects for EPSG:4326 (WGS84
 * geographic coordinates) and EPSG:3857 (Web or Spherical Mercator, as used
 * for example by Bing Maps or OpenStreetMap), together with the relevant
 * transform functions.
 *
 * Additional transforms may be added by using the http://proj4js.org/
 * library (version 2.2 or later). You can use the full build supplied by
 * Proj4js, or create a custom build to support those projections you need; see
 * the Proj4js website for how to do this. You also need the Proj4js definitions
 * for the required projections. These definitions can be obtained from
 * https://spatialreference.org/, and are a JS function, so can be loaded in a
 * script tag (as in the examples) or pasted into your application.
 *
 * After all required projection definitions are added to proj4's registry (by
 * using `proj4.defs()`), simply call `register(proj4)` from the `ol/proj/proj4`
 * package. Existing transforms are not changed by this function. See
 * examples/wms-image-custom-proj for an example of this.
 *
 * Additional projection definitions can be registered with `proj4.defs()` any
 * time. Just make sure to call `register(proj4)` again; for example, with user-supplied data where you don't
 * know in advance what projections are needed, you can initially load minimal
 * support and then load whichever are requested.
 *
 * Note that Proj4js does not support projection extents. If you want to add
 * one for creating default tile grids, you can add it after the Projection
 * object has been created with `setExtent`, for example,
 * `get('EPSG:1234').setExtent(extent)`.
 *
 * In addition to Proj4js support, any transform functions can be added with
 * {@link module:ol/proj.addCoordinateTransforms}. To use this, you must first create
 * a {@link module:ol/proj/Projection~Projection} object for the new projection and add it with
 * {@link module:ol/proj.addProjection}. You can then add the forward and inverse
 * functions with {@link module:ol/proj.addCoordinateTransforms}. See
 * examples/wms-custom-proj for an example of this.
 *
 * Note that if no transforms are needed and you only need to define the
 * projection, just add a {@link module:ol/proj/Projection~Projection} with
 * {@link module:ol/proj.addProjection}. See examples/wms-no-proj for an example of
 * this.
 */ /**
 * @module ol/console
 */ /**
 * @typedef {'info'|'warn'|'error'|'none'} Level
 */ /**
 * @type {Object<Level, number>}
 */ const $cf824eca25b51fde$var$levels = {
    info: 1,
    warn: 2,
    error: 3,
    none: 4
};
/**
 * @type {number}
 */ let $cf824eca25b51fde$var$level = $cf824eca25b51fde$var$levels.info;
function $cf824eca25b51fde$export$2c97a59140dbf245(l) {
    $cf824eca25b51fde$var$level = $cf824eca25b51fde$var$levels[l];
}
function $cf824eca25b51fde$export$bef1f36f5486a6a3(...args) {
    if ($cf824eca25b51fde$var$level > $cf824eca25b51fde$var$levels.info) return;
    console.log(...args); // eslint-disable-line no-console
}
function $cf824eca25b51fde$export$c106dd0671a0fc2d(...args) {
    if ($cf824eca25b51fde$var$level > $cf824eca25b51fde$var$levels.warn) return;
    console.warn(...args); // eslint-disable-line no-console
}
function $cf824eca25b51fde$export$a3bc9b8ed74fc(...args) {
    if ($cf824eca25b51fde$var$level > $cf824eca25b51fde$var$levels.error) return;
    console.error(...args); // eslint-disable-line no-console
}






/**
 * @module ol/proj/Units
 */ /**
 * @typedef {'radians' | 'degrees' | 'ft' | 'm' | 'pixels' | 'tile-pixels' | 'us-ft'} Units
 * Projection units.
 */ /**
 * See http://duff.ess.washington.edu/data/raster/drg/docs/geotiff.txt
 * @type {Object<number, Units>}
 */ const $8ebfe5645312696b$var$unitByCode = {
    '9001': 'm',
    '9002': 'ft',
    '9003': 'us-ft',
    '9101': 'radians',
    '9102': 'degrees'
};
function $8ebfe5645312696b$export$7f58726df3255edc(code) {
    return $8ebfe5645312696b$var$unitByCode[code];
}
const $8ebfe5645312696b$export$1482081eec883108 = {
    // use the radius of the Normal sphere
    'radians': 6370997 / (2 * Math.PI),
    'degrees': 2 * Math.PI * 6370997 / 360,
    'ft': 0.3048,
    'm': 1,
    'us-ft': 1200 / 3937
};


/**
 * @module ol/proj/epsg3857
 */ /**
 * @module ol/proj/Projection
 */ 
/**
 * The function is called with a `number` view resolution and a
 * {@link module:ol/coordinate~Coordinate} as arguments, and returns the `number` resolution
 * in projection units at the passed coordinate.
 * @typedef {function(number, import("../coordinate.js").Coordinate):number} GetPointResolution
 * @api
 */ /**
 * @typedef {Object} Options
 * @property {string} code The SRS identifier code, e.g. `EPSG:4326`.
 * @property {import("./Units.js").Units} [units] Units. Required unless a
 * proj4 projection is defined for `code`.
 * @property {import("../extent.js").Extent} [extent] The validity extent for the SRS.
 * @property {string} [axisOrientation='enu'] The axis orientation as specified in Proj4.
 * @property {boolean} [global=false] Whether the projection is valid for the whole globe.
 * @property {number} [metersPerUnit] The meters per unit for the SRS.
 * If not provided, the `units` are used to get the meters per unit from the {@link METERS_PER_UNIT}
 * lookup table.
 * @property {import("../extent.js").Extent} [worldExtent] The world extent for the SRS.
 * @property {GetPointResolution} [getPointResolution]
 * Function to determine resolution at a point. The function is called with a
 * `number` view resolution and a {@link module:ol/coordinate~Coordinate} as arguments, and returns
 * the `number` resolution in projection units at the passed coordinate. If this is `undefined`,
 * the default {@link module:ol/proj.getPointResolution} function will be used.
 */ /**
 * @classdesc
 * In most cases, you should not need to create instances of this class.
 * Instead, where projection information is required, you can use a string
 * projection code or identifier (e.g. `EPSG:4326`) instead of a projection
 * instance.
 *
 * The library includes support for transforming coordinates between the following
 * projections:
 *
 *  WGS 84 / Geographic - Using codes `EPSG:4326`, `CRS:84`, `urn:ogc:def:crs:EPSG:6.6:4326`,
 *    `urn:ogc:def:crs:OGC:1.3:CRS84`, `urn:ogc:def:crs:OGC:2:84`, `http://www.opengis.net/gml/srs/epsg.xml#4326`,
 *    or `urn:x-ogc:def:crs:EPSG:4326`
 *  WGS 84 / Spherical Mercator - Using codes `EPSG:3857`, `EPSG:102100`, `EPSG:102113`, `EPSG:900913`,
 *    `urn:ogc:def:crs:EPSG:6.18:3:3857`, or `http://www.opengis.net/gml/srs/epsg.xml#3857`
 *  WGS 84 / UTM zones - Using codes `EPSG:32601` through `EPSG:32660` for northern zones
 *    and `EPSG:32701` through `EPSG:32760` for southern zones. Note that the built-in UTM transforms
 *    are lower accuracy (with errors on the order of 0.1 m) than those that you might get in a
 *    library like [proj4js](https://github.com/proj4js/proj4js).
 *
 * For additional projection support, or to use higher accuracy transforms than the built-in ones, you can use
 * the [proj4js](https://github.com/proj4js/proj4js) library. With `proj4js`, after adding any new projection
 * definitions, call the {@link module:ol/proj/proj4.register} function.
 *
 * You can use the {@link module:ol/proj.get} function to retrieve a projection instance
 * for one of the registered projections.
 *
 * @api
 */ class $148e47e1fc09dc0c$var$Projection {
    /**
   * @param {Options} options Projection options.
   */ constructor(options){
        /**
     * @private
     * @type {string}
     */ this.code_ = options.code;
        /**
     * Units of projected coordinates. When set to `TILE_PIXELS`, a
     * `this.extent_` and `this.worldExtent_` must be configured properly for each
     * tile.
     * @private
     * @type {import("./Units.js").Units}
     */ this.units_ = /** @type {import("./Units.js").Units} */ options.units;
        /**
     * Validity extent of the projection in projected coordinates. For projections
     * with `TILE_PIXELS` units, this is the extent of the tile in
     * tile pixel space.
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = options.extent !== undefined ? options.extent : null;
        /**
     * Extent of the world in EPSG:4326. For projections with
     * `TILE_PIXELS` units, this is the extent of the tile in
     * projected coordinate space.
     * @private
     * @type {import("../extent.js").Extent}
     */ this.worldExtent_ = options.worldExtent !== undefined ? options.worldExtent : null;
        /**
     * @private
     * @type {string}
     */ this.axisOrientation_ = options.axisOrientation !== undefined ? options.axisOrientation : 'enu';
        /**
     * @private
     * @type {boolean}
     */ this.global_ = options.global !== undefined ? options.global : false;
        /**
     * @private
     * @type {boolean}
     */ this.canWrapX_ = !!(this.global_ && this.extent_);
        /**
     * @private
     * @type {GetPointResolution|undefined}
     */ this.getPointResolutionFunc_ = options.getPointResolution;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.defaultTileGrid_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.metersPerUnit_ = options.metersPerUnit;
    }
    /**
   * @return {boolean} The projection is suitable for wrapping the x-axis
   */ canWrapX() {
        return this.canWrapX_;
    }
    /**
   * Get the code for this projection, e.g. 'EPSG:4326'.
   * @return {string} Code.
   * @api
   */ getCode() {
        return this.code_;
    }
    /**
   * Get the validity extent for this projection.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        return this.extent_;
    }
    /**
   * Get the units of this projection.
   * @return {import("./Units.js").Units} Units.
   * @api
   */ getUnits() {
        return this.units_;
    }
    /**
   * Get the amount of meters per unit of this projection.  If the projection is
   * not configured with `metersPerUnit` or a units identifier, the return is
   * `undefined`.
   * @return {number|undefined} Meters.
   * @api
   */ getMetersPerUnit() {
        return this.metersPerUnit_ || (0, $8ebfe5645312696b$export$1482081eec883108)[this.units_];
    }
    /**
   * Get the world extent for this projection.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getWorldExtent() {
        return this.worldExtent_;
    }
    /**
   * Get the axis orientation of this projection.
   * Example values are:
   * enu - the default easting, northing, elevation.
   * neu - northing, easting, up - useful for "lat/long" geographic coordinates,
   *     or south orientated transverse mercator.
   * wnu - westing, northing, up - some planetary coordinate systems have
   *     "west positive" coordinate systems
   * @return {string} Axis orientation.
   * @api
   */ getAxisOrientation() {
        return this.axisOrientation_;
    }
    /**
   * Is this projection a global projection which spans the whole world?
   * @return {boolean} Whether the projection is global.
   * @api
   */ isGlobal() {
        return this.global_;
    }
    /**
   * Set if the projection is a global projection which spans the whole world
   * @param {boolean} global Whether the projection is global.
   * @api
   */ setGlobal(global) {
        this.global_ = global;
        this.canWrapX_ = !!(global && this.extent_);
    }
    /**
   * @return {import("../tilegrid/TileGrid.js").default} The default tile grid.
   */ getDefaultTileGrid() {
        return this.defaultTileGrid_;
    }
    /**
   * @param {import("../tilegrid/TileGrid.js").default} tileGrid The default tile grid.
   */ setDefaultTileGrid(tileGrid) {
        this.defaultTileGrid_ = tileGrid;
    }
    /**
   * Set the validity extent for this projection.
   * @param {import("../extent.js").Extent} extent Extent.
   * @api
   */ setExtent(extent) {
        this.extent_ = extent;
        this.canWrapX_ = !!(this.global_ && extent);
    }
    /**
   * Set the world extent for this projection.
   * @param {import("../extent.js").Extent} worldExtent World extent
   *     [minlon, minlat, maxlon, maxlat].
   * @api
   */ setWorldExtent(worldExtent) {
        this.worldExtent_ = worldExtent;
    }
    /**
   * Set the getPointResolution function (see {@link module:ol/proj.getPointResolution}
   * for this projection.
   * @param {function(number, import("../coordinate.js").Coordinate):number} func Function
   * @api
   */ setGetPointResolution(func) {
        this.getPointResolutionFunc_ = func;
    }
    /**
   * Get the custom point resolution function for this projection (if set).
   * @return {GetPointResolution|undefined} The custom point
   * resolution function (if set).
   */ getPointResolutionFunc() {
        return this.getPointResolutionFunc_;
    }
}
var $148e47e1fc09dc0c$export$2e2bcd8739ae039 = $148e47e1fc09dc0c$var$Projection;


const $cb7fa74d3a677d28$export$2d2c9be8b5b863f = 6378137;
const $cb7fa74d3a677d28$export$f3928063e5e96d35 = Math.PI * $cb7fa74d3a677d28$export$2d2c9be8b5b863f;
const $cb7fa74d3a677d28$export$21e6da8a7375dfe8 = [
    -$cb7fa74d3a677d28$export$f3928063e5e96d35,
    -$cb7fa74d3a677d28$export$f3928063e5e96d35,
    $cb7fa74d3a677d28$export$f3928063e5e96d35,
    $cb7fa74d3a677d28$export$f3928063e5e96d35
];
const $cb7fa74d3a677d28$export$ae9d6ed80df710e5 = [
    -180,
    -85,
    180,
    85
];
const $cb7fa74d3a677d28$export$d26945d1ad52feeb = $cb7fa74d3a677d28$export$2d2c9be8b5b863f * Math.log(Math.tan(Math.PI / 2));
/**
 * @classdesc
 * Projection object for web/spherical Mercator (EPSG:3857).
 */ class $cb7fa74d3a677d28$var$EPSG3857Projection extends (0, $148e47e1fc09dc0c$export$2e2bcd8739ae039) {
    /**
   * @param {string} code Code.
   */ constructor(code){
        super({
            code: code,
            units: 'm',
            extent: $cb7fa74d3a677d28$export$21e6da8a7375dfe8,
            global: true,
            worldExtent: $cb7fa74d3a677d28$export$ae9d6ed80df710e5,
            getPointResolution: function(resolution, point) {
                return resolution / Math.cosh(point[1] / $cb7fa74d3a677d28$export$2d2c9be8b5b863f);
            }
        });
    }
}
const $cb7fa74d3a677d28$export$b508d7ad9a891c1b = [
    new $cb7fa74d3a677d28$var$EPSG3857Projection('EPSG:3857'),
    new $cb7fa74d3a677d28$var$EPSG3857Projection('EPSG:102100'),
    new $cb7fa74d3a677d28$var$EPSG3857Projection('EPSG:102113'),
    new $cb7fa74d3a677d28$var$EPSG3857Projection('EPSG:900913'),
    new $cb7fa74d3a677d28$var$EPSG3857Projection('http://www.opengis.net/def/crs/EPSG/0/3857'),
    new $cb7fa74d3a677d28$var$EPSG3857Projection('http://www.opengis.net/gml/srs/epsg.xml#3857')
];
function $cb7fa74d3a677d28$export$1ff8bb36c0983070(input, output, dimension, stride) {
    const length = input.length;
    dimension = dimension > 1 ? dimension : 2;
    stride = stride ?? dimension;
    if (output === undefined) {
        if (dimension > 2) // preserve values beyond second dimension
        output = input.slice();
        else output = new Array(length);
    }
    for(let i = 0; i < length; i += stride){
        output[i] = $cb7fa74d3a677d28$export$f3928063e5e96d35 * input[i] / 180;
        let y = $cb7fa74d3a677d28$export$2d2c9be8b5b863f * Math.log(Math.tan(Math.PI * (+input[i + 1] + 90) / 360));
        if (y > $cb7fa74d3a677d28$export$d26945d1ad52feeb) y = $cb7fa74d3a677d28$export$d26945d1ad52feeb;
        else if (y < -$cb7fa74d3a677d28$export$d26945d1ad52feeb) y = -$cb7fa74d3a677d28$export$d26945d1ad52feeb;
        output[i + 1] = y;
    }
    return output;
}
function $cb7fa74d3a677d28$export$8c71322ec28ed6b4(input, output, dimension, stride) {
    const length = input.length;
    dimension = dimension > 1 ? dimension : 2;
    stride = stride ?? dimension;
    if (output === undefined) {
        if (dimension > 2) // preserve values beyond second dimension
        output = input.slice();
        else output = new Array(length);
    }
    for(let i = 0; i < length; i += stride){
        output[i] = 180 * input[i] / $cb7fa74d3a677d28$export$f3928063e5e96d35;
        output[i + 1] = 360 * Math.atan(Math.exp(input[i + 1] / $cb7fa74d3a677d28$export$2d2c9be8b5b863f)) / Math.PI - 90;
    }
    return output;
}


/**
 * @module ol/proj/epsg4326
 */ 
const $08c45d5d270b4708$export$2d2c9be8b5b863f = 6378137;
const $08c45d5d270b4708$export$21e6da8a7375dfe8 = [
    -180,
    -90,
    180,
    90
];
const $08c45d5d270b4708$export$1482081eec883108 = Math.PI * $08c45d5d270b4708$export$2d2c9be8b5b863f / 180;
/**
 * @classdesc
 * Projection object for WGS84 geographic coordinates (EPSG:4326).
 *
 * Note that OpenLayers does not strictly comply with the EPSG definition.
 * The EPSG registry defines 4326 as a CRS for Latitude,Longitude (y,x).
 * OpenLayers treats EPSG:4326 as a pseudo-projection, with x,y coordinates.
 */ class $08c45d5d270b4708$var$EPSG4326Projection extends (0, $148e47e1fc09dc0c$export$2e2bcd8739ae039) {
    /**
   * @param {string} code Code.
   * @param {string} [axisOrientation] Axis orientation.
   */ constructor(code, axisOrientation){
        super({
            code: code,
            units: 'degrees',
            extent: $08c45d5d270b4708$export$21e6da8a7375dfe8,
            axisOrientation: axisOrientation,
            global: true,
            metersPerUnit: $08c45d5d270b4708$export$1482081eec883108,
            worldExtent: $08c45d5d270b4708$export$21e6da8a7375dfe8
        });
    }
}
const $08c45d5d270b4708$export$b508d7ad9a891c1b = [
    new $08c45d5d270b4708$var$EPSG4326Projection('CRS:84'),
    new $08c45d5d270b4708$var$EPSG4326Projection('EPSG:4326', 'neu'),
    new $08c45d5d270b4708$var$EPSG4326Projection('urn:ogc:def:crs:OGC:1.3:CRS84'),
    new $08c45d5d270b4708$var$EPSG4326Projection('urn:ogc:def:crs:OGC:2:84'),
    new $08c45d5d270b4708$var$EPSG4326Projection('http://www.opengis.net/def/crs/OGC/1.3/CRS84'),
    new $08c45d5d270b4708$var$EPSG4326Projection('http://www.opengis.net/gml/srs/epsg.xml#4326', 'neu'),
    new $08c45d5d270b4708$var$EPSG4326Projection('http://www.opengis.net/def/crs/EPSG/0/4326', 'neu')
];


/**
 * @module ol/proj/projections
 */ /**
 * @type {Object<string, import("./Projection.js").default>}
 */ let $34203234f5613839$var$cache = {};
function $34203234f5613839$export$42ffd38884aecdac() {
    $34203234f5613839$var$cache = {};
}
function $34203234f5613839$export$3988ae62b71be9a3(code) {
    return $34203234f5613839$var$cache[code] || $34203234f5613839$var$cache[code.replace(/urn:(x-)?ogc:def:crs:EPSG:(.*:)?(\w+)$/, 'EPSG:$3')] || null;
}
function $34203234f5613839$export$e16d8520af44a096(code, projection) {
    $34203234f5613839$var$cache[code] = projection;
}


/**
 * @module ol/proj/transforms
 */ 
/**
 * @private
 * @type {!Object<string, Object<string, import("../proj.js").TransformFunction>>}
 */ let $822818829c3b5095$var$transforms = {};
function $822818829c3b5095$export$42ffd38884aecdac() {
    $822818829c3b5095$var$transforms = {};
}
function $822818829c3b5095$export$e16d8520af44a096(source, destination, transformFn) {
    const sourceCode = source.getCode();
    const destinationCode = destination.getCode();
    if (!(sourceCode in $822818829c3b5095$var$transforms)) $822818829c3b5095$var$transforms[sourceCode] = {};
    $822818829c3b5095$var$transforms[sourceCode][destinationCode] = transformFn;
}
function $822818829c3b5095$export$cd7f480d6b8286c3(source, destination) {
    const sourceCode = source.getCode();
    const destinationCode = destination.getCode();
    const transform = $822818829c3b5095$var$transforms[sourceCode][destinationCode];
    delete $822818829c3b5095$var$transforms[sourceCode][destinationCode];
    if ((0, $0669c62275461b52$export$dd1bc94b04021eeb)($822818829c3b5095$var$transforms[sourceCode])) delete $822818829c3b5095$var$transforms[sourceCode];
    return transform;
}
function $822818829c3b5095$export$3988ae62b71be9a3(sourceCode, destinationCode) {
    if (sourceCode in $822818829c3b5095$var$transforms && destinationCode in $822818829c3b5095$var$transforms[sourceCode]) return $822818829c3b5095$var$transforms[sourceCode][destinationCode];
    return null;
}


/**
 * @module ol/proj/utm
 */ /**
 * Adapted from https://github.com/Turbo87/utm
 * Copyright (c) 2012-2017 Tobias Bieniek
 *
 * The functions here provide approximate transforms to and from UTM.
 * They are not appropriate for use beyond the validity extend of a UTM
 * zone, and the accuracy of the transform decreases toward the zone
 * edges.
 */ 

/**
 * @typedef {Object} UTMZone
 * @property {number} number The zone number (1 - 60).
 * @property {boolean} north The northern hemisphere.
 */ const $a633ea8fc263bbcc$var$K0 = 0.9996;
const $a633ea8fc263bbcc$var$E = 0.00669438;
const $a633ea8fc263bbcc$var$E2 = $a633ea8fc263bbcc$var$E * $a633ea8fc263bbcc$var$E;
const $a633ea8fc263bbcc$var$E3 = $a633ea8fc263bbcc$var$E2 * $a633ea8fc263bbcc$var$E;
const $a633ea8fc263bbcc$var$E_P2 = $a633ea8fc263bbcc$var$E / (1 - $a633ea8fc263bbcc$var$E);
const $a633ea8fc263bbcc$var$SQRT_E = Math.sqrt(1 - $a633ea8fc263bbcc$var$E);
const $a633ea8fc263bbcc$var$_E = (1 - $a633ea8fc263bbcc$var$SQRT_E) / (1 + $a633ea8fc263bbcc$var$SQRT_E);
const $a633ea8fc263bbcc$var$_E2 = $a633ea8fc263bbcc$var$_E * $a633ea8fc263bbcc$var$_E;
const $a633ea8fc263bbcc$var$_E3 = $a633ea8fc263bbcc$var$_E2 * $a633ea8fc263bbcc$var$_E;
const $a633ea8fc263bbcc$var$_E4 = $a633ea8fc263bbcc$var$_E3 * $a633ea8fc263bbcc$var$_E;
const $a633ea8fc263bbcc$var$_E5 = $a633ea8fc263bbcc$var$_E4 * $a633ea8fc263bbcc$var$_E;
const $a633ea8fc263bbcc$var$M1 = 1 - $a633ea8fc263bbcc$var$E / 4 - 3 * $a633ea8fc263bbcc$var$E2 / 64 - 5 * $a633ea8fc263bbcc$var$E3 / 256;
const $a633ea8fc263bbcc$var$M2 = 3 * $a633ea8fc263bbcc$var$E / 8 + 3 * $a633ea8fc263bbcc$var$E2 / 32 + 45 * $a633ea8fc263bbcc$var$E3 / 1024;
const $a633ea8fc263bbcc$var$M3 = 15 * $a633ea8fc263bbcc$var$E2 / 256 + 45 * $a633ea8fc263bbcc$var$E3 / 1024;
const $a633ea8fc263bbcc$var$M4 = 35 * $a633ea8fc263bbcc$var$E3 / 3072;
const $a633ea8fc263bbcc$var$P2 = 1.5 * $a633ea8fc263bbcc$var$_E - 27 / 32 * $a633ea8fc263bbcc$var$_E3 + 269 / 512 * $a633ea8fc263bbcc$var$_E5;
const $a633ea8fc263bbcc$var$P3 = 21 / 16 * $a633ea8fc263bbcc$var$_E2 - 55 / 32 * $a633ea8fc263bbcc$var$_E4;
const $a633ea8fc263bbcc$var$P4 = 151 / 96 * $a633ea8fc263bbcc$var$_E3 - 417 / 128 * $a633ea8fc263bbcc$var$_E5;
const $a633ea8fc263bbcc$var$P5 = 1097 / 512 * $a633ea8fc263bbcc$var$_E4;
const $a633ea8fc263bbcc$var$R = 6378137;
/**
 * @param {number} easting Easting value of coordinate.
 * @param {number} northing Northing value of coordinate.
 * @param {UTMZone} zone The UTM zone.
 * @return {import("../coordinate.js").Coordinate} The transformed coordinate.
 */ function $a633ea8fc263bbcc$var$toLonLat(easting, northing, zone) {
    const x = easting - 500000;
    const y = zone.north ? northing : northing - 10000000;
    const m = y / $a633ea8fc263bbcc$var$K0;
    const mu = m / ($a633ea8fc263bbcc$var$R * $a633ea8fc263bbcc$var$M1);
    const pRad = mu + $a633ea8fc263bbcc$var$P2 * Math.sin(2 * mu) + $a633ea8fc263bbcc$var$P3 * Math.sin(4 * mu) + $a633ea8fc263bbcc$var$P4 * Math.sin(6 * mu) + $a633ea8fc263bbcc$var$P5 * Math.sin(8 * mu);
    const pSin = Math.sin(pRad);
    const pSin2 = pSin * pSin;
    const pCos = Math.cos(pRad);
    const pTan = pSin / pCos;
    const pTan2 = pTan * pTan;
    const pTan4 = pTan2 * pTan2;
    const epSin = 1 - $a633ea8fc263bbcc$var$E * pSin2;
    const epSinSqrt = Math.sqrt(1 - $a633ea8fc263bbcc$var$E * pSin2);
    const n = $a633ea8fc263bbcc$var$R / epSinSqrt;
    const r = (1 - $a633ea8fc263bbcc$var$E) / epSin;
    const c = $a633ea8fc263bbcc$var$E_P2 * pCos ** 2;
    const c2 = c * c;
    const d = x / (n * $a633ea8fc263bbcc$var$K0);
    const d2 = d * d;
    const d3 = d2 * d;
    const d4 = d3 * d;
    const d5 = d4 * d;
    const d6 = d5 * d;
    const latitude = pRad - pTan / r * (d2 / 2 - d4 / 24 * (5 + 3 * pTan2 + 10 * c - 4 * c2 - 9 * $a633ea8fc263bbcc$var$E_P2)) + d6 / 720 * (61 + 90 * pTan2 + 298 * c + 45 * pTan4 - 252 * $a633ea8fc263bbcc$var$E_P2 - 3 * c2);
    let longitude = (d - d3 / 6 * (1 + 2 * pTan2 + c) + d5 / 120 * (5 - 2 * c + 28 * pTan2 - 3 * c2 + 8 * $a633ea8fc263bbcc$var$E_P2 + 24 * pTan4)) / pCos;
    longitude = (0, $912ac838ff50d1cd$export$4997ffc0176396a6)(longitude + (0, $912ac838ff50d1cd$export$cba01ba138429a1d)($a633ea8fc263bbcc$var$zoneToCentralLongitude(zone.number)), -Math.PI, Math.PI);
    return [
        (0, $912ac838ff50d1cd$export$56cb859c01fa134d)(longitude),
        (0, $912ac838ff50d1cd$export$56cb859c01fa134d)(latitude)
    ];
}
const $a633ea8fc263bbcc$var$MIN_LATITUDE = -80;
const $a633ea8fc263bbcc$var$MAX_LATITUDE = 84;
const $a633ea8fc263bbcc$var$MIN_LONGITUDE = -180;
const $a633ea8fc263bbcc$var$MAX_LONGITUDE = 180;
/**
 * @param {number} longitude The longitude.
 * @param {number} latitude The latitude.
 * @param {UTMZone} zone The UTM zone.
 * @return {import('../coordinate.js').Coordinate} The UTM coordinate.
 */ function $a633ea8fc263bbcc$var$fromLonLat(longitude, latitude, zone) {
    longitude = (0, $912ac838ff50d1cd$export$4997ffc0176396a6)(longitude, $a633ea8fc263bbcc$var$MIN_LONGITUDE, $a633ea8fc263bbcc$var$MAX_LONGITUDE);
    if (latitude < $a633ea8fc263bbcc$var$MIN_LATITUDE) latitude = $a633ea8fc263bbcc$var$MIN_LATITUDE;
    else if (latitude > $a633ea8fc263bbcc$var$MAX_LATITUDE) latitude = $a633ea8fc263bbcc$var$MAX_LATITUDE;
    const latRad = (0, $912ac838ff50d1cd$export$cba01ba138429a1d)(latitude);
    const latSin = Math.sin(latRad);
    const latCos = Math.cos(latRad);
    const latTan = latSin / latCos;
    const latTan2 = latTan * latTan;
    const latTan4 = latTan2 * latTan2;
    const lonRad = (0, $912ac838ff50d1cd$export$cba01ba138429a1d)(longitude);
    const centralLon = $a633ea8fc263bbcc$var$zoneToCentralLongitude(zone.number);
    const centralLonRad = (0, $912ac838ff50d1cd$export$cba01ba138429a1d)(centralLon);
    const n = $a633ea8fc263bbcc$var$R / Math.sqrt(1 - $a633ea8fc263bbcc$var$E * latSin ** 2);
    const c = $a633ea8fc263bbcc$var$E_P2 * latCos ** 2;
    const a = latCos * (0, $912ac838ff50d1cd$export$4997ffc0176396a6)(lonRad - centralLonRad, -Math.PI, Math.PI);
    const a2 = a * a;
    const a3 = a2 * a;
    const a4 = a3 * a;
    const a5 = a4 * a;
    const a6 = a5 * a;
    const m = $a633ea8fc263bbcc$var$R * ($a633ea8fc263bbcc$var$M1 * latRad - $a633ea8fc263bbcc$var$M2 * Math.sin(2 * latRad) + $a633ea8fc263bbcc$var$M3 * Math.sin(4 * latRad) - $a633ea8fc263bbcc$var$M4 * Math.sin(6 * latRad));
    const easting = $a633ea8fc263bbcc$var$K0 * n * (a + a3 / 6 * (1 - latTan2 + c) + a5 / 120 * (5 - 18 * latTan2 + latTan4 + 72 * c - 58 * $a633ea8fc263bbcc$var$E_P2)) + 500000;
    let northing = $a633ea8fc263bbcc$var$K0 * (m + n * latTan * (a2 / 2 + a4 / 24 * (5 - latTan2 + 9 * c + 4 * c ** 2) + a6 / 720 * (61 - 58 * latTan2 + latTan4 + 600 * c - 330 * $a633ea8fc263bbcc$var$E_P2)));
    if (!zone.north) northing += 10000000;
    return [
        easting,
        northing
    ];
}
/**
 * @param {number} zone The zone number.
 * @return {number} The central longitude in degrees.
 */ function $a633ea8fc263bbcc$var$zoneToCentralLongitude(zone) {
    return (zone - 1) * 6 - 180 + 3;
}
/**
 * @type {Array<RegExp>}
 */ const $a633ea8fc263bbcc$var$epsgRegExes = [
    /^EPSG:(\d+)$/,
    /^urn:ogc:def:crs:EPSG::(\d+)$/,
    /^http:\/\/www\.opengis\.net\/def\/crs\/EPSG\/0\/(\d+)$/
];
function $a633ea8fc263bbcc$export$bb54dc52a08ed170(code) {
    let epsgId = 0;
    for (const re of $a633ea8fc263bbcc$var$epsgRegExes){
        const match = code.match(re);
        if (match) {
            epsgId = parseInt(match[1]);
            break;
        }
    }
    if (!epsgId) return null;
    let number = 0;
    let north = false;
    if (epsgId > 32700 && epsgId < 32761) number = epsgId - 32700;
    else if (epsgId > 32600 && epsgId < 32661) {
        north = true;
        number = epsgId - 32600;
    }
    if (!number) return null;
    return {
        number: number,
        north: north
    };
}
/**
 * @param {function(number, number, UTMZone): import('../coordinate.js').Coordinate} transformer The transformer.
 * @param {UTMZone} zone The UTM zone.
 * @return {import('../proj.js').TransformFunction} The transform function.
 */ function $a633ea8fc263bbcc$var$makeTransformFunction(transformer, zone) {
    return function(input, output, dimension, stride) {
        const length = input.length;
        dimension = dimension > 1 ? dimension : 2;
        stride = stride ?? dimension;
        if (!output) {
            if (dimension > 2) output = input.slice();
            else output = new Array(length);
        }
        for(let i = 0; i < length; i += stride){
            const x = input[i];
            const y = input[i + 1];
            const coord = transformer(x, y, zone);
            output[i] = coord[0];
            output[i + 1] = coord[1];
        }
        return output;
    };
}
function $a633ea8fc263bbcc$export$3277980d225b59be(code) {
    const zone = $a633ea8fc263bbcc$export$bb54dc52a08ed170(code);
    if (!zone) return null;
    return new (0, $148e47e1fc09dc0c$export$2e2bcd8739ae039)({
        code: code,
        units: 'm'
    });
}
function $a633ea8fc263bbcc$export$f94509e55523febf(projection) {
    const zone = $a633ea8fc263bbcc$export$bb54dc52a08ed170(projection.getCode());
    if (!zone) return null;
    return {
        forward: $a633ea8fc263bbcc$var$makeTransformFunction($a633ea8fc263bbcc$var$fromLonLat, zone),
        inverse: $a633ea8fc263bbcc$var$makeTransformFunction($a633ea8fc263bbcc$var$toLonLat, zone)
    };
}



/**
 * A projection as {@link module:ol/proj/Projection~Projection}, SRS identifier
 * string or undefined.
 * @typedef {Projection|string|undefined} ProjectionLike
 * @api
 */ /**
 * @typedef {Object} Transforms
 * @property {TransformFunction} forward The forward transform (from geographic).
 * @property {TransformFunction} inverse The inverse transform (to geographic).
 */ /**
 * @type {Array<function(Projection): Transforms|null>}
 */ const $2a998b085c5a7ac9$var$transformFactories = [
    (0, $a633ea8fc263bbcc$export$f94509e55523febf)
];
/**
 * @type {Array<function(string): Projection|null>}
 */ const $2a998b085c5a7ac9$var$projectionFactories = [
    (0, $a633ea8fc263bbcc$export$3277980d225b59be)
];
let $2a998b085c5a7ac9$var$showCoordinateWarning = true;
function $2a998b085c5a7ac9$export$ed949affbc7c4223(disable) {
    const hide = disable === undefined ? true : disable;
    $2a998b085c5a7ac9$var$showCoordinateWarning = !hide;
}
function $2a998b085c5a7ac9$export$dd516654c5f598fb(input, output) {
    if (output !== undefined) {
        for(let i = 0, ii = input.length; i < ii; ++i)output[i] = input[i];
        output;
    } else output = input.slice();
    return output;
}
function $2a998b085c5a7ac9$export$83e8ab53904f8022(input, output) {
    if (output !== undefined && input !== output) {
        for(let i = 0, ii = input.length; i < ii; ++i)output[i] = input[i];
        input = output;
    }
    return input;
}
function $2a998b085c5a7ac9$export$59ae956cd3e343f7(projection) {
    (0, $34203234f5613839$export$e16d8520af44a096)(projection.getCode(), projection);
    (0, $822818829c3b5095$export$e16d8520af44a096)(projection, projection, $2a998b085c5a7ac9$export$dd516654c5f598fb);
}
function $2a998b085c5a7ac9$export$638ad73f7aafb913(projections) {
    projections.forEach($2a998b085c5a7ac9$export$59ae956cd3e343f7);
}
function $2a998b085c5a7ac9$export$3988ae62b71be9a3(projectionLike) {
    if (!(typeof projectionLike === 'string')) return projectionLike;
    const projection = (0, $34203234f5613839$export$3988ae62b71be9a3)(projectionLike);
    if (projection) return projection;
    for (const makeProjection of $2a998b085c5a7ac9$var$projectionFactories){
        const projection = makeProjection(projectionLike);
        if (projection) return projection;
    }
    return null;
}
function $2a998b085c5a7ac9$export$2d8f7b4eec383d44(projection, resolution, point, units) {
    projection = $2a998b085c5a7ac9$export$3988ae62b71be9a3(projection);
    let pointResolution;
    const getter = projection.getPointResolutionFunc();
    if (getter) {
        pointResolution = getter(resolution, point);
        if (units && units !== projection.getUnits()) {
            const metersPerUnit = projection.getMetersPerUnit();
            if (metersPerUnit) pointResolution = pointResolution * metersPerUnit / (0, $8ebfe5645312696b$export$1482081eec883108)[units];
        }
    } else {
        const projUnits = projection.getUnits();
        if (projUnits == 'degrees' && !units || units == 'degrees') pointResolution = resolution;
        else {
            // Estimate point resolution by transforming the center pixel to EPSG:4326,
            // measuring its width and height on the normal sphere, and taking the
            // average of the width and height.
            const toEPSG4326 = $2a998b085c5a7ac9$export$e3c4995a701c26a3(projection, $2a998b085c5a7ac9$export$3988ae62b71be9a3('EPSG:4326'));
            if (!toEPSG4326 && projUnits !== 'degrees') // no transform is available
            pointResolution = resolution * projection.getMetersPerUnit();
            else {
                let vertices = [
                    point[0] - resolution / 2,
                    point[1],
                    point[0] + resolution / 2,
                    point[1],
                    point[0],
                    point[1] - resolution / 2,
                    point[0],
                    point[1] + resolution / 2
                ];
                vertices = toEPSG4326(vertices, vertices, 2);
                const width = (0, $662150a3b787a9f8$export$79376507b09a66f)(vertices.slice(0, 2), vertices.slice(2, 4));
                const height = (0, $662150a3b787a9f8$export$79376507b09a66f)(vertices.slice(4, 6), vertices.slice(6, 8));
                pointResolution = (width + height) / 2;
            }
            const metersPerUnit = units ? (0, $8ebfe5645312696b$export$1482081eec883108)[units] : projection.getMetersPerUnit();
            if (metersPerUnit !== undefined) pointResolution /= metersPerUnit;
        }
    }
    return pointResolution;
}
function $2a998b085c5a7ac9$export$eeb8392580a05a37(projections) {
    $2a998b085c5a7ac9$export$638ad73f7aafb913(projections);
    projections.forEach(function(source) {
        projections.forEach(function(destination) {
            if (source !== destination) (0, $822818829c3b5095$export$e16d8520af44a096)(source, destination, $2a998b085c5a7ac9$export$dd516654c5f598fb);
        });
    });
}
function $2a998b085c5a7ac9$export$4856f21c2f184f24(projections1, projections2, forwardTransform, inverseTransform) {
    projections1.forEach(function(projection1) {
        projections2.forEach(function(projection2) {
            (0, $822818829c3b5095$export$e16d8520af44a096)(projection1, projection2, forwardTransform);
            (0, $822818829c3b5095$export$e16d8520af44a096)(projection2, projection1, inverseTransform);
        });
    });
}
function $2a998b085c5a7ac9$export$4860237d10380594() {
    (0, $34203234f5613839$export$42ffd38884aecdac)();
    (0, $822818829c3b5095$export$42ffd38884aecdac)();
}
function $2a998b085c5a7ac9$export$549167224996a0fb(projection, defaultCode) {
    if (!projection) return $2a998b085c5a7ac9$export$3988ae62b71be9a3(defaultCode);
    if (typeof projection === 'string') return $2a998b085c5a7ac9$export$3988ae62b71be9a3(projection);
    return /** @type {Projection} */ projection;
}
function $2a998b085c5a7ac9$export$6b4aafd331159e0d(coordTransform) {
    return(/**
     * @param {Array<number>} input Input.
     * @param {Array<number>} [output] Output.
     * @param {number} [dimension] Dimensions that should be transformed.
     * @param {number} [stride] Stride.
     * @return {Array<number>} Output.
     */ function(input, output, dimension, stride) {
        const length = input.length;
        dimension = dimension !== undefined ? dimension : 2;
        stride = stride ?? dimension;
        output = output !== undefined ? output : new Array(length);
        for(let i = 0; i < length; i += stride){
            const point = coordTransform(input.slice(i, i + dimension));
            const pointLength = point.length;
            for(let j = 0, jj = stride; j < jj; ++j)output[i + j] = j >= pointLength ? input[i + j] : point[j];
        }
        return output;
    });
}
function $2a998b085c5a7ac9$export$6b1c2e6623f4f49d(source, destination, forward, inverse) {
    const sourceProj = $2a998b085c5a7ac9$export$3988ae62b71be9a3(source);
    const destProj = $2a998b085c5a7ac9$export$3988ae62b71be9a3(destination);
    (0, $822818829c3b5095$export$e16d8520af44a096)(sourceProj, destProj, $2a998b085c5a7ac9$export$6b4aafd331159e0d(forward));
    (0, $822818829c3b5095$export$e16d8520af44a096)(destProj, sourceProj, $2a998b085c5a7ac9$export$6b4aafd331159e0d(inverse));
}
function $2a998b085c5a7ac9$export$b15d9668511529b9(coordinate, projection) {
    $2a998b085c5a7ac9$export$ed949affbc7c4223();
    return $2a998b085c5a7ac9$export$51186ad6e864892a(coordinate, 'EPSG:4326', projection !== undefined ? projection : 'EPSG:3857');
}
function $2a998b085c5a7ac9$export$3fb495868742d370(coordinate, projection) {
    const lonLat = $2a998b085c5a7ac9$export$51186ad6e864892a(coordinate, projection !== undefined ? projection : 'EPSG:3857', 'EPSG:4326');
    const lon = lonLat[0];
    if (lon < -180 || lon > 180) lonLat[0] = (0, $912ac838ff50d1cd$export$ba467bec01d66def)(lon + 180, 360) - 180;
    return lonLat;
}
function $2a998b085c5a7ac9$export$fe091d73a555748b(projection1, projection2) {
    if (projection1 === projection2) return true;
    const equalUnits = projection1.getUnits() === projection2.getUnits();
    if (projection1.getCode() === projection2.getCode()) return equalUnits;
    const transformFunc = $2a998b085c5a7ac9$export$e3c4995a701c26a3(projection1, projection2);
    return transformFunc === $2a998b085c5a7ac9$export$dd516654c5f598fb && equalUnits;
}
function $2a998b085c5a7ac9$export$e3c4995a701c26a3(source, destination) {
    const sourceCode = source.getCode();
    const destinationCode = destination.getCode();
    let transformFunc = (0, $822818829c3b5095$export$3988ae62b71be9a3)(sourceCode, destinationCode);
    if (transformFunc) return transformFunc;
    /**
   * @type {Transforms|null}
   */ let sourceTransforms = null;
    /**
   * @type {Transforms|null}
   */ let destinationTransforms = null;
    // lazily add projections if we have supported transforms
    for (const makeTransforms of $2a998b085c5a7ac9$var$transformFactories){
        if (!sourceTransforms) sourceTransforms = makeTransforms(source);
        if (!destinationTransforms) destinationTransforms = makeTransforms(destination);
    }
    if (!sourceTransforms && !destinationTransforms) return null;
    const intermediateCode = 'EPSG:4326';
    if (!destinationTransforms) {
        const toDestination = (0, $822818829c3b5095$export$3988ae62b71be9a3)(intermediateCode, destinationCode);
        if (toDestination) transformFunc = $2a998b085c5a7ac9$var$composeTransformFuncs(sourceTransforms.inverse, toDestination);
    } else if (!sourceTransforms) {
        const fromSource = (0, $822818829c3b5095$export$3988ae62b71be9a3)(sourceCode, intermediateCode);
        if (fromSource) transformFunc = $2a998b085c5a7ac9$var$composeTransformFuncs(fromSource, destinationTransforms.forward);
    } else transformFunc = $2a998b085c5a7ac9$var$composeTransformFuncs(sourceTransforms.inverse, destinationTransforms.forward);
    if (transformFunc) {
        $2a998b085c5a7ac9$export$59ae956cd3e343f7(source);
        $2a998b085c5a7ac9$export$59ae956cd3e343f7(destination);
        (0, $822818829c3b5095$export$e16d8520af44a096)(source, destination, transformFunc);
    }
    return transformFunc;
}
/**
 * @param {TransformFunction} t1 The first transform function.
 * @param {TransformFunction} t2 The second transform function.
 * @return {TransformFunction} The composed transform function.
 */ function $2a998b085c5a7ac9$var$composeTransformFuncs(t1, t2) {
    return function(input, output, dimensions, stride) {
        output = t1(input, output, dimensions, stride);
        return t2(output, output, dimensions, stride);
    };
}
function $2a998b085c5a7ac9$export$fce0c6cfca85ed96(source, destination) {
    const sourceProjection = $2a998b085c5a7ac9$export$3988ae62b71be9a3(source);
    const destinationProjection = $2a998b085c5a7ac9$export$3988ae62b71be9a3(destination);
    return $2a998b085c5a7ac9$export$e3c4995a701c26a3(sourceProjection, destinationProjection);
}
function $2a998b085c5a7ac9$export$51186ad6e864892a(coordinate, source, destination) {
    const transformFunc = $2a998b085c5a7ac9$export$fce0c6cfca85ed96(source, destination);
    if (!transformFunc) {
        const sourceCode = $2a998b085c5a7ac9$export$3988ae62b71be9a3(source).getCode();
        const destinationCode = $2a998b085c5a7ac9$export$3988ae62b71be9a3(destination).getCode();
        throw new Error(`No transform available between ${sourceCode} and ${destinationCode}`);
    }
    return transformFunc(coordinate, undefined, coordinate.length);
}
function $2a998b085c5a7ac9$export$751c68e0e0efff79(extent, source, destination, stops) {
    const transformFunc = $2a998b085c5a7ac9$export$fce0c6cfca85ed96(source, destination);
    return (0, $3412ad7bd362b04c$export$9f9dcb98c894b623)(extent, transformFunc, undefined, stops);
}
function $2a998b085c5a7ac9$export$affbde93b1db73f8(point, sourceProjection, destinationProjection) {
    const transformFunc = $2a998b085c5a7ac9$export$e3c4995a701c26a3(sourceProjection, destinationProjection);
    return transformFunc(point);
}
/**
 * @type {Projection|null}
 */ let $2a998b085c5a7ac9$var$userProjection = null;
function $2a998b085c5a7ac9$export$d0aeadbeac54116e(projection) {
    $2a998b085c5a7ac9$var$userProjection = $2a998b085c5a7ac9$export$3988ae62b71be9a3(projection);
}
function $2a998b085c5a7ac9$export$1ae11279759d4e8f() {
    $2a998b085c5a7ac9$var$userProjection = null;
}
function $2a998b085c5a7ac9$export$3973b77d5f6f2790() {
    return $2a998b085c5a7ac9$var$userProjection;
}
function $2a998b085c5a7ac9$export$aa7494edfbe36197() {
    $2a998b085c5a7ac9$export$d0aeadbeac54116e('EPSG:4326');
}
function $2a998b085c5a7ac9$export$698f563af1ba02a5(coordinate, sourceProjection) {
    if (!$2a998b085c5a7ac9$var$userProjection) return coordinate;
    return $2a998b085c5a7ac9$export$51186ad6e864892a(coordinate, sourceProjection, $2a998b085c5a7ac9$var$userProjection);
}
function $2a998b085c5a7ac9$export$d4b8ec0b96db1ee2(coordinate, destProjection) {
    if (!$2a998b085c5a7ac9$var$userProjection) {
        if ($2a998b085c5a7ac9$var$showCoordinateWarning && !(0, $6542087bee114e8c$export$e9bab7fafb253603)(coordinate, [
            0,
            0
        ]) && coordinate[0] >= -180 && coordinate[0] <= 180 && coordinate[1] >= -90 && coordinate[1] <= 90) {
            $2a998b085c5a7ac9$var$showCoordinateWarning = false;
            (0, $cf824eca25b51fde$export$c106dd0671a0fc2d)('Call useGeographic() from ol/proj once to work with [longitude, latitude] coordinates.');
        }
        return coordinate;
    }
    return $2a998b085c5a7ac9$export$51186ad6e864892a(coordinate, $2a998b085c5a7ac9$var$userProjection, destProjection);
}
function $2a998b085c5a7ac9$export$96bfd09e2cffb006(extent, sourceProjection) {
    if (!$2a998b085c5a7ac9$var$userProjection) return extent;
    return $2a998b085c5a7ac9$export$751c68e0e0efff79(extent, sourceProjection, $2a998b085c5a7ac9$var$userProjection);
}
function $2a998b085c5a7ac9$export$494be3a3a25689ca(extent, destProjection) {
    if (!$2a998b085c5a7ac9$var$userProjection) return extent;
    return $2a998b085c5a7ac9$export$751c68e0e0efff79(extent, $2a998b085c5a7ac9$var$userProjection, destProjection);
}
function $2a998b085c5a7ac9$export$b56bb8ad8b3a00e9(resolution, sourceProjection) {
    if (!$2a998b085c5a7ac9$var$userProjection) return resolution;
    const sourceMetersPerUnit = $2a998b085c5a7ac9$export$3988ae62b71be9a3(sourceProjection).getMetersPerUnit();
    const userMetersPerUnit = $2a998b085c5a7ac9$var$userProjection.getMetersPerUnit();
    return sourceMetersPerUnit && userMetersPerUnit ? resolution * sourceMetersPerUnit / userMetersPerUnit : resolution;
}
function $2a998b085c5a7ac9$export$bd1cd3b88140b906(resolution, destProjection) {
    if (!$2a998b085c5a7ac9$var$userProjection) return resolution;
    const destMetersPerUnit = $2a998b085c5a7ac9$export$3988ae62b71be9a3(destProjection).getMetersPerUnit();
    const userMetersPerUnit = $2a998b085c5a7ac9$var$userProjection.getMetersPerUnit();
    return destMetersPerUnit && userMetersPerUnit ? resolution * userMetersPerUnit / destMetersPerUnit : resolution;
}
function $2a998b085c5a7ac9$export$1873f9cfeb8bd1d6(sourceProj, destProj, transform) {
    return function(coord) {
        let transformed, worldsAway;
        if (sourceProj.canWrapX()) {
            const sourceExtent = sourceProj.getExtent();
            const sourceExtentWidth = (0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(sourceExtent);
            coord = coord.slice(0);
            worldsAway = (0, $6542087bee114e8c$export$24e2b27d1ff0c1d5)(coord, sourceProj, sourceExtentWidth);
            if (worldsAway) // Move x to the real world
            coord[0] = coord[0] - worldsAway * sourceExtentWidth;
            coord[0] = (0, $912ac838ff50d1cd$export$7d15b64cf5a3a4c4)(coord[0], sourceExtent[0], sourceExtent[2]);
            coord[1] = (0, $912ac838ff50d1cd$export$7d15b64cf5a3a4c4)(coord[1], sourceExtent[1], sourceExtent[3]);
            transformed = transform(coord);
        } else transformed = transform(coord);
        if (worldsAway && destProj.canWrapX()) // Move transformed coordinate back to the offset world
        transformed[0] += worldsAway * (0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(destProj.getExtent());
        return transformed;
    };
}
function $2a998b085c5a7ac9$export$86eed449eb2dcac4() {
    // Add transformations that don't alter coordinates to convert within set of
    // projections with equal meaning.
    $2a998b085c5a7ac9$export$eeb8392580a05a37((0, $cb7fa74d3a677d28$export$b508d7ad9a891c1b));
    $2a998b085c5a7ac9$export$eeb8392580a05a37((0, $08c45d5d270b4708$export$b508d7ad9a891c1b));
    // Add transformations to convert EPSG:4326 like coordinates to EPSG:3857 like
    // coordinates and back.
    $2a998b085c5a7ac9$export$4856f21c2f184f24((0, $08c45d5d270b4708$export$b508d7ad9a891c1b), (0, $cb7fa74d3a677d28$export$b508d7ad9a891c1b), (0, $cb7fa74d3a677d28$export$1ff8bb36c0983070), (0, $cb7fa74d3a677d28$export$8c71322ec28ed6b4));
}
$2a998b085c5a7ac9$export$86eed449eb2dcac4();


/**
 * @module ol/transform
 */ 
/**
 * An array representing an affine 2d transformation for use with
 * {@link module:ol/transform} functions. The array has 6 elements.
 * @typedef {!Array<number>} Transform
 * @api
 */ /**
 * Collection of affine 2d transformation functions. The functions work on an
 * array of 6 elements. The element order is compatible with the [SVGMatrix
 * interface](https://developer.mozilla.org/en-US/docs/Web/API/SVGMatrix) and is
 * a subset (elements a to f) of a 3×3 matrix:
 * ```
 * [ a c e ]
 * [ b d f ]
 * [ 0 0 1 ]
 * ```
 */ /**
 * @private
 * @type {Transform}
 */ const $eb597965bdcc8f43$var$tmp_ = new Array(6);
function $eb597965bdcc8f43$export$185802fd694ee1f5() {
    return [
        1,
        0,
        0,
        1,
        0,
        0
    ];
}
function $eb597965bdcc8f43$export$aad8462122ac592b(transform) {
    return $eb597965bdcc8f43$export$adaa4cf7ef1b65be(transform, 1, 0, 0, 1, 0, 0);
}
function $eb597965bdcc8f43$export$2060d2db72cce88f(transform1, transform2) {
    const a1 = transform1[0];
    const b1 = transform1[1];
    const c1 = transform1[2];
    const d1 = transform1[3];
    const e1 = transform1[4];
    const f1 = transform1[5];
    const a2 = transform2[0];
    const b2 = transform2[1];
    const c2 = transform2[2];
    const d2 = transform2[3];
    const e2 = transform2[4];
    const f2 = transform2[5];
    transform1[0] = a1 * a2 + c1 * b2;
    transform1[1] = b1 * a2 + d1 * b2;
    transform1[2] = a1 * c2 + c1 * d2;
    transform1[3] = b1 * c2 + d1 * d2;
    transform1[4] = a1 * e2 + c1 * f2 + e1;
    transform1[5] = b1 * e2 + d1 * f2 + f1;
    return transform1;
}
function $eb597965bdcc8f43$export$adaa4cf7ef1b65be(transform, a, b, c, d, e, f) {
    transform[0] = a;
    transform[1] = b;
    transform[2] = c;
    transform[3] = d;
    transform[4] = e;
    transform[5] = f;
    return transform;
}
function $eb597965bdcc8f43$export$42b4187a82d80ed0(transform1, transform2) {
    transform1[0] = transform2[0];
    transform1[1] = transform2[1];
    transform1[2] = transform2[2];
    transform1[3] = transform2[3];
    transform1[4] = transform2[4];
    transform1[5] = transform2[5];
    return transform1;
}
function $eb597965bdcc8f43$export$5635d7ef4b8fee1c(transform, coordinate) {
    const x = coordinate[0];
    const y = coordinate[1];
    coordinate[0] = transform[0] * x + transform[2] * y + transform[4];
    coordinate[1] = transform[1] * x + transform[3] * y + transform[5];
    return coordinate;
}
function $eb597965bdcc8f43$export$bb628a54ab399bc9(transform, angle) {
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    return $eb597965bdcc8f43$export$2060d2db72cce88f(transform, $eb597965bdcc8f43$export$adaa4cf7ef1b65be($eb597965bdcc8f43$var$tmp_, cos, sin, -sin, cos, 0, 0));
}
function $eb597965bdcc8f43$export$dcdf75081b88279d(transform, x, y) {
    return $eb597965bdcc8f43$export$2060d2db72cce88f(transform, $eb597965bdcc8f43$export$adaa4cf7ef1b65be($eb597965bdcc8f43$var$tmp_, x, 0, 0, y, 0, 0));
}
function $eb597965bdcc8f43$export$3e4e33ea14aeb531(target, x, y) {
    return $eb597965bdcc8f43$export$adaa4cf7ef1b65be(target, x, 0, 0, y, 0, 0);
}
function $eb597965bdcc8f43$export$d73ee8ef04f5226a(transform, dx, dy) {
    return $eb597965bdcc8f43$export$2060d2db72cce88f(transform, $eb597965bdcc8f43$export$adaa4cf7ef1b65be($eb597965bdcc8f43$var$tmp_, 1, 0, 0, 1, dx, dy));
}
function $eb597965bdcc8f43$export$f672e0b6f7222cd7(transform, dx1, dy1, sx, sy, angle, dx2, dy2) {
    const sin = Math.sin(angle);
    const cos = Math.cos(angle);
    transform[0] = sx * cos;
    transform[1] = sy * sin;
    transform[2] = -sx * sin;
    transform[3] = sy * cos;
    transform[4] = dx2 * sx * cos - dy2 * sx * sin + dx1;
    transform[5] = dx2 * sy * sin + dy2 * sy * cos + dy1;
    return transform;
}
function $eb597965bdcc8f43$export$12a96a1aaf5558e3(dx1, dy1, sx, sy, angle, dx2, dy2) {
    return $eb597965bdcc8f43$export$f84e8e69fd4488a5($eb597965bdcc8f43$export$f672e0b6f7222cd7($eb597965bdcc8f43$export$185802fd694ee1f5(), dx1, dy1, sx, sy, angle, dx2, dy2));
}
function $eb597965bdcc8f43$export$6897c284b6f9f4dc(source) {
    return $eb597965bdcc8f43$export$bd70ea2a93c0fa4(source, source);
}
function $eb597965bdcc8f43$export$bd70ea2a93c0fa4(target, source) {
    const det = $eb597965bdcc8f43$export$a04698f914c55ed9(source);
    (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(det !== 0, 'Transformation matrix cannot be inverted');
    const a = source[0];
    const b = source[1];
    const c = source[2];
    const d = source[3];
    const e = source[4];
    const f = source[5];
    target[0] = d / det;
    target[1] = -b / det;
    target[2] = -c / det;
    target[3] = a / det;
    target[4] = (c * f - d * e) / det;
    target[5] = -(a * f - b * e) / det;
    return target;
}
function $eb597965bdcc8f43$export$a04698f914c55ed9(mat) {
    return mat[0] * mat[3] - mat[1] * mat[2];
}
/**
 * @type {Array}
 */ const $eb597965bdcc8f43$var$matrixPrecision = [
    1e5,
    1e5,
    1e5,
    1e5,
    2,
    2
];
function $eb597965bdcc8f43$export$f84e8e69fd4488a5(mat) {
    const transformString = 'matrix(' + mat.join(', ') + ')';
    return transformString;
}
function $eb597965bdcc8f43$export$3004f64547af360e(cssTransform) {
    const values = cssTransform.substring(7, cssTransform.length - 1).split(',');
    return values.map(parseFloat);
}
function $eb597965bdcc8f43$export$fe091d73a555748b(cssTransform1, cssTransform2) {
    const mat1 = $eb597965bdcc8f43$export$3004f64547af360e(cssTransform1);
    const mat2 = $eb597965bdcc8f43$export$3004f64547af360e(cssTransform2);
    for(let i = 0; i < 6; ++i){
        if (Math.round((mat1[i] - mat2[i]) * $eb597965bdcc8f43$var$matrixPrecision[i]) !== 0) return false;
    }
    return true;
}



/**
 * @module ol/geom/flat/transform
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {import("../../transform.js").Transform} transform Transform.
 * @param {Array<number>} [dest] Destination.
 * @param {number} [destinationStride] Stride of destination coordinates; if unspecified, assumed to be 2.
 * @return {Array<number>} Transformed coordinates.
 */ function $4149c848e00d54f8$export$b92b2dedcfff79de(flatCoordinates, offset, end, stride, transform, dest, destinationStride) {
    dest = dest ? dest : [];
    destinationStride = destinationStride ? destinationStride : 2;
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const x = flatCoordinates[j];
        const y = flatCoordinates[j + 1];
        dest[i++] = transform[0] * x + transform[2] * y + transform[4];
        dest[i++] = transform[1] * x + transform[3] * y + transform[5];
        for(let k = 2; k < destinationStride; k++)dest[i++] = flatCoordinates[j + k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $4149c848e00d54f8$export$bb628a54ab399bc9(flatCoordinates, offset, end, stride, angle, anchor, dest) {
    dest = dest ? dest : [];
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    const anchorX = anchor[0];
    const anchorY = anchor[1];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const deltaX = flatCoordinates[j] - anchorX;
        const deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + deltaX * cos - deltaY * sin;
        dest[i++] = anchorY + deltaX * sin + deltaY * cos;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $4149c848e00d54f8$export$dcdf75081b88279d(flatCoordinates, offset, end, stride, sx, sy, anchor, dest) {
    dest = dest ? dest : [];
    const anchorX = anchor[0];
    const anchorY = anchor[1];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const deltaX = flatCoordinates[j] - anchorX;
        const deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + sx * deltaX;
        dest[i++] = anchorY + sy * deltaY;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $4149c848e00d54f8$export$d73ee8ef04f5226a(flatCoordinates, offset, end, stride, deltaX, deltaY, dest) {
    dest = dest ? dest : [];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        dest[i++] = flatCoordinates[j] + deltaX;
        dest[i++] = flatCoordinates[j + 1] + deltaY;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}


/**
 * @typedef {'XY' | 'XYZ' | 'XYM' | 'XYZM'} GeometryLayout
 * The coordinate layout for geometries, indicating whether a 3rd or 4th z ('Z')
 * or measure ('M') coordinate is available.
 */ /**
 * @typedef {'Point' | 'LineString' | 'LinearRing' | 'Polygon' | 'MultiPoint' | 'MultiLineString' | 'MultiPolygon' | 'GeometryCollection' | 'Circle'} Type
 * The geometry type.  One of `'Point'`, `'LineString'`, `'LinearRing'`,
 * `'Polygon'`, `'MultiPoint'`, `'MultiLineString'`, `'MultiPolygon'`,
 * `'GeometryCollection'`, or `'Circle'`.
 */ /**
 * @type {import("../transform.js").Transform}
 */ const $87bae61d82b90c07$var$tmpTransform = (0, $eb597965bdcc8f43$export$185802fd694ee1f5)();
/** @type {import('../coordinate.js').Coordinate} */ const $87bae61d82b90c07$var$tmpPoint = [
    NaN,
    NaN
];
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for vector geometries.
 *
 * To get notified of changes to the geometry, register a listener for the
 * generic `change` event on your geometry instance.
 *
 * @abstract
 * @api
 */ class $87bae61d82b90c07$var$Geometry extends (0, $4dd5119c2f9fa355$export$2e2bcd8739ae039) {
    constructor(){
        super();
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = (0, $3412ad7bd362b04c$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {number}
     */ this.extentRevision_ = -1;
        /**
     * @protected
     * @type {number}
     */ this.simplifiedGeometryMaxMinSquaredTolerance = 0;
        /**
     * @protected
     * @type {number}
     */ this.simplifiedGeometryRevision = 0;
        /**
     * Get a transformed and simplified version of the geometry.
     * @abstract
     * @param {number} revision The geometry revision.
     * @param {number} squaredTolerance Squared tolerance.
     * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
     * @return {Geometry} Simplified geometry.
     */ this.simplifyTransformedInternal = (0, $7efea016d660e267$export$ff83df6f9971435f)((revision, squaredTolerance, transform)=>{
            if (!transform) return this.getSimplifiedGeometry(squaredTolerance);
            const clone = this.clone();
            clone.applyTransform(transform);
            return clone.getSimplifiedGeometry(squaredTolerance);
        });
    }
    /**
   * Get a transformed and simplified version of the geometry.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
   * @return {Geometry} Simplified geometry.
   */ simplifyTransformed(squaredTolerance, transform) {
        return this.simplifyTransformedInternal(this.getRevision(), squaredTolerance, transform);
    }
    /**
   * Make a complete copy of the geometry.
   * @abstract
   * @return {!Geometry} Clone.
   */ clone() {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */ containsXY(x, y) {
        return this.closestPointXY(x, y, $87bae61d82b90c07$var$tmpPoint, Number.MIN_VALUE) === 0;
    }
    /**
   * Return the closest point of the geometry to the passed point as
   * {@link module:ol/coordinate~Coordinate coordinate}.
   * @param {import("../coordinate.js").Coordinate} point Point.
   * @param {import("../coordinate.js").Coordinate} [closestPoint] Closest point.
   * @return {import("../coordinate.js").Coordinate} Closest point.
   * @api
   */ getClosestPoint(point, closestPoint) {
        closestPoint = closestPoint ? closestPoint : [
            NaN,
            NaN
        ];
        this.closestPointXY(point[0], point[1], closestPoint, Infinity);
        return closestPoint;
    }
    /**
   * Returns true if this geometry includes the specified coordinate. If the
   * coordinate is on the boundary of the geometry, returns false.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {boolean} Contains coordinate.
   * @api
   */ intersectsCoordinate(coordinate) {
        return this.containsXY(coordinate[0], coordinate[1]);
    }
    /**
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */ computeExtent(extent) {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Get the extent of the geometry.
   * @param {import("../extent.js").Extent} [extent] Extent.
   * @return {import("../extent.js").Extent} extent Extent.
   * @api
   */ getExtent(extent) {
        if (this.extentRevision_ != this.getRevision()) {
            const extent = this.computeExtent(this.extent_);
            if (isNaN(extent[0]) || isNaN(extent[1])) (0, $3412ad7bd362b04c$export$3e2152b047719fa1)(extent);
            this.extentRevision_ = this.getRevision();
        }
        return (0, $3412ad7bd362b04c$export$6a4fe494c558c238)(this.extent_, extent);
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} angle Rotation angle in radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   */ rotate(angle, anchor) {
        (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   */ scale(sx, sy, anchor) {
        (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Create a simplified version of this geometry.  For linestrings, this uses
   * the [Douglas Peucker](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm)
   * algorithm.  For polygons, a quantization-based
   * simplification is used to preserve topology.
   * @param {number} tolerance The tolerance distance for simplification.
   * @return {Geometry} A new, simplified version of the original geometry.
   * @api
   */ simplify(tolerance) {
        return this.getSimplifiedGeometry(tolerance * tolerance);
    }
    /**
   * Create a simplified version of this geometry using the Douglas Peucker
   * algorithm.
   * See https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @return {Geometry} Simplified geometry.
   */ getSimplifiedGeometry(squaredTolerance) {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Get the type of this geometry.
   * @abstract
   * @return {Type} Geometry type.
   */ getType() {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @abstract
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   */ applyTransform(transformFn) {
        (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   */ intersectsExtent(extent) {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @abstract
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   */ translate(deltaX, deltaY) {
        (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Transform each coordinate of the geometry from one coordinate reference
   * system to another. The geometry is modified in place.
   * For example, a line will be transformed to a line and a circle to a circle.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   *
   * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @return {this} This geometry.  Note that original geometry is
   *     modified in place.
   * @api
   */ transform(source, destination) {
        /** @type {import("../proj/Projection.js").default} */ const sourceProj = (0, $2a998b085c5a7ac9$export$3988ae62b71be9a3)(source);
        const transformFn = sourceProj.getUnits() == 'tile-pixels' ? function(inCoordinates, outCoordinates, stride) {
            const pixelExtent = sourceProj.getExtent();
            const projectedExtent = sourceProj.getWorldExtent();
            const scale = (0, $3412ad7bd362b04c$export$c08559766941f856)(projectedExtent) / (0, $3412ad7bd362b04c$export$c08559766941f856)(pixelExtent);
            (0, $eb597965bdcc8f43$export$f672e0b6f7222cd7)($87bae61d82b90c07$var$tmpTransform, projectedExtent[0], projectedExtent[3], scale, -scale, 0, 0, 0);
            const transformed = (0, $4149c848e00d54f8$export$b92b2dedcfff79de)(inCoordinates, 0, inCoordinates.length, stride, $87bae61d82b90c07$var$tmpTransform, outCoordinates);
            const projTransform = (0, $2a998b085c5a7ac9$export$fce0c6cfca85ed96)(sourceProj, destination);
            if (projTransform) return projTransform(transformed, transformed, stride);
            return transformed;
        } : (0, $2a998b085c5a7ac9$export$fce0c6cfca85ed96)(sourceProj, destination);
        this.applyTransform(transformFn);
        return this;
    }
}
var $87bae61d82b90c07$export$2e2bcd8739ae039 = $87bae61d82b90c07$var$Geometry;



/**
 * @classdesc
 * Abstract base class; only used for creating subclasses; do not instantiate
 * in apps, as cannot be rendered.
 *
 * @abstract
 * @api
 */ class $7afe4d7f43fcf744$var$SimpleGeometry extends (0, $87bae61d82b90c07$export$2e2bcd8739ae039) {
    constructor(){
        super();
        /**
     * @protected
     * @type {import("./Geometry.js").GeometryLayout}
     */ this.layout = 'XY';
        /**
     * @protected
     * @type {number}
     */ this.stride = 2;
        /**
     * @protected
     * @type {Array<number>}
     */ this.flatCoordinates;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        return (0, $3412ad7bd362b04c$export$be0ab0bf96ca59ca)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent);
    }
    /**
   * @abstract
   * @return {Array<*> | null} Coordinates.
   */ getCoordinates() {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Return the first coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} First coordinate.
   * @api
   */ getFirstCoordinate() {
        return this.flatCoordinates.slice(0, this.stride);
    }
    /**
   * @return {Array<number>} Flat coordinates.
   */ getFlatCoordinates() {
        return this.flatCoordinates;
    }
    /**
   * Return the last coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} Last point.
   * @api
   */ getLastCoordinate() {
        return this.flatCoordinates.slice(this.flatCoordinates.length - this.stride);
    }
    /**
   * Return the {@link import("./Geometry.js").GeometryLayout layout} of the geometry.
   * @return {import("./Geometry.js").GeometryLayout} Layout.
   * @api
   */ getLayout() {
        return this.layout;
    }
    /**
   * Create a simplified version of this geometry using the Douglas Peucker algorithm.
   * @param {number} squaredTolerance Squared tolerance.
   * @return {SimpleGeometry} Simplified geometry.
   * @override
   */ getSimplifiedGeometry(squaredTolerance) {
        if (this.simplifiedGeometryRevision !== this.getRevision()) {
            this.simplifiedGeometryMaxMinSquaredTolerance = 0;
            this.simplifiedGeometryRevision = this.getRevision();
        }
        // If squaredTolerance is negative or if we know that simplification will not
        // have any effect then just return this.
        if (squaredTolerance < 0 || this.simplifiedGeometryMaxMinSquaredTolerance !== 0 && squaredTolerance <= this.simplifiedGeometryMaxMinSquaredTolerance) return this;
        const simplifiedGeometry = this.getSimplifiedGeometryInternal(squaredTolerance);
        const simplifiedFlatCoordinates = simplifiedGeometry.getFlatCoordinates();
        if (simplifiedFlatCoordinates.length < this.flatCoordinates.length) return simplifiedGeometry;
        // Simplification did not actually remove any coordinates.  We now know
        // that any calls to getSimplifiedGeometry with a squaredTolerance less
        // than or equal to the current squaredTolerance will also not have any
        // effect.  This allows us to short circuit simplification (saving CPU
        // cycles) and prevents the cache of simplified geometries from filling
        // up with useless identical copies of this geometry (saving memory).
        this.simplifiedGeometryMaxMinSquaredTolerance = squaredTolerance;
        return this;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {SimpleGeometry} Simplified geometry.
   * @protected
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        return this;
    }
    /**
   * @return {number} Stride.
   */ getStride() {
        return this.stride;
    }
    /**
   * @param {import("./Geometry.js").GeometryLayout} layout Layout.
   * @param {Array<number>} flatCoordinates Flat coordinates.
   */ setFlatCoordinates(layout, flatCoordinates) {
        this.stride = $7afe4d7f43fcf744$export$6af0c1b4a8549a43(layout);
        this.layout = layout;
        this.flatCoordinates = flatCoordinates;
    }
    /**
   * @abstract
   * @param {!Array<*>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ setCoordinates(coordinates, layout) {
        (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * @param {import("./Geometry.js").GeometryLayout|undefined} layout Layout.
   * @param {Array<*>} coordinates Coordinates.
   * @param {number} nesting Nesting.
   * @protected
   */ setLayout(layout, coordinates, nesting) {
        let stride;
        if (layout) stride = $7afe4d7f43fcf744$export$6af0c1b4a8549a43(layout);
        else {
            for(let i = 0; i < nesting; ++i){
                if (coordinates.length === 0) {
                    this.layout = 'XY';
                    this.stride = 2;
                    return;
                }
                coordinates = /** @type {Array<unknown>} */ coordinates[0];
            }
            stride = coordinates.length;
            layout = $7afe4d7f43fcf744$export$61bb6938093db2c8(stride);
        }
        this.layout = layout;
        this.stride = stride;
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   * @api
   * @override
   */ applyTransform(transformFn) {
        if (this.flatCoordinates) {
            transformFn(this.flatCoordinates, this.flatCoordinates, this.layout.startsWith('XYZ') ? 3 : 2, this.stride);
            this.changed();
        }
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in counter-clockwise radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   * @override
   */ rotate(angle, anchor) {
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, $4149c848e00d54f8$export$bb628a54ab399bc9)(flatCoordinates, 0, flatCoordinates.length, stride, angle, anchor, flatCoordinates);
            this.changed();
        }
    }
    /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   * @override
   */ scale(sx, sy, anchor) {
        if (sy === undefined) sy = sx;
        if (!anchor) anchor = (0, $3412ad7bd362b04c$export$c91255cadecfe081)(this.getExtent());
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, $4149c848e00d54f8$export$dcdf75081b88279d)(flatCoordinates, 0, flatCoordinates.length, stride, sx, sy, anchor, flatCoordinates);
            this.changed();
        }
    }
    /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   * @override
   */ translate(deltaX, deltaY) {
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, $4149c848e00d54f8$export$d73ee8ef04f5226a)(flatCoordinates, 0, flatCoordinates.length, stride, deltaX, deltaY, flatCoordinates);
            this.changed();
        }
    }
}
function $7afe4d7f43fcf744$export$61bb6938093db2c8(stride) {
    let layout;
    if (stride == 2) layout = 'XY';
    else if (stride == 3) layout = 'XYZ';
    else if (stride == 4) layout = 'XYZM';
    return /** @type {import("./Geometry.js").GeometryLayout} */ layout;
}
function $7afe4d7f43fcf744$export$6af0c1b4a8549a43(layout) {
    let stride;
    if (layout == 'XY') stride = 2;
    else if (layout == 'XYZ' || layout == 'XYM') stride = 3;
    else if (layout == 'XYZM') stride = 4;
    return /** @type {number} */ stride;
}
function $7afe4d7f43fcf744$export$a3767472617c7861(simpleGeometry, transform, dest) {
    const flatCoordinates = simpleGeometry.getFlatCoordinates();
    if (!flatCoordinates) return null;
    const stride = simpleGeometry.getStride();
    return (0, $4149c848e00d54f8$export$b92b2dedcfff79de)(flatCoordinates, 0, flatCoordinates.length, stride, transform, dest);
}
var $7afe4d7f43fcf744$export$2e2bcd8739ae039 = $7afe4d7f43fcf744$var$SimpleGeometry;


/**
 * @module ol/geom/flat/area
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Area.
 */ function $3d4a8f2cf4f8d852$export$3c5e1905f889266e(flatCoordinates, offset, end, stride) {
    let twiceArea = 0;
    const x0 = flatCoordinates[end - stride];
    const y0 = flatCoordinates[end - stride + 1];
    let dx1 = 0;
    let dy1 = 0;
    for(; offset < end; offset += stride){
        const dx2 = flatCoordinates[offset] - x0;
        const dy2 = flatCoordinates[offset + 1] - y0;
        twiceArea += dy1 * dx2 - dx1 * dy2;
        dx1 = dx2;
        dy1 = dy2;
    }
    return twiceArea / 2;
}
function $3d4a8f2cf4f8d852$export$7a8ee541dfdf2ed5(flatCoordinates, offset, ends, stride) {
    let area = 0;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        area += $3d4a8f2cf4f8d852$export$3c5e1905f889266e(flatCoordinates, offset, end, stride);
        offset = end;
    }
    return area;
}
function $3d4a8f2cf4f8d852$export$78e139679ca7205(flatCoordinates, offset, endss, stride) {
    let area = 0;
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        area += $3d4a8f2cf4f8d852$export$7a8ee541dfdf2ed5(flatCoordinates, offset, ends, stride);
        offset = ends[ends.length - 1];
    }
    return area;
}


/**
 * @module ol/geom/flat/closest
 */ 
/**
 * Returns the point on the 2D line segment flatCoordinates[offset1] to
 * flatCoordinates[offset2] that is closest to the point (x, y).  Extra
 * dimensions are linearly interpolated.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset1 Offset 1.
 * @param {number} offset2 Offset 2.
 * @param {number} stride Stride.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {Array<number>} closestPoint Closest point.
 */ function $5b2e115e5e9e61bb$var$assignClosest(flatCoordinates, offset1, offset2, stride, x, y, closestPoint) {
    const x1 = flatCoordinates[offset1];
    const y1 = flatCoordinates[offset1 + 1];
    const dx = flatCoordinates[offset2] - x1;
    const dy = flatCoordinates[offset2 + 1] - y1;
    let offset;
    if (dx === 0 && dy === 0) offset = offset1;
    else {
        const t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) offset = offset2;
        else if (t > 0) {
            for(let i = 0; i < stride; ++i)closestPoint[i] = (0, $912ac838ff50d1cd$export$3a89f8d6f6bf6c9f)(flatCoordinates[offset1 + i], flatCoordinates[offset2 + i], t);
            closestPoint.length = stride;
            return;
        } else offset = offset1;
    }
    for(let i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[offset + i];
    closestPoint.length = stride;
}
function $5b2e115e5e9e61bb$export$bc2eb611ddf80103(flatCoordinates, offset, end, stride, max) {
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    for(offset += stride; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        const squaredDelta = (0, $912ac838ff50d1cd$export$88e6ebb4fe54f538)(x1, y1, x2, y2);
        if (squaredDelta > max) max = squaredDelta;
        x1 = x2;
        y1 = y2;
    }
    return max;
}
function $5b2e115e5e9e61bb$export$fbf31c8f2668ed5a(flatCoordinates, offset, ends, stride, max) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        max = $5b2e115e5e9e61bb$export$bc2eb611ddf80103(flatCoordinates, offset, end, stride, max);
        offset = end;
    }
    return max;
}
function $5b2e115e5e9e61bb$export$37c18e6e7d50501a(flatCoordinates, offset, endss, stride, max) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        max = $5b2e115e5e9e61bb$export$fbf31c8f2668ed5a(flatCoordinates, offset, ends, stride, max);
        offset = ends[ends.length - 1];
    }
    return max;
}
function $5b2e115e5e9e61bb$export$4adc8e5135fb44c(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    if (offset == end) return minSquaredDistance;
    let i, squaredDistance;
    if (maxDelta === 0) {
        // All points are identical, so just test the first point.
        squaredDistance = (0, $912ac838ff50d1cd$export$88e6ebb4fe54f538)(x, y, flatCoordinates[offset], flatCoordinates[offset + 1]);
        if (squaredDistance < minSquaredDistance) {
            for(i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[offset + i];
            closestPoint.length = stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    let index = offset + stride;
    while(index < end){
        $5b2e115e5e9e61bb$var$assignClosest(flatCoordinates, index - stride, index, stride, x, y, tmpPoint);
        squaredDistance = (0, $912ac838ff50d1cd$export$88e6ebb4fe54f538)(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for(i = 0; i < stride; ++i)closestPoint[i] = tmpPoint[i];
            closestPoint.length = stride;
            index += stride;
        } else // Skip ahead multiple points, because we know that all the skipped
        // points cannot be any closer than the closest point we have found so
        // far.  We know this because we know how close the current point is, how
        // close the closest point we have found so far is, and the maximum
        // distance between consecutive points.  For example, if we're currently
        // at distance 10, the best we've found so far is 3, and that the maximum
        // distance between consecutive points is 2, then we'll need to skip at
        // least (10 - 3) / 2 == 3 (rounded down) points to have any chance of
        // finding a closer point.  We use Math.max(..., 1) to ensure that we
        // always advance at least one point, to avoid an infinite loop.
        index += stride * Math.max((Math.sqrt(squaredDistance) - Math.sqrt(minSquaredDistance)) / maxDelta | 0, 1);
    }
    if (isRing) {
        // Check the closing segment.
        $5b2e115e5e9e61bb$var$assignClosest(flatCoordinates, end - stride, offset, stride, x, y, tmpPoint);
        squaredDistance = (0, $912ac838ff50d1cd$export$88e6ebb4fe54f538)(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for(i = 0; i < stride; ++i)closestPoint[i] = tmpPoint[i];
            closestPoint.length = stride;
        }
    }
    return minSquaredDistance;
}
function $5b2e115e5e9e61bb$export$5a48a0eefcf14992(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        minSquaredDistance = $5b2e115e5e9e61bb$export$4adc8e5135fb44c(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = end;
    }
    return minSquaredDistance;
}
function $5b2e115e5e9e61bb$export$60e067685eb8f9c4(flatCoordinates, offset, endss, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        minSquaredDistance = $5b2e115e5e9e61bb$export$5a48a0eefcf14992(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = ends[ends.length - 1];
    }
    return minSquaredDistance;
}


/**
 * @module ol/geom/flat/deflate
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
 * @param {number} stride Stride.
 * @return {number} offset Offset.
 */ function $f2e193ff6b521c26$export$60815ead40ec79ab(flatCoordinates, offset, coordinate, stride) {
    for(let i = 0, ii = coordinate.length; i < ii; ++i)flatCoordinates[offset++] = coordinate[i];
    return offset;
}
function $f2e193ff6b521c26$export$5c4daf67e03c190f(flatCoordinates, offset, coordinates, stride) {
    for(let i = 0, ii = coordinates.length; i < ii; ++i){
        const coordinate = coordinates[i];
        for(let j = 0; j < stride; ++j)flatCoordinates[offset++] = coordinate[j];
    }
    return offset;
}
function $f2e193ff6b521c26$export$47c3746a74384d45(flatCoordinates, offset, coordinatess, stride, ends) {
    ends = ends ? ends : [];
    let i = 0;
    for(let j = 0, jj = coordinatess.length; j < jj; ++j){
        const end = $f2e193ff6b521c26$export$5c4daf67e03c190f(flatCoordinates, offset, coordinatess[j], stride);
        ends[i++] = end;
        offset = end;
    }
    ends.length = i;
    return ends;
}
function $f2e193ff6b521c26$export$f9f2bb59da4accd3(flatCoordinates, offset, coordinatesss, stride, endss) {
    endss = endss ? endss : [];
    let i = 0;
    for(let j = 0, jj = coordinatesss.length; j < jj; ++j){
        const ends = $f2e193ff6b521c26$export$47c3746a74384d45(flatCoordinates, offset, coordinatesss[j], stride, endss[i]);
        if (ends.length === 0) ends[0] = offset;
        endss[i++] = ends;
        offset = ends[ends.length - 1];
    }
    endss.length = i;
    return endss;
}


/**
 * @module ol/geom/flat/inflate
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {Array<import("../../coordinate.js").Coordinate>} [coordinates] Coordinates.
 * @return {Array<import("../../coordinate.js").Coordinate>} Coordinates.
 */ function $1ffceb5bb486dffd$export$9c0934e4e9c3f61e(flatCoordinates, offset, end, stride, coordinates) {
    coordinates = coordinates !== undefined ? coordinates : [];
    let i = 0;
    for(let j = offset; j < end; j += stride)coordinates[i++] = flatCoordinates.slice(j, j + stride);
    coordinates.length = i;
    return coordinates;
}
function $1ffceb5bb486dffd$export$cbb9596fc0f40db2(flatCoordinates, offset, ends, stride, coordinatess) {
    coordinatess = coordinatess !== undefined ? coordinatess : [];
    let i = 0;
    for(let j = 0, jj = ends.length; j < jj; ++j){
        const end = ends[j];
        coordinatess[i++] = $1ffceb5bb486dffd$export$9c0934e4e9c3f61e(flatCoordinates, offset, end, stride, coordinatess[i]);
        offset = end;
    }
    coordinatess.length = i;
    return coordinatess;
}
function $1ffceb5bb486dffd$export$915c7058aeb4dfeb(flatCoordinates, offset, endss, stride, coordinatesss) {
    coordinatesss = coordinatesss !== undefined ? coordinatesss : [];
    let i = 0;
    for(let j = 0, jj = endss.length; j < jj; ++j){
        const ends = endss[j];
        coordinatesss[i++] = ends.length === 1 && ends[0] === offset ? [] : $1ffceb5bb486dffd$export$cbb9596fc0f40db2(flatCoordinates, offset, ends, stride, coordinatesss[i]);
        offset = ends[ends.length - 1];
    }
    coordinatesss.length = i;
    return coordinatesss;
}


/**
 * @module ol/geom/flat/simplify
 */ // Based on simplify-js https://github.com/mourner/simplify-js
// Copyright (c) 2012, Vladimir Agafonkin
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are met:
//
//    1. Redistributions of source code must retain the above copyright notice,
//       this list of conditions and the following disclaimer.
//
//    2. Redistributions in binary form must reproduce the above copyright
//       notice, this list of conditions and the following disclaimer in the
//       documentation and/or other materials provided with the distribution.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
// AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
// ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
// LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
// CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
// SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
// INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
// CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
// ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
// POSSIBILITY OF SUCH DAMAGE.

function $3d277811864cf352$export$2cbbcce9030b8734(flatCoordinates, offset, end, stride, squaredTolerance, highQuality, simplifiedFlatCoordinates) {
    simplifiedFlatCoordinates = simplifiedFlatCoordinates !== undefined ? simplifiedFlatCoordinates : [];
    if (!highQuality) {
        end = $3d277811864cf352$export$46dba205a0107e9e(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        flatCoordinates = simplifiedFlatCoordinates;
        offset = 0;
        stride = 2;
    }
    simplifiedFlatCoordinates.length = $3d277811864cf352$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
    return simplifiedFlatCoordinates;
}
function $3d277811864cf352$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    const n = (end - offset) / stride;
    if (n < 3) {
        for(; offset < end; offset += stride){
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    /** @type {Array<number>} */ const markers = new Array(n);
    markers[0] = 1;
    markers[n - 1] = 1;
    /** @type {Array<number>} */ const stack = [
        offset,
        end - stride
    ];
    let index = 0;
    while(stack.length > 0){
        const last = stack.pop();
        const first = stack.pop();
        let maxSquaredDistance = 0;
        const x1 = flatCoordinates[first];
        const y1 = flatCoordinates[first + 1];
        const x2 = flatCoordinates[last];
        const y2 = flatCoordinates[last + 1];
        for(let i = first + stride; i < last; i += stride){
            const x = flatCoordinates[i];
            const y = flatCoordinates[i + 1];
            const squaredDistance = (0, $912ac838ff50d1cd$export$251bb0a9cef172e6)(x, y, x1, y1, x2, y2);
            if (squaredDistance > maxSquaredDistance) {
                index = i;
                maxSquaredDistance = squaredDistance;
            }
        }
        if (maxSquaredDistance > squaredTolerance) {
            markers[(index - offset) / stride] = 1;
            if (first + stride < index) stack.push(first, index);
            if (index + stride < last) stack.push(index, last);
        }
    }
    for(let i = 0; i < n; ++i)if (markers[i]) {
        simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + i * stride];
        simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + i * stride + 1];
    }
    return simplifiedOffset;
}
function $3d277811864cf352$export$cedb9900c0b225c2(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        simplifiedOffset = $3d277811864cf352$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
function $3d277811864cf352$export$5d74fb54bb752ea0(flatCoordinates, offset, endss, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedOffset = $3d277811864cf352$export$cedb9900c0b225c2(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}
function $3d277811864cf352$export$46dba205a0107e9e(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    if (end <= offset + stride) {
        // zero or one point, no simplification possible, so copy and return
        for(; offset < end; offset += stride){
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    // copy first point
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    let x2 = x1;
    let y2 = y1;
    for(offset += stride; offset < end; offset += stride){
        x2 = flatCoordinates[offset];
        y2 = flatCoordinates[offset + 1];
        if ((0, $912ac838ff50d1cd$export$88e6ebb4fe54f538)(x1, y1, x2, y2) > squaredTolerance) {
            // copy point at offset
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            x1 = x2;
            y1 = y2;
        }
    }
    if (x2 != x1 || y2 != y1) {
        // copy last point
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    }
    return simplifiedOffset;
}
function $3d277811864cf352$export$51a0620f7a28532b(value, tolerance) {
    return tolerance * Math.round(value / tolerance);
}
function $3d277811864cf352$export$b84e8d2c4920a0c6(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    // do nothing if the line is empty
    if (offset == end) return simplifiedOffset;
    // snap the first coordinate (P1)
    let x1 = $3d277811864cf352$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
    let y1 = $3d277811864cf352$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
    offset += stride;
    // add the first coordinate to the output
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    // find the next coordinate that does not snap to the same value as the first
    // coordinate (P2)
    let x2, y2;
    do {
        x2 = $3d277811864cf352$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
        y2 = $3d277811864cf352$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        if (offset == end) {
            // all coordinates snap to the same value, the line collapses to a point
            // push the last snapped value anyway to ensure that the output contains
            // at least two points
            // FIXME should we really return at least two points anyway?
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            return simplifiedOffset;
        }
    }while (x2 == x1 && y2 == y1);
    while(offset < end){
        // snap the next coordinate (P3)
        const x3 = $3d277811864cf352$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
        const y3 = $3d277811864cf352$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        // skip P3 if it is equal to P2
        if (x3 == x2 && y3 == y2) continue;
        // calculate the delta between P1 and P2
        const dx1 = x2 - x1;
        const dy1 = y2 - y1;
        // calculate the delta between P3 and P1
        const dx2 = x3 - x1;
        const dy2 = y3 - y1;
        // if P1, P2, and P3 are colinear and P3 is further from P1 than P2 is from
        // P1 in the same direction then P2 is on the straight line between P1 and
        // P3
        if (dx1 * dy2 == dy1 * dx2 && (dx1 < 0 && dx2 < dx1 || dx1 == dx2 || dx1 > 0 && dx2 > dx1) && (dy1 < 0 && dy2 < dy1 || dy1 == dy2 || dy1 > 0 && dy2 > dy1)) {
            // discard P2 and set P2 = P3
            x2 = x3;
            y2 = y3;
            continue;
        }
        // either P1, P2, and P3 are not colinear, or they are colinear but P3 is
        // between P3 and P1 or on the opposite half of the line to P2.  add P2,
        // and continue with P1 = P2 and P2 = P3
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
        x1 = x2;
        y1 = y2;
        x2 = x3;
        y2 = y3;
    }
    // add the last point (P2)
    simplifiedFlatCoordinates[simplifiedOffset++] = x2;
    simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    return simplifiedOffset;
}
function $3d277811864cf352$export$60a9904b67f8d51b(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        simplifiedOffset = $3d277811864cf352$export$b84e8d2c4920a0c6(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
function $3d277811864cf352$export$b9acf67ef05cd17c(flatCoordinates, offset, endss, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedOffset = $3d277811864cf352$export$60a9904b67f8d51b(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}


/**
 * @classdesc
 * Linear ring geometry. Only used as part of polygon; cannot be rendered
 * on its own.
 *
 * @api
 */ class $c70d60c874220038$var$LinearRing extends (0, $7afe4d7f43fcf744$export$2e2bcd8739ae039) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (layout !== undefined && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!LinearRing} Clone.
   * @api
   * @override
   */ clone() {
        return new $c70d60c874220038$var$LinearRing(this.flatCoordinates.slice(), this.layout);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $3412ad7bd362b04c$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $5b2e115e5e9e61bb$export$bc2eb611ddf80103)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $5b2e115e5e9e61bb$export$4adc8e5135fb44c)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Return the area of the linear ring on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, $3d4a8f2cf4f8d852$export$3c5e1905f889266e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the coordinates of the linear ring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, $1ffceb5bb486dffd$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LinearRing} Simplified LinearRing.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        simplifiedFlatCoordinates.length = (0, $3d277811864cf352$export$ef693d1572e64fb8)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        return new $c70d60c874220038$var$LinearRing(simplifiedFlatCoordinates, 'XY');
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'LinearRing';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return false;
    }
    /**
   * Set the coordinates of the linear ring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $f2e193ff6b521c26$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $c70d60c874220038$export$2e2bcd8739ae039 = $c70d60c874220038$var$LinearRing;


/**
 * @module ol/geom/Point
 */ 



/**
 * @classdesc
 * Point geometry.
 *
 * @api
 */ class $777d8f3503c8fbb0$var$Point extends (0, $7afe4d7f43fcf744$export$2e2bcd8739ae039) {
    /**
   * @param {import("../coordinate.js").Coordinate} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        this.setCoordinates(coordinates, layout);
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!Point} Clone.
   * @api
   * @override
   */ clone() {
        const point = new $777d8f3503c8fbb0$var$Point(this.flatCoordinates.slice(), this.layout);
        point.applyProperties(this);
        return point;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        const flatCoordinates = this.flatCoordinates;
        const squaredDistance = (0, $912ac838ff50d1cd$export$88e6ebb4fe54f538)(x, y, flatCoordinates[0], flatCoordinates[1]);
        if (squaredDistance < minSquaredDistance) {
            const stride = this.stride;
            for(let i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[i];
            closestPoint.length = stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    /**
   * Return the coordinate of the point.
   * @return {import("../coordinate.js").Coordinate} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return this.flatCoordinates.slice();
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        return (0, $3412ad7bd362b04c$export$4838bf78d04a9440)(this.flatCoordinates, extent);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'Point';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $3412ad7bd362b04c$export$805bdfd6d6690e97)(extent, this.flatCoordinates[0], this.flatCoordinates[1]);
    }
    /**
   * @param {!Array<*>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 0);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $f2e193ff6b521c26$export$60815ead40ec79ab)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $777d8f3503c8fbb0$export$2e2bcd8739ae039 = $777d8f3503c8fbb0$var$Point;





/**
 * @module ol/geom/flat/contains
 */ 
function $9b499a31a2ad5cf2$export$cedabedc7ac0e138(flatCoordinates, offset, end, stride, extent) {
    const outside = (0, $3412ad7bd362b04c$export$f9ed8a3d123a08e2)(extent, /**
     * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
     * @return {boolean} Contains (x, y).
     */ function(coordinate) {
        return !$9b499a31a2ad5cf2$export$949a7a3a4b6f34fa(flatCoordinates, offset, end, stride, coordinate[0], coordinate[1]);
    });
    return !outside;
}
function $9b499a31a2ad5cf2$export$949a7a3a4b6f34fa(flatCoordinates, offset, end, stride, x, y) {
    // https://web.archive.org/web/20210504233957/http://geomalgorithms.com/a03-_inclusion.html
    // Copyright 2000 softSurfer, 2012 Dan Sunday
    // This code may be freely used and modified for any purpose
    // providing that this copyright notice is included with it.
    // SoftSurfer makes no warranty for this code, and cannot be held
    // liable for any real or imagined damage resulting from its use.
    // Users of this code must verify correctness for their application.
    let wn = 0;
    let x1 = flatCoordinates[end - stride];
    let y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        if (y1 <= y) {
            if (y2 > y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) > 0) wn++;
        } else if (y2 <= y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) < 0) wn--;
        x1 = x2;
        y1 = y2;
    }
    return wn !== 0;
}
function $9b499a31a2ad5cf2$export$ae868c0f6acc3355(flatCoordinates, offset, ends, stride, x, y) {
    if (ends.length === 0) return false;
    if (!$9b499a31a2ad5cf2$export$949a7a3a4b6f34fa(flatCoordinates, offset, ends[0], stride, x, y)) return false;
    for(let i = 1, ii = ends.length; i < ii; ++i){
        if ($9b499a31a2ad5cf2$export$949a7a3a4b6f34fa(flatCoordinates, ends[i - 1], ends[i], stride, x, y)) return false;
    }
    return true;
}
function $9b499a31a2ad5cf2$export$c760d9d16cf92043(flatCoordinates, offset, endss, stride, x, y) {
    if (endss.length === 0) return false;
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if ($9b499a31a2ad5cf2$export$ae868c0f6acc3355(flatCoordinates, offset, ends, stride, x, y)) return true;
        offset = ends[ends.length - 1];
    }
    return false;
}




/**
 * @module ol/geom/flat/interiorpoint
 */ 

function $be994eb649209148$export$50e3b25928a5e892(flatCoordinates, offset, ends, stride, flatCenters, flatCentersOffset, dest) {
    let i, ii, x, x1, x2, y1, y2;
    const y = flatCenters[flatCentersOffset + 1];
    /** @type {Array<number>} */ const intersections = [];
    // Calculate intersections with the horizontal line
    for(let r = 0, rr = ends.length; r < rr; ++r){
        const end = ends[r];
        x1 = flatCoordinates[end - stride];
        y1 = flatCoordinates[end - stride + 1];
        for(i = offset; i < end; i += stride){
            x2 = flatCoordinates[i];
            y2 = flatCoordinates[i + 1];
            if (y <= y1 && y2 <= y || y1 <= y && y <= y2) {
                x = (y - y1) / (y2 - y1) * (x2 - x1) + x1;
                intersections.push(x);
            }
            x1 = x2;
            y1 = y2;
        }
    }
    // Find the longest segment of the horizontal line that has its center point
    // inside the linear ring.
    let pointX = NaN;
    let maxSegmentLength = -Infinity;
    intersections.sort((0, $db525acb5f2517fc$export$fcb633242ef15540));
    x1 = intersections[0];
    for(i = 1, ii = intersections.length; i < ii; ++i){
        x2 = intersections[i];
        const segmentLength = Math.abs(x2 - x1);
        if (segmentLength > maxSegmentLength) {
            x = (x1 + x2) / 2;
            if ((0, $9b499a31a2ad5cf2$export$ae868c0f6acc3355)(flatCoordinates, offset, ends, stride, x, y)) {
                pointX = x;
                maxSegmentLength = segmentLength;
            }
        }
        x1 = x2;
    }
    if (isNaN(pointX)) // There is no horizontal line that has its center point inside the linear
    // ring.  Use the center of the the linear ring's extent.
    pointX = flatCenters[flatCentersOffset];
    if (dest) {
        dest.push(pointX, y, maxSegmentLength);
        return dest;
    }
    return [
        pointX,
        y,
        maxSegmentLength
    ];
}
function $be994eb649209148$export$11463803eda8a372(flatCoordinates, offset, endss, stride, flatCenters) {
    /** @type {Array<number>} */ let interiorPoints = [];
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        interiorPoints = $be994eb649209148$export$50e3b25928a5e892(flatCoordinates, offset, ends, stride, flatCenters, 2 * i, interiorPoints);
        offset = ends[ends.length - 1];
    }
    return interiorPoints;
}


/**
 * @module ol/geom/flat/intersectsextent
 */ 

/**
 * @module ol/geom/flat/segments
 */ /**
 * This function calls `callback` for each segment of the flat coordinates
 * array. If the callback returns a truthy value the function returns that
 * value immediately. Otherwise the function returns `false`.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {function(import("../../coordinate.js").Coordinate, import("../../coordinate.js").Coordinate): T} callback Function
 *     called for each segment.
 * @return {T|boolean} Value.
 * @template T
 */ function $8a538cdf4e153a23$export$4b80e395e36b5a56(flatCoordinates, offset, end, stride, callback) {
    let ret;
    offset += stride;
    for(; offset < end; offset += stride){
        ret = callback(flatCoordinates.slice(offset - stride, offset), flatCoordinates.slice(offset, offset + stride));
        if (ret) return ret;
    }
    return false;
}
function $8a538cdf4e153a23$export$3f024338373820dc(segment1, segment2) {
    const [a, b] = segment1;
    const [c, d] = segment2;
    const t = ((a[0] - c[0]) * (c[1] - d[1]) - (a[1] - c[1]) * (c[0] - d[0])) / ((a[0] - b[0]) * (c[1] - d[1]) - (a[1] - b[1]) * (c[0] - d[0]));
    const u = ((a[0] - c[0]) * (a[1] - b[1]) - (a[1] - c[1]) * (a[0] - b[0])) / ((a[0] - b[0]) * (c[1] - d[1]) - (a[1] - b[1]) * (c[0] - d[0]));
    // Check if lines actually intersect
    if (0 <= t && t <= 1 && 0 <= u && u <= 1) return [
        a[0] + t * (b[0] - a[0]),
        a[1] + t * (b[1] - a[1])
    ];
    return undefined;
}


function $ff49a05bd3496d04$export$40d8d71841a3d779(flatCoordinates, offset, end, stride, extent, coordinatesExtent) {
    coordinatesExtent = coordinatesExtent ?? (0, $3412ad7bd362b04c$export$30570204156ffd18)((0, $3412ad7bd362b04c$export$fe201bb3bbe031e9)(), flatCoordinates, offset, end, stride);
    if (!(0, $3412ad7bd362b04c$export$7b0a31e10bbff018)(extent, coordinatesExtent)) return false;
    if (coordinatesExtent[0] >= extent[0] && coordinatesExtent[2] <= extent[2] || coordinatesExtent[1] >= extent[1] && coordinatesExtent[3] <= extent[3]) return true;
    return (0, $8a538cdf4e153a23$export$4b80e395e36b5a56)(flatCoordinates, offset, end, stride, /**
     * @param {import("../../coordinate.js").Coordinate} point1 Start point.
     * @param {import("../../coordinate.js").Coordinate} point2 End point.
     * @return {boolean} `true` if the segment and the extent intersect,
     *     `false` otherwise.
     */ function(point1, point2) {
        return (0, $3412ad7bd362b04c$export$a6a5a7a461419425)(extent, point1, point2);
    });
}
function $ff49a05bd3496d04$export$fdb1d8e850bf7937(flatCoordinates, offset, ends, stride, extent) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        if ($ff49a05bd3496d04$export$40d8d71841a3d779(flatCoordinates, offset, ends[i], stride, extent)) return true;
        offset = ends[i];
    }
    return false;
}
function $ff49a05bd3496d04$export$830a0dafbb2ef1c5(flatCoordinates, offset, end, stride, extent) {
    if ($ff49a05bd3496d04$export$40d8d71841a3d779(flatCoordinates, offset, end, stride, extent)) return true;
    if ((0, $9b499a31a2ad5cf2$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[0], extent[1])) return true;
    if ((0, $9b499a31a2ad5cf2$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[0], extent[3])) return true;
    if ((0, $9b499a31a2ad5cf2$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[2], extent[1])) return true;
    if ((0, $9b499a31a2ad5cf2$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[2], extent[3])) return true;
    return false;
}
function $ff49a05bd3496d04$export$76dcd8f8f83b6ddb(flatCoordinates, offset, ends, stride, extent) {
    if (!$ff49a05bd3496d04$export$830a0dafbb2ef1c5(flatCoordinates, offset, ends[0], stride, extent)) return false;
    if (ends.length === 1) return true;
    for(let i = 1, ii = ends.length; i < ii; ++i)if ((0, $9b499a31a2ad5cf2$export$cedabedc7ac0e138)(flatCoordinates, ends[i - 1], ends[i], stride, extent)) {
        if (!$ff49a05bd3496d04$export$40d8d71841a3d779(flatCoordinates, ends[i - 1], ends[i], stride, extent)) return false;
    }
    return true;
}
function $ff49a05bd3496d04$export$77b72fa3792f5bf0(flatCoordinates, offset, endss, stride, extent) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if ($ff49a05bd3496d04$export$76dcd8f8f83b6ddb(flatCoordinates, offset, ends, stride, extent)) return true;
        offset = ends[ends.length - 1];
    }
    return false;
}


/**
 * @module ol/geom/flat/orient
 */ /**
 * @module ol/geom/flat/reverse
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 */ function $3e5f28bab3d8119a$export$741858880c96b18c(flatCoordinates, offset, end, stride) {
    while(offset < end - stride){
        for(let i = 0; i < stride; ++i){
            const tmp = flatCoordinates[offset + i];
            flatCoordinates[offset + i] = flatCoordinates[end - stride + i];
            flatCoordinates[end - stride + i] = tmp;
        }
        offset += stride;
        end -= stride;
    }
}


function $e3206434e8933f4a$export$318f2842ed17e094(flatCoordinates, offset, end, stride) {
    // https://stackoverflow.com/q/1165647/clockwise-method#1165943
    // https://github.com/OSGeo/gdal/blob/master/gdal/ogr/ogrlinearring.cpp
    let edge = 0;
    let x1 = flatCoordinates[end - stride];
    let y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        edge += (x2 - x1) * (y2 + y1);
        x1 = x2;
        y1 = y2;
    }
    return edge === 0 ? undefined : edge > 0;
}
function $e3206434e8933f4a$export$f27cd06e85f4ba28(flatCoordinates, offset, ends, stride, right) {
    right = right !== undefined ? right : false;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        const isClockwise = $e3206434e8933f4a$export$318f2842ed17e094(flatCoordinates, offset, end, stride);
        if (i === 0) {
            if (right && isClockwise || !right && !isClockwise) return false;
        } else {
            if (right && !isClockwise || !right && isClockwise) return false;
        }
        offset = end;
    }
    return true;
}
function $e3206434e8933f4a$export$a1d138f4bd85f4b4(flatCoordinates, offset, endss, stride, right) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if (!$e3206434e8933f4a$export$f27cd06e85f4ba28(flatCoordinates, offset, ends, stride, right)) return false;
        if (ends.length) offset = ends[ends.length - 1];
    }
    return true;
}
function $e3206434e8933f4a$export$b71b604ddfc778c7(flatCoordinates, offset, ends, stride, right) {
    right = right !== undefined ? right : false;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        const isClockwise = $e3206434e8933f4a$export$318f2842ed17e094(flatCoordinates, offset, end, stride);
        const reverse = i === 0 ? right && isClockwise || !right && !isClockwise : right && !isClockwise || !right && isClockwise;
        if (reverse) (0, $3e5f28bab3d8119a$export$741858880c96b18c)(flatCoordinates, offset, end, stride);
        offset = end;
    }
    return offset;
}
function $e3206434e8933f4a$export$ea9ed55fc2a85010(flatCoordinates, offset, endss, stride, right) {
    for(let i = 0, ii = endss.length; i < ii; ++i)offset = $e3206434e8933f4a$export$b71b604ddfc778c7(flatCoordinates, offset, endss[i], stride, right);
    return offset;
}
function $e3206434e8933f4a$export$cb72ae403d6e78e6(flatCoordinates, ends) {
    const endss = [];
    let offset = 0;
    let prevEndIndex = 0;
    let startOrientation;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        // classifies an array of rings into polygons with outer rings and holes
        const orientation = $e3206434e8933f4a$export$318f2842ed17e094(flatCoordinates, offset, end, 2);
        if (startOrientation === undefined) startOrientation = orientation;
        if (orientation === startOrientation) endss.push(ends.slice(prevEndIndex, i + 1));
        else {
            if (endss.length === 0) continue;
            endss[endss.length - 1].push(ends[prevEndIndex]);
        }
        prevEndIndex = i + 1;
        offset = end;
    }
    return endss;
}



/**
 * @classdesc
 * Polygon geometry.
 *
 * @api
 */ class $5a6d32626ac6e0b9$var$Polygon extends (0, $7afe4d7f43fcf744$export$2e2bcd8739ae039) {
    /**
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>|!Array<number>} coordinates
   *     Array of linear rings that define the polygon. The first linear ring of the
   *     array defines the outer-boundary or surface of the polygon. Each subsequent
   *     linear ring defines a hole in the surface of the polygon. A linear ring is
   *     an array of vertices' coordinates where the first coordinate and the last are
   *     equivalent. (For internal use, flat coordinates in combination with
   *     `layout` and `ends` are also accepted.)
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<number>} [ends] Ends (for internal use with flat coordinates).
   */ constructor(coordinates, layout, ends){
        super();
        /**
     * @type {Array<number>}
     * @private
     */ this.ends_ = [];
        /**
     * @private
     * @type {number}
     */ this.flatInteriorPointRevision_ = -1;
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.flatInteriorPoint_ = null;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.orientedRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.orientedFlatCoordinates_ = null;
        if (layout !== undefined && ends) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.ends_ = ends;
        } else this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ coordinates, layout);
    }
    /**
   * Append the passed linear ring to this polygon.
   * @param {LinearRing} linearRing Linear ring.
   * @api
   */ appendLinearRing(linearRing) {
        if (!this.flatCoordinates) this.flatCoordinates = linearRing.getFlatCoordinates().slice();
        else (0, $db525acb5f2517fc$export$8b58be045bf06082)(this.flatCoordinates, linearRing.getFlatCoordinates());
        this.ends_.push(this.flatCoordinates.length);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!Polygon} Clone.
   * @api
   * @override
   */ clone() {
        const polygon = new $5a6d32626ac6e0b9$var$Polygon(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
        polygon.applyProperties(this);
        return polygon;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $3412ad7bd362b04c$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $5b2e115e5e9e61bb$export$fbf31c8f2668ed5a)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $5b2e115e5e9e61bb$export$5a48a0eefcf14992)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        return (0, $9b499a31a2ad5cf2$export$ae868c0f6acc3355)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, x, y);
    }
    /**
   * Return the area of the polygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, $3d4a8f2cf4f8d852$export$7a8ee541dfdf2ed5)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride);
    }
    /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for polygons.
   *
   * @param {boolean} [right] Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @api
   * @override
   */ getCoordinates(right) {
        let flatCoordinates;
        if (right !== undefined) {
            flatCoordinates = this.getOrientedFlatCoordinates().slice();
            (0, $e3206434e8933f4a$export$b71b604ddfc778c7)(flatCoordinates, 0, this.ends_, this.stride, right);
        } else flatCoordinates = this.flatCoordinates;
        return (0, $1ffceb5bb486dffd$export$cbb9596fc0f40db2)(flatCoordinates, 0, this.ends_, this.stride);
    }
    /**
   * @return {Array<number>} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * @return {Array<number>} Interior point.
   */ getFlatInteriorPoint() {
        if (this.flatInteriorPointRevision_ != this.getRevision()) {
            const flatCenter = (0, $3412ad7bd362b04c$export$c91255cadecfe081)(this.getExtent());
            this.flatInteriorPoint_ = (0, $be994eb649209148$export$50e3b25928a5e892)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, flatCenter, 0);
            this.flatInteriorPointRevision_ = this.getRevision();
        }
        return /** @type {import("../coordinate.js").Coordinate} */ this.flatInteriorPoint_;
    }
    /**
   * Return an interior point of the polygon.
   * @return {Point} Interior point as XYM coordinate, where M is the
   * length of the horizontal intersection that the point belongs to.
   * @api
   */ getInteriorPoint() {
        return new (0, $777d8f3503c8fbb0$export$2e2bcd8739ae039)(this.getFlatInteriorPoint(), 'XYM');
    }
    /**
   * Return the number of rings of the polygon,  this includes the exterior
   * ring and any interior rings.
   *
   * @return {number} Number of rings.
   * @api
   */ getLinearRingCount() {
        return this.ends_.length;
    }
    /**
   * Return the Nth linear ring of the polygon geometry. Return `null` if the
   * given index is out of range.
   * The exterior linear ring is available at index `0` and the interior rings
   * at index `1` and beyond.
   *
   * @param {number} index Index.
   * @return {LinearRing|null} Linear ring.
   * @api
   */ getLinearRing(index) {
        if (index < 0 || this.ends_.length <= index) return null;
        return new (0, $c70d60c874220038$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
    }
    /**
   * Return the linear rings of the polygon.
   * @return {Array<LinearRing>} Linear rings.
   * @api
   */ getLinearRings() {
        const layout = this.layout;
        const flatCoordinates = this.flatCoordinates;
        const ends = this.ends_;
        const linearRings = [];
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const linearRing = new (0, $c70d60c874220038$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout);
            linearRings.push(linearRing);
            offset = end;
        }
        return linearRings;
    }
    /**
   * @return {Array<number>} Oriented flat coordinates.
   */ getOrientedFlatCoordinates() {
        if (this.orientedRevision_ != this.getRevision()) {
            const flatCoordinates = this.flatCoordinates;
            if ((0, $e3206434e8933f4a$export$f27cd06e85f4ba28)(flatCoordinates, 0, this.ends_, this.stride)) this.orientedFlatCoordinates_ = flatCoordinates;
            else {
                this.orientedFlatCoordinates_ = flatCoordinates.slice();
                this.orientedFlatCoordinates_.length = (0, $e3206434e8933f4a$export$b71b604ddfc778c7)(this.orientedFlatCoordinates_, 0, this.ends_, this.stride);
            }
            this.orientedRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.orientedFlatCoordinates_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {Polygon} Simplified Polygon.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedFlatCoordinates.length = (0, $3d277811864cf352$export$60a9904b67f8d51b)(this.flatCoordinates, 0, this.ends_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEnds);
        return new $5a6d32626ac6e0b9$var$Polygon(simplifiedFlatCoordinates, 'XY', simplifiedEnds);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'Polygon';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $ff49a05bd3496d04$export$76dcd8f8f83b6ddb)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, extent);
    }
    /**
   * Set the coordinates of the polygon.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 2);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const ends = (0, $f2e193ff6b521c26$export$47c3746a74384d45)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
        this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
        this.changed();
    }
}
var $5a6d32626ac6e0b9$export$2e2bcd8739ae039 = $5a6d32626ac6e0b9$var$Polygon;
function $5a6d32626ac6e0b9$export$f99d756c6d81ae3f(center, radius, n, sphereRadius) {
    n = n ? n : 32;
    /** @type {Array<number>} */ const flatCoordinates = [];
    for(let i = 0; i < n; ++i)(0, $db525acb5f2517fc$export$8b58be045bf06082)(flatCoordinates, (0, $662150a3b787a9f8$export$cc800923e997bb8)(center, radius, 2 * Math.PI * i / n, sphereRadius));
    flatCoordinates.push(flatCoordinates[0], flatCoordinates[1]);
    return new $5a6d32626ac6e0b9$var$Polygon(flatCoordinates, 'XY', [
        flatCoordinates.length
    ]);
}
function $5a6d32626ac6e0b9$export$c16b671815801c75(extent) {
    if ((0, $3412ad7bd362b04c$export$dd1bc94b04021eeb)(extent)) throw new Error('Cannot create polygon from empty extent');
    const minX = extent[0];
    const minY = extent[1];
    const maxX = extent[2];
    const maxY = extent[3];
    const flatCoordinates = [
        minX,
        minY,
        minX,
        maxY,
        maxX,
        maxY,
        maxX,
        minY,
        minX,
        minY
    ];
    return new $5a6d32626ac6e0b9$var$Polygon(flatCoordinates, 'XY', [
        flatCoordinates.length
    ]);
}
function $5a6d32626ac6e0b9$export$2451009d645fb8c2(circle, sides, angle) {
    sides = sides ? sides : 32;
    const stride = circle.getStride();
    const layout = circle.getLayout();
    const center = circle.getCenter();
    const arrayLength = stride * (sides + 1);
    const flatCoordinates = new Array(arrayLength);
    for(let i = 0; i < arrayLength; i += stride){
        flatCoordinates[i] = 0;
        flatCoordinates[i + 1] = 0;
        for(let j = 2; j < stride; j++)flatCoordinates[i + j] = center[j];
    }
    const ends = [
        flatCoordinates.length
    ];
    const polygon = new $5a6d32626ac6e0b9$var$Polygon(flatCoordinates, layout, ends);
    $5a6d32626ac6e0b9$export$87d6a1539a56e47f(polygon, center, circle.getRadius(), angle);
    return polygon;
}
function $5a6d32626ac6e0b9$export$87d6a1539a56e47f(polygon, center, radius, angle) {
    const flatCoordinates = polygon.getFlatCoordinates();
    const stride = polygon.getStride();
    const sides = flatCoordinates.length / stride - 1;
    const startAngle = angle ? angle : 0;
    for(let i = 0; i <= sides; ++i){
        const offset = i * stride;
        const angle = startAngle + (0, $912ac838ff50d1cd$export$ba467bec01d66def)(i, sides) * 2 * Math.PI / sides;
        flatCoordinates[offset] = center[0] + radius * Math.cos(angle);
        flatCoordinates[offset + 1] = center[1] + radius * Math.sin(angle);
    }
    polygon.changed();
}




/**
 * @module ol/resolutionconstraint
 */ 


/**
 * @typedef {function((number|undefined), number, import("./size.js").Size, boolean=): (number|undefined)} Type
 */ /**
 * Returns a modified resolution taking into account the viewport size and maximum
 * allowed extent.
 * @param {number} resolution Resolution
 * @param {import("./extent.js").Extent} maxExtent Maximum allowed extent.
 * @param {import("./size.js").Size} viewportSize Viewport size.
 * @param {boolean} showFullExtent Whether to show the full extent.
 * @return {number} Capped resolution.
 */ function $90c47efe07ea6e0f$var$getViewportClampedResolution(resolution, maxExtent, viewportSize, showFullExtent) {
    const xResolution = (0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(maxExtent) / viewportSize[0];
    const yResolution = (0, $3412ad7bd362b04c$export$c08559766941f856)(maxExtent) / viewportSize[1];
    if (showFullExtent) return Math.min(resolution, Math.max(xResolution, yResolution));
    return Math.min(resolution, Math.min(xResolution, yResolution));
}
/**
 * Returns a modified resolution to be between maxResolution and minResolution while
 * still allowing the value to be slightly out of bounds.
 * Note: the computation is based on the logarithm function (ln):
 *  - at 1, ln(x) is 0
 *  - above 1, ln(x) keeps increasing but at a much slower pace than x
 * The final result is clamped to prevent getting too far away from bounds.
 * @param {number} resolution Resolution.
 * @param {number} maxResolution Max resolution.
 * @param {number} minResolution Min resolution.
 * @return {number} Smoothed resolution.
 */ function $90c47efe07ea6e0f$var$getSmoothClampedResolution(resolution, maxResolution, minResolution) {
    let result = Math.min(resolution, maxResolution);
    const ratio = 50;
    result *= Math.log(1 + ratio * Math.max(0, resolution / maxResolution - 1)) / ratio + 1;
    if (minResolution) {
        result = Math.max(result, minResolution);
        result /= Math.log(1 + ratio * Math.max(0, minResolution / resolution - 1)) / ratio + 1;
    }
    return (0, $912ac838ff50d1cd$export$7d15b64cf5a3a4c4)(result, minResolution / 2, maxResolution * 2);
}
function $90c47efe07ea6e0f$export$d65a517690fc4385(resolutions, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const maxResolution = resolutions[0];
            const minResolution = resolutions[resolutions.length - 1];
            const cappedMaxRes = maxExtent ? $90c47efe07ea6e0f$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            // during interacting or animating, allow intermediary values
            if (isMoving) {
                if (!smooth) return (0, $912ac838ff50d1cd$export$7d15b64cf5a3a4c4)(resolution, minResolution, cappedMaxRes);
                return $90c47efe07ea6e0f$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
            }
            const capped = Math.min(cappedMaxRes, resolution);
            const z = Math.floor((0, $db525acb5f2517fc$export$8a3786cc03fdb777)(resolutions, capped, direction));
            if (resolutions[z] > cappedMaxRes && z < resolutions.length - 1) return resolutions[z + 1];
            return resolutions[z];
        }
        return undefined;
    });
}
function $90c47efe07ea6e0f$export$22ac0f6b219de91a(power, maxResolution, minResolution, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    minResolution = minResolution !== undefined ? minResolution : 0;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const cappedMaxRes = maxExtent ? $90c47efe07ea6e0f$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            // during interacting or animating, allow intermediary values
            if (isMoving) {
                if (!smooth) return (0, $912ac838ff50d1cd$export$7d15b64cf5a3a4c4)(resolution, minResolution, cappedMaxRes);
                return $90c47efe07ea6e0f$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
            }
            const tolerance = 1e-9;
            const minZoomLevel = Math.ceil(Math.log(maxResolution / cappedMaxRes) / Math.log(power) - tolerance);
            const offset = -direction * (0.5 - tolerance) + 0.5;
            const capped = Math.min(cappedMaxRes, resolution);
            const cappedZoomLevel = Math.floor(Math.log(maxResolution / capped) / Math.log(power) + offset);
            const zoomLevel = Math.max(minZoomLevel, cappedZoomLevel);
            const newResolution = maxResolution / Math.pow(power, zoomLevel);
            return (0, $912ac838ff50d1cd$export$7d15b64cf5a3a4c4)(newResolution, minResolution, cappedMaxRes);
        }
        return undefined;
    });
}
function $90c47efe07ea6e0f$export$1c4e6da9b4b066fe(maxResolution, minResolution, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const cappedMaxRes = maxExtent ? $90c47efe07ea6e0f$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            if (!smooth || !isMoving) return (0, $912ac838ff50d1cd$export$7d15b64cf5a3a4c4)(resolution, minResolution, cappedMaxRes);
            return $90c47efe07ea6e0f$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
        }
        return undefined;
    });
}


/**
 * @module ol/rotationconstraint
 */ 
function $8ede94341b226ce7$export$e20fbacbb41798b(rotation) {
    if (rotation !== undefined) return 0;
    return undefined;
}
function $8ede94341b226ce7$export$f883a24d5edde77c(rotation) {
    if (rotation !== undefined) return rotation;
    return undefined;
}
function $8ede94341b226ce7$export$9ba78806de831083(n) {
    const theta = 2 * Math.PI / n;
    return(/**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */ function(rotation, isMoving) {
        if (isMoving) return rotation;
        if (rotation !== undefined) {
            rotation = Math.floor(rotation / theta + 0.5) * theta;
            return rotation;
        }
        return undefined;
    });
}
function $8ede94341b226ce7$export$17a6e6f3448b17e8(tolerance) {
    const t = tolerance === undefined ? (0, $912ac838ff50d1cd$export$cba01ba138429a1d)(5) : tolerance;
    return(/**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */ function(rotation, isMoving) {
        if (isMoving || rotation === undefined) return rotation;
        if (Math.abs(rotation) <= t) return 0;
        return rotation;
    });
}


/**
 * @module ol/tilegrid/common
 */ /**
 * Default maximum zoom for default tile grids.
 * @type {number}
 */ const $54151e436146eea5$export$e98a216cdcc847dc = 42;
const $54151e436146eea5$export$6b8cb5cd370bd90c = 256;


/**
 * An animation configuration
 *
 * @typedef {Object} Animation
 * @property {import("./coordinate.js").Coordinate} [sourceCenter] Source center.
 * @property {import("./coordinate.js").Coordinate} [targetCenter] Target center.
 * @property {number} [sourceResolution] Source resolution.
 * @property {number} [targetResolution] Target resolution.
 * @property {number} [sourceRotation] Source rotation.
 * @property {number} [targetRotation] Target rotation.
 * @property {import("./coordinate.js").Coordinate} [anchor] Anchor.
 * @property {number} start Start.
 * @property {number} duration Duration.
 * @property {boolean} complete Complete.
 * @property {function(number):number} easing Easing.
 * @property {function(boolean):void} callback Callback.
 */ /**
 * @typedef {Object} Constraints
 * @property {import("./centerconstraint.js").Type} center Center.
 * @property {import("./resolutionconstraint.js").Type} resolution Resolution.
 * @property {import("./rotationconstraint.js").Type} rotation Rotation.
 */ /**
 * @typedef {Object} FitOptions
 * @property {import("./size.js").Size} [size] The size in pixels of the box to
 * fit the extent into. Defaults to the size of the map the view is associated with.
 * If no map or multiple maps are connected to the view, provide the desired box size
 * (e.g. `map.getSize()`).
 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in pixels) to be
 * cleared inside the view. Values in the array are top, right, bottom and left
 * padding.
 * @property {boolean} [nearest=false] If the view `constrainResolution` option is `true`,
 * get the nearest extent instead of the closest that actually fits the view.
 * @property {number} [minResolution=0] Minimum resolution that we zoom to.
 * @property {number} [maxZoom] Maximum zoom level that we zoom to. If
 * `minResolution` is given, this property is ignored.
 * @property {number} [duration] The duration of the animation in milliseconds.
 * By default, there is no animation to the target extent.
 * @property {function(number):number} [easing] The easing function used during
 * the animation (defaults to {@link module:ol/easing.inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 * @property {function(boolean):void} [callback] Function called when the view is in
 * its final position. The callback will be called with `true` if the animation
 * series completed on its own or `false` if it was cancelled.
 */ /**
 * @typedef {Object} ViewOptions
 * @property {import("./coordinate.js").Coordinate} [center] The initial center for
 * the view. If a user projection is not set, the coordinate system for the center is
 * specified with the `projection` option. Layer sources will not be fetched if this
 * is not set, but the center can be set later with {@link #setCenter}.
 * @property {boolean|number} [constrainRotation=true] Rotation constraint.
 * `false` means no constraint. `true` means no constraint, but snap to zero
 * near zero. A number constrains the rotation to that number of values. For
 * example, `4` will constrain the rotation to 0, 90, 180, and 270 degrees.
 * @property {boolean} [enableRotation=true] Enable rotation.
 * If `false`, a rotation constraint that always sets the rotation to zero is
 * used. The `constrainRotation` option has no effect if `enableRotation` is
 * `false`.
 * @property {import("./extent.js").Extent} [extent] The extent that constrains the
 * view, in other words, nothing outside of this extent can be visible on the map.
 * @property {boolean} [constrainOnlyCenter=false] If true, the extent
 * constraint will only apply to the view center and not the whole extent.
 * @property {boolean} [smoothExtentConstraint=true] If true, the extent
 * constraint will be applied smoothly, i.e. allow the view to go slightly outside
 * of the given `extent`.
 * @property {number} [maxResolution] The maximum resolution used to determine
 * the resolution constraint. It is used together with `minResolution` (or
 * `maxZoom`) and `zoomFactor`. If unspecified it is calculated in such a way
 * that the projection's validity extent fits in a 256x256 px tile. If the
 * projection is Spherical Mercator (the default) then `maxResolution` defaults
 * to `40075016.68557849 / 256 = 156543.03392804097`.
 * @property {number} [minResolution] The minimum resolution used to determine
 * the resolution constraint.  It is used together with `maxResolution` (or
 * `minZoom`) and `zoomFactor`.  If unspecified it is calculated assuming 29
 * zoom levels (with a factor of 2). If the projection is Spherical Mercator
 * (the default) then `minResolution` defaults to
 * `40075016.68557849 / 256 / Math.pow(2, 28) = 0.0005831682455839253`.
 * @property {number} [maxZoom=28] The maximum zoom level used to determine the
 * resolution constraint. It is used together with `minZoom` (or
 * `maxResolution`) and `zoomFactor`.  Note that if `minResolution` is also
 * provided, it is given precedence over `maxZoom`.
 * @property {number} [minZoom=0] The minimum zoom level used to determine the
 * resolution constraint. It is used together with `maxZoom` (or
 * `minResolution`) and `zoomFactor`.  Note that if `maxResolution` is also
 * provided, it is given precedence over `minZoom`.
 * @property {boolean} [multiWorld=false] If `false` the view is constrained so
 * only one world is visible, and you cannot pan off the edge.  If `true` the map
 * may show multiple worlds at low zoom levels.  Only used if the `projection` is
 * global.  Note that if `extent` is also provided it is given precedence.
 * @property {boolean} [constrainResolution=false] If true, the view will always
 * animate to the closest zoom level after an interaction; false means
 * intermediary zoom levels are allowed.
 * @property {boolean} [smoothResolutionConstraint=true] If true, the resolution
 * min/max values will be applied smoothly, i. e. allow the view to exceed slightly
 * the given resolution or zoom bounds.
 * @property {boolean} [showFullExtent=false] Allow the view to be zoomed out to
 * show the full configured extent. By default, when a view is configured with an
 * extent, users will not be able to zoom out so the viewport exceeds the extent in
 * either dimension. This means the full extent may not be visible if the viewport
 * is taller or wider than the aspect ratio of the configured extent. If
 * showFullExtent is true, the user will be able to zoom out so that the viewport
 * exceeds the height or width of the configured extent, but not both, allowing the
 * full extent to be shown.
 * @property {import("./proj.js").ProjectionLike} [projection='EPSG:3857'] The
 * projection. The default is Spherical Mercator.
 * @property {number} [resolution] The initial resolution for the view. The
 * units are `projection` units per pixel (e.g. meters per pixel). An
 * alternative to setting this is to set `zoom`. Layer sources will not be
 * fetched if neither this nor `zoom` are defined, but they can be set later
 * with {@link #setZoom} or {@link #setResolution}.
 * @property {Array<number>} [resolutions] Resolutions that determine the
 * zoom levels if specified. The index in the array corresponds to the zoom level,
 * therefore the resolution values have to be in descending order. It also constrains
 * the resolution by the minimum and maximum value. If set the `maxResolution`,
 * `minResolution`, `minZoom`, `maxZoom`, and `zoomFactor` options are ignored.
 * @property {number} [rotation=0] The initial rotation for the view in radians
 * (positive rotation clockwise, 0 means North).
 * @property {number} [zoom] Only used if `resolution` is not defined. Zoom
 * level used to calculate the initial resolution for the view.
 * @property {number} [zoomFactor=2] The zoom factor used to compute the
 * corresponding resolution.
 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in css pixels).
 * If the map viewport is partially covered with other content (overlays) along
 * its edges, this setting allows to shift the center of the viewport away from
 * that content. The order of the values is top, right, bottom, left.
 */ /**
 * @typedef {Object} AnimationOptions
 * @property {import("./coordinate.js").Coordinate} [center] The center of the view at the end of
 * the animation.
 * @property {number} [zoom] The zoom level of the view at the end of the
 * animation. This takes precedence over `resolution`.
 * @property {number} [resolution] The resolution of the view at the end
 * of the animation.  If `zoom` is also provided, this option will be ignored.
 * @property {number} [rotation] The rotation of the view at the end of
 * the animation.
 * @property {import("./coordinate.js").Coordinate} [anchor] Optional anchor to remain fixed
 * during a rotation or resolution animation.
 * @property {number} [duration=1000] The duration of the animation in milliseconds.
 * @property {function(number):number} [easing] The easing function used
 * during the animation (defaults to {@link module:ol/easing.inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 */ /**
 * @typedef {Object} State
 * @property {import("./coordinate.js").Coordinate} center Center (in view projection coordinates).
 * @property {import("./proj/Projection.js").default} projection Projection.
 * @property {number} resolution Resolution.
 * @property {import("./coordinate.js").Coordinate} [nextCenter] The next center during an animation series.
 * @property {number} [nextResolution] The next resolution during an animation series.
 * @property {number} [nextRotation] The next rotation during an animation series.
 * @property {number} rotation Rotation.
 * @property {number} zoom Zoom.
 */ /**
 * Like {@link import("./Map.js").FrameState}, but just `viewState` and `extent`.
 * @typedef {Object} ViewStateLayerStateExtent
 * @property {State} viewState View state.
 * @property {import("./extent.js").Extent} extent Extent (in user projection coordinates).
 * @property {Array<import("./layer/Layer.js").State>} [layerStatesArray] Layer states.
 */ /**
 * Default min zoom level for the map view.
 * @type {number}
 */ const $0ab5c72f1ca22f62$var$DEFAULT_MIN_ZOOM = 0;
/**
 * @typedef {import("./ObjectEventType.js").Types|'change:center'|'change:resolution'|'change:rotation'} ViewObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable.js").OnSignature<import("./Observable.js").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable.js").OnSignature<ViewObjectEventTypes, import("./Object.js").ObjectEvent, Return> &
 *   import("./Observable.js").CombinedOnSignature<import("./Observable.js").EventTypes|ViewObjectEventTypes, Return>} ViewOnSignature
 */ /**
 * @classdesc
 * A View object represents a simple 2D view of the map.
 *
 * This is the object to act upon to change the center, resolution,
 * and rotation of the map.
 *
 * A View has a `projection`. The projection determines the
 * coordinate system of the center, and its units determine the units of the
 * resolution (projection units per pixel). The default projection is
 * Web Mercator (EPSG:3857).
 *
 * ### The view states
 *
 * A View is determined by three states: `center`, `resolution`,
 * and `rotation`. Each state has a corresponding getter and setter, e.g.
 * `getCenter` and `setCenter` for the `center` state.
 *
 * The `zoom` state is actually not saved on the view: all computations
 * internally use the `resolution` state. Still, the `setZoom` and `getZoom`
 * methods are available, as well as `getResolutionForZoom` and
 * `getZoomForResolution` to switch from one system to the other.
 *
 * ### The constraints
 *
 * `setCenter`, `setResolution` and `setRotation` can be used to change the
 * states of the view, but any constraint defined in the constructor will
 * be applied along the way.
 *
 * A View object can have a *resolution constraint*, a *rotation constraint*
 * and a *center constraint*.
 *
 * The *resolution constraint* typically restricts min/max values and
 * snaps to specific resolutions. It is determined by the following
 * options: `resolutions`, `maxResolution`, `maxZoom` and `zoomFactor`.
 * If `resolutions` is set, the other three options are ignored. See
 * documentation for each option for more information. By default, the view
 * only has a min/max restriction and allow intermediary zoom levels when
 * pinch-zooming for example.
 *
 * The *rotation constraint* snaps to specific angles. It is determined
 * by the following options: `enableRotation` and `constrainRotation`.
 * By default rotation is allowed and its value is snapped to zero when approaching the
 * horizontal.
 *
 * The *center constraint* is determined by the `extent` option. By
 * default the view center is not constrained at all.
 *
 * ### Changing the view state
 *
 * It is important to note that `setZoom`, `setResolution`, `setCenter` and
 * `setRotation` are subject to the above mentioned constraints. As such, it
 * may sometimes not be possible to know in advance the resulting state of the
 * View. For example, calling `setResolution(10)` does not guarantee that
 * `getResolution()` will return `10`.
 *
 * A consequence of this is that, when applying a delta on the view state, one
 * should use `adjustCenter`, `adjustRotation`, `adjustZoom` and `adjustResolution`
 * rather than the corresponding setters. This will let view do its internal
 * computations. Besides, the `adjust*` methods also take an `anchor`
 * argument which allows specifying an origin for the transformation.
 *
 * ### Interacting with the view
 *
 * View constraints are usually only applied when the view is *at rest*, meaning that
 * no interaction or animation is ongoing. As such, if the user puts the view in a
 * state that is not equivalent to a constrained one (e.g. rotating the view when
 * the snap angle is 0), an animation will be triggered at the interaction end to
 * put back the view to a stable state;
 *
 * @api
 * @extends {BaseObject<ViewOptions>}
 */ class $0ab5c72f1ca22f62$var$View extends (0, $4dd5119c2f9fa355$export$2e2bcd8739ae039) {
    /**
   * @param {ViewOptions} [options] View options.
   */ constructor(options){
        super();
        /***
     * @type {ViewOnSignature<import("./events.js").EventsKey>}
     */ this.on;
        /***
     * @type {ViewOnSignature<import("./events.js").EventsKey>}
     */ this.once;
        /***
     * @type {ViewOnSignature<void>}
     */ this.un;
        options = Object.assign({}, options);
        /**
     * @private
     * @type {Array<number>}
     */ this.hints_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {Array<Array<Animation>>}
     */ this.animations_ = [];
        /**
     * @private
     * @type {number|undefined}
     */ this.updateAnimationKey_;
        /**
     * @private
     * @const
     * @type {import("./proj/Projection.js").default}
     */ this.projection_ = (0, $2a998b085c5a7ac9$export$549167224996a0fb)(options.projection, 'EPSG:3857');
        /**
     * @private
     * @type {import("./size.js").Size}
     */ this.viewportSize_ = [
            100,
            100
        ];
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate|undefined}
     */ this.targetCenter_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.targetResolution_;
        /**
     * @private
     * @type {number|undefined}
     */ this.targetRotation_;
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate}
     */ this.nextCenter_ = null;
        /**
     * @private
     * @type {number}
     */ this.nextResolution_;
        /**
     * @private
     * @type {number}
     */ this.nextRotation_;
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate|undefined}
     */ this.cancelAnchor_ = undefined;
        if (options.projection) (0, $2a998b085c5a7ac9$export$ed949affbc7c4223)();
        if (options.center) options.center = (0, $2a998b085c5a7ac9$export$d4b8ec0b96db1ee2)(options.center, this.projection_);
        if (options.extent) options.extent = (0, $2a998b085c5a7ac9$export$494be3a3a25689ca)(options.extent, this.projection_);
        this.applyOptions_(options);
    }
    /**
   * Set up the view with the given options.
   * @param {ViewOptions} options View options.
   */ applyOptions_(options) {
        const properties = Object.assign({}, options);
        for(const key in 0, $79a5ddcb45312553$export$2e2bcd8739ae039)delete properties[key];
        this.setProperties(properties, true);
        const resolutionConstraintInfo = $0ab5c72f1ca22f62$export$c68d65f9148da196(options);
        /**
     * @private
     * @type {number}
     */ this.maxResolution_ = resolutionConstraintInfo.maxResolution;
        /**
     * @private
     * @type {number}
     */ this.minResolution_ = resolutionConstraintInfo.minResolution;
        /**
     * @private
     * @type {number}
     */ this.zoomFactor_ = resolutionConstraintInfo.zoomFactor;
        /**
     * @private
     * @type {Array<number>|undefined}
     */ this.resolutions_ = options.resolutions;
        /**
     * @type {Array<number>|undefined}
     * @private
     */ this.padding_ = options.padding;
        /**
     * @private
     * @type {number}
     */ this.minZoom_ = resolutionConstraintInfo.minZoom;
        const centerConstraint = $0ab5c72f1ca22f62$export$964345001ee9ac52(options);
        const resolutionConstraint = resolutionConstraintInfo.constraint;
        const rotationConstraint = $0ab5c72f1ca22f62$export$4eeaa08dd550e3c0(options);
        /**
     * @private
     * @type {Constraints}
     */ this.constraints_ = {
            center: centerConstraint,
            resolution: resolutionConstraint,
            rotation: rotationConstraint
        };
        this.setRotation(options.rotation !== undefined ? options.rotation : 0);
        this.setCenterInternal(options.center !== undefined ? options.center : null);
        if (options.resolution !== undefined) this.setResolution(options.resolution);
        else if (options.zoom !== undefined) this.setZoom(options.zoom);
    }
    /**
   * Padding (in css pixels).
   * If the map viewport is partially covered with other content (overlays) along
   * its edges, this setting allows to shift the center of the viewport away from that
   * content. The order of the values in the array is top, right, bottom, left.
   * The default is no padding, which is equivalent to `[0, 0, 0, 0]`.
   * @type {Array<number>|undefined}
   * @api
   */ get padding() {
        return this.padding_;
    }
    set padding(padding) {
        let oldPadding = this.padding_;
        this.padding_ = padding;
        const center = this.getCenterInternal();
        if (center) {
            const newPadding = padding || [
                0,
                0,
                0,
                0
            ];
            oldPadding = oldPadding || [
                0,
                0,
                0,
                0
            ];
            const resolution = this.getResolution();
            const offsetX = resolution / 2 * (newPadding[3] - oldPadding[3] + oldPadding[1] - newPadding[1]);
            const offsetY = resolution / 2 * (newPadding[0] - oldPadding[0] + oldPadding[2] - newPadding[2]);
            this.setCenterInternal([
                center[0] + offsetX,
                center[1] - offsetY
            ]);
        }
    }
    /**
   * Get an updated version of the view options used to construct the view.  The
   * current resolution (or zoom), center, and rotation are applied to any stored
   * options.  The provided options can be used to apply new min/max zoom or
   * resolution limits.
   * @param {ViewOptions} newOptions New options to be applied.
   * @return {ViewOptions} New options updated with the current view state.
   */ getUpdatedOptions_(newOptions) {
        const options = this.getProperties();
        // preserve resolution (or zoom)
        if (options.resolution !== undefined) options.resolution = this.getResolution();
        else options.zoom = this.getZoom();
        // preserve center
        options.center = this.getCenterInternal();
        // preserve rotation
        options.rotation = this.getRotation();
        return Object.assign({}, options, newOptions);
    }
    /**
   * Animate the view.  The view's center, zoom (or resolution), and rotation
   * can be animated for smooth transitions between view states.  For example,
   * to animate the view to a new zoom level:
   *
   *     view.animate({zoom: view.getZoom() + 1});
   *
   * By default, the animation lasts one second and uses in-and-out easing.  You
   * can customize this behavior by including `duration` (in milliseconds) and
   * `easing` options (see {@link module:ol/easing}).
   *
   * To chain together multiple animations, call the method with multiple
   * animation objects.  For example, to first zoom and then pan:
   *
   *     view.animate({zoom: 10}, {center: [0, 0]});
   *
   * If you provide a function as the last argument to the animate method, it
   * will get called at the end of an animation series.  The callback will be
   * called with `true` if the animation series completed on its own or `false`
   * if it was cancelled.
   *
   * Animations are cancelled by user interactions (e.g. dragging the map) or by
   * calling `view.setCenter()`, `view.setResolution()`, or `view.setRotation()`
   * (or another method that calls one of these).
   *
   * @param {...(AnimationOptions|function(boolean): void)} var_args Animation
   *     options.  Multiple animations can be run in series by passing multiple
   *     options objects.  To run multiple animations in parallel, call the method
   *     multiple times.  An optional callback can be provided as a final
   *     argument.  The callback will be called with a boolean indicating whether
   *     the animation completed without being cancelled.
   * @api
   */ animate(var_args) {
        if (this.isDef() && !this.getAnimating()) this.resolveConstraints(0);
        const args = new Array(arguments.length);
        for(let i = 0; i < args.length; ++i){
            let options = arguments[i];
            if (options.center) {
                options = Object.assign({}, options);
                options.center = (0, $2a998b085c5a7ac9$export$d4b8ec0b96db1ee2)(options.center, this.getProjection());
            }
            if (options.anchor) {
                options = Object.assign({}, options);
                options.anchor = (0, $2a998b085c5a7ac9$export$d4b8ec0b96db1ee2)(options.anchor, this.getProjection());
            }
            args[i] = options;
        }
        this.animateInternal.apply(this, args);
    }
    /**
   * @param {...(AnimationOptions|function(boolean): void)} var_args Animation options.
   */ animateInternal(var_args) {
        let animationCount = arguments.length;
        let callback;
        if (animationCount > 1 && typeof arguments[animationCount - 1] === 'function') {
            callback = arguments[animationCount - 1];
            --animationCount;
        }
        let i = 0;
        for(; i < animationCount && !this.isDef(); ++i){
            // if view properties are not yet set, shortcut to the final state
            const state = arguments[i];
            if (state.center) this.setCenterInternal(state.center);
            if (state.zoom !== undefined) this.setZoom(state.zoom);
            else if (state.resolution) this.setResolution(state.resolution);
            if (state.rotation !== undefined) this.setRotation(state.rotation);
        }
        if (i === animationCount) {
            if (callback) $0ab5c72f1ca22f62$var$animationCallback(callback, true);
            return;
        }
        let start = Date.now();
        let center = this.targetCenter_.slice();
        let resolution = this.targetResolution_;
        let rotation = this.targetRotation_;
        const series = [];
        for(; i < animationCount; ++i){
            const options = /** @type {AnimationOptions} */ arguments[i];
            const animation = {
                start: start,
                complete: false,
                anchor: options.anchor,
                duration: options.duration !== undefined ? options.duration : 1000,
                easing: options.easing || (0, $6aa29dc5b469ae30$export$9b47139b511b56e4),
                callback: callback
            };
            if (options.center) {
                animation.sourceCenter = center;
                animation.targetCenter = options.center.slice();
                center = animation.targetCenter;
            }
            if (options.zoom !== undefined) {
                animation.sourceResolution = resolution;
                animation.targetResolution = this.getResolutionForZoom(options.zoom);
                resolution = animation.targetResolution;
            } else if (options.resolution) {
                animation.sourceResolution = resolution;
                animation.targetResolution = options.resolution;
                resolution = animation.targetResolution;
            }
            if (options.rotation !== undefined) {
                animation.sourceRotation = rotation;
                const delta = (0, $912ac838ff50d1cd$export$ba467bec01d66def)(options.rotation - rotation + Math.PI, 2 * Math.PI) - Math.PI;
                animation.targetRotation = rotation + delta;
                rotation = animation.targetRotation;
            }
            // check if animation is a no-op
            if ($0ab5c72f1ca22f62$export$ee75376562060184(animation)) animation.complete = true;
            else start += animation.duration;
            series.push(animation);
        }
        this.animations_.push(series);
        this.setHint((0, $08bf132ff3931200$export$2e2bcd8739ae039).ANIMATING, 1);
        this.updateAnimations_();
    }
    /**
   * Determine if the view is being animated.
   * @return {boolean} The view is being animated.
   * @api
   */ getAnimating() {
        return this.hints_[(0, $08bf132ff3931200$export$2e2bcd8739ae039).ANIMATING] > 0;
    }
    /**
   * Determine if the user is interacting with the view, such as panning or zooming.
   * @return {boolean} The view is being interacted with.
   * @api
   */ getInteracting() {
        return this.hints_[(0, $08bf132ff3931200$export$2e2bcd8739ae039).INTERACTING] > 0;
    }
    /**
   * Cancel any ongoing animations.
   * @api
   */ cancelAnimations() {
        this.setHint((0, $08bf132ff3931200$export$2e2bcd8739ae039).ANIMATING, -this.hints_[(0, $08bf132ff3931200$export$2e2bcd8739ae039).ANIMATING]);
        let anchor;
        for(let i = 0, ii = this.animations_.length; i < ii; ++i){
            const series = this.animations_[i];
            if (series[0].callback) $0ab5c72f1ca22f62$var$animationCallback(series[0].callback, false);
            if (!anchor) for(let j = 0, jj = series.length; j < jj; ++j){
                const animation = series[j];
                if (!animation.complete) {
                    anchor = animation.anchor;
                    break;
                }
            }
        }
        this.animations_.length = 0;
        this.cancelAnchor_ = anchor;
        this.nextCenter_ = null;
        this.nextResolution_ = NaN;
        this.nextRotation_ = NaN;
    }
    /**
   * Update all animations.
   */ updateAnimations_() {
        if (this.updateAnimationKey_ !== undefined) {
            cancelAnimationFrame(this.updateAnimationKey_);
            this.updateAnimationKey_ = undefined;
        }
        if (!this.getAnimating()) return;
        const now = Date.now();
        let more = false;
        for(let i = this.animations_.length - 1; i >= 0; --i){
            const series = this.animations_[i];
            let seriesComplete = true;
            for(let j = 0, jj = series.length; j < jj; ++j){
                const animation = series[j];
                if (animation.complete) continue;
                const elapsed = now - animation.start;
                let fraction = animation.duration > 0 ? elapsed / animation.duration : 1;
                if (fraction >= 1) {
                    animation.complete = true;
                    fraction = 1;
                } else seriesComplete = false;
                const progress = animation.easing(fraction);
                if (animation.sourceCenter) {
                    const x0 = animation.sourceCenter[0];
                    const y0 = animation.sourceCenter[1];
                    const x1 = animation.targetCenter[0];
                    const y1 = animation.targetCenter[1];
                    this.nextCenter_ = animation.targetCenter;
                    const x = x0 + progress * (x1 - x0);
                    const y = y0 + progress * (y1 - y0);
                    this.targetCenter_ = [
                        x,
                        y
                    ];
                }
                if (animation.sourceResolution && animation.targetResolution) {
                    const resolution = progress === 1 ? animation.targetResolution : animation.sourceResolution + progress * (animation.targetResolution - animation.sourceResolution);
                    if (animation.anchor) {
                        const size = this.getViewportSize_(this.getRotation());
                        const constrainedResolution = this.constraints_.resolution(resolution, 0, size, true);
                        this.targetCenter_ = this.calculateCenterZoom(constrainedResolution, animation.anchor);
                    }
                    this.nextResolution_ = animation.targetResolution;
                    this.targetResolution_ = resolution;
                    this.applyTargetState_(true);
                }
                if (animation.sourceRotation !== undefined && animation.targetRotation !== undefined) {
                    const rotation = progress === 1 ? (0, $912ac838ff50d1cd$export$ba467bec01d66def)(animation.targetRotation + Math.PI, 2 * Math.PI) - Math.PI : animation.sourceRotation + progress * (animation.targetRotation - animation.sourceRotation);
                    if (animation.anchor) {
                        const constrainedRotation = this.constraints_.rotation(rotation, true);
                        this.targetCenter_ = this.calculateCenterRotate(constrainedRotation, animation.anchor);
                    }
                    this.nextRotation_ = animation.targetRotation;
                    this.targetRotation_ = rotation;
                }
                this.applyTargetState_(true);
                more = true;
                if (!animation.complete) break;
            }
            if (seriesComplete) {
                this.animations_[i] = null;
                this.setHint((0, $08bf132ff3931200$export$2e2bcd8739ae039).ANIMATING, -1);
                this.nextCenter_ = null;
                this.nextResolution_ = NaN;
                this.nextRotation_ = NaN;
                const callback = series[0].callback;
                if (callback) $0ab5c72f1ca22f62$var$animationCallback(callback, true);
            }
        }
        // prune completed series
        this.animations_ = this.animations_.filter(Boolean);
        if (more && this.updateAnimationKey_ === undefined) this.updateAnimationKey_ = requestAnimationFrame(this.updateAnimations_.bind(this));
    }
    /**
   * @param {number} rotation Target rotation.
   * @param {import("./coordinate.js").Coordinate} anchor Rotation anchor.
   * @return {import("./coordinate.js").Coordinate|undefined} Center for rotation and anchor.
   */ calculateCenterRotate(rotation, anchor) {
        let center;
        const currentCenter = this.getCenterInternal();
        if (currentCenter !== undefined) {
            center = [
                currentCenter[0] - anchor[0],
                currentCenter[1] - anchor[1]
            ];
            (0, $6542087bee114e8c$export$bb628a54ab399bc9)(center, rotation - this.getRotation());
            (0, $6542087bee114e8c$export$e16d8520af44a096)(center, anchor);
        }
        return center;
    }
    /**
   * @param {number} resolution Target resolution.
   * @param {import("./coordinate.js").Coordinate} anchor Zoom anchor.
   * @return {import("./coordinate.js").Coordinate|undefined} Center for resolution and anchor.
   */ calculateCenterZoom(resolution, anchor) {
        let center;
        const currentCenter = this.getCenterInternal();
        const currentResolution = this.getResolution();
        if (currentCenter !== undefined && currentResolution !== undefined) {
            const x = anchor[0] - resolution * (anchor[0] - currentCenter[0]) / currentResolution;
            const y = anchor[1] - resolution * (anchor[1] - currentCenter[1]) / currentResolution;
            center = [
                x,
                y
            ];
        }
        return center;
    }
    /**
   * Returns the current viewport size.
   * @private
   * @param {number} [rotation] Take into account the rotation of the viewport when giving the size
   * @return {import("./size.js").Size} Viewport size or `[100, 100]` when no viewport is found.
   */ getViewportSize_(rotation) {
        const size = this.viewportSize_;
        if (rotation) {
            const w = size[0];
            const h = size[1];
            return [
                Math.abs(w * Math.cos(rotation)) + Math.abs(h * Math.sin(rotation)),
                Math.abs(w * Math.sin(rotation)) + Math.abs(h * Math.cos(rotation))
            ];
        }
        return size;
    }
    /**
   * Stores the viewport size on the view. The viewport size is not read every time from the DOM
   * to avoid performance hit and layout reflow.
   * This should be done on map size change.
   * Note: the constraints are not resolved during an animation to avoid stopping it
   * @param {import("./size.js").Size} [size] Viewport size; if undefined, [100, 100] is assumed
   */ setViewportSize(size) {
        this.viewportSize_ = Array.isArray(size) ? size.slice() : [
            100,
            100
        ];
        if (!this.getAnimating()) this.resolveConstraints(0);
    }
    /**
   * Get the view center.
   * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
   * @observable
   * @api
   */ getCenter() {
        const center = this.getCenterInternal();
        if (!center) return center;
        return (0, $2a998b085c5a7ac9$export$698f563af1ba02a5)(center, this.getProjection());
    }
    /**
   * Get the view center without transforming to user projection.
   * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
   */ getCenterInternal() {
        return /** @type {import("./coordinate.js").Coordinate|undefined} */ this.get((0, $79a5ddcb45312553$export$2e2bcd8739ae039).CENTER);
    }
    /**
   * @return {Constraints} Constraints.
   */ getConstraints() {
        return this.constraints_;
    }
    /**
   * @return {boolean} Resolution constraint is set
   */ getConstrainResolution() {
        return this.get('constrainResolution');
    }
    /**
   * @param {Array<number>} [hints] Destination array.
   * @return {Array<number>} Hint.
   */ getHints(hints) {
        if (hints !== undefined) {
            hints[0] = this.hints_[0];
            hints[1] = this.hints_[1];
            return hints;
        }
        return this.hints_.slice();
    }
    /**
   * Calculate the extent for the current view state and the passed box size.
   * @param {import("./size.js").Size} [size] The pixel dimensions of the box
   * into which the calculated extent should fit. Defaults to the size of the
   * map the view is associated with.
   * If no map or multiple maps are connected to the view, provide the desired
   * box size (e.g. `map.getSize()`).
   * @return {import("./extent.js").Extent} Extent.
   * @api
   */ calculateExtent(size) {
        const extent = this.calculateExtentInternal(size);
        return (0, $2a998b085c5a7ac9$export$96bfd09e2cffb006)(extent, this.getProjection());
    }
    /**
   * @param {import("./size.js").Size} [size] Box pixel size. If not provided,
   * the map's last known viewport size will be used.
   * @return {import("./extent.js").Extent} Extent.
   */ calculateExtentInternal(size) {
        size = size || this.getViewportSizeMinusPadding_();
        const center = /** @type {!import("./coordinate.js").Coordinate} */ this.getCenterInternal();
        (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(center, 'The view center is not defined');
        const resolution = /** @type {!number} */ this.getResolution();
        (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(resolution !== undefined, 'The view resolution is not defined');
        const rotation = /** @type {!number} */ this.getRotation();
        (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(rotation !== undefined, 'The view rotation is not defined');
        return (0, $3412ad7bd362b04c$export$13ba650faf8308)(center, resolution, rotation, size);
    }
    /**
   * Get the maximum resolution of the view.
   * @return {number} The maximum resolution of the view.
   * @api
   */ getMaxResolution() {
        return this.maxResolution_;
    }
    /**
   * Get the minimum resolution of the view.
   * @return {number} The minimum resolution of the view.
   * @api
   */ getMinResolution() {
        return this.minResolution_;
    }
    /**
   * Get the maximum zoom level for the view.
   * @return {number} The maximum zoom level.
   * @api
   */ getMaxZoom() {
        return /** @type {number} */ this.getZoomForResolution(this.minResolution_);
    }
    /**
   * Set a new maximum zoom level for the view.
   * @param {number} zoom The maximum zoom level.
   * @api
   */ setMaxZoom(zoom) {
        this.applyOptions_(this.getUpdatedOptions_({
            maxZoom: zoom
        }));
    }
    /**
   * Get the minimum zoom level for the view.
   * @return {number} The minimum zoom level.
   * @api
   */ getMinZoom() {
        return /** @type {number} */ this.getZoomForResolution(this.maxResolution_);
    }
    /**
   * Set a new minimum zoom level for the view.
   * @param {number} zoom The minimum zoom level.
   * @api
   */ setMinZoom(zoom) {
        this.applyOptions_(this.getUpdatedOptions_({
            minZoom: zoom
        }));
    }
    /**
   * Set whether the view should allow intermediary zoom levels.
   * @param {boolean} enabled Whether the resolution is constrained.
   * @api
   */ setConstrainResolution(enabled) {
        this.applyOptions_(this.getUpdatedOptions_({
            constrainResolution: enabled
        }));
    }
    /**
   * Get the view projection.
   * @return {import("./proj/Projection.js").default} The projection of the view.
   * @api
   */ getProjection() {
        return this.projection_;
    }
    /**
   * Get the view resolution.
   * @return {number|undefined} The resolution of the view.
   * @observable
   * @api
   */ getResolution() {
        return /** @type {number|undefined} */ this.get((0, $79a5ddcb45312553$export$2e2bcd8739ae039).RESOLUTION);
    }
    /**
   * Get the resolutions for the view. This returns the array of resolutions
   * passed to the constructor of the View, or undefined if none were given.
   * @return {Array<number>|undefined} The resolutions of the view.
   * @api
   */ getResolutions() {
        return this.resolutions_;
    }
    /**
   * Get the resolution for a provided extent (in map units) and size (in pixels).
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {import("./size.js").Size} [size] Box pixel size.
   * @return {number} The resolution at which the provided extent will render at
   *     the given size.
   * @api
   */ getResolutionForExtent(extent, size) {
        return this.getResolutionForExtentInternal((0, $2a998b085c5a7ac9$export$494be3a3a25689ca)(extent, this.getProjection()), size);
    }
    /**
   * Get the resolution for a provided extent (in map units) and size (in pixels).
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {import("./size.js").Size} [size] Box pixel size.
   * @return {number} The resolution at which the provided extent will render at
   *     the given size.
   */ getResolutionForExtentInternal(extent, size) {
        size = size || this.getViewportSizeMinusPadding_();
        const xResolution = (0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(extent) / size[0];
        const yResolution = (0, $3412ad7bd362b04c$export$c08559766941f856)(extent) / size[1];
        return Math.max(xResolution, yResolution);
    }
    /**
   * Return a function that returns a value between 0 and 1 for a
   * resolution. Exponential scaling is assumed.
   * @param {number} [power] Power.
   * @return {function(number): number} Resolution for value function.
   */ getResolutionForValueFunction(power) {
        power = power || 2;
        const maxResolution = this.getConstrainedResolution(this.maxResolution_);
        const minResolution = this.minResolution_;
        const max = Math.log(maxResolution / minResolution) / Math.log(power);
        return(/**
       * @param {number} value Value.
       * @return {number} Resolution.
       */ function(value) {
            const resolution = maxResolution / Math.pow(power, value * max);
            return resolution;
        });
    }
    /**
   * Get the view rotation.
   * @return {number} The rotation of the view in radians.
   * @observable
   * @api
   */ getRotation() {
        return /** @type {number} */ this.get((0, $79a5ddcb45312553$export$2e2bcd8739ae039).ROTATION);
    }
    /**
   * Return a function that returns a resolution for a value between
   * 0 and 1. Exponential scaling is assumed.
   * @param {number} [power] Power.
   * @return {function(number): number} Value for resolution function.
   */ getValueForResolutionFunction(power) {
        const logPower = Math.log(power || 2);
        const maxResolution = this.getConstrainedResolution(this.maxResolution_);
        const minResolution = this.minResolution_;
        const max = Math.log(maxResolution / minResolution) / logPower;
        return(/**
       * @param {number} resolution Resolution.
       * @return {number} Value.
       */ function(resolution) {
            const value = Math.log(maxResolution / resolution) / logPower / max;
            return value;
        });
    }
    /**
   * Returns the size of the viewport minus padding.
   * @private
   * @param {number} [rotation] Take into account the rotation of the viewport when giving the size
   * @return {import("./size.js").Size} Viewport size reduced by the padding.
   */ getViewportSizeMinusPadding_(rotation) {
        let size = this.getViewportSize_(rotation);
        const padding = this.padding_;
        if (padding) size = [
            size[0] - padding[1] - padding[3],
            size[1] - padding[0] - padding[2]
        ];
        return size;
    }
    /**
   * @return {State} View state.
   */ getState() {
        const projection = this.getProjection();
        const resolution = this.getResolution();
        const rotation = this.getRotation();
        let center = /** @type {import("./coordinate.js").Coordinate} */ this.getCenterInternal();
        const padding = this.padding_;
        if (padding) {
            const reducedSize = this.getViewportSizeMinusPadding_();
            center = $0ab5c72f1ca22f62$var$calculateCenterOn(center, this.getViewportSize_(), [
                reducedSize[0] / 2 + padding[3],
                reducedSize[1] / 2 + padding[0]
            ], resolution, rotation);
        }
        return {
            center: center.slice(0),
            projection: projection !== undefined ? projection : null,
            resolution: resolution,
            nextCenter: this.nextCenter_,
            nextResolution: this.nextResolution_,
            nextRotation: this.nextRotation_,
            rotation: rotation,
            zoom: this.getZoom()
        };
    }
    /**
   * @return {ViewStateLayerStateExtent} Like `FrameState`, but just `viewState` and `extent`.
   */ getViewStateAndExtent() {
        return {
            viewState: this.getState(),
            extent: this.calculateExtent()
        };
    }
    /**
   * Get the current zoom level. This method may return non-integer zoom levels
   * if the view does not constrain the resolution, or if an interaction or
   * animation is underway.
   * @return {number|undefined} Zoom.
   * @api
   */ getZoom() {
        let zoom;
        const resolution = this.getResolution();
        if (resolution !== undefined) zoom = this.getZoomForResolution(resolution);
        return zoom;
    }
    /**
   * Get the zoom level for a resolution.
   * @param {number} resolution The resolution.
   * @return {number|undefined} The zoom level for the provided resolution.
   * @api
   */ getZoomForResolution(resolution) {
        let offset = this.minZoom_ || 0;
        let max, zoomFactor;
        if (this.resolutions_) {
            const nearest = (0, $db525acb5f2517fc$export$8a3786cc03fdb777)(this.resolutions_, resolution, 1);
            offset = nearest;
            max = this.resolutions_[nearest];
            if (nearest == this.resolutions_.length - 1) zoomFactor = 2;
            else zoomFactor = max / this.resolutions_[nearest + 1];
        } else {
            max = this.maxResolution_;
            zoomFactor = this.zoomFactor_;
        }
        return offset + Math.log(max / resolution) / Math.log(zoomFactor);
    }
    /**
   * Get the resolution for a zoom level.
   * @param {number} zoom Zoom level.
   * @return {number} The view resolution for the provided zoom level.
   * @api
   */ getResolutionForZoom(zoom) {
        if (this.resolutions_?.length) {
            if (this.resolutions_.length === 1) return this.resolutions_[0];
            const baseLevel = (0, $912ac838ff50d1cd$export$7d15b64cf5a3a4c4)(Math.floor(zoom), 0, this.resolutions_.length - 2);
            const zoomFactor = this.resolutions_[baseLevel] / this.resolutions_[baseLevel + 1];
            return this.resolutions_[baseLevel] / Math.pow(zoomFactor, (0, $912ac838ff50d1cd$export$7d15b64cf5a3a4c4)(zoom - baseLevel, 0, 1));
        }
        return this.maxResolution_ / Math.pow(this.zoomFactor_, zoom - this.minZoom_);
    }
    /**
   * Fit the given geometry or extent based on the given map size and border.
   * The size is pixel dimensions of the box to fit the extent into.
   * In most cases you will want to use the map size, that is `map.getSize()`.
   * Takes care of the map angle.
   * @param {import("./geom/SimpleGeometry.js").default|import("./extent.js").Extent} geometryOrExtent The geometry or
   *     extent to fit the view to.
   * @param {FitOptions} [options] Options.
   * @api
   */ fit(geometryOrExtent, options) {
        /** @type {import("./geom/SimpleGeometry.js").default} */ let geometry;
        (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(Array.isArray(geometryOrExtent) || typeof /** @type {?} */ geometryOrExtent.getSimplifiedGeometry === 'function', 'Invalid extent or geometry provided as `geometry`');
        if (Array.isArray(geometryOrExtent)) {
            (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(!(0, $3412ad7bd362b04c$export$dd1bc94b04021eeb)(geometryOrExtent), 'Cannot fit empty extent provided as `geometry`');
            const extent = (0, $2a998b085c5a7ac9$export$494be3a3a25689ca)(geometryOrExtent, this.getProjection());
            geometry = (0, $5a6d32626ac6e0b9$export$c16b671815801c75)(extent);
        } else if (geometryOrExtent.getType() === 'Circle') {
            const extent = (0, $2a998b085c5a7ac9$export$494be3a3a25689ca)(geometryOrExtent.getExtent(), this.getProjection());
            geometry = (0, $5a6d32626ac6e0b9$export$c16b671815801c75)(extent);
            geometry.rotate(this.getRotation(), (0, $3412ad7bd362b04c$export$c91255cadecfe081)(extent));
        } else {
            const userProjection = (0, $2a998b085c5a7ac9$export$3973b77d5f6f2790)();
            if (userProjection) geometry = /** @type {import("./geom/SimpleGeometry.js").default} */ geometryOrExtent.clone().transform(userProjection, this.getProjection());
            else geometry = geometryOrExtent;
        }
        this.fitInternal(geometry, options);
    }
    /**
   * Calculate rotated extent
   * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
   * @return {import("./extent.js").Extent} The rotated extent for the geometry.
   */ rotatedExtentForGeometry(geometry) {
        const rotation = this.getRotation();
        const cosAngle = Math.cos(rotation);
        const sinAngle = Math.sin(-rotation);
        const coords = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        let minRotX = Infinity;
        let minRotY = Infinity;
        let maxRotX = -Infinity;
        let maxRotY = -Infinity;
        for(let i = 0, ii = coords.length; i < ii; i += stride){
            const rotX = coords[i] * cosAngle - coords[i + 1] * sinAngle;
            const rotY = coords[i] * sinAngle + coords[i + 1] * cosAngle;
            minRotX = Math.min(minRotX, rotX);
            minRotY = Math.min(minRotY, rotY);
            maxRotX = Math.max(maxRotX, rotX);
            maxRotY = Math.max(maxRotY, rotY);
        }
        return [
            minRotX,
            minRotY,
            maxRotX,
            maxRotY
        ];
    }
    /**
   * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
   * @param {FitOptions} [options] Options.
   */ fitInternal(geometry, options) {
        options = options || {};
        let size = options.size;
        if (!size) size = this.getViewportSizeMinusPadding_();
        const padding = options.padding !== undefined ? options.padding : [
            0,
            0,
            0,
            0
        ];
        const nearest = options.nearest !== undefined ? options.nearest : false;
        let minResolution;
        if (options.minResolution !== undefined) minResolution = options.minResolution;
        else if (options.maxZoom !== undefined) minResolution = this.getResolutionForZoom(options.maxZoom);
        else minResolution = 0;
        const rotatedExtent = this.rotatedExtentForGeometry(geometry);
        // calculate resolution
        let resolution = this.getResolutionForExtentInternal(rotatedExtent, [
            size[0] - padding[1] - padding[3],
            size[1] - padding[0] - padding[2]
        ]);
        resolution = isNaN(resolution) ? minResolution : Math.max(resolution, minResolution);
        resolution = this.getConstrainedResolution(resolution, nearest ? 0 : 1);
        // calculate center
        const rotation = this.getRotation();
        const sinAngle = Math.sin(rotation);
        const cosAngle = Math.cos(rotation);
        const centerRot = (0, $3412ad7bd362b04c$export$c91255cadecfe081)(rotatedExtent);
        centerRot[0] += (padding[1] - padding[3]) / 2 * resolution;
        centerRot[1] += (padding[0] - padding[2]) / 2 * resolution;
        const centerX = centerRot[0] * cosAngle - centerRot[1] * sinAngle;
        const centerY = centerRot[1] * cosAngle + centerRot[0] * sinAngle;
        const center = this.getConstrainedCenter([
            centerX,
            centerY
        ], resolution);
        const callback = options.callback ? options.callback : (0, $7efea016d660e267$export$1cd1943b3a73bbe8);
        if (options.duration !== undefined) this.animateInternal({
            resolution: resolution,
            center: center,
            duration: options.duration,
            easing: options.easing
        }, callback);
        else {
            this.targetResolution_ = resolution;
            this.targetCenter_ = center;
            this.applyTargetState_(false, true);
            $0ab5c72f1ca22f62$var$animationCallback(callback, true);
        }
    }
    /**
   * Center on coordinate and view position.
   * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("./size.js").Size} size Box pixel size.
   * @param {import("./pixel.js").Pixel} position Position on the view to center on.
   * @api
   */ centerOn(coordinate, size, position) {
        this.centerOnInternal((0, $2a998b085c5a7ac9$export$d4b8ec0b96db1ee2)(coordinate, this.getProjection()), size, position);
    }
    /**
   * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("./size.js").Size} size Box pixel size.
   * @param {import("./pixel.js").Pixel} position Position on the view to center on.
   */ centerOnInternal(coordinate, size, position) {
        this.setCenterInternal($0ab5c72f1ca22f62$var$calculateCenterOn(coordinate, size, position, this.getResolution(), this.getRotation()));
    }
    /**
   * Calculates the shift between map and viewport center.
   * @param {import("./coordinate.js").Coordinate} center Center.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {import("./size.js").Size} size Size.
   * @return {Array<number>|undefined} Center shift.
   */ calculateCenterShift(center, resolution, rotation, size) {
        let centerShift;
        const padding = this.padding_;
        if (padding && center) {
            const reducedSize = this.getViewportSizeMinusPadding_(-rotation);
            const shiftedCenter = $0ab5c72f1ca22f62$var$calculateCenterOn(center, size, [
                reducedSize[0] / 2 + padding[3],
                reducedSize[1] / 2 + padding[0]
            ], resolution, rotation);
            centerShift = [
                center[0] - shiftedCenter[0],
                center[1] - shiftedCenter[1]
            ];
        }
        return centerShift;
    }
    /**
   * @return {boolean} Is defined.
   */ isDef() {
        return !!this.getCenterInternal() && this.getResolution() !== undefined;
    }
    /**
   * Adds relative coordinates to the center of the view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
   * @api
   */ adjustCenter(deltaCoordinates) {
        const center = (0, $2a998b085c5a7ac9$export$698f563af1ba02a5)(this.targetCenter_, this.getProjection());
        this.setCenter([
            center[0] + deltaCoordinates[0],
            center[1] + deltaCoordinates[1]
        ]);
    }
    /**
   * Adds relative coordinates to the center of the view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
   */ adjustCenterInternal(deltaCoordinates) {
        const center = this.targetCenter_;
        this.setCenterInternal([
            center[0] + deltaCoordinates[0],
            center[1] + deltaCoordinates[1]
        ]);
    }
    /**
   * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} ratio The ratio to apply on the view resolution.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ adjustResolution(ratio, anchor) {
        anchor = anchor && (0, $2a998b085c5a7ac9$export$d4b8ec0b96db1ee2)(anchor, this.getProjection());
        this.adjustResolutionInternal(ratio, anchor);
    }
    /**
   * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} ratio The ratio to apply on the view resolution.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ adjustResolutionInternal(ratio, anchor) {
        const isMoving = this.getAnimating() || this.getInteracting();
        const size = this.getViewportSize_(this.getRotation());
        const newResolution = this.constraints_.resolution(this.targetResolution_ * ratio, 0, size, isMoving);
        if (anchor) this.targetCenter_ = this.calculateCenterZoom(newResolution, anchor);
        this.targetResolution_ *= ratio;
        this.applyTargetState_();
    }
    /**
   * Adds a value to the view zoom level, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} delta Relative value to add to the zoom level.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ adjustZoom(delta, anchor) {
        this.adjustResolution(Math.pow(this.zoomFactor_, -delta), anchor);
    }
    /**
   * Adds a value to the view rotation, optionally using an anchor. Any rotation
   * constraint will apply.
   * @param {number} delta Relative value to add to the zoom rotation, in radians.
   * @param {import("./coordinate.js").Coordinate} [anchor] The rotation center.
   * @api
   */ adjustRotation(delta, anchor) {
        if (anchor) anchor = (0, $2a998b085c5a7ac9$export$d4b8ec0b96db1ee2)(anchor, this.getProjection());
        this.adjustRotationInternal(delta, anchor);
    }
    /**
   * @param {number} delta Relative value to add to the zoom rotation, in radians.
   * @param {import("./coordinate.js").Coordinate} [anchor] The rotation center.
   */ adjustRotationInternal(delta, anchor) {
        const isMoving = this.getAnimating() || this.getInteracting();
        const newRotation = this.constraints_.rotation(this.targetRotation_ + delta, isMoving);
        if (anchor) this.targetCenter_ = this.calculateCenterRotate(newRotation, anchor);
        this.targetRotation_ += delta;
        this.applyTargetState_();
    }
    /**
   * Set the center of the current view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
   * @observable
   * @api
   */ setCenter(center) {
        this.setCenterInternal(center ? (0, $2a998b085c5a7ac9$export$d4b8ec0b96db1ee2)(center, this.getProjection()) : center);
    }
    /**
   * Set the center using the view projection (not the user projection).
   * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
   */ setCenterInternal(center) {
        this.targetCenter_ = center;
        this.applyTargetState_();
    }
    /**
   * @param {import("./ViewHint.js").default} hint Hint.
   * @param {number} delta Delta.
   * @return {number} New value.
   */ setHint(hint, delta) {
        this.hints_[hint] += delta;
        this.changed();
        return this.hints_[hint];
    }
    /**
   * Set the resolution for this view. Any resolution constraint will apply.
   * @param {number|undefined} resolution The resolution of the view.
   * @observable
   * @api
   */ setResolution(resolution) {
        this.targetResolution_ = resolution;
        this.applyTargetState_();
    }
    /**
   * Set the rotation for this view. Any rotation constraint will apply.
   * @param {number} rotation The rotation of the view in radians.
   * @observable
   * @api
   */ setRotation(rotation) {
        this.targetRotation_ = rotation;
        this.applyTargetState_();
    }
    /**
   * Zoom to a specific zoom level. Any resolution constrain will apply.
   * @param {number} zoom Zoom level.
   * @api
   */ setZoom(zoom) {
        this.setResolution(this.getResolutionForZoom(zoom));
    }
    /**
   * Recompute rotation/resolution/center based on target values.
   * Note: we have to compute rotation first, then resolution and center considering that
   * parameters can influence one another in case a view extent constraint is present.
   * @param {boolean} [doNotCancelAnims] Do not cancel animations.
   * @param {boolean} [forceMoving] Apply constraints as if the view is moving.
   * @private
   */ applyTargetState_(doNotCancelAnims, forceMoving) {
        const isMoving = this.getAnimating() || this.getInteracting() || forceMoving;
        // compute rotation
        const newRotation = this.constraints_.rotation(this.targetRotation_, isMoving);
        const size = this.getViewportSize_(newRotation);
        const newResolution = this.constraints_.resolution(this.targetResolution_, 0, size, isMoving);
        const newCenter = this.constraints_.center(this.targetCenter_, newResolution, size, isMoving, this.calculateCenterShift(this.targetCenter_, newResolution, newRotation, size));
        if (this.get((0, $79a5ddcb45312553$export$2e2bcd8739ae039).ROTATION) !== newRotation) this.set((0, $79a5ddcb45312553$export$2e2bcd8739ae039).ROTATION, newRotation);
        if (this.get((0, $79a5ddcb45312553$export$2e2bcd8739ae039).RESOLUTION) !== newResolution) {
            this.set((0, $79a5ddcb45312553$export$2e2bcd8739ae039).RESOLUTION, newResolution);
            this.set('zoom', this.getZoom(), true);
        }
        if (!newCenter || !this.get((0, $79a5ddcb45312553$export$2e2bcd8739ae039).CENTER) || !(0, $6542087bee114e8c$export$e9bab7fafb253603)(this.get((0, $79a5ddcb45312553$export$2e2bcd8739ae039).CENTER), newCenter)) this.set((0, $79a5ddcb45312553$export$2e2bcd8739ae039).CENTER, newCenter);
        if (this.getAnimating() && !doNotCancelAnims) this.cancelAnimations();
        this.cancelAnchor_ = undefined;
    }
    /**
   * If any constraints need to be applied, an animation will be triggered.
   * This is typically done on interaction end.
   * Note: calling this with a duration of 0 will apply the constrained values straight away,
   * without animation.
   * @param {number} [duration] The animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ resolveConstraints(duration, resolutionDirection, anchor) {
        duration = duration !== undefined ? duration : 200;
        const direction = resolutionDirection || 0;
        const newRotation = this.constraints_.rotation(this.targetRotation_);
        const size = this.getViewportSize_(newRotation);
        const newResolution = this.constraints_.resolution(this.targetResolution_, direction, size);
        const newCenter = this.constraints_.center(this.targetCenter_, newResolution, size, false, this.calculateCenterShift(this.targetCenter_, newResolution, newRotation, size));
        if (duration === 0 && !this.cancelAnchor_) {
            this.targetResolution_ = newResolution;
            this.targetRotation_ = newRotation;
            this.targetCenter_ = newCenter;
            this.applyTargetState_();
            return;
        }
        anchor = anchor || (duration === 0 ? this.cancelAnchor_ : undefined);
        this.cancelAnchor_ = undefined;
        if (this.getResolution() !== newResolution || this.getRotation() !== newRotation || !this.getCenterInternal() || !(0, $6542087bee114e8c$export$e9bab7fafb253603)(this.getCenterInternal(), newCenter)) {
            if (this.getAnimating()) this.cancelAnimations();
            this.animateInternal({
                rotation: newRotation,
                center: newCenter,
                resolution: newResolution,
                duration: duration,
                easing: (0, $6aa29dc5b469ae30$export$57636bb43b1ccbb0),
                anchor: anchor
            });
        }
    }
    /**
   * Notify the View that an interaction has started.
   * The view state will be resolved to a stable one if needed
   * (depending on its constraints).
   * @api
   */ beginInteraction() {
        this.resolveConstraints(0);
        this.setHint((0, $08bf132ff3931200$export$2e2bcd8739ae039).INTERACTING, 1);
    }
    /**
   * Notify the View that an interaction has ended. The view state will be resolved
   * to a stable one if needed (depending on its constraints).
   * @param {number} [duration] Animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ endInteraction(duration, resolutionDirection, anchor) {
        anchor = anchor && (0, $2a998b085c5a7ac9$export$d4b8ec0b96db1ee2)(anchor, this.getProjection());
        this.endInteractionInternal(duration, resolutionDirection, anchor);
    }
    /**
   * Notify the View that an interaction has ended. The view state will be resolved
   * to a stable one if needed (depending on its constraints).
   * @param {number} [duration] Animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ endInteractionInternal(duration, resolutionDirection, anchor) {
        if (!this.getInteracting()) return;
        this.setHint((0, $08bf132ff3931200$export$2e2bcd8739ae039).INTERACTING, -1);
        this.resolveConstraints(duration, resolutionDirection, anchor);
    }
    /**
   * Get a valid position for the view center according to the current constraints.
   * @param {import("./coordinate.js").Coordinate|undefined} targetCenter Target center position.
   * @param {number} [targetResolution] Target resolution. If not supplied, the current one will be used.
   * This is useful to guess a valid center position at a different zoom level.
   * @return {import("./coordinate.js").Coordinate|undefined} Valid center position.
   */ getConstrainedCenter(targetCenter, targetResolution) {
        const size = this.getViewportSize_(this.getRotation());
        return this.constraints_.center(targetCenter, targetResolution || this.getResolution(), size);
    }
    /**
   * Get a valid zoom level according to the current view constraints.
   * @param {number|undefined} targetZoom Target zoom.
   * @param {number} [direction] Indicate which resolution should be used
   * by a renderer if the view resolution does not match any resolution of the tile source.
   * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
   * will be used. If -1, the nearest higher resolution will be used.
   * @return {number|undefined} Valid zoom level.
   */ getConstrainedZoom(targetZoom, direction) {
        const targetRes = this.getResolutionForZoom(targetZoom);
        return this.getZoomForResolution(this.getConstrainedResolution(targetRes, direction));
    }
    /**
   * Get a valid resolution according to the current view constraints.
   * @param {number|undefined} targetResolution Target resolution.
   * @param {number} [direction] Indicate which resolution should be used
   * by a renderer if the view resolution does not match any resolution of the tile source.
   * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
   * will be used. If -1, the nearest higher resolution will be used.
   * @return {number|undefined} Valid resolution.
   */ getConstrainedResolution(targetResolution, direction) {
        direction = direction || 0;
        const size = this.getViewportSize_(this.getRotation());
        return this.constraints_.resolution(targetResolution, direction, size);
    }
}
/**
 * @param {Function} callback Callback.
 * @param {*} returnValue Return value.
 */ function $0ab5c72f1ca22f62$var$animationCallback(callback, returnValue) {
    setTimeout(function() {
        callback(returnValue);
    }, 0);
}
function $0ab5c72f1ca22f62$export$964345001ee9ac52(options) {
    if (options.extent !== undefined) {
        const smooth = options.smoothExtentConstraint !== undefined ? options.smoothExtentConstraint : true;
        return (0, $fbfd57abbff90523$export$c2f0af2c946f6897)(options.extent, options.constrainOnlyCenter, smooth);
    }
    const projection = (0, $2a998b085c5a7ac9$export$549167224996a0fb)(options.projection, 'EPSG:3857');
    if (options.multiWorld !== true && projection.isGlobal()) {
        const extent = projection.getExtent().slice();
        extent[0] = -Infinity;
        extent[2] = Infinity;
        return (0, $fbfd57abbff90523$export$c2f0af2c946f6897)(extent, false, false);
    }
    return 0, $fbfd57abbff90523$export$f883a24d5edde77c;
}
function $0ab5c72f1ca22f62$export$c68d65f9148da196(options) {
    let resolutionConstraint;
    let maxResolution;
    let minResolution;
    // TODO: move these to be ol constants
    // see https://github.com/openlayers/openlayers/issues/2076
    const defaultMaxZoom = 28;
    const defaultZoomFactor = 2;
    let minZoom = options.minZoom !== undefined ? options.minZoom : $0ab5c72f1ca22f62$var$DEFAULT_MIN_ZOOM;
    let maxZoom = options.maxZoom !== undefined ? options.maxZoom : defaultMaxZoom;
    const zoomFactor = options.zoomFactor !== undefined ? options.zoomFactor : defaultZoomFactor;
    const multiWorld = options.multiWorld !== undefined ? options.multiWorld : false;
    const smooth = options.smoothResolutionConstraint !== undefined ? options.smoothResolutionConstraint : true;
    const showFullExtent = options.showFullExtent !== undefined ? options.showFullExtent : false;
    const projection = (0, $2a998b085c5a7ac9$export$549167224996a0fb)(options.projection, 'EPSG:3857');
    const projExtent = projection.getExtent();
    let constrainOnlyCenter = options.constrainOnlyCenter;
    let extent = options.extent;
    if (!multiWorld && !extent && projection.isGlobal()) {
        constrainOnlyCenter = false;
        extent = projExtent;
    }
    if (options.resolutions !== undefined) {
        const resolutions = options.resolutions;
        maxResolution = resolutions[minZoom];
        minResolution = resolutions[maxZoom] !== undefined ? resolutions[maxZoom] : resolutions[resolutions.length - 1];
        if (options.constrainResolution) resolutionConstraint = (0, $90c47efe07ea6e0f$export$d65a517690fc4385)(resolutions, smooth, !constrainOnlyCenter && extent, showFullExtent);
        else resolutionConstraint = (0, $90c47efe07ea6e0f$export$1c4e6da9b4b066fe)(maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
    } else {
        // calculate the default min and max resolution
        const size = !projExtent ? 360 * (0, $8ebfe5645312696b$export$1482081eec883108).degrees / projection.getMetersPerUnit() : Math.max((0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(projExtent), (0, $3412ad7bd362b04c$export$c08559766941f856)(projExtent));
        const defaultMaxResolution = size / (0, $54151e436146eea5$export$6b8cb5cd370bd90c) / Math.pow(defaultZoomFactor, $0ab5c72f1ca22f62$var$DEFAULT_MIN_ZOOM);
        const defaultMinResolution = defaultMaxResolution / Math.pow(defaultZoomFactor, defaultMaxZoom - $0ab5c72f1ca22f62$var$DEFAULT_MIN_ZOOM);
        // user provided maxResolution takes precedence
        maxResolution = options.maxResolution;
        if (maxResolution !== undefined) minZoom = 0;
        else maxResolution = defaultMaxResolution / Math.pow(zoomFactor, minZoom);
        // user provided minResolution takes precedence
        minResolution = options.minResolution;
        if (minResolution === undefined) {
            if (options.maxZoom !== undefined) {
                if (options.maxResolution !== undefined) minResolution = maxResolution / Math.pow(zoomFactor, maxZoom);
                else minResolution = defaultMaxResolution / Math.pow(zoomFactor, maxZoom);
            } else minResolution = defaultMinResolution;
        }
        // given discrete zoom levels, minResolution may be different than provided
        maxZoom = minZoom + Math.floor(Math.log(maxResolution / minResolution) / Math.log(zoomFactor));
        minResolution = maxResolution / Math.pow(zoomFactor, maxZoom - minZoom);
        if (options.constrainResolution) resolutionConstraint = (0, $90c47efe07ea6e0f$export$22ac0f6b219de91a)(zoomFactor, maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
        else resolutionConstraint = (0, $90c47efe07ea6e0f$export$1c4e6da9b4b066fe)(maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
    }
    return {
        constraint: resolutionConstraint,
        maxResolution: maxResolution,
        minResolution: minResolution,
        minZoom: minZoom,
        zoomFactor: zoomFactor
    };
}
function $0ab5c72f1ca22f62$export$4eeaa08dd550e3c0(options) {
    const enableRotation = options.enableRotation !== undefined ? options.enableRotation : true;
    if (enableRotation) {
        const constrainRotation = options.constrainRotation;
        if (constrainRotation === undefined || constrainRotation === true) return (0, $8ede94341b226ce7$export$17a6e6f3448b17e8)();
        if (constrainRotation === false) return 0, $8ede94341b226ce7$export$f883a24d5edde77c;
        if (typeof constrainRotation === 'number') return (0, $8ede94341b226ce7$export$9ba78806de831083)(constrainRotation);
        return 0, $8ede94341b226ce7$export$f883a24d5edde77c;
    }
    return 0, $8ede94341b226ce7$export$e20fbacbb41798b;
}
function $0ab5c72f1ca22f62$export$ee75376562060184(animation) {
    if (animation.sourceCenter && animation.targetCenter) {
        if (!(0, $6542087bee114e8c$export$e9bab7fafb253603)(animation.sourceCenter, animation.targetCenter)) return false;
    }
    if (animation.sourceResolution !== animation.targetResolution) return false;
    if (animation.sourceRotation !== animation.targetRotation) return false;
    return true;
}
/**
 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
 * @param {import("./size.js").Size} size Box pixel size.
 * @param {import("./pixel.js").Pixel} position Position on the view to center on.
 * @param {number} resolution Resolution.
 * @param {number} rotation Rotation.
 * @return {import("./coordinate.js").Coordinate} Shifted center.
 */ function $0ab5c72f1ca22f62$var$calculateCenterOn(coordinate, size, position, resolution, rotation) {
    // calculate rotated position
    const cosAngle = Math.cos(-rotation);
    let sinAngle = Math.sin(-rotation);
    let rotX = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
    let rotY = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
    rotX += (size[0] / 2 - position[0]) * resolution;
    rotY += (position[1] - size[1] / 2) * resolution;
    // go back to original angle
    sinAngle = -sinAngle; // go back to original rotation
    const centerX = rotX * cosAngle - rotY * sinAngle;
    const centerY = rotY * cosAngle + rotX * sinAngle;
    return [
        centerX,
        centerY
    ];
}
var $0ab5c72f1ca22f62$export$2e2bcd8739ae039 = $0ab5c72f1ca22f62$var$View;
function $0ab5c72f1ca22f62$export$c25fb981a0c5b500(num) {
    return function(options) {
        if (!options.resolutions) return options;
        const resolutions = [
            ...options.resolutions
        ];
        const highest = resolutions[resolutions.length - 1];
        for(let i = 0; i < num; ++i)resolutions.push(highest / Math.pow(2, i + 1));
        return {
            ...options,
            resolutions: resolutions
        };
    };
}
function $0ab5c72f1ca22f62$export$bd7c975990ce76fa(num) {
    return function(options) {
        if (!options.resolutions) return options;
        const resolutions = [
            ...options.resolutions
        ];
        const lowest = resolutions[0];
        for(let i = 0; i < num; ++i)resolutions.unshift(lowest * Math.pow(2, i + 1));
        return {
            ...options,
            resolutions: resolutions
        };
    };
}
function $0ab5c72f1ca22f62$export$fa18f70fef5f1fab() {
    return function(options) {
        if (!options.extent) return options;
        const center = (0, $3412ad7bd362b04c$export$c91255cadecfe081)(options.extent);
        const newOptions = {
            ...options,
            center: center
        };
        delete newOptions.extent;
        return newOptions;
    };
}
function $0ab5c72f1ca22f62$export$c8cdb1d588f29e82(z) {
    return function(options) {
        return {
            ...options,
            zoom: z
        };
    };
}
async function $0ab5c72f1ca22f62$export$513f42987b822fd7(source, ...transforms) {
    let config = await source.getView();
    for (const transform of transforms)config = transform(config);
    return config;
}






/**
 * @module ol/control/defaults
 */ 
/**
 * @module ol/control/Attribution
 */ 
/**
 * @module ol/css
 */ /**
 * @typedef {Object} FontParameters
 * @property {string} style Style.
 * @property {string} variant Variant.
 * @property {string} weight Weight.
 * @property {string} size Size.
 * @property {string} lineHeight LineHeight.
 * @property {string} family Family.
 * @property {Array<string>} families Families.
 */ /**
 * The CSS class for hidden feature.
 *
 * @const
 * @type {string}
 */ const $87710eafad36a2e8$export$981241db82723ce2 = 'ol-hidden';
const $87710eafad36a2e8$export$99b49471b0394319 = 'ol-selectable';
const $87710eafad36a2e8$export$1afde3d6e16a7b29 = 'ol-unselectable';
const $87710eafad36a2e8$export$68eede0dd8c6c1da = 'ol-unsupported';
const $87710eafad36a2e8$export$4d4f8be70b656192 = 'ol-control';
const $87710eafad36a2e8$export$e16017ac68d14492 = 'ol-collapsed';
/**
 * From https://stackoverflow.com/questions/10135697/regex-to-parse-any-css-font
 * @type {RegExp}
 */ const $87710eafad36a2e8$var$fontRegEx = new RegExp([
    '^\\s*(?=(?:(?:[-a-z]+\\s*){0,2}(italic|oblique))?)',
    '(?=(?:(?:[-a-z]+\\s*){0,2}(small-caps))?)',
    '(?=(?:(?:[-a-z]+\\s*){0,2}(bold(?:er)?|lighter|[1-9]00 ))?)',
    '(?:(?:normal|\\1|\\2|\\3)\\s*){0,3}((?:xx?-)?',
    '(?:small|large)|medium|smaller|larger|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx]))',
    '(?:\\s*\\/\\s*(normal|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx])?))',
    '?\\s*([-,\\"\\\'\\sa-z0-9]+?)\\s*$'
].join(''), 'i');
/** @type {Array<'style'|'variant'|'weight'|'size'|'lineHeight'|'family'>} */ const $87710eafad36a2e8$var$fontRegExMatchIndex = [
    'style',
    'variant',
    'weight',
    'size',
    'lineHeight',
    'family'
];
const $87710eafad36a2e8$export$59230918eb9bd861 = {
    normal: 400,
    bold: 700
};
const $87710eafad36a2e8$export$5abde8a6aec4a131 = function(fontSpec) {
    const match = fontSpec.match($87710eafad36a2e8$var$fontRegEx);
    if (!match) return null;
    const style = /** @type {FontParameters} */ {
        lineHeight: 'normal',
        size: '1.2em',
        style: 'normal',
        weight: '400',
        variant: 'normal'
    };
    for(let i = 0, ii = $87710eafad36a2e8$var$fontRegExMatchIndex.length; i < ii; ++i){
        const value = match[i + 1];
        if (value !== undefined) style[$87710eafad36a2e8$var$fontRegExMatchIndex[i]] = typeof value === 'string' ? value.trim() : value;
    }
    if (isNaN(Number(style.weight)) && style.weight in $87710eafad36a2e8$export$59230918eb9bd861) style.weight = $87710eafad36a2e8$export$59230918eb9bd861[style.weight];
    style.families = style.family.split(/,\s?/).map((f)=>f.trim().replace(/^['"]|['"]$/g, ''));
    return style;
};



function $5ce605ba3ee034a0$export$9e05d10eae75c464(width, height, canvasPool, settings) {
    /** @type {HTMLCanvasElement|OffscreenCanvas} */ let canvas;
    if (canvasPool && canvasPool.length) canvas = /** @type {HTMLCanvasElement} */ canvasPool.shift();
    else if (0, $013e07c1ef6d00ad$export$98fcef3dc9973292) canvas = new class extends OffscreenCanvas {
        style = {};
    }(width ?? 300, height ?? 150);
    else canvas = document.createElement('canvas');
    if (width) canvas.width = width;
    if (height) canvas.height = height;
    return /** @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} */ canvas.getContext('2d', settings);
}
/**
 * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
 */ let $5ce605ba3ee034a0$var$sharedCanvasContext;
function $5ce605ba3ee034a0$export$fcb72ce088a6632c() {
    if (!$5ce605ba3ee034a0$var$sharedCanvasContext) $5ce605ba3ee034a0$var$sharedCanvasContext = $5ce605ba3ee034a0$export$9e05d10eae75c464(1, 1);
    return $5ce605ba3ee034a0$var$sharedCanvasContext;
}
function $5ce605ba3ee034a0$export$e918ac6a1026a12a(context) {
    const canvas = context.canvas;
    canvas.width = 1;
    canvas.height = 1;
    context.clearRect(0, 0, 1, 1);
}
function $5ce605ba3ee034a0$export$e823f88e4111159a(element) {
    let width = element.offsetWidth;
    const style = getComputedStyle(element);
    width += parseInt(style.marginLeft, 10) + parseInt(style.marginRight, 10);
    return width;
}
function $5ce605ba3ee034a0$export$fc5b8aac72846d1e(element) {
    let height = element.offsetHeight;
    const style = getComputedStyle(element);
    height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
    return height;
}
function $5ce605ba3ee034a0$export$5542201de9311ab2(newNode, oldNode) {
    const parent = oldNode.parentNode;
    if (parent) parent.replaceChild(newNode, oldNode);
}
function $5ce605ba3ee034a0$export$1e1c9bf5a4ffe0d1(node) {
    while(node.lastChild)node.lastChild.remove();
}
function $5ce605ba3ee034a0$export$caeacfe04f52533a(node, children) {
    const oldChildren = node.childNodes;
    for(let i = 0;; ++i){
        const oldChild = oldChildren[i];
        const newChild = children[i];
        // check if our work is done
        if (!oldChild && !newChild) break;
        // check if children match
        if (oldChild === newChild) continue;
        // check if a new child needs to be added
        if (!oldChild) {
            node.appendChild(newChild);
            continue;
        }
        // check if an old child needs to be removed
        if (!newChild) {
            node.removeChild(oldChild);
            --i;
            continue;
        }
        // reorder
        node.insertBefore(newChild, oldChild);
    }
}
function $5ce605ba3ee034a0$export$45b7f73d625b5cde() {
    const mockedDiv = new Proxy({
        /**
       * @type {Array<HTMLElement>}
       */ childNodes: [],
        /**
       * @param {HTMLElement} node html node.
       * @return {HTMLElement} html node.
       */ appendChild: function(node) {
            this.childNodes.push(node);
            return node;
        },
        /**
       * dummy function, as this structure is not supposed to have a parent.
       */ remove: function() {},
        /**
       * @param {HTMLElement} node html node.
       * @return {HTMLElement} html node.
       */ removeChild: function(node) {
            const index = this.childNodes.indexOf(node);
            if (index === -1) throw new Error('Node to remove was not found');
            this.childNodes.splice(index, 1);
            return node;
        },
        /**
       * @param {HTMLElement} newNode new html node.
       * @param {HTMLElement} referenceNode reference html node.
       * @return {HTMLElement} new html node.
       */ insertBefore: function(newNode, referenceNode) {
            const index = this.childNodes.indexOf(referenceNode);
            if (index === -1) throw new Error('Reference node not found');
            this.childNodes.splice(index, 0, newNode);
            return newNode;
        },
        style: {}
    }, {
        get (target, prop, receiver) {
            if (prop === 'firstElementChild') return target.childNodes.length > 0 ? target.childNodes[0] : null;
            return Reflect.get(target, prop, receiver);
        }
    });
    return /** @type {*} */ mockedDiv;
}
function $5ce605ba3ee034a0$export$4b05d74c82e4c4d2(obj) {
    return typeof HTMLCanvasElement !== 'undefined' && obj instanceof HTMLCanvasElement || typeof OffscreenCanvas !== 'undefined' && obj instanceof OffscreenCanvas;
}




/**
 * @module ol/control/Control
 */ 



/**
 * @typedef {Object} Options
 * @property {HTMLElement} [element] The element is the control's
 * container element. This only needs to be specified if you're developing
 * a custom control.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 * @property {HTMLElement|string} [target] Specify a target if you want
 * the control to be rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A control is a visible widget with a DOM element in a fixed position on the
 * screen. They can involve user input (buttons), or be informational only;
 * the position is determined using CSS. By default these are placed in the
 * container with CSS class name `ol-overlaycontainer-stopevent`, but can use
 * any outside DOM element.
 *
 * This is the base class for controls. You can use it for simple custom
 * controls by creating the element with listeners, creating an instance:
 * ```js
 * const myControl = new Control({element: myElement});
 * ```
 * and then adding this to the map.
 *
 * The main advantage of having this as a control rather than a simple separate
 * DOM element is that preventing propagation is handled for you. Controls
 * will also be objects in a {@link module:ol/Collection~Collection}, so you can use their methods.
 *
 * You can also extend this base for your own control class. See
 * examples/custom-controls for an example of how to do this.
 *
 * @api
 */ class $a44d9328346bdaf7$var$Control extends (0, $4dd5119c2f9fa355$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Control options.
   */ constructor(options){
        super();
        const element = options.element;
        if (element && !options.target && !element.style.pointerEvents) element.style.pointerEvents = 'auto';
        /**
     * @protected
     * @type {HTMLElement}
     */ this.element = element ? element : null;
        /**
     * @private
     * @type {HTMLElement}
     */ this.target_ = null;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        /**
     * @protected
     * @type {!Array<import("../events.js").EventsKey>}
     */ this.listenerKeys = [];
        if (options.render) this.render = options.render;
        if (options.target) this.setTarget(options.target);
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.element?.remove();
        super.disposeInternal();
    }
    /**
   * Get the map associated with this control.
   * @return {import("../Map.js").default|null} Map.
   * @api
   */ getMap() {
        return this.map_;
    }
    /**
   * Remove the control from its current map and attach it to the new map.
   * Pass `null` to just remove the control from the current map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */ setMap(map) {
        if (this.map_) this.element?.remove();
        for(let i = 0, ii = this.listenerKeys.length; i < ii; ++i)(0, $8061a5de9380012b$export$b0a21c8b3c1c921)(this.listenerKeys[i]);
        this.listenerKeys.length = 0;
        this.map_ = map;
        if (map) {
            const target = this.target_ ?? map.getOverlayContainerStopEvent();
            if (this.element) target.appendChild(this.element);
            if (this.render !== (0, $7efea016d660e267$export$1cd1943b3a73bbe8)) this.listenerKeys.push((0, $8061a5de9380012b$export$63174c828edd6ff8)(map, (0, $f13f0d102103b0f4$export$2e2bcd8739ae039).POSTRENDER, this.render, this));
            map.render();
        }
    }
    /**
   * Renders the control.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @api
   */ render(mapEvent) {}
    /**
   * This function is used to set a target element for the control. It has no
   * effect if it is called after the control has been added to the map (i.e.
   * after `setMap` is called on the control). If no `target` is set in the
   * options passed to the control constructor and if `setTarget` is not called
   * then the control is added to the map's overlay container.
   * @param {HTMLElement|string} target Target.
   * @api
   */ setTarget(target) {
        this.target_ = typeof target === 'string' ? document.getElementById(target) : target;
    }
}
var $a44d9328346bdaf7$export$2e2bcd8739ae039 = $a44d9328346bdaf7$var$Control;


/**
 * @typedef {Object} Options
 * @property {string} [className='ol-attribution'] CSS class name.
 * @property {HTMLElement|string} [target] Specify a target if you
 * want the control to be rendered outside of the map's
 * viewport.
 * @property {boolean} [collapsible] Specify if attributions can
 * be collapsed. If not specified, sources control this behavior with their
 * `attributionsCollapsible` setting.
 * @property {boolean} [collapsed=true] Specify if attributions should
 * be collapsed at startup.
 * @property {string} [tipLabel='Attributions'] Text label to use for the button tip.
 * @property {string|HTMLElement} [label='i'] Text label to use for the
 * collapsed attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [expandClassName=className + '-expand'] CSS class name for the
 * collapsed attributions button.
 * @property {string|HTMLElement} [collapseLabel='›'] Text label to use
 * for the expanded attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [collapseClassName=className + '-collapse'] CSS class name for the
 * expanded attributions button.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 * @property {string|Array<string>|undefined} [attributions] Optional attribution(s) that will always be
 * displayed regardless of the layers rendered.
 * **Caution:** Attributions are rendered dynamically using `innerHTML`, which can lead to potential
 * [**XSS (Cross-Site Scripting)**](https://en.wikipedia.org/wiki/Cross-site_scripting) vulnerabilities.
 * Use this feature only for trusted content
 * or ensure that the content is properly sanitized before inserting it.
 */ /**
 * @classdesc
 * Control to show all the attributions associated with the layer sources
 * in the map. This control is one of the default controls included in maps.
 * By default it will show in the bottom right portion of the map, but this can
 * be changed by using a css selector for `.ol-attribution`.
 *
 * @api
 */ class $deb6a5747d8d2634$var$Attribution extends (0, $a44d9328346bdaf7$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Attribution options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement('div'),
            render: options.render,
            target: options.target
        });
        /**
     * @private
     * @type {HTMLElement}
     */ this.ulElement_ = document.createElement('ul');
        /**
     * @private
     * @type {boolean}
     */ this.collapsed_ = options.collapsed !== undefined ? options.collapsed : true;
        /**
     * @private
     * @type {boolean}
     */ this.userCollapsed_ = this.collapsed_;
        /**
     * @private
     * @type {boolean}
     */ this.overrideCollapsible_ = options.collapsible !== undefined;
        /**
     * @private
     * @type {boolean}
     */ this.collapsible_ = options.collapsible !== undefined ? options.collapsible : true;
        if (!this.collapsible_) this.collapsed_ = false;
        /**
     * @private
     * @type {string | Array<string> | undefined}
     */ this.attributions_ = options.attributions;
        const className = options.className !== undefined ? options.className : 'ol-attribution';
        const tipLabel = options.tipLabel !== undefined ? options.tipLabel : 'Attributions';
        const expandClassName = options.expandClassName !== undefined ? options.expandClassName : className + '-expand';
        const collapseLabel = options.collapseLabel !== undefined ? options.collapseLabel : '\u203A';
        const collapseClassName = options.collapseClassName !== undefined ? options.collapseClassName : className + '-collapse';
        if (typeof collapseLabel === 'string') {
            /**
       * @private
       * @type {HTMLElement}
       */ this.collapseLabel_ = document.createElement('span');
            this.collapseLabel_.textContent = collapseLabel;
            this.collapseLabel_.className = collapseClassName;
        } else this.collapseLabel_ = collapseLabel;
        const label = options.label !== undefined ? options.label : 'i';
        if (typeof label === 'string') {
            /**
       * @private
       * @type {HTMLElement}
       */ this.label_ = document.createElement('span');
            this.label_.textContent = label;
            this.label_.className = expandClassName;
        } else this.label_ = label;
        const activeLabel = this.collapsible_ && !this.collapsed_ ? this.collapseLabel_ : this.label_;
        /**
     * @private
     * @type {HTMLElement}
     */ this.toggleButton_ = document.createElement('button');
        this.toggleButton_.setAttribute('type', 'button');
        this.toggleButton_.setAttribute('aria-expanded', String(!this.collapsed_));
        this.toggleButton_.title = tipLabel;
        this.toggleButton_.appendChild(activeLabel);
        this.toggleButton_.addEventListener((0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this), false);
        const cssClasses = className + ' ' + (0, $87710eafad36a2e8$export$1afde3d6e16a7b29) + ' ' + (0, $87710eafad36a2e8$export$4d4f8be70b656192) + (this.collapsed_ && this.collapsible_ ? ' ' + (0, $87710eafad36a2e8$export$e16017ac68d14492) : '') + (this.collapsible_ ? '' : ' ol-uncollapsible');
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(this.toggleButton_);
        element.appendChild(this.ulElement_);
        /**
     * A list of currently rendered resolutions.
     * @type {Array<string>}
     * @private
     */ this.renderedAttributions_ = [];
        /**
     * @private
     * @type {boolean}
     */ this.renderedVisible_ = true;
    }
    /**
   * Collect a list of visible attributions and set the collapsible state.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @return {Array<string>} Attributions.
   * @private
   */ collectSourceAttributions_(frameState) {
        const layers = this.getMap().getAllLayers();
        const visibleAttributions = new Set(layers.flatMap((layer)=>layer.getAttributions(frameState)));
        if (this.attributions_ !== undefined) Array.isArray(this.attributions_) ? this.attributions_.forEach((item)=>visibleAttributions.add(item)) : visibleAttributions.add(this.attributions_);
        if (!this.overrideCollapsible_) {
            const collapsible = !layers.some((layer)=>layer.getSource()?.getAttributionsCollapsible() === false);
            this.setCollapsible(collapsible);
        }
        return Array.from(visibleAttributions);
    }
    /**
   * @private
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */ async updateElement_(frameState) {
        if (!frameState) {
            if (this.renderedVisible_) {
                this.element.style.display = 'none';
                this.renderedVisible_ = false;
            }
            return;
        }
        const attributions = await Promise.all(this.collectSourceAttributions_(frameState).map((attribution)=>(0, $7efea016d660e267$export$4dbaaf6c79705e6c)(()=>attribution)));
        const visible = attributions.length > 0;
        if (this.renderedVisible_ != visible) {
            this.element.style.display = visible ? '' : 'none';
            this.renderedVisible_ = visible;
        }
        if ((0, $db525acb5f2517fc$export$e9bab7fafb253603)(attributions, this.renderedAttributions_)) return;
        (0, $5ce605ba3ee034a0$export$1e1c9bf5a4ffe0d1)(this.ulElement_);
        // append the attributions
        for(let i = 0, ii = attributions.length; i < ii; ++i){
            const element = document.createElement('li');
            element.innerHTML = attributions[i];
            this.ulElement_.appendChild(element);
        }
        this.renderedAttributions_ = attributions;
    }
    /**
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(event) {
        event.preventDefault();
        this.handleToggle_();
        this.userCollapsed_ = this.collapsed_;
    }
    /**
   * @private
   */ handleToggle_() {
        this.element.classList.toggle((0, $87710eafad36a2e8$export$e16017ac68d14492));
        if (this.collapsed_) (0, $5ce605ba3ee034a0$export$5542201de9311ab2)(this.collapseLabel_, this.label_);
        else (0, $5ce605ba3ee034a0$export$5542201de9311ab2)(this.label_, this.collapseLabel_);
        this.collapsed_ = !this.collapsed_;
        this.toggleButton_.setAttribute('aria-expanded', String(!this.collapsed_));
    }
    /**
   * Return `true` if the attribution is collapsible, `false` otherwise.
   * @return {boolean} True if the widget is collapsible.
   * @api
   */ getCollapsible() {
        return this.collapsible_;
    }
    /**
   * Set whether the attribution should be collapsible.
   * @param {boolean} collapsible True if the widget is collapsible.
   * @api
   */ setCollapsible(collapsible) {
        if (this.collapsible_ === collapsible) return;
        this.collapsible_ = collapsible;
        this.element.classList.toggle('ol-uncollapsible');
        if (this.userCollapsed_) this.handleToggle_();
    }
    /**
   * Collapse or expand the attribution according to the passed parameter. Will
   * not do anything if the attribution isn't collapsible or if the current
   * collapsed state is already the one requested.
   * @param {boolean} collapsed True if the widget is collapsed.
   * @api
   */ setCollapsed(collapsed) {
        this.userCollapsed_ = collapsed;
        if (!this.collapsible_ || this.collapsed_ === collapsed) return;
        this.handleToggle_();
    }
    /**
   * Return `true` when the attribution is currently collapsed or `false`
   * otherwise.
   * @return {boolean} True if the widget is collapsed.
   * @api
   */ getCollapsed() {
        return this.collapsed_;
    }
    /**
   * Update the attribution element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */ render(mapEvent) {
        this.updateElement_(mapEvent.frameState);
    }
}
var $deb6a5747d8d2634$export$2e2bcd8739ae039 = $deb6a5747d8d2634$var$Attribution;


/**
 * @module ol/control/Rotate
 */ 



/**
 * @typedef {Object} Options
 * @property {string} [className='ol-rotate'] CSS class name.
 * @property {string|HTMLElement} [label='⇧'] Text label to use for the rotate button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [tipLabel='Reset rotation'] Text label to use for the rotate tip.
 * @property {string} [compassClassName='ol-compass'] CSS class name for the compass.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {boolean} [autoHide=true] Hide the control when rotation is 0.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the control should
 * be re-rendered. This is called in a `requestAnimationFrame` callback.
 * @property {function():void} [resetNorth] Function called when the control is clicked.
 * This will override the default `resetNorth`.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A button control to reset rotation to 0.
 * To style this control use css selector `.ol-rotate`. A `.ol-hidden` css
 * selector is added to the button when the rotation is 0.
 *
 * @api
 */ class $d8964a6a05955146$var$Rotate extends (0, $a44d9328346bdaf7$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Rotate options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement('div'),
            render: options.render,
            target: options.target
        });
        const className = options.className !== undefined ? options.className : 'ol-rotate';
        const label = options.label !== undefined ? options.label : '\u21E7';
        const compassClassName = options.compassClassName !== undefined ? options.compassClassName : 'ol-compass';
        /**
     * @type {HTMLElement}
     * @private
     */ this.label_ = null;
        if (typeof label === 'string') {
            this.label_ = document.createElement('span');
            this.label_.className = compassClassName;
            this.label_.textContent = label;
        } else {
            this.label_ = label;
            this.label_.classList.add(compassClassName);
        }
        const tipLabel = options.tipLabel ? options.tipLabel : 'Reset rotation';
        const button = document.createElement('button');
        button.className = className + '-reset';
        button.setAttribute('type', 'button');
        button.title = tipLabel;
        button.appendChild(this.label_);
        button.addEventListener((0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this), false);
        const cssClasses = className + ' ' + (0, $87710eafad36a2e8$export$1afde3d6e16a7b29) + ' ' + (0, $87710eafad36a2e8$export$4d4f8be70b656192);
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(button);
        /**
     * @private
     */ this.callResetNorth_ = options.resetNorth ? options.resetNorth : undefined;
        /**
     * @type {number}
     * @private
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
     * @type {boolean}
     * @private
     */ this.autoHide_ = options.autoHide !== undefined ? options.autoHide : true;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = undefined;
        if (this.autoHide_) this.element.classList.add((0, $87710eafad36a2e8$export$981241db82723ce2));
    }
    /**
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(event) {
        event.preventDefault();
        if (this.callResetNorth_ !== undefined) this.callResetNorth_();
        else this.resetNorth_();
    }
    /**
   * @private
   */ resetNorth_() {
        const map = this.getMap();
        const view = map.getView();
        if (!view) // the map does not have a view, so we can't act
        // upon it
        return;
        const rotation = view.getRotation();
        if (rotation !== undefined) {
            if (this.duration_ > 0 && rotation % (2 * Math.PI) !== 0) view.animate({
                rotation: 0,
                duration: this.duration_,
                easing: (0, $6aa29dc5b469ae30$export$57636bb43b1ccbb0)
            });
            else view.setRotation(0);
        }
    }
    /**
   * Update the rotate control element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */ render(mapEvent) {
        const frameState = mapEvent.frameState;
        if (!frameState) return;
        const rotation = frameState.viewState.rotation;
        if (rotation != this.rotation_) {
            const transform = 'rotate(' + rotation + 'rad)';
            if (this.autoHide_) {
                const contains = this.element.classList.contains((0, $87710eafad36a2e8$export$981241db82723ce2));
                if (!contains && rotation === 0) this.element.classList.add((0, $87710eafad36a2e8$export$981241db82723ce2));
                else if (contains && rotation !== 0) this.element.classList.remove((0, $87710eafad36a2e8$export$981241db82723ce2));
            }
            this.label_.style.transform = transform;
        }
        this.rotation_ = rotation;
    }
}
var $d8964a6a05955146$export$2e2bcd8739ae039 = $d8964a6a05955146$var$Rotate;


/**
 * @module ol/control/Zoom
 */ 



/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {string} [className='ol-zoom'] CSS class name.
 * @property {string} [zoomInClassName=className + '-in'] CSS class name for the zoom-in button.
 * @property {string} [zoomOutClassName=className + '-out'] CSS class name for the zoom-out button.
 * @property {string|HTMLElement} [zoomInLabel='+'] Text label to use for the zoom-in
 * button. Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string|HTMLElement} [zoomOutLabel='–'] Text label to use for the zoom-out button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [zoomInTipLabel='Zoom in'] Text label to use for the button tip.
 * @property {string} [zoomOutTipLabel='Zoom out'] Text label to use for the button tip.
 * @property {number} [delta=1] The zoom delta applied on each click.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A control with 2 buttons, one for zoom in and one for zoom out.
 * This control is one of the default controls of a map. To style this control
 * use css selectors `.ol-zoom-in` and `.ol-zoom-out`.
 *
 * @api
 */ class $376219d14d146488$var$Zoom extends (0, $a44d9328346bdaf7$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Zoom options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement('div'),
            target: options.target
        });
        const className = options.className !== undefined ? options.className : 'ol-zoom';
        const delta = options.delta !== undefined ? options.delta : 1;
        const zoomInClassName = options.zoomInClassName !== undefined ? options.zoomInClassName : className + '-in';
        const zoomOutClassName = options.zoomOutClassName !== undefined ? options.zoomOutClassName : className + '-out';
        const zoomInLabel = options.zoomInLabel !== undefined ? options.zoomInLabel : '+';
        const zoomOutLabel = options.zoomOutLabel !== undefined ? options.zoomOutLabel : '\u2013';
        const zoomInTipLabel = options.zoomInTipLabel !== undefined ? options.zoomInTipLabel : 'Zoom in';
        const zoomOutTipLabel = options.zoomOutTipLabel !== undefined ? options.zoomOutTipLabel : 'Zoom out';
        const inElement = document.createElement('button');
        inElement.className = zoomInClassName;
        inElement.setAttribute('type', 'button');
        inElement.title = zoomInTipLabel;
        inElement.appendChild(typeof zoomInLabel === 'string' ? document.createTextNode(zoomInLabel) : zoomInLabel);
        inElement.addEventListener((0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this, delta), false);
        const outElement = document.createElement('button');
        outElement.className = zoomOutClassName;
        outElement.setAttribute('type', 'button');
        outElement.title = zoomOutTipLabel;
        outElement.appendChild(typeof zoomOutLabel === 'string' ? document.createTextNode(zoomOutLabel) : zoomOutLabel);
        outElement.addEventListener((0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this, -delta), false);
        const cssClasses = className + ' ' + (0, $87710eafad36a2e8$export$1afde3d6e16a7b29) + ' ' + (0, $87710eafad36a2e8$export$4d4f8be70b656192);
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(inElement);
        element.appendChild(outElement);
        /**
     * @type {number}
     * @private
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * @param {number} delta Zoom delta.
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(delta, event) {
        event.preventDefault();
        this.zoomByDelta_(delta);
    }
    /**
   * @param {number} delta Zoom delta.
   * @private
   */ zoomByDelta_(delta) {
        const map = this.getMap();
        const view = map.getView();
        if (!view) // the map does not have a view, so we can't act
        // upon it
        return;
        const currentZoom = view.getZoom();
        if (currentZoom !== undefined) {
            const newZoom = view.getConstrainedZoom(currentZoom + delta);
            if (this.duration_ > 0) {
                if (view.getAnimating()) view.cancelAnimations();
                view.animate({
                    zoom: newZoom,
                    duration: this.duration_,
                    easing: (0, $6aa29dc5b469ae30$export$57636bb43b1ccbb0)
                });
            } else view.setZoom(newZoom);
        }
    }
}
var $376219d14d146488$export$2e2bcd8739ae039 = $376219d14d146488$var$Zoom;


function $b0851fae3ad0c95a$export$ebe90cb607ad99e(options) {
    options = options ? options : {};
    /** @type {Collection<import("./Control.js").default>} */ const controls = new (0, $c6078a5bf4414204$export$2e2bcd8739ae039)();
    const zoomControl = options.zoom !== undefined ? options.zoom : true;
    if (zoomControl) controls.push(new (0, $376219d14d146488$export$2e2bcd8739ae039)(options.zoomOptions));
    const rotateControl = options.rotate !== undefined ? options.rotate : true;
    if (rotateControl) controls.push(new (0, $d8964a6a05955146$export$2e2bcd8739ae039)(options.rotateOptions));
    const attributionControl = options.attribution !== undefined ? options.attribution : true;
    if (attributionControl) controls.push(new (0, $deb6a5747d8d2634$export$2e2bcd8739ae039)(options.attributionOptions));
    return controls;
}








/**
 * @module ol/interaction/defaults
 */ 
/**
 * @module ol/Kinetic
 */ /**
 * @classdesc
 * Implementation of inertial deceleration for map movement.
 *
 * @api
 */ class $e63167c26b8f73ba$var$Kinetic {
    /**
   * @param {number} decay Rate of decay (must be negative).
   * @param {number} minVelocity Minimum velocity (pixels/millisecond).
   * @param {number} delay Delay to consider to calculate the kinetic
   *     initial values (milliseconds).
   */ constructor(decay, minVelocity, delay){
        /**
     * @private
     * @type {number}
     */ this.decay_ = decay;
        /**
     * @private
     * @type {number}
     */ this.minVelocity_ = minVelocity;
        /**
     * @private
     * @type {number}
     */ this.delay_ = delay;
        /**
     * @private
     * @type {Array<number>}
     */ this.points_ = [];
        /**
     * @private
     * @type {number}
     */ this.angle_ = 0;
        /**
     * @private
     * @type {number}
     */ this.initialVelocity_ = 0;
    }
    /**
   * FIXME empty description for jsdoc
   */ begin() {
        this.points_.length = 0;
        this.angle_ = 0;
        this.initialVelocity_ = 0;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   */ update(x, y) {
        this.points_.push(x, y, Date.now());
    }
    /**
   * @return {boolean} Whether we should do kinetic animation.
   */ end() {
        if (this.points_.length < 6) // at least 2 points are required (i.e. there must be at least 6 elements
        // in the array)
        return false;
        const delay = Date.now() - this.delay_;
        const lastIndex = this.points_.length - 3;
        if (this.points_[lastIndex + 2] < delay) // the last tracked point is too old, which means that the user stopped
        // panning before releasing the map
        return false;
        // get the first point which still falls into the delay time
        let firstIndex = lastIndex - 3;
        while(firstIndex > 0 && this.points_[firstIndex + 2] > delay)firstIndex -= 3;
        const duration = this.points_[lastIndex + 2] - this.points_[firstIndex + 2];
        // we don't want a duration of 0 (divide by zero)
        // we also make sure the user panned for a duration of at least one frame
        // (1/60s) to compute sane displacement values
        if (duration < 1000 / 60) return false;
        const dx = this.points_[lastIndex] - this.points_[firstIndex];
        const dy = this.points_[lastIndex + 1] - this.points_[firstIndex + 1];
        this.angle_ = Math.atan2(dy, dx);
        this.initialVelocity_ = Math.sqrt(dx * dx + dy * dy) / duration;
        return this.initialVelocity_ > this.minVelocity_;
    }
    /**
   * @return {number} Total distance travelled (pixels).
   */ getDistance() {
        return (this.minVelocity_ - this.initialVelocity_) / this.decay_;
    }
    /**
   * @return {number} Angle of the kinetic panning animation (radians).
   */ getAngle() {
        return this.angle_;
    }
}
var $e63167c26b8f73ba$export$2e2bcd8739ae039 = $e63167c26b8f73ba$var$Kinetic;


/**
 * @module ol/interaction/DoubleClickZoom
 */ 
/**
 * @module ol/interaction/Interaction
 */ 

/**
 * @module ol/interaction/Property
 */ /**
 * @enum {string}
 */ var $52dc8f2951bd6357$export$2e2bcd8739ae039 = {
    ACTIVE: 'active'
};


/***
 * @template Return
 * @typedef {import("../Observable.js").OnSignature<import("../Observable.js").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable.js").OnSignature<import("../ObjectEventType.js").Types|
 *     'change:active', import("../Object.js").ObjectEvent, Return> &
 *   import("../Observable.js").CombinedOnSignature<import("../Observable.js").EventTypes|import("../ObjectEventType.js").Types|
 *     'change:active', Return>} InteractionOnSignature
 */ /**
 * Object literal with config options for interactions.
 * @typedef {Object} InteractionOptions
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleEvent]
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. If the function returns a falsy value, propagation of
 * the event to other interactions in the map's interactions chain will be
 * prevented (this includes functions with no explicit return). The interactions
 * are traversed in reverse order of the interactions collection of the map.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * User actions that change the state of the map. Some are similar to controls,
 * but are not associated with a DOM element.
 * For example, {@link module:ol/interaction/KeyboardZoom~KeyboardZoom} is
 * functionally the same as {@link module:ol/control/Zoom~Zoom}, but triggered
 * by a keyboard event not a button element event.
 * Although interactions do not have a DOM element, some of them do render
 * vectors and so are visible on the screen.
 * @api
 */ class $1cc97d1fb6a71ea7$var$Interaction extends (0, $4dd5119c2f9fa355$export$2e2bcd8739ae039) {
    /**
   * @param {InteractionOptions} [options] Options.
   */ constructor(options){
        super();
        /***
     * @type {InteractionOnSignature<import("../events.js").EventsKey>}
     */ this.on;
        /***
     * @type {InteractionOnSignature<import("../events.js").EventsKey>}
     */ this.once;
        /***
     * @type {InteractionOnSignature<void>}
     */ this.un;
        if (options && options.handleEvent) this.handleEvent = options.handleEvent;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        this.setActive(true);
    }
    /**
   * Return whether the interaction is currently active.
   * @return {boolean} `true` if the interaction is active, `false` otherwise.
   * @observable
   * @api
   */ getActive() {
        return /** @type {boolean} */ this.get((0, $52dc8f2951bd6357$export$2e2bcd8739ae039).ACTIVE);
    }
    /**
   * Get the map associated with this interaction.
   * @return {import("../Map.js").default|null} Map.
   * @api
   */ getMap() {
        return this.map_;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event}.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   */ handleEvent(mapBrowserEvent) {
        return true;
    }
    /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   */ setActive(active) {
        this.set((0, $52dc8f2951bd6357$export$2e2bcd8739ae039).ACTIVE, active);
    }
    /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   */ setMap(map) {
        this.map_ = map;
    }
}
function $1cc97d1fb6a71ea7$export$4c486572e961a974(view, delta, duration) {
    const currentCenter = view.getCenterInternal();
    if (currentCenter) {
        const center = [
            currentCenter[0] + delta[0],
            currentCenter[1] + delta[1]
        ];
        view.animateInternal({
            duration: duration !== undefined ? duration : 250,
            easing: (0, $6aa29dc5b469ae30$export$45db2fc2f15997e7),
            center: view.getConstrainedCenter(center)
        });
    }
}
function $1cc97d1fb6a71ea7$export$ace321ff2a8016ef(view, delta, anchor, duration) {
    const currentZoom = view.getZoom();
    if (currentZoom === undefined) return;
    const newZoom = view.getConstrainedZoom(currentZoom + delta);
    const newResolution = view.getResolutionForZoom(newZoom);
    if (view.getAnimating()) view.cancelAnimations();
    view.animate({
        resolution: newResolution,
        anchor: anchor,
        duration: duration !== undefined ? duration : 250,
        easing: (0, $6aa29dc5b469ae30$export$57636bb43b1ccbb0)
    });
}
var $1cc97d1fb6a71ea7$export$2e2bcd8739ae039 = $1cc97d1fb6a71ea7$var$Interaction;


/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [delta=1] The zoom delta applied on each double click.
 */ /**
 * @classdesc
 * Allows the user to zoom by double-clicking on the map.
 * @api
 */ class $e0a862e5bd39c983$var$DoubleClickZoom extends (0, $1cc97d1fb6a71ea7$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options ? options : {};
        /**
     * @private
     * @type {number}
     */ this.delta_ = options.delta ? options.delta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a
   * doubleclick) and eventually zooms the map.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, $1daf9bd643ab3fe0$export$2e2bcd8739ae039).DBLCLICK) {
            const browserEvent = /** @type {MouseEvent} */ mapBrowserEvent.originalEvent;
            const map = mapBrowserEvent.map;
            const anchor = mapBrowserEvent.coordinate;
            const delta = browserEvent.shiftKey ? -this.delta_ : this.delta_;
            const view = map.getView();
            (0, $1cc97d1fb6a71ea7$export$ace321ff2a8016ef)(view, delta, anchor, this.duration_);
            browserEvent.preventDefault();
            stopEvent = true;
        }
        return !stopEvent;
    }
}
var $e0a862e5bd39c983$export$2e2bcd8739ae039 = $e0a862e5bd39c983$var$DoubleClickZoom;


/**
 * @module ol/interaction/DragPan
 */ 

/**
 * @module ol/events/condition
 */ 


function $3b1164812973fec3$export$84bf76cd7afc7469(var_args) {
    const conditions = arguments;
    /**
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @return {boolean} All conditions passed.
   */ return function(event) {
        let pass = true;
        for(let i = 0, ii = conditions.length; i < ii; ++i){
            pass = pass && conditions[i](event);
            if (!pass) break;
        }
        return pass;
    };
}
const $3b1164812973fec3$export$573409992e89967e = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const $3b1164812973fec3$export$4e5f01653f9f1f82 = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && originalEvent.shiftKey;
};
const $3b1164812973fec3$export$d7ddd398f22d79ef = function(event) {
    const targetElement = event.map.getTargetElement();
    const rootNode = targetElement.getRootNode();
    const activeElement = event.map.getOwnerDocument().activeElement;
    return rootNode instanceof ShadowRoot ? rootNode.host.contains(activeElement) : targetElement.contains(activeElement);
};
const $3b1164812973fec3$export$ae2cdf064e3b0c55 = function(event) {
    const targetElement = event.map.getTargetElement();
    const rootNode = targetElement.getRootNode();
    const tabIndexCandidate = rootNode instanceof ShadowRoot ? rootNode.host : targetElement;
    return tabIndexCandidate.hasAttribute('tabindex') ? $3b1164812973fec3$export$d7ddd398f22d79ef(event) : true;
};
const $3b1164812973fec3$export$ba9e5d519bc326ca = (0, $7efea016d660e267$export$22e23a2304399231);
const $3b1164812973fec3$export$64ef1bee2b9504c1 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $1daf9bd643ab3fe0$export$2e2bcd8739ae039).CLICK;
};
const $3b1164812973fec3$export$1238ad6b5e7fff70 = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return 'pointerId' in originalEvent && originalEvent.button == 0 && !((0, $013e07c1ef6d00ad$export$39dfd62a25e0fe93) && (0, $013e07c1ef6d00ad$export$76c0a3b101d93136) && originalEvent.ctrlKey);
};
const $3b1164812973fec3$export$b3e22bcfd64c1022 = (0, $7efea016d660e267$export$8f11cee4bdc7e668);
const $3b1164812973fec3$export$71eac0963f2c2f01 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == 'pointermove';
};
const $3b1164812973fec3$export$194df8bad091b401 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $1daf9bd643ab3fe0$export$2e2bcd8739ae039).SINGLECLICK;
};
const $3b1164812973fec3$export$c59d944dd10b3dc7 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $1daf9bd643ab3fe0$export$2e2bcd8739ae039).DBLCLICK;
};
const $3b1164812973fec3$export$fdc892d0d8fe3bfb = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const $3b1164812973fec3$export$f3100d8d6292d638 = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && ((0, $013e07c1ef6d00ad$export$76c0a3b101d93136) ? originalEvent.metaKey : originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const $3b1164812973fec3$export$32603ad571dd22b5 = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return (0, $013e07c1ef6d00ad$export$76c0a3b101d93136) ? originalEvent.metaKey : originalEvent.ctrlKey;
};
const $3b1164812973fec3$export$5d31fe68a477cfbb = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && originalEvent.shiftKey;
};
const $3b1164812973fec3$export$e5570ca80cd8fd54 = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    const tagName = /** @type {Element} */ originalEvent.target.tagName;
    return tagName !== 'INPUT' && tagName !== 'SELECT' && tagName !== 'TEXTAREA' && // `isContentEditable` is only available on `HTMLElement`, but it may also be a
    // different type like `SVGElement`.
    // @ts-ignore
    !originalEvent.target.isContentEditable;
};
const $3b1164812973fec3$export$abb7acbfa76bf3c4 = function(mapBrowserEvent) {
    const pointerEvent = mapBrowserEvent.originalEvent;
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return 'pointerId' in pointerEvent && pointerEvent.pointerType == 'mouse';
};
const $3b1164812973fec3$export$e74de664a571d084 = function(mapBrowserEvent) {
    const pointerEvt = mapBrowserEvent.originalEvent;
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return 'pointerId' in pointerEvt && pointerEvt.pointerType === 'touch';
};
const $3b1164812973fec3$export$cd1707283a23f059 = function(mapBrowserEvent) {
    const pointerEvt = mapBrowserEvent.originalEvent;
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return 'pointerId' in pointerEvt && pointerEvt.pointerType === 'pen';
};
const $3b1164812973fec3$export$189f0d593022b199 = function(mapBrowserEvent) {
    const pointerEvent = mapBrowserEvent.originalEvent;
    return 'pointerId' in pointerEvent && pointerEvent.isPrimary && pointerEvent.button === 0;
};



/**
 * @module ol/interaction/Pointer
 */ 

/**
 * @typedef {Object} Options
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleDownEvent]
 * Function handling "down" events. If the function returns `true` then a drag
 * sequence is started.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleDragEvent]
 * Function handling "drag" events. This function is called on "move" events
 * during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleEvent]
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. The function may return `false` to prevent the
 * propagation of the event to other interactions in the map's interactions
 * chain.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleMoveEvent]
 * Function handling "move" events. This function is called on "move" events.
 * This functions is also called during a drag sequence, so during a drag
 * sequence both the `handleDragEvent` function and this function are called.
 * If `handleDownEvent` is defined and it returns true this function will not
 * be called during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleUpEvent]
 *  Function handling "up" events. If the function returns `false` then the
 * current drag sequence is stopped.
 * @property {function(boolean):boolean} [stopDown]
 * Should the down event be propagated to other interactions, or should be
 * stopped?
 */ /**
 * @classdesc
 * Base class that calls user-defined functions on `down`, `move` and `up`
 * events. This class also manages "drag sequences".
 *
 * When the `handleDownEvent` user function returns `true` a drag sequence is
 * started. During a drag sequence the `handleDragEvent` user function is
 * called on `move` events. The drag sequence ends when the `handleUpEvent`
 * user function is called and returns `false`.
 * @api
 */ class $9f944f7feef3a9e2$var$PointerInteraction extends (0, $1cc97d1fb6a71ea7$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super(/** @type {import("./Interaction.js").InteractionOptions} */ options);
        if (options.handleDownEvent) this.handleDownEvent = options.handleDownEvent;
        if (options.handleDragEvent) this.handleDragEvent = options.handleDragEvent;
        if (options.handleMoveEvent) this.handleMoveEvent = options.handleMoveEvent;
        if (options.handleUpEvent) this.handleUpEvent = options.handleUpEvent;
        if (options.stopDown) this.stopDown = options.stopDown;
        /**
     * @type {boolean}
     * @protected
     */ this.handlingDownUpSequence = false;
        /**
     * @type {Array<PointerEvent>}
     * @protected
     */ this.targetPointers = [];
    }
    /**
   * Returns the current number of pointers involved in the interaction,
   * e.g. `2` when two fingers are used.
   * @return {number} The number of pointers.
   * @api
   */ getPointerCount() {
        return this.targetPointers.length;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */ handleDownEvent(mapBrowserEvent) {
        return false;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @protected
   */ handleDragEvent(mapBrowserEvent) {}
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may call into
   * other functions, if event sequences like e.g. 'drag' or 'down-up' etc. are
   * detected.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   * @override
   */ handleEvent(mapBrowserEvent) {
        if (!mapBrowserEvent.originalEvent) return true;
        let stopEvent = false;
        this.updateTrackedPointers_(mapBrowserEvent);
        if (this.handlingDownUpSequence) {
            if (mapBrowserEvent.type == (0, $1daf9bd643ab3fe0$export$2e2bcd8739ae039).POINTERDRAG) {
                this.handleDragEvent(mapBrowserEvent);
                // prevent page scrolling during dragging
                mapBrowserEvent.originalEvent.preventDefault();
            } else if (mapBrowserEvent.type == (0, $1daf9bd643ab3fe0$export$2e2bcd8739ae039).POINTERUP) {
                const handledUp = this.handleUpEvent(mapBrowserEvent);
                this.handlingDownUpSequence = handledUp && this.targetPointers.length > 0;
            }
        } else {
            if (mapBrowserEvent.type == (0, $1daf9bd643ab3fe0$export$2e2bcd8739ae039).POINTERDOWN) {
                const handled = this.handleDownEvent(mapBrowserEvent);
                this.handlingDownUpSequence = handled;
                stopEvent = this.stopDown(handled);
            } else if (mapBrowserEvent.type == (0, $1daf9bd643ab3fe0$export$2e2bcd8739ae039).POINTERMOVE) this.handleMoveEvent(mapBrowserEvent);
        }
        return !stopEvent;
    }
    /**
   * Handle pointer move events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @protected
   */ handleMoveEvent(mapBrowserEvent) {}
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */ handleUpEvent(mapBrowserEvent) {
        return false;
    }
    /**
   * This function is used to determine if "down" events should be propagated
   * to other interactions or should be stopped.
   * @param {boolean} handled Was the event handled by the interaction?
   * @return {boolean} Should the `down` event be stopped?
   */ stopDown(handled) {
        return handled;
    }
    /**
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @private
   */ updateTrackedPointers_(mapBrowserEvent) {
        if (mapBrowserEvent.activePointers) this.targetPointers = mapBrowserEvent.activePointers;
    }
}
function $9f944f7feef3a9e2$export$e2a20c553f6c85ce(pointerEvents) {
    const length = pointerEvents.length;
    let clientX = 0;
    let clientY = 0;
    for(let i = 0; i < length; i++){
        clientX += pointerEvents[i].clientX;
        clientY += pointerEvents[i].clientY;
    }
    return {
        clientX: clientX / length,
        clientY: clientY / length
    };
}
var $9f944f7feef3a9e2$export$2e2bcd8739ae039 = $9f944f7feef3a9e2$var$PointerInteraction;


/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.noModifierKeys} and {@link module:ol/events/condition.primaryAction}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {import("../Kinetic.js").default} [kinetic] Kinetic inertia to apply to the pan.
 */ /**
 * @classdesc
 * Allows the user to pan the map by dragging the map.
 * @api
 */ class $d461b9d6d4543693$var$DragPan extends (0, $9f944f7feef3a9e2$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super({
            stopDown: (0, $7efea016d660e267$export$8f11cee4bdc7e668)
        });
        options = options ? options : {};
        /**
     * @private
     * @type {import("../Kinetic.js").default|undefined}
     */ this.kinetic_ = options.kinetic;
        /**
     * @type {import("../pixel.js").Pixel}
     */ this.lastCentroid = null;
        /**
     * @type {number}
     * @private
     */ this.lastPointersCount_;
        /**
     * @type {boolean}
     * @private
     */ this.panning_ = false;
        const condition = options.condition ? options.condition : (0, $3b1164812973fec3$export$84bf76cd7afc7469)((0, $3b1164812973fec3$export$fdc892d0d8fe3bfb), (0, $3b1164812973fec3$export$189f0d593022b199));
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.onFocusOnly ? (0, $3b1164812973fec3$export$84bf76cd7afc7469)((0, $3b1164812973fec3$export$ae2cdf064e3b0c55), condition) : condition;
        /**
     * @private
     * @type {boolean}
     */ this.noKinetic_ = false;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        const map = mapBrowserEvent.map;
        if (!this.panning_) {
            this.panning_ = true;
            map.getView().beginInteraction();
        }
        const targetPointers = this.targetPointers;
        const centroid = map.getEventPixel((0, $9f944f7feef3a9e2$export$e2a20c553f6c85ce)(targetPointers));
        if (targetPointers.length == this.lastPointersCount_) {
            if (this.kinetic_) this.kinetic_.update(centroid[0], centroid[1]);
            if (this.lastCentroid) {
                const delta = [
                    this.lastCentroid[0] - centroid[0],
                    centroid[1] - this.lastCentroid[1]
                ];
                const map = mapBrowserEvent.map;
                const view = map.getView();
                (0, $6542087bee114e8c$export$dcdf75081b88279d)(delta, view.getResolution());
                (0, $6542087bee114e8c$export$bb628a54ab399bc9)(delta, view.getRotation());
                view.adjustCenterInternal(delta);
            }
        } else if (this.kinetic_) // reset so we don't overestimate the kinetic energy after
        // after one finger down, tiny drag, second finger down
        this.kinetic_.begin();
        this.lastCentroid = centroid;
        this.lastPointersCount_ = targetPointers.length;
        mapBrowserEvent.originalEvent.preventDefault();
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (this.targetPointers.length === 0) {
            if (!this.noKinetic_ && this.kinetic_ && this.kinetic_.end()) {
                const distance = this.kinetic_.getDistance();
                const angle = this.kinetic_.getAngle();
                const center = view.getCenterInternal();
                const centerpx = map.getPixelFromCoordinateInternal(center);
                const dest = map.getCoordinateFromPixelInternal([
                    centerpx[0] - distance * Math.cos(angle),
                    centerpx[1] - distance * Math.sin(angle)
                ]);
                view.animateInternal({
                    center: view.getConstrainedCenter(dest),
                    duration: 500,
                    easing: (0, $6aa29dc5b469ae30$export$57636bb43b1ccbb0)
                });
            }
            if (this.panning_) {
                this.panning_ = false;
                view.endInteraction();
            }
            return false;
        }
        if (this.kinetic_) // reset so we don't overestimate the kinetic energy after
        // after one finger up, tiny drag, second finger up
        this.kinetic_.begin();
        this.lastCentroid = null;
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length > 0 && this.condition_(mapBrowserEvent)) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            this.lastCentroid = null;
            // stop any current animation
            if (view.getAnimating()) view.cancelAnimations();
            if (this.kinetic_) this.kinetic_.begin();
            // No kinetic as soon as more than one pointer on the screen is
            // detected. This is to prevent nasty pans after pinch.
            this.noKinetic_ = this.targetPointers.length > 1;
            return true;
        }
        return false;
    }
}
var $d461b9d6d4543693$export$2e2bcd8739ae039 = $d461b9d6d4543693$var$DragPan;


/**
 * @module ol/interaction/DragRotate
 */ 



/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes a
 * {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.altShiftKeysOnly}.
 * @property {number} [duration=250] Animation duration in milliseconds.
 */ /**
 * @classdesc
 * Allows the user to rotate the map by clicking and dragging on the map,
 * normally combined with a {@link module:ol/events/condition} that limits
 * it to when the alt and shift keys are held down.
 *
 * This interaction is only supported for mouse devices.
 * @api
 */ class $8699d8f1337c9257$var$DragRotate extends (0, $9f944f7feef3a9e2$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super({
            stopDown: (0, $7efea016d660e267$export$8f11cee4bdc7e668)
        });
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $3b1164812973fec3$export$4e5f01653f9f1f82);
        /**
     * @private
     * @type {number|undefined}
     */ this.lastAngle_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        if (!(0, $3b1164812973fec3$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (view.getConstraints().rotation === (0, $8ede94341b226ce7$export$e20fbacbb41798b)) return;
        const size = map.getSize();
        const offset = mapBrowserEvent.pixel;
        const theta = Math.atan2(size[1] / 2 - offset[1], offset[0] - size[0] / 2);
        if (this.lastAngle_ !== undefined) {
            const delta = theta - this.lastAngle_;
            view.adjustRotationInternal(-delta);
        }
        this.lastAngle_ = theta;
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (!(0, $3b1164812973fec3$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return true;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        view.endInteraction(this.duration_);
        return false;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (!(0, $3b1164812973fec3$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return false;
        if ((0, $3b1164812973fec3$export$1238ad6b5e7fff70)(mapBrowserEvent) && this.condition_(mapBrowserEvent)) {
            const map = mapBrowserEvent.map;
            map.getView().beginInteraction();
            this.lastAngle_ = undefined;
            return true;
        }
        return false;
    }
}
var $8699d8f1337c9257$export$2e2bcd8739ae039 = $8699d8f1337c9257$var$DragRotate;


/**
 * @module ol/interaction/DragZoom
 */ 

/**
 * @module ol/interaction/DragBox
 */ // FIXME draw drag box


/**
 * @module ol/render/Box
 */ 

class $0086077a8da83b43$var$RenderBox extends (0, $b54235dad6714a76$export$2e2bcd8739ae039) {
    /**
   * @param {string} className CSS class name.
   */ constructor(className){
        super();
        /**
     * @type {import("../geom/Polygon.js").default}
     * @private
     */ this.geometry_ = null;
        /**
     * @type {HTMLDivElement}
     * @private
     */ this.element_ = document.createElement('div');
        this.element_.style.position = 'absolute';
        this.element_.style.pointerEvents = 'auto';
        this.element_.className = 'ol-box ' + className;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        /**
     * @private
     * @type {import("../pixel.js").Pixel}
     */ this.startPixel_ = null;
        /**
     * @private
     * @type {import("../pixel.js").Pixel}
     */ this.endPixel_ = null;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.setMap(null);
    }
    /**
   * @private
   */ render_() {
        const startPixel = this.startPixel_;
        const endPixel = this.endPixel_;
        const px = 'px';
        const style = this.element_.style;
        style.left = Math.min(startPixel[0], endPixel[0]) + px;
        style.top = Math.min(startPixel[1], endPixel[1]) + px;
        style.width = Math.abs(endPixel[0] - startPixel[0]) + px;
        style.height = Math.abs(endPixel[1] - startPixel[1]) + px;
    }
    /**
   * @param {import("../Map.js").default|null} map Map.
   */ setMap(map) {
        if (this.map_) {
            this.map_.getOverlayContainer().removeChild(this.element_);
            const style = this.element_.style;
            style.left = 'inherit';
            style.top = 'inherit';
            style.width = 'inherit';
            style.height = 'inherit';
        }
        this.map_ = map;
        if (this.map_) this.map_.getOverlayContainer().appendChild(this.element_);
    }
    /**
   * @param {import("../pixel.js").Pixel} startPixel Start pixel.
   * @param {import("../pixel.js").Pixel} endPixel End pixel.
   */ setPixels(startPixel, endPixel) {
        this.startPixel_ = startPixel;
        this.endPixel_ = endPixel;
        this.createOrUpdateGeometry();
        this.render_();
    }
    /**
   * Creates or updates the cached geometry.
   */ createOrUpdateGeometry() {
        if (!this.map_) return;
        const startPixel = this.startPixel_;
        const endPixel = this.endPixel_;
        const pixels = [
            startPixel,
            [
                startPixel[0],
                endPixel[1]
            ],
            endPixel,
            [
                endPixel[0],
                startPixel[1]
            ]
        ];
        const coordinates = pixels.map(this.map_.getCoordinateFromPixelInternal, this.map_);
        // close the polygon
        coordinates[4] = coordinates[0].slice();
        if (!this.geometry_) this.geometry_ = new (0, $5a6d32626ac6e0b9$export$2e2bcd8739ae039)([
            coordinates
        ]);
        else this.geometry_.setCoordinates([
            coordinates
        ]);
    }
    /**
   * @return {import("../geom/Polygon.js").default} Geometry.
   */ getGeometry() {
        return this.geometry_;
    }
}
var $0086077a8da83b43$export$2e2bcd8739ae039 = $0086077a8da83b43$var$RenderBox;



/**
 * A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s and returns a `{boolean}`. If the condition is met,
 * true should be returned.
 * @typedef {function(this: ?, import("../MapBrowserEvent.js").default, import("../pixel.js").Pixel, import("../pixel.js").Pixel):boolean} EndCondition
 */ /**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragbox'] CSS class name for styling the box.
 * @property {import("../events/condition.js").Condition} [condition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link ol/events/condition~mouseActionButton}.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the default
 * `boxEndCondition` function.
 * @property {EndCondition} [boxEndCondition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s to indicate whether a `boxend` event should be fired.
 * Default is `true` if the area of the box is bigger than the `minArea` option.
 * @property {function(this:DragBox, import("../MapBrowserEvent.js").default):void} [onBoxEnd] Code to execute just
 * before `boxend` is fired.
 */ /**
 * @enum {string}
 */ const $6ba7299f161580d3$var$DragBoxEventType = {
    /**
   * Triggered upon drag box start.
   * @event DragBoxEvent#boxstart
   * @api
   */ BOXSTART: 'boxstart',
    /**
   * Triggered on drag when box is active.
   * @event DragBoxEvent#boxdrag
   * @api
   */ BOXDRAG: 'boxdrag',
    /**
   * Triggered upon drag box end.
   * @event DragBoxEvent#boxend
   * @api
   */ BOXEND: 'boxend',
    /**
   * Triggered upon drag box canceled.
   * @event DragBoxEvent#boxcancel
   * @api
   */ BOXCANCEL: 'boxcancel'
};
class $6ba7299f161580d3$export$7053c33c051365ea extends (0, $bc90848f8b15fa29$export$2e2bcd8739ae039) {
    /**
   * @param {string} type The event type.
   * @param {import("../coordinate.js").Coordinate} coordinate The event coordinate.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Originating event.
   */ constructor(type, coordinate, mapBrowserEvent){
        super(type);
        /**
     * The coordinate of the drag event.
     * @const
     * @type {import("../coordinate.js").Coordinate}
     * @api
     */ this.coordinate = coordinate;
        /**
     * @const
     * @type {import("../MapBrowserEvent.js").default}
     * @api
     */ this.mapBrowserEvent = mapBrowserEvent;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable.js").OnSignature<import("../Observable.js").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable.js").OnSignature<import("../ObjectEventType.js").Types|
 *     'change:active', import("../Object.js").ObjectEvent, Return> &
 *   import("../Observable.js").OnSignature<'boxcancel'|'boxdrag'|'boxend'|'boxstart', DragBoxEvent, Return> &
 *   import("../Observable.js").CombinedOnSignature<import("../Observable.js").EventTypes|import("../ObjectEventType.js").Types|
 *     'change:active'|'boxcancel'|'boxdrag'|'boxend', Return>} DragBoxOnSignature
 */ /**
 * @classdesc
 * Allows the user to draw a vector box by clicking and dragging on the map,
 * normally combined with a {@link module:ol/events/condition} that limits
 * it to when the shift or other key is held down. This is used, for example,
 * for zooming to a specific area of the map
 * (see {@link module:ol/interaction/DragZoom~DragZoom} and
 * {@link module:ol/interaction/DragRotateAndZoom~DragRotateAndZoom}).
 *
 * @fires DragBoxEvent
 * @api
 */ class $6ba7299f161580d3$var$DragBox extends (0, $9f944f7feef3a9e2$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        /***
     * @type {DragBoxOnSignature<import("../events.js").EventsKey>}
     */ this.on;
        /***
     * @type {DragBoxOnSignature<import("../events.js").EventsKey>}
     */ this.once;
        /***
     * @type {DragBoxOnSignature<void>}
     */ this.un;
        options = options ?? {};
        /**
     * @type {import("../render/Box.js").default}
     * @private
     */ this.box_ = new (0, $0086077a8da83b43$export$2e2bcd8739ae039)(options.className || 'ol-dragbox');
        /**
     * @type {number}
     * @private
     */ this.minArea_ = options.minArea ?? 64;
        if (options.onBoxEnd) this.onBoxEnd = options.onBoxEnd;
        /**
     * @type {import("../pixel.js").Pixel}
     * @private
     */ this.startPixel_ = null;
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ?? (0, $3b1164812973fec3$export$1238ad6b5e7fff70);
        /**
     * @private
     * @type {EndCondition}
     */ this.boxEndCondition_ = options.boxEndCondition ?? this.defaultBoxEndCondition;
    }
    /**
   * The default condition for determining whether the boxend event
   * should fire.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent The originating MapBrowserEvent
   *     leading to the box end.
   * @param {import("../pixel.js").Pixel} startPixel The starting pixel of the box.
   * @param {import("../pixel.js").Pixel} endPixel The end pixel of the box.
   * @return {boolean} Whether or not the boxend condition should be fired.
   */ defaultBoxEndCondition(mapBrowserEvent, startPixel, endPixel) {
        const width = endPixel[0] - startPixel[0];
        const height = endPixel[1] - startPixel[1];
        return width * width + height * height >= this.minArea_;
    }
    /**
   * Returns geometry of last drawn box.
   * @return {import("../geom/Polygon.js").default} Geometry.
   * @api
   */ getGeometry() {
        return this.box_.getGeometry();
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        if (!this.startPixel_) return;
        this.box_.setPixels(this.startPixel_, mapBrowserEvent.pixel);
        this.dispatchEvent(new $6ba7299f161580d3$export$7053c33c051365ea($6ba7299f161580d3$var$DragBoxEventType.BOXDRAG, mapBrowserEvent.coordinate, mapBrowserEvent));
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (!this.startPixel_) return false;
        const completeBox = this.boxEndCondition_(mapBrowserEvent, this.startPixel_, mapBrowserEvent.pixel);
        if (completeBox) this.onBoxEnd(mapBrowserEvent);
        this.dispatchEvent(new $6ba7299f161580d3$export$7053c33c051365ea(completeBox ? $6ba7299f161580d3$var$DragBoxEventType.BOXEND : $6ba7299f161580d3$var$DragBoxEventType.BOXCANCEL, mapBrowserEvent.coordinate, mapBrowserEvent));
        this.box_.setMap(null);
        this.startPixel_ = null;
        return false;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.condition_(mapBrowserEvent)) {
            this.startPixel_ = mapBrowserEvent.pixel;
            this.box_.setMap(mapBrowserEvent.map);
            this.box_.setPixels(this.startPixel_, this.startPixel_);
            this.dispatchEvent(new $6ba7299f161580d3$export$7053c33c051365ea($6ba7299f161580d3$var$DragBoxEventType.BOXSTART, mapBrowserEvent.coordinate, mapBrowserEvent));
            return true;
        }
        return false;
    }
    /**
   * Function to execute just before `onboxend` is fired
   * @param {import("../MapBrowserEvent.js").default} event Event.
   */ onBoxEnd(event) {}
    /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   * @override
   */ setActive(active) {
        if (!active) {
            this.box_.setMap(null);
            if (this.startPixel_) {
                this.dispatchEvent(new $6ba7299f161580d3$export$7053c33c051365ea($6ba7299f161580d3$var$DragBoxEventType.BOXCANCEL, this.startPixel_, null));
                this.startPixel_ = null;
            }
        }
        super.setActive(active);
    }
    /**
   * @param {import("../Map.js").default|null} map Map.
   * @override
   */ setMap(map) {
        const oldMap = this.getMap();
        if (oldMap) {
            this.box_.setMap(null);
            if (this.startPixel_) {
                this.dispatchEvent(new $6ba7299f161580d3$export$7053c33c051365ea($6ba7299f161580d3$var$DragBoxEventType.BOXCANCEL, this.startPixel_, null));
                this.startPixel_ = null;
            }
        }
        super.setMap(map);
    }
}
var $6ba7299f161580d3$export$2e2bcd8739ae039 = $6ba7299f161580d3$var$DragBox;


/**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragzoom'] CSS class name for styling the
 * box.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.shiftKeyOnly}.
 * @property {number} [duration=200] Animation duration in milliseconds.
 * @property {boolean} [out=false] Use interaction for zooming out.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the parent default
 * `boxEndCondition` function.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by clicking and dragging on the map,
 * normally combined with a {@link module:ol/events/condition} that limits
 * it to when a key, shift by default, is held down.
 *
 * To change the style of the box, use CSS and the `.ol-dragzoom` selector, or
 * your custom one configured with `className`.
 * @api
 */ class $d364de11c66b6b72$var$DragZoom extends (0, $6ba7299f161580d3$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const condition = options.condition ? options.condition : (0, $3b1164812973fec3$export$5d31fe68a477cfbb);
        super({
            condition: condition,
            className: options.className || 'ol-dragzoom',
            minArea: options.minArea
        });
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 200;
        /**
     * @private
     * @type {boolean}
     */ this.out_ = options.out !== undefined ? options.out : false;
    }
    /**
   * Function to execute just before `onboxend` is fired
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @override
   */ onBoxEnd(event) {
        const map = this.getMap();
        const view = /** @type {!import("../View.js").default} */ map.getView();
        let geometry = this.getGeometry();
        if (this.out_) {
            const rotatedExtent = view.rotatedExtentForGeometry(geometry);
            const resolution = view.getResolutionForExtentInternal(rotatedExtent);
            const factor = view.getResolution() / resolution;
            geometry = geometry.clone();
            geometry.scale(factor * factor);
        }
        view.fitInternal(geometry, {
            duration: this.duration_,
            easing: (0, $6aa29dc5b469ae30$export$57636bb43b1ccbb0)
        });
    }
}
var $d364de11c66b6b72$export$2e2bcd8739ae039 = $d364de11c66b6b72$var$DragZoom;


/**
 * @module ol/interaction/KeyboardPan
 */ 

/**
 * @module ol/events/Key
 */ /**
 * @enum {string}
 * @const
 */ var $bae9d917e11085b3$export$2e2bcd8739ae039 = {
    LEFT: 'ArrowLeft',
    UP: 'ArrowUp',
    RIGHT: 'ArrowRight',
    DOWN: 'ArrowDown'
};




/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.noModifierKeys} and
 * {@link module:ol/events/condition.targetNotEditable}.
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {number} [pixelDelta=128] The amount of pixels to pan on each key
 * press.
 */ /**
 * @classdesc
 * Allows the user to pan the map using keyboard arrows.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardZoom~KeyboardZoom}.
 * @api
 */ class $5465559b01244714$var$KeyboardPan extends (0, $1cc97d1fb6a71ea7$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options || {};
        /**
     * @private
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Browser event.
     * @return {boolean} Combined condition result.
     */ this.defaultCondition_ = function(mapBrowserEvent) {
            return (0, $3b1164812973fec3$export$fdc892d0d8fe3bfb)(mapBrowserEvent) && (0, $3b1164812973fec3$export$e5570ca80cd8fd54)(mapBrowserEvent);
        };
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition !== undefined ? options.condition : this.defaultCondition_;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 100;
        /**
     * @private
     * @type {number}
     */ this.pixelDelta_ = options.pixelDelta !== undefined ? options.pixelDelta : 128;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
   * `KeyEvent`, and decides the direction to pan to (if an arrow key was
   * pressed).
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).KEYDOWN) {
            const keyEvent = /** @type {KeyboardEvent} */ mapBrowserEvent.originalEvent;
            const key = keyEvent.key;
            if (this.condition_(mapBrowserEvent) && (key == (0, $bae9d917e11085b3$export$2e2bcd8739ae039).DOWN || key == (0, $bae9d917e11085b3$export$2e2bcd8739ae039).LEFT || key == (0, $bae9d917e11085b3$export$2e2bcd8739ae039).RIGHT || key == (0, $bae9d917e11085b3$export$2e2bcd8739ae039).UP)) {
                const map = mapBrowserEvent.map;
                const view = map.getView();
                const mapUnitsDelta = view.getResolution() * this.pixelDelta_;
                let deltaX = 0, deltaY = 0;
                if (key == (0, $bae9d917e11085b3$export$2e2bcd8739ae039).DOWN) deltaY = -mapUnitsDelta;
                else if (key == (0, $bae9d917e11085b3$export$2e2bcd8739ae039).LEFT) deltaX = -mapUnitsDelta;
                else if (key == (0, $bae9d917e11085b3$export$2e2bcd8739ae039).RIGHT) deltaX = mapUnitsDelta;
                else deltaY = mapUnitsDelta;
                const delta = [
                    deltaX,
                    deltaY
                ];
                (0, $6542087bee114e8c$export$bb628a54ab399bc9)(delta, view.getRotation());
                (0, $1cc97d1fb6a71ea7$export$4c486572e961a974)(view, delta, this.duration_);
                keyEvent.preventDefault();
                stopEvent = true;
            }
        }
        return !stopEvent;
    }
}
var $5465559b01244714$export$2e2bcd8739ae039 = $5465559b01244714$var$KeyboardPan;


/**
 * @module ol/interaction/KeyboardZoom
 */ 


/**
 * @typedef {Object} Options
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. The default condition is
 * that {@link module:ol/events/condition.targetNotEditable} is fulfilled and that
 * the platform modifier key isn't pressed
 * (!{@link module:ol/events/condition.platformModifierKey}).
 * @property {number} [delta=1] The zoom level delta on each key press.
 */ /**
 * @classdesc
 * Allows the user to zoom the map using keyboard + and -.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardPan~KeyboardPan}.
 * @api
 */ class $e162737f8a86ca88$var$KeyboardZoom extends (0, $1cc97d1fb6a71ea7$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options ? options : {};
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : function(mapBrowserEvent) {
            return !(0, $3b1164812973fec3$export$32603ad571dd22b5)(mapBrowserEvent) && (0, $3b1164812973fec3$export$e5570ca80cd8fd54)(mapBrowserEvent);
        };
        /**
     * @private
     * @type {number}
     */ this.delta_ = options.delta ? options.delta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 100;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
   * `KeyEvent`, and decides whether to zoom in or out (depending on whether the
   * key pressed was '+' or '-').
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).KEYDOWN || mapBrowserEvent.type == (0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).KEYPRESS) {
            const keyEvent = /** @type {KeyboardEvent} */ mapBrowserEvent.originalEvent;
            const key = keyEvent.key;
            if (this.condition_(mapBrowserEvent) && (key === '+' || key === '-')) {
                const map = mapBrowserEvent.map;
                const delta = key === '+' ? this.delta_ : -this.delta_;
                const view = map.getView();
                (0, $1cc97d1fb6a71ea7$export$ace321ff2a8016ef)(view, delta, undefined, this.duration_);
                keyEvent.preventDefault();
                stopEvent = true;
            }
        }
        return !stopEvent;
    }
}
var $e162737f8a86ca88$export$2e2bcd8739ae039 = $e162737f8a86ca88$var$KeyboardZoom;


/**
 * @module ol/interaction/MouseWheelZoom
 */ 




/**
 * @typedef {'trackpad' | 'wheel'} Mode
 */ /**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.always}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {number} [maxDelta=1] Maximum mouse wheel delta.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [timeout=80] Mouse wheel timeout duration in milliseconds.
 * @property {boolean} [useAnchor=true] Enable zooming using the mouse's
 * location as the anchor. When set to `false`, zooming in and out will zoom to
 * the center of the screen instead of zooming on the mouse's location.
 * @property {boolean} [constrainResolution=false] If true, the mouse wheel zoom
 * event will always animate to the closest zoom level after an interaction;
 * false means intermediary zoom levels are allowed.
 */ /**
 * Mutliplier for the DOM_DELTA_LINE delta value.
 * @type {number}
 */ const $bfc93873e3c84b3d$var$DELTA_LINE_MULTIPLIER = 40;
/**
 * Mutliplier for the DOM_DELTA_PAGE delta value.
 * @type {number}
 */ const $bfc93873e3c84b3d$var$DELTA_PAGE_MULTIPLIER = 300;
/**
 * Mutliplier for the delta value when using pinch-to-zoom
 * @type {number}
 */ const $bfc93873e3c84b3d$var$DELTA_TRACKPAD_PINCH_TO_ZOOM_MULTIPLIER = 3; // 5 = google maps. 3 = apple maps, MapLibre.
/**
 * @classdesc
 * Allows the user to zoom the map by scrolling the mouse wheel.
 * @api
 */ class $bfc93873e3c84b3d$var$MouseWheelZoom extends (0, $1cc97d1fb6a71ea7$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super(/** @type {import("./Interaction.js").InteractionOptions} */ options);
        /**
     * @private
     * @type {number}
     */ this.totalDelta_ = 0;
        /**
     * @private
     * @type {number}
     */ this.lastDelta_ = 0;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = options.maxDelta !== undefined ? options.maxDelta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
     * @private
     * @type {number}
     */ this.timeout_ = options.timeout !== undefined ? options.timeout : 80;
        /**
     * @private
     * @type {boolean}
     */ this.useAnchor_ = options.useAnchor !== undefined ? options.useAnchor : true;
        /**
     * @private
     * @type {boolean}
     */ this.constrainResolution_ = options.constrainResolution !== undefined ? options.constrainResolution : false;
        const condition = options.condition ? options.condition : (0, $3b1164812973fec3$export$ba9e5d519bc326ca);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.onFocusOnly ? (0, $3b1164812973fec3$export$84bf76cd7afc7469)((0, $3b1164812973fec3$export$ae2cdf064e3b0c55), condition) : condition;
        /**
     * @private
     * @type {?import("../pixel.js").Pixel}
     */ this.lastAnchor_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.startTime_ = undefined;
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.timeoutId_;
        /**
     * @private
     * @type {Mode|undefined}
     */ this.mode_ = undefined;
        /**
     * Trackpad events separated by this delay will be considered separate
     * interactions.
     * @private
     * @type {number}
     */ this.trackpadEventGap_ = 400;
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.trackpadTimeoutId_;
        /**
     * The number of delta values per zoom level
     * @private
     * @type {number}
     */ this.deltaPerZoom_ = 300;
        /**
     * Tracks whether the Ctrl key is physically held down (as opposed to the
     * browser synthesizing ctrlKey=true for pinch-to-zoom trackpad gestures).
     * @private
     * @type {boolean}
     */ this.ctrlKeyPressed_ = false;
        /**
     * @private
     * @type {Array<import('../events.js').EventsKey>}
     */ this.ctrlKeyListenerKeys_ = [];
    }
    /**
   * @param {import('../Map.js').default|null} map Map.
   * @override
   */ setMap(map) {
        this.ctrlKeyListenerKeys_.forEach((0, $8061a5de9380012b$export$b0a21c8b3c1c921));
        this.ctrlKeyListenerKeys_.length = 0;
        this.ctrlKeyPressed_ = false;
        super.setMap(map);
        if (map) {
            const doc = map.getOwnerDocument();
            this.ctrlKeyListenerKeys_.push((0, $8061a5de9380012b$export$63174c828edd6ff8)(doc, 'keydown', (/** @type {KeyboardEvent} */ e)=>{
                if (e.key === 'Control') this.ctrlKeyPressed_ = true;
            }), (0, $8061a5de9380012b$export$63174c828edd6ff8)(doc, 'keyup', (/** @type {KeyboardEvent} */ e)=>{
                if (e.key === 'Control') this.ctrlKeyPressed_ = false;
            }));
        }
    }
    /**
   * @private
   */ endInteraction_() {
        this.trackpadTimeoutId_ = undefined;
        const map = this.getMap();
        if (!map) return;
        const view = map.getView();
        const direction = this.lastDelta_ ? this.lastDelta_ > 0 ? 1 : -1 : 0;
        view.endInteraction(this.constrainResolution_ || view.getConstrainResolution() ? 100 : undefined, direction, this.lastAnchor_ ? map.getCoordinateFromPixel(this.lastAnchor_) : null);
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a mousewheel-event) and eventually
   * zooms the map.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        if (!this.condition_(mapBrowserEvent)) return true;
        const type = mapBrowserEvent.type;
        if (type !== (0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).WHEEL) return true;
        const map = mapBrowserEvent.map;
        const wheelEvent = /** @type {WheelEvent} */ mapBrowserEvent.originalEvent;
        wheelEvent.preventDefault();
        const isPinchToZoom = wheelEvent.ctrlKey && !this.ctrlKeyPressed_;
        if (!wheelEvent.ctrlKey) this.ctrlKeyPressed_ = false;
        if (this.useAnchor_) this.lastAnchor_ = mapBrowserEvent.pixel;
        // Delta normalisation inspired by
        // https://github.com/mapbox/mapbox-gl-js/blob/001c7b9/js/ui/handler/scroll_zoom.js
        let delta = wheelEvent.deltaY;
        switch(wheelEvent.deltaMode){
            case WheelEvent.DOM_DELTA_LINE:
                delta *= $bfc93873e3c84b3d$var$DELTA_LINE_MULTIPLIER;
                break;
            case WheelEvent.DOM_DELTA_PAGE:
                delta *= $bfc93873e3c84b3d$var$DELTA_PAGE_MULTIPLIER;
                break;
            default:
        }
        if (delta === 0) return false;
        this.lastDelta_ = delta;
        const now = Date.now();
        if (this.startTime_ === undefined) this.startTime_ = now;
        if (!this.mode_ || now - this.startTime_ > this.trackpadEventGap_) this.mode_ = Math.abs(delta) < 4 ? 'trackpad' : 'wheel';
        const view = map.getView();
        if (this.mode_ === 'trackpad') {
            if (this.trackpadTimeoutId_) clearTimeout(this.trackpadTimeoutId_);
            else {
                if (view.getAnimating()) view.cancelAnimations();
                view.beginInteraction();
            }
            this.trackpadTimeoutId_ = setTimeout(this.endInteraction_.bind(this), this.timeout_);
            if (isPinchToZoom) delta = delta * $bfc93873e3c84b3d$var$DELTA_TRACKPAD_PINCH_TO_ZOOM_MULTIPLIER;
            view.adjustZoom(-delta / this.deltaPerZoom_, this.lastAnchor_ ? map.getCoordinateFromPixel(this.lastAnchor_) : null);
            this.startTime_ = now;
            return false;
        }
        this.totalDelta_ += delta;
        const timeLeft = Math.max(this.timeout_ - (now - this.startTime_), 0);
        clearTimeout(this.timeoutId_);
        this.timeoutId_ = setTimeout(this.handleWheelZoom_.bind(this, map), timeLeft);
        return false;
    }
    /**
   * @private
   * @param {import("../Map.js").default} map Map.
   */ handleWheelZoom_(map) {
        const view = map.getView();
        if (view.getAnimating()) view.cancelAnimations();
        let delta = -(0, $912ac838ff50d1cd$export$7d15b64cf5a3a4c4)(this.totalDelta_, -this.maxDelta_ * this.deltaPerZoom_, this.maxDelta_ * this.deltaPerZoom_) / this.deltaPerZoom_;
        if (view.getConstrainResolution() || this.constrainResolution_) // view has a zoom constraint, zoom by 1
        delta = delta ? delta > 0 ? 1 : -1 : 0;
        (0, $1cc97d1fb6a71ea7$export$ace321ff2a8016ef)(view, delta, this.lastAnchor_ ? map.getCoordinateFromPixel(this.lastAnchor_) : null, this.duration_);
        this.mode_ = undefined;
        this.totalDelta_ = 0;
        this.lastAnchor_ = null;
        this.startTime_ = undefined;
        this.timeoutId_ = undefined;
    }
    /**
   * Enable or disable using the mouse's location as an anchor when zooming
   * @param {boolean} useAnchor true to zoom to the mouse's location, false
   * to zoom to the center of the map
   * @api
   */ setMouseAnchor(useAnchor) {
        this.useAnchor_ = useAnchor;
        if (!useAnchor) this.lastAnchor_ = null;
    }
}
var $bfc93873e3c84b3d$export$2e2bcd8739ae039 = $bfc93873e3c84b3d$var$MouseWheelZoom;


/**
 * @module ol/interaction/PinchRotate
 */ 


/**
 * @typedef {Object} Options
 * @property {number} [duration=250] The duration of the animation in
 * milliseconds.
 * @property {number} [threshold=0.3] Minimal angle in radians to start a rotation.
 */ /**
 * @classdesc
 * Allows the user to rotate the map by twisting with two fingers
 * on a touch screen.
 * @api
 */ class $d2c43376bbb686dd$var$PinchRotate extends (0, $9f944f7feef3a9e2$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $7efea016d660e267$export$8f11cee4bdc7e668);
        super(pointerOptions);
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */ this.anchor_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.lastAngle_ = undefined;
        /**
     * @private
     * @type {boolean}
     */ this.rotating_ = false;
        /**
     * @private
     * @type {number}
     */ this.rotationDelta_ = 0.0;
        /**
     * @private
     * @type {number}
     */ this.threshold_ = options.threshold !== undefined ? options.threshold : 0.3;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        let rotationDelta = 0.0;
        const touch0 = this.targetPointers[0];
        const touch1 = this.targetPointers[1];
        // angle between touches
        const angle = Math.atan2(touch1.clientY - touch0.clientY, touch1.clientX - touch0.clientX);
        if (this.lastAngle_ !== undefined) {
            const delta = angle - this.lastAngle_;
            this.rotationDelta_ += delta;
            if (!this.rotating_ && Math.abs(this.rotationDelta_) > this.threshold_) this.rotating_ = true;
            rotationDelta = delta;
        }
        this.lastAngle_ = angle;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (view.getConstraints().rotation === (0, $8ede94341b226ce7$export$e20fbacbb41798b)) return;
        // rotate anchor point.
        // FIXME: should be the intersection point between the lines:
        //     touch0,touch1 and previousTouch0,previousTouch1
        this.anchor_ = map.getCoordinateFromPixelInternal(map.getEventPixel((0, $9f944f7feef3a9e2$export$e2a20c553f6c85ce)(this.targetPointers)));
        // rotate
        if (this.rotating_) {
            map.render();
            view.adjustRotationInternal(rotationDelta, this.anchor_);
        }
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (this.targetPointers.length < 2) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            view.endInteraction(this.duration_);
            return false;
        }
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length >= 2) {
            const map = mapBrowserEvent.map;
            this.anchor_ = null;
            this.lastAngle_ = undefined;
            this.rotating_ = false;
            this.rotationDelta_ = 0.0;
            if (!this.handlingDownUpSequence) map.getView().beginInteraction();
            return true;
        }
        return false;
    }
}
var $d2c43376bbb686dd$export$2e2bcd8739ae039 = $d2c43376bbb686dd$var$PinchRotate;


/**
 * @module ol/interaction/PinchZoom
 */ 

/**
 * @typedef {Object} Options
 * @property {number} [duration=400] Animation duration in milliseconds.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by pinching with two fingers
 * on a touch screen.
 * @api
 */ class $7e367c5d979c9a03$var$PinchZoom extends (0, $9f944f7feef3a9e2$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $7efea016d660e267$export$8f11cee4bdc7e668);
        super(pointerOptions);
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */ this.anchor_ = null;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 400;
        /**
     * @private
     * @type {number|undefined}
     */ this.lastDistance_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.lastScaleDelta_ = 1;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        let scaleDelta = 1.0;
        const touch0 = this.targetPointers[0];
        const touch1 = this.targetPointers[1];
        const dx = touch0.clientX - touch1.clientX;
        const dy = touch0.clientY - touch1.clientY;
        // distance between touches
        const distance = Math.sqrt(dx * dx + dy * dy);
        if (this.lastDistance_ !== undefined) scaleDelta = this.lastDistance_ / distance;
        this.lastDistance_ = distance;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (scaleDelta != 1.0) this.lastScaleDelta_ = scaleDelta;
        // scale anchor point.
        this.anchor_ = map.getCoordinateFromPixelInternal(map.getEventPixel((0, $9f944f7feef3a9e2$export$e2a20c553f6c85ce)(this.targetPointers)));
        // scale, bypass the resolution constraint
        map.render();
        view.adjustResolutionInternal(scaleDelta, this.anchor_);
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (this.targetPointers.length < 2) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            const direction = this.lastScaleDelta_ > 1 ? 1 : -1;
            view.endInteraction(this.duration_, direction);
            return false;
        }
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length >= 2) {
            const map = mapBrowserEvent.map;
            this.anchor_ = null;
            this.lastDistance_ = undefined;
            this.lastScaleDelta_ = 1;
            if (!this.handlingDownUpSequence) map.getView().beginInteraction();
            return true;
        }
        return false;
    }
}
var $7e367c5d979c9a03$export$2e2bcd8739ae039 = $7e367c5d979c9a03$var$PinchZoom;


function $eec0d17a56f2f04b$export$ebe90cb607ad99e(options) {
    options = options ? options : {};
    /** @type {Collection<import("./Interaction.js").default>} */ const interactions = new (0, $c6078a5bf4414204$export$2e2bcd8739ae039)();
    const kinetic = new (0, $e63167c26b8f73ba$export$2e2bcd8739ae039)(-0.005, 0.05, 100);
    const altShiftDragRotate = options.altShiftDragRotate !== undefined ? options.altShiftDragRotate : true;
    if (altShiftDragRotate) interactions.push(new (0, $8699d8f1337c9257$export$2e2bcd8739ae039)());
    const doubleClickZoom = options.doubleClickZoom !== undefined ? options.doubleClickZoom : true;
    if (doubleClickZoom) interactions.push(new (0, $e0a862e5bd39c983$export$2e2bcd8739ae039)({
        delta: options.zoomDelta,
        duration: options.zoomDuration
    }));
    const dragPan = options.dragPan !== undefined ? options.dragPan : true;
    if (dragPan) interactions.push(new (0, $d461b9d6d4543693$export$2e2bcd8739ae039)({
        onFocusOnly: options.onFocusOnly,
        kinetic: kinetic
    }));
    const pinchRotate = options.pinchRotate !== undefined ? options.pinchRotate : true;
    if (pinchRotate) interactions.push(new (0, $d2c43376bbb686dd$export$2e2bcd8739ae039)());
    const pinchZoom = options.pinchZoom !== undefined ? options.pinchZoom : true;
    if (pinchZoom) interactions.push(new (0, $7e367c5d979c9a03$export$2e2bcd8739ae039)({
        duration: options.zoomDuration
    }));
    const keyboard = options.keyboard !== undefined ? options.keyboard : true;
    if (keyboard) {
        interactions.push(new (0, $5465559b01244714$export$2e2bcd8739ae039)());
        interactions.push(new (0, $e162737f8a86ca88$export$2e2bcd8739ae039)({
            delta: options.zoomDelta,
            duration: options.zoomDuration
        }));
    }
    const mouseWheelZoom = options.mouseWheelZoom !== undefined ? options.mouseWheelZoom : true;
    if (mouseWheelZoom) interactions.push(new (0, $bfc93873e3c84b3d$export$2e2bcd8739ae039)({
        onFocusOnly: options.onFocusOnly,
        duration: options.zoomDuration
    }));
    const shiftDragZoom = options.shiftDragZoom !== undefined ? options.shiftDragZoom : true;
    if (shiftDragZoom) interactions.push(new (0, $d364de11c66b6b72$export$2e2bcd8739ae039)({
        duration: options.zoomDuration
    }));
    return interactions;
}


/**
 * @module ol/layer/Group
 */ 









/**
 * @module ol/layer/Base
 */ 



/**
 * @module ol/layer/Property
 */ /**
 * @enum {string}
 */ var $7361c3b47198b095$export$2e2bcd8739ae039 = {
    OPACITY: 'opacity',
    VISIBLE: 'visible',
    EXTENT: 'extent',
    Z_INDEX: 'zIndex',
    MAX_RESOLUTION: 'maxResolution',
    MIN_RESOLUTION: 'minResolution',
    MAX_ZOOM: 'maxZoom',
    MIN_ZOOM: 'minZoom',
    SOURCE: 'source',
    MAP: 'map'
};


/**
 * A css color, or a function called with a view resolution returning a css color.
 *
 * @typedef {string|function(number):string} BackgroundColor
 * @api
 */ /**
 * @typedef {import("../ObjectEventType.js").Types|'change:extent'|'change:maxResolution'|'change:maxZoom'|
 *    'change:minResolution'|'change:minZoom'|'change:opacity'|'change:visible'|'change:zIndex'} BaseLayerObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("../Observable.js").OnSignature<import("../Observable.js").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable.js").OnSignature<BaseLayerObjectEventTypes, import("../Object.js").ObjectEvent, Return> &
 *   import("../Observable.js").CombinedOnSignature<import("../Observable.js").EventTypes|BaseLayerObjectEventTypes, Return>} BaseLayerOnSignature
 */ /**
 * @template {Object<string, *>} [Properties=Object<string, *>]
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number | undefined} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {Properties} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Note that with {@link module:ol/layer/Base~BaseLayer} and all its subclasses, any property set in
 * the options is set as a {@link module:ol/Object~BaseObject} property on the layer object, so
 * is observable, and has get/set accessors.
 *
 * @api
 * @template {Object<string, *>} [Properties=Object<string, *>]
 * @extends {BaseObject<NoInfer<Properties> & Object<string, *>>}
 */ class $e4383f9fd67d95d6$var$BaseLayer extends (0, $4dd5119c2f9fa355$export$2e2bcd8739ae039) {
    /**
   * @param {Options<NoInfer<Properties>>} options Layer options.
   */ constructor(options){
        super();
        /***
     * @type {BaseLayerOnSignature<import("../events.js").EventsKey>}
     */ this.on;
        /***
     * @type {BaseLayerOnSignature<import("../events.js").EventsKey>}
     */ this.once;
        /***
     * @type {BaseLayerOnSignature<void>}
     */ this.un;
        /**
     * @type {BackgroundColor|false}
     * @private
     */ this.background_ = options.background;
        /**
     * @type {?}
     */ const properties = Object.assign({}, options);
        if (typeof options.properties === 'object') {
            delete properties.properties;
            Object.assign(properties, options.properties);
        }
        properties[(0, $7361c3b47198b095$export$2e2bcd8739ae039).OPACITY] = options.opacity !== undefined ? options.opacity : 1;
        (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(typeof properties[(0, $7361c3b47198b095$export$2e2bcd8739ae039).OPACITY] === 'number', 'Layer opacity must be a number');
        properties[(0, $7361c3b47198b095$export$2e2bcd8739ae039).VISIBLE] = options.visible !== undefined ? options.visible : true;
        properties[(0, $7361c3b47198b095$export$2e2bcd8739ae039).Z_INDEX] = options.zIndex;
        properties[(0, $7361c3b47198b095$export$2e2bcd8739ae039).MAX_RESOLUTION] = options.maxResolution !== undefined ? options.maxResolution : Infinity;
        properties[(0, $7361c3b47198b095$export$2e2bcd8739ae039).MIN_RESOLUTION] = options.minResolution !== undefined ? options.minResolution : 0;
        properties[(0, $7361c3b47198b095$export$2e2bcd8739ae039).MIN_ZOOM] = options.minZoom !== undefined ? options.minZoom : -Infinity;
        properties[(0, $7361c3b47198b095$export$2e2bcd8739ae039).MAX_ZOOM] = options.maxZoom !== undefined ? options.maxZoom : Infinity;
        /**
     * @type {string}
     * @private
     */ this.className_ = properties.className !== undefined ? properties.className : 'ol-layer';
        delete properties.className;
        this.setProperties(properties);
        /**
     * @type {import("./Layer.js").State}
     * @private
     */ this.state_ = null;
    }
    /**
   * Get the background for this layer.
   * @return {BackgroundColor|false} Layer background.
   */ getBackground() {
        return this.background_;
    }
    /**
   * @return {string} CSS class name.
   */ getClassName() {
        return this.className_;
    }
    /**
   * This method is not meant to be called by layers or layer renderers because the state
   * is incorrect if the layer is included in a layer group.
   *
   * @param {boolean} [managed] Layer is managed.
   * @return {import("./Layer.js").State} Layer state.
   */ getLayerState(managed) {
        /** @type {import("./Layer.js").State} */ const state = this.state_ || /** @type {?} */ {
            layer: this,
            managed: managed === undefined ? true : managed
        };
        const zIndex = this.getZIndex();
        state.opacity = (0, $912ac838ff50d1cd$export$7d15b64cf5a3a4c4)(Math.round(this.getOpacity() * 100) / 100, 0, 1);
        state.visible = this.getVisible();
        state.extent = this.getExtent();
        state.zIndex = zIndex === undefined && !state.managed ? Infinity : zIndex;
        state.maxResolution = this.getMaxResolution();
        state.minResolution = Math.max(this.getMinResolution(), 0);
        state.minZoom = this.getMinZoom();
        state.maxZoom = this.getMaxZoom();
        this.state_ = state;
        return state;
    }
    /**
   * @abstract
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be
   *     modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   */ getLayersArray(array) {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {Array<import("./Layer.js").State>} [states] Optional list of layer
   *     states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   */ getLayerStatesArray(states) {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Return the {@link module:ol/extent~Extent extent} of the layer or `undefined` if it
   * will be visible regardless of extent.
   * @return {import("../extent.js").Extent|undefined} The layer extent.
   * @observable
   * @api
   */ getExtent() {
        return /** @type {import("../extent.js").Extent|undefined} */ this.get((0, $7361c3b47198b095$export$2e2bcd8739ae039).EXTENT);
    }
    /**
   * Return the maximum resolution of the layer. Returns Infinity if
   * the layer has no maximum resolution set.
   * @return {number} The maximum resolution of the layer.
   * @observable
   * @api
   */ getMaxResolution() {
        return /** @type {number} */ this.get((0, $7361c3b47198b095$export$2e2bcd8739ae039).MAX_RESOLUTION);
    }
    /**
   * Return the minimum resolution of the layer. Returns 0 if
   * the layer has no minimum resolution set.
   * @return {number} The minimum resolution of the layer.
   * @observable
   * @api
   */ getMinResolution() {
        return /** @type {number} */ this.get((0, $7361c3b47198b095$export$2e2bcd8739ae039).MIN_RESOLUTION);
    }
    /**
   * Return the minimum zoom level of the layer. Returns -Infinity if
   * the layer has no minimum zoom set.
   * @return {number} The minimum zoom level of the layer.
   * @observable
   * @api
   */ getMinZoom() {
        return /** @type {number} */ this.get((0, $7361c3b47198b095$export$2e2bcd8739ae039).MIN_ZOOM);
    }
    /**
   * Return the maximum zoom level of the layer. Returns Infinity if
   * the layer has no maximum zoom set.
   * @return {number} The maximum zoom level of the layer.
   * @observable
   * @api
   */ getMaxZoom() {
        return /** @type {number} */ this.get((0, $7361c3b47198b095$export$2e2bcd8739ae039).MAX_ZOOM);
    }
    /**
   * Return the opacity of the layer (between 0 and 1).
   * @return {number} The opacity of the layer.
   * @observable
   * @api
   */ getOpacity() {
        return /** @type {number} */ this.get((0, $7361c3b47198b095$export$2e2bcd8739ae039).OPACITY);
    }
    /**
   * @abstract
   * @return {import("../source/Source.js").State} Source state.
   */ getSourceState() {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Return the value of this layer's `visible` property. To find out whether the layer
   * is visible on a map, use `isVisible()` instead.
   * @return {boolean} The value of the `visible` property of the layer.
   * @observable
   * @api
   */ getVisible() {
        return /** @type {boolean} */ this.get((0, $7361c3b47198b095$export$2e2bcd8739ae039).VISIBLE);
    }
    /**
   * Return the Z-index of the layer, which is used to order layers before
   * rendering. Returns undefined if the layer is unmanaged.
   * @return {number|undefined} The Z-index of the layer.
   * @observable
   * @api
   */ getZIndex() {
        return /** @type {number|undefined} */ this.get((0, $7361c3b47198b095$export$2e2bcd8739ae039).Z_INDEX);
    }
    /**
   * Sets the background color.
   * @param {BackgroundColor} [background] Background color.
   */ setBackground(background) {
        this.background_ = background;
        this.changed();
    }
    /**
   * Set the extent at which the layer is visible.  If `undefined`, the layer
   * will be visible at all extents.
   * @param {import("../extent.js").Extent|undefined} extent The extent of the layer.
   * @observable
   * @api
   */ setExtent(extent) {
        this.set((0, $7361c3b47198b095$export$2e2bcd8739ae039).EXTENT, extent);
    }
    /**
   * Set the maximum resolution at which the layer is visible.
   * @param {number} maxResolution The maximum resolution of the layer.
   * @observable
   * @api
   */ setMaxResolution(maxResolution) {
        this.set((0, $7361c3b47198b095$export$2e2bcd8739ae039).MAX_RESOLUTION, maxResolution);
    }
    /**
   * Set the minimum resolution at which the layer is visible.
   * @param {number} minResolution The minimum resolution of the layer.
   * @observable
   * @api
   */ setMinResolution(minResolution) {
        this.set((0, $7361c3b47198b095$export$2e2bcd8739ae039).MIN_RESOLUTION, minResolution);
    }
    /**
   * Set the maximum zoom (exclusive) at which the layer is visible.
   * Note that the zoom levels for layer visibility are based on the
   * view zoom level, which may be different from a tile source zoom level.
   * @param {number} maxZoom The maximum zoom of the layer.
   * @observable
   * @api
   */ setMaxZoom(maxZoom) {
        this.set((0, $7361c3b47198b095$export$2e2bcd8739ae039).MAX_ZOOM, maxZoom);
    }
    /**
   * Set the minimum zoom (inclusive) at which the layer is visible.
   * Note that the zoom levels for layer visibility are based on the
   * view zoom level, which may be different from a tile source zoom level.
   * @param {number} minZoom The minimum zoom of the layer.
   * @observable
   * @api
   */ setMinZoom(minZoom) {
        this.set((0, $7361c3b47198b095$export$2e2bcd8739ae039).MIN_ZOOM, minZoom);
    }
    /**
   * Set the opacity of the layer, allowed values range from 0 to 1.
   * @param {number} opacity The opacity of the layer.
   * @observable
   * @api
   */ setOpacity(opacity) {
        (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(typeof opacity === 'number', 'Layer opacity must be a number');
        this.set((0, $7361c3b47198b095$export$2e2bcd8739ae039).OPACITY, opacity);
    }
    /**
   * Set the visibility of the layer (`true` or `false`).
   * @param {boolean} visible The visibility of the layer.
   * @observable
   * @api
   */ setVisible(visible) {
        this.set((0, $7361c3b47198b095$export$2e2bcd8739ae039).VISIBLE, visible);
    }
    /**
   * Set Z-index of the layer, which is used to order layers before rendering.
   * The default Z-index is 0.
   * @param {number} zindex The z-index of the layer.
   * @observable
   * @api
   */ setZIndex(zindex) {
        this.set((0, $7361c3b47198b095$export$2e2bcd8739ae039).Z_INDEX, zindex);
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.state_) {
            this.state_.layer = null;
            this.state_ = null;
        }
        super.disposeInternal();
    }
}
var $e4383f9fd67d95d6$export$2e2bcd8739ae039 = $e4383f9fd67d95d6$var$BaseLayer;


/**
 * @enum {string}
 */ const $c087d5d4d6aeb943$var$GroupEventType = {
    /**
   * Triggered when a layer is added
   * @event GroupEvent#addlayer
   * @api
   */ ADDLAYER: 'addlayer',
    /**
   * Triggered when a layer is removed
   * @event GroupEvent#removelayer
   * @api
   */ REMOVELAYER: 'removelayer'
};
class $c087d5d4d6aeb943$export$2f5ff21d758d25a7 extends (0, $bc90848f8b15fa29$export$2e2bcd8739ae039) {
    /**
   * @param {GroupEventType} type The event type.
   * @param {BaseLayer} layer The layer.
   */ constructor(type, layer){
        super(type);
        /**
     * The added or removed layer.
     * @type {BaseLayer}
     * @api
     */ this.layer = layer;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable.js").OnSignature<import("../Observable.js").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable.js").OnSignature<import("./Base.js").BaseLayerObjectEventTypes|
 *     'change:layers', import("../Object.js").ObjectEvent, Return> &
 *   import("../Observable.js").OnSignature<'addlayer'|'removelayer', GroupEvent, Return> &
 *   import("../Observable.js").CombinedOnSignature<import("../Observable.js").EventTypes|import("./Base.js").BaseLayerObjectEventTypes|'addlayer'|'removelayer'|'change:layers', Return>} GroupOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {Array<import("./Base.js").default>|Collection<import("./Base.js").default>} [layers] Child layers.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @enum {string}
 * @private
 */ const $c087d5d4d6aeb943$var$Property = {
    LAYERS: 'layers'
};
/**
 * @classdesc
 * A {@link module:ol/Collection~Collection} of layers that are handled together.
 *
 * A generic `change` event is triggered when the group/Collection changes.
 *
 * @fires GroupEvent
 * @api
 */ class $c087d5d4d6aeb943$var$LayerGroup extends (0, $e4383f9fd67d95d6$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Layer options.
   */ constructor(options){
        options = options || {};
        const baseOptions = /** @type {Options} */ Object.assign({}, options);
        delete baseOptions.layers;
        let layers = options.layers;
        super(baseOptions);
        /***
     * @type {GroupOnSignature<import("../events.js").EventsKey>}
     */ this.on;
        /***
     * @type {GroupOnSignature<import("../events.js").EventsKey>}
     */ this.once;
        /***
     * @type {GroupOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {Array<import("../events.js").EventsKey>}
     */ this.layersListenerKeys_ = [];
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").EventsKey>>}
     */ this.listenerKeys_ = {};
        this.addChangeListener($c087d5d4d6aeb943$var$Property.LAYERS, this.handleLayersChanged_);
        if (layers) {
            if (Array.isArray(layers)) layers = new (0, $c6078a5bf4414204$export$2e2bcd8739ae039)(layers.slice(), {
                unique: true
            });
            else (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(typeof /** @type {?} */ layers.getArray === 'function', 'Expected `layers` to be an array or a `Collection`');
        } else layers = new (0, $c6078a5bf4414204$export$2e2bcd8739ae039)(undefined, {
            unique: true
        });
        this.setLayers(layers);
    }
    /**
   * @private
   */ handleLayerChange_() {
        this.changed();
    }
    /**
   * @private
   */ handleLayersChanged_() {
        this.layersListenerKeys_.forEach((0, $8061a5de9380012b$export$b0a21c8b3c1c921));
        this.layersListenerKeys_.length = 0;
        const layers = this.getLayers();
        this.layersListenerKeys_.push((0, $8061a5de9380012b$export$63174c828edd6ff8)(layers, (0, $d4ae00bf358e4687$export$2e2bcd8739ae039).ADD, this.handleLayersAdd_, this), (0, $8061a5de9380012b$export$63174c828edd6ff8)(layers, (0, $d4ae00bf358e4687$export$2e2bcd8739ae039).REMOVE, this.handleLayersRemove_, this));
        for(const id in this.listenerKeys_)this.listenerKeys_[id].forEach((0, $8061a5de9380012b$export$b0a21c8b3c1c921));
        (0, $0669c62275461b52$export$42ffd38884aecdac)(this.listenerKeys_);
        const layersArray = layers.getArray();
        for(let i = 0, ii = layersArray.length; i < ii; i++){
            const layer = layersArray[i];
            this.registerLayerListeners_(layer);
            this.dispatchEvent(new $c087d5d4d6aeb943$export$2f5ff21d758d25a7($c087d5d4d6aeb943$var$GroupEventType.ADDLAYER, layer));
        }
        this.changed();
    }
    /**
   * @param {BaseLayer} layer The layer.
   */ registerLayerListeners_(layer) {
        const listenerKeys = [
            (0, $8061a5de9380012b$export$63174c828edd6ff8)(layer, (0, $026be6c727dde691$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleLayerChange_, this),
            (0, $8061a5de9380012b$export$63174c828edd6ff8)(layer, (0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CHANGE, this.handleLayerChange_, this)
        ];
        if (layer instanceof $c087d5d4d6aeb943$var$LayerGroup) listenerKeys.push((0, $8061a5de9380012b$export$63174c828edd6ff8)(layer, $c087d5d4d6aeb943$var$GroupEventType.ADDLAYER, this.handleLayerGroupAdd_, this), (0, $8061a5de9380012b$export$63174c828edd6ff8)(layer, $c087d5d4d6aeb943$var$GroupEventType.REMOVELAYER, this.handleLayerGroupRemove_, this));
        this.listenerKeys_[(0, $01f1986453243423$export$5e82334337e0f204)(layer)] = listenerKeys;
    }
    /**
   * @param {GroupEvent} event The layer group event.
   */ handleLayerGroupAdd_(event) {
        this.dispatchEvent(new $c087d5d4d6aeb943$export$2f5ff21d758d25a7($c087d5d4d6aeb943$var$GroupEventType.ADDLAYER, event.layer));
    }
    /**
   * @param {GroupEvent} event The layer group event.
   */ handleLayerGroupRemove_(event) {
        this.dispatchEvent(new $c087d5d4d6aeb943$export$2f5ff21d758d25a7($c087d5d4d6aeb943$var$GroupEventType.REMOVELAYER, event.layer));
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<import("./Base.js").default>} collectionEvent CollectionEvent.
   * @private
   */ handleLayersAdd_(collectionEvent) {
        const layer = collectionEvent.element;
        this.registerLayerListeners_(layer);
        this.dispatchEvent(new $c087d5d4d6aeb943$export$2f5ff21d758d25a7($c087d5d4d6aeb943$var$GroupEventType.ADDLAYER, layer));
        this.changed();
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<import("./Base.js").default>} collectionEvent CollectionEvent.
   * @private
   */ handleLayersRemove_(collectionEvent) {
        const layer = collectionEvent.element;
        const key = (0, $01f1986453243423$export$5e82334337e0f204)(layer);
        this.listenerKeys_[key].forEach((0, $8061a5de9380012b$export$b0a21c8b3c1c921));
        delete this.listenerKeys_[key];
        this.dispatchEvent(new $c087d5d4d6aeb943$export$2f5ff21d758d25a7($c087d5d4d6aeb943$var$GroupEventType.REMOVELAYER, layer));
        this.changed();
    }
    /**
   * Returns the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @return {!Collection<import("./Base.js").default>} Collection of
   *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
   * @observable
   * @api
   */ getLayers() {
        return /** @type {!Collection<import("./Base.js").default>} */ this.get($c087d5d4d6aeb943$var$Property.LAYERS);
    }
    /**
   * Set the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @param {!Collection<import("./Base.js").default>} layers Collection of
   *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
   * @observable
   * @api
   */ setLayers(layers) {
        const collection = this.getLayers();
        if (collection) {
            const currentLayers = collection.getArray();
            for(let i = 0, ii = currentLayers.length; i < ii; ++i)this.dispatchEvent(new $c087d5d4d6aeb943$export$2f5ff21d758d25a7($c087d5d4d6aeb943$var$GroupEventType.REMOVELAYER, currentLayers[i]));
        }
        this.set($c087d5d4d6aeb943$var$Property.LAYERS, layers);
    }
    /**
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   * @override
   */ getLayersArray(array) {
        array = array !== undefined ? array : [];
        this.getLayers().forEach(function(layer) {
            layer.getLayersArray(array);
        });
        return array;
    }
    /**
   * Get the layer states list and use this groups z-index as the default
   * for all layers in this and nested groups, if it is unset at this point.
   * If dest is not provided and this group's z-index is undefined
   * 0 is used a the default z-index.
   * @param {Array<import("./Layer.js").State>} [dest] Optional list
   * of layer states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   * @override
   */ getLayerStatesArray(dest) {
        const states = dest !== undefined ? dest : [];
        const pos = states.length;
        this.getLayers().forEach(function(layer) {
            layer.getLayerStatesArray(states);
        });
        const ownLayerState = this.getLayerState();
        let defaultZIndex = ownLayerState.zIndex;
        if (!dest && ownLayerState.zIndex === undefined) defaultZIndex = 0;
        for(let i = pos, ii = states.length; i < ii; i++){
            const layerState = states[i];
            layerState.opacity *= ownLayerState.opacity;
            layerState.visible = layerState.visible && ownLayerState.visible;
            layerState.maxResolution = Math.min(layerState.maxResolution, ownLayerState.maxResolution);
            layerState.minResolution = Math.max(layerState.minResolution, ownLayerState.minResolution);
            layerState.minZoom = Math.max(layerState.minZoom, ownLayerState.minZoom);
            layerState.maxZoom = Math.min(layerState.maxZoom, ownLayerState.maxZoom);
            if (ownLayerState.extent !== undefined) {
                if (layerState.extent !== undefined) layerState.extent = (0, $3412ad7bd362b04c$export$72209efa88586d42)(layerState.extent, ownLayerState.extent);
                else layerState.extent = ownLayerState.extent;
            }
            if (layerState.zIndex === undefined) layerState.zIndex = defaultZIndex;
        }
        return states;
    }
    /**
   * @return {import("../source/Source.js").State} Source state.
   * @override
   */ getSourceState() {
        return 'ready';
    }
}
var $c087d5d4d6aeb943$export$2e2bcd8739ae039 = $c087d5d4d6aeb943$var$LayerGroup;


/**
 * @module ol/layer/Layer
 */ 




/**
 * @module ol/render/EventType
 */ /**
 * @enum {string}
 */ var $97affab8a58f0c97$export$2e2bcd8739ae039 /**
 * @typedef {'postrender'|'precompose'|'postcompose'|'rendercomplete'} MapRenderEventTypes
 */  /**
 * @typedef {'postrender'|'prerender'} LayerRenderEventTypes
 */  = {
    /**
   * Triggered before a layer is rendered.
   * @event module:ol/render/Event~RenderEvent#prerender
   * @api
   */ PRERENDER: 'prerender',
    /**
   * Triggered after a layer is rendered.
   * @event module:ol/render/Event~RenderEvent#postrender
   * @api
   */ POSTRENDER: 'postrender',
    /**
   * Triggered before layers are composed.  When dispatched by the map, the event object will not have
   * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
   * WebGL layers currently dispatch this event.
   * @event module:ol/render/Event~RenderEvent#precompose
   * @api
   */ PRECOMPOSE: 'precompose',
    /**
   * Triggered after layers are composed.  When dispatched by the map, the event object will not have
   * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
   * WebGL layers currently dispatch this event.
   * @event module:ol/render/Event~RenderEvent#postcompose
   * @api
   */ POSTCOMPOSE: 'postcompose',
    /**
   * Triggered when rendering is complete, i.e. all sources and tiles have
   * finished loading for the current viewport, and all tiles are faded in.
   * The event object will not have a `context` set.
   * @event module:ol/render/Event~RenderEvent#rendercomplete
   * @api
   */ RENDERCOMPLETE: 'rendercomplete'
};




/**
 * @typedef {function(import("../Map.js").FrameState):HTMLElement} RenderFunction
 */ /**
 * @typedef {'sourceready'|'change:source'} LayerEventType
 */ /***
 * @template Return
 * @typedef {import("../Observable.js").OnSignature<import("../Observable.js").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable.js").OnSignature<import("./Base.js").BaseLayerObjectEventTypes|
 *     LayerEventType, import("../Object.js").ObjectEvent, Return> &
 *   import("../Observable.js").OnSignature<import("../render/EventType.js").LayerRenderEventTypes, import("../render/Event.js").default, Return> &
 *   import("../Observable.js").CombinedOnSignature<import("../Observable.js").EventTypes|import("./Base.js").BaseLayerObjectEventTypes|LayerEventType|
 *     import("../render/EventType.js").LayerRenderEventTypes, Return>} LayerOnSignature
 */ /**
 * @template {import("../source/Source.js").default} [SourceType=import("../source/Source.js").default]
 * @template {Object<string, *>} [Properties=Object<string, *>]
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {SourceType} [source] Source for this layer.  If not provided to the constructor,
 * the source can be set by calling {@link module:ol/layer/Layer~Layer#setSource layer.setSource(source)} after
 * construction.
 * @property {import("../Map.js").default|null} [map] Map.
 * @property {RenderFunction} [render] Render function. Takes the frame state as input and is expected to return an
 * HTML element. Will overwrite the default rendering for the layer.
 * @property {Properties} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @typedef {Object} State
 * @property {import("./Layer.js").default} layer Layer.
 * @property {number} opacity Opacity, the value is rounded to two digits to appear after the decimal point.
 * @property {boolean} visible Visible.
 * @property {boolean} managed Managed.
 * @property {import("../extent.js").Extent} [extent] Extent.
 * @property {number} zIndex ZIndex.
 * @property {number} maxResolution Maximum resolution.
 * @property {number} minResolution Minimum resolution.
 * @property {number} minZoom Minimum zoom.
 * @property {number} maxZoom Maximum zoom.
 */ /**
 * @classdesc
 * Base class from which all layer types are derived. This should only be instantiated
 * in the case where a custom layer is added to the map with a custom `render` function.
 * Such a function can be specified in the `options` object, and is expected to return an HTML element.
 *
 * A visual representation of raster or vector map data.
 * Layers group together those properties that pertain to how the data is to be
 * displayed, irrespective of the source of that data.
 *
 * Layers are usually added to a map with [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * Components like {@link module:ol/interaction/Draw~Draw} use unmanaged layers
 * internally. These unmanaged layers are associated with the map using
 * [layer.setMap()]{@link module:ol/layer/Layer~Layer#setMap} instead.
 *
 * A generic `change` event is fired when the state of the source changes.
 * A `sourceready` event is fired when the layer's source is ready.
 *
 * @fires import("../render/Event.js").RenderEvent#prerender
 * @fires import("../render/Event.js").RenderEvent#postrender
 * @fires import("../events/Event.js").BaseEvent#sourceready
 *
 * @template {import("../source/Source.js").default} [SourceType=import("../source/Source.js").default]
 * @template {import("../renderer/Layer.js").default} [RendererType=import("../renderer/Layer.js").default]
 * @template {Object<string, *>} [Properties=Object<string, *>]
 * @extends {BaseLayer<NoInfer<Properties>>}
 * @api
 */ class $7bdbe21729fecf84$var$Layer extends (0, $e4383f9fd67d95d6$export$2e2bcd8739ae039) {
    /**
   * @param {Options<SourceType, NoInfer<Properties>>} options Layer options.
   */ constructor(options){
        const baseOptions = Object.assign({}, options);
        delete baseOptions.source;
        super(baseOptions);
        /***
     * @type {LayerOnSignature<import("../events.js").EventsKey>}
     */ this.on;
        /***
     * @type {LayerOnSignature<import("../events.js").EventsKey>}
     */ this.once;
        /***
     * @type {LayerOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.mapPrecomposeKey_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.mapRenderKey_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.sourceChangeKey_ = null;
        /**
     * @private
     * @type {RendererType}
     */ this.renderer_ = null;
        /**
     * @private
     * @type {boolean}
     */ this.sourceReady_ = false;
        /**
     * @protected
     * @type {boolean}
     */ this.rendered = false;
        // Overwrite default render method with a custom one
        if (options.render) this.render = options.render;
        if (options.map) this.setMap(options.map);
        this.addChangeListener((0, $7361c3b47198b095$export$2e2bcd8739ae039).SOURCE, this.handleSourcePropertyChange_);
        const source = options.source ? /** @type {SourceType} */ options.source : null;
        this.setSource(source);
    }
    /**
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   * @override
   */ getLayersArray(array) {
        array = array ? array : [];
        array.push(this);
        return array;
    }
    /**
   * @param {Array<import("./Layer.js").State>} [states] Optional list of layer states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   * @override
   */ getLayerStatesArray(states) {
        states = states ? states : [];
        states.push(this.getLayerState());
        return states;
    }
    /**
   * Get the layer source.
   * @return {SourceType|null} The layer source (or `null` if not yet set).
   * @observable
   * @api
   */ getSource() {
        return /** @type {SourceType} */ this.get((0, $7361c3b47198b095$export$2e2bcd8739ae039).SOURCE) || null;
    }
    /**
   * @return {SourceType|null} The source being rendered.
   */ getRenderSource() {
        return this.getSource();
    }
    /**
   * @return {import("../source/Source.js").State} Source state.
   * @override
   */ getSourceState() {
        const source = this.getSource();
        return !source ? 'undefined' : source.getState();
    }
    /**
   * @private
   */ handleSourceChange_() {
        this.changed();
        if (this.sourceReady_ || this.getSource().getState() !== 'ready') return;
        this.sourceReady_ = true;
        this.dispatchEvent('sourceready');
    }
    /**
   * @private
   */ handleSourcePropertyChange_() {
        if (this.sourceChangeKey_) {
            (0, $8061a5de9380012b$export$b0a21c8b3c1c921)(this.sourceChangeKey_);
            this.sourceChangeKey_ = null;
        }
        this.sourceReady_ = false;
        const source = this.getSource();
        if (source) {
            this.sourceChangeKey_ = (0, $8061a5de9380012b$export$63174c828edd6ff8)(source, (0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CHANGE, this.handleSourceChange_, this);
            if (source.getState() === 'ready') {
                this.sourceReady_ = true;
                setTimeout(()=>{
                    this.dispatchEvent('sourceready');
                }, 0);
            }
        }
        this.changed();
    }
    /**
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature.js").FeatureLike>>} Promise that resolves with
   * an array of features.
   */ getFeatures(pixel) {
        if (!this.renderer_) return Promise.resolve([]);
        return this.renderer_.getFeatures(pixel);
    }
    /**
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   */ getData(pixel) {
        if (!this.renderer_ || !this.rendered) return null;
        return this.renderer_.getData(pixel);
    }
    /**
   * The layer is visible on the map view, i.e. within its min/max resolution or zoom and
   * extent, not set to `visible: false`, and not inside a layer group that is set
   * to `visible: false`.
   * @param {View|import("../View.js").ViewStateLayerStateExtent} [view] View or {@link import("../Map.js").FrameState}.
   * Only required when the layer is not added to a map.
   * @return {boolean} The layer is visible in the map view.
   * @api
   */ isVisible(view) {
        let frameState;
        const map = this.getMapInternal();
        if (!view && map) view = map.getView();
        if (view instanceof (0, $0ab5c72f1ca22f62$export$2e2bcd8739ae039)) frameState = {
            viewState: view.getState(),
            extent: view.calculateExtent()
        };
        else frameState = view;
        if (!frameState.layerStatesArray && map) frameState.layerStatesArray = map.getLayerGroup().getLayerStatesArray();
        let layerState;
        if (frameState.layerStatesArray) {
            layerState = frameState.layerStatesArray.find((layerState)=>layerState.layer === this);
            if (!layerState) return false;
        } else layerState = this.getLayerState();
        const layerExtent = this.getExtent();
        return $7bdbe21729fecf84$export$acb1e9cb9ce4ca56(layerState, frameState.viewState) && (!layerExtent || (0, $3412ad7bd362b04c$export$7b0a31e10bbff018)(layerExtent, frameState.extent));
    }
    /**
   * Get the attributions of the source of this layer for the given view.
   * @param {View|import("../View.js").ViewStateLayerStateExtent} [view] View or {@link import("../Map.js").FrameState}.
   * Only required when the layer is not added to a map.
   * @return {Array<string>} Attributions for this layer at the given view.
   * @api
   */ getAttributions(view) {
        if (!this.isVisible(view)) return [];
        const getAttributions = this.getSource()?.getAttributions();
        if (!getAttributions) return [];
        const frameState = view instanceof (0, $0ab5c72f1ca22f62$export$2e2bcd8739ae039) ? view.getViewStateAndExtent() : view;
        let attributions = getAttributions(frameState);
        if (!Array.isArray(attributions)) attributions = [
            attributions
        ];
        return attributions;
    }
    /**
   * In charge to manage the rendering of the layer. One layer type is
   * bounded with one layer renderer.
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target which the renderer may (but need not) use
   * for rendering its content.
   * @return {HTMLElement|null} The rendered element.
   */ render(frameState, target) {
        const layerRenderer = this.getRenderer();
        if (layerRenderer.prepareFrame(frameState)) {
            this.rendered = true;
            return layerRenderer.renderFrame(frameState, target);
        }
        return null;
    }
    /**
   * Called when a layer is not visible during a map render.
   */ unrender() {
        this.rendered = false;
    }
    /** @return {string} Declutter */ getDeclutter() {
        return undefined;
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {import("../layer/Layer.js").State} layerState Layer state.
   */ renderDeclutter(frameState, layerState) {}
    /**
   * When the renderer follows a layout -> render approach, do the final rendering here.
   * @param {import('../Map.js').FrameState} frameState Frame state
   */ renderDeferred(frameState) {
        const layerRenderer = this.getRenderer();
        if (!layerRenderer) return;
        layerRenderer.renderDeferred(frameState);
    }
    /**
   * For use inside the library only.
   * @param {import("../Map.js").default|null} map Map.
   */ setMapInternal(map) {
        if (!map) this.unrender();
        this.set((0, $7361c3b47198b095$export$2e2bcd8739ae039).MAP, map);
    }
    /**
   * For use inside the library only.
   * @return {import("../Map.js").default|null} Map.
   */ getMapInternal() {
        return this.get((0, $7361c3b47198b095$export$2e2bcd8739ae039).MAP);
    }
    /**
   * Sets the layer to be rendered on top of other layers on a map. The map will
   * not manage this layer in its layers collection. This
   * is useful for temporary layers. To remove an unmanaged layer from the map,
   * use `#setMap(null)`.
   *
   * To add the layer to a map and have it managed by the map, use
   * {@link module:ol/Map~Map#addLayer} instead.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */ setMap(map) {
        if (this.mapPrecomposeKey_) {
            (0, $8061a5de9380012b$export$b0a21c8b3c1c921)(this.mapPrecomposeKey_);
            this.mapPrecomposeKey_ = null;
        }
        if (!map) this.changed();
        if (this.mapRenderKey_) {
            (0, $8061a5de9380012b$export$b0a21c8b3c1c921)(this.mapRenderKey_);
            this.mapRenderKey_ = null;
        }
        if (map) {
            this.mapPrecomposeKey_ = (0, $8061a5de9380012b$export$63174c828edd6ff8)(map, (0, $97affab8a58f0c97$export$2e2bcd8739ae039).PRECOMPOSE, this.handlePrecompose_, this);
            this.mapRenderKey_ = (0, $8061a5de9380012b$export$63174c828edd6ff8)(this, (0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CHANGE, map.render, map);
            this.changed();
        }
    }
    /**
   * @param {import("../events/Event.js").default} renderEvent Render event
   * @private
   */ handlePrecompose_(renderEvent) {
        const layerStatesArray = /** @type {import("../render/Event.js").default} */ renderEvent.frameState.layerStatesArray;
        const layerState = this.getLayerState(false);
        (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(!layerStatesArray.some((arrayLayerState)=>arrayLayerState.layer === layerState.layer), 'A layer can only be added to the map once. Use either `layer.setMap()` or `map.addLayer()`, not both.');
        layerStatesArray.push(layerState);
    }
    /**
   * Set the layer source.
   * @param {SourceType|null} source The layer source.
   * @observable
   * @api
   */ setSource(source) {
        this.set((0, $7361c3b47198b095$export$2e2bcd8739ae039).SOURCE, source);
    }
    /**
   * Get the renderer for this layer.
   * @return {RendererType|null} The layer renderer.
   */ getRenderer() {
        if (!this.renderer_) this.renderer_ = this.createRenderer();
        return this.renderer_;
    }
    /**
   * @return {boolean} The layer has a renderer.
   */ hasRenderer() {
        return !!this.renderer_;
    }
    /**
   * Create a renderer for this layer.
   * @return {RendererType} A layer renderer.
   * @protected
   */ createRenderer() {
        return null;
    }
    /**
   * This will clear the renderer so that a new one can be created next time it is needed
   */ clearRenderer() {
        if (this.renderer_) {
            this.renderer_.dispose();
            delete this.renderer_;
        }
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.clearRenderer();
        this.setSource(null);
        super.disposeInternal();
    }
}
function $7bdbe21729fecf84$export$acb1e9cb9ce4ca56(layerState, viewState) {
    if (!layerState.visible) return false;
    const resolution = viewState.resolution;
    if (resolution < layerState.minResolution || resolution >= layerState.maxResolution) return false;
    const zoom = viewState.zoom;
    return zoom > layerState.minZoom && zoom <= layerState.maxZoom;
}
var $7bdbe21729fecf84$export$2e2bcd8739ae039 = $7bdbe21729fecf84$var$Layer;





/**
 * @module ol/renderer/Composite
 */ 




/**
 * @module ol/layer/BaseVector
 */ var $d767c9267f21fd9e$exports = {};
!function(t, i) {
    $d767c9267f21fd9e$exports = i();
}($d767c9267f21fd9e$exports, function() {
    "use strict";
    function t(e, h, r = 0, s = e.length - 1, a = n) {
        for(; s > r;){
            if (s - r > 600) {
                const i = s - r + 1, n = h - r + 1, o = Math.log(i), l = .5 * Math.exp(2 * o / 3), c = .5 * Math.sqrt(o * l * (i - l) / i) * (n - i / 2 < 0 ? -1 : 1);
                t(e, h, Math.max(r, Math.floor(h - n * l / i + c)), Math.min(s, Math.floor(h + (i - n) * l / i + c)), a);
            }
            const n = e[h];
            let o = r, l = s;
            for(i(e, r, h), a(e[s], n) > 0 && i(e, r, s); o < l;){
                for(i(e, o, l), o++, l--; a(e[o], n) < 0;)o++;
                for(; a(e[l], n) > 0;)l--;
            }
            0 === a(e[r], n) ? i(e, r, l) : (l++, i(e, l, s)), l <= h && (r = l + 1), h <= l && (s = l - 1);
        }
    }
    function i(t, i, n) {
        const e = t[i];
        t[i] = t[n], t[n] = e;
    }
    function n(t, i) {
        return t < i ? -1 : t > i ? 1 : 0;
    }
    function e(t, i, n) {
        if (!n) return i.indexOf(t);
        for(let e = 0; e < i.length; e++)if (n(t, i[e])) return e;
        return -1;
    }
    function h(t, i) {
        r(t, 0, t.children.length, i, t);
    }
    function r(t, i, n, e, h) {
        h || (h = d(null)), h.minX = 1 / 0, h.minY = 1 / 0, h.maxX = -1 / 0, h.maxY = -1 / 0;
        for(let r = i; r < n; r++){
            const i = t.children[r];
            s(h, t.leaf ? e(i) : i);
        }
        return h;
    }
    function s(t, i) {
        return t.minX = Math.min(t.minX, i.minX), t.minY = Math.min(t.minY, i.minY), t.maxX = Math.max(t.maxX, i.maxX), t.maxY = Math.max(t.maxY, i.maxY), t;
    }
    function a(t, i) {
        return t.minX - i.minX;
    }
    function o(t, i) {
        return t.minY - i.minY;
    }
    function l(t) {
        return (t.maxX - t.minX) * (t.maxY - t.minY);
    }
    function c(t) {
        return t.maxX - t.minX + (t.maxY - t.minY);
    }
    function m(t, i) {
        const n = Math.max(t.minX, i.minX), e = Math.max(t.minY, i.minY), h = Math.min(t.maxX, i.maxX), r = Math.min(t.maxY, i.maxY);
        return Math.max(0, h - n) * Math.max(0, r - e);
    }
    function f(t, i) {
        return t.minX <= i.minX && t.minY <= i.minY && i.maxX <= t.maxX && i.maxY <= t.maxY;
    }
    function u(t, i) {
        return i.minX <= t.maxX && i.minY <= t.maxY && i.maxX >= t.minX && i.maxY >= t.minY;
    }
    function d(t) {
        return {
            children: t,
            height: 1,
            leaf: !0,
            minX: 1 / 0,
            minY: 1 / 0,
            maxX: -1 / 0,
            maxY: -1 / 0
        };
    }
    function x(i, n, e, h, r) {
        const s = [
            n,
            e
        ];
        for(; s.length;){
            if ((e = s.pop()) - (n = s.pop()) <= h) continue;
            const a = n + Math.ceil((e - n) / h / 2) * h;
            t(i, a, n, e, r), s.push(n, a, a, e);
        }
    }
    return class {
        constructor(t = 9){
            this._maxEntries = Math.max(4, t), this._minEntries = Math.max(2, Math.ceil(.4 * this._maxEntries)), this.clear();
        }
        all() {
            return this._all(this.data, []);
        }
        search(t) {
            let i = this.data;
            const n = [];
            if (!u(t, i)) return n;
            const e = this.toBBox, h = [];
            for(; i;){
                for(let r = 0; r < i.children.length; r++){
                    const s = i.children[r], a = i.leaf ? e(s) : s;
                    u(t, a) && (i.leaf ? n.push(s) : f(t, a) ? this._all(s, n) : h.push(s));
                }
                i = h.pop();
            }
            return n;
        }
        collides(t) {
            let i = this.data;
            if (!u(t, i)) return !1;
            const n = [];
            for(; i;){
                for(let e = 0; e < i.children.length; e++){
                    const h = i.children[e], r = i.leaf ? this.toBBox(h) : h;
                    if (u(t, r)) {
                        if (i.leaf || f(t, r)) return !0;
                        n.push(h);
                    }
                }
                i = n.pop();
            }
            return !1;
        }
        load(t) {
            if (!t || !t.length) return this;
            if (t.length < this._minEntries) {
                for(let i = 0; i < t.length; i++)this.insert(t[i]);
                return this;
            }
            let i = this._build(t.slice(), 0, t.length - 1, 0);
            if (this.data.children.length) {
                if (this.data.height === i.height) this._splitRoot(this.data, i);
                else {
                    if (this.data.height < i.height) {
                        const t = this.data;
                        this.data = i, i = t;
                    }
                    this._insert(i, this.data.height - i.height - 1, !0);
                }
            } else this.data = i;
            return this;
        }
        insert(t) {
            return t && this._insert(t, this.data.height - 1), this;
        }
        clear() {
            return this.data = d([]), this;
        }
        remove(t, i) {
            if (!t) return this;
            let n = this.data;
            const h = this.toBBox(t), r = [], s = [];
            let a, o, l;
            for(; n || r.length;){
                if (n || (n = r.pop(), o = r[r.length - 1], a = s.pop(), l = !0), n.leaf) {
                    const h = e(t, n.children, i);
                    if (-1 !== h) return n.children.splice(h, 1), r.push(n), this._condense(r), this;
                }
                l || n.leaf || !f(n, h) ? o ? (a++, n = o.children[a], l = !1) : n = null : (r.push(n), s.push(a), a = 0, o = n, n = n.children[0]);
            }
            return this;
        }
        toBBox(t) {
            return t;
        }
        compareMinX(t, i) {
            return t.minX - i.minX;
        }
        compareMinY(t, i) {
            return t.minY - i.minY;
        }
        toJSON() {
            return this.data;
        }
        fromJSON(t) {
            return this.data = t, this;
        }
        _all(t, i) {
            const n = [];
            for(; t;)t.leaf ? i.push(...t.children) : n.push(...t.children), t = n.pop();
            return i;
        }
        _build(t, i, n, e) {
            const r = n - i + 1;
            let s, a = this._maxEntries;
            if (r <= a) return s = d(t.slice(i, n + 1)), h(s, this.toBBox), s;
            e || (e = Math.ceil(Math.log(r) / Math.log(a)), a = Math.ceil(r / Math.pow(a, e - 1))), s = d([]), s.leaf = !1, s.height = e;
            const o = Math.ceil(r / a), l = o * Math.ceil(Math.sqrt(a));
            x(t, i, n, l, this.compareMinX);
            for(let h = i; h <= n; h += l){
                const i = Math.min(h + l - 1, n);
                x(t, h, i, o, this.compareMinY);
                for(let n = h; n <= i; n += o){
                    const h = Math.min(n + o - 1, i);
                    s.children.push(this._build(t, n, h, e - 1));
                }
            }
            return h(s, this.toBBox), s;
        }
        _chooseSubtree(t, i, n, e) {
            for(; e.push(i), !i.leaf && e.length - 1 !== n;){
                let n, e = 1 / 0, s = 1 / 0;
                for(let a = 0; a < i.children.length; a++){
                    const o = i.children[a], c = l(o), m = (h = t, r = o, (Math.max(r.maxX, h.maxX) - Math.min(r.minX, h.minX)) * (Math.max(r.maxY, h.maxY) - Math.min(r.minY, h.minY)) - c);
                    m < s ? (s = m, e = c < e ? c : e, n = o) : m === s && c < e && (e = c, n = o);
                }
                i = n || i.children[0];
            }
            var h, r;
            return i;
        }
        _insert(t, i, n) {
            const e = n ? t : this.toBBox(t), h = [], r = this._chooseSubtree(e, this.data, i, h);
            for(r.children.push(t), s(r, e); i >= 0 && h[i].children.length > this._maxEntries;)this._split(h, i), i--;
            this._adjustParentBBoxes(e, h, i);
        }
        _split(t, i) {
            const n = t[i], e = n.children.length, r = this._minEntries;
            this._chooseSplitAxis(n, r, e);
            const s = this._chooseSplitIndex(n, r, e), a = d(n.children.splice(s, n.children.length - s));
            a.height = n.height, a.leaf = n.leaf, h(n, this.toBBox), h(a, this.toBBox), i ? t[i - 1].children.push(a) : this._splitRoot(n, a);
        }
        _splitRoot(t, i) {
            this.data = d([
                t,
                i
            ]), this.data.height = t.height + 1, this.data.leaf = !1, h(this.data, this.toBBox);
        }
        _chooseSplitIndex(t, i, n) {
            let e, h = 1 / 0, s = 1 / 0;
            for(let a = i; a <= n - i; a++){
                const i = r(t, 0, a, this.toBBox), o = r(t, a, n, this.toBBox), c = m(i, o), f = l(i) + l(o);
                c < h ? (h = c, e = a, s = f < s ? f : s) : c === h && f < s && (s = f, e = a);
            }
            return e || n - i;
        }
        _chooseSplitAxis(t, i, n) {
            const e = t.leaf ? this.compareMinX : a, h = t.leaf ? this.compareMinY : o;
            this._allDistMargin(t, i, n, e) < this._allDistMargin(t, i, n, h) && t.children.sort(e);
        }
        _allDistMargin(t, i, n, e) {
            t.children.sort(e);
            const h = this.toBBox, a = r(t, 0, i, h), o = r(t, n - i, n, h);
            let l = c(a) + c(o);
            for(let e = i; e < n - i; e++){
                const i = t.children[e];
                s(a, t.leaf ? h(i) : i), l += c(a);
            }
            for(let e = n - i - 1; e >= i; e--){
                const i = t.children[e];
                s(o, t.leaf ? h(i) : i), l += c(o);
            }
            return l;
        }
        _adjustParentBBoxes(t, i, n) {
            for(let e = n; e >= 0; e--)s(i[e], t);
        }
        _condense(t) {
            for(let i, n = t.length - 1; n >= 0; n--)0 === t[n].children.length ? n > 0 ? (i = t[n - 1].children, i.splice(i.indexOf(t[n]), 1)) : this.clear() : h(t[n], this.toBBox);
        }
    };
});


/**
 * @module ol/render/canvas/style
 */ /**
 * @module ol/color
 */ 

const $6c864c0c7b61b9b5$export$6c844c64a5efe1ee = [
    NaN,
    NaN,
    NaN,
    0
];
let $6c864c0c7b61b9b5$var$colorParseContext;
/**
 * @return {CanvasRenderingContext2D} The color parse context
 */ function $6c864c0c7b61b9b5$var$getColorParseContext() {
    if (!$6c864c0c7b61b9b5$var$colorParseContext) $6c864c0c7b61b9b5$var$colorParseContext = (0, $5ce605ba3ee034a0$export$9e05d10eae75c464)(1, 1, undefined, {
        willReadFrequently: true,
        desynchronized: true
    });
    return $6c864c0c7b61b9b5$var$colorParseContext;
}
const $6c864c0c7b61b9b5$var$rgbModernRegEx = /^rgba?\(\s*(\d+%?)\s+(\d+%?)\s+(\d+%?)(?:\s*\/\s*(\d+%|\d*\.\d+|[01]))?\s*\)$/i;
const $6c864c0c7b61b9b5$var$rgbLegacyAbsoluteRegEx = /^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)(?:\s*,\s*(\d+%|\d*\.\d+|[01]))?\s*\)$/i;
const $6c864c0c7b61b9b5$var$rgbLegacyPercentageRegEx = /^rgba?\(\s*(\d+%)\s*,\s*(\d+%)\s*,\s*(\d+%)(?:\s*,\s*(\d+%|\d*\.\d+|[01]))?\s*\)$/i;
const $6c864c0c7b61b9b5$var$hexRegEx = /^#([\da-f]{3,4}|[\da-f]{6}|[\da-f]{8})$/i;
/**
 * @param {string} s Color component as number or percentage.
 * @param {number} divider Divider for percentage.
 * @return {number} Color component.
 */ function $6c864c0c7b61b9b5$var$toColorComponent(s, divider) {
    return s.endsWith('%') ? Number(s.substring(0, s.length - 1)) / divider : Number(s);
}
/**
 * @param {string} color Color string.
 */ function $6c864c0c7b61b9b5$var$throwInvalidColor(color) {
    throw new Error('failed to parse "' + color + '" as color');
}
/**
 * @param {string} color Color string.
 * @return {Color} RGBa color array.
 */ function $6c864c0c7b61b9b5$var$parseRgba(color) {
    // Fast lane for rgb(a) colors
    if (color.toLowerCase().startsWith('rgb')) {
        const rgb = color.match($6c864c0c7b61b9b5$var$rgbLegacyAbsoluteRegEx) || color.match($6c864c0c7b61b9b5$var$rgbModernRegEx) || color.match($6c864c0c7b61b9b5$var$rgbLegacyPercentageRegEx);
        if (rgb) {
            const alpha = rgb[4];
            const rgbDivider = 100 / 255;
            return [
                (0, $912ac838ff50d1cd$export$7d15b64cf5a3a4c4)($6c864c0c7b61b9b5$var$toColorComponent(rgb[1], rgbDivider) + 0.5 | 0, 0, 255),
                (0, $912ac838ff50d1cd$export$7d15b64cf5a3a4c4)($6c864c0c7b61b9b5$var$toColorComponent(rgb[2], rgbDivider) + 0.5 | 0, 0, 255),
                (0, $912ac838ff50d1cd$export$7d15b64cf5a3a4c4)($6c864c0c7b61b9b5$var$toColorComponent(rgb[3], rgbDivider) + 0.5 | 0, 0, 255),
                alpha !== undefined ? (0, $912ac838ff50d1cd$export$7d15b64cf5a3a4c4)($6c864c0c7b61b9b5$var$toColorComponent(alpha, 100), 0, 1) : 1
            ];
        }
        $6c864c0c7b61b9b5$var$throwInvalidColor(color);
    }
    // Fast lane for hex colors (also with alpha)
    if (color.startsWith('#')) {
        if ($6c864c0c7b61b9b5$var$hexRegEx.test(color)) {
            const hex = color.substring(1);
            const step = hex.length <= 4 ? 1 : 2;
            const colorFromHex = [
                0,
                0,
                0,
                255
            ];
            for(let i = 0, ii = hex.length; i < ii; i += step){
                let colorComponent = parseInt(hex.substring(i, i + step), 16);
                if (step === 1) colorComponent += colorComponent << 4;
                colorFromHex[i / step] = colorComponent;
            }
            colorFromHex[3] = colorFromHex[3] / 255;
            return colorFromHex;
        }
        $6c864c0c7b61b9b5$var$throwInvalidColor(color);
    }
    // Use canvas color serialization to parse the color into hex or rgba
    // See https://www.w3.org/TR/2021/SPSD-2dcontext-20210128/#serialization-of-a-color
    const context = $6c864c0c7b61b9b5$var$getColorParseContext();
    context.fillStyle = '#abcdef';
    let invalidCheckFillStyle = context.fillStyle;
    context.fillStyle = color;
    if (context.fillStyle === invalidCheckFillStyle) {
        context.fillStyle = '#fedcba';
        invalidCheckFillStyle = context.fillStyle;
        context.fillStyle = color;
        if (context.fillStyle === invalidCheckFillStyle) $6c864c0c7b61b9b5$var$throwInvalidColor(color);
    }
    const colorString = context.fillStyle;
    if (colorString.startsWith('#') || colorString.startsWith('rgba')) return $6c864c0c7b61b9b5$var$parseRgba(colorString);
    context.clearRect(0, 0, 1, 1);
    context.fillRect(0, 0, 1, 1);
    const colorFromImage = Array.from(context.getImageData(0, 0, 1, 1).data);
    colorFromImage[3] = (0, $912ac838ff50d1cd$export$a81f732198733497)(colorFromImage[3] / 255, 3);
    return colorFromImage;
}
function $6c864c0c7b61b9b5$export$590567be997858b6(color) {
    if (typeof color === 'string') return color;
    return $6c864c0c7b61b9b5$export$f84e8e69fd4488a5(color);
}
/**
 * @type {number}
 */ const $6c864c0c7b61b9b5$var$MAX_CACHE_SIZE = 1024;
/**
 * We maintain a small cache of parsed strings.  Whenever the cache grows too large,
 * we delete an arbitrary set of the entries.
 *
 * @type {Object<string, Color>}
 */ const $6c864c0c7b61b9b5$var$cache = {};
/**
 * @type {number}
 */ let $6c864c0c7b61b9b5$var$cacheSize = 0;
function $6c864c0c7b61b9b5$export$138c09bdd6bd797c(color) {
    if (color.length === 4) return color;
    const output = color.slice();
    output[3] = 1;
    return output;
}
// The functions b1, b2, a1, a2, rgbaToLcha and lchaToRgba below are adapted from
// https://stackoverflow.com/a/67219995/2389327
/**
 * @param {number} v Input value.
 * @return {number} Output value.
 */ function $6c864c0c7b61b9b5$var$b1(v) {
    return v > 0.0031308 ? Math.pow(v, 1 / 2.4) * 269.025 - 14.025 : v * 3294.6;
}
/**
 * @param {number} v Input value.
 * @return {number} Output value.
 */ function $6c864c0c7b61b9b5$var$b2(v) {
    return v > 0.2068965 ? Math.pow(v, 3) : (v - 4 / 29) * (108 / 841);
}
/**
 * @param {number} v Input value.
 * @return {number} Output value.
 */ function $6c864c0c7b61b9b5$var$a1(v) {
    return v > 10.314724 ? Math.pow((v + 14.025) / 269.025, 2.4) : v / 3294.6;
}
/**
 * @param {number} v Input value.
 * @return {number} Output value.
 */ function $6c864c0c7b61b9b5$var$a2(v) {
    return v > 0.0088564 ? Math.pow(v, 1 / 3) : v / (108 / 841) + 4 / 29;
}
function $6c864c0c7b61b9b5$export$44fb54fa2e0c0d4(color) {
    const r = $6c864c0c7b61b9b5$var$a1(color[0]);
    const g = $6c864c0c7b61b9b5$var$a1(color[1]);
    const b = $6c864c0c7b61b9b5$var$a1(color[2]);
    const y = $6c864c0c7b61b9b5$var$a2(r * 0.222488403 + g * 0.716873169 + b * 0.06060791);
    const l = 500 * ($6c864c0c7b61b9b5$var$a2(r * 0.452247074 + g * 0.399439023 + b * 0.148375274) - y);
    const q = 200 * (y - $6c864c0c7b61b9b5$var$a2(r * 0.016863605 + g * 0.117638439 + b * 0.865350722));
    const h = Math.atan2(q, l) * (180 / Math.PI);
    return [
        116 * y - 16,
        Math.sqrt(l * l + q * q),
        h < 0 ? h + 360 : h,
        color[3]
    ];
}
function $6c864c0c7b61b9b5$export$27cc94530c050f00(color) {
    const l = (color[0] + 16) / 116;
    const c = color[1];
    const h = color[2] * Math.PI / 180;
    const y = $6c864c0c7b61b9b5$var$b2(l);
    const x = $6c864c0c7b61b9b5$var$b2(l + c / 500 * Math.cos(h));
    const z = $6c864c0c7b61b9b5$var$b2(l - c / 200 * Math.sin(h));
    const r = $6c864c0c7b61b9b5$var$b1(x * 3.021973625 - y * 1.617392459 - z * 0.404875592);
    const g = $6c864c0c7b61b9b5$var$b1(x * -0.943766287 + y * 1.916279586 + z * 0.027607165);
    const b = $6c864c0c7b61b9b5$var$b1(x * 0.069407491 - y * 0.22898585 + z * 1.159737864);
    return [
        (0, $912ac838ff50d1cd$export$7d15b64cf5a3a4c4)(r + 0.5 | 0, 0, 255),
        (0, $912ac838ff50d1cd$export$7d15b64cf5a3a4c4)(g + 0.5 | 0, 0, 255),
        (0, $912ac838ff50d1cd$export$7d15b64cf5a3a4c4)(b + 0.5 | 0, 0, 255),
        color[3]
    ];
}
function $6c864c0c7b61b9b5$export$3004f64547af360e(s) {
    if (s === 'none') return $6c864c0c7b61b9b5$export$6c844c64a5efe1ee;
    if ($6c864c0c7b61b9b5$var$cache.hasOwnProperty(s)) return $6c864c0c7b61b9b5$var$cache[s];
    if ($6c864c0c7b61b9b5$var$cacheSize >= $6c864c0c7b61b9b5$var$MAX_CACHE_SIZE) {
        let i = 0;
        for(const key in $6c864c0c7b61b9b5$var$cache)if ((i++ & 3) === 0) {
            delete $6c864c0c7b61b9b5$var$cache[key];
            --$6c864c0c7b61b9b5$var$cacheSize;
        }
    }
    const color = $6c864c0c7b61b9b5$var$parseRgba(s);
    if (color.length !== 4) $6c864c0c7b61b9b5$var$throwInvalidColor(s);
    for (const c of color)if (isNaN(c)) $6c864c0c7b61b9b5$var$throwInvalidColor(s);
    $6c864c0c7b61b9b5$var$cache[s] = color;
    ++$6c864c0c7b61b9b5$var$cacheSize;
    return color;
}
function $6c864c0c7b61b9b5$export$75093a47a9fa838d(color) {
    if (Array.isArray(color)) return color;
    return $6c864c0c7b61b9b5$export$3004f64547af360e(color);
}
function $6c864c0c7b61b9b5$export$f84e8e69fd4488a5(color) {
    let r = color[0];
    if (r != (r | 0)) r = r + 0.5 | 0;
    let g = color[1];
    if (g != (g | 0)) g = g + 0.5 | 0;
    let b = color[2];
    if (b != (b | 0)) b = b + 0.5 | 0;
    const a = color[3] === undefined ? 1 : Math.round(color[3] * 1000) / 1000;
    return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
}
function $6c864c0c7b61b9b5$export$40dd713d7775a0b1(s) {
    try {
        $6c864c0c7b61b9b5$export$3004f64547af360e(s);
        return true;
    } catch  {
        return false;
    }
}


/**
 * @module ol/expr/cpu
 */ 
/**
 * @module ol/expr/expression
 */ 

/**
 * @module ol/size
 */ /**
 * An array of numbers representing a size: `[width, height]`.
 * @typedef {Array<number>} Size
 * @api
 */ /**
 * Returns a buffered size.
 * @param {Size} size Size.
 * @param {number} num The amount by which to buffer.
 * @param {Size} [dest] Optional reusable size array.
 * @return {Size} The buffered size.
 */ function $e9727ecf69942748$export$ab1029bcae9ddb4a(size, num, dest) {
    if (dest === undefined) dest = [
        0,
        0
    ];
    dest[0] = size[0] + 2 * num;
    dest[1] = size[1] + 2 * num;
    return dest;
}
function $e9727ecf69942748$export$622c471beb1693c7(size) {
    return size[0] > 0 && size[1] > 0;
}
function $e9727ecf69942748$export$dcdf75081b88279d(size, ratio, dest) {
    if (dest === undefined) dest = [
        0,
        0
    ];
    dest[0] = size[0] * ratio + 0.5 | 0;
    dest[1] = size[1] * ratio + 0.5 | 0;
    return dest;
}
function $e9727ecf69942748$export$a71a825ff42fb8e1(size, dest) {
    if (Array.isArray(size)) return size;
    if (dest === undefined) dest = [
        size,
        size
    ];
    else {
        dest[0] = size;
        dest[1] = size;
    }
    return dest;
}


/**
 * @fileoverview This module includes types and functions for parsing array encoded expressions.
 * The result of parsing an encoded expression is one of the specific expression classes.
 * During parsing, information is added to the parsing context about the data accessed by the
 * expression.
 */ /**
 * Base type used for literal style parameters; can be a number literal or the output of an operator,
 * which in turns takes {@link import("./expression.js").ExpressionValue} arguments.
 *
 * See below for details on the available operators (with notes for those that are WebGL or Canvas only).
 *
 * Reading operators:
 *   * `['band', bandIndex, xOffset, yOffset]` For tile layers only. Fetches pixel values from band
 *     `bandIndex` of the source's data. The first `bandIndex` of the source data is `1`. Fetched values
 *     are in the 0..1 range. {@link import("../source/TileImage.js").default} sources have 4 bands: red,
 *     green, blue and alpha. {@link import("../source/DataTile.js").default} sources can have any number
 *     of bands, depending on the underlying data source and
 *     {@link import("../source/GeoTIFF.js").Options configuration}. `xOffset` and `yOffset` are optional
 *     and allow specifying pixel offsets for x and y. This is used for sampling data from neighboring pixels (WebGL only).
 *   * `['get', attributeName]` fetches a feature property value, similar to `feature.get('attributeName')`.
 *   * `['get', attributeName, keyOrArrayIndex, ...]` (Canvas only) Access nested properties and array items of a
 *     feature property. The result is `undefined` when there is nothing at the specified key or index.
 *   * `['geometry-type']` returns a feature's geometry type as string, either: 'LineString', 'Point' or 'Polygon'
 *     `Multi*` values are returned as their singular equivalent
 *     `Circle` geometries are returned as 'Polygon'
 *     `GeometryCollection` geometries are returned as the type of the first geometry found in the collection (WebGL only).
 *   * `['resolution']` returns the current resolution
 *   * `['time']` The time in seconds since the creation of the layer (WebGL only).
 *   * `['var', 'varName']` fetches a value from the style variables; will throw an error if that variable is undefined
 *   * `['zoom']` The current zoom level (WebGL only).
 *   * `['line-metric']` returns the M component of the current point on a line (WebGL only); in case where the geometry layout of the line
 *      does not contain an M component (e.g. XY or XYZ), 0 is returned; 0 is also returned for geometries other than lines.
 *      Please note that the M component will be linearly interpolated between the two points composing a segment.
 *
 * Math operators:
 *   * `['*', value1, value2, ...]` multiplies the values (either numbers or colors)
 *   * `['/', value1, value2]` divides `value1` by `value2`
 *   * `['+', value1, value2, ...]` adds the values
 *   * `['-', value1, value2]` subtracts `value2` from `value1`
 *   * `['clamp', value, low, high]` clamps `value` between `low` and `high`
 *   * `['%', value1, value2]` returns the result of `value1 % value2` (modulo)
 *   * `['^', value1, value2]` returns the value of `value1` raised to the `value2` power
 *   * `['abs', value1]` returns the absolute value of `value1`
 *   * `['floor', value1]` returns the nearest integer less than or equal to `value1`
 *   * `['round', value1]` returns the nearest integer to `value1`
 *   * `['ceil', value1]` returns the nearest integer greater than or equal to `value1`
 *   * `['sin', value1]` returns the sine of `value1`
 *   * `['cos', value1]` returns the cosine of `value1`
 *   * `['atan', value1, value2]` returns `atan2(value1, value2)`. If `value2` is not provided, returns `atan(value1)`
 *   * `['sqrt', value1]` returns the square root of `value1`
 *
 * * Transform operators:
 *   * `['case', condition1, output1, ...conditionN, outputN, fallback]` selects the first output whose corresponding
 *     condition evaluates to `true`. If no match is found, returns the `fallback` value.
 *     All conditions should be `boolean`, output and fallback can be any kind.
 *   * `['match', input, match1, output1, ...matchN, outputN, fallback]` compares the `input` value against all
 *     provided `matchX` values, returning the output associated with the first valid match. If no match is found,
 *     returns the `fallback` value.
 *     `input` and `matchX` values must all be of the same type, and can be `number` or `string`. `outputX` and
 *     `fallback` values must be of the same type, and can be of any kind.
 *   * `['interpolate', interpolation, input, stop1, output1, ...stopN, outputN]` returns a value by interpolating between
 *     pairs of inputs and outputs; `interpolation` can either be `['linear']` or `['exponential', base]` where `base` is
 *     the rate of increase from stop A to stop B (i.e. power to which the interpolation ratio is raised); a value
 *     of 1 is equivalent to `['linear']`.
 *     `input` and `stopX` values must all be of type `number`. `outputX` values can be `number` or `color` values.
 *     Note: `input` will be clamped between `stop1` and `stopN`, meaning that all output values will be comprised
 *     between `output1` and `outputN`.
 *   * `['string', value1, value2, ...]` returns the first value in the list that evaluates to a string.
 *     An example would be to provide a default value for get: `['string', ['get', 'propertyname'], 'default value']]`
 *     (Canvas only).
 *   * `['number', value1, value2, ...]` returns the first value in the list that evaluates to a number.
 *     An example would be to provide a default value for get: `['string', ['get', 'propertyname'], 42]]`
 *     (Canvas only).
 *   * `['coalesce', value1, value2, ...]` returns the first value in the list which is not null or undefined.
 *     An example would be to provide a default value for get: `['coalesce', ['get','propertyname'], 'default value']]`
 *     (Canvas only).
 *
 * * Logical operators:
 *   * `['<', value1, value2]` returns `true` if `value1` is strictly lower than `value2`, or `false` otherwise.
 *   * `['<=', value1, value2]` returns `true` if `value1` is lower than or equals `value2`, or `false` otherwise.
 *   * `['>', value1, value2]` returns `true` if `value1` is strictly greater than `value2`, or `false` otherwise.
 *   * `['>=', value1, value2]` returns `true` if `value1` is greater than or equals `value2`, or `false` otherwise.
 *   * `['==', value1, value2]` returns `true` if `value1` equals `value2`, or `false` otherwise.
 *   * `['!=', value1, value2]` returns `true` if `value1` does not equal `value2`, or `false` otherwise.
 *   * `['!', value1]` returns `false` if `value1` is `true` or greater than `0`, or `true` otherwise.
 *   * `['all', value1, value2, ...]` returns `true` if all the inputs are `true`, `false` otherwise.
 *   * `['any', value1, value2, ...]` returns `true` if any of the inputs are `true`, `false` otherwise.
 *   * `['has', attributeName, keyOrArrayIndex, ...]` returns `true` if feature properties include the (nested) key `attributeName`,
 *     `false` otherwise.
 *     Note that for WebGL layers, the hardcoded value `-9999999` is used to distinguish when a property is not defined.
 *   * `['between', value1, value2, value3]` returns `true` if `value1` is contained between `value2` and `value3`
 *     (inclusively), or `false` otherwise.
 *   * `['in', needle, haystack]` returns `true` if `needle` is found in `haystack`, and
 *     `false` otherwise.
 *     This operator has the following limitations:
 *     * `haystack` has to be an array of numbers or strings (searching for a substring in a string is not supported yet)
 *     * Only literal arrays are supported as `haystack` for now; this means that `haystack` cannot be the result of an
 *     expression. If `haystack` is an array of strings, use the `literal` operator to disambiguate from an expression:
 *     `['literal', ['abc', 'def', 'ghi']]`
 *     This works as well for number arrays although it is not required. Mixing types (numbers and strings) will produce undefined results.
 *
 * * Conversion operators:
 *   * `['array', value1, ...valueN]` creates a numerical array from `number` values; please note that the amount of
 *     values can currently only be 2, 3 or 4 (WebGL only).
 *   * `['color', red, green, blue, alpha]` or `['color', shade, alpha]` creates a `color` value from `number` values;
 *     the `alpha` parameter is optional; if not specified, it will be set to 1 (WebGL only).
 *     Note: `red`, `green` and `blue` or `shade` components must be values between 0 and 255; `alpha` between 0 and 1.
 *   * `['palette', index, colors]` picks a `color` value from an array of colors using the given index; the `index`
 *     expression must evaluate to a number; the items in the `colors` array must be strings with hex colors
 *     (e.g. `'#86A136'`), colors using the rgba[a] functional notation (e.g. `'rgb(134, 161, 54)'` or `'rgba(134, 161, 54, 1)'`),
 *     named colors (e.g. `'red'`), or array literals with 3 ([r, g, b]) or 4 ([r, g, b, a]) values (with r, g, and b
 *     in the 0-255 range and a in the 0-1 range) (WebGL only).
 *   * `['to-string', value]` converts the input value to a string. If the input is a boolean, the result is "true" or "false".
 *     If the input is a number, it is converted to a string as specified by the "NumberToString" algorithm of the ECMAScript
 *     Language Specification. If the input is a color, it is converted to a string of the form "rgba(r,g,b,a)". (Canvas only)
 *
 * Values can either be literals or another operator, as they will be evaluated recursively.
 * Literal values can be of the following types:
 * * `boolean`
 * * `number`
 * * `number[]` (number arrays can only have a length of 2, 3 or 4)
 * * `string`
 * * {@link module:ol/color~Color}
 *
 * @typedef {Array<*>|import("../color.js").Color|string|number|boolean} ExpressionValue
 * @api
 */ let $e8b52593925b4bc9$var$numTypes = 0;
const $e8b52593925b4bc9$export$267d7ad6fa96ffaf = 0;
const $e8b52593925b4bc9$export$240f7fffab1b25a0 = 1 << $e8b52593925b4bc9$var$numTypes++;
const $e8b52593925b4bc9$export$86a7aca748b1e260 = 1 << $e8b52593925b4bc9$var$numTypes++;
const $e8b52593925b4bc9$export$2b93044cbf134323 = 1 << $e8b52593925b4bc9$var$numTypes++;
const $e8b52593925b4bc9$export$2cd82751acc0e609 = 1 << $e8b52593925b4bc9$var$numTypes++;
const $e8b52593925b4bc9$export$d701d0e49f4bcb39 = 1 << $e8b52593925b4bc9$var$numTypes++;
const $e8b52593925b4bc9$export$52725c8a6d4c61d1 = 1 << $e8b52593925b4bc9$var$numTypes++;
const $e8b52593925b4bc9$export$ec4c9a150bae86cd = Math.pow(2, $e8b52593925b4bc9$var$numTypes) - 1;
const $e8b52593925b4bc9$var$typeNames = {
    [$e8b52593925b4bc9$export$240f7fffab1b25a0]: 'boolean',
    [$e8b52593925b4bc9$export$86a7aca748b1e260]: 'number',
    [$e8b52593925b4bc9$export$2b93044cbf134323]: 'string',
    [$e8b52593925b4bc9$export$2cd82751acc0e609]: 'color',
    [$e8b52593925b4bc9$export$d701d0e49f4bcb39]: 'number[]',
    [$e8b52593925b4bc9$export$52725c8a6d4c61d1]: 'size'
};
const $e8b52593925b4bc9$var$namedTypes = Object.keys($e8b52593925b4bc9$var$typeNames).map(Number).sort((0, $db525acb5f2517fc$export$fcb633242ef15540));
/**
 * @param {number} type The type.
 * @return {boolean} The type is one of the specific types (not any or a union type).
 */ function $e8b52593925b4bc9$var$isSpecific(type) {
    return type in $e8b52593925b4bc9$var$typeNames;
}
function $e8b52593925b4bc9$export$b2afc7c96b2b4a45(type) {
    const names = [];
    for (const namedType of $e8b52593925b4bc9$var$namedTypes)if ($e8b52593925b4bc9$export$9fdcb8b441c4f2b4(type, namedType)) names.push($e8b52593925b4bc9$var$typeNames[namedType]);
    if (names.length === 0) return 'untyped';
    if (names.length < 3) return names.join(' or ');
    return names.slice(0, -1).join(', ') + ', or ' + names[names.length - 1];
}
function $e8b52593925b4bc9$export$9fdcb8b441c4f2b4(broad, specific) {
    return (broad & specific) === specific;
}
function $e8b52593925b4bc9$export$3252d368d784c970(oneType, otherType) {
    return !!(oneType & otherType);
}
function $e8b52593925b4bc9$export$26b9f946b448f23e(type, expected) {
    return type === expected;
}
class $e8b52593925b4bc9$export$eb63e96e0913dda4 {
    /**
   * @param {number} type The value type.
   * @param {LiteralValue} value The literal value.
   */ constructor(type, value){
        if (!$e8b52593925b4bc9$var$isSpecific(type)) throw new Error(`literal expressions must have a specific type, got ${$e8b52593925b4bc9$export$b2afc7c96b2b4a45(type)}`);
        this.type = type;
        this.value = value;
    }
}
class $e8b52593925b4bc9$export$6f3d80189eb72cd4 {
    /**
   * @param {number} type The return type.
   * @param {string} operator The operator.
   * @param {...Expression} args The arguments.
   */ constructor(type, operator, ...args){
        this.type = type;
        this.operator = operator;
        this.args = args;
    }
}
function $e8b52593925b4bc9$export$1c8b4c1584800354() {
    return {
        variables: new Set(),
        properties: new Set(),
        featureId: false,
        geometryType: false,
        mCoordinate: false,
        mapState: false
    };
}
function $e8b52593925b4bc9$export$98e6a39c04603d36(encoded, expectedType, context) {
    switch(typeof encoded){
        case 'boolean':
            if ($e8b52593925b4bc9$export$26b9f946b448f23e(expectedType, $e8b52593925b4bc9$export$2b93044cbf134323)) return new $e8b52593925b4bc9$export$eb63e96e0913dda4($e8b52593925b4bc9$export$2b93044cbf134323, encoded ? 'true' : 'false');
            if (!$e8b52593925b4bc9$export$9fdcb8b441c4f2b4(expectedType, $e8b52593925b4bc9$export$240f7fffab1b25a0)) throw new Error(`got a boolean, but expected ${$e8b52593925b4bc9$export$b2afc7c96b2b4a45(expectedType)}`);
            return new $e8b52593925b4bc9$export$eb63e96e0913dda4($e8b52593925b4bc9$export$240f7fffab1b25a0, encoded);
        case 'number':
            if ($e8b52593925b4bc9$export$26b9f946b448f23e(expectedType, $e8b52593925b4bc9$export$52725c8a6d4c61d1)) return new $e8b52593925b4bc9$export$eb63e96e0913dda4($e8b52593925b4bc9$export$52725c8a6d4c61d1, (0, $e9727ecf69942748$export$a71a825ff42fb8e1)(encoded));
            if ($e8b52593925b4bc9$export$26b9f946b448f23e(expectedType, $e8b52593925b4bc9$export$240f7fffab1b25a0)) return new $e8b52593925b4bc9$export$eb63e96e0913dda4($e8b52593925b4bc9$export$240f7fffab1b25a0, !!encoded);
            if ($e8b52593925b4bc9$export$26b9f946b448f23e(expectedType, $e8b52593925b4bc9$export$2b93044cbf134323)) return new $e8b52593925b4bc9$export$eb63e96e0913dda4($e8b52593925b4bc9$export$2b93044cbf134323, encoded.toString());
            if (!$e8b52593925b4bc9$export$9fdcb8b441c4f2b4(expectedType, $e8b52593925b4bc9$export$86a7aca748b1e260)) throw new Error(`got a number, but expected ${$e8b52593925b4bc9$export$b2afc7c96b2b4a45(expectedType)}`);
            return new $e8b52593925b4bc9$export$eb63e96e0913dda4($e8b52593925b4bc9$export$86a7aca748b1e260, encoded);
        case 'string':
            if ($e8b52593925b4bc9$export$26b9f946b448f23e(expectedType, $e8b52593925b4bc9$export$2cd82751acc0e609)) return new $e8b52593925b4bc9$export$eb63e96e0913dda4($e8b52593925b4bc9$export$2cd82751acc0e609, (0, $6c864c0c7b61b9b5$export$3004f64547af360e)(encoded));
            if ($e8b52593925b4bc9$export$26b9f946b448f23e(expectedType, $e8b52593925b4bc9$export$240f7fffab1b25a0)) return new $e8b52593925b4bc9$export$eb63e96e0913dda4($e8b52593925b4bc9$export$240f7fffab1b25a0, !!encoded);
            if (!$e8b52593925b4bc9$export$9fdcb8b441c4f2b4(expectedType, $e8b52593925b4bc9$export$2b93044cbf134323)) throw new Error(`got a string, but expected ${$e8b52593925b4bc9$export$b2afc7c96b2b4a45(expectedType)}`);
            return new $e8b52593925b4bc9$export$eb63e96e0913dda4($e8b52593925b4bc9$export$2b93044cbf134323, encoded);
        default:
    }
    if (!Array.isArray(encoded)) throw new Error('expression must be an array or a primitive value');
    if (encoded.length === 0) throw new Error('empty expression');
    if (typeof encoded[0] === 'string') return $e8b52593925b4bc9$var$parseCallExpression(encoded, expectedType, context);
    for (const item of encoded){
        if (typeof item !== 'number') throw new Error('expected an array of numbers');
    }
    if ($e8b52593925b4bc9$export$26b9f946b448f23e(expectedType, $e8b52593925b4bc9$export$52725c8a6d4c61d1)) {
        if (encoded.length !== 2) throw new Error(`expected an array of two values for a size, got ${encoded.length}`);
        return new $e8b52593925b4bc9$export$eb63e96e0913dda4($e8b52593925b4bc9$export$52725c8a6d4c61d1, encoded);
    }
    if ($e8b52593925b4bc9$export$26b9f946b448f23e(expectedType, $e8b52593925b4bc9$export$2cd82751acc0e609)) {
        if (encoded.length === 3) return new $e8b52593925b4bc9$export$eb63e96e0913dda4($e8b52593925b4bc9$export$2cd82751acc0e609, [
            ...encoded,
            1
        ]);
        if (encoded.length === 4) return new $e8b52593925b4bc9$export$eb63e96e0913dda4($e8b52593925b4bc9$export$2cd82751acc0e609, encoded);
        throw new Error(`expected an array of 3 or 4 values for a color, got ${encoded.length}`);
    }
    if (!$e8b52593925b4bc9$export$9fdcb8b441c4f2b4(expectedType, $e8b52593925b4bc9$export$d701d0e49f4bcb39)) throw new Error(`got an array of numbers, but expected ${$e8b52593925b4bc9$export$b2afc7c96b2b4a45(expectedType)}`);
    return new $e8b52593925b4bc9$export$eb63e96e0913dda4($e8b52593925b4bc9$export$d701d0e49f4bcb39, encoded);
}
const $e8b52593925b4bc9$export$2655e45458bc48f3 = {
    Get: 'get',
    Var: 'var',
    Concat: 'concat',
    GeometryType: 'geometry-type',
    LineMetric: 'line-metric',
    Any: 'any',
    All: 'all',
    Not: '!',
    Resolution: 'resolution',
    Zoom: 'zoom',
    Time: 'time',
    Equal: '==',
    NotEqual: '!=',
    GreaterThan: '>',
    GreaterThanOrEqualTo: '>=',
    LessThan: '<',
    LessThanOrEqualTo: '<=',
    Multiply: '*',
    Divide: '/',
    Add: '+',
    Subtract: '-',
    Clamp: 'clamp',
    Mod: '%',
    Pow: '^',
    Abs: 'abs',
    Floor: 'floor',
    Ceil: 'ceil',
    Round: 'round',
    Sin: 'sin',
    Cos: 'cos',
    Atan: 'atan',
    Sqrt: 'sqrt',
    Match: 'match',
    Between: 'between',
    Interpolate: 'interpolate',
    Coalesce: 'coalesce',
    Case: 'case',
    In: 'in',
    Number: 'number',
    String: 'string',
    Array: 'array',
    Color: 'color',
    Id: 'id',
    Band: 'band',
    Palette: 'palette',
    ToString: 'to-string',
    Has: 'has'
};
/**
 * @typedef {function(Array, number, ParsingContext):Expression} Parser
 *
 * Second argument is the expected type.
 */ /**
 * @type {Object<string, Parser>}
 */ const $e8b52593925b4bc9$var$parsers = {
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Get]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(1, Infinity), $e8b52593925b4bc9$var$withGetArgs),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Var]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(1, 1), $e8b52593925b4bc9$var$withVarArgs),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Has]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(1, Infinity), $e8b52593925b4bc9$var$withGetArgs),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Id]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$usesFeatureId, $e8b52593925b4bc9$var$withNoArgs),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Concat]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(2, Infinity), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$2b93044cbf134323)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.GeometryType]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$usesGeometryType, $e8b52593925b4bc9$var$withNoArgs),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.LineMetric]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$usesMCoordinate, $e8b52593925b4bc9$var$withNoArgs),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Resolution]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$usesMapState, $e8b52593925b4bc9$var$withNoArgs),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Zoom]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$usesMapState, $e8b52593925b4bc9$var$withNoArgs),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Time]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$usesMapState, $e8b52593925b4bc9$var$withNoArgs),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Any]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(2, Infinity), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$240f7fffab1b25a0)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.All]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(2, Infinity), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$240f7fffab1b25a0)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Not]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(1, 1), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$240f7fffab1b25a0)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Equal]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(2, 2), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$ec4c9a150bae86cd)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.NotEqual]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(2, 2), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$ec4c9a150bae86cd)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.GreaterThan]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(2, 2), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$86a7aca748b1e260)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.GreaterThanOrEqualTo]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(2, 2), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$86a7aca748b1e260)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.LessThan]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(2, 2), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$86a7aca748b1e260)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.LessThanOrEqualTo]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(2, 2), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$86a7aca748b1e260)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Multiply]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(2, Infinity), $e8b52593925b4bc9$var$withArgsOfReturnType),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Coalesce]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(2, Infinity), $e8b52593925b4bc9$var$withArgsOfReturnType),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Divide]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(2, 2), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$86a7aca748b1e260)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Add]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(2, Infinity), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$86a7aca748b1e260)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Subtract]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(2, 2), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$86a7aca748b1e260)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Clamp]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(3, 3), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$86a7aca748b1e260)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Mod]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(2, 2), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$86a7aca748b1e260)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Pow]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(2, 2), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$86a7aca748b1e260)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Abs]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(1, 1), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$86a7aca748b1e260)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Floor]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(1, 1), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$86a7aca748b1e260)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Ceil]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(1, 1), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$86a7aca748b1e260)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Round]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(1, 1), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$86a7aca748b1e260)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Sin]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(1, 1), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$86a7aca748b1e260)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Cos]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(1, 1), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$86a7aca748b1e260)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Atan]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(1, 2), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$86a7aca748b1e260)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Sqrt]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(1, 1), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$86a7aca748b1e260)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Match]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(4, Infinity), $e8b52593925b4bc9$var$hasEvenArgs, $e8b52593925b4bc9$var$withMatchArgs),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Between]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(3, 3), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$86a7aca748b1e260)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Interpolate]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(6, Infinity), $e8b52593925b4bc9$var$hasEvenArgs, $e8b52593925b4bc9$var$withInterpolateArgs),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Case]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(3, Infinity), $e8b52593925b4bc9$var$hasOddArgs, $e8b52593925b4bc9$var$withCaseArgs),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.In]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(2, 2), $e8b52593925b4bc9$var$withInArgs),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Number]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(1, Infinity), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$ec4c9a150bae86cd)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.String]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(1, Infinity), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$ec4c9a150bae86cd)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Array]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(1, Infinity), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$86a7aca748b1e260)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Color]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(1, 4), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$86a7aca748b1e260)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Band]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(1, 3), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$86a7aca748b1e260)),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.Palette]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(2, 2), $e8b52593925b4bc9$var$withPaletteArgs),
    [$e8b52593925b4bc9$export$2655e45458bc48f3.ToString]: $e8b52593925b4bc9$var$createCallExpressionParser($e8b52593925b4bc9$var$hasArgsCount(1, 1), $e8b52593925b4bc9$var$withArgsOfType($e8b52593925b4bc9$export$240f7fffab1b25a0 | $e8b52593925b4bc9$export$86a7aca748b1e260 | $e8b52593925b4bc9$export$2b93044cbf134323 | $e8b52593925b4bc9$export$2cd82751acc0e609))
};
/**
 * @typedef {function(Array<EncodedExpression>, number, ParsingContext):Array<Expression>|void} ArgValidator
 *
 * An argument validator applies various checks to an encoded expression arguments and
 * returns the parsed arguments if any.  The second argument is the return type of the call expression.
 */ /**
 * @type {ArgValidator}
 */ function $e8b52593925b4bc9$var$withGetArgs(encoded, returnType, context) {
    const argsCount = encoded.length - 1;
    const args = new Array(argsCount);
    for(let i = 0; i < argsCount; ++i){
        const key = encoded[i + 1];
        switch(typeof key){
            case 'number':
                args[i] = new $e8b52593925b4bc9$export$eb63e96e0913dda4($e8b52593925b4bc9$export$86a7aca748b1e260, key);
                break;
            case 'string':
                args[i] = new $e8b52593925b4bc9$export$eb63e96e0913dda4($e8b52593925b4bc9$export$2b93044cbf134323, key);
                break;
            default:
                throw new Error(`expected a string key or numeric array index for a get operation, got ${key}`);
        }
        if (i === 0) context.properties.add(String(key));
    }
    return args;
}
/**
 * @type {ArgValidator}
 */ function $e8b52593925b4bc9$var$withVarArgs(encoded, returnType, context) {
    const name = encoded[1];
    if (typeof name !== 'string') throw new Error('expected a string argument for var operation');
    context.variables.add(name);
    return [
        new $e8b52593925b4bc9$export$eb63e96e0913dda4($e8b52593925b4bc9$export$2b93044cbf134323, name)
    ];
}
/**
 * @type {ArgValidator}
 */ function $e8b52593925b4bc9$var$usesFeatureId(encoded, returnType, context) {
    context.featureId = true;
}
/**
 * @type {ArgValidator}
 */ function $e8b52593925b4bc9$var$usesGeometryType(encoded, returnType, context) {
    context.geometryType = true;
}
/**
 * @type {ArgValidator}
 */ function $e8b52593925b4bc9$var$usesMCoordinate(encoded, returnType, context) {
    context.mCoordinate = true;
}
/**
 * @type {ArgValidator}
 */ function $e8b52593925b4bc9$var$usesMapState(encoded, returnType, context) {
    context.mapState = true;
}
/**
 * @type {ArgValidator}
 */ function $e8b52593925b4bc9$var$withNoArgs(encoded, returnType, context) {
    const operation = encoded[0];
    if (encoded.length !== 1) throw new Error(`expected no arguments for ${operation} operation`);
    return [];
}
/**
 * @param {number} minArgs The minimum number of arguments.
 * @param {number} maxArgs The maximum number of arguments.
 * @return {ArgValidator} The argument validator
 */ function $e8b52593925b4bc9$var$hasArgsCount(minArgs, maxArgs) {
    return function(encoded, returnType, context) {
        const operation = encoded[0];
        const argCount = encoded.length - 1;
        if (minArgs === maxArgs) {
            if (argCount !== minArgs) {
                const plural = minArgs === 1 ? '' : 's';
                throw new Error(`expected ${minArgs} argument${plural} for ${operation}, got ${argCount}`);
            }
        } else if (argCount < minArgs || argCount > maxArgs) {
            const range = maxArgs === Infinity ? `${minArgs} or more` : `${minArgs} to ${maxArgs}`;
            throw new Error(`expected ${range} arguments for ${operation}, got ${argCount}`);
        }
    };
}
/**
 * @type {ArgValidator}
 */ function $e8b52593925b4bc9$var$withArgsOfReturnType(encoded, returnType, context) {
    const argCount = encoded.length - 1;
    /**
   * @type {Array<Expression>}
   */ const args = new Array(argCount);
    for(let i = 0; i < argCount; ++i){
        const expression = $e8b52593925b4bc9$export$98e6a39c04603d36(encoded[i + 1], returnType, context);
        args[i] = expression;
    }
    return args;
}
/**
 * @param {number} argType The argument type.
 * @return {ArgValidator} The argument validator
 */ function $e8b52593925b4bc9$var$withArgsOfType(argType) {
    return function(encoded, returnType, context) {
        const argCount = encoded.length - 1;
        /**
     * @type {Array<Expression>}
     */ const args = new Array(argCount);
        for(let i = 0; i < argCount; ++i){
            const expression = $e8b52593925b4bc9$export$98e6a39c04603d36(encoded[i + 1], argType, context);
            args[i] = expression;
        }
        return args;
    };
}
/**
 * @type {ArgValidator}
 */ function $e8b52593925b4bc9$var$hasOddArgs(encoded, returnType, context) {
    const operation = encoded[0];
    const argCount = encoded.length - 1;
    if (argCount % 2 === 0) throw new Error(`expected an odd number of arguments for ${operation}, got ${argCount} instead`);
}
/**
 * @type {ArgValidator}
 */ function $e8b52593925b4bc9$var$hasEvenArgs(encoded, returnType, context) {
    const operation = encoded[0];
    const argCount = encoded.length - 1;
    if (argCount % 2 === 1) throw new Error(`expected an even number of arguments for operation ${operation}, got ${argCount} instead`);
}
/**
 * @type {ArgValidator}
 */ function $e8b52593925b4bc9$var$withMatchArgs(encoded, returnType, context) {
    const argsCount = encoded.length - 1;
    const inputType = $e8b52593925b4bc9$export$2b93044cbf134323 | $e8b52593925b4bc9$export$86a7aca748b1e260 | $e8b52593925b4bc9$export$240f7fffab1b25a0;
    const input = $e8b52593925b4bc9$export$98e6a39c04603d36(encoded[1], inputType, context);
    const fallback = $e8b52593925b4bc9$export$98e6a39c04603d36(encoded[encoded.length - 1], returnType, context);
    const args = new Array(argsCount - 2);
    for(let i = 0; i < argsCount - 2; i += 2){
        try {
            const match = $e8b52593925b4bc9$export$98e6a39c04603d36(encoded[i + 2], input.type, context);
            args[i] = match;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 1} of match expression: ${err.message}`);
        }
        try {
            const output = $e8b52593925b4bc9$export$98e6a39c04603d36(encoded[i + 3], fallback.type, context);
            args[i + 1] = output;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 2} of match expression: ${err.message}`);
        }
    }
    return [
        input,
        ...args,
        fallback
    ];
}
/**
 * @type {ArgValidator}
 */ function $e8b52593925b4bc9$var$withInterpolateArgs(encoded, returnType, context) {
    const interpolationType = encoded[1];
    /**
   * @type {number}
   */ let base;
    switch(interpolationType[0]){
        case 'linear':
            base = 1;
            break;
        case 'exponential':
            const b = interpolationType[1];
            if (typeof b !== 'number' || b <= 0) throw new Error(`expected a number base for exponential interpolation` + `, got ${JSON.stringify(b)} instead`);
            base = b;
            break;
        default:
            throw new Error(`invalid interpolation type: ${JSON.stringify(interpolationType)}`);
    }
    const interpolation = new $e8b52593925b4bc9$export$eb63e96e0913dda4($e8b52593925b4bc9$export$86a7aca748b1e260, base);
    let input;
    try {
        input = $e8b52593925b4bc9$export$98e6a39c04603d36(encoded[2], $e8b52593925b4bc9$export$86a7aca748b1e260, context);
    } catch (err) {
        throw new Error(`failed to parse argument 1 in interpolate expression: ${err.message}`);
    }
    const args = new Array(encoded.length - 3);
    for(let i = 0; i < args.length; i += 2){
        try {
            const stop = $e8b52593925b4bc9$export$98e6a39c04603d36(encoded[i + 3], $e8b52593925b4bc9$export$86a7aca748b1e260, context);
            args[i] = stop;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 2} for interpolate expression: ${err.message}`);
        }
        try {
            const output = $e8b52593925b4bc9$export$98e6a39c04603d36(encoded[i + 4], returnType, context);
            args[i + 1] = output;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 3} for interpolate expression: ${err.message}`);
        }
    }
    return [
        interpolation,
        input,
        ...args
    ];
}
/**
 * @type {ArgValidator}
 */ function $e8b52593925b4bc9$var$withCaseArgs(encoded, returnType, context) {
    const fallback = $e8b52593925b4bc9$export$98e6a39c04603d36(encoded[encoded.length - 1], returnType, context);
    const args = new Array(encoded.length - 1);
    for(let i = 0; i < args.length - 1; i += 2){
        try {
            const condition = $e8b52593925b4bc9$export$98e6a39c04603d36(encoded[i + 1], $e8b52593925b4bc9$export$240f7fffab1b25a0, context);
            args[i] = condition;
        } catch (err) {
            throw new Error(`failed to parse argument ${i} of case expression: ${err.message}`);
        }
        try {
            const output = $e8b52593925b4bc9$export$98e6a39c04603d36(encoded[i + 2], fallback.type, context);
            args[i + 1] = output;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 1} of case expression: ${err.message}`);
        }
    }
    args[args.length - 1] = fallback;
    return args;
}
/**
 * @type {ArgValidator}
 */ function $e8b52593925b4bc9$var$withInArgs(encoded, returnType, context) {
    let haystack = encoded[2];
    if (!Array.isArray(haystack)) throw new Error(`the second argument for the "in" operator must be an array`);
    /**
   * @type {number}
   */ let needleType;
    // check if we're using the 'literal' operator for the haystack
    if (haystack[0] === 'literal') {
        haystack = haystack[1];
        if (!Array.isArray(haystack)) throw new Error(`failed to parse "in" expression: the literal operator must be followed by an array`);
    } else if (typeof haystack[0] === 'string') throw new Error(`for the "in" operator, a string array should be wrapped in a "literal" operator to disambiguate from expressions`);
    if (typeof haystack[0] === 'string') needleType = $e8b52593925b4bc9$export$2b93044cbf134323;
    else needleType = $e8b52593925b4bc9$export$86a7aca748b1e260;
    const args = new Array(haystack.length);
    for(let i = 0; i < args.length; i++)try {
        const arg = $e8b52593925b4bc9$export$98e6a39c04603d36(haystack[i], needleType, context);
        args[i] = arg;
    } catch (err) {
        throw new Error(`failed to parse haystack item ${i} for "in" expression: ${err.message}`);
    }
    const needle = $e8b52593925b4bc9$export$98e6a39c04603d36(encoded[1], needleType, context);
    return [
        needle,
        ...args
    ];
}
/**
 * @type {ArgValidator}
 */ function $e8b52593925b4bc9$var$withPaletteArgs(encoded, returnType, context) {
    let index;
    try {
        index = $e8b52593925b4bc9$export$98e6a39c04603d36(encoded[1], $e8b52593925b4bc9$export$86a7aca748b1e260, context);
    } catch (err) {
        throw new Error(`failed to parse first argument in palette expression: ${err.message}`);
    }
    const colors = encoded[2];
    if (!Array.isArray(colors)) throw new Error('the second argument of palette must be an array');
    const parsedColors = new Array(colors.length);
    for(let i = 0; i < parsedColors.length; i++){
        let color;
        try {
            color = $e8b52593925b4bc9$export$98e6a39c04603d36(colors[i], $e8b52593925b4bc9$export$2cd82751acc0e609, context);
        } catch (err) {
            throw new Error(`failed to parse color at index ${i} in palette expression: ${err.message}`);
        }
        if (!(color instanceof $e8b52593925b4bc9$export$eb63e96e0913dda4)) throw new Error(`the palette color at index ${i} must be a literal value`);
        parsedColors[i] = color;
    }
    return [
        index,
        ...parsedColors
    ];
}
/**
 * @param {Array<ArgValidator>} validators A chain of argument validators.  The last validator is expected
 * to return the parsed arguments.
 * @return {Parser} The parser.
 */ function $e8b52593925b4bc9$var$createCallExpressionParser(...validators) {
    return function(encoded, returnType, context) {
        const operator = encoded[0];
        /**
     * @type {Array<Expression>}
     */ let args;
        for(let i = 0; i < validators.length; i++){
            const parsed = validators[i](encoded, returnType, context);
            if (i == validators.length - 1) {
                if (!parsed) throw new Error('expected last argument validator to return the parsed args');
                args = parsed;
            }
        }
        return new $e8b52593925b4bc9$export$6f3d80189eb72cd4(returnType, operator, ...args);
    };
}
/**
 * @param {Array} encoded The encoded expression.
 * @param {number} returnType The expected return type of the call expression.
 * @param {ParsingContext} context The parsing context.
 * @return {Expression} The parsed expression.
 */ function $e8b52593925b4bc9$var$parseCallExpression(encoded, returnType, context) {
    const operator = encoded[0];
    const parser = $e8b52593925b4bc9$var$parsers[operator];
    if (!parser) throw new Error(`unknown operator: ${operator}`);
    return parser(encoded, returnType, context);
}
function $e8b52593925b4bc9$export$8da88d86d10c1295(geometry) {
    if (!geometry) return '';
    const type = geometry.getType();
    switch(type){
        case 'Point':
        case 'LineString':
        case 'Polygon':
            return type;
        case 'MultiPoint':
        case 'MultiLineString':
        case 'MultiPolygon':
            return /** @type {'Point'|'LineString'|'Polygon'} */ type.substring(5);
        case 'Circle':
            return 'Polygon';
        case 'GeometryCollection':
            return $e8b52593925b4bc9$export$8da88d86d10c1295(/** @type {import("../geom/GeometryCollection.js").default} */ geometry.getGeometries()[0]);
        default:
            return '';
    }
}


function $24bd7dccc97f8a38$export$c18f39f0e136c26() {
    return {
        variables: {},
        properties: {},
        resolution: NaN,
        featureId: null,
        geometryType: ''
    };
}
function $24bd7dccc97f8a38$export$b5f535122a9211f0(encoded, type, context) {
    const expression = (0, $e8b52593925b4bc9$export$98e6a39c04603d36)(encoded, type, context);
    return $24bd7dccc97f8a38$var$compileExpression(expression, context);
}
/**
 * @param {import("./expression.js").Expression} expression The expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $24bd7dccc97f8a38$var$compileExpression(expression, context) {
    if (expression instanceof (0, $e8b52593925b4bc9$export$eb63e96e0913dda4)) {
        // convert colors to array if possible
        if (expression.type === (0, $e8b52593925b4bc9$export$2cd82751acc0e609) && typeof expression.value === 'string') {
            const colorValue = (0, $6c864c0c7b61b9b5$export$3004f64547af360e)(expression.value);
            return function() {
                return colorValue;
            };
        }
        return function() {
            return expression.value;
        };
    }
    const operator = expression.operator;
    switch(operator){
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Number:
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).String:
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Coalesce:
            return $24bd7dccc97f8a38$var$compileAssertionExpression(expression, context);
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Get:
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Var:
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Has:
            return $24bd7dccc97f8a38$var$compileAccessorExpression(expression, context);
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Id:
            return (context)=>context.featureId;
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).GeometryType:
            return (context)=>context.geometryType;
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Concat:
            {
                const args = expression.args.map((e)=>$24bd7dccc97f8a38$var$compileExpression(e, context));
                return (context)=>''.concat(...args.map((arg)=>arg(context).toString()));
            }
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Resolution:
            return (context)=>context.resolution;
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Any:
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).All:
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Between:
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).In:
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Not:
            return $24bd7dccc97f8a38$var$compileLogicalExpression(expression, context);
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Equal:
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).NotEqual:
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).LessThan:
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).LessThanOrEqualTo:
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).GreaterThan:
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).GreaterThanOrEqualTo:
            return $24bd7dccc97f8a38$var$compileComparisonExpression(expression, context);
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Multiply:
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Divide:
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Add:
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Subtract:
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Clamp:
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Mod:
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Pow:
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Abs:
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Floor:
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Ceil:
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Round:
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Sin:
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Cos:
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Atan:
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Sqrt:
            return $24bd7dccc97f8a38$var$compileNumericExpression(expression, context);
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Case:
            return $24bd7dccc97f8a38$var$compileCaseExpression(expression, context);
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Match:
            return $24bd7dccc97f8a38$var$compileMatchExpression(expression, context);
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Interpolate:
            return $24bd7dccc97f8a38$var$compileInterpolateExpression(expression, context);
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).ToString:
            return $24bd7dccc97f8a38$var$compileConvertExpression(expression, context);
        default:
            throw new Error(`Unsupported operator ${operator}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $24bd7dccc97f8a38$var$compileAssertionExpression(expression, context) {
    const type = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $24bd7dccc97f8a38$var$compileExpression(expression.args[i], context);
    switch(type){
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Coalesce:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    const value = args[i](context);
                    if (typeof value !== 'undefined' && value !== null) return value;
                }
                throw new Error('Expected one of the values to be non-null');
            };
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Number:
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).String:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    const value = args[i](context);
                    if (typeof value === type) return value;
                }
                throw new Error(`Expected one of the values to be a ${type}`);
            };
        default:
            throw new Error(`Unsupported assertion operator ${type}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $24bd7dccc97f8a38$var$compileAccessorExpression(expression, context) {
    const nameExpression = /** @type {LiteralExpression} */ expression.args[0];
    const name = /** @type {string} */ nameExpression.value;
    switch(expression.operator){
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Get:
            return (context)=>{
                const args = expression.args;
                let value = context.properties[name];
                for(let i = 1, ii = args.length; i < ii; ++i){
                    const keyExpression = /** @type {LiteralExpression} */ args[i];
                    const key = /** @type {string|number} */ keyExpression.value;
                    value = value[key];
                }
                return value;
            };
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Var:
            return (context)=>context.variables[name];
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Has:
            return (context)=>{
                const args = expression.args;
                if (!(name in context.properties)) return false;
                let value = context.properties[name];
                for(let i = 1, ii = args.length; i < ii; ++i){
                    const keyExpression = /** @type {LiteralExpression} */ args[i];
                    const key = /** @type {string|number} */ keyExpression.value;
                    if (!value || !Object.hasOwn(value, key)) return false;
                    value = value[key];
                }
                return true;
            };
        default:
            throw new Error(`Unsupported accessor operator ${expression.operator}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {BooleanEvaluator} The evaluator function.
 */ function $24bd7dccc97f8a38$var$compileComparisonExpression(expression, context) {
    const op = expression.operator;
    const left = $24bd7dccc97f8a38$var$compileExpression(expression.args[0], context);
    const right = $24bd7dccc97f8a38$var$compileExpression(expression.args[1], context);
    switch(op){
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Equal:
            return (context)=>left(context) === right(context);
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).NotEqual:
            return (context)=>left(context) !== right(context);
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).LessThan:
            return (context)=>left(context) < right(context);
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).LessThanOrEqualTo:
            return (context)=>left(context) <= right(context);
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).GreaterThan:
            return (context)=>left(context) > right(context);
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).GreaterThanOrEqualTo:
            return (context)=>left(context) >= right(context);
        default:
            throw new Error(`Unsupported comparison operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {BooleanEvaluator} The evaluator function.
 */ function $24bd7dccc97f8a38$var$compileLogicalExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $24bd7dccc97f8a38$var$compileExpression(expression.args[i], context);
    switch(op){
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Any:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    if (args[i](context)) return true;
                }
                return false;
            };
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).All:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    if (!args[i](context)) return false;
                }
                return true;
            };
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Between:
            return (context)=>{
                const value = args[0](context);
                const min = args[1](context);
                const max = args[2](context);
                return value >= min && value <= max;
            };
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).In:
            return (context)=>{
                const value = args[0](context);
                for(let i = 1; i < length; ++i){
                    if (value === args[i](context)) return true;
                }
                return false;
            };
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Not:
            return (context)=>!args[0](context);
        default:
            throw new Error(`Unsupported logical operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {NumberEvaluator} The evaluator function.
 */ function $24bd7dccc97f8a38$var$compileNumericExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $24bd7dccc97f8a38$var$compileExpression(expression.args[i], context);
    switch(op){
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Multiply:
            return (context)=>{
                let value = 1;
                for(let i = 0; i < length; ++i)value *= args[i](context);
                return value;
            };
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Divide:
            return (context)=>args[0](context) / args[1](context);
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Add:
            return (context)=>{
                let value = 0;
                for(let i = 0; i < length; ++i)value += args[i](context);
                return value;
            };
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Subtract:
            return (context)=>args[0](context) - args[1](context);
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Clamp:
            return (context)=>{
                const value = args[0](context);
                const min = args[1](context);
                if (value < min) return min;
                const max = args[2](context);
                if (value > max) return max;
                return value;
            };
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Mod:
            return (context)=>args[0](context) % args[1](context);
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Pow:
            return (context)=>Math.pow(args[0](context), args[1](context));
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Abs:
            return (context)=>Math.abs(args[0](context));
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Floor:
            return (context)=>Math.floor(args[0](context));
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Ceil:
            return (context)=>Math.ceil(args[0](context));
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Round:
            return (context)=>Math.round(args[0](context));
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Sin:
            return (context)=>Math.sin(args[0](context));
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Cos:
            return (context)=>Math.cos(args[0](context));
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Atan:
            if (length === 2) return (context)=>Math.atan2(args[0](context), args[1](context));
            return (context)=>Math.atan(args[0](context));
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).Sqrt:
            return (context)=>Math.sqrt(args[0](context));
        default:
            throw new Error(`Unsupported numeric operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $24bd7dccc97f8a38$var$compileCaseExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $24bd7dccc97f8a38$var$compileExpression(expression.args[i], context);
    return (context)=>{
        for(let i = 0; i < length - 1; i += 2){
            const condition = args[i](context);
            if (condition) return args[i + 1](context);
        }
        return args[length - 1](context);
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $24bd7dccc97f8a38$var$compileMatchExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $24bd7dccc97f8a38$var$compileExpression(expression.args[i], context);
    return (context)=>{
        const value = args[0](context);
        for(let i = 1; i < length - 1; i += 2){
            if (value === args[i](context)) return args[i + 1](context);
        }
        return args[length - 1](context);
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $24bd7dccc97f8a38$var$compileInterpolateExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $24bd7dccc97f8a38$var$compileExpression(expression.args[i], context);
    return (context)=>{
        const base = args[0](context);
        const value = args[1](context);
        let previousInput;
        let previousOutput;
        for(let i = 2; i < length; i += 2){
            const input = args[i](context);
            let output = args[i + 1](context);
            const isColor = Array.isArray(output);
            if (isColor) output = (0, $6c864c0c7b61b9b5$export$138c09bdd6bd797c)(output);
            if (input >= value) {
                if (i === 2) return output;
                if (isColor) return $24bd7dccc97f8a38$var$interpolateColor(base, value, previousInput, previousOutput, input, output);
                return $24bd7dccc97f8a38$var$interpolateNumber(base, value, previousInput, previousOutput, input, output);
            }
            previousInput = input;
            previousOutput = output;
        }
        return previousOutput;
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $24bd7dccc97f8a38$var$compileConvertExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $24bd7dccc97f8a38$var$compileExpression(expression.args[i], context);
    switch(op){
        case (0, $e8b52593925b4bc9$export$2655e45458bc48f3).ToString:
            return (context)=>{
                const value = args[0](context);
                if (expression.args[0].type === (0, $e8b52593925b4bc9$export$2cd82751acc0e609)) return (0, $6c864c0c7b61b9b5$export$f84e8e69fd4488a5)(value);
                return value.toString();
            };
        default:
            throw new Error(`Unsupported convert operator ${op}`);
    }
}
/**
 * @param {number} base The base.
 * @param {number} value The value.
 * @param {number} input1 The first input value.
 * @param {number} output1 The first output value.
 * @param {number} input2 The second input value.
 * @param {number} output2 The second output value.
 * @return {number} The interpolated value.
 */ function $24bd7dccc97f8a38$var$interpolateNumber(base, value, input1, output1, input2, output2) {
    const delta = input2 - input1;
    if (delta === 0) return output1;
    const along = value - input1;
    const factor = base === 1 ? along / delta : (Math.pow(base, along) - 1) / (Math.pow(base, delta) - 1);
    return output1 + factor * (output2 - output1);
}
/**
 * @param {number} base The base.
 * @param {number} value The value.
 * @param {number} input1 The first input value.
 * @param {import('../color.js').Color} rgba1 The first output value.
 * @param {number} input2 The second input value.
 * @param {import('../color.js').Color} rgba2 The second output value.
 * @return {import('../color.js').Color} The interpolated color.
 */ function $24bd7dccc97f8a38$var$interpolateColor(base, value, input1, rgba1, input2, rgba2) {
    const delta = input2 - input1;
    if (delta === 0) return rgba1;
    const lcha1 = (0, $6c864c0c7b61b9b5$export$44fb54fa2e0c0d4)(rgba1);
    const lcha2 = (0, $6c864c0c7b61b9b5$export$44fb54fa2e0c0d4)(rgba2);
    let deltaHue = lcha2[2] - lcha1[2];
    if (deltaHue > 180) deltaHue -= 360;
    else if (deltaHue < -180) deltaHue += 360;
    const lcha = [
        $24bd7dccc97f8a38$var$interpolateNumber(base, value, input1, lcha1[0], input2, lcha2[0]),
        $24bd7dccc97f8a38$var$interpolateNumber(base, value, input1, lcha1[1], input2, lcha2[1]),
        lcha1[2] + $24bd7dccc97f8a38$var$interpolateNumber(base, value, input1, 0, input2, deltaHue),
        $24bd7dccc97f8a38$var$interpolateNumber(base, value, input1, rgba1[3], input2, rgba2[3])
    ];
    return (0, $6c864c0c7b61b9b5$export$27cc94530c050f00)(lcha);
}





/**
 * @module ol/style/Circle
 */ /**
 * @module ol/style/RegularShape
 */ /**
 * @module ol/ImageState
 */ /**
 * @enum {number}
 */ var $b7bb8c7fd6676c50$export$2e2bcd8739ae039 = {
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    ERROR: 3,
    EMPTY: 4
};



/**
 * @module ol/colorlike
 */ 


/**
 * @module ol/style/IconImage
 */ /**
 * @module ol/Image
 */ 





/**
 * A function that takes an {@link module:ol/Image~ImageWrapper} for the image and a
 * `{string}` for the src as arguments. It is supposed to make it so the
 * underlying image {@link module:ol/Image~ImageWrapper#getImage} is assigned the
 * content specified by the src. If not specified, the default is
 *
 *     function(image, src) {
 *       image.getImage().src = src;
 *     }
 *
 * Providing a custom `imageLoadFunction` can be useful to load images with
 * post requests or - in general - through XHR requests, where the src of the
 * image element would be set to a data URI when the content is loaded.
 *
 * @typedef {function(import("./Image.js").default, string): void} LoadFunction
 * @api
 */ /**
 * @typedef {Object} ImageObject
 * @property {import("./extent.js").Extent} [extent] Extent, if different from the requested one.
 * @property {import("./resolution.js").ResolutionLike} [resolution] Resolution, if different from the requested one.
 * When x and y resolution are different, use the array type (`[xResolution, yResolution]`).
 * @property {number} [pixelRatio] Pixel ratio, if different from the requested one.
 * @property {import('./DataTile.js').ImageLike} image Image.
 */ /**
 * Loader function used for image sources. Receives extent, resolution and pixel ratio as arguments.
 * For images that cover any extent and resolution (static images), the loader function should not accept
 * any arguments. The function returns an {@link import("./DataTile.js").ImageLike image}, an
 * {@link import("./Image.js").ImageObject image object}, or a promise for the same.
 * For loaders that generate images, the promise should not resolve until the image is loaded.
 * If the returned image does not match the extent, resolution or pixel ratio passed to the loader,
 * it has to return an {@link import("./Image.js").ImageObject image object} with the `image` and the
 * correct `extent`, `resolution` and `pixelRatio`.
 *
 * @typedef {function(import("./extent.js").Extent, number, number, (function(HTMLImageElement, string): void)=): import("./DataTile.js").ImageLike|ImageObject|Promise<import("./DataTile.js").ImageLike|ImageObject>} Loader
 * @api
 */ /**
 * Loader function used for image sources. Receives extent, resolution and pixel ratio as arguments.
 * The function returns a promise for an  {@link import("./Image.js").ImageObject image object}.
 *
 * @typedef {function(import("./extent.js").Extent, number, number, (function(HTMLImageElement, string): void)=): Promise<import("./DataTile.js").ImageLike|ImageObject>} ImageObjectPromiseLoader
 */ class $2ec9ee9b9239c7e8$var$ImageWrapper extends (0, $8c60cc978e8694f4$export$2e2bcd8739ae039) {
    /**
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {number|Array<number>|undefined} resolution Resolution. If provided as array, x and y
   * resolution will be assumed.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("./ImageState.js").default|Loader} stateOrLoader State.
   */ constructor(extent, resolution, pixelRatio, stateOrLoader){
        super();
        /**
     * @protected
     * @type {import("./extent.js").Extent}
     */ this.extent = extent;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @protected
     * @type {number|Array<number>|undefined}
     */ this.resolution = resolution;
        /**
     * @protected
     * @type {import("./ImageState.js").default}
     */ this.state = typeof stateOrLoader === 'function' ? (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).IDLE : stateOrLoader;
        /**
     * @private
     * @type {import('./DataTile.js').ImageLike|null}
     */ this.image_ = null;
        /**
     * @protected
     * @type {Loader|null}
     */ this.loader = typeof stateOrLoader === 'function' ? stateOrLoader : null;
    }
    /**
   * @protected
   */ changed() {
        this.dispatchEvent((0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CHANGE);
    }
    /**
   * @return {import("./extent.js").Extent} Extent.
   */ getExtent() {
        return this.extent;
    }
    /**
   * @return {import('./DataTile.js').ImageLike} Image.
   */ getImage() {
        return this.image_;
    }
    /**
   * @return {number} PixelRatio.
   */ getPixelRatio() {
        return this.pixelRatio_;
    }
    /**
   * @return {number|Array<number>} Resolution.
   */ getResolution() {
        return /** @type {number} */ this.resolution;
    }
    /**
   * @return {import("./ImageState.js").default} State.
   */ getState() {
        return this.state;
    }
    /**
   * Load not yet loaded URI.
   */ load() {
        if (this.state == (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).IDLE) {
            if (this.loader) {
                this.state = (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADING;
                this.changed();
                const resolution = this.getResolution();
                const requestResolution = Array.isArray(resolution) ? resolution[0] : resolution;
                (0, $7efea016d660e267$export$4dbaaf6c79705e6c)(()=>this.loader(this.getExtent(), requestResolution, this.getPixelRatio())).then((image)=>{
                    if ('image' in image) this.image_ = image.image;
                    if ('extent' in image) this.extent = image.extent;
                    if ('resolution' in image) this.resolution = image.resolution;
                    if ('pixelRatio' in image) this.pixelRatio_ = image.pixelRatio;
                    if (image instanceof HTMLImageElement || (0, $013e07c1ef6d00ad$export$7478563940788376) && image instanceof ImageBitmap || image instanceof HTMLCanvasElement || image instanceof HTMLVideoElement) this.image_ = image;
                    this.state = (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADED;
                }).catch((error)=>{
                    this.state = (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).ERROR;
                    console.error(error); // eslint-disable-line no-console
                }).finally(()=>this.changed());
            }
        }
    }
    /**
   * @param {import('./DataTile.js').ImageLike} image The image.
   */ setImage(image) {
        this.image_ = image;
    }
    /**
   * @param {number|Array<number>} resolution Resolution.
   */ setResolution(resolution) {
        this.resolution = resolution;
    }
}
function $2ec9ee9b9239c7e8$export$bc96ecc7c2a50764(image, loadHandler, errorHandler) {
    const img = /** @type {HTMLImageElement} */ image;
    let listening = true;
    let decoding = false;
    let loaded = false;
    const listenerKeys = [
        (0, $8061a5de9380012b$export$8d2a95bc11b44725)(img, (0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).LOAD, function() {
            loaded = true;
            if (!decoding) loadHandler();
        })
    ];
    if (img.src && (0, $013e07c1ef6d00ad$export$716f8695eedb9bad)) {
        decoding = true;
        img.decode().then(function() {
            if (listening) loadHandler();
        }).catch(function(error) {
            if (listening) {
                if (loaded) loadHandler();
                else errorHandler();
            }
        });
    } else listenerKeys.push((0, $8061a5de9380012b$export$8d2a95bc11b44725)(img, (0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).ERROR, errorHandler));
    return function unlisten() {
        listening = false;
        listenerKeys.forEach((0, $8061a5de9380012b$export$b0a21c8b3c1c921));
    };
}
function $2ec9ee9b9239c7e8$export$11e63f7b0f3d9900(image, src) {
    return new Promise((resolve, reject)=>{
        function handleLoad() {
            unlisten();
            resolve(image);
        }
        function handleError() {
            unlisten();
            reject(new Error('Image load error'));
        }
        function unlisten() {
            image.removeEventListener('load', handleLoad);
            image.removeEventListener('error', handleError);
        }
        image.addEventListener('load', handleLoad);
        image.addEventListener('error', handleError);
        if (src) image.src = src;
    });
}
function $2ec9ee9b9239c7e8$export$a9e5af241c1bd389(image, src) {
    if (src) image.src = src;
    return image.src && (0, $013e07c1ef6d00ad$export$716f8695eedb9bad) ? new Promise((resolve, reject)=>image.decode().then(()=>resolve(image)).catch((e)=>image.complete && image.width ? resolve(image) : reject(e))) : $2ec9ee9b9239c7e8$export$11e63f7b0f3d9900(image);
}
function $2ec9ee9b9239c7e8$export$2f872c0f2117be69(image, src) {
    if (src) image.src = src;
    return image.src && (0, $013e07c1ef6d00ad$export$716f8695eedb9bad) && (0, $013e07c1ef6d00ad$export$7478563940788376) ? image.decode().then(()=>createImageBitmap(image)).catch((e)=>{
        if (image.complete && image.width) return image;
        throw e;
    }) : $2ec9ee9b9239c7e8$export$a9e5af241c1bd389(image);
}
var $2ec9ee9b9239c7e8$export$2e2bcd8739ae039 = $2ec9ee9b9239c7e8$var$ImageWrapper;







/**
 * @module ol/style/IconImageCache
 */ 


/**
 * @classdesc
 * Singleton class. Available through {@link module:ol/style/IconImageCache.shared}.
 */ class $3eb09d66fc28233e$var$IconImageCache {
    constructor(){
        /**
     * @type {!Object<string, import("./IconImage.js").default>}
     * @private
     */ this.cache_ = {};
        /**
     * @type {!Object<string, CanvasPattern>}
     * @private
     */ this.patternCache_ = {};
        /**
     * @type {number}
     * @private
     */ this.cacheSize_ = 0;
        /**
     * @type {number}
     * @private
     */ this.maxCacheSize_ = 1024;
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        this.cache_ = {};
        this.patternCache_ = {};
        this.cacheSize_ = 0;
    }
    /**
   * @return {boolean} Can expire cache.
   */ canExpireCache() {
        return this.cacheSize_ > this.maxCacheSize_;
    }
    /**
   * FIXME empty description for jsdoc
   */ expire() {
        if (this.canExpireCache()) {
            let i = 0;
            for(const key in this.cache_){
                const iconImage = this.cache_[key];
                if ((i++ & 3) === 0 && !iconImage.hasListener()) {
                    delete this.cache_[key];
                    delete this.patternCache_[key];
                    --this.cacheSize_;
                }
            }
        }
    }
    /**
   * @param {string} src Src.
   * @param {import("../color.js").Color|string|null} color Color.
   * @return {import("./IconImage.js").default} Icon image.
   */ get(src, color) {
        const key = $3eb09d66fc28233e$export$611736262b635f8d(src, color);
        const icon = key in this.cache_ ? this.cache_[key] : null;
        return icon;
    }
    /**
   * @param {string} src Src.
   * @param {import("../color.js").Color|string|null} color Color.
   * @return {CanvasPattern} Icon image.
   */ getPattern(src, color) {
        const key = $3eb09d66fc28233e$export$611736262b635f8d(src, color);
        return key in this.patternCache_ ? this.patternCache_[key] : null;
    }
    /**
   * @param {string} src Src.
   * @param {import("../color.js").Color|string|null} color Color.
   * @param {import("./IconImage.js").default|null} iconImage Icon image.
   * @param {boolean} [pattern] Also cache a `'repeat'` pattern with this `iconImage`.
   */ set(src, color, iconImage, pattern) {
        const key = $3eb09d66fc28233e$export$611736262b635f8d(src, color);
        const update = key in this.cache_;
        this.cache_[key] = iconImage;
        if (pattern) {
            if (iconImage.getImageState() === (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).IDLE) iconImage.load();
            if (iconImage.getImageState() === (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADING) iconImage.ready().then(()=>{
                this.patternCache_[key] = (0, $5ce605ba3ee034a0$export$fcb72ce088a6632c)().createPattern(iconImage.getImage(1), 'repeat');
            });
            else this.patternCache_[key] = (0, $5ce605ba3ee034a0$export$fcb72ce088a6632c)().createPattern(iconImage.getImage(1), 'repeat');
        }
        if (!update) ++this.cacheSize_;
    }
    /**
   * Set the cache size of the icon cache. Default is `1024`. Change this value when
   * your map uses more than 1024 different icon images and you are not caching icon
   * styles on the application level.
   * @param {number} maxCacheSize Cache max size.
   * @api
   */ setSize(maxCacheSize) {
        this.maxCacheSize_ = maxCacheSize;
        this.expire();
    }
}
function $3eb09d66fc28233e$export$611736262b635f8d(src, color) {
    const colorString = color ? (0, $6c864c0c7b61b9b5$export$75093a47a9fa838d)(color) : 'null';
    return src + ':' + colorString;
}
var $3eb09d66fc28233e$export$2e2bcd8739ae039 = $3eb09d66fc28233e$var$IconImageCache;
const $3eb09d66fc28233e$export$747ccdf771a87ab8 = new $3eb09d66fc28233e$var$IconImageCache();


/**
 * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
 */ let $c8822aedb641e9f2$var$taintedTestContext = null;
class $c8822aedb641e9f2$var$IconImage extends (0, $8c60cc978e8694f4$export$2e2bcd8739ae039) {
    /**
   * @param {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap|null} image Image.
   * @param {string|undefined} src Src.
   * @param {import('../dom.js').ImageAttributes} imageAttributes Image attributes options.
   * @param {import("../ImageState.js").default|undefined} imageState Image state.
   * @param {import("../color.js").Color|string|null} color Color.
   */ constructor(image, src, imageAttributes, imageState, color){
        super();
        /**
     * @private
     * @type {HTMLImageElement|OffscreenCanvas|HTMLCanvasElement|ImageBitmap}
     */ this.hitDetectionImage_ = null;
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap|null}
     */ this.image_ = image;
        /**
     * @private
     * @type {string|null}
     */ this.crossOrigin_ = imageAttributes?.crossOrigin;
        /**
     * @private
     * @type {ReferrerPolicy}
     */ this.referrerPolicy_ = imageAttributes?.referrerPolicy;
        /**
     * @private
     * @type {Object<number, HTMLCanvasElement|OffscreenCanvas>}
     */ this.canvas_ = {};
        /**
     * @private
     * @type {import("../color.js").Color|string|null}
     */ this.color_ = color;
        /**
     * @private
     * @type {import("../ImageState.js").default}
     */ this.imageState_ = imageState === undefined ? (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).IDLE : imageState;
        /**
     * @private
     * @type {import("../size.js").Size|null}
     */ this.size_ = image && image.width && image.height ? [
            image.width,
            image.height
        ] : null;
        /**
     * @private
     * @type {string|undefined}
     */ this.src_ = src;
        /**
     * @private
     */ this.tainted_;
        /**
     * @private
     * @type {Promise<void>|null}
     */ this.ready_ = null;
    }
    /**
   * @private
   */ initializeImage_() {
        this.image_ = new Image();
        if (this.crossOrigin_ !== null) this.image_.crossOrigin = this.crossOrigin_;
        if (this.referrerPolicy_ !== undefined) this.image_.referrerPolicy = this.referrerPolicy_;
    }
    /**
   * @private
   * @return {boolean} The image canvas is tainted.
   */ isTainted_() {
        if (this.tainted_ === undefined && this.imageState_ === (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADED) {
            if (!$c8822aedb641e9f2$var$taintedTestContext) $c8822aedb641e9f2$var$taintedTestContext = (0, $5ce605ba3ee034a0$export$9e05d10eae75c464)(1, 1, undefined, {
                willReadFrequently: true
            });
            $c8822aedb641e9f2$var$taintedTestContext.drawImage(this.image_, 0, 0);
            try {
                $c8822aedb641e9f2$var$taintedTestContext.getImageData(0, 0, 1, 1);
                this.tainted_ = false;
            } catch  {
                $c8822aedb641e9f2$var$taintedTestContext = null;
                this.tainted_ = true;
            }
        }
        return this.tainted_ === true;
    }
    /**
   * @private
   */ dispatchChangeEvent_() {
        this.dispatchEvent((0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CHANGE);
    }
    /**
   * @private
   */ handleImageError_() {
        this.imageState_ = (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).ERROR;
        this.dispatchChangeEvent_();
    }
    /**
   * @private
   */ handleImageLoad_() {
        this.imageState_ = (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADED;
        this.size_ = [
            this.image_.width,
            this.image_.height
        ];
        this.dispatchChangeEvent_();
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap} Image or Canvas element or image bitmap.
   */ getImage(pixelRatio) {
        if (!this.image_) this.initializeImage_();
        this.replaceColor_(pixelRatio);
        return this.canvas_[pixelRatio] ? this.canvas_[pixelRatio] : this.image_;
    }
    /**
   * @param {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap} image Image.
   */ setImage(image) {
        this.image_ = image;
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Image or Canvas element.
   */ getPixelRatio(pixelRatio) {
        this.replaceColor_(pixelRatio);
        return this.canvas_[pixelRatio] ? pixelRatio : 1;
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   */ getImageState() {
        return this.imageState_;
    }
    /**
   * @return {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap} Image element.
   */ getHitDetectionImage() {
        if (!this.image_) this.initializeImage_();
        if (!this.hitDetectionImage_) {
            if (this.isTainted_()) {
                const width = this.size_[0];
                const height = this.size_[1];
                const context = (0, $5ce605ba3ee034a0$export$9e05d10eae75c464)(width, height);
                context.fillRect(0, 0, width, height);
                this.hitDetectionImage_ = context.canvas;
            } else this.hitDetectionImage_ = this.image_;
        }
        return this.hitDetectionImage_;
    }
    /**
   * Get the size of the icon (in pixels).
   * @return {import("../size.js").Size} Image size.
   */ getSize() {
        return this.size_;
    }
    /**
   * @return {string|undefined} Image src.
   */ getSrc() {
        return this.src_;
    }
    /**
   * Load not yet loaded URI.
   */ load() {
        if (this.imageState_ !== (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).IDLE) return;
        if (!this.image_) this.initializeImage_();
        this.imageState_ = (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADING;
        try {
            if (this.src_ !== undefined) /** @type {HTMLImageElement} */ this.image_.src = this.src_;
        } catch  {
            this.handleImageError_();
        }
        if (this.image_ instanceof HTMLImageElement) (0, $2ec9ee9b9239c7e8$export$a9e5af241c1bd389)(this.image_, this.src_).then((image)=>{
            this.image_ = image;
            this.handleImageLoad_();
        }).catch(this.handleImageError_.bind(this));
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @private
   */ replaceColor_(pixelRatio) {
        if (!this.color_ || this.canvas_[pixelRatio] || this.imageState_ !== (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADED) return;
        const image = this.image_;
        const ctx = (0, $5ce605ba3ee034a0$export$9e05d10eae75c464)(Math.ceil(image.width * pixelRatio), Math.ceil(image.height * pixelRatio));
        const canvas = ctx.canvas;
        ctx.scale(pixelRatio, pixelRatio);
        ctx.drawImage(image, 0, 0);
        ctx.globalCompositeOperation = 'multiply';
        ctx.fillStyle = (0, $6c864c0c7b61b9b5$export$590567be997858b6)(this.color_);
        ctx.fillRect(0, 0, canvas.width / pixelRatio, canvas.height / pixelRatio);
        ctx.globalCompositeOperation = 'destination-in';
        ctx.drawImage(image, 0, 0);
        this.canvas_[pixelRatio] = canvas;
    }
    /**
   * @return {Promise<void>} Promise that resolves when the image is loaded.
   */ ready() {
        if (!this.ready_) this.ready_ = new Promise((resolve)=>{
            if (this.imageState_ === (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADED || this.imageState_ === (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).ERROR) resolve();
            else {
                const onChange = ()=>{
                    if (this.imageState_ === (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADED || this.imageState_ === (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).ERROR) {
                        this.removeEventListener((0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CHANGE, onChange);
                        resolve();
                    }
                };
                this.addEventListener((0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CHANGE, onChange);
            }
        });
        return this.ready_;
    }
}
function $c8822aedb641e9f2$export$3988ae62b71be9a3(image, src, imageAttributes, imageState, color, pattern) {
    let iconImage = src === undefined ? undefined : (0, $3eb09d66fc28233e$export$747ccdf771a87ab8).get(src, color);
    if (!iconImage) {
        iconImage = new $c8822aedb641e9f2$var$IconImage(image, image && 'src' in image ? image.src || undefined : src, imageAttributes, imageState, color);
        (0, $3eb09d66fc28233e$export$747ccdf771a87ab8).set(src, color, iconImage, pattern);
    }
    if (pattern && iconImage && !(0, $3eb09d66fc28233e$export$747ccdf771a87ab8).getPattern(src, color)) (0, $3eb09d66fc28233e$export$747ccdf771a87ab8).set(src, color, iconImage, pattern);
    return iconImage;
}
var $c8822aedb641e9f2$export$2e2bcd8739ae039 = $c8822aedb641e9f2$var$IconImage;



function $bafa252a4f4b168a$export$dc5b1400ac3a10a8(color) {
    if (!color) return null;
    if (Array.isArray(color)) return (0, $6c864c0c7b61b9b5$export$f84e8e69fd4488a5)(color);
    if (typeof color === 'object' && 'src' in color) return $bafa252a4f4b168a$var$asCanvasPattern(color);
    return color;
}
/**
 * @param {PatternDescriptor} pattern Pattern descriptor.
 * @return {CanvasPattern|null} Canvas pattern or null if the pattern referenced in the
 * PatternDescriptor was not found in the icon image cache.
 */ function $bafa252a4f4b168a$var$asCanvasPattern(pattern) {
    if (!pattern.offset || !pattern.size) return (0, $3eb09d66fc28233e$export$747ccdf771a87ab8).getPattern(pattern.src, pattern.color);
    const cacheKey = pattern.src + ':' + pattern.offset;
    const canvasPattern = (0, $3eb09d66fc28233e$export$747ccdf771a87ab8).getPattern(cacheKey, pattern.color);
    if (canvasPattern) return canvasPattern;
    const iconImage = (0, $3eb09d66fc28233e$export$747ccdf771a87ab8).get(pattern.src, null);
    if (iconImage.getImageState() !== (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADED) return null;
    const patternCanvasContext = (0, $5ce605ba3ee034a0$export$9e05d10eae75c464)(pattern.size[0], pattern.size[1]);
    patternCanvasContext.drawImage(iconImage.getImage(1), pattern.offset[0], pattern.offset[1], pattern.size[0], pattern.size[1], 0, 0, pattern.size[0], pattern.size[1]);
    (0, $c8822aedb641e9f2$export$3988ae62b71be9a3)(patternCanvasContext.canvas, cacheKey, undefined, (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADED, pattern.color, true);
    return (0, $3eb09d66fc28233e$export$747ccdf771a87ab8).getPattern(cacheKey, pattern.color);
}



/**
 * @module ol/render/canvas
 */ 




const $3b9b2e731b8ee924$export$3847dfea4f8d4dfa = '10px sans-serif';
const $3b9b2e731b8ee924$export$c495d52ee3fd74b2 = '#000';
const $3b9b2e731b8ee924$export$17bd0c38d6ae694e = 'round';
const $3b9b2e731b8ee924$export$e21b4112fdc612fc = [];
const $3b9b2e731b8ee924$export$e06efc2409049f76 = 0;
const $3b9b2e731b8ee924$export$365eb9648cf19bd0 = 'round';
const $3b9b2e731b8ee924$export$80c1c01844597b7b = 10;
const $3b9b2e731b8ee924$export$e010c2b9c075c7a1 = 0;
const $3b9b2e731b8ee924$export$1eb2eaecacf2031e = '#000';
const $3b9b2e731b8ee924$export$94d53b95641b5766 = 'center';
const $3b9b2e731b8ee924$export$cf2279a1bff62eb = 'middle';
const $3b9b2e731b8ee924$export$40a9eeef55665a40 = [
    0,
    0,
    0,
    0
];
const $3b9b2e731b8ee924$export$79661f132c62010e = 1;
const $3b9b2e731b8ee924$export$1d36981fcadac93b = new (0, $4dd5119c2f9fa355$export$2e2bcd8739ae039)();
/**
 * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
 */ let $3b9b2e731b8ee924$var$measureContext = null;
/**
 * @type {string}
 */ let $3b9b2e731b8ee924$var$measureFont;
const $3b9b2e731b8ee924$export$7fdcec604f0b1fa7 = {};
const $3b9b2e731b8ee924$var$genericFontFamilies = new Set([
    'serif',
    'sans-serif',
    'monospace',
    'cursive',
    'fantasy',
    'system-ui',
    'ui-serif',
    'ui-sans-serif',
    'ui-monospace',
    'ui-rounded',
    'emoji',
    'math',
    'fangsong'
]);
/**
 * @param {string} style Css font-style
 * @param {string} weight Css font-weight
 * @param {string} family Css font-family
 * @return {string} Font key.
 */ function $3b9b2e731b8ee924$var$getFontKey(style, weight, family) {
    return `${style} ${weight} 16px "${family}"`;
}
const $3b9b2e731b8ee924$export$a534074a28fa87ff = function() {
    const retries = 100;
    let timeout, fontFaceSet;
    /**
   * @param {string} fontSpec Css font spec
   * @return {Promise<boolean>} Font with style and weight is available
   */ async function isAvailable(fontSpec) {
        await fontFaceSet.ready;
        const fontFaces = await fontFaceSet.load(fontSpec);
        if (fontFaces.length === 0) return false;
        const font = (0, $87710eafad36a2e8$export$5abde8a6aec4a131)(fontSpec);
        const checkFamily = font.families[0].toLowerCase();
        const checkWeight = font.weight;
        return fontFaces.some(/**
       * @param {import('../css.js').FontParameters} f Font.
       * @return {boolean} Font matches.
       */ (f)=>{
            const family = f.family.replace(/^['"]|['"]$/g, '').toLowerCase();
            const weight = (0, $87710eafad36a2e8$export$59230918eb9bd861)[f.weight] || f.weight;
            return family === checkFamily && f.style === font.style && weight == checkWeight;
        });
    }
    async function check() {
        await fontFaceSet.ready;
        let done = true;
        const checkedFontsProperties = $3b9b2e731b8ee924$export$1d36981fcadac93b.getProperties();
        const fonts = Object.keys(checkedFontsProperties).filter((key)=>checkedFontsProperties[key] < retries);
        for(let i = fonts.length - 1; i >= 0; --i){
            const font = fonts[i];
            let currentRetries = checkedFontsProperties[font];
            if (currentRetries < retries) {
                if (await isAvailable(font)) {
                    (0, $0669c62275461b52$export$42ffd38884aecdac)($3b9b2e731b8ee924$export$7fdcec604f0b1fa7);
                    $3b9b2e731b8ee924$export$1d36981fcadac93b.set(font, retries);
                } else {
                    currentRetries += 10;
                    $3b9b2e731b8ee924$export$1d36981fcadac93b.set(font, currentRetries, true);
                    if (currentRetries < retries) done = false;
                }
            }
        }
        timeout = undefined;
        if (!done) timeout = setTimeout(check, 100);
    }
    return async function(fontSpec) {
        if (!fontFaceSet) fontFaceSet = (0, $013e07c1ef6d00ad$export$98fcef3dc9973292) ? self.fonts : document.fonts;
        const font = (0, $87710eafad36a2e8$export$5abde8a6aec4a131)(fontSpec);
        if (!font) return;
        const families = font.families;
        let needCheck = false;
        for (const family of families){
            if ($3b9b2e731b8ee924$var$genericFontFamilies.has(family)) continue;
            const key = $3b9b2e731b8ee924$var$getFontKey(font.style, font.weight, family);
            if ($3b9b2e731b8ee924$export$1d36981fcadac93b.get(key) !== undefined) continue;
            $3b9b2e731b8ee924$export$1d36981fcadac93b.set(key, 0, true);
            needCheck = true;
        }
        if (needCheck) {
            clearTimeout(timeout);
            timeout = setTimeout(check, 100);
        }
    };
}();
const $3b9b2e731b8ee924$export$4feaf6852ff92513 = function() {
    /**
   * @type {HTMLDivElement}
   */ let measureElement;
    return function(fontSpec) {
        let height = $3b9b2e731b8ee924$export$7fdcec604f0b1fa7[fontSpec];
        if (height == undefined) {
            if (0, $013e07c1ef6d00ad$export$98fcef3dc9973292) {
                const font = (0, $87710eafad36a2e8$export$5abde8a6aec4a131)(fontSpec);
                const metrics = $3b9b2e731b8ee924$var$measureText(fontSpec, "\u017Dg");
                const lineHeight = isNaN(Number(font.lineHeight)) ? 1.2 : Number(font.lineHeight);
                height = lineHeight * (metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent);
            } else {
                if (!measureElement) {
                    measureElement = document.createElement('div');
                    measureElement.innerHTML = 'M';
                    measureElement.style.minHeight = '0';
                    measureElement.style.maxHeight = 'none';
                    measureElement.style.height = 'auto';
                    measureElement.style.padding = '0';
                    measureElement.style.border = 'none';
                    measureElement.style.position = 'absolute';
                    measureElement.style.display = 'block';
                    measureElement.style.left = '-99999px';
                }
                measureElement.style.font = fontSpec;
                document.body.appendChild(measureElement);
                height = measureElement.offsetHeight;
                document.body.removeChild(measureElement);
            }
            $3b9b2e731b8ee924$export$7fdcec604f0b1fa7[fontSpec] = height;
        }
        return height;
    };
}();
/**
 * @param {string} font Font.
 * @param {string} text Text.
 * @return {TextMetrics} Text metrics.
 */ function $3b9b2e731b8ee924$var$measureText(font, text) {
    if (!$3b9b2e731b8ee924$var$measureContext) $3b9b2e731b8ee924$var$measureContext = (0, $5ce605ba3ee034a0$export$9e05d10eae75c464)(1, 1);
    if (font != $3b9b2e731b8ee924$var$measureFont) {
        $3b9b2e731b8ee924$var$measureContext.font = font;
        $3b9b2e731b8ee924$var$measureFont = $3b9b2e731b8ee924$var$measureContext.font;
    }
    return $3b9b2e731b8ee924$var$measureContext.measureText(text);
}
function $3b9b2e731b8ee924$export$4ea92329b673abd1(font, text) {
    return $3b9b2e731b8ee924$var$measureText(font, text).width;
}
function $3b9b2e731b8ee924$export$915c7ba51467308f(font, text, cache) {
    if (text in cache) return cache[text];
    const width = text.split('\n').reduce((prev, curr)=>Math.max(prev, $3b9b2e731b8ee924$export$4ea92329b673abd1(font, curr)), 0);
    cache[text] = width;
    return width;
}
function $3b9b2e731b8ee924$export$7d7c13020df1e791(baseStyle, chunks) {
    const widths = [];
    const heights = [];
    const lineWidths = [];
    let width = 0;
    let lineWidth = 0;
    let height = 0;
    let lineHeight = 0;
    for(let i = 0, ii = chunks.length; i <= ii; i += 2){
        const text = chunks[i];
        if (text === '\n' || i === ii) {
            width = Math.max(width, lineWidth);
            lineWidths.push(lineWidth);
            lineWidth = 0;
            height += lineHeight;
            lineHeight = 0;
            continue;
        }
        const font = chunks[i + 1] || baseStyle.font;
        const currentWidth = $3b9b2e731b8ee924$export$4ea92329b673abd1(font, text);
        widths.push(currentWidth);
        lineWidth += currentWidth;
        const currentHeight = $3b9b2e731b8ee924$export$4feaf6852ff92513(font);
        heights.push(currentHeight);
        lineHeight = Math.max(lineHeight, currentHeight);
    }
    return {
        width: width,
        height: height,
        widths: widths,
        heights: heights,
        lineWidths: lineWidths
    };
}
function $3b9b2e731b8ee924$export$8ac4d72be78047e6(context, rotation, offsetX, offsetY) {
    if (rotation !== 0) {
        context.translate(offsetX, offsetY);
        context.rotate(rotation);
        context.translate(-offsetX, -offsetY);
    }
}
function $3b9b2e731b8ee924$export$3cb6f3a6e49cc0ee(context, transform, opacity, labelOrImage, originX, originY, w, h, x, y, scale) {
    context.save();
    if (opacity !== 1) {
        if (context.globalAlpha === undefined) context.globalAlpha = (context)=>context.globalAlpha *= opacity;
        else context.globalAlpha *= opacity;
    }
    if (transform) context.transform.apply(context, transform);
    if (/** @type {*} */ labelOrImage.contextInstructions) {
        // label
        context.translate(x, y);
        context.scale(scale[0], scale[1]);
        $3b9b2e731b8ee924$var$executeLabelInstructions(/** @type {Label} */ labelOrImage, context);
    } else if (scale[0] < 0 || scale[1] < 0) {
        // flipped image
        context.translate(x, y);
        context.scale(scale[0], scale[1]);
        context.drawImage(/** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */ labelOrImage, originX, originY, w, h, 0, 0, w, h);
    } else // if image not flipped translate and scale can be avoided
    context.drawImage(/** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */ labelOrImage, originX, originY, w, h, x, y, w * scale[0], h * scale[1]);
    context.restore();
}
/**
 * @param {Label} label Label.
 * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
 */ function $3b9b2e731b8ee924$var$executeLabelInstructions(label, context) {
    const contextInstructions = label.contextInstructions;
    for(let i = 0, ii = contextInstructions.length; i < ii; i += 2)if (Array.isArray(contextInstructions[i + 1])) context[contextInstructions[i]].apply(context, contextInstructions[i + 1]);
    else context[contextInstructions[i]] = contextInstructions[i + 1];
}




/**
 * @module ol/style/Image
 */ 

/**
 * @typedef {Object} Options
 * @property {number} opacity Opacity.
 * @property {boolean} rotateWithView If the image should get rotated with the view.
 * @property {number} rotation Rotation.
 * @property {number|import("../size.js").Size} scale Scale.
 * @property {Array<number>} displacement Displacement.
 * @property {import('../style/Style.js').DeclutterMode} declutterMode Declutter mode: `declutter`, `obstacle`, `none`.
 */ /**
 * @classdesc
 * A base class used for creating subclasses and not instantiated in
 * apps. Base class for {@link module:ol/style/Icon~Icon}, {@link module:ol/style/Circle~CircleStyle} and
 * {@link module:ol/style/RegularShape~RegularShape}.
 * @abstract
 * @api
 */ class $e869ab451c83a5dc$var$ImageStyle {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        /**
     * @private
     * @type {number}
     */ this.opacity_ = options.opacity;
        /**
     * @private
     * @type {boolean}
     */ this.rotateWithView_ = options.rotateWithView;
        /**
     * @private
     * @type {number}
     */ this.rotation_ = options.rotation;
        /**
     * @private
     * @type {number|import("../size.js").Size}
     */ this.scale_ = options.scale;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.scaleArray_ = (0, $e9727ecf69942748$export$a71a825ff42fb8e1)(options.scale);
        /**
     * @private
     * @type {Array<number>}
     */ this.displacement_ = options.displacement;
        /**
     * @private
     * @type {import('../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = options.declutterMode;
    }
    /**
   * Clones the style.
   * @return {ImageStyle} The cloned style.
   * @api
   */ clone() {
        const scale = this.getScale();
        return new $e869ab451c83a5dc$var$ImageStyle({
            opacity: this.getOpacity(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the symbolizer opacity.
   * @return {number} Opacity.
   * @api
   */ getOpacity() {
        return this.opacity_;
    }
    /**
   * Determine whether the symbolizer rotates with the map.
   * @return {boolean} Rotate with map.
   * @api
   */ getRotateWithView() {
        return this.rotateWithView_;
    }
    /**
   * Get the symoblizer rotation.
   * @return {number} Rotation.
   * @api
   */ getRotation() {
        return this.rotation_;
    }
    /**
   * Get the symbolizer scale.
   * @return {number|import("../size.js").Size} Scale.
   * @api
   */ getScale() {
        return this.scale_;
    }
    /**
   * Get the symbolizer scale array.
   * @return {import("../size.js").Size} Scale array.
   */ getScaleArray() {
        return this.scaleArray_;
    }
    /**
   * Get the displacement of the shape
   * @return {Array<number>} Shape's center displacement
   * @api
   */ getDisplacement() {
        return this.displacement_;
    }
    /**
   * Get the declutter mode of the shape
   * @return {import("./Style.js").DeclutterMode} Shape's declutter mode
   * @api
   */ getDeclutterMode() {
        return this.declutterMode_;
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @abstract
   * @return {Array<number>} Anchor.
   */ getAnchor() {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Get the image element for the symbolizer.
   * @abstract
   * @param {number} pixelRatio Pixel ratio.
   * @return {import('../DataTile.js').ImageLike} Image element.
   */ getImage(pixelRatio) {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @return {import('../DataTile.js').ImageLike} Image element.
   */ getHitDetectionImage() {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Get the image pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Pixel ratio.
   */ getPixelRatio(pixelRatio) {
        return 1;
    }
    /**
   * @abstract
   * @return {import("../ImageState.js").default} Image state.
   */ getImageState() {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @return {import("../size.js").Size} Image size.
   */ getImageSize() {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Get the origin of the symbolizer.
   * @abstract
   * @return {Array<number>} Origin.
   */ getOrigin() {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Get the size of the symbolizer (in pixels).
   * @abstract
   * @return {import("../size.js").Size} Size.
   */ getSize() {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Set the displacement.
   *
   * @param {Array<number>} displacement Displacement.
   * @api
   */ setDisplacement(displacement) {
        this.displacement_ = displacement;
    }
    /**
   * Set the opacity.
   *
   * @param {number} opacity Opacity.
   * @api
   */ setOpacity(opacity) {
        this.opacity_ = opacity;
    }
    /**
   * Set whether to rotate the style with the view.
   *
   * @param {boolean} rotateWithView Rotate with map.
   * @api
   */ setRotateWithView(rotateWithView) {
        this.rotateWithView_ = rotateWithView;
    }
    /**
   * Set the rotation.
   *
   * @param {number} rotation Rotation.
   * @api
   */ setRotation(rotation) {
        this.rotation_ = rotation;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size} scale Scale.
   * @api
   */ setScale(scale) {
        this.scale_ = scale;
        this.scaleArray_ = (0, $e9727ecf69942748$export$a71a825ff42fb8e1)(scale);
    }
    /**
   * @abstract
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ listenImageChange(listener) {
        (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Load not yet loaded URI.
   * @abstract
   */ load() {
        (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ unlistenImageChange(listener) {
        (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * @return {Promise<void>} `false` or Promise that resolves when the style is ready to use.
   */ ready() {
        return Promise.resolve();
    }
}
var $e869ab451c83a5dc$export$2e2bcd8739ae039 = $e869ab451c83a5dc$var$ImageStyle;


/**
 * Specify radius for regular polygons, or both radius and radius2 for stars.
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} points Number of points for stars and regular polygons. In case of a polygon, the number of points
 * is the number of sides.
 * @property {number} radius Radius of a regular polygon.
 * @property {number} [radius2] Second radius to make a star instead of a regular polygon.
 * @property {number} [angle=0] Shape's angle in radians. A value of 0 will have one of the shape's points facing up.
 * @property {Array<number>} [displacement=[0, 0]] Displacement of the shape in pixels.
 * Positive values will shift the shape right and up.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view.
 * @property {number|import("../size.js").Size} [scale=1] Scale. Unless two dimensional scaling is required a better
 * result may be obtained with appropriate settings for `radius` and `radius2`.
 * @property {import('./Style.js').DeclutterMode} [declutterMode] Declutter mode.
 */ /**
 * @typedef {Object} RenderOptions
 * @property {import("../colorlike.js").ColorLike|undefined} strokeStyle StrokeStyle.
 * @property {number} strokeWidth StrokeWidth.
 * @property {number} size Size.
 * @property {CanvasLineCap} lineCap LineCap.
 * @property {Array<number>|null} lineDash LineDash.
 * @property {number} lineDashOffset LineDashOffset.
 * @property {CanvasLineJoin} lineJoin LineJoin.
 * @property {number} miterLimit MiterLimit.
 */ /**
 * @classdesc
 * Set regular shape style for vector features. The resulting shape will be
 * a regular polygon when `radius` is provided, or a star when both `radius` and
 * `radius2` are provided.
 * @api
 */ class $5fad9a707e2de9d2$var$RegularShape extends (0, $e869ab451c83a5dc$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        super({
            opacity: 1,
            rotateWithView: options.rotateWithView !== undefined ? options.rotateWithView : false,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            scale: options.scale !== undefined ? options.scale : 1,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            declutterMode: options.declutterMode
        });
        /**
     * @private
     * @type {HTMLCanvasElement|OffscreenCanvas|null}
     */ this.hitDetectionCanvas_ = null;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : null;
        /**
     * @private
     * @type {Array<number>}
     */ this.origin_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {number}
     */ this.points_ = options.points;
        /**
     * @protected
     * @type {number}
     */ this.radius = options.radius;
        /**
     * @private
     * @type {number|undefined}
     */ this.radius2_ = options.radius2;
        /**
     * @private
     * @type {number}
     */ this.angle_ = options.angle !== undefined ? options.angle : 0;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.size_;
        /**
     * @private
     * @type {RenderOptions}
     */ this.renderOptions_;
        /**
     * @private
     */ this.imageState_ = this.fill_ && this.fill_.loading() ? (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADING : (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADED;
        if (this.imageState_ === (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADING) this.ready().then(()=>this.imageState_ = (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADED);
        this.render();
    }
    /**
   * Clones the style.
   * @return {RegularShape} The cloned style.
   * @api
   * @override
   */ clone() {
        const scale = this.getScale();
        const style = new $5fad9a707e2de9d2$var$RegularShape({
            fill: this.getFill() ? this.getFill().clone() : undefined,
            points: this.getPoints(),
            radius: this.getRadius(),
            radius2: this.getRadius2(),
            angle: this.getAngle(),
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
        style.setOpacity(this.getOpacity());
        return style;
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @return {Array<number>} Anchor.
   * @api
   * @override
   */ getAnchor() {
        const size = this.size_;
        const displacement = this.getDisplacement();
        const scale = this.getScaleArray();
        // anchor is scaled by renderer but displacement should not be scaled
        // so divide by scale here
        return [
            size[0] / 2 - displacement[0] / scale[0],
            size[1] / 2 + displacement[1] / scale[1]
        ];
    }
    /**
   * Get the angle used in generating the shape.
   * @return {number} Shape's rotation in radians.
   * @api
   */ getAngle() {
        return this.angle_;
    }
    /**
   * Get the fill style for the shape.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Set the fill style.
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
        this.render();
    }
    /**
   * @return {HTMLCanvasElement|OffscreenCanvas} Image element.
   * @override
   */ getHitDetectionImage() {
        if (!this.hitDetectionCanvas_) this.hitDetectionCanvas_ = this.createHitDetectionCanvas_(this.renderOptions_);
        return this.hitDetectionCanvas_;
    }
    /**
   * Get the image icon.
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLCanvasElement|OffscreenCanvas} Image or Canvas element.
   * @api
   * @override
   */ getImage(pixelRatio) {
        const fillKey = this.fill_?.getKey();
        const cacheKey = `${pixelRatio},${this.angle_},${this.radius},${this.radius2_},${this.points_},${fillKey}` + Object.values(this.renderOptions_).join(',');
        let image = /** @type {HTMLCanvasElement|OffscreenCanvas} */ (0, $3eb09d66fc28233e$export$747ccdf771a87ab8).get(cacheKey, null)?.getImage(1);
        if (!image) {
            const renderOptions = this.renderOptions_;
            const size = Math.ceil(renderOptions.size * pixelRatio);
            const context = (0, $5ce605ba3ee034a0$export$9e05d10eae75c464)(size, size);
            this.draw_(renderOptions, context, pixelRatio);
            image = context.canvas;
            const iconImage = new (0, $c8822aedb641e9f2$export$2e2bcd8739ae039)(image, undefined, null, (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADED, null);
            (0, $3eb09d66fc28233e$export$747ccdf771a87ab8).set(cacheKey, null, iconImage);
            // Update the image in place to an ImageBitmap for better performance and lower memory usage
            createImageBitmap(image).then((imageBitmap)=>{
                iconImage.setImage(imageBitmap);
            });
        }
        return image;
    }
    /**
   * Get the image pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Pixel ratio.
   * @override
   */ getPixelRatio(pixelRatio) {
        return pixelRatio;
    }
    /**
   * @return {import("../size.js").Size} Image size.
   * @override
   */ getImageSize() {
        return this.size_;
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   * @override
   */ getImageState() {
        return this.imageState_;
    }
    /**
   * Get the origin of the symbolizer.
   * @return {Array<number>} Origin.
   * @api
   * @override
   */ getOrigin() {
        return this.origin_;
    }
    /**
   * Get the number of points for generating the shape.
   * @return {number} Number of points for stars and regular polygons.
   * @api
   */ getPoints() {
        return this.points_;
    }
    /**
   * Get the (primary) radius for the shape.
   * @return {number} Radius.
   * @api
   */ getRadius() {
        return this.radius;
    }
    /**
   * Set the (primary) radius for the shape.
   * @param {number} radius Radius.
   * @api
   */ setRadius(radius) {
        if (this.radius === radius) return;
        this.radius = radius;
        this.render();
    }
    /**
   * Get the secondary radius for the shape.
   * @return {number|undefined} Radius2.
   * @api
   */ getRadius2() {
        return this.radius2_;
    }
    /**
   * Set the secondary radius for the shape.
   * @param {number|undefined} radius2 Radius2.
   * @api
   */ setRadius2(radius2) {
        if (this.radius2_ === radius2) return;
        this.radius2_ = radius2;
        this.render();
    }
    /**
   * Get the size of the symbolizer (in pixels).
   * @return {import("../size.js").Size} Size.
   * @api
   * @override
   */ getSize() {
        return this.size_;
    }
    /**
   * Get the stroke style for the shape.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Set the stroke style.
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
        this.render();
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ listenImageChange(listener) {}
    /**
   * Load not yet loaded URI.
   * @override
   */ load() {}
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ unlistenImageChange(listener) {}
    /**
   * Calculate additional canvas size needed for the miter.
   * @param {string} lineJoin Line join
   * @param {number} strokeWidth Stroke width
   * @param {number} miterLimit Miter limit
   * @return {number} Additional canvas size needed
   * @private
   */ calculateLineJoinSize_(lineJoin, strokeWidth, miterLimit) {
        if (strokeWidth === 0 || this.points_ === Infinity || lineJoin !== 'bevel' && lineJoin !== 'miter') return strokeWidth;
        // m  | ^
        // i  | |\                  .
        // t >|  #\
        // e  | |\ \              .
        // r      \s\
        //      |  \t\          .                 .
        //          \r\                      .   .
        //      |    \o\      .          .  . . .
        //          e \k\            .  .    . .
        //      |      \e\  .    .  .       . .
        //       d      \ \  .  .          . .
        //      | _ _a_ _\#  .            . .
        //   r1          / `             . .
        //      |                       . .
        //       b     /               . .
        //      |                     . .
        //           / r2            . .
        //      |                        .   .
        //         /                           .   .
        //      |α                                   .   .
        //       /                                         .   .
        //      ° center
        let r1 = this.radius;
        let r2 = this.radius2_ === undefined ? r1 : this.radius2_;
        if (r1 < r2) {
            const tmp = r1;
            r1 = r2;
            r2 = tmp;
        }
        const points = this.radius2_ === undefined ? this.points_ : this.points_ * 2;
        const alpha = 2 * Math.PI / points;
        const a = r2 * Math.sin(alpha);
        const b = Math.sqrt(r2 * r2 - a * a);
        const d = r1 - b;
        const e = Math.sqrt(a * a + d * d);
        const miterRatio = e / a;
        if (lineJoin === 'miter' && miterRatio <= miterLimit) return miterRatio * strokeWidth;
        // Calculate the distance from center to the stroke corner where
        // it was cut short because of the miter limit.
        //              l
        //        ----+---- <= distance from center to here is maxr
        //       /####|k ##\
        //      /#####^#####\
        //     /#### /+\# s #\
        //    /### h/+++\# t #\
        //   /### t/+++++\# r #\
        //  /### a/+++++++\# o #\
        // /### p/++ fill +\# k #\
        ///#### /+++++^+++++\# e #\
        //#####/+++++/+\+++++\#####\
        const k = strokeWidth / 2 / miterRatio;
        const l = strokeWidth / 2 * (d / e);
        const maxr = Math.sqrt((r1 + k) * (r1 + k) + l * l);
        const bevelAdd = maxr - r1;
        if (this.radius2_ === undefined || lineJoin === 'bevel') return bevelAdd * 2;
        // If outer miter is over the miter limit the inner miter may reach through the
        // center and be longer than the bevel, same calculation as above but swap r1 / r2.
        const aa = r1 * Math.sin(alpha);
        const bb = Math.sqrt(r1 * r1 - aa * aa);
        const dd = r2 - bb;
        const ee = Math.sqrt(aa * aa + dd * dd);
        const innerMiterRatio = ee / aa;
        if (innerMiterRatio <= miterLimit) {
            const innerLength = innerMiterRatio * strokeWidth / 2 - r2 - r1;
            return 2 * Math.max(bevelAdd, innerLength);
        }
        return bevelAdd * 2;
    }
    /**
   * @return {RenderOptions}  The render options
   * @protected
   */ createRenderOptions() {
        let lineCap = (0, $3b9b2e731b8ee924$export$17bd0c38d6ae694e);
        let lineJoin = (0, $3b9b2e731b8ee924$export$365eb9648cf19bd0);
        let miterLimit = 0;
        let lineDash = null;
        let lineDashOffset = 0;
        let strokeStyle;
        let strokeWidth = 0;
        if (this.stroke_) {
            strokeStyle = (0, $bafa252a4f4b168a$export$dc5b1400ac3a10a8)(this.stroke_.getColor() ?? (0, $3b9b2e731b8ee924$export$1eb2eaecacf2031e));
            strokeWidth = this.stroke_.getWidth() ?? (0, $3b9b2e731b8ee924$export$79661f132c62010e);
            lineDash = this.stroke_.getLineDash();
            lineDashOffset = this.stroke_.getLineDashOffset() ?? 0;
            lineJoin = this.stroke_.getLineJoin() ?? (0, $3b9b2e731b8ee924$export$365eb9648cf19bd0);
            lineCap = this.stroke_.getLineCap() ?? (0, $3b9b2e731b8ee924$export$17bd0c38d6ae694e);
            miterLimit = this.stroke_.getMiterLimit() ?? (0, $3b9b2e731b8ee924$export$80c1c01844597b7b);
        }
        const add = this.calculateLineJoinSize_(lineJoin, strokeWidth, miterLimit);
        const maxRadius = Math.max(this.radius, this.radius2_ || 0);
        const size = Math.ceil(2 * maxRadius + add);
        return {
            strokeStyle: strokeStyle,
            strokeWidth: strokeWidth,
            size: size,
            lineCap: lineCap,
            lineDash: lineDash,
            lineDashOffset: lineDashOffset,
            lineJoin: lineJoin,
            miterLimit: miterLimit
        };
    }
    /**
   * @protected
   */ render() {
        this.renderOptions_ = this.createRenderOptions();
        const size = this.renderOptions_.size;
        this.hitDetectionCanvas_ = null;
        this.size_ = [
            size,
            size
        ];
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context The rendering context.
   * @param {number} pixelRatio The pixel ratio.
   */ draw_(renderOptions, context, pixelRatio) {
        context.scale(pixelRatio, pixelRatio);
        // set origin to canvas center
        context.translate(renderOptions.size / 2, renderOptions.size / 2);
        this.createPath_(context);
        if (this.fill_) {
            let color = this.fill_.getColor();
            if (color === null) color = (0, $3b9b2e731b8ee924$export$c495d52ee3fd74b2);
            context.fillStyle = (0, $bafa252a4f4b168a$export$dc5b1400ac3a10a8)(color);
            context.fill();
        }
        if (renderOptions.strokeStyle) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = renderOptions.strokeWidth;
            if (renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.lineCap = renderOptions.lineCap;
            context.lineJoin = renderOptions.lineJoin;
            context.miterLimit = renderOptions.miterLimit;
            context.stroke();
        }
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @return {HTMLCanvasElement|OffscreenCanvas} Canvas containing the icon
   */ createHitDetectionCanvas_(renderOptions) {
        let context;
        if (this.fill_) {
            let color = this.fill_.getColor();
            // determine if fill is transparent (or pattern or gradient)
            let opacity = 0;
            if (typeof color === 'string') color = (0, $6c864c0c7b61b9b5$export$75093a47a9fa838d)(color);
            if (color === null) opacity = 1;
            else if (Array.isArray(color)) opacity = color.length === 4 ? color[3] : 1;
            if (opacity === 0) {
                // if a transparent fill style is set, create an extra hit-detection image
                // with a default fill style
                context = (0, $5ce605ba3ee034a0$export$9e05d10eae75c464)(renderOptions.size, renderOptions.size);
                this.drawHitDetectionCanvas_(renderOptions, context);
            }
        }
        return context ? context.canvas : this.getImage(1);
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context The context to draw in.
   */ createPath_(context) {
        let points = this.points_;
        const radius = this.radius;
        if (points === Infinity) context.arc(0, 0, radius, 0, 2 * Math.PI);
        else {
            const radius2 = this.radius2_ === undefined ? radius : this.radius2_;
            if (this.radius2_ !== undefined) points *= 2;
            const startAngle = this.angle_ - Math.PI / 2;
            const step = 2 * Math.PI / points;
            for(let i = 0; i < points; i++){
                const angle0 = startAngle + i * step;
                const radiusC = i % 2 === 0 ? radius : radius2;
                context.lineTo(radiusC * Math.cos(angle0), radiusC * Math.sin(angle0));
            }
            context.closePath();
        }
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context The context.
   */ drawHitDetectionCanvas_(renderOptions, context) {
        // set origin to canvas center
        context.translate(renderOptions.size / 2, renderOptions.size / 2);
        this.createPath_(context);
        context.fillStyle = (0, $3b9b2e731b8ee924$export$c495d52ee3fd74b2);
        context.fill();
        if (renderOptions.strokeStyle) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = renderOptions.strokeWidth;
            if (renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.lineJoin = renderOptions.lineJoin;
            context.miterLimit = renderOptions.miterLimit;
            context.stroke();
        }
    }
    /**
   * @override
   */ ready() {
        return this.fill_ ? this.fill_.ready() : Promise.resolve();
    }
}
var $5fad9a707e2de9d2$export$2e2bcd8739ae039 = $5fad9a707e2de9d2$var$RegularShape;


/**
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} radius Circle radius.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {Array<number>} [displacement=[0,0]] displacement
 * @property {number|import("../size.js").Size} [scale=1] Scale. A two dimensional scale will produce an ellipse.
 * Unless two dimensional scaling is required a better result may be obtained with an appropriate setting for `radius`.
 * @property {number} [rotation=0] Rotation in radians
 * (positive rotation clockwise, meaningful only when used in conjunction with a two dimensional scale).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view
 * (meaningful only when used in conjunction with a two dimensional scale).
 * @property {import('./Style.js').DeclutterMode} [declutterMode] Declutter mode
 */ /**
 * @classdesc
 * Set circle style for vector features.
 * @api
 */ class $c1968949086c96bc$var$CircleStyle extends (0, $5fad9a707e2de9d2$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {
            radius: 5
        };
        super({
            points: Infinity,
            fill: options.fill,
            radius: options.radius,
            stroke: options.stroke,
            scale: options.scale !== undefined ? options.scale : 1,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            rotateWithView: options.rotateWithView !== undefined ? options.rotateWithView : false,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            declutterMode: options.declutterMode
        });
    }
    /**
   * Clones the style.
   * @return {CircleStyle} The cloned style.
   * @api
   * @override
   */ clone() {
        const scale = this.getScale();
        const style = new $c1968949086c96bc$var$CircleStyle({
            fill: this.getFill() ? this.getFill().clone() : undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            radius: this.getRadius(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
        style.setOpacity(this.getOpacity());
        return style;
    }
}
var $c1968949086c96bc$export$2e2bcd8739ae039 = $c1968949086c96bc$var$CircleStyle;


/**
 * @module ol/style/Fill
 */ 



/**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} [color=null] A color,
 * gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats. For polygon fills (not for {@link import("./RegularShape.js").default} fills),
 * a pattern can also be provided as {@link module:ol/colorlike~PatternDescriptor}.
 * Default null; if null, the Canvas/renderer default black will be used.
 */ /**
 * @classdesc
 * Set fill style for vector features.
 * @api
 */ class $83cca4c6d7d93d3c$var$Fill {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {import("./IconImage.js").default|null}
     */ this.patternImage_ = null;
        /**
     * @private
     * @type {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null}
     */ this.color_ = null;
        if (options.color !== undefined) this.setColor(options.color);
    }
    /**
   * Clones the style. The color is not cloned if it is a {@link module:ol/colorlike~ColorLike}.
   * @return {Fill} The cloned style.
   * @api
   */ clone() {
        const color = this.getColor();
        return new $83cca4c6d7d93d3c$var$Fill({
            color: Array.isArray(color) ? color.slice() : color || undefined
        });
    }
    /**
   * Get the fill color.
   * @return {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Set the color.
   *
   * @param {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} color Color.
   * @api
   */ setColor(color) {
        if (color !== null && typeof color === 'object' && 'src' in color) {
            const patternImage = (0, $c8822aedb641e9f2$export$3988ae62b71be9a3)(null, color.src, {
                crossOrigin: 'anonymous'
            }, undefined, color.offset ? null : color.color ? color.color : null, !(color.offset && color.size));
            patternImage.ready().then(()=>{
                this.patternImage_ = null;
            });
            if (patternImage.getImageState() === (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).IDLE) patternImage.load();
            if (patternImage.getImageState() === (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADING) this.patternImage_ = patternImage;
        }
        this.color_ = color;
    }
    /**
   * @return {string} Key of the fill for cache lookup.
   */ getKey() {
        const fill = this.getColor();
        if (!fill) return '';
        return fill instanceof CanvasPattern || fill instanceof CanvasGradient ? (0, $01f1986453243423$export$5e82334337e0f204)(fill) : typeof fill === 'object' && 'src' in fill ? fill.src + ':' + fill.offset : (0, $6c864c0c7b61b9b5$export$75093a47a9fa838d)(fill).toString();
    }
    /**
   * @return {boolean} The fill style is loading an image pattern.
   */ loading() {
        return !!this.patternImage_;
    }
    /**
   * @return {Promise<void>} `false` or a promise that resolves when the style is ready to use.
   */ ready() {
        return this.patternImage_ ? this.patternImage_.ready() : Promise.resolve();
    }
}
var $83cca4c6d7d93d3c$export$2e2bcd8739ae039 = $83cca4c6d7d93d3c$var$Fill;


/**
 * @module ol/style/Icon
 */ 






/**
 * @typedef {'fraction' | 'pixels'} IconAnchorUnits
 * Anchor unit can be either a fraction of the icon size or in pixels.
 */ /**
 * @typedef {'bottom-left' | 'bottom-right' | 'top-left' | 'top-right'} IconOrigin
 * Icon origin. One of 'bottom-left', 'bottom-right', 'top-left', 'top-right'.
 */ /**
 * @typedef {Object} Options
 * @property {Array<number>} [anchor=[0.5, 0.5]] Anchor. Default value is the icon center.
 * @property {IconOrigin} [anchorOrigin='top-left'] Origin of the anchor: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {IconAnchorUnits} [anchorXUnits='fraction'] Units in which the anchor x value is
 * specified. A value of `'fraction'` indicates the x value is a fraction of the icon. A value of `'pixels'` indicates
 * the x value in pixels.
 * @property {IconAnchorUnits} [anchorYUnits='fraction'] Units in which the anchor y value is
 * specified. A value of `'fraction'` indicates the y value is a fraction of the icon. A value of `'pixels'` indicates
 * the y value in pixels.
 * @property {import("../color.js").Color|string} [color] Color to tint the icon. If not specified,
 * the icon will be left as is.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images. Note that you must provide a
 * `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {ReferrerPolicy} [referrerPolicy] The `referrerPolicy` property for loaded images.
 * @property {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap} [img] Image object for the icon.
 * @property {Array<number>} [displacement=[0, 0]] Displacement of the icon in pixels.
 * Positive values will shift the icon right and up.
 * @property {number} [opacity=1] Opacity of the icon.
 * @property {number} [width] The width of the icon in pixels. This can't be used together with `scale`.
 * @property {number} [height] The height of the icon in pixels. This can't be used together with `scale`.
 * @property {number|import("../size.js").Size} [scale=1] Scale.
 * @property {boolean} [rotateWithView=false] Whether to rotate the icon with the view.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {Array<number>} [offset=[0, 0]] Offset which, together with `size` and `offsetOrigin`, defines the
 * sub-rectangle to use from the original (sprite) image.
 * @property {IconOrigin} [offsetOrigin='top-left'] Origin of the offset: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {import("../size.js").Size} [size] Icon size in pixels. Used together with `offset` to define the
 * sub-rectangle to use from the original (sprite) image.
 * @property {string} [src] Image source URI.
 * @property {import("./Style.js").DeclutterMode} [declutterMode] Declutter mode.
 */ /**
 * @param {number} width The width.
 * @param {number} height The height.
 * @param {number|undefined} wantedWidth The wanted width.
 * @param {number|undefined} wantedHeight The wanted height.
 * @return {number|Array<number>} The scale.
 */ function $3f49168ea08c039d$var$calculateScale(width, height, wantedWidth, wantedHeight) {
    if (wantedWidth !== undefined && wantedHeight !== undefined) return [
        wantedWidth / width,
        wantedHeight / height
    ];
    if (wantedWidth !== undefined) return wantedWidth / width;
    if (wantedHeight !== undefined) return wantedHeight / height;
    return 1;
}
/**
 * @classdesc
 * Set icon style for vector features.
 * @api
 */ class $3f49168ea08c039d$var$Icon extends (0, $e869ab451c83a5dc$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @type {number}
     */ const opacity = options.opacity !== undefined ? options.opacity : 1;
        /**
     * @type {number}
     */ const rotation = options.rotation !== undefined ? options.rotation : 0;
        /**
     * @type {number|import("../size.js").Size}
     */ const scale = options.scale !== undefined ? options.scale : 1;
        /**
     * @type {boolean}
     */ const rotateWithView = options.rotateWithView !== undefined ? options.rotateWithView : false;
        super({
            opacity: opacity,
            rotation: rotation,
            scale: scale,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            rotateWithView: rotateWithView,
            declutterMode: options.declutterMode
        });
        /**
     * @private
     * @type {Array<number>}
     */ this.anchor_ = options.anchor !== undefined ? options.anchor : [
            0.5,
            0.5
        ];
        /**
     * @private
     * @type {Array<number>}
     */ this.normalizedAnchor_ = null;
        /**
     * @private
     * @type {IconOrigin}
     */ this.anchorOrigin_ = options.anchorOrigin !== undefined ? options.anchorOrigin : 'top-left';
        /**
     * @private
     * @type {IconAnchorUnits}
     */ this.anchorXUnits_ = options.anchorXUnits !== undefined ? options.anchorXUnits : 'fraction';
        /**
     * @private
     * @type {IconAnchorUnits}
     */ this.anchorYUnits_ = options.anchorYUnits !== undefined ? options.anchorYUnits : 'fraction';
        /**
     * @private
     * @type {?string}
     */ this.crossOrigin_ = options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
     * @private
     * @type {ReferrerPolicy}
     */ this.referrerPolicy_ = options.referrerPolicy;
        const image = options.img !== undefined ? options.img : null;
        let cacheKey = options.src;
        (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(!(cacheKey !== undefined && image), '`image` and `src` cannot be provided at the same time');
        if ((cacheKey === undefined || cacheKey.length === 0) && image) cacheKey = /** @type {HTMLImageElement} */ image.src || (0, $01f1986453243423$export$5e82334337e0f204)(image);
        (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(cacheKey !== undefined && cacheKey.length > 0, 'A defined and non-empty `src` or `image` must be provided');
        (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(!((options.width !== undefined || options.height !== undefined) && options.scale !== undefined), '`width` or `height` cannot be provided together with `scale`');
        let imageState;
        if (options.src !== undefined) imageState = (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).IDLE;
        else if (image !== undefined) {
            if ('complete' in image) {
                if (image.complete) imageState = image.src ? (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADED : (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).IDLE;
                else imageState = (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADING;
            } else imageState = (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADED;
        }
        /**
     * @private
     * @type {import("../color.js").Color}
     */ this.color_ = options.color !== undefined ? (0, $6c864c0c7b61b9b5$export$75093a47a9fa838d)(options.color) : null;
        /**
     * @private
     * @type {import("./IconImage.js").default}
     */ this.iconImage_ = (0, $c8822aedb641e9f2$export$3988ae62b71be9a3)(image, /** @type {string} */ cacheKey, {
            crossOrigin: this.crossOrigin_,
            referrerPolicy: this.referrerPolicy_
        }, imageState, this.color_);
        /**
     * @private
     * @type {Array<number>}
     */ this.offset_ = options.offset !== undefined ? options.offset : [
            0,
            0
        ];
        /**
     * @private
     * @type {IconOrigin}
     */ this.offsetOrigin_ = options.offsetOrigin !== undefined ? options.offsetOrigin : 'top-left';
        /**
     * @private
     * @type {Array<number>}
     */ this.origin_ = null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.size_ = options.size !== undefined ? options.size : null;
        /**
     * @private
     */ this.initialOptions_;
        /**
     * Calculate the scale if width or height were given.
     */ if (options.width !== undefined || options.height !== undefined) {
            let width, height;
            if (options.size) [width, height] = options.size;
            else {
                const image = this.getImage(1);
                if (image.width && image.height) {
                    width = image.width;
                    height = image.height;
                } else if (image instanceof HTMLImageElement) {
                    this.initialOptions_ = options;
                    const onload = ()=>{
                        this.unlistenImageChange(onload);
                        if (!this.initialOptions_) return;
                        const imageSize = this.iconImage_.getSize();
                        this.setScale($3f49168ea08c039d$var$calculateScale(imageSize[0], imageSize[1], options.width, options.height));
                    };
                    this.listenImageChange(onload);
                    return;
                }
            }
            if (width !== undefined) this.setScale($3f49168ea08c039d$var$calculateScale(width, height, options.width, options.height));
        }
    }
    /**
   * Clones the style. The underlying Image/HTMLCanvasElement is not cloned.
   * @return {Icon} The cloned style.
   * @api
   * @override
   */ clone() {
        let scale, width, height;
        if (this.initialOptions_) {
            width = this.initialOptions_.width;
            height = this.initialOptions_.height;
        } else {
            scale = this.getScale();
            scale = Array.isArray(scale) ? scale.slice() : scale;
        }
        return new $3f49168ea08c039d$var$Icon({
            anchor: this.anchor_.slice(),
            anchorOrigin: this.anchorOrigin_,
            anchorXUnits: this.anchorXUnits_,
            anchorYUnits: this.anchorYUnits_,
            color: this.color_ && this.color_.slice ? this.color_.slice() : this.color_ || undefined,
            crossOrigin: this.crossOrigin_,
            referrerPolicy: this.referrerPolicy_,
            offset: this.offset_.slice(),
            offsetOrigin: this.offsetOrigin_,
            opacity: this.getOpacity(),
            rotateWithView: this.getRotateWithView(),
            rotation: this.getRotation(),
            scale: scale,
            width: width,
            height: height,
            size: this.size_ !== null ? this.size_.slice() : undefined,
            src: this.getSrc(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @return {Array<number>} Anchor.
   * @api
   * @override
   */ getAnchor() {
        let anchor = this.normalizedAnchor_;
        if (!anchor) {
            anchor = this.anchor_;
            const size = this.getSize();
            if (this.anchorXUnits_ == 'fraction' || this.anchorYUnits_ == 'fraction') {
                if (!size) return null;
                anchor = this.anchor_.slice();
                if (this.anchorXUnits_ == 'fraction') anchor[0] *= size[0];
                if (this.anchorYUnits_ == 'fraction') anchor[1] *= size[1];
            }
            if (this.anchorOrigin_ != 'top-left') {
                if (!size) return null;
                if (anchor === this.anchor_) anchor = this.anchor_.slice();
                if (this.anchorOrigin_ == 'top-right' || this.anchorOrigin_ == 'bottom-right') anchor[0] = -anchor[0] + size[0];
                if (this.anchorOrigin_ == 'bottom-left' || this.anchorOrigin_ == 'bottom-right') anchor[1] = -anchor[1] + size[1];
            }
            this.normalizedAnchor_ = anchor;
        }
        const displacement = this.getDisplacement();
        const scale = this.getScaleArray();
        // anchor is scaled by renderer but displacement should not be scaled
        // so divide by scale here
        return [
            anchor[0] - displacement[0] / scale[0],
            anchor[1] + displacement[1] / scale[1]
        ];
    }
    /**
   * Set the anchor point. The anchor determines the center point for the
   * symbolizer.
   *
   * @param {Array<number>} anchor Anchor.
   * @api
   */ setAnchor(anchor) {
        this.anchor_ = anchor;
        this.normalizedAnchor_ = null;
    }
    /**
   * Get the icon color.
   * @return {import("../color.js").Color} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Set the icon color.
   *
   * Warning: Repeatedly setting the color on an icon style
   * causes the icon image to be re-created each time. This can have a
   * severe performance impact.
   *
   * @param {import("../color.js").Color|string|null|undefined} color Color.
   */ setColor(color) {
        const nextColor = color ? (0, $6c864c0c7b61b9b5$export$75093a47a9fa838d)(color) : null;
        if (this.color_ === nextColor || this.color_ && nextColor && this.color_.length === nextColor.length && this.color_.every((value, index)=>value === nextColor[index])) // Discard if the color hasn't changed.
        return;
        this.color_ = nextColor;
        const src = this.getSrc();
        const image = src !== undefined ? null : this.getHitDetectionImage();
        const imageState = src !== undefined ? (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).IDLE : this.iconImage_.getImageState();
        this.iconImage_ = (0, $c8822aedb641e9f2$export$3988ae62b71be9a3)(image, src, {
            crossOrigin: this.crossOrigin_,
            referrerPolicy: this.referrerPolicy_
        }, imageState, this.color_);
    }
    /**
   * Get the image icon.
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap} Image or Canvas element. If the Icon
   * style was configured with `src` or with a not let loaded `img`, an `ImageBitmap` will be returned.
   * @api
   * @override
   */ getImage(pixelRatio) {
        return this.iconImage_.getImage(pixelRatio);
    }
    /**
   * Get the pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} The pixel ratio of the image.
   * @api
   * @override
   */ getPixelRatio(pixelRatio) {
        return this.iconImage_.getPixelRatio(pixelRatio);
    }
    /**
   * @return {import("../size.js").Size} Image size.
   * @override
   */ getImageSize() {
        return this.iconImage_.getSize();
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   * @override
   */ getImageState() {
        return this.iconImage_.getImageState();
    }
    /**
   * @return {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas|ImageBitmap} Image element.
   * @override
   */ getHitDetectionImage() {
        return this.iconImage_.getHitDetectionImage();
    }
    /**
   * Get the origin of the symbolizer.
   * @return {Array<number>} Origin.
   * @api
   * @override
   */ getOrigin() {
        if (this.origin_) return this.origin_;
        let offset = this.offset_;
        if (this.offsetOrigin_ != 'top-left') {
            const size = this.getSize();
            const iconImageSize = this.iconImage_.getSize();
            if (!size || !iconImageSize) return null;
            offset = offset.slice();
            if (this.offsetOrigin_ == 'top-right' || this.offsetOrigin_ == 'bottom-right') offset[0] = iconImageSize[0] - size[0] - offset[0];
            if (this.offsetOrigin_ == 'bottom-left' || this.offsetOrigin_ == 'bottom-right') offset[1] = iconImageSize[1] - size[1] - offset[1];
        }
        this.origin_ = offset;
        return this.origin_;
    }
    /**
   * Get the image URL.
   * @return {string|undefined} Image src.
   * @api
   */ getSrc() {
        return this.iconImage_.getSrc();
    }
    /**
   * Set the image URI
   * @param {string} src Image source URI
   * @api
   */ setSrc(src) {
        this.iconImage_ = (0, $c8822aedb641e9f2$export$3988ae62b71be9a3)(null, src, {
            crossOrigin: this.crossOrigin_,
            referrerPolicy: this.referrerPolicy_
        }, (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).IDLE, this.color_);
    }
    /**
   * Get the size of the icon (in pixels).
   * @return {import("../size.js").Size} Image size.
   * @api
   * @override
   */ getSize() {
        return !this.size_ ? this.iconImage_.getSize() : this.size_;
    }
    /**
   * Get the width of the icon (in pixels). Will return undefined when the icon image is not yet loaded.
   * @return {number} Icon width (in pixels).
   * @api
   */ getWidth() {
        const scale = this.getScaleArray();
        if (this.size_) return this.size_[0] * scale[0];
        if (this.iconImage_.getImageState() == (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADED) return this.iconImage_.getSize()[0] * scale[0];
        return undefined;
    }
    /**
   * Get the height of the icon (in pixels). Will return undefined when the icon image is not yet loaded.
   * @return {number} Icon height (in pixels).
   * @api
   */ getHeight() {
        const scale = this.getScaleArray();
        if (this.size_) return this.size_[1] * scale[1];
        if (this.iconImage_.getImageState() == (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADED) return this.iconImage_.getSize()[1] * scale[1];
        return undefined;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size} scale Scale.
   * @api
   * @override
   */ setScale(scale) {
        delete this.initialOptions_;
        super.setScale(scale);
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ listenImageChange(listener) {
        this.iconImage_.addEventListener((0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CHANGE, listener);
    }
    /**
   * Load not yet loaded URI.
   * When rendering a feature with an icon style, the vector renderer will
   * automatically call this method. However, you might want to call this
   * method yourself for preloading or other purposes.
   * @api
   * @override
   */ load() {
        this.iconImage_.load();
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ unlistenImageChange(listener) {
        this.iconImage_.removeEventListener((0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CHANGE, listener);
    }
    /**
   * @override
   */ ready() {
        return this.iconImage_.ready();
    }
}
var $3f49168ea08c039d$export$2e2bcd8739ae039 = $3f49168ea08c039d$var$Icon;



/**
 * @module ol/style/Stroke
 */ /**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike} [color] A color, gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats.
 * Default null; if null, the Canvas/renderer default black will be used.
 * @property {CanvasLineCap} [lineCap='round'] Line cap style: `butt`, `round`, or `square`.
 * @property {CanvasLineJoin} [lineJoin='round'] Line join style: `bevel`, `round`, or `miter`.
 * @property {Array<number>} [lineDash] Line dash pattern. Default is `null` (no dash).
 * @property {number} [lineDashOffset=0] Line dash offset.
 * @property {number} [miterLimit=10] Miter limit.
 * @property {number} [offset] Line offset in pixels along the normal. A positive value offsets the line to the right,
 * relative to the direction of the line. Default is `undefined` (no offset).
 * @property {number} [width] Width.
 */ /**
 * @classdesc
 * Set stroke style for vector features.
 * Note that the defaults given are the Canvas defaults, which will be used if
 * option is not defined. The `get` functions return whatever was entered in
 * the options; they will not return the default.
 * @api
 */ class $4eba39905b0caafc$var$Stroke {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {import("../color.js").Color|import("../colorlike.js").ColorLike}
     */ this.color_ = options.color !== undefined ? options.color : null;
        /**
     * @private
     * @type {CanvasLineCap|undefined}
     */ this.lineCap_ = options.lineCap;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.lineDash_ = options.lineDash !== undefined ? options.lineDash : null;
        /**
     * @private
     * @type {number|undefined}
     */ this.lineDashOffset_ = options.lineDashOffset;
        /**
     * @private
     * @type {CanvasLineJoin|undefined}
     */ this.lineJoin_ = options.lineJoin;
        /**
     * @private
     * @type {number|undefined}
     */ this.miterLimit_ = options.miterLimit;
        /**
     * @private
     * @type {number|undefined}
     */ this.offset_ = options.offset;
        /**
     * @private
     * @type {number|undefined}
     */ this.width_ = options.width;
    }
    /**
   * Clones the style.
   * @return {Stroke} The cloned style.
   * @api
   */ clone() {
        const color = this.getColor();
        return new $4eba39905b0caafc$var$Stroke({
            color: Array.isArray(color) ? color.slice() : color || undefined,
            lineCap: this.getLineCap(),
            lineDash: this.getLineDash() ? this.getLineDash().slice() : undefined,
            lineDashOffset: this.getLineDashOffset(),
            lineJoin: this.getLineJoin(),
            miterLimit: this.getMiterLimit(),
            offset: this.getOffset(),
            width: this.getWidth()
        });
    }
    /**
   * Get the stroke color.
   * @return {import("../color.js").Color|import("../colorlike.js").ColorLike} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Get the line cap type for the stroke.
   * @return {CanvasLineCap|undefined} Line cap.
   * @api
   */ getLineCap() {
        return this.lineCap_;
    }
    /**
   * Get the line dash style for the stroke.
   * @return {Array<number>|null} Line dash.
   * @api
   */ getLineDash() {
        return this.lineDash_;
    }
    /**
   * Get the line dash offset for the stroke.
   * @return {number|undefined} Line dash offset.
   * @api
   */ getLineDashOffset() {
        return this.lineDashOffset_;
    }
    /**
   * Get the line join type for the stroke.
   * @return {CanvasLineJoin|undefined} Line join.
   * @api
   */ getLineJoin() {
        return this.lineJoin_;
    }
    /**
   * Get the miter limit for the stroke.
   * @return {number|undefined} Miter limit.
   * @api
   */ getMiterLimit() {
        return this.miterLimit_;
    }
    /**
   * Get the line offset in pixels.
   * @return {number|undefined} Offset.
   * @api
   */ getOffset() {
        return this.offset_;
    }
    /**
   * Get the stroke width.
   * @return {number|undefined} Width.
   * @api
   */ getWidth() {
        return this.width_;
    }
    /**
   * Set the color.
   *
   * @param {import("../color.js").Color|import("../colorlike.js").ColorLike} color Color.
   * @api
   */ setColor(color) {
        this.color_ = color;
    }
    /**
   * Set the line cap.
   *
   * @param {CanvasLineCap|undefined} lineCap Line cap.
   * @api
   */ setLineCap(lineCap) {
        this.lineCap_ = lineCap;
    }
    /**
   * Set the line dash.
   *
   * @param {Array<number>|null} lineDash Line dash.
   * @api
   */ setLineDash(lineDash) {
        this.lineDash_ = lineDash;
    }
    /**
   * Set the line dash offset.
   *
   * @param {number|undefined} lineDashOffset Line dash offset.
   * @api
   */ setLineDashOffset(lineDashOffset) {
        this.lineDashOffset_ = lineDashOffset;
    }
    /**
   * Set the line join.
   *
   * @param {CanvasLineJoin|undefined} lineJoin Line join.
   * @api
   */ setLineJoin(lineJoin) {
        this.lineJoin_ = lineJoin;
    }
    /**
   * Set the miter limit.
   *
   * @param {number|undefined} miterLimit Miter limit.
   * @api
   */ setMiterLimit(miterLimit) {
        this.miterLimit_ = miterLimit;
    }
    /**
   * Set the line offset in pixels.
   *
   * @param {number|undefined} offset Offset.
   * @api
   */ setOffset(offset) {
        this.offset_ = offset;
    }
    /**
   * Set the width.
   *
   * @param {number|undefined} width Width.
   * @api
   */ setWidth(width) {
        this.width_ = width;
    }
}
var $4eba39905b0caafc$export$2e2bcd8739ae039 = $4eba39905b0caafc$var$Stroke;


/**
 * @module ol/style/Style
 */ 



/**
 * Defines how symbols and text are decluttered on layers ith `declutter` set to `true`
 * **declutter**: Overlapping symbols and text are decluttered.
 * **obstacle**: Symbols and text are rendered, but serve as obstacle for subsequent attempts
 *   to place a symbol or text at the same location.
 * **none**: No decluttering is done.
 *
 * @typedef {"declutter"|"obstacle"|"none"} DeclutterMode
 */ /**
 * A function that takes a {@link module:ol/Feature~Feature} and a `{number}`
 * representing the view's resolution. The function should return a
 * {@link module:ol/style/Style~Style} or an array of them. This way e.g. a
 * vector layer can be styled. If the function returns `undefined`, the
 * feature will not be rendered.
 *
 * @typedef {function(import("../Feature.js").FeatureLike, number):(Style|Array<Style>|void)} StyleFunction
 */ /**
 * A {@link Style}, an array of {@link Style}, or a {@link StyleFunction}.
 * @typedef {Style|Array<Style>|StyleFunction} StyleLike
 */ /**
 * A function that takes a {@link module:ol/Feature~Feature} as argument and returns an
 * {@link module:ol/geom/Geometry~Geometry} that will be rendered and styled for the feature.
 *
 * @typedef {function(import("../Feature.js").FeatureLike):
 *     (import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined)} GeometryFunction
 */ /**
 * Custom renderer function. Takes two arguments:
 *
 * 1. The pixel coordinates of the geometry in GeoJSON notation.
 * 2. The {@link module:ol/render~State} of the layer renderer.
 *
 * @typedef {function((import("../coordinate.js").Coordinate|Array<import("../coordinate.js").Coordinate>|Array<Array<import("../coordinate.js").Coordinate>>|Array<Array<Array<import("../coordinate.js").Coordinate>>>),import("../render.js").State): void} RenderFunction
 */ /**
 * @typedef {Object} Options
 * @property {string|import("../geom/Geometry.js").default|GeometryFunction} [geometry] Feature property or geometry
 * or function returning a geometry to render for this style.
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {import("./Image.js").default} [image] Image style.
 * @property {RenderFunction} [renderer] Custom renderer. When configured, `fill`, `stroke` and `image` will be
 * ignored, and the provided function will be called with each render frame for each geometry.
 * @property {RenderFunction} [hitDetectionRenderer] Custom renderer for hit detection. If provided will be used
 * in hit detection rendering.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {import("./Text.js").default} [text] Text style.
 * @property {number} [zIndex] Z index.
 */ /**
 * @classdesc
 * Container for vector feature rendering styles. Any changes made to the style
 * or its children through `set*()` methods will not take effect until the
 * feature or layer that uses the style is re-rendered.
 *
 * ## Feature styles
 *
 * If no style is defined, the following default style is used:
 * ```js
 *  import {Circle, Fill, Stroke, Style} from 'ol/style.js';
 *
 *  const fill = new Fill({
 *    color: 'rgba(255,255,255,0.4)',
 *  });
 *  const stroke = new Stroke({
 *    color: '#3399CC',
 *    width: 1.25,
 *  });
 *  const styles = [
 *    new Style({
 *      image: new Circle({
 *        fill: fill,
 *        stroke: stroke,
 *        radius: 5,
 *      }),
 *      fill: fill,
 *      stroke: stroke,
 *    }),
 *  ];
 * ```
 *
 * A separate editing style has the following defaults:
 * ```js
 *  import {Circle, Fill, Stroke, Style} from 'ol/style.js';
 *
 *  const styles = {};
 *  const white = [255, 255, 255, 1];
 *  const blue = [0, 153, 255, 1];
 *  const width = 3;
 *  styles['Polygon'] = [
 *    new Style({
 *      fill: new Fill({
 *        color: [255, 255, 255, 0.5],
 *      }),
 *    }),
 *  ];
 *  styles['MultiPolygon'] =
 *      styles['Polygon'];
 *  styles['LineString'] = [
 *    new Style({
 *      stroke: new Stroke({
 *        color: white,
 *        width: width + 2,
 *      }),
 *    }),
 *    new Style({
 *      stroke: new Stroke({
 *        color: blue,
 *        width: width,
 *      }),
 *    }),
 *  ];
 *  styles['MultiLineString'] = styles['LineString'];
 *
 *  styles['Circle'] = styles['Polygon'].concat(
 *    styles['LineString']
 *  );
 *
 *  styles['Point'] = [
 *    new Style({
 *      image: new Circle({
 *        radius: width * 2,
 *        fill: new Fill({
 *          color: blue,
 *        }),
 *        stroke: new Stroke({
 *          color: white,
 *          width: width / 2,
 *        }),
 *      }),
 *      zIndex: Infinity,
 *    }),
 *  ];
 *  styles['MultiPoint'] =
 *      styles['Point'];
 *  styles['GeometryCollection'] =
 *      styles['Polygon'].concat(
 *          styles['LineString'],
 *          styles['Point']
 *      );
 * ```
 *
 * @api
 */ class $97cdc16020961e75$var$Style {
    /**
   * @param {Options} [options] Style options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {string|import("../geom/Geometry.js").default|GeometryFunction|null}
     */ this.geometry_ = null;
        /**
     * @private
     * @type {!GeometryFunction}
     */ this.geometryFunction_ = $97cdc16020961e75$var$defaultGeometryFunction;
        if (options.geometry !== undefined) this.setGeometry(options.geometry);
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : null;
        /**
     * @private
     * @type {import("./Image.js").default|null}
     */ this.image_ = options.image !== undefined ? options.image : null;
        /**
     * @private
     * @type {RenderFunction|null}
     */ this.renderer_ = options.renderer !== undefined ? options.renderer : null;
        /**
     * @private
     * @type {RenderFunction|null}
     */ this.hitDetectionRenderer_ = options.hitDetectionRenderer !== undefined ? options.hitDetectionRenderer : null;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {import("./Text.js").default|null}
     */ this.text_ = options.text !== undefined ? options.text : null;
        /**
     * @private
     * @type {number|undefined}
     */ this.zIndex_ = options.zIndex;
    }
    /**
   * Clones the style.
   * @return {Style} The cloned style.
   * @api
   */ clone() {
        let geometry = this.getGeometry();
        if (geometry && typeof geometry === 'object') geometry = /** @type {import("../geom/Geometry.js").default} */ geometry.clone();
        return new $97cdc16020961e75$var$Style({
            geometry: geometry ?? undefined,
            fill: this.getFill() ? this.getFill().clone() : undefined,
            image: this.getImage() ? this.getImage().clone() : undefined,
            renderer: this.getRenderer() ?? undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            text: this.getText() ? this.getText().clone() : undefined,
            zIndex: this.getZIndex()
        });
    }
    /**
   * Get the custom renderer function that was configured with
   * {@link #setRenderer} or the `renderer` constructor option.
   * @return {RenderFunction|null} Custom renderer function.
   * @api
   */ getRenderer() {
        return this.renderer_;
    }
    /**
   * Sets a custom renderer function for this style. When set, `fill`, `stroke`
   * and `image` options of the style will be ignored.
   * @param {RenderFunction|null} renderer Custom renderer function.
   * @api
   */ setRenderer(renderer) {
        this.renderer_ = renderer;
    }
    /**
   * Sets a custom renderer function for this style used
   * in hit detection.
   * @param {RenderFunction|null} renderer Custom renderer function.
   * @api
   */ setHitDetectionRenderer(renderer) {
        this.hitDetectionRenderer_ = renderer;
    }
    /**
   * Get the custom renderer function that was configured with
   * {@link #setHitDetectionRenderer} or the `hitDetectionRenderer` constructor option.
   * @return {RenderFunction|null} Custom renderer function.
   * @api
   */ getHitDetectionRenderer() {
        return this.hitDetectionRenderer_;
    }
    /**
   * Get the geometry to be rendered.
   * @return {string|import("../geom/Geometry.js").default|GeometryFunction|null}
   * Feature property or geometry or function that returns the geometry that will
   * be rendered with this style.
   * @api
   */ getGeometry() {
        return this.geometry_;
    }
    /**
   * Get the function used to generate a geometry for rendering.
   * @return {!GeometryFunction} Function that is called with a feature
   * and returns the geometry to render instead of the feature's geometry.
   * @api
   */ getGeometryFunction() {
        return this.geometryFunction_;
    }
    /**
   * Get the fill style.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Set the fill style.
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
    }
    /**
   * Get the image style.
   * @return {import("./Image.js").default|null} Image style.
   * @api
   */ getImage() {
        return this.image_;
    }
    /**
   * Set the image style.
   * @param {import("./Image.js").default} image Image style.
   * @api
   */ setImage(image) {
        this.image_ = image;
    }
    /**
   * Get the stroke style.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Set the stroke style.
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
    }
    /**
   * Get the text style.
   * @return {import("./Text.js").default|null} Text style.
   * @api
   */ getText() {
        return this.text_;
    }
    /**
   * Set the text style.
   * @param {import("./Text.js").default} text Text style.
   * @api
   */ setText(text) {
        this.text_ = text;
    }
    /**
   * Get the z-index for the style.
   * @return {number|undefined} ZIndex.
   * @api
   */ getZIndex() {
        return this.zIndex_;
    }
    /**
   * Set a geometry that is rendered instead of the feature's geometry.
   *
   * @param {string|import("../geom/Geometry.js").default|GeometryFunction|null} geometry
   *     Feature property or geometry or function returning a geometry to render
   *     for this style.
   * @api
   */ setGeometry(geometry) {
        if (typeof geometry === 'function') this.geometryFunction_ = geometry;
        else if (typeof geometry === 'string') this.geometryFunction_ = function(feature) {
            return /** @type {import("../geom/Geometry.js").default} */ feature.get(geometry);
        };
        else if (!geometry) this.geometryFunction_ = $97cdc16020961e75$var$defaultGeometryFunction;
        else if (geometry !== undefined) this.geometryFunction_ = function() {
            return /** @type {import("../geom/Geometry.js").default} */ geometry;
        };
        this.geometry_ = geometry;
    }
    /**
   * Set the z-index.
   *
   * @param {number|undefined} zIndex ZIndex.
   * @api
   */ setZIndex(zIndex) {
        this.zIndex_ = zIndex;
    }
}
function $97cdc16020961e75$export$c314ea3f6b164147(obj) {
    let styleFunction;
    if (typeof obj === 'function') styleFunction = obj;
    else {
        /**
     * @type {Array<Style>}
     */ let styles;
        if (Array.isArray(obj)) styles = obj;
        else {
            (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(typeof /** @type {?} */ obj.getZIndex === 'function', 'Expected an `Style` or an array of `Style`');
            const style = /** @type {Style} */ obj;
            styles = [
                style
            ];
        }
        styleFunction = function() {
            return styles;
        };
    }
    return styleFunction;
}
/**
 * @type {Array<Style>|null}
 */ let $97cdc16020961e75$var$defaultStyles = null;
function $97cdc16020961e75$export$6865c5ac2f5ce8b6(feature, resolution) {
    // We don't use an immediately-invoked function
    // and a closure so we don't get an error at script evaluation time in
    // browsers that do not support Canvas. (import("./Circle.js").CircleStyle does
    // canvas.getContext('2d') at construction time, which will cause an.error
    // in such browsers.)
    if (!$97cdc16020961e75$var$defaultStyles) {
        const fill = new (0, $83cca4c6d7d93d3c$export$2e2bcd8739ae039)({
            color: 'rgba(255,255,255,0.4)'
        });
        const stroke = new (0, $4eba39905b0caafc$export$2e2bcd8739ae039)({
            color: '#3399CC',
            width: 1.25
        });
        $97cdc16020961e75$var$defaultStyles = [
            new $97cdc16020961e75$var$Style({
                image: new (0, $c1968949086c96bc$export$2e2bcd8739ae039)({
                    fill: fill,
                    stroke: stroke,
                    radius: 5
                }),
                fill: fill,
                stroke: stroke
            })
        ];
    }
    return $97cdc16020961e75$var$defaultStyles;
}
function $97cdc16020961e75$export$ed1eaede5d0e77ac() {
    /** @type {Object<import("../geom/Geometry.js").Type, Array<Style>>} */ const styles = {};
    const white = [
        255,
        255,
        255,
        1
    ];
    const blue = [
        0,
        153,
        255,
        1
    ];
    const width = 3;
    styles['Polygon'] = [
        new $97cdc16020961e75$var$Style({
            fill: new (0, $83cca4c6d7d93d3c$export$2e2bcd8739ae039)({
                color: [
                    255,
                    255,
                    255,
                    0.5
                ]
            })
        })
    ];
    styles['MultiPolygon'] = styles['Polygon'];
    styles['LineString'] = [
        new $97cdc16020961e75$var$Style({
            stroke: new (0, $4eba39905b0caafc$export$2e2bcd8739ae039)({
                color: white,
                width: width + 2
            })
        }),
        new $97cdc16020961e75$var$Style({
            stroke: new (0, $4eba39905b0caafc$export$2e2bcd8739ae039)({
                color: blue,
                width: width
            })
        })
    ];
    styles['MultiLineString'] = styles['LineString'];
    styles['Circle'] = styles['Polygon'].concat(styles['LineString']);
    styles['Point'] = [
        new $97cdc16020961e75$var$Style({
            image: new (0, $c1968949086c96bc$export$2e2bcd8739ae039)({
                radius: width * 2,
                fill: new (0, $83cca4c6d7d93d3c$export$2e2bcd8739ae039)({
                    color: blue
                }),
                stroke: new (0, $4eba39905b0caafc$export$2e2bcd8739ae039)({
                    color: white,
                    width: width / 2
                })
            }),
            zIndex: Infinity
        })
    ];
    styles['MultiPoint'] = styles['Point'];
    styles['GeometryCollection'] = styles['Polygon'].concat(styles['LineString'], styles['Point']);
    return styles;
}
/**
 * Function that is called with a feature and returns its default geometry.
 * @param {import("../Feature.js").FeatureLike} feature Feature to get the geometry for.
 * @return {import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined} Geometry to render.
 */ function $97cdc16020961e75$var$defaultGeometryFunction(feature) {
    return feature.getGeometry();
}
var $97cdc16020961e75$export$2e2bcd8739ae039 = $97cdc16020961e75$var$Style;


/**
 * @module ol/style/Text
 */ 

/**
 * @typedef {'point' | 'line'} TextPlacement
 * Default text placement is `'point'`. Note that
 * `'line'` requires the underlying geometry to be a {@link module:ol/geom/LineString~LineString},
 * {@link module:ol/geom/Polygon~Polygon}, {@link module:ol/geom/MultiLineString~MultiLineString} or
 * {@link module:ol/geom/MultiPolygon~MultiPolygon}.
 */ /**
 * @typedef {'left' | 'center' | 'right'} TextJustify
 */ /**
 * The default fill color to use if no fill was set at construction time; a
 * blackish `#333`.
 *
 * @const {string}
 */ const $3df0a22f11ceded5$var$DEFAULT_FILL_COLOR = '#333';
/**
 * @typedef {Object} Options
 * @property {string} [font] Font style as CSS `font` value, see:
 * https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/font. Default is `'10px sans-serif'`
 * @property {number} [maxAngle=Math.PI/4] When `placement` is set to `'line'`, allow a maximum angle between adjacent characters.
 * The expected value is in radians, and the default is 45° (`Math.PI / 4`).
 * @property {number} [offsetX=0] Horizontal text offset in pixels. A positive will shift the text right.
 * @property {number} [offsetY=0] Vertical text offset in pixels. A positive will shift the text down.
 * @property {boolean} [overflow=false] For polygon labels or when `placement` is set to `'line'`, allow text to exceed
 * the width of the polygon at the label position or the length of the path that it follows.
 * @property {TextPlacement} [placement='point'] Text placement.
 * @property {number} [repeat] Repeat interval. When set, the text will be repeated at this interval, which specifies
 * the distance between two text anchors in pixels. Only available when `placement` is set to `'line'`. Overrides 'textAlign'.
 * @property {number|import("../size.js").Size} [scale] Scale.
 * @property {boolean} [rotateWithView=false] Whether to rotate the text with the view.
 * @property {boolean} [keepUpright=true] Whether the text can be rotated 180° to prevent being rendered upside down.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {string|Array<string>} [text] Text content or rich text content. For plain text provide a string, which can
 * contain line breaks (`\n`). For rich text provide an array of text/font tuples. A tuple consists of the text to
 * render and the font to use (or `''` to use the text style's font). A line break has to be a separate tuple (i.e. `'\n', ''`).
 * **Example:** `['foo', 'bold 10px sans-serif', ' bar', 'italic 10px sans-serif', ' baz', '']` will yield "**foo** *bar* baz".
 * **Note:** Rich text is not supported for `placement: 'line'` or the immediate rendering API.
 * @property {CanvasTextAlign} [textAlign] Text alignment. Possible values: `'left'`, `'right'`, `'center'`, `'end'` or `'start'`.
 * Default is `'center'` for `placement: 'point'`. For `placement: 'line'`, the default is to let the renderer choose a
 * placement where `maxAngle` is not exceeded.
 * @property {TextJustify} [justify] Text justification within the text box.
 * If not set, text is justified towards the `textAlign` anchor.
 * Otherwise, use options `'left'`, `'center'`, or `'right'` to justify the text within the text box.
 * **Note:** `justify` is ignored for immediate rendering and also for `placement: 'line'`.
 * @property {CanvasTextBaseline} [textBaseline='middle'] Text base line. Possible values: `'bottom'`, `'top'`, `'middle'`, `'alphabetic'`,
 * `'hanging'`, `'ideographic'`.
 * @property {import("./Fill.js").default|null} [fill] Fill style. If none is provided, we'll use a dark fill-style (#333). Specify `null` for no fill.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {import("./Fill.js").default} [backgroundFill] Fill style for the text background when `placement` is
 * `'point'`. Default is no fill.
 * @property {import("./Stroke.js").default} [backgroundStroke] Stroke style for the text background  when `placement`
 * is `'point'`. Default is no stroke.
 * @property {Array<number>} [padding=[0, 0, 0, 0]] Padding in pixels around the text for decluttering and background. The order of
 * values in the array is `[top, right, bottom, left]`.
 * @property {import('../style/Style.js').DeclutterMode} [declutterMode] Declutter mode: `declutter`, `obstacle`, `none`
 */ /**
 * @classdesc
 * Set text style for vector features.
 * @api
 */ class $3df0a22f11ceded5$var$Text {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {string|undefined}
     */ this.font_ = options.font;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = options.rotation;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.rotateWithView_ = options.rotateWithView;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.keepUpright_ = options.keepUpright;
        /**
     * @private
     * @type {number|import("../size.js").Size|undefined}
     */ this.scale_ = options.scale;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.scaleArray_ = (0, $e9727ecf69942748$export$a71a825ff42fb8e1)(options.scale !== undefined ? options.scale : 1);
        /**
     * @private
     * @type {string|Array<string>|undefined}
     */ this.text_ = options.text;
        /**
     * @private
     * @type {CanvasTextAlign|undefined}
     */ this.textAlign_ = options.textAlign;
        /**
     * @private
     * @type {TextJustify|undefined}
     */ this.justify_ = options.justify;
        /**
     * @private
     * @type {number|undefined}
     */ this.repeat_ = options.repeat;
        /**
     * @private
     * @type {CanvasTextBaseline|undefined}
     */ this.textBaseline_ = options.textBaseline;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : new (0, $83cca4c6d7d93d3c$export$2e2bcd8739ae039)({
            color: $3df0a22f11ceded5$var$DEFAULT_FILL_COLOR
        });
        /**
     * @private
     * @type {number}
     */ this.maxAngle_ = options.maxAngle !== undefined ? options.maxAngle : Math.PI / 4;
        /**
     * @private
     * @type {TextPlacement}
     */ this.placement_ = options.placement !== undefined ? options.placement : 'point';
        /**
     * @private
     * @type {boolean}
     */ this.overflow_ = !!options.overflow;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {number}
     */ this.offsetX_ = options.offsetX !== undefined ? options.offsetX : 0;
        /**
     * @private
     * @type {number}
     */ this.offsetY_ = options.offsetY !== undefined ? options.offsetY : 0;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.backgroundFill_ = options.backgroundFill ? options.backgroundFill : null;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.backgroundStroke_ = options.backgroundStroke ? options.backgroundStroke : null;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.padding_ = options.padding === undefined ? null : options.padding;
        /**
     * @private
     * @type {import('../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = options.declutterMode;
    }
    /**
   * Clones the style.
   * @return {Text} The cloned style.
   * @api
   */ clone() {
        const scale = this.getScale();
        return new $3df0a22f11ceded5$var$Text({
            font: this.getFont(),
            placement: this.getPlacement(),
            repeat: this.getRepeat(),
            maxAngle: this.getMaxAngle(),
            overflow: this.getOverflow(),
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            keepUpright: this.getKeepUpright(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            text: this.getText(),
            textAlign: this.getTextAlign(),
            justify: this.getJustify(),
            textBaseline: this.getTextBaseline(),
            fill: this.getFill() instanceof (0, $83cca4c6d7d93d3c$export$2e2bcd8739ae039) ? this.getFill().clone() : this.getFill(),
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            offsetX: this.getOffsetX(),
            offsetY: this.getOffsetY(),
            backgroundFill: this.getBackgroundFill() ? this.getBackgroundFill().clone() : undefined,
            backgroundStroke: this.getBackgroundStroke() ? this.getBackgroundStroke().clone() : undefined,
            padding: this.getPadding() || undefined,
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the `overflow` configuration.
   * @return {boolean} Let text overflow the length of the path they follow.
   * @api
   */ getOverflow() {
        return this.overflow_;
    }
    /**
   * Get the font name.
   * @return {string|undefined} Font.
   * @api
   */ getFont() {
        return this.font_;
    }
    /**
   * Get the maximum angle between adjacent characters.
   * @return {number} Angle in radians.
   * @api
   */ getMaxAngle() {
        return this.maxAngle_;
    }
    /**
   * Get the label placement.
   * @return {TextPlacement} Text placement.
   * @api
   */ getPlacement() {
        return this.placement_;
    }
    /**
   * Get the repeat interval of the text.
   * @return {number|undefined} Repeat interval in pixels.
   * @api
   */ getRepeat() {
        return this.repeat_;
    }
    /**
   * Get the x-offset for the text.
   * @return {number} Horizontal text offset.
   * @api
   */ getOffsetX() {
        return this.offsetX_;
    }
    /**
   * Get the y-offset for the text.
   * @return {number} Vertical text offset.
   * @api
   */ getOffsetY() {
        return this.offsetY_;
    }
    /**
   * Get the fill style for the text.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Determine whether the text rotates with the map.
   * @return {boolean|undefined} Rotate with map.
   * @api
   */ getRotateWithView() {
        return this.rotateWithView_;
    }
    /**
   * Determine whether the text can be rendered upside down.
   * @return {boolean|undefined} Keep text upright.
   * @api
   */ getKeepUpright() {
        return this.keepUpright_;
    }
    /**
   * Get the text rotation.
   * @return {number|undefined} Rotation.
   * @api
   */ getRotation() {
        return this.rotation_;
    }
    /**
   * Get the text scale.
   * @return {number|import("../size.js").Size|undefined} Scale.
   * @api
   */ getScale() {
        return this.scale_;
    }
    /**
   * Get the symbolizer scale array.
   * @return {import("../size.js").Size} Scale array.
   */ getScaleArray() {
        return this.scaleArray_;
    }
    /**
   * Get the stroke style for the text.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Get the text to be rendered.
   * @return {string|Array<string>|undefined} Text.
   * @api
   */ getText() {
        return this.text_;
    }
    /**
   * Get the text alignment.
   * @return {CanvasTextAlign|undefined} Text align.
   * @api
   */ getTextAlign() {
        return this.textAlign_;
    }
    /**
   * Get the justification.
   * @return {TextJustify|undefined} Justification.
   * @api
   */ getJustify() {
        return this.justify_;
    }
    /**
   * Get the text baseline.
   * @return {CanvasTextBaseline|undefined} Text baseline.
   * @api
   */ getTextBaseline() {
        return this.textBaseline_;
    }
    /**
   * Get the background fill style for the text.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getBackgroundFill() {
        return this.backgroundFill_;
    }
    /**
   * Get the background stroke style for the text.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getBackgroundStroke() {
        return this.backgroundStroke_;
    }
    /**
   * Get the padding for the text.
   * @return {Array<number>|null} Padding.
   * @api
   */ getPadding() {
        return this.padding_;
    }
    /**
   * Get the declutter mode of the shape
   * @return {import("./Style.js").DeclutterMode} Shape's declutter mode
   * @api
   */ getDeclutterMode() {
        return this.declutterMode_;
    }
    /**
   * Set the `overflow` property.
   *
   * @param {boolean} overflow Let text overflow the path that it follows.
   * @api
   */ setOverflow(overflow) {
        this.overflow_ = overflow;
    }
    /**
   * Set the font.
   *
   * @param {string|undefined} font Font.
   * @api
   */ setFont(font) {
        this.font_ = font;
    }
    /**
   * Set the maximum angle between adjacent characters.
   *
   * @param {number} maxAngle Angle in radians.
   * @api
   */ setMaxAngle(maxAngle) {
        this.maxAngle_ = maxAngle;
    }
    /**
   * Set the x offset.
   *
   * @param {number} offsetX Horizontal text offset.
   * @api
   */ setOffsetX(offsetX) {
        this.offsetX_ = offsetX;
    }
    /**
   * Set the y offset.
   *
   * @param {number} offsetY Vertical text offset.
   * @api
   */ setOffsetY(offsetY) {
        this.offsetY_ = offsetY;
    }
    /**
   * Set the text placement.
   *
   * @param {TextPlacement} placement Placement.
   * @api
   */ setPlacement(placement) {
        this.placement_ = placement;
    }
    /**
   * Set the repeat interval of the text.
   * @param {number|undefined} [repeat] Repeat interval in pixels.
   * @api
   */ setRepeat(repeat) {
        this.repeat_ = repeat;
    }
    /**
   * Set whether to rotate the text with the view.
   *
   * @param {boolean} rotateWithView Rotate with map.
   * @api
   */ setRotateWithView(rotateWithView) {
        this.rotateWithView_ = rotateWithView;
    }
    /**
   * Set whether the text can be rendered upside down.
   *
   * @param {boolean} keepUpright Keep text upright.
   * @api
   */ setKeepUpright(keepUpright) {
        this.keepUpright_ = keepUpright;
    }
    /**
   * Set the fill.
   *
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
    }
    /**
   * Set the rotation.
   *
   * @param {number|undefined} rotation Rotation.
   * @api
   */ setRotation(rotation) {
        this.rotation_ = rotation;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size|undefined} scale Scale.
   * @api
   */ setScale(scale) {
        this.scale_ = scale;
        this.scaleArray_ = (0, $e9727ecf69942748$export$a71a825ff42fb8e1)(scale !== undefined ? scale : 1);
    }
    /**
   * Set the stroke.
   *
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
    }
    /**
   * Set the text.
   *
   * @param {string|Array<string>|undefined} text Text.
   * @api
   */ setText(text) {
        this.text_ = text;
    }
    /**
   * Set the text alignment.
   *
   * @param {CanvasTextAlign|undefined} textAlign Text align.
   * @api
   */ setTextAlign(textAlign) {
        this.textAlign_ = textAlign;
    }
    /**
   * Set the justification.
   *
   * @param {TextJustify|undefined} justify Justification.
   * @api
   */ setJustify(justify) {
        this.justify_ = justify;
    }
    /**
   * Set the text baseline.
   *
   * @param {CanvasTextBaseline|undefined} textBaseline Text baseline.
   * @api
   */ setTextBaseline(textBaseline) {
        this.textBaseline_ = textBaseline;
    }
    /**
   * Set the background fill.
   *
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setBackgroundFill(fill) {
        this.backgroundFill_ = fill;
    }
    /**
   * Set the background stroke.
   *
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setBackgroundStroke(stroke) {
        this.backgroundStroke_ = stroke;
    }
    /**
   * Set the padding (`[top, right, bottom, left]`).
   *
   * @param {Array<number>|null} padding Padding.
   * @api
   */ setPadding(padding) {
        this.padding_ = padding;
    }
}
var $3df0a22f11ceded5$export$2e2bcd8739ae039 = $3df0a22f11ceded5$var$Text;


/**
 * @fileoverview This module includes functions to build styles for the canvas renderer.  Building
 * is composed of two steps: parsing and compiling.  The parsing step takes an encoded expression
 * and returns an instance of one of the expression classes.  The compiling step takes the
 * expression instance and returns a function that can be evaluated to return a literal value.  The
 * evaluator function should do as little allocation and work as possible.
 */ /**
 * @typedef {import("../../style/flat.js").FlatStyle} FlatStyle
 */ /**
 * @typedef {import("../../expr/expression.js").EncodedExpression} EncodedExpression
 */ /**
 * @typedef {import("../../expr/expression.js").ParsingContext} ParsingContext
 */ /**
 * @typedef {import("../../expr/expression.js").CallExpression} CallExpression
 */ /**
 * @typedef {import("../../expr/cpu.js").EvaluationContext} EvaluationContext
 */ /**
 * @typedef {import("../../expr/cpu.js").ExpressionEvaluator} ExpressionEvaluator
 */ /**
 * @param {EvaluationContext} context The evaluation context.
 * @return {boolean} Always true.
 */ function $f4ebf74948ee9ae3$var$always(context) {
    return true;
}
function $f4ebf74948ee9ae3$export$fc6a94152b1b05a8(rules) {
    const parsingContext = (0, $e8b52593925b4bc9$export$1c8b4c1584800354)();
    const evaluator = $f4ebf74948ee9ae3$export$d6ae6a4799989976(rules, parsingContext);
    const evaluationContext = (0, $24bd7dccc97f8a38$export$c18f39f0e136c26)();
    return function(feature, resolution) {
        evaluationContext.properties = feature.getPropertiesInternal();
        evaluationContext.resolution = resolution;
        if (parsingContext.featureId) {
            const id = feature.getId();
            if (id !== undefined) evaluationContext.featureId = id;
            else evaluationContext.featureId = null;
        }
        if (parsingContext.geometryType) evaluationContext.geometryType = (0, $e8b52593925b4bc9$export$8da88d86d10c1295)(feature.getGeometry());
        return evaluator(evaluationContext);
    };
}
function $f4ebf74948ee9ae3$export$5a130bc4f0a0420b(flatStyles) {
    const parsingContext = (0, $e8b52593925b4bc9$export$1c8b4c1584800354)();
    const length = flatStyles.length;
    /**
   * @type {Array<StyleEvaluator>}
   */ const evaluators = new Array(length);
    for(let i = 0; i < length; ++i)evaluators[i] = $f4ebf74948ee9ae3$export$a6e5f510497b7388(flatStyles[i], parsingContext);
    const evaluationContext = (0, $24bd7dccc97f8a38$export$c18f39f0e136c26)();
    /**
   * @type {Array<Style>}
   */ const styles = new Array(length);
    return function(feature, resolution) {
        evaluationContext.properties = feature.getPropertiesInternal();
        evaluationContext.resolution = resolution;
        if (parsingContext.featureId) {
            const id = feature.getId();
            if (id !== undefined) evaluationContext.featureId = id;
            else evaluationContext.featureId = null;
        }
        let nonNullCount = 0;
        for(let i = 0; i < length; ++i){
            const style = evaluators[i](evaluationContext);
            if (style) {
                styles[nonNullCount] = style;
                nonNullCount += 1;
            }
        }
        styles.length = nonNullCount;
        return styles;
    };
}
function $f4ebf74948ee9ae3$export$d6ae6a4799989976(rules, context) {
    const length = rules.length;
    /**
   * @type {Array<CompiledRule>}
   */ const compiledRules = new Array(length);
    for(let i = 0; i < length; ++i){
        const rule = rules[i];
        const filter = 'filter' in rule ? (0, $24bd7dccc97f8a38$export$b5f535122a9211f0)(rule.filter, (0, $e8b52593925b4bc9$export$240f7fffab1b25a0), context) : $f4ebf74948ee9ae3$var$always;
        /**
     * @type {Array<StyleEvaluator>}
     */ let styles;
        if (Array.isArray(rule.style)) {
            const styleLength = rule.style.length;
            styles = new Array(styleLength);
            for(let j = 0; j < styleLength; ++j)styles[j] = $f4ebf74948ee9ae3$export$a6e5f510497b7388(rule.style[j], context);
        } else styles = [
            $f4ebf74948ee9ae3$export$a6e5f510497b7388(rule.style, context)
        ];
        compiledRules[i] = {
            filter: filter,
            styles: styles
        };
    }
    return function(context) {
        /**
     * @type {Array<Style>}
     */ const styles = [];
        let someMatched = false;
        for(let i = 0; i < length; ++i){
            const filterEvaluator = compiledRules[i].filter;
            if (!filterEvaluator(context)) continue;
            if (rules[i].else && someMatched) continue;
            someMatched = true;
            for (const styleEvaluator of compiledRules[i].styles){
                const style = styleEvaluator(context);
                if (!style) continue;
                styles.push(style);
            }
        }
        return styles;
    };
}
function $f4ebf74948ee9ae3$export$a6e5f510497b7388(flatStyle, context) {
    const evaluateFill = $f4ebf74948ee9ae3$var$buildFill(flatStyle, '', context);
    const evaluateStroke = $f4ebf74948ee9ae3$var$buildStroke(flatStyle, '', context);
    const evaluateText = $f4ebf74948ee9ae3$var$buildText(flatStyle, context);
    const evaluateImage = $f4ebf74948ee9ae3$var$buildImage(flatStyle, context);
    const evaluateZIndex = $f4ebf74948ee9ae3$var$numberEvaluator(flatStyle, 'z-index', context);
    if (!evaluateFill && !evaluateStroke && !evaluateText && !evaluateImage && !(0, $0669c62275461b52$export$dd1bc94b04021eeb)(flatStyle)) // assume this is a user error
    // would be nice to check the properties and suggest "did you mean..."
    throw new Error('No fill, stroke, point, or text symbolizer properties in style: ' + JSON.stringify(flatStyle));
    const style = new (0, $97cdc16020961e75$export$2e2bcd8739ae039)();
    return function(context) {
        let empty = true;
        if (evaluateFill) {
            const fill = evaluateFill(context);
            if (fill) empty = false;
            style.setFill(fill);
        }
        if (evaluateStroke) {
            const stroke = evaluateStroke(context);
            if (stroke) empty = false;
            style.setStroke(stroke);
        }
        if (evaluateText) {
            const text = evaluateText(context);
            if (text) empty = false;
            style.setText(text);
        }
        if (evaluateImage) {
            const image = evaluateImage(context);
            if (image) empty = false;
            style.setImage(image);
        }
        if (evaluateZIndex) style.setZIndex(evaluateZIndex(context));
        if (empty) return null;
        return style;
    };
}
/**
 * @typedef {function(EvaluationContext):Fill|null} FillEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} prefix The property prefix.
 * @param {ParsingContext} context The parsing context.
 * @return {FillEvaluator?} A function that evaluates to a fill.
 */ function $f4ebf74948ee9ae3$var$buildFill(flatStyle, prefix, context) {
    let evaluateColor;
    if (prefix + 'fill-pattern-src' in flatStyle) evaluateColor = $f4ebf74948ee9ae3$var$patternEvaluator(flatStyle, prefix + 'fill-', context);
    else {
        if (flatStyle[prefix + 'fill-color'] === 'none') // avoids hit detection
        return (context)=>null;
        evaluateColor = $f4ebf74948ee9ae3$var$colorLikeEvaluator(flatStyle, prefix + 'fill-color', context);
    }
    if (!evaluateColor) return null;
    const fill = new (0, $83cca4c6d7d93d3c$export$2e2bcd8739ae039)();
    return function(context) {
        const color = evaluateColor(context);
        if (color === (0, $6c864c0c7b61b9b5$export$6c844c64a5efe1ee)) return null;
        fill.setColor(color);
        return fill;
    };
}
/**
 * @typedef {function(EvaluationContext):Stroke|null} StrokeEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} prefix The property prefix.
 * @param {ParsingContext} context The parsing context.
 * @return {StrokeEvaluator?} A function the evaluates to a stroke.
 */ function $f4ebf74948ee9ae3$var$buildStroke(flatStyle, prefix, context) {
    const evaluateWidth = $f4ebf74948ee9ae3$var$numberEvaluator(flatStyle, prefix + 'stroke-width', context);
    const evaluateColor = $f4ebf74948ee9ae3$var$colorLikeEvaluator(flatStyle, prefix + 'stroke-color', context);
    if (!evaluateWidth && !evaluateColor) return null;
    const evaluateLineCap = $f4ebf74948ee9ae3$var$stringEvaluator(flatStyle, prefix + 'stroke-line-cap', context);
    const evaluateLineJoin = $f4ebf74948ee9ae3$var$stringEvaluator(flatStyle, prefix + 'stroke-line-join', context);
    const evaluateLineDash = $f4ebf74948ee9ae3$var$numberArrayEvaluator(flatStyle, prefix + 'stroke-line-dash', context);
    const evaluateLineDashOffset = $f4ebf74948ee9ae3$var$numberEvaluator(flatStyle, prefix + 'stroke-line-dash-offset', context);
    const evaluateMiterLimit = $f4ebf74948ee9ae3$var$numberEvaluator(flatStyle, prefix + 'stroke-miter-limit', context);
    const evaluateOffset = $f4ebf74948ee9ae3$var$numberEvaluator(flatStyle, prefix + 'stroke-offset', context);
    const stroke = new (0, $4eba39905b0caafc$export$2e2bcd8739ae039)();
    return function(context) {
        if (evaluateColor) {
            const color = evaluateColor(context);
            if (color === (0, $6c864c0c7b61b9b5$export$6c844c64a5efe1ee)) return null;
            stroke.setColor(color);
        }
        if (evaluateWidth) stroke.setWidth(evaluateWidth(context));
        if (evaluateLineCap) {
            const lineCap = evaluateLineCap(context);
            if (lineCap !== 'butt' && lineCap !== 'round' && lineCap !== 'square') throw new Error('Expected butt, round, or square line cap');
            stroke.setLineCap(lineCap);
        }
        if (evaluateLineJoin) {
            const lineJoin = evaluateLineJoin(context);
            if (lineJoin !== 'bevel' && lineJoin !== 'round' && lineJoin !== 'miter') throw new Error('Expected bevel, round, or miter line join');
            stroke.setLineJoin(lineJoin);
        }
        if (evaluateLineDash) stroke.setLineDash(evaluateLineDash(context));
        if (evaluateLineDashOffset) stroke.setLineDashOffset(evaluateLineDashOffset(context));
        if (evaluateMiterLimit) stroke.setMiterLimit(evaluateMiterLimit(context));
        if (evaluateOffset) stroke.setOffset(evaluateOffset(context));
        return stroke;
    };
}
/**
 * @typedef {function(EvaluationContext):Text} TextEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {TextEvaluator?} A function that evaluates to a text symbolizer.
 */ function $f4ebf74948ee9ae3$var$buildText(flatStyle, context) {
    const prefix = 'text-';
    // Currently, an Array<string> may be used for rich text support.  This doesn't
    // work with our expression syntax where arrays of strings are interpreted as
    // call expressions.  To support rich text, we could add a 'strings' operator
    // where all the following arguments would be string values.
    const evaluateValue = $f4ebf74948ee9ae3$var$stringEvaluator(flatStyle, prefix + 'value', context);
    if (!evaluateValue) return null;
    const evaluateFill = $f4ebf74948ee9ae3$var$buildFill(flatStyle, prefix, context);
    const evaluateBackgroundFill = $f4ebf74948ee9ae3$var$buildFill(flatStyle, prefix + 'background-', context);
    const evaluateStroke = $f4ebf74948ee9ae3$var$buildStroke(flatStyle, prefix, context);
    const evaluateBackgroundStroke = $f4ebf74948ee9ae3$var$buildStroke(flatStyle, prefix + 'background-', context);
    const evaluateFont = $f4ebf74948ee9ae3$var$stringEvaluator(flatStyle, prefix + 'font', context);
    const evaluateMaxAngle = $f4ebf74948ee9ae3$var$numberEvaluator(flatStyle, prefix + 'max-angle', context);
    const evaluateOffsetX = $f4ebf74948ee9ae3$var$numberEvaluator(flatStyle, prefix + 'offset-x', context);
    const evaluateOffsetY = $f4ebf74948ee9ae3$var$numberEvaluator(flatStyle, prefix + 'offset-y', context);
    const evaluateOverflow = $f4ebf74948ee9ae3$var$booleanEvaluator(flatStyle, prefix + 'overflow', context);
    const evaluatePlacement = $f4ebf74948ee9ae3$var$stringEvaluator(flatStyle, prefix + 'placement', context);
    const evaluateRepeat = $f4ebf74948ee9ae3$var$numberEvaluator(flatStyle, prefix + 'repeat', context);
    const evaluateScale = $f4ebf74948ee9ae3$var$sizeLikeEvaluator(flatStyle, prefix + 'scale', context);
    const evaluateRotateWithView = $f4ebf74948ee9ae3$var$booleanEvaluator(flatStyle, prefix + 'rotate-with-view', context);
    const evaluateRotation = $f4ebf74948ee9ae3$var$numberEvaluator(flatStyle, prefix + 'rotation', context);
    const evaluateAlign = $f4ebf74948ee9ae3$var$stringEvaluator(flatStyle, prefix + 'align', context);
    const evaluateJustify = $f4ebf74948ee9ae3$var$stringEvaluator(flatStyle, prefix + 'justify', context);
    const evaluateBaseline = $f4ebf74948ee9ae3$var$stringEvaluator(flatStyle, prefix + 'baseline', context);
    const evaluateKeepUpright = $f4ebf74948ee9ae3$var$booleanEvaluator(flatStyle, prefix + 'keep-upright', context);
    const evaluatePadding = $f4ebf74948ee9ae3$var$numberArrayEvaluator(flatStyle, prefix + 'padding', context);
    // The following properties are not currently settable
    const declutterMode = $f4ebf74948ee9ae3$var$optionalDeclutterMode(flatStyle, prefix + 'declutter-mode');
    const text = new (0, $3df0a22f11ceded5$export$2e2bcd8739ae039)({
        declutterMode: declutterMode
    });
    return function(context) {
        text.setText(evaluateValue(context));
        if (evaluateFill) text.setFill(evaluateFill(context));
        if (evaluateBackgroundFill) text.setBackgroundFill(evaluateBackgroundFill(context));
        if (evaluateStroke) text.setStroke(evaluateStroke(context));
        if (evaluateBackgroundStroke) text.setBackgroundStroke(evaluateBackgroundStroke(context));
        if (evaluateFont) text.setFont(evaluateFont(context));
        if (evaluateMaxAngle) text.setMaxAngle(evaluateMaxAngle(context));
        if (evaluateOffsetX) text.setOffsetX(evaluateOffsetX(context));
        if (evaluateOffsetY) text.setOffsetY(evaluateOffsetY(context));
        if (evaluateOverflow) text.setOverflow(evaluateOverflow(context));
        if (evaluatePlacement) {
            const placement = evaluatePlacement(context);
            if (placement !== 'point' && placement !== 'line') throw new Error('Expected point or line for text-placement');
            text.setPlacement(placement);
        }
        if (evaluateRepeat) text.setRepeat(evaluateRepeat(context));
        if (evaluateScale) text.setScale(evaluateScale(context));
        if (evaluateRotateWithView) text.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateRotation) text.setRotation(evaluateRotation(context));
        if (evaluateAlign) {
            const textAlign = evaluateAlign(context);
            if (textAlign !== 'left' && textAlign !== 'center' && textAlign !== 'right' && textAlign !== 'end' && textAlign !== 'start') throw new Error('Expected left, right, center, start, or end for text-align');
            text.setTextAlign(textAlign);
        }
        if (evaluateJustify) {
            const justify = evaluateJustify(context);
            if (justify !== 'left' && justify !== 'right' && justify !== 'center') throw new Error('Expected left, right, or center for text-justify');
            text.setJustify(justify);
        }
        if (evaluateBaseline) {
            const textBaseline = evaluateBaseline(context);
            if (textBaseline !== 'bottom' && textBaseline !== 'top' && textBaseline !== 'middle' && textBaseline !== 'alphabetic' && textBaseline !== 'hanging') throw new Error('Expected bottom, top, middle, alphabetic, or hanging for text-baseline');
            text.setTextBaseline(textBaseline);
        }
        if (evaluatePadding) text.setPadding(evaluatePadding(context));
        if (evaluateKeepUpright) text.setKeepUpright(evaluateKeepUpright(context));
        return text;
    };
}
/**
 * @typedef {function(EvaluationContext):import("../../style/Image.js").default} ImageEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator?} A function that evaluates to an image symbolizer.
 */ function $f4ebf74948ee9ae3$var$buildImage(flatStyle, context) {
    if ('icon-src' in flatStyle) return $f4ebf74948ee9ae3$var$buildIcon(flatStyle, context);
    if ('shape-points' in flatStyle) return $f4ebf74948ee9ae3$var$buildShape(flatStyle, context);
    if ('circle-radius' in flatStyle) return $f4ebf74948ee9ae3$var$buildCircle(flatStyle, context);
    return null;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to an image symbolizer.
 */ function $f4ebf74948ee9ae3$var$buildIcon(flatStyle, context) {
    const prefix = 'icon-';
    // required property
    const srcName = prefix + 'src';
    const src = $f4ebf74948ee9ae3$var$requireString(flatStyle[srcName], srcName);
    // settable properties
    const evaluateAnchor = $f4ebf74948ee9ae3$var$coordinateEvaluator(flatStyle, prefix + 'anchor', context);
    const evaluateScale = $f4ebf74948ee9ae3$var$sizeLikeEvaluator(flatStyle, prefix + 'scale', context);
    const evaluateOpacity = $f4ebf74948ee9ae3$var$numberEvaluator(flatStyle, prefix + 'opacity', context);
    const evaluateDisplacement = $f4ebf74948ee9ae3$var$coordinateEvaluator(flatStyle, prefix + 'displacement', context);
    const evaluateRotation = $f4ebf74948ee9ae3$var$numberEvaluator(flatStyle, prefix + 'rotation', context);
    const evaluateRotateWithView = $f4ebf74948ee9ae3$var$booleanEvaluator(flatStyle, prefix + 'rotate-with-view', context);
    // the remaining symbolizer properties are not currently settable
    const anchorOrigin = $f4ebf74948ee9ae3$var$optionalIconOrigin(flatStyle, prefix + 'anchor-origin');
    const anchorXUnits = $f4ebf74948ee9ae3$var$optionalIconAnchorUnits(flatStyle, prefix + 'anchor-x-units');
    const anchorYUnits = $f4ebf74948ee9ae3$var$optionalIconAnchorUnits(flatStyle, prefix + 'anchor-y-units');
    const colorValue = $f4ebf74948ee9ae3$var$getExpressionValue(flatStyle, prefix + 'color');
    let color;
    let evaluateColor = null;
    if (colorValue !== undefined) {
        const isColorExpression = Array.isArray(colorValue) && colorValue.length > 0 && typeof colorValue[0] === 'string';
        if (isColorExpression) evaluateColor = $f4ebf74948ee9ae3$var$colorLikeEvaluator(flatStyle, prefix + 'color', context);
        else color = $f4ebf74948ee9ae3$var$requireColorLike(colorValue, prefix + 'color');
    }
    const crossOrigin = $f4ebf74948ee9ae3$var$optionalString(flatStyle, prefix + 'cross-origin');
    const offset = $f4ebf74948ee9ae3$var$optionalNumberArray(flatStyle, prefix + 'offset');
    const offsetOrigin = $f4ebf74948ee9ae3$var$optionalIconOrigin(flatStyle, prefix + 'offset-origin');
    const width = $f4ebf74948ee9ae3$var$optionalNumber(flatStyle, prefix + 'width');
    const height = $f4ebf74948ee9ae3$var$optionalNumber(flatStyle, prefix + 'height');
    const size = $f4ebf74948ee9ae3$var$optionalSize(flatStyle, prefix + 'size');
    const declutterMode = $f4ebf74948ee9ae3$var$optionalDeclutterMode(flatStyle, prefix + 'declutter-mode');
    const iconOptions = {
        src: src,
        anchorOrigin: anchorOrigin,
        anchorXUnits: anchorXUnits,
        anchorYUnits: anchorYUnits,
        crossOrigin: crossOrigin,
        offset: offset,
        offsetOrigin: offsetOrigin,
        height: height,
        width: width,
        size: size,
        declutterMode: declutterMode
    };
    let icon = null;
    return function(context) {
        if (!icon) {
            // lazily create the icon to allow for expression evaluation
            const initialColor = evaluateColor ? evaluateColor(context) : color;
            icon = new (0, $3f49168ea08c039d$export$2e2bcd8739ae039)(initialColor !== undefined ? Object.assign({}, iconOptions, {
                color: initialColor
            }) : Object.assign({}, iconOptions));
        } else if (evaluateColor) icon.setColor(evaluateColor(context));
        if (evaluateOpacity) icon.setOpacity(evaluateOpacity(context));
        if (evaluateDisplacement) icon.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) icon.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) icon.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) icon.setScale(evaluateScale(context));
        if (evaluateAnchor) icon.setAnchor(evaluateAnchor(context));
        return icon;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to an icon symbolizer.
 */ function $f4ebf74948ee9ae3$var$buildShape(flatStyle, context) {
    const prefix = 'shape-';
    // required property
    const pointsName = prefix + 'points';
    const radiusName = prefix + 'radius';
    const points = $f4ebf74948ee9ae3$var$requireNumber(flatStyle[pointsName], pointsName);
    if (!(radiusName in flatStyle)) throw new Error(`Expected a number for ${radiusName}`);
    const evaluateRadius = $f4ebf74948ee9ae3$var$numberEvaluator(flatStyle, radiusName, context);
    const initialRadius = typeof flatStyle[radiusName] === 'number' ? flatStyle[radiusName] : 5;
    const radius2Name = prefix + 'radius2';
    const evaluateRadius2 = $f4ebf74948ee9ae3$var$numberEvaluator(flatStyle, radius2Name, context);
    const initialRadius2 = typeof flatStyle[radius2Name] === 'number' ? flatStyle[radius2Name] : undefined;
    // settable properties
    const evaluateFill = $f4ebf74948ee9ae3$var$buildFill(flatStyle, prefix, context);
    const evaluateStroke = $f4ebf74948ee9ae3$var$buildStroke(flatStyle, prefix, context);
    const evaluateScale = $f4ebf74948ee9ae3$var$sizeLikeEvaluator(flatStyle, prefix + 'scale', context);
    const evaluateDisplacement = $f4ebf74948ee9ae3$var$coordinateEvaluator(flatStyle, prefix + 'displacement', context);
    const evaluateRotation = $f4ebf74948ee9ae3$var$numberEvaluator(flatStyle, prefix + 'rotation', context);
    const evaluateRotateWithView = $f4ebf74948ee9ae3$var$booleanEvaluator(flatStyle, prefix + 'rotate-with-view', context);
    // the remaining properties are not currently settable
    const angle = $f4ebf74948ee9ae3$var$optionalNumber(flatStyle, prefix + 'angle');
    const declutterMode = $f4ebf74948ee9ae3$var$optionalDeclutterMode(flatStyle, prefix + 'declutter-mode');
    const shape = new (0, $5fad9a707e2de9d2$export$2e2bcd8739ae039)({
        points: points,
        radius: initialRadius,
        radius2: initialRadius2,
        angle: angle,
        declutterMode: declutterMode
    });
    return function(context) {
        if (evaluateRadius) shape.setRadius(evaluateRadius(context));
        if (evaluateRadius2) shape.setRadius2(evaluateRadius2(context));
        if (evaluateFill) shape.setFill(evaluateFill(context));
        if (evaluateStroke) shape.setStroke(evaluateStroke(context));
        if (evaluateDisplacement) shape.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) shape.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) shape.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) shape.setScale(evaluateScale(context));
        return shape;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to a circle symbolizer.
 */ function $f4ebf74948ee9ae3$var$buildCircle(flatStyle, context) {
    const prefix = 'circle-';
    // settable properties
    const evaluateFill = $f4ebf74948ee9ae3$var$buildFill(flatStyle, prefix, context);
    const evaluateStroke = $f4ebf74948ee9ae3$var$buildStroke(flatStyle, prefix, context);
    const evaluateRadius = $f4ebf74948ee9ae3$var$numberEvaluator(flatStyle, prefix + 'radius', context);
    const evaluateScale = $f4ebf74948ee9ae3$var$sizeLikeEvaluator(flatStyle, prefix + 'scale', context);
    const evaluateDisplacement = $f4ebf74948ee9ae3$var$coordinateEvaluator(flatStyle, prefix + 'displacement', context);
    const evaluateRotation = $f4ebf74948ee9ae3$var$numberEvaluator(flatStyle, prefix + 'rotation', context);
    const evaluateRotateWithView = $f4ebf74948ee9ae3$var$booleanEvaluator(flatStyle, prefix + 'rotate-with-view', context);
    // the remaining properties are not currently settable
    const declutterMode = $f4ebf74948ee9ae3$var$optionalDeclutterMode(flatStyle, prefix + 'declutter-mode');
    const circle = new (0, $c1968949086c96bc$export$2e2bcd8739ae039)({
        radius: 5,
        declutterMode: declutterMode
    });
    return function(context) {
        if (evaluateRadius) circle.setRadius(evaluateRadius(context));
        if (evaluateFill) circle.setFill(evaluateFill(context));
        if (evaluateStroke) circle.setStroke(evaluateStroke(context));
        if (evaluateDisplacement) circle.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) circle.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) circle.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) circle.setScale(evaluateScale(context));
        return circle;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @return {any|undefined} The encoded value, or undefined if not provided.
 */ function $f4ebf74948ee9ae3$var$getExpressionValue(flatStyle, name) {
    if (!(name in flatStyle)) return undefined;
    const value = flatStyle[name];
    return value === undefined ? undefined : value;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').NumberEvaluator|undefined} The expression evaluator or undefined.
 */ function $f4ebf74948ee9ae3$var$numberEvaluator(flatStyle, name, context) {
    const encoded = $f4ebf74948ee9ae3$var$getExpressionValue(flatStyle, name);
    if (encoded === undefined) return undefined;
    const evaluator = (0, $24bd7dccc97f8a38$export$b5f535122a9211f0)(encoded, (0, $e8b52593925b4bc9$export$86a7aca748b1e260), context);
    return function(context) {
        return $f4ebf74948ee9ae3$var$requireNumber(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').StringEvaluator?} The expression evaluator.
 */ function $f4ebf74948ee9ae3$var$stringEvaluator(flatStyle, name, context) {
    const encoded = $f4ebf74948ee9ae3$var$getExpressionValue(flatStyle, name);
    if (encoded === undefined) return null;
    const evaluator = (0, $24bd7dccc97f8a38$export$b5f535122a9211f0)(encoded, (0, $e8b52593925b4bc9$export$2b93044cbf134323), context);
    return function(context) {
        return $f4ebf74948ee9ae3$var$requireString(evaluator(context), name);
    };
}
function $f4ebf74948ee9ae3$var$patternEvaluator(flatStyle, prefix, context) {
    const srcEvaluator = $f4ebf74948ee9ae3$var$stringEvaluator(flatStyle, prefix + 'pattern-src', context);
    const offsetEvaluator = $f4ebf74948ee9ae3$var$sizeEvaluator(flatStyle, prefix + 'pattern-offset', context);
    const patternSizeEvaluator = $f4ebf74948ee9ae3$var$sizeEvaluator(flatStyle, prefix + 'pattern-size', context);
    const colorEvaluator = $f4ebf74948ee9ae3$var$colorLikeEvaluator(flatStyle, prefix + 'color', context);
    return function(context) {
        return {
            src: srcEvaluator(context),
            offset: offsetEvaluator && offsetEvaluator(context),
            size: patternSizeEvaluator && patternSizeEvaluator(context),
            color: colorEvaluator && colorEvaluator(context)
        };
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').BooleanEvaluator?} The expression evaluator.
 */ function $f4ebf74948ee9ae3$var$booleanEvaluator(flatStyle, name, context) {
    const encoded = $f4ebf74948ee9ae3$var$getExpressionValue(flatStyle, name);
    if (encoded === undefined) return null;
    const evaluator = (0, $24bd7dccc97f8a38$export$b5f535122a9211f0)(encoded, (0, $e8b52593925b4bc9$export$240f7fffab1b25a0), context);
    return function(context) {
        const value = evaluator(context);
        if (typeof value !== 'boolean') throw new Error(`Expected a boolean for ${name}`);
        return value;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').ColorLikeEvaluator?} The expression evaluator.
 */ function $f4ebf74948ee9ae3$var$colorLikeEvaluator(flatStyle, name, context) {
    const encoded = $f4ebf74948ee9ae3$var$getExpressionValue(flatStyle, name);
    if (encoded === undefined) return null;
    const evaluator = (0, $24bd7dccc97f8a38$export$b5f535122a9211f0)(encoded, (0, $e8b52593925b4bc9$export$2cd82751acc0e609), context);
    return function(context) {
        return $f4ebf74948ee9ae3$var$requireColorLike(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').NumberArrayEvaluator?} The expression evaluator.
 */ function $f4ebf74948ee9ae3$var$numberArrayEvaluator(flatStyle, name, context) {
    const encoded = $f4ebf74948ee9ae3$var$getExpressionValue(flatStyle, name);
    if (encoded === undefined) return null;
    if (Array.isArray(encoded) && (encoded.length === 0 || typeof encoded[0] !== 'string')) {
        /** @type {Array<import('../../expr/cpu.js').NumberEvaluator>} */ const evaluators = encoded.map((value, index)=>{
            if (typeof value === 'number') return ()=>value;
            const evaluator = (0, $24bd7dccc97f8a38$export$b5f535122a9211f0)(value, (0, $e8b52593925b4bc9$export$86a7aca748b1e260), context);
            return function(context) {
                return $f4ebf74948ee9ae3$var$requireNumber(evaluator(context), `${name}[${index}]`);
            };
        });
        return function(context) {
            const array = new Array(evaluators.length);
            for(let i = 0; i < evaluators.length; ++i)array[i] = evaluators[i](context);
            return array;
        };
    }
    const evaluator = (0, $24bd7dccc97f8a38$export$b5f535122a9211f0)(encoded, (0, $e8b52593925b4bc9$export$d701d0e49f4bcb39), context);
    return function(context) {
        return $f4ebf74948ee9ae3$var$requireNumberArray(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').CoordinateEvaluator?} The expression evaluator.
 */ function $f4ebf74948ee9ae3$var$coordinateEvaluator(flatStyle, name, context) {
    const encoded = $f4ebf74948ee9ae3$var$getExpressionValue(flatStyle, name);
    if (encoded === undefined) return null;
    const evaluator = (0, $24bd7dccc97f8a38$export$b5f535122a9211f0)(encoded, (0, $e8b52593925b4bc9$export$d701d0e49f4bcb39), context);
    return function(context) {
        const array = $f4ebf74948ee9ae3$var$requireNumberArray(evaluator(context), name);
        if (array.length !== 2) throw new Error(`Expected two numbers for ${name}`);
        return array;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').SizeEvaluator?} The expression evaluator.
 */ function $f4ebf74948ee9ae3$var$sizeEvaluator(flatStyle, name, context) {
    const encoded = $f4ebf74948ee9ae3$var$getExpressionValue(flatStyle, name);
    if (encoded === undefined) return null;
    const evaluator = (0, $24bd7dccc97f8a38$export$b5f535122a9211f0)(encoded, (0, $e8b52593925b4bc9$export$d701d0e49f4bcb39), context);
    return function(context) {
        return $f4ebf74948ee9ae3$var$requireSize(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').SizeLikeEvaluator?} The expression evaluator.
 */ function $f4ebf74948ee9ae3$var$sizeLikeEvaluator(flatStyle, name, context) {
    const encoded = $f4ebf74948ee9ae3$var$getExpressionValue(flatStyle, name);
    if (encoded === undefined) return null;
    const evaluator = (0, $24bd7dccc97f8a38$export$b5f535122a9211f0)(encoded, (0, $e8b52593925b4bc9$export$d701d0e49f4bcb39) | (0, $e8b52593925b4bc9$export$86a7aca748b1e260), context);
    return function(context) {
        return $f4ebf74948ee9ae3$var$requireSizeLike(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {number|undefined} A number or undefined.
 */ function $f4ebf74948ee9ae3$var$optionalNumber(flatStyle, property) {
    const value = flatStyle[property];
    if (value === undefined) return undefined;
    if (typeof value !== 'number') throw new Error(`Expected a number for ${property}`);
    return value;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../size.js").Size|undefined} A size or undefined.
 */ function $f4ebf74948ee9ae3$var$optionalSize(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded === 'number') return (0, $e9727ecf69942748$export$a71a825ff42fb8e1)(encoded);
    if (!Array.isArray(encoded)) throw new Error(`Expected a number or size array for ${property}`);
    if (encoded.length !== 2 || typeof encoded[0] !== 'number' || typeof encoded[1] !== 'number') throw new Error(`Expected a number or size array for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {string|undefined} A string or undefined.
 */ function $f4ebf74948ee9ae3$var$optionalString(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded !== 'string') throw new Error(`Expected a string for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../style/Icon.js").IconOrigin|undefined} An icon origin or undefined.
 */ function $f4ebf74948ee9ae3$var$optionalIconOrigin(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (encoded !== 'bottom-left' && encoded !== 'bottom-right' && encoded !== 'top-left' && encoded !== 'top-right') throw new Error(`Expected bottom-left, bottom-right, top-left, or top-right for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../style/Icon.js").IconAnchorUnits|undefined} Icon anchor units or undefined.
 */ function $f4ebf74948ee9ae3$var$optionalIconAnchorUnits(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (encoded !== 'pixels' && encoded !== 'fraction') throw new Error(`Expected pixels or fraction for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {Array<number>|undefined} An array of numbers or undefined.
 */ function $f4ebf74948ee9ae3$var$optionalNumberArray(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    return $f4ebf74948ee9ae3$var$requireNumberArray(encoded, property);
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import('../../style/Style.js').DeclutterMode} Icon declutter mode.
 */ function $f4ebf74948ee9ae3$var$optionalDeclutterMode(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded !== 'string') throw new Error(`Expected a string for ${property}`);
    if (encoded !== 'declutter' && encoded !== 'obstacle' && encoded !== 'none') throw new Error(`Expected declutter, obstacle, or none for ${property}`);
    return encoded;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>} An array of numbers.
 */ function $f4ebf74948ee9ae3$var$requireNumberArray(value, property) {
    if (!Array.isArray(value)) throw new Error(`Expected an array for ${property}`);
    const length = value.length;
    for(let i = 0; i < length; ++i){
        if (typeof value[i] !== 'number') throw new Error(`Expected an array of numbers for ${property}`);
    }
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {string} A string.
 */ function $f4ebf74948ee9ae3$var$requireString(value, property) {
    if (typeof value !== 'string') throw new Error(`Expected a string for ${property}`);
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {number} A number.
 */ function $f4ebf74948ee9ae3$var$requireNumber(value, property) {
    if (typeof value !== 'number') throw new Error(`Expected a number for ${property}`);
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>|string} A color.
 */ function $f4ebf74948ee9ae3$var$requireColorLike(value, property) {
    if (typeof value === 'string') return value;
    const array = $f4ebf74948ee9ae3$var$requireNumberArray(value, property);
    const length = array.length;
    if (length < 3 || length > 4) throw new Error(`Expected a color with 3 or 4 values for ${property}`);
    return array;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>} A number or an array of two numbers.
 */ function $f4ebf74948ee9ae3$var$requireSize(value, property) {
    const size = $f4ebf74948ee9ae3$var$requireNumberArray(value, property);
    if (size.length !== 2) throw new Error(`Expected an array of two numbers for ${property}`);
    return size;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {number|Array<number>} A number or an array of two numbers.
 */ function $f4ebf74948ee9ae3$var$requireSizeLike(value, property) {
    if (typeof value === 'number') return value;
    return $f4ebf74948ee9ae3$var$requireSize(value, property);
}




/***
 * @template T
 * @typedef {T extends import("../source/Vector.js").default<infer U extends import("../Feature.js").FeatureLike> ? U : never} ExtractedFeatureType
 */ /**
 * @template {import('../Feature.js').FeatureLike} FeatureType
 * @template {import("../source/Vector.js").default<FeatureType>|import("../source/VectorTile.js").default<FeatureType>} VectorSourceType<FeatureType>
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the viewport extent used by the
 * renderer when getting features from the vector source for the rendering or hit-detection.
 * Recommended value: the size of the largest symbol, line width or label.
 * @property {VectorSourceType} [source] Source.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * @property {boolean|string|number} [declutter=false] Declutter images and text. Any truthy value will enable
 * decluttering. Within a layer, a feature rendered before another has higher priority. All layers with the
 * same `declutter` value will be decluttered together. The priority is determined by the drawing order of the
 * layers with the same `declutter` value. Higher in the layer stack means higher priority. To declutter distinct
 * layers or groups of layers separately, use different truthy values for `declutter`.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style. When set to `null`, only
 * features that have their own style will be rendered. See {@link module:ol/style/Style~Style} for the default style
 * which will be used if this is not set.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {boolean} [updateWhileAnimating=false] When set to `true`, feature batches will
 * be recreated during animations. This means that no vectors will be shown clipped, but the
 * setting will have a performance impact for large amounts of vector data. When set to `false`,
 * batches will be recreated when no animation is active.
 * @property {boolean} [updateWhileInteracting=false] When set to `true`, feature batches will
 * be recreated during interactions. See also `updateWhileAnimating`.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @enum {string}
 * @private
 */ const $1e2c8a3879fb9f61$var$Property = {
    RENDER_ORDER: 'renderOrder'
};
/**
 * @classdesc
 * Vector data that is rendered client-side.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import('../Feature.js').FeatureLike} FeatureType
 * @template {import("../source/Vector.js").default<FeatureType>|import("../source/VectorTile.js").default<FeatureType>} VectorSourceType<FeatureType>
 * @extends {Layer<VectorSourceType, RendererType>}
 * @template {import("../renderer/canvas/VectorLayer.js").default|import("../renderer/canvas/VectorTileLayer.js").default|import("../renderer/canvas/VectorImageLayer.js").default|import("../renderer/webgl/VectorLayer.js").default|import("../renderer/webgl/PointsLayer.js").default} RendererType
 * @api
 */ class $1e2c8a3879fb9f61$var$BaseVectorLayer extends (0, $7bdbe21729fecf84$export$2e2bcd8739ae039) {
    /**
   * @param {Options<FeatureType, VectorSourceType>} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const baseOptions = Object.assign({}, options);
        delete baseOptions.style;
        delete baseOptions.renderBuffer;
        delete baseOptions.updateWhileAnimating;
        delete baseOptions.updateWhileInteracting;
        super(baseOptions);
        /**
     * @private
     * @type {string}
     */ this.declutter_ = options.declutter ? String(options.declutter) : undefined;
        /**
     * @type {number}
     * @private
     */ this.renderBuffer_ = options.renderBuffer !== undefined ? options.renderBuffer : 100;
        /**
     * User provided style.
     * @type {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike}
     * @private
     */ this.style_ = null;
        /**
     * Style function for use within the library.
     * @type {import("../style/Style.js").StyleFunction|undefined}
     * @private
     */ this.styleFunction_ = undefined;
        this.setStyle(options.style);
        /**
     * @type {boolean}
     * @private
     */ this.updateWhileAnimating_ = options.updateWhileAnimating !== undefined ? options.updateWhileAnimating : false;
        /**
     * @type {boolean}
     * @private
     */ this.updateWhileInteracting_ = options.updateWhileInteracting !== undefined ? options.updateWhileInteracting : false;
    }
    /**
   * @return {string} Declutter group.
   * @override
   */ getDeclutter() {
        return this.declutter_;
    }
    /**
   * Get the topmost feature that intersects the given pixel on the viewport. Returns a promise
   * that resolves with an array of features. The array will either contain the topmost feature
   * when a hit was detected, or it will be empty.
   *
   * The hit detection algorithm used for this method is optimized for performance, but is less
   * accurate than the one used in [map.getFeaturesAtPixel()]{@link import("../Map.js").default#getFeaturesAtPixel}.
   * Text is not considered, and icons are only represented by their bounding box instead of the exact
   * image.
   *
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature.js").FeatureLike>>} Promise that resolves with an array of features.
   * @api
   * @override
   */ getFeatures(pixel) {
        return super.getFeatures(pixel);
    }
    /**
   * @return {number|undefined} Render buffer.
   */ getRenderBuffer() {
        return this.renderBuffer_;
    }
    /**
   * @return {import("../render.js").OrderFunction|null|undefined} Render order.
   */ getRenderOrder() {
        return /** @type {import("../render.js").OrderFunction|null|undefined} */ this.get($1e2c8a3879fb9f61$var$Property.RENDER_ORDER);
    }
    /**
   * Get the style for features.  This returns whatever was passed to the `style`
   * option at construction or to the `setStyle` method.
   * @return {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null|undefined} Layer style.
   * @api
   */ getStyle() {
        return this.style_;
    }
    /**
   * Get the style function.
   * @return {import("../style/Style.js").StyleFunction|undefined} Layer style function.
   * @api
   */ getStyleFunction() {
        return this.styleFunction_;
    }
    /**
   * @return {boolean} Whether the rendered layer should be updated while
   *     animating.
   */ getUpdateWhileAnimating() {
        return this.updateWhileAnimating_;
    }
    /**
   * @return {boolean} Whether the rendered layer should be updated while
   *     interacting.
   */ getUpdateWhileInteracting() {
        return this.updateWhileInteracting_;
    }
    /**
   * Render declutter items for this layer
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {import("../layer/Layer.js").State} layerState Layer state.
   * @override
   */ renderDeclutter(frameState, layerState) {
        const declutterGroup = this.getDeclutter();
        if (declutterGroup in frameState.declutter === false) frameState.declutter[declutterGroup] = new (0, (/*@__PURE__*/$parcel$interopDefault($d767c9267f21fd9e$exports)))(9);
        this.getRenderer().renderDeclutter(frameState, layerState);
    }
    /**
   * @param {import("../render.js").OrderFunction|null|undefined} renderOrder
   *     Render order.
   */ setRenderOrder(renderOrder) {
        this.set($1e2c8a3879fb9f61$var$Property.RENDER_ORDER, renderOrder);
    }
    /**
   * Set the style for features.  This can be a single style object, an array
   * of styles, or a function that takes a feature and resolution and returns
   * an array of styles. If set to `null`, the layer has no style (a `null` style),
   * so only features that have their own styles will be rendered in the layer. Call
   * `setStyle()` without arguments to reset to the default style. See
   * [the ol/style/Style module]{@link module:ol/style/Style~Style} for information on the default style.
   *
   * If your layer has a static style, you can use [flat style]{@link module:ol/style/flat~FlatStyle} object
   * literals instead of using the `Style` and symbolizer constructors (`Fill`, `Stroke`, etc.):
   * ```js
   * vectorLayer.setStyle({
   *   "fill-color": "yellow",
   *   "stroke-color": "black",
   *   "stroke-width": 4
   * })
   * ```
   *
   * @param {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style.
   * @api
   */ setStyle(style) {
        this.style_ = style === undefined ? (0, $97cdc16020961e75$export$6865c5ac2f5ce8b6) : style;
        const styleLike = $1e2c8a3879fb9f61$var$toStyleLike(style);
        this.styleFunction_ = style === null ? undefined : (0, $97cdc16020961e75$export$c314ea3f6b164147)(styleLike);
        this.changed();
    }
    /**
   * @param {boolean|string|number} declutter Declutter images and text.
   * @api
   */ setDeclutter(declutter) {
        this.declutter_ = declutter ? String(declutter) : undefined;
        this.changed();
    }
}
/**
 * Coerce the allowed style types into a shorter list of types.  Flat styles, arrays of flat
 * styles, and arrays of rules are converted into style functions.
 *
 * @param {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style.
 * @return {import("../style/Style.js").StyleLike|null} The style.
 */ function $1e2c8a3879fb9f61$var$toStyleLike(style) {
    if (style === undefined) return 0, $97cdc16020961e75$export$6865c5ac2f5ce8b6;
    if (!style) return null;
    if (typeof style === 'function') return style;
    if (style instanceof (0, $97cdc16020961e75$export$2e2bcd8739ae039)) return style;
    if (!Array.isArray(style)) return (0, $f4ebf74948ee9ae3$export$5a130bc4f0a0420b)([
        style
    ]);
    if (style.length === 0) return [];
    const length = style.length;
    const first = style[0];
    if (first instanceof (0, $97cdc16020961e75$export$2e2bcd8739ae039)) {
        /**
     * @type {Array<Style>}
     */ const styles = new Array(length);
        for(let i = 0; i < length; ++i){
            const candidate = style[i];
            if (!(candidate instanceof (0, $97cdc16020961e75$export$2e2bcd8739ae039))) throw new Error('Expected a list of style instances');
            styles[i] = candidate;
        }
        return styles;
    }
    if ('style' in first) {
        /**
     * @type {Array<import("../style/flat.js").Rule>}
     */ const rules = new Array(length);
        for(let i = 0; i < length; ++i){
            const candidate = style[i];
            if (!('style' in candidate)) throw new Error('Expected a list of rules with a style property');
            rules[i] = candidate;
        }
        return (0, $f4ebf74948ee9ae3$export$fc6a94152b1b05a8)(rules);
    }
    const flatStyles = /** @type {Array<import("../style/flat.js").FlatStyle>} */ style;
    return (0, $f4ebf74948ee9ae3$export$5a130bc4f0a0420b)(flatStyles);
}
var $1e2c8a3879fb9f61$export$2e2bcd8739ae039 = $1e2c8a3879fb9f61$var$BaseVectorLayer;



/**
 * @module ol/render/Event
 */ 
class $2df7dd2947499e28$var$RenderEvent extends (0, $bc90848f8b15fa29$export$2e2bcd8739ae039) {
    /**
   * @param {import("./EventType.js").default} type Type.
   * @param {import("../transform.js").Transform} [inversePixelTransform] Transform for
   *     CSS pixels to rendered pixels.
   * @param {import("../Map.js").FrameState} [frameState] Frame state.
   * @param {?(CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D|WebGLRenderingContext)} [context] Context.
   */ constructor(type, inversePixelTransform, frameState, context){
        super(type);
        /**
     * Transform from CSS pixels (relative to the top-left corner of the map viewport)
     * to rendered pixels on this event's `context`. Only available when a Canvas renderer is used, null otherwise.
     * @type {import("../transform.js").Transform|undefined}
     * @api
     */ this.inversePixelTransform = inversePixelTransform;
        /**
     * An object representing the current render frame state.
     * @type {import("../Map.js").FrameState|undefined}
     * @api
     */ this.frameState = frameState;
        /**
     * Canvas context. Not available when the event is dispatched by the map. For Canvas 2D layers,
     * the context will be the 2D rendering context.  For WebGL layers, the context will be the WebGL
     * context.
     * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D|WebGLRenderingContext|undefined}
     * @api
     */ this.context = context;
    }
}
var $2df7dd2947499e28$export$2e2bcd8739ae039 = $2df7dd2947499e28$var$RenderEvent;





/**
 * @module ol/renderer/Map
 */ 







/**
 * @template T
 * @typedef HitMatch
 * @property {import("../Feature.js").FeatureLike} feature Feature.
 * @property {import("../layer/Layer.js").default} layer Layer.
 * @property {import("../geom/SimpleGeometry.js").default} geometry Geometry.
 * @property {number} distanceSq Squared distance.
 * @property {import("./vector.js").FeatureCallback<T>} callback Callback.
 */ /**
 * @abstract
 */ class $c6cfcb61e18b8356$var$MapRenderer extends (0, $b54235dad6714a76$export$2e2bcd8739ae039) {
    /**
   * @param {import("../Map.js").default} map Map.
   */ constructor(map){
        super();
        /**
     * @private
     * @type {import("../Map.js").default}
     */ this.map_ = map;
    }
    /**
   * @abstract
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */ dispatchRenderEvent(type, frameState) {
        (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @protected
   */ calculateMatrices2D(frameState) {
        const viewState = frameState.viewState;
        const coordinateToPixelTransform = frameState.coordinateToPixelTransform;
        const pixelToCoordinateTransform = frameState.pixelToCoordinateTransform;
        (0, $eb597965bdcc8f43$export$f672e0b6f7222cd7)(coordinateToPixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / viewState.resolution, -1 / viewState.resolution, -viewState.rotation, -viewState.center[0], -viewState.center[1]);
        (0, $eb597965bdcc8f43$export$bd70ea2a93c0fa4)(pixelToCoordinateTransform, coordinateToPixelTransform);
    }
    /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {boolean} checkWrapped Check for wrapped geometries.
   * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {S} thisArg Value to use as `this` when executing `callback`.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg2 Value to use as `this` when executing `layerFilter`.
   * @return {T|undefined} Callback result.
   * @template S,T,U
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, callback, thisArg, layerFilter, thisArg2) {
        let result;
        const viewState = frameState.viewState;
        /**
     * @param {boolean} managed Managed layer.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     * @param {import("../layer/Layer.js").default} layer Layer.
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @return {T|undefined} Callback result.
     */ function forEachFeatureAtCoordinate(managed, feature, layer, geometry) {
            return callback.call(thisArg, feature, managed ? layer : null, geometry);
        }
        const projection = viewState.projection;
        const translatedCoordinate = (0, $6542087bee114e8c$export$39a9ce3624977b84)(coordinate.slice(), projection);
        const offsets = [
            [
                0,
                0
            ]
        ];
        if (projection.canWrapX() && checkWrapped) {
            const projectionExtent = projection.getExtent();
            const worldWidth = (0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(projectionExtent);
            offsets.push([
                -worldWidth,
                0
            ], [
                worldWidth,
                0
            ]);
        }
        const layerStates = frameState.layerStatesArray;
        const numLayers = layerStates.length;
        const matches = /** @type {Array<HitMatch<T>>} */ [];
        const tmpCoord = [];
        for(let i = 0; i < offsets.length; i++)for(let j = numLayers - 1; j >= 0; --j){
            const layerState = layerStates[j];
            const layer = layerState.layer;
            if (layer.hasRenderer() && (0, $7bdbe21729fecf84$export$acb1e9cb9ce4ca56)(layerState, viewState) && layerFilter.call(thisArg2, layer)) {
                const layerRenderer = layer.getRenderer();
                const source = layer.getSource();
                if (layerRenderer && source) {
                    const coordinates = source.getWrapX() ? translatedCoordinate : coordinate;
                    const callback = forEachFeatureAtCoordinate.bind(null, layerState.managed);
                    tmpCoord[0] = coordinates[0] + offsets[i][0];
                    tmpCoord[1] = coordinates[1] + offsets[i][1];
                    result = layerRenderer.forEachFeatureAtCoordinate(tmpCoord, frameState, hitTolerance, callback, matches);
                }
                if (result) return result;
            }
        }
        if (matches.length === 0) return undefined;
        const order = 1 / matches.length;
        matches.forEach((m, i)=>m.distanceSq += i * order);
        matches.sort((a, b)=>a.distanceSq - b.distanceSq);
        matches.some((m)=>{
            return result = m.callback(m.feature, m.layer, m.geometry);
        });
        return result;
    }
    /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {boolean} checkWrapped Check for wrapped geometries.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg Value to use as `this` when executing `layerFilter`.
   * @return {boolean} Is there a feature at the given coordinate?
   * @template U
   */ hasFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, layerFilter, thisArg) {
        const hasFeature = this.forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, (0, $7efea016d660e267$export$22e23a2304399231), this, layerFilter, thisArg);
        return hasFeature !== undefined;
    }
    /**
   * @return {import("../Map.js").default} Map.
   */ getMap() {
        return this.map_;
    }
    /**
   * Render.
   * @abstract
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */ renderFrame(frameState) {
        (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @protected
   */ scheduleExpireIconCache(frameState) {
        if ((0, $3eb09d66fc28233e$export$747ccdf771a87ab8).canExpireCache()) frameState.postRenderFunctions.push($c6cfcb61e18b8356$var$expireIconCache);
    }
}
/**
 * @param {import("../Map.js").default} map Map.
 * @param {import("../Map.js").FrameState} frameState Frame state.
 */ function $c6cfcb61e18b8356$var$expireIconCache(map, frameState) {
    (0, $3eb09d66fc28233e$export$747ccdf771a87ab8).expire();
}
var $c6cfcb61e18b8356$export$2e2bcd8739ae039 = $c6cfcb61e18b8356$var$MapRenderer;


/**
 * @classdesc
 * Canvas map renderer.
 * @api
 */ class $bce7756dbaf5b110$var$CompositeMapRenderer extends (0, $c6cfcb61e18b8356$export$2e2bcd8739ae039) {
    /**
   * @param {import("../Map.js").default} map Map.
   */ constructor(map){
        super(map);
        /**
     * @private
     * @type {import("../events.js").EventsKey}
     */ this.fontChangeListenerKey_ = (0, $8061a5de9380012b$export$63174c828edd6ff8)((0, $3b9b2e731b8ee924$export$1d36981fcadac93b), (0, $026be6c727dde691$export$2e2bcd8739ae039).PROPERTYCHANGE, map.redrawText, map);
        /**
     * @private
     * @type {HTMLDivElement}
     */ this.element_ = (0, $013e07c1ef6d00ad$export$98fcef3dc9973292) ? (0, $5ce605ba3ee034a0$export$45b7f73d625b5cde)() : document.createElement('div');
        const style = this.element_.style;
        style.position = 'absolute';
        style.width = '100%';
        style.height = '100%';
        style.zIndex = '0';
        this.element_.className = (0, $87710eafad36a2e8$export$1afde3d6e16a7b29) + ' ol-layers';
        const container = map.getViewport();
        if (container) // maps in a worker do not have a viewport.
        container.insertBefore(this.element_, container.firstChild || null);
        /**
     * @private
     * @type {Array<HTMLElement>}
     */ this.children_ = [];
        /**
     * @private
     * @type {boolean}
     */ this.renderedVisible_ = true;
    }
    /**
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @override
   */ dispatchRenderEvent(type, frameState) {
        const map = this.getMap();
        if (map.hasListener(type)) {
            const event = new (0, $2df7dd2947499e28$export$2e2bcd8739ae039)(type, undefined, frameState);
            map.dispatchEvent(event);
        }
    }
    /**
   * @override
   */ disposeInternal() {
        (0, $8061a5de9380012b$export$b0a21c8b3c1c921)(this.fontChangeListenerKey_);
        this.element_.remove();
        super.disposeInternal();
    }
    /**
   * Render.
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   * @override
   */ renderFrame(frameState) {
        if (!frameState) {
            if (this.renderedVisible_) {
                this.element_.style.display = 'none';
                this.renderedVisible_ = false;
            }
            return;
        }
        this.calculateMatrices2D(frameState);
        this.dispatchRenderEvent((0, $97affab8a58f0c97$export$2e2bcd8739ae039).PRECOMPOSE, frameState);
        const layerStatesArray = frameState.layerStatesArray.sort((a, b)=>a.zIndex - b.zIndex);
        const declutter = layerStatesArray.some((layerState)=>layerState.layer instanceof (0, $1e2c8a3879fb9f61$export$2e2bcd8739ae039) && layerState.layer.getDeclutter());
        if (declutter) // Some layers need decluttering, turn on deferred rendering hint
        frameState.declutter = {};
        const viewState = frameState.viewState;
        this.children_.length = 0;
        const renderedLayerStates = [];
        let previousElement = null;
        for(let i = 0, ii = layerStatesArray.length; i < ii; ++i){
            const layerState = layerStatesArray[i];
            frameState.layerIndex = i;
            const layer = layerState.layer;
            const sourceState = layer.getSourceState();
            if (!(0, $7bdbe21729fecf84$export$acb1e9cb9ce4ca56)(layerState, viewState) || sourceState != 'ready' && sourceState != 'undefined') {
                layer.unrender();
                continue;
            }
            const element = layer.render(frameState, previousElement);
            if (!element) continue;
            if (element !== previousElement) {
                this.children_.push(element);
                previousElement = element;
            }
            renderedLayerStates.push(layerState);
        }
        this.declutter(frameState, renderedLayerStates);
        (0, $5ce605ba3ee034a0$export$caeacfe04f52533a)(this.element_, this.children_);
        const map = this.getMap();
        const mapCanvas = map.getTargetElement();
        if ((0, $5ce605ba3ee034a0$export$4b05d74c82e4c4d2)(mapCanvas)) {
            // Canvas composition when container is a canvas
            const mapContext = mapCanvas.getContext('2d');
            for (const container of this.children_){
                const canvas = container.firstElementChild || container;
                const backgroundColor = container.style.backgroundColor;
                if (backgroundColor && (!(0, $5ce605ba3ee034a0$export$4b05d74c82e4c4d2)(canvas) || canvas.width > 0)) {
                    mapContext.fillStyle = backgroundColor;
                    mapContext.fillRect(0, 0, mapCanvas.width, mapCanvas.height);
                }
                if ((0, $5ce605ba3ee034a0$export$4b05d74c82e4c4d2)(canvas) && canvas.width > 0) {
                    mapContext.save();
                    const opacity = container.style.opacity || canvas.style.opacity;
                    mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
                    const transform = canvas.style.transform;
                    if (transform) // Get the transform parameters from the style's transform matrix
                    mapContext.transform(.../** @type {[number, number, number, number, number, number]} */ (0, $eb597965bdcc8f43$export$3004f64547af360e)(transform));
                    else {
                        const w = parseFloat(canvas.style.width) / canvas.width;
                        const h = parseFloat(canvas.style.height) / canvas.height;
                        mapContext.transform(w, 0, 0, h, 0, 0);
                    }
                    mapContext.drawImage(canvas, 0, 0);
                    mapContext.restore();
                }
            }
        }
        this.dispatchRenderEvent((0, $97affab8a58f0c97$export$2e2bcd8739ae039).POSTCOMPOSE, frameState);
        if (!this.renderedVisible_) {
            this.element_.style.display = '';
            this.renderedVisible_ = true;
        }
        this.scheduleExpireIconCache(frameState);
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {Array<import('../layer/Layer.js').State>} layerStates Layers.
   */ declutter(frameState, layerStates) {
        if (!frameState.declutter) return;
        for(let i = layerStates.length - 1; i >= 0; --i){
            const layerState = layerStates[i];
            const layer = layerState.layer;
            if (layer.getDeclutter()) layer.renderDeclutter(frameState, layerState);
        }
        layerStates.forEach((layerState)=>layerState.layer.renderDeferred(frameState));
    }
}
var $bce7756dbaf5b110$export$2e2bcd8739ae039 = $bce7756dbaf5b110$var$CompositeMapRenderer;





/**
 * State of the current frame. Only `pixelRatio`, `time` and `viewState` should
 * be used in applications.
 * @typedef {Object} FrameState
 * @property {number} pixelRatio The pixel ratio of the frame.
 * @property {number} time The time when rendering of the frame was requested.
 * @property {import("./View.js").State} viewState The state of the current view.
 * @property {boolean} animate Animate.
 * @property {import("./transform.js").Transform} coordinateToPixelTransform CoordinateToPixelTransform.
 * @property {Object<string, import("rbush").default<import('./render/canvas/Executor.js').DeclutterEntry>>|null} declutter
 * Declutter trees by declutter group.
 * When null, no decluttering is needed because no layers have decluttering enabled.
 * @property {null|import("./extent.js").Extent} extent Extent (in view projection coordinates).
 * @property {import("./extent.js").Extent} [nextExtent] Next extent during an animation series.
 * @property {number} index Index.
 * @property {Array<import("./layer/Layer.js").State>} layerStatesArray LayerStatesArray.
 * @property {number} layerIndex LayerIndex.
 * @property {import("./transform.js").Transform} pixelToCoordinateTransform PixelToCoordinateTransform.
 * @property {Array<PostRenderFunction>} postRenderFunctions PostRenderFunctions.
 * @property {import("./size.js").Size} size Size.
 * @property {TileQueue} tileQueue TileQueue.
 * @property {!Object<string, Object<string, boolean>>} usedTiles UsedTiles.
 * @property {Array<number>} viewHints ViewHints.
 * @property {!Object<string, Object<string, boolean>>} wantedTiles WantedTiles.
 * @property {string} mapId The id of the map.
 * @property {Object<string, boolean>} renderTargets Identifiers of previously rendered elements.
 */ /**
 * @typedef {function(Map, FrameState): any} PostRenderFunction
 */ /**
 * @typedef {Object} AtPixelOptions
 * @property {undefined|function(import("./layer/Layer.js").default<import("./source/Source.js").default>): boolean} [layerFilter] Layer filter
 * function. The filter function will receive one argument, the
 * {@link module:ol/layer/Layer~Layer layer-candidate} and it should return a boolean value.
 * Only layers which are visible and for which this function returns `true`
 * will be tested for features. By default, all visible layers will be tested.
 * @property {number} [hitTolerance=0] Hit-detection tolerance in css pixels. Pixels
 * inside the radius around the given position will be checked for features.
 * @property {boolean} [checkWrapped=true] Check-Wrapped Will check for wrapped geometries inside the range of
 *   +/- 1 world width. Works only if a projection is used that can be wrapped.
 */ /**
 * @typedef {Object} MapOptionsInternal
 * @property {Collection<import("./control/Control.js").default>} [controls] Controls.
 * @property {Collection<import("./interaction/Interaction.js").default>} [interactions] Interactions.
 * @property {HTMLElement|Document} keyboardEventTarget KeyboardEventTarget.
 * @property {Collection<import("./Overlay.js").default>} overlays Overlays.
 * @property {Object<string, *>} values Values.
 */ /**
 * @typedef {import("./ObjectEventType.js").Types|'change:layergroup'|'change:size'|'change:target'|'change:view'} MapObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable.js").OnSignature<import("./Observable.js").EventTypes, import("./events/Event.js").default, Return> &
 *    import("./Observable.js").OnSignature<MapObjectEventTypes, import("./Object.js").ObjectEvent, Return> &
 *    import("./Observable.js").OnSignature<import("./MapBrowserEventType.js").Types, import("./MapBrowserEvent.js").default, Return> &
 *    import("./Observable.js").OnSignature<import("./MapEventType.js").Types, import("./MapEvent.js").default, Return> &
 *    import("./Observable.js").OnSignature<import("./render/EventType.js").MapRenderEventTypes, import("./render/Event.js").default, Return> &
 *    import("./Observable.js").CombinedOnSignature<import("./Observable.js").EventTypes|MapObjectEventTypes|
 *      import("./MapBrowserEventType.js").Types|import("./MapEventType.js").Types|
 *      import("./render/EventType.js").MapRenderEventTypes, Return>} MapEventHandler
 */ /**
 * Object literal with config options for the map.
 * @typedef {Object} MapOptions
 * @property {Collection<import("./control/Control.js").default>|Array<import("./control/Control.js").default>} [controls]
 * Controls initially added to the map. If not specified,
 * {@link module:ol/control/defaults.defaults} is used. In a worker, no controls are added by default.
 * @property {number} [pixelRatio=window.devicePixelRatio] The ratio between
 * physical pixels and device-independent pixels (dips) on the device.
 * @property {Collection<import("./interaction/Interaction.js").default>|Array<import("./interaction/Interaction.js").default>} [interactions]
 * Interactions that are initially added to the map. If not specified,
 * {@link module:ol/interaction/defaults.defaults} is used. In a worker, no interactions are added by default.
 * @property {HTMLElement|Document|string} [keyboardEventTarget] The element to
 * listen to keyboard events on. This determines when the `KeyboardPan` and
 * `KeyboardZoom` interactions trigger. For example, if this option is set to
 * `document` the keyboard interactions will always trigger. If this option is
 * not specified, the element the library listens to keyboard events on is the
 * map target (i.e. the user-provided div for the map). If this is not
 * `document`, the target element needs to be focused for key events to be
 * emitted, requiring that the target element has a `tabindex` attribute.
 * @property {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>|LayerGroup} [layers]
 * Layers. If this is not defined, a map with no layers will be rendered. Note
 * that layers are rendered in the order supplied, so if you want, for example,
 * a vector layer to appear on top of a tile layer, it must come after the tile
 * layer.
 * @property {number} [maxTilesLoading=16] Maximum number tiles to load
 * simultaneously.
 * @property {number} [moveTolerance=1] The minimum distance in pixels the
 * cursor must move to be detected as a map move event instead of a click.
 * Increasing this value can make it easier to click on the map.
 * @property {Collection<import("./Overlay.js").default>|Array<import("./Overlay.js").default>} [overlays]
 * Overlays initially added to the map. By default, no overlays are added.
 * @property {HTMLElement|string|HTMLCanvasElement|OffscreenCanvas} [target] The container for the map, either the
 * element itself or the `id` of the element. If not specified at construction
 * time, {@link module:ol/Map~Map#setTarget} must be called for the map to be
 * rendered. If passed by element, the container can be in a secondary document.
 * For use in workers or when exporting a map, use an `OffscreenCanvas` or `HTMLCanvasElement` as target,
 * with a width and height in physical pixels, optionally multiplied by and a scale transform matching
 * the map's pixel ratio.
 * For accessibility (focus and keyboard events for map navigation), the `target` element must have a
 *  properly configured `tabindex` attribute. If the `target` element is inside a Shadow DOM, the
 *  `tabindex` atribute must be set on the custom element's host element.
 * **Note:** CSS `transform` support for the target element is limited to `scale`.
 * @property {View|Promise<import("./View.js").ViewOptions>} [view] The map's view.  No layer sources will be
 * fetched unless this is specified at construction time or through
 * {@link module:ol/Map~Map#setView}.
 */ /**
 * @param {import("./layer/Base.js").default} layer Layer.
 */ function $19f0d4d634ca7fe4$var$removeLayerMapProperty(layer) {
    if (layer instanceof (0, $7bdbe21729fecf84$export$2e2bcd8739ae039)) {
        layer.setMapInternal(null);
        return;
    }
    if (layer instanceof (0, $c087d5d4d6aeb943$export$2e2bcd8739ae039)) layer.getLayers().forEach($19f0d4d634ca7fe4$var$removeLayerMapProperty);
}
/**
 * @param {import("./layer/Base.js").default} layer Layer.
 * @param {Map} map Map.
 */ function $19f0d4d634ca7fe4$var$setLayerMapProperty(layer, map) {
    if (layer instanceof (0, $7bdbe21729fecf84$export$2e2bcd8739ae039)) {
        layer.setMapInternal(map);
        return;
    }
    if (layer instanceof (0, $c087d5d4d6aeb943$export$2e2bcd8739ae039)) {
        const layers = layer.getLayers().getArray();
        for(let i = 0, ii = layers.length; i < ii; ++i)$19f0d4d634ca7fe4$var$setLayerMapProperty(layers[i], map);
    }
}
/**
 * @classdesc
 * The map is the core component of OpenLayers. For a map to render, a view,
 * one or more layers, and a target container are needed:
 *
 *     import Map from 'ol/Map.js';
 *     import View from 'ol/View.js';
 *     import TileLayer from 'ol/layer/Tile.js';
 *     import OSM from 'ol/source/OSM.js';
 *
 *     const map = new Map({
 *       view: new View({
 *         center: [0, 0],
 *         zoom: 1,
 *       }),
 *       layers: [
 *         new TileLayer({
 *           source: new OSM(),
 *         }),
 *       ],
 *       target: 'map',
 *     });
 *
 * The above snippet creates a map using a {@link module:ol/layer/Tile~TileLayer} to
 * display {@link module:ol/source/OSM~OSM} OSM data and render it to a DOM
 * element with the id `map`.
 *
 * The constructor places a viewport container (with CSS class name
 * `ol-viewport`) in the target element (see `getViewport()`), and then two
 * further elements within the viewport: one with CSS class name
 * `ol-overlaycontainer-stopevent` for controls and some overlays, and one with
 * CSS class name `ol-overlaycontainer` for other overlays (see the `stopEvent`
 * option of {@link module:ol/Overlay~Overlay} for the difference). The map
 * itself is placed in a further element within the viewport.
 *
 * Layers are stored as a {@link module:ol/Collection~Collection} in
 * layerGroups. A top-level group is provided by the library. This is what is
 * accessed by `getLayerGroup` and `setLayerGroup`. Layers entered in the
 * options are added to this group, and `addLayer` and `removeLayer` change the
 * layer collection in the group. `getLayers` is a convenience function for
 * `getLayerGroup().getLayers()`. Note that {@link module:ol/layer/Group~LayerGroup}
 * is a subclass of {@link module:ol/layer/Base~BaseLayer}, so layers entered in the
 * options or added with `addLayer` can be groups, which can contain further
 * groups, and so on.
 *
 * @fires import("./MapBrowserEvent.js").MapBrowserEvent
 * @fires import("./MapEvent.js").MapEvent
 * @fires import("./render/Event.js").default#precompose
 * @fires import("./render/Event.js").default#postcompose
 * @fires import("./render/Event.js").default#rendercomplete
 * @api
 */ class $19f0d4d634ca7fe4$var$Map extends (0, $4dd5119c2f9fa355$export$2e2bcd8739ae039) {
    /**
   * @param {MapOptions} [options] Map options.
   */ constructor(options){
        super();
        options = options || {};
        /***
     * @type {MapEventHandler<import("./events.js").EventsKey>}
     */ this.on;
        /***
     * @type {MapEventHandler<import("./events.js").EventsKey>}
     */ this.once;
        /***
     * @type {MapEventHandler<void>}
     */ this.un;
        const optionsInternal = $19f0d4d634ca7fe4$var$createOptionsInternal(options);
        /**
     * @private
     * @type {boolean}
     */ this.renderComplete_ = false;
        /**
     * @private
     * @type {boolean}
     */ this.loaded_ = true;
        /** @private */ this.boundHandleBrowserEvent_ = this.handleBrowserEvent.bind(this);
        /**
     * @type {number}
     * @private
     */ this.maxTilesLoading_ = options.maxTilesLoading !== undefined ? options.maxTilesLoading : 16;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = options.pixelRatio !== undefined ? options.pixelRatio : (0, $013e07c1ef6d00ad$export$6b83a0446fc26f94);
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.postRenderTimeoutHandle_;
        /**
     * @private
     * @type {number|undefined}
     */ this.animationDelayKey_;
        /**
     * @private
     */ this.animationDelay_ = this.animationDelay_.bind(this);
        /**
     * @private
     * @type {import("./transform.js").Transform}
     */ this.coordinateToPixelTransform_ = (0, $eb597965bdcc8f43$export$185802fd694ee1f5)();
        /**
     * @private
     * @type {import("./transform.js").Transform}
     */ this.pixelToCoordinateTransform_ = (0, $eb597965bdcc8f43$export$185802fd694ee1f5)();
        /**
     * @private
     * @type {number}
     */ this.frameIndex_ = 0;
        /**
     * @private
     * @type {?FrameState}
     */ this.frameState_ = null;
        /**
     * The extent at the previous 'moveend' event.
     * @private
     * @type {import("./extent.js").Extent}
     */ this.previousExtent_ = null;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.viewPropertyListenerKey_ = null;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.viewChangeListenerKey_ = null;
        /**
     * @private
     * @type {?Array<import("./events.js").EventsKey>}
     */ this.layerGroupPropertyListenerKeys_ = null;
        /**
     * @private
     * @type {!HTMLElement}
     */ if (!(0, $013e07c1ef6d00ad$export$98fcef3dc9973292)) {
            this.viewport_ = document.createElement('div');
            this.viewport_.className = 'ol-viewport' + ('ontouchstart' in window ? ' ol-touch' : '');
            this.viewport_.style.position = 'relative';
            this.viewport_.style.overflow = 'hidden';
            this.viewport_.style.width = '100%';
            this.viewport_.style.height = '100%';
            /**
       * @private
       * @type {!HTMLElement}
       */ this.overlayContainer_ = document.createElement('div');
            this.overlayContainer_.style.position = 'absolute';
            this.overlayContainer_.style.zIndex = '0';
            this.overlayContainer_.style.width = '100%';
            this.overlayContainer_.style.height = '100%';
            this.overlayContainer_.style.pointerEvents = 'none';
            this.overlayContainer_.className = 'ol-overlaycontainer';
            this.viewport_.appendChild(this.overlayContainer_);
            /**
       * @private
       * @type {!HTMLElement}
       */ this.overlayContainerStopEvent_ = document.createElement('div');
            this.overlayContainerStopEvent_.style.position = 'absolute';
            this.overlayContainerStopEvent_.style.zIndex = '0';
            this.overlayContainerStopEvent_.style.width = '100%';
            this.overlayContainerStopEvent_.style.height = '100%';
            this.overlayContainerStopEvent_.style.pointerEvents = 'none';
            this.overlayContainerStopEvent_.className = 'ol-overlaycontainer-stopevent';
            this.viewport_.appendChild(this.overlayContainerStopEvent_);
        }
        /**
     * @private
     * @type {MapBrowserEventHandler}
     */ this.mapBrowserEventHandler_ = null;
        /**
     * @private
     * @type {number}
     */ this.moveTolerance_ = options.moveTolerance;
        /**
     * @private
     * @type {HTMLElement|Document}
     */ this.keyboardEventTarget_ = optionsInternal.keyboardEventTarget;
        /**
     * @private
     * @type {?Array<import("./events.js").EventsKey>}
     */ this.targetChangeHandlerKeys_ = null;
        /**
     * @private
     * @type {HTMLElement|null}
     */ this.targetElement_ = null;
        if (!(0, $013e07c1ef6d00ad$export$98fcef3dc9973292)) /**
       * @private
       * @type {ResizeObserver}
       */ this.resizeObserver_ = new ResizeObserver(()=>this.updateSize());
        /**
     * @type {Collection<import("./control/Control.js").default>}
     * @protected
     */ this.controls = optionsInternal.controls || ((0, $013e07c1ef6d00ad$export$98fcef3dc9973292) ? new (0, $c6078a5bf4414204$export$2e2bcd8739ae039)() : (0, $b0851fae3ad0c95a$export$ebe90cb607ad99e)());
        /**
     * @type {Collection<import("./interaction/Interaction.js").default>}
     * @protected
     */ this.interactions = optionsInternal.interactions || ((0, $013e07c1ef6d00ad$export$98fcef3dc9973292) ? new (0, $c6078a5bf4414204$export$2e2bcd8739ae039)() : (0, $eec0d17a56f2f04b$export$ebe90cb607ad99e)({
            onFocusOnly: true
        }));
        /**
     * @type {Collection<import("./Overlay.js").default>}
     * @private
     */ this.overlays_ = optionsInternal.overlays;
        /**
     * A lookup of overlays by id.
     * @private
     * @type {Object<string, import("./Overlay.js").default>}
     */ this.overlayIdIndex_ = {};
        /**
     * @type {import("./renderer/Map.js").default|null}
     * @private
     */ this.renderer_ = null;
        /**
     * @private
     * @type {!Array<PostRenderFunction>}
     */ this.postRenderFunctions_ = [];
        /**
     * @private
     * @type {TileQueue}
     */ this.tileQueue_ = new (0, $0492c075e7d7702c$export$2e2bcd8739ae039)(this.getTilePriority.bind(this), this.handleTileChange_.bind(this));
        this.addChangeListener((0, $3460d904c594f91b$export$2e2bcd8739ae039).LAYERGROUP, this.handleLayerGroupChanged_);
        this.addChangeListener((0, $3460d904c594f91b$export$2e2bcd8739ae039).VIEW, this.handleViewChanged_);
        this.addChangeListener((0, $3460d904c594f91b$export$2e2bcd8739ae039).SIZE, this.handleSizeChanged_);
        this.addChangeListener((0, $3460d904c594f91b$export$2e2bcd8739ae039).TARGET, this.handleTargetChanged_);
        // setProperties will trigger the rendering of the map if the map
        // is "defined" already.
        this.setProperties(optionsInternal.values);
        const map = this;
        if (options.view && !(options.view instanceof (0, $0ab5c72f1ca22f62$export$2e2bcd8739ae039))) options.view.then(function(viewOptions) {
            map.setView(new (0, $0ab5c72f1ca22f62$export$2e2bcd8739ae039)(viewOptions));
        });
        this.controls.addEventListener((0, $d4ae00bf358e4687$export$2e2bcd8739ae039).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./control/Control.js").default>} event CollectionEvent
       */ (event)=>{
            event.element.setMap(this);
        });
        this.controls.addEventListener((0, $d4ae00bf358e4687$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./control/Control.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(null);
        });
        this.interactions.addEventListener((0, $d4ae00bf358e4687$export$2e2bcd8739ae039).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./interaction/Interaction.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(this);
        });
        this.interactions.addEventListener((0, $d4ae00bf358e4687$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./interaction/Interaction.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(null);
        });
        this.overlays_.addEventListener((0, $d4ae00bf358e4687$export$2e2bcd8739ae039).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./Overlay.js").default>} event CollectionEvent.
       */ (event)=>{
            this.addOverlayInternal_(event.element);
        });
        this.overlays_.addEventListener((0, $d4ae00bf358e4687$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./Overlay.js").default>} event CollectionEvent.
       */ (event)=>{
            const id = event.element.getId();
            if (id !== undefined) delete this.overlayIdIndex_[id.toString()];
            event.element.setMap(null);
        });
        this.controls.forEach(/**
       * @param {import("./control/Control.js").default} control Control.
       */ (control)=>{
            control.setMap(this);
        });
        this.interactions.forEach(/**
       * @param {import("./interaction/Interaction.js").default} interaction Interaction.
       */ (interaction)=>{
            interaction.setMap(this);
        });
        this.overlays_.forEach(this.addOverlayInternal_.bind(this));
    }
    /**
   * Add the given control to the map.
   * @param {import("./control/Control.js").default} control Control.
   * @api
   */ addControl(control) {
        this.getControls().push(control);
    }
    /**
   * Add the given interaction to the map. If you want to add an interaction
   * at another point of the collection use `getInteractions()` and the methods
   * available on {@link module:ol/Collection~Collection}. This can be used to
   * stop the event propagation from the handleEvent function. The interactions
   * get to handle the events in the reverse order of this collection.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to add.
   * @api
   */ addInteraction(interaction) {
        this.getInteractions().push(interaction);
    }
    /**
   * Adds the given layer to the top of this map. If you want to add a layer
   * elsewhere in the stack, use `getLayers()` and the methods available on
   * {@link module:ol/Collection~Collection}.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @api
   */ addLayer(layer) {
        const layers = this.getLayerGroup().getLayers();
        layers.push(layer);
    }
    /**
   * @param {import("./layer/Group.js").GroupEvent} event The layer add event.
   * @private
   */ handleLayerAdd_(event) {
        $19f0d4d634ca7fe4$var$setLayerMapProperty(event.layer, this);
    }
    /**
   * Add the given overlay to the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @api
   */ addOverlay(overlay) {
        this.getOverlays().push(overlay);
    }
    /**
   * This deals with map's overlay collection changes.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @private
   */ addOverlayInternal_(overlay) {
        const id = overlay.getId();
        if (id !== undefined) this.overlayIdIndex_[id.toString()] = overlay;
        overlay.setMap(this);
    }
    /**
   *
   * Clean up.
   * @override
   */ disposeInternal() {
        this.controls.clear();
        this.interactions.clear();
        this.overlays_.clear();
        this.resizeObserver_?.disconnect();
        this.setTarget(null);
        super.disposeInternal();
    }
    /**
   * Detect features that intersect a pixel on the viewport, and execute a
   * callback with each intersecting feature. Layers included in the detection can
   * be configured through the `layerFilter` option in `options`.
   * For polygons without a fill, only the stroke will be used for hit detection.
   * Polygons must have a fill style applied to ensure that pixels inside a polygon are detected.
   * The fill can be transparent.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {function(import("./Feature.js").FeatureLike, import("./layer/Layer.js").default<import("./source/Source.js").default>, import("./geom/SimpleGeometry.js").default): T} callback Feature callback. The callback will be
   *     called with two arguments. The first argument is one
   *     {@link module:ol/Feature~Feature feature} or
   *     {@link module:ol/render/Feature~RenderFeature render feature} at the pixel, the second is
   *     the {@link module:ol/layer/Layer~Layer layer} of the feature and will be null for
   *     unmanaged layers. To stop detection, callback functions can return a
   *     truthy value.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {T|undefined} Callback result, i.e. the return value of last
   * callback execution, or the first truthy callback return value.
   * @template T
   * @api
   */ forEachFeatureAtPixel(pixel, callback, options) {
        if (!this.frameState_ || !this.renderer_) return;
        const coordinate = this.getCoordinateFromPixelInternal(pixel);
        options = options !== undefined ? options : {};
        const hitTolerance = options.hitTolerance !== undefined ? options.hitTolerance : 0;
        const layerFilter = options.layerFilter !== undefined ? options.layerFilter : (0, $7efea016d660e267$export$22e23a2304399231);
        const checkWrapped = options.checkWrapped !== false;
        return this.renderer_.forEachFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, callback, null, layerFilter, null);
    }
    /**
   * Get all features that intersect a pixel on the viewport.
   * For polygons without a fill, only the stroke will be used for hit detection.
   * Polygons must have a fill style applied to ensure that pixels inside a polygon are detected.
   * The fill can be transparent.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {Array<import("./Feature.js").FeatureLike>} The detected features or
   * an empty array if none were found.
   * @api
   */ getFeaturesAtPixel(pixel, options) {
        const features = [];
        this.forEachFeatureAtPixel(pixel, function(feature) {
            features.push(feature);
        }, options);
        return features;
    }
    /**
   * Get all layers from all layer groups.
   * @return {Array<import("./layer/Layer.js").default>} Layers.
   * @api
   */ getAllLayers() {
        const layers = [];
        function addLayersFrom(layerGroup) {
            layerGroup.forEach(function(layer) {
                if (layer instanceof (0, $c087d5d4d6aeb943$export$2e2bcd8739ae039)) addLayersFrom(layer.getLayers());
                else layers.push(layer);
            });
        }
        addLayersFrom(this.getLayers());
        return layers;
    }
    /**
   * Detect if features intersect a pixel on the viewport. Layers included in the
   * detection can be configured through the `layerFilter` option.
   * For polygons without a fill, only the stroke will be used for hit detection.
   * Polygons must have a fill style applied to ensure that pixels inside a polygon are detected.
   * The fill can be transparent.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {boolean} Is there a feature at the given pixel?
   * @api
   */ hasFeatureAtPixel(pixel, options) {
        if (!this.frameState_ || !this.renderer_) return false;
        const coordinate = this.getCoordinateFromPixelInternal(pixel);
        options = options !== undefined ? options : {};
        const layerFilter = options.layerFilter !== undefined ? options.layerFilter : (0, $7efea016d660e267$export$22e23a2304399231);
        const hitTolerance = options.hitTolerance !== undefined ? options.hitTolerance : 0;
        const checkWrapped = options.checkWrapped !== false;
        return this.renderer_.hasFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, layerFilter, null);
    }
    /**
   * Returns the coordinate in user projection for a browser event.
   * @param {MouseEvent} event Event.
   * @return {import("./coordinate.js").Coordinate} Coordinate.
   * @api
   */ getEventCoordinate(event) {
        return this.getCoordinateFromPixel(this.getEventPixel(event));
    }
    /**
   * Returns the coordinate in view projection for a browser event.
   * @param {MouseEvent} event Event.
   * @return {import("./coordinate.js").Coordinate} Coordinate.
   */ getEventCoordinateInternal(event) {
        return this.getCoordinateFromPixelInternal(this.getEventPixel(event));
    }
    /**
   * Returns the map pixel position for a browser event relative to the viewport.
   * @param {UIEvent|{clientX: number, clientY: number}} event Event.
   * @return {import("./pixel.js").Pixel} Pixel.
   * @api
   */ getEventPixel(event) {
        const viewport = this.viewport_;
        const viewportPosition = viewport.getBoundingClientRect();
        const viewportSize = this.getSize();
        const scaleX = viewportPosition.width / viewportSize[0];
        const scaleY = viewportPosition.height / viewportSize[1];
        const eventPosition = //FIXME Are we really calling this with a TouchEvent anywhere?
        'changedTouches' in event ? /** @type {TouchEvent} */ event.changedTouches[0] : /** @type {MouseEvent} */ event;
        return [
            (eventPosition.clientX - viewportPosition.left) / scaleX,
            (eventPosition.clientY - viewportPosition.top) / scaleY
        ];
    }
    /**
   * Get the target in which this map is rendered.
   * Note that this returns what is entered as an option or in setTarget:
   * if that was an element, it returns an element; if a string, it returns that.
   * @return {HTMLElement|string|undefined} The Element or id of the Element that the
   *     map is rendered in.
   * @observable
   * @api
   */ getTarget() {
        return /** @type {HTMLElement|string|undefined} */ this.get((0, $3460d904c594f91b$export$2e2bcd8739ae039).TARGET);
    }
    /**
   * Get the DOM element into which this map is rendered. In contrast to
   * `getTarget` this method always return an `Element`, or `null` if the
   * map has no target.
   * @return {HTMLElement} The element that the map is rendered in.
   * @api
   */ getTargetElement() {
        return this.targetElement_;
    }
    /**
   * Get the coordinate for a given pixel.  This returns a coordinate in the
   * user projection.
   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
   * @api
   */ getCoordinateFromPixel(pixel) {
        return (0, $2a998b085c5a7ac9$export$698f563af1ba02a5)(this.getCoordinateFromPixelInternal(pixel), this.getView().getProjection());
    }
    /**
   * Get the coordinate for a given pixel.  This returns a coordinate in the
   * map view projection.
   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
   */ getCoordinateFromPixelInternal(pixel) {
        const frameState = this.frameState_;
        if (!frameState) return null;
        return (0, $eb597965bdcc8f43$export$5635d7ef4b8fee1c)(frameState.pixelToCoordinateTransform, pixel.slice());
    }
    /**
   * Get the map controls. Modifying this collection changes the controls
   * associated with the map.
   * @return {Collection<import("./control/Control.js").default>} Controls.
   * @api
   */ getControls() {
        return this.controls;
    }
    /**
   * Get the map overlays. Modifying this collection changes the overlays
   * associated with the map.
   * @return {Collection<import("./Overlay.js").default>} Overlays.
   * @api
   */ getOverlays() {
        return this.overlays_;
    }
    /**
   * Get an overlay by its identifier (the value returned by overlay.getId()).
   * Note that the index treats string and numeric identifiers as the same. So
   * `map.getOverlayById(2)` will return an overlay with id `'2'` or `2`.
   * @param {string|number} id Overlay identifier.
   * @return {import("./Overlay.js").default|null} Overlay.
   * @api
   */ getOverlayById(id) {
        const overlay = this.overlayIdIndex_[id.toString()];
        return overlay !== undefined ? overlay : null;
    }
    /**
   * Get the map interactions. Modifying this collection changes the interactions
   * associated with the map.
   *
   * Interactions are used for e.g. pan, zoom and rotate.
   * @return {Collection<import("./interaction/Interaction.js").default>} Interactions.
   * @api
   */ getInteractions() {
        return this.interactions;
    }
    /**
   * Get the layergroup associated with this map.
   * @return {LayerGroup} A layer group containing the layers in this map.
   * @observable
   * @api
   */ getLayerGroup() {
        return /** @type {LayerGroup} */ this.get((0, $3460d904c594f91b$export$2e2bcd8739ae039).LAYERGROUP);
    }
    /**
   * Clear any existing layers and add layers to the map.
   * @param {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>} layers The layers to be added to the map.
   * @api
   */ setLayers(layers) {
        const group = this.getLayerGroup();
        if (layers instanceof (0, $c6078a5bf4414204$export$2e2bcd8739ae039)) {
            group.setLayers(layers);
            return;
        }
        const collection = group.getLayers();
        collection.clear();
        collection.extend(layers);
    }
    /**
   * Get the collection of layers associated with this map.
   * @return {!Collection<import("./layer/Base.js").default>} Layers.
   * @api
   */ getLayers() {
        const layers = this.getLayerGroup().getLayers();
        return layers;
    }
    /**
   * @return {boolean} Layers have sources that are still loading.
   */ getLoadingOrNotReady() {
        const layerStatesArray = this.getLayerGroup().getLayerStatesArray();
        for(let i = 0, ii = layerStatesArray.length; i < ii; ++i){
            const state = layerStatesArray[i];
            if (!state.visible) continue;
            const renderer = state.layer.getRenderer();
            if (renderer && !renderer.ready) return true;
            const source = state.layer.getSource();
            if (source && source.loading) return true;
        }
        return false;
    }
    /**
   * Get the pixel for a coordinate.  This takes a coordinate in the user
   * projection and returns the corresponding pixel.
   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
   * @api
   */ getPixelFromCoordinate(coordinate) {
        const viewCoordinate = (0, $2a998b085c5a7ac9$export$d4b8ec0b96db1ee2)(coordinate, this.getView().getProjection());
        return this.getPixelFromCoordinateInternal(viewCoordinate);
    }
    /**
   * Get the pixel for a coordinate.  This takes a coordinate in the map view
   * projection and returns the corresponding pixel.
   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
   */ getPixelFromCoordinateInternal(coordinate) {
        const frameState = this.frameState_;
        if (!frameState) return null;
        return (0, $eb597965bdcc8f43$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, coordinate.slice(0, 2));
    }
    /**
   * Get the pixel ratio of the rendered map.
   * @return {number} Pixel ratio.
   * @api
   */ getPixelRatio() {
        return this.pixelRatio_;
    }
    /**
   * Set the pixel ratio of the rendered map.
   * @param {number} pixelRatio Pixel ratio.
   * @api
   */ setPixelRatio(pixelRatio) {
        if (this.pixelRatio_ === pixelRatio) return;
        this.pixelRatio_ = pixelRatio;
        this.render();
    }
    /**
   * Get the map renderer.
   * @return {import("./renderer/Map.js").default|null} Renderer
   */ getRenderer() {
        return this.renderer_;
    }
    /**
   * Get the size of this map.
   * @return {import("./size.js").Size|undefined} The size in pixels of the map in the DOM.
   * @observable
   * @api
   */ getSize() {
        return /** @type {import("./size.js").Size|undefined} */ this.get((0, $3460d904c594f91b$export$2e2bcd8739ae039).SIZE);
    }
    /**
   * Get the view associated with this map. A view manages properties such as
   * center and resolution.
   * @return {View} The view that controls this map.
   * @observable
   * @api
   */ getView() {
        return /** @type {View} */ this.get((0, $3460d904c594f91b$export$2e2bcd8739ae039).VIEW);
    }
    /**
   * Get the element that serves as the map viewport.
   * @return {HTMLElement} Viewport.
   * @api
   */ getViewport() {
        return this.viewport_;
    }
    /**
   * Get the element that serves as the container for overlays.  Elements added to
   * this container will let mousedown and touchstart events through to the map,
   * so clicks and gestures on an overlay will trigger {@link module:ol/MapBrowserEvent~MapBrowserEvent}
   * events.
   * @return {!HTMLElement} The map's overlay container.
   */ getOverlayContainer() {
        return this.overlayContainer_;
    }
    /**
   * Get the element that serves as a container for overlays that don't allow
   * event propagation. Elements added to this container won't let mousedown and
   * touchstart events through to the map, so clicks and gestures on an overlay
   * don't trigger any {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
   * @return {!HTMLElement} The map's overlay container that stops events.
   */ getOverlayContainerStopEvent() {
        return this.overlayContainerStopEvent_;
    }
    /**
   * @return {!Document} The document where the map is displayed.
   */ getOwnerDocument() {
        const targetElement = this.getTargetElement();
        return targetElement ? targetElement.ownerDocument : document;
    }
    /**
   * @param {import("./Tile.js").default} tile Tile.
   * @param {string} tileSourceKey Tile source key.
   * @param {import("./coordinate.js").Coordinate} tileCenter Tile center.
   * @param {number} tileResolution Tile resolution.
   * @return {number} Tile priority.
   */ getTilePriority(tile, tileSourceKey, tileCenter, tileResolution) {
        return (0, $0492c075e7d7702c$export$f08ad5eceeff5d45)(this.frameState_, tile, tileSourceKey, tileCenter, tileResolution);
    }
    /**
   * @param {PointerEvent|KeyboardEvent|WheelEvent} browserEvent Browser event.
   * @param {string} [type] Type.
   */ handleBrowserEvent(browserEvent, type) {
        type = type || browserEvent.type;
        const mapBrowserEvent = new (0, $0b2b68a741a0182d$export$2e2bcd8739ae039)(type, this, browserEvent);
        this.handleMapBrowserEvent(mapBrowserEvent);
    }
    /**
   * @param {MapBrowserEvent} mapBrowserEvent The event to handle.
   */ handleMapBrowserEvent(mapBrowserEvent) {
        if (!this.frameState_) // With no view defined, we cannot translate pixels into geographical
        // coordinates so interactions cannot be used.
        return;
        const originalEvent = mapBrowserEvent.originalEvent;
        const eventType = originalEvent.type;
        if (eventType === (0, $d49a55e5017c1935$export$2e2bcd8739ae039).POINTERDOWN || eventType === (0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).WHEEL || eventType === (0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).KEYDOWN) {
            const doc = this.getOwnerDocument();
            const rootNode = this.viewport_.getRootNode ? this.viewport_.getRootNode() : doc;
            const target = /** @type {Node} */ originalEvent.target;
            const currentDoc = rootNode instanceof ShadowRoot ? rootNode.host === target ? rootNode.host.ownerDocument : rootNode : rootNode === doc ? doc.documentElement : rootNode;
            if (// Abort if the target is a child of the container for elements whose events are not meant
            // to be handled by map interactions.
            this.overlayContainerStopEvent_.contains(target) || // Abort if the event target is a child of the container that is no longer in the page.
            // It's possible for the target to no longer be in the page if it has been removed in an
            // event listener, this might happen in a Control that recreates it's content based on
            // user interaction either manually or via a render in something like https://reactjs.org/
            !currentDoc.contains(target)) return;
        }
        mapBrowserEvent.frameState = this.frameState_;
        if (this.dispatchEvent(mapBrowserEvent) !== false) {
            const interactionsArray = this.getInteractions().getArray().slice();
            for(let i = interactionsArray.length - 1; i >= 0; i--){
                const interaction = interactionsArray[i];
                if (interaction.getMap() !== this || !interaction.getActive() || !this.getTargetElement()) continue;
                const cont = interaction.handleEvent(mapBrowserEvent);
                if (!cont || mapBrowserEvent.propagationStopped) break;
            }
        }
    }
    /**
   * @protected
   */ handlePostRender() {
        const frameState = this.frameState_;
        // Manage the tile queue
        // Image loads are expensive and a limited resource, so try to use them
        // efficiently:
        // * When the view is static we allow a large number of parallel tile loads
        //   to complete the frame as quickly as possible.
        // * When animating or interacting, image loads can cause janks, so we reduce
        //   the maximum number of loads per frame and limit the number of parallel
        //   tile loads to remain reactive to view changes and to reduce the chance of
        //   loading tiles that will quickly disappear from view.
        const tileQueue = this.tileQueue_;
        if (!tileQueue.isEmpty()) {
            let maxTotalLoading = this.maxTilesLoading_;
            let maxNewLoads = maxTotalLoading;
            const hints = frameState ? frameState.viewHints : undefined;
            const animatingOrInteracting = hints ? hints[(0, $08bf132ff3931200$export$2e2bcd8739ae039).ANIMATING] || hints[(0, $08bf132ff3931200$export$2e2bcd8739ae039).INTERACTING] : false;
            if (animatingOrInteracting) {
                const lowOnFrameBudget = Date.now() - frameState.time > 8;
                maxTotalLoading = lowOnFrameBudget ? 0 : 8;
                maxNewLoads = lowOnFrameBudget ? 0 : 2;
            }
            if (tileQueue.getTilesLoading() < maxTotalLoading) {
                if (animatingOrInteracting) tileQueue.reprioritize();
                tileQueue.loadMoreTiles(maxTotalLoading, maxNewLoads);
            }
        }
        if (frameState && this.renderer_ && !frameState.animate) {
            if (this.renderComplete_) {
                if (this.hasListener((0, $97affab8a58f0c97$export$2e2bcd8739ae039).RENDERCOMPLETE)) this.renderer_.dispatchRenderEvent((0, $97affab8a58f0c97$export$2e2bcd8739ae039).RENDERCOMPLETE, frameState);
                if (this.loaded_ === false) {
                    this.loaded_ = true;
                    this.dispatchEvent(new (0, $bbec7b72ddf9c25d$export$2e2bcd8739ae039)((0, $f13f0d102103b0f4$export$2e2bcd8739ae039).LOADEND, this, frameState));
                }
            } else if (this.loaded_ === true) {
                this.loaded_ = false;
                this.dispatchEvent(new (0, $bbec7b72ddf9c25d$export$2e2bcd8739ae039)((0, $f13f0d102103b0f4$export$2e2bcd8739ae039).LOADSTART, this, frameState));
            }
        }
        const postRenderFunctions = this.postRenderFunctions_;
        if (frameState) for(let i = 0, ii = postRenderFunctions.length; i < ii; ++i)postRenderFunctions[i](this, frameState);
        postRenderFunctions.length = 0;
    }
    /**
   * @private
   */ handleSizeChanged_() {
        if (this.getView() && !this.getView().getAnimating()) this.getView().resolveConstraints(0);
        this.render();
    }
    /**
   * @private
   */ handleTargetChanged_() {
        if (this.mapBrowserEventHandler_) {
            for(let i = 0, ii = this.targetChangeHandlerKeys_.length; i < ii; ++i)(0, $8061a5de9380012b$export$b0a21c8b3c1c921)(this.targetChangeHandlerKeys_[i]);
            this.targetChangeHandlerKeys_ = null;
            this.viewport_.removeEventListener((0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CONTEXTMENU, this.boundHandleBrowserEvent_);
            this.viewport_.removeEventListener((0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).WHEEL, this.boundHandleBrowserEvent_);
            this.mapBrowserEventHandler_.dispose();
            this.mapBrowserEventHandler_ = null;
            this.viewport_.remove();
        }
        if (this.targetElement_ && !(0, $5ce605ba3ee034a0$export$4b05d74c82e4c4d2)(this.targetElement_)) {
            this.resizeObserver_?.unobserve(this.targetElement_);
            const rootNode = this.targetElement_.getRootNode();
            if (rootNode instanceof ShadowRoot) this.resizeObserver_.unobserve(rootNode.host);
            this.setSize(undefined);
        }
        // target may be undefined, null, a string or an Element.
        // If it's a string we convert it to an Element before proceeding.
        // If it's not now an Element we remove the viewport from the DOM.
        // If it's an Element we append the viewport element to it.
        const target = this.getTarget();
        const targetElement = typeof target === 'string' ? document.getElementById(target) : target;
        this.targetElement_ = targetElement;
        if (!targetElement) {
            if (this.renderer_) {
                clearTimeout(this.postRenderTimeoutHandle_);
                this.postRenderTimeoutHandle_ = undefined;
                this.postRenderFunctions_.length = 0;
                this.renderer_.dispose();
                this.renderer_ = null;
            }
            if (this.animationDelayKey_) {
                cancelAnimationFrame(this.animationDelayKey_);
                this.animationDelayKey_ = undefined;
            }
        } else {
            if (!(0, $5ce605ba3ee034a0$export$4b05d74c82e4c4d2)(targetElement)) targetElement.appendChild(this.viewport_);
            if (!this.renderer_) this.renderer_ = new (0, $bce7756dbaf5b110$export$2e2bcd8739ae039)(this);
            if (!(0, $5ce605ba3ee034a0$export$4b05d74c82e4c4d2)(targetElement)) {
                this.mapBrowserEventHandler_ = new (0, $289a0e66403793e5$export$2e2bcd8739ae039)(this, this.moveTolerance_);
                for(const key in 0, $1daf9bd643ab3fe0$export$2e2bcd8739ae039)this.mapBrowserEventHandler_.addEventListener((0, $1daf9bd643ab3fe0$export$2e2bcd8739ae039)[key], this.handleMapBrowserEvent.bind(this));
                this.viewport_.addEventListener((0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CONTEXTMENU, this.boundHandleBrowserEvent_, false);
                this.viewport_.addEventListener((0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).WHEEL, this.boundHandleBrowserEvent_, (0, $013e07c1ef6d00ad$export$f751ce96c6c4e4fc) ? {
                    passive: false
                } : false);
                let keyboardEventTarget;
                if (!this.keyboardEventTarget_) {
                    // check if map target is in shadowDOM, if yes use host element as target
                    const targetRoot = targetElement.getRootNode();
                    const targetCandidate = targetRoot instanceof ShadowRoot ? targetRoot.host : targetElement;
                    keyboardEventTarget = targetCandidate;
                } else keyboardEventTarget = this.keyboardEventTarget_;
                this.targetChangeHandlerKeys_ = [
                    (0, $8061a5de9380012b$export$63174c828edd6ff8)(keyboardEventTarget, (0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).KEYDOWN, this.handleBrowserEvent, this),
                    (0, $8061a5de9380012b$export$63174c828edd6ff8)(keyboardEventTarget, (0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).KEYPRESS, this.handleBrowserEvent, this)
                ];
                if (targetElement instanceof HTMLElement) {
                    const rootNode = targetElement.getRootNode();
                    if (rootNode instanceof ShadowRoot) this.resizeObserver_.observe(rootNode.host);
                    this.resizeObserver_?.observe(targetElement);
                }
            }
            this.updateSize();
        }
    // updateSize calls setSize, so no need to call this.render
    // ourselves here.
    }
    /**
   * @private
   */ handleTileChange_() {
        this.render();
    }
    /**
   * @private
   */ handleViewPropertyChanged_() {
        this.render();
    }
    /**
   * @private
   */ handleViewChanged_() {
        if (this.viewPropertyListenerKey_) {
            (0, $8061a5de9380012b$export$b0a21c8b3c1c921)(this.viewPropertyListenerKey_);
            this.viewPropertyListenerKey_ = null;
        }
        if (this.viewChangeListenerKey_) {
            (0, $8061a5de9380012b$export$b0a21c8b3c1c921)(this.viewChangeListenerKey_);
            this.viewChangeListenerKey_ = null;
        }
        const view = this.getView();
        if (view) {
            this.updateViewportSize_(this.getSize());
            this.viewPropertyListenerKey_ = (0, $8061a5de9380012b$export$63174c828edd6ff8)(view, (0, $026be6c727dde691$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleViewPropertyChanged_, this);
            this.viewChangeListenerKey_ = (0, $8061a5de9380012b$export$63174c828edd6ff8)(view, (0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CHANGE, this.handleViewPropertyChanged_, this);
            view.resolveConstraints(0);
        }
        this.render();
    }
    /**
   * @private
   */ handleLayerGroupChanged_() {
        if (this.layerGroupPropertyListenerKeys_) {
            this.layerGroupPropertyListenerKeys_.forEach((0, $8061a5de9380012b$export$b0a21c8b3c1c921));
            this.layerGroupPropertyListenerKeys_ = null;
        }
        const layerGroup = this.getLayerGroup();
        if (layerGroup) {
            this.handleLayerAdd_(new (0, $c087d5d4d6aeb943$export$2f5ff21d758d25a7)('addlayer', layerGroup));
            this.layerGroupPropertyListenerKeys_ = [
                (0, $8061a5de9380012b$export$63174c828edd6ff8)(layerGroup, (0, $026be6c727dde691$export$2e2bcd8739ae039).PROPERTYCHANGE, this.render, this),
                (0, $8061a5de9380012b$export$63174c828edd6ff8)(layerGroup, (0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CHANGE, this.render, this),
                (0, $8061a5de9380012b$export$63174c828edd6ff8)(layerGroup, 'addlayer', this.handleLayerAdd_, this),
                (0, $8061a5de9380012b$export$63174c828edd6ff8)(layerGroup, 'removelayer', this.handleLayerRemove_, this)
            ];
        }
        this.render();
    }
    /**
   * @return {boolean} Is rendered.
   */ isRendered() {
        return !!this.frameState_;
    }
    /**
   * @private
   */ animationDelay_() {
        this.animationDelayKey_ = undefined;
        this.renderFrame_(Date.now());
    }
    /**
   * Requests an immediate render in a synchronous manner.
   * @api
   */ renderSync() {
        if (this.animationDelayKey_) cancelAnimationFrame(this.animationDelayKey_);
        this.animationDelay_();
    }
    /**
   * Redraws all text after new fonts have loaded
   */ redrawText() {
        if (!this.frameState_) return;
        const layerStates = this.frameState_.layerStatesArray;
        for(let i = 0, ii = layerStates.length; i < ii; ++i){
            const layer = layerStates[i].layer;
            if (layer.hasRenderer()) layer.getRenderer().handleFontsChanged();
        }
    }
    /**
   * Request a map rendering (at the next animation frame).
   * @api
   */ render() {
        if (this.renderer_ && this.animationDelayKey_ === undefined) this.animationDelayKey_ = requestAnimationFrame(this.animationDelay_);
    }
    /**
   * Remove the given control from the map.
   * @param {import("./control/Control.js").default} control Control.
   * @return {import("./control/Control.js").default|undefined} The removed control (or undefined
   *     if the control was not found).
   * @api
   */ removeControl(control) {
        return this.getControls().remove(control);
    }
    /**
   * Remove the given interaction from the map.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to remove.
   * @return {import("./interaction/Interaction.js").default|undefined} The removed interaction (or
   *     undefined if the interaction was not found).
   * @api
   */ removeInteraction(interaction) {
        return this.getInteractions().remove(interaction);
    }
    /**
   * Removes the given layer from the map.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @return {import("./layer/Base.js").default|undefined} The removed layer (or undefined if the
   *     layer was not found).
   * @api
   */ removeLayer(layer) {
        const layers = this.getLayerGroup().getLayers();
        return layers.remove(layer);
    }
    /**
   * @param {import("./layer/Group.js").GroupEvent} event The layer remove event.
   * @private
   */ handleLayerRemove_(event) {
        $19f0d4d634ca7fe4$var$removeLayerMapProperty(event.layer);
    }
    /**
   * Remove the given overlay from the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @return {import("./Overlay.js").default|undefined} The removed overlay (or undefined
   *     if the overlay was not found).
   * @api
   */ removeOverlay(overlay) {
        return this.getOverlays().remove(overlay);
    }
    /**
   * @param {number} time Time.
   * @private
   */ renderFrame_(time) {
        const size = this.getSize();
        const view = this.getView();
        const previousFrameState = this.frameState_;
        /** @type {?FrameState} */ let frameState = null;
        if (size !== undefined && (0, $e9727ecf69942748$export$622c471beb1693c7)(size) && view && view.isDef()) {
            const viewHints = view.getHints(this.frameState_ ? this.frameState_.viewHints : undefined);
            const viewState = view.getState();
            frameState = {
                animate: false,
                coordinateToPixelTransform: this.coordinateToPixelTransform_,
                declutter: null,
                extent: (0, $3412ad7bd362b04c$export$13ba650faf8308)(viewState.center, viewState.resolution, viewState.rotation, size),
                index: this.frameIndex_++,
                layerIndex: 0,
                layerStatesArray: this.getLayerGroup().getLayerStatesArray(),
                pixelRatio: this.pixelRatio_,
                pixelToCoordinateTransform: this.pixelToCoordinateTransform_,
                postRenderFunctions: [],
                size: size,
                tileQueue: this.tileQueue_,
                time: time,
                usedTiles: {},
                viewState: viewState,
                viewHints: viewHints,
                wantedTiles: {},
                mapId: (0, $01f1986453243423$export$5e82334337e0f204)(this),
                renderTargets: {}
            };
            if (viewState.nextCenter && viewState.nextResolution) {
                const rotation = isNaN(viewState.nextRotation) ? viewState.rotation : viewState.nextRotation;
                frameState.nextExtent = (0, $3412ad7bd362b04c$export$13ba650faf8308)(viewState.nextCenter, viewState.nextResolution, rotation, size);
            }
        }
        this.frameState_ = frameState;
        this.renderer_.renderFrame(frameState);
        if (frameState) {
            if (frameState.animate) this.render();
            Array.prototype.push.apply(this.postRenderFunctions_, frameState.postRenderFunctions);
            if (previousFrameState) {
                const moveStart = !this.previousExtent_ || !(0, $3412ad7bd362b04c$export$dd1bc94b04021eeb)(this.previousExtent_) && !(0, $3412ad7bd362b04c$export$e9bab7fafb253603)(frameState.extent, this.previousExtent_);
                if (moveStart) {
                    this.dispatchEvent(new (0, $bbec7b72ddf9c25d$export$2e2bcd8739ae039)((0, $f13f0d102103b0f4$export$2e2bcd8739ae039).MOVESTART, this, previousFrameState));
                    this.previousExtent_ = (0, $3412ad7bd362b04c$export$3e2152b047719fa1)(this.previousExtent_);
                }
            }
            const idle = this.previousExtent_ && !frameState.viewHints[(0, $08bf132ff3931200$export$2e2bcd8739ae039).ANIMATING] && !frameState.viewHints[(0, $08bf132ff3931200$export$2e2bcd8739ae039).INTERACTING] && !(0, $3412ad7bd362b04c$export$e9bab7fafb253603)(frameState.extent, this.previousExtent_);
            if (idle) {
                this.dispatchEvent(new (0, $bbec7b72ddf9c25d$export$2e2bcd8739ae039)((0, $f13f0d102103b0f4$export$2e2bcd8739ae039).MOVEEND, this, frameState));
                (0, $3412ad7bd362b04c$export$9cd59f9826255e47)(frameState.extent, this.previousExtent_);
            }
        }
        this.dispatchEvent(new (0, $bbec7b72ddf9c25d$export$2e2bcd8739ae039)((0, $f13f0d102103b0f4$export$2e2bcd8739ae039).POSTRENDER, this, frameState));
        this.renderComplete_ = (this.hasListener((0, $f13f0d102103b0f4$export$2e2bcd8739ae039).LOADSTART) || this.hasListener((0, $f13f0d102103b0f4$export$2e2bcd8739ae039).LOADEND) || this.hasListener((0, $97affab8a58f0c97$export$2e2bcd8739ae039).RENDERCOMPLETE)) && !this.tileQueue_.getTilesLoading() && !this.tileQueue_.getCount() && !this.getLoadingOrNotReady();
        if (!this.postRenderTimeoutHandle_) this.postRenderTimeoutHandle_ = setTimeout(()=>{
            this.postRenderTimeoutHandle_ = undefined;
            this.handlePostRender();
        }, 0);
    }
    /**
   * Sets the layergroup of this map.
   * @param {LayerGroup} layerGroup A layer group containing the layers in this map.
   * @observable
   * @api
   */ setLayerGroup(layerGroup) {
        const oldLayerGroup = this.getLayerGroup();
        if (oldLayerGroup) this.handleLayerRemove_(new (0, $c087d5d4d6aeb943$export$2f5ff21d758d25a7)('removelayer', oldLayerGroup));
        this.set((0, $3460d904c594f91b$export$2e2bcd8739ae039).LAYERGROUP, layerGroup);
    }
    /**
   * Set the size of this map.
   * @param {import("./size.js").Size|undefined} size The size in pixels of the map in the DOM.
   * @observable
   * @api
   */ setSize(size) {
        this.set((0, $3460d904c594f91b$export$2e2bcd8739ae039).SIZE, size);
    }
    /**
   * Set the target element to render this map into.
   * For accessibility (focus and keyboard events for map navigation), the `target` element must have a
   *  properly configured `tabindex` attribute. If the `target` element is inside a Shadow DOM, the
   *  `tabindex` atribute must be set on the custom element's host element.
   * @param {HTMLElement|string} [target] The Element or id of the Element
   *     that the map is rendered in.
   * @observable
   * @api
   */ setTarget(target) {
        this.set((0, $3460d904c594f91b$export$2e2bcd8739ae039).TARGET, target);
    }
    /**
   * Set the view for this map.
   * @param {View|Promise<import("./View.js").ViewOptions>|null} view The view that controls this map.
   * It is also possible to pass a promise that resolves to options for constructing a view.  This
   * alternative allows view properties to be resolved by sources or other components that load
   * view-related metadata.
   * @observable
   * @api
   */ setView(view) {
        if (!view || view instanceof (0, $0ab5c72f1ca22f62$export$2e2bcd8739ae039)) {
            this.set((0, $3460d904c594f91b$export$2e2bcd8739ae039).VIEW, view);
            return;
        }
        this.set((0, $3460d904c594f91b$export$2e2bcd8739ae039).VIEW, new (0, $0ab5c72f1ca22f62$export$2e2bcd8739ae039)());
        const map = this;
        view.then(function(viewOptions) {
            map.setView(new (0, $0ab5c72f1ca22f62$export$2e2bcd8739ae039)(viewOptions));
        });
    }
    /**
   * Force a recalculation of the map viewport size.  This should be called when
   * third-party code changes the size of the map viewport.
   * @api
   */ updateSize() {
        const targetElement = this.getTargetElement();
        let size = undefined;
        if (targetElement) {
            let width, height;
            if ((0, $5ce605ba3ee034a0$export$4b05d74c82e4c4d2)(targetElement)) {
                const transform = targetElement.getContext('2d').getTransform();
                // Use scale components of the transform to calculate the size in CSS pixels
                width = targetElement.width / transform.a;
                height = targetElement.height / transform.d;
            } else {
                const computedStyle = getComputedStyle(targetElement);
                width = targetElement.offsetWidth - parseFloat(computedStyle['borderLeftWidth']) - parseFloat(computedStyle['paddingLeft']) - parseFloat(computedStyle['paddingRight']) - parseFloat(computedStyle['borderRightWidth']);
                height = targetElement.offsetHeight - parseFloat(computedStyle['borderTopWidth']) - parseFloat(computedStyle['paddingTop']) - parseFloat(computedStyle['paddingBottom']) - parseFloat(computedStyle['borderBottomWidth']);
            }
            if (!isNaN(width) && !isNaN(height)) {
                size = [
                    Math.max(0, width),
                    Math.max(0, height)
                ];
                if (!(0, $e9727ecf69942748$export$622c471beb1693c7)(size) && !!(targetElement.offsetWidth || targetElement.offsetHeight || targetElement.getClientRects().length)) (0, $cf824eca25b51fde$export$c106dd0671a0fc2d)("No map visible because the map container's width or height are 0.");
            }
        }
        const oldSize = this.getSize();
        if (size && (!oldSize || !(0, $db525acb5f2517fc$export$e9bab7fafb253603)(size, oldSize))) {
            this.updateViewportSize_(size);
            this.setSize(size);
        }
    }
    /**
   * Recomputes the viewport size and save it on the view object (if any)
   * @param {import("./size.js").Size|undefined} size The size.
   * @private
   */ updateViewportSize_(size) {
        const view = this.getView();
        if (view) view.setViewportSize(size);
    }
}
/**
 * @param {MapOptions} options Map options.
 * @return {MapOptionsInternal} Internal map options.
 */ function $19f0d4d634ca7fe4$var$createOptionsInternal(options) {
    /**
   * @type {HTMLElement|Document}
   */ let keyboardEventTarget = null;
    if (options.keyboardEventTarget !== undefined) keyboardEventTarget = typeof options.keyboardEventTarget === 'string' ? document.getElementById(options.keyboardEventTarget) : options.keyboardEventTarget;
    /**
   * @type {Object<string, *>}
   */ const values = {};
    const layerGroup = options.layers && typeof /** @type {?} */ options.layers.getLayers === 'function' ? /** @type {LayerGroup} */ options.layers : new (0, $c087d5d4d6aeb943$export$2e2bcd8739ae039)({
        layers: /** @type {Collection<import("./layer/Base.js").default>|Array<import("./layer/Base.js").default>} */ options.layers
    });
    values[(0, $3460d904c594f91b$export$2e2bcd8739ae039).LAYERGROUP] = layerGroup;
    values[(0, $3460d904c594f91b$export$2e2bcd8739ae039).TARGET] = options.target;
    values[(0, $3460d904c594f91b$export$2e2bcd8739ae039).VIEW] = options.view instanceof (0, $0ab5c72f1ca22f62$export$2e2bcd8739ae039) ? options.view : new (0, $0ab5c72f1ca22f62$export$2e2bcd8739ae039)();
    /** @type {Collection<import("./control/Control.js").default>} */ let controls;
    if (options.controls !== undefined) {
        if (Array.isArray(options.controls)) controls = new (0, $c6078a5bf4414204$export$2e2bcd8739ae039)(options.controls.slice());
        else {
            (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(typeof /** @type {?} */ options.controls.getArray === 'function', 'Expected `controls` to be an array or an `ol/Collection.js`');
            controls = options.controls;
        }
    }
    /** @type {Collection<import("./interaction/Interaction.js").default>} */ let interactions;
    if (options.interactions !== undefined) {
        if (Array.isArray(options.interactions)) interactions = new (0, $c6078a5bf4414204$export$2e2bcd8739ae039)(options.interactions.slice());
        else {
            (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(typeof /** @type {?} */ options.interactions.getArray === 'function', 'Expected `interactions` to be an array or an `ol/Collection.js`');
            interactions = options.interactions;
        }
    }
    /** @type {Collection<import("./Overlay.js").default>} */ let overlays;
    if (options.overlays !== undefined) {
        if (Array.isArray(options.overlays)) overlays = new (0, $c6078a5bf4414204$export$2e2bcd8739ae039)(options.overlays.slice());
        else {
            (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(typeof /** @type {?} */ options.overlays.getArray === 'function', 'Expected `overlays` to be an array or an `ol/Collection.js`');
            overlays = options.overlays;
        }
    } else overlays = new (0, $c6078a5bf4414204$export$2e2bcd8739ae039)();
    return {
        controls: controls,
        interactions: interactions,
        keyboardEventTarget: keyboardEventTarget,
        overlays: overlays,
        values: values
    };
}
var $19f0d4d634ca7fe4$export$2e2bcd8739ae039 = $19f0d4d634ca7fe4$var$Map;




/**
 * @module ol/format/GeoJSON
 */ /**
 * @module ol/Feature
 */ 



/**
 * @typedef {typeof Feature|typeof import("./render/Feature.js").default} FeatureClass
 */ /**
 * @typedef {Feature|import("./render/Feature.js").default} FeatureLike
 */ /***
 * @template Return
 * @typedef {import("./Observable.js").OnSignature<import("./Observable.js").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable.js").OnSignature<import("./ObjectEventType.js").Types|'change:geometry', import("./Object.js").ObjectEvent, Return> &
 *   import("./Observable.js").CombinedOnSignature<import("./Observable.js").EventTypes|import("./ObjectEventType.js").Types
 *     |'change:geometry', Return>} FeatureOnSignature
 */ /***
 * @template {import("./geom/Geometry.js").default} [Geometry=import("./geom/Geometry.js").default]
 * @template {Object<string, *>} [Properties=Object<string, *>]
 * @typedef {Properties & { geometry?: Geometry }} ObjectWithGeometry
 */ /**
 * @classdesc
 * A vector object for geographic features with a geometry and other
 * attribute properties, similar to the features in vector file formats like
 * GeoJSON.
 *
 * Features can be styled individually with `setStyle`; otherwise they use the
 * style of their vector layer.
 *
 * Note that attribute properties are set as {@link module:ol/Object~BaseObject} properties on
 * the feature object, so they are observable, and have get/set accessors.
 *
 * Typically, a feature has a single geometry property. You can set the
 * geometry using the `setGeometry` method and get it with `getGeometry`.
 * It is possible to store more than one geometry on a feature using attribute
 * properties. By default, the geometry used for rendering is identified by
 * the property name `geometry`. If you want to use another geometry property
 * for rendering, use the `setGeometryName` method to change the attribute
 * property associated with the geometry for the feature.  For example:
 *
 * ```js
 *
 * import Feature from 'ol/Feature.js';
 * import Polygon from 'ol/geom/Polygon.js';
 * import Point from 'ol/geom/Point.js';
 *
 * const feature = new Feature({
 *   geometry: new Polygon(polyCoords),
 *   labelPoint: new Point(labelCoords),
 *   name: 'My Polygon',
 * });
 *
 * // get the polygon geometry
 * const poly = feature.getGeometry();
 *
 * // Render the feature as a point using the coordinates from labelPoint
 * feature.setGeometryName('labelPoint');
 *
 * // get the point geometry
 * const point = feature.getGeometry();
 * ```
 *
 * @api
 * @template {import("./geom/Geometry.js").default} [Geometry=import("./geom/Geometry.js").default]
 * @template {Object<string, *>} [Properties=Object<string, *>]
 * @extends {BaseObject<NoInfer<Properties>>}
 */ class $de6aee8cdd7a10c6$var$Feature extends (0, $4dd5119c2f9fa355$export$2e2bcd8739ae039) {
    /**
   * @param {Geometry|ObjectWithGeometry<Geometry, NoInfer<Properties>>} [geometryOrProperties]
   *     You may pass a Geometry object directly, or an object literal containing
   *     properties. If you pass an object literal, you may include a Geometry
   *     associated with a `geometry` key.
   */ constructor(geometryOrProperties){
        super();
        /***
     * @type {FeatureOnSignature<import("./events.js").EventsKey>}
     */ this.on;
        /***
     * @type {FeatureOnSignature<import("./events.js").EventsKey>}
     */ this.once;
        /***
     * @type {FeatureOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {number|string|undefined}
     */ this.id_ = undefined;
        /**
     * @type {string}
     * @private
     */ this.geometryName_ = 'geometry';
        /**
     * User provided style.
     * @private
     * @type {import("./style/Style.js").StyleLike}
     */ this.style_ = null;
        /**
     * @private
     * @type {import("./style/Style.js").StyleFunction|undefined}
     */ this.styleFunction_ = undefined;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.geometryChangeKey_ = null;
        this.addChangeListener(this.geometryName_, this.handleGeometryChanged_);
        if (geometryOrProperties) {
            if (typeof /** @type {?} */ geometryOrProperties.getSimplifiedGeometry === 'function') {
                const geometry = /** @type {Geometry} */ geometryOrProperties;
                this.setGeometry(geometry);
            } else {
                /** @type {?} */ const properties = geometryOrProperties;
                this.setProperties(properties);
            }
        }
    }
    /**
   * Clone this feature. If the original feature has a geometry it
   * is also cloned. The feature id is not set in the clone.
   * @return {Feature<Geometry>} The clone.
   * @api
   */ clone() {
        const clone = /** @type {Feature<Geometry>} */ new $de6aee8cdd7a10c6$var$Feature();
        const geometryName = this.geometryName_;
        clone.setGeometryName(geometryName);
        const properties = this.getPropertiesInternal();
        if (properties) {
            const geometry = this.getGeometry();
            for(const key in properties)if (key === geometryName && geometry) clone.set(key, geometry.clone());
            else clone.set(key, properties[key], true);
        }
        const style = this.getStyle();
        if (style) clone.setStyle(style);
        return clone;
    }
    /**
   * Get the feature's default geometry.  A feature may have any number of named
   * geometries.  The "default" geometry (the one that is rendered by default) is
   * set when calling {@link module:ol/Feature~Feature#setGeometry}.
   * @return {Geometry|undefined} The default geometry for the feature.
   * @api
   * @observable
   */ getGeometry() {
        return /** @type {Geometry|undefined} */ this.get(this.geometryName_);
    }
    /**
   * Get the feature identifier.  This is a stable identifier for the feature and
   * is either set when reading data from a remote source or set explicitly by
   * calling {@link module:ol/Feature~Feature#setId}.
   * @return {number|string|undefined} Id.
   * @api
   */ getId() {
        return this.id_;
    }
    /**
   * Get the name of the feature's default geometry.  By default, the default
   * geometry is named `geometry`.
   * @return {string} Get the property name associated with the default geometry
   *     for this feature.
   * @api
   */ getGeometryName() {
        return this.geometryName_;
    }
    /**
   * Get the feature's style. Will return what was provided to the
   * {@link module:ol/Feature~Feature#setStyle} method.
   * @return {import("./style/Style.js").StyleLike|undefined} The feature style.
   * @api
   */ getStyle() {
        return this.style_;
    }
    /**
   * Get the feature's style function.
   * @return {import("./style/Style.js").StyleFunction|undefined} Return a function
   * representing the current style of this feature.
   * @api
   */ getStyleFunction() {
        return this.styleFunction_;
    }
    /**
   * @private
   */ handleGeometryChange_() {
        this.changed();
    }
    /**
   * @private
   */ handleGeometryChanged_() {
        if (this.geometryChangeKey_) {
            (0, $8061a5de9380012b$export$b0a21c8b3c1c921)(this.geometryChangeKey_);
            this.geometryChangeKey_ = null;
        }
        const geometry = this.getGeometry();
        if (geometry) this.geometryChangeKey_ = (0, $8061a5de9380012b$export$63174c828edd6ff8)(geometry, (0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CHANGE, this.handleGeometryChange_, this);
        this.changed();
    }
    /**
   * Set the default geometry for the feature.  This will update the property
   * with the name returned by {@link module:ol/Feature~Feature#getGeometryName}.
   * @param {Geometry|undefined} geometry The new geometry.
   * @api
   * @observable
   */ setGeometry(geometry) {
        this.set(this.geometryName_, geometry);
    }
    /**
   * Set the style for the feature to override the layer style.  This can be a
   * single style object, an array of styles, or a function that takes a
   * resolution and returns an array of styles. To unset the feature style, call
   * `setStyle()` without arguments or a falsey value.
   * @param {import("./style/Style.js").StyleLike} [style] Style for this feature.
   * @api
   * @fires module:ol/events/Event~BaseEvent#event:change
   */ setStyle(style) {
        this.style_ = style;
        this.styleFunction_ = !style ? undefined : $de6aee8cdd7a10c6$export$bb06ddfd5d66e02e(style);
        this.changed();
    }
    /**
   * Set the feature id.  The feature id is considered stable and may be used when
   * requesting features or comparing identifiers returned from a remote source.
   * The feature id can be used with the
   * {@link module:ol/source/Vector~VectorSource#getFeatureById} method.
   * @param {number|string|undefined} id The feature id.
   * @api
   * @fires module:ol/events/Event~BaseEvent#event:change
   */ setId(id) {
        this.id_ = id;
        this.changed();
    }
    /**
   * Set the property name to be used when getting the feature's default geometry.
   * When calling {@link module:ol/Feature~Feature#getGeometry}, the value of the property with
   * this name will be returned.
   * @param {string} name The property name of the default geometry.
   * @api
   */ setGeometryName(name) {
        if (name === this.geometryName_) return;
        this.removeChangeListener(this.geometryName_, this.handleGeometryChanged_);
        this.geometryName_ = name;
        this.addChangeListener(this.geometryName_, this.handleGeometryChanged_);
        this.handleGeometryChanged_();
    }
}
function $de6aee8cdd7a10c6$export$bb06ddfd5d66e02e(obj) {
    if (typeof obj === 'function') return obj;
    /**
   * @type {Array<import("./style/Style.js").default>}
   */ let styles;
    if (Array.isArray(obj)) styles = obj;
    else {
        (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(typeof /** @type {?} */ obj.getZIndex === 'function', 'Expected an `ol/style/Style` or an array of `ol/style/Style.js`');
        const style = /** @type {import("./style/Style.js").default} */ obj;
        styles = [
            style
        ];
    }
    return function() {
        return styles;
    };
}
var $de6aee8cdd7a10c6$export$2e2bcd8739ae039 = $de6aee8cdd7a10c6$var$Feature;






/**
 * @module ol/render/Feature
 */ 



/**
 * @module ol/geom/LineString
 */ 





/**
 * @module ol/geom/flat/interpolate
 */ 

function $e5e0bd49910c1e6d$export$687ff82efd78795b(flatCoordinates, offset, end, stride, fraction, dest, dimension) {
    let o, t;
    const n = (end - offset) / stride;
    if (n === 1) o = offset;
    else if (n === 2) {
        o = offset;
        t = fraction;
    } else if (n !== 0) {
        let x1 = flatCoordinates[offset];
        let y1 = flatCoordinates[offset + 1];
        let length = 0;
        const cumulativeLengths = [
            0
        ];
        for(let i = offset + stride; i < end; i += stride){
            const x2 = flatCoordinates[i];
            const y2 = flatCoordinates[i + 1];
            length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
            cumulativeLengths.push(length);
            x1 = x2;
            y1 = y2;
        }
        const target = fraction * length;
        const index = (0, $db525acb5f2517fc$export$2e0ae67339d5f1ac)(cumulativeLengths, target);
        if (index < 0) {
            t = (target - cumulativeLengths[-index - 2]) / (cumulativeLengths[-index - 1] - cumulativeLengths[-index - 2]);
            o = offset + (-index - 2) * stride;
        } else o = offset + index * stride;
    }
    dimension = dimension > 1 ? dimension : 2;
    dest = dest ? dest : new Array(dimension);
    for(let i = 0; i < dimension; ++i)dest[i] = o === undefined ? NaN : t === undefined ? flatCoordinates[o + i] : (0, $912ac838ff50d1cd$export$3a89f8d6f6bf6c9f)(flatCoordinates[o + i], flatCoordinates[o + stride + i], t);
    return dest;
}
function $e5e0bd49910c1e6d$export$8f44c3c220ef6f09(flatCoordinates, offset, end, stride, m, extrapolate) {
    if (end == offset) return null;
    let coordinate;
    if (m < flatCoordinates[offset + stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(offset, offset + stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    if (flatCoordinates[end - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(end - stride, end);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    // FIXME use O(1) search
    if (m == flatCoordinates[offset + stride - 1]) return flatCoordinates.slice(offset, offset + stride);
    let lo = offset / stride;
    let hi = end / stride;
    while(lo < hi){
        const mid = lo + hi >> 1;
        if (m < flatCoordinates[(mid + 1) * stride - 1]) hi = mid;
        else lo = mid + 1;
    }
    const m0 = flatCoordinates[lo * stride - 1];
    if (m == m0) return flatCoordinates.slice((lo - 1) * stride, (lo - 1) * stride + stride);
    const m1 = flatCoordinates[(lo + 1) * stride - 1];
    const t = (m - m0) / (m1 - m0);
    coordinate = [];
    for(let i = 0; i < stride - 1; ++i)coordinate.push((0, $912ac838ff50d1cd$export$3a89f8d6f6bf6c9f)(flatCoordinates[(lo - 1) * stride + i], flatCoordinates[lo * stride + i], t));
    coordinate.push(m);
    return coordinate;
}
function $e5e0bd49910c1e6d$export$6a3300857e9ef453(flatCoordinates, offset, ends, stride, m, extrapolate, interpolate) {
    if (interpolate) return $e5e0bd49910c1e6d$export$8f44c3c220ef6f09(flatCoordinates, offset, ends[ends.length - 1], stride, m, extrapolate);
    let coordinate;
    if (m < flatCoordinates[stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(0, stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    if (flatCoordinates[flatCoordinates.length - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(flatCoordinates.length - stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        if (offset == end) continue;
        if (m < flatCoordinates[offset + stride - 1]) return null;
        if (m <= flatCoordinates[end - 1]) return $e5e0bd49910c1e6d$export$8f44c3c220ef6f09(flatCoordinates, offset, end, stride, m, false);
        offset = end;
    }
    return null;
}



/**
 * @module ol/geom/flat/length
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Length.
 */ function $a4bcede32ab492a7$export$153f8c6b4d8caebc(flatCoordinates, offset, end, stride) {
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    let length = 0;
    for(let i = offset + stride; i < end; i += stride){
        const x2 = flatCoordinates[i];
        const y2 = flatCoordinates[i + 1];
        length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
        x1 = x2;
        y1 = y2;
    }
    return length;
}
function $a4bcede32ab492a7$export$2bbb4f6f727a75c2(flatCoordinates, offset, end, stride) {
    let perimeter = $a4bcede32ab492a7$export$153f8c6b4d8caebc(flatCoordinates, offset, end, stride);
    const dx = flatCoordinates[end - stride] - flatCoordinates[offset];
    const dy = flatCoordinates[end - stride + 1] - flatCoordinates[offset + 1];
    perimeter += Math.sqrt(dx * dx + dy * dy);
    return perimeter;
}




/**
 * @classdesc
 * Linestring geometry.
 *
 * @api
 */ class $f39509739d6a215a$var$LineString extends (0, $7afe4d7f43fcf744$export$2e2bcd8739ae039) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.flatMidpoint_ = null;
        /**
     * @private
     * @type {number}
     */ this.flatMidpointRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (layout !== undefined && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Append the passed coordinate to the coordinates of the linestring.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @api
   */ appendCoordinate(coordinate) {
        (0, $db525acb5f2517fc$export$8b58be045bf06082)(this.flatCoordinates, coordinate);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!LineString} Clone.
   * @api
   * @override
   */ clone() {
        const lineString = new $f39509739d6a215a$var$LineString(this.flatCoordinates.slice(), this.layout);
        lineString.applyProperties(this);
        return lineString;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $3412ad7bd362b04c$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $5b2e115e5e9e61bb$export$bc2eb611ddf80103)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $5b2e115e5e9e61bb$export$4adc8e5135fb44c)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Iterate over each segment, calling the provided callback.
   * If the callback returns a truthy value the function returns that
   * value immediately. Otherwise the function returns `false`.
   *
   * @param {function(this: S, import("../coordinate.js").Coordinate, import("../coordinate.js").Coordinate): T} callback Function
   *     called for each segment. The function will receive two arguments, the start and end coordinates of the segment.
   * @return {T|boolean} Value.
   * @template T,S
   * @api
   */ forEachSegment(callback) {
        return (0, $8a538cdf4e153a23$export$4b80e395e36b5a56)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, callback);
    }
    /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * @param {number} m M.
   * @param {boolean} [extrapolate] Extrapolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate|null} Coordinate.
   * @api
   */ getCoordinateAtM(m, extrapolate) {
        if (this.layout != 'XYM' && this.layout != 'XYZM') return null;
        extrapolate = extrapolate !== undefined ? extrapolate : false;
        return (0, $e5e0bd49910c1e6d$export$8f44c3c220ef6f09)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, m, extrapolate);
    }
    /**
   * Return the coordinates of the linestring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, $1ffceb5bb486dffd$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the coordinate at the provided fraction along the linestring.
   * The `fraction` is a number between 0 and 1, where 0 is the start of the
   * linestring and 1 is the end.
   * @param {number} fraction Fraction.
   * @param {import("../coordinate.js").Coordinate} [dest] Optional coordinate whose values will
   *     be modified. If not provided, a new coordinate will be returned.
   * @return {import("../coordinate.js").Coordinate} Coordinate of the interpolated point.
   * @api
   */ getCoordinateAt(fraction, dest) {
        return (0, $e5e0bd49910c1e6d$export$687ff82efd78795b)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, fraction, dest, this.stride);
    }
    /**
   * Return the length of the linestring on projected plane.
   * @return {number} Length (on projected plane).
   * @api
   */ getLength() {
        return (0, $a4bcede32ab492a7$export$153f8c6b4d8caebc)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * @return {Array<number>} Flat midpoint.
   */ getFlatMidpoint() {
        if (this.flatMidpointRevision_ != this.getRevision()) {
            this.flatMidpoint_ = this.getCoordinateAt(0.5, this.flatMidpoint_ ?? undefined);
            this.flatMidpointRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.flatMidpoint_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LineString} Simplified LineString.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        simplifiedFlatCoordinates.length = (0, $3d277811864cf352$export$ef693d1572e64fb8)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        return new $f39509739d6a215a$var$LineString(simplifiedFlatCoordinates, 'XY');
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'LineString';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $ff49a05bd3496d04$export$40d8d71841a3d779)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent, this.getExtent());
    }
    /**
   * Set the coordinates of the linestring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $f2e193ff6b521c26$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $f39509739d6a215a$export$2e2bcd8739ae039 = $f39509739d6a215a$var$LineString;


/**
 * @module ol/geom/MultiLineString
 */ 










/**
 * @classdesc
 * Multi-linestring geometry.
 *
 * @api
 */ class $e87e615191dda5ba$var$MultiLineString extends (0, $7afe4d7f43fcf744$export$2e2bcd8739ae039) {
    /**
   * @param {Array<Array<import("../coordinate.js").Coordinate>|LineString>|Array<number>} coordinates
   *     Coordinates or LineString geometries. (For internal use, flat coordinates in
   *     combination with `layout` and `ends` are also accepted.)
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<number>} [ends] Flat coordinate ends for internal use.
   */ constructor(coordinates, layout, ends){
        super();
        /**
     * @type {Array<number>}
     * @private
     */ this.ends_ = [];
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (Array.isArray(coordinates[0])) this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ coordinates, layout);
        else if (layout !== undefined && ends) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.ends_ = ends;
        } else {
            const lineStrings = /** @type {Array<LineString>} */ coordinates;
            /** @type {Array<number>} */ const flatCoordinates = [];
            const ends = [];
            for(let i = 0, ii = lineStrings.length; i < ii; ++i){
                const lineString = lineStrings[i];
                (0, $db525acb5f2517fc$export$8b58be045bf06082)(flatCoordinates, lineString.getFlatCoordinates());
                ends.push(flatCoordinates.length);
            }
            const layout = lineStrings.length === 0 ? this.getLayout() : lineStrings[0].getLayout();
            this.setFlatCoordinates(layout, flatCoordinates);
            this.ends_ = ends;
        }
    }
    /**
   * Append the passed linestring to the multilinestring.
   * @param {LineString} lineString LineString.
   * @api
   */ appendLineString(lineString) {
        (0, $db525acb5f2517fc$export$8b58be045bf06082)(this.flatCoordinates, lineString.getFlatCoordinates().slice());
        this.ends_.push(this.flatCoordinates.length);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiLineString} Clone.
   * @api
   * @override
   */ clone() {
        const multiLineString = new $e87e615191dda5ba$var$MultiLineString(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
        multiLineString.applyProperties(this);
        return multiLineString;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $3412ad7bd362b04c$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $5b2e115e5e9e61bb$export$fbf31c8f2668ed5a)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $5b2e115e5e9e61bb$export$5a48a0eefcf14992)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * `interpolate` controls interpolation between consecutive LineStrings
   * within the MultiLineString. If `interpolate` is `true` the coordinates
   * will be linearly interpolated between the last coordinate of one LineString
   * and the first coordinate of the next LineString.  If `interpolate` is
   * `false` then the function will return `null` for Ms falling between
   * LineStrings.
   *
   * @param {number} m M.
   * @param {boolean} [extrapolate] Extrapolate. Default is `false`.
   * @param {boolean} [interpolate] Interpolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate|null} Coordinate.
   * @api
   */ getCoordinateAtM(m, extrapolate, interpolate) {
        if (this.layout != 'XYM' && this.layout != 'XYZM' || this.flatCoordinates.length === 0) return null;
        extrapolate = extrapolate !== undefined ? extrapolate : false;
        interpolate = interpolate !== undefined ? interpolate : false;
        return (0, $e5e0bd49910c1e6d$export$6a3300857e9ef453)(this.flatCoordinates, 0, this.ends_, this.stride, m, extrapolate, interpolate);
    }
    /**
   * Return the coordinates of the multilinestring.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, $1ffceb5bb486dffd$export$cbb9596fc0f40db2)(this.flatCoordinates, 0, this.ends_, this.stride);
    }
    /**
   * @return {Array<number>} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * Return the linestring at the specified index.
   * @param {number} index Index.
   * @return {LineString} LineString.
   * @api
   */ getLineString(index) {
        if (index < 0 || this.ends_.length <= index) return null;
        return new (0, $f39509739d6a215a$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
    }
    /**
   * Return the linestrings of this multilinestring.
   * @return {Array<LineString>} LineStrings.
   * @api
   */ getLineStrings() {
        const flatCoordinates = this.flatCoordinates;
        const ends = this.ends_;
        const layout = this.layout;
        /** @type {Array<LineString>} */ const lineStrings = [];
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const lineString = new (0, $f39509739d6a215a$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout);
            lineStrings.push(lineString);
            offset = end;
        }
        return lineStrings;
    }
    /**
   * Return the sum of all line string lengths
   * @return {number} Length (on projected plane).
   * @api
   */ getLength() {
        const ends = this.ends_;
        let start = 0;
        let length = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            length += (0, $a4bcede32ab492a7$export$153f8c6b4d8caebc)(this.flatCoordinates, start, ends[i], this.stride);
            start = ends[i];
        }
        return length;
    }
    /**
   * @return {Array<number>} Flat midpoints.
   */ getFlatMidpoints() {
        /** @type {Array<number>} */ const midpoints = [];
        const flatCoordinates = this.flatCoordinates;
        let offset = 0;
        const ends = this.ends_;
        const stride = this.stride;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const midpoint = (0, $e5e0bd49910c1e6d$export$687ff82efd78795b)(flatCoordinates, offset, end, stride, 0.5);
            (0, $db525acb5f2517fc$export$8b58be045bf06082)(midpoints, midpoint);
            offset = end;
        }
        return midpoints;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {MultiLineString} Simplified MultiLineString.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedFlatCoordinates.length = (0, $3d277811864cf352$export$cedb9900c0b225c2)(this.flatCoordinates, 0, this.ends_, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0, simplifiedEnds);
        return new $e87e615191dda5ba$var$MultiLineString(simplifiedFlatCoordinates, 'XY', simplifiedEnds);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'MultiLineString';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $ff49a05bd3496d04$export$fdb1d8e850bf7937)(this.flatCoordinates, 0, this.ends_, this.stride, extent);
    }
    /**
   * Set the coordinates of the multilinestring.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 2);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const ends = (0, $f2e193ff6b521c26$export$47c3746a74384d45)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
        this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
        this.changed();
    }
}
var $e87e615191dda5ba$export$2e2bcd8739ae039 = $e87e615191dda5ba$var$MultiLineString;


/**
 * @module ol/geom/MultiPoint
 */ 






/**
 * @classdesc
 * Multi-point geometry.
 *
 * @api
 */ class $58a702d20b3ac5c1$var$MultiPoint extends (0, $7afe4d7f43fcf744$export$2e2bcd8739ae039) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        if (layout && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Append the passed point to this multipoint.
   * @param {Point} point Point.
   * @api
   */ appendPoint(point) {
        (0, $db525acb5f2517fc$export$8b58be045bf06082)(this.flatCoordinates, point.getFlatCoordinates());
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiPoint} Clone.
   * @api
   * @override
   */ clone() {
        const multiPoint = new $58a702d20b3ac5c1$var$MultiPoint(this.flatCoordinates.slice(), this.layout);
        multiPoint.applyProperties(this);
        return multiPoint;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $3412ad7bd362b04c$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        const flatCoordinates = this.flatCoordinates;
        const stride = this.stride;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const squaredDistance = (0, $912ac838ff50d1cd$export$88e6ebb4fe54f538)(x, y, flatCoordinates[i], flatCoordinates[i + 1]);
            if (squaredDistance < minSquaredDistance) {
                minSquaredDistance = squaredDistance;
                for(let j = 0; j < stride; ++j)closestPoint[j] = flatCoordinates[i + j];
                closestPoint.length = stride;
            }
        }
        return minSquaredDistance;
    }
    /**
   * Return the coordinates of the multipoint.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, $1ffceb5bb486dffd$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the point at the specified index.
   * @param {number} index Index.
   * @return {Point} Point.
   * @api
   */ getPoint(index) {
        const n = this.flatCoordinates.length / this.stride;
        if (index < 0 || n <= index) return null;
        return new (0, $777d8f3503c8fbb0$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index * this.stride, (index + 1) * this.stride), this.layout);
    }
    /**
   * Return the points of this multipoint.
   * @return {Array<Point>} Points.
   * @api
   */ getPoints() {
        const flatCoordinates = this.flatCoordinates;
        const layout = this.layout;
        const stride = this.stride;
        /** @type {Array<Point>} */ const points = [];
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const point = new (0, $777d8f3503c8fbb0$export$2e2bcd8739ae039)(flatCoordinates.slice(i, i + stride), layout);
            points.push(point);
        }
        return points;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'MultiPoint';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        const flatCoordinates = this.flatCoordinates;
        const stride = this.stride;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const x = flatCoordinates[i];
            const y = flatCoordinates[i + 1];
            if ((0, $3412ad7bd362b04c$export$805bdfd6d6690e97)(extent, x, y)) return true;
        }
        return false;
    }
    /**
   * Set the coordinates of the multipoint.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $f2e193ff6b521c26$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $58a702d20b3ac5c1$export$2e2bcd8739ae039 = $58a702d20b3ac5c1$var$MultiPoint;


/**
 * @module ol/geom/MultiPolygon
 */ 





/**
 * @module ol/geom/flat/center
 */ 
function $08d162661da5a8bc$export$78e139679ca7205(flatCoordinates, offset, endss, stride) {
    const flatCenters = [];
    let extent = (0, $3412ad7bd362b04c$export$fe201bb3bbe031e9)();
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        extent = (0, $3412ad7bd362b04c$export$be0ab0bf96ca59ca)(flatCoordinates, offset, ends[0], stride);
        flatCenters.push((extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2);
        offset = ends[ends.length - 1];
    }
    return flatCenters;
}










/**
 * @classdesc
 * Multi-polygon geometry.
 *
 * @api
 */ class $243f44e394b1fc3e$var$MultiPolygon extends (0, $7afe4d7f43fcf744$export$2e2bcd8739ae039) {
    /**
   * @param {Array<Array<Array<import("../coordinate.js").Coordinate>>|Polygon>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` and `endss` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<Array<number>>} [endss] Array of ends for internal use with flat coordinates.
   */ constructor(coordinates, layout, endss){
        super();
        /**
     * @type {Array<Array<number>>}
     * @private
     */ this.endss_ = [];
        /**
     * @private
     * @type {number}
     */ this.flatInteriorPointsRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.flatInteriorPoints_ = null;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.orientedRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.orientedFlatCoordinates_ = null;
        if (!endss && !Array.isArray(coordinates[0])) {
            const polygons = /** @type {Array<Polygon>} */ coordinates;
            /** @type {Array<number>} */ const flatCoordinates = [];
            const thisEndss = [];
            for(let i = 0, ii = polygons.length; i < ii; ++i){
                const polygon = polygons[i];
                const offset = flatCoordinates.length;
                const ends = polygon.getEnds();
                for(let j = 0, jj = ends.length; j < jj; ++j)ends[j] += offset;
                (0, $db525acb5f2517fc$export$8b58be045bf06082)(flatCoordinates, polygon.getFlatCoordinates());
                thisEndss.push(ends);
            }
            layout = polygons.length === 0 ? this.getLayout() : polygons[0].getLayout();
            coordinates = flatCoordinates;
            endss = thisEndss;
        }
        if (layout !== undefined && endss) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.endss_ = endss;
        } else this.setCoordinates(/** @type {Array<Array<Array<import("../coordinate.js").Coordinate>>>} */ coordinates, layout);
    }
    /**
   * Append the passed polygon to this multipolygon.
   * @param {Polygon} polygon Polygon.
   * @api
   */ appendPolygon(polygon) {
        /** @type {Array<number>} */ let ends;
        if (!this.flatCoordinates) {
            this.flatCoordinates = polygon.getFlatCoordinates().slice();
            ends = polygon.getEnds().slice();
            this.endss_.push();
        } else {
            const offset = this.flatCoordinates.length;
            (0, $db525acb5f2517fc$export$8b58be045bf06082)(this.flatCoordinates, polygon.getFlatCoordinates());
            ends = polygon.getEnds().slice();
            for(let i = 0, ii = ends.length; i < ii; ++i)ends[i] += offset;
        }
        this.endss_.push(ends);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiPolygon} Clone.
   * @api
   * @override
   */ clone() {
        const len = this.endss_.length;
        const newEndss = new Array(len);
        for(let i = 0; i < len; ++i)newEndss[i] = this.endss_[i].slice();
        const multiPolygon = new $243f44e394b1fc3e$var$MultiPolygon(this.flatCoordinates.slice(), this.layout, newEndss);
        multiPolygon.applyProperties(this);
        return multiPolygon;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $3412ad7bd362b04c$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $5b2e115e5e9e61bb$export$37c18e6e7d50501a)(this.flatCoordinates, 0, this.endss_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $5b2e115e5e9e61bb$export$60e067685eb8f9c4)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        return (0, $9b499a31a2ad5cf2$export$c760d9d16cf92043)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, x, y);
    }
    /**
   * Return the area of the multipolygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, $3d4a8f2cf4f8d852$export$78e139679ca7205)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride);
    }
    /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for multi-polygons.
   *
   * @param {boolean} [right] Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<Array<import("../coordinate.js").Coordinate>>>} Coordinates.
   * @api
   * @override
   */ getCoordinates(right) {
        let flatCoordinates;
        if (right !== undefined) {
            flatCoordinates = this.getOrientedFlatCoordinates().slice();
            (0, $e3206434e8933f4a$export$ea9ed55fc2a85010)(flatCoordinates, 0, this.endss_, this.stride, right);
        } else flatCoordinates = this.flatCoordinates;
        return (0, $1ffceb5bb486dffd$export$915c7058aeb4dfeb)(flatCoordinates, 0, this.endss_, this.stride);
    }
    /**
   * @return {Array<Array<number>>} Endss.
   */ getEndss() {
        return this.endss_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoints() {
        if (this.flatInteriorPointsRevision_ != this.getRevision()) {
            const flatCenters = (0, $08d162661da5a8bc$export$78e139679ca7205)(this.flatCoordinates, 0, this.endss_, this.stride);
            this.flatInteriorPoints_ = (0, $be994eb649209148$export$11463803eda8a372)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, flatCenters);
            this.flatInteriorPointsRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.flatInteriorPoints_;
    }
    /**
   * Return the interior points as {@link module:ol/geom/MultiPoint~MultiPoint multipoint}.
   * @return {MultiPoint} Interior points as XYM coordinates, where M is
   * the length of the horizontal intersection that the point belongs to.
   * @api
   */ getInteriorPoints() {
        return new (0, $58a702d20b3ac5c1$export$2e2bcd8739ae039)(this.getFlatInteriorPoints().slice(), 'XYM');
    }
    /**
   * @return {Array<number>} Oriented flat coordinates.
   */ getOrientedFlatCoordinates() {
        if (this.orientedRevision_ != this.getRevision()) {
            const flatCoordinates = this.flatCoordinates;
            if ((0, $e3206434e8933f4a$export$a1d138f4bd85f4b4)(flatCoordinates, 0, this.endss_, this.stride)) this.orientedFlatCoordinates_ = flatCoordinates;
            else {
                this.orientedFlatCoordinates_ = flatCoordinates.slice();
                this.orientedFlatCoordinates_.length = (0, $e3206434e8933f4a$export$ea9ed55fc2a85010)(this.orientedFlatCoordinates_, 0, this.endss_, this.stride);
            }
            this.orientedRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.orientedFlatCoordinates_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {MultiPolygon} Simplified MultiPolygon.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<Array<number>>} */ const simplifiedEndss = [];
        simplifiedFlatCoordinates.length = (0, $3d277811864cf352$export$b9acf67ef05cd17c)(this.flatCoordinates, 0, this.endss_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEndss);
        return new $243f44e394b1fc3e$var$MultiPolygon(simplifiedFlatCoordinates, 'XY', simplifiedEndss);
    }
    /**
   * Return the polygon at the specified index.
   * @param {number} index Index.
   * @return {Polygon} Polygon.
   * @api
   */ getPolygon(index) {
        if (index < 0 || this.endss_.length <= index) return null;
        let offset;
        if (index === 0) offset = 0;
        else {
            const prevEnds = this.endss_[index - 1];
            offset = prevEnds[prevEnds.length - 1];
        }
        const ends = this.endss_[index].slice();
        const end = ends[ends.length - 1];
        if (offset !== 0) for(let i = 0, ii = ends.length; i < ii; ++i)ends[i] -= offset;
        return new (0, $5a6d32626ac6e0b9$export$2e2bcd8739ae039)(this.flatCoordinates.slice(offset, end), this.layout, ends);
    }
    /**
   * Return the polygons of this multipolygon.
   * @return {Array<Polygon>} Polygons.
   * @api
   */ getPolygons() {
        const layout = this.layout;
        const flatCoordinates = this.flatCoordinates;
        const endss = this.endss_;
        const polygons = [];
        let offset = 0;
        for(let i = 0, ii = endss.length; i < ii; ++i){
            const ends = endss[i].slice();
            const end = ends[ends.length - 1];
            if (offset !== 0) for(let j = 0, jj = ends.length; j < jj; ++j)ends[j] -= offset;
            const polygon = new (0, $5a6d32626ac6e0b9$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout, ends);
            polygons.push(polygon);
            offset = end;
        }
        return polygons;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'MultiPolygon';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $ff49a05bd3496d04$export$77b72fa3792f5bf0)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, extent);
    }
    /**
   * Set the coordinates of the multipolygon.
   * @param {!Array<Array<Array<import("../coordinate.js").Coordinate>>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 3);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const endss = (0, $f2e193ff6b521c26$export$f9f2bb59da4accd3)(this.flatCoordinates, 0, coordinates, this.stride, this.endss_);
        if (endss.length === 0) this.flatCoordinates.length = 0;
        else {
            const lastEnds = endss[endss.length - 1];
            this.flatCoordinates.length = lastEnds.length === 0 ? 0 : lastEnds[lastEnds.length - 1];
        }
        this.changed();
    }
}
var $243f44e394b1fc3e$export$2e2bcd8739ae039 = $243f44e394b1fc3e$var$MultiPolygon;












/**
 * @typedef {'Point' | 'LineString' | 'LinearRing' | 'Polygon' | 'MultiPoint' | 'MultiLineString'} Type
 * The geometry type.  One of `'Point'`, `'LineString'`, `'LinearRing'`,
 * `'Polygon'`, `'MultiPoint'` or 'MultiLineString'`.
 */ /**
 * @type {import("../transform.js").Transform}
 */ const $edf3df43d76225f4$var$tmpTransform = (0, $eb597965bdcc8f43$export$185802fd694ee1f5)();
/**
 * Lightweight, read-only, {@link module:ol/Feature~Feature} and {@link module:ol/geom/Geometry~Geometry} like
 * structure, optimized for vector tile rendering and styling. Geometry access
 * through the API is limited to getting the type and extent of the geometry.
 */ class $edf3df43d76225f4$var$RenderFeature {
    /**
   * @param {Type} type Geometry type.
   * @param {Array<number>} flatCoordinates Flat coordinates. These always need
   *     to be right-handed for polygons.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {Object<string, *>} properties Properties.
   * @param {number|string|undefined} id Feature id.
   */ constructor(type, flatCoordinates, ends, stride, properties, id){
        /**
     * @type {import("../style/Style.js").StyleFunction|undefined}
     */ this.styleFunction;
        /**
     * @private
     * @type {import("../extent.js").Extent|undefined}
     */ this.extent_;
        /**
     * @private
     * @type {number|string|undefined}
     */ this.id_ = id;
        /**
     * @private
     * @type {Type}
     */ this.type_ = type;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatCoordinates_ = flatCoordinates;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatInteriorPoints_ = null;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatMidpoints_ = null;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.ends_ = ends || null;
        /**
     * @private
     * @type {Object<string, *>}
     */ this.properties_ = properties;
        /**
     * @private
     * @type {number}
     */ this.squaredTolerance_;
        /**
     * @private
     * @type {number}
     */ this.stride_ = stride;
        /**
     * @private
     * @type {RenderFeature}
     */ this.simplifiedGeometry_;
    }
    /**
   * Get a feature property by its key.
   * @param {string} key Key
   * @return {*} Value for the requested key.
   * @api
   */ get(key) {
        return this.properties_[key];
    }
    /**
   * Get the extent of this feature's geometry.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        if (!this.extent_) this.extent_ = this.type_ === 'Point' ? (0, $3412ad7bd362b04c$export$4838bf78d04a9440)(this.flatCoordinates_) : (0, $3412ad7bd362b04c$export$be0ab0bf96ca59ca)(this.flatCoordinates_, 0, this.flatCoordinates_.length, this.stride_);
        return this.extent_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoint() {
        if (!this.flatInteriorPoints_) {
            const flatCenter = (0, $3412ad7bd362b04c$export$c91255cadecfe081)(this.getExtent());
            this.flatInteriorPoints_ = (0, $be994eb649209148$export$50e3b25928a5e892)(this.flatCoordinates_, 0, this.ends_, this.stride_, flatCenter, 0);
        }
        return this.flatInteriorPoints_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoints() {
        if (!this.flatInteriorPoints_) {
            const ends = (0, $e3206434e8933f4a$export$cb72ae403d6e78e6)(this.flatCoordinates_, this.ends_);
            const flatCenters = (0, $08d162661da5a8bc$export$78e139679ca7205)(this.flatCoordinates_, 0, ends, this.stride_);
            this.flatInteriorPoints_ = (0, $be994eb649209148$export$11463803eda8a372)(this.flatCoordinates_, 0, ends, this.stride_, flatCenters);
        }
        return this.flatInteriorPoints_;
    }
    /**
   * @return {Array<number>} Flat midpoint.
   */ getFlatMidpoint() {
        if (!this.flatMidpoints_) this.flatMidpoints_ = (0, $e5e0bd49910c1e6d$export$687ff82efd78795b)(this.flatCoordinates_, 0, this.flatCoordinates_.length, this.stride_, 0.5);
        return this.flatMidpoints_;
    }
    /**
   * @return {Array<number>} Flat midpoints.
   */ getFlatMidpoints() {
        if (!this.flatMidpoints_) {
            this.flatMidpoints_ = [];
            const flatCoordinates = this.flatCoordinates_;
            let offset = 0;
            const ends = /** @type {Array<number>} */ this.ends_;
            for(let i = 0, ii = ends.length; i < ii; ++i){
                const end = ends[i];
                const midpoint = (0, $e5e0bd49910c1e6d$export$687ff82efd78795b)(flatCoordinates, offset, end, this.stride_, 0.5);
                (0, $db525acb5f2517fc$export$8b58be045bf06082)(this.flatMidpoints_, midpoint);
                offset = end;
            }
        }
        return this.flatMidpoints_;
    }
    /**
   * Get the feature identifier.  This is a stable identifier for the feature and
   * is set when reading data from a remote source.
   * @return {number|string|undefined} Id.
   * @api
   */ getId() {
        return this.id_;
    }
    /**
   * @return {Array<number>} Flat coordinates.
   */ getOrientedFlatCoordinates() {
        return this.flatCoordinates_;
    }
    /**
   * For API compatibility with {@link module:ol/Feature~Feature}, this method is useful when
   * determining the geometry type in style function (see {@link #getType}).
   * @return {RenderFeature} Feature.
   * @api
   */ getGeometry() {
        return this;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {RenderFeature} Simplified geometry.
   */ getSimplifiedGeometry(squaredTolerance) {
        return this;
    }
    /**
   * Get a transformed and simplified version of the geometry.
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
   * @return {RenderFeature} Simplified geometry.
   */ simplifyTransformed(squaredTolerance, transform) {
        return this;
    }
    /**
   * Get the feature properties.
   * @return {Object<string, *>} Feature properties.
   * @api
   */ getProperties() {
        return this.properties_;
    }
    /**
   * Get an object of all property names and values.  This has the same behavior as getProperties,
   * but is here to conform with the {@link module:ol/Feature~Feature} interface.
   * @return {Object<string, *>?} Object.
   */ getPropertiesInternal() {
        return this.properties_;
    }
    /**
   * @return {number} Stride.
   */ getStride() {
        return this.stride_;
    }
    /**
   * @return {import('../style/Style.js').StyleFunction|undefined} Style
   */ getStyleFunction() {
        return this.styleFunction;
    }
    /**
   * Get the type of this feature's geometry.
   * @return {Type} Geometry type.
   * @api
   */ getType() {
        return this.type_;
    }
    /**
   * Transform geometry coordinates from tile pixel space to projected.
   *
   * @param {import("../proj.js").ProjectionLike} projection The data projection
   */ transform(projection) {
        projection = (0, $2a998b085c5a7ac9$export$3988ae62b71be9a3)(projection);
        const pixelExtent = projection.getExtent();
        const projectedExtent = projection.getWorldExtent();
        if (pixelExtent && projectedExtent) {
            const scale = (0, $3412ad7bd362b04c$export$c08559766941f856)(projectedExtent) / (0, $3412ad7bd362b04c$export$c08559766941f856)(pixelExtent);
            (0, $eb597965bdcc8f43$export$f672e0b6f7222cd7)($edf3df43d76225f4$var$tmpTransform, projectedExtent[0], projectedExtent[3], scale, -scale, 0, 0, 0);
            (0, $4149c848e00d54f8$export$b92b2dedcfff79de)(this.flatCoordinates_, 0, this.flatCoordinates_.length, this.stride_, $edf3df43d76225f4$var$tmpTransform, this.flatCoordinates_);
        }
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   */ applyTransform(transformFn) {
        transformFn(this.flatCoordinates_, this.flatCoordinates_, this.stride_);
    }
    /**
   * @return {RenderFeature} A cloned render feature.
   */ clone() {
        return new $edf3df43d76225f4$var$RenderFeature(this.type_, this.flatCoordinates_.slice(), this.ends_?.slice(), this.stride_, Object.assign({}, this.properties_), this.id_);
    }
    /**
   * @return {Array<number>|null} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * Add transform and resolution based geometry simplification to this instance.
   * @return {RenderFeature} This render feature.
   */ enableSimplifyTransformed() {
        this.simplifyTransformed = (0, $7efea016d660e267$export$ff83df6f9971435f)((squaredTolerance, transform)=>{
            if (squaredTolerance === this.squaredTolerance_) return this.simplifiedGeometry_;
            this.simplifiedGeometry_ = this.clone();
            if (transform) this.simplifiedGeometry_.applyTransform(transform);
            const simplifiedFlatCoordinates = this.simplifiedGeometry_.getFlatCoordinates();
            let simplifiedEnds;
            switch(this.type_){
                case 'LineString':
                    simplifiedFlatCoordinates.length = (0, $3d277811864cf352$export$ef693d1572e64fb8)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.flatCoordinates_.length, this.simplifiedGeometry_.stride_, squaredTolerance, simplifiedFlatCoordinates, 0);
                    simplifiedEnds = [
                        simplifiedFlatCoordinates.length
                    ];
                    break;
                case 'MultiLineString':
                    simplifiedEnds = [];
                    simplifiedFlatCoordinates.length = (0, $3d277811864cf352$export$cedb9900c0b225c2)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.ends_, this.simplifiedGeometry_.stride_, squaredTolerance, simplifiedFlatCoordinates, 0, simplifiedEnds);
                    break;
                case 'Polygon':
                    simplifiedEnds = [];
                    simplifiedFlatCoordinates.length = (0, $3d277811864cf352$export$60a9904b67f8d51b)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.ends_, this.simplifiedGeometry_.stride_, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEnds);
                    break;
                default:
            }
            if (simplifiedEnds) this.simplifiedGeometry_ = new $edf3df43d76225f4$var$RenderFeature(this.type_, simplifiedFlatCoordinates, simplifiedEnds, this.stride_, this.properties_, this.id_);
            this.squaredTolerance_ = squaredTolerance;
            return this.simplifiedGeometry_;
        });
        return this;
    }
}
/**
 * @return {Array<number>} Flat coordinates.
 */ $edf3df43d76225f4$var$RenderFeature.prototype.getFlatCoordinates = $edf3df43d76225f4$var$RenderFeature.prototype.getOrientedFlatCoordinates;
function $edf3df43d76225f4$export$b89ab3d1d30dec84(renderFeature) {
    const geometryType = renderFeature.getType();
    switch(geometryType){
        case 'Point':
            return new (0, $777d8f3503c8fbb0$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates());
        case 'MultiPoint':
            return new (0, $58a702d20b3ac5c1$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates(), 'XY');
        case 'LineString':
            return new (0, $f39509739d6a215a$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates(), 'XY');
        case 'MultiLineString':
            return new (0, $e87e615191dda5ba$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates(), 'XY', /** @type {Array<number>} */ renderFeature.getEnds());
        case 'Polygon':
            const flatCoordinates = renderFeature.getFlatCoordinates();
            const ends = renderFeature.getEnds();
            const endss = (0, $e3206434e8933f4a$export$cb72ae403d6e78e6)(flatCoordinates, ends);
            return endss.length > 1 ? new (0, $243f44e394b1fc3e$export$2e2bcd8739ae039)(flatCoordinates, 'XY', endss) : new (0, $5a6d32626ac6e0b9$export$2e2bcd8739ae039)(flatCoordinates, 'XY', ends);
        default:
            throw new Error('Invalid geometry type:' + geometryType);
    }
}
function $edf3df43d76225f4$export$ab19ba60efd1c4b5(renderFeature, geometryName) {
    const id = renderFeature.getId();
    const geometry = $edf3df43d76225f4$export$b89ab3d1d30dec84(renderFeature);
    const properties = renderFeature.getProperties();
    const feature = new (0, $de6aee8cdd7a10c6$export$2e2bcd8739ae039)();
    if (geometryName !== undefined) feature.setGeometryName(geometryName);
    feature.setGeometry(geometry);
    if (id !== undefined) feature.setId(id);
    feature.setProperties(properties, true);
    return feature;
}
var $edf3df43d76225f4$export$2e2bcd8739ae039 = $edf3df43d76225f4$var$RenderFeature;


/**
 * @module ol/format/Feature
 */ 
/**
 * @module ol/geom/GeometryCollection
 */ 



/**
 * @classdesc
 * An array of {@link module:ol/geom/Geometry~Geometry} objects.
 *
 * @api
 */ class $ffb8beec0163db19$var$GeometryCollection extends (0, $87bae61d82b90c07$export$2e2bcd8739ae039) {
    /**
   * @param {Array<Geometry>} geometries Geometries.
   */ constructor(geometries){
        super();
        /**
     * @private
     * @type {Array<Geometry>}
     */ this.geometries_ = geometries;
        /**
     * @private
     * @type {Array<import("../events.js").EventsKey>}
     */ this.changeEventsKeys_ = [];
        this.listenGeometriesChange_();
    }
    /**
   * @private
   */ unlistenGeometriesChange_() {
        this.changeEventsKeys_.forEach((0, $8061a5de9380012b$export$b0a21c8b3c1c921));
        this.changeEventsKeys_.length = 0;
    }
    /**
   * @private
   */ listenGeometriesChange_() {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)this.changeEventsKeys_.push((0, $8061a5de9380012b$export$63174c828edd6ff8)(geometries[i], (0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CHANGE, this.changed, this));
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!GeometryCollection} Clone.
   * @api
   * @override
   */ clone() {
        const geometryCollection = new $ffb8beec0163db19$var$GeometryCollection($ffb8beec0163db19$var$cloneGeometries(this.geometries_));
        geometryCollection.applyProperties(this);
        return geometryCollection;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $3412ad7bd362b04c$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)minSquaredDistance = geometries[i].closestPointXY(x, y, closestPoint, minSquaredDistance);
        return minSquaredDistance;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i){
            if (geometries[i].containsXY(x, y)) return true;
        }
        return false;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        (0, $3412ad7bd362b04c$export$3e2152b047719fa1)(extent);
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)(0, $3412ad7bd362b04c$export$8b58be045bf06082)(extent, geometries[i].getExtent());
        return extent;
    }
    /**
   * Return the geometries that make up this geometry collection.
   * @return {Array<Geometry>} Geometries.
   * @api
   */ getGeometries() {
        return $ffb8beec0163db19$var$cloneGeometries(this.geometries_);
    }
    /**
   * @return {Array<Geometry>} Geometries.
   */ getGeometriesArray() {
        return this.geometries_;
    }
    /**
   * @return {Array<Geometry>} Geometries.
   */ getGeometriesArrayRecursive() {
        /** @type {Array<Geometry>} */ let geometriesArray = [];
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)if (geometries[i].getType() === this.getType()) geometriesArray = geometriesArray.concat(/** @type {GeometryCollection} */ geometries[i].getGeometriesArrayRecursive());
        else geometriesArray.push(geometries[i]);
        return geometriesArray;
    }
    /**
   * Create a simplified version of this geometry using the Douglas Peucker algorithm.
   * @param {number} squaredTolerance Squared tolerance.
   * @return {GeometryCollection} Simplified GeometryCollection.
   * @override
   */ getSimplifiedGeometry(squaredTolerance) {
        if (this.simplifiedGeometryRevision !== this.getRevision()) {
            this.simplifiedGeometryMaxMinSquaredTolerance = 0;
            this.simplifiedGeometryRevision = this.getRevision();
        }
        if (squaredTolerance < 0 || this.simplifiedGeometryMaxMinSquaredTolerance !== 0 && squaredTolerance < this.simplifiedGeometryMaxMinSquaredTolerance) return this;
        const simplifiedGeometries = [];
        const geometries = this.geometries_;
        let simplified = false;
        for(let i = 0, ii = geometries.length; i < ii; ++i){
            const geometry = geometries[i];
            const simplifiedGeometry = geometry.getSimplifiedGeometry(squaredTolerance);
            simplifiedGeometries.push(simplifiedGeometry);
            if (simplifiedGeometry !== geometry) simplified = true;
        }
        if (simplified) {
            const simplifiedGeometryCollection = new $ffb8beec0163db19$var$GeometryCollection(simplifiedGeometries);
            return simplifiedGeometryCollection;
        }
        this.simplifiedGeometryMaxMinSquaredTolerance = squaredTolerance;
        return this;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'GeometryCollection';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i){
            if (geometries[i].intersectsExtent(extent)) return true;
        }
        return false;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return this.geometries_.length === 0;
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   * @override
   */ rotate(angle, anchor) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].rotate(angle, anchor);
        this.changed();
    }
    /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   * @override
   */ scale(sx, sy, anchor) {
        if (!anchor) anchor = (0, $3412ad7bd362b04c$export$c91255cadecfe081)(this.getExtent());
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].scale(sx, sy, anchor);
        this.changed();
    }
    /**
   * Set the geometries that make up this geometry collection.
   * @param {Array<Geometry>} geometries Geometries.
   * @api
   */ setGeometries(geometries) {
        this.setGeometriesArray($ffb8beec0163db19$var$cloneGeometries(geometries));
    }
    /**
   * @param {Array<Geometry>} geometries Geometries.
   */ setGeometriesArray(geometries) {
        this.unlistenGeometriesChange_();
        this.geometries_ = geometries;
        this.listenGeometriesChange_();
        this.changed();
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   * @api
   * @override
   */ applyTransform(transformFn) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].applyTransform(transformFn);
        this.changed();
    }
    /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   * @override
   */ translate(deltaX, deltaY) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].translate(deltaX, deltaY);
        this.changed();
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.unlistenGeometriesChange_();
        super.disposeInternal();
    }
}
/**
 * @param {Array<Geometry>} geometries Geometries.
 * @return {Array<Geometry>} Cloned geometries.
 */ function $ffb8beec0163db19$var$cloneGeometries(geometries) {
    return geometries.map((geometry)=>geometry.clone());
}
var $ffb8beec0163db19$export$2e2bcd8739ae039 = $ffb8beec0163db19$var$GeometryCollection;












/**
 * @typedef {Object} ReadOptions
 * @property {import("../proj.js").ProjectionLike} [dataProjection] Projection of the data we are reading.
 * If not provided, the projection will be derived from the data (where possible) or
 * the `dataProjection` of the format is assigned (where set). If the projection
 * can not be derived from the data and if no `dataProjection` is set for a format,
 * the features will not be reprojected.
 * @property {import("../extent.js").Extent} [extent] Tile extent in map units of the tile being read.
 * This is only required when reading data with tile pixels as geometry units. When configured,
 * a `dataProjection` with `TILE_PIXELS` as `units` and the tile's pixel extent as `extent` needs to be
 * provided.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection of the feature geometries
 * created by the format reader. If not provided, features will be returned in the
 * `dataProjection`.
 */ /**
 * @typedef {Object} WriteOptions
 * @property {import("../proj.js").ProjectionLike} [dataProjection] Projection of the data we are writing.
 * If not provided, the `dataProjection` of the format is assigned (where set).
 * If no `dataProjection` is set for a format, the features will be returned
 * in the `featureProjection`.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection of the feature geometries
 * that will be serialized by the format writer. If not provided, geometries are assumed
 * to be in the `dataProjection` if that is set; in other words, they are not transformed.
 * @property {boolean} [rightHanded] When writing geometries, follow the right-hand
 * rule for linear ring orientation.  This means that polygons will have counter-clockwise
 * exterior rings and clockwise interior rings.  By default, coordinates are serialized
 * as they are provided at construction.  If `true`, the right-hand rule will
 * be applied.  If `false`, the left-hand rule will be applied (clockwise for
 * exterior and counter-clockwise for interior rings).  Note that not all
 * formats support this.  The GeoJSON format does use this property when writing
 * geometries.
 * @property {number} [decimals] Maximum number of decimal places for coordinates.
 * Coordinates are stored internally as floats, but floating-point arithmetic can create
 * coordinates with a large number of decimal places, not generally wanted on output.
 * Set a number here to round coordinates. Can also be used to ensure that
 * coordinates read in can be written back out with the same number of decimals.
 * Default is no rounding.
 */ /**
 * @typedef {'arraybuffer' | 'json' | 'text' | 'xml'} Type
 */ /**
 * @typedef {Object} SimpleGeometryObject
 * @property {import('../geom/Geometry.js').Type} type Type.
 * @property {Array<number>} flatCoordinates Flat coordinates.
 * @property {Array<number>|Array<Array<number>>} [ends] Ends or endss.
 * @property {import('../geom/Geometry.js').GeometryLayout} [layout] Layout.
 */ /**
 * @typedef {Array<GeometryObject>} GeometryCollectionObject
 */ /**
 * @typedef {SimpleGeometryObject|GeometryCollectionObject} GeometryObject
 */ /**
 * @typedef {Object} FeatureObject
 * @property {string|number} [id] Id.
 * @property {GeometryObject} [geometry] Geometry.
 * @property {Object<string, *>} [properties] Properties.
 */ /***
 * @template {import('../Feature.js').FeatureLike} T
 * @typedef {T extends RenderFeature ? typeof RenderFeature : typeof Feature} FeatureToFeatureClass
 */ /***
 * @template {import("../Feature.js").FeatureClass} T
 * @typedef {T[keyof T] extends RenderFeature ? RenderFeature : Feature} FeatureClassToFeature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for feature formats.
 * {@link module:ol/format/Feature~FeatureFormat} subclasses provide the ability to decode and encode
 * {@link module:ol/Feature~Feature} objects from a variety of commonly used geospatial
 * file formats.  See the documentation for each format for more details.
 *
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("../Feature.js").default]
 * @abstract
 * @api
 */ class $cbbdf771f4a27aff$var$FeatureFormat {
    constructor(){
        /**
     * @protected
     * @type {import("../proj/Projection.js").default|undefined}
     */ this.dataProjection = undefined;
        /**
     * @protected
     * @type {import("../proj/Projection.js").default|undefined}
     */ this.defaultFeatureProjection = undefined;
        /**
     * @protected
     * @type {FeatureToFeatureClass<FeatureType>}
     */ this.featureClass = /** @type {FeatureToFeatureClass<FeatureType>} */ (0, $de6aee8cdd7a10c6$export$2e2bcd8739ae039);
        /**
     * A list media types supported by the format in descending order of preference.
     * @type {Array<string>}
     */ this.supportedMediaTypes = null;
    }
    /**
   * Adds the data projection to the read options.
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Options.
   * @return {ReadOptions|undefined} Options.
   * @protected
   */ getReadOptions(source, options) {
        if (options) {
            let dataProjection = options.dataProjection ? (0, $2a998b085c5a7ac9$export$3988ae62b71be9a3)(options.dataProjection) : this.readProjection(source);
            if (options.extent && dataProjection && dataProjection.getUnits() === 'tile-pixels') {
                dataProjection = (0, $2a998b085c5a7ac9$export$3988ae62b71be9a3)(dataProjection);
                dataProjection.setWorldExtent(options.extent);
            }
            options = {
                dataProjection: dataProjection,
                featureProjection: options.featureProjection
            };
        }
        return this.adaptOptions(options);
    }
    /**
   * Sets the `dataProjection` on the options, if no `dataProjection`
   * is set.
   * @param {WriteOptions|ReadOptions|undefined} options
   *     Options.
   * @protected
   * @return {WriteOptions|ReadOptions|undefined}
   *     Updated options.
   */ adaptOptions(options) {
        return Object.assign({
            dataProjection: this.dataProjection,
            featureProjection: this.defaultFeatureProjection,
            featureClass: this.featureClass
        }, options);
    }
    /**
   * @abstract
   * @return {Type} The format type.
   */ getType() {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Read a single feature from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {FeatureType|Array<FeatureType>} Feature.
   */ readFeature(source, options) {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Read all features from a source.
   *
   * @abstract
   * @param {Document|Element|ArrayBuffer|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {Array<FeatureType>} Features.
   */ readFeatures(source, options) {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Read a single geometry from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {import("../geom/Geometry.js").default} Geometry.
   */ readGeometry(source, options) {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Read the projection from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @return {import("../proj/Projection.js").default|undefined} Projection.
   */ readProjection(source) {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Encode a feature in this format.
   *
   * @abstract
   * @param {Feature} feature Feature.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */ writeFeature(feature, options) {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Encode an array of features in this format.
   *
   * @abstract
   * @param {Array<Feature>} features Features.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */ writeFeatures(features, options) {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Write a single geometry in this format.
   *
   * @abstract
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */ writeGeometry(geometry, options) {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
}
var $cbbdf771f4a27aff$export$2e2bcd8739ae039 = $cbbdf771f4a27aff$var$FeatureFormat;
function $cbbdf771f4a27aff$export$7beeea566b560d4(geometry, write, options) {
    const featureProjection = options ? (0, $2a998b085c5a7ac9$export$3988ae62b71be9a3)(options.featureProjection) : null;
    const dataProjection = options ? (0, $2a998b085c5a7ac9$export$3988ae62b71be9a3)(options.dataProjection) : null;
    let transformed = geometry;
    if (featureProjection && dataProjection && !(0, $2a998b085c5a7ac9$export$fe091d73a555748b)(featureProjection, dataProjection)) {
        if (write) transformed = /** @type {T} */ geometry.clone();
        const fromProjection = write ? featureProjection : dataProjection;
        const toProjection = write ? dataProjection : featureProjection;
        if (fromProjection.getUnits() === 'tile-pixels') transformed.transform(fromProjection, toProjection);
        else transformed.applyTransform((0, $2a998b085c5a7ac9$export$fce0c6cfca85ed96)(fromProjection, toProjection));
    }
    if (write && options && /** @type {WriteOptions} */ options.decimals !== undefined) {
        const power = Math.pow(10, /** @type {WriteOptions} */ options.decimals);
        // if decimals option on write, round each coordinate appropriately
        /**
     * @param {Array<number>} coordinates Coordinates.
     * @return {Array<number>} Transformed coordinates.
     */ const transform = function(coordinates) {
            for(let i = 0, ii = coordinates.length; i < ii; ++i)coordinates[i] = Math.round(coordinates[i] * power) / power;
            return coordinates;
        };
        if (transformed === geometry) transformed = /** @type {T} */ geometry.clone();
        transformed.applyTransform(transform);
    }
    return transformed;
}
function $cbbdf771f4a27aff$export$d3e9e4b1c7f2405c(extent, options) {
    const featureProjection = options ? (0, $2a998b085c5a7ac9$export$3988ae62b71be9a3)(options.featureProjection) : null;
    const dataProjection = options ? (0, $2a998b085c5a7ac9$export$3988ae62b71be9a3)(options.dataProjection) : null;
    if (featureProjection && dataProjection && !(0, $2a998b085c5a7ac9$export$fe091d73a555748b)(featureProjection, dataProjection)) return (0, $2a998b085c5a7ac9$export$751c68e0e0efff79)(extent, dataProjection, featureProjection);
    return extent;
}
const $cbbdf771f4a27aff$var$GeometryConstructor = {
    Point: (0, $777d8f3503c8fbb0$export$2e2bcd8739ae039),
    LineString: (0, $f39509739d6a215a$export$2e2bcd8739ae039),
    Polygon: (0, $5a6d32626ac6e0b9$export$2e2bcd8739ae039),
    MultiPoint: (0, $58a702d20b3ac5c1$export$2e2bcd8739ae039),
    MultiLineString: (0, $e87e615191dda5ba$export$2e2bcd8739ae039),
    MultiPolygon: (0, $243f44e394b1fc3e$export$2e2bcd8739ae039)
};
function $cbbdf771f4a27aff$var$orientFlatCoordinates(flatCoordinates, ends, stride) {
    if (Array.isArray(ends[0])) {
        // MultiPolagon
        if (!(0, $e3206434e8933f4a$export$a1d138f4bd85f4b4)(flatCoordinates, 0, ends, stride)) {
            flatCoordinates = flatCoordinates.slice();
            (0, $e3206434e8933f4a$export$ea9ed55fc2a85010)(flatCoordinates, 0, ends, stride);
        }
        return flatCoordinates;
    }
    if (!(0, $e3206434e8933f4a$export$f27cd06e85f4ba28)(flatCoordinates, 0, ends, stride)) {
        flatCoordinates = flatCoordinates.slice();
        (0, $e3206434e8933f4a$export$b71b604ddfc778c7)(flatCoordinates, 0, ends, stride);
    }
    return flatCoordinates;
}
function $cbbdf771f4a27aff$export$f935e77582b330a(object, options) {
    const geometry = object.geometry;
    if (!geometry) return [];
    if (Array.isArray(geometry)) return geometry.map((geometry)=>$cbbdf771f4a27aff$export$f935e77582b330a({
            ...object,
            geometry: geometry
        })).flat();
    const geometryType = geometry.type === 'MultiPolygon' ? 'Polygon' : geometry.type;
    if (geometryType === 'GeometryCollection' || geometryType === 'Circle') throw new Error('Unsupported geometry type: ' + geometryType);
    const stride = geometry.layout.length;
    return $cbbdf771f4a27aff$export$7beeea566b560d4(new (0, $edf3df43d76225f4$export$2e2bcd8739ae039)(geometryType, geometryType === 'Polygon' ? $cbbdf771f4a27aff$var$orientFlatCoordinates(geometry.flatCoordinates, geometry.ends, stride) : geometry.flatCoordinates, geometry.ends?.flat(), stride, object.properties || {}, object.id).enableSimplifyTransformed(), false, options);
}
function $cbbdf771f4a27aff$export$322c9678d8c47bf(object, options) {
    if (!object) return null;
    if (Array.isArray(object)) {
        const geometries = object.map((geometry)=>$cbbdf771f4a27aff$export$322c9678d8c47bf(geometry, options));
        return new (0, $ffb8beec0163db19$export$2e2bcd8739ae039)(geometries);
    }
    const Geometry = $cbbdf771f4a27aff$var$GeometryConstructor[object.type];
    return $cbbdf771f4a27aff$export$7beeea566b560d4(new Geometry(object.flatCoordinates, object.layout || 'XY', object.ends), false, options);
}


/**
 * @module ol/format/JSONFeature
 */ 

/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for JSON feature formats.
 *
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("../Feature.js").default]
 * @extends {FeatureFormat<FeatureType>}
 * @abstract
 */ class $05ba474756738438$var$JSONFeature extends (0, $cbbdf771f4a27aff$export$2e2bcd8739ae039) {
    constructor(){
        super();
    }
    /**
   * @return {import("./Feature.js").Type} Format.
   * @override
   */ getType() {
        return 'json';
    }
    /**
   * Read a feature.  Only works for a single feature. Use `readFeatures` to
   * read a feature collection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {FeatureType|Array<FeatureType>} Feature.
   * @api
   * @override
   */ readFeature(source, options) {
        return this.readFeatureFromObject($05ba474756738438$var$getObject(source), this.getReadOptions(source, options));
    }
    /**
   * Read all features.  Works with both a single feature and a feature
   * collection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {Array<FeatureType>} Features.
   * @api
   * @override
   */ readFeatures(source, options) {
        return this.readFeaturesFromObject($05ba474756738438$var$getObject(source), this.getReadOptions(source, options));
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {FeatureType|Array<FeatureType>} Feature.
   */ readFeatureFromObject(object, options) {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {Array<FeatureType>} Features.
   */ readFeaturesFromObject(object, options) {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Read a geometry.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {import("../geom/Geometry.js").default} Geometry.
   * @api
   * @override
   */ readGeometry(source, options) {
        return this.readGeometryFromObject($05ba474756738438$var$getObject(source), this.getReadOptions(source, options));
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   */ readGeometryFromObject(object, options) {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Read the projection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @return {import("../proj/Projection.js").default} Projection.
   * @api
   * @override
   */ readProjection(source) {
        return this.readProjectionFromObject($05ba474756738438$var$getObject(source));
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @protected
   * @return {import("../proj/Projection.js").default} Projection.
   */ readProjectionFromObject(object) {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Encode a feature as string.
   *
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded feature.
   * @api
   * @override
   */ writeFeature(feature, options) {
        return JSON.stringify(this.writeFeatureObject(feature, options));
    }
    /**
   * @abstract
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */ writeFeatureObject(feature, options) {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Encode an array of features as string.
   *
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded features.
   * @api
   * @override
   */ writeFeatures(features, options) {
        return JSON.stringify(this.writeFeaturesObject(features, options));
    }
    /**
   * @abstract
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */ writeFeaturesObject(features, options) {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Encode a geometry as string.
   *
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded geometry.
   * @api
   * @override
   */ writeGeometry(geometry, options) {
        return JSON.stringify(this.writeGeometryObject(geometry, options));
    }
    /**
   * @abstract
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */ writeGeometryObject(geometry, options) {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
}
/**
 * @param {Document|Element|Object|string} source Source.
 * @return {Object} Object.
 */ function $05ba474756738438$var$getObject(source) {
    if (typeof source === 'string') {
        const object = JSON.parse(source);
        return object ? /** @type {Object} */ object : null;
    }
    if (source !== null) return source;
    return null;
}
var $05ba474756738438$export$2e2bcd8739ae039 = $05ba474756738438$var$JSONFeature;


/**
 * @typedef {import("geojson").GeoJSON} GeoJSONObject
 * @typedef {import("geojson").Feature} GeoJSONFeature
 * @typedef {import("geojson").FeatureCollection} GeoJSONFeatureCollection
 * @typedef {import("geojson").Geometry} GeoJSONGeometry
 * @typedef {import("geojson").Point} GeoJSONPoint
 * @typedef {import("geojson").LineString} GeoJSONLineString
 * @typedef {import("geojson").Polygon} GeoJSONPolygon
 * @typedef {import("geojson").MultiPoint} GeoJSONMultiPoint
 * @typedef {import("geojson").MultiLineString} GeoJSONMultiLineString
 * @typedef {import("geojson").MultiPolygon} GeoJSONMultiPolygon
 * @typedef {import("geojson").GeometryCollection} GeoJSONGeometryCollection
 */ /**
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 * @typedef {Object} Options
 *
 * @property {import("../proj.js").ProjectionLike} [dataProjection='EPSG:4326'] Default data projection.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection for features read or
 * written by the format.  Options passed to read or write methods will take precedence.
 * @property {string} [geometryName] Geometry name to use when creating features.
 * @property {boolean} [extractGeometryName=false] Certain GeoJSON providers include
 * the geometry_name field in the feature GeoJSON. If set to `true` the GeoJSON reader
 * will look for that field to set the geometry name. If both this field is set to `true`
 * and a `geometryName` is provided, the `geometryName` will take precedence.
 * @property {import('./Feature.js').FeatureToFeatureClass<FeatureType>} [featureClass] Feature class
 * to be used when reading features. The default is {@link module:ol/Feature~Feature}. If performance is
 * the primary concern, and features are not going to be modified or round-tripped through the format,
 * consider using {@link module:ol/render/Feature~RenderFeature}
 */ /**
 * @classdesc
 * Feature format for reading and writing data in the GeoJSON format.
 *
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("../Feature.js").default]
 * @extends {JSONFeature<FeatureType>}
 * @api
 */ class $efdc8ee71ecdd4b6$var$GeoJSON extends (0, $05ba474756738438$export$2e2bcd8739ae039) {
    /**
   * @param {Options<FeatureType>} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super();
        /**
     * @type {import("../proj/Projection.js").default}
     */ this.dataProjection = (0, $2a998b085c5a7ac9$export$3988ae62b71be9a3)(options.dataProjection ? options.dataProjection : 'EPSG:4326');
        if (options.featureProjection) /**
       * @type {import("../proj/Projection.js").default}
       */ this.defaultFeatureProjection = (0, $2a998b085c5a7ac9$export$3988ae62b71be9a3)(options.featureProjection);
        if (options.featureClass) this.featureClass = options.featureClass;
        /**
     * Name of the geometry attribute for features.
     * @type {string|undefined}
     * @private
     */ this.geometryName_ = options.geometryName;
        /**
     * Look for the `geometry_name` in the feature GeoJSON
     * @type {boolean|undefined}
     * @private
     */ this.extractGeometryName_ = options.extractGeometryName;
        this.supportedMediaTypes = [
            'application/geo+json',
            'application/vnd.geo+json'
        ];
    }
    /**
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {FeatureType|Array<FeatureType>} Feature.
   * @override
   */ readFeatureFromObject(object, options) {
        /**
     * @type {GeoJSONFeature}
     */ let geoJSONFeature = null;
        if (object['type'] === 'Feature') geoJSONFeature = /** @type {GeoJSONFeature} */ object;
        else geoJSONFeature = {
            'type': 'Feature',
            'geometry': /** @type {GeoJSONGeometry} */ object,
            'properties': null
        };
        const geometry = $efdc8ee71ecdd4b6$var$readGeometryInternal(geoJSONFeature['geometry'], options);
        if (this.featureClass === (0, $edf3df43d76225f4$export$2e2bcd8739ae039)) return /** @type {FeatureType|Array<FeatureType>} */ (0, $cbbdf771f4a27aff$export$f935e77582b330a)({
            geometry: geometry,
            id: geoJSONFeature['id'],
            properties: geoJSONFeature['properties']
        }, options);
        const feature = new (0, $de6aee8cdd7a10c6$export$2e2bcd8739ae039)();
        if (this.geometryName_) feature.setGeometryName(this.geometryName_);
        else if (this.extractGeometryName_ && geoJSONFeature['geometry_name']) feature.setGeometryName(geoJSONFeature['geometry_name']);
        feature.setGeometry((0, $cbbdf771f4a27aff$export$322c9678d8c47bf)(geometry, options));
        if ('id' in geoJSONFeature) feature.setId(geoJSONFeature['id']);
        if (geoJSONFeature['properties']) feature.setProperties(geoJSONFeature['properties'], true);
        return /** @type {FeatureType|Array<FeatureType>} */ feature;
    }
    /**
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {Array<FeatureType>} Features.
   * @override
   */ readFeaturesFromObject(object, options) {
        const geoJSONObject = /** @type {GeoJSONObject} */ object;
        let features = null;
        if (geoJSONObject['type'] === 'FeatureCollection') {
            const geoJSONFeatureCollection = /** @type {GeoJSONFeatureCollection} */ object;
            features = [];
            const geoJSONFeatures = geoJSONFeatureCollection['features'];
            for(let i = 0, ii = geoJSONFeatures.length; i < ii; ++i){
                const featureObject = this.readFeatureFromObject(geoJSONFeatures[i], options);
                if (!featureObject) continue;
                features.push(featureObject);
            }
        } else features = [
            this.readFeatureFromObject(object, options)
        ];
        return /** @type {Array<FeatureType>} */ features.flat();
    }
    /**
   * @param {GeoJSONGeometry} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   * @override
   */ readGeometryFromObject(object, options) {
        return $efdc8ee71ecdd4b6$var$readGeometry(object, options);
    }
    /**
   * @param {Object} object Object.
   * @protected
   * @return {import("../proj/Projection.js").default} Projection.
   * @override
   */ readProjectionFromObject(object) {
        const crs = object['crs'];
        let projection;
        if (crs) {
            if (crs['type'] == 'name') projection = (0, $2a998b085c5a7ac9$export$3988ae62b71be9a3)(crs['properties']['name']);
            else if (crs['type'] === 'EPSG') projection = (0, $2a998b085c5a7ac9$export$3988ae62b71be9a3)('EPSG:' + crs['properties']['code']);
            else throw new Error('Unknown SRS type');
        } else projection = this.dataProjection;
        return /** @type {import("../proj/Projection.js").default} */ projection;
    }
    /**
   * Encode a feature as a GeoJSON Feature object.
   *
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONFeature} Object.
   * @api
   * @override
   */ writeFeatureObject(feature, options) {
        options = this.adaptOptions(options);
        /** @type {GeoJSONFeature} */ const object = {
            'type': 'Feature',
            geometry: null,
            properties: null
        };
        const id = feature.getId();
        if (id !== undefined) object.id = id;
        if (!feature.hasProperties()) return object;
        const properties = feature.getProperties();
        const geometry = feature.getGeometry();
        if (geometry) {
            object.geometry = $efdc8ee71ecdd4b6$var$writeGeometry(geometry, options);
            delete properties[feature.getGeometryName()];
        }
        if (!(0, $0669c62275461b52$export$dd1bc94b04021eeb)(properties)) object.properties = properties;
        return object;
    }
    /**
   * Encode an array of features as a GeoJSON object.
   *
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONFeatureCollection} GeoJSON Object.
   * @api
   * @override
   */ writeFeaturesObject(features, options) {
        options = this.adaptOptions(options);
        const objects = [];
        for(let i = 0, ii = features.length; i < ii; ++i)objects.push(this.writeFeatureObject(features[i], options));
        return {
            type: 'FeatureCollection',
            features: objects
        };
    }
    /**
   * Encode a geometry as a GeoJSON object.
   *
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONGeometry|GeoJSONGeometryCollection} Object.
   * @api
   * @override
   */ writeGeometryObject(geometry, options) {
        return $efdc8ee71ecdd4b6$var$writeGeometry(geometry, this.adaptOptions(options));
    }
}
/**
 * @param {GeoJSONGeometry|GeoJSONGeometryCollection} object Object.
 * @param {import("./Feature.js").ReadOptions} [options] Read options.
 * @return {import("./Feature.js").GeometryObject} Geometry.
 */ function $efdc8ee71ecdd4b6$var$readGeometryInternal(object, options) {
    if (!object) return null;
    /** @type {import("./Feature.js").GeometryObject} */ let geometry;
    switch(object['type']){
        case 'Point':
            geometry = $efdc8ee71ecdd4b6$var$readPointGeometry(/** @type {GeoJSONPoint} */ object);
            break;
        case 'LineString':
            geometry = $efdc8ee71ecdd4b6$var$readLineStringGeometry(/** @type {GeoJSONLineString} */ object);
            break;
        case 'Polygon':
            geometry = $efdc8ee71ecdd4b6$var$readPolygonGeometry(/** @type {GeoJSONPolygon} */ object);
            break;
        case 'MultiPoint':
            geometry = $efdc8ee71ecdd4b6$var$readMultiPointGeometry(/** @type {GeoJSONMultiPoint} */ object);
            break;
        case 'MultiLineString':
            geometry = $efdc8ee71ecdd4b6$var$readMultiLineStringGeometry(/** @type {GeoJSONMultiLineString} */ object);
            break;
        case 'MultiPolygon':
            geometry = $efdc8ee71ecdd4b6$var$readMultiPolygonGeometry(/** @type {GeoJSONMultiPolygon} */ object);
            break;
        case 'GeometryCollection':
            geometry = $efdc8ee71ecdd4b6$var$readGeometryCollectionGeometry(/** @type {GeoJSONGeometryCollection} */ object);
            break;
        default:
            throw new Error('Unsupported GeoJSON type: ' + object['type']);
    }
    return geometry;
}
/**
 * @param {GeoJSONGeometry|GeoJSONGeometryCollection} object Object.
 * @param {import("./Feature.js").ReadOptions} [options] Read options.
 * @return {import("../geom/Geometry.js").default} Geometry.
 */ function $efdc8ee71ecdd4b6$var$readGeometry(object, options) {
    const geometryObject = $efdc8ee71ecdd4b6$var$readGeometryInternal(object, options);
    return (0, $cbbdf771f4a27aff$export$322c9678d8c47bf)(geometryObject, options);
}
/**
 * @param {GeoJSONGeometryCollection} object Object.
 * @param {import("./Feature.js").ReadOptions} [options] Read options.
 * @return {import("./Feature.js").GeometryCollectionObject} Geometry collection.
 */ function $efdc8ee71ecdd4b6$var$readGeometryCollectionGeometry(object, options) {
    const geometries = object['geometries'].map(/**
     * @param {GeoJSONGeometry} geometry Geometry.
     * @return {import("./Feature.js").GeometryObject} geometry Geometry.
     */ function(geometry) {
        return $efdc8ee71ecdd4b6$var$readGeometryInternal(geometry, options);
    });
    return geometries;
}
/**
 * @param {GeoJSONPoint} object Input object.
 * @return {import("./Feature.js").GeometryObject} Point geometry.
 */ function $efdc8ee71ecdd4b6$var$readPointGeometry(object) {
    const flatCoordinates = object['coordinates'];
    return {
        type: 'Point',
        flatCoordinates: flatCoordinates,
        layout: (0, $7afe4d7f43fcf744$export$61bb6938093db2c8)(flatCoordinates.length)
    };
}
/**
 * @param {GeoJSONLineString} object Object.
 * @return {import("./Feature.js").GeometryObject} LineString geometry.
 */ function $efdc8ee71ecdd4b6$var$readLineStringGeometry(object) {
    const coordinates = object['coordinates'];
    const flatCoordinates = coordinates.flat();
    return {
        type: 'LineString',
        flatCoordinates: flatCoordinates,
        ends: [
            flatCoordinates.length
        ],
        layout: (0, $7afe4d7f43fcf744$export$61bb6938093db2c8)(coordinates[0]?.length || 2)
    };
}
/**
 * @param {GeoJSONMultiLineString} object Object.
 * @return {import("./Feature.js").GeometryObject} MultiLineString geometry.
 */ function $efdc8ee71ecdd4b6$var$readMultiLineStringGeometry(object) {
    const coordinates = object['coordinates'];
    const stride = coordinates[0]?.[0]?.length || 2;
    const flatCoordinates = [];
    const ends = (0, $f2e193ff6b521c26$export$47c3746a74384d45)(flatCoordinates, 0, coordinates, stride);
    return {
        type: 'MultiLineString',
        flatCoordinates: flatCoordinates,
        ends: ends,
        layout: (0, $7afe4d7f43fcf744$export$61bb6938093db2c8)(stride)
    };
}
/**
 * @param {GeoJSONMultiPoint} object Object.
 * @return {import("./Feature.js").GeometryObject} MultiPoint geometry.
 */ function $efdc8ee71ecdd4b6$var$readMultiPointGeometry(object) {
    const coordinates = object['coordinates'];
    return {
        type: 'MultiPoint',
        flatCoordinates: coordinates.flat(),
        layout: (0, $7afe4d7f43fcf744$export$61bb6938093db2c8)(coordinates[0]?.length || 2)
    };
}
/**
 * @param {GeoJSONMultiPolygon} object Object.
 * @return {import("./Feature.js").GeometryObject} MultiPolygon geometry.
 */ function $efdc8ee71ecdd4b6$var$readMultiPolygonGeometry(object) {
    const coordinates = object['coordinates'];
    const flatCoordinates = [];
    const stride = coordinates[0]?.[0]?.[0].length || 2;
    const endss = (0, $f2e193ff6b521c26$export$f9f2bb59da4accd3)(flatCoordinates, 0, coordinates, stride);
    return {
        type: 'MultiPolygon',
        flatCoordinates: flatCoordinates,
        ends: endss,
        layout: (0, $7afe4d7f43fcf744$export$61bb6938093db2c8)(stride)
    };
}
/**
 * @param {GeoJSONPolygon} object Object.
 * @return {import("./Feature.js").GeometryObject} Polygon.
 */ function $efdc8ee71ecdd4b6$var$readPolygonGeometry(object) {
    const coordinates = object['coordinates'];
    const flatCoordinates = [];
    const stride = coordinates[0]?.[0]?.length;
    const ends = (0, $f2e193ff6b521c26$export$47c3746a74384d45)(flatCoordinates, 0, coordinates, stride);
    return {
        type: 'Polygon',
        flatCoordinates: flatCoordinates,
        ends: ends,
        layout: (0, $7afe4d7f43fcf744$export$61bb6938093db2c8)(stride)
    };
}
/**
 * @param {import("../geom/Geometry.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $efdc8ee71ecdd4b6$var$writeGeometry(geometry, options) {
    geometry = (0, $cbbdf771f4a27aff$export$7beeea566b560d4)(geometry, true, options);
    const type = geometry.getType();
    /** @type {GeoJSONGeometry} */ let geoJSON;
    switch(type){
        case 'Point':
            geoJSON = $efdc8ee71ecdd4b6$var$writePointGeometry(/** @type {import("../geom/Point.js").default} */ geometry, options);
            break;
        case 'LineString':
            geoJSON = $efdc8ee71ecdd4b6$var$writeLineStringGeometry(/** @type {import("../geom/LineString.js").default} */ geometry, options);
            break;
        case 'Polygon':
            geoJSON = $efdc8ee71ecdd4b6$var$writePolygonGeometry(/** @type {import("../geom/Polygon.js").default} */ geometry, options);
            break;
        case 'MultiPoint':
            geoJSON = $efdc8ee71ecdd4b6$var$writeMultiPointGeometry(/** @type {import("../geom/MultiPoint.js").default} */ geometry, options);
            break;
        case 'MultiLineString':
            geoJSON = $efdc8ee71ecdd4b6$var$writeMultiLineStringGeometry(/** @type {import("../geom/MultiLineString.js").default} */ geometry, options);
            break;
        case 'MultiPolygon':
            geoJSON = $efdc8ee71ecdd4b6$var$writeMultiPolygonGeometry(/** @type {import("../geom/MultiPolygon.js").default} */ geometry, options);
            break;
        case 'GeometryCollection':
            geoJSON = $efdc8ee71ecdd4b6$var$writeGeometryCollectionGeometry(/** @type {import("../geom/GeometryCollection.js").default} */ geometry, options);
            break;
        case 'Circle':
            geoJSON = {
                type: 'GeometryCollection',
                geometries: []
            };
            break;
        default:
            throw new Error('Unsupported geometry type: ' + type);
    }
    return geoJSON;
}
/**
 * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometryCollection} GeoJSON geometry collection.
 */ function $efdc8ee71ecdd4b6$var$writeGeometryCollectionGeometry(geometry, options) {
    options = Object.assign({}, options);
    delete options.featureProjection;
    const geometries = geometry.getGeometriesArray().map(function(geometry) {
        return $efdc8ee71ecdd4b6$var$writeGeometry(geometry, options);
    });
    return {
        type: 'GeometryCollection',
        geometries: geometries
    };
}
/**
 * @param {import("../geom/LineString.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $efdc8ee71ecdd4b6$var$writeLineStringGeometry(geometry, options) {
    return {
        type: 'LineString',
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/MultiLineString.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $efdc8ee71ecdd4b6$var$writeMultiLineStringGeometry(geometry, options) {
    return {
        type: 'MultiLineString',
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/MultiPoint.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $efdc8ee71ecdd4b6$var$writeMultiPointGeometry(geometry, options) {
    return {
        type: 'MultiPoint',
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $efdc8ee71ecdd4b6$var$writeMultiPolygonGeometry(geometry, options) {
    let right;
    if (options) right = options.rightHanded;
    return {
        type: 'MultiPolygon',
        coordinates: geometry.getCoordinates(right)
    };
}
/**
 * @param {import("../geom/Point.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $efdc8ee71ecdd4b6$var$writePointGeometry(geometry, options) {
    return {
        type: 'Point',
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/Polygon.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $efdc8ee71ecdd4b6$var$writePolygonGeometry(geometry, options) {
    let right;
    if (options) right = options.rightHanded;
    return {
        type: 'Polygon',
        coordinates: geometry.getCoordinates(right)
    };
}
var $efdc8ee71ecdd4b6$export$2e2bcd8739ae039 = $efdc8ee71ecdd4b6$var$GeoJSON;


/**
 * @module ol/format/MVT
 */ //FIXME Implement projection handling
const $92c9b313d53dc597$var$SHIFT_LEFT_32 = 4294967296;
const $92c9b313d53dc597$var$SHIFT_RIGHT_32 = 1 / $92c9b313d53dc597$var$SHIFT_LEFT_32;
// Threshold chosen based on both benchmarking and knowledge about browser string
// data structures (which currently switch structure types at 12 bytes or more)
const $92c9b313d53dc597$var$TEXT_DECODER_MIN_LENGTH = 12;
const $92c9b313d53dc597$var$utf8TextDecoder = typeof TextDecoder === 'undefined' ? null : new TextDecoder('utf-8');
const $92c9b313d53dc597$var$PBF_VARINT = 0; // varint: int32, int64, uint32, uint64, sint32, sint64, bool, enum
const $92c9b313d53dc597$var$PBF_FIXED64 = 1; // 64-bit: double, fixed64, sfixed64
const $92c9b313d53dc597$var$PBF_BYTES = 2; // length-delimited: string, bytes, embedded messages, packed repeated fields
const $92c9b313d53dc597$var$PBF_FIXED32 = 5; // 32-bit: float, fixed32, sfixed32
class $92c9b313d53dc597$export$2e2bcd8739ae039 {
    /**
     * @param {Uint8Array | ArrayBuffer} [buf]
     */ constructor(buf = new Uint8Array(16)){
        this.buf = ArrayBuffer.isView(buf) ? buf : new Uint8Array(buf);
        this.dataView = new DataView(this.buf.buffer);
        this.pos = 0;
        this.type = 0;
        this.length = this.buf.length;
    }
    // === READING =================================================================
    /**
     * @template T
     * @param {(tag: number, result: T, pbf: Pbf) => void} readField
     * @param {T} result
     * @param {number} [end]
     */ readFields(readField, result, end = this.length) {
        while(this.pos < end){
            const val = this.readVarint(), tag = val >> 3, startPos = this.pos;
            this.type = val & 0x7;
            readField(tag, result, this);
            if (this.pos === startPos) this.skip(val);
        }
        return result;
    }
    /**
     * @template T
     * @param {(tag: number, result: T, pbf: Pbf) => void} readField
     * @param {T} result
     */ readMessage(readField, result) {
        return this.readFields(readField, result, this.readVarint() + this.pos);
    }
    readFixed32() {
        const val = this.dataView.getUint32(this.pos, true);
        this.pos += 4;
        return val;
    }
    readSFixed32() {
        const val = this.dataView.getInt32(this.pos, true);
        this.pos += 4;
        return val;
    }
    // 64-bit int handling is based on github.com/dpw/node-buffer-more-ints (MIT-licensed)
    readFixed64() {
        const val = this.dataView.getUint32(this.pos, true) + this.dataView.getUint32(this.pos + 4, true) * $92c9b313d53dc597$var$SHIFT_LEFT_32;
        this.pos += 8;
        return val;
    }
    readSFixed64() {
        const val = this.dataView.getUint32(this.pos, true) + this.dataView.getInt32(this.pos + 4, true) * $92c9b313d53dc597$var$SHIFT_LEFT_32;
        this.pos += 8;
        return val;
    }
    readFloat() {
        const val = this.dataView.getFloat32(this.pos, true);
        this.pos += 4;
        return val;
    }
    readDouble() {
        const val = this.dataView.getFloat64(this.pos, true);
        this.pos += 8;
        return val;
    }
    /**
     * @param {boolean} [isSigned]
     */ readVarint(isSigned) {
        const buf = this.buf;
        let val, b;
        b = buf[this.pos++];
        val = b & 0x7f;
        if (b < 0x80) return val;
        b = buf[this.pos++];
        val |= (b & 0x7f) << 7;
        if (b < 0x80) return val;
        b = buf[this.pos++];
        val |= (b & 0x7f) << 14;
        if (b < 0x80) return val;
        b = buf[this.pos++];
        val |= (b & 0x7f) << 21;
        if (b < 0x80) return val;
        b = buf[this.pos];
        val |= (b & 0x0f) << 28;
        return $92c9b313d53dc597$var$readVarintRemainder(val, isSigned, this);
    }
    readVarint64() {
        return this.readVarint(true);
    }
    readSVarint() {
        const num = this.readVarint();
        return num % 2 === 1 ? (num + 1) / -2 : num / 2; // zigzag encoding
    }
    readBoolean() {
        return Boolean(this.readVarint());
    }
    readString() {
        const end = this.readVarint() + this.pos;
        const pos = this.pos;
        this.pos = end;
        if (end - pos >= $92c9b313d53dc597$var$TEXT_DECODER_MIN_LENGTH && $92c9b313d53dc597$var$utf8TextDecoder) // longer strings are fast with the built-in browser TextDecoder API
        return $92c9b313d53dc597$var$utf8TextDecoder.decode(this.buf.subarray(pos, end));
        // short strings are fast with our custom implementation
        return $92c9b313d53dc597$var$readUtf8(this.buf, pos, end);
    }
    readBytes() {
        const end = this.readVarint() + this.pos, buffer = this.buf.subarray(this.pos, end);
        this.pos = end;
        return buffer;
    }
    // verbose for performance reasons; doesn't affect gzipped size
    /**
     * @param {number[]} [arr]
     * @param {boolean} [isSigned]
     */ readPackedVarint(arr = [], isSigned) {
        const end = this.readPackedEnd();
        while(this.pos < end)arr.push(this.readVarint(isSigned));
        return arr;
    }
    /** @param {number[]} [arr] */ readPackedSVarint(arr = []) {
        const end = this.readPackedEnd();
        while(this.pos < end)arr.push(this.readSVarint());
        return arr;
    }
    /** @param {boolean[]} [arr] */ readPackedBoolean(arr = []) {
        const end = this.readPackedEnd();
        while(this.pos < end)arr.push(this.readBoolean());
        return arr;
    }
    /** @param {number[]} [arr] */ readPackedFloat(arr = []) {
        const end = this.readPackedEnd();
        while(this.pos < end)arr.push(this.readFloat());
        return arr;
    }
    /** @param {number[]} [arr] */ readPackedDouble(arr = []) {
        const end = this.readPackedEnd();
        while(this.pos < end)arr.push(this.readDouble());
        return arr;
    }
    /** @param {number[]} [arr] */ readPackedFixed32(arr = []) {
        const end = this.readPackedEnd();
        while(this.pos < end)arr.push(this.readFixed32());
        return arr;
    }
    /** @param {number[]} [arr] */ readPackedSFixed32(arr = []) {
        const end = this.readPackedEnd();
        while(this.pos < end)arr.push(this.readSFixed32());
        return arr;
    }
    /** @param {number[]} [arr] */ readPackedFixed64(arr = []) {
        const end = this.readPackedEnd();
        while(this.pos < end)arr.push(this.readFixed64());
        return arr;
    }
    /** @param {number[]} [arr] */ readPackedSFixed64(arr = []) {
        const end = this.readPackedEnd();
        while(this.pos < end)arr.push(this.readSFixed64());
        return arr;
    }
    readPackedEnd() {
        return this.type === $92c9b313d53dc597$var$PBF_BYTES ? this.readVarint() + this.pos : this.pos + 1;
    }
    /** @param {number} val */ skip(val) {
        const type = val & 0x7;
        if (type === $92c9b313d53dc597$var$PBF_VARINT) while(this.buf[this.pos++] > 0x7f);
        else if (type === $92c9b313d53dc597$var$PBF_BYTES) this.pos = this.readVarint() + this.pos;
        else if (type === $92c9b313d53dc597$var$PBF_FIXED32) this.pos += 4;
        else if (type === $92c9b313d53dc597$var$PBF_FIXED64) this.pos += 8;
        else throw new Error(`Unimplemented type: ${type}`);
    }
    // === WRITING =================================================================
    /**
     * @param {number} tag
     * @param {number} type
     */ writeTag(tag, type) {
        this.writeVarint(tag << 3 | type);
    }
    /** @param {number} min */ realloc(min) {
        let length = this.length || 16;
        while(length < this.pos + min)length *= 2;
        if (length !== this.length) {
            const buf = new Uint8Array(length);
            buf.set(this.buf);
            this.buf = buf;
            this.dataView = new DataView(buf.buffer);
            this.length = length;
        }
    }
    finish() {
        this.length = this.pos;
        this.pos = 0;
        return this.buf.subarray(0, this.length);
    }
    /** @param {number} val */ writeFixed32(val) {
        this.realloc(4);
        this.dataView.setInt32(this.pos, val, true);
        this.pos += 4;
    }
    /** @param {number} val */ writeSFixed32(val) {
        this.realloc(4);
        this.dataView.setInt32(this.pos, val, true);
        this.pos += 4;
    }
    /** @param {number} val */ writeFixed64(val) {
        this.realloc(8);
        this.dataView.setInt32(this.pos, val & -1, true);
        this.dataView.setInt32(this.pos + 4, Math.floor(val * $92c9b313d53dc597$var$SHIFT_RIGHT_32), true);
        this.pos += 8;
    }
    /** @param {number} val */ writeSFixed64(val) {
        this.realloc(8);
        this.dataView.setInt32(this.pos, val & -1, true);
        this.dataView.setInt32(this.pos + 4, Math.floor(val * $92c9b313d53dc597$var$SHIFT_RIGHT_32), true);
        this.pos += 8;
    }
    /** @param {number} val */ writeVarint(val) {
        val = +val || 0;
        if (val > 0xfffffff || val < 0) {
            $92c9b313d53dc597$var$writeBigVarint(val, this);
            return;
        }
        this.realloc(4);
        this.buf[this.pos++] = val & 0x7f | (val > 0x7f ? 0x80 : 0);
        if (val <= 0x7f) return;
        this.buf[this.pos++] = (val >>>= 7) & 0x7f | (val > 0x7f ? 0x80 : 0);
        if (val <= 0x7f) return;
        this.buf[this.pos++] = (val >>>= 7) & 0x7f | (val > 0x7f ? 0x80 : 0);
        if (val <= 0x7f) return;
        this.buf[this.pos++] = val >>> 7 & 0x7f;
    }
    /** @param {number} val */ writeSVarint(val) {
        this.writeVarint(val < 0 ? -val * 2 - 1 : val * 2);
    }
    /** @param {boolean} val */ writeBoolean(val) {
        this.writeVarint(+val);
    }
    /** @param {string} str */ writeString(str) {
        str = String(str);
        this.realloc(str.length * 4);
        this.pos++; // reserve 1 byte for short string length
        const startPos = this.pos;
        // write the string directly to the buffer and see how much was written
        this.pos = $92c9b313d53dc597$var$writeUtf8(this.buf, str, this.pos);
        const len = this.pos - startPos;
        if (len >= 0x80) $92c9b313d53dc597$var$makeRoomForExtraLength(startPos, len, this);
        // finally, write the message length in the reserved place and restore the position
        this.pos = startPos - 1;
        this.writeVarint(len);
        this.pos += len;
    }
    /** @param {number} val */ writeFloat(val) {
        this.realloc(4);
        this.dataView.setFloat32(this.pos, val, true);
        this.pos += 4;
    }
    /** @param {number} val */ writeDouble(val) {
        this.realloc(8);
        this.dataView.setFloat64(this.pos, val, true);
        this.pos += 8;
    }
    /** @param {Uint8Array} buffer */ writeBytes(buffer) {
        const len = buffer.length;
        this.writeVarint(len);
        this.realloc(len);
        for(let i = 0; i < len; i++)this.buf[this.pos++] = buffer[i];
    }
    /**
     * @template T
     * @param {(obj: T, pbf: Pbf) => void} fn
     * @param {T} obj
     */ writeRawMessage(fn, obj) {
        this.pos++; // reserve 1 byte for short message length
        // write the message directly to the buffer and see how much was written
        const startPos = this.pos;
        fn(obj, this);
        const len = this.pos - startPos;
        if (len >= 0x80) $92c9b313d53dc597$var$makeRoomForExtraLength(startPos, len, this);
        // finally, write the message length in the reserved place and restore the position
        this.pos = startPos - 1;
        this.writeVarint(len);
        this.pos += len;
    }
    /**
     * @template T
     * @param {number} tag
     * @param {(obj: T, pbf: Pbf) => void} fn
     * @param {T} obj
     */ writeMessage(tag, fn, obj) {
        this.writeTag(tag, $92c9b313d53dc597$var$PBF_BYTES);
        this.writeRawMessage(fn, obj);
    }
    /**
     * @param {number} tag
     * @param {number[]} arr
     */ writePackedVarint(tag, arr) {
        if (arr.length) this.writeMessage(tag, $92c9b313d53dc597$var$writePackedVarint, arr);
    }
    /**
     * @param {number} tag
     * @param {number[]} arr
     */ writePackedSVarint(tag, arr) {
        if (arr.length) this.writeMessage(tag, $92c9b313d53dc597$var$writePackedSVarint, arr);
    }
    /**
     * @param {number} tag
     * @param {boolean[]} arr
     */ writePackedBoolean(tag, arr) {
        if (arr.length) this.writeMessage(tag, $92c9b313d53dc597$var$writePackedBoolean, arr);
    }
    /**
     * @param {number} tag
     * @param {number[]} arr
     */ writePackedFloat(tag, arr) {
        if (arr.length) this.writeMessage(tag, $92c9b313d53dc597$var$writePackedFloat, arr);
    }
    /**
     * @param {number} tag
     * @param {number[]} arr
     */ writePackedDouble(tag, arr) {
        if (arr.length) this.writeMessage(tag, $92c9b313d53dc597$var$writePackedDouble, arr);
    }
    /**
     * @param {number} tag
     * @param {number[]} arr
     */ writePackedFixed32(tag, arr) {
        if (arr.length) this.writeMessage(tag, $92c9b313d53dc597$var$writePackedFixed32, arr);
    }
    /**
     * @param {number} tag
     * @param {number[]} arr
     */ writePackedSFixed32(tag, arr) {
        if (arr.length) this.writeMessage(tag, $92c9b313d53dc597$var$writePackedSFixed32, arr);
    }
    /**
     * @param {number} tag
     * @param {number[]} arr
     */ writePackedFixed64(tag, arr) {
        if (arr.length) this.writeMessage(tag, $92c9b313d53dc597$var$writePackedFixed64, arr);
    }
    /**
     * @param {number} tag
     * @param {number[]} arr
     */ writePackedSFixed64(tag, arr) {
        if (arr.length) this.writeMessage(tag, $92c9b313d53dc597$var$writePackedSFixed64, arr);
    }
    /**
     * @param {number} tag
     * @param {Uint8Array} buffer
     */ writeBytesField(tag, buffer) {
        this.writeTag(tag, $92c9b313d53dc597$var$PBF_BYTES);
        this.writeBytes(buffer);
    }
    /**
     * @param {number} tag
     * @param {number} val
     */ writeFixed32Field(tag, val) {
        this.writeTag(tag, $92c9b313d53dc597$var$PBF_FIXED32);
        this.writeFixed32(val);
    }
    /**
     * @param {number} tag
     * @param {number} val
     */ writeSFixed32Field(tag, val) {
        this.writeTag(tag, $92c9b313d53dc597$var$PBF_FIXED32);
        this.writeSFixed32(val);
    }
    /**
     * @param {number} tag
     * @param {number} val
     */ writeFixed64Field(tag, val) {
        this.writeTag(tag, $92c9b313d53dc597$var$PBF_FIXED64);
        this.writeFixed64(val);
    }
    /**
     * @param {number} tag
     * @param {number} val
     */ writeSFixed64Field(tag, val) {
        this.writeTag(tag, $92c9b313d53dc597$var$PBF_FIXED64);
        this.writeSFixed64(val);
    }
    /**
     * @param {number} tag
     * @param {number} val
     */ writeVarintField(tag, val) {
        this.writeTag(tag, $92c9b313d53dc597$var$PBF_VARINT);
        this.writeVarint(val);
    }
    /**
     * @param {number} tag
     * @param {number} val
     */ writeSVarintField(tag, val) {
        this.writeTag(tag, $92c9b313d53dc597$var$PBF_VARINT);
        this.writeSVarint(val);
    }
    /**
     * @param {number} tag
     * @param {string} str
     */ writeStringField(tag, str) {
        this.writeTag(tag, $92c9b313d53dc597$var$PBF_BYTES);
        this.writeString(str);
    }
    /**
     * @param {number} tag
     * @param {number} val
     */ writeFloatField(tag, val) {
        this.writeTag(tag, $92c9b313d53dc597$var$PBF_FIXED32);
        this.writeFloat(val);
    }
    /**
     * @param {number} tag
     * @param {number} val
     */ writeDoubleField(tag, val) {
        this.writeTag(tag, $92c9b313d53dc597$var$PBF_FIXED64);
        this.writeDouble(val);
    }
    /**
     * @param {number} tag
     * @param {boolean} val
     */ writeBooleanField(tag, val) {
        this.writeVarintField(tag, +val);
    }
}
/**
 * @param {number} l
 * @param {boolean | undefined} s
 * @param {Pbf} p
 */ function $92c9b313d53dc597$var$readVarintRemainder(l, s, p) {
    const buf = p.buf;
    let h, b;
    b = buf[p.pos++];
    h = (b & 0x70) >> 4;
    if (b < 0x80) return $92c9b313d53dc597$var$toNum(l, h, s);
    b = buf[p.pos++];
    h |= (b & 0x7f) << 3;
    if (b < 0x80) return $92c9b313d53dc597$var$toNum(l, h, s);
    b = buf[p.pos++];
    h |= (b & 0x7f) << 10;
    if (b < 0x80) return $92c9b313d53dc597$var$toNum(l, h, s);
    b = buf[p.pos++];
    h |= (b & 0x7f) << 17;
    if (b < 0x80) return $92c9b313d53dc597$var$toNum(l, h, s);
    b = buf[p.pos++];
    h |= (b & 0x7f) << 24;
    if (b < 0x80) return $92c9b313d53dc597$var$toNum(l, h, s);
    b = buf[p.pos++];
    h |= (b & 0x01) << 31;
    if (b < 0x80) return $92c9b313d53dc597$var$toNum(l, h, s);
    throw new Error('Expected varint not more than 10 bytes');
}
/**
 * @param {number} low
 * @param {number} high
 * @param {boolean} [isSigned]
 */ function $92c9b313d53dc597$var$toNum(low, high, isSigned) {
    return isSigned ? high * 0x100000000 + (low >>> 0) : (high >>> 0) * 0x100000000 + (low >>> 0);
}
/**
 * @param {number} val
 * @param {Pbf} pbf
 */ function $92c9b313d53dc597$var$writeBigVarint(val, pbf) {
    let low, high;
    if (val >= 0) {
        low = val % 0x100000000 | 0;
        high = val / 0x100000000 | 0;
    } else {
        low = ~(-val % 0x100000000);
        high = ~(-val / 0x100000000);
        if (low ^ 0xffffffff) low = low + 1 | 0;
        else {
            low = 0;
            high = high + 1 | 0;
        }
    }
    if (val >= 0x10000000000000000 || val < -18446744073709552000) throw new Error('Given varint doesn\'t fit into 10 bytes');
    pbf.realloc(10);
    $92c9b313d53dc597$var$writeBigVarintLow(low, high, pbf);
    $92c9b313d53dc597$var$writeBigVarintHigh(high, pbf);
}
/**
 * @param {number} high
 * @param {number} low
 * @param {Pbf} pbf
 */ function $92c9b313d53dc597$var$writeBigVarintLow(low, high, pbf) {
    pbf.buf[pbf.pos++] = low & 0x7f | 0x80;
    low >>>= 7;
    pbf.buf[pbf.pos++] = low & 0x7f | 0x80;
    low >>>= 7;
    pbf.buf[pbf.pos++] = low & 0x7f | 0x80;
    low >>>= 7;
    pbf.buf[pbf.pos++] = low & 0x7f | 0x80;
    low >>>= 7;
    pbf.buf[pbf.pos] = low & 0x7f;
}
/**
 * @param {number} high
 * @param {Pbf} pbf
 */ function $92c9b313d53dc597$var$writeBigVarintHigh(high, pbf) {
    const lsb = (high & 0x07) << 4;
    pbf.buf[pbf.pos++] |= lsb | ((high >>>= 3) ? 0x80 : 0);
    if (!high) return;
    pbf.buf[pbf.pos++] = high & 0x7f | ((high >>>= 7) ? 0x80 : 0);
    if (!high) return;
    pbf.buf[pbf.pos++] = high & 0x7f | ((high >>>= 7) ? 0x80 : 0);
    if (!high) return;
    pbf.buf[pbf.pos++] = high & 0x7f | ((high >>>= 7) ? 0x80 : 0);
    if (!high) return;
    pbf.buf[pbf.pos++] = high & 0x7f | ((high >>>= 7) ? 0x80 : 0);
    if (!high) return;
    pbf.buf[pbf.pos++] = high & 0x7f;
}
/**
 * @param {number} startPos
 * @param {number} len
 * @param {Pbf} pbf
 */ function $92c9b313d53dc597$var$makeRoomForExtraLength(startPos, len, pbf) {
    const extraLen = len <= 0x3fff ? 1 : len <= 0x1fffff ? 2 : len <= 0xfffffff ? 3 : Math.floor(Math.log(len) / (Math.LN2 * 7));
    // if 1 byte isn't enough for encoding message length, shift the data to the right
    pbf.realloc(extraLen);
    for(let i = pbf.pos - 1; i >= startPos; i--)pbf.buf[i + extraLen] = pbf.buf[i];
}
/**
 * @param {number[]} arr
 * @param {Pbf} pbf
 */ function $92c9b313d53dc597$var$writePackedVarint(arr, pbf) {
    for(let i = 0; i < arr.length; i++)pbf.writeVarint(arr[i]);
}
/**
 * @param {number[]} arr
 * @param {Pbf} pbf
 */ function $92c9b313d53dc597$var$writePackedSVarint(arr, pbf) {
    for(let i = 0; i < arr.length; i++)pbf.writeSVarint(arr[i]);
}
/**
 * @param {number[]} arr
 * @param {Pbf} pbf
 */ function $92c9b313d53dc597$var$writePackedFloat(arr, pbf) {
    for(let i = 0; i < arr.length; i++)pbf.writeFloat(arr[i]);
}
/**
 * @param {number[]} arr
 * @param {Pbf} pbf
 */ function $92c9b313d53dc597$var$writePackedDouble(arr, pbf) {
    for(let i = 0; i < arr.length; i++)pbf.writeDouble(arr[i]);
}
/**
 * @param {boolean[]} arr
 * @param {Pbf} pbf
 */ function $92c9b313d53dc597$var$writePackedBoolean(arr, pbf) {
    for(let i = 0; i < arr.length; i++)pbf.writeBoolean(arr[i]);
}
/**
 * @param {number[]} arr
 * @param {Pbf} pbf
 */ function $92c9b313d53dc597$var$writePackedFixed32(arr, pbf) {
    for(let i = 0; i < arr.length; i++)pbf.writeFixed32(arr[i]);
}
/**
 * @param {number[]} arr
 * @param {Pbf} pbf
 */ function $92c9b313d53dc597$var$writePackedSFixed32(arr, pbf) {
    for(let i = 0; i < arr.length; i++)pbf.writeSFixed32(arr[i]);
}
/**
 * @param {number[]} arr
 * @param {Pbf} pbf
 */ function $92c9b313d53dc597$var$writePackedFixed64(arr, pbf) {
    for(let i = 0; i < arr.length; i++)pbf.writeFixed64(arr[i]);
}
/**
 * @param {number[]} arr
 * @param {Pbf} pbf
 */ function $92c9b313d53dc597$var$writePackedSFixed64(arr, pbf) {
    for(let i = 0; i < arr.length; i++)pbf.writeSFixed64(arr[i]);
}
// Buffer code below from https://github.com/feross/buffer, MIT-licensed
/**
 * @param {Uint8Array} buf
 * @param {number} pos
 * @param {number} end
 */ function $92c9b313d53dc597$var$readUtf8(buf, pos, end) {
    let str = '';
    let i = pos;
    while(i < end){
        const b0 = buf[i];
        let c = null; // codepoint
        let bytesPerSequence = b0 > 0xEF ? 4 : b0 > 0xDF ? 3 : b0 > 0xBF ? 2 : 1;
        if (i + bytesPerSequence > end) break;
        let b1, b2, b3;
        if (bytesPerSequence === 1) {
            if (b0 < 0x80) c = b0;
        } else if (bytesPerSequence === 2) {
            b1 = buf[i + 1];
            if ((b1 & 0xC0) === 0x80) {
                c = (b0 & 0x1F) << 0x6 | b1 & 0x3F;
                if (c <= 0x7F) c = null;
            }
        } else if (bytesPerSequence === 3) {
            b1 = buf[i + 1];
            b2 = buf[i + 2];
            if ((b1 & 0xC0) === 0x80 && (b2 & 0xC0) === 0x80) {
                c = (b0 & 0xF) << 0xC | (b1 & 0x3F) << 0x6 | b2 & 0x3F;
                if (c <= 0x7FF || c >= 0xD800 && c <= 0xDFFF) c = null;
            }
        } else if (bytesPerSequence === 4) {
            b1 = buf[i + 1];
            b2 = buf[i + 2];
            b3 = buf[i + 3];
            if ((b1 & 0xC0) === 0x80 && (b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                c = (b0 & 0xF) << 0x12 | (b1 & 0x3F) << 0xC | (b2 & 0x3F) << 0x6 | b3 & 0x3F;
                if (c <= 0xFFFF || c >= 0x110000) c = null;
            }
        }
        if (c === null) {
            c = 0xFFFD;
            bytesPerSequence = 1;
        } else if (c > 0xFFFF) {
            c -= 0x10000;
            str += String.fromCharCode(c >>> 10 & 0x3FF | 0xD800);
            c = 0xDC00 | c & 0x3FF;
        }
        str += String.fromCharCode(c);
        i += bytesPerSequence;
    }
    return str;
}
/**
 * @param {Uint8Array} buf
 * @param {string} str
 * @param {number} pos
 */ function $92c9b313d53dc597$var$writeUtf8(buf, str, pos) {
    for(let i = 0, c, lead; i < str.length; i++){
        c = str.charCodeAt(i); // code point
        if (c > 0xD7FF && c < 0xE000) {
            if (lead) {
                if (c < 0xDC00) {
                    buf[pos++] = 0xEF;
                    buf[pos++] = 0xBF;
                    buf[pos++] = 0xBD;
                    lead = c;
                    continue;
                } else {
                    c = lead - 0xD800 << 10 | c - 0xDC00 | 0x10000;
                    lead = null;
                }
            } else {
                if (c > 0xDBFF || i + 1 === str.length) {
                    buf[pos++] = 0xEF;
                    buf[pos++] = 0xBF;
                    buf[pos++] = 0xBD;
                } else lead = c;
                continue;
            }
        } else if (lead) {
            buf[pos++] = 0xEF;
            buf[pos++] = 0xBF;
            buf[pos++] = 0xBD;
            lead = null;
        }
        if (c < 0x80) buf[pos++] = c;
        else {
            if (c < 0x800) buf[pos++] = c >> 0x6 | 0xC0;
            else {
                if (c < 0x10000) buf[pos++] = c >> 0xC | 0xE0;
                else {
                    buf[pos++] = c >> 0x12 | 0xF0;
                    buf[pos++] = c >> 0xC & 0x3F | 0x80;
                }
                buf[pos++] = c >> 0x6 & 0x3F | 0x80;
            }
            buf[pos++] = c & 0x3F | 0x80;
        }
    }
    return pos;
}













/**
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../render/Feature.js").default]
 * @typedef {Object} Options
 * @property {import('./Feature.js').FeatureToFeatureClass<FeatureType>} [featureClass] Class for features returned by
 * {@link module:ol/format/MVT~MVT#readFeatures}. Set to {@link module:ol/Feature~Feature} to get full editing and geometry
 * support at the cost of decreased rendering performance. The default is
 * {@link module:ol/render/Feature~RenderFeature}, which is optimized for rendering and hit detection.
 * @property {string} [geometryName='geometry'] Geometry name to use when creating features.
 * @property {string} [layerName='layer'] Name of the feature attribute that holds the layer name.
 * @property {Array<string>} [layers] Layers to read features from. If not provided, features will be read from all
 * @property {string} [idProperty] Optional property that will be assigned as the feature id and removed from the properties.
 * layers.
 */ /**
 * @classdesc
 * Feature format for reading data in the Mapbox MVT format.
 *
 * @template {import('../Feature.js').FeatureLike} [FeatureType=RenderFeature]
 * @extends {FeatureFormat<FeatureType>}
 * @api
 */ class $76637151dba7e2e2$var$MVT extends (0, $cbbdf771f4a27aff$export$2e2bcd8739ae039) {
    /**
   * @param {Options<FeatureType>} [options] Options.
   */ constructor(options){
        super();
        options = options ? options : {};
        /**
     * @type {Projection}
     */ this.dataProjection = new (0, $148e47e1fc09dc0c$export$2e2bcd8739ae039)({
            code: '',
            units: 'tile-pixels'
        });
        this.featureClass = options.featureClass ? options.featureClass : /** @type {import('./Feature.js').FeatureToFeatureClass<FeatureType>} */ (0, $edf3df43d76225f4$export$2e2bcd8739ae039);
        /**
     * @private
     * @type {string|undefined}
     */ this.geometryName_ = options.geometryName;
        /**
     * @private
     * @type {string}
     */ this.layerName_ = options.layerName ? options.layerName : 'layer';
        /**
     * @private
     * @type {Array<string>|null}
     */ this.layers_ = options.layers ? options.layers : null;
        /**
     * @private
     * @type {string}
     */ this.idProperty_ = options.idProperty;
        this.supportedMediaTypes = [
            'application/vnd.mapbox-vector-tile',
            'application/x-protobuf'
        ];
    }
    /**
   * Read the raw geometry from the pbf offset stored in a raw feature's geometry
   * property.
   * @param {PBF} pbf PBF.
   * @param {Object} feature Raw feature.
   * @param {Array<number>} flatCoordinates Array to store flat coordinates in.
   * @param {Array<number>} ends Array to store ends in.
   * @private
   */ readRawGeometry_(pbf, feature, flatCoordinates, ends) {
        pbf.pos = feature.geometry;
        const end = pbf.readVarint() + pbf.pos;
        let cmd = 1;
        let length = 0;
        let x = 0;
        let y = 0;
        let coordsLen = 0;
        let currentEnd = 0;
        while(pbf.pos < end){
            if (!length) {
                const cmdLen = pbf.readVarint();
                cmd = cmdLen & 0x7;
                length = cmdLen >> 3;
            }
            length--;
            if (cmd === 1 || cmd === 2) {
                x += pbf.readSVarint();
                y += pbf.readSVarint();
                if (cmd === 1) // moveTo
                {
                    if (coordsLen > currentEnd) {
                        ends.push(coordsLen);
                        currentEnd = coordsLen;
                    }
                }
                flatCoordinates.push(x, y);
                coordsLen += 2;
            } else if (cmd === 7) {
                if (coordsLen > currentEnd) {
                    // close polygon
                    flatCoordinates.push(flatCoordinates[currentEnd], flatCoordinates[currentEnd + 1]);
                    coordsLen += 2;
                }
            } else throw new Error('Invalid command found in the PBF');
        }
        if (coordsLen > currentEnd) {
            ends.push(coordsLen);
            currentEnd = coordsLen;
        }
    }
    /**
   * @private
   * @param {PBF} pbf PBF
   * @param {Object} rawFeature Raw Mapbox feature.
   * @param {import("./Feature.js").ReadOptions} options Read options.
   * @return {FeatureType|null} Feature.
   */ createFeature_(pbf, rawFeature, options) {
        const type = rawFeature.type;
        if (type === 0) return null;
        let feature;
        const values = rawFeature.properties;
        let id;
        if (!this.idProperty_) id = rawFeature.id;
        else {
            id = values[this.idProperty_];
            delete values[this.idProperty_];
        }
        values[this.layerName_] = rawFeature.layer.name;
        const flatCoordinates = /** @type {Array<number>} */ [];
        const ends = /** @type {Array<number>} */ [];
        this.readRawGeometry_(pbf, rawFeature, flatCoordinates, ends);
        const geometryType = $76637151dba7e2e2$var$getGeometryType(type, ends.length);
        if (this.featureClass === (0, $edf3df43d76225f4$export$2e2bcd8739ae039)) {
            feature = new /** @type {import('./Feature.js').FeatureToFeatureClass<RenderFeature>} */ this.featureClass(geometryType, flatCoordinates, ends, 2, values, id);
            feature.transform(options.dataProjection);
        } else {
            let geom;
            if (geometryType == 'Polygon') {
                const endss = (0, $e3206434e8933f4a$export$cb72ae403d6e78e6)(flatCoordinates, ends);
                geom = endss.length > 1 ? new (0, $243f44e394b1fc3e$export$2e2bcd8739ae039)(flatCoordinates, 'XY', endss) : new (0, $5a6d32626ac6e0b9$export$2e2bcd8739ae039)(flatCoordinates, 'XY', ends);
            } else geom = geometryType === 'Point' ? new (0, $777d8f3503c8fbb0$export$2e2bcd8739ae039)(flatCoordinates, 'XY') : geometryType === 'LineString' ? new (0, $f39509739d6a215a$export$2e2bcd8739ae039)(flatCoordinates, 'XY') : geometryType === 'MultiPoint' ? new (0, $58a702d20b3ac5c1$export$2e2bcd8739ae039)(flatCoordinates, 'XY') : geometryType === 'MultiLineString' ? new (0, $e87e615191dda5ba$export$2e2bcd8739ae039)(flatCoordinates, 'XY', ends) : null;
            const ctor = /** @type {typeof import("../Feature.js").default} */ this.featureClass;
            feature = new ctor();
            if (this.geometryName_) feature.setGeometryName(this.geometryName_);
            const geometry = (0, $cbbdf771f4a27aff$export$7beeea566b560d4)(geom, false, options);
            feature.setGeometry(geometry);
            if (id !== undefined) feature.setId(id);
            feature.setProperties(values, true);
        }
        return /** @type {FeatureType} */ feature;
    }
    /**
   * @return {import("./Feature.js").Type} Format.
   * @override
   */ getType() {
        return 'arraybuffer';
    }
    /**
   * Read all features.
   *
   * @param {ArrayBuffer} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {Array<FeatureType>} Features.
   * @api
   * @override
   */ readFeatures(source, options) {
        const layers = this.layers_;
        options = this.adaptOptions(options);
        const dataProjection = (0, $2a998b085c5a7ac9$export$3988ae62b71be9a3)(options.dataProjection);
        dataProjection.setWorldExtent(options.extent);
        options.dataProjection = dataProjection;
        const pbf = new (0, $92c9b313d53dc597$export$2e2bcd8739ae039)(/** @type {ArrayBuffer} */ source);
        const pbfLayers = pbf.readFields($76637151dba7e2e2$var$layersPBFReader, {});
        const features = [];
        for(const name in pbfLayers){
            if (layers && !layers.includes(name)) continue;
            const pbfLayer = pbfLayers[name];
            const extent = pbfLayer ? [
                0,
                0,
                pbfLayer.extent,
                pbfLayer.extent
            ] : null;
            dataProjection.setExtent(extent);
            for(let i = 0, ii = pbfLayer.length; i < ii; ++i){
                const rawFeature = $76637151dba7e2e2$var$readRawFeature(pbf, pbfLayer, i);
                const feature = this.createFeature_(pbf, rawFeature, options);
                if (feature !== null) features.push(feature);
            }
        }
        return /** @type {Array<FeatureType>} */ features;
    }
    /**
   * Read the projection from the source.
   *
   * @param {Document|Element|Object|string} source Source.
   * @return {import("../proj/Projection.js").default} Projection.
   * @api
   * @override
   */ readProjection(source) {
        return this.dataProjection;
    }
    /**
   * Sets the layers that features will be read from.
   * @param {Array<string>} layers Layers.
   * @api
   */ setLayers(layers) {
        this.layers_ = layers;
    }
}
/**
 * Reader callback for parsing layers.
 * @param {number} tag The tag.
 * @param {Object} layers The layers object.
 * @param {PBF} pbf The PBF.
 */ function $76637151dba7e2e2$var$layersPBFReader(tag, layers, pbf) {
    if (tag === 3) {
        const layer = {
            keys: [],
            values: [],
            features: []
        };
        const end = pbf.readVarint() + pbf.pos;
        pbf.readFields($76637151dba7e2e2$var$layerPBFReader, layer, end);
        layer.length = layer.features.length;
        if (layer.length) layers[layer.name] = layer;
    }
}
/**
 * Reader callback for parsing layer.
 * @param {number} tag The tag.
 * @param {Object} layer The layer object.
 * @param {PBF} pbf The PBF.
 */ function $76637151dba7e2e2$var$layerPBFReader(tag, layer, pbf) {
    if (tag === 15) layer.version = pbf.readVarint();
    else if (tag === 1) layer.name = pbf.readString();
    else if (tag === 5) layer.extent = pbf.readVarint();
    else if (tag === 2) layer.features.push(pbf.pos);
    else if (tag === 3) layer.keys.push(pbf.readString());
    else if (tag === 4) {
        let value = null;
        const end = pbf.readVarint() + pbf.pos;
        while(pbf.pos < end){
            tag = pbf.readVarint() >> 3;
            value = tag === 1 ? pbf.readString() : tag === 2 ? pbf.readFloat() : tag === 3 ? pbf.readDouble() : tag === 4 ? pbf.readVarint64() : tag === 5 ? pbf.readVarint() : tag === 6 ? pbf.readSVarint() : tag === 7 ? pbf.readBoolean() : null;
        }
        layer.values.push(value);
    }
}
/**
 * Reader callback for parsing feature.
 * @param {number} tag The tag.
 * @param {Object} feature The feature object.
 * @param {PBF} pbf The PBF.
 */ function $76637151dba7e2e2$var$featurePBFReader(tag, feature, pbf) {
    if (tag == 1) feature.id = pbf.readVarint();
    else if (tag == 2) {
        const end = pbf.readVarint() + pbf.pos;
        while(pbf.pos < end){
            const key = feature.layer.keys[pbf.readVarint()];
            const value = feature.layer.values[pbf.readVarint()];
            feature.properties[key] = value;
        }
    } else if (tag == 3) feature.type = pbf.readVarint();
    else if (tag == 4) feature.geometry = pbf.pos;
}
/**
 * Read a raw feature from the pbf offset stored at index `i` in the raw layer.
 * @param {PBF} pbf PBF.
 * @param {Object} layer Raw layer.
 * @param {number} i Index of the feature in the raw layer's `features` array.
 * @return {Object} Raw feature.
 */ function $76637151dba7e2e2$var$readRawFeature(pbf, layer, i) {
    pbf.pos = layer.features[i];
    const end = pbf.readVarint() + pbf.pos;
    const feature = {
        layer: layer,
        type: 0,
        properties: {}
    };
    pbf.readFields($76637151dba7e2e2$var$featurePBFReader, feature, end);
    return feature;
}
/**
 * @param {number} type The raw feature's geometry type
 * @param {number} numEnds Number of ends of the flat coordinates of the
 * geometry.
 * @return {import("../render/Feature.js").Type} The geometry type.
 */ function $76637151dba7e2e2$var$getGeometryType(type, numEnds) {
    /** @type {import("../render/Feature.js").Type} */ let geometryType;
    if (type === 1) geometryType = numEnds === 1 ? 'Point' : 'MultiPoint';
    else if (type === 2) geometryType = numEnds === 1 ? 'LineString' : 'MultiLineString';
    else if (type === 3) geometryType = 'Polygon';
    return geometryType;
}
var $76637151dba7e2e2$export$2e2bcd8739ae039 = $76637151dba7e2e2$var$MVT;





/**
 * @module ol/layer/Tile
 */ /**
 * @module ol/renderer/canvas/TileLayer
 */ /**
 * @module ol/DataTile
 */ /**
 * @module ol/Tile
 */ 




/**
 * A function that takes a {@link module:ol/Tile~Tile} for the tile and a
 * `{string}` for the url as arguments. The default is
 * ```js
 * source.setTileLoadFunction(function(tile, src) {
 *   tile.getImage().src = src;
 * });
 * ```
 * For more fine grained control, the load function can use fetch or XMLHttpRequest and involve
 * error handling:
 *
 * ```js
 * import TileState from 'ol/TileState.js';
 *
 * source.setTileLoadFunction(function(tile, src) {
 *   const xhr = new XMLHttpRequest();
 *   xhr.responseType = 'blob';
 *   xhr.addEventListener('loadend', function (evt) {
 *     const data = this.response;
 *     if (data !== undefined) {
 *       tile.getImage().src = URL.createObjectURL(data);
 *     } else {
 *       tile.setState(TileState.ERROR);
 *     }
 *   });
 *   xhr.addEventListener('error', function () {
 *     tile.setState(TileState.ERROR);
 *   });
 *   xhr.open('GET', src);
 *   xhr.send();
 * });
 * ```
 *
 * @typedef {function(Tile, string): void} LoadFunction
 * @api
 */ /**
 * {@link module:ol/source/Tile~TileSource} sources use a function of this type to get
 * the url that provides a tile for a given tile coordinate.
 *
 * This function takes a {@link module:ol/tilecoord~TileCoord} for the tile
 * coordinate, a `{number}` representing the pixel ratio and a
 * {@link module:ol/proj/Projection~Projection} for the projection  as arguments
 * and returns a `{string}` representing the tile URL, or undefined if no tile
 * should be requested for the passed tile coordinate.
 *
 * @typedef {function(import("./tilecoord.js").TileCoord, number,
 *           import("./proj/Projection.js").default): (string|undefined)} UrlFunction
 * @api
 */ /**
 * @typedef {Object} Options
 * @property {number} [transition=250] A duration for tile opacity
 * transitions in milliseconds. A duration of 0 disables the opacity transition.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 * @api
 */ /**
 * @classdesc
 * Base class for tiles.
 *
 * @abstract
 */ class $1e3bc99d4012152b$var$Tile extends (0, $8c60cc978e8694f4$export$2e2bcd8739ae039) {
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {Options} [options] Tile options.
   */ constructor(tileCoord, state, options){
        super();
        options = options ? options : {};
        /**
     * @type {import("./tilecoord.js").TileCoord}
     */ this.tileCoord = tileCoord;
        /**
     * @protected
     * @type {import("./TileState.js").default}
     */ this.state = state;
        /**
     * A key assigned to the tile. This is used in conjunction with a source key
     * to determine if a cached version of this tile may be used by the renderer.
     * @type {string}
     */ this.key = '';
        /**
     * The duration for the opacity transition.
     * @private
     * @type {number}
     */ this.transition_ = options.transition === undefined ? 250 : options.transition;
        /**
     * Lookup of start times for rendering transitions.  If the start time is
     * equal to -1, the transition is complete.
     * @private
     * @type {Object<string, number>}
     */ this.transitionStarts_ = {};
        /**
     * @type {boolean}
     */ this.interpolate = !!options.interpolate;
    }
    /**
   * @protected
   */ changed() {
        this.dispatchEvent((0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CHANGE);
    }
    /**
   * Called by the tile cache when the tile is removed from the cache due to expiry
   */ release() {
        // to remove the `change` listener on this tile in `ol/TileQueue#handleTileChange`
        this.setState((0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).EMPTY);
    }
    /**
   * @return {string} Key.
   */ getKey() {
        return this.key + '/' + this.tileCoord;
    }
    /**
   * Get the tile coordinate for this tile.
   * @return {import("./tilecoord.js").TileCoord} The tile coordinate.
   * @api
   */ getTileCoord() {
        return this.tileCoord;
    }
    /**
   * @return {import("./TileState.js").default} State.
   */ getState() {
        return this.state;
    }
    /**
   * Sets the state of this tile. If you write your own {@link module:ol/Tile~LoadFunction tileLoadFunction} ,
   * it is important to set the state correctly to {@link module:ol/TileState~ERROR}
   * when the tile cannot be loaded. Otherwise the tile cannot be removed from
   * the tile queue and will block other requests.
   * @param {import("./TileState.js").default} state State.
   * @api
   */ setState(state) {
        if (this.state === (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).EMPTY) // no more state changes
        return;
        if (this.state !== (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).ERROR && this.state > state) throw new Error('Tile load sequence violation');
        this.state = state;
        this.changed();
    }
    /**
   * Load the image or retry if loading previously failed.
   * Loading is taken care of by the tile queue, and calling this method is
   * only needed for preloading or for reloading in case of an error.
   * @abstract
   * @api
   */ load() {
        (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Get the alpha value for rendering.
   * @param {string} id An id for the renderer.
   * @param {number} time The render frame time.
   * @return {number} A number between 0 and 1.
   */ getAlpha(id, time) {
        if (!this.transition_) return 1;
        let start = this.transitionStarts_[id];
        if (!start) {
            start = time;
            this.transitionStarts_[id] = start;
        } else if (start === -1) return 1;
        const delta = time - start + 1000 / 60; // avoid rendering at 0
        if (delta >= this.transition_) return 1;
        return (0, $6aa29dc5b469ae30$export$929e5a82286172a6)(delta / this.transition_);
    }
    /**
   * Determine if a tile is in an alpha transition.  A tile is considered in
   * transition if tile.getAlpha() has not yet been called or has been called
   * and returned 1.
   * @param {string} id An id for the renderer.
   * @return {boolean} The tile is in transition.
   */ inTransition(id) {
        if (!this.transition_) return false;
        return this.transitionStarts_[id] !== -1;
    }
    /**
   * Mark a transition as complete.
   * @param {string} id An id for the renderer.
   */ endTransition(id) {
        if (this.transition_) this.transitionStarts_[id] = -1;
    }
    /**
   * @override
   */ disposeInternal() {
        this.release();
        super.disposeInternal();
    }
}
var $1e3bc99d4012152b$export$2e2bcd8739ae039 = $1e3bc99d4012152b$var$Tile;




function $b8e5ebdf24076278$export$3a7c913cb40dcb7d(data) {
    return data instanceof Image || data instanceof HTMLCanvasElement || data instanceof HTMLVideoElement || data instanceof ImageBitmap ? data : null;
}
function $b8e5ebdf24076278$export$7386cb0413f6b283(data) {
    return data instanceof Uint8Array || data instanceof Uint8ClampedArray || data instanceof Float32Array || data instanceof DataView ? data : null;
}
const $b8e5ebdf24076278$export$df4c617b86128e3e = new Error('disposed');
/**
 * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D|null}
 */ let $b8e5ebdf24076278$var$sharedContext = null;
function $b8e5ebdf24076278$export$45b10814cc054894(image) {
    if (!$b8e5ebdf24076278$var$sharedContext) $b8e5ebdf24076278$var$sharedContext = (0, $5ce605ba3ee034a0$export$9e05d10eae75c464)(image.width, image.height, undefined, {
        willReadFrequently: true
    });
    const canvas = $b8e5ebdf24076278$var$sharedContext.canvas;
    const width = image.width;
    if (canvas.width !== width) canvas.width = width;
    const height = image.height;
    if (canvas.height !== height) canvas.height = height;
    $b8e5ebdf24076278$var$sharedContext.clearRect(0, 0, width, height);
    $b8e5ebdf24076278$var$sharedContext.drawImage(image, 0, 0);
    return $b8e5ebdf24076278$var$sharedContext.getImageData(0, 0, width, height).data;
}
/**
 * @type {import('./size.js').Size}
 */ const $b8e5ebdf24076278$var$defaultSize = [
    256,
    256
];
/**
 * @typedef {Object} Options
 * @property {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
 * @property {function(): Promise<Data>} loader Data loader.  For loaders that generate images,
 * the promise should not resolve until the image is loaded.
 * @property {number} [transition=250] A duration for tile opacity
 * transitions in milliseconds. A duration of 0 disables the opacity transition.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 * @property {import('./size.js').Size} [size=[256, 256]] Tile size.
 * @property {AbortController} [controller] An abort controller.
 * @api
 */ class $b8e5ebdf24076278$var$DataTile extends (0, $1e3bc99d4012152b$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Tile options.
   */ constructor(options){
        const state = (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).IDLE;
        super(options.tileCoord, state, {
            transition: options.transition,
            interpolate: options.interpolate
        });
        /**
     * @type {function(): Promise<Data>}
     * @private
     */ this.loader_ = options.loader;
        /**
     * @type {Data}
     * @private
     */ this.data_ = null;
        /**
     * @type {Error}
     * @private
     */ this.error_ = null;
        /**
     * @type {import('./size.js').Size|null}
     * @private
     */ this.size_ = options.size || null;
        /**
     * @type {AbortController|null}
     * @private
     */ this.controller_ = options.controller || null;
    }
    /**
   * Get the tile size.
   * @return {import('./size.js').Size} Tile size.
   */ getSize() {
        if (this.size_) return this.size_;
        const imageData = $b8e5ebdf24076278$export$3a7c913cb40dcb7d(this.data_);
        if (imageData) return [
            imageData.width,
            imageData.height
        ];
        return $b8e5ebdf24076278$var$defaultSize;
    }
    /**
   * Get the data for the tile.
   * @return {Data} Tile data.
   * @api
   */ getData() {
        return this.data_;
    }
    /**
   * Get any loading error.
   * @return {Error} Loading error.
   * @api
   */ getError() {
        return this.error_;
    }
    /**
   * Load the tile data.
   * @api
   * @override
   */ load() {
        if (this.state !== (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).IDLE && this.state !== (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).ERROR) return;
        this.state = (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADING;
        this.changed();
        const self = this;
        this.loader_().then(function(data) {
            self.data_ = data;
            self.state = (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADED;
            self.changed();
        }).catch(function(error) {
            self.error_ = error;
            self.state = (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).ERROR;
            self.changed();
        });
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.controller_) {
            this.controller_.abort($b8e5ebdf24076278$export$df4c617b86128e3e);
            this.controller_ = null;
        }
        super.disposeInternal();
    }
}
var $b8e5ebdf24076278$export$2e2bcd8739ae039 = $b8e5ebdf24076278$var$DataTile;


/**
 * @module ol/ImageTile
 */ 




class $cabe2cad606723f7$var$ImageTile extends (0, $1e3bc99d4012152b$export$2e2bcd8739ae039) {
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {string} src Image source URI.
   * @param {import('./dom.js').ImageAttributes} imageAttributes Image attributes options.
   * @param {import("./Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @param {import("./Tile.js").Options} [options] Tile options.
   */ constructor(tileCoord, state, src, imageAttributes, tileLoadFunction, options){
        super(tileCoord, state, options);
        /**
     * @private
     * @type {?string}
     */ this.crossOrigin_ = imageAttributes?.crossOrigin;
        /**
     * @private
     * @type {ReferrerPolicy}
     */ this.referrerPolicy_ = imageAttributes?.referrerPolicy;
        /**
     * Image URI
     *
     * @private
     * @type {string}
     */ this.src_ = src;
        this.key = src;
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement|OffscreenCanvas}
     */ this.image_;
        if (0, $013e07c1ef6d00ad$export$98fcef3dc9973292) this.image_ = new OffscreenCanvas(1, 1);
        else {
            this.image_ = new Image();
            if (this.crossOrigin_ !== null) this.image_.crossOrigin = this.crossOrigin_;
            if (this.referrerPolicy_ !== undefined) this.image_.referrerPolicy = this.referrerPolicy_;
        }
        /**
     * @private
     * @type {?function():void}
     */ this.unlisten_ = null;
        /**
     * @private
     * @type {import("./Tile.js").LoadFunction}
     */ this.tileLoadFunction_ = tileLoadFunction;
    }
    /**
   * Get the HTML image element for this tile (may be a Canvas, OffscreenCanvas, Image, or Video).
   * @return {HTMLCanvasElement|OffscreenCanvas|HTMLImageElement|HTMLVideoElement} Image.
   * @api
   */ getImage() {
        return this.image_;
    }
    /**
   * Sets an HTML image element for this tile (may be a Canvas or preloaded Image).
   * @param {HTMLCanvasElement|OffscreenCanvas|HTMLImageElement} element Element.
   */ setImage(element) {
        this.image_ = element;
        this.state = (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADED;
        this.unlistenImage_();
        this.changed();
    }
    /**
   * Get the cross origin of the ImageTile.
   * @return {string} Cross origin.
   */ getCrossOrigin() {
        return this.crossOrigin_;
    }
    /**
   * Get the referrer policy of the ImageTile.
   * @return {ReferrerPolicy} Referrer policy.
   */ getReferrerPolicy() {
        return this.referrerPolicy_;
    }
    /**
   * Tracks loading or read errors.
   *
   * @private
   */ handleImageError_() {
        this.state = (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).ERROR;
        this.unlistenImage_();
        this.image_ = $cabe2cad606723f7$var$getBlankImage();
        this.changed();
    }
    /**
   * Tracks successful image load.
   *
   * @private
   */ handleImageLoad_() {
        if (0, $013e07c1ef6d00ad$export$98fcef3dc9973292) // OffscreenCanvas does not have naturalWidth and naturalHeight
        this.state = (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADED;
        else {
            const image = /** @type {HTMLImageElement} */ this.image_;
            if (image.naturalWidth && image.naturalHeight) this.state = (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADED;
            else this.state = (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).EMPTY;
        }
        this.unlistenImage_();
        this.changed();
    }
    /**
   * Load the image or retry if loading previously failed.
   * Loading is taken care of by the tile queue, and calling this method is
   * only needed for preloading or for reloading in case of an error.
   *
   * To retry loading tiles on failed requests, use a custom `tileLoadFunction`
   * that checks for error status codes and reloads only when the status code is
   * 408, 429, 500, 502, 503 and 504, and only when not too many retries have been
   * made already:
   *
   * ```js
   * const retryCodes = [408, 429, 500, 502, 503, 504];
   * const retries = {};
   * source.setTileLoadFunction((tile, src) => {
   *   const image = tile.getImage();
   *   fetch(src)
   *     .then((response) => {
   *       if (retryCodes.includes(response.status)) {
   *         retries[src] = (retries[src] || 0) + 1;
   *         if (retries[src] <= 3) {
   *           setTimeout(() => tile.load(), retries[src] * 1000);
   *         }
   *         return Promise.reject();
   *       }
   *       return response.blob();
   *     })
   *     .then((blob) => {
   *       const imageUrl = URL.createObjectURL(blob);
   *       image.src = imageUrl;
   *       setTimeout(() => URL.revokeObjectURL(imageUrl), 5000);
   *     })
   *     .catch(() => tile.setState(3)); // error
   * });
   * ```
   * @api
   * @override
   */ load() {
        if (this.state == (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).ERROR) {
            this.state = (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).IDLE;
            this.image_ = new Image();
            if (this.crossOrigin_ !== null) this.image_.crossOrigin = this.crossOrigin_;
            if (this.referrerPolicy_ !== undefined) this.image_.referrerPolicy = this.referrerPolicy_;
        }
        if (this.state == (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).IDLE) {
            this.state = (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADING;
            this.changed();
            this.tileLoadFunction_(this, this.src_);
            this.unlisten_ = (0, $2ec9ee9b9239c7e8$export$bc96ecc7c2a50764)(this.image_, this.handleImageLoad_.bind(this), this.handleImageError_.bind(this));
        }
    }
    /**
   * Discards event handlers which listen for load completion or errors.
   *
   * @private
   */ unlistenImage_() {
        if (this.unlisten_) {
            this.unlisten_();
            this.unlisten_ = null;
        }
    }
    /**
   * @override
   */ disposeInternal() {
        this.unlistenImage_();
        this.image_ = null;
        super.disposeInternal();
    }
}
/**
 * Get a 1-pixel blank image.
 * @return {HTMLCanvasElement|OffscreenCanvas} Blank image.
 */ function $cabe2cad606723f7$var$getBlankImage() {
    const ctx = (0, $5ce605ba3ee034a0$export$9e05d10eae75c464)(1, 1);
    ctx.fillStyle = 'rgba(0,0,0,0)';
    ctx.fillRect(0, 0, 1, 1);
    return ctx.canvas;
}
var $cabe2cad606723f7$export$2e2bcd8739ae039 = $cabe2cad606723f7$var$ImageTile;


/**
 * @module ol/TileRange
 */ /**
 * A representation of a contiguous block of tiles.  A tile range is specified
 * by its min/max tile coordinates and is inclusive of coordinates.
 */ class $1bd0ced7cb08c615$var$TileRange {
    /**
   * @param {number} minX Minimum X.
   * @param {number} maxX Maximum X.
   * @param {number} minY Minimum Y.
   * @param {number} maxY Maximum Y.
   */ constructor(minX, maxX, minY, maxY){
        /**
     * @type {number}
     */ this.minX = minX;
        /**
     * @type {number}
     */ this.maxX = maxX;
        /**
     * @type {number}
     */ this.minY = minY;
        /**
     * @type {number}
     */ this.maxY = maxY;
    }
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {boolean} Contains tile coordinate.
   */ contains(tileCoord) {
        return this.containsXY(tileCoord[1], tileCoord[2]);
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Contains.
   */ containsTileRange(tileRange) {
        return this.minX <= tileRange.minX && tileRange.maxX <= this.maxX && this.minY <= tileRange.minY && tileRange.maxY <= this.maxY;
    }
    /**
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @return {boolean} Contains coordinate.
   */ containsXY(x, y) {
        return this.minX <= x && x <= this.maxX && this.minY <= y && y <= this.maxY;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Equals.
   */ equals(tileRange) {
        return this.minX == tileRange.minX && this.minY == tileRange.minY && this.maxX == tileRange.maxX && this.maxY == tileRange.maxY;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   */ extend(tileRange) {
        if (tileRange.minX < this.minX) this.minX = tileRange.minX;
        if (tileRange.maxX > this.maxX) this.maxX = tileRange.maxX;
        if (tileRange.minY < this.minY) this.minY = tileRange.minY;
        if (tileRange.maxY > this.maxY) this.maxY = tileRange.maxY;
    }
    /**
   * @return {number} Height.
   */ getHeight() {
        return this.maxY - this.minY + 1;
    }
    /**
   * @return {import("./size.js").Size} Size.
   */ getSize() {
        return [
            this.getWidth(),
            this.getHeight()
        ];
    }
    /**
   * @return {number} Width.
   */ getWidth() {
        return this.maxX - this.minX + 1;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Intersects.
   */ intersects(tileRange) {
        return this.minX <= tileRange.maxX && this.maxX >= tileRange.minX && this.minY <= tileRange.maxY && this.maxY >= tileRange.minY;
    }
}
function $1bd0ced7cb08c615$export$958e3e1a02eac4b6(minX, maxX, minY, maxY, tileRange) {
    if (tileRange !== undefined) {
        tileRange.minX = minX;
        tileRange.maxX = maxX;
        tileRange.minY = minY;
        tileRange.maxY = maxY;
        return tileRange;
    }
    return new $1bd0ced7cb08c615$var$TileRange(minX, maxX, minY, maxY);
}
var $1bd0ced7cb08c615$export$2e2bcd8739ae039 = $1bd0ced7cb08c615$var$TileRange;






/**
 * @module ol/reproj/Tile
 */ 






/**
 * @module ol/reproj
 */ 



let $6f24a3a97d494c8d$var$brokenDiagonalRendering_;
const $6f24a3a97d494c8d$export$a166f0857c555517 = [];
/**
 * This draws a small triangle into a canvas by setting the triangle as the clip region
 * and then drawing a (too large) rectangle
 *
 * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} ctx The context in which to draw the triangle
 * @param {number} u1 The x-coordinate of the second point. The first point is 0,0.
 * @param {number} v1 The y-coordinate of the second point.
 * @param {number} u2 The x-coordinate of the third point.
 * @param {number} v2 The y-coordinate of the third point.
 */ function $6f24a3a97d494c8d$var$drawTestTriangle(ctx, u1, v1, u2, v2) {
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(u1, v1);
    ctx.lineTo(u2, v2);
    ctx.closePath();
    ctx.save();
    ctx.clip();
    ctx.fillRect(0, 0, Math.max(u1, u2) + 1, Math.max(v1, v2));
    ctx.restore();
}
/**
 * Given the data from getImageData, see if the right values appear at the provided offset.
 * Returns true if either the color or transparency is off
 *
 * @param {Uint8ClampedArray} data The data returned from getImageData
 * @param {number} offset The pixel offset from the start of data.
 * @return {boolean} true if the diagonal rendering is broken
 */ function $6f24a3a97d494c8d$var$verifyBrokenDiagonalRendering(data, offset) {
    // the values ought to be close to the rgba(210, 0, 0, 0.75)
    return Math.abs(data[offset * 4] - 210) > 2 || Math.abs(data[offset * 4 + 3] - 191.25) > 2;
}
/**
 * Determines if the current browser configuration can render triangular clip regions correctly.
 * This value is cached so the function is only expensive the first time called.
 * Firefox on Windows (as of now) does not if HWA is enabled. See https://bugzilla.mozilla.org/show_bug.cgi?id=1606976
 * Chrome works, and everything seems to work on OSX and Android. This function caches the
 * result. I suppose that it is conceivably possible that a browser might flip modes while the app is
 * running, but lets hope not.
 *
 * @return {boolean} true if the Diagonal Rendering is broken.
 */ function $6f24a3a97d494c8d$var$isBrokenDiagonalRendering() {
    if ($6f24a3a97d494c8d$var$brokenDiagonalRendering_ === undefined) {
        const ctx = (0, $5ce605ba3ee034a0$export$9e05d10eae75c464)(6, 6, $6f24a3a97d494c8d$export$a166f0857c555517);
        ctx.globalCompositeOperation = 'lighter';
        ctx.fillStyle = 'rgba(210, 0, 0, 0.75)';
        $6f24a3a97d494c8d$var$drawTestTriangle(ctx, 4, 5, 4, 0);
        $6f24a3a97d494c8d$var$drawTestTriangle(ctx, 4, 5, 0, 5);
        const data = ctx.getImageData(0, 0, 3, 3).data;
        $6f24a3a97d494c8d$var$brokenDiagonalRendering_ = $6f24a3a97d494c8d$var$verifyBrokenDiagonalRendering(data, 0) || $6f24a3a97d494c8d$var$verifyBrokenDiagonalRendering(data, 4) || $6f24a3a97d494c8d$var$verifyBrokenDiagonalRendering(data, 8);
        (0, $5ce605ba3ee034a0$export$e918ac6a1026a12a)(ctx);
        $6f24a3a97d494c8d$export$a166f0857c555517.push(ctx.canvas);
    }
    return $6f24a3a97d494c8d$var$brokenDiagonalRendering_;
}
function $6f24a3a97d494c8d$export$5fbb958059b7e71f(sourceProj, targetProj, targetCenter, targetResolution) {
    const sourceCenter = (0, $2a998b085c5a7ac9$export$51186ad6e864892a)(targetCenter, targetProj, sourceProj);
    // calculate the ideal resolution of the source data
    let sourceResolution = (0, $2a998b085c5a7ac9$export$2d8f7b4eec383d44)(targetProj, targetResolution, targetCenter);
    const targetMetersPerUnit = targetProj.getMetersPerUnit();
    if (targetMetersPerUnit !== undefined) sourceResolution *= targetMetersPerUnit;
    const sourceMetersPerUnit = sourceProj.getMetersPerUnit();
    if (sourceMetersPerUnit !== undefined) sourceResolution /= sourceMetersPerUnit;
    // Based on the projection properties, the point resolution at the specified
    // coordinates may be slightly different. We need to reverse-compensate this
    // in order to achieve optimal results.
    const sourceExtent = sourceProj.getExtent();
    if (!sourceExtent || (0, $3412ad7bd362b04c$export$ac68c24d37ca240f)(sourceExtent, sourceCenter)) {
        const compensationFactor = (0, $2a998b085c5a7ac9$export$2d8f7b4eec383d44)(sourceProj, sourceResolution, sourceCenter) / sourceResolution;
        if (isFinite(compensationFactor) && compensationFactor > 0) sourceResolution /= compensationFactor;
    }
    return sourceResolution;
}
function $6f24a3a97d494c8d$export$16d356211d01f1cc(sourceProj, targetProj, targetExtent, targetResolution) {
    const targetCenter = (0, $3412ad7bd362b04c$export$c91255cadecfe081)(targetExtent);
    let sourceResolution = $6f24a3a97d494c8d$export$5fbb958059b7e71f(sourceProj, targetProj, targetCenter, targetResolution);
    if (!isFinite(sourceResolution) || sourceResolution <= 0) (0, $3412ad7bd362b04c$export$f9ed8a3d123a08e2)(targetExtent, function(corner) {
        sourceResolution = $6f24a3a97d494c8d$export$5fbb958059b7e71f(sourceProj, targetProj, corner, targetResolution);
        return isFinite(sourceResolution) && sourceResolution > 0;
    });
    return sourceResolution;
}
function $6f24a3a97d494c8d$export$b3890eb0ae9dca99(width, height, pixelRatio, sourceResolution, sourceExtent, targetResolution, targetExtent, triangulation, sources, gutter, renderEdges, interpolate, drawSingle, clipExtent) {
    const context = (0, $5ce605ba3ee034a0$export$9e05d10eae75c464)(Math.round(pixelRatio * width), Math.round(pixelRatio * height), $6f24a3a97d494c8d$export$a166f0857c555517);
    if (!interpolate) context.imageSmoothingEnabled = false;
    if (sources.length === 0) return context.canvas;
    context.scale(pixelRatio, pixelRatio);
    function pixelRound(value) {
        return Math.round(value * pixelRatio) / pixelRatio;
    }
    context.globalCompositeOperation = 'lighter';
    const sourceDataExtent = (0, $3412ad7bd362b04c$export$fe201bb3bbe031e9)();
    sources.forEach(function(src, i, arr) {
        (0, $3412ad7bd362b04c$export$8b58be045bf06082)(sourceDataExtent, src.extent);
    });
    let stitchContext;
    const stitchScale = pixelRatio / sourceResolution;
    // Round up Float32 scale values to prevent interpolation in Firefox.
    const inverseScale = (interpolate ? 1 : 1 + Math.pow(2, -24)) / stitchScale;
    if (!drawSingle || sources.length !== 1 || gutter !== 0) {
        stitchContext = (0, $5ce605ba3ee034a0$export$9e05d10eae75c464)(Math.round((0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(sourceDataExtent) * stitchScale), Math.round((0, $3412ad7bd362b04c$export$c08559766941f856)(sourceDataExtent) * stitchScale), $6f24a3a97d494c8d$export$a166f0857c555517);
        if (!interpolate) stitchContext.imageSmoothingEnabled = false;
        if (sourceExtent && clipExtent) {
            const xPos = (sourceExtent[0] - sourceDataExtent[0]) * stitchScale;
            const yPos = -(sourceExtent[3] - sourceDataExtent[3]) * stitchScale;
            const width = (0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(sourceExtent) * stitchScale;
            const height = (0, $3412ad7bd362b04c$export$c08559766941f856)(sourceExtent) * stitchScale;
            stitchContext.rect(xPos, yPos, width, height);
            stitchContext.clip();
        }
        sources.forEach(function(src, i, arr) {
            // This test should never fail -- but it does. Need to find a fix the upstream condition
            if (src.image.width > 0 && src.image.height > 0) {
                if (src.clipExtent) {
                    stitchContext.save();
                    const xPos = (src.clipExtent[0] - sourceDataExtent[0]) * stitchScale;
                    const yPos = -(src.clipExtent[3] - sourceDataExtent[3]) * stitchScale;
                    const width = (0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(src.clipExtent) * stitchScale;
                    const height = (0, $3412ad7bd362b04c$export$c08559766941f856)(src.clipExtent) * stitchScale;
                    stitchContext.rect(interpolate ? xPos : Math.round(xPos), interpolate ? yPos : Math.round(yPos), interpolate ? width : Math.round(xPos + width) - Math.round(xPos), interpolate ? height : Math.round(yPos + height) - Math.round(yPos));
                    stitchContext.clip();
                }
                const xPos = (src.extent[0] - sourceDataExtent[0]) * stitchScale;
                const yPos = -(src.extent[3] - sourceDataExtent[3]) * stitchScale;
                const srcWidth = (0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(src.extent) * stitchScale;
                const srcHeight = (0, $3412ad7bd362b04c$export$c08559766941f856)(src.extent) * stitchScale;
                stitchContext.drawImage(src.image, gutter, gutter, src.image.width - 2 * gutter, src.image.height - 2 * gutter, interpolate ? xPos : Math.round(xPos), interpolate ? yPos : Math.round(yPos), interpolate ? srcWidth : Math.round(xPos + srcWidth) - Math.round(xPos), interpolate ? srcHeight : Math.round(yPos + srcHeight) - Math.round(yPos));
                if (src.clipExtent) stitchContext.restore();
            }
        });
    }
    const targetTopLeft = (0, $3412ad7bd362b04c$export$cb1538b07e6964ff)(targetExtent);
    triangulation.getTriangles().forEach(function(triangle, i, arr) {
        /* Calculate affine transform (src -> dst)
     * Resulting matrix can be used to transform coordinate
     * from `sourceProjection` to destination pixels.
     *
     * To optimize number of context calls and increase numerical stability,
     * we also do the following operations:
     * trans(-topLeftExtentCorner), scale(1 / targetResolution), scale(1, -1)
     * here before solving the linear system so [ui, vi] are pixel coordinates.
     *
     * Src points: xi, yi
     * Dst points: ui, vi
     * Affine coefficients: aij
     *
     * | x0 y0 1  0  0 0 |   |a00|   |u0|
     * | x1 y1 1  0  0 0 |   |a01|   |u1|
     * | x2 y2 1  0  0 0 | x |a02| = |u2|
     * |  0  0 0 x0 y0 1 |   |a10|   |v0|
     * |  0  0 0 x1 y1 1 |   |a11|   |v1|
     * |  0  0 0 x2 y2 1 |   |a12|   |v2|
     */ const source = triangle.source;
        const target = triangle.target;
        let x0 = source[0][0], y0 = source[0][1];
        let x1 = source[1][0], y1 = source[1][1];
        let x2 = source[2][0], y2 = source[2][1];
        // Make sure that everything is on pixel boundaries
        const u0 = pixelRound((target[0][0] - targetTopLeft[0]) / targetResolution);
        const v0 = pixelRound(-(target[0][1] - targetTopLeft[1]) / targetResolution);
        const u1 = pixelRound((target[1][0] - targetTopLeft[0]) / targetResolution);
        const v1 = pixelRound(-(target[1][1] - targetTopLeft[1]) / targetResolution);
        const u2 = pixelRound((target[2][0] - targetTopLeft[0]) / targetResolution);
        const v2 = pixelRound(-(target[2][1] - targetTopLeft[1]) / targetResolution);
        // Shift all the source points to improve numerical stability
        // of all the subsequent calculations. The [x0, y0] is used here.
        // This is also used to simplify the linear system.
        const sourceNumericalShiftX = x0;
        const sourceNumericalShiftY = y0;
        x0 = 0;
        y0 = 0;
        x1 -= sourceNumericalShiftX;
        y1 -= sourceNumericalShiftY;
        x2 -= sourceNumericalShiftX;
        y2 -= sourceNumericalShiftY;
        const augmentedMatrix = [
            [
                x1,
                y1,
                0,
                0,
                u1 - u0
            ],
            [
                x2,
                y2,
                0,
                0,
                u2 - u0
            ],
            [
                0,
                0,
                x1,
                y1,
                v1 - v0
            ],
            [
                0,
                0,
                x2,
                y2,
                v2 - v0
            ]
        ];
        const affineCoefs = (0, $912ac838ff50d1cd$export$8240f01c446270e6)(augmentedMatrix);
        if (!affineCoefs) return;
        context.save();
        context.beginPath();
        if ($6f24a3a97d494c8d$var$isBrokenDiagonalRendering() || !interpolate) {
            // Make sure that all lines are horizontal or vertical
            context.moveTo(u1, v1);
            // This is the diagonal line. Do it in 4 steps
            const steps = 4;
            const ud = u0 - u1;
            const vd = v0 - v1;
            for(let step = 0; step < steps; step++){
                // Go horizontally
                context.lineTo(u1 + pixelRound((step + 1) * ud / steps), v1 + pixelRound(step * vd / (steps - 1)));
                // Go vertically
                if (step != steps - 1) context.lineTo(u1 + pixelRound((step + 1) * ud / steps), v1 + pixelRound((step + 1) * vd / (steps - 1)));
            }
            // We are almost at u0r, v0r
            context.lineTo(u2, v2);
        } else {
            context.moveTo(u1, v1);
            context.lineTo(u0, v0);
            context.lineTo(u2, v2);
        }
        context.clip();
        context.transform(affineCoefs[0], affineCoefs[2], affineCoefs[1], affineCoefs[3], u0, v0);
        context.translate(sourceDataExtent[0] - sourceNumericalShiftX, sourceDataExtent[3] - sourceNumericalShiftY);
        let image;
        if (stitchContext) {
            image = stitchContext.canvas;
            context.scale(inverseScale, -inverseScale);
        } else {
            const source = sources[0];
            const extent = source.extent;
            image = source.image;
            context.scale((0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(extent) / image.width, -(0, $3412ad7bd362b04c$export$c08559766941f856)(extent) / image.height);
        }
        context.drawImage(image, 0, 0);
        context.restore();
    });
    if (stitchContext) {
        (0, $5ce605ba3ee034a0$export$e918ac6a1026a12a)(stitchContext);
        $6f24a3a97d494c8d$export$a166f0857c555517.push(stitchContext.canvas);
    }
    if (renderEdges) {
        context.save();
        context.globalCompositeOperation = 'source-over';
        context.strokeStyle = 'black';
        context.lineWidth = 1;
        triangulation.getTriangles().forEach(function(triangle, i, arr) {
            const target = triangle.target;
            const u0 = (target[0][0] - targetTopLeft[0]) / targetResolution;
            const v0 = -(target[0][1] - targetTopLeft[1]) / targetResolution;
            const u1 = (target[1][0] - targetTopLeft[0]) / targetResolution;
            const v1 = -(target[1][1] - targetTopLeft[1]) / targetResolution;
            const u2 = (target[2][0] - targetTopLeft[0]) / targetResolution;
            const v2 = -(target[2][1] - targetTopLeft[1]) / targetResolution;
            context.beginPath();
            context.moveTo(u1, v1);
            context.lineTo(u0, v0);
            context.lineTo(u2, v2);
            context.closePath();
            context.stroke();
        });
        context.restore();
    }
    return context.canvas;
}


/**
 * @module ol/reproj/Triangulation
 */ 



/**
 * Single triangle; consists of 3 source points and 3 target points.
 * @typedef {Object} Triangle
 * @property {Array<import("../coordinate.js").Coordinate>} source Source.
 * @property {Array<import("../coordinate.js").Coordinate>} target Target.
 */ /**
 * Maximum number of subdivision steps during raster reprojection triangulation.
 * Prevents high memory usage and large number of proj4 calls (for certain
 * transformations and areas). At most `2*(2^this)` triangles are created for
 * each triangulated extent (tile/image).
 * @type {number}
 */ const $306d859d6bfa3587$var$MAX_SUBDIVISION = 10;
/**
 * Maximum allowed size of triangle relative to world width. When transforming
 * corners of world extent between certain projections, the resulting
 * triangulation seems to have zero error and no subdivision is performed. If
 * the triangle width is more than this (relative to world width; 0-1),
 * subdivison is forced (up to `MAX_SUBDIVISION`). Default is `0.25`.
 * @type {number}
 */ const $306d859d6bfa3587$var$MAX_TRIANGLE_WIDTH = 0.25;
/**
 * @classdesc
 * Class containing triangulation of the given target extent.
 * Used for determining source data and the reprojection itself.
 */ class $306d859d6bfa3587$var$Triangulation {
    /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection.
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../extent.js").Extent} targetExtent Target extent to triangulate.
   * @param {import("../extent.js").Extent} maxSourceExtent Maximal source extent that can be used.
   * @param {number} errorThreshold Acceptable error (in source units).
   * @param {?number} destinationResolution The (optional) resolution of the destination.
   * @param {import("../transform.js").Transform} [sourceMatrix] Source transform matrix.
   */ constructor(sourceProj, targetProj, targetExtent, maxSourceExtent, errorThreshold, destinationResolution, sourceMatrix){
        /**
     * @type {import("../proj/Projection.js").default}
     * @private
     */ this.sourceProj_ = sourceProj;
        /**
     * @type {import("../proj/Projection.js").default}
     * @private
     */ this.targetProj_ = targetProj;
        /** @type {!Object<string, import("../coordinate.js").Coordinate>} */ let transformInvCache = {};
        const transformInv = sourceMatrix ? (0, $2a998b085c5a7ac9$export$6b4aafd331159e0d)((input)=>(0, $eb597965bdcc8f43$export$5635d7ef4b8fee1c)(sourceMatrix, (0, $2a998b085c5a7ac9$export$51186ad6e864892a)(input, this.targetProj_, this.sourceProj_))) : (0, $2a998b085c5a7ac9$export$fce0c6cfca85ed96)(this.targetProj_, this.sourceProj_);
        /**
     * @param {import("../coordinate.js").Coordinate} c A coordinate.
     * @return {import("../coordinate.js").Coordinate} Transformed coordinate.
     * @private
     */ this.transformInv_ = function(c) {
            const key = c[0] + '/' + c[1];
            if (!transformInvCache[key]) transformInvCache[key] = transformInv(c);
            return transformInvCache[key];
        };
        /**
     * @type {import("../extent.js").Extent}
     * @private
     */ this.maxSourceExtent_ = maxSourceExtent;
        /**
     * @type {number}
     * @private
     */ this.errorThresholdSquared_ = errorThreshold * errorThreshold;
        /**
     * @type {Array<Triangle>}
     * @private
     */ this.triangles_ = [];
        /**
     * Indicates that the triangulation crosses edge of the source projection.
     * @type {boolean}
     * @private
     */ this.wrapsXInSource_ = false;
        /**
     * @type {boolean}
     * @private
     */ this.canWrapXInSource_ = this.sourceProj_.canWrapX() && !!maxSourceExtent && !!this.sourceProj_.getExtent() && (0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(maxSourceExtent) >= (0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(this.sourceProj_.getExtent());
        /**
     * @type {?number}
     * @private
     */ this.sourceWorldWidth_ = this.sourceProj_.getExtent() ? (0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(this.sourceProj_.getExtent()) : null;
        /**
     * @type {?number}
     * @private
     */ this.targetWorldWidth_ = this.targetProj_.getExtent() ? (0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(this.targetProj_.getExtent()) : null;
        const destinationTopLeft = (0, $3412ad7bd362b04c$export$cb1538b07e6964ff)(targetExtent);
        const destinationTopRight = (0, $3412ad7bd362b04c$export$b84fa077c8b05295)(targetExtent);
        const destinationBottomRight = (0, $3412ad7bd362b04c$export$e77c1cf70445e168)(targetExtent);
        const destinationBottomLeft = (0, $3412ad7bd362b04c$export$8d09f5e2e1bf560d)(targetExtent);
        const sourceTopLeft = this.transformInv_(destinationTopLeft);
        const sourceTopRight = this.transformInv_(destinationTopRight);
        const sourceBottomRight = this.transformInv_(destinationBottomRight);
        const sourceBottomLeft = this.transformInv_(destinationBottomLeft);
        /*
     * The maxSubdivision controls how many splittings of the target area can
     * be done. The idea here is to do a linear mapping of the target areas
     * but the actual overall reprojection (can be) extremely non-linear. The
     * default value of MAX_SUBDIVISION was chosen based on mapping a 256x256
     * tile size. However this function is also called to remap canvas rendered
     * layers which can be much larger. This calculation increases the maxSubdivision
     * value by the right factor so that each 256x256 pixel area has
     * MAX_SUBDIVISION divisions.
     */ const maxSubdivision = $306d859d6bfa3587$var$MAX_SUBDIVISION + (destinationResolution ? Math.max(0, Math.ceil(Math.log2((0, $3412ad7bd362b04c$export$520c40045967cb15)(targetExtent) / (destinationResolution * destinationResolution * 65536)))) : 0);
        this.addQuad_(destinationTopLeft, destinationTopRight, destinationBottomRight, destinationBottomLeft, sourceTopLeft, sourceTopRight, sourceBottomRight, sourceBottomLeft, maxSubdivision);
        if (this.wrapsXInSource_) {
            let leftBound = Infinity;
            this.triangles_.forEach(function(triangle, i, arr) {
                leftBound = Math.min(leftBound, triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]);
            });
            // Shift triangles to be as close to `leftBound` as possible
            // (if the distance is more than `worldWidth / 2` it can be closer.
            this.triangles_.forEach((triangle)=>{
                if (Math.max(triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]) - leftBound > this.sourceWorldWidth_ / 2) {
                    const newTriangle = [
                        [
                            triangle.source[0][0],
                            triangle.source[0][1]
                        ],
                        [
                            triangle.source[1][0],
                            triangle.source[1][1]
                        ],
                        [
                            triangle.source[2][0],
                            triangle.source[2][1]
                        ]
                    ];
                    if (newTriangle[0][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[0][0] -= this.sourceWorldWidth_;
                    if (newTriangle[1][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[1][0] -= this.sourceWorldWidth_;
                    if (newTriangle[2][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[2][0] -= this.sourceWorldWidth_;
                    // Rarely (if the extent contains both the dateline and prime meridian)
                    // the shift can in turn break some triangles.
                    // Detect this here and don't shift in such cases.
                    const minX = Math.min(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                    const maxX = Math.max(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                    if (maxX - minX < this.sourceWorldWidth_ / 2) triangle.source = newTriangle;
                }
            });
        }
        transformInvCache = {};
    }
    /**
   * Adds triangle to the triangulation.
   * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
   * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
   * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
   * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
   * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
   * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
   * @private
   */ addTriangle_(a, b, c, aSrc, bSrc, cSrc) {
        this.triangles_.push({
            source: [
                aSrc,
                bSrc,
                cSrc
            ],
            target: [
                a,
                b,
                c
            ]
        });
    }
    /**
   * Adds quad (points in clock-wise order) to the triangulation
   * (and reprojects the vertices) if valid.
   * Performs quad subdivision if needed to increase precision.
   *
   * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
   * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
   * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
   * @param {import("../coordinate.js").Coordinate} d The target d coordinate.
   * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
   * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
   * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
   * @param {import("../coordinate.js").Coordinate} dSrc The source d coordinate.
   * @param {number} maxSubdivision Maximal allowed subdivision of the quad.
   * @private
   */ addQuad_(a, b, c, d, aSrc, bSrc, cSrc, dSrc, maxSubdivision) {
        const sourceQuadExtent = (0, $3412ad7bd362b04c$export$8aceca7c77505534)([
            aSrc,
            bSrc,
            cSrc,
            dSrc
        ]);
        const sourceCoverageX = this.sourceWorldWidth_ ? (0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(sourceQuadExtent) / this.sourceWorldWidth_ : null;
        const sourceWorldWidth = /** @type {number} */ this.sourceWorldWidth_;
        // when the quad is wrapped in the source projection
        // it covers most of the projection extent, but not fully
        const wrapsX = this.sourceProj_.canWrapX() && sourceCoverageX > 0.5 && sourceCoverageX < 1;
        let needsSubdivision = false;
        if (maxSubdivision > 0) {
            if (this.targetProj_.isGlobal() && this.targetWorldWidth_) {
                const targetQuadExtent = (0, $3412ad7bd362b04c$export$8aceca7c77505534)([
                    a,
                    b,
                    c,
                    d
                ]);
                const targetCoverageX = (0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(targetQuadExtent) / this.targetWorldWidth_;
                needsSubdivision = targetCoverageX > $306d859d6bfa3587$var$MAX_TRIANGLE_WIDTH || needsSubdivision;
            }
            if (!wrapsX && this.sourceProj_.isGlobal() && sourceCoverageX) needsSubdivision = sourceCoverageX > $306d859d6bfa3587$var$MAX_TRIANGLE_WIDTH || needsSubdivision;
        }
        if (!needsSubdivision && this.maxSourceExtent_) {
            if (isFinite(sourceQuadExtent[0]) && isFinite(sourceQuadExtent[1]) && isFinite(sourceQuadExtent[2]) && isFinite(sourceQuadExtent[3])) {
                if (!(0, $3412ad7bd362b04c$export$7b0a31e10bbff018)(sourceQuadExtent, this.maxSourceExtent_)) // whole quad outside source projection extent -> ignore
                return;
            }
        }
        let isNotFinite = 0;
        if (!needsSubdivision) {
            if (!isFinite(aSrc[0]) || !isFinite(aSrc[1]) || !isFinite(bSrc[0]) || !isFinite(bSrc[1]) || !isFinite(cSrc[0]) || !isFinite(cSrc[1]) || !isFinite(dSrc[0]) || !isFinite(dSrc[1])) {
                if (maxSubdivision > 0) needsSubdivision = true;
                else {
                    // It might be the case that only 1 of the points is infinite. In this case
                    // we can draw a single triangle with the other three points
                    isNotFinite = (!isFinite(aSrc[0]) || !isFinite(aSrc[1]) ? 8 : 0) + (!isFinite(bSrc[0]) || !isFinite(bSrc[1]) ? 4 : 0) + (!isFinite(cSrc[0]) || !isFinite(cSrc[1]) ? 2 : 0) + (!isFinite(dSrc[0]) || !isFinite(dSrc[1]) ? 1 : 0);
                    if (isNotFinite != 1 && isNotFinite != 2 && isNotFinite != 4 && isNotFinite != 8) return;
                }
            }
        }
        if (maxSubdivision > 0) {
            if (!needsSubdivision) {
                const center = [
                    (a[0] + c[0]) / 2,
                    (a[1] + c[1]) / 2
                ];
                const centerSrc = this.transformInv_(center);
                let dx;
                if (wrapsX) {
                    const centerSrcEstimX = ((0, $912ac838ff50d1cd$export$ba467bec01d66def)(aSrc[0], sourceWorldWidth) + (0, $912ac838ff50d1cd$export$ba467bec01d66def)(cSrc[0], sourceWorldWidth)) / 2;
                    dx = centerSrcEstimX - (0, $912ac838ff50d1cd$export$ba467bec01d66def)(centerSrc[0], sourceWorldWidth);
                } else dx = (aSrc[0] + cSrc[0]) / 2 - centerSrc[0];
                const dy = (aSrc[1] + cSrc[1]) / 2 - centerSrc[1];
                const centerSrcErrorSquared = dx * dx + dy * dy;
                needsSubdivision = centerSrcErrorSquared > this.errorThresholdSquared_;
            }
            if (needsSubdivision) {
                if (Math.abs(a[0] - c[0]) <= Math.abs(a[1] - c[1])) {
                    // split horizontally (top & bottom)
                    const bc = [
                        (b[0] + c[0]) / 2,
                        (b[1] + c[1]) / 2
                    ];
                    const bcSrc = this.transformInv_(bc);
                    const da = [
                        (d[0] + a[0]) / 2,
                        (d[1] + a[1]) / 2
                    ];
                    const daSrc = this.transformInv_(da);
                    this.addQuad_(a, b, bc, da, aSrc, bSrc, bcSrc, daSrc, maxSubdivision - 1);
                    this.addQuad_(da, bc, c, d, daSrc, bcSrc, cSrc, dSrc, maxSubdivision - 1);
                } else {
                    // split vertically (left & right)
                    const ab = [
                        (a[0] + b[0]) / 2,
                        (a[1] + b[1]) / 2
                    ];
                    const abSrc = this.transformInv_(ab);
                    const cd = [
                        (c[0] + d[0]) / 2,
                        (c[1] + d[1]) / 2
                    ];
                    const cdSrc = this.transformInv_(cd);
                    this.addQuad_(a, ab, cd, d, aSrc, abSrc, cdSrc, dSrc, maxSubdivision - 1);
                    this.addQuad_(ab, b, c, cd, abSrc, bSrc, cSrc, cdSrc, maxSubdivision - 1);
                }
                return;
            }
        }
        if (wrapsX) {
            if (!this.canWrapXInSource_) return;
            this.wrapsXInSource_ = true;
        }
        // Exactly zero or one of *Src is not finite
        // The triangles must have the diagonal line as the first side
        // This is to allow easy code in reproj.s to make it straight for broken
        // browsers that can't handle diagonal clipping
        if ((isNotFinite & 0xb) == 0) this.addTriangle_(a, c, d, aSrc, cSrc, dSrc);
        if ((isNotFinite & 0xe) == 0) this.addTriangle_(a, c, b, aSrc, cSrc, bSrc);
        if (isNotFinite) {
            // Try the other two triangles
            if ((isNotFinite & 0xd) == 0) this.addTriangle_(b, d, a, bSrc, dSrc, aSrc);
            if ((isNotFinite & 0x7) == 0) this.addTriangle_(b, d, c, bSrc, dSrc, cSrc);
        }
    }
    /**
   * Calculates extent of the `source` coordinates from all the triangles.
   *
   * @return {import("../extent.js").Extent} Calculated extent.
   */ calculateSourceExtent() {
        const extent = (0, $3412ad7bd362b04c$export$fe201bb3bbe031e9)();
        this.triangles_.forEach(function(triangle, i, arr) {
            const src = triangle.source;
            (0, $3412ad7bd362b04c$export$1f820e3920fa5715)(extent, src[0]);
            (0, $3412ad7bd362b04c$export$1f820e3920fa5715)(extent, src[1]);
            (0, $3412ad7bd362b04c$export$1f820e3920fa5715)(extent, src[2]);
        });
        return extent;
    }
    /**
   * @return {Array<Triangle>} Array of the calculated triangles.
   */ getTriangles() {
        return this.triangles_;
    }
}
var $306d859d6bfa3587$export$2e2bcd8739ae039 = $306d859d6bfa3587$var$Triangulation;


/**
 * @module ol/reproj/common
 */ /**
 * Default maximum allowed threshold  (in pixels) for reprojection
 * triangulation.
 * @type {number}
 */ const $ac3e64c1413dba86$export$3ecb4bcfa5aae855 = 0.5;


/**
 * @typedef {function(number, number, number, number) : (import("../ImageTile.js").default)} FunctionType
 */ /**
 * @typedef {Object} TileOffset
 * @property {import("../ImageTile.js").default} [tile] Tile.
 * @property {function(): import("../ImageTile.js").default} getTile Tile getter.
 * @property {number} offset Offset.
 */ /**
 * @classdesc
 * Class encapsulating single reprojected tile.
 * See {@link module:ol/source/TileImage~TileImage}.
 *
 */ class $5967f4f203a3bc87$var$ReprojTile extends (0, $1e3bc99d4012152b$export$2e2bcd8739ae039) {
    /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection.
   * @param {import("../tilegrid/TileGrid.js").default} sourceTileGrid Source tile grid.
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../tilegrid/TileGrid.js").default} targetTileGrid Target tile grid.
   * @param {import("../tilecoord.js").TileCoord} tileCoord Coordinate of the tile.
   * @param {import("../tilecoord.js").TileCoord} wrappedTileCoord Coordinate of the tile wrapped in X.
   * @param {number} pixelRatio Pixel ratio.
   * @param {number} gutter Gutter of the source tiles.
   * @param {FunctionType} getTileFunction
   *     Function returning source tiles (z, x, y, pixelRatio).
   * @param {number} [errorThreshold] Acceptable reprojection error (in px).
   * @param {boolean} [renderEdges] Render reprojection edges.
   * @param {import("../Tile.js").Options} [options] Tile options.
   */ constructor(sourceProj, sourceTileGrid, targetProj, targetTileGrid, tileCoord, wrappedTileCoord, pixelRatio, gutter, getTileFunction, errorThreshold, renderEdges, options){
        super(tileCoord, (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).IDLE, options);
        /**
     * @private
     * @type {boolean}
     */ this.renderEdges_ = renderEdges !== undefined ? renderEdges : false;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.gutter_ = gutter;
        /**
     * @private
     * @type {HTMLCanvasElement|OffscreenCanvas}
     */ this.canvas_ = null;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.sourceTileGrid_ = sourceTileGrid;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.targetTileGrid_ = targetTileGrid;
        /**
     * @private
     * @type {import("../tilecoord.js").TileCoord}
     */ this.wrappedTileCoord_ = wrappedTileCoord ? wrappedTileCoord : tileCoord;
        /**
     * @private
     * @type {!Array<TileOffset>}
     */ this.sourceTiles_ = [];
        /**
     * @private
     * @type {?Array<import("../events.js").EventsKey>}
     */ this.sourcesListenerKeys_ = null;
        /**
     * @private
     * @type {number}
     */ this.sourceZ_ = 0;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.clipExtent_ = sourceProj.canWrapX() ? sourceProj.getExtent() : undefined;
        const targetExtent = targetTileGrid.getTileCoordExtent(this.wrappedTileCoord_);
        const maxTargetExtent = this.targetTileGrid_.getExtent();
        let maxSourceExtent = this.sourceTileGrid_.getExtent();
        const limitedTargetExtent = maxTargetExtent ? (0, $3412ad7bd362b04c$export$72209efa88586d42)(targetExtent, maxTargetExtent) : targetExtent;
        if ((0, $3412ad7bd362b04c$export$520c40045967cb15)(limitedTargetExtent) === 0) {
            // Tile is completely outside range -> EMPTY
            // TODO: is it actually correct that the source even creates the tile ?
            this.state = (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).EMPTY;
            return;
        }
        const sourceProjExtent = sourceProj.getExtent();
        if (sourceProjExtent) {
            if (!maxSourceExtent) maxSourceExtent = sourceProjExtent;
            else maxSourceExtent = (0, $3412ad7bd362b04c$export$72209efa88586d42)(maxSourceExtent, sourceProjExtent);
        }
        const targetResolution = targetTileGrid.getResolution(this.wrappedTileCoord_[0]);
        const sourceResolution = (0, $6f24a3a97d494c8d$export$16d356211d01f1cc)(sourceProj, targetProj, limitedTargetExtent, targetResolution);
        if (!isFinite(sourceResolution) || sourceResolution <= 0) {
            // invalid sourceResolution -> EMPTY
            // probably edges of the projections when no extent is defined
            this.state = (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).EMPTY;
            return;
        }
        const errorThresholdInPixels = errorThreshold !== undefined ? errorThreshold : (0, $ac3e64c1413dba86$export$3ecb4bcfa5aae855);
        /**
     * @private
     * @type {!import("./Triangulation.js").default}
     */ this.triangulation_ = new (0, $306d859d6bfa3587$export$2e2bcd8739ae039)(sourceProj, targetProj, limitedTargetExtent, maxSourceExtent, sourceResolution * errorThresholdInPixels, targetResolution);
        if (this.triangulation_.getTriangles().length === 0) {
            // no valid triangles -> EMPTY
            this.state = (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).EMPTY;
            return;
        }
        this.sourceZ_ = sourceTileGrid.getZForResolution(sourceResolution);
        let sourceExtent = this.triangulation_.calculateSourceExtent();
        if (maxSourceExtent) {
            if (sourceProj.canWrapX()) {
                sourceExtent[1] = (0, $912ac838ff50d1cd$export$7d15b64cf5a3a4c4)(sourceExtent[1], maxSourceExtent[1], maxSourceExtent[3]);
                sourceExtent[3] = (0, $912ac838ff50d1cd$export$7d15b64cf5a3a4c4)(sourceExtent[3], maxSourceExtent[1], maxSourceExtent[3]);
            } else sourceExtent = (0, $3412ad7bd362b04c$export$72209efa88586d42)(sourceExtent, maxSourceExtent);
        }
        if (!(0, $3412ad7bd362b04c$export$520c40045967cb15)(sourceExtent)) this.state = (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).EMPTY;
        else {
            let worldWidth = 0;
            let worldsAway = 0;
            if (sourceProj.canWrapX()) {
                worldWidth = (0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(sourceProjExtent);
                worldsAway = Math.floor((sourceExtent[0] - sourceProjExtent[0]) / worldWidth);
            }
            const sourceExtents = (0, $3412ad7bd362b04c$export$9031237f01de0947)(sourceExtent.slice(), sourceProj, true);
            sourceExtents.forEach((extent)=>{
                const sourceRange = sourceTileGrid.getTileRangeForExtentAndZ(extent, this.sourceZ_);
                for(let srcX = sourceRange.minX; srcX <= sourceRange.maxX; srcX++)for(let srcY = sourceRange.minY; srcY <= sourceRange.maxY; srcY++){
                    const offset = worldsAway * worldWidth;
                    this.sourceTiles_.push({
                        getTile: ()=>getTileFunction(this.sourceZ_, srcX, srcY, pixelRatio),
                        offset: offset
                    });
                }
                ++worldsAway;
            });
            if (this.sourceTiles_.length === 0) this.state = (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).EMPTY;
        }
    }
    /**
   * Get the HTML Canvas element for this tile.
   * @return {HTMLCanvasElement|OffscreenCanvas} Canvas.
   */ getImage() {
        return this.canvas_;
    }
    /**
   * @private
   */ reproject_() {
        const sources = [];
        this.sourceTiles_.forEach((source)=>{
            const tile = source.tile;
            if (tile && tile.getState() == (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADED) {
                const extent = this.sourceTileGrid_.getTileCoordExtent(tile.tileCoord);
                extent[0] += source.offset;
                extent[2] += source.offset;
                const clipExtent = this.clipExtent_?.slice();
                if (clipExtent) {
                    clipExtent[0] += source.offset;
                    clipExtent[2] += source.offset;
                }
                sources.push({
                    extent: extent,
                    clipExtent: clipExtent,
                    image: tile.getImage()
                });
            }
        });
        this.sourceTiles_.length = 0;
        if (sources.length === 0) this.state = (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).ERROR;
        else {
            const z = this.wrappedTileCoord_[0];
            const size = this.targetTileGrid_.getTileSize(z);
            const width = typeof size === 'number' ? size : size[0];
            const height = typeof size === 'number' ? size : size[1];
            const targetResolution = this.targetTileGrid_.getResolution(z);
            const sourceResolution = this.sourceTileGrid_.getResolution(this.sourceZ_);
            const targetExtent = this.targetTileGrid_.getTileCoordExtent(this.wrappedTileCoord_);
            this.canvas_ = (0, $6f24a3a97d494c8d$export$b3890eb0ae9dca99)(width, height, this.pixelRatio_, sourceResolution, this.sourceTileGrid_.getExtent(), targetResolution, targetExtent, this.triangulation_, sources, this.gutter_, this.renderEdges_, this.interpolate);
            this.state = (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADED;
        }
        this.changed();
    }
    /**
   * Load not yet loaded URI.
   * @override
   */ load() {
        for (const sourceTile of this.sourceTiles_)sourceTile.tile = sourceTile.getTile();
        if (this.state == (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).IDLE) {
            this.state = (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADING;
            this.changed();
            let leftToLoad = 0;
            this.sourcesListenerKeys_ = [];
            this.sourceTiles_.forEach(({ tile: tile })=>{
                const state = tile.getState();
                if (state == (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).IDLE || state == (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADING) {
                    leftToLoad++;
                    const sourceListenKey = (0, $8061a5de9380012b$export$63174c828edd6ff8)(tile, (0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CHANGE, (e)=>{
                        const state = tile.getState();
                        if (state == (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADED || state == (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).ERROR || state == (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).EMPTY) {
                            (0, $8061a5de9380012b$export$b0a21c8b3c1c921)(sourceListenKey);
                            leftToLoad--;
                            if (leftToLoad === 0) {
                                this.unlistenSources_();
                                this.reproject_();
                            }
                        }
                    });
                    this.sourcesListenerKeys_.push(sourceListenKey);
                }
            });
            if (leftToLoad === 0) setTimeout(this.reproject_.bind(this), 0);
            else this.sourceTiles_.forEach(function({ tile: tile }, i, arr) {
                const state = tile.getState();
                if (state == (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).IDLE) tile.load();
            });
        }
    }
    /**
   * @private
   */ unlistenSources_() {
        this.sourcesListenerKeys_.forEach((0, $8061a5de9380012b$export$b0a21c8b3c1c921));
        this.sourcesListenerKeys_ = null;
    }
    /**
   * Remove from the cache due to expiry
   * @override
   */ release() {
        if (this.canvas_) {
            (0, $5ce605ba3ee034a0$export$e918ac6a1026a12a)(/** @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} */ this.canvas_.getContext('2d'));
            (0, $6f24a3a97d494c8d$export$a166f0857c555517).push(this.canvas_);
            this.canvas_ = null;
        }
        this.sourceTiles_.length = 0;
        super.release();
    }
}
var $5967f4f203a3bc87$export$2e2bcd8739ae039 = $5967f4f203a3bc87$var$ReprojTile;



/**
 * @module ol/structs/LRUCache
 */ 

/**
 * @typedef {Object} Entry
 * @property {string} key_ Key.
 * @property {Entry|null} newer Newer.
 * @property {Entry|null} older Older.
 * @property {*} value_ Value.
 */ /**
 * @classdesc
 * Implements a Least-Recently-Used cache where the keys do not conflict with
 * Object's properties (e.g. 'hasOwnProperty' is not allowed as a key). Expiring
 * items from the cache is the responsibility of the user.
 *
 * @fires import("../events/Event.js").default
 * @template T
 */ class $248e7c67fdc65d5d$var$LRUCache {
    /**
   * @param {number} [highWaterMark] High water mark.
   */ constructor(highWaterMark){
        /**
     * Desired max cache size after expireCache(). If set to 0, no cache entries
     * will be pruned at all.
     * @type {number}
     */ this.highWaterMark = highWaterMark !== undefined ? highWaterMark : 2048;
        /**
     * @private
     * @type {number}
     */ this.count_ = 0;
        /**
     * @private
     * @type {!Object<string, Entry>}
     */ this.entries_ = {};
        /**
     * @private
     * @type {?Entry}
     */ this.oldest_ = null;
        /**
     * @private
     * @type {?Entry}
     */ this.newest_ = null;
    }
    deleteOldest() {
        const entry = this.pop();
        if (entry instanceof (0, $b54235dad6714a76$export$2e2bcd8739ae039)) entry.dispose();
    }
    /**
   * @return {boolean} Can expire cache.
   */ canExpireCache() {
        return this.highWaterMark > 0 && this.getCount() > this.highWaterMark;
    }
    /**
   * Expire the cache. When the cache entry is a {@link module:ol/Disposable~Disposable},
   * the entry will be disposed.
   * @param {!Object<string, boolean>} [keep] Keys to keep. To be implemented by subclasses.
   */ expireCache(keep) {
        while(this.canExpireCache())this.deleteOldest();
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        while(this.oldest_)this.deleteOldest();
    }
    /**
   * @param {string} key Key.
   * @return {boolean} Contains key.
   */ containsKey(key) {
        return this.entries_.hasOwnProperty(key);
    }
    /**
   * @param {function(T, string, LRUCache<T>): ?} f The function
   *     to call for every entry from the oldest to the newer. This function takes
   *     3 arguments (the entry value, the entry key and the LRUCache object).
   *     The return value is ignored.
   */ forEach(f) {
        let entry = this.oldest_;
        while(entry){
            f(entry.value_, entry.key_, this);
            entry = entry.newer;
        }
    }
    /**
   * @param {string} key Key.
   * @param {*} [options] Options (reserved for subclasses).
   * @return {T} Value.
   */ get(key, options) {
        const entry = this.entries_[key];
        (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(entry !== undefined, 'Tried to get a value for a key that does not exist in the cache');
        if (entry === this.newest_) return entry.value_;
        if (entry === this.oldest_) {
            this.oldest_ = /** @type {Entry} */ this.oldest_.newer;
            this.oldest_.older = null;
        } else {
            entry.newer.older = entry.older;
            entry.older.newer = entry.newer;
        }
        entry.newer = null;
        entry.older = this.newest_;
        this.newest_.newer = entry;
        this.newest_ = entry;
        return entry.value_;
    }
    /**
   * Remove an entry from the cache.
   * @param {string} key The entry key.
   * @return {T} The removed entry.
   */ remove(key) {
        const entry = this.entries_[key];
        (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(entry !== undefined, 'Tried to get a value for a key that does not exist in the cache');
        if (entry === this.newest_) {
            this.newest_ = /** @type {Entry} */ entry.older;
            if (this.newest_) this.newest_.newer = null;
        } else if (entry === this.oldest_) {
            this.oldest_ = /** @type {Entry} */ entry.newer;
            if (this.oldest_) this.oldest_.older = null;
        } else {
            entry.newer.older = entry.older;
            entry.older.newer = entry.newer;
        }
        delete this.entries_[key];
        --this.count_;
        return entry.value_;
    }
    /**
   * @return {number} Count.
   */ getCount() {
        return this.count_;
    }
    /**
   * @return {Array<string>} Keys.
   */ getKeys() {
        const keys = new Array(this.count_);
        let i = 0;
        let entry;
        for(entry = this.newest_; entry; entry = entry.older)keys[i++] = entry.key_;
        return keys;
    }
    /**
   * @return {Array<T>} Values.
   */ getValues() {
        const values = new Array(this.count_);
        let i = 0;
        let entry;
        for(entry = this.newest_; entry; entry = entry.older)values[i++] = entry.value_;
        return values;
    }
    /**
   * @return {T} Last value.
   */ peekLast() {
        return this.oldest_.value_;
    }
    /**
   * @return {string} Last key.
   */ peekLastKey() {
        return this.oldest_.key_;
    }
    /**
   * Get the key of the newest item in the cache.  Throws if the cache is empty.
   * @return {string} The newest key.
   */ peekFirstKey() {
        return this.newest_.key_;
    }
    /**
   * Return an entry without updating least recently used time.
   * @param {string} key Key.
   * @return {T|undefined} Value.
   */ peek(key) {
        return this.entries_[key]?.value_;
    }
    /**
   * @return {T} value Value.
   */ pop() {
        const entry = this.oldest_;
        delete this.entries_[entry.key_];
        if (entry.newer) entry.newer.older = null;
        this.oldest_ = /** @type {Entry} */ entry.newer;
        if (!this.oldest_) this.newest_ = null;
        --this.count_;
        return entry.value_;
    }
    /**
   * @param {string} key Key.
   * @param {T} value Value.
   */ replace(key, value) {
        this.get(key); // update `newest_`
        this.entries_[key].value_ = value;
    }
    /**
   * @param {string} key Key.
   * @param {T} value Value.
   */ set(key, value) {
        (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(!(key in this.entries_), 'Tried to set a value for a key that is used already');
        const entry = {
            key_: key,
            newer: null,
            older: this.newest_,
            value_: value
        };
        if (!this.newest_) this.oldest_ = entry;
        else this.newest_.newer = entry;
        this.newest_ = entry;
        this.entries_[key] = entry;
        ++this.count_;
    }
    /**
   * Set a maximum number of entries for the cache.
   * @param {number} size Cache size.
   * @api
   */ setSize(size) {
        this.highWaterMark = size;
    }
}
var $248e7c67fdc65d5d$export$2e2bcd8739ae039 = $248e7c67fdc65d5d$var$LRUCache;


/**
 * @module ol/tilecoord
 */ 
function $3324a006fd485ae2$export$958e3e1a02eac4b6(z, x, y, tileCoord) {
    if (tileCoord !== undefined) {
        tileCoord[0] = z;
        tileCoord[1] = x;
        tileCoord[2] = y;
        return tileCoord;
    }
    return [
        z,
        x,
        y
    ];
}
function $3324a006fd485ae2$export$92d0df0f1d25c63c(z, x, y) {
    return z + '/' + x + '/' + y;
}
function $3324a006fd485ae2$export$a47fb462a08de82f(tileCoord) {
    return $3324a006fd485ae2$export$92d0df0f1d25c63c(tileCoord[0], tileCoord[1], tileCoord[2]);
}
function $3324a006fd485ae2$export$7f760414a8e3d2b5(tileKey) {
    const [z, x, y] = tileKey.substring(tileKey.lastIndexOf('/') + 1, tileKey.length).split(',').map(Number);
    return $3324a006fd485ae2$export$92d0df0f1d25c63c(z, x, y);
}
function $3324a006fd485ae2$export$611736262b635f8d(source, sourceKey, z, x, y) {
    return `${(0, $01f1986453243423$export$5e82334337e0f204)(source)},${sourceKey},${$3324a006fd485ae2$export$92d0df0f1d25c63c(z, x, y)}`;
}
function $3324a006fd485ae2$export$a807b7874eb66454(key) {
    return key.split('/').map(Number);
}
function $3324a006fd485ae2$export$d6af199866bfb566(tileCoord) {
    return $3324a006fd485ae2$export$731f79419750ccf7(tileCoord[0], tileCoord[1], tileCoord[2]);
}
function $3324a006fd485ae2$export$731f79419750ccf7(z, x, y) {
    return (x << z) + y;
}
function $3324a006fd485ae2$export$60bedf8e3e3c3dbe(tileCoord, tileGrid) {
    const z = tileCoord[0];
    const x = tileCoord[1];
    const y = tileCoord[2];
    if (tileGrid.getMinZoom() > z || z > tileGrid.getMaxZoom()) return false;
    const tileRange = tileGrid.getFullTileRange(z);
    if (!tileRange) return true;
    return tileRange.containsXY(x, y);
}




/**
 * @module ol/renderer/canvas/Layer
 */ 






/**
 * @module ol/render/canvas/ZIndexContext
 */ 
/** @typedef {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D & {globalAlpha: any}} ZIndexContextProxy */ /**
 * @extends {CanvasRenderingContext2D}
 */ class $4564f3e97d8a38f7$var$ZIndexContext {
    constructor(){
        /**
     * @private
     * @type {Array<Array<*>>}
     */ this.instructions_ = [];
        /**
     * @type {number}
     */ this.zIndex = 0;
        /**
     * @private
     * @type {number}
     */ this.offset_ = 0;
        /**
     * @private
     * @type {ZIndexContextProxy}
     */ this.context_ = /** @type {ZIndexContextProxy} */ new Proxy((0, $5ce605ba3ee034a0$export$fcb72ce088a6632c)(), {
            get: (target, property)=>{
                if (typeof /** @type {*} */ (0, $5ce605ba3ee034a0$export$fcb72ce088a6632c)()[property] !== 'function') // we only accept calling functions on the proxy, not accessing properties
                return undefined;
                this.push_(property);
                return this.pushMethodArgs_;
            },
            set: (target, property, value)=>{
                this.push_(property, value);
                return true;
            }
        });
    }
    /**
   * @param {...*} args Arguments to push to the instructions array.
   * @private
   */ push_(...args) {
        const instructions = this.instructions_;
        const index = this.zIndex + this.offset_;
        if (!instructions[index]) instructions[index] = [];
        instructions[index].push(...args);
    }
    /**
   * @private
   * @param {...*} args Args.
   * @return {ZIndexContext} This.
   */ pushMethodArgs_ = (...args)=>{
        this.push_(args);
        return this;
    };
    /**
   * Push a function that renders to the context directly.
   * @param {function(CanvasRenderingContext2D): void} render Function.
   */ pushFunction(render) {
        this.push_(render);
    }
    /**
   * Get a proxy for CanvasRenderingContext2D which does not support getting state
   * (e.g. `context.globalAlpha`, which will return `undefined`). To set state, if it relies on a
   * previous state (e.g. `context.globalAlpha = context.globalAlpha / 2`), set a function,
   * e.g. `context.globalAlpha = (context) => context.globalAlpha / 2`.
   * @return {ZIndexContextProxy} Context.
   */ getContext() {
        return this.context_;
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   */ draw(context) {
        this.instructions_.forEach((instructionsAtIndex)=>{
            for(let i = 0, ii = instructionsAtIndex.length; i < ii; ++i){
                const property = instructionsAtIndex[i];
                if (typeof property === 'function') {
                    property(context);
                    continue;
                }
                const instructionAtIndex = instructionsAtIndex[++i];
                if (typeof /** @type {*} */ context[property] === 'function') /** @type {*} */ context[property](...instructionAtIndex);
                else {
                    if (typeof instructionAtIndex === 'function') {
                        /** @type {*} */ context[property] = instructionAtIndex(context);
                        continue;
                    }
                    /** @type {*} */ context[property] = instructionAtIndex;
                }
            }
        });
    }
    clear() {
        this.instructions_.length = 0;
        this.zIndex = 0;
        this.offset_ = 0;
    }
    /**
   * Offsets the zIndex by the highest current zIndex. Useful for rendering multiple worlds or tiles, to
   * avoid conflicting context.clip() or context.save()/restore() calls.
   */ offset() {
        this.offset_ = this.instructions_.length;
        this.zIndex = 0;
    }
}
var $4564f3e97d8a38f7$export$2e2bcd8739ae039 = $4564f3e97d8a38f7$var$ZIndexContext;



/**
 * @module ol/renderer/Layer
 */ 



const $9ea74cc865425532$var$maxStaleKeys = 5;
/**
 * @template {import("../layer/Layer.js").default} LayerType
 */ class $9ea74cc865425532$var$LayerRenderer extends (0, $efe31481b2126ee6$export$2e2bcd8739ae039) {
    /**
   * @param {LayerType} layer Layer.
   */ constructor(layer){
        super();
        /**
     * The renderer is initialized and ready to render.
     * @type {boolean}
     */ this.ready = true;
        /** @private */ this.boundHandleImageChange_ = this.handleImageChange_.bind(this);
        /**
     * @private
     * @type {LayerType}
     */ this.layer_ = layer;
        /**
     * @type {Array<string>}
     * @private
     */ this.staleKeys_ = new Array();
        /**
     * @type {number}
     * @protected
     */ this.maxStaleKeys = $9ea74cc865425532$var$maxStaleKeys;
    }
    /**
   * @return {Array<string>} Get the list of stale keys.
   */ getStaleKeys() {
        return this.staleKeys_;
    }
    /**
   * @param {string} key The new stale key.
   */ prependStaleKey(key) {
        this.staleKeys_.unshift(key);
        if (this.staleKeys_.length > this.maxStaleKeys) this.staleKeys_.length = this.maxStaleKeys;
    }
    /**
   * Asynchronous layer level hit detection.
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature.js").FeatureLike>>} Promise that resolves with
   * an array of features.
   */ getFeatures(pixel) {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   */ getData(pixel) {
        return null;
    }
    /**
   * Determine whether render should be called.
   * @abstract
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   */ prepareFrame(frameState) {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Render the layer.
   * @abstract
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement|null} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   */ renderFrame(frameState, target) {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("./Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, matches) {
        return undefined;
    }
    /**
   * @return {LayerType} Layer.
   */ getLayer() {
        return this.layer_;
    }
    /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   * @abstract
   */ handleFontsChanged() {}
    /**
   * Handle changes in image state.
   * @param {import("../events/Event.js").default} event Image change event.
   * @private
   */ handleImageChange_(event) {
        const image = /** @type {import("../Image.js").default} */ event.target;
        if (image.getState() === (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADED || image.getState() === (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).ERROR) this.renderIfReadyAndVisible();
    }
    /**
   * Load the image if not already loaded, and register the image change
   * listener if needed.
   * @param {import("../Image.js").default} image Image.
   * @return {boolean} `true` if the image is already loaded, `false` otherwise.
   * @protected
   */ loadImage(image) {
        let imageState = image.getState();
        if (imageState != (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADED && imageState != (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).ERROR) image.addEventListener((0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CHANGE, this.boundHandleImageChange_);
        if (imageState == (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).IDLE) {
            image.load();
            imageState = image.getState();
        }
        return imageState == (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADED;
    }
    /**
   * @protected
   */ renderIfReadyAndVisible() {
        const layer = this.getLayer();
        if (layer && layer.getVisible() && layer.getSourceState() === 'ready') layer.changed();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */ renderDeferred(frameState) {}
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        delete this.layer_;
        super.disposeInternal();
    }
}
var $9ea74cc865425532$export$2e2bcd8739ae039 = $9ea74cc865425532$var$LayerRenderer;


const $80ebe417992070aa$export$a166f0857c555517 = [];
/**
 * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
 */ let $80ebe417992070aa$var$pixelContext = null;
function $80ebe417992070aa$var$createPixelContext() {
    $80ebe417992070aa$var$pixelContext = (0, $5ce605ba3ee034a0$export$9e05d10eae75c464)(1, 1, undefined, {
        willReadFrequently: true
    });
}
/**
 * @abstract
 * @template {import("../../layer/Layer.js").default} LayerType
 * @extends {LayerRenderer<LayerType>}
 */ class $80ebe417992070aa$var$CanvasLayerRenderer extends (0, $9ea74cc865425532$export$2e2bcd8739ae039) {
    /**
   * @param {LayerType} layer Layer.
   */ constructor(layer){
        super(layer);
        /**
     * HTMLElement container for the layer to be rendered in.
     * @protected
     * @type {HTMLElement}
     */ this.container = null;
        /**
     * @protected
     * @type {number}
     */ this.renderedResolution;
        /**
     * A temporary transform.  The values in this transform should only be used in a
     * function that sets the values.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.tempTransform = (0, $eb597965bdcc8f43$export$185802fd694ee1f5)();
        /**
     * The transform for rendered pixels to viewport CSS pixels.  This transform must
     * be set when rendering a frame and may be used by other functions after rendering.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.pixelTransform = (0, $eb597965bdcc8f43$export$185802fd694ee1f5)();
        /**
     * The transform for viewport CSS pixels to rendered pixels.  This transform must
     * be set when rendering a frame and may be used by other functions after rendering.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.inversePixelTransform = (0, $eb597965bdcc8f43$export$185802fd694ee1f5)();
        /**
     * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
     */ this.context = null;
        /**
     * @private
     * @type {ZIndexContext}
     */ this.deferredContext_ = null;
        /**
     * true if the container has been reused from the previous renderer
     * @type {boolean}
     */ this.containerReused = false;
        /**
     * @protected
     * @type {import("../../Map.js").FrameState|null}
     */ this.frameState = null;
    }
    /**
   * @param {import('../../DataTile.js').ImageLike} image Image.
   * @param {number} col The column index.
   * @param {number} row The row index.
   * @return {Uint8ClampedArray|null} The image data.
   */ getImageData(image, col, row) {
        if (!$80ebe417992070aa$var$pixelContext) $80ebe417992070aa$var$createPixelContext();
        $80ebe417992070aa$var$pixelContext.clearRect(0, 0, 1, 1);
        let data;
        try {
            $80ebe417992070aa$var$pixelContext.drawImage(image, col, row, 1, 1, 0, 0, 1, 1);
            data = $80ebe417992070aa$var$pixelContext.getImageData(0, 0, 1, 1).data;
        } catch  {
            $80ebe417992070aa$var$pixelContext = null;
            return null;
        }
        return data;
    }
    /**
   * @param {import('../../Map.js').FrameState} frameState Frame state.
   * @return {string} Background color.
   */ getBackground(frameState) {
        const layer = this.getLayer();
        let background = layer.getBackground();
        if (typeof background === 'function') background = background(frameState.viewState.resolution);
        return background || undefined;
    }
    /**
   * Get a rendering container from an existing target, if compatible.
   * @param {HTMLElement} target Potential render target.
   * @param {string} transform CSS transform matrix.
   * @param {string} [backgroundColor] Background color.
   */ useContainer(target, transform, backgroundColor) {
        // renderer canvas to target canvas
        const layerClassName = this.getLayer().getClassName();
        let container, context;
        if (target && target.className === layerClassName && (!backgroundColor || target && target.style.backgroundColor && (0, $db525acb5f2517fc$export$e9bab7fafb253603)((0, $6c864c0c7b61b9b5$export$75093a47a9fa838d)(target.style.backgroundColor), (0, $6c864c0c7b61b9b5$export$75093a47a9fa838d)(backgroundColor)))) {
            const canvas = target.firstElementChild;
            if ((0, $5ce605ba3ee034a0$export$4b05d74c82e4c4d2)(canvas)) context = canvas.getContext('2d');
        }
        if (context && (0, $eb597965bdcc8f43$export$fe091d73a555748b)(context.canvas.style.transform, transform)) {
            // Container of the previous layer renderer can be used.
            this.container = target;
            this.context = context;
            this.containerReused = true;
        } else if (this.containerReused) {
            // Previously reused container cannot be used any more.
            this.container = null;
            this.context = null;
            this.containerReused = false;
        } else if (this.container) this.container.style.backgroundColor = null;
        if (!this.container) {
            container = (0, $013e07c1ef6d00ad$export$98fcef3dc9973292) ? (0, $5ce605ba3ee034a0$export$45b7f73d625b5cde)() : document.createElement('div');
            container.className = layerClassName;
            let style = container.style;
            style.position = 'absolute';
            style.width = '100%';
            style.height = '100%';
            context = (0, $5ce605ba3ee034a0$export$9e05d10eae75c464)();
            const canvas = /** @type {HTMLCanvasElement} */ context.canvas;
            container.appendChild(canvas);
            style = canvas.style;
            style.position = 'absolute';
            style.left = '0';
            style.transformOrigin = 'top left';
            this.container = container;
            this.context = context;
        }
        if (!this.containerReused && backgroundColor && !this.container.style.backgroundColor) this.container.style.backgroundColor = backgroundColor;
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../extent.js").Extent} extent Clip extent.
   * @protected
   */ clipUnrotated(context, frameState, extent) {
        const topLeft = (0, $3412ad7bd362b04c$export$cb1538b07e6964ff)(extent);
        const topRight = (0, $3412ad7bd362b04c$export$b84fa077c8b05295)(extent);
        const bottomRight = (0, $3412ad7bd362b04c$export$e77c1cf70445e168)(extent);
        const bottomLeft = (0, $3412ad7bd362b04c$export$8d09f5e2e1bf560d)(extent);
        (0, $eb597965bdcc8f43$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, topLeft);
        (0, $eb597965bdcc8f43$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, topRight);
        (0, $eb597965bdcc8f43$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, bottomRight);
        (0, $eb597965bdcc8f43$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, bottomLeft);
        const inverted = this.inversePixelTransform;
        (0, $eb597965bdcc8f43$export$5635d7ef4b8fee1c)(inverted, topLeft);
        (0, $eb597965bdcc8f43$export$5635d7ef4b8fee1c)(inverted, topRight);
        (0, $eb597965bdcc8f43$export$5635d7ef4b8fee1c)(inverted, bottomRight);
        (0, $eb597965bdcc8f43$export$5635d7ef4b8fee1c)(inverted, bottomLeft);
        context.save();
        context.beginPath();
        context.moveTo(Math.round(topLeft[0]), Math.round(topLeft[1]));
        context.lineTo(Math.round(topRight[0]), Math.round(topRight[1]));
        context.lineTo(Math.round(bottomRight[0]), Math.round(bottomRight[1]));
        context.lineTo(Math.round(bottomLeft[0]), Math.round(bottomLeft[1]));
        context.clip();
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @protected
   */ prepareContainer(frameState, target) {
        const extent = frameState.extent;
        const resolution = frameState.viewState.resolution;
        const rotation = frameState.viewState.rotation;
        const pixelRatio = frameState.pixelRatio;
        const width = Math.round((0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(extent) / resolution * pixelRatio);
        const height = Math.round((0, $3412ad7bd362b04c$export$c08559766941f856)(extent) / resolution * pixelRatio);
        // set forward and inverse pixel transforms
        (0, $eb597965bdcc8f43$export$f672e0b6f7222cd7)(this.pixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / pixelRatio, 1 / pixelRatio, rotation, -width / 2, -height / 2);
        (0, $eb597965bdcc8f43$export$bd70ea2a93c0fa4)(this.inversePixelTransform, this.pixelTransform);
        const canvasTransform = (0, $eb597965bdcc8f43$export$f84e8e69fd4488a5)(this.pixelTransform);
        this.useContainer(target, canvasTransform, this.getBackground(frameState));
        if (!this.containerReused) {
            const canvas = this.context.canvas;
            if (canvas.width != width || canvas.height != height) {
                canvas.width = width;
                canvas.height = height;
            } else this.context.clearRect(0, 0, width, height);
            if (canvasTransform !== /** @type {HTMLCanvasElement} */ canvas.style.transform) /** @type {HTMLCanvasElement} */ canvas.style.transform = canvasTransform;
        }
    }
    /**
   * @param {import("../../render/EventType.js").default} type Event type.
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @private
   */ dispatchRenderEvent_(type, context, frameState) {
        const layer = this.getLayer();
        if (layer.hasListener(type)) {
            const event = new (0, $2df7dd2947499e28$export$2e2bcd8739ae039)(type, this.inversePixelTransform, frameState, context);
            layer.dispatchEvent(event);
        }
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */ preRender(context, frameState) {
        this.frameState = frameState;
        if (frameState.declutter) return;
        this.dispatchRenderEvent_((0, $97affab8a58f0c97$export$2e2bcd8739ae039).PRERENDER, context, frameState);
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */ postRender(context, frameState) {
        if (frameState.declutter) return;
        this.dispatchRenderEvent_((0, $97affab8a58f0c97$export$2e2bcd8739ae039).POSTRENDER, context, frameState);
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   */ renderDeferredInternal(frameState) {}
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import('../../render/canvas/ZIndexContext.js').ZIndexContextProxy} Context.
   */ getRenderContext(frameState) {
        if (frameState.declutter && !this.deferredContext_) this.deferredContext_ = new (0, $4564f3e97d8a38f7$export$2e2bcd8739ae039)();
        return frameState.declutter ? this.deferredContext_.getContext() : this.context;
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @override
   */ renderDeferred(frameState) {
        if (!frameState.declutter) return;
        this.dispatchRenderEvent_((0, $97affab8a58f0c97$export$2e2bcd8739ae039).PRERENDER, this.context, frameState);
        if (frameState.declutter && this.deferredContext_) {
            this.deferredContext_.draw(this.context);
            this.deferredContext_.clear();
        }
        this.renderDeferredInternal(frameState);
        this.dispatchRenderEvent_((0, $97affab8a58f0c97$export$2e2bcd8739ae039).POSTRENDER, this.context, frameState);
    }
    /**
   * Creates a transform for rendering to an element that will be rotated after rendering.
   * @param {import("../../coordinate.js").Coordinate} center Center.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {number} pixelRatio Pixel ratio.
   * @param {number} width Width of the rendered element (in pixels).
   * @param {number} height Height of the rendered element (in pixels).
   * @param {number} offsetX Offset on the x-axis in view coordinates.
   * @protected
   * @return {!import("../../transform.js").Transform} Transform.
   */ getRenderTransform(center, resolution, rotation, pixelRatio, width, height, offsetX) {
        const dx1 = width / 2;
        const dy1 = height / 2;
        const sx = pixelRatio / resolution;
        const sy = -sx;
        const dx2 = -center[0] + offsetX;
        const dy2 = -center[1];
        return (0, $eb597965bdcc8f43$export$f672e0b6f7222cd7)(this.tempTransform, dx1, dy1, sx, sy, -rotation, dx2, dy2);
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        delete this.frameState;
        super.disposeInternal();
    }
}
var $80ebe417992070aa$export$2e2bcd8739ae039 = $80ebe417992070aa$var$CanvasLayerRenderer;


/**
 * @typedef {Object<number, Set<import("../../Tile.js").default>>} TileLookup
 */ /**
 * Add a tile to the lookup.
 * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
 * @param {import("../../Tile.js").default} tile A tile.
 * @param {number} z The zoom level.
 * @return {boolean} The tile was added to the lookup.
 */ function $551edd9f90d397f6$var$addTileToLookup(tilesByZ, tile, z) {
    if (!(z in tilesByZ)) {
        tilesByZ[z] = new Set([
            tile
        ]);
        return true;
    }
    const set = tilesByZ[z];
    const existing = set.has(tile);
    if (!existing) set.add(tile);
    return !existing;
}
/**
 * Remove a tile from the lookup.
 * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
 * @param {import("../../Tile.js").default} tile A tile.
 * @param {number} z The zoom level.
 * @return {boolean} The tile was removed from the lookup.
 */ function $551edd9f90d397f6$var$removeTileFromLookup(tilesByZ, tile, z) {
    const set = tilesByZ[z];
    if (set) return set.delete(tile);
    return false;
}
/**
 * @param {import("../../Map.js").FrameState} frameState Frame state.
 * @param {import("../../extent.js").Extent} extent The frame extent.
 * @return {import("../../extent.js").Extent} Frame extent intersected with layer extents.
 */ function $551edd9f90d397f6$var$getRenderExtent(frameState, extent) {
    const layerState = frameState.layerStatesArray[frameState.layerIndex];
    if (layerState.extent) extent = (0, $3412ad7bd362b04c$export$72209efa88586d42)(extent, (0, $2a998b085c5a7ac9$export$494be3a3a25689ca)(layerState.extent, frameState.viewState.projection));
    const source = /** @type {import("../../source/Tile.js").default} */ layerState.layer.getRenderSource();
    if (!source.getWrapX()) {
        const gridExtent = source.getTileGridForProjection(frameState.viewState.projection).getExtent();
        if (gridExtent) extent = (0, $3412ad7bd362b04c$export$72209efa88586d42)(extent, gridExtent);
    }
    return extent;
}
/**
 * @typedef {Object} Options
 * @property {number} [cacheSize=512] The cache size.
 */ /**
 * @classdesc
 * Canvas renderer for tile layers.
 * @api
 * @template {import("../../layer/Tile.js").default|import("../../layer/VectorTile.js").default} [LayerType=import("../../layer/Tile.js").default<import("../../source/Tile.js").default>|import("../../layer/VectorTile.js").default]
 * @extends {CanvasLayerRenderer<LayerType>}
 */ class $551edd9f90d397f6$var$CanvasTileLayerRenderer extends (0, $80ebe417992070aa$export$2e2bcd8739ae039) {
    /**
   * @param {LayerType} tileLayer Tile layer.
   * @param {Options} [options] Options.
   */ constructor(tileLayer, options){
        super(tileLayer);
        options = options || {};
        /**
     * Rendered extent has changed since the previous `renderFrame()` call
     * @type {boolean}
     */ this.extentChanged = true;
        /**
     * The last call to `renderFrame` was completed with all tiles loaded
     * @type {boolean}
     */ this.renderComplete = false;
        /**
     * @private
     * @type {?import("../../extent.js").Extent}
     */ this.renderedExtent_ = null;
        /**
     * @protected
     * @type {number}
     */ this.renderedPixelRatio;
        /**
     * @protected
     * @type {import("../../proj/Projection.js").default|null}
     */ this.renderedProjection = null;
        /**
     * @protected
     * @type {!Array<import("../../Tile.js").default>}
     */ this.renderedTiles = [];
        /**
     * @private
     * @type {string}
     */ this.renderedSourceKey_;
        /**
     * @private
     * @type {number}
     */ this.renderedSourceRevision_;
        /**
     * @protected
     * @type {import("../../extent.js").Extent}
     */ this.tempExtent = (0, $3412ad7bd362b04c$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {import("../../TileRange.js").default}
     */ this.tempTileRange_ = new (0, $1bd0ced7cb08c615$export$2e2bcd8739ae039)(0, 0, 0, 0);
        /**
     * @type {import("../../tilecoord.js").TileCoord}
     * @private
     */ this.tempTileCoord_ = (0, $3324a006fd485ae2$export$958e3e1a02eac4b6)(0, 0, 0);
        const cacheSize = options.cacheSize !== undefined ? options.cacheSize : 512;
        /**
     * @type {import("../../structs/LRUCache.js").default<import("../../Tile.js").default>}
     * @private
     */ this.tileCache_ = new (0, $248e7c67fdc65d5d$export$2e2bcd8739ae039)(cacheSize);
        /**
     * @type {import("../../structs/LRUCache.js").default<import("../../Tile.js").default|null>}
     * @private
     */ this.sourceTileCache_ = null;
        /**
     * @protected
     * @type {import("../../extent.js").Extent|null}
     */ this.layerExtent = null;
        this.maxStaleKeys = cacheSize * 0.5;
    }
    /**
   * @return {LRUCache} Tile cache.
   */ getTileCache() {
        return this.tileCache_;
    }
    /**
   * @return {LRUCache} Tile cache.
   */ getSourceTileCache() {
        if (!this.sourceTileCache_) this.sourceTileCache_ = new (0, $248e7c67fdc65d5d$export$2e2bcd8739ae039)(512);
        return this.sourceTileCache_;
    }
    /**
   * Get a tile from the cache or create one if needed.
   *
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import("../../Tile.js").default|null} Tile (or null if outside source extent).
   * @protected
   */ getOrCreateTile(z, x, y, frameState) {
        const tileCache = this.tileCache_;
        const tileLayer = this.getLayer();
        const tileSource = tileLayer.getSource();
        const cacheKey = (0, $3324a006fd485ae2$export$611736262b635f8d)(tileSource, tileSource.getKey(), z, x, y);
        /** @type {import("../../Tile.js").default} */ let tile;
        if (tileCache.containsKey(cacheKey)) tile = tileCache.get(cacheKey);
        else {
            const projection = frameState.viewState.projection;
            const sourceProjection = tileSource.getProjection();
            tile = tileSource.getTile(z, x, y, frameState.pixelRatio, projection, !sourceProjection || (0, $2a998b085c5a7ac9$export$fe091d73a555748b)(sourceProjection, projection) ? undefined : this.getSourceTileCache());
            if (!tile) return null;
            tileCache.set(cacheKey, tile);
        }
        return tile;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import("../../Tile.js").default|null} Tile (or null if outside source extent).
   * @protected
   */ getTile(z, x, y, frameState) {
        const tile = this.getOrCreateTile(z, x, y, frameState);
        if (!tile) return null;
        return tile;
    }
    /**
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray} Data at the pixel location.
   * @override
   */ getData(pixel) {
        const frameState = this.frameState;
        if (!frameState) return null;
        const layer = this.getLayer();
        const coordinate = (0, $eb597965bdcc8f43$export$5635d7ef4b8fee1c)(frameState.pixelToCoordinateTransform, pixel.slice());
        const layerExtent = layer.getExtent();
        if (layerExtent) {
            if (!(0, $3412ad7bd362b04c$export$ac68c24d37ca240f)(layerExtent, coordinate)) return null;
        }
        const viewState = frameState.viewState;
        const source = layer.getRenderSource();
        const tileGrid = source.getTileGridForProjection(viewState.projection);
        const tilePixelRatio = source.getTilePixelRatio(frameState.pixelRatio);
        for(let z = tileGrid.getZForResolution(viewState.resolution); z >= tileGrid.getMinZoom(); --z){
            const tileCoord = tileGrid.getTileCoordForCoordAndZ(coordinate, z);
            const tile = this.getTile(z, tileCoord[1], tileCoord[2], frameState);
            if (!tile || tile.getState() !== (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADED) continue;
            const tileOrigin = tileGrid.getOrigin(z);
            const tileSize = (0, $e9727ecf69942748$export$a71a825ff42fb8e1)(tileGrid.getTileSize(z));
            const tileResolution = tileGrid.getResolution(z);
            /**
       * @type {import('../../DataTile.js').ImageLike}
       */ let image;
            if (tile instanceof (0, $cabe2cad606723f7$export$2e2bcd8739ae039) || tile instanceof (0, $5967f4f203a3bc87$export$2e2bcd8739ae039)) image = tile.getImage();
            else if (tile instanceof (0, $b8e5ebdf24076278$export$2e2bcd8739ae039)) {
                image = (0, $b8e5ebdf24076278$export$3a7c913cb40dcb7d)(tile.getData());
                if (!image) continue;
            } else continue;
            const col = Math.floor(tilePixelRatio * ((coordinate[0] - tileOrigin[0]) / tileResolution - tileCoord[1] * tileSize[0]));
            const row = Math.floor(tilePixelRatio * ((tileOrigin[1] - coordinate[1]) / tileResolution - tileCoord[2] * tileSize[1]));
            const gutter = Math.round(tilePixelRatio * source.getGutterForProjection(viewState.projection));
            return this.getImageData(image, col + gutter, row + gutter);
        }
        return null;
    }
    /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   * @override
   */ prepareFrame(frameState) {
        if (!this.renderedProjection) this.renderedProjection = frameState.viewState.projection;
        else if (frameState.viewState.projection !== this.renderedProjection) {
            this.tileCache_.clear();
            this.renderedProjection = frameState.viewState.projection;
        }
        const source = this.getLayer().getSource();
        if (!source) return false;
        const sourceRevision = source.getRevision();
        if (!this.renderedSourceRevision_) this.renderedSourceRevision_ = sourceRevision;
        else if (this.renderedSourceRevision_ !== sourceRevision) {
            this.renderedSourceRevision_ = sourceRevision;
            if (this.renderedSourceKey_ === source.getKey()) {
                this.tileCache_.clear();
                this.sourceTileCache_?.clear();
            }
        }
        return true;
    }
    /**
   * Determine whether tiles for next extent should be enqueued for rendering.
   * @return {boolean} Rendering tiles for next extent is supported.
   * @protected
   */ enqueueTilesForNextExtent() {
        return true;
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../extent.js").Extent} extent The extent to be rendered.
   * @param {number} initialZ The zoom level.
   * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
   * @param {number} preload Number of additional levels to load.
   */ enqueueTiles(frameState, extent, initialZ, tilesByZ, preload) {
        const viewState = frameState.viewState;
        const tileLayer = this.getLayer();
        const tileSource = tileLayer.getRenderSource();
        const tileGrid = tileSource.getTileGridForProjection(viewState.projection);
        const tileSourceKey = (0, $01f1986453243423$export$5e82334337e0f204)(tileSource);
        if (!(tileSourceKey in frameState.wantedTiles)) frameState.wantedTiles[tileSourceKey] = {};
        const wantedTiles = frameState.wantedTiles[tileSourceKey];
        const map = tileLayer.getMapInternal();
        const minZ = Math.max(initialZ - preload, tileGrid.getMinZoom(), tileGrid.getZForResolution(Math.min(tileLayer.getMaxResolution(), map ? map.getView().getResolutionForZoom(Math.max(tileLayer.getMinZoom(), 0)) : tileGrid.getResolution(0)), tileSource.zDirection));
        const rotation = viewState.rotation;
        const viewport = rotation ? (0, $3412ad7bd362b04c$export$4b7a6fb4002cd6ac)(viewState.center, viewState.resolution, rotation, frameState.size) : undefined;
        for(let z = initialZ; z >= minZ; --z){
            const tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z, this.tempTileRange_);
            const tileResolution = tileGrid.getResolution(z);
            for(let x = tileRange.minX; x <= tileRange.maxX; ++x)for(let y = tileRange.minY; y <= tileRange.maxY; ++y){
                if (rotation && !tileGrid.tileCoordIntersectsViewport([
                    z,
                    x,
                    y
                ], viewport)) continue;
                const tile = this.getTile(z, x, y, frameState);
                if (!tile) continue;
                const added = $551edd9f90d397f6$var$addTileToLookup(tilesByZ, tile, z);
                if (!added) continue;
                const tileQueueKey = tile.getKey();
                wantedTiles[tileQueueKey] = true;
                if (tile.getState() === (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).IDLE) {
                    if (!frameState.tileQueue.isKeyQueued(tileQueueKey)) {
                        const tileCoord = (0, $3324a006fd485ae2$export$958e3e1a02eac4b6)(z, x, y, this.tempTileCoord_);
                        frameState.tileQueue.enqueue([
                            tile,
                            tileSourceKey,
                            tileGrid.getTileCoordCenter(tileCoord),
                            tileResolution
                        ]);
                    }
                }
            }
        }
    }
    /**
   * Look for tiles covering the provided tile coordinate at an alternate
   * zoom level.  Loaded tiles will be added to the provided tile texture lookup.
   * @param {import("../../tilecoord.js").TileCoord} tileCoord The target tile coordinate.
   * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
   * @return {boolean} The tile coordinate is covered by loaded tiles at the alternate zoom level.
   * @private
   */ findStaleTile_(tileCoord, tilesByZ) {
        const tileCache = this.tileCache_;
        const z = tileCoord[0];
        const x = tileCoord[1];
        const y = tileCoord[2];
        const staleKeys = this.getStaleKeys();
        for(let i = 0; i < staleKeys.length; ++i){
            const cacheKey = (0, $3324a006fd485ae2$export$611736262b635f8d)(this.getLayer().getSource(), staleKeys[i], z, x, y);
            if (tileCache.containsKey(cacheKey)) {
                const tile = tileCache.peek(cacheKey);
                if (tile.getState() === (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADED) {
                    tile.endTransition((0, $01f1986453243423$export$5e82334337e0f204)(this));
                    $551edd9f90d397f6$var$addTileToLookup(tilesByZ, tile, z);
                    return true;
                }
            }
        }
        return false;
    }
    /**
   * Look for tiles covering the provided tile coordinate at an alternate
   * zoom level.  Loaded tiles will be added to the provided tile texture lookup.
   * @param {import("../../tilegrid/TileGrid.js").default} tileGrid The tile grid.
   * @param {import("../../tilecoord.js").TileCoord} tileCoord The target tile coordinate.
   * @param {number} altZ The alternate zoom level.
   * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
   * @return {boolean} The tile coordinate is covered by loaded tiles at the alternate zoom level.
   * @private
   */ findAltTiles_(tileGrid, tileCoord, altZ, tilesByZ) {
        const tileRange = tileGrid.getTileRangeForTileCoordAndZ(tileCoord, altZ, this.tempTileRange_);
        if (!tileRange) return false;
        let covered = true;
        const tileCache = this.tileCache_;
        const source = this.getLayer().getRenderSource();
        const sourceKey = source.getKey();
        for(let x = tileRange.minX; x <= tileRange.maxX; ++x)for(let y = tileRange.minY; y <= tileRange.maxY; ++y){
            const cacheKey = (0, $3324a006fd485ae2$export$611736262b635f8d)(source, sourceKey, altZ, x, y);
            let loaded = false;
            if (tileCache.containsKey(cacheKey)) {
                const tile = tileCache.peek(cacheKey);
                if (tile.getState() === (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADED) {
                    $551edd9f90d397f6$var$addTileToLookup(tilesByZ, tile, altZ);
                    loaded = true;
                }
            }
            if (!loaded) covered = false;
        }
        return covered;
    }
    /**
   * Render the layer.
   *
   * The frame rendering logic has three parts:
   *
   *  1. Enqueue tiles
   *  2. Find alt tiles for those that are not yet loaded
   *  3. Render loaded tiles
   *
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   * @override
   */ renderFrame(frameState, target) {
        this.renderComplete = true;
        /**
     * TODO:
     *  maybe skip transition when not fully opaque
     *  decide if this.renderComplete is useful
     */ const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const viewState = frameState.viewState;
        const projection = viewState.projection;
        const viewResolution = viewState.resolution;
        const viewCenter = viewState.center;
        const pixelRatio = frameState.pixelRatio;
        const tileLayer = this.getLayer();
        const tileSource = tileLayer.getSource();
        const tileGrid = tileSource.getTileGridForProjection(projection);
        const z = tileGrid.getZForResolution(viewResolution, tileSource.zDirection);
        const tileResolution = tileGrid.getResolution(z);
        const sourceKey = tileSource.getKey();
        if (!this.renderedSourceKey_) this.renderedSourceKey_ = sourceKey;
        else if (this.renderedSourceKey_ !== sourceKey) {
            this.prependStaleKey(this.renderedSourceKey_);
            this.renderedSourceKey_ = sourceKey;
        }
        let frameExtent = frameState.extent;
        const tilePixelRatio = tileSource.getTilePixelRatio(pixelRatio);
        this.prepareContainer(frameState, target);
        // desired dimensions of the canvas in pixels
        const width = this.context.canvas.width;
        const height = this.context.canvas.height;
        this.layerExtent = layerState.extent ? (0, $2a998b085c5a7ac9$export$494be3a3a25689ca)(layerState.extent, projection) : null;
        if (this.layerExtent) frameExtent = (0, $3412ad7bd362b04c$export$72209efa88586d42)(frameExtent, this.layerExtent);
        const dx = tileResolution * width / 2 / tilePixelRatio;
        const dy = tileResolution * height / 2 / tilePixelRatio;
        const canvasExtent = [
            viewCenter[0] - dx,
            viewCenter[1] - dy,
            viewCenter[0] + dx,
            viewCenter[1] + dy
        ];
        /**
     * @type {TileLookup}
     */ const tilesByZ = {};
        this.renderedTiles.length = 0;
        /**
     * Part 1: Enqueue tiles
     */ const preload = tileLayer.getPreload();
        if (frameState.nextExtent && this.enqueueTilesForNextExtent()) {
            const targetZ = tileGrid.getZForResolution(viewState.nextResolution, tileSource.zDirection);
            const nextExtent = $551edd9f90d397f6$var$getRenderExtent(frameState, frameState.nextExtent);
            this.enqueueTiles(frameState, nextExtent, targetZ, tilesByZ, preload);
        }
        const renderExtent = $551edd9f90d397f6$var$getRenderExtent(frameState, frameExtent);
        this.enqueueTiles(frameState, renderExtent, z, tilesByZ, 0);
        if (preload > 0) setTimeout(()=>{
            this.enqueueTiles(frameState, renderExtent, z - 1, tilesByZ, preload - 1);
        }, 0);
        if (!(z in tilesByZ)) return this.container;
        /**
     * Part 2: Find alt tiles for those that are not yet loaded
     */ const uid = (0, $01f1986453243423$export$5e82334337e0f204)(this);
        const time = frameState.time;
        // look for cached tiles to use if a target tile is not ready
        for (const tile of tilesByZ[z]){
            const tileState = tile.getState();
            if (tileState === (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).EMPTY) continue;
            const tileCoord = tile.tileCoord;
            if (tileState === (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADED) {
                const alpha = tile.getAlpha(uid, time);
                if (alpha === 1) {
                    // no need to look for alt tiles
                    tile.endTransition(uid);
                    continue;
                }
            }
            if (tileState !== (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).ERROR) this.renderComplete = false;
            const hasStaleTile = this.findStaleTile_(tileCoord, tilesByZ);
            if (hasStaleTile) {
                // use the stale tile before the new tile's transition has completed
                $551edd9f90d397f6$var$removeTileFromLookup(tilesByZ, tile, z);
                frameState.animate = true;
                continue;
            }
            // first look for child tiles (at z + 1)
            const coveredByChildren = this.findAltTiles_(tileGrid, tileCoord, z + 1, tilesByZ);
            if (coveredByChildren) continue;
            // next look for parent tiles
            const minZoom = tileGrid.getMinZoom();
            for(let parentZ = z - 1; parentZ >= minZoom; --parentZ){
                const coveredByParent = this.findAltTiles_(tileGrid, tileCoord, parentZ, tilesByZ);
                if (coveredByParent) break;
            }
        }
        /**
     * Part 3: Render loaded tiles
     */ const canvasScale = tileResolution / viewResolution * pixelRatio / tilePixelRatio;
        const context = this.getRenderContext(frameState);
        // set scale transform for calculating tile positions on the canvas
        (0, $eb597965bdcc8f43$export$f672e0b6f7222cd7)(this.tempTransform, width / 2, height / 2, canvasScale, canvasScale, 0, -width / 2, -height / 2);
        if (this.layerExtent) this.clipUnrotated(context, frameState, this.layerExtent);
        if (!tileSource.getInterpolate()) context.imageSmoothingEnabled = false;
        this.preRender(context, frameState);
        /** @type {Array<number>} */ const zs = Object.keys(tilesByZ).map(Number);
        zs.sort((0, $db525acb5f2517fc$export$fcb633242ef15540));
        let currentClip;
        const clips = [];
        const clipZs = [];
        for(let i = zs.length - 1; i >= 0; --i){
            const currentZ = zs[i];
            const currentTilePixelSize = tileSource.getTilePixelSize(currentZ, pixelRatio, projection);
            const currentResolution = tileGrid.getResolution(currentZ);
            const currentScale = currentResolution / tileResolution;
            const dx = currentTilePixelSize[0] * currentScale * canvasScale;
            const dy = currentTilePixelSize[1] * currentScale * canvasScale;
            const originTileCoord = tileGrid.getTileCoordForCoordAndZ((0, $3412ad7bd362b04c$export$cb1538b07e6964ff)(canvasExtent), currentZ);
            const originTileExtent = tileGrid.getTileCoordExtent(originTileCoord);
            const origin = (0, $eb597965bdcc8f43$export$5635d7ef4b8fee1c)(this.tempTransform, [
                tilePixelRatio * (originTileExtent[0] - canvasExtent[0]) / tileResolution,
                tilePixelRatio * (canvasExtent[3] - originTileExtent[3]) / tileResolution
            ]);
            const tileGutter = tilePixelRatio * tileSource.getGutterForProjection(projection);
            for (const tile of tilesByZ[currentZ]){
                if (tile.getState() !== (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADED) continue;
                const tileCoord = tile.tileCoord;
                // Calculate integer positions and sizes so that tiles align
                const xIndex = originTileCoord[1] - tileCoord[1];
                const nextX = Math.round(origin[0] - (xIndex - 1) * dx);
                const yIndex = originTileCoord[2] - tileCoord[2];
                const nextY = Math.round(origin[1] - (yIndex - 1) * dy);
                const x = Math.round(origin[0] - xIndex * dx);
                const y = Math.round(origin[1] - yIndex * dy);
                const w = nextX - x;
                const h = nextY - y;
                const transition = zs.length === 1;
                let contextSaved = false;
                // Clip mask for regions in this tile that already filled by a higher z tile
                currentClip = [
                    x,
                    y,
                    x + w,
                    y,
                    x + w,
                    y + h,
                    x,
                    y + h
                ];
                for(let i = 0, ii = clips.length; i < ii; ++i)if (!transition && currentZ < clipZs[i]) {
                    const clip = clips[i];
                    if ((0, $3412ad7bd362b04c$export$7b0a31e10bbff018)([
                        x,
                        y,
                        x + w,
                        y + h
                    ], [
                        clip[0],
                        clip[3],
                        clip[4],
                        clip[7]
                    ])) {
                        if (!contextSaved) {
                            context.save();
                            contextSaved = true;
                        }
                        context.beginPath();
                        // counter-clockwise (outer ring) for current tile
                        context.moveTo(currentClip[0], currentClip[1]);
                        context.lineTo(currentClip[2], currentClip[3]);
                        context.lineTo(currentClip[4], currentClip[5]);
                        context.lineTo(currentClip[6], currentClip[7]);
                        // clockwise (inner ring) for higher z tile
                        context.moveTo(clip[6], clip[7]);
                        context.lineTo(clip[4], clip[5]);
                        context.lineTo(clip[2], clip[3]);
                        context.lineTo(clip[0], clip[1]);
                        context.clip();
                    }
                }
                clips.push(currentClip);
                clipZs.push(currentZ);
                this.drawTile(tile, frameState, x, y, w, h, tileGutter, transition);
                if (contextSaved) context.restore();
                this.renderedTiles.unshift(tile);
                // TODO: decide if this is necessary
                this.updateUsedTiles(frameState.usedTiles, tileSource, tile);
            }
        }
        this.renderedResolution = tileResolution;
        this.extentChanged = !this.renderedExtent_ || !(0, $3412ad7bd362b04c$export$e9bab7fafb253603)(this.renderedExtent_, canvasExtent);
        this.renderedExtent_ = canvasExtent;
        this.renderedPixelRatio = pixelRatio;
        this.postRender(this.context, frameState);
        if (this.layerExtent) context.restore();
        context.imageSmoothingEnabled = true;
        if (this.renderComplete) {
            /**
       * @param {import("../../Map.js").default} map Map.
       * @param {import("../../Map.js").FrameState} frameState Frame state.
       */ const postRenderFunction = (map, frameState)=>{
                const tileSourceKey = (0, $01f1986453243423$export$5e82334337e0f204)(tileSource);
                const wantedTiles = frameState.wantedTiles[tileSourceKey];
                const tilesCount = wantedTiles ? Object.keys(wantedTiles).length : 0;
                this.updateCacheSize(tilesCount);
                this.tileCache_.expireCache();
                this.sourceTileCache_?.expireCache();
            };
            frameState.postRenderFunctions.push(postRenderFunction);
        }
        // this normally is `div.ol-layer` and is a mocked div in worker
        return this.container;
    }
    /**
   * Increases the cache size if needed
   * @param {number} tileCount Minimum number of tiles needed.
   */ updateCacheSize(tileCount) {
        this.tileCache_.highWaterMark = Math.max(this.tileCache_.highWaterMark, tileCount * 2);
    }
    /**
   * @param {import("../../Tile.js").default} tile Tile.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} x Left of the tile.
   * @param {number} y Top of the tile.
   * @param {number} w Width of the tile.
   * @param {number} h Height of the tile.
   * @param {number} gutter Tile gutter.
   * @param {boolean} transition Apply an alpha transition.
   * @protected
   */ drawTile(tile, frameState, x, y, w, h, gutter, transition) {
        let image;
        if (tile instanceof (0, $b8e5ebdf24076278$export$2e2bcd8739ae039)) {
            image = (0, $b8e5ebdf24076278$export$3a7c913cb40dcb7d)(tile.getData());
            if (!image) throw new Error('Rendering array data is not yet supported');
        } else image = this.getTileImage(/** @type {import("../../ImageTile.js").default} */ tile);
        if (!image) return;
        const context = this.getRenderContext(frameState);
        const uid = (0, $01f1986453243423$export$5e82334337e0f204)(this);
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const alpha = layerState.opacity * (transition ? tile.getAlpha(uid, frameState.time) : 1);
        const alphaChanged = alpha !== context.globalAlpha;
        if (alphaChanged) {
            context.save();
            context.globalAlpha = alpha;
        }
        context.drawImage(image, gutter, gutter, image.width - 2 * gutter, image.height - 2 * gutter, x, y, w, h);
        if (alphaChanged) context.restore();
        if (alpha !== layerState.opacity) frameState.animate = true;
        else if (transition) tile.endTransition(uid);
    }
    /**
   * @return {HTMLCanvasElement|OffscreenCanvas} Image
   */ getImage() {
        const context = this.context;
        return context ? context.canvas : null;
    }
    /**
   * Get the image from a tile.
   * @param {import("../../ImageTile.js").default} tile Tile.
   * @return {HTMLCanvasElement|OffscreenCanvas|HTMLImageElement|HTMLVideoElement} Image.
   * @protected
   */ getTileImage(tile) {
        return tile.getImage();
    }
    /**
   * @param {!Object<string, !Object<string, boolean>>} usedTiles Used tiles.
   * @param {import("../../source/Tile.js").default} tileSource Tile source.
   * @param {import('../../Tile.js').default} tile Tile.
   * @protected
   */ updateUsedTiles(usedTiles, tileSource, tile) {
        // FIXME should we use tilesToDrawByZ instead?
        const tileSourceKey = (0, $01f1986453243423$export$5e82334337e0f204)(tileSource);
        if (!(tileSourceKey in usedTiles)) usedTiles[tileSourceKey] = {};
        usedTiles[tileSourceKey][tile.getKey()] = true;
    }
}
var $551edd9f90d397f6$export$2e2bcd8739ae039 = $551edd9f90d397f6$var$CanvasTileLayerRenderer;


/**
 * @module ol/layer/BaseTile
 */ 
/**
 * @module ol/layer/TileProperty
 */ /**
 * @enum {string}
 */ var $c68b61e2cb6b5397$export$2e2bcd8739ae039 = {
    PRELOAD: 'preload',
    USE_INTERIM_TILES_ON_ERROR: 'useInterimTilesOnError'
};


/***
 * @template Return
 * @typedef {import("../Observable.js").OnSignature<import("../Observable.js").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable.js").OnSignature<import("./Base.js").BaseLayerObjectEventTypes|
 *     import("./Layer.js").LayerEventType|'change:preload'|'change:useInterimTilesOnError', import("../Object.js").ObjectEvent, Return> &
 *   import("../Observable.js").OnSignature<import("../render/EventType.js").LayerRenderEventTypes, import("../render/Event.js").default, Return> &
 *   import("../Observable.js").CombinedOnSignature<import("../Observable.js").EventTypes|import("./Base.js").BaseLayerObjectEventTypes|
 *   import("./Layer.js").LayerEventType|'change:preload'|'change:useInterimTilesOnError'|import("../render/EventType.js").LayerRenderEventTypes, Return>} BaseTileLayerOnSignature
 */ /**
 * @template {import("../source/Tile.js").default} TileSourceType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {number} [preload=0] Preload. Load low-resolution tiles up to `preload` levels. `0`
 * means no preloading.
 * @property {TileSourceType} [source] Source for this layer.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link import("../Map.js").default#addLayer map.addLayer()}.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {boolean} [useInterimTilesOnError=true] Deprecated.  Use interim tiles on error.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 * @property {number} [cacheSize=512] The internal tile cache size.  This needs to be large enough to render
 * two zoom levels worth of tiles.
 */ /**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Tile.js").default} TileSourceType
 * @template {import("../renderer/Layer.js").default} RendererType
 * @extends {Layer<TileSourceType, RendererType>}
 * @api
 */ class $d006826f9b36869a$var$BaseTileLayer extends (0, $7bdbe21729fecf84$export$2e2bcd8739ae039) {
    /**
   * @param {Options<TileSourceType>} [options] Tile layer options.
   */ constructor(options){
        options = options ? options : {};
        const baseOptions = Object.assign({}, options);
        const cacheSize = options.cacheSize;
        delete options.cacheSize;
        delete baseOptions.preload;
        delete baseOptions.useInterimTilesOnError;
        super(baseOptions);
        /***
     * @type {BaseTileLayerOnSignature<import("../events.js").EventsKey>}
     */ this.on;
        /***
     * @type {BaseTileLayerOnSignature<import("../events.js").EventsKey>}
     */ this.once;
        /***
     * @type {BaseTileLayerOnSignature<void>}
     */ this.un;
        /**
     * @type {number|undefined}
     * @private
     */ this.cacheSize_ = cacheSize;
        this.setPreload(options.preload !== undefined ? options.preload : 0);
        this.setUseInterimTilesOnError(options.useInterimTilesOnError !== undefined ? options.useInterimTilesOnError : true);
    }
    /**
   * @return {number|undefined} The suggested cache size
   * @protected
   */ getCacheSize() {
        return this.cacheSize_;
    }
    /**
   * Return the level as number to which we will preload tiles up to.
   * @return {number} The level to preload tiles up to.
   * @observable
   * @api
   */ getPreload() {
        return /** @type {number} */ this.get((0, $c68b61e2cb6b5397$export$2e2bcd8739ae039).PRELOAD);
    }
    /**
   * Set the level as number to which we will preload tiles up to.
   * @param {number} preload The level to preload tiles up to.
   * @observable
   * @api
   */ setPreload(preload) {
        this.set((0, $c68b61e2cb6b5397$export$2e2bcd8739ae039).PRELOAD, preload);
    }
    /**
   * Deprecated.  Whether we use interim tiles on error.
   * @return {boolean} Use interim tiles on error.
   * @observable
   * @api
   */ getUseInterimTilesOnError() {
        return /** @type {boolean} */ this.get((0, $c68b61e2cb6b5397$export$2e2bcd8739ae039).USE_INTERIM_TILES_ON_ERROR);
    }
    /**
   * Deprecated.  Set whether we use interim tiles on error.
   * @param {boolean} useInterimTilesOnError Use interim tiles on error.
   * @observable
   * @api
   */ setUseInterimTilesOnError(useInterimTilesOnError) {
        this.set((0, $c68b61e2cb6b5397$export$2e2bcd8739ae039).USE_INTERIM_TILES_ON_ERROR, useInterimTilesOnError);
    }
    /**
   * Get data for a pixel location.  The return type depends on the source data.  For image tiles,
   * a four element RGBA array will be returned.  For data tiles, the array length will match the
   * number of bands in the dataset.  For requests outside the layer extent, `null` will be returned.
   * Data for a image tiles can only be retrieved if the source's `crossOrigin` property is set.
   *
   * ```js
   * // display layer data on every pointer move
   * map.on('pointermove', (event) => {
   *   console.log(layer.getData(event.pixel));
   * });
   * ```
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   * @api
   * @override
   */ getData(pixel) {
        return super.getData(pixel);
    }
}
var $d006826f9b36869a$export$2e2bcd8739ae039 = $d006826f9b36869a$var$BaseTileLayer;


/**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Tile.js").default} [TileSourceType=import("../source/Tile.js").default]
 * @extends BaseTileLayer<TileSourceType, CanvasTileLayerRenderer>
 * @api
 */ class $356faab3821ea36b$var$TileLayer extends (0, $d006826f9b36869a$export$2e2bcd8739ae039) {
    /**
   * @param {import("./BaseTile.js").Options<TileSourceType>} [options] Tile layer options.
   */ constructor(options){
        super(options);
    }
    /**
   * @override
   */ createRenderer() {
        return new (0, $551edd9f90d397f6$export$2e2bcd8739ae039)(this, {
            cacheSize: this.getCacheSize()
        });
    }
}
var $356faab3821ea36b$export$2e2bcd8739ae039 = $356faab3821ea36b$var$TileLayer;


/**
 * @module ol/layer/Vector
 */ /**
 * @module ol/renderer/canvas/VectorLayer
 */ 






/**
 * @module ol/render/canvas/BuilderGroup
 */ /**
 * @module ol/render/canvas/Builder
 */ 




/**
 * @module ol/render/VectorContext
 */ /**
 * @classdesc
 * Context for drawing geometries.  A vector context is available on render
 * events and does not need to be constructed directly.
 * @api
 */ class $b070ce327ce37de2$var$VectorContext {
    /**
   * Render a geometry with a custom renderer.
   *
   * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {Function} renderer Renderer.
   * @param {Function} hitDetectionRenderer Renderer.
   * @param {number} [index] Render order index.
   */ drawCustom(geometry, feature, renderer, hitDetectionRenderer, index) {}
    /**
   * Render a geometry.
   *
   * @param {import("../geom/Geometry.js").default} geometry The geometry to render.
   */ drawGeometry(geometry) {}
    /**
   * Set the rendering style.
   *
   * @param {import("../style/Style.js").default} style The rendering style.
   */ setStyle(style) {}
    /**
   * @param {import("../geom/Circle.js").default} circleGeometry Circle geometry.
   * @param {import("../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   */ drawCircle(circleGeometry, feature, index) {}
    /**
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("../style/Style.js").default} style Style.
   * @param {number} [index] Render order index.
   */ drawFeature(feature, style, index) {}
    /**
   * @param {import("../geom/GeometryCollection.js").default} geometryCollectionGeometry Geometry collection.
   * @param {import("../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   */ drawGeometryCollection(geometryCollectionGeometry, feature, index) {}
    /**
   * @param {import("../geom/LineString.js").default|import("./Feature.js").default} lineStringGeometry Line string geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawLineString(lineStringGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiLineString.js").default|import("./Feature.js").default} multiLineStringGeometry MultiLineString geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiLineString(multiLineStringGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiPoint.js").default|import("./Feature.js").default} multiPointGeometry MultiPoint geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiPoint(multiPointGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiPolygon(multiPolygonGeometry, feature, index) {}
    /**
   * @param {import("../geom/Point.js").default|import("./Feature.js").default} pointGeometry Point geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawPoint(pointGeometry, feature, index) {}
    /**
   * @param {import("../geom/Polygon.js").default|import("./Feature.js").default} polygonGeometry Polygon geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawPolygon(polygonGeometry, feature, index) {}
    /**
   * @param {import("../geom/SimpleGeometry.js").default|import("./Feature.js").default} geometry Geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawText(geometry, feature, index) {}
    /**
   * @param {import("../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../style/Stroke.js").default} strokeStyle Stroke style.
   */ setFillStrokeStyle(fillStyle, strokeStyle) {}
    /**
   * @param {import("../style/Image.js").default} imageStyle Image style.
   * @param {import("../render/canvas.js").DeclutterImageWithText} [declutterImageWithText] Shared data for combined decluttering with a text style.
   */ setImageStyle(imageStyle, declutterImageWithText) {}
    /**
   * @param {import("../style/Text.js").default} textStyle Text style.
   * @param {import("../render/canvas.js").DeclutterImageWithText} [declutterImageWithText] Shared data for combined decluttering with an image style.
   */ setTextStyle(textStyle, declutterImageWithText) {}
}
var $b070ce327ce37de2$export$2e2bcd8739ae039 = $b070ce327ce37de2$var$VectorContext;



/**
 * @module ol/render/canvas/Instruction
 */ /**
 * @enum {number}
 */ const $64d2b9bf11c0008d$var$Instruction = {
    BEGIN_GEOMETRY: 0,
    BEGIN_PATH: 1,
    CIRCLE: 2,
    CLOSE_PATH: 3,
    CUSTOM: 4,
    DRAW_CHARS: 5,
    DRAW_IMAGE: 6,
    END_GEOMETRY: 7,
    FILL: 8,
    MOVE_TO_LINE_TO: 9,
    SET_FILL_STYLE: 10,
    SET_STROKE_STYLE: 11,
    STROKE: 12
};
const $64d2b9bf11c0008d$export$f21891651e408226 = [
    $64d2b9bf11c0008d$var$Instruction.FILL
];
const $64d2b9bf11c0008d$export$7a98aa5364d62ba8 = [
    $64d2b9bf11c0008d$var$Instruction.STROKE
];
const $64d2b9bf11c0008d$export$9f746cc58a899a00 = [
    $64d2b9bf11c0008d$var$Instruction.BEGIN_PATH
];
const $64d2b9bf11c0008d$export$89b10f327e413e71 = [
    $64d2b9bf11c0008d$var$Instruction.CLOSE_PATH
];
var $64d2b9bf11c0008d$export$2e2bcd8739ae039 = $64d2b9bf11c0008d$var$Instruction;


class $17f0c3c0104ebc6a$var$CanvasBuilder extends (0, $b070ce327ce37de2$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super();
        /**
     * @protected
     * @type {number}
     */ this.tolerance = tolerance;
        /**
     * @protected
     * @const
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent = maxExtent;
        /**
     * @protected
     * @type {number}
     */ this.pixelRatio = pixelRatio;
        /**
     * @protected
     * @type {number}
     */ this.maxLineWidth = 0;
        /**
     * @protected
     * @const
     * @type {number}
     */ this.resolution = resolution;
        /**
     * @private
     * @type {Array<*>}
     */ this.beginGeometryInstruction1_ = null;
        /**
     * @private
     * @type {Array<*>}
     */ this.beginGeometryInstruction2_ = null;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.bufferedMaxExtent_ = null;
        /**
     * @protected
     * @type {Array<*>}
     */ this.instructions = [];
        /**
     * @protected
     * @type {Array<number>}
     */ this.coordinates = [];
        /**
     * @private
     * @type {import("../../coordinate.js").Coordinate}
     */ this.tmpCoordinate_ = [];
        /**
     * @protected
     * @type {Array<*>}
     */ this.hitDetectionInstructions = [];
        /**
     * @protected
     * @type {import("../canvas.js").FillStrokeState}
     */ this.state = /** @type {import("../canvas.js").FillStrokeState} */ {};
    }
    /**
   * @protected
   * @param {Array<number>} dashArray Dash array.
   * @return {Array<number>} Dash array with pixel ratio applied
   */ applyPixelRatio(dashArray) {
        const pixelRatio = this.pixelRatio;
        return pixelRatio == 1 ? dashArray : dashArray.map(function(dash) {
            return dash * pixelRatio;
        });
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} stride Stride.
   * @protected
   * @return {number} My end
   */ appendFlatPointCoordinates(flatCoordinates, stride) {
        const extent = this.getBufferedMaxExtent();
        const tmpCoord = this.tmpCoordinate_;
        const coordinates = this.coordinates;
        let myEnd = coordinates.length;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            tmpCoord[0] = flatCoordinates[i];
            tmpCoord[1] = flatCoordinates[i + 1];
            if ((0, $3412ad7bd362b04c$export$ac68c24d37ca240f)(extent, tmpCoord)) {
                coordinates[myEnd++] = tmpCoord[0];
                coordinates[myEnd++] = tmpCoord[1];
            }
        }
        return myEnd;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} closed Last input coordinate equals first.
   * @param {boolean} skipFirst Skip first coordinate.
   * @protected
   * @return {number} My end.
   */ appendFlatLineCoordinates(flatCoordinates, offset, end, stride, closed, skipFirst) {
        const coordinates = this.coordinates;
        let myEnd = coordinates.length;
        const extent = this.getBufferedMaxExtent();
        if (skipFirst) offset += stride;
        let lastXCoord = flatCoordinates[offset];
        let lastYCoord = flatCoordinates[offset + 1];
        const nextCoord = this.tmpCoordinate_;
        let skipped = true;
        let i, lastRel, nextRel;
        for(i = offset + stride; i < end; i += stride){
            nextCoord[0] = flatCoordinates[i];
            nextCoord[1] = flatCoordinates[i + 1];
            nextRel = (0, $3412ad7bd362b04c$export$f97905ead28c61a8)(extent, nextCoord);
            if (nextRel !== lastRel) {
                if (skipped) {
                    coordinates[myEnd++] = lastXCoord;
                    coordinates[myEnd++] = lastYCoord;
                    skipped = false;
                }
                coordinates[myEnd++] = nextCoord[0];
                coordinates[myEnd++] = nextCoord[1];
            } else if (nextRel === (0, $c5827132adbdcac8$export$2e2bcd8739ae039).INTERSECTING) {
                coordinates[myEnd++] = nextCoord[0];
                coordinates[myEnd++] = nextCoord[1];
                skipped = false;
            } else skipped = true;
            lastXCoord = nextCoord[0];
            lastYCoord = nextCoord[1];
            lastRel = nextRel;
        }
        // Last coordinate equals first or only one point to append:
        if (closed && skipped || i === offset + stride) {
            coordinates[myEnd++] = lastXCoord;
            coordinates[myEnd++] = lastYCoord;
        }
        return myEnd;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {Array<number>} builderEnds Builder ends.
   * @return {number} Offset.
   */ drawCustomCoordinates_(flatCoordinates, offset, ends, stride, builderEnds) {
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const builderEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
            builderEnds.push(builderEnd);
            offset = end;
        }
        return offset;
    }
    /**
   * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {Function} renderer Renderer.
   * @param {Function} hitDetectionRenderer Renderer.
   * @param {number} [index] Render order index.
   * @override
   */ drawCustom(geometry, feature, renderer, hitDetectionRenderer, index) {
        this.beginGeometry(geometry, feature, index);
        const type = geometry.getType();
        const stride = geometry.getStride();
        const builderBegin = this.coordinates.length;
        let flatCoordinates, builderEnd, builderEnds, builderEndss;
        let offset;
        switch(type){
            case 'MultiPolygon':
                flatCoordinates = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getOrientedFlatCoordinates();
                builderEndss = [];
                const endss = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getEndss();
                offset = 0;
                for(let i = 0, ii = endss.length; i < ii; ++i){
                    const myEnds = [];
                    offset = this.drawCustomCoordinates_(flatCoordinates, offset, endss[i], stride, myEnds);
                    builderEndss.push(myEnds);
                }
                this.instructions.push([
                    (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEndss,
                    geometry,
                    renderer,
                    (0, $1ffceb5bb486dffd$export$915c7058aeb4dfeb),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEndss,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $1ffceb5bb486dffd$export$915c7058aeb4dfeb),
                    index
                ]);
                break;
            case 'Polygon':
            case 'MultiLineString':
                builderEnds = [];
                flatCoordinates = type == 'Polygon' ? /** @type {import("../../geom/Polygon.js").default} */ geometry.getOrientedFlatCoordinates() : geometry.getFlatCoordinates();
                offset = this.drawCustomCoordinates_(flatCoordinates, 0, /** @type {import("../../geom/Polygon.js").default|import("../../geom/MultiLineString.js").default} */ geometry.getEnds(), stride, builderEnds);
                this.instructions.push([
                    (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnds,
                    geometry,
                    renderer,
                    (0, $1ffceb5bb486dffd$export$cbb9596fc0f40db2),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnds,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $1ffceb5bb486dffd$export$cbb9596fc0f40db2),
                    index
                ]);
                break;
            case 'LineString':
            case 'Circle':
                flatCoordinates = geometry.getFlatCoordinates();
                builderEnd = this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
                this.instructions.push([
                    (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    renderer,
                    (0, $1ffceb5bb486dffd$export$9c0934e4e9c3f61e),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $1ffceb5bb486dffd$export$9c0934e4e9c3f61e),
                    index
                ]);
                break;
            case 'MultiPoint':
                flatCoordinates = geometry.getFlatCoordinates();
                builderEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
                if (builderEnd > builderBegin) {
                    this.instructions.push([
                        (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).CUSTOM,
                        builderBegin,
                        builderEnd,
                        geometry,
                        renderer,
                        (0, $1ffceb5bb486dffd$export$9c0934e4e9c3f61e),
                        index
                    ]);
                    this.hitDetectionInstructions.push([
                        (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).CUSTOM,
                        builderBegin,
                        builderEnd,
                        geometry,
                        hitDetectionRenderer || renderer,
                        (0, $1ffceb5bb486dffd$export$9c0934e4e9c3f61e),
                        index
                    ]);
                }
                break;
            case 'Point':
                flatCoordinates = geometry.getFlatCoordinates();
                this.coordinates.push(flatCoordinates[0], flatCoordinates[1]);
                builderEnd = this.coordinates.length;
                this.instructions.push([
                    (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    renderer,
                    undefined,
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    hitDetectionRenderer || renderer,
                    undefined,
                    index
                ]);
                break;
            default:
        }
        this.endGeometry(feature);
    }
    /**
   * @protected
   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry The geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} index Render order index
   */ beginGeometry(geometry, feature, index) {
        this.beginGeometryInstruction1_ = [
            (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).BEGIN_GEOMETRY,
            feature,
            0,
            geometry,
            index
        ];
        this.instructions.push(this.beginGeometryInstruction1_);
        this.beginGeometryInstruction2_ = [
            (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).BEGIN_GEOMETRY,
            feature,
            0,
            geometry,
            index
        ];
        this.hitDetectionInstructions.push(this.beginGeometryInstruction2_);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */ finish() {
        return {
            instructions: this.instructions,
            hitDetectionInstructions: this.hitDetectionInstructions,
            coordinates: this.coordinates
        };
    }
    /**
   * Reverse the hit detection instructions.
   */ reverseHitDetectionInstructions() {
        const hitDetectionInstructions = this.hitDetectionInstructions;
        // step 1 - reverse array
        hitDetectionInstructions.reverse();
        // step 2 - reverse instructions within geometry blocks
        let i;
        const n = hitDetectionInstructions.length;
        let instruction;
        let type;
        let begin = -1;
        for(i = 0; i < n; ++i){
            instruction = hitDetectionInstructions[i];
            type = /** @type {import("./Instruction.js").default} */ instruction[0];
            if (type == (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).END_GEOMETRY) begin = i;
            else if (type == (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).BEGIN_GEOMETRY) {
                instruction[2] = i;
                (0, $db525acb5f2517fc$export$292cfa960964f0e0)(this.hitDetectionInstructions, begin, i);
                begin = -1;
            }
        }
    }
    /**
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import('../canvas.js').FillStrokeState} [state] State.
   * @return {import('../canvas.js').FillStrokeState} State.
   */ fillStyleToState(fillStyle, state = /** @type {import('../canvas.js').FillStrokeState} */ {}) {
        if (fillStyle) {
            const fillStyleColor = fillStyle.getColor();
            state.fillPatternScale = fillStyleColor && typeof fillStyleColor === 'object' && 'src' in fillStyleColor ? this.pixelRatio : 1;
            state.fillStyle = (0, $bafa252a4f4b168a$export$dc5b1400ac3a10a8)(fillStyleColor ? fillStyleColor : (0, $3b9b2e731b8ee924$export$c495d52ee3fd74b2)) ?? undefined;
        } else state.fillStyle = undefined;
        return state;
    }
    /**
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {import("../canvas.js").FillStrokeState} State.
   */ strokeStyleToState(strokeStyle, state = /** @type {import('../canvas.js').FillStrokeState} */ {}) {
        if (strokeStyle) {
            const strokeStyleColor = strokeStyle.getColor();
            state.strokeStyle = (0, $bafa252a4f4b168a$export$dc5b1400ac3a10a8)(strokeStyleColor ? strokeStyleColor : (0, $3b9b2e731b8ee924$export$1eb2eaecacf2031e));
            const strokeStyleLineCap = strokeStyle.getLineCap();
            state.lineCap = strokeStyleLineCap !== undefined ? strokeStyleLineCap : (0, $3b9b2e731b8ee924$export$17bd0c38d6ae694e);
            const strokeStyleLineDash = strokeStyle.getLineDash();
            state.lineDash = strokeStyleLineDash ? strokeStyleLineDash.slice() : (0, $3b9b2e731b8ee924$export$e21b4112fdc612fc);
            const strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
            state.lineDashOffset = strokeStyleLineDashOffset ? strokeStyleLineDashOffset : (0, $3b9b2e731b8ee924$export$e06efc2409049f76);
            const strokeStyleLineJoin = strokeStyle.getLineJoin();
            state.lineJoin = strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : (0, $3b9b2e731b8ee924$export$365eb9648cf19bd0);
            const strokeStyleWidth = strokeStyle.getWidth();
            state.lineWidth = strokeStyleWidth !== undefined ? strokeStyleWidth : (0, $3b9b2e731b8ee924$export$79661f132c62010e);
            const strokeStyleMiterLimit = strokeStyle.getMiterLimit();
            state.miterLimit = strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : (0, $3b9b2e731b8ee924$export$80c1c01844597b7b);
            const strokeStyleOffset = strokeStyle.getOffset();
            state.strokeOffset = strokeStyleOffset ?? (0, $3b9b2e731b8ee924$export$e010c2b9c075c7a1);
            if (state.lineWidth > this.maxLineWidth) {
                this.maxLineWidth = state.lineWidth;
                // invalidate the buffered max extent cache
                this.bufferedMaxExtent_ = null;
            }
        } else {
            state.strokeStyle = undefined;
            state.lineCap = undefined;
            state.lineDash = null;
            state.lineDashOffset = undefined;
            state.lineJoin = undefined;
            state.lineWidth = undefined;
            state.miterLimit = undefined;
            state.strokeOffset = undefined;
        }
        return state;
    }
    /**
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   * @override
   */ setFillStrokeStyle(fillStyle, strokeStyle) {
        const state = this.state;
        this.fillStyleToState(fillStyle, state);
        this.strokeStyleToState(strokeStyle, state);
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {Array<*>} Fill instruction.
   */ createFill(state) {
        const fillStyle = state.fillStyle;
        /** @type {Array<*>} */ const fillInstruction = [
            (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).SET_FILL_STYLE,
            fillStyle
        ];
        if (typeof fillStyle !== 'string') // Fill is a pattern or gradient - align and scale it!
        fillInstruction.push(state.fillPatternScale);
        return fillInstruction;
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   */ applyStroke(state) {
        this.instructions.push(this.createStroke(state));
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {Array<*>} Stroke instruction.
   */ createStroke(state) {
        return [
            (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth * this.pixelRatio,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            state.lineDash ? this.applyPixelRatio(state.lineDash) : null,
            state.lineDashOffset * this.pixelRatio
        ];
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState):Array<*>} createFill Create fill.
   */ updateFillStyle(state, createFill) {
        const fillStyle = state.fillStyle;
        if (fillStyle !== undefined && typeof fillStyle !== 'string' || state.currentFillStyle != fillStyle) {
            this.instructions.push(createFill.call(this, state));
            state.currentFillStyle = fillStyle;
        }
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState): void} applyStroke Apply stroke.
   */ updateStrokeStyle(state, applyStroke) {
        const strokeStyle = state.strokeStyle;
        const lineCap = state.lineCap;
        const lineDash = state.lineDash;
        const lineDashOffset = state.lineDashOffset;
        const lineJoin = state.lineJoin;
        const lineWidth = state.lineWidth;
        const miterLimit = state.miterLimit;
        const strokeOffset = state.strokeOffset;
        if (state.currentStrokeStyle != strokeStyle || state.currentLineCap != lineCap || lineDash != state.currentLineDash && !(0, $db525acb5f2517fc$export$e9bab7fafb253603)(state.currentLineDash, lineDash) || state.currentLineDashOffset != lineDashOffset || state.currentLineJoin != lineJoin || state.currentLineWidth != lineWidth || state.currentMiterLimit != miterLimit || state.currentStrokeOffset != strokeOffset) {
            applyStroke.call(this, state);
            state.currentStrokeStyle = strokeStyle;
            state.currentLineCap = lineCap;
            state.currentLineDash = lineDash;
            state.currentLineDashOffset = lineDashOffset;
            state.currentLineJoin = lineJoin;
            state.currentLineWidth = lineWidth;
            state.currentMiterLimit = miterLimit;
            state.currentStrokeOffset = strokeOffset;
        }
    }
    /**
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */ endGeometry(feature) {
        this.beginGeometryInstruction1_[2] = this.instructions.length;
        this.beginGeometryInstruction1_ = null;
        this.beginGeometryInstruction2_[2] = this.hitDetectionInstructions.length;
        this.beginGeometryInstruction2_ = null;
        const endGeometryInstruction = [
            (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).END_GEOMETRY,
            feature
        ];
        this.instructions.push(endGeometryInstruction);
        this.hitDetectionInstructions.push(endGeometryInstruction);
    }
    /**
   * Get the buffered rendering extent.  Rendering will be clipped to the extent
   * provided to the constructor.  To account for symbolizers that may intersect
   * this extent, we calculate a buffered extent (e.g. based on stroke width).
   * @return {import("../../extent.js").Extent} The buffered rendering extent.
   * @protected
   */ getBufferedMaxExtent() {
        if (!this.bufferedMaxExtent_) {
            this.bufferedMaxExtent_ = (0, $3412ad7bd362b04c$export$9cd59f9826255e47)(this.maxExtent);
            if (this.maxLineWidth > 0) {
                const width = this.resolution * (this.maxLineWidth + 1) / 2;
                (0, $3412ad7bd362b04c$export$ab1029bcae9ddb4a)(this.bufferedMaxExtent_, width, this.bufferedMaxExtent_);
            }
        }
        return this.bufferedMaxExtent_;
    }
}
var $17f0c3c0104ebc6a$export$2e2bcd8739ae039 = $17f0c3c0104ebc6a$var$CanvasBuilder;


/**
 * @module ol/render/canvas/ImageBuilder
 */ 


class $253a14ffee595604$var$CanvasImageBuilder extends (0, $17f0c3c0104ebc6a$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.hitDetectionImage_ = null;
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.image_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.imagePixelRatio_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.anchorX_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.anchorY_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.height_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.opacity_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.originX_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.originY_ = undefined;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.rotateWithView_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = undefined;
        /**
     * @private
     * @type {import("../../size.js").Size|undefined}
     */ this.scale_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.width_ = undefined;
        /**
     * @private
     * @type {import('../../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = undefined;
        /**
     * Data shared with a text builder for combined decluttering.
     * @private
     * @type {import("../canvas.js").DeclutterImageWithText}
     */ this.declutterImageWithText_ = undefined;
    }
    /**
   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} pointGeometry Point geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawPoint(pointGeometry, feature, index) {
        if (!this.image_ || this.maxExtent && !(0, $3412ad7bd362b04c$export$ac68c24d37ca240f)(this.maxExtent, pointGeometry.getFlatCoordinates())) return;
        this.beginGeometry(pointGeometry, feature, index);
        const flatCoordinates = pointGeometry.getFlatCoordinates();
        const stride = pointGeometry.getStride();
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
        this.instructions.push([
            (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.image_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_ * this.imagePixelRatio_,
            this.anchorY_ * this.imagePixelRatio_,
            Math.ceil(this.height_ * this.imagePixelRatio_),
            this.opacity_,
            this.originX_ * this.imagePixelRatio_,
            this.originY_ * this.imagePixelRatio_,
            this.rotateWithView_,
            this.rotation_,
            [
                this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
                this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
            ],
            Math.ceil(this.width_ * this.imagePixelRatio_),
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.hitDetectionInstructions.push([
            (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.hitDetectionImage_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.height_,
            1,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_,
            this.width_,
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} multiPointGeometry MultiPoint geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawMultiPoint(multiPointGeometry, feature, index) {
        if (!this.image_) return;
        this.beginGeometry(multiPointGeometry, feature, index);
        const flatCoordinates = multiPointGeometry.getFlatCoordinates();
        const filteredFlatCoordinates = [];
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += multiPointGeometry.getStride())if (!this.maxExtent || (0, $3412ad7bd362b04c$export$ac68c24d37ca240f)(this.maxExtent, flatCoordinates.slice(i, i + 2))) filteredFlatCoordinates.push(flatCoordinates[i], flatCoordinates[i + 1]);
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatPointCoordinates(filteredFlatCoordinates, 2);
        this.instructions.push([
            (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.image_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_ * this.imagePixelRatio_,
            this.anchorY_ * this.imagePixelRatio_,
            Math.ceil(this.height_ * this.imagePixelRatio_),
            this.opacity_,
            this.originX_ * this.imagePixelRatio_,
            this.originY_ * this.imagePixelRatio_,
            this.rotateWithView_,
            this.rotation_,
            [
                this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
                this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
            ],
            Math.ceil(this.width_ * this.imagePixelRatio_),
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.hitDetectionInstructions.push([
            (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.hitDetectionImage_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.height_,
            1,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_,
            this.width_,
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        this.reverseHitDetectionInstructions();
        // FIXME this doesn't really protect us against further calls to draw*Geometry
        this.anchorX_ = undefined;
        this.anchorY_ = undefined;
        this.hitDetectionImage_ = null;
        this.image_ = null;
        this.imagePixelRatio_ = undefined;
        this.height_ = undefined;
        this.scale_ = undefined;
        this.opacity_ = undefined;
        this.originX_ = undefined;
        this.originY_ = undefined;
        this.rotateWithView_ = undefined;
        this.rotation_ = undefined;
        this.width_ = undefined;
        return super.finish();
    }
    /**
   * @param {import("../../style/Image.js").default} imageStyle Image style.
   * @param {Object} [sharedData] Shared data.
   * @override
   */ setImageStyle(imageStyle, sharedData) {
        const anchor = imageStyle.getAnchor();
        const size = imageStyle.getSize();
        const origin = imageStyle.getOrigin();
        this.imagePixelRatio_ = imageStyle.getPixelRatio(this.pixelRatio);
        this.anchorX_ = anchor[0];
        this.anchorY_ = anchor[1];
        this.hitDetectionImage_ = imageStyle.getHitDetectionImage();
        this.image_ = imageStyle.getImage(this.pixelRatio);
        this.height_ = size[1];
        this.opacity_ = imageStyle.getOpacity();
        this.originX_ = origin[0];
        this.originY_ = origin[1];
        this.rotateWithView_ = imageStyle.getRotateWithView();
        this.rotation_ = imageStyle.getRotation();
        this.scale_ = imageStyle.getScaleArray();
        this.width_ = size[0];
        this.declutterMode_ = imageStyle.getDeclutterMode();
        this.declutterImageWithText_ = sharedData;
    }
}
var $253a14ffee595604$export$2e2bcd8739ae039 = $253a14ffee595604$var$CanvasImageBuilder;


/**
 * @module ol/render/canvas/LineStringBuilder
 */ 


class $e38e5fd965383c8e$var$CanvasLineStringBuilder extends (0, $17f0c3c0104ebc6a$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {number} [strokeOffset] Stroke Offset in pixels.
   * @private
   * @return {number} end.
   */ drawFlatCoordinates_(flatCoordinates, offset, end, stride, strokeOffset) {
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
        this.instructions.push([
            (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).MOVE_TO_LINE_TO,
            myBegin,
            myEnd,
            strokeOffset * this.pixelRatio
        ]);
        this.hitDetectionInstructions.push([
            (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).MOVE_TO_LINE_TO,
            myBegin,
            myEnd,
            strokeOffset
        ]);
        return end;
    }
    /**
   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} lineStringGeometry Line string geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawLineString(lineStringGeometry, feature, index) {
        const state = this.state;
        const strokeStyle = state.strokeStyle;
        const lineWidth = state.lineWidth;
        const strokeOffset = state.strokeOffset;
        if (strokeStyle === undefined || lineWidth === undefined) return;
        this.updateStrokeStyle(state, this.applyStroke);
        this.beginGeometry(lineStringGeometry, feature, index);
        this.hitDetectionInstructions.push([
            (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            (0, $3b9b2e731b8ee924$export$1eb2eaecacf2031e),
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $3b9b2e731b8ee924$export$e21b4112fdc612fc),
            (0, $3b9b2e731b8ee924$export$e06efc2409049f76)
        ], (0, $64d2b9bf11c0008d$export$9f746cc58a899a00));
        const flatCoordinates = lineStringGeometry.getFlatCoordinates();
        const stride = lineStringGeometry.getStride();
        this.drawFlatCoordinates_(flatCoordinates, 0, flatCoordinates.length, stride, strokeOffset);
        this.hitDetectionInstructions.push((0, $64d2b9bf11c0008d$export$7a98aa5364d62ba8));
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} multiLineStringGeometry MultiLineString geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawMultiLineString(multiLineStringGeometry, feature, index) {
        const state = this.state;
        const strokeStyle = state.strokeStyle;
        const lineWidth = state.lineWidth;
        const strokeOffset = state.strokeOffset;
        if (strokeStyle === undefined || lineWidth === undefined) return;
        this.updateStrokeStyle(state, this.applyStroke);
        this.beginGeometry(multiLineStringGeometry, feature, index);
        this.hitDetectionInstructions.push([
            (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            (0, $3b9b2e731b8ee924$export$1eb2eaecacf2031e),
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $3b9b2e731b8ee924$export$e21b4112fdc612fc),
            (0, $3b9b2e731b8ee924$export$e06efc2409049f76)
        ], (0, $64d2b9bf11c0008d$export$9f746cc58a899a00));
        const ends = multiLineStringGeometry.getEnds();
        const flatCoordinates = multiLineStringGeometry.getFlatCoordinates();
        const stride = multiLineStringGeometry.getStride();
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.drawFlatCoordinates_(flatCoordinates, offset, /** @type {number} */ ends[i], stride, strokeOffset);
        this.hitDetectionInstructions.push((0, $64d2b9bf11c0008d$export$7a98aa5364d62ba8));
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        const state = this.state;
        if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) this.instructions.push((0, $64d2b9bf11c0008d$export$7a98aa5364d62ba8));
        this.reverseHitDetectionInstructions();
        this.state = null;
        return super.finish();
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @override
   */ applyStroke(state) {
        if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) {
            this.instructions.push((0, $64d2b9bf11c0008d$export$7a98aa5364d62ba8));
            state.lastStroke = this.coordinates.length;
        }
        state.lastStroke = 0;
        super.applyStroke(state);
        this.instructions.push((0, $64d2b9bf11c0008d$export$9f746cc58a899a00));
    }
}
var $e38e5fd965383c8e$export$2e2bcd8739ae039 = $e38e5fd965383c8e$var$CanvasLineStringBuilder;


/**
 * @module ol/render/canvas/PolygonBuilder
 */ 



class $1028d8a9c70b9899$var$CanvasPolygonBuilder extends (0, $17f0c3c0104ebc6a$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {number} [strokeOffset] Stroke Offset in pixels.
   * @private
   * @return {number} End.
   */ drawFlatCoordinatess_(flatCoordinates, offset, ends, stride, strokeOffset) {
        const state = this.state;
        const fill = state.fillStyle !== undefined;
        const stroke = state.strokeStyle !== undefined;
        const numEnds = ends.length;
        this.instructions.push((0, $64d2b9bf11c0008d$export$9f746cc58a899a00));
        this.hitDetectionInstructions.push((0, $64d2b9bf11c0008d$export$9f746cc58a899a00));
        for(let i = 0; i < numEnds; ++i){
            const end = ends[i];
            const myBegin = this.coordinates.length;
            const myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, true, !stroke);
            this.instructions.push([
                (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).MOVE_TO_LINE_TO,
                myBegin,
                myEnd,
                strokeOffset * this.pixelRatio,
                true
            ]);
            this.hitDetectionInstructions.push([
                (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).MOVE_TO_LINE_TO,
                myBegin,
                myEnd,
                strokeOffset,
                true
            ]);
            if (stroke) {
                // Performance optimization: only call closePath() when we have a stroke.
                // Otherwise the ring is closed already (see appendFlatLineCoordinates above).
                this.instructions.push((0, $64d2b9bf11c0008d$export$89b10f327e413e71));
                this.hitDetectionInstructions.push((0, $64d2b9bf11c0008d$export$89b10f327e413e71));
            }
            offset = end;
        }
        if (fill) {
            this.instructions.push((0, $64d2b9bf11c0008d$export$f21891651e408226));
            this.hitDetectionInstructions.push((0, $64d2b9bf11c0008d$export$f21891651e408226));
        }
        if (stroke) {
            this.instructions.push((0, $64d2b9bf11c0008d$export$7a98aa5364d62ba8));
            this.hitDetectionInstructions.push((0, $64d2b9bf11c0008d$export$7a98aa5364d62ba8));
        }
        return offset;
    }
    /**
   * @param {import("../../geom/Circle.js").default} circleGeometry Circle geometry.
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawCircle(circleGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        const strokeOffset = state.strokeOffset;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        if (this.handleStrokeOffset_(()=>this.drawCircle(circleGeometry, feature, index))) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(circleGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $3b9b2e731b8ee924$export$c495d52ee3fd74b2)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            (0, $3b9b2e731b8ee924$export$1eb2eaecacf2031e),
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $3b9b2e731b8ee924$export$e21b4112fdc612fc),
            (0, $3b9b2e731b8ee924$export$e06efc2409049f76)
        ]);
        const flatCoordinates = circleGeometry.getFlatCoordinates();
        const stride = circleGeometry.getStride();
        const myBegin = this.coordinates.length;
        this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
        const circleInstruction = [
            (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).CIRCLE,
            myBegin,
            strokeOffset
        ];
        this.instructions.push((0, $64d2b9bf11c0008d$export$9f746cc58a899a00), circleInstruction);
        this.hitDetectionInstructions.push((0, $64d2b9bf11c0008d$export$9f746cc58a899a00), circleInstruction);
        if (state.fillStyle !== undefined) {
            this.instructions.push((0, $64d2b9bf11c0008d$export$f21891651e408226));
            this.hitDetectionInstructions.push((0, $64d2b9bf11c0008d$export$f21891651e408226));
        }
        if (state.strokeStyle !== undefined) {
            this.instructions.push((0, $64d2b9bf11c0008d$export$7a98aa5364d62ba8));
            this.hitDetectionInstructions.push((0, $64d2b9bf11c0008d$export$7a98aa5364d62ba8));
        }
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} polygonGeometry Polygon geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawPolygon(polygonGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        const strokeOffset = state.strokeOffset;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        if (this.handleStrokeOffset_(()=>this.drawPolygon(polygonGeometry, feature, index))) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(polygonGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $3b9b2e731b8ee924$export$c495d52ee3fd74b2)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            (0, $3b9b2e731b8ee924$export$1eb2eaecacf2031e),
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $3b9b2e731b8ee924$export$e21b4112fdc612fc),
            (0, $3b9b2e731b8ee924$export$e06efc2409049f76)
        ]);
        const ends = polygonGeometry.getEnds();
        const flatCoordinates = polygonGeometry.getOrientedFlatCoordinates();
        const stride = polygonGeometry.getStride();
        this.drawFlatCoordinatess_(flatCoordinates, 0, /** @type {Array<number>} */ ends, stride, strokeOffset);
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawMultiPolygon(multiPolygonGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        const strokeOffset = state.strokeOffset;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        if (this.handleStrokeOffset_(()=>this.drawMultiPolygon(multiPolygonGeometry, feature, index))) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(multiPolygonGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $3b9b2e731b8ee924$export$c495d52ee3fd74b2)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            (0, $3b9b2e731b8ee924$export$1eb2eaecacf2031e),
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $3b9b2e731b8ee924$export$e21b4112fdc612fc),
            (0, $3b9b2e731b8ee924$export$e06efc2409049f76)
        ]);
        const endss = multiPolygonGeometry.getEndss();
        const flatCoordinates = multiPolygonGeometry.getOrientedFlatCoordinates();
        const stride = multiPolygonGeometry.getStride();
        let offset = 0;
        for(let i = 0, ii = endss.length; i < ii; ++i)offset = this.drawFlatCoordinatess_(flatCoordinates, offset, endss[i], stride, strokeOffset);
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        this.reverseHitDetectionInstructions();
        this.state = null;
        // We want to preserve topology when drawing polygons.  Polygons are
        // simplified using quantization and point elimination. However, we might
        // have received a mix of quantized and non-quantized geometries, so ensure
        // that all are quantized by quantizing all coordinates in the batch.
        const tolerance = this.tolerance;
        if (tolerance !== 0) {
            const coordinates = this.coordinates;
            for(let i = 0, ii = coordinates.length; i < ii; ++i)coordinates[i] = (0, $3d277811864cf352$export$51a0620f7a28532b)(coordinates[i], tolerance);
        }
        return super.finish();
    }
    /**
   * @private
   */ setFillStrokeStyles_() {
        const state = this.state;
        this.updateFillStyle(state, this.createFill);
        this.updateStrokeStyle(state, this.applyStroke);
    }
    handleStrokeOffset_(drawGeometryCallback) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        const strokeOffset = state.strokeOffset;
        // In case both fill style and stroke style are defined and the stroke style has an offset,
        // the stroke and fill should be done in separate steps, because offset stroke shape will
        // be different from the original shape used for the fill.
        if (Math.abs(strokeOffset) > 0 && fillStyle !== undefined && strokeStyle !== undefined) {
            // First do only fill
            state.strokeStyle = undefined;
            state.strokeOffset = 0;
            drawGeometryCallback();
            // Now separately do the stroke
            state.fillStyle = undefined;
            state.strokeStyle = strokeStyle;
            state.strokeOffset = strokeOffset;
            drawGeometryCallback();
            // Reset the state to the original
            state.fillStyle = fillStyle;
            return true;
        }
        return false;
    }
}
var $1028d8a9c70b9899$export$2e2bcd8739ae039 = $1028d8a9c70b9899$var$CanvasPolygonBuilder;


/**
 * @module ol/render/canvas/TextBuilder
 */ 


function $93d639db585b08af$export$f08272c6ff321e57(chunkLength, flatCoordinates, offset, end, stride) {
    const chunks = [];
    let cursor = offset;
    let chunkM = 0;
    let currentChunk = flatCoordinates.slice(offset, 2);
    while(chunkM < chunkLength && cursor + stride < end){
        const [x1, y1] = currentChunk.slice(-2);
        const x2 = flatCoordinates[cursor + stride];
        const y2 = flatCoordinates[cursor + stride + 1];
        const segmentLength = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
        chunkM += segmentLength;
        if (chunkM >= chunkLength) {
            const m = (chunkLength - chunkM + segmentLength) / segmentLength;
            const x = (0, $912ac838ff50d1cd$export$3a89f8d6f6bf6c9f)(x1, x2, m);
            const y = (0, $912ac838ff50d1cd$export$3a89f8d6f6bf6c9f)(y1, y2, m);
            currentChunk.push(x, y);
            chunks.push(currentChunk);
            currentChunk = [
                x,
                y
            ];
            if (chunkM == chunkLength) cursor += stride;
            chunkM = 0;
        } else if (chunkM < chunkLength) {
            currentChunk.push(flatCoordinates[cursor + stride], flatCoordinates[cursor + stride + 1]);
            cursor += stride;
        } else {
            const missing = segmentLength - chunkM;
            const x = (0, $912ac838ff50d1cd$export$3a89f8d6f6bf6c9f)(x1, x2, missing / segmentLength);
            const y = (0, $912ac838ff50d1cd$export$3a89f8d6f6bf6c9f)(y1, y2, missing / segmentLength);
            currentChunk.push(x, y);
            chunks.push(currentChunk);
            currentChunk = [
                x,
                y
            ];
            chunkM = 0;
            cursor += stride;
        }
    }
    if (chunkM > 0) chunks.push(currentChunk);
    return chunks;
}


/**
 * @module ol/geom/flat/straightchunk
 */ /**
 * @param {number} maxAngle Maximum acceptable angle delta between segments.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {Array<number>} Start and end of the first suitable chunk of the
 * given `flatCoordinates`.
 */ function $51874d72cd9a94d6$export$ed6c897eea07a254(maxAngle, flatCoordinates, offset, end, stride) {
    let chunkStart = offset;
    let chunkEnd = offset;
    let chunkM = 0;
    let m = 0;
    let start = offset;
    let acos, i, m12, m23, x1, y1, x12, y12, x23, y23;
    for(i = offset; i < end; i += stride){
        const x2 = flatCoordinates[i];
        const y2 = flatCoordinates[i + 1];
        if (x1 !== undefined) {
            x23 = x2 - x1;
            y23 = y2 - y1;
            m23 = Math.sqrt(x23 * x23 + y23 * y23);
            if (x12 !== undefined) {
                m += m12;
                acos = Math.acos((x12 * x23 + y12 * y23) / (m12 * m23));
                if (acos > maxAngle) {
                    if (m > chunkM) {
                        chunkM = m;
                        chunkStart = start;
                        chunkEnd = i;
                    }
                    m = 0;
                    start = i - stride;
                }
            }
            m12 = m23;
            x12 = x23;
            y12 = y23;
        }
        x1 = x2;
        y1 = y2;
    }
    m += m23;
    return m > chunkM ? [
        start,
        i
    ] : [
        chunkStart,
        chunkEnd
    ];
}






const $0fa00ddf39ce27e0$export$91a016276e4aee96 = {
    'left': 0,
    'center': 0.5,
    'right': 1,
    'top': 0,
    'middle': 0.5,
    'hanging': 0.2,
    'alphabetic': 0.8,
    'ideographic': 0.8,
    'bottom': 1
};
class $0fa00ddf39ce27e0$var$CanvasTextBuilder extends (0, $17f0c3c0104ebc6a$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
        /**
     * @private
     * @type {Array<HTMLCanvasElement>}
     */ this.labels_ = null;
        /**
     * @private
     * @type {string|Array<string>}
     */ this.text_ = '';
        /**
     * @private
     * @type {number}
     */ this.textOffsetX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.textOffsetY_ = 0;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.textRotateWithView_ = undefined;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.textKeepUpright_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.textRotation_ = 0;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.textFillState_ = null;
        /**
     * @type {!Object<string, import("../canvas.js").FillState>}
     */ this.fillStates = {};
        this.fillStates[0, $3b9b2e731b8ee924$export$c495d52ee3fd74b2] = {
            fillStyle: (0, $3b9b2e731b8ee924$export$c495d52ee3fd74b2)
        };
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.textStrokeState_ = null;
        /**
     * @type {!Object<string, import("../canvas.js").StrokeState>}
     */ this.strokeStates = {};
        /**
     * @private
     * @type {import("../canvas.js").TextState}
     */ this.textState_ = /** @type {import("../canvas.js").TextState} */ {};
        /**
     * @type {!Object<string, import("../canvas.js").TextState>}
     */ this.textStates = {};
        /**
     * @private
     * @type {string}
     */ this.textKey_ = '';
        /**
     * @private
     * @type {string}
     */ this.fillKey_ = '';
        /**
     * @private
     * @type {string}
     */ this.strokeKey_ = '';
        /**
     * @private
     * @type {import('../../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = undefined;
        /**
     * Data shared with an image builder for combined decluttering.
     * @private
     * @type {import("../canvas.js").DeclutterImageWithText}
     */ this.declutterImageWithText_ = undefined;
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        const instructions = super.finish();
        instructions.textStates = this.textStates;
        instructions.fillStates = this.fillStates;
        instructions.strokeStates = this.strokeStates;
        return instructions;
    }
    /**
   * @param {import("../../geom/SimpleGeometry.js").default|import("../Feature.js").default} geometry Geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawText(geometry, feature, index) {
        const fillState = this.textFillState_;
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        if (this.text_ === '' || !textState || !fillState && !strokeState) return;
        const coordinates = this.coordinates;
        let begin = coordinates.length;
        const geometryType = geometry.getType();
        let flatCoordinates = null;
        let stride = geometry.getStride();
        if (textState.placement === 'line' && (geometryType == 'LineString' || geometryType == 'MultiLineString' || geometryType == 'Polygon' || geometryType == 'MultiPolygon')) {
            if (!(0, $3412ad7bd362b04c$export$7b0a31e10bbff018)(this.maxExtent, geometry.getExtent())) return;
            let ends;
            flatCoordinates = geometry.getFlatCoordinates();
            if (geometryType == 'LineString') ends = [
                flatCoordinates.length
            ];
            else if (geometryType == 'MultiLineString') ends = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.getEnds();
            else if (geometryType == 'Polygon') ends = /** @type {import("../../geom/Polygon.js").default} */ geometry.getEnds().slice(0, 1);
            else if (geometryType == 'MultiPolygon') {
                const endss = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getEndss();
                ends = [];
                for(let i = 0, ii = endss.length; i < ii; ++i)ends.push(endss[i][0]);
            }
            this.beginGeometry(geometry, feature, index);
            const repeat = textState.repeat;
            const textAlign = repeat ? undefined : textState.textAlign;
            // No `justify` support for line placement.
            let flatOffset = 0;
            for(let o = 0, oo = ends.length; o < oo; ++o){
                let chunks;
                if (repeat) chunks = (0, $93d639db585b08af$export$f08272c6ff321e57)(repeat * this.resolution, flatCoordinates, flatOffset, ends[o], stride);
                else chunks = [
                    flatCoordinates.slice(flatOffset, ends[o])
                ];
                for(let c = 0, cc = chunks.length; c < cc; ++c){
                    const chunk = chunks[c];
                    let chunkBegin = 0;
                    let chunkEnd = chunk.length;
                    if (textAlign == undefined) {
                        const range = (0, $51874d72cd9a94d6$export$ed6c897eea07a254)(textState.maxAngle, chunk, 0, chunk.length, 2);
                        chunkBegin = range[0];
                        chunkEnd = range[1];
                    }
                    for(let i = chunkBegin; i < chunkEnd; i += stride)coordinates.push(chunk[i], chunk[i + 1]);
                    const end = coordinates.length;
                    flatOffset = ends[o];
                    this.drawChars_(begin, end);
                    begin = end;
                }
            }
            this.endGeometry(feature);
        } else {
            let geometryWidths = textState.overflow ? null : [];
            switch(geometryType){
                case 'Point':
                case 'MultiPoint':
                    flatCoordinates = /** @type {import("../../geom/MultiPoint.js").default} */ geometry.getFlatCoordinates();
                    break;
                case 'LineString':
                    flatCoordinates = /** @type {import("../../geom/LineString.js").default} */ geometry.getFlatMidpoint();
                    break;
                case 'Circle':
                    flatCoordinates = /** @type {import("../../geom/Circle.js").default} */ geometry.getCenter();
                    break;
                case 'MultiLineString':
                    flatCoordinates = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.getFlatMidpoints();
                    stride = 2;
                    break;
                case 'Polygon':
                    flatCoordinates = /** @type {import("../../geom/Polygon.js").default} */ geometry.getFlatInteriorPoint();
                    if (!textState.overflow) geometryWidths.push(flatCoordinates[2] / this.resolution);
                    stride = 3;
                    break;
                case 'MultiPolygon':
                    const interiorPoints = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getFlatInteriorPoints();
                    flatCoordinates = [];
                    for(let i = 0, ii = interiorPoints.length; i < ii; i += 3){
                        if (!textState.overflow) geometryWidths.push(interiorPoints[i + 2] / this.resolution);
                        flatCoordinates.push(interiorPoints[i], interiorPoints[i + 1]);
                    }
                    if (flatCoordinates.length === 0) return;
                    stride = 2;
                    break;
                default:
            }
            const end = this.appendFlatPointCoordinates(flatCoordinates, stride);
            if (end === begin) return;
            if (geometryWidths && (end - begin) / 2 !== flatCoordinates.length / stride) {
                let beg = begin / 2;
                geometryWidths = geometryWidths.filter((w, i)=>{
                    const keep = coordinates[(beg + i) * 2] === flatCoordinates[i * stride] && coordinates[(beg + i) * 2 + 1] === flatCoordinates[i * stride + 1];
                    if (!keep) --beg;
                    return keep;
                });
            }
            this.saveTextStates_();
            const backgroundFill = textState.backgroundFill ? this.createFill(this.fillStyleToState(textState.backgroundFill)) : null;
            const backgroundStroke = textState.backgroundStroke ? this.createStroke(this.strokeStyleToState(textState.backgroundStroke)) : null;
            this.beginGeometry(geometry, feature, index);
            // adjust padding for negative scale
            let padding = textState.padding;
            if (padding != (0, $3b9b2e731b8ee924$export$40a9eeef55665a40) && (textState.scale[0] < 0 || textState.scale[1] < 0)) {
                let p0 = textState.padding[0];
                let p1 = textState.padding[1];
                let p2 = textState.padding[2];
                let p3 = textState.padding[3];
                if (textState.scale[0] < 0) {
                    p1 = -p1;
                    p3 = -p3;
                }
                if (textState.scale[1] < 0) {
                    p0 = -p0;
                    p2 = -p2;
                }
                padding = [
                    p0,
                    p1,
                    p2,
                    p3
                ];
            }
            // The image is unknown at this stage so we pass null; it will be computed at render time.
            // For clarity, we pass NaN for offsetX, offsetY, width and height, which will be computed at
            // render time.
            const pixelRatio = this.pixelRatio;
            this.instructions.push([
                (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).DRAW_IMAGE,
                begin,
                end,
                null,
                NaN,
                NaN,
                NaN,
                1,
                0,
                0,
                this.textRotateWithView_,
                this.textRotation_,
                [
                    1,
                    1
                ],
                NaN,
                this.declutterMode_,
                this.declutterImageWithText_,
                padding == (0, $3b9b2e731b8ee924$export$40a9eeef55665a40) ? (0, $3b9b2e731b8ee924$export$40a9eeef55665a40) : padding.map(function(p) {
                    return p * pixelRatio;
                }),
                backgroundFill,
                backgroundStroke,
                this.text_,
                this.textKey_,
                this.strokeKey_,
                this.fillKey_,
                this.textOffsetX_,
                this.textOffsetY_,
                geometryWidths
            ]);
            const scale = 1 / pixelRatio;
            // Set default fill for hit detection background
            const hitDetectionBackgroundFill = backgroundFill ? backgroundFill.slice(0) : null;
            if (hitDetectionBackgroundFill) hitDetectionBackgroundFill[1] = (0, $3b9b2e731b8ee924$export$c495d52ee3fd74b2);
            this.hitDetectionInstructions.push([
                (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).DRAW_IMAGE,
                begin,
                end,
                null,
                NaN,
                NaN,
                NaN,
                1,
                0,
                0,
                this.textRotateWithView_,
                this.textRotation_,
                [
                    scale,
                    scale
                ],
                NaN,
                this.declutterMode_,
                this.declutterImageWithText_,
                padding,
                hitDetectionBackgroundFill,
                backgroundStroke,
                this.text_,
                this.textKey_,
                this.strokeKey_,
                this.fillKey_ ? (0, $3b9b2e731b8ee924$export$c495d52ee3fd74b2) : this.fillKey_,
                this.textOffsetX_,
                this.textOffsetY_,
                geometryWidths
            ]);
            this.endGeometry(feature);
        }
    }
    /**
   * @private
   */ saveTextStates_() {
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        const fillState = this.textFillState_;
        const strokeKey = this.strokeKey_;
        if (strokeState) {
            if (!(strokeKey in this.strokeStates)) this.strokeStates[strokeKey] = {
                strokeStyle: strokeState.strokeStyle,
                lineCap: strokeState.lineCap,
                lineDashOffset: strokeState.lineDashOffset,
                lineWidth: strokeState.lineWidth,
                lineJoin: strokeState.lineJoin,
                miterLimit: strokeState.miterLimit,
                lineDash: strokeState.lineDash
            };
        }
        const textKey = this.textKey_;
        if (!(textKey in this.textStates)) this.textStates[textKey] = {
            font: textState.font,
            textAlign: textState.textAlign || (0, $3b9b2e731b8ee924$export$94d53b95641b5766),
            justify: textState.justify,
            textBaseline: textState.textBaseline || (0, $3b9b2e731b8ee924$export$cf2279a1bff62eb),
            scale: textState.scale
        };
        const fillKey = this.fillKey_;
        if (fillState) {
            if (!(fillKey in this.fillStates)) this.fillStates[fillKey] = {
                fillStyle: fillState.fillStyle
            };
        }
    }
    /**
   * @private
   * @param {number} begin Begin.
   * @param {number} end End.
   */ drawChars_(begin, end) {
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        const strokeKey = this.strokeKey_;
        const textKey = this.textKey_;
        const fillKey = this.fillKey_;
        this.saveTextStates_();
        const pixelRatio = this.pixelRatio;
        const baseline = $0fa00ddf39ce27e0$export$91a016276e4aee96[textState.textBaseline];
        const offsetY = this.textOffsetY_ * pixelRatio;
        const text = this.text_;
        const strokeWidth = strokeState ? strokeState.lineWidth * Math.abs(textState.scale[0]) / 2 : 0;
        this.instructions.push([
            (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).DRAW_CHARS,
            begin,
            end,
            baseline,
            textState.overflow,
            fillKey,
            textState.maxAngle,
            pixelRatio,
            offsetY,
            strokeKey,
            strokeWidth * pixelRatio,
            text,
            textKey,
            1,
            this.declutterMode_,
            this.textKeepUpright_
        ]);
        this.hitDetectionInstructions.push([
            (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).DRAW_CHARS,
            begin,
            end,
            baseline,
            textState.overflow,
            fillKey ? (0, $3b9b2e731b8ee924$export$c495d52ee3fd74b2) : fillKey,
            textState.maxAngle,
            pixelRatio,
            offsetY,
            strokeKey,
            strokeWidth * pixelRatio,
            text,
            textKey,
            1 / pixelRatio,
            this.declutterMode_,
            this.textKeepUpright_
        ]);
    }
    /**
   * @param {import("../../style/Text.js").default} textStyle Text style.
   * @param {Object} [sharedData] Shared data.
   * @override
   */ setTextStyle(textStyle, sharedData) {
        let textState, fillState, strokeState;
        if (!textStyle) this.text_ = '';
        else {
            const textFillStyle = textStyle.getFill();
            if (!textFillStyle) {
                fillState = null;
                this.textFillState_ = fillState;
            } else {
                fillState = this.textFillState_;
                if (!fillState) {
                    fillState = /** @type {import("../canvas.js").FillState} */ {};
                    this.textFillState_ = fillState;
                }
                fillState.fillStyle = (0, $bafa252a4f4b168a$export$dc5b1400ac3a10a8)(textFillStyle.getColor() || (0, $3b9b2e731b8ee924$export$c495d52ee3fd74b2));
            }
            const textStrokeStyle = textStyle.getStroke();
            if (!textStrokeStyle) {
                strokeState = null;
                this.textStrokeState_ = strokeState;
            } else {
                strokeState = this.textStrokeState_;
                if (!strokeState) {
                    strokeState = /** @type {import("../canvas.js").StrokeState} */ {};
                    this.textStrokeState_ = strokeState;
                }
                const lineDash = textStrokeStyle.getLineDash();
                const lineDashOffset = textStrokeStyle.getLineDashOffset();
                const lineWidth = textStrokeStyle.getWidth();
                const miterLimit = textStrokeStyle.getMiterLimit();
                strokeState.lineCap = textStrokeStyle.getLineCap() || (0, $3b9b2e731b8ee924$export$17bd0c38d6ae694e);
                strokeState.lineDash = lineDash ? lineDash.slice() : (0, $3b9b2e731b8ee924$export$e21b4112fdc612fc);
                strokeState.lineDashOffset = lineDashOffset === undefined ? (0, $3b9b2e731b8ee924$export$e06efc2409049f76) : lineDashOffset;
                strokeState.lineJoin = textStrokeStyle.getLineJoin() || (0, $3b9b2e731b8ee924$export$365eb9648cf19bd0);
                strokeState.lineWidth = lineWidth === undefined ? (0, $3b9b2e731b8ee924$export$79661f132c62010e) : lineWidth;
                strokeState.miterLimit = miterLimit === undefined ? (0, $3b9b2e731b8ee924$export$80c1c01844597b7b) : miterLimit;
                strokeState.strokeStyle = (0, $bafa252a4f4b168a$export$dc5b1400ac3a10a8)(textStrokeStyle.getColor() || (0, $3b9b2e731b8ee924$export$1eb2eaecacf2031e));
            }
            textState = this.textState_;
            const font = textStyle.getFont() || (0, $3b9b2e731b8ee924$export$3847dfea4f8d4dfa);
            (0, $3b9b2e731b8ee924$export$a534074a28fa87ff)(font);
            const textScale = textStyle.getScaleArray();
            textState.overflow = textStyle.getOverflow();
            textState.font = font;
            textState.maxAngle = textStyle.getMaxAngle();
            textState.placement = textStyle.getPlacement();
            textState.textAlign = textStyle.getTextAlign();
            textState.repeat = textStyle.getRepeat();
            textState.justify = textStyle.getJustify();
            textState.textBaseline = textStyle.getTextBaseline() || (0, $3b9b2e731b8ee924$export$cf2279a1bff62eb);
            textState.backgroundFill = textStyle.getBackgroundFill();
            textState.backgroundStroke = textStyle.getBackgroundStroke();
            textState.padding = textStyle.getPadding() || (0, $3b9b2e731b8ee924$export$40a9eeef55665a40);
            textState.scale = textScale === undefined ? [
                1,
                1
            ] : textScale;
            const textOffsetX = textStyle.getOffsetX();
            const textOffsetY = textStyle.getOffsetY();
            const textRotateWithView = textStyle.getRotateWithView();
            const textKeepUpright = textStyle.getKeepUpright();
            const textRotation = textStyle.getRotation();
            this.text_ = textStyle.getText() || '';
            this.textOffsetX_ = textOffsetX === undefined ? 0 : textOffsetX;
            this.textOffsetY_ = textOffsetY === undefined ? 0 : textOffsetY;
            this.textRotateWithView_ = textRotateWithView === undefined ? false : textRotateWithView;
            this.textKeepUpright_ = textKeepUpright === undefined ? true : textKeepUpright;
            this.textRotation_ = textRotation === undefined ? 0 : textRotation;
            this.strokeKey_ = strokeState ? (typeof strokeState.strokeStyle == 'string' ? strokeState.strokeStyle : (0, $01f1986453243423$export$5e82334337e0f204)(strokeState.strokeStyle)) + strokeState.lineCap + strokeState.lineDashOffset + '|' + strokeState.lineWidth + strokeState.lineJoin + strokeState.miterLimit + '[' + strokeState.lineDash.join() + ']' : '';
            this.textKey_ = textState.font + textState.scale + (textState.textAlign || '?') + (textState.repeat || '?') + (textState.justify || '?') + (textState.textBaseline || '?');
            this.fillKey_ = fillState && fillState.fillStyle ? typeof fillState.fillStyle == 'string' ? fillState.fillStyle : '|' + (0, $01f1986453243423$export$5e82334337e0f204)(fillState.fillStyle) : '';
        }
        this.declutterMode_ = textStyle.getDeclutterMode();
        this.declutterImageWithText_ = sharedData;
    }
}
var $0fa00ddf39ce27e0$export$2e2bcd8739ae039 = $0fa00ddf39ce27e0$var$CanvasTextBuilder;


/**
 * @type {Object<import("../canvas.js").BuilderType, typeof Builder>}
 */ const $1a244f8e555e6dbf$var$BATCH_CONSTRUCTORS = {
    'Circle': (0, $1028d8a9c70b9899$export$2e2bcd8739ae039),
    'Default': (0, $17f0c3c0104ebc6a$export$2e2bcd8739ae039),
    'Image': (0, $253a14ffee595604$export$2e2bcd8739ae039),
    'LineString': (0, $e38e5fd965383c8e$export$2e2bcd8739ae039),
    'Polygon': (0, $1028d8a9c70b9899$export$2e2bcd8739ae039),
    'Text': (0, $0fa00ddf39ce27e0$export$2e2bcd8739ae039)
};
class $1a244f8e555e6dbf$var$BuilderGroup {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Max extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        /**
     * @private
     * @type {number}
     */ this.tolerance_ = tolerance;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent_ = maxExtent;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.resolution_ = resolution;
        /**
     * @private
     * @type {!Object<string, !Object<import("../canvas.js").BuilderType, Builder>>}
     */ this.buildersByZIndex_ = {};
    }
    /**
   * @return {!Object<string, !Object<import("../canvas.js").BuilderType, import("./Builder.js").SerializableInstructions>>} The serializable instructions
   */ finish() {
        const builderInstructions = {};
        for(const zKey in this.buildersByZIndex_){
            builderInstructions[zKey] = builderInstructions[zKey] || {};
            const builders = this.buildersByZIndex_[zKey];
            for(const builderKey in builders){
                const builderInstruction = builders[builderKey].finish();
                builderInstructions[zKey][builderKey] = builderInstruction;
            }
        }
        return builderInstructions;
    }
    /**
   * @param {number|undefined} zIndex Z index.
   * @param {import("../canvas.js").BuilderType} builderType Replay type.
   * @return {import("../VectorContext.js").default} Replay.
   */ getBuilder(zIndex, builderType) {
        const zIndexKey = zIndex !== undefined ? zIndex.toString() : '0';
        let replays = this.buildersByZIndex_[zIndexKey];
        if (replays === undefined) {
            replays = {};
            this.buildersByZIndex_[zIndexKey] = replays;
        }
        let replay = replays[builderType];
        if (replay === undefined) {
            const Constructor = $1a244f8e555e6dbf$var$BATCH_CONSTRUCTORS[builderType];
            replay = new Constructor(this.tolerance_, this.maxExtent_, this.resolution_, this.pixelRatio_);
            replays[builderType] = replay;
        }
        return replay;
    }
}
var $1a244f8e555e6dbf$export$2e2bcd8739ae039 = $1a244f8e555e6dbf$var$BuilderGroup;


/**
 * @module ol/render/canvas/ExecutorGroup
 */ 





/**
 * @module ol/render/canvas/Executor
 */ 



function $9bae2b3a5a7a0a59$export$a6b2441cc3fe7033(flatCoordinates, start, end, stride, offset, isClosedRing, dest, destinationStride) {
    dest = dest ?? [];
    destinationStride = destinationStride ?? stride;
    const secondPointX = flatCoordinates[start + stride];
    const secondPointY = flatCoordinates[start + stride + 1];
    const secondToLastPointX = flatCoordinates[end - 2 * stride];
    const secondToLastPointY = flatCoordinates[end - 2 * stride + 1];
    let x, y, prevX, prevY, nextX, nextY, offsetX, offsetY;
    let i = 0;
    for(let j = start; j < end; j += stride){
        // 1. Detect previous and next coordinates of a current vertex
        prevX = x;
        prevY = y;
        nextX = undefined;
        nextY = undefined;
        if (j + stride < end) {
            nextX = flatCoordinates[j + stride];
            nextY = flatCoordinates[j + stride + 1];
        }
        // First coordinate of a closed ring -> previous coordinate is the second to last one
        if (isClosedRing && j === start) {
            prevX = secondToLastPointX;
            prevY = secondToLastPointY;
        }
        // Last coordinate of a closed ring -> next coordinate is the second vertex of a line string (the last one is same as the first one for a closed ring)
        if (isClosedRing && j === end - stride) {
            nextX = secondPointX;
            nextY = secondPointY;
        }
        // 2. Current vertex to offset
        x = flatCoordinates[j];
        y = flatCoordinates[j + 1];
        // 3. Offset the vertex
        [offsetX, offsetY] = $9bae2b3a5a7a0a59$var$offsetLineVertex(x, y, prevX, prevY, nextX, nextY, offset);
        dest[i++] = offsetX;
        dest[i++] = offsetY;
        // 4. Copy over other dimension values if any
        for(let k = 2; k < destinationStride; k++)dest[i++] = flatCoordinates[j + k];
    }
    if (dest.length != i) dest.length = i;
    return dest;
}
/**
 * Computes the offset of a single vertex of a line string.
 *
 * The function calculates a new vertex coordinate offset along the normal/miter direction of the line at this vertex.
 * Offset is applied along the segment normal (positive offset goes "right" relative to the line direction).
 * It handles first and last vertices (caps) as well as joins between two segments (mitering).
 * For very sharp angles, the function falls back to offsetting along the segment normal direction to avoid excessively long miters.
 *
 * Coordinates and the offset should be in the same units — either pixels or the same spatial reference system as the input line coordinates.
 *
 * @param {number} x Vertex x-coordinate.
 * @param {number} y Vertex y-coordinate.
 * @param {number|undefined} prevX Previous vertex x-coordinate.
 *   Pass undefined if computing the offset for the first vertex (no previous vertex).
 * @param {number|undefined} prevY Previous vertex y-coordinate.
 *   Pass undefined if computing the offset for the first vertex (no previous vertex).
 * @param {number|undefined} nextX Next vertex x-coordinate.
 *   Pass undefined if computing the offset for the last vertex (no next vertex).
 * @param {number|undefined} nextY Next vertex y-coordinate.
 *   Pass undefined if computing the offset for the last vertex (no next vertex).
 * @param {number} offset Offset distance along the segment normal direction.
 *   Positive values offset to the right relative to the direction from previous to next vertex.
 *   Negative values offset to the left.
 * @return {import("../../coordinate.js").Coordinate} Offset vertex coordinate as `[x, y]`.
 */ function $9bae2b3a5a7a0a59$var$offsetLineVertex(x, y, prevX, prevY, nextX, nextY, offset) {
    // Compute segment direction
    let nx, ny;
    if (prevX !== undefined && prevY !== undefined) {
        nx = x - prevX;
        ny = y - prevY;
    } else if (nextX !== undefined && nextY !== undefined) {
        nx = nextX - x;
        ny = nextY - y;
    } else {
        // no next, no previous point given -> just assume some default (horizontal) direction
        nx = 1;
        ny = 0;
    }
    // Normalize -> tangent
    const len = Math.hypot(nx, ny);
    const tx = nx / len;
    const ty = ny / len;
    // Rotate tangent 90° -> normal
    nx = -ty;
    ny = tx;
    // First / last vertex -> offset the point in the direction of the normal vector
    if (prevX === undefined || prevY === undefined) return [
        x + nx * offset,
        y + ny * offset
    ];
    if (nextX === undefined || nextY === undefined) return [
        x + nx * offset,
        y + ny * offset
    ];
    // Compute join angle - angle between 2 segments of the vertex.
    const joinAngle = (0, $6542087bee114e8c$export$47cb7eb79666608a)([
        x,
        y
    ], [
        prevX,
        prevY
    ], [
        nextX,
        nextY
    ]);
    // Avoid huge or infinite miter joins for very sharp angles, offset in the segment direction in this case.
    if (Math.cos(joinAngle) > 0.998) return [
        x + tx * offset,
        y + ty * offset
    ];
    // Compute join offset direction.
    // We rotate the normal vector by half of the join angle.
    // This gives the direction of the miter at the vertex.
    const cos = Math.cos(joinAngle / 2);
    const sin = Math.sin(joinAngle / 2);
    // Rotate the normal vector (nx, ny) by half of the join angle.
    // bx/by = bisector direction before normalization
    const bx = sin * nx + cos * ny;
    const by = -cos * nx + sin * ny;
    // Scale the bisector so that moving along it preserves the correct offset distance.
    // Dividing by sin(half of angle) converts the bisector into the true miter vector.
    // (This expands the miter for sharp angles and shortens it for wide ones.)
    const dx = bx * (1 / sin);
    const dy = by * (1 / sin);
    // Offset final vertex along miter direction
    return [
        x + dx * offset,
        y + dy * offset
    ];
}
function $9bae2b3a5a7a0a59$export$6b86a4a35195acf9(coords, stride) {
    for(let i = 0, ii = coords.length - 2; i < ii; i += stride)for(let j = coords.length - 2 * stride; j > i + stride; j -= stride){
        const p1x = coords[i];
        const p1y = coords[i + 1];
        const p2x = coords[i + stride];
        const p2y = coords[i + stride + 1];
        const p3x = coords[j];
        const p3y = coords[j + 1];
        const p4x = coords[j + stride];
        const p4y = coords[j + stride + 1];
        const d = (p4y - p3y) * (p2x - p1x) - (p4x - p3x) * (p2y - p1y);
        if (d === 0) continue;
        const t = ((p4x - p3x) * (p1y - p3y) - (p4y - p3y) * (p1x - p3x)) / d;
        const u = ((p2x - p1x) * (p1y - p3y) - (p2y - p1y) * (p1x - p3x)) / d;
        if (t > 0 && t < 1 && u > 0 && u < 1) {
            const ix = p1x + t * (p2x - p1x);
            const iy = p1y + t * (p2y - p1y);
            coords[i + stride] = ix;
            coords[i + stride + 1] = iy;
            coords.splice(i + 2 * stride, j - i - stride);
            break;
        }
    }
    return coords;
}


/**
 * @module ol/geom/flat/textpath
 */ 

function $a7ccf996405c407d$export$153a9a17ab3e949f(flatCoordinates, offset, end, stride, text, startM, maxAngle, scale, measureAndCacheTextWidth, font, cache, rotation, keepUpright = true) {
    let x2 = flatCoordinates[offset];
    let y2 = flatCoordinates[offset + 1];
    let x1 = 0;
    let y1 = 0;
    let segmentLength = 0;
    let segmentM = 0;
    function advance() {
        x1 = x2;
        y1 = y2;
        offset += stride;
        x2 = flatCoordinates[offset];
        y2 = flatCoordinates[offset + 1];
        segmentM += segmentLength;
        segmentLength = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
    do advance();
    while (offset < end - stride && segmentM + segmentLength < startM);
    let interpolate = segmentLength === 0 ? 0 : (startM - segmentM) / segmentLength;
    const beginX = (0, $912ac838ff50d1cd$export$3a89f8d6f6bf6c9f)(x1, x2, interpolate);
    const beginY = (0, $912ac838ff50d1cd$export$3a89f8d6f6bf6c9f)(y1, y2, interpolate);
    const startOffset = offset - stride;
    const startLength = segmentM;
    const endM = startM + scale * measureAndCacheTextWidth(font, text, cache);
    while(offset < end - stride && segmentM + segmentLength < endM)advance();
    interpolate = segmentLength === 0 ? 0 : (endM - segmentM) / segmentLength;
    const endX = (0, $912ac838ff50d1cd$export$3a89f8d6f6bf6c9f)(x1, x2, interpolate);
    const endY = (0, $912ac838ff50d1cd$export$3a89f8d6f6bf6c9f)(y1, y2, interpolate);
    // Keep text upright if the option is selected
    let reverse = false;
    if (keepUpright) {
        if (rotation) {
            const flat = [
                beginX,
                beginY,
                endX,
                endY
            ];
            (0, $4149c848e00d54f8$export$bb628a54ab399bc9)(flat, 0, 4, 2, rotation, flat, flat);
            reverse = flat[0] > flat[2];
        } else reverse = beginX > endX;
    }
    const PI = Math.PI;
    const result = [];
    const singleSegment = startOffset + stride === offset;
    offset = startOffset;
    segmentLength = 0;
    segmentM = startLength;
    x2 = flatCoordinates[offset];
    y2 = flatCoordinates[offset + 1];
    let previousAngle;
    // All on the same segment
    if (singleSegment) {
        advance();
        previousAngle = Math.atan2(y2 - y1, x2 - x1);
        if (reverse) previousAngle += previousAngle > 0 ? -PI : PI;
        const x = (endX + beginX) / 2;
        const y = (endY + beginY) / 2;
        result[0] = [
            x,
            y,
            (endM - startM) / 2,
            previousAngle,
            text
        ];
        return result;
    }
    // rendering across line segments
    text = text.replace(/\n/g, ' '); // ensure rendering in single-line as all calculations below don't handle multi-lines
    for(let i = 0, ii = text.length; i < ii;){
        advance();
        let angle = Math.atan2(y2 - y1, x2 - x1);
        if (reverse) angle += angle > 0 ? -PI : PI;
        if (previousAngle !== undefined) {
            let delta = angle - previousAngle;
            delta += delta > PI ? -2 * PI : delta < -PI ? 2 * PI : 0;
            if (Math.abs(delta) > maxAngle) return null;
        }
        previousAngle = angle;
        const iStart = i;
        let charLength = 0;
        for(; i < ii; ++i){
            const index = reverse ? ii - i - 1 : i;
            const len = scale * measureAndCacheTextWidth(font, text[index], cache);
            if (offset + stride < end && segmentM + segmentLength < startM + charLength + len / 2) break;
            charLength += len;
        }
        if (i === iStart) continue;
        const chars = reverse ? text.substring(ii - iStart, ii - i) : text.substring(iStart, i);
        interpolate = segmentLength === 0 ? 0 : (startM + charLength / 2 - segmentM) / segmentLength;
        const x = (0, $912ac838ff50d1cd$export$3a89f8d6f6bf6c9f)(x1, x2, interpolate);
        const y = (0, $912ac838ff50d1cd$export$3a89f8d6f6bf6c9f)(y1, y2, interpolate);
        result.push([
            x,
            y,
            charLength / 2,
            angle,
            chars
        ]);
        startM += charLength;
    }
    return result;
}








/**
 * @typedef {import('../../structs/RBush.js').Entry<import('../../Feature.js').FeatureLike>} DeclutterEntry
 */ /**
 * @typedef {Object} ImageOrLabelDimensions
 * @property {number} drawImageX DrawImageX.
 * @property {number} drawImageY DrawImageY.
 * @property {number} drawImageW DrawImageW.
 * @property {number} drawImageH DrawImageH.
 * @property {number} originX OriginX.
 * @property {number} originY OriginY.
 * @property {Array<number>} scale Scale.
 * @property {DeclutterEntry} declutterBox DeclutterBox.
 * @property {import("../../transform.js").Transform} canvasTransform CanvasTransform.
 */ /**
 * @typedef {{0: CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D, 1: import('../../size.js').Size, 2: import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement, 3: ImageOrLabelDimensions, 4: number, 5: Array<*>, 6: Array<*>}} ReplayImageOrLabelArgs
 */ /**
 * @template T
 * @typedef {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default, import("../../style/Style.js").DeclutterMode): T} FeatureCallback
 */ /**
 * @type {import("../../extent.js").Extent}
 */ const $994b7eb2172d6639$var$tmpExtent = (0, $3412ad7bd362b04c$export$fe201bb3bbe031e9)();
/** @type {import("../../coordinate.js").Coordinate} */ const $994b7eb2172d6639$var$p1 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const $994b7eb2172d6639$var$p2 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const $994b7eb2172d6639$var$p3 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const $994b7eb2172d6639$var$p4 = [];
/**
 * @param {ReplayImageOrLabelArgs} replayImageOrLabelArgs Arguments to replayImageOrLabel
 * @return {DeclutterEntry} Declutter rbush entry.
 */ function $994b7eb2172d6639$var$getDeclutterBox(replayImageOrLabelArgs) {
    return replayImageOrLabelArgs[3].declutterBox;
}
const $994b7eb2172d6639$var$rtlRegEx = new RegExp(/* eslint-disable prettier/prettier */ '[' + String.fromCharCode(0x00591) + '-' + String.fromCharCode(0x008ff) + String.fromCharCode(0x0fb1d) + '-' + String.fromCharCode(0x0fdff) + String.fromCharCode(0x0fe70) + '-' + String.fromCharCode(0x0fefc) + String.fromCharCode(0x10800) + '-' + String.fromCharCode(0x10fff) + String.fromCharCode(0x1e800) + '-' + String.fromCharCode(0x1efff) + ']');
/**
 * @param {string} text Text.
 * @param {CanvasTextAlign} align Alignment.
 * @return {number} Text alignment.
 */ function $994b7eb2172d6639$var$horizontalTextAlign(text, align) {
    if (align === 'start') align = $994b7eb2172d6639$var$rtlRegEx.test(text) ? 'right' : 'left';
    else if (align === 'end') align = $994b7eb2172d6639$var$rtlRegEx.test(text) ? 'left' : 'right';
    return (0, $0fa00ddf39ce27e0$export$91a016276e4aee96)[align];
}
/**
 * @param {Array<string>} acc Accumulator.
 * @param {string} line Line of text.
 * @param {number} i Index
 * @return {Array<string>} Accumulator.
 */ function $994b7eb2172d6639$var$createTextChunks(acc, line, i) {
    if (i > 0) acc.push('\n', '');
    acc.push(line, '');
    return acc;
}
/**
 * Converts rich text to plain text for text along lines.
 * @param {string} result The resulting plain text.
 * @param {string} part Item of the rich text array.
 * @param {number} index Index of the item in the rich text array.
 * @return {string} The resulting plain text.
 */ function $994b7eb2172d6639$var$richTextToPlainText(result, part, index) {
    if (index % 2 === 0) result += part;
    return result;
}
class $994b7eb2172d6639$var$Executor {
    /**
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {boolean} overlaps The replay can have overlapping geometries.
   * @param {import("../canvas.js").SerializableInstructions} instructions The serializable instructions.
   * @param {boolean} [deferredRendering] Enable deferred rendering.
   */ constructor(resolution, pixelRatio, overlaps, instructions, deferredRendering){
        /**
     * @protected
     * @type {boolean}
     */ this.overlaps = overlaps;
        /**
     * @protected
     * @type {number}
     */ this.pixelRatio = pixelRatio;
        /**
     * @protected
     * @const
     * @type {number}
     */ this.resolution = resolution;
        /**
     * @private
     * @type {number}
     */ this.alignAndScaleFill_;
        /**
     * @protected
     * @type {Array<*>}
     */ this.instructions = instructions.instructions;
        /**
     * @protected
     * @type {Array<number>}
     */ this.coordinates = instructions.coordinates;
        /**
     * @private
     * @type {!Object<number,import("../../coordinate.js").Coordinate|Array<import("../../coordinate.js").Coordinate>|Array<Array<import("../../coordinate.js").Coordinate>>>}
     */ this.coordinateCache_ = {};
        /**
     * @private
     * @type {!import("../../transform.js").Transform}
     */ this.renderedTransform_ = (0, $eb597965bdcc8f43$export$185802fd694ee1f5)();
        /**
     * @protected
     * @type {Array<*>}
     */ this.hitDetectionInstructions = instructions.hitDetectionInstructions;
        /**
     * @private
     * @type {Array<number>}
     */ this.pixelCoordinates_ = null;
        /**
     * @private
     * @type {number}
     */ this.viewRotation_ = 0;
        /**
     * @type {!Object<string, import("../canvas.js").FillState>}
     */ this.fillStates = instructions.fillStates || {};
        /**
     * @type {!Object<string, import("../canvas.js").StrokeState>}
     */ this.strokeStates = instructions.strokeStates || {};
        /**
     * @type {!Object<string, import("../canvas.js").TextState>}
     */ this.textStates = instructions.textStates || {};
        /**
     * @private
     * @type {Object<string, Object<string, number>>}
     */ this.widths_ = {};
        /**
     * @private
     * @type {Object<string, import("../canvas.js").Label>}
     */ this.labels_ = {};
        /**
     * @private
     * @type {import("../canvas/ZIndexContext.js").default}
     */ this.zIndexContext_ = deferredRendering ? new (0, $4564f3e97d8a38f7$export$2e2bcd8739ae039)() : null;
    }
    /**
   * @return {ZIndexContext} ZIndex context.
   */ getZIndexContext() {
        return this.zIndexContext_;
    }
    /**
   * @param {string|Array<string>} text Text.
   * @param {string} textKey Text style key.
   * @param {string} fillKey Fill style key.
   * @param {string} strokeKey Stroke style key.
   * @return {import("../canvas.js").Label} Label.
   */ createLabel(text, textKey, fillKey, strokeKey) {
        const key = text + textKey + fillKey + strokeKey;
        if (this.labels_[key]) return this.labels_[key];
        const strokeState = strokeKey ? this.strokeStates[strokeKey] : null;
        const fillState = fillKey ? this.fillStates[fillKey] : null;
        const textState = this.textStates[textKey];
        const pixelRatio = this.pixelRatio;
        const scale = [
            textState.scale[0] * pixelRatio,
            textState.scale[1] * pixelRatio
        ];
        const align = textState.justify ? (0, $0fa00ddf39ce27e0$export$91a016276e4aee96)[textState.justify] : $994b7eb2172d6639$var$horizontalTextAlign(Array.isArray(text) ? text[0] : text, textState.textAlign || (0, $3b9b2e731b8ee924$export$94d53b95641b5766));
        const strokeWidth = strokeKey && strokeState.lineWidth ? strokeState.lineWidth : 0;
        const chunks = Array.isArray(text) ? text : String(text).split('\n').reduce($994b7eb2172d6639$var$createTextChunks, []);
        const { width: width, height: height, widths: widths, heights: heights, lineWidths: lineWidths } = (0, $3b9b2e731b8ee924$export$7d7c13020df1e791)(textState, chunks);
        const renderWidth = width + strokeWidth;
        const contextInstructions = [];
        // make canvas 2 pixels wider to account for italic text width measurement errors
        const w = (renderWidth + 2) * scale[0];
        const h = (height + strokeWidth) * scale[1];
        /** @type {import("../canvas.js").Label} */ const label = {
            width: w < 0 ? Math.floor(w) : Math.ceil(w),
            height: h < 0 ? Math.floor(h) : Math.ceil(h),
            contextInstructions: contextInstructions
        };
        if (scale[0] != 1 || scale[1] != 1) contextInstructions.push('scale', scale);
        if (strokeKey) {
            contextInstructions.push('strokeStyle', strokeState.strokeStyle);
            contextInstructions.push('lineWidth', strokeWidth);
            contextInstructions.push('lineCap', strokeState.lineCap);
            contextInstructions.push('lineJoin', strokeState.lineJoin);
            contextInstructions.push('miterLimit', strokeState.miterLimit);
            contextInstructions.push('setLineDash', [
                strokeState.lineDash
            ]);
            contextInstructions.push('lineDashOffset', strokeState.lineDashOffset);
        }
        if (fillKey) contextInstructions.push('fillStyle', fillState.fillStyle);
        contextInstructions.push('textBaseline', 'middle');
        contextInstructions.push('textAlign', 'center');
        const leftRight = 0.5 - align;
        let x = align * renderWidth + leftRight * strokeWidth;
        const strokeInstructions = [];
        const fillInstructions = [];
        let lineHeight = 0;
        let lineOffset = 0;
        let widthHeightIndex = 0;
        let lineWidthIndex = 0;
        let previousFont;
        for(let i = 0, ii = chunks.length; i < ii; i += 2){
            const text = chunks[i];
            if (text === '\n') {
                lineOffset += lineHeight;
                lineHeight = 0;
                x = align * renderWidth + leftRight * strokeWidth;
                ++lineWidthIndex;
                continue;
            }
            const font = chunks[i + 1] || textState.font;
            if (font !== previousFont) {
                if (strokeKey) strokeInstructions.push('font', font);
                if (fillKey) fillInstructions.push('font', font);
                previousFont = font;
            }
            lineHeight = Math.max(lineHeight, heights[widthHeightIndex]);
            const fillStrokeArgs = [
                text,
                x + leftRight * widths[widthHeightIndex] + align * (widths[widthHeightIndex] - lineWidths[lineWidthIndex]),
                0.5 * (strokeWidth + lineHeight) + lineOffset
            ];
            x += widths[widthHeightIndex];
            if (strokeKey) strokeInstructions.push('strokeText', fillStrokeArgs);
            if (fillKey) fillInstructions.push('fillText', fillStrokeArgs);
            ++widthHeightIndex;
        }
        Array.prototype.push.apply(contextInstructions, strokeInstructions);
        Array.prototype.push.apply(contextInstructions, fillInstructions);
        this.labels_[key] = label;
        return label;
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../coordinate.js").Coordinate} p1 1st point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p2 2nd point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p3 3rd point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p4 4th point of the background box.
   * @param {Array<*>} fillInstruction Fill instruction.
   * @param {Array<*>} strokeInstruction Stroke instruction.
   */ replayTextBackground_(context, p1, p2, p3, p4, fillInstruction, strokeInstruction) {
        context.beginPath();
        context.moveTo.apply(context, p1);
        context.lineTo.apply(context, p2);
        context.lineTo.apply(context, p3);
        context.lineTo.apply(context, p4);
        context.lineTo.apply(context, p1);
        if (fillInstruction) {
            this.alignAndScaleFill_ = /** @type {number} */ fillInstruction[2];
            context.fillStyle = /** @type {string} */ fillInstruction[1];
            this.fill_(context);
        }
        if (strokeInstruction) {
            this.setStrokeStyle_(context, /** @type {Array<*>} */ strokeInstruction);
            context.stroke();
        }
    }
    /**
   * @private
   * @param {number} sheetWidth Width of the sprite sheet.
   * @param {number} sheetHeight Height of the sprite sheet.
   * @param {number} centerX X.
   * @param {number} centerY Y.
   * @param {number} width Width.
   * @param {number} height Height.
   * @param {number} anchorX Anchor X.
   * @param {number} anchorY Anchor Y.
   * @param {number} originX Origin X.
   * @param {number} originY Origin Y.
   * @param {number} rotation Rotation.
   * @param {import("../../size.js").Size} scale Scale.
   * @param {boolean} snapToPixel Snap to pixel.
   * @param {Array<number>} padding Padding.
   * @param {boolean} fillStroke Background fill or stroke.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @return {ImageOrLabelDimensions} Dimensions for positioning and decluttering the image or label.
   */ calculateImageOrLabelDimensions_(sheetWidth, sheetHeight, centerX, centerY, width, height, anchorX, anchorY, originX, originY, rotation, scale, snapToPixel, padding, fillStroke, feature) {
        anchorX *= scale[0];
        anchorY *= scale[1];
        let x = centerX - anchorX;
        let y = centerY - anchorY;
        const w = width + originX > sheetWidth ? sheetWidth - originX : width;
        const h = height + originY > sheetHeight ? sheetHeight - originY : height;
        const boxW = padding[3] + w * scale[0] + padding[1];
        const boxH = padding[0] + h * scale[1] + padding[2];
        const boxX = x - padding[3];
        const boxY = y - padding[0];
        if (fillStroke || rotation !== 0) {
            $994b7eb2172d6639$var$p1[0] = boxX;
            $994b7eb2172d6639$var$p4[0] = boxX;
            $994b7eb2172d6639$var$p1[1] = boxY;
            $994b7eb2172d6639$var$p2[1] = boxY;
            $994b7eb2172d6639$var$p2[0] = boxX + boxW;
            $994b7eb2172d6639$var$p3[0] = $994b7eb2172d6639$var$p2[0];
            $994b7eb2172d6639$var$p3[1] = boxY + boxH;
            $994b7eb2172d6639$var$p4[1] = $994b7eb2172d6639$var$p3[1];
        }
        let transform;
        if (rotation !== 0) {
            transform = (0, $eb597965bdcc8f43$export$f672e0b6f7222cd7)((0, $eb597965bdcc8f43$export$185802fd694ee1f5)(), centerX, centerY, 1, 1, rotation, -centerX, -centerY);
            (0, $eb597965bdcc8f43$export$5635d7ef4b8fee1c)(transform, $994b7eb2172d6639$var$p1);
            (0, $eb597965bdcc8f43$export$5635d7ef4b8fee1c)(transform, $994b7eb2172d6639$var$p2);
            (0, $eb597965bdcc8f43$export$5635d7ef4b8fee1c)(transform, $994b7eb2172d6639$var$p3);
            (0, $eb597965bdcc8f43$export$5635d7ef4b8fee1c)(transform, $994b7eb2172d6639$var$p4);
            (0, $3412ad7bd362b04c$export$958e3e1a02eac4b6)(Math.min($994b7eb2172d6639$var$p1[0], $994b7eb2172d6639$var$p2[0], $994b7eb2172d6639$var$p3[0], $994b7eb2172d6639$var$p4[0]), Math.min($994b7eb2172d6639$var$p1[1], $994b7eb2172d6639$var$p2[1], $994b7eb2172d6639$var$p3[1], $994b7eb2172d6639$var$p4[1]), Math.max($994b7eb2172d6639$var$p1[0], $994b7eb2172d6639$var$p2[0], $994b7eb2172d6639$var$p3[0], $994b7eb2172d6639$var$p4[0]), Math.max($994b7eb2172d6639$var$p1[1], $994b7eb2172d6639$var$p2[1], $994b7eb2172d6639$var$p3[1], $994b7eb2172d6639$var$p4[1]), $994b7eb2172d6639$var$tmpExtent);
        } else (0, $3412ad7bd362b04c$export$958e3e1a02eac4b6)(Math.min(boxX, boxX + boxW), Math.min(boxY, boxY + boxH), Math.max(boxX, boxX + boxW), Math.max(boxY, boxY + boxH), $994b7eb2172d6639$var$tmpExtent);
        if (snapToPixel) {
            x = Math.round(x);
            y = Math.round(y);
        }
        return {
            drawImageX: x,
            drawImageY: y,
            drawImageW: w,
            drawImageH: h,
            originX: originX,
            originY: originY,
            declutterBox: {
                minX: $994b7eb2172d6639$var$tmpExtent[0],
                minY: $994b7eb2172d6639$var$tmpExtent[1],
                maxX: $994b7eb2172d6639$var$tmpExtent[2],
                maxY: $994b7eb2172d6639$var$tmpExtent[3],
                value: feature
            },
            canvasTransform: transform,
            scale: scale
        };
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size.
   * @param {import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement} imageOrLabel Image.
   * @param {ImageOrLabelDimensions} dimensions Dimensions.
   * @param {number} opacity Opacity.
   * @param {Array<*>} fillInstruction Fill instruction.
   * @param {Array<*>} strokeInstruction Stroke instruction.
   * @return {boolean} The image or label was rendered.
   */ replayImageOrLabel_(context, scaledCanvasSize, imageOrLabel, dimensions, opacity, fillInstruction, strokeInstruction) {
        const fillStroke = !!(fillInstruction || strokeInstruction);
        const box = dimensions.declutterBox;
        const strokePadding = strokeInstruction ? strokeInstruction[2] * dimensions.scale[0] / 2 : 0;
        const intersects = box.minX - strokePadding <= scaledCanvasSize[0] && box.maxX + strokePadding >= 0 && box.minY - strokePadding <= scaledCanvasSize[1] && box.maxY + strokePadding >= 0;
        if (intersects) {
            if (fillStroke) this.replayTextBackground_(context, $994b7eb2172d6639$var$p1, $994b7eb2172d6639$var$p2, $994b7eb2172d6639$var$p3, $994b7eb2172d6639$var$p4, /** @type {Array<*>} */ fillInstruction, /** @type {Array<*>} */ strokeInstruction);
            (0, $3b9b2e731b8ee924$export$3cb6f3a6e49cc0ee)(context, dimensions.canvasTransform, opacity, imageOrLabel, dimensions.originX, dimensions.originY, dimensions.drawImageW, dimensions.drawImageH, dimensions.drawImageX, dimensions.drawImageY, dimensions.scale);
        }
        return true;
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   */ fill_(context) {
        const alignAndScale = this.alignAndScaleFill_;
        if (alignAndScale) {
            const origin = (0, $eb597965bdcc8f43$export$5635d7ef4b8fee1c)(this.renderedTransform_, [
                0,
                0
            ]);
            const repeatSize = 512 * this.pixelRatio;
            context.save();
            context.translate(origin[0] % repeatSize, origin[1] % repeatSize);
            if (alignAndScale !== 1) context.scale(alignAndScale, alignAndScale);
        }
        context.fill();
        if (alignAndScale) context.restore();
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {Array<*>} instruction Instruction.
   */ setStrokeStyle_(context, instruction) {
        context.strokeStyle = /** @type {import("../../colorlike.js").ColorLike} */ instruction[1];
        if (!instruction[1]) return;
        context.lineWidth = /** @type {number} */ instruction[2];
        context.lineCap = /** @type {CanvasLineCap} */ instruction[3];
        context.lineJoin = /** @type {CanvasLineJoin} */ instruction[4];
        context.miterLimit = /** @type {number} */ instruction[5];
        context.lineDashOffset = /** @type {number} */ instruction[7];
        context.setLineDash(/** @type {Array<number>} */ instruction[6]);
    }
    /**
   * @private
   * @param {string|Array<string>} text The text to draw.
   * @param {string} textKey The key of the text state.
   * @param {string} strokeKey The key for the stroke state.
   * @param {string} fillKey The key for the fill state.
   * @return {{label: import("../canvas.js").Label, anchorX: number, anchorY: number}} The text image and its anchor.
   */ drawLabelWithPointPlacement_(text, textKey, strokeKey, fillKey) {
        const textState = this.textStates[textKey];
        const label = this.createLabel(text, textKey, fillKey, strokeKey);
        const strokeState = this.strokeStates[strokeKey];
        const pixelRatio = this.pixelRatio;
        const align = $994b7eb2172d6639$var$horizontalTextAlign(Array.isArray(text) ? text[0] : text, textState.textAlign || (0, $3b9b2e731b8ee924$export$94d53b95641b5766));
        const baseline = (0, $0fa00ddf39ce27e0$export$91a016276e4aee96)[textState.textBaseline || (0, $3b9b2e731b8ee924$export$cf2279a1bff62eb)];
        const strokeWidth = strokeState && strokeState.lineWidth ? strokeState.lineWidth : 0;
        // Remove the 2 pixels we added in createLabel() for the anchor
        const width = label.width / pixelRatio - 2 * textState.scale[0];
        const anchorX = align * width + 2 * (0.5 - align) * strokeWidth;
        const anchorY = baseline * label.height / pixelRatio + 2 * (0.5 - baseline) * strokeWidth;
        return {
            label: label,
            anchorX: anchorX,
            anchorY: anchorY
        };
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {Array<*>} instructions Instructions array.
   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
   * @param {FeatureCallback<T>} [featureCallback] Feature callback.
   * @param {import("../../extent.js").Extent} [hitExtent] Only check
   *     features that intersect this extent.
   * @param {import("rbush").default<DeclutterEntry>} [declutterTree] Declutter tree.
   * @return {T|undefined} Callback result.
   * @template T
   */ execute_(context, scaledCanvasSize, transform, instructions, snapToPixel, featureCallback, hitExtent, declutterTree) {
        const zIndexContext = this.zIndexContext_;
        /** @type {Array<number>} */ let pixelCoordinates;
        if (this.pixelCoordinates_ && (0, $db525acb5f2517fc$export$e9bab7fafb253603)(transform, this.renderedTransform_)) pixelCoordinates = this.pixelCoordinates_;
        else {
            if (!this.pixelCoordinates_) this.pixelCoordinates_ = [];
            pixelCoordinates = (0, $4149c848e00d54f8$export$b92b2dedcfff79de)(this.coordinates, 0, this.coordinates.length, 2, transform, this.pixelCoordinates_);
            (0, $eb597965bdcc8f43$export$42b4187a82d80ed0)(this.renderedTransform_, transform);
        }
        let i = 0; // instruction index
        const ii = instructions.length; // end of instructions
        let d = 0; // data index
        let dd; // end of per-instruction data
        const offsetCoords = [];
        let anchorX, anchorY, lineOffsetPx, /** @type {import('../../style/Style.js').DeclutterMode} */ declutterMode, prevX, prevY, roundX, roundY, image, text, textKey, strokeKey, fillKey;
        let pendingFill = 0;
        let pendingStroke = 0;
        const coordinateCache = this.coordinateCache_;
        const viewRotation = this.viewRotation_;
        const viewRotationFromTransform = Math.round(Math.atan2(-transform[1], transform[0]) * 1e12) / 1e12;
        const state = /** @type {import("../../render.js").State} */ {
            context: context,
            pixelRatio: this.pixelRatio,
            resolution: this.resolution,
            rotation: viewRotation
        };
        // When the batch size gets too big, performance decreases. 200 is a good
        // balance between batch size and number of fill/stroke instructions.
        const batchSize = this.instructions != instructions || this.overlaps ? 0 : 200;
        let /** @type {import("../../Feature.js").FeatureLike} */ feature;
        let x, y, currentGeometry;
        while(i < ii){
            const instruction = instructions[i];
            const type = /** @type {import("./Instruction.js").default} */ instruction[0];
            switch(type){
                case (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).BEGIN_GEOMETRY:
                    feature = /** @type {import("../../Feature.js").FeatureLike} */ instruction[1];
                    currentGeometry = instruction[3];
                    if (!feature.getGeometry()) i = /** @type {number} */ instruction[2];
                    else if (hitExtent !== undefined && !(0, $3412ad7bd362b04c$export$7b0a31e10bbff018)(hitExtent, currentGeometry.getExtent())) i = /** @type {number} */ instruction[2] + 1;
                    else ++i;
                    if (zIndexContext) zIndexContext.zIndex = instruction[4];
                    break;
                case (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).BEGIN_PATH:
                    if (pendingFill > batchSize) {
                        this.fill_(context);
                        pendingFill = 0;
                    }
                    if (pendingStroke > batchSize) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    if (!pendingFill && !pendingStroke) {
                        context.beginPath();
                        prevX = NaN;
                        prevY = NaN;
                    }
                    ++i;
                    break;
                case (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).CIRCLE:
                    d = /** @type {number} */ instruction[1];
                    lineOffsetPx = /** @type {number} */ instruction[2] ?? 0;
                    const x1 = pixelCoordinates[d];
                    const y1 = pixelCoordinates[d + 1];
                    const x2 = pixelCoordinates[d + 2] - lineOffsetPx;
                    const y2 = pixelCoordinates[d + 3] - lineOffsetPx;
                    const dx = x2 - x1;
                    const dy = y2 - y1;
                    const r = Math.sqrt(dx * dx + dy * dy);
                    context.moveTo(x1 + r, y1);
                    context.arc(x1, y1, r, 0, 2 * Math.PI, true);
                    ++i;
                    break;
                case (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).CLOSE_PATH:
                    context.closePath();
                    ++i;
                    break;
                case (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).CUSTOM:
                    d = /** @type {number} */ instruction[1];
                    dd = instruction[2];
                    const geometry = /** @type {import("../../geom/SimpleGeometry.js").default} */ instruction[3];
                    const renderer = instruction[4];
                    const fn = instruction[5];
                    state.geometry = geometry;
                    state.feature = feature;
                    if (!(i in coordinateCache)) coordinateCache[i] = [];
                    const coords = coordinateCache[i];
                    if (fn) fn(pixelCoordinates, d, dd, 2, coords);
                    else {
                        coords[0] = pixelCoordinates[d];
                        coords[1] = pixelCoordinates[d + 1];
                        coords.length = 2;
                    }
                    if (zIndexContext) zIndexContext.zIndex = instruction[6];
                    renderer(coords, state);
                    ++i;
                    break;
                case (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).DRAW_IMAGE:
                    d = /** @type {number} */ instruction[1];
                    dd = /** @type {number} */ instruction[2];
                    image = /** @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} */ instruction[3];
                    // Remaining arguments in DRAW_IMAGE are in alphabetical order
                    anchorX = /** @type {number} */ instruction[4];
                    anchorY = /** @type {number} */ instruction[5];
                    let height = /** @type {number} */ instruction[6];
                    const opacity = /** @type {number} */ instruction[7];
                    const originX = /** @type {number} */ instruction[8];
                    const originY = /** @type {number} */ instruction[9];
                    const rotateWithView = /** @type {boolean} */ instruction[10];
                    let rotation = /** @type {number} */ instruction[11];
                    const scale = /** @type {import("../../size.js").Size} */ instruction[12];
                    let width = /** @type {number} */ instruction[13];
                    declutterMode = instruction[14] || 'declutter';
                    const declutterImageWithText = /** @type {{args: import("../canvas.js").DeclutterImageWithText, declutterMode: import('../../style/Style.js').DeclutterMode}} */ instruction[15];
                    if (!image && instruction.length >= 20) {
                        // create label images
                        text = /** @type {string} */ instruction[19];
                        textKey = /** @type {string} */ instruction[20];
                        strokeKey = /** @type {string} */ instruction[21];
                        fillKey = /** @type {string} */ instruction[22];
                        const labelWithAnchor = this.drawLabelWithPointPlacement_(text, textKey, strokeKey, fillKey);
                        image = labelWithAnchor.label;
                        instruction[3] = image;
                        const textOffsetX = /** @type {number} */ instruction[23];
                        anchorX = (labelWithAnchor.anchorX - textOffsetX) * this.pixelRatio;
                        instruction[4] = anchorX;
                        const textOffsetY = /** @type {number} */ instruction[24];
                        anchorY = (labelWithAnchor.anchorY - textOffsetY) * this.pixelRatio;
                        instruction[5] = anchorY;
                        height = image.height;
                        instruction[6] = height;
                        width = image.width;
                        instruction[13] = width;
                    }
                    let geometryWidths;
                    if (instruction.length > 25) geometryWidths = /** @type {number} */ instruction[25];
                    let padding, backgroundFillInstruction, backgroundStrokeInstruction;
                    if (instruction.length > 17) {
                        padding = /** @type {Array<number>} */ instruction[16];
                        backgroundFillInstruction = /** @type {Array<*>} */ instruction[17];
                        backgroundStrokeInstruction = /** @type {Array<*>} */ instruction[18];
                    } else {
                        padding = (0, $3b9b2e731b8ee924$export$40a9eeef55665a40);
                        backgroundFillInstruction = null;
                        backgroundStrokeInstruction = null;
                    }
                    if (rotateWithView && viewRotationFromTransform) // Canvas is expected to be rotated to reverse view rotation.
                    rotation += viewRotation;
                    else if (!rotateWithView && !viewRotationFromTransform) // Canvas is not rotated, images need to be rotated back to be north-up.
                    rotation -= viewRotation;
                    let widthIndex = 0;
                    for(; d < dd; d += 2){
                        if (geometryWidths && geometryWidths[widthIndex++] < width / this.pixelRatio) continue;
                        const dimensions = this.calculateImageOrLabelDimensions_(image.width, image.height, pixelCoordinates[d], pixelCoordinates[d + 1], width, height, anchorX, anchorY, originX, originY, rotation, scale, snapToPixel, padding, !!backgroundFillInstruction || !!backgroundStrokeInstruction, feature);
                        /** @type {ReplayImageOrLabelArgs} */ const args = [
                            context,
                            scaledCanvasSize,
                            image,
                            dimensions,
                            opacity,
                            backgroundFillInstruction,
                            backgroundStrokeInstruction
                        ];
                        if (declutterTree) {
                            let imageArgs, imageDeclutterMode, imageDeclutterBox;
                            if (declutterImageWithText) {
                                const index = dd - d;
                                if (!declutterImageWithText[index]) {
                                    // We now have the image for an image+text combination.
                                    declutterImageWithText[index] = {
                                        args: args,
                                        declutterMode: declutterMode
                                    };
                                    continue;
                                }
                                const imageDeclutter = declutterImageWithText[index];
                                imageArgs = imageDeclutter.args;
                                imageDeclutterMode = imageDeclutter.declutterMode;
                                delete declutterImageWithText[index];
                                imageDeclutterBox = $994b7eb2172d6639$var$getDeclutterBox(imageArgs);
                            }
                            // We now have image and text for an image+text combination.
                            let renderImage, renderText;
                            if (imageArgs && (imageDeclutterMode !== 'declutter' || !declutterTree.collides(imageDeclutterBox))) renderImage = true;
                            if (declutterMode !== 'declutter' || !declutterTree.collides(dimensions.declutterBox)) renderText = true;
                            if (imageDeclutterMode === 'declutter' && declutterMode === 'declutter') {
                                const render = renderImage && renderText;
                                renderImage = render;
                                renderText = render;
                            }
                            if (renderImage) {
                                if (imageDeclutterMode !== 'none') declutterTree.insert(imageDeclutterBox);
                                this.replayImageOrLabel_.apply(this, imageArgs);
                            }
                            if (renderText) {
                                if (declutterMode !== 'none') declutterTree.insert(dimensions.declutterBox);
                                this.replayImageOrLabel_.apply(this, args);
                            }
                        } else this.replayImageOrLabel_.apply(this, args);
                    }
                    ++i;
                    break;
                case (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).DRAW_CHARS:
                    const begin = /** @type {number} */ instruction[1];
                    const end = /** @type {number} */ instruction[2];
                    const baseline = /** @type {number} */ instruction[3];
                    const overflow = /** @type {number} */ instruction[4];
                    fillKey = /** @type {string} */ instruction[5];
                    const maxAngle = /** @type {number} */ instruction[6];
                    const measurePixelRatio = /** @type {number} */ instruction[7];
                    const offsetY = /** @type {number} */ instruction[8];
                    strokeKey = /** @type {string} */ instruction[9];
                    const strokeWidth = /** @type {number} */ instruction[10];
                    text = /** @type {string|Array<string>} */ instruction[11];
                    if (Array.isArray(text)) //FIXME Add support for rich text along lines
                    text = text.reduce($994b7eb2172d6639$var$richTextToPlainText, '');
                    textKey = /** @type {string} */ instruction[12];
                    const pixelRatioScale = [
                        /** @type {number} */ instruction[13],
                        /** @type {number} */ instruction[13]
                    ];
                    declutterMode = instruction[14] || 'declutter';
                    const textKeepUpright = /** @type {boolean} */ instruction[15];
                    const textState = this.textStates[textKey];
                    const font = textState.font;
                    const textScale = [
                        textState.scale[0] * measurePixelRatio,
                        textState.scale[1] * measurePixelRatio
                    ];
                    let cachedWidths;
                    if (font in this.widths_) cachedWidths = this.widths_[font];
                    else {
                        cachedWidths = {};
                        this.widths_[font] = cachedWidths;
                    }
                    const pathLength = (0, $a4bcede32ab492a7$export$153f8c6b4d8caebc)(pixelCoordinates, begin, end, 2);
                    const textLength = Math.abs(textScale[0]) * (0, $3b9b2e731b8ee924$export$915c7ba51467308f)(font, text, cachedWidths);
                    if (overflow || textLength <= pathLength) {
                        const textAlign = this.textStates[textKey].textAlign;
                        const startM = (pathLength - textLength) * $994b7eb2172d6639$var$horizontalTextAlign(text, textAlign);
                        const parts = (0, $a7ccf996405c407d$export$153a9a17ab3e949f)(pixelCoordinates, begin, end, 2, text, startM, maxAngle, Math.abs(textScale[0]), (0, $3b9b2e731b8ee924$export$915c7ba51467308f), font, cachedWidths, viewRotationFromTransform ? 0 : this.viewRotation_, textKeepUpright);
                        drawChars: if (parts) {
                            /** @type {Array<ReplayImageOrLabelArgs>} */ const replayImageOrLabelArgs = [];
                            let c, cc, chars, label, part;
                            if (strokeKey) for(c = 0, cc = parts.length; c < cc; ++c){
                                part = parts[c]; // x, y, anchorX, rotation, chunk
                                chars = /** @type {string} */ part[4];
                                label = this.createLabel(chars, textKey, '', strokeKey);
                                anchorX = /** @type {number} */ part[2] + (textScale[0] < 0 ? -strokeWidth : strokeWidth);
                                anchorY = baseline * label.height + (0.5 - baseline) * 2 * strokeWidth * textScale[1] / textScale[0] - offsetY;
                                const dimensions = this.calculateImageOrLabelDimensions_(label.width, label.height, part[0], part[1], label.width, label.height, anchorX, anchorY, 0, 0, part[3], pixelRatioScale, false, (0, $3b9b2e731b8ee924$export$40a9eeef55665a40), false, feature);
                                if (declutterTree && declutterMode === 'declutter' && declutterTree.collides(dimensions.declutterBox)) break drawChars;
                                replayImageOrLabelArgs.push([
                                    context,
                                    scaledCanvasSize,
                                    label,
                                    dimensions,
                                    1,
                                    null,
                                    null
                                ]);
                            }
                            if (fillKey) for(c = 0, cc = parts.length; c < cc; ++c){
                                part = parts[c]; // x, y, anchorX, rotation, chunk
                                chars = /** @type {string} */ part[4];
                                label = this.createLabel(chars, textKey, fillKey, '');
                                anchorX = /** @type {number} */ part[2];
                                anchorY = baseline * label.height - offsetY;
                                const dimensions = this.calculateImageOrLabelDimensions_(label.width, label.height, part[0], part[1], label.width, label.height, anchorX, anchorY, 0, 0, part[3], pixelRatioScale, false, (0, $3b9b2e731b8ee924$export$40a9eeef55665a40), false, feature);
                                if (declutterTree && declutterMode === 'declutter' && declutterTree.collides(dimensions.declutterBox)) break drawChars;
                                replayImageOrLabelArgs.push([
                                    context,
                                    scaledCanvasSize,
                                    label,
                                    dimensions,
                                    1,
                                    null,
                                    null
                                ]);
                            }
                            if (declutterTree && declutterMode !== 'none') declutterTree.load(replayImageOrLabelArgs.map($994b7eb2172d6639$var$getDeclutterBox));
                            for(let i = 0, ii = replayImageOrLabelArgs.length; i < ii; ++i)this.replayImageOrLabel_.apply(this, replayImageOrLabelArgs[i]);
                        }
                    }
                    ++i;
                    break;
                case (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).END_GEOMETRY:
                    if (featureCallback !== undefined) {
                        feature = /** @type {import("../../Feature.js").FeatureLike} */ instruction[1];
                        const result = featureCallback(feature, currentGeometry, declutterMode);
                        if (result) return result;
                    }
                    ++i;
                    break;
                case (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).FILL:
                    if (batchSize) pendingFill++;
                    else this.fill_(context);
                    ++i;
                    break;
                case (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).MOVE_TO_LINE_TO:
                    d = /** @type {number} */ instruction[1];
                    dd = /** @type {number} */ instruction[2];
                    lineOffsetPx = /** @type {number|undefined} */ instruction[3];
                    let lineCoords, lineStart, lineEnd;
                    if (lineOffsetPx) {
                        const isClosedRing = /** @type {boolean|undefined} */ instruction[4] ?? false;
                        (0, $9bae2b3a5a7a0a59$export$a6b2441cc3fe7033)(pixelCoordinates, d, dd, 2, lineOffsetPx, isClosedRing, offsetCoords);
                        (0, $9bae2b3a5a7a0a59$export$6b86a4a35195acf9)(offsetCoords, 2);
                        lineCoords = offsetCoords;
                        lineStart = 0;
                        lineEnd = lineCoords.length;
                    } else {
                        lineCoords = pixelCoordinates;
                        lineStart = d;
                        lineEnd = dd;
                    }
                    x = lineCoords[lineStart];
                    y = lineCoords[lineStart + 1];
                    context.moveTo(x, y);
                    prevX = x + 0.5 | 0;
                    prevY = y + 0.5 | 0;
                    for(let k = lineStart + 2; k < lineEnd; k += 2){
                        x = lineCoords[k];
                        y = lineCoords[k + 1];
                        roundX = x + 0.5 | 0;
                        roundY = y + 0.5 | 0;
                        if (k == lineEnd - 2 || roundX !== prevX || roundY !== prevY) {
                            context.lineTo(x, y);
                            prevX = roundX;
                            prevY = roundY;
                        }
                    }
                    ++i;
                    break;
                case (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).SET_FILL_STYLE:
                    this.alignAndScaleFill_ = instruction[2];
                    if (pendingFill) {
                        this.fill_(context);
                        pendingFill = 0;
                        if (pendingStroke) {
                            context.stroke();
                            pendingStroke = 0;
                        }
                    } else if (pendingStroke && instruction[1]) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    /** @type {import("../../colorlike.js").ColorLike} */ context.fillStyle = instruction[1];
                    ++i;
                    break;
                case (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).SET_STROKE_STYLE:
                    if (pendingFill && instruction[1]) {
                        this.fill_(context);
                        pendingFill = 0;
                    }
                    if (pendingStroke) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    this.setStrokeStyle_(context, /** @type {Array<*>} */ instruction);
                    ++i;
                    break;
                case (0, $64d2b9bf11c0008d$export$2e2bcd8739ae039).STROKE:
                    if (batchSize) pendingStroke++;
                    else context.stroke();
                    ++i;
                    break;
                default:
                    ++i;
                    break;
            }
        }
        if (pendingFill) this.fill_(context);
        if (pendingStroke) context.stroke();
        return undefined;
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
   * @param {import("rbush").default<DeclutterEntry>} [declutterTree] Declutter tree.
   */ execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree) {
        this.viewRotation_ = viewRotation;
        this.execute_(context, scaledCanvasSize, transform, this.instructions, snapToPixel, undefined, undefined, declutterTree);
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {FeatureCallback<T>} [featureCallback] Feature callback.
   * @param {import("../../extent.js").Extent} [hitExtent] Only check
   *     features that intersect this extent.
   * @return {T|undefined} Callback result.
   * @template T
   */ executeHitDetection(context, transform, viewRotation, featureCallback, hitExtent) {
        this.viewRotation_ = viewRotation;
        return this.execute_(context, [
            context.canvas.width,
            context.canvas.height
        ], transform, this.hitDetectionInstructions, true, featureCallback, hitExtent);
    }
}
var $994b7eb2172d6639$export$2e2bcd8739ae039 = $994b7eb2172d6639$var$Executor;


const $50fd8cb5269ba2f5$export$61b49a5ae59d663 = [
    'Polygon',
    'Circle',
    'LineString',
    'Image',
    'Text',
    'Default'
];
const $50fd8cb5269ba2f5$export$6195a93a6c97ce02 = [
    'Image',
    'Text'
];
const $50fd8cb5269ba2f5$export$d0fe61ccfaa1ca87 = $50fd8cb5269ba2f5$export$61b49a5ae59d663.filter((builderType)=>!$50fd8cb5269ba2f5$export$6195a93a6c97ce02.includes(builderType));
/** @type {boolean|undefined} */ let $50fd8cb5269ba2f5$var$willReadFrequently = false;
/** @type {boolean|undefined} */ let $50fd8cb5269ba2f5$var$canvasReadsBenchmarked = false;
/** Determine if canvas read operations are faster with willReadFrequently set to true or false */ function $50fd8cb5269ba2f5$var$benchmarkCanvasReads() {
    let bestResult = 0;
    /**
   * @param {boolean} willReadFrequently Will read frequently.
   * @return {number} Operation count.
   */ const measure = (willReadFrequently)=>{
        const context = (0, $5ce605ba3ee034a0$export$9e05d10eae75c464)(1, 1, null, {
            willReadFrequently: willReadFrequently
        });
        let count = 0;
        const start = performance.now();
        for(; performance.now() - start < 50; ++count){
            context.fillStyle = `rgba(255,0,${count % 256},1)`;
            context.fillRect(0, 0, 1, 1);
            context.getImageData(0, 0, 1, 1);
        }
        bestResult = count > bestResult ? count : bestResult;
        return count;
    };
    const measures = {
        [measure(true)]: true,
        [measure(false)]: false,
        [measure(undefined)]: undefined
    };
    $50fd8cb5269ba2f5$var$willReadFrequently = measures[bestResult];
    $50fd8cb5269ba2f5$var$canvasReadsBenchmarked = true;
}
class $50fd8cb5269ba2f5$var$ExecutorGroup {
    /**
   * @param {import("../../extent.js").Extent} maxExtent Max extent for clipping. When a
   * `maxExtent` was set on the Builder for this executor group, the same `maxExtent`
   * should be set here, unless the target context does not exceed that extent (which
   * can be the case when rendering to tiles).
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {boolean} overlaps The executor group can have overlapping geometries.
   * @param {!Object<string, !Object<import("../canvas.js").BuilderType, import("../canvas.js").SerializableInstructions>>} allInstructions
   * The serializable instructions.
   * @param {number} [renderBuffer] Optional rendering buffer.
   * @param {boolean} [deferredRendering] Enable deferred rendering with renderDeferred().
   */ constructor(maxExtent, resolution, pixelRatio, overlaps, allInstructions, renderBuffer, deferredRendering){
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent_ = maxExtent;
        /**
     * @private
     * @type {boolean}
     */ this.overlaps_ = overlaps;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.resolution_ = resolution;
        /**
     * @private
     * @type {number|undefined}
     */ this.renderBuffer_ = renderBuffer;
        /**
     * @private
     * @type {!Object<string, !Object<string, import("./Executor.js").default>>}
     */ this.executorsByZIndex_ = {};
        /**
     * @private
     * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
     */ this.hitDetectionContext_ = null;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.hitDetectionTransform_ = (0, $eb597965bdcc8f43$export$185802fd694ee1f5)();
        /**
     * @private
     * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
     */ this.renderedContext_ = null;
        /**
     * @private
     * @type {Object<number, Array<import("./ZIndexContext.js").default>>}
     */ this.deferredZIndexContexts_ = {};
        this.createExecutors_(allInstructions, deferredRendering);
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   */ clip(context, transform) {
        const flatClipCoords = this.getClipCoords(transform);
        context.beginPath();
        context.moveTo(flatClipCoords[0], flatClipCoords[1]);
        context.lineTo(flatClipCoords[2], flatClipCoords[3]);
        context.lineTo(flatClipCoords[4], flatClipCoords[5]);
        context.lineTo(flatClipCoords[6], flatClipCoords[7]);
        context.clip();
    }
    /**
   * Create executors and populate them using the provided instructions.
   * @private
   * @param {!Object<string, !Object<string, import("../canvas.js").SerializableInstructions>>} allInstructions The serializable instructions
   * @param {boolean} deferredRendering Enable deferred rendering.
   */ createExecutors_(allInstructions, deferredRendering) {
        for(const zIndex in allInstructions){
            let executors = this.executorsByZIndex_[zIndex];
            if (executors === undefined) {
                executors = {};
                this.executorsByZIndex_[zIndex] = executors;
            }
            const instructionByZindex = allInstructions[zIndex];
            for(const builderType in instructionByZindex){
                const instructions = instructionByZindex[builderType];
                executors[builderType] = new (0, $994b7eb2172d6639$export$2e2bcd8739ae039)(this.resolution_, this.pixelRatio_, this.overlaps_, instructions, deferredRendering);
            }
        }
    }
    /**
   * @param {Array<import("../canvas.js").BuilderType>} executors Executors.
   * @return {boolean} Has executors of the provided types.
   */ hasExecutors(executors) {
        for(const zIndex in this.executorsByZIndex_){
            const candidates = this.executorsByZIndex_[zIndex];
            for(let i = 0, ii = executors.length; i < ii; ++i){
                if (executors[i] in candidates) return true;
            }
        }
        return false;
    }
    /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default, number): T} callback Feature callback.
   * @param {Array<import("../../Feature.js").FeatureLike>} declutteredFeatures Decluttered features.
   * @return {T|undefined} Callback result.
   * @template T
   */ forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, callback, declutteredFeatures) {
        if ($50fd8cb5269ba2f5$var$canvasReadsBenchmarked === false) $50fd8cb5269ba2f5$var$benchmarkCanvasReads();
        hitTolerance = Math.round(hitTolerance);
        const contextSize = hitTolerance * 2 + 1;
        const transform = (0, $eb597965bdcc8f43$export$f672e0b6f7222cd7)(this.hitDetectionTransform_, hitTolerance + 0.5, hitTolerance + 0.5, 1 / resolution, -1 / resolution, -rotation, -coordinate[0], -coordinate[1]);
        const newContext = !this.hitDetectionContext_;
        if (newContext) this.hitDetectionContext_ = (0, $5ce605ba3ee034a0$export$9e05d10eae75c464)(contextSize, contextSize, null, {
            willReadFrequently: $50fd8cb5269ba2f5$var$willReadFrequently
        });
        const context = this.hitDetectionContext_;
        if (context.canvas.width !== contextSize || context.canvas.height !== contextSize) {
            context.canvas.width = contextSize;
            context.canvas.height = contextSize;
        } else if (!newContext) context.clearRect(0, 0, contextSize, contextSize);
        /** @type {import("../../extent.js").Extent|undefined} */ let hitExtent;
        if (this.renderBuffer_ !== undefined) {
            hitExtent = (0, $3412ad7bd362b04c$export$fe201bb3bbe031e9)();
            (0, $3412ad7bd362b04c$export$1f820e3920fa5715)(hitExtent, coordinate);
            (0, $3412ad7bd362b04c$export$ab1029bcae9ddb4a)(hitExtent, resolution * (this.renderBuffer_ + hitTolerance), hitExtent);
        }
        const indexes = $50fd8cb5269ba2f5$export$96fc84ea21b8269f(hitTolerance);
        /** @type {import("../canvas.js").BuilderType} */ let builderType;
        /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {import('../../style/Style.js').DeclutterMode} declutterMode Declutter mode.
     * @return {T|undefined} Callback result.
     */ function featureCallback(feature, geometry, declutterMode) {
            const imageData = context.getImageData(0, 0, contextSize, contextSize).data;
            for(let i = 0, ii = indexes.length; i < ii; i++)if (imageData[indexes[i]] > 0) {
                if (!declutteredFeatures || declutterMode === 'none' || builderType !== 'Image' && builderType !== 'Text' || declutteredFeatures.includes(feature)) {
                    const idx = (indexes[i] - 3) / 4;
                    const x = hitTolerance - idx % contextSize;
                    const y = hitTolerance - (idx / contextSize | 0);
                    const result = callback(feature, geometry, x * x + y * y);
                    if (result) return result;
                }
                context.clearRect(0, 0, contextSize, contextSize);
                break;
            }
            return undefined;
        }
        /** @type {Array<number>} */ const zs = Object.keys(this.executorsByZIndex_).map(Number);
        zs.sort((0, $db525acb5f2517fc$export$fcb633242ef15540));
        let i, j, executors, executor, result;
        for(i = zs.length - 1; i >= 0; --i){
            const zIndexKey = zs[i].toString();
            executors = this.executorsByZIndex_[zIndexKey];
            for(j = $50fd8cb5269ba2f5$export$61b49a5ae59d663.length - 1; j >= 0; --j){
                builderType = $50fd8cb5269ba2f5$export$61b49a5ae59d663[j];
                executor = executors[builderType];
                if (executor !== undefined) {
                    result = executor.executeHitDetection(context, transform, rotation, featureCallback, hitExtent);
                    if (result) return result;
                }
            }
        }
        return undefined;
    }
    /**
   * @param {import("../../transform.js").Transform} transform Transform.
   * @return {Array<number>|null} Clip coordinates.
   */ getClipCoords(transform) {
        const maxExtent = this.maxExtent_;
        if (!maxExtent) return null;
        const minX = maxExtent[0];
        const minY = maxExtent[1];
        const maxX = maxExtent[2];
        const maxY = maxExtent[3];
        const flatClipCoords = [
            minX,
            minY,
            minX,
            maxY,
            maxX,
            maxY,
            maxX,
            minY
        ];
        (0, $4149c848e00d54f8$export$b92b2dedcfff79de)(flatClipCoords, 0, 8, 2, transform, flatClipCoords);
        return flatClipCoords;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return (0, $0669c62275461b52$export$dd1bc94b04021eeb)(this.executorsByZIndex_);
    }
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} targetContext Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scale of the context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {boolean} snapToPixel Snap point symbols and test to integer pixel.
   * @param {Array<import("../canvas.js").BuilderType>} [builderTypes] Ordered replay types to replay.
   *     Default is {@link module:ol/render/replay~ALL}
   * @param {import("rbush").default<import('./Executor.js').DeclutterEntry>|null} [declutterTree] Declutter tree.
   *     When set to null, no decluttering is done, even when the executor group has a `ZIndexContext`.
   */ execute(targetContext, scaledCanvasSize, transform, viewRotation, snapToPixel, builderTypes, declutterTree) {
        const zs = Object.keys(this.executorsByZIndex_).map(Number);
        zs.sort(declutterTree ? (0, $db525acb5f2517fc$export$4fa3190a997c3d8f) : (0, $db525acb5f2517fc$export$fcb633242ef15540));
        builderTypes = builderTypes ? builderTypes : $50fd8cb5269ba2f5$export$61b49a5ae59d663;
        const maxBuilderTypes = $50fd8cb5269ba2f5$export$61b49a5ae59d663.length;
        for(let i = 0, ii = zs.length; i < ii; ++i){
            const zIndexKey = zs[i].toString();
            const replays = this.executorsByZIndex_[zIndexKey];
            for(let j = 0, jj = builderTypes.length; j < jj; ++j){
                const builderType = builderTypes[j];
                const replay = replays[builderType];
                if (replay !== undefined) {
                    const zIndexContext = declutterTree === null ? undefined : replay.getZIndexContext();
                    const context = zIndexContext ? zIndexContext.getContext() : targetContext;
                    const requireClip = this.maxExtent_ && builderType !== 'Image' && builderType !== 'Text';
                    if (requireClip) {
                        context.save();
                        // setup clipping so that the parts of over-simplified geometries are not
                        // visible outside the current extent when panning
                        this.clip(context, transform);
                    }
                    if (!zIndexContext || builderType === 'Text' || builderType === 'Image') replay.execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree);
                    else zIndexContext.pushFunction((context)=>replay.execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree));
                    if (requireClip) context.restore();
                    if (zIndexContext) {
                        zIndexContext.offset();
                        const index = zs[i] * maxBuilderTypes + $50fd8cb5269ba2f5$export$61b49a5ae59d663.indexOf(builderType);
                        if (!this.deferredZIndexContexts_[index]) this.deferredZIndexContexts_[index] = [];
                        this.deferredZIndexContexts_[index].push(zIndexContext);
                    }
                }
            }
        }
        this.renderedContext_ = targetContext;
    }
    getDeferredZIndexContexts() {
        return this.deferredZIndexContexts_;
    }
    getRenderedContext() {
        return this.renderedContext_;
    }
    renderDeferred() {
        const deferredZIndexContexts = this.deferredZIndexContexts_;
        const zs = Object.keys(deferredZIndexContexts).map(Number).sort((0, $db525acb5f2517fc$export$fcb633242ef15540));
        for(let i = 0, ii = zs.length; i < ii; ++i){
            deferredZIndexContexts[zs[i]].forEach((zIndexContext)=>{
                zIndexContext.draw(this.renderedContext_); // FIXME Pass clip to replay for temporarily enabling clip
                zIndexContext.clear();
            });
            deferredZIndexContexts[zs[i]].length = 0;
        }
    }
}
/**
 * This cache is used to store arrays of indexes for calculated pixel circles
 * to increase performance.
 * It is a static property to allow each Replaygroup to access it.
 * @type {Object<number, Array<number>>}
 */ const $50fd8cb5269ba2f5$var$circlePixelIndexArrayCache = {};
function $50fd8cb5269ba2f5$export$96fc84ea21b8269f(radius) {
    if ($50fd8cb5269ba2f5$var$circlePixelIndexArrayCache[radius] !== undefined) return $50fd8cb5269ba2f5$var$circlePixelIndexArrayCache[radius];
    const size = radius * 2 + 1;
    const maxDistanceSq = radius * radius;
    const distances = new Array(maxDistanceSq + 1);
    for(let i = 0; i <= radius; ++i)for(let j = 0; j <= radius; ++j){
        const distanceSq = i * i + j * j;
        if (distanceSq > maxDistanceSq) break;
        let distance = distances[distanceSq];
        if (!distance) {
            distance = [];
            distances[distanceSq] = distance;
        }
        distance.push(((radius + i) * size + (radius + j)) * 4 + 3);
        if (i > 0) distance.push(((radius - i) * size + (radius + j)) * 4 + 3);
        if (j > 0) {
            distance.push(((radius + i) * size + (radius - j)) * 4 + 3);
            if (i > 0) distance.push(((radius - i) * size + (radius - j)) * 4 + 3);
        }
    }
    const pixelIndex = [];
    for(let i = 0, ii = distances.length; i < ii; ++i)if (distances[i]) pixelIndex.push(...distances[i]);
    $50fd8cb5269ba2f5$var$circlePixelIndexArrayCache[radius] = pixelIndex;
    return pixelIndex;
}
var $50fd8cb5269ba2f5$export$2e2bcd8739ae039 = $50fd8cb5269ba2f5$var$ExecutorGroup;


/**
 * @module ol/render/canvas/hitdetect
 */ 





/**
 * @module ol/render/canvas/Immediate
 */ // FIXME test, especially polygons with holes and multipolygons
// FIXME need to handle large thick features (where pixel size matters)
// FIXME add offset and end to ol/geom/flat/transform~transform2D?










/**
 * @classdesc
 * A concrete subclass of {@link module:ol/render/VectorContext~VectorContext} that implements
 * direct rendering of features and geometries to an HTML5 Canvas context.
 * Instances of this class are created internally by the library and
 * provided to application code as vectorContext member of the
 * {@link module:ol/render/Event~RenderEvent} object associated with postcompose, precompose and
 * render events emitted by layers and maps.
 */ class $458889cf11241a7b$var$CanvasImmediateRenderer extends (0, $b070ce327ce37de2$export$2e2bcd8739ae039) {
    /**
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Context.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../../extent.js").Extent} extent Extent.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {number} [squaredTolerance] Optional squared tolerance for simplification.
   * @param {import("../../proj.js").TransformFunction} [userTransform] Transform from user to view projection.
   */ constructor(context, pixelRatio, extent, transform, viewRotation, squaredTolerance, userTransform){
        super();
        /**
     * @private
     * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
     */ this.context_ = context;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.extent_ = extent;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.transform_ = transform;
        /**
     * @private
     * @type {number}
     */ this.transformRotation_ = transform ? (0, $912ac838ff50d1cd$export$a81f732198733497)(Math.atan2(transform[1], transform[0]), 10) : 0;
        /**
     * @private
     * @type {number}
     */ this.viewRotation_ = viewRotation;
        /**
     * @private
     * @type {number}
     */ this.squaredTolerance_ = squaredTolerance;
        /**
     * @private
     * @type {import("../../proj.js").TransformFunction}
     */ this.userTransform_ = userTransform;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.contextFillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.contextStrokeState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").TextState}
     */ this.contextTextState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.fillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.strokeState_ = null;
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.image_ = null;
        /**
     * @private
     * @type {number}
     */ this.imageAnchorX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageAnchorY_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageHeight_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOpacity_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOriginX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOriginY_ = 0;
        /**
     * @private
     * @type {boolean}
     */ this.imageRotateWithView_ = false;
        /**
     * @private
     * @type {number}
     */ this.imageRotation_ = 0;
        /**
     * @private
     * @type {import("../../size.js").Size}
     */ this.imageScale_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {number}
     */ this.imageWidth_ = 0;
        /**
     * @private
     * @type {string}
     */ this.text_ = '';
        /**
     * @private
     * @type {number}
     */ this.textOffsetX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.textOffsetY_ = 0;
        /**
     * @private
     * @type {boolean}
     */ this.textRotateWithView_ = false;
        /**
     * @private
     * @type {number}
     */ this.textRotation_ = 0;
        /**
     * @private
     * @type {import("../../size.js").Size}
     */ this.textScale_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.textFillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.textStrokeState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").TextState}
     */ this.textState_ = null;
        /**
     * @private
     * @type {Array<number>}
     */ this.pixelCoordinates_ = [];
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.tmpLocalTransform_ = (0, $eb597965bdcc8f43$export$185802fd694ee1f5)();
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */ drawImages_(flatCoordinates, offset, end, stride) {
        if (!this.image_) return;
        const pixelCoordinates = (0, $4149c848e00d54f8$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        const context = this.context_;
        const localTransform = this.tmpLocalTransform_;
        const alpha = context.globalAlpha;
        if (this.imageOpacity_ != 1) context.globalAlpha = alpha * this.imageOpacity_;
        let rotation = this.imageRotation_;
        if (this.transformRotation_ === 0) rotation -= this.viewRotation_;
        if (this.imageRotateWithView_) rotation += this.viewRotation_;
        for(let i = 0, ii = pixelCoordinates.length; i < ii; i += 2){
            const x = pixelCoordinates[i] - this.imageAnchorX_;
            const y = pixelCoordinates[i + 1] - this.imageAnchorY_;
            if (rotation !== 0 || this.imageScale_[0] != 1 || this.imageScale_[1] != 1) {
                const centerX = x + this.imageAnchorX_;
                const centerY = y + this.imageAnchorY_;
                (0, $eb597965bdcc8f43$export$f672e0b6f7222cd7)(localTransform, centerX, centerY, 1, 1, rotation, -centerX, -centerY);
                context.save();
                context.transform.apply(context, localTransform);
                context.translate(centerX, centerY);
                context.scale(this.imageScale_[0], this.imageScale_[1]);
                context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, -this.imageAnchorX_, -this.imageAnchorY_, this.imageWidth_, this.imageHeight_);
                context.restore();
            } else context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, x, y, this.imageWidth_, this.imageHeight_);
        }
        if (this.imageOpacity_ != 1) context.globalAlpha = alpha;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */ drawText_(flatCoordinates, offset, end, stride) {
        if (!this.textState_ || this.text_ === '') return;
        if (this.textFillState_) this.setContextFillState_(this.textFillState_);
        if (this.textStrokeState_) this.setContextStrokeState_(this.textStrokeState_);
        this.setContextTextState_(this.textState_);
        const pixelCoordinates = (0, $4149c848e00d54f8$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        const context = this.context_;
        let rotation = this.textRotation_;
        if (this.transformRotation_ === 0) rotation -= this.viewRotation_;
        if (this.textRotateWithView_) rotation += this.viewRotation_;
        for(; offset < end; offset += stride){
            const x = pixelCoordinates[offset] + this.textOffsetX_;
            const y = pixelCoordinates[offset + 1] + this.textOffsetY_;
            if (rotation !== 0 || this.textScale_[0] != 1 || this.textScale_[1] != 1) {
                context.save();
                context.translate(x - this.textOffsetX_, y - this.textOffsetY_);
                context.rotate(rotation);
                context.translate(this.textOffsetX_, this.textOffsetY_);
                context.scale(this.textScale_[0], this.textScale_[1]);
                if (this.textStrokeState_) context.strokeText(this.text_, 0, 0);
                if (this.textFillState_) context.fillText(this.text_, 0, 0);
                context.restore();
            } else {
                if (this.textStrokeState_) context.strokeText(this.text_, x, y);
                if (this.textFillState_) context.fillText(this.text_, x, y);
            }
        }
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} close Close.
   * @param {number} [strokeOffset] Stroke Offset.
   * @private
   * @return {number} end End.
   */ moveToLineTo_(flatCoordinates, offset, end, stride, close, strokeOffset) {
        const context = this.context_;
        let pixelCoordinates = (0, $4149c848e00d54f8$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        if (Math.abs(strokeOffset) > 0) {
            pixelCoordinates = (0, $9bae2b3a5a7a0a59$export$a6b2441cc3fe7033)(pixelCoordinates, 0, pixelCoordinates.length, 2, strokeOffset, close, pixelCoordinates);
            (0, $9bae2b3a5a7a0a59$export$6b86a4a35195acf9)(pixelCoordinates, 2);
        }
        context.moveTo(pixelCoordinates[0], pixelCoordinates[1]);
        let length = pixelCoordinates.length;
        if (close) length -= 2;
        for(let i = 2; i < length; i += 2)context.lineTo(pixelCoordinates[i], pixelCoordinates[i + 1]);
        if (close) context.closePath();
        return end;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {number} [strokeOffset] Stroke Offset.
   * @private
   * @return {number} End.
   */ drawRings_(flatCoordinates, offset, ends, stride, strokeOffset) {
        for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, true, strokeOffset);
        return offset;
    }
    /**
   * Render a circle geometry into the canvas.  Rendering is immediate and uses
   * the current fill and stroke styles.
   *
   * @param {import("../../geom/Circle.js").default} geometry Circle geometry.
   * @api
   * @override
   */ drawCircle(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Circle.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $3412ad7bd362b04c$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.fillState_ || this.strokeState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const pixelCoordinates = (0, $7afe4d7f43fcf744$export$a3767472617c7861)(geometry, this.transform_, this.pixelCoordinates_);
            const dx = pixelCoordinates[2] - pixelCoordinates[0];
            const dy = pixelCoordinates[3] - pixelCoordinates[1];
            const radius = Math.sqrt(dx * dx + dy * dy);
            const context = this.context_;
            context.beginPath();
            context.arc(pixelCoordinates[0], pixelCoordinates[1], radius, 0, 2 * Math.PI);
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== '') this.drawText_(geometry.getCenter(), 0, 2, 2);
    }
    /**
   * Set the rendering style.  Note that since this is an immediate rendering API,
   * any `zIndex` on the provided style will be ignored.
   *
   * @param {import("../../style/Style.js").default} style The rendering style.
   * @api
   * @override
   */ setStyle(style) {
        this.setFillStrokeStyle(style.getFill(), style.getStroke());
        this.setImageStyle(style.getImage());
        this.setTextStyle(style.getText());
    }
    /**
   * @param {import("../../transform.js").Transform} transform Transform.
   */ setTransform(transform) {
        this.transform_ = transform;
    }
    /**
   * Render a geometry into the canvas.  Call
   * {@link module:ol/render/canvas/Immediate~CanvasImmediateRenderer#setStyle renderer.setStyle()} first to set the rendering style.
   *
   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry The geometry to render.
   * @api
   * @override
   */ drawGeometry(geometry) {
        const type = geometry.getType();
        switch(type){
            case 'Point':
                this.drawPoint(/** @type {import("../../geom/Point.js").default} */ geometry);
                break;
            case 'LineString':
                this.drawLineString(/** @type {import("../../geom/LineString.js").default} */ geometry);
                break;
            case 'Polygon':
                this.drawPolygon(/** @type {import("../../geom/Polygon.js").default} */ geometry);
                break;
            case 'MultiPoint':
                this.drawMultiPoint(/** @type {import("../../geom/MultiPoint.js").default} */ geometry);
                break;
            case 'MultiLineString':
                this.drawMultiLineString(/** @type {import("../../geom/MultiLineString.js").default} */ geometry);
                break;
            case 'MultiPolygon':
                this.drawMultiPolygon(/** @type {import("../../geom/MultiPolygon.js").default} */ geometry);
                break;
            case 'GeometryCollection':
                this.drawGeometryCollection(/** @type {import("../../geom/GeometryCollection.js").default} */ geometry);
                break;
            case 'Circle':
                this.drawCircle(/** @type {import("../../geom/Circle.js").default} */ geometry);
                break;
            default:
        }
    }
    /**
   * Render a feature into the canvas.  Note that any `zIndex` on the provided
   * style will be ignored - features are rendered immediately in the order that
   * this method is called.  If you need `zIndex` support, you should be using an
   * {@link module:ol/layer/Vector~VectorLayer} instead.
   *
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {import("../../style/Style.js").default} style Style.
   * @api
   * @override
   */ drawFeature(feature, style) {
        const geometry = style.getGeometryFunction()(feature);
        if (!geometry) return;
        this.setStyle(style);
        this.drawGeometry(geometry);
    }
    /**
   * Render a GeometryCollection to the canvas.  Rendering is immediate and
   * uses the current styles appropriate for each geometry in the collection.
   *
   * @param {import("../../geom/GeometryCollection.js").default} geometry Geometry collection.
   * @override
   */ drawGeometryCollection(geometry) {
        const geometries = geometry.getGeometriesArray();
        for(let i = 0, ii = geometries.length; i < ii; ++i)this.drawGeometry(geometries[i]);
    }
    /**
   * Render a Point geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} geometry Point geometry.
   * @override
   */ drawPoint(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Point.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const flatCoordinates = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        if (this.image_) this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
        if (this.text_ !== '') this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
    }
    /**
   * Render a MultiPoint geometry  into the canvas.  Rendering is immediate and
   * uses the current style.
   *
   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} geometry MultiPoint geometry.
   * @override
   */ drawMultiPoint(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiPoint.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const flatCoordinates = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        if (this.image_) this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
        if (this.text_ !== '') this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
    }
    /**
   * Render a LineString into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} geometry LineString geometry.
   * @override
   */ drawLineString(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/LineString.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $3412ad7bd362b04c$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_) {
            this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getFlatCoordinates();
            context.beginPath();
            this.moveToLineTo_(flatCoordinates, 0, flatCoordinates.length, geometry.getStride(), false, this.strokeState_.strokeOffset);
            context.stroke();
        }
        if (this.text_ !== '') {
            const flatMidpoint = geometry.getFlatMidpoint();
            this.drawText_(flatMidpoint, 0, 2, 2);
        }
    }
    /**
   * Render a MultiLineString geometry into the canvas.  Rendering is immediate
   * and uses the current style.
   *
   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} geometry MultiLineString geometry.
   * @override
   */ drawMultiLineString(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const geometryExtent = geometry.getExtent();
        if (!(0, $3412ad7bd362b04c$export$7b0a31e10bbff018)(this.extent_, geometryExtent)) return;
        if (this.strokeState_) {
            this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getFlatCoordinates();
            let offset = 0;
            const ends = /** @type {Array<number>} */ geometry.getEnds();
            const stride = geometry.getStride();
            context.beginPath();
            for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, false, this.strokeState_.strokeOffset);
            context.stroke();
        }
        if (this.text_ !== '') {
            const flatMidpoints = geometry.getFlatMidpoints();
            this.drawText_(flatMidpoints, 0, flatMidpoints.length, 2);
        }
    }
    /**
   * Render a Polygon geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} geometry Polygon geometry.
   * @override
   */ drawPolygon(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Polygon.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $3412ad7bd362b04c$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_ || this.fillState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            context.beginPath();
            this.drawRings_(geometry.getOrientedFlatCoordinates(), 0, /** @type {Array<number>} */ geometry.getEnds(), geometry.getStride(), this.strokeState_?.strokeOffset);
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== '') {
            const flatInteriorPoint = geometry.getFlatInteriorPoint();
            this.drawText_(flatInteriorPoint, 0, 2, 2);
        }
    }
    /**
   * Render MultiPolygon geometry into the canvas.  Rendering is immediate and
   * uses the current style.
   * @param {import("../../geom/MultiPolygon.js").default} geometry MultiPolygon geometry.
   * @override
   */ drawMultiPolygon(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $3412ad7bd362b04c$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_ || this.fillState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getOrientedFlatCoordinates();
            let offset = 0;
            const endss = geometry.getEndss();
            const stride = geometry.getStride();
            context.beginPath();
            for(let i = 0, ii = endss.length; i < ii; ++i){
                const ends = endss[i];
                offset = this.drawRings_(flatCoordinates, offset, ends, stride, this.strokeState_?.strokeOffset);
            }
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== '') {
            const flatInteriorPoints = geometry.getFlatInteriorPoints();
            this.drawText_(flatInteriorPoints, 0, flatInteriorPoints.length, 2);
        }
    }
    /**
   * @param {import("../canvas.js").FillState} fillState Fill state.
   * @private
   */ setContextFillState_(fillState) {
        const context = this.context_;
        const contextFillState = this.contextFillState_;
        if (!contextFillState) {
            context.fillStyle = fillState.fillStyle;
            this.contextFillState_ = {
                fillStyle: fillState.fillStyle
            };
        } else if (contextFillState.fillStyle != fillState.fillStyle) {
            contextFillState.fillStyle = fillState.fillStyle;
            context.fillStyle = fillState.fillStyle;
        }
    }
    /**
   * @param {import("../canvas.js").StrokeState} strokeState Stroke state.
   * @private
   */ setContextStrokeState_(strokeState) {
        const context = this.context_;
        const contextStrokeState = this.contextStrokeState_;
        if (!contextStrokeState) {
            context.lineCap = strokeState.lineCap;
            context.setLineDash(strokeState.lineDash);
            context.lineDashOffset = strokeState.lineDashOffset;
            context.lineJoin = strokeState.lineJoin;
            context.lineWidth = strokeState.lineWidth;
            context.miterLimit = strokeState.miterLimit;
            context.strokeStyle = strokeState.strokeStyle;
            this.contextStrokeState_ = {
                lineCap: strokeState.lineCap,
                lineDash: strokeState.lineDash,
                lineDashOffset: strokeState.lineDashOffset,
                lineJoin: strokeState.lineJoin,
                lineWidth: strokeState.lineWidth,
                miterLimit: strokeState.miterLimit,
                strokeStyle: strokeState.strokeStyle
            };
        } else {
            if (contextStrokeState.lineCap != strokeState.lineCap) {
                contextStrokeState.lineCap = strokeState.lineCap;
                context.lineCap = strokeState.lineCap;
            }
            if (!(0, $db525acb5f2517fc$export$e9bab7fafb253603)(contextStrokeState.lineDash, strokeState.lineDash)) context.setLineDash(contextStrokeState.lineDash = strokeState.lineDash);
            if (contextStrokeState.lineDashOffset != strokeState.lineDashOffset) {
                contextStrokeState.lineDashOffset = strokeState.lineDashOffset;
                context.lineDashOffset = strokeState.lineDashOffset;
            }
            if (contextStrokeState.lineJoin != strokeState.lineJoin) {
                contextStrokeState.lineJoin = strokeState.lineJoin;
                context.lineJoin = strokeState.lineJoin;
            }
            if (contextStrokeState.lineWidth != strokeState.lineWidth) {
                contextStrokeState.lineWidth = strokeState.lineWidth;
                context.lineWidth = strokeState.lineWidth;
            }
            if (contextStrokeState.miterLimit != strokeState.miterLimit) {
                contextStrokeState.miterLimit = strokeState.miterLimit;
                context.miterLimit = strokeState.miterLimit;
            }
            if (contextStrokeState.strokeStyle != strokeState.strokeStyle) {
                contextStrokeState.strokeStyle = strokeState.strokeStyle;
                context.strokeStyle = strokeState.strokeStyle;
            }
        }
    }
    /**
   * @param {import("../canvas.js").TextState} textState Text state.
   * @private
   */ setContextTextState_(textState) {
        const context = this.context_;
        const contextTextState = this.contextTextState_;
        const textAlign = textState.textAlign ? textState.textAlign : (0, $3b9b2e731b8ee924$export$94d53b95641b5766);
        if (!contextTextState) {
            context.font = textState.font;
            context.textAlign = textAlign;
            context.textBaseline = textState.textBaseline;
            this.contextTextState_ = {
                font: textState.font,
                textAlign: textAlign,
                textBaseline: textState.textBaseline
            };
        } else {
            if (contextTextState.font != textState.font) {
                contextTextState.font = textState.font;
                context.font = textState.font;
            }
            if (contextTextState.textAlign != textAlign) {
                contextTextState.textAlign = textAlign;
                context.textAlign = textAlign;
            }
            if (contextTextState.textBaseline != textState.textBaseline) {
                contextTextState.textBaseline = textState.textBaseline;
                context.textBaseline = textState.textBaseline;
            }
        }
    }
    /**
   * Set the fill and stroke style for subsequent draw operations.  To clear
   * either fill or stroke styles, pass null for the appropriate parameter.
   *
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   * @override
   */ setFillStrokeStyle(fillStyle, strokeStyle) {
        if (!fillStyle) this.fillState_ = null;
        else {
            const fillStyleColor = fillStyle.getColor();
            this.fillState_ = {
                fillStyle: (0, $bafa252a4f4b168a$export$dc5b1400ac3a10a8)(fillStyleColor ? fillStyleColor : (0, $3b9b2e731b8ee924$export$c495d52ee3fd74b2))
            };
        }
        if (!strokeStyle) this.strokeState_ = null;
        else {
            const strokeStyleColor = strokeStyle.getColor();
            const strokeStyleLineCap = strokeStyle.getLineCap();
            const strokeStyleLineDash = strokeStyle.getLineDash();
            const strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
            const strokeStyleLineJoin = strokeStyle.getLineJoin();
            const strokeStyleWidth = strokeStyle.getWidth();
            const strokeStyleMiterLimit = strokeStyle.getMiterLimit();
            const lineDash = strokeStyleLineDash ? strokeStyleLineDash : (0, $3b9b2e731b8ee924$export$e21b4112fdc612fc);
            const strokeOffset = strokeStyle.getOffset();
            this.strokeState_ = {
                lineCap: strokeStyleLineCap !== undefined ? strokeStyleLineCap : (0, $3b9b2e731b8ee924$export$17bd0c38d6ae694e),
                lineDash: this.pixelRatio_ === 1 ? lineDash : lineDash.map((n)=>n * this.pixelRatio_),
                lineDashOffset: (strokeStyleLineDashOffset ? strokeStyleLineDashOffset : (0, $3b9b2e731b8ee924$export$e06efc2409049f76)) * this.pixelRatio_,
                lineJoin: strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : (0, $3b9b2e731b8ee924$export$365eb9648cf19bd0),
                lineWidth: (strokeStyleWidth !== undefined ? strokeStyleWidth : (0, $3b9b2e731b8ee924$export$79661f132c62010e)) * this.pixelRatio_,
                miterLimit: strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : (0, $3b9b2e731b8ee924$export$80c1c01844597b7b),
                strokeStyle: (0, $bafa252a4f4b168a$export$dc5b1400ac3a10a8)(strokeStyleColor ? strokeStyleColor : (0, $3b9b2e731b8ee924$export$1eb2eaecacf2031e)),
                strokeOffset: (strokeOffset ?? 0) * this.pixelRatio_
            };
        }
    }
    /**
   * Set the image style for subsequent draw operations.  Pass null to remove
   * the image style.
   *
   * @param {import("../../style/Image.js").default} imageStyle Image style.
   * @override
   */ setImageStyle(imageStyle) {
        let imageSize;
        if (!imageStyle || !(imageSize = imageStyle.getSize())) {
            this.image_ = null;
            return;
        }
        const imagePixelRatio = imageStyle.getPixelRatio(this.pixelRatio_);
        const imageAnchor = imageStyle.getAnchor();
        const imageOrigin = imageStyle.getOrigin();
        this.image_ = imageStyle.getImage(this.pixelRatio_);
        this.imageAnchorX_ = imageAnchor[0] * imagePixelRatio;
        this.imageAnchorY_ = imageAnchor[1] * imagePixelRatio;
        this.imageHeight_ = imageSize[1] * imagePixelRatio;
        this.imageOpacity_ = imageStyle.getOpacity();
        this.imageOriginX_ = imageOrigin[0];
        this.imageOriginY_ = imageOrigin[1];
        this.imageRotateWithView_ = imageStyle.getRotateWithView();
        this.imageRotation_ = imageStyle.getRotation();
        const imageScale = imageStyle.getScaleArray();
        this.imageScale_ = [
            imageScale[0] * this.pixelRatio_ / imagePixelRatio,
            imageScale[1] * this.pixelRatio_ / imagePixelRatio
        ];
        this.imageWidth_ = imageSize[0] * imagePixelRatio;
    }
    /**
   * Set the text style for subsequent draw operations.  Pass null to
   * remove the text style.
   *
   * @param {import("../../style/Text.js").default} textStyle Text style.
   * @override
   */ setTextStyle(textStyle) {
        if (!textStyle) this.text_ = '';
        else {
            const textFillStyle = textStyle.getFill();
            if (!textFillStyle) this.textFillState_ = null;
            else {
                const textFillStyleColor = textFillStyle.getColor();
                this.textFillState_ = {
                    fillStyle: (0, $bafa252a4f4b168a$export$dc5b1400ac3a10a8)(textFillStyleColor ? textFillStyleColor : (0, $3b9b2e731b8ee924$export$c495d52ee3fd74b2))
                };
            }
            const textStrokeStyle = textStyle.getStroke();
            if (!textStrokeStyle) this.textStrokeState_ = null;
            else {
                const textStrokeStyleColor = textStrokeStyle.getColor();
                const textStrokeStyleLineCap = textStrokeStyle.getLineCap();
                const textStrokeStyleLineDash = textStrokeStyle.getLineDash();
                const textStrokeStyleLineDashOffset = textStrokeStyle.getLineDashOffset();
                const textStrokeStyleLineJoin = textStrokeStyle.getLineJoin();
                const textStrokeStyleWidth = textStrokeStyle.getWidth();
                const textStrokeStyleMiterLimit = textStrokeStyle.getMiterLimit();
                this.textStrokeState_ = {
                    lineCap: textStrokeStyleLineCap !== undefined ? textStrokeStyleLineCap : (0, $3b9b2e731b8ee924$export$17bd0c38d6ae694e),
                    lineDash: textStrokeStyleLineDash ? textStrokeStyleLineDash : (0, $3b9b2e731b8ee924$export$e21b4112fdc612fc),
                    lineDashOffset: textStrokeStyleLineDashOffset ? textStrokeStyleLineDashOffset : (0, $3b9b2e731b8ee924$export$e06efc2409049f76),
                    lineJoin: textStrokeStyleLineJoin !== undefined ? textStrokeStyleLineJoin : (0, $3b9b2e731b8ee924$export$365eb9648cf19bd0),
                    lineWidth: textStrokeStyleWidth !== undefined ? textStrokeStyleWidth : (0, $3b9b2e731b8ee924$export$79661f132c62010e),
                    miterLimit: textStrokeStyleMiterLimit !== undefined ? textStrokeStyleMiterLimit : (0, $3b9b2e731b8ee924$export$80c1c01844597b7b),
                    strokeStyle: (0, $bafa252a4f4b168a$export$dc5b1400ac3a10a8)(textStrokeStyleColor ? textStrokeStyleColor : (0, $3b9b2e731b8ee924$export$1eb2eaecacf2031e))
                };
            }
            const textFont = textStyle.getFont();
            const textOffsetX = textStyle.getOffsetX();
            const textOffsetY = textStyle.getOffsetY();
            const textRotateWithView = textStyle.getRotateWithView();
            const textRotation = textStyle.getRotation();
            const textScale = textStyle.getScaleArray();
            const textText = textStyle.getText();
            const textTextAlign = textStyle.getTextAlign();
            const textTextBaseline = textStyle.getTextBaseline();
            this.textState_ = {
                font: textFont !== undefined ? textFont : (0, $3b9b2e731b8ee924$export$3847dfea4f8d4dfa),
                textAlign: textTextAlign !== undefined ? textTextAlign : (0, $3b9b2e731b8ee924$export$94d53b95641b5766),
                textBaseline: textTextBaseline !== undefined ? textTextBaseline : (0, $3b9b2e731b8ee924$export$cf2279a1bff62eb)
            };
            this.text_ = textText !== undefined ? Array.isArray(textText) ? textText.reduce((acc, t, i)=>acc += i % 2 ? ' ' : t, '') : textText : '';
            this.textOffsetX_ = textOffsetX !== undefined ? this.pixelRatio_ * textOffsetX : 0;
            this.textOffsetY_ = textOffsetY !== undefined ? this.pixelRatio_ * textOffsetY : 0;
            this.textRotateWithView_ = textRotateWithView !== undefined ? textRotateWithView : false;
            this.textRotation_ = textRotation !== undefined ? textRotation : 0;
            this.textScale_ = [
                this.pixelRatio_ * textScale[0],
                this.pixelRatio_ * textScale[1]
            ];
        }
    }
}
var $458889cf11241a7b$export$2e2bcd8739ae039 = $458889cf11241a7b$var$CanvasImmediateRenderer;


const $75ad1ba908ec14d4$export$ab51038298418f25 = 0.5;
function $75ad1ba908ec14d4$export$bd05e394339d469(size, transforms, features, styleFunction, extent, resolution, rotation, squaredTolerance, projection) {
    const userExtent = projection ? (0, $2a998b085c5a7ac9$export$96bfd09e2cffb006)(extent, projection) : extent;
    const width = size[0] * $75ad1ba908ec14d4$export$ab51038298418f25;
    const height = size[1] * $75ad1ba908ec14d4$export$ab51038298418f25;
    const context = (0, $5ce605ba3ee034a0$export$9e05d10eae75c464)(width, height);
    context.imageSmoothingEnabled = false;
    const canvas = context.canvas;
    const renderer = new (0, $458889cf11241a7b$export$2e2bcd8739ae039)(context, $75ad1ba908ec14d4$export$ab51038298418f25, extent, null, rotation, squaredTolerance, projection ? (0, $2a998b085c5a7ac9$export$e3c4995a701c26a3)((0, $2a998b085c5a7ac9$export$3973b77d5f6f2790)(), projection) : null);
    const featureCount = features.length;
    // Stretch hit detection index to use the whole available color range
    const indexFactor = Math.floor(16777215 / featureCount);
    const featuresByZIndex = {};
    for(let i = 1; i <= featureCount; ++i){
        const feature = features[i - 1];
        const featureStyleFunction = feature.getStyleFunction() || styleFunction;
        if (!featureStyleFunction) continue;
        let styles = featureStyleFunction(feature, resolution);
        if (!styles) continue;
        if (!Array.isArray(styles)) styles = [
            styles
        ];
        const index = i * indexFactor;
        const color = index.toString(16).padStart(7, '#00000');
        for(let j = 0, jj = styles.length; j < jj; ++j){
            const originalStyle = styles[j];
            const geometry = originalStyle.getGeometryFunction()(feature);
            if (!geometry || !(0, $3412ad7bd362b04c$export$7b0a31e10bbff018)(userExtent, geometry.getExtent())) continue;
            const style = originalStyle.clone();
            const fill = style.getFill();
            if (fill) fill.setColor(color);
            const stroke = style.getStroke();
            if (stroke) {
                stroke.setColor(color);
                stroke.setLineDash(null);
            }
            style.setText(undefined);
            const image = originalStyle.getImage();
            if (image) {
                const imgSize = image.getImageSize();
                if (!imgSize) continue;
                const imgContext = (0, $5ce605ba3ee034a0$export$9e05d10eae75c464)(imgSize[0], imgSize[1], undefined, {
                    alpha: false
                });
                const img = imgContext.canvas;
                imgContext.fillStyle = color;
                imgContext.fillRect(0, 0, img.width, img.height);
                style.setImage(new (0, $3f49168ea08c039d$export$2e2bcd8739ae039)({
                    img: img,
                    anchor: image.getAnchor(),
                    anchorXUnits: 'pixels',
                    anchorYUnits: 'pixels',
                    offset: image.getOrigin(),
                    opacity: 1,
                    size: image.getSize(),
                    scale: image.getScale(),
                    rotation: image.getRotation(),
                    rotateWithView: image.getRotateWithView()
                }));
            }
            const zIndex = style.getZIndex() || 0;
            let byGeometryType = featuresByZIndex[zIndex];
            if (!byGeometryType) {
                byGeometryType = {};
                featuresByZIndex[zIndex] = byGeometryType;
                byGeometryType['Polygon'] = [];
                byGeometryType['Circle'] = [];
                byGeometryType['LineString'] = [];
                byGeometryType['Point'] = [];
            }
            const type = geometry.getType();
            if (type === 'GeometryCollection') {
                const geometries = /** @type {import("../../geom/GeometryCollection.js").default} */ geometry.getGeometriesArrayRecursive();
                for(let i = 0, ii = geometries.length; i < ii; ++i){
                    const geometry = geometries[i];
                    byGeometryType[geometry.getType().replace('Multi', '')].push(geometry, style);
                }
            } else byGeometryType[type.replace('Multi', '')].push(geometry, style);
        }
    }
    const zIndexKeys = Object.keys(featuresByZIndex).map(Number).sort((0, $db525acb5f2517fc$export$fcb633242ef15540));
    for(let i = 0, ii = zIndexKeys.length; i < ii; ++i){
        const byGeometryType = featuresByZIndex[zIndexKeys[i]];
        for(const type in byGeometryType){
            const geomAndStyle = byGeometryType[type];
            for(let j = 0, jj = geomAndStyle.length; j < jj; j += 2){
                renderer.setStyle(geomAndStyle[j + 1]);
                for(let k = 0, kk = transforms.length; k < kk; ++k){
                    renderer.setTransform(transforms[k]);
                    renderer.drawGeometry(geomAndStyle[j]);
                }
            }
        }
    }
    return context.getImageData(0, 0, canvas.width, canvas.height);
}
function $75ad1ba908ec14d4$export$6d4d555ddbfffa32(pixel, features, imageData) {
    /** @type {Array<F>} */ const resultFeatures = [];
    if (imageData) {
        const x = Math.floor(Math.round(pixel[0]) * $75ad1ba908ec14d4$export$ab51038298418f25);
        const y = Math.floor(Math.round(pixel[1]) * $75ad1ba908ec14d4$export$ab51038298418f25);
        // The pixel coordinate is clamped down to the hit-detect canvas' size to account
        // for browsers returning coordinates slightly larger than the actual canvas size
        // due to a non-integer pixel ratio.
        const index = ((0, $912ac838ff50d1cd$export$7d15b64cf5a3a4c4)(x, 0, imageData.width - 1) + (0, $912ac838ff50d1cd$export$7d15b64cf5a3a4c4)(y, 0, imageData.height - 1) * imageData.width) * 4;
        const r = imageData.data[index];
        const g = imageData.data[index + 1];
        const b = imageData.data[index + 2];
        const i = b + 256 * (g + 256 * r);
        const indexFactor = Math.floor(16777215 / features.length);
        if (i && i % indexFactor === 0) resultFeatures.push(features[i / indexFactor - 1]);
    }
    return resultFeatures;
}



/**
 * @module ol/renderer/vector
 */ 

/**
 * Feature callback. The callback will be called with three arguments. The first
 * argument is one {@link module:ol/Feature~Feature feature} or {@link module:ol/render/Feature~RenderFeature render feature}
 * at the pixel, the second is the {@link module:ol/layer/Layer~Layer layer} of the feature and will be null for
 * unmanaged layers. The third is the {@link module:ol/geom/SimpleGeometry~SimpleGeometry} of the feature. For features
 * with a GeometryCollection geometry, it will be the first detected geometry from the collection.
 * @template T
 * @typedef {function(import("../Feature.js").FeatureLike, import("../layer/Layer.js").default<import("../source/Source.js").default>, import("../geom/SimpleGeometry.js").default): T} FeatureCallback
 */ /**
 * Tolerance for geometry simplification in device pixels.
 * @type {number}
 */ const $16bc938c5cf0388a$var$SIMPLIFY_TOLERANCE = 0.5;
/**
 * @const
 * @type {Object<import("../geom/Geometry.js").Type,
 *                function(import("../render/canvas/BuilderGroup.js").default, import("../geom/Geometry.js").default,
 *                         import("../style/Style.js").default, Object): void>}
 */ const $16bc938c5cf0388a$var$GEOMETRY_RENDERERS = {
    'Point': $16bc938c5cf0388a$var$renderPointGeometry,
    'LineString': $16bc938c5cf0388a$var$renderLineStringGeometry,
    'Polygon': $16bc938c5cf0388a$var$renderPolygonGeometry,
    'MultiPoint': $16bc938c5cf0388a$var$renderMultiPointGeometry,
    'MultiLineString': $16bc938c5cf0388a$var$renderMultiLineStringGeometry,
    'MultiPolygon': $16bc938c5cf0388a$var$renderMultiPolygonGeometry,
    'GeometryCollection': $16bc938c5cf0388a$var$renderGeometryCollectionGeometry,
    'Circle': $16bc938c5cf0388a$var$renderCircleGeometry
};
function $16bc938c5cf0388a$export$531ddd8416d52dfc(feature1, feature2) {
    return parseInt((0, $01f1986453243423$export$5e82334337e0f204)(feature1), 10) - parseInt((0, $01f1986453243423$export$5e82334337e0f204)(feature2), 10);
}
function $16bc938c5cf0388a$export$75084a70d324c1e6(resolution, pixelRatio) {
    const tolerance = $16bc938c5cf0388a$export$bdacc5b475012edb(resolution, pixelRatio);
    return tolerance * tolerance;
}
function $16bc938c5cf0388a$export$bdacc5b475012edb(resolution, pixelRatio) {
    return $16bc938c5cf0388a$var$SIMPLIFY_TOLERANCE * resolution / pixelRatio;
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
 * @param {import("../geom/Circle.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {number} [index] Render order index.
 */ function $16bc938c5cf0388a$var$renderCircleGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        const circleReplay = builderGroup.getBuilder(style.getZIndex(), 'Circle');
        circleReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        circleReplay.drawCircle(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
function $16bc938c5cf0388a$export$36f470a33a42f413(replayGroup, feature, style, squaredTolerance, listener, transform, declutter, index) {
    const loadingPromises = [];
    const imageStyle = style.getImage();
    if (imageStyle) {
        let loading = true;
        const imageState = imageStyle.getImageState();
        if (imageState == (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADED || imageState == (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).ERROR) loading = false;
        else if (imageState == (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).IDLE) imageStyle.load();
        if (loading) loadingPromises.push(imageStyle.ready());
    }
    const fillStyle = style.getFill();
    if (fillStyle && fillStyle.loading()) loadingPromises.push(fillStyle.ready());
    const loading = loadingPromises.length > 0;
    if (loading) Promise.all(loadingPromises).then(()=>listener(null));
    $16bc938c5cf0388a$var$renderFeatureInternal(replayGroup, feature, style, squaredTolerance, transform, declutter, index);
    return loading;
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../style/Style.js").default} style Style.
 * @param {number} squaredTolerance Squared tolerance.
 * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
 * @param {boolean} [declutter] Enable decluttering.
 * @param {number} [index] Render order index..
 */ function $16bc938c5cf0388a$var$renderFeatureInternal(replayGroup, feature, style, squaredTolerance, transform, declutter, index) {
    const geometry = style.getGeometryFunction()(feature);
    if (!geometry) return;
    const simplifiedGeometry = geometry.simplifyTransformed(squaredTolerance, transform);
    const renderer = style.getRenderer();
    if (renderer) $16bc938c5cf0388a$var$renderGeometry(replayGroup, simplifiedGeometry, style, feature, index);
    else {
        const geometryRenderer = $16bc938c5cf0388a$var$GEOMETRY_RENDERERS[simplifiedGeometry.getType()];
        geometryRenderer(replayGroup, simplifiedGeometry, style, feature, index, declutter);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/Geometry.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $16bc938c5cf0388a$var$renderGeometry(replayGroup, geometry, style, feature, index) {
    if (geometry.getType() == 'GeometryCollection') {
        const geometries = /** @type {import("../geom/GeometryCollection.js").default} */ geometry.getGeometries();
        for(let i = 0, ii = geometries.length; i < ii; ++i)$16bc938c5cf0388a$var$renderGeometry(replayGroup, geometries[i], style, feature, index);
        return;
    }
    const replay = replayGroup.getBuilder(style.getZIndex(), 'Default');
    replay.drawCustom(/** @type {import("../geom/SimpleGeometry.js").default} */ geometry, feature, style.getRenderer(), style.getHitDetectionRenderer(), index);
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [declutterBuilderGroup] Builder for decluttering.
 * @param {number} [index] Render order index.
 */ function $16bc938c5cf0388a$var$renderGeometryCollectionGeometry(replayGroup, geometry, style, feature, declutterBuilderGroup, index) {
    const geometries = geometry.getGeometriesArray();
    let i, ii;
    for(i = 0, ii = geometries.length; i < ii; ++i){
        const geometryRenderer = $16bc938c5cf0388a$var$GEOMETRY_RENDERERS[geometries[i].getType()];
        geometryRenderer(replayGroup, geometries[i], style, feature, declutterBuilderGroup, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/LineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $16bc938c5cf0388a$var$renderLineStringGeometry(builderGroup, geometry, style, feature, index) {
    const strokeStyle = style.getStroke();
    if (strokeStyle) {
        const lineStringReplay = builderGroup.getBuilder(style.getZIndex(), 'LineString');
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawLineString(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiLineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $16bc938c5cf0388a$var$renderMultiLineStringGeometry(builderGroup, geometry, style, feature, index) {
    const strokeStyle = style.getStroke();
    if (strokeStyle) {
        const lineStringReplay = builderGroup.getBuilder(style.getZIndex(), 'LineString');
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawMultiLineString(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {number} [index] Render order index.
 */ function $16bc938c5cf0388a$var$renderMultiPolygonGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (strokeStyle || fillStyle) {
        const polygonReplay = builderGroup.getBuilder(style.getZIndex(), 'Polygon');
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawMultiPolygon(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/Point.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 * @param {boolean} [declutter] Enable decluttering.
 */ function $16bc938c5cf0388a$var$renderPointGeometry(builderGroup, geometry, style, feature, index, declutter) {
    const imageStyle = style.getImage();
    const textStyle = style.getText();
    const hasText = textStyle && textStyle.getText();
    /** @type {import("../render/canvas.js").DeclutterImageWithText} */ const declutterImageWithText = declutter && imageStyle && hasText ? {} : undefined;
    if (imageStyle) {
        if (imageStyle.getImageState() != (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADED) return;
        const imageReplay = builderGroup.getBuilder(style.getZIndex(), 'Image');
        imageReplay.setImageStyle(imageStyle, declutterImageWithText);
        imageReplay.drawPoint(geometry, feature, index);
    }
    if (hasText) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle, declutterImageWithText);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiPoint.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 * @param {boolean} [declutter] Enable decluttering.
 */ function $16bc938c5cf0388a$var$renderMultiPointGeometry(builderGroup, geometry, style, feature, index, declutter) {
    const imageStyle = style.getImage();
    const hasImage = imageStyle && imageStyle.getOpacity() !== 0;
    const textStyle = style.getText();
    const hasText = textStyle && textStyle.getText();
    /** @type {import("../render/canvas.js").DeclutterImageWithText} */ const declutterImageWithText = declutter && hasImage && hasText ? {} : undefined;
    if (hasImage) {
        if (imageStyle.getImageState() != (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADED) return;
        const imageReplay = builderGroup.getBuilder(style.getZIndex(), 'Image');
        imageReplay.setImageStyle(imageStyle, declutterImageWithText);
        imageReplay.drawMultiPoint(geometry, feature, index);
    }
    if (hasText) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle, declutterImageWithText);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/Polygon.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $16bc938c5cf0388a$var$renderPolygonGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        const polygonReplay = builderGroup.getBuilder(style.getZIndex(), 'Polygon');
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawPolygon(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}



/**
 * @classdesc
 * Canvas renderer for vector layers.
 * @api
 */ class $ae1542c17bfef714$var$CanvasVectorLayerRenderer extends (0, $80ebe417992070aa$export$2e2bcd8739ae039) {
    /**
   * @param {import("../../layer/BaseVector.js").default} vectorLayer Vector layer.
   */ constructor(vectorLayer){
        super(vectorLayer);
        /** @private */ this.boundHandleStyleImageChange_ = this.handleStyleImageChange_.bind(this);
        /**
     * @private
     * @type {boolean}
     */ this.animatingOrInteracting_;
        /**
     * @private
     * @type {ImageData|null}
     */ this.hitDetectionImageData_ = null;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.clipExtent_ = null;
        /**
     * Do we need to extend the rendered area on the x-axis to handle
     * features that cross the antimeridian?
     * @private
     * @type {boolean}
     */ this.extendX_ = false;
        /**
     * @private
     * @type {Array<import("../../Feature.js").default>}
     */ this.renderedFeatures_ = null;
        /**
     * @private
     * @type {number}
     */ this.renderedRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.renderedResolution_ = NaN;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.renderedExtent_ = (0, $3412ad7bd362b04c$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.wrappedRenderedExtent_ = (0, $3412ad7bd362b04c$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {number}
     */ this.renderedRotation_;
        /**
     * @private
     * @type {import("../../coordinate.js").Coordinate}
     */ this.renderedCenter_ = null;
        /**
     * @private
     * @type {import("../../proj/Projection.js").default}
     */ this.renderedProjection_ = null;
        /**
     * @private
     * @type {number}
     */ this.renderedPixelRatio_ = 1;
        /**
     * @private
     * @type {import("../../render.js").OrderFunction|null}
     */ this.renderedRenderOrder_ = null;
        /**
     * @private
     * @type {boolean}
     */ this.renderedFrameDeclutter_;
        /**
     * @private
     * @type {import("../../render/canvas/ExecutorGroup.js").default}
     */ this.replayGroup_ = null;
        /**
     * A new replay group had to be created by `prepareFrame()`
     * @type {boolean}
     */ this.replayGroupChanged = true;
        /**
     * Clipping to be performed by `renderFrame()`
     * @type {boolean}
     */ this.clipping = true;
        /**
     * @private
     * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
     */ this.targetContext_ = null;
        /**
     * @private
     * @type {number}
     */ this.opacity_ = 1;
    }
    /**
   * @param {ExecutorGroup} executorGroup Executor group.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {boolean} [declutterable] `true` to only render declutterable items,
   *     `false` to only render non-declutterable items, `undefined` to render all.
   */ renderWorlds(executorGroup, frameState, declutterable) {
        const extent = frameState.extent;
        const viewState = frameState.viewState;
        const center = viewState.center;
        const resolution = viewState.resolution;
        const projection = viewState.projection;
        const rotation = viewState.rotation;
        const projectionExtent = projection.getExtent();
        const vectorSource = this.getLayer().getSource();
        const declutter = this.getLayer().getDeclutter();
        const pixelRatio = frameState.pixelRatio;
        const viewHints = frameState.viewHints;
        const snapToPixel = !(viewHints[(0, $08bf132ff3931200$export$2e2bcd8739ae039).ANIMATING] || viewHints[(0, $08bf132ff3931200$export$2e2bcd8739ae039).INTERACTING]);
        const context = this.context;
        const width = Math.round((0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(extent) / resolution * pixelRatio);
        const height = Math.round((0, $3412ad7bd362b04c$export$c08559766941f856)(extent) / resolution * pixelRatio);
        const multiWorld = vectorSource.getWrapX() && projection.canWrapX();
        const worldWidth = multiWorld ? (0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(projectionExtent) : null;
        const endWorld = multiWorld ? Math.ceil((extent[2] - projectionExtent[2]) / worldWidth) + (this.extendX_ ? 2 : 1) : 1;
        let world = multiWorld ? Math.floor((extent[0] - projectionExtent[0]) / worldWidth) - (this.extendX_ ? 1 : 0) : 0;
        do {
            let transform = this.getRenderTransform(center, resolution, 0, pixelRatio, width, height, world * worldWidth);
            if (frameState.declutter) transform = transform.slice(0);
            executorGroup.execute(context, [
                context.canvas.width,
                context.canvas.height
            ], transform, rotation, snapToPixel, declutterable === undefined ? (0, $50fd8cb5269ba2f5$export$61b49a5ae59d663) : declutterable ? (0, $50fd8cb5269ba2f5$export$6195a93a6c97ce02) : (0, $50fd8cb5269ba2f5$export$d0fe61ccfaa1ca87), declutterable ? declutter && frameState.declutter[declutter] : undefined);
        }while (++world < endWorld);
    }
    /**
   * @private
   */ setDrawContext_() {
        if (this.opacity_ !== 1) {
            this.targetContext_ = this.context;
            this.context = (0, $5ce605ba3ee034a0$export$9e05d10eae75c464)(this.context.canvas.width, this.context.canvas.height, (0, $80ebe417992070aa$export$a166f0857c555517));
        }
    }
    /**
   * @private
   */ resetDrawContext_() {
        if (this.opacity_ !== 1 && this.targetContext_) {
            const alpha = this.targetContext_.globalAlpha;
            this.targetContext_.globalAlpha = this.opacity_;
            this.targetContext_.drawImage(this.context.canvas, 0, 0);
            this.targetContext_.globalAlpha = alpha;
            (0, $5ce605ba3ee034a0$export$e918ac6a1026a12a)(this.context);
            (0, $80ebe417992070aa$export$a166f0857c555517).push(this.context.canvas);
            this.context = this.targetContext_;
            this.targetContext_ = null;
        }
    }
    /**
   * Render declutter items for this layer
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   */ renderDeclutter(frameState) {
        if (!this.replayGroup_ || !this.getLayer().getDeclutter()) return;
        this.renderWorlds(this.replayGroup_, frameState, true);
    }
    /**
   * Render deferred instructions.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @override
   */ renderDeferredInternal(frameState) {
        if (!this.replayGroup_) return;
        if (this.clipExtent_) this.clipUnrotated(this.context, frameState, this.clipExtent_);
        this.replayGroup_.renderDeferred();
        if (this.clipExtent_) {
            this.context.restore();
            this.clipExtent_ = null;
        }
        this.resetDrawContext_();
    }
    /**
   * Render the layer.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement|null} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   * @override
   */ renderFrame(frameState, target) {
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        this.opacity_ = layerState.opacity;
        const viewState = frameState.viewState;
        this.prepareContainer(frameState, target);
        const context = this.context;
        const replayGroup = this.replayGroup_;
        let render = replayGroup && !replayGroup.isEmpty();
        if (!render) {
            const hasRenderListeners = this.getLayer().hasListener((0, $97affab8a58f0c97$export$2e2bcd8739ae039).PRERENDER) || this.getLayer().hasListener((0, $97affab8a58f0c97$export$2e2bcd8739ae039).POSTRENDER);
            if (!hasRenderListeners) return this.container;
        }
        this.setDrawContext_();
        this.preRender(context, frameState);
        const projection = viewState.projection;
        // clipped rendering if layer extent is set
        this.clipExtent_ = null;
        let clipped = false;
        if (render && layerState.extent && this.clipping) {
            const layerExtent = (0, $2a998b085c5a7ac9$export$494be3a3a25689ca)(layerState.extent, projection);
            render = (0, $3412ad7bd362b04c$export$7b0a31e10bbff018)(layerExtent, frameState.extent);
            const needsClip = render && !(0, $3412ad7bd362b04c$export$be866b1e0809b17e)(layerExtent, frameState.extent);
            if (needsClip) {
                if (frameState.declutter) // Store extent for deferred clipping
                this.clipExtent_ = layerExtent;
                else {
                    // Apply clipping immediately for non-declutter rendering
                    this.clipUnrotated(context, frameState, layerExtent);
                    clipped = true;
                }
            }
        }
        if (render) this.renderWorlds(replayGroup, frameState, this.getLayer().getDeclutter() ? false : undefined);
        if (clipped) context.restore();
        this.postRender(context, frameState);
        if (this.renderedRotation_ !== viewState.rotation) {
            this.renderedRotation_ = viewState.rotation;
            this.hitDetectionImageData_ = null;
        }
        if (!frameState.declutter) this.resetDrawContext_();
        return this.container;
    }
    /**
   * Asynchronous layer level hit detection.
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../../Feature.js").default>>} Promise
   * that resolves with an array of features.
   * @override
   */ getFeatures(pixel) {
        return new Promise((resolve)=>{
            if (this.frameState && !this.hitDetectionImageData_ && !this.animatingOrInteracting_) {
                const size = this.frameState.size.slice();
                const center = this.renderedCenter_;
                const resolution = this.renderedResolution_;
                const rotation = this.renderedRotation_;
                const projection = this.renderedProjection_;
                const extent = this.wrappedRenderedExtent_;
                const layer = this.getLayer();
                const transforms = [];
                const width = size[0] * (0, $75ad1ba908ec14d4$export$ab51038298418f25);
                const height = size[1] * (0, $75ad1ba908ec14d4$export$ab51038298418f25);
                transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $75ad1ba908ec14d4$export$ab51038298418f25), width, height, 0).slice());
                const source = layer.getSource();
                const projectionExtent = projection.getExtent();
                if (source.getWrapX() && projection.canWrapX() && !(0, $3412ad7bd362b04c$export$be866b1e0809b17e)(projectionExtent, extent)) {
                    let startX = extent[0];
                    const worldWidth = (0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(projectionExtent);
                    let world = 0;
                    let offsetX;
                    while(startX < projectionExtent[0]){
                        --world;
                        offsetX = worldWidth * world;
                        transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $75ad1ba908ec14d4$export$ab51038298418f25), width, height, offsetX).slice());
                        startX += worldWidth;
                    }
                    world = 0;
                    startX = extent[2];
                    while(startX > projectionExtent[2]){
                        ++world;
                        offsetX = worldWidth * world;
                        transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $75ad1ba908ec14d4$export$ab51038298418f25), width, height, offsetX).slice());
                        startX -= worldWidth;
                    }
                }
                const userProjection = (0, $2a998b085c5a7ac9$export$3973b77d5f6f2790)();
                this.hitDetectionImageData_ = (0, $75ad1ba908ec14d4$export$bd05e394339d469)(size, transforms, this.renderedFeatures_, layer.getStyleFunction(), extent, resolution, rotation, (0, $16bc938c5cf0388a$export$75084a70d324c1e6)(resolution, this.renderedPixelRatio_), userProjection ? projection : null);
            }
            resolve((0, $75ad1ba908ec14d4$export$6d4d555ddbfffa32)(pixel, this.renderedFeatures_, this.hitDetectionImageData_));
        });
    }
    /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("../vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("../Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   * @override
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, matches) {
        if (!this.replayGroup_) return undefined;
        const resolution = frameState.viewState.resolution;
        const rotation = frameState.viewState.rotation;
        const layer = this.getLayer();
        /** @type {!Object<string, import("../Map.js").HitMatch<T>|true>} */ const features = {};
        /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {number} distanceSq The squared distance to the click position
     * @return {T|undefined} Callback result.
     */ const featureCallback = function(feature, geometry, distanceSq) {
            const key = (0, $01f1986453243423$export$5e82334337e0f204)(feature);
            const match = features[key];
            if (!match) {
                if (distanceSq === 0) {
                    features[key] = true;
                    return callback(feature, layer, geometry);
                }
                matches.push(features[key] = {
                    feature: feature,
                    layer: layer,
                    geometry: geometry,
                    distanceSq: distanceSq,
                    callback: callback
                });
            } else if (match !== true && distanceSq < match.distanceSq) {
                if (distanceSq === 0) {
                    features[key] = true;
                    matches.splice(matches.lastIndexOf(match), 1);
                    return callback(feature, layer, geometry);
                }
                match.geometry = geometry;
                match.distanceSq = distanceSq;
            }
            return undefined;
        };
        const declutter = this.getLayer().getDeclutter();
        return this.replayGroup_.forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, featureCallback, declutter ? frameState.declutter?.[declutter]?.all().map((item)=>item.value) : null);
    }
    /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   * @override
   */ handleFontsChanged() {
        const layer = this.getLayer();
        if (layer.getVisible() && this.replayGroup_) layer.changed();
    }
    /**
   * Handle changes in image style state.
   * @param {import("../../events/Event.js").default} event Image style change event.
   * @private
   */ handleStyleImageChange_(event) {
        this.renderIfReadyAndVisible();
    }
    /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   * @override
   */ prepareFrame(frameState) {
        const vectorLayer = this.getLayer();
        const vectorSource = vectorLayer.getSource();
        if (!vectorSource) return false;
        const animating = frameState.viewHints[(0, $08bf132ff3931200$export$2e2bcd8739ae039).ANIMATING];
        const interacting = frameState.viewHints[(0, $08bf132ff3931200$export$2e2bcd8739ae039).INTERACTING];
        const updateWhileAnimating = vectorLayer.getUpdateWhileAnimating();
        const updateWhileInteracting = vectorLayer.getUpdateWhileInteracting();
        if (this.ready && !updateWhileAnimating && animating || !updateWhileInteracting && interacting) {
            this.animatingOrInteracting_ = true;
            return true;
        }
        this.animatingOrInteracting_ = false;
        const frameStateExtent = frameState.extent;
        const viewState = frameState.viewState;
        const projection = viewState.projection;
        const resolution = viewState.resolution;
        const pixelRatio = frameState.pixelRatio;
        const vectorLayerRevision = vectorLayer.getRevision();
        const vectorLayerRenderBuffer = vectorLayer.getRenderBuffer();
        let vectorLayerRenderOrder = vectorLayer.getRenderOrder();
        if (vectorLayerRenderOrder === undefined) vectorLayerRenderOrder = (0, $16bc938c5cf0388a$export$531ddd8416d52dfc);
        const center = viewState.center.slice();
        const extent = (0, $3412ad7bd362b04c$export$ab1029bcae9ddb4a)(frameStateExtent, vectorLayerRenderBuffer * resolution);
        const renderedExtent = extent.slice();
        const loadExtents = [
            extent.slice()
        ];
        const projectionExtent = projection.getExtent();
        const canWrapX = vectorSource.getWrapX() && projection.canWrapX();
        this.extendX_ = false;
        if (canWrapX) {
            const sourceExtent = vectorSource.getExtent();
            if (sourceExtent && !(0, $3412ad7bd362b04c$export$dd1bc94b04021eeb)(sourceExtent)) this.extendX_ = sourceExtent[0] < projectionExtent[0] || sourceExtent[2] > projectionExtent[2];
        }
        if (canWrapX && (!(0, $3412ad7bd362b04c$export$be866b1e0809b17e)(projectionExtent, frameState.extent) || this.extendX_)) {
            // For the replay group, we need an extent that intersects the real world
            // (-180° to +180°). To support geometries in a coordinate range from -540°
            // to +540°, we add at least 1 world width on each side of the projection
            // extent. If the viewport is wider than the world, we need to add half of
            // the viewport width to make sure we cover the whole viewport.
            const worldWidth = (0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(projectionExtent);
            const gutter = Math.max((0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(extent) / 2, worldWidth);
            let projMinX = projectionExtent[0];
            let projMaxX = projectionExtent[2];
            if (this.extendX_) {
                projMinX -= worldWidth;
                projMaxX += worldWidth;
            }
            extent[0] = projMinX - gutter;
            extent[2] = projMaxX + gutter;
            (0, $6542087bee114e8c$export$39a9ce3624977b84)(center, projection);
            const loadExtent = (0, $3412ad7bd362b04c$export$39a9ce3624977b84)(loadExtents[0], projection);
            // If the extent crosses the date line, we load data for both edges of the worlds
            if (loadExtent[0] < projectionExtent[0] && loadExtent[2] < projectionExtent[2]) loadExtents.push([
                loadExtent[0] + worldWidth,
                loadExtent[1],
                loadExtent[2] + worldWidth,
                loadExtent[3]
            ]);
            else if (loadExtent[0] > projectionExtent[0] && loadExtent[2] > projectionExtent[2]) loadExtents.push([
                loadExtent[0] - worldWidth,
                loadExtent[1],
                loadExtent[2] - worldWidth,
                loadExtent[3]
            ]);
        }
        if (this.ready && this.renderedResolution_ == resolution && this.renderedPixelRatio_ === pixelRatio && this.renderedRevision_ == vectorLayerRevision && this.renderedRenderOrder_ == vectorLayerRenderOrder && this.renderedFrameDeclutter_ === !!frameState.declutter && (0, $3412ad7bd362b04c$export$be866b1e0809b17e)(this.wrappedRenderedExtent_, extent)) {
            if (!(0, $db525acb5f2517fc$export$e9bab7fafb253603)(this.renderedExtent_, renderedExtent)) {
                this.hitDetectionImageData_ = null;
                this.renderedExtent_ = renderedExtent;
            }
            this.renderedCenter_ = center;
            this.replayGroupChanged = false;
            return true;
        }
        this.replayGroup_ = null;
        const replayGroup = new (0, $1a244f8e555e6dbf$export$2e2bcd8739ae039)((0, $16bc938c5cf0388a$export$bdacc5b475012edb)(resolution, pixelRatio), extent, resolution, pixelRatio);
        const userProjection = (0, $2a998b085c5a7ac9$export$3973b77d5f6f2790)();
        let userTransform;
        if (userProjection) {
            for(let i = 0, ii = loadExtents.length; i < ii; ++i){
                const extent = loadExtents[i];
                const userExtent = (0, $2a998b085c5a7ac9$export$96bfd09e2cffb006)(extent, projection);
                vectorSource.loadFeatures(userExtent, (0, $2a998b085c5a7ac9$export$b56bb8ad8b3a00e9)(resolution, projection), userProjection);
            }
            userTransform = (0, $2a998b085c5a7ac9$export$e3c4995a701c26a3)(userProjection, projection);
        } else for(let i = 0, ii = loadExtents.length; i < ii; ++i)vectorSource.loadFeatures(loadExtents[i], resolution, projection);
        const squaredTolerance = (0, $16bc938c5cf0388a$export$75084a70d324c1e6)(resolution, pixelRatio);
        let ready = true;
        const render = /**
       * @param {import("../../Feature.js").default} feature Feature.
       * @param {number} index Index.
       */ (feature, index)=>{
            let styles;
            const styleFunction = feature.getStyleFunction() || vectorLayer.getStyleFunction();
            if (styleFunction) styles = styleFunction(feature, resolution);
            if (styles) {
                const dirty = this.renderFeature(feature, squaredTolerance, styles, replayGroup, userTransform, this.getLayer().getDeclutter(), index);
                ready = ready && !dirty;
            }
        };
        const userExtent = (0, $2a998b085c5a7ac9$export$96bfd09e2cffb006)(extent, projection);
        /** @type {Array<import("../../Feature.js").default>} */ const features = vectorSource.getFeaturesInExtent(userExtent);
        if (vectorLayerRenderOrder) features.sort(vectorLayerRenderOrder);
        for(let i = 0, ii = features.length; i < ii; ++i)render(features[i], i);
        this.renderedFeatures_ = features;
        this.ready = ready;
        const replayGroupInstructions = replayGroup.finish();
        const executorGroup = new (0, $50fd8cb5269ba2f5$export$2e2bcd8739ae039)(extent, resolution, pixelRatio, vectorSource.getOverlaps(), replayGroupInstructions, vectorLayer.getRenderBuffer(), !!frameState.declutter);
        this.renderedResolution_ = resolution;
        this.renderedRevision_ = vectorLayerRevision;
        this.renderedRenderOrder_ = vectorLayerRenderOrder;
        this.renderedFrameDeclutter_ = !!frameState.declutter;
        this.renderedExtent_ = renderedExtent;
        this.wrappedRenderedExtent_ = extent;
        this.renderedCenter_ = center;
        this.renderedProjection_ = projection;
        this.renderedPixelRatio_ = pixelRatio;
        this.replayGroup_ = executorGroup;
        this.hitDetectionImageData_ = null;
        this.replayGroupChanged = true;
        return true;
    }
    /**
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {number} squaredTolerance Squared render tolerance.
   * @param {import("../../style/Style.js").default|Array<import("../../style/Style.js").default>} styles The style or array of styles.
   * @param {import("../../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
   * @param {import("../../proj.js").TransformFunction} [transform] Transform from user to view projection.
   * @param {boolean} [declutter] Enable decluttering.
   * @param {number} [index] Render order index.
   * @return {boolean} `true` if an image is loading.
   */ renderFeature(feature, squaredTolerance, styles, builderGroup, transform, declutter, index) {
        if (!styles) return false;
        let loading = false;
        if (Array.isArray(styles)) for(let i = 0, ii = styles.length; i < ii; ++i)loading = (0, $16bc938c5cf0388a$export$36f470a33a42f413)(builderGroup, feature, styles[i], squaredTolerance, this.boundHandleStyleImageChange_, transform, declutter, index) || loading;
        else loading = (0, $16bc938c5cf0388a$export$36f470a33a42f413)(builderGroup, feature, styles, squaredTolerance, this.boundHandleStyleImageChange_, transform, declutter, index);
        return loading;
    }
}
var $ae1542c17bfef714$export$2e2bcd8739ae039 = $ae1542c17bfef714$var$CanvasVectorLayerRenderer;



/**
 * @template {import("../source/Vector.js").default<FeatureType>} [VectorSourceType=import("../source/Vector.js").default<*>]
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("./BaseVector.js").ExtractedFeatureType<VectorSourceType>]
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the viewport extent used by the
 * renderer when getting features from the vector source for the rendering or hit-detection.
 * Recommended value: the size of the largest symbol, line width or label.
 * @property {VectorSourceType} [source] Source.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * @property {boolean|string|number} [declutter=false] Declutter images and text. Any truthy value will enable
 * decluttering. Within a layer, a feature rendered before another has higher priority. All layers with the
 * same `declutter` value will be decluttered together. The priority is determined by the drawing order of the
 * layers with the same `declutter` value. Higher in the layer stack means higher priority. To declutter distinct
 * layers or groups of layers separately, use different truthy values for `declutter`.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style. When set to `null`, only
 * features that have their own style will be rendered. See {@link module:ol/style/Style~Style} for the default style
 * which will be used if this is not set.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {boolean} [updateWhileAnimating=false] When set to `true`, feature batches will
 * be recreated during animations. This means that no vectors will be shown clipped, but the
 * setting will have a performance impact for large amounts of vector data. When set to `false`,
 * batches will be recreated when no animation is active.
 * @property {boolean} [updateWhileInteracting=false] When set to `true`, feature batches will
 * be recreated during interactions. See also `updateWhileAnimating`.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Vector data is rendered client-side, as vectors. This layer type provides most accurate rendering
 * even during animations. Points and labels stay upright on rotated views. For very large
 * amounts of vector data, performance may suffer during pan and zoom animations. In this case,
 * try {@link module:ol/layer/VectorImage~VectorImageLayer}.
 *
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Vector.js").default<FeatureType>} [VectorSourceType=import("../source/Vector.js").default<*>]
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("./BaseVector.js").ExtractedFeatureType<VectorSourceType>]
 * @extends {BaseVectorLayer<FeatureType, VectorSourceType, CanvasVectorLayerRenderer>}
 * @api
 */ class $ebf91b069eda61ff$var$VectorLayer extends (0, $1e2c8a3879fb9f61$export$2e2bcd8739ae039) {
    /**
   * @param {Options<VectorSourceType, FeatureType>} [options] Options.
   */ constructor(options){
        super(options);
    }
    /**
   * @override
   */ createRenderer() {
        return new (0, $ae1542c17bfef714$export$2e2bcd8739ae039)(this);
    }
}
var $ebf91b069eda61ff$export$2e2bcd8739ae039 = $ebf91b069eda61ff$var$VectorLayer;


/**
 * @module ol/layer/VectorTile
 */ 
/**
 * @module ol/renderer/canvas/VectorTileLayer
 */ 














/**
 * @type {!Object<string, Array<import("../../render/canvas.js").BuilderType>>}
 */ const $c006d7e93423ab97$var$IMAGE_REPLAYS = {
    'image': [
        'Polygon',
        'Circle',
        'LineString',
        'Image',
        'Text'
    ],
    'hybrid': [
        'Polygon',
        'LineString'
    ],
    'vector': []
};
/**
 * @type {!Object<string, Array<import("../../render/canvas.js").BuilderType>>}
 */ const $c006d7e93423ab97$var$VECTOR_REPLAYS = {
    'hybrid': [
        'Image',
        'Text',
        'Default'
    ],
    'vector': [
        'Polygon',
        'Circle',
        'LineString',
        'Image',
        'Text',
        'Default'
    ]
};
/**
 * @classdesc
 * Canvas renderer for vector tile layers.
 * @api
 * @extends {CanvasTileLayerRenderer<import("../../layer/VectorTile.js").default<import('../../source/VectorTile.js').default<import('../../Feature.js').FeatureLike>>>}
 */ class $c006d7e93423ab97$var$CanvasVectorTileLayerRenderer extends (0, $551edd9f90d397f6$export$2e2bcd8739ae039) {
    /**
   * @param {import("../../layer/VectorTile.js").default} layer VectorTile layer.
   * @param {import("./TileLayer.js").Options} options Options.
   */ constructor(layer, options){
        super(layer, options);
        /** @private */ this.boundHandleStyleImageChange_ = this.handleStyleImageChange_.bind(this);
        /**
     * @private
     * @type {number}
     */ this.renderedLayerRevision_;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.renderedPixelToCoordinateTransform_ = null;
        /**
     * @private
     * @type {number}
     */ this.renderedRotation_;
        /**
     * @private
     * @type {number}
     */ this.renderedOpacity_ = 1;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.tmpTransform_ = (0, $eb597965bdcc8f43$export$185802fd694ee1f5)();
        /**
     * @private
     * @type {Array<ZIndexContext>}
     */ this.tileClipContexts_ = null;
    }
    /**
   * Determine whether tiles for next extent should be enqueued for rendering.
   * @return {boolean} Rendering tiles for next extent is supported.
   * @override
   */ enqueueTilesForNextExtent() {
        return this.getLayer().getRenderMode() !== 'vector';
    }
    /**
   * @param {import("../../VectorRenderTile.js").default} tile Tile.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} x Left of the tile.
   * @param {number} y Top of the tile.
   * @param {number} w Width of the tile.
   * @param {number} h Height of the tile.
   * @param {number} gutter Tile gutter.
   * @param {boolean} transition Apply an alpha transition.
   * @override
   */ drawTile(tile, frameState, x, y, w, h, gutter, transition) {
        this.updateExecutorGroup_(tile, frameState.pixelRatio, frameState.viewState.projection);
        if (this.tileImageNeedsRender_(tile)) this.renderTileImage_(tile, frameState);
        super.drawTile(tile, frameState, x, y, w, h, gutter, transition);
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import("../../Tile.js").default|null} Tile (or null if outside source extent).
   * @override
   */ getTile(z, x, y, frameState) {
        const tile = /** @type {import("../../VectorRenderTile.js").default} */ this.getOrCreateTile(z, x, y, frameState);
        if (!tile) return null;
        const viewState = frameState.viewState;
        const resolution = viewState.resolution;
        const viewHints = frameState.viewHints;
        const source = this.getLayer().getSource();
        const tileGrid = source.getTileGridForProjection(viewState.projection);
        const hifi = !(viewHints[(0, $08bf132ff3931200$export$2e2bcd8739ae039).ANIMATING] || viewHints[(0, $08bf132ff3931200$export$2e2bcd8739ae039).INTERACTING]);
        const withinTileResolutionRange = tileGrid.getZForResolution(resolution, source.zDirection) === z;
        if (hifi && withinTileResolutionRange) tile.wantedResolution = resolution;
        else if (!tile.wantedResolution) tile.wantedResolution = tileGrid.getResolution(z);
        return tile;
    }
    /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   * @override
   */ prepareFrame(frameState) {
        const layerRevision = this.getLayer().getRevision();
        if (this.renderedLayerRevision_ !== layerRevision) {
            this.renderedLayerRevision_ = layerRevision;
            this.renderedTiles.length = 0;
        }
        return super.prepareFrame(frameState);
    }
    /**
   * @param {import("../../VectorRenderTile.js").default} tile Tile.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../../proj/Projection.js").default} projection Projection.
   * @private
   */ updateExecutorGroup_(tile, pixelRatio, projection) {
        const layer = /** @type {import("../../layer/VectorTile.js").default} */ this.getLayer();
        const revision = layer.getRevision();
        const renderOrder = layer.getRenderOrder() || null;
        const resolution = tile.wantedResolution;
        const builderState = tile.getReplayState(layer);
        if (!builderState.dirty && builderState.renderedResolution === resolution && builderState.renderedRevision == revision && builderState.renderedPixelRatio === pixelRatio && builderState.renderedRenderOrder == renderOrder) return;
        const source = layer.getSource();
        const declutter = !!layer.getDeclutter();
        const sourceTileGrid = source.getTileGrid();
        const tileGrid = source.getTileGridForProjection(projection);
        const tileExtent = tileGrid.getTileCoordExtent(tile.wrappedTileCoord);
        const sourceTiles = source.getSourceTiles(pixelRatio, projection, tile);
        const layerUid = (0, $01f1986453243423$export$5e82334337e0f204)(layer);
        delete tile.hitDetectionImageData[layerUid];
        tile.executorGroups[layerUid] = [];
        builderState.dirty = false;
        for(let t = 0, tt = sourceTiles.length; t < tt; ++t){
            const sourceTile = sourceTiles[t];
            if (sourceTile.getState() != (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADED) continue;
            const sourceProjection = source.getProjection();
            const sourceTileCoord = sourceTile.tileCoord;
            let sourceTileExtent = sourceTileGrid.getTileCoordExtent(sourceTileCoord);
            if (projection && sourceProjection && !(0, $2a998b085c5a7ac9$export$fe091d73a555748b)(projection, sourceProjection)) sourceTileExtent = (0, $2a998b085c5a7ac9$export$751c68e0e0efff79)(sourceTileExtent, sourceProjection, projection, 32);
            const sharedExtent = (0, $3412ad7bd362b04c$export$72209efa88586d42)(tileExtent, sourceTileExtent);
            const builderExtent = (0, $3412ad7bd362b04c$export$ab1029bcae9ddb4a)(sharedExtent, layer.getRenderBuffer() * resolution, this.tempExtent);
            const bufferedExtent = (0, $3412ad7bd362b04c$export$e9bab7fafb253603)(sourceTileExtent, sharedExtent) ? null : builderExtent;
            const builderGroup = new (0, $1a244f8e555e6dbf$export$2e2bcd8739ae039)(0, sharedExtent, resolution, pixelRatio);
            const squaredTolerance = (0, $16bc938c5cf0388a$export$75084a70d324c1e6)(resolution, pixelRatio);
            /**
       * @param {import("../../Feature.js").FeatureLike} feature Feature.
       * @param {number} [index] Render order index.
       * @this {CanvasVectorTileLayerRenderer}
       */ const render = function(feature, index) {
                let styles;
                const styleFunction = feature.getStyleFunction() || layer.getStyleFunction();
                if (styleFunction) styles = styleFunction(feature, resolution);
                if (styles) {
                    const dirty = this.renderFeature(feature, squaredTolerance, styles, builderGroup, declutter, index);
                    builderState.dirty = builderState.dirty || dirty;
                }
            };
            const features = sourceTile.getFeatures();
            if (renderOrder && renderOrder !== builderState.renderedRenderOrder) features.sort(renderOrder);
            for(let i = 0, ii = features.length; i < ii; ++i){
                let feature = features[i];
                if (projection && sourceTile.projection && !(0, $2a998b085c5a7ac9$export$fe091d73a555748b)(projection, sourceTile.projection)) {
                    feature = feature.clone();
                    feature.getGeometry().applyTransform((0, $2a998b085c5a7ac9$export$fce0c6cfca85ed96)(sourceTile.projection, projection));
                }
                if (!bufferedExtent || (0, $3412ad7bd362b04c$export$7b0a31e10bbff018)(bufferedExtent, feature.getGeometry().getExtent())) render.call(this, feature, i);
            }
            const executorGroupInstructions = builderGroup.finish();
            // no need to clip when the render tile is covered by a single source tile
            const replayExtent = layer.getRenderMode() !== 'vector' && declutter && sourceTiles.length === 1 ? null : sharedExtent;
            const renderingReplayGroup = new (0, $50fd8cb5269ba2f5$export$2e2bcd8739ae039)(replayExtent, resolution, pixelRatio, source.getOverlaps(), executorGroupInstructions, layer.getRenderBuffer(), true);
            tile.executorGroups[layerUid].push(renderingReplayGroup);
        }
        builderState.renderedRevision = revision;
        builderState.renderedPixelRatio = pixelRatio;
        builderState.renderedRenderOrder = renderOrder;
        builderState.renderedResolution = resolution;
    }
    /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("../vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("../Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   * @override
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, matches) {
        const resolution = frameState.viewState.resolution;
        const rotation = frameState.viewState.rotation;
        hitTolerance = hitTolerance == undefined ? 0 : hitTolerance;
        const layer = this.getLayer();
        const source = layer.getSource();
        const tileGrid = source.getTileGridForProjection(frameState.viewState.projection);
        const renderBuffer = layer.getRenderBuffer();
        const hitExtent = (0, $3412ad7bd362b04c$export$8aceca7c77505534)([
            coordinate
        ]);
        (0, $3412ad7bd362b04c$export$ab1029bcae9ddb4a)(hitExtent, resolution * (renderBuffer + hitTolerance), hitExtent);
        /** @type {!Object<string, import("../Map.js").HitMatch<T>|true>} */ const features = {};
        /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {number} distanceSq The squared distance to the click position.
     * @return {T|undefined} Callback result.
     */ const featureCallback = function(feature, geometry, distanceSq) {
            let key = feature.getId();
            if (key === undefined) key = (0, $01f1986453243423$export$5e82334337e0f204)(feature);
            const match = features[key];
            if (!match) {
                if (distanceSq === 0) {
                    features[key] = true;
                    return callback(feature, layer, geometry);
                }
                matches.push(features[key] = {
                    feature: feature,
                    layer: layer,
                    geometry: geometry,
                    distanceSq: distanceSq,
                    callback: callback
                });
            } else if (match !== true && distanceSq < match.distanceSq) {
                if (distanceSq === 0) {
                    features[key] = true;
                    matches.splice(matches.lastIndexOf(match), 1);
                    return callback(feature, layer, geometry);
                }
                match.geometry = geometry;
                match.distanceSq = distanceSq;
            }
            return undefined;
        };
        const renderedTiles = /** @type {Array<import("../../VectorRenderTile.js").default>} */ this.renderedTiles;
        const layerUid = (0, $01f1986453243423$export$5e82334337e0f204)(layer);
        const declutter = layer.getDeclutter();
        const declutteredFeatures = declutter ? frameState.declutter?.[declutter]?.all().map((item)=>item.value) : null;
        let found;
        foundFeature: for(let i = renderedTiles.length - 1; i >= 0; --i){
            const tile = renderedTiles[i];
            const tileExtent = tileGrid.getTileCoordExtent(tile.wrappedTileCoord);
            if (!(0, $3412ad7bd362b04c$export$7b0a31e10bbff018)(tileExtent, hitExtent)) continue;
            const executorGroups = tile.executorGroups[layerUid];
            for(let t = 0, tt = executorGroups.length; t < tt; ++t){
                found = executorGroups[t].forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, featureCallback, declutteredFeatures);
                if (found) break foundFeature;
            }
        }
        return found;
    }
    /**
   * Asynchronous layer level hit detection.
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../../Feature.js").FeatureLike>>} Promise that resolves with an array of features.
   * @override
   */ getFeatures(pixel) {
        if (this.renderedTiles.length === 0) return Promise.resolve([]);
        return new Promise((resolve, reject)=>{
            const layer = this.getLayer();
            const source = layer.getSource();
            const projection = this.renderedProjection;
            const projectionExtent = projection.getExtent();
            const resolution = this.renderedResolution;
            const tileGrid = source.getTileGridForProjection(projection);
            const coordinate = (0, $eb597965bdcc8f43$export$5635d7ef4b8fee1c)(this.renderedPixelToCoordinateTransform_, pixel.slice());
            const tileCoordString = tileGrid.getTileCoordForCoordAndResolution(coordinate, resolution).toString();
            const tile = /** @type {Array<import("../../VectorRenderTile.js").default>} */ this.renderedTiles.find((tile)=>tile.tileCoord.toString() === tileCoordString && tile.getState() === (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADED);
            if (!tile || tile.loadingSourceTiles > 0) {
                resolve([]);
                return;
            }
            if (source.getWrapX() && projection.canWrapX() && !(0, $3412ad7bd362b04c$export$be866b1e0809b17e)(projectionExtent, tileGrid.getTileCoordExtent(tile.tileCoord))) (0, $6542087bee114e8c$export$39a9ce3624977b84)(coordinate, projection);
            const layerUid = (0, $01f1986453243423$export$5e82334337e0f204)(layer);
            const extent = tileGrid.getTileCoordExtent(tile.wrappedTileCoord);
            const corner = (0, $3412ad7bd362b04c$export$cb1538b07e6964ff)(extent);
            const tilePixel = [
                (coordinate[0] - corner[0]) / resolution,
                (corner[1] - coordinate[1]) / resolution
            ];
            const features = tile.getSourceTiles().reduce((accumulator, sourceTile)=>accumulator.concat(sourceTile.getFeatures()), /** @type {Array<import("../../Feature.js").FeatureLike>} */ []);
            let hitDetectionImageData = tile.hitDetectionImageData[layerUid];
            if (!hitDetectionImageData) {
                const tileSize = (0, $e9727ecf69942748$export$a71a825ff42fb8e1)(tileGrid.getTileSize(tileGrid.getZForResolution(resolution, source.zDirection)));
                const rotation = this.renderedRotation_;
                const transforms = [
                    this.getRenderTransform(tileGrid.getTileCoordCenter(tile.wrappedTileCoord), resolution, 0, (0, $75ad1ba908ec14d4$export$ab51038298418f25), tileSize[0] * (0, $75ad1ba908ec14d4$export$ab51038298418f25), tileSize[1] * (0, $75ad1ba908ec14d4$export$ab51038298418f25), 0)
                ];
                hitDetectionImageData = (0, $75ad1ba908ec14d4$export$bd05e394339d469)(tileSize, transforms, features, layer.getStyleFunction(), tileGrid.getTileCoordExtent(tile.wrappedTileCoord), tile.getReplayState(layer).renderedResolution, rotation);
                tile.hitDetectionImageData[layerUid] = hitDetectionImageData;
            }
            resolve((0, $75ad1ba908ec14d4$export$6d4d555ddbfffa32)(tilePixel, features, hitDetectionImageData));
        });
    }
    /**
   * @param {import("../../extent.js").Extent} extent Extent.
   * @return {Array<import('../../Feature.js').FeatureLike>} Features.
   */ getFeaturesInExtent(extent) {
        /** @type {Array<import('../../Feature.js').FeatureLike>} */ const features = [];
        const tileCache = this.getTileCache();
        if (tileCache.getCount() === 0) return features;
        const source = this.getLayer().getSource();
        const tileGrid = source.getTileGridForProjection(this.frameState.viewState.projection);
        const z = tileGrid.getZForResolution(this.renderedResolution);
        /** @type {Object<string, true>} */ const visitedSourceTiles = {};
        tileCache.forEach((tile)=>{
            if (tile.tileCoord[0] !== z || tile.getState() !== (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADED) return;
            const sourceTiles = tile.getSourceTiles();
            for(let i = 0, ii = sourceTiles.length; i < ii; ++i){
                const sourceTile = sourceTiles[i];
                const key = sourceTile.getKey();
                if (key in visitedSourceTiles) continue;
                visitedSourceTiles[key] = true;
                const tileCoord = sourceTile.tileCoord;
                if ((0, $3412ad7bd362b04c$export$7b0a31e10bbff018)(extent, tileGrid.getTileCoordExtent(tileCoord))) {
                    const tileFeatures = sourceTile.getFeatures();
                    if (tileFeatures) for(let j = 0, jj = tileFeatures.length; j < jj; ++j){
                        const candidate = tileFeatures[j];
                        const geometry = candidate.getGeometry();
                        if ((0, $3412ad7bd362b04c$export$7b0a31e10bbff018)(extent, geometry.getExtent())) features.push(candidate);
                    }
                }
            }
        });
        return features;
    }
    /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   * @override
   */ handleFontsChanged() {
        const layer = this.getLayer();
        if (layer.getVisible() && this.renderedLayerRevision_ !== undefined) layer.changed();
    }
    /**
   * Handle changes in image style state.
   * @param {import("../../events/Event.js").default} event Image style change event.
   * @private
   */ handleStyleImageChange_(event) {
        this.renderIfReadyAndVisible();
    }
    /**
   * Render declutter items for this layer
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../layer/Layer.js").State} layerState Layer state.
   */ renderDeclutter(frameState, layerState) {
        const context = this.context;
        const alpha = context.globalAlpha;
        context.globalAlpha = layerState.opacity;
        const viewHints = frameState.viewHints;
        const hifi = !(viewHints[(0, $08bf132ff3931200$export$2e2bcd8739ae039).ANIMATING] || viewHints[(0, $08bf132ff3931200$export$2e2bcd8739ae039).INTERACTING]);
        const scaledCanvasSize = [
            this.context.canvas.width,
            this.context.canvas.height
        ];
        const declutter = this.getLayer().getDeclutter();
        const declutterTree = declutter ? frameState.declutter?.[declutter] : undefined;
        const layerUid = (0, $01f1986453243423$export$5e82334337e0f204)(this.getLayer());
        const tiles = /** @type {Array<import("../../VectorRenderTile.js").default>} */ this.renderedTiles;
        for(let i = 0, ii = tiles.length; i < ii; ++i){
            const tile = tiles[i];
            const executorGroups = tile.executorGroups[layerUid];
            if (executorGroups) for(let j = executorGroups.length - 1; j >= 0; --j)executorGroups[j].execute(this.context, scaledCanvasSize, this.getTileRenderTransform(tile, frameState), frameState.viewState.rotation, hifi, (0, $50fd8cb5269ba2f5$export$6195a93a6c97ce02), declutterTree);
        }
        context.globalAlpha = alpha;
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @override
   */ renderDeferredInternal(frameState) {
        const tiles = /** @type {Array<import("../../VectorRenderTile.js").default>} */ this.renderedTiles;
        const layerUid = (0, $01f1986453243423$export$5e82334337e0f204)(this.getLayer());
        const executorGroups = tiles.reduce((acc, tile, index)=>{
            tile.executorGroups[layerUid].forEach((executorGroup)=>acc.push({
                    executorGroup: executorGroup,
                    index: index
                }));
            return acc;
        }, /** @type {Array<{executorGroup: CanvasExecutorGroup, index: number}>} */ []);
        const executorGroupZIndexContexts = executorGroups.map(({ executorGroup: executorGroup })=>executorGroup.getDeferredZIndexContexts());
        /** @type {Object<number, true>} */ const usedZIndices = {};
        for(let i = 0, ii = executorGroups.length; i < ii; ++i){
            const executorGroupZindexContext = executorGroups[i].executorGroup.getDeferredZIndexContexts();
            for(const key in executorGroupZindexContext)usedZIndices[key] = true;
        }
        const zIndexKeys = Object.keys(usedZIndices).map(Number).sort((0, $db525acb5f2517fc$export$fcb633242ef15540));
        if (this.layerExtent) this.clipUnrotated(this.context, frameState, this.layerExtent);
        zIndexKeys.forEach((zIndex)=>{
            executorGroupZIndexContexts.forEach((zIndexContexts, i)=>{
                if (!zIndexContexts[zIndex]) return;
                zIndexContexts[zIndex].forEach((zIndexContext)=>{
                    const { executorGroup: executorGroup, index: index } = executorGroups[i];
                    const context = executorGroup.getRenderedContext();
                    const alpha = context.globalAlpha;
                    context.globalAlpha = this.renderedOpacity_;
                    const tileClipContext = this.tileClipContexts_[index];
                    if (tileClipContext) tileClipContext.draw(context);
                    zIndexContext.draw(context);
                    if (tileClipContext) context.restore();
                    context.globalAlpha = alpha;
                    zIndexContext.clear();
                });
                zIndexContexts[zIndex].length = 0;
            });
        });
        if (this.layerExtent) this.context.restore();
    }
    /**
   * @param {import("../../VectorRenderTile.js").default} tile The tile
   * @param {import('../../Map.js').FrameState} frameState Current frame state
   * @return {import('../../transform.js').Transform} Transform to use to render this tile
   */ getTileRenderTransform(tile, frameState) {
        const pixelRatio = frameState.pixelRatio;
        const viewState = frameState.viewState;
        const center = viewState.center;
        const resolution = viewState.resolution;
        const rotation = viewState.rotation;
        const size = frameState.size;
        const width = Math.round(size[0] * pixelRatio);
        const height = Math.round(size[1] * pixelRatio);
        const source = this.getLayer().getSource();
        const tileGrid = source.getTileGridForProjection(frameState.viewState.projection);
        const tileCoord = tile.tileCoord;
        const tileExtent = tileGrid.getTileCoordExtent(tile.wrappedTileCoord);
        const worldOffset = tileGrid.getTileCoordExtent(tileCoord, this.tempExtent)[0] - tileExtent[0];
        const transform = (0, $eb597965bdcc8f43$export$2060d2db72cce88f)((0, $eb597965bdcc8f43$export$dcdf75081b88279d)(this.inversePixelTransform.slice(), 1 / pixelRatio, 1 / pixelRatio), this.getRenderTransform(center, resolution, rotation, pixelRatio, width, height, worldOffset));
        return transform;
    }
    /**
   * Render the vectors for this layer.
   * @param {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} context Target context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @override
   */ postRender(context, frameState) {
        const viewHints = frameState.viewHints;
        const hifi = !(viewHints[(0, $08bf132ff3931200$export$2e2bcd8739ae039).ANIMATING] || viewHints[(0, $08bf132ff3931200$export$2e2bcd8739ae039).INTERACTING]);
        this.renderedPixelToCoordinateTransform_ = frameState.pixelToCoordinateTransform.slice();
        this.renderedRotation_ = frameState.viewState.rotation;
        this.renderedOpacity_ = frameState.layerStatesArray[frameState.layerIndex].opacity;
        const layer = /** @type {import("../../layer/VectorTile.js").default} */ this.getLayer();
        const renderMode = layer.getRenderMode();
        const alpha = context.globalAlpha;
        context.globalAlpha = this.renderedOpacity_;
        const declutter = layer.getDeclutter();
        const replayTypes = declutter ? $c006d7e93423ab97$var$VECTOR_REPLAYS[renderMode].filter((type)=>!(0, $50fd8cb5269ba2f5$export$6195a93a6c97ce02).includes(type)) : $c006d7e93423ab97$var$VECTOR_REPLAYS[renderMode];
        const viewState = frameState.viewState;
        const rotation = viewState.rotation;
        // clipped rendering if layer extent is set
        if (this.layerExtent) this.clipUnrotated(context, frameState, this.layerExtent);
        const tileSource = layer.getSource();
        const tileGrid = tileSource.getTileGridForProjection(viewState.projection);
        const z = tileGrid.getZForResolution(viewState.resolution, tileSource.zDirection);
        const tiles = /** @type {Array<import("../../VectorRenderTile.js").default>} */ this.renderedTiles;
        const clips = [];
        const clipZs = [];
        const tileClipContexts = [];
        const layerUid = (0, $01f1986453243423$export$5e82334337e0f204)(layer);
        let ready = true;
        for(let i = tiles.length - 1; i >= 0; --i){
            const tile = tiles[i];
            ready = ready && !tile.getReplayState(layer).dirty;
            const executorGroups = tile.executorGroups[layerUid].filter((group)=>group.hasExecutors(replayTypes));
            if (executorGroups.length === 0) continue;
            const transform = this.getTileRenderTransform(tile, frameState);
            const currentZ = tile.tileCoord[0];
            let contextSaved = false;
            // Clip mask for regions in this tile that already filled by a higher z tile
            const currentClip = executorGroups[0].getClipCoords(transform);
            let clipContext = context;
            let tileClipContext;
            if (currentClip) {
                tileClipContext = new (0, $4564f3e97d8a38f7$export$2e2bcd8739ae039)();
                clipContext = tileClipContext.getContext();
                for(let j = 0, jj = clips.length; j < jj; ++j)if (z !== currentZ && currentZ < clipZs[j]) {
                    const clip = clips[j];
                    if ((0, $3412ad7bd362b04c$export$7b0a31e10bbff018)([
                        currentClip[0],
                        currentClip[3],
                        currentClip[4],
                        currentClip[7]
                    ], [
                        clip[0],
                        clip[3],
                        clip[4],
                        clip[7]
                    ])) {
                        if (!contextSaved) {
                            clipContext.save();
                            contextSaved = true;
                        }
                        clipContext.beginPath();
                        // counter-clockwise (outer ring) for current tile
                        clipContext.moveTo(currentClip[0], currentClip[1]);
                        clipContext.lineTo(currentClip[2], currentClip[3]);
                        clipContext.lineTo(currentClip[4], currentClip[5]);
                        clipContext.lineTo(currentClip[6], currentClip[7]);
                        // clockwise (inner ring) for higher z tile
                        clipContext.moveTo(clip[6], clip[7]);
                        clipContext.lineTo(clip[4], clip[5]);
                        clipContext.lineTo(clip[2], clip[3]);
                        clipContext.lineTo(clip[0], clip[1]);
                        clipContext.clip();
                    }
                }
                clips.push(currentClip);
                clipZs.push(currentZ);
            }
            for(let t = 0, tt = executorGroups.length; t < tt; ++t){
                const executorGroup = executorGroups[t];
                executorGroup.execute(context, [
                    context.canvas.width,
                    context.canvas.height
                ], transform, rotation, hifi, replayTypes, frameState.declutter?.[declutter]);
            }
            if (contextSaved) {
                if (clipContext === context) clipContext.restore();
                else tileClipContexts[i] = tileClipContext;
            }
        }
        if (this.layerExtent) context.restore();
        context.globalAlpha = alpha;
        this.ready = ready;
        this.tileClipContexts_ = tileClipContexts;
        if (!frameState.declutter) this.renderDeferredInternal(frameState);
        super.postRender(context, frameState);
    }
    /**
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../../style/Style.js").default|Array<import("../../style/Style.js").default>} styles The style or array of styles.
   * @param {import("../../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
   * @param {boolean} [declutter] Enable decluttering.
   * @param {number} [index] Render order index.
   * @return {boolean} `true` if an image is loading.
   */ renderFeature(feature, squaredTolerance, styles, builderGroup, declutter, index) {
        if (!styles) return false;
        let loading = false;
        if (Array.isArray(styles)) for(let i = 0, ii = styles.length; i < ii; ++i)loading = (0, $16bc938c5cf0388a$export$36f470a33a42f413)(builderGroup, feature, styles[i], squaredTolerance, this.boundHandleStyleImageChange_, undefined, declutter, index) || loading;
        else loading = (0, $16bc938c5cf0388a$export$36f470a33a42f413)(builderGroup, feature, styles, squaredTolerance, this.boundHandleStyleImageChange_, undefined, declutter, index);
        return loading;
    }
    /**
   * @param {import("../../VectorRenderTile.js").default} tile Tile.
   * @return {boolean} A new tile image was rendered.
   * @private
   */ tileImageNeedsRender_(tile) {
        const layer = /** @type {import("../../layer/VectorTile.js").default} */ this.getLayer();
        if (layer.getRenderMode() === 'vector') return false;
        const replayState = tile.getReplayState(layer);
        const revision = layer.getRevision();
        const resolution = tile.wantedResolution;
        const tileImageNeedsRender = replayState.renderedTileResolution !== resolution || replayState.renderedTileRevision !== revision;
        return tileImageNeedsRender;
    }
    /**
   * @param {import("../../VectorRenderTile.js").default} tile Tile.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @private
   */ renderTileImage_(tile, frameState) {
        const layer = /** @type {import("../../layer/VectorTile.js").default} */ this.getLayer();
        const replayState = tile.getReplayState(layer);
        const revision = layer.getRevision();
        const executorGroups = tile.executorGroups[(0, $01f1986453243423$export$5e82334337e0f204)(layer)];
        replayState.renderedTileRevision = revision;
        const tileCoord = tile.wrappedTileCoord;
        const z = tileCoord[0];
        const source = layer.getSource();
        let pixelRatio = frameState.pixelRatio;
        const viewState = frameState.viewState;
        const projection = viewState.projection;
        const tileGrid = source.getTileGridForProjection(projection);
        const tileResolution = tileGrid.getResolution(tile.tileCoord[0]);
        const renderPixelRatio = frameState.pixelRatio / tile.wantedResolution * tileResolution;
        const resolution = tileGrid.getResolution(z);
        const context = tile.getContext();
        // Increase tile size when overzooming for low pixel ratio, to avoid blurry tiles
        pixelRatio = Math.round(Math.max(pixelRatio, renderPixelRatio / pixelRatio));
        const size = source.getTilePixelSize(z, pixelRatio, projection);
        context.canvas.width = size[0];
        context.canvas.height = size[1];
        const renderScale = pixelRatio / renderPixelRatio;
        if (renderScale !== 1) {
            const canvasTransform = (0, $eb597965bdcc8f43$export$aad8462122ac592b)(this.tmpTransform_);
            (0, $eb597965bdcc8f43$export$dcdf75081b88279d)(canvasTransform, renderScale, renderScale);
            context.setTransform.apply(context, canvasTransform);
        }
        const tileExtent = tileGrid.getTileCoordExtent(tileCoord, this.tempExtent);
        const pixelScale = renderPixelRatio / resolution;
        const transform = (0, $eb597965bdcc8f43$export$aad8462122ac592b)(this.tmpTransform_);
        (0, $eb597965bdcc8f43$export$dcdf75081b88279d)(transform, pixelScale, -pixelScale);
        (0, $eb597965bdcc8f43$export$d73ee8ef04f5226a)(transform, -tileExtent[0], -tileExtent[3]);
        for(let i = 0, ii = executorGroups.length; i < ii; ++i){
            const executorGroup = executorGroups[i];
            executorGroup.execute(context, [
                context.canvas.width * renderScale,
                context.canvas.height * renderScale
            ], transform, 0, true, $c006d7e93423ab97$var$IMAGE_REPLAYS[layer.getRenderMode()], null);
        }
        replayState.renderedTileResolution = tile.wantedResolution;
    }
}
var $c006d7e93423ab97$export$2e2bcd8739ae039 = $c006d7e93423ab97$var$CanvasVectorTileLayerRenderer;




/***
 * @template Return
 * @typedef {import("../Observable.js").OnSignature<import("../Observable.js").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable.js").OnSignature<import("./Base.js").BaseLayerObjectEventTypes|
 *     import("./Layer.js").LayerEventType|'change:preload'|'change:useInterimTilesOnError', import("../Object.js").ObjectEvent, Return> &
 *   import("../Observable.js").OnSignature<import("../render/EventType.js").LayerRenderEventTypes, import("../render/Event.js").default, Return> &
 *   import("../Observable.js").CombinedOnSignature<import("../Observable.js").EventTypes|import("./Base.js").BaseLayerObjectEventTypes|
 *     import("./Layer.js").LayerEventType|'change:preload'|'change:useInterimTilesOnError'|import("../render/EventType.js").LayerRenderEventTypes, Return>} VectorTileLayerOnSignature
 */ /**
 * @typedef {'hybrid' | 'vector'} VectorTileRenderType
 */ /***
 * @template T
 * @typedef {T extends import("../source/VectorTile.js").default<infer U extends import("../Feature.js").FeatureLike> ? U : never} ExtractedFeatureType
 */ /**
 * @template {import("../source/VectorTile.js").default<FeatureType>} [VectorTileSourceType=import("../source/VectorTile.js").default<*>]
 * @template {import("../Feature.js").FeatureLike} [FeatureType=ExtractedFeatureType<VectorTileSourceType>]
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the tile extent used by the
 * renderer when getting features from the vector tile for the rendering or hit-detection.
 * Recommended value: Vector tiles are usually generated with a buffer, so this value should match
 * the largest possible buffer of the used tiles. It should be at least the size of the largest
 * point symbol or line width.
 * @property {VectorTileRenderType} [renderMode='hybrid'] Render mode for vector tiles:
 *  `'hybrid'`: Polygon and line elements are rendered as images, so pixels are scaled during zoom
 *    animations. Point symbols and texts are accurately rendered as vectors and can stay upright on
 *    rotated views, but get lifted above all polygon and line elements.
 *  `'vector'`: Everything is rendered as vectors and the original render order is maintained. Use
 *    this mode for improved performance and visual epxerience on vector tile layers with not too many
 *    rendered features (e.g. for highlighting a subset of features of another layer with the same
 *    source).
 * @property {VectorTileSourceType} [source] Source.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * @property {boolean|string|number} [declutter=false] Declutter images and text. Any truthy value will enable
 * decluttering. Within a layer, a feature rendered before another has higher priority. All layers with the
 * same `declutter` value will be decluttered together. The priority is determined by the drawing order of the
 * layers with the same `declutter` value. Higher in the layer stack means higher priority. To declutter distinct
 * layers or groups of layers separately, use different truthy values for `declutter`.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer
 * style. When set to `null`, only
 * features that have their own style will be rendered. See {@link module:ol/style/Style~Style} for the default style
 * which will be used if this is not set.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no
 * background will be rendered.
 * @property {boolean} [updateWhileAnimating=false] When set to `true`, feature batches will be
 * recreated during animations. This means that no vectors will be shown clipped, but the setting
 * will have a performance impact for large amounts of vector data. When set to `false`, batches
 * will be recreated when no animation is active.
 * @property {boolean} [updateWhileInteracting=false] When set to `true`, feature batches will be
 * recreated during interactions. See also `updateWhileAnimating`.
 * @property {number} [preload=0] Preload. Load low-resolution tiles up to `preload` levels. `0`
 * means no preloading.
 * @property {boolean} [useInterimTilesOnError=true] Deprecated.  Use interim tiles on error.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 * @property {number} [cacheSize=0] The internal tile cache size.  If too small, this will auto-grow to hold
 * two zoom levels worth of tiles.
 */ /**
 * @classdesc
 * Layer for vector tile data that is rendered client-side.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/VectorTile.js").default<FeatureType>} [VectorTileSourceType=import("../source/VectorTile.js").default<*>]
 * @template {import("../Feature.js").FeatureLike} [FeatureType=ExtractedFeatureType<VectorTileSourceType>]
 * @extends {BaseVectorLayer<FeatureType, VectorTileSourceType, CanvasVectorTileLayerRenderer>}
 * @api
 */ class $28d5c8cb633b2bb5$var$VectorTileLayer extends (0, $1e2c8a3879fb9f61$export$2e2bcd8739ae039) {
    /**
   * @param {Options<VectorTileSourceType, FeatureType>} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const baseOptions = Object.assign({}, options);
        delete baseOptions.preload;
        const cacheSize = options.cacheSize === undefined ? 0 : options.cacheSize;
        delete options.cacheSize;
        delete baseOptions.useInterimTilesOnError;
        super(baseOptions);
        /***
     * @type {VectorTileLayerOnSignature<import("../events.js").EventsKey>}
     */ this.on;
        /***
     * @type {VectorTileLayerOnSignature<import("../events.js").EventsKey>}
     */ this.once;
        /***
     * @type {VectorTileLayerOnSignature<void>}
     */ this.un;
        /**
     * @type {number|undefined}
     * @private
     */ this.cacheSize_ = cacheSize;
        const renderMode = options.renderMode || 'hybrid';
        (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(renderMode == 'hybrid' || renderMode == 'vector', "`renderMode` must be `'hybrid'` or `'vector'`");
        /**
     * @private
     * @type {VectorTileRenderType}
     */ this.renderMode_ = renderMode;
        this.setPreload(options.preload ? options.preload : 0);
        this.setUseInterimTilesOnError(options.useInterimTilesOnError !== undefined ? options.useInterimTilesOnError : true);
        /**
     * @return {import("./Base.js").BackgroundColor} Background color.
     * @function
     * @api
     */ this.getBackground;
        /**
     * @param {import("./Base.js").BackgroundColor} background Background color.
     * @function
     * @api
     */ this.setBackground;
    }
    /**
   * @override
   */ createRenderer() {
        return new (0, $c006d7e93423ab97$export$2e2bcd8739ae039)(this, {
            cacheSize: this.cacheSize_
        });
    }
    /**
   * Get the topmost feature that intersects the given pixel on the viewport. Returns a promise
   * that resolves with an array of features. The array will either contain the topmost feature
   * when a hit was detected, or it will be empty.
   *
   * The hit detection algorithm used for this method is optimized for performance, but is less
   * accurate than the one used in [map.getFeaturesAtPixel()]{@link import("../Map.js").default#getFeaturesAtPixel}.
   * Text is not considered, and icons are only represented by their bounding box instead of the exact
   * image.
   *
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature.js").FeatureLike>>} Promise that resolves with an array of features.
   * @api
   * @override
   */ getFeatures(pixel) {
        return super.getFeatures(pixel);
    }
    /**
   * Get features whose bounding box intersects the provided extent. Only features for cached
   * tiles for the last rendered zoom level are available in the source. So this method is only
   * suitable for requesting tiles for extents that are currently rendered.
   *
   * Features are returned in random tile order and as they are included in the tiles. This means
   * they can be clipped, duplicated across tiles, and simplified to the render resolution.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeaturesInExtent(extent) {
        return /** @type {*} */ this.getRenderer().getFeaturesInExtent(extent);
    }
    /**
   * @return {VectorTileRenderType} The render mode.
   */ getRenderMode() {
        return this.renderMode_;
    }
    /**
   * Return the level as number to which we will preload tiles up to.
   * @return {number} The level to preload tiles up to.
   * @observable
   * @api
   */ getPreload() {
        return /** @type {number} */ this.get((0, $c68b61e2cb6b5397$export$2e2bcd8739ae039).PRELOAD);
    }
    /**
   * Deprecated.  Whether we use interim tiles on error.
   * @return {boolean} Use interim tiles on error.
   * @observable
   * @api
   */ getUseInterimTilesOnError() {
        return /** @type {boolean} */ this.get((0, $c68b61e2cb6b5397$export$2e2bcd8739ae039).USE_INTERIM_TILES_ON_ERROR);
    }
    /**
   * Set the level as number to which we will preload tiles up to.
   * @param {number} preload The level to preload tiles up to.
   * @observable
   * @api
   */ setPreload(preload) {
        this.set((0, $c68b61e2cb6b5397$export$2e2bcd8739ae039).PRELOAD, preload);
    }
    /**
   * Deprecated.  Set whether we use interim tiles on error.
   * @param {boolean} useInterimTilesOnError Use interim tiles on error.
   * @observable
   * @api
   */ setUseInterimTilesOnError(useInterimTilesOnError) {
        this.set((0, $c68b61e2cb6b5397$export$2e2bcd8739ae039).USE_INTERIM_TILES_ON_ERROR, useInterimTilesOnError);
    }
}
var $28d5c8cb633b2bb5$export$2e2bcd8739ae039 = $28d5c8cb633b2bb5$var$VectorTileLayer;


/**
 * @module ol/loadingstrategy
 */ 
function $70d62d5d3836dc81$export$84bf76cd7afc7469(extent, resolution) {
    return [
        [
            -Infinity,
            -Infinity,
            Infinity,
            Infinity
        ]
    ];
}
function $70d62d5d3836dc81$export$bf67010aacbe66fa(extent, resolution) {
    return [
        extent
    ];
}
function $70d62d5d3836dc81$export$3c17558da18e4d75(tileGrid) {
    return(/**
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {import("./proj.js").Projection} projection Projection.
     * @return {Array<import("./extent.js").Extent>} Extents.
     */ function(extent, resolution, projection) {
        const z = tileGrid.getZForResolution((0, $2a998b085c5a7ac9$export$bd1cd3b88140b906)(resolution, projection));
        const tileRange = tileGrid.getTileRangeForExtentAndZ((0, $2a998b085c5a7ac9$export$494be3a3a25689ca)(extent, projection), z);
        /** @type {Array<import("./extent.js").Extent>} */ const extents = [];
        /** @type {import("./tilecoord.js").TileCoord} */ const tileCoord = [
            z,
            0,
            0
        ];
        for(tileCoord[1] = tileRange.minX; tileCoord[1] <= tileRange.maxX; ++tileCoord[1])for(tileCoord[2] = tileRange.minY; tileCoord[2] <= tileRange.maxY; ++tileCoord[2])extents.push((0, $2a998b085c5a7ac9$export$96bfd09e2cffb006)(tileGrid.getTileCoordExtent(tileCoord), projection));
        return extents;
    });
}




/**
 * @module ol/source/Source
 */ 

/**
 * @typedef {'undefined' | 'loading' | 'ready' | 'error'} State
 * State of the source, one of 'undefined', 'loading', 'ready' or 'error'.
 */ /**
 * A function that takes a {@link import("../View.js").ViewStateLayerStateExtent} and returns a string or
 * an array of strings representing source attributions.
 *
 * @typedef {function(import("../View.js").ViewStateLayerStateExtent): (string|Array<string>)} Attribution
 */ /**
 * A type that can be used to provide attribution information for data sources.
 *
 * It represents either
 * a simple string (e.g. `'© Acme Inc.'`)
 * an array of simple strings (e.g. `['© Acme Inc.', '© Bacme Inc.']`)
 * a function that returns a string or array of strings ({@link module:ol/source/Source~Attribution})
 *
 * @typedef {string|Array<string>|Attribution} AttributionLike
 */ /**
 * @typedef {Object} Options
 * @property {AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {import("./Source.js").State} [state='ready'] State.
 * @property {boolean} [wrapX=false] WrapX.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for {@link module:ol/layer/Layer~Layer} sources.
 *
 * A generic `change` event is triggered when the state of the source changes.
 * @abstract
 * @api
 */ class $039754a80ce105f8$var$Source extends (0, $4dd5119c2f9fa355$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Source options.
   */ constructor(options){
        super();
        /**
     * @protected
     * @type {import("../proj/Projection.js").default|null}
     */ this.projection = (0, $2a998b085c5a7ac9$export$3988ae62b71be9a3)(options.projection);
        /**
     * @private
     * @type {?Attribution}
     */ this.attributions_ = $039754a80ce105f8$var$adaptAttributions(options.attributions);
        /**
     * @private
     * @type {boolean}
     */ this.attributionsCollapsible_ = options.attributionsCollapsible ?? true;
        /**
     * This source is currently loading data. Sources that defer loading to the
     * map's tile queue never set this to a `truthy` value.
     * @type {boolean|number}
     */ this.loading = false;
        /**
     * @private
     * @type {import("./Source.js").State}
     */ this.state_ = options.state !== undefined ? options.state : 'ready';
        /**
     * @private
     * @type {boolean}
     */ this.wrapX_ = options.wrapX !== undefined ? options.wrapX : false;
        /**
     * @private
     * @type {boolean}
     */ this.interpolate_ = !!options.interpolate;
        /**
     * @protected
     * @type {function(import("../View.js").ViewOptions):void}
     */ this.viewResolver = null;
        /**
     * @protected
     * @type {function(Error):void}
     */ this.viewRejector = null;
        const self = this;
        /**
     * @private
     * @type {Promise<import("../View.js").ViewOptions>}
     */ this.viewPromise_ = new Promise(function(resolve, reject) {
            self.viewResolver = resolve;
            self.viewRejector = reject;
        });
    }
    /**
   * Get the attribution function for the source.
   * @return {?Attribution} Attribution function.
   * @api
   */ getAttributions() {
        return this.attributions_;
    }
    /**
   * @return {boolean} Attributions are collapsible.
   * @api
   */ getAttributionsCollapsible() {
        return this.attributionsCollapsible_;
    }
    /**
   * Get the projection of the source.
   * @return {import("../proj/Projection.js").default|null} Projection.
   * @api
   */ getProjection() {
        return this.projection;
    }
    /**
   * @param {import("../proj/Projection.js").default} [projection] Projection.
   * @return {Array<number>|null} Resolutions.
   */ getResolutions(projection) {
        return null;
    }
    /**
   * @return {Promise<import("../View.js").ViewOptions>} A promise for view-related properties.
   */ getView() {
        return this.viewPromise_;
    }
    /**
   * Get the state of the source, see {@link import("./Source.js").State} for possible states.
   * @return {import("./Source.js").State} State.
   * @api
   */ getState() {
        return this.state_;
    }
    /**
   * @return {boolean|undefined} Wrap X.
   */ getWrapX() {
        return this.wrapX_;
    }
    /**
   * @return {boolean} Use linear interpolation when resampling.
   */ getInterpolate() {
        return this.interpolate_;
    }
    /**
   * Refreshes the source. The source will be cleared, and data from the server will be reloaded.
   * @api
   */ refresh() {
        this.changed();
    }
    /**
   * Set the attributions of the source.
   * @param {AttributionLike|undefined} attributions Attributions.
   *     Can be passed as `string`, `Array<string>`, {@link module:ol/source/Source~Attribution},
   *     or `undefined`.
   * @api
   */ setAttributions(attributions) {
        this.attributions_ = $039754a80ce105f8$var$adaptAttributions(attributions);
        this.changed();
    }
    /**
   * Set the state of the source.
   * @param {import("./Source.js").State} state State.
   */ setState(state) {
        this.state_ = state;
        this.changed();
    }
}
/**
 * Turns the attributions option into an attributions function.
 * @param {AttributionLike|undefined} attributionLike The attribution option.
 * @return {Attribution|null} An attribution function (or null).
 */ function $039754a80ce105f8$var$adaptAttributions(attributionLike) {
    if (!attributionLike) return null;
    if (typeof attributionLike === 'function') return attributionLike;
    if (!Array.isArray(attributionLike)) attributionLike = [
        attributionLike
    ];
    return (frameState)=>attributionLike;
}
var $039754a80ce105f8$export$2e2bcd8739ae039 = $039754a80ce105f8$var$Source;


/**
 * @module ol/source/TileJSON
 */ // FIXME check order of async callbacks
/**
 * See https://mapbox.com/developers/api/.
 */ 
/**
 * @module ol/net
 */ 
function $2602cfa493b9e192$export$3552a04808364507(url, callback, errback, callbackParam) {
    const script = document.createElement('script');
    const key = 'olc_' + (0, $01f1986453243423$export$5e82334337e0f204)(callback);
    function cleanup() {
        delete window[key];
        script.parentNode.removeChild(script);
    }
    script.async = true;
    script.src = url + (url.includes('?') ? '&' : '?') + (callbackParam || 'callback') + '=' + key;
    const timer = setTimeout(function() {
        cleanup();
        if (errback) errback();
    }, 10000);
    window[key] = function(data) {
        clearTimeout(timer);
        cleanup();
        callback(data);
    };
    document.head.appendChild(script);
}
class $2602cfa493b9e192$export$286baf652d0b1206 extends Error {
    /**
   * @param {XMLHttpRequest} response The XHR object.
   */ constructor(response){
        const message = 'Unexpected response status: ' + response.status;
        super(message);
        /**
     * @type {string}
     */ this.name = 'ResponseError';
        /**
     * @type {XMLHttpRequest}
     */ this.response = response;
    }
}
class $2602cfa493b9e192$export$bb8c263ad32caa8 extends Error {
    /**
   * @param {XMLHttpRequest} client The XHR object.
   */ constructor(client){
        super('Failed to issue request');
        /**
     * @type {string}
     */ this.name = 'ClientError';
        /**
     * @type {XMLHttpRequest}
     */ this.client = client;
    }
}
function $2602cfa493b9e192$export$d047a7c56db64af4(url) {
    return new Promise(function(resolve, reject) {
        /**
     * @param {ProgressEvent<XMLHttpRequest>} event The load event.
     */ function onLoad(event) {
            const client = event.target;
            // status will be 0 for file:// urls
            if (!client.status || client.status >= 200 && client.status < 300) {
                let data;
                try {
                    data = JSON.parse(client.responseText);
                } catch (err) {
                    const message = 'Error parsing response text as JSON: ' + err.message;
                    reject(new Error(message));
                    return;
                }
                resolve(data);
                return;
            }
            reject(new $2602cfa493b9e192$export$286baf652d0b1206(client));
        }
        /**
     * @param {ProgressEvent<XMLHttpRequest>} event The error event.
     */ function onError(event) {
            reject(new $2602cfa493b9e192$export$bb8c263ad32caa8(event.target));
        }
        const client = new XMLHttpRequest();
        client.addEventListener('load', onLoad);
        client.addEventListener('error', onError);
        client.open('GET', url);
        client.setRequestHeader('Accept', 'application/json');
        client.send();
    });
}
function $2602cfa493b9e192$export$f85c16a6d62f7d63(base, url) {
    if (url.includes('://')) return url;
    return new URL(url, base).href;
}
let $2602cfa493b9e192$var$originalXHR;
function $2602cfa493b9e192$export$deeb0e1e5243b56c(xhr) {
    if (typeof XMLHttpRequest !== 'undefined') $2602cfa493b9e192$var$originalXHR = XMLHttpRequest;
    globalThis.XMLHttpRequest = xhr;
}
function $2602cfa493b9e192$export$c2af84f345593eb8() {
    globalThis.XMLHttpRequest = $2602cfa493b9e192$var$originalXHR;
}



/**
 * @module ol/tilegrid
 */ 


/**
 * @module ol/tilegrid/TileGrid
 */ 








/**
 * @private
 * @type {import("../tilecoord.js").TileCoord}
 */ const $56db44221d298c30$var$tmpTileCoord = [
    0,
    0,
    0
];
/**
 * Number of decimal digits to consider in integer values when rounding.
 * @type {number}
 */ const $56db44221d298c30$var$DECIMALS = 5;
/**
 * @typedef {Object} Options
 * @property {import("../extent.js").Extent} [extent] Extent for the tile grid. No tiles outside this
 * extent will be requested by {@link module:ol/source/Tile~TileSource} sources. When no `origin` or
 * `origins` are configured, the `origin` will be set to the top-left corner of the extent.
 * @property {number} [minZoom=0] Minimum zoom.
 * @property {import("../coordinate.js").Coordinate} [origin] The tile grid origin, i.e. where the `x`
 * and `y` axes meet (`[z, 0, 0]`). Tile coordinates increase left to right and downwards. If not
 * specified, `extent` or `origins` must be provided.
 * @property {Array<import("../coordinate.js").Coordinate>} [origins] Tile grid origins, i.e. where
 * the `x` and `y` axes meet (`[z, 0, 0]`), for each zoom level. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * origin. Tile coordinates increase left to right and downwards. If not specified, `extent` or
 * `origin` must be provided.
 * @property {!Array<number>} resolutions Resolutions. The array index of each resolution needs
 * to match the zoom level. This means that even if a `minZoom` is configured, the resolutions
 * array will have a length of `maxZoom + 1`.
 * @property {Array<import("../size.js").Size>} [sizes] Number of tile rows and columns
 * of the grid for each zoom level. If specified the values
 * define each zoom level's extent together with the `origin` or `origins`.
 * A grid `extent` can be configured in addition, and will further limit the extent
 * for which tile requests are made by sources. If the bottom-left corner of
 * an extent is used as `origin` or `origins`, then the `y` value must be
 * negative because OpenLayers tile coordinates use the top left as the origin.
 * @property {number|import("../size.js").Size} [tileSize] Tile size.
 * Default is `[256, 256]`.
 * @property {Array<number|import("../size.js").Size>} [tileSizes] Tile sizes. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * tile size.
 */ /**
 * @classdesc
 * Base class for setting the grid pattern for sources accessing tiled-image
 * servers.
 * @api
 */ class $56db44221d298c30$var$TileGrid {
    /**
   * @param {Options} options Tile grid options.
   */ constructor(options){
        /**
     * @protected
     * @type {number}
     */ this.minZoom = options.minZoom !== undefined ? options.minZoom : 0;
        /**
     * @private
     * @type {!Array<number>}
     */ this.resolutions_ = options.resolutions;
        (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)((0, $db525acb5f2517fc$export$efa610630f9e181)(this.resolutions_, /**
         * @param {number} a First resolution
         * @param {number} b Second resolution
         * @return {number} Comparison result
         */ (a, b)=>b - a, true), '`resolutions` must be sorted in descending order');
        // check if we've got a consistent zoom factor and origin
        let zoomFactor;
        if (!options.origins) for(let i = 0, ii = this.resolutions_.length - 1; i < ii; ++i){
            if (!zoomFactor) zoomFactor = this.resolutions_[i] / this.resolutions_[i + 1];
            else if (this.resolutions_[i] / this.resolutions_[i + 1] !== zoomFactor) {
                zoomFactor = undefined;
                break;
            }
        }
        /**
     * @private
     * @type {number|undefined}
     */ this.zoomFactor_ = zoomFactor;
        /**
     * @protected
     * @type {number}
     */ this.maxZoom = this.resolutions_.length - 1;
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.origin_ = options.origin !== undefined ? options.origin : null;
        /**
     * @private
     * @type {Array<import("../coordinate.js").Coordinate>}
     */ this.origins_ = null;
        if (options.origins !== undefined) {
            this.origins_ = options.origins;
            (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(this.origins_.length == this.resolutions_.length, 'Number of `origins` and `resolutions` must be equal');
        }
        const extent = options.extent;
        if (extent !== undefined && !this.origin_ && !this.origins_) this.origin_ = (0, $3412ad7bd362b04c$export$cb1538b07e6964ff)(extent);
        (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(!this.origin_ && this.origins_ || this.origin_ && !this.origins_, 'Either `origin` or `origins` must be configured, never both');
        /**
     * @private
     * @type {Array<number|import("../size.js").Size>}
     */ this.tileSizes_ = null;
        if (options.tileSizes !== undefined) {
            this.tileSizes_ = options.tileSizes;
            (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(this.tileSizes_.length == this.resolutions_.length, 'Number of `tileSizes` and `resolutions` must be equal');
        }
        /**
     * @private
     * @type {number|import("../size.js").Size}
     */ this.tileSize_ = options.tileSize !== undefined ? options.tileSize : !this.tileSizes_ ? (0, $54151e436146eea5$export$6b8cb5cd370bd90c) : null;
        (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(!this.tileSize_ && this.tileSizes_ || this.tileSize_ && !this.tileSizes_, 'Either `tileSize` or `tileSizes` must be configured, never both');
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = extent !== undefined ? extent : null;
        /**
     * @private
     * @type {Array<import("../TileRange.js").default>}
     */ this.fullTileRanges_ = null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.tmpSize_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.tmpExtent_ = [
            0,
            0,
            0,
            0
        ];
        if (options.sizes !== undefined) this.fullTileRanges_ = options.sizes.map((size, z)=>{
            const tileRange = new (0, $1bd0ced7cb08c615$export$2e2bcd8739ae039)(Math.min(0, size[0]), Math.max(size[0] - 1, -1), Math.min(0, size[1]), Math.max(size[1] - 1, -1));
            if (extent) {
                const restrictedTileRange = this.getTileRangeForExtentAndZ(extent, z);
                tileRange.minX = Math.max(restrictedTileRange.minX, tileRange.minX);
                tileRange.maxX = Math.min(restrictedTileRange.maxX, tileRange.maxX);
                tileRange.minY = Math.max(restrictedTileRange.minY, tileRange.minY);
                tileRange.maxY = Math.min(restrictedTileRange.maxY, tileRange.maxY);
            }
            return tileRange;
        });
        else if (extent) this.calculateTileRanges_(extent);
    }
    /**
   * Call a function with each tile coordinate for a given extent and zoom level.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} zoom Integer zoom level.
   * @param {function(import("../tilecoord.js").TileCoord): void} callback Function called with each tile coordinate.
   * @api
   */ forEachTileCoord(extent, zoom, callback) {
        const tileRange = this.getTileRangeForExtentAndZ(extent, zoom);
        for(let i = tileRange.minX, ii = tileRange.maxX; i <= ii; ++i)for(let j = tileRange.minY, jj = tileRange.maxY; j <= jj; ++j)callback([
            zoom,
            i,
            j
        ]);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {function(number, import("../TileRange.js").default): boolean} callback Callback.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary import("../extent.js").Extent object.
   * @return {boolean} Callback succeeded.
   */ forEachTileCoordParentTileRange(tileCoord, callback, tempTileRange, tempExtent) {
        let tileRange, x, y;
        let tileCoordExtent = null;
        let z = tileCoord[0] - 1;
        if (this.zoomFactor_ === 2) {
            x = tileCoord[1];
            y = tileCoord[2];
        } else tileCoordExtent = this.getTileCoordExtent(tileCoord, tempExtent);
        while(z >= this.minZoom){
            if (x !== undefined && y !== undefined) {
                x = Math.floor(x / 2);
                y = Math.floor(y / 2);
                tileRange = (0, $1bd0ced7cb08c615$export$958e3e1a02eac4b6)(x, x, y, y, tempTileRange);
            } else tileRange = this.getTileRangeForExtentAndZ(tileCoordExtent, z, tempTileRange);
            if (callback(z, tileRange)) return true;
            --z;
        }
        return false;
    }
    /**
   * Get the extent for this tile grid, if it was configured.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        return this.extent_;
    }
    /**
   * Get the maximum zoom level for the grid.
   * @return {number} Max zoom.
   * @api
   */ getMaxZoom() {
        return this.maxZoom;
    }
    /**
   * Get the minimum zoom level for the grid.
   * @return {number} Min zoom.
   * @api
   */ getMinZoom() {
        return this.minZoom;
    }
    /**
   * Get the origin for the grid at the given zoom level.
   * @param {number} z Integer zoom level.
   * @return {import("../coordinate.js").Coordinate} Origin.
   * @api
   */ getOrigin(z) {
        if (this.origin_) return this.origin_;
        return this.origins_[z];
    }
    /**
   * Get the list of origins for the grid.
   * @return {Array<import("../coordinate.js").Coordinate>|null} Origin.
   */ getOrigins() {
        return this.origins_;
    }
    /**
   * Get the resolution for the given zoom level.
   * @param {number} z Integer zoom level.
   * @return {number} Resolution.
   * @api
   */ getResolution(z) {
        return this.resolutions_[z];
    }
    /**
   * Get the list of resolutions for the tile grid.
   * @return {Array<number>} Resolutions.
   * @api
   */ getResolutions() {
        return this.resolutions_;
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary import("../extent.js").Extent object.
   * @return {import("../TileRange.js").default|null} Tile range.
   */ getTileCoordChildTileRange(tileCoord, tempTileRange, tempExtent) {
        if (tileCoord[0] < this.maxZoom) {
            if (this.zoomFactor_ === 2) {
                const minX = tileCoord[1] * 2;
                const minY = tileCoord[2] * 2;
                return (0, $1bd0ced7cb08c615$export$958e3e1a02eac4b6)(minX, minX + 1, minY, minY + 1, tempTileRange);
            }
            const tileCoordExtent = this.getTileCoordExtent(tileCoord, tempExtent || this.tmpExtent_);
            return this.getTileRangeForExtentAndZ(tileCoordExtent, tileCoord[0] + 1, tempTileRange);
        }
        return null;
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {number} z Integer zoom level.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @return {import("../TileRange.js").default|null} Tile range.
   */ getTileRangeForTileCoordAndZ(tileCoord, z, tempTileRange) {
        if (z > this.maxZoom || z < this.minZoom) return null;
        const tileCoordZ = tileCoord[0];
        const tileCoordX = tileCoord[1];
        const tileCoordY = tileCoord[2];
        if (z === tileCoordZ) return (0, $1bd0ced7cb08c615$export$958e3e1a02eac4b6)(tileCoordX, tileCoordY, tileCoordX, tileCoordY, tempTileRange);
        if (this.zoomFactor_) {
            const factor = Math.pow(this.zoomFactor_, z - tileCoordZ);
            const minX = Math.floor(tileCoordX * factor);
            const minY = Math.floor(tileCoordY * factor);
            if (z < tileCoordZ) return (0, $1bd0ced7cb08c615$export$958e3e1a02eac4b6)(minX, minX, minY, minY, tempTileRange);
            const maxX = Math.floor(factor * (tileCoordX + 1)) - 1;
            const maxY = Math.floor(factor * (tileCoordY + 1)) - 1;
            return (0, $1bd0ced7cb08c615$export$958e3e1a02eac4b6)(minX, maxX, minY, maxY, tempTileRange);
        }
        const tileCoordExtent = this.getTileCoordExtent(tileCoord, this.tmpExtent_);
        return this.getTileRangeForExtentAndZ(tileCoordExtent, z, tempTileRange);
    }
    /**
   * Get a tile range for the given extent and integer zoom level.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} z Integer zoom level.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary tile range object.
   * @return {import("../TileRange.js").default} Tile range.
   */ getTileRangeForExtentAndZ(extent, z, tempTileRange) {
        this.getTileCoordForXYAndZ_(extent[0], extent[3], z, false, $56db44221d298c30$var$tmpTileCoord);
        const minX = $56db44221d298c30$var$tmpTileCoord[1];
        const minY = $56db44221d298c30$var$tmpTileCoord[2];
        this.getTileCoordForXYAndZ_(extent[2], extent[1], z, true, $56db44221d298c30$var$tmpTileCoord);
        const maxX = $56db44221d298c30$var$tmpTileCoord[1];
        const maxY = $56db44221d298c30$var$tmpTileCoord[2];
        return (0, $1bd0ced7cb08c615$export$958e3e1a02eac4b6)(minX, maxX, minY, maxY, tempTileRange);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {import("../coordinate.js").Coordinate} Tile center.
   */ getTileCoordCenter(tileCoord) {
        const origin = this.getOrigin(tileCoord[0]);
        const resolution = this.getResolution(tileCoord[0]);
        const tileSize = (0, $e9727ecf69942748$export$a71a825ff42fb8e1)(this.getTileSize(tileCoord[0]), this.tmpSize_);
        return [
            origin[0] + (tileCoord[1] + 0.5) * tileSize[0] * resolution,
            origin[1] - (tileCoord[2] + 0.5) * tileSize[1] * resolution
        ];
    }
    /**
   * Get the extent of a tile coordinate.
   *
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary extent object.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getTileCoordExtent(tileCoord, tempExtent) {
        const origin = this.getOrigin(tileCoord[0]);
        const resolution = this.getResolution(tileCoord[0]);
        const tileSize = (0, $e9727ecf69942748$export$a71a825ff42fb8e1)(this.getTileSize(tileCoord[0]), this.tmpSize_);
        const minX = origin[0] + tileCoord[1] * tileSize[0] * resolution;
        const minY = origin[1] - (tileCoord[2] + 1) * tileSize[1] * resolution;
        const maxX = minX + tileSize[0] * resolution;
        const maxY = minY + tileSize[1] * resolution;
        return (0, $3412ad7bd362b04c$export$958e3e1a02eac4b6)(minX, minY, maxX, maxY, tempExtent);
    }
    /**
   * Get the tile coordinate for the given map coordinate and resolution.  This
   * method considers that coordinates that intersect tile boundaries should be
   * assigned the higher tile coordinate.
   *
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @api
   */ getTileCoordForCoordAndResolution(coordinate, resolution, opt_tileCoord) {
        return this.getTileCoordForXYAndResolution_(coordinate[0], coordinate[1], resolution, false, opt_tileCoord);
    }
    /**
   * Note that this method should not be called for resolutions that correspond
   * to an integer zoom level.  Instead call the `getTileCoordForXYAndZ_` method.
   * @param {number} x X.
   * @param {number} y Y.
   * @param {number} resolution Resolution (for a non-integer zoom level).
   * @param {boolean} reverseIntersectionPolicy Instead of letting edge
   *     intersections go to the higher tile coordinate, let edge intersections
   *     go to the lower tile coordinate.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @private
   */ getTileCoordForXYAndResolution_(x, y, resolution, reverseIntersectionPolicy, opt_tileCoord) {
        const z = this.getZForResolution(resolution);
        const scale = resolution / this.getResolution(z);
        const origin = this.getOrigin(z);
        const tileSize = (0, $e9727ecf69942748$export$a71a825ff42fb8e1)(this.getTileSize(z), this.tmpSize_);
        let tileCoordX = scale * (x - origin[0]) / resolution / tileSize[0];
        let tileCoordY = scale * (origin[1] - y) / resolution / tileSize[1];
        if (reverseIntersectionPolicy) {
            tileCoordX = (0, $912ac838ff50d1cd$export$803ce6b71a0a94b2)(tileCoordX, $56db44221d298c30$var$DECIMALS) - 1;
            tileCoordY = (0, $912ac838ff50d1cd$export$803ce6b71a0a94b2)(tileCoordY, $56db44221d298c30$var$DECIMALS) - 1;
        } else {
            tileCoordX = (0, $912ac838ff50d1cd$export$a3fe094919f356fd)(tileCoordX, $56db44221d298c30$var$DECIMALS);
            tileCoordY = (0, $912ac838ff50d1cd$export$a3fe094919f356fd)(tileCoordY, $56db44221d298c30$var$DECIMALS);
        }
        return (0, $3324a006fd485ae2$export$958e3e1a02eac4b6)(z, tileCoordX, tileCoordY, opt_tileCoord);
    }
    /**
   * Although there is repetition between this method and `getTileCoordForXYAndResolution_`,
   * they should have separate implementations.  This method is for integer zoom
   * levels.  The other method should only be called for resolutions corresponding
   * to non-integer zoom levels.
   * @param {number} x Map x coordinate.
   * @param {number} y Map y coordinate.
   * @param {number} z Integer zoom level.
   * @param {boolean} reverseIntersectionPolicy Instead of letting edge
   *     intersections go to the higher tile coordinate, let edge intersections
   *     go to the lower tile coordinate.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @private
   */ getTileCoordForXYAndZ_(x, y, z, reverseIntersectionPolicy, opt_tileCoord) {
        const origin = this.getOrigin(z);
        const resolution = this.getResolution(z);
        const tileSize = (0, $e9727ecf69942748$export$a71a825ff42fb8e1)(this.getTileSize(z), this.tmpSize_);
        let tileCoordX = (x - origin[0]) / resolution / tileSize[0];
        let tileCoordY = (origin[1] - y) / resolution / tileSize[1];
        if (reverseIntersectionPolicy) {
            tileCoordX = (0, $912ac838ff50d1cd$export$803ce6b71a0a94b2)(tileCoordX, $56db44221d298c30$var$DECIMALS) - 1;
            tileCoordY = (0, $912ac838ff50d1cd$export$803ce6b71a0a94b2)(tileCoordY, $56db44221d298c30$var$DECIMALS) - 1;
        } else {
            tileCoordX = (0, $912ac838ff50d1cd$export$a3fe094919f356fd)(tileCoordX, $56db44221d298c30$var$DECIMALS);
            tileCoordY = (0, $912ac838ff50d1cd$export$a3fe094919f356fd)(tileCoordY, $56db44221d298c30$var$DECIMALS);
        }
        return (0, $3324a006fd485ae2$export$958e3e1a02eac4b6)(z, tileCoordX, tileCoordY, opt_tileCoord);
    }
    /**
   * Get a tile coordinate given a map coordinate and zoom level.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} z Integer zoom level, e.g. the result of a `getZForResolution()` method call
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @api
   */ getTileCoordForCoordAndZ(coordinate, z, opt_tileCoord) {
        return this.getTileCoordForXYAndZ_(coordinate[0], coordinate[1], z, false, opt_tileCoord);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {number} Tile resolution.
   */ getTileCoordResolution(tileCoord) {
        return this.resolutions_[tileCoord[0]];
    }
    /**
   * Get the tile size for a zoom level. The type of the return value matches the
   * `tileSize` or `tileSizes` that the tile grid was configured with. To always
   * get an {@link import("../size.js").Size}, run the result through {@link module:ol/size.toSize}.
   * @param {number} z Z.
   * @return {number|import("../size.js").Size} Tile size.
   * @api
   */ getTileSize(z) {
        if (this.tileSize_) return this.tileSize_;
        return this.tileSizes_[z];
    }
    /**
   * @param {number} z Zoom level.
   * @return {import("../TileRange.js").default|null} Extent tile range for the specified zoom level.
   */ getFullTileRange(z) {
        if (!this.fullTileRanges_) return this.extent_ ? this.getTileRangeForExtentAndZ(this.extent_, z) : null;
        return this.fullTileRanges_[z];
    }
    /**
   * @param {number} resolution Resolution.
   * @param {number|import("../array.js").NearestDirectionFunction} [opt_direction]
   *     If 0, the nearest resolution will be used.
   *     If 1, the nearest higher resolution (lower Z) will be used. If -1, the
   *     nearest lower resolution (higher Z) will be used. Default is 0.
   *     Use a {@link module:ol/array~NearestDirectionFunction} for more precise control.
   *
   * For example to change tile Z at the midpoint of zoom levels
   * ```js
   * function(value, high, low) {
   *   return value - low * Math.sqrt(high / low);
   * }
   * ```
   * @return {number} Z.
   * @api
   */ getZForResolution(resolution, opt_direction) {
        const z = (0, $db525acb5f2517fc$export$8a3786cc03fdb777)(this.resolutions_, resolution, opt_direction || 0);
        return (0, $912ac838ff50d1cd$export$7d15b64cf5a3a4c4)(z, this.minZoom, this.maxZoom);
    }
    /**
   * The tile with the provided tile coordinate intersects the given viewport.
   * @param {import('../tilecoord.js').TileCoord} tileCoord Tile coordinate.
   * @param {Array<number>} viewport Viewport as returned from {@link module:ol/extent.getRotatedViewport}.
   * @return {boolean} The tile with the provided tile coordinate intersects the given viewport.
   */ tileCoordIntersectsViewport(tileCoord, viewport) {
        return (0, $ff49a05bd3496d04$export$830a0dafbb2ef1c5)(viewport, 0, viewport.length, 2, this.getTileCoordExtent(tileCoord));
    }
    /**
   * @param {!import("../extent.js").Extent} extent Extent for this tile grid.
   * @private
   */ calculateTileRanges_(extent) {
        const length = this.resolutions_.length;
        const fullTileRanges = new Array(length);
        for(let z = this.minZoom; z < length; ++z)fullTileRanges[z] = this.getTileRangeForExtentAndZ(extent, z);
        this.fullTileRanges_ = fullTileRanges;
    }
}
var $56db44221d298c30$export$2e2bcd8739ae039 = $56db44221d298c30$var$TileGrid;




function $258117a93d01826e$export$1f4812384df8a9c5(projection) {
    let tileGrid = projection.getDefaultTileGrid();
    if (!tileGrid) {
        tileGrid = $258117a93d01826e$export$a251b12f5601c16f(projection);
        projection.setDefaultTileGrid(tileGrid);
    }
    return tileGrid;
}
function $258117a93d01826e$export$39a9ce3624977b84(tileGrid, tileCoord, projection) {
    const z = tileCoord[0];
    const center = tileGrid.getTileCoordCenter(tileCoord);
    const projectionExtent = $258117a93d01826e$export$7b5b6ef8fd55fac4(projection);
    if (!(0, $3412ad7bd362b04c$export$ac68c24d37ca240f)(projectionExtent, center)) {
        const worldWidth = (0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(projectionExtent);
        const worldsAway = Math.ceil((projectionExtent[0] - center[0]) / worldWidth);
        center[0] += worldWidth * worldsAway;
        return tileGrid.getTileCoordForCoordAndZ(center, z);
    }
    return tileCoord;
}
function $258117a93d01826e$export$ce88871416242df8(extent, maxZoom, tileSize, corner) {
    corner = corner !== undefined ? corner : 'top-left';
    const resolutions = $258117a93d01826e$var$resolutionsFromExtent(extent, maxZoom, tileSize);
    return new (0, $56db44221d298c30$export$2e2bcd8739ae039)({
        extent: extent,
        origin: (0, $3412ad7bd362b04c$export$a1cfd206661d0801)(extent, corner),
        resolutions: resolutions,
        tileSize: tileSize
    });
}
function $258117a93d01826e$export$38500bbeccc864ff(options) {
    const xyzOptions = options || {};
    const extent = xyzOptions.extent || (0, $2a998b085c5a7ac9$export$3988ae62b71be9a3)('EPSG:3857').getExtent();
    const gridOptions = {
        extent: extent,
        minZoom: xyzOptions.minZoom,
        tileSize: xyzOptions.tileSize,
        resolutions: $258117a93d01826e$var$resolutionsFromExtent(extent, xyzOptions.maxZoom, xyzOptions.tileSize, xyzOptions.maxResolution)
    };
    return new (0, $56db44221d298c30$export$2e2bcd8739ae039)(gridOptions);
}
/**
 * Create a resolutions array from an extent.  A zoom factor of 2 is assumed.
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {number} [maxZoom] Maximum zoom level (default is
 *     DEFAULT_MAX_ZOOM).
 * @param {number|import("./size.js").Size} [tileSize] Tile size (default uses
 *     DEFAULT_TILE_SIZE).
 * @param {number} [maxResolution] Resolution at level zero.
 * @return {!Array<number>} Resolutions array.
 */ function $258117a93d01826e$var$resolutionsFromExtent(extent, maxZoom, tileSize, maxResolution) {
    maxZoom = maxZoom !== undefined ? maxZoom : (0, $54151e436146eea5$export$e98a216cdcc847dc);
    tileSize = (0, $e9727ecf69942748$export$a71a825ff42fb8e1)(tileSize !== undefined ? tileSize : (0, $54151e436146eea5$export$6b8cb5cd370bd90c));
    const height = (0, $3412ad7bd362b04c$export$c08559766941f856)(extent);
    const width = (0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(extent);
    maxResolution = maxResolution > 0 ? maxResolution : Math.max(width / tileSize[0], height / tileSize[1]);
    const length = maxZoom + 1;
    const resolutions = new Array(length);
    for(let z = 0; z < length; ++z)resolutions[z] = maxResolution / Math.pow(2, z);
    return resolutions;
}
function $258117a93d01826e$export$a251b12f5601c16f(projection, maxZoom, tileSize, corner) {
    const extent = $258117a93d01826e$export$7b5b6ef8fd55fac4(projection);
    return $258117a93d01826e$export$ce88871416242df8(extent, maxZoom, tileSize, corner);
}
function $258117a93d01826e$export$7b5b6ef8fd55fac4(projection) {
    projection = (0, $2a998b085c5a7ac9$export$3988ae62b71be9a3)(projection);
    let extent = projection.getExtent();
    if (!extent) {
        const half = 180 * (0, $8ebfe5645312696b$export$1482081eec883108).degrees / projection.getMetersPerUnit();
        extent = (0, $3412ad7bd362b04c$export$958e3e1a02eac4b6)(-half, -half, half, half);
    }
    return extent;
}


/**
 * @module ol/tileurlfunction
 */ 

/**
 * @module ol/uri
 */ 

function $afb91b101dc7d4ff$export$c202e3cb8db99a95(uri, params) {
    /** @type {Array<string>} */ const keyParams = [];
    // Skip any null or undefined parameter values
    Object.keys(params).forEach(function(k) {
        if (params[k] !== null && params[k] !== undefined) keyParams.push(k + '=' + encodeURIComponent(params[k]));
    });
    const qs = keyParams.join('&');
    // remove any trailing ? or &
    uri = uri.replace(/[?&]$/, '');
    // append ? or & depending on whether uri has existing parameters
    uri += uri.includes('?') ? '&' : '?';
    return uri + qs;
}
const $afb91b101dc7d4ff$var$zRegEx = /\{z\}/g;
const $afb91b101dc7d4ff$var$xRegEx = /\{x\}/g;
const $afb91b101dc7d4ff$var$yRegEx = /\{y\}/g;
const $afb91b101dc7d4ff$var$dashYRegEx = /\{-y\}/g;
function $afb91b101dc7d4ff$export$df1e52f1b5b1c86f(template, z, x, y, maxY) {
    return template.replace($afb91b101dc7d4ff$var$zRegEx, z.toString()).replace($afb91b101dc7d4ff$var$xRegEx, x.toString()).replace($afb91b101dc7d4ff$var$yRegEx, y.toString()).replace($afb91b101dc7d4ff$var$dashYRegEx, function() {
        if (maxY === undefined) throw new Error('If the URL template has a {-y} placeholder, the grid extent must be known');
        return (maxY - y).toString();
    });
}
function $afb91b101dc7d4ff$export$83e87e683240b2e8(urls, z, x, y) {
    const hash = (0, $3324a006fd485ae2$export$731f79419750ccf7)(z, x, y);
    const index = (0, $912ac838ff50d1cd$export$ba467bec01d66def)(hash, urls.length);
    return urls[index];
}
function $afb91b101dc7d4ff$export$2a1fa079bfd73dde(url) {
    const urls = [];
    let match = /\{([a-z])-([a-z])\}/.exec(url);
    if (match) {
        // char range
        const startCharCode = match[1].charCodeAt(0);
        const stopCharCode = match[2].charCodeAt(0);
        let charCode;
        for(charCode = startCharCode; charCode <= stopCharCode; ++charCode)urls.push(url.replace(match[0], String.fromCharCode(charCode)));
        return urls;
    }
    match = /\{(\d+)-(\d+)\}/.exec(url);
    if (match) {
        // number range
        const stop = parseInt(match[2], 10);
        for(let i = parseInt(match[1], 10); i <= stop; i++)urls.push(url.replace(match[0], i.toString()));
        return urls;
    }
    urls.push(url);
    return urls;
}


function $ca177be05011f9c0$export$f0ecb46e90798741(template, tileGrid) {
    return(/**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ function(tileCoord, pixelRatio, projection) {
        if (!tileCoord) return undefined;
        let maxY;
        const z = tileCoord[0];
        if (tileGrid) {
            // The `{-y}` placeholder only works for sources that have a tile grid at construction
            const range = tileGrid.getFullTileRange(z);
            if (range) maxY = range.getHeight() - 1;
        }
        return (0, $afb91b101dc7d4ff$export$df1e52f1b5b1c86f)(template, z, tileCoord[1], tileCoord[2], maxY);
    });
}
function $ca177be05011f9c0$export$436f44dbcc31fea3(templates, tileGrid) {
    const len = templates.length;
    const tileUrlFunctions = new Array(len);
    for(let i = 0; i < len; ++i)tileUrlFunctions[i] = $ca177be05011f9c0$export$f0ecb46e90798741(templates[i], tileGrid);
    return $ca177be05011f9c0$export$4229b1d9af69b3be(tileUrlFunctions);
}
function $ca177be05011f9c0$export$4229b1d9af69b3be(tileUrlFunctions) {
    if (tileUrlFunctions.length === 1) return tileUrlFunctions[0];
    return(/**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ function(tileCoord, pixelRatio, projection) {
        if (!tileCoord) return undefined;
        const h = (0, $3324a006fd485ae2$export$d6af199866bfb566)(tileCoord);
        const index = (0, $912ac838ff50d1cd$export$ba467bec01d66def)(h, tileUrlFunctions.length);
        return tileUrlFunctions[index](tileCoord, pixelRatio, projection);
    });
}
function $ca177be05011f9c0$export$fab585f002f634a1(tileCoord, pixelRatio, projection) {
    return undefined;
}


/**
 * @module ol/source/TileImage
 */ 








/**
 * @module ol/source/UrlTile
 */ 



/**
 * @module ol/source/Tile
 */ 





/***
 * @template Return
 * @typedef {import("../Observable.js").OnSignature<import("../Observable.js").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable.js").OnSignature<import("../ObjectEventType.js").Types, import("../Object.js").ObjectEvent, Return> &
 *   import("../Observable.js").OnSignature<import("./TileEventType.js").TileSourceEventTypes, TileSourceEvent, Return> &
 *   import("../Observable.js").CombinedOnSignature<import("../Observable.js").EventTypes|import("../ObjectEventType.js").Types|
 *     import("./TileEventType.js").TileSourceEventTypes, Return>} TileSourceOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {number} [tilePixelRatio] TilePixelRatio.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {import("./Source.js").State} [state] State.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] TileGrid.
 * @property {boolean} [wrapX=false] WrapX.
 * @property {number} [transition] Transition.
 * @property {string} [key] Key.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0] ZDirection.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for sources providing images divided into a tile grid.
 *
 * @template {import("../Tile.js").default} [TileType=import("../Tile.js").default]
 * @abstract
 * @api
 */ class $b198f34e90170996$var$TileSource extends (0, $039754a80ce105f8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options SourceTile source options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            attributionsCollapsible: options.attributionsCollapsible,
            projection: options.projection,
            state: options.state,
            wrapX: options.wrapX,
            interpolate: options.interpolate
        });
        /***
     * @type {TileSourceOnSignature<import("../events.js").EventsKey>}
     */ this.on;
        /***
     * @type {TileSourceOnSignature<import("../events.js").EventsKey>}
     */ this.once;
        /***
     * @type {TileSourceOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {number}
     */ this.tilePixelRatio_ = options.tilePixelRatio !== undefined ? options.tilePixelRatio : 1;
        /**
     * @type {import("../tilegrid/TileGrid.js").default|null}
     * @protected
     */ this.tileGrid = options.tileGrid !== undefined ? options.tileGrid : null;
        const tileSize = [
            256,
            256
        ];
        if (this.tileGrid) (0, $e9727ecf69942748$export$a71a825ff42fb8e1)(this.tileGrid.getTileSize(this.tileGrid.getMinZoom()), tileSize);
        /**
     * @protected
     * @type {import("../size.js").Size}
     */ this.tmpSize = [
            0,
            0
        ];
        /**
     * @private
     * @type {string}
     */ this.key_ = options.key || (0, $01f1986453243423$export$5e82334337e0f204)(this);
        /**
     * @protected
     * @type {import("../Tile.js").Options}
     */ this.tileOptions = {
            transition: options.transition,
            interpolate: options.interpolate
        };
        /**
     * zDirection hint, read by the renderer. Indicates which resolution should be used
     * by a renderer if the views resolution does not match any resolution of the tile source.
     * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
     * will be used. If -1, the nearest higher resolution will be used.
     * @type {number|import("../array.js").NearestDirectionFunction}
     */ this.zDirection = options.zDirection ? options.zDirection : 0;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {number} Gutter.
   */ getGutterForProjection(projection) {
        return 0;
    }
    /**
   * Return the key to be used for all tiles in the source.
   * @return {string} The key for all tiles.
   */ getKey() {
        return this.key_;
    }
    /**
   * Set the value to be used as the key for all tiles in the source.
   * @param {string} key The key for tiles.
   * @protected
   */ setKey(key) {
        if (this.key_ !== key) {
            this.key_ = key;
            this.changed();
        }
    }
    /**
   * @param {import("../proj/Projection.js").default} [projection] Projection.
   * @return {Array<number>|null} Resolutions.
   * @override
   */ getResolutions(projection) {
        const tileGrid = projection ? this.getTileGridForProjection(projection) : this.tileGrid;
        if (!tileGrid) return null;
        return tileGrid.getResolutions();
    }
    /**
   * @abstract
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {import("../structs/LRUCache.js").default<import("../Tile.js").default>} [tileCache] Tile cache.
   * @return {TileType|null} Tile.
   */ getTile(z, x, y, pixelRatio, projection, tileCache) {
        return (0, $01f1986453243423$export$817eb92a8194bab0)();
    }
    /**
   * Return the tile grid of the tile source.
   * @return {import("../tilegrid/TileGrid.js").default|null} Tile grid.
   * @api
   */ getTileGrid() {
        return this.tileGrid;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   */ getTileGridForProjection(projection) {
        if (!this.tileGrid) return (0, $258117a93d01826e$export$1f4812384df8a9c5)(projection);
        return this.tileGrid;
    }
    /**
   * Get the tile pixel ratio for this source. Subclasses may override this
   * method, which is meant to return a supported pixel ratio that matches the
   * provided `pixelRatio` as close as possible.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Tile pixel ratio.
   */ getTilePixelRatio(pixelRatio) {
        return this.tilePixelRatio_;
    }
    /**
   * @param {number} z Z.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../size.js").Size} Tile size.
   */ getTilePixelSize(z, pixelRatio, projection) {
        const tileGrid = this.getTileGridForProjection(projection);
        const tilePixelRatio = this.getTilePixelRatio(pixelRatio);
        const tileSize = (0, $e9727ecf69942748$export$a71a825ff42fb8e1)(tileGrid.getTileSize(z), this.tmpSize);
        if (tilePixelRatio == 1) return tileSize;
        return (0, $e9727ecf69942748$export$dcdf75081b88279d)(tileSize, tilePixelRatio, this.tmpSize);
    }
    /**
   * Returns a tile coordinate wrapped around the x-axis. When the tile coordinate
   * is outside the resolution and extent range of the tile grid, `null` will be
   * returned.
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../proj/Projection.js").default} [projection] Projection.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate to be passed to the tileUrlFunction or
   *     null if no tile URL should be created for the passed `tileCoord`.
   */ getTileCoordForTileUrlFunction(tileCoord, projection) {
        const gridProjection = projection !== undefined ? projection : this.getProjection();
        const tileGrid = projection !== undefined ? this.getTileGridForProjection(gridProjection) : this.tileGrid || this.getTileGridForProjection(gridProjection);
        if (this.getWrapX() && gridProjection.isGlobal()) tileCoord = (0, $258117a93d01826e$export$39a9ce3624977b84)(tileGrid, tileCoord, gridProjection);
        return (0, $3324a006fd485ae2$export$60bedf8e3e3c3dbe)(tileCoord, tileGrid) ? tileCoord : null;
    }
    /**
   * Remove all cached reprojected tiles from the source. The next render cycle will create new tiles.
   * @api
   */ clear() {}
    /**
   * @override
   */ refresh() {
        this.clear();
        super.refresh();
    }
}
class $b198f34e90170996$export$c571855c51e6c4b6 extends (0, $bc90848f8b15fa29$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Type.
   * @param {import("../Tile.js").default} tile The tile.
   */ constructor(type, tile){
        super(type);
        /**
     * The tile related to the event.
     * @type {import("../Tile.js").default}
     * @api
     */ this.tile = tile;
    }
}
var $b198f34e90170996$export$2e2bcd8739ae039 = $b198f34e90170996$var$TileSource;


/**
 * @module ol/source/TileEventType
 */ /**
 * @enum {string}
 */ var $0263e3998878e9e9$export$2e2bcd8739ae039 /**
 * @typedef {'tileloadstart'|'tileloadend'|'tileloaderror'} TileSourceEventTypes
 */  = {
    /**
   * Triggered when a tile starts loading.
   * @event module:ol/source/Tile.TileSourceEvent#tileloadstart
   * @api
   */ TILELOADSTART: 'tileloadstart',
    /**
   * Triggered when a tile finishes loading, either when its data is loaded,
   * or when loading was aborted because the tile is no longer needed.
   * @event module:ol/source/Tile.TileSourceEvent#tileloadend
   * @api
   */ TILELOADEND: 'tileloadend',
    /**
   * Triggered if tile loading results in an error. Note that this is not the
   * right place to re-fetch tiles. See {@link module:ol/ImageTile~ImageTile#load}
   * for details.
   * @event module:ol/source/Tile.TileSourceEvent#tileloaderror
   * @api
   */ TILELOADERROR: 'tileloaderror'
};


/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {import("./Source.js").State} [state] State.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] TileGrid.
 * @property {import("../Tile.js").LoadFunction} tileLoadFunction TileLoadFunction.
 * @property {number} [tilePixelRatio] TilePixelRatio.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Deprecated.  Use an ImageTile source and provide a function
 * for the url option instead.
 * @property {string} [url] Url.
 * @property {Array<string>} [urls] Urls.
 * @property {boolean} [wrapX=true] WrapX.
 * @property {number} [transition] Transition.
 * @property {string} [key] Key.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0] ZDirection.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @deprecated Use the ol/source/ImageTile.js instead.
 *
 * @fires import("./Tile.js").TileSourceEvent
 */ class $99a9b780f47de391$var$UrlTile extends (0, $b198f34e90170996$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Image tile options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tilePixelRatio: options.tilePixelRatio,
            wrapX: options.wrapX,
            transition: options.transition,
            interpolate: options.interpolate,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @private
     * @type {boolean}
     */ this.generateTileUrlFunction_ = this.tileUrlFunction === $99a9b780f47de391$var$UrlTile.prototype.tileUrlFunction;
        /**
     * @protected
     * @type {import("../Tile.js").LoadFunction}
     */ this.tileLoadFunction = options.tileLoadFunction;
        if (options.tileUrlFunction) this.tileUrlFunction = options.tileUrlFunction;
        /**
     * @protected
     * @type {!Array<string>|null}
     */ this.urls = null;
        if (options.urls) this.setUrls(options.urls);
        else if (options.url) this.setUrl(options.url);
        /**
     * @private
     * @type {!Object<string, boolean>}
     */ this.tileLoadingKeys_ = {};
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Return the tile load function of the source.
   * @return {import("../Tile.js").LoadFunction} TileLoadFunction
   * @api
   */ getTileLoadFunction() {
        return this.tileLoadFunction;
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Return the tile URL function of the source.
   * @return {import("../Tile.js").UrlFunction} TileUrlFunction
   * @api
   */ getTileUrlFunction() {
        return Object.getPrototypeOf(this).tileUrlFunction === this.tileUrlFunction ? this.tileUrlFunction.bind(this) : this.tileUrlFunction;
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Return the URLs used for this source.
   * When a tileUrlFunction is used instead of url or urls,
   * null will be returned.
   * @return {!Array<string>|null} URLs.
   * @api
   */ getUrls() {
        return this.urls;
    }
    /**
   * Handle tile change events.
   * @param {import("../events/Event.js").default} event Event.
   * @protected
   */ handleTileChange(event) {
        const tile = /** @type {import("../Tile.js").default} */ event.target;
        const uid = (0, $01f1986453243423$export$5e82334337e0f204)(tile);
        const tileState = tile.getState();
        let type;
        if (tileState == (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADING) {
            this.tileLoadingKeys_[uid] = true;
            type = (0, $0263e3998878e9e9$export$2e2bcd8739ae039).TILELOADSTART;
        } else if (uid in this.tileLoadingKeys_) {
            delete this.tileLoadingKeys_[uid];
            type = tileState == (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).ERROR ? (0, $0263e3998878e9e9$export$2e2bcd8739ae039).TILELOADERROR : tileState == (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADED ? (0, $0263e3998878e9e9$export$2e2bcd8739ae039).TILELOADEND : undefined;
        }
        if (type != undefined) this.dispatchEvent(new (0, $b198f34e90170996$export$c571855c51e6c4b6)(type, tile));
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Set the tile load function of the source.
   * @param {import("../Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @api
   */ setTileLoadFunction(tileLoadFunction) {
        this.tileLoadFunction = tileLoadFunction;
        this.changed();
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Set the tile URL function of the source.
   * @param {import("../Tile.js").UrlFunction} tileUrlFunction Tile URL function.
   * @param {string} [key] Optional new tile key for the source.
   * @api
   */ setTileUrlFunction(tileUrlFunction, key) {
        this.tileUrlFunction = tileUrlFunction;
        if (typeof key !== 'undefined') this.setKey(key);
        else this.changed();
    }
    /**
   * Set the URL to use for requests.
   * @param {string} url URL.
   * @api
   */ setUrl(url) {
        const urls = (0, $afb91b101dc7d4ff$export$2a1fa079bfd73dde)(url);
        this.urls = urls;
        this.setUrls(urls);
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Set the URLs to use for requests.
   * @param {Array<string>} urls URLs.
   * @api
   */ setUrls(urls) {
        this.urls = urls;
        const key = urls.join('\n');
        if (this.generateTileUrlFunction_) this.setTileUrlFunction((0, $ca177be05011f9c0$export$436f44dbcc31fea3)(urls, this.tileGrid), key);
        else this.setKey(key);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {string|undefined} Tile URL.
   */ tileUrlFunction(tileCoord, pixelRatio, projection) {
        return undefined;
    }
}
var $99a9b780f47de391$export$2e2bcd8739ae039 = $99a9b780f47de391$var$UrlTile;


/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {ReferrerPolicy} [referrerPolicy] The `referrerPolicy` property for loaded images.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("./Source.js").State} [state] Source state.
 * @property {typeof import("../ImageTile.js").default} [tileClass] Class used to instantiate image tiles.
 * Default is {@link module:ol/ImageTile~ImageTile}.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service. For example, if the tile
 * service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Deprecated.  Use an ImageTile source and provide a function
 * for the url option instead.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`, may be
 * used instead of defining each one separately in the `urls` option.
 * @property {Array<string>} [urls] An array of URL templates.
 * @property {boolean} [wrapX] Whether to wrap the world horizontally. The default, is to
 * request out-of-bounds tiles from the server. When set to `false`, only one
 * world will be rendered. When set to `true`, tiles will be requested for one
 * world only, but they will be wrapped horizontally to render multiple worlds.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {string} [key] Optional tile key for proper cache fetching
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @deprecated Use the ol/source/ImageTile.js instead.
 *
 * @fires import("./Tile.js").TileSourceEvent
 * @api
 */ class $f47f9e8b72327546$var$TileImage extends (0, $99a9b780f47de391$export$2e2bcd8739ae039) {
    /**
   * @param {!Options} options Image tile options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tileLoadFunction: options.tileLoadFunction ? options.tileLoadFunction : $f47f9e8b72327546$export$bf0e2e44d1d59b25,
            tilePixelRatio: options.tilePixelRatio,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX,
            transition: options.transition,
            interpolate: options.interpolate !== undefined ? options.interpolate : true,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @protected
     * @type {?string}
     */ this.crossOrigin = options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
     * @protected
     * @type {ReferrerPolicy}
     */ this.referrerPolicy = options.referrerPolicy;
        /**
     * @protected
     * @type {typeof ImageTile}
     */ this.tileClass = options.tileClass !== undefined ? options.tileClass : (0, $cabe2cad606723f7$export$2e2bcd8739ae039);
        /**
     * @protected
     * @type {!Object<string, import("../tilegrid/TileGrid.js").default>}
     */ this.tileGridForProjection = {};
        /**
     * @private
     * @type {number|undefined}
     */ this.reprojectionErrorThreshold_ = options.reprojectionErrorThreshold;
        /**
     * @private
     * @type {boolean}
     */ this.renderReprojectionEdges_ = false;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {number} Gutter.
   * @override
   */ getGutterForProjection(projection) {
        if (this.getProjection() && projection && !(0, $2a998b085c5a7ac9$export$fe091d73a555748b)(this.getProjection(), projection)) return 0;
        return this.getGutter();
    }
    /**
   * @return {number} Gutter.
   */ getGutter() {
        return 0;
    }
    /**
   * Return the key to be used for all tiles in the source.
   * @return {string} The key for all tiles.
   * @override
   */ getKey() {
        let key = super.getKey();
        if (!this.getInterpolate()) key += ':disable-interpolation';
        return key;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   * @override
   */ getTileGridForProjection(projection) {
        const thisProj = this.getProjection();
        if (this.tileGrid && (!thisProj || (0, $2a998b085c5a7ac9$export$fe091d73a555748b)(thisProj, projection))) return this.tileGrid;
        const projKey = (0, $01f1986453243423$export$5e82334337e0f204)(projection);
        if (!(projKey in this.tileGridForProjection)) this.tileGridForProjection[projKey] = (0, $258117a93d01826e$export$1f4812384df8a9c5)(projection);
        return this.tileGridForProjection[projKey];
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {string} key The key set on the tile.
   * @return {!ImageTile} Tile.
   * @private
   */ createTile_(z, x, y, pixelRatio, projection, key) {
        const tileCoord = [
            z,
            x,
            y
        ];
        const urlTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
        const tileUrl = urlTileCoord ? this.tileUrlFunction(urlTileCoord, pixelRatio, projection) : undefined;
        const tile = new this.tileClass(tileCoord, tileUrl !== undefined ? (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).IDLE : (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).EMPTY, tileUrl !== undefined ? tileUrl : '', {
            crossOrigin: this.crossOrigin,
            referrerPolicy: this.referrerPolicy
        }, this.tileLoadFunction, this.tileOptions);
        tile.key = key;
        tile.addEventListener((0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CHANGE, this.handleTileChange.bind(this));
        return tile;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {import("../structs/LRUCache.js").default<import("../Tile.js").default>} [tileCache] Tile cache.
   * @return {!(ImageTile|ReprojTile)} Tile.
   * @override
   */ getTile(z, x, y, pixelRatio, projection, tileCache) {
        const sourceProjection = this.getProjection();
        if (!sourceProjection || !projection || (0, $2a998b085c5a7ac9$export$fe091d73a555748b)(sourceProjection, projection)) return this.getTileInternal(z, x, y, pixelRatio, sourceProjection || projection);
        const tileCoord = [
            z,
            x,
            y
        ];
        const key = this.getKey();
        const sourceTileGrid = this.getTileGridForProjection(sourceProjection);
        const targetTileGrid = this.getTileGridForProjection(projection);
        const wrappedTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
        const tile = new (0, $5967f4f203a3bc87$export$2e2bcd8739ae039)(sourceProjection, sourceTileGrid, projection, targetTileGrid, tileCoord, wrappedTileCoord, this.getTilePixelRatio(pixelRatio), this.getGutter(), (z, x, y, pixelRatio)=>this.getTileInternal(z, x, y, pixelRatio, sourceProjection, tileCache), this.reprojectionErrorThreshold_, this.renderReprojectionEdges_, this.tileOptions);
        tile.key = key;
        return tile;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {!import("../proj/Projection.js").default} projection Projection.
   * @param {import("../structs/LRUCache.js").default<import("../Tile.js").default>} [tileCache] Tile cache.
   * @return {!ImageTile} Tile.
   * @protected
   */ getTileInternal(z, x, y, pixelRatio, projection, tileCache) {
        const key = this.getKey();
        const cacheKey = (0, $3324a006fd485ae2$export$611736262b635f8d)(this, key, z, x, y);
        if (tileCache && tileCache.containsKey(cacheKey)) {
            const tile = /** @type {!ImageTile} */ tileCache.get(cacheKey);
            return tile;
        }
        const tile = this.createTile_(z, x, y, pixelRatio, projection, key);
        tileCache?.set(cacheKey, tile);
        return tile;
    }
    /**
   * Sets whether to render reprojection edges or not (usually for debugging).
   * @param {boolean} render Render the edges.
   * @api
   */ setRenderReprojectionEdges(render) {
        if (this.renderReprojectionEdges_ == render) return;
        this.renderReprojectionEdges_ = render;
        this.changed();
    }
    /**
   * Sets the tile grid to use when reprojecting the tiles to the given
   * projection instead of the default tile grid for the projection.
   *
   * This can be useful when the default tile grid cannot be created
   * (e.g. projection has no extent defined) or
   * for optimization reasons (custom tile size, resolutions, ...).
   *
   * @param {import("../proj.js").ProjectionLike} projection Projection.
   * @param {import("../tilegrid/TileGrid.js").default} tilegrid Tile grid to use for the projection.
   * @api
   */ setTileGridForProjection(projection, tilegrid) {
        const proj = (0, $2a998b085c5a7ac9$export$3988ae62b71be9a3)(projection);
        if (proj) {
            const projKey = (0, $01f1986453243423$export$5e82334337e0f204)(proj);
            if (!(projKey in this.tileGridForProjection)) this.tileGridForProjection[projKey] = tilegrid;
        }
    }
}
function $f47f9e8b72327546$export$bf0e2e44d1d59b25(imageTile, src) {
    if (0, $013e07c1ef6d00ad$export$98fcef3dc9973292) {
        // special treatment for offscreen canvas
        const crossOrigin = imageTile.getCrossOrigin();
        /** @type {RequestMode} */ let mode = 'same-origin';
        /** @type {RequestCredentials} */ let credentials = 'same-origin';
        if (crossOrigin === 'anonymous' || crossOrigin === '') {
            mode = 'cors';
            credentials = 'omit';
        } else if (crossOrigin === 'use-credentials') {
            mode = 'cors';
            credentials = 'include';
        }
        const options = {
            mode: mode,
            credentials: credentials,
            referrerPolicy: imageTile.getReferrerPolicy()
        };
        fetch(src, options).then((response)=>{
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return response.blob();
        }).then((blob)=>{
            return createImageBitmap(blob);
        }).then((imageBitmap)=>{
            const canvas = imageTile.getImage();
            canvas.width = imageBitmap.width;
            canvas.height = imageBitmap.height;
            const ctx = /** @type {OffscreenCanvas} */ canvas.getContext('2d');
            ctx.drawImage(imageBitmap, 0, 0);
            imageBitmap.close?.();
            // mock the image 'load' event
            canvas.dispatchEvent(new Event('load'));
        }).catch(()=>{
            const canvas = imageTile.getImage();
            canvas.dispatchEvent(new Event('error'));
        });
        return;
    }
    /** @type {HTMLImageElement|HTMLVideoElement} */ imageTile.getImage().src = src;
}
var $f47f9e8b72327546$export$2e2bcd8739ae039 = $f47f9e8b72327546$var$TileImage;


/**
 * @typedef {Object} Config
 * @property {string} [name] The name.
 * @property {string} [description] The description.
 * @property {string} [version] The version.
 * @property {string} [attribution] The attribution.
 * @property {string} [template] The template.
 * @property {string} [legend] The legend.
 * @property {string} [scheme] The scheme.
 * @property {Array<string>} tiles The tile URL templates.
 * @property {Array<string>} [grids] Optional grids.
 * @property {number} [minzoom] Minimum zoom level.
 * @property {number} [maxzoom] Maximum zoom level.
 * @property {Array<number>} [bounds] Optional bounds.
 * @property {Array<number>} [center] Optional center.
 */ /**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {boolean} [jsonp=false] Use JSONP with callback to load the TileJSON.
 * Useful when the server does not support CORS..
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {Config} [tileJSON] TileJSON configuration for this source.
 * If not provided, `url` must be configured.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number|import("../size.js").Size} [tileSize=[256, 256]] The tile size used by the tile service.
 * Note: `tileSize` and other non-standard TileJSON properties are currently ignored.
 * @property {string} [url] URL to the TileJSON file. If not provided, `tileJSON` must be configured.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Layer source for tile data in TileJSON format.
 * @api
 */ class $527758ca463865d7$var$TileJSON extends (0, $f47f9e8b72327546$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options TileJSON options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            interpolate: options.interpolate,
            projection: (0, $2a998b085c5a7ac9$export$3988ae62b71be9a3)('EPSG:3857'),
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            state: 'loading',
            tileLoadFunction: options.tileLoadFunction,
            wrapX: options.wrapX !== undefined ? options.wrapX : true,
            transition: options.transition,
            zDirection: options.zDirection
        });
        /**
     * @type {Config}
     * @private
     */ this.tileJSON_ = null;
        /**
     * @type {number|import("../size.js").Size}
     * @private
     */ this.tileSize_ = options.tileSize;
        if (options.url) {
            if (options.jsonp) (0, $2602cfa493b9e192$export$3552a04808364507)(options.url, this.handleTileJSONResponse.bind(this), this.handleTileJSONError.bind(this));
            else {
                const client = new XMLHttpRequest();
                client.addEventListener('load', this.onXHRLoad_.bind(this));
                client.addEventListener('error', this.onXHRError_.bind(this));
                client.open('GET', options.url);
                client.send();
            }
        } else if (options.tileJSON) this.handleTileJSONResponse(options.tileJSON);
        else throw new Error('Either `url` or `tileJSON` options must be provided');
    }
    /**
   * @private
   * @param {Event} event The load event.
   */ onXHRLoad_(event) {
        const client = /** @type {XMLHttpRequest} */ event.target;
        // status will be 0 for file:// urls
        if (!client.status || client.status >= 200 && client.status < 300) {
            let response;
            try {
                response = /** @type {Config} */ JSON.parse(client.responseText);
            } catch  {
                this.handleTileJSONError();
                return;
            }
            this.handleTileJSONResponse(response);
        } else this.handleTileJSONError();
    }
    /**
   * @private
   * @param {Event} event The error event.
   */ onXHRError_(event) {
        this.handleTileJSONError();
    }
    /**
   * @return {Config} The tilejson object.
   * @api
   */ getTileJSON() {
        return this.tileJSON_;
    }
    /**
   * @protected
   * @param {Config} tileJSON Tile JSON.
   */ handleTileJSONResponse(tileJSON) {
        const epsg4326Projection = (0, $2a998b085c5a7ac9$export$3988ae62b71be9a3)('EPSG:4326');
        const sourceProjection = this.getProjection();
        let extent;
        if (tileJSON['bounds'] !== undefined) {
            const transform = (0, $2a998b085c5a7ac9$export$e3c4995a701c26a3)(epsg4326Projection, sourceProjection);
            extent = (0, $3412ad7bd362b04c$export$9f9dcb98c894b623)(tileJSON['bounds'], transform);
        }
        const gridExtent = (0, $258117a93d01826e$export$7b5b6ef8fd55fac4)(sourceProjection);
        const minZoom = tileJSON['minzoom'] || 0;
        const maxZoom = tileJSON['maxzoom'] || 22;
        const tileGrid = (0, $258117a93d01826e$export$38500bbeccc864ff)({
            extent: gridExtent,
            maxZoom: maxZoom,
            minZoom: minZoom,
            tileSize: this.tileSize_
        });
        this.tileGrid = tileGrid;
        this.tileUrlFunction = (0, $ca177be05011f9c0$export$436f44dbcc31fea3)(tileJSON['tiles'], tileGrid);
        if (tileJSON['attribution'] && !this.getAttributions()) {
            const attributionExtent = extent !== undefined ? extent : gridExtent;
            this.setAttributions(function(frameState) {
                if ((0, $3412ad7bd362b04c$export$7b0a31e10bbff018)(attributionExtent, frameState.extent)) return [
                    tileJSON['attribution']
                ];
                return null;
            });
        }
        this.tileJSON_ = tileJSON;
        this.setState('ready');
    }
    /**
   * @protected
   */ handleTileJSONError() {
        this.setState('error');
    }
}
var $527758ca463865d7$export$2e2bcd8739ae039 = $527758ca463865d7$var$TileJSON;


/**
 * @module ol/source/Vector
 */ 








/**
 * @module ol/featureloader
 */ /**
 *
 * @type {boolean}
 * @private
 */ let $3e28f3fe74d4ef3e$var$withCredentials = false;
function $3e28f3fe74d4ef3e$export$441d7b57adab24d0(url, format, extent, resolution, projection, success, failure) {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', typeof url === 'function' ? url(extent, resolution, projection) : url, true);
    if (format.getType() == 'arraybuffer') xhr.responseType = 'arraybuffer';
    xhr.withCredentials = $3e28f3fe74d4ef3e$var$withCredentials;
    /**
   * @param {Event} event Event.
   * @private
   */ xhr.onload = function(event) {
        // status will be 0 for file:// urls
        if (!xhr.status || xhr.status >= 200 && xhr.status < 300) {
            const type = format.getType();
            try {
                /** @type {Document|Node|Object|string|undefined} */ let source;
                if (type == 'text' || type == 'json') source = xhr.responseText;
                else if (type == 'xml') source = xhr.responseXML || xhr.responseText;
                else if (type == 'arraybuffer') source = /** @type {ArrayBuffer} */ xhr.response;
                if (source) success(/** @type {Array<FeatureType>} */ format.readFeatures(source, {
                    extent: extent,
                    featureProjection: projection
                }), format.readProjection(source));
                else failure();
            } catch  {
                failure();
            }
        } else failure();
    };
    /**
   * @private
   */ xhr.onerror = failure;
    xhr.send();
}
function $3e28f3fe74d4ef3e$export$14cc81df70b6707e(url, format) {
    /**
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {import("./proj/Projection.js").default} projection Projection.
   * @param {function(Array<FeatureType>): void} [success] Success
   *      Function called when loading succeeded.
   * @param {function(): void} [failure] Failure
   *      Function called when loading failed.
   * @this {import("./source/Vector.js").default<FeatureType>}
   */ return function(extent, resolution, projection, success, failure) {
        $3e28f3fe74d4ef3e$export$441d7b57adab24d0(url, format, extent, resolution, projection, /**
       * @param {Array<FeatureType>} features The loaded features.
       * @param {import("./proj/Projection.js").default} dataProjection Data
       * projection.
       */ (features, dataProjection)=>{
            this.addFeatures(features);
            if (success !== undefined) success(features);
        }, ()=>{
            this.changed();
            if (failure !== undefined) failure();
        });
    };
}
function $3e28f3fe74d4ef3e$export$36fa6977a6d0d8fe(xhrWithCredentials) {
    $3e28f3fe74d4ef3e$var$withCredentials = xhrWithCredentials;
}






/**
 * @module ol/structs/RBush
 */ 



/**
 * @typedef {import("rbush").BBox & {value: T}} Entry
 * @template T
 */ /**
 * @classdesc
 * Wrapper around the RBush by Vladimir Agafonkin.
 * See https://github.com/mourner/rbush.
 *
 * @template {Object} T
 */ class $fe629b4b6d3815e8$var$RBush {
    /**
   * @param {number} [maxEntries] Max entries.
   */ constructor(maxEntries){
        /**
     * @private
     * @type {RBush_<Entry<T>>}
     */ this.rbush_ = new (0, (/*@__PURE__*/$parcel$interopDefault($d767c9267f21fd9e$exports)))(maxEntries);
        /**
     * A mapping between the objects added to this rbush wrapper
     * and the objects that are actually added to the internal rbush.
     * @private
     * @type {Object<string, Entry<T>>}
     */ this.items_ = {};
    }
    /**
   * Insert a value into the RBush.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {T} value Value.
   */ insert(extent, value) {
        /** @type {Entry<T>} */ const item = {
            minX: extent[0],
            minY: extent[1],
            maxX: extent[2],
            maxY: extent[3],
            value: value
        };
        this.rbush_.insert(item);
        this.items_[(0, $01f1986453243423$export$5e82334337e0f204)(value)] = item;
    }
    /**
   * Bulk-insert values into the RBush.
   * @param {Array<import("../extent.js").Extent>} extents Extents.
   * @param {Array<T>} values Values.
   */ load(extents, values) {
        const items = new Array(values.length);
        for(let i = 0, l = values.length; i < l; i++){
            const extent = extents[i];
            const value = values[i];
            /** @type {Entry<T>} */ const item = {
                minX: extent[0],
                minY: extent[1],
                maxX: extent[2],
                maxY: extent[3],
                value: value
            };
            items[i] = item;
            this.items_[(0, $01f1986453243423$export$5e82334337e0f204)(value)] = item;
        }
        this.rbush_.load(items);
    }
    /**
   * Remove a value from the RBush.
   * @param {T} value Value.
   * @return {boolean} Removed.
   */ remove(value) {
        const uid = (0, $01f1986453243423$export$5e82334337e0f204)(value);
        // get the object in which the value was wrapped when adding to the
        // internal rbush. then use that object to do the removal.
        const item = this.items_[uid];
        delete this.items_[uid];
        return this.rbush_.remove(item) !== null;
    }
    /**
   * Update the extent of a value in the RBush.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {T} value Value.
   */ update(extent, value) {
        const item = this.items_[(0, $01f1986453243423$export$5e82334337e0f204)(value)];
        const bbox = [
            item.minX,
            item.minY,
            item.maxX,
            item.maxY
        ];
        if (!(0, $3412ad7bd362b04c$export$e9bab7fafb253603)(bbox, extent)) {
            this.remove(value);
            this.insert(extent, value);
        }
    }
    /**
   * Return all values in the RBush.
   * @return {Array<T>} All.
   */ getAll() {
        const items = this.rbush_.all();
        return items.map(function(item) {
            return item.value;
        });
    }
    /**
   * Return all values in the given extent.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {Array<T>} All in extent.
   */ getInExtent(extent) {
        /** @type {import("rbush").BBox} */ const bbox = {
            minX: extent[0],
            minY: extent[1],
            maxX: extent[2],
            maxY: extent[3]
        };
        const items = this.rbush_.search(bbox);
        return items.map(function(item) {
            return item.value;
        });
    }
    /**
   * Calls a callback function with each value in the tree.
   * If the callback returns a truthy value, this value is returned without
   * checking the rest of the tree.
   * @param {function(T): R} callback Callback.
   * @return {R|undefined} Callback return value.
   * @template R
   */ forEach(callback) {
        return this.forEach_(this.getAll(), callback);
    }
    /**
   * Calls a callback function with each value in the provided extent.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(T): R} callback Callback.
   * @return {R|undefined} Callback return value.
   * @template R
   */ forEachInExtent(extent, callback) {
        return this.forEach_(this.getInExtent(extent), callback);
    }
    /**
   * @param {Array<T>} values Values.
   * @param {function(T): R} callback Callback.
   * @return {R|undefined} Callback return value.
   * @template R
   * @private
   */ forEach_(values, callback) {
        let result;
        for(let i = 0, l = values.length; i < l; i++){
            result = callback(values[i]);
            if (result) return result;
        }
        return result;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return (0, $0669c62275461b52$export$dd1bc94b04021eeb)(this.items_);
    }
    /**
   * Remove all values from the RBush.
   */ clear() {
        this.rbush_.clear();
        this.items_ = {};
    }
    /**
   * @param {import("../extent.js").Extent} [extent] Extent.
   * @return {import("../extent.js").Extent} Extent.
   */ getExtent(extent) {
        const data = this.rbush_.toJSON();
        return (0, $3412ad7bd362b04c$export$958e3e1a02eac4b6)(data.minX, data.minY, data.maxX, data.maxY, extent);
    }
    /**
   * @param {RBush<T>} rbush R-Tree.
   */ concat(rbush) {
        this.rbush_.load(rbush.rbush_.all());
        for(const i in rbush.items_)this.items_[i] = rbush.items_[i];
    }
}
var $fe629b4b6d3815e8$export$2e2bcd8739ae039 = $fe629b4b6d3815e8$var$RBush;




/**
 * @module ol/source/VectorEventType
 */ /**
 * @enum {string}
 */ var $25ecff61a5783dd9$export$2e2bcd8739ae039 /**
 * @typedef {'addfeature'|'changefeature'|'clear'|'removefeature'|'featuresloadstart'|'featuresloadend'|'featuresloaderror'} VectorSourceEventTypes
 */  = {
    /**
   * Triggered when a feature is added to the source.
   * @event module:ol/source/Vector.VectorSourceEvent#addfeature
   * @api
   */ ADDFEATURE: 'addfeature',
    /**
   * Triggered when a feature is updated.
   * @event module:ol/source/Vector.VectorSourceEvent#changefeature
   * @api
   */ CHANGEFEATURE: 'changefeature',
    /**
   * Triggered when the clear method is called on the source.
   * @event module:ol/source/Vector.VectorSourceEvent#clear
   * @api
   */ CLEAR: 'clear',
    /**
   * Triggered when a feature is removed from the source.
   * See {@link module:ol/source/Vector~VectorSource#clear source.clear()} for exceptions.
   * @event module:ol/source/Vector.VectorSourceEvent#removefeature
   * @api
   */ REMOVEFEATURE: 'removefeature',
    /**
   * Triggered when features starts loading.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloadstart
   * @api
   */ FEATURESLOADSTART: 'featuresloadstart',
    /**
   * Triggered when features finishes loading.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloadend
   * @api
   */ FEATURESLOADEND: 'featuresloadend',
    /**
   * Triggered if feature loading results in an error.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloaderror
   * @api
   */ FEATURESLOADERROR: 'featuresloaderror'
};


class $747f9d9b478d4c9f$export$d402fd02dc2b661c extends (0, $bc90848f8b15fa29$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Type.
   * @param {FeatureType} [feature] Feature.
   * @param {Array<FeatureType>} [features] Features.
   */ constructor(type, feature, features){
        super(type);
        /**
     * The added or removed feature for the `ADDFEATURE` and `REMOVEFEATURE` events, `undefined` otherwise.
     * @type {FeatureType|undefined}
     * @api
     */ this.feature = feature;
        /**
     * The loaded features for the `FEATURESLOADED` event, `undefined` otherwise.
     * @type {Array<FeatureType>|undefined}
     * @api
     */ this.features = features;
    }
}
/***
 * @template {import("../Feature.js").FeatureLike} [T=import("../Feature.js").default]
 * @typedef {T extends RenderFeature ? T|Array<T> : T} FeatureClassOrArrayOfRenderFeatures
 */ /***
 * @template Return
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 * @typedef {import("../Observable.js").OnSignature<import("../Observable.js").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable.js").OnSignature<import("../ObjectEventType.js").Types, import("../Object.js").ObjectEvent, Return> &
 *   import("../Observable.js").OnSignature<import("./VectorEventType.js").VectorSourceEventTypes, VectorSourceEvent<FeatureType>, Return> &
 *   import("../Observable.js").CombinedOnSignature<import("../Observable.js").EventTypes|import("../ObjectEventType.js").Types|
 *     import("./VectorEventType.js").VectorSourceEventTypes, Return>} VectorSourceOnSignature
 */ /**
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {Array<FeatureType>|Collection<FeatureType>} [features]
 * Features. If provided as {@link module:ol/Collection~Collection}, the features in the source
 * and the collection will stay in sync.
 * @property {import("../format/Feature.js").default<FeatureType>} [format] The feature format used by the XHR
 * feature loader when `url` is set. Required if `url` is set, otherwise ignored.
 * @property {import("../featureloader.js").FeatureLoader<FeatureType>} [loader]
 * The loader function used to load features, from a remote source for example.
 * If this is not set and `url` is set, the source will create and use an XHR
 * feature loader. The `'featuresloadend'` and `'featuresloaderror'` events
 * will only fire if the `success` and `failure` callbacks are used.
 *
 * Example:
 *
 * ```js
 * import Vector from 'ol/source/Vector.js';
 * import GeoJSON from 'ol/format/GeoJSON.js';
 * import {bbox} from 'ol/loadingstrategy.js';
 *
 * const vectorSource = new Vector({
 *   loader: async (extent, resolution, projection) => {
 *      const url = 'https://ahocevar.com/geoserver/wfs?service=WFS&' +
 *          'version=1.1.0&request=GetFeature&typename=osm:water_areas&' +
 *          'outputFormat=application/json' +
 *          'bbox=' + extent.join(',') + ',' + projection.getCode();
 *      const response = await fetch(url);
 *      if (!response.ok) {
 *        throw new Error('Network response was not ok');
 *      }
 *      const json = await response.json();
 *      const features = new GeoJSON().readFeatures(json, {
 *        featureProjection: projection,
 *      });
 *      return features;
 *    },
 *    strategy: bbox,
 *  });
 * ```
 *
 * When you want to retry a failed request, use
 * ```js
 * vectorSource.removeLoadedExtent(extent);
 * vectorSource.changed();
 * ```
 *
 * @property {boolean} [overlaps=true] This source may have overlapping geometries.
 * Setting this to `false` (e.g. for sources with polygons that represent administrative
 * boundaries or TopoJSON sources) allows the renderer to optimise fill and
 * stroke operations.
 * @property {LoadingStrategy} [strategy] The loading strategy to use.
 * By default an {@link module:ol/loadingstrategy.all}
 * strategy is used, a one-off strategy which loads all features at once.
 * @property {string|import("../featureloader.js").FeatureUrlFunction} [url]
 * Setting this option instructs the source to load features using an XHR loader
 * (see {@link module:ol/featureloader.xhr}). Use a `string` and an
 * {@link module:ol/loadingstrategy.all} for a one-off download of all features from
 * the given URL. Use a {@link module:ol/featureloader~FeatureUrlFunction} to generate the url with
 * other loading strategies.
 * Requires `format` to be set as well.
 * When default XHR feature loader is provided, the features will
 * be transformed from the data projection to the view projection
 * during parsing. If your remote data source does not advertise its projection
 * properly, this transformation will be incorrect. For some formats, the
 * default projection (usually EPSG:4326) can be overridden by setting the
 * dataProjection constructor option on the format.
 * Note that if a source contains non-feature data, such as a GeoJSON geometry
 * or a KML NetworkLink, these will be ignored. Use a custom loader to load these.
 * @property {boolean} [useSpatialIndex=true]
 * By default, an RTree is used as spatial index. When features are removed and
 * added frequently, and the total number of features is low, setting this to
 * `false` may improve performance.
 *
 * Note that
 * {@link module:ol/source/Vector~VectorSource#getFeaturesInExtent},
 * {@link module:ol/source/Vector~VectorSource#getClosestFeatureToCoordinate} and
 * {@link module:ol/source/Vector~VectorSource#getExtent} cannot be used when `useSpatialIndex` is
 * set to `false`, and {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent} will loop
 * through all features.
 *
 * When set to `false`, the features will be maintained in an
 * {@link module:ol/Collection~Collection}, which can be retrieved through
 * {@link module:ol/source/Vector~VectorSource#getFeaturesCollection}.
 * @property {boolean} [wrapX=true] Wrap the world horizontally. For vector editing across the
 * -180° and 180° meridians to work properly, this should be set to `false`. The
 * resulting geometry coordinates will then exceed the world bounds.
 */ /**
 * @classdesc
 * Provides a source of features for vector layers. Vector features provided
 * by this source are suitable for editing. See {@link module:ol/source/VectorTile~VectorTile} for
 * vector data that is optimized for rendering.
 *
 * @fires VectorSourceEvent
 * @api
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 */ class $747f9d9b478d4c9f$var$VectorSource extends (0, $039754a80ce105f8$export$2e2bcd8739ae039) {
    /**
   * @param {Options<FeatureType>} [options] Vector source options.
   */ constructor(options){
        options = options || {};
        super({
            attributions: options.attributions,
            interpolate: true,
            projection: undefined,
            state: 'ready',
            wrapX: options.wrapX !== undefined ? options.wrapX : true
        });
        /***
     * @type {VectorSourceOnSignature<import("../events.js").EventsKey, FeatureType>}
     */ this.on;
        /***
     * @type {VectorSourceOnSignature<import("../events.js").EventsKey, FeatureType>}
     */ this.once;
        /***
     * @type {VectorSourceOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {import("../featureloader.js").FeatureLoader<import("../Feature.js").FeatureLike>}
     */ this.loader_ = (0, $7efea016d660e267$export$1cd1943b3a73bbe8);
        /**
     * @private
     * @type {import("../format/Feature.js").default<FeatureType>|null}
     */ this.format_ = options.format || null;
        /**
     * @private
     * @type {boolean}
     */ this.overlaps_ = options.overlaps === undefined ? true : options.overlaps;
        /**
     * @private
     * @type {string|import("../featureloader.js").FeatureUrlFunction|undefined}
     */ this.url_ = options.url;
        if (options.loader !== undefined) this.loader_ = options.loader;
        else if (this.url_ !== undefined) {
            (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(this.format_, '`format` must be set when `url` is set');
            // create a XHR feature loader for "url" and "format"
            this.loader_ = (0, $3e28f3fe74d4ef3e$export$14cc81df70b6707e)(this.url_, this.format_);
        }
        /**
     * @private
     * @type {LoadingStrategy}
     */ this.strategy_ = options.strategy !== undefined ? options.strategy : (0, $70d62d5d3836dc81$export$84bf76cd7afc7469);
        const useSpatialIndex = options.useSpatialIndex !== undefined ? options.useSpatialIndex : true;
        /**
     * @private
     * @type {RBush<FeatureType>}
     */ this.featuresRtree_ = useSpatialIndex ? new (0, $fe629b4b6d3815e8$export$2e2bcd8739ae039)() : null;
        /**
     * @private
     * @type {RBush<{extent: import("../extent.js").Extent}>}
     */ this.loadedExtentsRtree_ = new (0, $fe629b4b6d3815e8$export$2e2bcd8739ae039)();
        /**
     * @private
     * @type {!Object<string, FeatureType>}
     */ this.nullGeometryFeatures_ = {};
        /**
     * A lookup of features by id (the return from feature.getId()).
     * @private
     * @type {!Object<string, import('../Feature.js').FeatureLike|Array<import('../Feature.js').FeatureLike>>}
     */ this.idIndex_ = {};
        /**
     * A lookup of features by uid (using getUid(feature)).
     * @private
     * @type {!Object<string, FeatureType>}
     */ this.uidIndex_ = {};
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").EventsKey>>}
     */ this.featureChangeKeys_ = {};
        /**
     * @private
     * @type {Collection<FeatureType>|null}
     */ this.featuresCollection_ = null;
        /** @type {Collection<FeatureType>} */ let collection;
        /** @type {Array<FeatureType>} */ let features;
        if (Array.isArray(options.features)) features = options.features;
        else if (options.features) {
            collection = options.features;
            features = collection.getArray();
        }
        if (!useSpatialIndex && collection === undefined) collection = new (0, $c6078a5bf4414204$export$2e2bcd8739ae039)(features);
        if (features !== undefined) this.addFeaturesInternal(features);
        if (collection !== undefined) this.bindFeaturesCollection_(collection);
    }
    /**
   * Add a single feature to the source.  If you want to add a batch of features
   * at once, call {@link module:ol/source/Vector~VectorSource#addFeatures #addFeatures()}
   * instead. A feature will not be added to the source if feature with
   * the same id is already there. The reason for this behavior is to avoid
   * feature duplication when using bbox or tile loading strategies.
   * Note: this also applies if a {@link module:ol/Collection~Collection} is used for features,
   * meaning that if a feature with a duplicate id is added in the collection, it will
   * be removed from it right away.
   * @param {FeatureType} feature Feature to add.
   * @api
   */ addFeature(feature) {
        this.addFeatureInternal(feature);
        this.changed();
    }
    /**
   * Add a feature without firing a `change` event.
   * @param {FeatureType} feature Feature.
   * @protected
   */ addFeatureInternal(feature) {
        const featureKey = (0, $01f1986453243423$export$5e82334337e0f204)(feature);
        if (!this.addToIndex_(featureKey, feature)) {
            if (this.featuresCollection_) this.featuresCollection_.remove(feature);
            return;
        }
        this.setupChangeEvents_(featureKey, feature);
        const geometry = feature.getGeometry();
        if (geometry) {
            const extent = geometry.getExtent();
            if (this.featuresRtree_) this.featuresRtree_.insert(extent, feature);
        } else this.nullGeometryFeatures_[featureKey] = feature;
        this.dispatchEvent(new $747f9d9b478d4c9f$export$d402fd02dc2b661c((0, $25ecff61a5783dd9$export$2e2bcd8739ae039).ADDFEATURE, feature));
    }
    /**
   * @param {string} featureKey Unique identifier for the feature.
   * @param {FeatureType} feature The feature.
   * @private
   */ setupChangeEvents_(featureKey, feature) {
        if (feature instanceof (0, $edf3df43d76225f4$export$2e2bcd8739ae039)) return;
        this.featureChangeKeys_[featureKey] = [
            (0, $8061a5de9380012b$export$63174c828edd6ff8)(feature, (0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CHANGE, this.handleFeatureChange_, this),
            (0, $8061a5de9380012b$export$63174c828edd6ff8)(feature, (0, $026be6c727dde691$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleFeatureChange_, this)
        ];
    }
    /**
   * @param {string} featureKey Unique identifier for the feature.
   * @param {FeatureType} feature The feature.
   * @return {boolean} The feature is "valid", in the sense that it is also a
   *     candidate for insertion into the Rtree.
   * @private
   */ addToIndex_(featureKey, feature) {
        let valid = true;
        if (feature.getId() !== undefined) {
            const id = String(feature.getId());
            if (!(id in this.idIndex_)) this.idIndex_[id] = feature;
            else if (feature instanceof (0, $edf3df43d76225f4$export$2e2bcd8739ae039)) {
                const indexedFeature = this.idIndex_[id];
                if (!(indexedFeature instanceof (0, $edf3df43d76225f4$export$2e2bcd8739ae039))) valid = false;
                else if (!Array.isArray(indexedFeature)) this.idIndex_[id] = [
                    indexedFeature,
                    feature
                ];
                else indexedFeature.push(feature);
            } else valid = false;
        }
        if (valid) {
            (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(!(featureKey in this.uidIndex_), 'The passed `feature` was already added to the source');
            this.uidIndex_[featureKey] = feature;
        }
        return valid;
    }
    /**
   * Add a batch of features to the source.
   * @param {Array<FeatureType>} features Features to add.
   * @api
   */ addFeatures(features) {
        this.addFeaturesInternal(features);
        this.changed();
    }
    /**
   * Add features without firing a `change` event.
   * @param {Array<FeatureType>} features Features.
   * @protected
   */ addFeaturesInternal(features) {
        const extents = [];
        /** @type {Array<FeatureType>} */ const newFeatures = [];
        /** @type {Array<FeatureType>} */ const geometryFeatures = [];
        for(let i = 0, length = features.length; i < length; i++){
            const feature = features[i];
            const featureKey = (0, $01f1986453243423$export$5e82334337e0f204)(feature);
            if (this.addToIndex_(featureKey, feature)) newFeatures.push(feature);
        }
        for(let i = 0, length = newFeatures.length; i < length; i++){
            const feature = newFeatures[i];
            const featureKey = (0, $01f1986453243423$export$5e82334337e0f204)(feature);
            this.setupChangeEvents_(featureKey, feature);
            const geometry = feature.getGeometry();
            if (geometry) {
                const extent = geometry.getExtent();
                extents.push(extent);
                geometryFeatures.push(feature);
            } else this.nullGeometryFeatures_[featureKey] = feature;
        }
        if (this.featuresRtree_) this.featuresRtree_.load(extents, geometryFeatures);
        if (this.hasListener((0, $25ecff61a5783dd9$export$2e2bcd8739ae039).ADDFEATURE)) for(let i = 0, length = newFeatures.length; i < length; i++)this.dispatchEvent(new $747f9d9b478d4c9f$export$d402fd02dc2b661c((0, $25ecff61a5783dd9$export$2e2bcd8739ae039).ADDFEATURE, newFeatures[i]));
    }
    /**
   * @param {!Collection<FeatureType>} collection Collection.
   * @private
   */ bindFeaturesCollection_(collection) {
        let modifyingCollection = false;
        this.addEventListener((0, $25ecff61a5783dd9$export$2e2bcd8739ae039).ADDFEATURE, /**
       * @param {VectorSourceEvent<FeatureType>} evt The vector source event
       */ function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                collection.push(evt.feature);
                modifyingCollection = false;
            }
        });
        this.addEventListener((0, $25ecff61a5783dd9$export$2e2bcd8739ae039).REMOVEFEATURE, /**
       * @param {VectorSourceEvent<FeatureType>} evt The vector source event
       */ function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                collection.remove(evt.feature);
                modifyingCollection = false;
            }
        });
        collection.addEventListener((0, $d4ae00bf358e4687$export$2e2bcd8739ae039).ADD, /**
       * @param {import("../Collection.js").CollectionEvent<FeatureType>} evt The collection event
       */ (evt)=>{
            if (!modifyingCollection) {
                modifyingCollection = true;
                this.addFeature(evt.element);
                modifyingCollection = false;
            }
        });
        collection.addEventListener((0, $d4ae00bf358e4687$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("../Collection.js").CollectionEvent<FeatureType>} evt The collection event
       */ (evt)=>{
            if (!modifyingCollection) {
                modifyingCollection = true;
                this.removeFeature(evt.element);
                modifyingCollection = false;
            }
        });
        this.featuresCollection_ = collection;
    }
    /**
   * Remove all features from the source.
   * @param {boolean} [fast] Skip dispatching of {@link module:ol/source/Vector.VectorSourceEvent#event:removefeature} events.
   * @api
   */ clear(fast) {
        if (fast) {
            for(const featureId in this.featureChangeKeys_){
                const keys = this.featureChangeKeys_[featureId];
                keys.forEach((0, $8061a5de9380012b$export$b0a21c8b3c1c921));
            }
            if (!this.featuresCollection_) {
                this.featureChangeKeys_ = {};
                this.idIndex_ = {};
                this.uidIndex_ = {};
            }
        } else if (this.featuresRtree_) {
            this.featuresRtree_.forEach((feature)=>{
                this.removeFeatureInternal(feature);
            });
            for(const id in this.nullGeometryFeatures_)this.removeFeatureInternal(this.nullGeometryFeatures_[id]);
        }
        if (this.featuresCollection_) this.featuresCollection_.clear();
        if (this.featuresRtree_) this.featuresRtree_.clear();
        this.nullGeometryFeatures_ = {};
        const clearEvent = new $747f9d9b478d4c9f$export$d402fd02dc2b661c((0, $25ecff61a5783dd9$export$2e2bcd8739ae039).CLEAR);
        this.dispatchEvent(clearEvent);
        this.changed();
    }
    /**
   * Iterate through all features on the source, calling the provided callback
   * with each one.  If the callback returns any "truthy" value, iteration will
   * stop and the function will return the same value.
   * Note: this function only iterate through the feature that have a defined geometry.
   *
   * @param {function(FeatureType): T} callback Called with each feature
   *     on the source.  Return a truthy value to stop iteration.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeature(callback) {
        if (this.featuresRtree_) return this.featuresRtree_.forEach(callback);
        if (this.featuresCollection_) this.featuresCollection_.forEach(callback);
    }
    /**
   * Iterate through all features whose geometries contain the provided
   * coordinate, calling the callback with each feature.  If the callback returns
   * a "truthy" value, iteration will stop and the function will return the same
   * value.
   *
   * For {@link module:ol/render/Feature~RenderFeature} features, the callback will be
   * called for all features.
   *
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose goemetry contains the provided coordinate.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   */ forEachFeatureAtCoordinateDirect(coordinate, callback) {
        const extent = [
            coordinate[0],
            coordinate[1],
            coordinate[0],
            coordinate[1]
        ];
        return this.forEachFeatureInExtent(extent, function(feature) {
            const geometry = feature.getGeometry();
            if (geometry instanceof (0, $edf3df43d76225f4$export$2e2bcd8739ae039) || geometry.intersectsCoordinate(coordinate)) return callback(feature);
            return undefined;
        });
    }
    /**
   * Iterate through all features whose bounding box intersects the provided
   * extent (note that the feature's geometry may not intersect the extent),
   * calling the callback with each feature.  If the callback returns a "truthy"
   * value, iteration will stop and the function will return the same value.
   *
   * If you are interested in features whose geometry intersects an extent, call
   * the {@link module:ol/source/Vector~VectorSource#forEachFeatureIntersectingExtent #forEachFeatureIntersectingExtent()} method instead.
   *
   * When `useSpatialIndex` is set to false, this method will loop through all
   * features, equivalent to {@link module:ol/source/Vector~VectorSource#forEachFeature #forEachFeature()}.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose bounding box intersects the provided extent.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeatureInExtent(extent, callback) {
        if (this.featuresRtree_) return this.featuresRtree_.forEachInExtent(extent, callback);
        if (this.featuresCollection_) this.featuresCollection_.forEach(callback);
    }
    /**
   * Iterate through all features whose geometry intersects the provided extent,
   * calling the callback with each feature.  If the callback returns a "truthy"
   * value, iteration will stop and the function will return the same value.
   *
   * If you only want to test for bounding box intersection, call the
   * {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent #forEachFeatureInExtent()} method instead.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose geometry intersects the provided extent.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeatureIntersectingExtent(extent, callback) {
        return this.forEachFeatureInExtent(extent, /**
       * @param {FeatureType} feature Feature.
       * @return {T|undefined} The return value from the last call to the callback.
       */ function(feature) {
            const geometry = feature.getGeometry();
            if (geometry instanceof (0, $edf3df43d76225f4$export$2e2bcd8739ae039) || geometry.intersectsExtent(extent)) {
                const result = callback(feature);
                if (result) return result;
            }
        });
    }
    /**
   * Get the features collection associated with this source. Will be `null`
   * unless the source was configured with `useSpatialIndex` set to `false`, or
   * with a {@link module:ol/Collection~Collection} as `features`.
   * @return {Collection<FeatureType>|null} The collection of features.
   * @api
   */ getFeaturesCollection() {
        return this.featuresCollection_;
    }
    /**
   * Get a snapshot of the features currently on the source in random order. The returned array
   * is a copy, the features are references to the features in the source.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeatures() {
        let features;
        if (this.featuresCollection_) features = this.featuresCollection_.getArray().slice(0);
        else if (this.featuresRtree_) {
            features = this.featuresRtree_.getAll();
            if (!(0, $0669c62275461b52$export$dd1bc94b04021eeb)(this.nullGeometryFeatures_)) (0, $db525acb5f2517fc$export$8b58be045bf06082)(features, Object.values(this.nullGeometryFeatures_));
        }
        return features;
    }
    /**
   * Get all features whose geometry intersects the provided coordinate.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeaturesAtCoordinate(coordinate) {
        /** @type {Array<FeatureType>} */ const features = [];
        this.forEachFeatureAtCoordinateDirect(coordinate, function(feature) {
            features.push(feature);
        });
        return features;
    }
    /**
   * Get all features whose bounding box intersects the provided extent.  Note that this returns an array of
   * all features intersecting the given extent in random order (so it may include
   * features whose geometries do not intersect the extent).
   *
   * When `useSpatialIndex` is set to false, this method will return all
   * features.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {import("../proj/Projection.js").default} [projection] Include features
   * where `extent` exceeds the x-axis bounds of `projection` and wraps around the world.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeaturesInExtent(extent, projection) {
        if (this.featuresRtree_) {
            const multiWorld = projection && projection.canWrapX() && this.getWrapX();
            if (!multiWorld) return this.featuresRtree_.getInExtent(extent);
            const extents = (0, $3412ad7bd362b04c$export$9031237f01de0947)(extent, projection);
            return [].concat(...extents.map((anExtent)=>this.featuresRtree_.getInExtent(anExtent)));
        }
        if (this.featuresCollection_) return this.featuresCollection_.getArray().slice(0);
        return [];
    }
    /**
   * Get the closest feature to the provided coordinate.
   *
   * This method is not available when the source is configured with
   * `useSpatialIndex` set to `false` and the features in this source are of type
   * {@link module:ol/Feature~Feature}.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {function(FeatureType):boolean} [filter] Feature filter function.
   *     The filter function will receive one argument, the {@link module:ol/Feature~Feature feature}
   *     and it should return a boolean value. By default, no filtering is made.
   * @return {FeatureType|null} Closest feature (or `null` if none found).
   * @api
   */ getClosestFeatureToCoordinate(coordinate, filter) {
        // Find the closest feature using branch and bound.  We start searching an
        // infinite extent, and find the distance from the first feature found.  This
        // becomes the closest feature.  We then compute a smaller extent which any
        // closer feature must intersect.  We continue searching with this smaller
        // extent, trying to find a closer feature.  Every time we find a closer
        // feature, we update the extent being searched so that any even closer
        // feature must intersect it.  We continue until we run out of features.
        const x = coordinate[0];
        const y = coordinate[1];
        let closestFeature = null;
        const closestPoint = [
            NaN,
            NaN
        ];
        let minSquaredDistance = Infinity;
        const extent = [
            -Infinity,
            -Infinity,
            Infinity,
            Infinity
        ];
        filter = filter ? filter : (0, $7efea016d660e267$export$22e23a2304399231);
        this.featuresRtree_.forEachInExtent(extent, /**
       * @param {FeatureType} feature Feature.
       */ function(feature) {
            if (filter(feature)) {
                const geometry = feature.getGeometry();
                const previousMinSquaredDistance = minSquaredDistance;
                minSquaredDistance = geometry instanceof (0, $edf3df43d76225f4$export$2e2bcd8739ae039) ? 0 : geometry.closestPointXY(x, y, closestPoint, minSquaredDistance);
                if (minSquaredDistance < previousMinSquaredDistance) {
                    closestFeature = feature;
                    // This is sneaky.  Reduce the extent that it is currently being
                    // searched while the R-Tree traversal using this same extent object
                    // is still in progress.  This is safe because the new extent is
                    // strictly contained by the old extent.
                    const minDistance = Math.sqrt(minSquaredDistance);
                    extent[0] = x - minDistance;
                    extent[1] = y - minDistance;
                    extent[2] = x + minDistance;
                    extent[3] = y + minDistance;
                }
            }
        });
        return closestFeature;
    }
    /**
   * Get the extent of the features currently in the source.
   *
   * This will return `null` when the source is configured with
   * `useSpatialIndex` set to `false`.
   * @param {import("../extent.js").Extent} [extent] Destination extent. If provided, no new extent
   *     will be created. Instead, that extent's coordinates will be overwritten.
   * @return {import("../extent.js").Extent | null} Extent.
   * @api
   */ getExtent(extent) {
        return this.featuresRtree_?.getExtent(extent) ?? null;
    }
    /**
   * Get a feature by its identifier (the value returned by feature.getId()). When `RenderFeature`s
   * are used, `getFeatureById()` can return an array of `RenderFeature`s. This allows for handling
   * of `GeometryCollection` geometries, where format readers create one `RenderFeature` per
   * `GeometryCollection` member.
   * Note that the index treats string and numeric identifiers as the same.  So
   * `source.getFeatureById(2)` will return a feature with id `'2'` or `2`.
   *
   * @param {string|number} id Feature identifier.
   * @return {FeatureClassOrArrayOfRenderFeatures<FeatureType>|null} The feature (or `null` if not found).
   * @api
   */ getFeatureById(id) {
        const feature = this.idIndex_[id.toString()];
        return feature !== undefined ? /** @type {FeatureClassOrArrayOfRenderFeatures<FeatureType>} */ feature : null;
    }
    /**
   * Get a feature by its internal unique identifier (using `getUid`).
   *
   * @param {string} uid Feature identifier.
   * @return {FeatureType|null} The feature (or `null` if not found).
   */ getFeatureByUid(uid) {
        const feature = this.uidIndex_[uid];
        return feature !== undefined ? feature : null;
    }
    /**
   * Get the format associated with this source.
   *
   * @return {import("../format/Feature.js").default<FeatureType>|null}} The feature format.
   * @api
   */ getFormat() {
        return this.format_;
    }
    /**
   * @return {boolean} The source can have overlapping geometries.
   */ getOverlaps() {
        return this.overlaps_;
    }
    /**
   * Get the url associated with this source.
   *
   * @return {string|import("../featureloader.js").FeatureUrlFunction|undefined} The url.
   * @api
   */ getUrl() {
        return this.url_;
    }
    /**
   * @param {Event} event Event.
   * @private
   */ handleFeatureChange_(event) {
        const feature = /** @type {FeatureType} */ event.target;
        const featureKey = (0, $01f1986453243423$export$5e82334337e0f204)(feature);
        const geometry = feature.getGeometry();
        if (!geometry) {
            if (!(featureKey in this.nullGeometryFeatures_)) {
                if (this.featuresRtree_) this.featuresRtree_.remove(feature);
                this.nullGeometryFeatures_[featureKey] = feature;
            }
        } else {
            const extent = geometry.getExtent();
            if (featureKey in this.nullGeometryFeatures_) {
                delete this.nullGeometryFeatures_[featureKey];
                if (this.featuresRtree_) this.featuresRtree_.insert(extent, feature);
            } else if (this.featuresRtree_) this.featuresRtree_.update(extent, feature);
        }
        const id = feature.getId();
        if (id !== undefined) {
            const sid = id.toString();
            if (this.idIndex_[sid] !== feature) {
                this.removeFromIdIndex_(feature);
                this.idIndex_[sid] = feature;
            }
        } else {
            this.removeFromIdIndex_(feature);
            this.uidIndex_[featureKey] = feature;
        }
        this.changed();
        this.dispatchEvent(new $747f9d9b478d4c9f$export$d402fd02dc2b661c((0, $25ecff61a5783dd9$export$2e2bcd8739ae039).CHANGEFEATURE, feature));
    }
    /**
   * Returns true if the feature is contained within the source.
   * @param {FeatureType} feature Feature.
   * @return {boolean} Has feature.
   * @api
   */ hasFeature(feature) {
        const id = feature.getId();
        if (id !== undefined) return id in this.idIndex_;
        return (0, $01f1986453243423$export$5e82334337e0f204)(feature) in this.uidIndex_;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        if (this.featuresRtree_) return this.featuresRtree_.isEmpty() && (0, $0669c62275461b52$export$dd1bc94b04021eeb)(this.nullGeometryFeatures_);
        if (this.featuresCollection_) return this.featuresCollection_.getLength() === 0;
        return true;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {import("../proj/Projection.js").default} projection Projection.
   */ loadFeatures(extent, resolution, projection) {
        const loadedExtentsRtree = this.loadedExtentsRtree_;
        const extentsToLoad = this.strategy_(extent, resolution, projection);
        for(let i = 0, ii = extentsToLoad.length; i < ii; ++i){
            const extentToLoad = extentsToLoad[i];
            const alreadyLoaded = loadedExtentsRtree.forEachInExtent(extentToLoad, /**
         * @param {{extent: import("../extent.js").Extent}} object Object.
         * @return {boolean} Contains.
         */ function(object) {
                return (0, $3412ad7bd362b04c$export$be866b1e0809b17e)(object.extent, extentToLoad);
            });
            if (!alreadyLoaded) {
                this.loading = Number(this.loading) + 1;
                this.dispatchEvent(new $747f9d9b478d4c9f$export$d402fd02dc2b661c((0, $25ecff61a5783dd9$export$2e2bcd8739ae039).FEATURESLOADSTART));
                /**
         * @param {Array<FeatureType>} features Loaded features
         */ const success = (features)=>{
                    this.loading = Number(this.loading) - 1;
                    this.dispatchEvent(new $747f9d9b478d4c9f$export$d402fd02dc2b661c((0, $25ecff61a5783dd9$export$2e2bcd8739ae039).FEATURESLOADEND, undefined, features));
                };
                const failure = ()=>{
                    this.changed();
                    this.loading = Number(this.loading) - 1;
                    this.dispatchEvent(new $747f9d9b478d4c9f$export$d402fd02dc2b661c((0, $25ecff61a5783dd9$export$2e2bcd8739ae039).FEATURESLOADERROR));
                };
                //TODO Remove this when the deprecatedsuccess and failure arguments are removed
                let disableCallbacks = false;
                const loaded = this.loader_.call(this, extentToLoad, resolution, projection, (features)=>disableCallbacks || success(features), ()=>disableCallbacks || failure());
                if (loaded instanceof Promise) {
                    //TODO Remove this when the deprecatedsuccess and failure arguments are removed
                    disableCallbacks = true;
                    loaded.then((features)=>{
                        this.addFeatures(features);
                        success(features);
                    }).catch(failure);
                } else if (this.loader_.length < 4) this.loading = false;
                loadedExtentsRtree.insert(extentToLoad, {
                    extent: extentToLoad.slice()
                });
            }
        }
    }
    /**
   * @override
   */ refresh() {
        this.clear(true);
        this.loadedExtentsRtree_.clear();
        super.refresh();
    }
    /**
   * Remove an extent from the list of loaded extents.
   * @param {import("../extent.js").Extent} extent Extent.
   * @api
   */ removeLoadedExtent(extent) {
        const loadedExtentsRtree = this.loadedExtentsRtree_;
        const obj = loadedExtentsRtree.forEachInExtent(extent, function(object) {
            if ((0, $3412ad7bd362b04c$export$e9bab7fafb253603)(object.extent, extent)) return object;
        });
        if (obj) loadedExtentsRtree.remove(obj);
    }
    /**
   * Batch remove features from the source.  If you want to remove all features
   * at once, use the {@link module:ol/source/Vector~VectorSource#clear #clear()} method
   * instead.
   * @param {Array<FeatureType>} features Features to remove.
   * @api
   */ removeFeatures(features) {
        let removed = false;
        for(let i = 0, ii = features.length; i < ii; ++i)removed = this.removeFeatureInternal(features[i]) || removed;
        if (removed) this.changed();
    }
    /**
   * Remove a single feature from the source. If you want to batch remove
   * features, use the {@link module:ol/source/Vector~VectorSource#removeFeatures #removeFeatures()} method
   * instead.
   * @param {FeatureType} feature Feature to remove.
   * @api
   */ removeFeature(feature) {
        if (!feature) return;
        const removed = this.removeFeatureInternal(feature);
        if (removed) this.changed();
    }
    /**
   * Remove feature without firing a `change` event.
   * @param {FeatureType} feature Feature.
   * @return {boolean} True if the feature was removed, false if it was not found.
   * @protected
   */ removeFeatureInternal(feature) {
        const featureKey = (0, $01f1986453243423$export$5e82334337e0f204)(feature);
        if (!(featureKey in this.uidIndex_)) return false;
        if (featureKey in this.nullGeometryFeatures_) delete this.nullGeometryFeatures_[featureKey];
        else if (this.featuresRtree_) this.featuresRtree_.remove(feature);
        const featureChangeKeys = this.featureChangeKeys_[featureKey];
        featureChangeKeys?.forEach((0, $8061a5de9380012b$export$b0a21c8b3c1c921));
        delete this.featureChangeKeys_[featureKey];
        const id = feature.getId();
        if (id !== undefined) {
            const idString = id.toString();
            const indexedFeature = this.idIndex_[idString];
            if (indexedFeature === feature) delete this.idIndex_[idString];
            else if (Array.isArray(indexedFeature)) {
                indexedFeature.splice(indexedFeature.indexOf(feature), 1);
                if (indexedFeature.length === 1) this.idIndex_[idString] = indexedFeature[0];
            }
        }
        delete this.uidIndex_[featureKey];
        if (this.hasListener((0, $25ecff61a5783dd9$export$2e2bcd8739ae039).REMOVEFEATURE)) this.dispatchEvent(new $747f9d9b478d4c9f$export$d402fd02dc2b661c((0, $25ecff61a5783dd9$export$2e2bcd8739ae039).REMOVEFEATURE, feature));
        return true;
    }
    /**
   * Remove a feature from the id index.  Called internally when the feature id
   * may have changed.
   * @param {FeatureType} feature The feature.
   * @private
   */ removeFromIdIndex_(feature) {
        for(const id in this.idIndex_)if (this.idIndex_[id] === feature) {
            delete this.idIndex_[id];
            break;
        }
    }
    /**
   * Set the new loader of the source. The next render cycle will use the
   * new loader.
   * @param {import("../featureloader.js").FeatureLoader} loader The loader to set.
   * @api
   */ setLoader(loader) {
        this.loader_ = loader;
    }
    /**
   * Points the source to a new url. The next render cycle will use the new url.
   * @param {string|import("../featureloader.js").FeatureUrlFunction} url Url.
   * @api
   */ setUrl(url) {
        (0, $5bf8d54622bcd4c6$export$a7a9523472993e97)(this.format_, '`format` must be set when `url` is set');
        this.url_ = url;
        this.setLoader((0, $3e28f3fe74d4ef3e$export$14cc81df70b6707e)(url, this.format_));
    }
    /**
   * @param {boolean} overlaps The source can have overlapping geometries.
   */ setOverlaps(overlaps) {
        this.overlaps_ = overlaps;
        this.changed();
    }
}
var $747f9d9b478d4c9f$export$2e2bcd8739ae039 = $747f9d9b478d4c9f$var$VectorSource;


/**
 * @module ol/source/VectorTile
 */ 
/**
 * @module ol/VectorRenderTile
 */ 


/**
 * @typedef {Object} ReplayState
 * @property {boolean} dirty Dirty.
 * @property {null|import("./render.js").OrderFunction} renderedRenderOrder RenderedRenderOrder.
 * @property {number} renderedTileRevision RenderedTileRevision.
 * @property {number} renderedResolution RenderedResolution.
 * @property {number} renderedPixelRatio RenderedPixelRatio.
 * @property {number} renderedRevision RenderedRevision.
 * @property {number} renderedTileResolution RenderedTileResolution.
 * @property {number} renderedTileZ RenderedTileZ.
 */ /**
 * @type {Array<HTMLCanvasElement|OffscreenCanvas>}
 */ const $3af7cb4b6dcfdb46$var$canvasPool = [];
class $3af7cb4b6dcfdb46$var$VectorRenderTile extends (0, $1e3bc99d4012152b$export$2e2bcd8739ae039) {
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {import("./tilecoord.js").TileCoord} urlTileCoord Wrapped tile coordinate for source urls.
   * @param {function(VectorRenderTile):Array<import("./VectorTile.js").default>} getSourceTiles Function.
   * @param {function(VectorRenderTile):void} removeSourceTiles Function.
   */ constructor(tileCoord, state, urlTileCoord, getSourceTiles, removeSourceTiles){
        super(tileCoord, state, {
            transition: 0
        });
        /**
     * @private
     * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D|null}
     */ this.context_ = null;
        /**
     * Executor groups. Read/written by the renderer.
     * @type {Object<string, Array<import("./render/canvas/ExecutorGroup.js").default>>}
     */ this.executorGroups = {};
        /**
     * Number of loading source tiles. Read/written by the source.
     * @type {number}
     */ this.loadingSourceTiles = 0;
        /**
     * @type {Object<string, ImageData>}
     */ this.hitDetectionImageData = {};
        /**
     * @private
     * @type {!Object<string, ReplayState>}
     */ this.replayState_ = {};
        /**
     * @type {Array<import("./VectorTile.js").default>}
     */ this.sourceTiles = [];
        /**
     * @type {Object<string, boolean>}
     */ this.errorTileKeys = {};
        /**
     * @type {number}
     */ this.wantedResolution;
        /**
     * @type {!function():Array<import("./VectorTile.js").default>}
     */ this.getSourceTiles = getSourceTiles.bind(undefined, this);
        /**
     * @type {!function(VectorRenderTile):void}
     * @private
     */ this.removeSourceTiles_ = removeSourceTiles;
        /**
     * @type {import("./tilecoord.js").TileCoord}
     */ this.wrappedTileCoord = urlTileCoord;
    }
    /**
   * @return {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} The rendering context.
   */ getContext() {
        if (!this.context_) this.context_ = (0, $5ce605ba3ee034a0$export$9e05d10eae75c464)(1, 1, $3af7cb4b6dcfdb46$var$canvasPool);
        return this.context_;
    }
    /**
   * @return {boolean} Tile has a rendering context.
   */ hasContext() {
        return !!this.context_;
    }
    /**
   * Get the Canvas for this tile.
   * @return {HTMLCanvasElement|OffscreenCanvas} Canvas.
   */ getImage() {
        return this.hasContext() ? this.getContext().canvas : null;
    }
    /**
   * @param {import("./layer/Layer.js").default} layer Layer.
   * @return {ReplayState} The replay state.
   */ getReplayState(layer) {
        const key = (0, $01f1986453243423$export$5e82334337e0f204)(layer);
        if (!(key in this.replayState_)) this.replayState_[key] = {
            dirty: false,
            renderedRenderOrder: null,
            renderedResolution: NaN,
            renderedPixelRatio: NaN,
            renderedRevision: -1,
            renderedTileResolution: NaN,
            renderedTileRevision: -1,
            renderedTileZ: -1
        };
        return this.replayState_[key];
    }
    /**
   * Load the tile.
   * @override
   */ load() {
        this.getSourceTiles();
    }
    /**
   * Remove from the cache due to expiry
   * @override
   */ release() {
        if (this.context_) {
            (0, $5ce605ba3ee034a0$export$e918ac6a1026a12a)(this.context_);
            $3af7cb4b6dcfdb46$var$canvasPool.push(this.context_.canvas);
            this.context_ = null;
        }
        this.removeSourceTiles_(this);
        this.sourceTiles.length = 0;
        super.release();
    }
}
var $3af7cb4b6dcfdb46$export$2e2bcd8739ae039 = $3af7cb4b6dcfdb46$var$VectorRenderTile;


/**
 * @module ol/VectorTile
 */ 

/**
 * @template {import('./Feature.js').FeatureLike} FeatureType
 */ class $9d3248ff4a4ffac2$var$VectorTile extends (0, $1e3bc99d4012152b$export$2e2bcd8739ae039) {
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {string} src Data source url.
   * @param {import("./format/Feature.js").default<FeatureType>} format Feature format.
   * @param {import("./Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @param {import("./Tile.js").Options} [options] Tile options.
   */ constructor(tileCoord, state, src, format, tileLoadFunction, options){
        super(tileCoord, state, options);
        /**
     * Extent of this tile; set by the source.
     * @type {import("./extent.js").Extent}
     */ this.extent = null;
        /**
     * @private
     * @type {import("./format/Feature.js").default<FeatureType>}
     */ this.format_ = format;
        /**
     * @private
     * @type {Array<FeatureType>}
     */ this.features_ = null;
        /**
     * @private
     * @type {import("./featureloader.js").FeatureLoader}
     */ this.loader_;
        /**
     * Feature projection of this tile; set by the source.
     * @type {import("./proj/Projection.js").default}
     */ this.projection = null;
        /**
     * Resolution of this tile; set by the source.
     * @type {number}
     */ this.resolution;
        /**
     * @private
     * @type {import("./Tile.js").LoadFunction}
     */ this.tileLoadFunction_ = tileLoadFunction;
        /**
     * @private
     * @type {string}
     */ this.url_ = src;
        this.key = src;
    }
    /**
   * @return {string} Tile url.
   */ getTileUrl() {
        return this.url_;
    }
    /**
   * Get the feature format assigned for reading this tile's features.
   * @return {import("./format/Feature.js").default<FeatureType>} Feature format.
   * @api
   */ getFormat() {
        return this.format_;
    }
    /**
   * Get the features for this tile. Geometries will be in the view projection.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeatures() {
        return this.features_;
    }
    /**
   * Load not yet loaded URI.
   * @override
   */ load() {
        if (this.state == (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).IDLE) {
            this.setState((0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADING);
            this.tileLoadFunction_(this, this.url_);
            if (this.loader_) this.loader_(this.extent, this.resolution, this.projection);
        }
    }
    /**
   * Handler for successful tile load.
   * @param {Array<FeatureType>} features The loaded features.
   * @param {import("./proj/Projection.js").default} dataProjection Data projection.
   */ onLoad(features, dataProjection) {
        this.setFeatures(features);
    }
    /**
   * Handler for tile load errors.
   */ onError() {
        this.setState((0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).ERROR);
    }
    /**
   * Function for use in a {@link module:ol/source/VectorTile~VectorTile}'s `tileLoadFunction`.
   * Sets the features for the tile.
   * @param {Array<FeatureType>} features Features.
   * @api
   */ setFeatures(features) {
        this.features_ = features;
        this.setState((0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADED);
    }
    /**
   * Set the feature loader for reading this tile's features.
   * @param {import("./featureloader.js").FeatureLoader<FeatureType>} loader Feature loader.
   * @api
   */ setLoader(loader) {
        this.loader_ = loader;
    }
}
var $9d3248ff4a4ffac2$export$2e2bcd8739ae039 = $9d3248ff4a4ffac2$var$VectorTile;












/**
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../render/Feature.js").default]
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least twice the number of tiles in the viewport.
 * @property {import("../extent.js").Extent} [extent] Extent.
 * @property {import("../format/Feature.js").default<FeatureType>} [format] Feature format for tiles. Used and required by the default.
 * @property {boolean} [overlaps=true] This source may have overlapping geometries. Setting this
 * to `false` (e.g. for sources with polygons that represent administrative
 * boundaries or TopoJSON sources) allows the renderer to optimise fill and
 * stroke operations.
 * @property {import("../proj.js").ProjectionLike} [projection='EPSG:3857'] Projection of the tile source.
 * @property {import("./Source.js").State} [state] Source state.
 * @property {typeof import("../VectorTile.js").default} [tileClass] Class used to instantiate tiles.
 * Default is {@link module:ol/VectorTile~VectorTile}.
 * @property {number} [maxZoom=22] Optional max zoom level. Not used if `tileGrid` is provided.
 * @property {number} [minZoom] Optional min zoom level. Not used if `tileGrid` is provided.
 * @property {number|import("../size.js").Size} [tileSize=512] Optional tile size. Not used if `tileGrid` is provided.
 * @property {number} [maxResolution] Optional tile grid resolution at level zero. Not used if `tileGrid` is provided.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction]
 * Optional function to load a tile given a URL. Could look like this for pbf tiles:
 * ```js
 * function(tile, url) {
 *   tile.setLoader(function(extent, resolution, projection) {
 *     fetch(url).then(function(response) {
 *       response.arrayBuffer().then(function(data) {
 *         const format = tile.getFormat() // ol/format/MVT configured as source format
 *         const features = format.readFeatures(data, {
 *           extent: extent,
 *           featureProjection: projection
 *         });
 *         tile.setFeatures(features);
 *       });
 *     });
 *   });
 * }
 * ```
 * If you do not need extent, resolution and projection to get the features for a tile (e.g.
 * for GeoJSON tiles), your `tileLoadFunction` does not need a `setLoader()` call. Only make sure
 * to call `setFeatures()` on the tile:
 * ```js
 * const format = new GeoJSON({featureProjection: map.getView().getProjection()});
 * async function tileLoadFunction(tile, url) {
 *   const response = await fetch(url);
 *   const data = await response.json();
 *   tile.setFeatures(format.readFeatures(data));
 * }
 * ```
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Optional function to get tile URL given a tile coordinate and the projection.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`, may be
 * used instead of defining each one separately in the `urls` option.
 * @property {number} [transition] A duration for tile opacity
 * transitions in milliseconds. A duration of 0 disables the opacity transition.
 * @property {Array<string>} [urls] An array of URL templates.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * When set to `false`, only one world
 * will be rendered. When set to `true`, tiles will be wrapped horizontally to
 * render multiple worlds.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=1]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Class for layer sources providing vector data divided into a tile grid, to be
 * used with {@link module:ol/layer/VectorTile~VectorTileLayer}. Although this source receives tiles
 * with vector features from the server, it is not meant for feature editing.
 * Features are optimized for rendering, their geometries are clipped at or near
 * tile boundaries and simplified for a view resolution. See
 * {@link module:ol/source/Vector~VectorSource} for vector sources that are suitable for feature
 * editing.
 *
 * @fires import("./Tile.js").TileSourceEvent
 * @api
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../render/Feature.js").default]
 */ class $b191c0e6dd9e9d60$var$VectorTile extends (0, $99a9b780f47de391$export$2e2bcd8739ae039) {
    /**
   * @param {!Options<FeatureType>} options Vector tile options.
   */ constructor(options){
        const projection = options.projection || 'EPSG:3857';
        const extent = options.extent || (0, $258117a93d01826e$export$7b5b6ef8fd55fac4)(projection);
        const tileGrid = options.tileGrid || (0, $258117a93d01826e$export$38500bbeccc864ff)({
            extent: extent,
            maxResolution: options.maxResolution,
            maxZoom: options.maxZoom !== undefined ? options.maxZoom : 22,
            minZoom: options.minZoom,
            tileSize: options.tileSize || 512
        });
        super({
            attributions: options.attributions,
            attributionsCollapsible: options.attributionsCollapsible,
            cacheSize: options.cacheSize,
            interpolate: true,
            projection: projection,
            state: options.state,
            tileGrid: tileGrid,
            tileLoadFunction: options.tileLoadFunction ? options.tileLoadFunction : $b191c0e6dd9e9d60$export$7a0df80a606b730e,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX === undefined ? true : options.wrapX,
            transition: options.transition,
            zDirection: options.zDirection === undefined ? 1 : options.zDirection
        });
        /**
     * @private
     * @type {import("../format/Feature.js").default<FeatureType>|null}
     */ this.format_ = options.format ? options.format : null;
        /**
     * @type {Object<string, Array<string>>}
     * @private
     */ this.tileKeysBySourceTileUrl_ = {};
        /**
     @type {Object<string, Tile<FeatureType>>}
     */ this.sourceTiles_ = {};
        /**
     * @private
     * @type {boolean}
     */ this.overlaps_ = options.overlaps == undefined ? true : options.overlaps;
        /**
     * @protected
     * @type {typeof import("../VectorTile.js").default}
     */ this.tileClass = options.tileClass ? options.tileClass : (0, $9d3248ff4a4ffac2$export$2e2bcd8739ae039);
        /**
     * @private
     * @type {Object<string, import("../tilegrid/TileGrid.js").default>}
     */ this.tileGrids_ = {};
    }
    /**
   * @return {boolean} The source can have overlapping geometries.
   */ getOverlaps() {
        return this.overlaps_;
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {VectorRenderTile} tile Vector render tile.
   * @param {import("../Tile.js").UrlFunction} [tileUrlFunction] Tile URL function.
   * @return {Array<import("../VectorTile.js").default>} Tile keys.
   */ getSourceTiles(pixelRatio, projection, tile, tileUrlFunction) {
        if (tile.getState() === (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).IDLE) {
            tile.setState((0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADING);
            const urlTileCoord = tile.wrappedTileCoord;
            const tileGrid = this.getTileGridForProjection(projection);
            let extent = tileGrid.getTileCoordExtent(urlTileCoord);
            const z = urlTileCoord[0];
            const resolution = tileGrid.getResolution(z);
            // make extent 1 pixel smaller so we don't load tiles for < 0.5 pixel render space
            (0, $3412ad7bd362b04c$export$ab1029bcae9ddb4a)(extent, -resolution, extent);
            const sourceProjection = this.projection;
            if (projection && this.projection && !(0, $2a998b085c5a7ac9$export$fe091d73a555748b)(projection, sourceProjection)) extent = (0, $2a998b085c5a7ac9$export$751c68e0e0efff79)(extent, projection, sourceProjection);
            const sourceTileGrid = this.tileGrid;
            const sourceExtent = sourceTileGrid.getExtent();
            if (sourceExtent) (0, $3412ad7bd362b04c$export$72209efa88586d42)(extent, sourceExtent, extent);
            let sourceResolution = resolution;
            if (projection && sourceProjection && !(0, $2a998b085c5a7ac9$export$fe091d73a555748b)(projection, sourceProjection)) sourceResolution = resolution / sourceProjection.getMetersPerUnit() / projection.getMetersPerUnit();
            const sourceZ = sourceTileGrid.getZForResolution(sourceResolution, this.zDirection);
            const urlFunction = tileUrlFunction || this.tileUrlFunction;
            sourceTileGrid.forEachTileCoord(extent, sourceZ, (sourceTileCoord)=>{
                const tileUrl = urlFunction(sourceTileCoord, pixelRatio, projection);
                if (!this.sourceTiles_[tileUrl]) this.sourceTiles_[tileUrl] = new this.tileClass(sourceTileCoord, tileUrl ? (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).IDLE : (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).EMPTY, tileUrl, this.format_, this.tileLoadFunction);
                const sourceTile = this.sourceTiles_[tileUrl];
                tile.sourceTiles.push(sourceTile);
                if (!this.tileKeysBySourceTileUrl_[tileUrl]) this.tileKeysBySourceTileUrl_[tileUrl] = [];
                this.tileKeysBySourceTileUrl_[tileUrl].push(tile.getKey());
                const sourceTileState = sourceTile.getState();
                if (sourceTileState < (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADED) {
                    const listenChange = (event)=>{
                        this.handleTileChange(event);
                        const state = sourceTile.getState();
                        if (state === (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADED || state === (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).ERROR) {
                            const sourceTileKey = sourceTile.getKey();
                            if (sourceTileKey in tile.errorTileKeys) {
                                if (sourceTile.getState() === (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADED) delete tile.errorTileKeys[sourceTileKey];
                            } else tile.loadingSourceTiles--;
                            if (state === (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).ERROR) tile.errorTileKeys[sourceTileKey] = true;
                            else sourceTile.removeEventListener((0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CHANGE, listenChange);
                            if (tile.loadingSourceTiles === 0) tile.setState((0, $0669c62275461b52$export$dd1bc94b04021eeb)(tile.errorTileKeys) ? (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADED : (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).ERROR);
                        }
                    };
                    sourceTile.addEventListener((0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CHANGE, listenChange);
                    tile.loadingSourceTiles++;
                }
                if (sourceTileState === (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).IDLE) {
                    sourceTile.extent = sourceTileGrid.getTileCoordExtent(sourceTileCoord);
                    sourceTile.projection = this.projection;
                    sourceTile.resolution = sourceTileGrid.getResolution(sourceTileCoord[0]);
                    sourceTile.load();
                }
            });
            if (!tile.loadingSourceTiles) tile.setState(tile.sourceTiles.some((sourceTile)=>sourceTile.getState() === (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).ERROR) ? (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).ERROR : (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).LOADED);
        }
        return tile.sourceTiles;
    }
    /**
   * @param {VectorRenderTile} tile Vector render tile.
   */ removeSourceTiles(tile) {
        const tileKey = tile.getKey();
        const sourceTiles = tile.sourceTiles;
        for(let i = 0, ii = sourceTiles.length; i < ii; ++i){
            const sourceTileUrl = sourceTiles[i].getTileUrl();
            if (!this.tileKeysBySourceTileUrl_[sourceTileUrl]) return;
            const index = this.tileKeysBySourceTileUrl_[sourceTileUrl].indexOf(tileKey);
            if (index === -1) continue;
            this.tileKeysBySourceTileUrl_[sourceTileUrl].splice(index, 1);
            if (this.tileKeysBySourceTileUrl_[sourceTileUrl].length === 0) {
                delete this.tileKeysBySourceTileUrl_[sourceTileUrl];
                delete this.sourceTiles_[sourceTileUrl];
            }
        }
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!VectorRenderTile} Tile.
   * @override
   */ getTile(z, x, y, pixelRatio, projection) {
        const tileCoord = [
            z,
            x,
            y
        ];
        let urlTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
        const sourceExtent = this.getTileGrid().getExtent();
        const sourceProjection = this.projection;
        const tileGrid = this.getTileGridForProjection(projection);
        if (urlTileCoord && sourceExtent) {
            const tileExtent = tileGrid.getTileCoordExtent(urlTileCoord);
            // make extent 1 pixel smaller so we don't load tiles for < 0.5 pixel render space
            (0, $3412ad7bd362b04c$export$ab1029bcae9ddb4a)(tileExtent, -tileGrid.getResolution(z), tileExtent);
            if (!(0, $3412ad7bd362b04c$export$7b0a31e10bbff018)(sourceExtent, !projection || !sourceProjection || (0, $2a998b085c5a7ac9$export$fe091d73a555748b)(projection, sourceProjection) ? tileExtent : (0, $2a998b085c5a7ac9$export$751c68e0e0efff79)(tileExtent, projection, sourceProjection))) urlTileCoord = null;
        }
        let empty = true;
        if (urlTileCoord !== null) {
            const sourceTileGrid = this.tileGrid;
            const resolution = tileGrid.getResolution(z);
            let sourceResolution = resolution;
            if (projection && sourceProjection && !(0, $2a998b085c5a7ac9$export$fe091d73a555748b)(projection, sourceProjection)) sourceResolution = resolution / sourceProjection.getMetersPerUnit() / projection.getMetersPerUnit();
            const sourceZ = sourceTileGrid.getZForResolution(sourceResolution, 1);
            // make extent 1 pixel smaller so we don't load tiles for < 0.5 pixel render space
            const extent = tileGrid.getTileCoordExtent(urlTileCoord);
            (0, $3412ad7bd362b04c$export$ab1029bcae9ddb4a)(extent, -resolution, extent);
            sourceTileGrid.forEachTileCoord(!projection || !sourceProjection || (0, $2a998b085c5a7ac9$export$fe091d73a555748b)(projection, sourceProjection) ? extent : (0, $2a998b085c5a7ac9$export$751c68e0e0efff79)(extent, projection, sourceProjection), sourceZ, (sourceTileCoord)=>{
                empty = empty && !this.tileUrlFunction(sourceTileCoord, pixelRatio, sourceProjection);
            });
        }
        const tileUrlFunction = this.tileUrlFunction;
        const newTile = new (0, $3af7cb4b6dcfdb46$export$2e2bcd8739ae039)(tileCoord, empty ? (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).EMPTY : (0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).IDLE, urlTileCoord, (tile)=>this.getSourceTiles(pixelRatio, projection, tile, tileUrlFunction), this.removeSourceTiles.bind(this));
        newTile.key = this.getKey();
        return newTile;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   * @override
   */ getTileGridForProjection(projection) {
        const code = projection.getCode();
        let tileGrid = this.tileGrids_[code];
        if (!tileGrid) {
            const sourceProjection = this.projection;
            if (sourceProjection !== null && !(0, $2a998b085c5a7ac9$export$fe091d73a555748b)(sourceProjection, projection)) return (0, $258117a93d01826e$export$1f4812384df8a9c5)(projection);
            // A tile grid that matches the tile size of the source tile grid is more
            // likely to have 1:1 relationships between source tiles and rendered tiles.
            const sourceTileGrid = this.tileGrid;
            const resolutions = sourceTileGrid.getResolutions().slice();
            const origins = resolutions.map(function(resolution, z) {
                return sourceTileGrid.getOrigin(z);
            });
            const tileSizes = resolutions.map(function(resolution, z) {
                return sourceTileGrid.getTileSize(z);
            });
            const length = (0, $54151e436146eea5$export$e98a216cdcc847dc) + 1;
            for(let z = resolutions.length; z < length; ++z){
                resolutions.push(resolutions[z - 1] / 2);
                origins.push(origins[z - 1]);
                tileSizes.push(tileSizes[z - 1]);
            }
            tileGrid = new (0, $56db44221d298c30$export$2e2bcd8739ae039)({
                extent: sourceTileGrid.getExtent(),
                origins: origins,
                resolutions: resolutions,
                tileSizes: tileSizes
            });
            this.tileGrids_[code] = tileGrid;
        }
        return tileGrid;
    }
    /**
   * Get the tile pixel ratio for this source.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Tile pixel ratio.
   * @override
   */ getTilePixelRatio(pixelRatio) {
        return pixelRatio;
    }
    /**
   * @param {number} z Z.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../size.js").Size} Tile size.
   * @override
   */ getTilePixelSize(z, pixelRatio, projection) {
        const tileGrid = this.getTileGridForProjection(projection);
        const tileSize = (0, $e9727ecf69942748$export$a71a825ff42fb8e1)(tileGrid.getTileSize(z), this.tmpSize);
        return [
            Math.round(tileSize[0] * pixelRatio),
            Math.round(tileSize[1] * pixelRatio)
        ];
    }
    /**
   * @param {boolean} overlaps The source has overlapping geometries.
   */ setOverlaps(overlaps) {
        this.overlaps_ = overlaps;
        this.changed();
    }
}
var $b191c0e6dd9e9d60$export$2e2bcd8739ae039 = $b191c0e6dd9e9d60$var$VectorTile;
function $b191c0e6dd9e9d60$export$7a0df80a606b730e(tile, url) {
    tile.setLoader(/**
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {import("../proj/Projection.js").default} projection Projection.
     */ function(extent, resolution, projection) {
        (0, $3e28f3fe74d4ef3e$export$441d7b57adab24d0)(url, tile.getFormat(), extent, resolution, projection, tile.onLoad.bind(tile), tile.onError.bind(tile));
    });
}






/**
 * @param {import('@maplibre/maplibre-gl-style-spec').EvaluationContext} ctx Context
 * @param {Array<import('@maplibre/maplibre-gl-style-spec').Expression>} args r, g, b, alpha
 * @return {Color} The parsed HSLA color.
 */ function $29b6935815fba8a6$var$hsla(ctx, args) {
    const h = args[0].evaluate(ctx);
    const s = args[1].evaluate(ctx);
    const l = args[2].evaluate(ctx);
    const alpha = args[3] ? args[3].evaluate(ctx) : 1;
    return (0, $ed234ca8eb1f5a84$export$892596cec99bc70e).parse(`hsla(${h}, ${s}%, ${l}%, ${alpha})`);
}
function $29b6935815fba8a6$var$rgbaToHsla(rgba) {
    const r = rgba[0] / 255;
    const g = rgba[1] / 255;
    const b = rgba[2] / 255;
    const a = rgba[3];
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s;
    if (max === min) {
        h = 0;
        s = 0;
    } else {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                h = 0;
        }
        h /= 6;
    }
    return [
        h * 360,
        s * 100,
        l * 100,
        a
    ];
}
function $29b6935815fba8a6$export$10728aedf8b6b602(expression) {
    if (Array.isArray(expression)) {
        if (expression.length === 0) return expression;
        const op = expression[0];
        if (op === 'literal') return expression;
        if (op === 'image' && expression.length === 3 && typeof expression[2] === 'object' && expression[2] !== null && !Array.isArray(expression[2])) {
            const newExpression = [
                'image-config',
                $29b6935815fba8a6$export$10728aedf8b6b602(expression[1]),
                [
                    'literal',
                    expression[2]
                ]
            ];
            return newExpression;
        }
        const length = expression.length;
        for(let i = 1; i < length; ++i){
            const arg = expression[i];
            const newArg = $29b6935815fba8a6$export$10728aedf8b6b602(arg);
            if (newArg !== arg) {
                const newExpression = [
                    op
                ];
                for(let j = 1; j < i; ++j)newExpression.push(expression[j]);
                newExpression.push(newArg);
                for(let j = i + 1; j < length; ++j)newExpression.push($29b6935815fba8a6$export$10728aedf8b6b602(expression[j]));
                return newExpression;
            }
        }
    }
    return expression;
}
const $29b6935815fba8a6$export$812e807713593a71 = {};
const $29b6935815fba8a6$export$56ff1d6843523eec = {
    zoom: 0,
    distanceFromCenter: 0
};
// Add unsupported expressions to the MapLibre GL Style spec
(0, $ed234ca8eb1f5a84$export$a766a6736ff5bbbf).register((0, $ed234ca8eb1f5a84$export$f55ecc93729893d7), {
    ...(0, $ed234ca8eb1f5a84$export$a766a6736ff5bbbf).definitions,
    'pitch': [
        {
            kind: 'number'
        },
        [],
        (ctx)=>$29b6935815fba8a6$export$56ff1d6843523eec.pitch || 0
    ],
    'distance-from-center': [
        {
            kind: 'number'
        },
        [],
        (ctx)=>$29b6935815fba8a6$export$56ff1d6843523eec.distanceFromCenter || 0
    ],
    'to-hsla': [
        {
            kind: 'array',
            itemType: {
                kind: 'number'
            },
            N: 4
        },
        [
            {
                kind: 'string'
            }
        ],
        (ctx, [v])=>{
            return $29b6935815fba8a6$var$rgbaToHsla((0, $6c864c0c7b61b9b5$export$3004f64547af360e)(v.evaluate(ctx)));
        }
    ],
    'hsl': [
        {
            kind: 'color'
        },
        [
            {
                kind: 'number'
            },
            {
                kind: 'number'
            },
            {
                kind: 'number'
            }
        ],
        $29b6935815fba8a6$var$hsla
    ],
    'hsla': [
        {
            kind: 'color'
        },
        [
            {
                kind: 'number'
            },
            {
                kind: 'number'
            },
            {
                kind: 'number'
            },
            {
                kind: 'number'
            }
        ],
        $29b6935815fba8a6$var$hsla
    ],
    'image-config': [
        {
            kind: 'value'
        },
        [
            {
                kind: 'string'
            },
            {
                kind: 'value'
            }
        ],
        (ctx, [v, c])=>v.evaluate(ctx)
    ],
    'measure-light': [
        {
            kind: 'number'
        },
        [
            {
                kind: 'value'
            }
        ],
        ()=>1
    ],
    'config': [
        {
            kind: 'value'
        },
        [
            {
                kind: 'string'
            }
        ],
        (ctx, [key])=>{
            const value = $29b6935815fba8a6$export$812e807713593a71[key.evaluate(ctx)];
            return value === undefined ? {} : value;
        }
    ]
});


const $10d6e9cfb77b7759$var$mapboxBaseUrl = 'https://api.mapbox.com';
function $10d6e9cfb77b7759$export$b375a3c64fb1a7(url) {
    const startsWith = 'mapbox://';
    if (url.indexOf(startsWith) !== 0) return '';
    return url.slice(startsWith.length);
}
function $10d6e9cfb77b7759$export$d9ae4eecff2acce1(sprite, token, styleUrl) {
    if (typeof sprite === 'string') return [
        {
            'id': 'default',
            'url': $10d6e9cfb77b7759$export$1c3786be0ff234b0(sprite, token, styleUrl)
        }
    ];
    for (const spriteObj of sprite)spriteObj.url = $10d6e9cfb77b7759$export$1c3786be0ff234b0(spriteObj.url, token, styleUrl);
    return sprite;
}
function $10d6e9cfb77b7759$export$1c3786be0ff234b0(url, token, styleUrl) {
    const mapboxPath = $10d6e9cfb77b7759$export$b375a3c64fb1a7(url);
    if (!token || !mapboxPath) return decodeURI(new URL(url, styleUrl).href);
    const startsWith = 'sprites/';
    if (mapboxPath.indexOf(startsWith) !== 0) throw new Error(`unexpected sprites url: ${url}`);
    const sprite = mapboxPath.slice(startsWith.length);
    return `${$10d6e9cfb77b7759$var$mapboxBaseUrl}/styles/v1/${sprite}/sprite?access_token=${token}`;
}
function $10d6e9cfb77b7759$export$c295124411c04466(url, token) {
    const mapboxPath = $10d6e9cfb77b7759$export$b375a3c64fb1a7(url);
    if (!mapboxPath || !token) return decodeURI(new URL(url, location.href).href);
    const startsWith = 'styles/';
    if (mapboxPath.indexOf(startsWith) !== 0) throw new Error(`unexpected style url: ${url}`);
    const style = mapboxPath.slice(startsWith.length);
    return `${$10d6e9cfb77b7759$var$mapboxBaseUrl}/styles/v1/${style}?&access_token=${token}`;
}
const $10d6e9cfb77b7759$var$mapboxSubdomains = [
    'a',
    'b',
    'c',
    'd'
];
function $10d6e9cfb77b7759$export$19109ee3fbff0f51(url, token, tokenParam, styleUrl) {
    const urlObject = new URL(url, styleUrl || location.href);
    const mapboxPath = $10d6e9cfb77b7759$export$b375a3c64fb1a7(url);
    if (!mapboxPath) {
        if (!token) return [
            decodeURI(urlObject.href)
        ];
        if (!urlObject.searchParams.has(tokenParam)) urlObject.searchParams.set(tokenParam, token);
        return [
            decodeURI(urlObject.href)
        ];
    }
    if (mapboxPath === 'mapbox.satellite') {
        const sizeFactor = window.devicePixelRatio >= 1.5 ? '@2x' : '';
        return [
            `https://api.mapbox.com/v4/${mapboxPath}/{z}/{x}/{y}${sizeFactor}.webp?access_token=${token}`
        ];
    }
    return $10d6e9cfb77b7759$var$mapboxSubdomains.map((sub)=>`https://${sub}.tiles.mapbox.com/v4/${mapboxPath}/{z}/{x}/{y}.vector.pbf?access_token=${token}`);
}


/*
ol-mapbox-style - Use Mapbox/MapLibre Style objects with OpenLayers
Copyright 2016-present ol-mapbox-style contributors
License: https://raw.githubusercontent.com/openlayers/ol-mapbox-style/master/LICENSE
*/ 

/**
 * @module ol/layer/Image
 */ /**
 * @module ol/renderer/canvas/ImageLayer
 */ 





/**
 * @classdesc
 * Canvas renderer for image layers.
 * @api
 */ class $64db00d1fc6ca4a4$var$CanvasImageLayerRenderer extends (0, $80ebe417992070aa$export$2e2bcd8739ae039) {
    /**
   * @param {import("../../layer/Image.js").default} imageLayer Image layer.
   */ constructor(imageLayer){
        super(imageLayer);
        /**
     * @protected
     * @type {?import("../../Image.js").default}
     */ this.image = null;
        /**
     * @private
     * @type {number}
     */ this.renderedSourceRevision_ = 0;
    }
    /**
   * @return {import('../../DataTile.js').ImageLike} Image.
   */ getImage() {
        return !this.image ? null : this.image.getImage();
    }
    /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   * @override
   */ prepareFrame(frameState) {
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const pixelRatio = frameState.pixelRatio;
        const viewState = frameState.viewState;
        const viewResolution = viewState.resolution;
        const imageSource = this.getLayer().getSource();
        const hints = frameState.viewHints;
        let renderedExtent = frameState.extent;
        if (layerState.extent !== undefined) renderedExtent = (0, $3412ad7bd362b04c$export$72209efa88586d42)(renderedExtent, (0, $2a998b085c5a7ac9$export$494be3a3a25689ca)(layerState.extent, viewState.projection));
        if (!hints[(0, $08bf132ff3931200$export$2e2bcd8739ae039).ANIMATING] && !hints[(0, $08bf132ff3931200$export$2e2bcd8739ae039).INTERACTING] && !(0, $3412ad7bd362b04c$export$dd1bc94b04021eeb)(renderedExtent)) {
            if (imageSource) {
                if (!this.getLayer().rendered && this.renderedSourceRevision_ !== imageSource.getRevision()) this.image = null;
                this.renderedSourceRevision_ = imageSource.getRevision();
                const projection = viewState.projection;
                const image = imageSource.getImage(renderedExtent, viewResolution, pixelRatio, projection);
                if (image) {
                    if (this.loadImage(image)) this.image = image;
                    else if (image.getState() === (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).EMPTY) this.image = null;
                }
            } else this.image = null;
        }
        return !!this.image;
    }
    /**
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray} Data at the pixel location.
   * @override
   */ getData(pixel) {
        const frameState = this.frameState;
        if (!frameState) return null;
        const layer = this.getLayer();
        const coordinate = (0, $eb597965bdcc8f43$export$5635d7ef4b8fee1c)(frameState.pixelToCoordinateTransform, pixel.slice());
        const layerExtent = layer.getExtent();
        if (layerExtent) {
            if (!(0, $3412ad7bd362b04c$export$ac68c24d37ca240f)(layerExtent, coordinate)) return null;
        }
        const imageExtent = this.image.getExtent();
        const img = this.image.getImage();
        const imageMapWidth = (0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(imageExtent);
        const col = Math.floor(img.width * ((coordinate[0] - imageExtent[0]) / imageMapWidth));
        if (col < 0 || col >= img.width) return null;
        const imageMapHeight = (0, $3412ad7bd362b04c$export$c08559766941f856)(imageExtent);
        const row = Math.floor(img.height * ((imageExtent[3] - coordinate[1]) / imageMapHeight));
        if (row < 0 || row >= img.height) return null;
        return this.getImageData(img, col, row);
    }
    /**
   * Render the layer.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   * @override
   */ renderFrame(frameState, target) {
        const image = this.image;
        const imageExtent = image.getExtent();
        const imageResolution = image.getResolution();
        const [imageResolutionX, imageResolutionY] = Array.isArray(imageResolution) ? imageResolution : [
            imageResolution,
            imageResolution
        ];
        const imagePixelRatio = image.getPixelRatio();
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const pixelRatio = frameState.pixelRatio;
        const viewState = frameState.viewState;
        const viewCenter = viewState.center;
        const viewResolution = viewState.resolution;
        const scaleX = pixelRatio * imageResolutionX / (viewResolution * imagePixelRatio);
        const scaleY = pixelRatio * imageResolutionY / (viewResolution * imagePixelRatio);
        this.prepareContainer(frameState, target);
        // desired dimensions of the canvas in pixels
        const width = this.context.canvas.width;
        const height = this.context.canvas.height;
        const context = this.getRenderContext(frameState);
        // clipped rendering if layer extent is set
        let clipped = false;
        let render = true;
        if (layerState.extent) {
            const layerExtent = (0, $2a998b085c5a7ac9$export$494be3a3a25689ca)(layerState.extent, viewState.projection);
            render = (0, $3412ad7bd362b04c$export$7b0a31e10bbff018)(layerExtent, frameState.extent);
            clipped = render && !(0, $3412ad7bd362b04c$export$be866b1e0809b17e)(layerExtent, frameState.extent);
            if (clipped) this.clipUnrotated(context, frameState, layerExtent);
        }
        const img = image.getImage();
        const transform = (0, $eb597965bdcc8f43$export$f672e0b6f7222cd7)(this.tempTransform, width / 2, height / 2, scaleX, scaleY, 0, imagePixelRatio * (imageExtent[0] - viewCenter[0]) / imageResolutionX, imagePixelRatio * (viewCenter[1] - imageExtent[3]) / imageResolutionY);
        this.renderedResolution = imageResolutionY * pixelRatio / imagePixelRatio;
        const dw = img.width * transform[0];
        const dh = img.height * transform[3];
        if (!this.getLayer().getSource().getInterpolate()) context.imageSmoothingEnabled = false;
        this.preRender(context, frameState);
        if (render && dw >= 0.5 && dh >= 0.5) {
            const dx = transform[4];
            const dy = transform[5];
            const opacity = layerState.opacity;
            if (opacity !== 1) {
                context.save();
                context.globalAlpha = opacity;
            }
            context.drawImage(img, 0, 0, +img.width, +img.height, dx, dy, dw, dh);
            if (opacity !== 1) context.restore();
        }
        this.postRender(this.context, frameState);
        if (clipped) context.restore();
        context.imageSmoothingEnabled = true;
        return this.container;
    }
}
var $64db00d1fc6ca4a4$export$2e2bcd8739ae039 = $64db00d1fc6ca4a4$var$CanvasImageLayerRenderer;


/**
 * @module ol/layer/BaseImage
 */ 
/**
 * @template {import("../source/Image.js").default} ImageSourceType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link import("../Map.js").default#addLayer map.addLayer()}.
 * @property {ImageSourceType} [source] Source for this layer.
 * @property {import('./Base.js').BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Server-rendered images that are available for arbitrary extents and
 * resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Image.js").default} ImageSourceType
 * @template {import("../renderer/Layer.js").default} RendererType
 * @extends {Layer<ImageSourceType, RendererType>}
 * @api
 */ class $e7ae3f7baa3f7251$var$BaseImageLayer extends (0, $7bdbe21729fecf84$export$2e2bcd8739ae039) {
    /**
   * @param {Options<ImageSourceType>} [options] Layer options.
   */ constructor(options){
        options = options ? options : {};
        super(options);
    }
}
var $e7ae3f7baa3f7251$export$2e2bcd8739ae039 = $e7ae3f7baa3f7251$var$BaseImageLayer;


/**
 * @classdesc
 * Server-rendered images that are available for arbitrary extents and
 * resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Image.js").default} ImageSourceType
 * @extends {BaseImageLayer<ImageSourceType, CanvasImageLayerRenderer>}
 * @api
 */ class $733c124325e59ca7$var$ImageLayer extends (0, $e7ae3f7baa3f7251$export$2e2bcd8739ae039) {
    /**
   * @param {import("./BaseImage.js").Options<ImageSourceType>} [options] Layer options.
   */ constructor(options){
        super(options);
    }
    /**
   * @override
   */ createRenderer() {
        return new (0, $64db00d1fc6ca4a4$export$2e2bcd8739ae039)(this);
    }
    /**
   * Get data for a pixel location.  A four element RGBA array will be returned.  For requests outside the
   * layer extent, `null` will be returned.  Data for an image can only be retrieved if the
   * source's `crossOrigin` property is set.
   *
   * ```js
   * // display layer data on every pointer move
   * map.on('pointermove', (event) => {
   *   console.log(layer.getData(event.pixel));
   * });
   * ```
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   * @api
   * @override
   */ getData(pixel) {
        return super.getData(pixel);
    }
}
var $733c124325e59ca7$export$2e2bcd8739ae039 = $733c124325e59ca7$var$ImageLayer;



/**
 * @module ol/source/Raster
 */ 
/**
 * @module ol/ImageCanvas
 */ 

/**
 * A function that is called to trigger asynchronous canvas drawing.  It is
 * called with a "done" callback that should be called when drawing is done.
 * If any error occurs during drawing, the "done" callback should be called with
 * that error.
 *
 * @typedef {function(function(Error=): void): void} Loader
 */ class $35d90f15f510f1c3$var$ImageCanvas extends (0, $2ec9ee9b9239c7e8$export$2e2bcd8739ae039) {
    /**
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {HTMLCanvasElement|OffscreenCanvas} canvas Canvas.
   * @param {Loader} [loader] Optional loader function to
   *     support asynchronous canvas drawing.
   */ constructor(extent, resolution, pixelRatio, canvas, loader){
        const state = loader !== undefined ? (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).IDLE : (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADED;
        super(extent, resolution, pixelRatio, state);
        /**
     * Optional canvas loader function.
     * @type {?Loader}
     * @private
     */ this.loader_ = loader !== undefined ? loader : null;
        /**
     * @private
     * @type {HTMLCanvasElement|OffscreenCanvas}
     */ this.canvas_ = canvas;
        /**
     * @private
     * @type {?Error}
     */ this.error_ = null;
    }
    /**
   * Get any error associated with asynchronous rendering.
   * @return {?Error} Any error that occurred during rendering.
   */ getError() {
        return this.error_;
    }
    /**
   * Handle async drawing complete.
   * @param {Error} [err] Any error during drawing.
   * @private
   */ handleLoad_(err) {
        if (err) {
            this.error_ = err;
            this.state = (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).ERROR;
        } else this.state = (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADED;
        this.changed();
    }
    /**
   * Load not yet loaded URI.
   * @override
   */ load() {
        if (this.state == (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).IDLE) {
            this.state = (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADING;
            this.changed();
            this.loader_(this.handleLoad_.bind(this));
        }
    }
    /**
   * @return {HTMLCanvasElement|OffscreenCanvas} Canvas element.
   * @override
   */ getImage() {
        return this.canvas_;
    }
}
var $35d90f15f510f1c3$export$2e2bcd8739ae039 = $35d90f15f510f1c3$var$ImageCanvas;











/**
 * @module ol/source/Image
 */ 







/**
 * @module ol/reproj/Image
 */ 





/**
 * @module ol/resolution
 */ /**
 * @typedef {number|Array<number>} ResolutionLike
 */ /**
 * @param {ResolutionLike} resolution Resolution.
 * @return {number} Resolution.
 */ function $fef78339fba5712f$export$bc4231bf34bfa9ad(resolution) {
    if (Array.isArray(resolution)) return Math.min(...resolution);
    return resolution;
}




/**
 * @typedef {function(import("../extent.js").Extent, number, number) : import("../Image.js").default} FunctionType
 */ /**
 * @classdesc
 * Class encapsulating single reprojected image.
 * See {@link module:ol/source/Image~ImageSource}.
 */ class $100abe429088f256$var$ReprojImage extends (0, $2ec9ee9b9239c7e8$export$2e2bcd8739ae039) {
    /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection (of the data).
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../extent.js").Extent} targetExtent Target extent.
   * @param {number} targetResolution Target resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {FunctionType} getImageFunction
   *     Function returning source images (extent, resolution, pixelRatio).
   * @param {boolean} interpolate Use linear interpolation when resampling.
   */ constructor(sourceProj, targetProj, targetExtent, targetResolution, pixelRatio, getImageFunction, interpolate){
        let maxSourceExtent = sourceProj.getExtent();
        if (maxSourceExtent && sourceProj.canWrapX()) {
            maxSourceExtent = maxSourceExtent.slice();
            maxSourceExtent[0] = -Infinity;
            maxSourceExtent[2] = Infinity;
        }
        let maxTargetExtent = targetProj.getExtent();
        if (maxTargetExtent && targetProj.canWrapX()) {
            maxTargetExtent = maxTargetExtent.slice();
            maxTargetExtent[0] = -Infinity;
            maxTargetExtent[2] = Infinity;
        }
        const limitedTargetExtent = maxTargetExtent ? (0, $3412ad7bd362b04c$export$72209efa88586d42)(targetExtent, maxTargetExtent) : targetExtent;
        const targetCenter = (0, $3412ad7bd362b04c$export$c91255cadecfe081)(limitedTargetExtent);
        const sourceResolution = (0, $6f24a3a97d494c8d$export$5fbb958059b7e71f)(sourceProj, targetProj, targetCenter, targetResolution);
        const errorThresholdInPixels = (0, $ac3e64c1413dba86$export$3ecb4bcfa5aae855);
        const triangulation = new (0, $306d859d6bfa3587$export$2e2bcd8739ae039)(sourceProj, targetProj, limitedTargetExtent, maxSourceExtent, sourceResolution * errorThresholdInPixels, targetResolution);
        const sourceExtent = triangulation.calculateSourceExtent();
        const sourceImage = (0, $3412ad7bd362b04c$export$dd1bc94b04021eeb)(sourceExtent) ? null : getImageFunction(sourceExtent, sourceResolution, pixelRatio);
        const state = sourceImage ? (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).IDLE : (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).EMPTY;
        const sourcePixelRatio = sourceImage ? sourceImage.getPixelRatio() : 1;
        super(targetExtent, targetResolution, sourcePixelRatio, state);
        /**
     * @private
     * @type {import("../proj/Projection.js").default}
     */ this.targetProj_ = targetProj;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.maxSourceExtent_ = maxSourceExtent;
        /**
     * @private
     * @type {!import("./Triangulation.js").default}
     */ this.triangulation_ = triangulation;
        /**
     * @private
     * @type {number}
     */ this.targetResolution_ = targetResolution;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.targetExtent_ = targetExtent;
        /**
     * @private
     * @type {import("../Image.js").default}
     */ this.sourceImage_ = sourceImage;
        /**
     * @private
     * @type {number}
     */ this.sourcePixelRatio_ = sourcePixelRatio;
        /**
     * @private
     * @type {boolean}
     */ this.interpolate_ = interpolate;
        /**
     * @private
     * @type {HTMLCanvasElement|OffscreenCanvas}
     */ this.canvas_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.sourceListenerKey_ = null;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.state == (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADING) this.unlistenSource_();
        super.disposeInternal();
    }
    /**
   * @return {HTMLCanvasElement|OffscreenCanvas} Image.
   * @override
   */ getImage() {
        return this.canvas_;
    }
    /**
   * @return {import("../proj/Projection.js").default} Projection.
   */ getProjection() {
        return this.targetProj_;
    }
    /**
   * @private
   */ reproject_() {
        const sourceState = this.sourceImage_.getState();
        if (sourceState == (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADED) {
            const width = (0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(this.targetExtent_) / this.targetResolution_;
            const height = (0, $3412ad7bd362b04c$export$c08559766941f856)(this.targetExtent_) / this.targetResolution_;
            this.canvas_ = (0, $6f24a3a97d494c8d$export$b3890eb0ae9dca99)(width, height, this.sourcePixelRatio_, (0, $fef78339fba5712f$export$bc4231bf34bfa9ad)(this.sourceImage_.getResolution()), this.maxSourceExtent_, this.targetResolution_, this.targetExtent_, this.triangulation_, [
                {
                    extent: this.sourceImage_.getExtent(),
                    image: this.sourceImage_.getImage()
                }
            ], 0, undefined, this.interpolate_, true);
        }
        this.state = sourceState;
        this.changed();
    }
    /**
   * Load not yet loaded URI.
   * @override
   */ load() {
        if (this.state == (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).IDLE) {
            this.state = (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADING;
            this.changed();
            const sourceState = this.sourceImage_.getState();
            if (sourceState == (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADED || sourceState == (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).ERROR) this.reproject_();
            else {
                this.sourceListenerKey_ = (0, $8061a5de9380012b$export$63174c828edd6ff8)(this.sourceImage_, (0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CHANGE, (e)=>{
                    const sourceState = this.sourceImage_.getState();
                    if (sourceState == (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADED || sourceState == (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).ERROR) {
                        this.unlistenSource_();
                        this.reproject_();
                    }
                });
                this.sourceImage_.load();
            }
        }
    }
    /**
   * @private
   */ unlistenSource_() {
        (0, $8061a5de9380012b$export$b0a21c8b3c1c921)(/** @type {!import("../events.js").EventsKey} */ this.sourceListenerKey_);
        this.sourceListenerKey_ = null;
    }
}
var $100abe429088f256$export$2e2bcd8739ae039 = $100abe429088f256$var$ReprojImage;




/**
 * @module ol/source/common
 */ /**
 * Default WMS version.
 * @type {string}
 */ const $55f7dbac48b04305$export$8c33e4eedb20eeb5 = '1.3.0';
const $55f7dbac48b04305$export$48fbc15abf52505f = 4;


const $a95be25e5eb82a6f$export$4e0f6da20e5dcc4f = {
    /**
   * Triggered when an image starts loading.
   * @event module:ol/source/Image.ImageSourceEvent#imageloadstart
   * @api
   */ IMAGELOADSTART: 'imageloadstart',
    /**
   * Triggered when an image finishes loading.
   * @event module:ol/source/Image.ImageSourceEvent#imageloadend
   * @api
   */ IMAGELOADEND: 'imageloadend',
    /**
   * Triggered if image loading results in an error.
   * @event module:ol/source/Image.ImageSourceEvent#imageloaderror
   * @api
   */ IMAGELOADERROR: 'imageloaderror'
};
class $a95be25e5eb82a6f$export$58d3276cd83daede extends (0, $bc90848f8b15fa29$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Type.
   * @param {import("../Image.js").default} image The image.
   */ constructor(type, image){
        super(type);
        /**
     * The image related to the event.
     * @type {import("../Image.js").default}
     * @api
     */ this.image = image;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable.js").OnSignature<import("../Observable.js").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable.js").OnSignature<import("../ObjectEventType.js").Types, import("../Object.js").ObjectEvent, Return> &
 *   import("../Observable.js").OnSignature<ImageSourceEventTypes, ImageSourceEvent, Return> &
 *   import("../Observable.js").CombinedOnSignature<import("../Observable.js").EventTypes|import("../ObjectEventType.js").Types
 *     |ImageSourceEventTypes, Return>} ImageSourceOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {import("../Image.js").Loader} [loader] Loader. Can either be a custom loader, or one of the
 * loaders created with a `createLoader()` function ({@link module:ol/source/wms.createLoader wms},
 * {@link module:ol/source/arcgisRest.createLoader arcgisRest}, {@link module:ol/source/mapguide.createLoader mapguide},
 * {@link module:ol/source/static.createLoader static}).
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {Array<number>} [resolutions] Resolutions.
 * @property {import("./Source.js").State} [state] State.
 */ /**
 * @classdesc
 * Base class for sources providing a single image.
 * @fires module:ol/source/Image.ImageSourceEvent
 * @api
 */ class $a95be25e5eb82a6f$var$ImageSource extends (0, $039754a80ce105f8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Single image source options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            projection: options.projection,
            state: options.state,
            interpolate: options.interpolate !== undefined ? options.interpolate : true
        });
        /***
     * @type {ImageSourceOnSignature<import("../events.js").EventsKey>}
     */ this.on;
        /***
     * @type {ImageSourceOnSignature<import("../events.js").EventsKey>}
     */ this.once;
        /***
     * @type {ImageSourceOnSignature<void>}
     */ this.un;
        /**
     * @protected
     * @type {import("../Image.js").Loader}
     */ this.loader = options.loader || null;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.resolutions_ = options.resolutions !== undefined ? options.resolutions : null;
        /**
     * @private
     * @type {import("../reproj/Image.js").default}
     */ this.reprojectedImage_ = null;
        /**
     * @private
     * @type {number}
     */ this.reprojectedRevision_ = 0;
        /**
     * @protected
     * @type {import("../Image.js").default}
     */ this.image = null;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.wantedExtent_;
        /**
     * @private
     * @type {number}
     */ this.wantedResolution_;
        /**
     * @private
     * @type {boolean}
     */ this.static_ = options.loader ? options.loader.length === 0 : false;
        /**
     * @private
     * @type {import("../proj/Projection.js").default}
     */ this.wantedProjection_ = null;
    }
    /**
   * @return {Array<number>|null} Resolutions.
   * @override
   */ getResolutions() {
        return this.resolutions_;
    }
    /**
   * @param {Array<number>|null} resolutions Resolutions.
   */ setResolutions(resolutions) {
        this.resolutions_ = resolutions;
    }
    /**
   * @protected
   * @param {number} resolution Resolution.
   * @return {number} Resolution.
   */ findNearestResolution(resolution) {
        const resolutions = this.getResolutions();
        if (resolutions) {
            const idx = (0, $db525acb5f2517fc$export$8a3786cc03fdb777)(resolutions, resolution, 0);
            resolution = resolutions[idx];
        }
        return resolution;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../Image.js").default} Single image.
   */ getImage(extent, resolution, pixelRatio, projection) {
        const sourceProjection = this.getProjection();
        if (!sourceProjection || !projection || (0, $2a998b085c5a7ac9$export$fe091d73a555748b)(sourceProjection, projection)) {
            if (sourceProjection) projection = sourceProjection;
            return this.getImageInternal(extent, resolution, pixelRatio, projection);
        }
        if (this.reprojectedImage_) {
            if (this.reprojectedRevision_ == this.getRevision() && (0, $2a998b085c5a7ac9$export$fe091d73a555748b)(this.reprojectedImage_.getProjection(), projection) && this.reprojectedImage_.getResolution() == resolution && (0, $3412ad7bd362b04c$export$e9bab7fafb253603)(this.reprojectedImage_.getExtent(), extent)) return this.reprojectedImage_;
            this.reprojectedImage_.dispose();
            this.reprojectedImage_ = null;
        }
        this.reprojectedImage_ = new (0, $100abe429088f256$export$2e2bcd8739ae039)(sourceProjection, projection, extent, resolution, pixelRatio, (extent, resolution, pixelRatio)=>this.getImageInternal(extent, resolution, pixelRatio, sourceProjection), this.getInterpolate());
        this.reprojectedRevision_ = this.getRevision();
        return this.reprojectedImage_;
    }
    /**
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../Image.js").default} Single image.
   * @protected
   */ getImageInternal(extent, resolution, pixelRatio, projection) {
        if (this.loader) {
            const requestExtent = $a95be25e5eb82a6f$export$2a9dcc8f63da1787(extent, resolution, pixelRatio, 1);
            const requestResolution = this.findNearestResolution(resolution);
            if (this.image && (this.static_ || this.wantedProjection_ === projection && (this.wantedExtent_ && (0, $3412ad7bd362b04c$export$be866b1e0809b17e)(this.wantedExtent_, requestExtent) || (0, $3412ad7bd362b04c$export$be866b1e0809b17e)(this.image.getExtent(), requestExtent)) && (this.wantedResolution_ && (0, $fef78339fba5712f$export$bc4231bf34bfa9ad)(this.wantedResolution_) === requestResolution || (0, $fef78339fba5712f$export$bc4231bf34bfa9ad)(this.image.getResolution()) === requestResolution))) return this.image;
            this.wantedProjection_ = projection;
            this.wantedExtent_ = requestExtent;
            this.wantedResolution_ = requestResolution;
            this.image = new (0, $2ec9ee9b9239c7e8$export$2e2bcd8739ae039)(requestExtent, requestResolution, pixelRatio, this.loader);
            this.image.addEventListener((0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CHANGE, this.handleImageChange.bind(this));
        }
        return this.image;
    }
    /**
   * Handle image change events.
   * @param {import("../events/Event.js").default} event Event.
   * @protected
   */ handleImageChange(event) {
        const image = /** @type {import("../Image.js").default} */ event.target;
        let type;
        switch(image.getState()){
            case (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADING:
                this.loading = true;
                type = $a95be25e5eb82a6f$export$4e0f6da20e5dcc4f.IMAGELOADSTART;
                break;
            case (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).LOADED:
                this.loading = false;
                type = $a95be25e5eb82a6f$export$4e0f6da20e5dcc4f.IMAGELOADEND;
                break;
            case (0, $b7bb8c7fd6676c50$export$2e2bcd8739ae039).ERROR:
                this.loading = false;
                type = $a95be25e5eb82a6f$export$4e0f6da20e5dcc4f.IMAGELOADERROR;
                break;
            default:
                return;
        }
        if (this.hasListener(type)) this.dispatchEvent(new $a95be25e5eb82a6f$export$58d3276cd83daede(type, image));
    }
}
function $a95be25e5eb82a6f$export$584f102f75ff44b3(image, src) {
    /** @type {HTMLImageElement|HTMLVideoElement} */ image.getImage().src = src;
}
function $a95be25e5eb82a6f$export$2a9dcc8f63da1787(extent, resolution, pixelRatio, ratio) {
    const imageResolution = resolution / pixelRatio;
    const center = (0, $3412ad7bd362b04c$export$c91255cadecfe081)(extent);
    const viewWidth = (0, $912ac838ff50d1cd$export$803ce6b71a0a94b2)((0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(extent) / imageResolution, (0, $55f7dbac48b04305$export$48fbc15abf52505f));
    const viewHeight = (0, $912ac838ff50d1cd$export$803ce6b71a0a94b2)((0, $3412ad7bd362b04c$export$c08559766941f856)(extent) / imageResolution, (0, $55f7dbac48b04305$export$48fbc15abf52505f));
    const marginWidth = (0, $912ac838ff50d1cd$export$803ce6b71a0a94b2)((ratio - 1) * viewWidth / 2, (0, $55f7dbac48b04305$export$48fbc15abf52505f));
    const requestWidth = viewWidth + 2 * marginWidth;
    const marginHeight = (0, $912ac838ff50d1cd$export$803ce6b71a0a94b2)((ratio - 1) * viewHeight / 2, (0, $55f7dbac48b04305$export$48fbc15abf52505f));
    const requestHeight = viewHeight + 2 * marginHeight;
    return (0, $3412ad7bd362b04c$export$13ba650faf8308)(center, imageResolution, 0, [
        requestWidth,
        requestHeight
    ]);
}
var $a95be25e5eb82a6f$export$2e2bcd8739ae039 = $a95be25e5eb82a6f$var$ImageSource;




/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $d4ecdbf520e63dca$export$a143d493d941bafc;
var $d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a;
var $d4ecdbf520e63dca$export$f99ded8fe4b79145;
var $d4ecdbf520e63dca$export$599f31c3813fae4d;
'use strict';
var $034686670a8a195b$export$a48f0734ac7c2329;
var $034686670a8a195b$export$d622b2ad8d90c771;
var $034686670a8a195b$export$6100ba28696e12de;
'use strict';
$034686670a8a195b$export$a48f0734ac7c2329 = $034686670a8a195b$var$byteLength;
$034686670a8a195b$export$d622b2ad8d90c771 = $034686670a8a195b$var$toByteArray;
$034686670a8a195b$export$6100ba28696e12de = $034686670a8a195b$var$fromByteArray;
var $034686670a8a195b$var$lookup = [];
var $034686670a8a195b$var$revLookup = [];
var $034686670a8a195b$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $034686670a8a195b$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $034686670a8a195b$var$i = 0, $034686670a8a195b$var$len = $034686670a8a195b$var$code.length; $034686670a8a195b$var$i < $034686670a8a195b$var$len; ++$034686670a8a195b$var$i){
    $034686670a8a195b$var$lookup[$034686670a8a195b$var$i] = $034686670a8a195b$var$code[$034686670a8a195b$var$i];
    $034686670a8a195b$var$revLookup[$034686670a8a195b$var$code.charCodeAt($034686670a8a195b$var$i)] = $034686670a8a195b$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$034686670a8a195b$var$revLookup['-'.charCodeAt(0)] = 62;
$034686670a8a195b$var$revLookup['_'.charCodeAt(0)] = 63;
function $034686670a8a195b$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $034686670a8a195b$var$byteLength(b64) {
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$toByteArray(b64) {
    var tmp;
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $034686670a8a195b$var$Arr($034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 18 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 2 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 10 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $034686670a8a195b$var$tripletToBase64(num) {
    return $034686670a8a195b$var$lookup[num >> 18 & 0x3F] + $034686670a8a195b$var$lookup[num >> 12 & 0x3F] + $034686670a8a195b$var$lookup[num >> 6 & 0x3F] + $034686670a8a195b$var$lookup[num & 0x3F];
}
function $034686670a8a195b$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($034686670a8a195b$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $034686670a8a195b$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($034686670a8a195b$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 2] + $034686670a8a195b$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 10] + $034686670a8a195b$var$lookup[tmp >> 4 & 0x3F] + $034686670a8a195b$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $454af19f7384844b$export$aafa59e2e03f2942;
var $454af19f7384844b$export$68d8715fc104d294;
$454af19f7384844b$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$454af19f7384844b$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $d4ecdbf520e63dca$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$d4ecdbf520e63dca$export$a143d493d941bafc = $d4ecdbf520e63dca$var$Buffer;
$d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a = $d4ecdbf520e63dca$var$SlowBuffer;
$d4ecdbf520e63dca$export$f99ded8fe4b79145 = 50;
const $d4ecdbf520e63dca$var$K_MAX_LENGTH = 0x7fffffff;
$d4ecdbf520e63dca$export$599f31c3813fae4d = $d4ecdbf520e63dca$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT = $d4ecdbf520e63dca$var$typedArraySupport();
if (!$d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d4ecdbf520e63dca$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d4ecdbf520e63dca$var$createBuffer(length) {
    if (length > $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d4ecdbf520e63dca$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d4ecdbf520e63dca$var$allocUnsafe(arg);
    }
    return $d4ecdbf520e63dca$var$from(arg, encodingOrOffset, length);
}
$d4ecdbf520e63dca$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $d4ecdbf520e63dca$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d4ecdbf520e63dca$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($d4ecdbf520e63dca$var$isInstance(value, ArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, ArrayBuffer)) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($d4ecdbf520e63dca$var$isInstance(value, SharedArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, SharedArrayBuffer))) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d4ecdbf520e63dca$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $d4ecdbf520e63dca$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $d4ecdbf520e63dca$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d4ecdbf520e63dca$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer, Uint8Array);
function $d4ecdbf520e63dca$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d4ecdbf520e63dca$var$alloc(size, fill, encoding) {
    $d4ecdbf520e63dca$var$assertSize(size);
    if (size <= 0) return $d4ecdbf520e63dca$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $d4ecdbf520e63dca$var$createBuffer(size).fill(fill, encoding) : $d4ecdbf520e63dca$var$createBuffer(size).fill(fill);
    return $d4ecdbf520e63dca$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d4ecdbf520e63dca$var$Buffer.alloc = function(size, fill, encoding) {
    return $d4ecdbf520e63dca$var$alloc(size, fill, encoding);
};
function $d4ecdbf520e63dca$var$allocUnsafe(size) {
    $d4ecdbf520e63dca$var$assertSize(size);
    return $d4ecdbf520e63dca$var$createBuffer(size < 0 ? 0 : $d4ecdbf520e63dca$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d4ecdbf520e63dca$var$Buffer.allocUnsafe = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d4ecdbf520e63dca$var$Buffer.allocUnsafeSlow = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
function $d4ecdbf520e63dca$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $d4ecdbf520e63dca$var$byteLength(string, encoding) | 0;
    let buf = $d4ecdbf520e63dca$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $d4ecdbf520e63dca$var$checked(array.length) | 0;
    const buf = $d4ecdbf520e63dca$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayView(arrayView) {
    if ($d4ecdbf520e63dca$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $d4ecdbf520e63dca$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d4ecdbf520e63dca$var$fromArrayLike(arrayView);
}
function $d4ecdbf520e63dca$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
function $d4ecdbf520e63dca$var$fromObject(obj) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(obj)) {
        const len = $d4ecdbf520e63dca$var$checked(obj.length) | 0;
        const buf = $d4ecdbf520e63dca$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $d4ecdbf520e63dca$var$numberIsNaN(obj.length)) return $d4ecdbf520e63dca$var$createBuffer(0);
        return $d4ecdbf520e63dca$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $d4ecdbf520e63dca$var$fromArrayLike(obj.data);
}
function $d4ecdbf520e63dca$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d4ecdbf520e63dca$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $d4ecdbf520e63dca$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d4ecdbf520e63dca$var$Buffer.alloc(+length);
}
$d4ecdbf520e63dca$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d4ecdbf520e63dca$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d4ecdbf520e63dca$var$Buffer.compare = function compare(a, b) {
    if ($d4ecdbf520e63dca$var$isInstance(a, Uint8Array)) a = $d4ecdbf520e63dca$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d4ecdbf520e63dca$var$isInstance(b, Uint8Array)) b = $d4ecdbf520e63dca$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(a) || !$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d4ecdbf520e63dca$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$d4ecdbf520e63dca$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d4ecdbf520e63dca$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $d4ecdbf520e63dca$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($d4ecdbf520e63dca$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) buf = $d4ecdbf520e63dca$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d4ecdbf520e63dca$var$byteLength(string, encoding) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d4ecdbf520e63dca$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $d4ecdbf520e63dca$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $d4ecdbf520e63dca$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d4ecdbf520e63dca$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d4ecdbf520e63dca$var$Buffer.byteLength = $d4ecdbf520e63dca$var$byteLength;
function $d4ecdbf520e63dca$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $d4ecdbf520e63dca$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $d4ecdbf520e63dca$var$utf8Slice(this, start, end);
        case 'ascii':
            return $d4ecdbf520e63dca$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $d4ecdbf520e63dca$var$latin1Slice(this, start, end);
        case 'base64':
            return $d4ecdbf520e63dca$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d4ecdbf520e63dca$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d4ecdbf520e63dca$var$Buffer.prototype._isBuffer = true;
function $d4ecdbf520e63dca$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d4ecdbf520e63dca$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$d4ecdbf520e63dca$var$swap(this, i, i + 1);
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $d4ecdbf520e63dca$var$swap(this, i, i + 3);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $d4ecdbf520e63dca$var$swap(this, i, i + 7);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 6);
        $d4ecdbf520e63dca$var$swap(this, i + 2, i + 5);
        $d4ecdbf520e63dca$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $d4ecdbf520e63dca$var$utf8Slice(this, 0, length);
    return $d4ecdbf520e63dca$var$slowToString.apply(this, arguments);
};
$d4ecdbf520e63dca$var$Buffer.prototype.toLocaleString = $d4ecdbf520e63dca$var$Buffer.prototype.toString;
$d4ecdbf520e63dca$var$Buffer.prototype.equals = function equals(b) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $d4ecdbf520e63dca$var$Buffer.compare(this, b) === 0;
};
$d4ecdbf520e63dca$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $d4ecdbf520e63dca$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($d4ecdbf520e63dca$var$customInspectSymbol) $d4ecdbf520e63dca$var$Buffer.prototype[$d4ecdbf520e63dca$var$customInspectSymbol] = $d4ecdbf520e63dca$var$Buffer.prototype.inspect;
$d4ecdbf520e63dca$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d4ecdbf520e63dca$var$isInstance(target, Uint8Array)) target = $d4ecdbf520e63dca$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d4ecdbf520e63dca$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d4ecdbf520e63dca$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $d4ecdbf520e63dca$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d4ecdbf520e63dca$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d4ecdbf520e63dca$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d4ecdbf520e63dca$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d4ecdbf520e63dca$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d4ecdbf520e63dca$var$utf8Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d4ecdbf520e63dca$var$asciiWrite(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$asciiToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$base64Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$base64ToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$ucs2Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d4ecdbf520e63dca$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $d4ecdbf520e63dca$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $d4ecdbf520e63dca$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $d4ecdbf520e63dca$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $d4ecdbf520e63dca$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d4ecdbf520e63dca$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d4ecdbf520e63dca$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d4ecdbf520e63dca$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $034686670a8a195b$export$6100ba28696e12de(buf);
    else return $034686670a8a195b$export$6100ba28696e12de(buf.slice(start, end));
}
function $d4ecdbf520e63dca$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d4ecdbf520e63dca$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d4ecdbf520e63dca$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d4ecdbf520e63dca$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d4ecdbf520e63dca$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d4ecdbf520e63dca$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $d4ecdbf520e63dca$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d4ecdbf520e63dca$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d4ecdbf520e63dca$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d4ecdbf520e63dca$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$d4ecdbf520e63dca$var$Buffer.prototype.readUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readBigUInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$d4ecdbf520e63dca$var$Buffer.prototype.readBigUInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$d4ecdbf520e63dca$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readBigInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$d4ecdbf520e63dca$var$Buffer.prototype.readBigInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $d4ecdbf520e63dca$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d4ecdbf520e63dca$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $d4ecdbf520e63dca$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $d4ecdbf520e63dca$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $d4ecdbf520e63dca$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigUInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigUInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $d4ecdbf520e63dca$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $454af19f7384844b$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, false, noAssert);
};
function $d4ecdbf520e63dca$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $454af19f7384844b$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d4ecdbf520e63dca$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d4ecdbf520e63dca$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $d4ecdbf520e63dca$var$Buffer.isBuffer(val) ? val : $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $d4ecdbf520e63dca$var$errors = {};
function $d4ecdbf520e63dca$var$E(sym, getMessage, Base) {
    $d4ecdbf520e63dca$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$d4ecdbf520e63dca$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$d4ecdbf520e63dca$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$d4ecdbf520e63dca$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $d4ecdbf520e63dca$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $d4ecdbf520e63dca$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $d4ecdbf520e63dca$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $d4ecdbf520e63dca$var$checkBounds(buf, offset, byteLength) {
    $d4ecdbf520e63dca$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $d4ecdbf520e63dca$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $d4ecdbf520e63dca$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $d4ecdbf520e63dca$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $d4ecdbf520e63dca$var$checkBounds(buf, offset, byteLength);
}
function $d4ecdbf520e63dca$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $d4ecdbf520e63dca$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $d4ecdbf520e63dca$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $d4ecdbf520e63dca$var$validateNumber(value, type);
        throw new $d4ecdbf520e63dca$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $d4ecdbf520e63dca$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $d4ecdbf520e63dca$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $d4ecdbf520e63dca$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d4ecdbf520e63dca$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d4ecdbf520e63dca$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $d4ecdbf520e63dca$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $d4ecdbf520e63dca$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d4ecdbf520e63dca$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d4ecdbf520e63dca$var$base64ToBytes(str) {
    return $034686670a8a195b$export$d622b2ad8d90c771($d4ecdbf520e63dca$var$base64clean(str));
}
function $d4ecdbf520e63dca$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d4ecdbf520e63dca$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d4ecdbf520e63dca$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $d4ecdbf520e63dca$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $d4ecdbf520e63dca$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $d4ecdbf520e63dca$var$BufferBigIntNotDefined : fn;
}
function $d4ecdbf520e63dca$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $c799687f236c7f28$require$Buffer = $d4ecdbf520e63dca$export$a143d493d941bafc;
/**
 * @typedef {Object} MinionData
 * @property {Array<ArrayBuffer>} buffers Array of buffers.
 * @property {Object} meta Operation metadata.
 * @property {boolean} imageOps The operation is an image operation.
 * @property {number} width The width of the image.
 * @property {number} height The height of the image.
 */ /* istanbul ignore next */ /**
 * Create a function for running operations.  This function is serialized for
 * use in a worker.
 * @param {function(Array, Object):*} operation The operation.
 * @return {function(MinionData):ArrayBuffer} A function that takes an object with
 * buffers, meta, imageOps, width, and height properties and returns an array
 * buffer.
 */ function $c799687f236c7f28$var$createMinion(operation) {
    return function(data) {
        // bracket notation for minification support
        const buffers = data['buffers'];
        const meta = data['meta'];
        const imageOps = data['imageOps'];
        const width = data['width'];
        const height = data['height'];
        const numBuffers = buffers.length;
        const numBytes = buffers[0].byteLength;
        if (imageOps) {
            const images = new Array(numBuffers);
            for(let b = 0; b < numBuffers; ++b)images[b] = new ImageData(new Uint8ClampedArray(buffers[b]), width, height);
            const output = operation(images, meta).data;
            return output.buffer;
        }
        const output = new Uint8ClampedArray(numBytes);
        const arrays = new Array(numBuffers);
        const pixels = new Array(numBuffers);
        for(let b = 0; b < numBuffers; ++b){
            arrays[b] = new Uint8ClampedArray(buffers[b]);
            pixels[b] = [
                0,
                0,
                0,
                0
            ];
        }
        for(let i = 0; i < numBytes; i += 4){
            for(let j = 0; j < numBuffers; ++j){
                const array = arrays[j];
                pixels[j][0] = array[i];
                pixels[j][1] = array[i + 1];
                pixels[j][2] = array[i + 2];
                pixels[j][3] = array[i + 3];
            }
            const pixel = operation(pixels, meta);
            output[i] = pixel[0];
            output[i + 1] = pixel[1];
            output[i + 2] = pixel[2];
            output[i + 3] = pixel[3];
        }
        return output.buffer;
    };
}
/**
 * Create a worker for running operations.
 * @param {ProcessorOptions} config Processor options.
 * @param {function(MessageEvent): void} onMessage Called with a message event.
 * @return {Worker} The worker.
 */ function $c799687f236c7f28$var$createWorker(config, onMessage) {
    const lib = Object.keys(config.lib || {}).map(function(name) {
        return 'const ' + name + ' = ' + config.lib[name].toString() + ';';
    });
    const lines = lib.concat([
        'const __minion__ = (' + $c799687f236c7f28$var$createMinion.toString() + ')(',
        config.operation.toString(),
        ');',
        'self.addEventListener("message", function(event) {',
        '  const buffer = __minion__(event.data);',
        '  self.postMessage({buffer: buffer, meta: event.data.meta}, [buffer]);',
        '});'
    ]);
    const worker = new Worker(typeof Blob === 'undefined' ? 'data:text/javascript;base64,' + //@ts-expect-error
    $c799687f236c7f28$require$Buffer.from(lines.join('\n'), 'binary').toString('base64') : URL.createObjectURL(new Blob(lines, {
        type: 'text/javascript'
    })));
    worker.addEventListener('message', onMessage);
    return worker;
}
/**
 * @typedef {Object} FauxMessageEvent
 * @property {Object} data Message data.
 */ /**
 * Create a faux worker for running operations.
 * @param {ProcessorOptions} config Configuration.
 * @param {function(FauxMessageEvent): void} onMessage Called with a message event.
 * @return {Object} The faux worker.
 */ function $c799687f236c7f28$var$createFauxWorker(config, onMessage) {
    const minion = $c799687f236c7f28$var$createMinion(config.operation);
    let terminated = false;
    return {
        postMessage: function(data) {
            setTimeout(function() {
                if (terminated) return;
                onMessage({
                    data: {
                        buffer: minion(data),
                        meta: data['meta']
                    }
                });
            }, 0);
        },
        terminate: function() {
            terminated = true;
        }
    };
}
class $c799687f236c7f28$export$c30cd198d731db19 extends (0, $b54235dad6714a76$export$2e2bcd8739ae039) {
    /**
   * @param {ProcessorOptions} config Configuration.
   */ constructor(config){
        super();
        /**
     * @type {boolean}
     * @private
     */ this.imageOps_ = !!config.imageOps;
        let threads;
        if (config.threads === 0) threads = 0;
        else if (this.imageOps_) threads = 1;
        else threads = config.threads || 1;
        /**
     * @type {Array<Worker>}
     */ const workers = new Array(threads);
        if (threads) for(let i = 0; i < threads; ++i)workers[i] = $c799687f236c7f28$var$createWorker(config, this.onWorkerMessage_.bind(this, i));
        else workers[0] = $c799687f236c7f28$var$createFauxWorker(config, this.onWorkerMessage_.bind(this, 0));
        /**
     * @type {Array<Worker>}
     * @private
     */ this.workers_ = workers;
        /**
     * @type {Array<Job>}
     * @private
     */ this.queue_ = [];
        /**
     * @type {number}
     * @private
     */ this.maxQueueLength_ = config.queue || Infinity;
        /**
     * @type {number}
     * @private
     */ this.running_ = 0;
        /**
     * @type {Object<number, any>}
     * @private
     */ this.dataLookup_ = {};
        /**
     * @type {Job|null}
     * @private
     */ this.job_ = null;
    }
    /**
   * Run operation on input data.
   * @param {Array<ImageData>} inputs Array of image data.
   * @param {Object} meta A user data object.  This is passed to all operations
   *     and must be serializable.
   * @param {function(Error, ImageData, Object): void} callback Called when work
   *     completes.  The first argument is any error.  The second is the ImageData
   *     generated by operations.  The third is the user data object.
   */ process(inputs, meta, callback) {
        this.enqueue_({
            inputs: inputs,
            meta: meta,
            callback: callback
        });
        this.dispatch_();
    }
    /**
   * Add a job to the queue.
   * @param {Job} job The job.
   */ enqueue_(job) {
        this.queue_.push(job);
        while(this.queue_.length > this.maxQueueLength_)this.queue_.shift().callback(null, null);
    }
    /**
   * Dispatch a job.
   */ dispatch_() {
        if (this.running_ || this.queue_.length === 0) return;
        const job = this.queue_.shift();
        this.job_ = job;
        const width = job.inputs[0].width;
        const height = job.inputs[0].height;
        const buffers = job.inputs.map(function(input) {
            return input.data.buffer;
        });
        const threads = this.workers_.length;
        this.running_ = threads;
        if (threads === 1) {
            this.workers_[0].postMessage({
                buffers: buffers,
                meta: job.meta,
                imageOps: this.imageOps_,
                width: width,
                height: height
            }, buffers);
            return;
        }
        const length = job.inputs[0].data.length;
        const segmentLength = 4 * Math.ceil(length / 4 / threads);
        for(let i = 0; i < threads; ++i){
            const offset = i * segmentLength;
            const slices = [];
            for(let j = 0, jj = buffers.length; j < jj; ++j)slices.push(buffers[j].slice(offset, offset + segmentLength));
            this.workers_[i].postMessage({
                buffers: slices,
                meta: job.meta,
                imageOps: this.imageOps_,
                width: width,
                height: height
            }, slices);
        }
    }
    /**
   * Handle messages from the worker.
   * @param {number} index The worker index.
   * @param {MessageEvent} event The message event.
   */ onWorkerMessage_(index, event) {
        if (this.disposed) return;
        this.dataLookup_[index] = event.data;
        --this.running_;
        if (this.running_ === 0) this.resolveJob_();
    }
    /**
   * Resolve a job.  If there are no more worker threads, the processor callback
   * will be called.
   */ resolveJob_() {
        const job = this.job_;
        const threads = this.workers_.length;
        let data, meta;
        if (threads === 1) {
            data = new Uint8ClampedArray(this.dataLookup_[0]['buffer']);
            meta = this.dataLookup_[0]['meta'];
        } else {
            const length = job.inputs[0].data.length;
            data = new Uint8ClampedArray(length);
            meta = new Array(threads);
            const segmentLength = 4 * Math.ceil(length / 4 / threads);
            for(let i = 0; i < threads; ++i){
                const buffer = this.dataLookup_[i]['buffer'];
                const offset = i * segmentLength;
                data.set(new Uint8ClampedArray(buffer), offset);
                meta[i] = this.dataLookup_[i]['meta'];
            }
        }
        this.job_ = null;
        this.dataLookup_ = {};
        job.callback(null, new ImageData(data, job.inputs[0].width, job.inputs[0].height), meta);
        this.dispatch_();
    }
    /**
   * Terminate all workers associated with the processor.
   * @override
   */ disposeInternal() {
        for(let i = 0; i < this.workers_.length; ++i)this.workers_[i].terminate();
        this.workers_.length = 0;
    }
}
/**
 * A function that takes an array of input data, performs some operation, and
 * returns an array of output data.
 * For `pixel` type operations, the function will be called with an array of
 * pixels, where each pixel is an array of four numbers (`[r, g, b, a]`) in the
 * range of 0 - 255. It should return a single pixel array.
 * For `'image'` type operations, functions will be called with an array of
 * [ImageData](https://developer.mozilla.org/en-US/docs/Web/API/ImageData)
 * and should return a single
 * [ImageData](https://developer.mozilla.org/en-US/docs/Web/API/ImageData).
 * The operations
 * are called with a second "data" argument, which can be used for storage.  The
 * data object is accessible from raster events, where it can be initialized in
 * "beforeoperations" and accessed again in "afteroperations".
 *
 * @typedef {function((Array<Array<number>>|Array<ImageData>), Object):
 *     (Array<number>|ImageData)} Operation
 */ /**
 * @enum {string}
 */ const $c799687f236c7f28$var$RasterEventType = {
    /**
   * Triggered before operations are run.  Listeners will receive an event object with
   * a `data` property that can be used to make data available to operations.
   * @event module:ol/source/Raster.RasterSourceEvent#beforeoperations
   * @api
   */ BEFOREOPERATIONS: 'beforeoperations',
    /**
   * Triggered after operations are run.  Listeners will receive an event object with
   * a `data` property.  If more than one thread is used, `data` will be an array of
   * objects.  If a single thread is used, `data` will be a single object.
   * @event module:ol/source/Raster.RasterSourceEvent#afteroperations
   * @api
   */ AFTEROPERATIONS: 'afteroperations'
};
class $c799687f236c7f28$export$67177215309db11c extends (0, $bc90848f8b15fa29$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Type.
   * @param {import("../Map.js").FrameState} frameState The frame state.
   * @param {Object|Array<Object>} data An object made available to operations.  For "afteroperations" evenets
   * this will be an array of objects if more than one thread is used.
   */ constructor(type, frameState, data){
        super(type);
        /**
     * The raster extent.
     * @type {import("../extent.js").Extent}
     * @api
     */ this.extent = frameState.extent;
        /**
     * The pixel resolution (map units per pixel).
     * @type {number}
     * @api
     */ this.resolution = frameState.viewState.resolution / frameState.pixelRatio;
        /**
     * An object made available to all operations.  This can be used by operations
     * as a storage object (e.g. for calculating statistics).
     * @type {Object}
     * @api
     */ this.data = data;
    }
}
/**
 * @typedef {Object} Options
 * @property {Array<import("./Source.js").default|import("../layer/Layer.js").default>} sources Input
 * sources or layers.
 * @property {Operation} [operation] Raster operation.
 * The operation will be called with data from input sources
 * and the output will be assigned to the raster source.
 * @property {Object} [lib] Functions that will be made available to operations run in a worker.
 * @property {number} [threads] By default, operations will be run in a single worker thread.
 * To avoid using workers altogether, set `threads: 0`.  For pixel operations, operations can
 * be run in multiple worker threads.  Note that there is additional overhead in
 * transferring data to multiple workers, and that depending on the user's
 * system, it may not be possible to parallelize the work.
 * @property {RasterOperationType} [operationType='pixel'] Operation type.
 * Supported values are `'pixel'` and `'image'`.  By default,
 * `'pixel'` operations are assumed, and operations will be called with an
 * array of pixels from input sources.  If set to `'image'`, operations will
 * be called with an array of ImageData objects from input sources.
 * @property {Array<number>|null} [resolutions] Resolutions. If specified, raster operations will only
 * be run at the given resolutions.  By default, the resolutions of the first source with resolutions
 * specified will be used, if any. Set to `null` to use any view resolution instead.
 */ /***
 * @template Return
 * @typedef {import("../Observable.js").OnSignature<import("../Observable.js").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable.js").OnSignature<import("../ObjectEventType.js").Types, import("../Object.js").ObjectEvent, Return> &
 *   import("../Observable.js").OnSignature<import("./Image.js").ImageSourceEventTypes, import("./Image.js").ImageSourceEvent, Return> &
 *   import("../Observable.js").OnSignature<RasterSourceEventTypes, RasterSourceEvent, Return> &
 *   import("../Observable.js").CombinedOnSignature<import("../Observable.js").EventTypes|import("../ObjectEventType.js").Types
 *     |RasterSourceEventTypes, Return>} RasterSourceOnSignature
 */ /**
 * @classdesc
 * A source that transforms data from any number of input sources using an
 * {@link module:ol/source/Raster~Operation} function to transform input pixel values into
 * output pixel values.
 *
 * @fires module:ol/source/Raster.RasterSourceEvent
 * @api
 */ class $c799687f236c7f28$var$RasterSource extends (0, $a95be25e5eb82a6f$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        super({
            projection: null
        });
        /***
     * @type {RasterSourceOnSignature<import("../events.js").EventsKey>}
     */ this.on;
        /***
     * @type {RasterSourceOnSignature<import("../events.js").EventsKey>}
     */ this.once;
        /***
     * @type {RasterSourceOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {Processor}
     */ this.processor_ = null;
        /**
     * @private
     * @type {RasterOperationType}
     */ this.operationType_ = options.operationType !== undefined ? options.operationType : 'pixel';
        /**
     * @private
     * @type {number}
     */ this.threads_ = options.threads !== undefined ? options.threads : 1;
        /**
     * @private
     * @type {Array<import("../layer/Layer.js").default>}
     */ this.layers_ = $c799687f236c7f28$var$createLayers(options.sources);
        const changed = this.changed.bind(this);
        for(let i = 0, ii = this.layers_.length; i < ii; ++i)this.layers_[i].addEventListener((0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).CHANGE, changed);
        /**
     * @private
     * @type {boolean}
     */ this.useResolutions_ = options.resolutions !== null;
        /**
     * @private
     * @type {import("../TileQueue.js").default}
     */ this.tileQueue_ = new (0, $0492c075e7d7702c$export$2e2bcd8739ae039)(function() {
            return 1;
        }, this.processSources_.bind(this));
        /**
     * The most recently requested frame state.
     * @type {import("../Map.js").FrameState}
     * @private
     */ this.requestedFrameState_;
        /**
     * The most recently rendered image canvas.
     * @type {import("../ImageCanvas.js").default}
     * @private
     */ this.renderedImageCanvas_ = null;
        /**
     * The most recently rendered revision.
     * @type {number}
     * @private
     */ this.renderedRevision_;
        /**
     * @private
     * @type {import("../Map.js").FrameState}
     */ this.frameState_ = {
            animate: false,
            coordinateToPixelTransform: (0, $eb597965bdcc8f43$export$185802fd694ee1f5)(),
            declutter: null,
            extent: null,
            index: 0,
            layerIndex: 0,
            layerStatesArray: $c799687f236c7f28$var$getLayerStatesArray(this.layers_),
            pixelRatio: 1,
            pixelToCoordinateTransform: (0, $eb597965bdcc8f43$export$185802fd694ee1f5)(),
            postRenderFunctions: [],
            size: [
                0,
                0
            ],
            tileQueue: this.tileQueue_,
            time: Date.now(),
            usedTiles: {},
            viewState: /** @type {import("../View.js").State} */ {
                rotation: 0
            },
            viewHints: [],
            wantedTiles: {},
            mapId: (0, $01f1986453243423$export$5e82334337e0f204)(this),
            renderTargets: {}
        };
        this.setAttributions(function(frameState) {
            /** @type {Array<string>} */ const attributions = [];
            for(let i = 0, iMax = options.sources.length; i < iMax; ++i){
                const sourceOrLayer = options.sources[i];
                const source = sourceOrLayer instanceof (0, $039754a80ce105f8$export$2e2bcd8739ae039) ? sourceOrLayer : sourceOrLayer.getSource();
                if (!source) continue;
                const sourceAttributions = source.getAttributions()?.(frameState);
                if (typeof sourceAttributions === 'string') attributions.push(sourceAttributions);
                else if (sourceAttributions !== undefined) attributions.push(...sourceAttributions);
            }
            return attributions;
        });
        if (options.operation !== undefined) this.setOperation(options.operation, options.lib);
    }
    /**
   * Set the operation.
   * @param {Operation} operation New operation.
   * @param {Object} [lib] Functions that will be available to operations run
   *     in a worker.
   * @api
   */ setOperation(operation, lib) {
        if (this.processor_) this.processor_.dispose();
        this.processor_ = new $c799687f236c7f28$export$c30cd198d731db19({
            operation: operation,
            imageOps: this.operationType_ === 'image',
            queue: 1,
            lib: lib,
            threads: this.threads_
        });
        this.changed();
    }
    /**
   * Update the stored frame state.
   * @param {import("../extent.js").Extent} extent The view extent (in map units).
   * @param {number} resolution The view resolution.
   * @param {import("../proj/Projection.js").default} projection The view projection.
   * @return {import("../Map.js").FrameState} The updated frame state.
   * @private
   */ updateFrameState_(extent, resolution, projection) {
        const frameState = /** @type {import("../Map.js").FrameState} */ Object.assign({}, this.frameState_);
        frameState.viewState = /** @type {import("../View.js").State} */ Object.assign({}, frameState.viewState);
        const center = (0, $3412ad7bd362b04c$export$c91255cadecfe081)(extent);
        frameState.size[0] = Math.ceil((0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(extent) / resolution);
        frameState.size[1] = Math.ceil((0, $3412ad7bd362b04c$export$c08559766941f856)(extent) / resolution);
        frameState.extent = [
            center[0] - frameState.size[0] * resolution / 2,
            center[1] - frameState.size[1] * resolution / 2,
            center[0] + frameState.size[0] * resolution / 2,
            center[1] + frameState.size[1] * resolution / 2
        ];
        frameState.time = Date.now();
        const viewState = frameState.viewState;
        viewState.center = center;
        viewState.projection = projection;
        viewState.resolution = resolution;
        return frameState;
    }
    /**
   * Determine if all sources are ready.
   * @return {boolean} All sources are ready.
   * @private
   */ allSourcesReady_() {
        let ready = true;
        let source;
        for(let i = 0, ii = this.layers_.length; i < ii; ++i){
            source = this.layers_[i].getSource();
            if (!source || source.getState() !== 'ready') {
                ready = false;
                break;
            }
        }
        return ready;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../ImageCanvas.js").default} Single image.
   * @override
   */ getImage(extent, resolution, pixelRatio, projection) {
        if (!this.allSourcesReady_()) return null;
        this.tileQueue_.loadMoreTiles(16, 16);
        resolution = this.findNearestResolution(resolution);
        const frameState = this.updateFrameState_(extent, resolution, projection);
        this.requestedFrameState_ = frameState;
        // check if we can't reuse the existing ol/ImageCanvas
        if (this.renderedImageCanvas_) {
            const renderedResolution = this.renderedImageCanvas_.getResolution();
            const renderedExtent = this.renderedImageCanvas_.getExtent();
            if (resolution !== renderedResolution || !(0, $3412ad7bd362b04c$export$e9bab7fafb253603)(frameState.extent, renderedExtent)) this.renderedImageCanvas_ = null;
        }
        if (!this.renderedImageCanvas_ || this.getRevision() !== this.renderedRevision_) this.processSources_();
        if (frameState.animate) requestAnimationFrame(this.changed.bind(this));
        return this.renderedImageCanvas_;
    }
    /**
   * Start processing source data.
   * @private
   */ processSources_() {
        const frameState = this.requestedFrameState_;
        const len = this.layers_.length;
        const imageDatas = new Array(len);
        for(let i = 0; i < len; ++i){
            frameState.layerIndex = i;
            frameState.renderTargets = {};
            const imageData = $c799687f236c7f28$var$getImageData(this.layers_[i], frameState);
            if (imageData) imageDatas[i] = imageData;
            else return;
        }
        const data = {};
        this.dispatchEvent(new $c799687f236c7f28$export$67177215309db11c($c799687f236c7f28$var$RasterEventType.BEFOREOPERATIONS, frameState, data));
        this.processor_.process(imageDatas, data, this.onWorkerComplete_.bind(this, frameState));
    }
    /**
   * Called when pixel processing is complete.
   * @param {import("../Map.js").FrameState} frameState The frame state.
   * @param {Error} err Any error during processing.
   * @param {ImageData} output The output image data.
   * @param {Object|Array<Object>} data The user data (or an array if more than one thread).
   * @private
   */ onWorkerComplete_(frameState, err, output, data) {
        if (err || !output) return;
        // do nothing if extent or resolution changed
        const extent = frameState.extent;
        const resolution = frameState.viewState.resolution;
        if (resolution !== this.requestedFrameState_.viewState.resolution || !(0, $3412ad7bd362b04c$export$e9bab7fafb253603)(extent, this.requestedFrameState_.extent)) return;
        let context;
        if (this.renderedImageCanvas_) context = /** @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D} */ this.renderedImageCanvas_.getImage().getContext('2d');
        else {
            const width = Math.round((0, $3412ad7bd362b04c$export$3c49c185de0c2bfc)(extent) / resolution);
            const height = Math.round((0, $3412ad7bd362b04c$export$c08559766941f856)(extent) / resolution);
            context = (0, $5ce605ba3ee034a0$export$9e05d10eae75c464)(width, height);
            this.renderedImageCanvas_ = new (0, $35d90f15f510f1c3$export$2e2bcd8739ae039)(extent, resolution, 1, context.canvas);
        }
        context.putImageData(output, 0, 0);
        if (frameState.animate) requestAnimationFrame(this.changed.bind(this));
        else this.changed();
        this.renderedRevision_ = this.getRevision();
        this.dispatchEvent(new $c799687f236c7f28$export$67177215309db11c($c799687f236c7f28$var$RasterEventType.AFTEROPERATIONS, frameState, data));
    }
    /**
   * @param {import("../proj/Projection.js").default} [projection] Projection.
   * @return {Array<number>|null} Resolutions.
   * @override
   */ getResolutions(projection) {
        if (!this.useResolutions_) return null;
        let resolutions = super.getResolutions();
        if (!resolutions) for(let i = 0, ii = this.layers_.length; i < ii; ++i){
            const source = this.layers_[i].getSource();
            resolutions = source.getResolutions(projection);
            if (resolutions) break;
        }
        return resolutions;
    }
    /**
   * @override
   */ disposeInternal() {
        if (this.processor_) this.processor_.dispose();
        super.disposeInternal();
    }
}
/**
 * Clean up and unregister the worker.
 * @function
 * @api
 */ $c799687f236c7f28$var$RasterSource.prototype.dispose;
/**
 * A reusable canvas context.
 * @type {CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D}
 * @private
 */ let $c799687f236c7f28$var$sharedContext = null;
/**
 * Get image data from a layer.
 * @param {import("../layer/Layer.js").default} layer Layer to render.
 * @param {import("../Map.js").FrameState} frameState The frame state.
 * @return {ImageData} The image data.
 */ function $c799687f236c7f28$var$getImageData(layer, frameState) {
    const renderer = layer.getRenderer();
    if (!renderer) throw new Error('Unsupported layer type: ' + layer);
    if (!renderer.prepareFrame(frameState)) return null;
    const width = frameState.size[0];
    const height = frameState.size[1];
    if (width === 0 || height === 0) return null;
    const container = renderer.renderFrame(frameState, null);
    let element;
    if (container instanceof HTMLCanvasElement) element = container;
    else {
        if (container) element = container.firstElementChild;
        if (!(element instanceof HTMLCanvasElement)) throw new Error('Unsupported rendered element: ' + element);
        if (element.width === width && element.height === height) {
            const context = element.getContext('2d');
            return context.getImageData(0, 0, width, height);
        }
    }
    if (!$c799687f236c7f28$var$sharedContext) $c799687f236c7f28$var$sharedContext = (0, $5ce605ba3ee034a0$export$9e05d10eae75c464)(width, height, undefined, {
        willReadFrequently: true
    });
    else {
        const canvas = $c799687f236c7f28$var$sharedContext.canvas;
        if (canvas.width !== width || canvas.height !== height) $c799687f236c7f28$var$sharedContext = (0, $5ce605ba3ee034a0$export$9e05d10eae75c464)(width, height, undefined, {
            willReadFrequently: true
        });
        else $c799687f236c7f28$var$sharedContext.clearRect(0, 0, width, height);
    }
    $c799687f236c7f28$var$sharedContext.drawImage(element, 0, 0, width, height);
    return $c799687f236c7f28$var$sharedContext.getImageData(0, 0, width, height);
}
/**
 * Get a list of layer states from a list of layers.
 * @param {Array<import("../layer/Layer.js").default>} layers Layers.
 * @return {Array<import("../layer/Layer.js").State>} The layer states.
 */ function $c799687f236c7f28$var$getLayerStatesArray(layers) {
    return layers.map(function(layer) {
        return layer.getLayerState();
    });
}
/**
 * Create layers for all sources.
 * @param {Array<import("./Source.js").default|import("../layer/Layer.js").default>} sources The sources.
 * @return {Array<import("../layer/Layer.js").default>} Array of layers.
 */ function $c799687f236c7f28$var$createLayers(sources) {
    const len = sources.length;
    const layers = new Array(len);
    for(let i = 0; i < len; ++i)layers[i] = $c799687f236c7f28$var$createLayer(sources[i]);
    return layers;
}
/**
 * Create a layer for the provided source.
 * @param {import("./Source.js").default|import("../layer/Layer.js").default} layerOrSource The layer or source.
 * @return {import("../layer/Layer.js").default} The layer.
 */ function $c799687f236c7f28$var$createLayer(layerOrSource) {
    // @type {import("../layer/Layer.js").default}
    let layer;
    if (layerOrSource instanceof (0, $039754a80ce105f8$export$2e2bcd8739ae039)) {
        if (layerOrSource instanceof (0, $b198f34e90170996$export$2e2bcd8739ae039)) layer = new (0, $356faab3821ea36b$export$2e2bcd8739ae039)({
            source: layerOrSource
        });
        else if (layerOrSource instanceof (0, $a95be25e5eb82a6f$export$2e2bcd8739ae039)) layer = new (0, $733c124325e59ca7$export$2e2bcd8739ae039)({
            source: layerOrSource
        });
    } else layer = layerOrSource;
    return layer;
}
var $c799687f236c7f28$export$2e2bcd8739ae039 = $c799687f236c7f28$var$RasterSource;



/**
 * Generates a shaded relief image given elevation data.  Uses a 3x3
 * neighborhood for determining slope and aspect.
 * Supports multiple hillshade algorithms matching MapLibre's
 * {@link https://github.com/maplibre/maplibre-gl-js/blob/main/src/shaders/hillshade.fragment.glsl hillshade.fragment.glsl}:
 * standard, basic, combined, igor, and multidirectional.
 * @type {import('ol/source/Raster.js').Operation}
 */ function $9ebd86d05c6dff70$export$f01104271975e695(inputs, data) {
    const elevationImage = /** @type {ImageData} */ inputs[0];
    const width = elevationImage.width;
    const height = elevationImage.height;
    const elevationData = elevationImage.data;
    const shadeData = new Uint8ClampedArray(elevationData.length);
    const dp = data.resolution * 2;
    const maxX = width - 1;
    const maxY = height - 1;
    const pixel = [
        0,
        0,
        0,
        0
    ];
    const PI = Math.PI;
    const encoding = data.encoding;
    const intensity = data.exaggeration;
    const zoom = data.zoom;
    const method = data.method || 'standard';
    // Colors
    const accentColor = data.accentColor;
    const shadowColors = data.shadowColors || [
        data.shadowColor
    ];
    const highlightColors = data.highlightColors || [
        data.highlightColor
    ];
    // Azimuths in radians
    const azimuths = data.azimuths || [
        data.sunAz
    ];
    const azimuthsRad = azimuths.map((a)=>a * PI / 180);
    // Altitudes in radians (for basic, combined, multidirectional)
    const altitudes = data.altitudes || [
        45
    ];
    const altitudesRad = altitudes.map((a)=>a * PI / 180);
    // Number of light sources (for multidirectional, max 4)
    const numSources = Math.min(azimuthsRad.length, altitudesRad.length, shadowColors.length, highlightColors.length, 4);
    // Zoom-dependent exaggeration factor from MapLibre's hillshade_prepare.fragment.glsl
    // At low zooms, derivatives are amplified so hillshading remains visible.
    const exaggerationFactor = zoom < 2 ? 0.4 : zoom < 4.5 ? 0.35 : 0.3;
    const zoomExaggeration = zoom < 15 ? Math.pow(2, (15 - zoom) * exaggerationFactor) : 1;
    function calculateElevation(pixel, encoding = 'mapbox') {
        if (encoding === 'mapbox') return (pixel[0] * 65536 + pixel[1] * 256 + pixel[2]) * 0.1 - 10000;
        if (encoding === 'terrarium') return pixel[0] * 256 + pixel[1] + pixel[2] / 256 - 32768;
        return 0;
    }
    function getAspect(dzdx, dzdy) {
        if (dzdx !== 0) return Math.atan2(dzdy, -dzdx);
        return PI / 2 * (dzdy > 0 ? 1 : -1);
    }
    // Per-pixel shading for standard (legacy) algorithm
    function standardShade(dzdx, dzdy) {
        const azimuth = azimuthsRad[0] + PI;
        const slope = Math.atan(0.625 * Math.sqrt(dzdx * dzdx + dzdy * dzdy));
        const aspect = getAspect(dzdx, dzdy);
        const base = 1.875 - intensity * 1.75;
        const maxValue = 0.5 * PI;
        const scaledSlope = intensity !== 0.5 ? (Math.pow(base, slope) - 1) / (Math.pow(base, maxValue) - 1) * maxValue : slope;
        // Accent color
        const accent = Math.cos(scaledSlope);
        const intensityScale = Math.min(Math.max(intensity * 2, 0), 1);
        const accentScale = (1 - accent) * intensityScale;
        const ac = accentColor;
        const ar = ac.r * accentScale;
        const ag = ac.g * accentScale;
        const ab = ac.b * accentScale;
        const aa = ac.a * accentScale;
        // Shade color
        let val = (aspect + azimuth) / PI + 0.5;
        val = val % 2;
        if (val < 0) val += 2;
        const shade = Math.abs(val - 1);
        const shadeScale = Math.sin(scaledSlope) * intensityScale;
        const sc = shadowColors[0];
        const hc = highlightColors[0];
        const sr = (sc.r * (1 - shade) + hc.r * shade) * shadeScale;
        const sg = (sc.g * (1 - shade) + hc.g * shade) * shadeScale;
        const sb = (sc.b * (1 - shade) + hc.b * shade) * shadeScale;
        const sa = (sc.a * (1 - shade) + hc.a * shade) * shadeScale;
        // Composite (premultiplied alpha)
        return [
            ar * (1 - sa) + sr,
            ag * (1 - sa) + sg,
            ab * (1 - sa) + sb,
            aa * (1 - sa) + sa
        ];
    }
    // Igor algorithm - minimizes effects on underlying map features
    // Based on Maperitive's Igor algorithm
    function igorShade(dzdx, dzdy) {
        dzdx *= intensity * 2;
        dzdy *= intensity * 2;
        const aspect = getAspect(dzdx, dzdy);
        const azimuth = azimuthsRad[0] + PI;
        const slopeStrength = Math.atan(Math.sqrt(dzdx * dzdx + dzdy * dzdy)) * (2 / PI);
        let val = (aspect + azimuth) / PI + 0.5;
        val = val % 2;
        if (val < 0) val += 2;
        const aspectStrength = 1 - Math.abs(val - 1);
        const shadowStr = slopeStrength * aspectStrength;
        const highlightStr = slopeStrength * (1 - aspectStrength);
        const sc = shadowColors[0];
        const hc = highlightColors[0];
        return [
            sc.r * shadowStr + hc.r * highlightStr,
            sc.g * shadowStr + hc.g * highlightStr,
            sc.b * shadowStr + hc.b * highlightStr,
            sc.a * shadowStr + hc.a * highlightStr
        ];
    }
    // Basic hillshade - simple physics-based model (similar to GDAL default)
    function basicShade(dzdx, dzdy) {
        dzdx *= intensity * 2;
        dzdy *= intensity * 2;
        const azimuth = azimuthsRad[0] + PI;
        const cosAz = Math.cos(azimuth);
        const sinAz = Math.sin(azimuth);
        const cosAlt = Math.cos(altitudesRad[0]);
        const sinAlt = Math.sin(altitudesRad[0]);
        const cang = (sinAlt - (dzdy * cosAz * cosAlt - dzdx * sinAz * cosAlt)) / Math.sqrt(1 + dzdx * dzdx + dzdy * dzdy);
        const shade = Math.max(0, Math.min(1, cang));
        if (shade > 0.5) {
            const f = 2 * shade - 1;
            const c = highlightColors[0];
            return [
                c.r * f,
                c.g * f,
                c.b * f,
                c.a * f
            ];
        }
        const f = 1 - 2 * shade;
        const c = shadowColors[0];
        return [
            c.r * f,
            c.g * f,
            c.b * f,
            c.a * f
        ];
    }
    // Combined hillshade - combines slope and oblique shading (similar to GDAL -combined)
    function combinedShade(dzdx, dzdy) {
        dzdx *= intensity * 2;
        dzdy *= intensity * 2;
        const azimuth = azimuthsRad[0] + PI;
        const cosAz = Math.cos(azimuth);
        const sinAz = Math.sin(azimuth);
        const cosAlt = Math.cos(altitudesRad[0]);
        const sinAlt = Math.sin(altitudesRad[0]);
        let cang = Math.acos((sinAlt - (dzdy * cosAz * cosAlt - dzdx * sinAz * cosAlt)) / Math.sqrt(1 + dzdx * dzdx + dzdy * dzdy));
        cang = Math.max(0, Math.min(PI / 2, cang));
        const slopeAtan = Math.atan(Math.sqrt(dzdx * dzdx + dzdy * dzdy)) * (4 / PI / PI);
        const shade = cang * slopeAtan;
        const highlight = (PI / 2 - cang) * slopeAtan;
        const sc = shadowColors[0];
        const hc = highlightColors[0];
        return [
            sc.r * shade + hc.r * highlight,
            sc.g * shade + hc.g * highlight,
            sc.b * shade + hc.b * highlight,
            sc.a * shade + hc.a * highlight
        ];
    }
    // Multidirectional hillshade - combines illumination from multiple light sources
    // Based on USGS methodology
    function multidirectionalShade(dzdx, dzdy) {
        dzdx *= intensity * 2;
        dzdy *= intensity * 2;
        const dotDeriv = dzdx * dzdx + dzdy * dzdy;
        const sqrtDot = Math.sqrt(1 + dotDeriv);
        let rr = 0;
        let rg = 0;
        let rb = 0;
        let ra = 0;
        for(let i = 0; i < numSources; i++){
            const cosAlt = Math.cos(altitudesRad[i]);
            const sinAlt = Math.sin(altitudesRad[i]);
            // Note: multidirectional uses -cos/-sin (no +PI offset)
            const cosAz = -Math.cos(azimuthsRad[i]);
            const sinAz = -Math.sin(azimuthsRad[i]);
            const cang = (sinAlt - (dzdy * cosAz * cosAlt - dzdx * sinAz * cosAlt)) / sqrtDot;
            const shade = Math.max(0, Math.min(1, cang));
            const sc = shadowColors[Math.min(i, shadowColors.length - 1)];
            const hc = highlightColors[Math.min(i, highlightColors.length - 1)];
            if (shade > 0.5) {
                const f = (2 * shade - 1) / numSources;
                rr += hc.r * f;
                rg += hc.g * f;
                rb += hc.b * f;
                ra += hc.a * f;
            } else {
                const f = (1 - 2 * shade) / numSources;
                rr += sc.r * f;
                rg += sc.g * f;
                rb += sc.b * f;
                ra += sc.a * f;
            }
        }
        return [
            rr,
            rg,
            rb,
            ra
        ];
    }
    // Select shading function based on method
    const shadeFn = method === 'igor' ? igorShade : method === 'basic' ? basicShade : method === 'combined' ? combinedShade : method === 'multidirectional' ? multidirectionalShade : standardShade;
    let pixelX, pixelY, x0, x1, y0, y1, offset, z0, z1, dzdx, dzdy;
    for(pixelY = 0; pixelY <= maxY; ++pixelY){
        y0 = pixelY === 0 ? 0 : pixelY - 1;
        y1 = pixelY === maxY ? maxY : pixelY + 1;
        for(pixelX = 0; pixelX <= maxX; ++pixelX){
            x0 = pixelX === 0 ? 0 : pixelX - 1;
            x1 = pixelX === maxX ? maxX : pixelX + 1;
            // determine elevation for (x0, pixelY)
            offset = (pixelY * width + x0) * 4;
            pixel[0] = elevationData[offset];
            pixel[1] = elevationData[offset + 1];
            pixel[2] = elevationData[offset + 2];
            pixel[3] = elevationData[offset + 3];
            z0 = calculateElevation(pixel, encoding);
            // determine elevation for (x1, pixelY)
            offset = (pixelY * width + x1) * 4;
            pixel[0] = elevationData[offset];
            pixel[1] = elevationData[offset + 1];
            pixel[2] = elevationData[offset + 2];
            pixel[3] = elevationData[offset + 3];
            z1 = calculateElevation(pixel, encoding);
            dzdx = (z1 - z0) / dp * zoomExaggeration;
            // determine elevation for (pixelX, y0)
            offset = (y0 * width + pixelX) * 4;
            pixel[0] = elevationData[offset];
            pixel[1] = elevationData[offset + 1];
            pixel[2] = elevationData[offset + 2];
            pixel[3] = elevationData[offset + 3];
            z0 = calculateElevation(pixel, encoding);
            // determine elevation for (pixelX, y1)
            offset = (y1 * width + pixelX) * 4;
            pixel[0] = elevationData[offset];
            pixel[1] = elevationData[offset + 1];
            pixel[2] = elevationData[offset + 2];
            pixel[3] = elevationData[offset + 3];
            z1 = calculateElevation(pixel, encoding);
            dzdy = (z1 - z0) / dp * zoomExaggeration;
            // Compute shading (result is premultiplied alpha)
            const result = shadeFn(dzdx, dzdy);
            // Un-premultiply for Canvas ImageData (straight alpha)
            const a = result[3];
            offset = (pixelY * width + pixelX) * 4;
            if (a > 0) {
                shadeData[offset] = result[0] / a * 255;
                shadeData[offset + 1] = result[1] / a * 255;
                shadeData[offset + 2] = result[2] / a * 255;
            }
            shadeData[offset + 3] = a * 255;
        }
    }
    return new ImageData(shadeData, width, height);
}
function $9ebd86d05c6dff70$export$abf1f7e1a47af2a9(inputs, data) {
    const image = /** @type {ImageData} */ inputs[0];
    const width = image.width;
    const height = image.height;
    const imageData = image.data;
    const shadeData = new Uint8ClampedArray(imageData.length);
    const maxX = width - 1;
    const maxY = height - 1;
    const pixel = [
        0,
        0,
        0,
        0
    ];
    let pixelX, pixelY, offset;
    /*
   * The following functions have the same math as <https://github.com/maplibre/maplibre-gl-js/blob/5518ede00ef769fed1ca4f54f6d970885987fb22/src/render/program/raster_program.ts#L76>
   *   - calculateContrastFactor
   *   - calculateSaturationFactor
   *   - generateSpinWeights
   */ function calculateContrastFactor(contrast) {
        return contrast > 0 ? 1 / (1 - contrast) : 1 + contrast;
    }
    function calculateSaturationFactor(saturation) {
        return saturation > 0 ? 1 - 1 / (1.001 - saturation) : -saturation;
    }
    function generateSpinWeights(angle) {
        angle *= Math.PI / 180;
        const s = Math.sin(angle);
        const c = Math.cos(angle);
        return [
            (2 * c + 1) / 3,
            (-Math.sqrt(3) * s - c + 1) / 3,
            (Math.sqrt(3) * s - c + 1) / 3
        ];
    }
    const sFactor = calculateSaturationFactor(data.saturation);
    const cFactor = calculateContrastFactor(data.contrast);
    const cSpinWeights = generateSpinWeights(data.hueRotate);
    const cSpinWeightsXYZ = cSpinWeights;
    const cSpinWeightsZXY = [
        cSpinWeights[2],
        cSpinWeights[0],
        cSpinWeights[1]
    ];
    const cSpinWeightsYZX = [
        cSpinWeights[1],
        cSpinWeights[2],
        cSpinWeights[0]
    ];
    const bLow = data.brightnessLow;
    const bHigh = data.brightnessHigh;
    for(pixelY = 0; pixelY <= maxY; ++pixelY)for(pixelX = 0; pixelX <= maxX; ++pixelX){
        offset = (pixelY * width + pixelX) * 4;
        pixel[0] = imageData[offset];
        pixel[1] = imageData[offset + 1];
        pixel[2] = imageData[offset + 2];
        pixel[3] = imageData[offset + 3];
        const or = pixel[0];
        const og = pixel[1];
        const ob = pixel[2];
        const dotProduct = (vector1, vector2)=>{
            let result = 0;
            for(let i = 0; i < vector1.length; i++)result += vector1[i] * vector2[i];
            return result;
        };
        // hue-rotate
        let r = dotProduct([
            or,
            og,
            ob
        ], cSpinWeightsXYZ);
        let g = dotProduct([
            or,
            og,
            ob
        ], cSpinWeightsZXY);
        let b = dotProduct([
            or,
            og,
            ob
        ], cSpinWeightsYZX);
        // saturation
        const average = (r + g + b) / 3;
        r += (average - r) * sFactor;
        g += (average - g) * sFactor;
        b += (average - b) * sFactor;
        // contrast
        r = (r - 127.5) * cFactor + 127.5;
        g = (g - 127.5) * cFactor + 127.5;
        b = (b - 127.5) * cFactor + 127.5;
        // brightness
        r = bLow * (255 - r) + bHigh * r;
        g = bLow * (255 - g) + bHigh * g;
        b = bLow * (255 - b) + bHigh * b;
        shadeData[offset] = r;
        shadeData[offset + 1] = g;
        shadeData[offset + 2] = b;
        shadeData[offset + 3] = pixel[3];
    }
    return new ImageData(shadeData, width, height);
}


/*
ol-mapbox-style - Use Mapbox/MapLibre Style objects with OpenLayers
Copyright 2016-present ol-mapbox-style contributors
License: https://raw.githubusercontent.com/openlayers/ol-mapbox-style/master/LICENSE
*/ 
var $01c264c2ae87dd64$var$fontWeights = {
    thin: 100,
    hairline: 100,
    'ultra-light': 200,
    'extra-light': 200,
    light: 300,
    book: 300,
    regular: 400,
    normal: 400,
    plain: 400,
    roman: 400,
    standard: 400,
    medium: 500,
    'semi-bold': 600,
    'demi-bold': 600,
    bold: 700,
    'extra-bold': 800,
    'ultra-bold': 800,
    heavy: 900,
    black: 900,
    'heavy-black': 900,
    fat: 900,
    poster: 900,
    'ultra-black': 950,
    'extra-black': 950
};
var $01c264c2ae87dd64$var$sp = ' ';
var $01c264c2ae87dd64$var$italicRE = /(italic|oblique)$/i;
var $01c264c2ae87dd64$var$fontCache = {};
function $01c264c2ae87dd64$export$2e2bcd8739ae039(fonts, size, lineHeight) {
    var cssData = $01c264c2ae87dd64$var$fontCache[fonts];
    if (!cssData) {
        if (!Array.isArray(fonts)) fonts = [
            fonts
        ];
        var weight = 400;
        var style = 'normal';
        var fontFamilies = [];
        var haveWeight, haveStyle;
        for(var i = 0, ii = fonts.length; i < ii; ++i){
            var font = fonts[i];
            var parts = font.split(' ');
            var maybeWeight = parts[parts.length - 1].toLowerCase();
            if (maybeWeight == 'normal' || maybeWeight == 'italic' || maybeWeight == 'oblique') {
                style = haveStyle ? style : maybeWeight;
                haveStyle = true;
                parts.pop();
                maybeWeight = parts[parts.length - 1].toLowerCase();
            } else if ($01c264c2ae87dd64$var$italicRE.test(maybeWeight)) {
                maybeWeight = maybeWeight.replace($01c264c2ae87dd64$var$italicRE, '');
                style = haveStyle ? style : parts[parts.length - 1].replace(maybeWeight, '');
                haveStyle = true;
            }
            for(var w in $01c264c2ae87dd64$var$fontWeights){
                var previousPart = parts.length > 1 ? parts[parts.length - 2].toLowerCase() : '';
                if (maybeWeight == w || maybeWeight == w.replace('-', '') || previousPart + '-' + maybeWeight == w) {
                    weight = haveWeight ? weight : $01c264c2ae87dd64$var$fontWeights[w];
                    parts.pop();
                    if (previousPart && w.startsWith(previousPart)) parts.pop();
                    break;
                }
            }
            if (!haveWeight && typeof maybeWeight == 'number') {
                weight = maybeWeight;
                haveWeight = true;
            }
            var fontFamily = parts.join($01c264c2ae87dd64$var$sp).replace('Klokantech Noto Sans', 'Noto Sans').replace('DIN Pro', 'Barlow').replace('Arial Unicode MS', 'Arial');
            if (fontFamily.indexOf($01c264c2ae87dd64$var$sp) !== -1) fontFamily = '"' + fontFamily + '"';
            fontFamilies.push(fontFamily);
        }
        // CSS font property: font-style font-weight font-size/line-height font-family
        cssData = $01c264c2ae87dd64$var$fontCache[fonts] = [
            style,
            weight,
            fontFamilies
        ];
    }
    return cssData[0] + $01c264c2ae87dd64$var$sp + cssData[1] + $01c264c2ae87dd64$var$sp + size + 'px' + (lineHeight ? '/' + lineHeight : '') + $01c264c2ae87dd64$var$sp + cssData[2];
}






















const $4f6c3bb417864b02$export$952e2b7e251b8b38 = Object.freeze({});
const $4f6c3bb417864b02$var$functionCacheByStyleId = {};
const $4f6c3bb417864b02$var$filterCacheByStyleId = {};
let $4f6c3bb417864b02$var$styleId = 0;
function $4f6c3bb417864b02$export$fb278f46a98b8805(glStyle) {
    if (!glStyle.id) glStyle.id = $4f6c3bb417864b02$var$styleId++;
    return glStyle.id;
}
function $4f6c3bb417864b02$export$2e9c16762be40bb0(glStyle, olLayer) {
    return $4f6c3bb417864b02$export$fb278f46a98b8805(glStyle) + '.' + (0, $01f1986453243423$export$5e82334337e0f204)(olLayer);
}
function $4f6c3bb417864b02$export$fba1d5e26ba27516(glStyle) {
    let functionCache = $4f6c3bb417864b02$var$functionCacheByStyleId[glStyle.id];
    if (!functionCache) {
        functionCache = {};
        $4f6c3bb417864b02$var$functionCacheByStyleId[$4f6c3bb417864b02$export$fb278f46a98b8805(glStyle)] = functionCache;
    }
    return functionCache;
}
function $4f6c3bb417864b02$export$1ebbb340c3c51fbc() {
    for(const key in $4f6c3bb417864b02$var$functionCacheByStyleId)delete $4f6c3bb417864b02$var$functionCacheByStyleId[key];
}
function $4f6c3bb417864b02$export$330c4a8ebe9a8d1e(glStyle) {
    let filterCache = $4f6c3bb417864b02$var$filterCacheByStyleId[glStyle.id];
    if (!filterCache) {
        filterCache = {};
        $4f6c3bb417864b02$var$filterCacheByStyleId[$4f6c3bb417864b02$export$fb278f46a98b8805(glStyle)] = filterCache;
    }
    return filterCache;
}
function $4f6c3bb417864b02$export$b1b275608b2b1b8(degrees) {
    return degrees * Math.PI / 180;
}
const $4f6c3bb417864b02$export$f1479b9369ff0206 = function() {
    const resolutions = [];
    for(let res = 78271.51696402048; resolutions.length <= 24; res /= 2)resolutions.push(res);
    return resolutions;
}();
function $4f6c3bb417864b02$export$cd3d1f114b139967(width, height) {
    if (typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope && typeof OffscreenCanvas !== 'undefined') return /** @type {?} */ new OffscreenCanvas(width, height);
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    return canvas;
}
function $4f6c3bb417864b02$export$f8f663988f36f2e1(resolution, resolutions) {
    let i = 0;
    const ii = resolutions.length;
    for(; i < ii; ++i){
        const candidate = resolutions[i];
        if (candidate < resolution && i + 1 < ii) {
            const zoomFactor = resolutions[i] / resolutions[i + 1];
            return i + Math.log(resolutions[i] / resolution) / Math.log(zoomFactor);
        }
    }
    return ii - 1;
}
function $4f6c3bb417864b02$export$94fb592f1183c995(zoom, resolutions) {
    const base = Math.floor(zoom);
    const factor = Math.pow(2, zoom - base);
    return resolutions[base] / factor;
}
const $4f6c3bb417864b02$var$pendingRequests = {};
function $4f6c3bb417864b02$export$c3f39970a2f25d16(resourceType, url, options = {}, metadata) {
    if (url in $4f6c3bb417864b02$var$pendingRequests) {
        if (metadata) metadata.url = $4f6c3bb417864b02$var$pendingRequests[url][0].url;
        return $4f6c3bb417864b02$var$pendingRequests[url][1];
    }
    const transformedRequest = options.transformRequest ? options.transformRequest(url, resourceType) || url : url;
    const handleError = function(error) {
        delete $4f6c3bb417864b02$var$pendingRequests[url];
        return Promise.reject(new Error('Error fetching source ' + url));
    };
    const handleResponse = function(response) {
        delete $4f6c3bb417864b02$var$pendingRequests[url];
        return response.ok ? response.json() : Promise.reject(new Error('Error fetching source ' + url));
    };
    const pendingRequest = (0, $7efea016d660e267$export$4dbaaf6c79705e6c)(()=>transformedRequest).then((transformedRequest)=>{
        if (transformedRequest instanceof Response) {
            if (metadata) metadata.url = transformedRequest.url;
            return handleResponse(transformedRequest);
        }
        if (!(transformedRequest instanceof Request)) transformedRequest = new Request(transformedRequest);
        if (!transformedRequest.headers.get('Accept')) transformedRequest.headers.set('Accept', 'application/json');
        if (metadata) metadata.url = transformedRequest.url;
        return fetch(transformedRequest).then(handleResponse).catch(handleError);
    }).catch(handleError);
    $4f6c3bb417864b02$var$pendingRequests[url] = [
        transformedRequest,
        pendingRequest
    ];
    return pendingRequest;
}
function $4f6c3bb417864b02$export$2b5651466f978e42(glStyleOrUrl, options) {
    if (typeof glStyleOrUrl === 'string') {
        if (glStyleOrUrl.trim().startsWith('{')) try {
            const glStyle = JSON.parse(glStyleOrUrl);
            return Promise.resolve(glStyle);
        } catch (error) {
            return Promise.reject(error);
        }
        else {
            glStyleOrUrl = (0, $10d6e9cfb77b7759$export$c295124411c04466)(glStyleOrUrl, options.accessToken);
            return $4f6c3bb417864b02$export$c3f39970a2f25d16('Style', glStyleOrUrl, options);
        }
    } else return Promise.resolve(glStyleOrUrl);
}
const $4f6c3bb417864b02$var$tilejsonCache = {};
function $4f6c3bb417864b02$export$53a539a0cb0d8ede(glSource, styleUrl, options = {}) {
    const cacheKey = [
        styleUrl,
        JSON.stringify(glSource)
    ].toString();
    let promise = $4f6c3bb417864b02$var$tilejsonCache[cacheKey];
    if (!promise || options.transformRequest) {
        let tileLoadFunction;
        if (options.transformRequest) tileLoadFunction = (tile, src)=>{
            const transformedRequest = options.transformRequest ? options.transformRequest(src, 'Tiles') || src : src;
            if (tile instanceof (0, $9d3248ff4a4ffac2$export$2e2bcd8739ae039)) tile.setLoader((extent, resolution, projection)=>{
                const handleResponse = function(response) {
                    response.arrayBuffer().then((data)=>{
                        const format = tile.getFormat();
                        const features = format.readFeatures(data, {
                            extent: extent,
                            featureProjection: projection
                        });
                        // @ts-ignore
                        tile.setFeatures(features);
                    });
                };
                (0, $7efea016d660e267$export$4dbaaf6c79705e6c)(()=>transformedRequest).then((transformedRequest)=>{
                    if (transformedRequest instanceof Response) return handleResponse(transformedRequest);
                    fetch(transformedRequest).then(handleResponse).catch((e)=>tile.setState((0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).ERROR));
                }).catch((e)=>tile.setState((0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).ERROR));
            });
            else {
                const img = tile.getImage();
                (0, $7efea016d660e267$export$4dbaaf6c79705e6c)(()=>transformedRequest).then((transformedRequest)=>{
                    if (typeof transformedRequest === 'string') {
                        img.src = transformedRequest;
                        return;
                    }
                    const handleResponse = (response)=>response.blob().then((blob)=>{
                            const url = URL.createObjectURL(blob);
                            img.addEventListener('load', ()=>URL.revokeObjectURL(url));
                            img.addEventListener('error', ()=>URL.revokeObjectURL(url));
                            img.src = url;
                        });
                    if (transformedRequest instanceof Response) return handleResponse(transformedRequest);
                    fetch(transformedRequest).then(handleResponse).catch((e)=>tile.setState((0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).ERROR));
                }).catch((e)=>tile.setState((0, $b91d4eaa5c4015a3$export$2e2bcd8739ae039).ERROR));
            }
        };
        const url = glSource.url;
        if (url && !glSource.tiles) {
            const normalizedSourceUrl = (0, $10d6e9cfb77b7759$export$19109ee3fbff0f51)(url, options.accessToken, options.accessTokenParam || 'access_token', styleUrl || location.href);
            if (url.startsWith('mapbox://')) promise = Promise.resolve({
                tileJson: Object.assign({}, glSource, {
                    url: undefined,
                    tiles: normalizedSourceUrl
                }),
                tileLoadFunction: tileLoadFunction
            });
            else {
                const metadata = {};
                promise = $4f6c3bb417864b02$export$c3f39970a2f25d16('Source', normalizedSourceUrl[0], options, metadata).then(function(tileJson) {
                    tileJson.tiles = tileJson.tiles.map(function(tileUrl) {
                        if (tileJson.scheme === 'tms') tileUrl = tileUrl.replace('{y}', '{-y}');
                        return (0, $10d6e9cfb77b7759$export$19109ee3fbff0f51)(tileUrl, options.accessToken, options.accessTokenParam || 'access_token', metadata.url)[0];
                    });
                    return Promise.resolve({
                        tileJson: tileJson,
                        tileLoadFunction: tileLoadFunction
                    });
                });
            }
        } else if (glSource.tiles) {
            glSource = Object.assign({}, glSource, {
                tiles: glSource.tiles.map(function(tileUrl) {
                    if (glSource.scheme === 'tms') tileUrl = tileUrl.replace('{y}', '{-y}');
                    return (0, $10d6e9cfb77b7759$export$19109ee3fbff0f51)(tileUrl, options.accessToken, options.accessTokenParam || 'access_token', styleUrl || location.href)[0];
                })
            });
            promise = Promise.resolve({
                tileJson: Object.assign({}, glSource),
                tileLoadFunction: tileLoadFunction
            });
        } else promise = Promise.reject(new Error('source has no `tiles` nor `url`'));
        $4f6c3bb417864b02$var$tilejsonCache[cacheKey] = promise;
    }
    return promise;
}
function $4f6c3bb417864b02$export$76143e2926156ae4(spriteImage, spriteImageData, haloWidth, haloColor) {
    const imgSize = [
        2 * haloWidth * spriteImageData.pixelRatio + spriteImageData.width,
        2 * haloWidth * spriteImageData.pixelRatio + spriteImageData.height
    ];
    const imageCanvas = $4f6c3bb417864b02$export$cd3d1f114b139967(imgSize[0], imgSize[1]);
    const imageContext = imageCanvas.getContext('2d');
    imageContext.drawImage(spriteImage, spriteImageData.x, spriteImageData.y, spriteImageData.width, spriteImageData.height, haloWidth * spriteImageData.pixelRatio, haloWidth * spriteImageData.pixelRatio, spriteImageData.width, spriteImageData.height);
    const imageData = imageContext.getImageData(0, 0, imgSize[0], imgSize[1]);
    imageContext.globalCompositeOperation = 'destination-over';
    imageContext.fillStyle = `rgba(${haloColor.r * 255},${haloColor.g * 255},${haloColor.b * 255},${haloColor.a})`;
    const data = imageData.data;
    for(let i = 0, ii = imageData.width; i < ii; ++i)for(let j = 0, jj = imageData.height; j < jj; ++j){
        const index = (j * ii + i) * 4;
        const alpha = data[index + 3];
        if (alpha > 0) imageContext.arc(i, j, haloWidth * spriteImageData.pixelRatio, 0, 2 * Math.PI);
    }
    imageContext.fill();
    return imageCanvas;
}
function $4f6c3bb417864b02$var$smoothstep(min, max, value) {
    const x = Math.max(0, Math.min(1, (value - min) / (max - min)));
    return x * x * (3 - 2 * x);
}
function $4f6c3bb417864b02$export$9c562940726ba358(image, area, color) {
    const imageCanvas = $4f6c3bb417864b02$export$cd3d1f114b139967(area.width, area.height);
    const imageContext = imageCanvas.getContext('2d');
    imageContext.drawImage(image, area.x, area.y, area.width, area.height, 0, 0, area.width, area.height);
    const imageData = imageContext.getImageData(0, 0, area.width, area.height);
    const data = imageData.data;
    for(let i = 0, ii = imageData.width; i < ii; ++i)for(let j = 0, jj = imageData.height; j < jj; ++j){
        const index = (j * ii + i) * 4;
        const dist = data[index + 3] / 255;
        const buffer = 0.75;
        const gamma = 0.1;
        const alpha = $4f6c3bb417864b02$var$smoothstep(buffer - gamma, buffer + gamma, dist);
        if (alpha > 0) {
            data[index + 0] = Math.round(255 * color.r * alpha);
            data[index + 1] = Math.round(255 * color.g * alpha);
            data[index + 2] = Math.round(255 * color.b * alpha);
            data[index + 3] = Math.round(255 * alpha);
        } else data[index + 3] = 0;
    }
    imageContext.putImageData(imageData, 0, 0);
    return imageCanvas;
} /**
 * @typedef {import("./apply.js").Options} Options
 * @private
 */ 


const $86a2ca3c041b3852$var$hairSpacePool = Array(256).join('\u200A');
function $86a2ca3c041b3852$export$b532a8ed6cbc2f82(text, letterSpacing) {
    if (letterSpacing >= 0.05) {
        let textWithLetterSpacing = '';
        const lines = text.split('\n');
        const joinSpaceString = $86a2ca3c041b3852$var$hairSpacePool.slice(0, Math.round(letterSpacing / 0.1));
        for(let l = 0, ll = lines.length; l < ll; ++l){
            if (l > 0) textWithLetterSpacing += '\n';
            textWithLetterSpacing += lines[l].split('').join(joinSpaceString);
        }
        return textWithLetterSpacing;
    }
    return text;
}
let $86a2ca3c041b3852$var$measureContext;
function $86a2ca3c041b3852$var$getMeasureContext() {
    if (!$86a2ca3c041b3852$var$measureContext) $86a2ca3c041b3852$var$measureContext = (0, $4f6c3bb417864b02$export$cd3d1f114b139967)(1, 1).getContext('2d');
    return $86a2ca3c041b3852$var$measureContext;
}
function $86a2ca3c041b3852$var$fitWeight(fontWeight, weight) {
    if (/\d+ \d+/.test(fontWeight)) {
        const [start, end] = fontWeight.split(' ').map(Number);
        return start <= weight && weight <= end;
    }
    return fontWeight == weight;
}
function $86a2ca3c041b3852$var$measureText(text, letterSpacing) {
    return $86a2ca3c041b3852$var$getMeasureContext().measureText(text).width + (text.length - 1) * letterSpacing;
}
const $86a2ca3c041b3852$var$measureCache = {};
(0, $3b9b2e731b8ee924$export$1d36981fcadac93b).on('propertychange', ()=>{
    for(const key in $86a2ca3c041b3852$var$measureCache)delete $86a2ca3c041b3852$var$measureCache[key];
});
function $86a2ca3c041b3852$export$db1d31f4af680217(text, font, em, letterSpacing) {
    if (text.indexOf('\n') !== -1) {
        const hardLines = text.split('\n');
        const lines = [];
        for(let i = 0, ii = hardLines.length; i < ii; ++i)lines.push($86a2ca3c041b3852$export$db1d31f4af680217(hardLines[i], font, em, letterSpacing));
        return lines.join('\n');
    }
    const key = em + ',' + font + ',' + text + ',' + letterSpacing;
    let wrappedText = $86a2ca3c041b3852$var$measureCache[key];
    if (!wrappedText) {
        const words = text.split(' ');
        if (words.length > 1) {
            const ctx = $86a2ca3c041b3852$var$getMeasureContext();
            ctx.font = font;
            const oneEm = ctx.measureText('M').width;
            const maxWidth = oneEm * em;
            let line = '';
            const lines = [];
            // Pass 1 - wrap lines to not exceed maxWidth
            for(let i = 0, ii = words.length; i < ii; ++i){
                const word = words[i];
                const testLine = line + (line ? ' ' : '') + word;
                if ($86a2ca3c041b3852$var$measureText(testLine, letterSpacing) <= maxWidth) line = testLine;
                else {
                    if (line) lines.push(line);
                    line = word;
                }
            }
            if (line) lines.push(line);
            // Pass 2 - add lines with a width of less than 30% of maxWidth to the previous or next line
            for(let i = 0, ii = lines.length; i < ii && ii > 1; ++i){
                const line = lines[i];
                if ($86a2ca3c041b3852$var$measureText(line, letterSpacing) < maxWidth * 0.35) {
                    const prevWidth = i > 0 ? $86a2ca3c041b3852$var$measureText(lines[i - 1], letterSpacing) : Infinity;
                    const nextWidth = i < ii - 1 ? $86a2ca3c041b3852$var$measureText(lines[i + 1], letterSpacing) : Infinity;
                    lines.splice(i, 1);
                    ii -= 1;
                    if (prevWidth < nextWidth) {
                        lines[i - 1] += ' ' + line;
                        i -= 1;
                    } else lines[i] = line + ' ' + lines[i];
                }
            }
            // Pass 3 - try to fill 80% of maxWidth for each line
            for(let i = 0, ii = lines.length - 1; i < ii; ++i){
                const line = lines[i];
                const next = lines[i + 1];
                if ($86a2ca3c041b3852$var$measureText(line, letterSpacing) > maxWidth * 0.7 && $86a2ca3c041b3852$var$measureText(next, letterSpacing) < maxWidth * 0.6) {
                    const lineWords = line.split(' ');
                    const lastWord = lineWords.pop();
                    if ($86a2ca3c041b3852$var$measureText(lastWord, letterSpacing) < maxWidth * 0.2) {
                        lines[i] = lineWords.join(' ');
                        lines[i + 1] = lastWord + ' ' + next;
                    }
                    ii -= 1;
                }
            }
            wrappedText = lines.join('\n');
        } else wrappedText = text;
        wrappedText = $86a2ca3c041b3852$export$b532a8ed6cbc2f82(wrappedText, letterSpacing);
        $86a2ca3c041b3852$var$measureCache[key] = wrappedText;
    }
    return wrappedText;
}
const $86a2ca3c041b3852$var$webSafeFonts = [
    'Arial',
    'Courier New',
    'Times New Roman',
    'Verdana',
    'sans-serif',
    'serif',
    'monospace',
    'cursive',
    'fantasy'
];
const $86a2ca3c041b3852$var$processedFontFamilies = {};
function $86a2ca3c041b3852$export$cbcfe4007f417765(fonts, templateUrl = 'https://cdn.jsdelivr.net/npm/@fontsource/{font-family}/{fontweight}{-fontstyle}.css') {
    if (0, $013e07c1ef6d00ad$export$98fcef3dc9973292) //FIXME Font handling in web workers
    return fonts;
    let fontDescriptions;
    for(let i = 0, ii = fonts.length; i < ii; ++i){
        const font = fonts[i];
        if (font in $86a2ca3c041b3852$var$processedFontFamilies) continue;
        $86a2ca3c041b3852$var$processedFontFamilies[font] = true;
        const cssFont = (0, $01c264c2ae87dd64$export$2e2bcd8739ae039)(font, 16);
        const parts = cssFont.split(' ');
        if (!fontDescriptions) fontDescriptions = [];
        fontDescriptions.push([
            parts.slice(3).join(' ').replace(/"/g, ''),
            parts[1],
            parts[0]
        ]);
    }
    if (!fontDescriptions) return fonts;
    (async ()=>{
        await document.fonts.ready;
        for(let i = 0, ii = fontDescriptions.length; i < ii; ++i){
            const fontDescription = fontDescriptions[i];
            const family = fontDescription[0];
            if ($86a2ca3c041b3852$var$webSafeFonts.includes(family)) continue;
            const weight = fontDescription[1];
            const style = fontDescription[2];
            const loaded = await document.fonts.load(`${style} ${weight} 16px "${family}"`);
            if (!loaded.some((f)=>f.family.replace(/^['"]|['"]$/g, '').toLowerCase() === family.toLowerCase() && $86a2ca3c041b3852$var$fitWeight(f.weight, weight) && f.style === style)) {
                const fontUrl = templateUrl.replace('{font-family}', family.replace(/ /g, '-').toLowerCase()).replace('{Font+Family}', family.replace(/ /g, '+')).replace('{fontweight}', weight).replace('{-fontstyle}', style.replace('normal', '').replace(/(.+)/, '-$1')).replace('{fontstyle}', style);
                if (!document.querySelector('link[href="' + fontUrl + '"]')) {
                    const markup = document.createElement('link');
                    markup.href = fontUrl;
                    markup.rel = 'stylesheet';
                    document.head.appendChild(markup);
                }
            }
        }
    })();
    return fonts;
}



/**
 * @typedef {import("ol/layer/Vector.js").default} VectorLayer
 * @typedef {import("ol/layer/VectorTile.js").default} VectorTileLayer
 * @typedef {import("ol/style/Style.js").StyleFunction} StyleFunction
 * @typedef {import('./util.js').ResourceType} ResourceType
 */ /** @typedef {string|Request|Response|Promise<string|Request|Response>|Object<string, string|Request|Response|Promise<string|Request|Response>>} SpriteImageUrl */ /**
 * @typedef {Object} SpriteImage
 * @property {HTMLImageElement|HTMLCanvasElement} image Image
 * @property {Array<number>} size Size
 * @property {boolean} [unSDFed] Image has been unSDFed
 */ /** @typedef {Object<string, SpriteImage>} SpriteImages */ const $90723b470dfea2c1$var$types = {
    'Point': 1,
    'MultiPoint': 1,
    'LineString': 2,
    'MultiLineString': 2,
    'Polygon': 3,
    'MultiPolygon': 3
};
const $90723b470dfea2c1$var$anchor = {
    'center': [
        0.5,
        0.5
    ],
    'left': [
        0,
        0.5
    ],
    'right': [
        1,
        0.5
    ],
    'top': [
        0.5,
        0
    ],
    'bottom': [
        0.5,
        1
    ],
    'top-left': [
        0,
        0
    ],
    'top-right': [
        1,
        0
    ],
    'bottom-left': [
        0,
        1
    ],
    'bottom-right': [
        1,
        1
    ]
};
const $90723b470dfea2c1$var$expressionData = function(rawExpression, propertySpec) {
    let compiledExpression = (0, $ed234ca8eb1f5a84$export$64925a39029a32a)(rawExpression, propertySpec);
    if (compiledExpression.result === 'error') {
        const wrappedExpression = (0, $29b6935815fba8a6$export$10728aedf8b6b602)(rawExpression);
        if (wrappedExpression !== rawExpression) compiledExpression = (0, $ed234ca8eb1f5a84$export$64925a39029a32a)(wrappedExpression, propertySpec);
    }
    if (compiledExpression.result === 'error') {
        const err = compiledExpression.value[0];
        // eslint-disable-next-line no-console
        console.error('Error parsing expression:', rawExpression, err.key, err.message);
        // fallback to default value
        return {
            evaluate: ()=>{
                return propertySpec.default;
            }
        };
    }
    return compiledExpression.value;
};
let $90723b470dfea2c1$var$renderFeatureCoordinates, $90723b470dfea2c1$var$renderFeature;
function $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, layoutOrPaint, property, feature, functionCache, featureState) {
    const layerId = layer.id;
    if (!functionCache) {
        functionCache = {};
        console.warn('No functionCache provided to getValue()'); // eslint-disable-line no-console
    }
    if (!functionCache[layerId]) functionCache[layerId] = {};
    const functions = functionCache[layerId];
    if (!functions[property]) {
        let value = (layer[layoutOrPaint] || (0, $4f6c3bb417864b02$export$952e2b7e251b8b38))[property];
        const propertySpec = (0, $ed234ca8eb1f5a84$export$f94bee7ded07ee77)[`${layoutOrPaint}_${layer.type}`] && (0, $ed234ca8eb1f5a84$export$f94bee7ded07ee77)[`${layoutOrPaint}_${layer.type}`][property];
        if (value === undefined) {
            if (propertySpec) value = propertySpec.default;
        }
        let isExpr = (0, $ed234ca8eb1f5a84$export$3827579d8e65d9ac)(value);
        if (!isExpr && (0, $ed234ca8eb1f5a84$export$f6e2535fb5126e54)(value)) {
            value = (0, $ed234ca8eb1f5a84$export$4ffa6b66a9b9e443)(value, propertySpec);
            isExpr = true;
        }
        if (isExpr) {
            const compiledExpression = $90723b470dfea2c1$var$expressionData(value, propertySpec);
            functions[property] = compiledExpression.evaluate.bind(compiledExpression);
        } else {
            const type = propertySpec ? propertySpec.type : typeof value;
            if (type === 'color' || type === 'colorArray') value = (0, $ed234ca8eb1f5a84$export$892596cec99bc70e).parse(value);
            let hasExpr = false;
            if (type === 'array') for(let i = 0; i < value.length; ++i){
                const item = value[i];
                if ((0, $ed234ca8eb1f5a84$export$3827579d8e65d9ac)(item) || (0, $ed234ca8eb1f5a84$export$f6e2535fb5126e54)(item)) {
                    hasExpr = true;
                    break;
                }
            }
            if (hasExpr) {
                const itemPropertySpec = Object.assign({}, propertySpec, {
                    type: propertySpec.value
                });
                const itemExpressions = [];
                for(let i = 0; i < value.length; ++i){
                    let item = value[i];
                    if (!(0, $ed234ca8eb1f5a84$export$3827579d8e65d9ac)(item) && (0, $ed234ca8eb1f5a84$export$f6e2535fb5126e54)(item)) item = (0, $ed234ca8eb1f5a84$export$4ffa6b66a9b9e443)(item, itemPropertySpec);
                    if ((0, $ed234ca8eb1f5a84$export$3827579d8e65d9ac)(item)) {
                        const compiledExpression = $90723b470dfea2c1$var$expressionData(item, itemPropertySpec);
                        itemExpressions.push(compiledExpression.evaluate.bind(compiledExpression));
                    } else itemExpressions.push(function() {
                        return item;
                    });
                }
                functions[property] = function(globalProperties, feature, featureState) {
                    const result = [];
                    for(let i = 0; i < itemExpressions.length; ++i)result[i] = itemExpressions[i](globalProperties, feature, featureState);
                    return result;
                };
            } else functions[property] = function() {
                return value;
            };
        }
    }
    return functions[property]((0, $29b6935815fba8a6$export$56ff1d6843523eec), feature, featureState);
}
/**
 * @private
 * @param {Object} layer Gl object layer.
 * @param {Object} feature Gl feature.
 * @param {"icon"|"text"} prefix Style property prefix.
 * @param {Object} [functionCache] Function cache.
 * @return {"declutter"|"obstacle"|"none"} Value.
 */ function $90723b470dfea2c1$var$getDeclutterMode(layer, feature, prefix, functionCache) {
    const allowOverlap = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', `${prefix}-allow-overlap`, feature, functionCache);
    if (!allowOverlap) return 'declutter';
    const ignorePlacement = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', `${prefix}-ignore-placement`, feature, functionCache);
    if (!ignorePlacement) return 'obstacle';
    return 'none';
}
/**
 * @private
 * @param {string} layerId Layer id.
 * @param {?} filter Filter.
 * @param {Object} feature Feature.
 * @param {Object} [filterCache] Filter cache.
 * @return {boolean} Filter result.
 */ function $90723b470dfea2c1$export$143d5d4b99caccf1(layerId, filter, feature, filterCache) {
    if (!filterCache) console.warn('No filterCache provided to evaluateFilter()'); // eslint-disable-line no-console
    if (!(layerId in filterCache)) try {
        filterCache[layerId] = (0, $ed234ca8eb1f5a84$export$51cc184a952b52db)(filter).filter;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('Filter will evaluate to false: ' + /** @type {Error} */ e.message);
        filterCache[layerId] = function() {
            return false;
        };
    }
    return filterCache[layerId]((0, $29b6935815fba8a6$export$56ff1d6843523eec), feature);
}
let $90723b470dfea2c1$var$renderTransparentEnabled = false;
function $90723b470dfea2c1$export$11676a8d4c96cad6(enabled) {
    if (enabled !== $90723b470dfea2c1$var$renderTransparentEnabled) {
        (0, $4f6c3bb417864b02$export$1ebbb340c3c51fbc)();
        $90723b470dfea2c1$var$renderTransparentEnabled = enabled;
    }
}
/**
 * @private
 * @param {?} color Color.
 * @param {number} [opacity] Opacity.
 * @return {string} Color.
 */ function $90723b470dfea2c1$export$9e0174a126f113d7(color, opacity) {
    if (color) {
        if (!$90723b470dfea2c1$var$renderTransparentEnabled && (color.a === 0 || opacity === 0)) return undefined;
        const a = color.a;
        opacity = opacity === undefined ? 1 : opacity;
        return a === 0 ? 'transparent' : 'rgba(' + Math.round(color.r * 255 / a) + ',' + Math.round(color.g * 255 / a) + ',' + Math.round(color.b * 255 / a) + ',' + a * opacity + ')';
    }
    return color;
}
const $90723b470dfea2c1$var$templateRegEx = /\{[^{}}]*\}/g;
/**
 * @private
 * @param {string} text Text.
 * @param {Object} properties Properties.
 * @return {string} Text.
 */ function $90723b470dfea2c1$export$3ef4668330afa3d0(text, properties) {
    return text.replace($90723b470dfea2c1$var$templateRegEx, function(match) {
        return properties[match.slice(1, -1)] || '';
    });
}
function $90723b470dfea2c1$export$7ff5bf59de0ba507(icon, spriteImages) {
    let prefix = icon.split(':')[0];
    if (prefix === icon) prefix = 'default';
    return spriteImages[prefix];
}
let $90723b470dfea2c1$var$recordLayer = false;
function $90723b470dfea2c1$export$24cdc3db6068e672(record = false) {
    $90723b470dfea2c1$var$recordLayer = record;
}
const $90723b470dfea2c1$export$ce8063ac6ec145f8 = {};
function $90723b470dfea2c1$export$8775234cf93fa7a5(olLayer, glStyle, sourceOrLayers, resolutions = (0, $4f6c3bb417864b02$export$f1479b9369ff0206), spriteData, spriteImageUrl, getFonts, getImage) {
    if (typeof glStyle == 'string') glStyle = JSON.parse(glStyle);
    if (glStyle.schema) for(const key in glStyle.schema){
        const config = glStyle.schema[key];
        if ('default' in config) (0, $29b6935815fba8a6$export$812e807713593a71)[key] = config.default;
    }
    if (glStyle.version != 8) throw new Error('glStyle version 8 required.');
    $90723b470dfea2c1$export$ce8063ac6ec145f8[(0, $4f6c3bb417864b02$export$2e9c16762be40bb0)(glStyle, olLayer)] = Array.from(arguments);
    /** @type {SpriteImages} */ const spriteImages = {};
    if (typeof spriteImageUrl === 'string' || spriteImageUrl instanceof Request || spriteImageUrl instanceof Response || spriteImageUrl instanceof Promise) spriteImageUrl = {
        'default': spriteImageUrl
    };
    for(const prefix in spriteImageUrl){
        const imageUrl = spriteImageUrl[prefix];
        (0, $7efea016d660e267$export$4dbaaf6c79705e6c)(()=>imageUrl).then(async (imageUrl)=>{
            let blobUrl;
            if (typeof Image !== 'undefined') {
                const img = new Image();
                if (typeof imageUrl === 'string') {
                    img.crossOrigin = 'anonymous';
                    img.src = imageUrl;
                } else {
                    let response;
                    if (imageUrl instanceof Request) response = await fetch(imageUrl);
                    else if (imageUrl instanceof Response) response = imageUrl;
                    const blob = await response.blob();
                    blobUrl = URL.createObjectURL(blob);
                    img.src = blobUrl;
                }
                img.addEventListener('load', function load() {
                    img.removeEventListener('load', load);
                    spriteImages[prefix] = {
                        image: img,
                        size: [
                            img.width,
                            img.height
                        ]
                    };
                    olLayer.changed();
                    if (blobUrl) URL.revokeObjectURL(blobUrl);
                });
                img.addEventListener('error', function error() {
                    URL.revokeObjectURL(blobUrl);
                    img.removeEventListener('error', error);
                });
            } else if (typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope // eslint-disable-line
            ) {
                const worker = /** @type {*} */ self;
                // Main thread needs to handle 'loadImage' and dispatch 'imageLoaded'
                worker.postMessage({
                    action: 'loadImage',
                    src: imageUrl
                });
                worker.addEventListener('message', function handler(event) {
                    if (event.data.action === 'imageLoaded' && event.data.src === imageUrl) spriteImages[prefix] = {
                        image: event.data.image,
                        size: [
                            event.data.image.width,
                            event.data.image.height
                        ]
                    };
                });
            }
        });
    }
    /** @type {*} */ const allLayers = (0, $ed234ca8eb1f5a84$export$4f143e2847fe5618)(glStyle.layers);
    const layersBySourceLayer = {};
    const mapboxLayers = [];
    const iconImageCache = {};
    const patternCache = {};
    const functionCache = (0, $4f6c3bb417864b02$export$fba1d5e26ba27516)(glStyle);
    const filterCache = (0, $4f6c3bb417864b02$export$330c4a8ebe9a8d1e)(glStyle);
    let mapboxSource;
    for(let i = 0, ii = allLayers.length; i < ii; ++i){
        const layer = allLayers[i];
        const layerId = layer.id;
        if (typeof sourceOrLayers == 'string' && layer.source == sourceOrLayers || Array.isArray(sourceOrLayers) && sourceOrLayers.indexOf(layerId) !== -1) {
            const sourceLayer = layer['source-layer'];
            if (!mapboxSource) {
                mapboxSource = layer.source;
                const source = glStyle.sources[mapboxSource];
                if (!source) throw new Error(`Source "${mapboxSource}" is not defined`);
                const type = source.type;
                if (type !== 'vector' && type !== 'geojson') throw new Error(`Source "${mapboxSource}" is not of type "vector" or "geojson", but "${type}"`);
            } else if (layer.source !== mapboxSource) throw new Error(`Layer "${layerId}" does not use source "${mapboxSource}`);
            let layers = layersBySourceLayer[sourceLayer];
            if (!layers) {
                layers = [];
                layersBySourceLayer[sourceLayer] = layers;
            }
            layers.push({
                layer: layer,
                index: i
            });
            mapboxLayers.push(layerId);
        }
    }
    const styles = [];
    /**
   * @param {import("ol/Feature.js").default|import("ol/render/Feature.js").default} feature Feature.
   * @param {number} resolution Resolution.
   * @param {string} [onlyLayer] Calculate style for this layer only.
   * @return {Array<import("ol/style/Style.js").default>} Style.
   */ const styleFunction = function(feature, resolution, onlyLayer) {
        const layerProperty = //@ts-ignore
        olLayer.getSource?.()?.format_?.layerName_ ?? 'mvt:layer';
        const properties = feature.getProperties();
        const layers = layersBySourceLayer[properties[layerProperty]];
        if (!layers) return undefined;
        let zoom = resolutions.indexOf(resolution);
        if (zoom == -1) zoom = (0, $4f6c3bb417864b02$export$f8f663988f36f2e1)(resolution, resolutions);
        (0, $29b6935815fba8a6$export$56ff1d6843523eec).zoom = zoom;
        (0, $29b6935815fba8a6$export$56ff1d6843523eec).distanceFromCenter = 0;
        const featureGeometry = feature.getGeometry();
        const type = $90723b470dfea2c1$var$types[featureGeometry.getType()];
        const map = olLayer.get('map');
        if (map && map instanceof (0, $19f0d4d634ca7fe4$export$2e2bcd8739ae039) && type === 1) {
            const size = map.getSize();
            if (size) {
                const mapCenter = map.getView().getCenter();
                const featureCenter = (0, $3412ad7bd362b04c$export$c91255cadecfe081)(featureGeometry.getExtent());
                (0, $29b6935815fba8a6$export$56ff1d6843523eec).distanceFromCenter = (0, $6542087bee114e8c$export$9f17032d917177de)(mapCenter, featureCenter) / resolution / size[1];
            }
        }
        const f = {
            id: feature.getId(),
            properties: properties,
            type: type
        };
        const featureState = olLayer.get('mapbox-featurestate')[feature.getId()];
        let stylesLength = -1;
        let featureBelongsToLayer;
        for(let i = 0, ii = layers.length; i < ii; ++i){
            const layerData = layers[i];
            const layer = layerData.layer;
            const layerId = layer.id;
            if (onlyLayer !== undefined && onlyLayer !== layerId) continue;
            const layout = layer.layout || (0, $4f6c3bb417864b02$export$952e2b7e251b8b38);
            const paint = layer.paint || (0, $4f6c3bb417864b02$export$952e2b7e251b8b38);
            const visibility = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', 'visibility', f, functionCache, featureState);
            if (visibility === 'none' || 'minzoom' in layer && zoom < layer.minzoom || 'maxzoom' in layer && zoom >= layer.maxzoom) continue;
            const filter = layer.filter;
            if (!filter || $90723b470dfea2c1$export$143d5d4b99caccf1(layerId, filter, f, filterCache)) {
                featureBelongsToLayer = layer;
                let color, opacity, fill, stroke, strokeColor, style;
                const index = layerData.index;
                if (type == 3 && (layer.type == 'fill' || layer.type == 'fill-extrusion')) {
                    opacity = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'paint', layer.type + '-opacity', f, functionCache, featureState);
                    if (layer.type + '-pattern' in paint) {
                        const fillIcon = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'paint', layer.type + '-pattern', f, functionCache, featureState);
                        if (fillIcon) {
                            const icon = typeof fillIcon === 'string' ? $90723b470dfea2c1$export$3ef4668330afa3d0(fillIcon, properties) : fillIcon.toString();
                            const spriteImage = $90723b470dfea2c1$export$7ff5bf59de0ba507(icon, spriteImages);
                            if (spriteData && spriteData[icon] && spriteImage) {
                                ++stylesLength;
                                style = styles[stylesLength];
                                if (!style || !style.getFill() || style.getStroke() || style.getText()) {
                                    style = new (0, $97cdc16020961e75$export$2e2bcd8739ae039)({
                                        fill: new (0, $83cca4c6d7d93d3c$export$2e2bcd8739ae039)()
                                    });
                                    styles[stylesLength] = style;
                                }
                                fill = style.getFill();
                                style.setZIndex(index);
                                const icon_cache_key = icon + '.' + opacity;
                                let pattern = patternCache[icon_cache_key];
                                if (!pattern) {
                                    const spriteImageData = spriteData[icon];
                                    const canvas = (0, $4f6c3bb417864b02$export$cd3d1f114b139967)(spriteImageData.width, spriteImageData.height);
                                    const ctx = /** @type {CanvasRenderingContext2D} */ canvas.getContext('2d');
                                    ctx.globalAlpha = opacity;
                                    ctx.drawImage(spriteImage.image, spriteImageData.x, spriteImageData.y, spriteImageData.width, spriteImageData.height, 0, 0, spriteImageData.width, spriteImageData.height);
                                    pattern = ctx.createPattern(canvas, 'repeat');
                                    patternCache[icon_cache_key] = pattern;
                                }
                                fill.setColor(pattern);
                            }
                        }
                    } else {
                        color = $90723b470dfea2c1$export$9e0174a126f113d7($90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'paint', layer.type + '-color', f, functionCache, featureState), opacity);
                        if (layer.type + '-outline-color' in paint) strokeColor = $90723b470dfea2c1$export$9e0174a126f113d7($90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'paint', layer.type + '-outline-color', f, functionCache, featureState), opacity);
                        if (!strokeColor) strokeColor = color;
                        if (color || strokeColor) {
                            ++stylesLength;
                            style = styles[stylesLength];
                            if (!style || color && !style.getFill() || !color && style.getFill() || strokeColor && !style.getStroke() || !strokeColor && style.getStroke() || style.getText()) {
                                style = new (0, $97cdc16020961e75$export$2e2bcd8739ae039)({
                                    fill: color ? new (0, $83cca4c6d7d93d3c$export$2e2bcd8739ae039)() : undefined,
                                    stroke: strokeColor ? new (0, $4eba39905b0caafc$export$2e2bcd8739ae039)() : undefined
                                });
                                styles[stylesLength] = style;
                            }
                            if (color) {
                                fill = style.getFill();
                                fill.setColor(color);
                            }
                            if (layer.type === 'fill-extrusion') {
                                const height = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'paint', 'fill-extrusion-height', f, functionCache, featureState);
                                // For fill-extrusion, we darken the stroke color based on height
                                // This gives a pseudo-3D effect
                                if (height > 0) {
                                    // Darken factor: clamps between 0.1 and 0.9 based on height
                                    // Higher extrusion = darker outline
                                    const darkenFactor = Math.max(0.1, 0.9 - Math.min(height, 225) / 280);
                                    if (strokeColor && strokeColor !== 'transparent') {
                                        const rgba = (0, $ed234ca8eb1f5a84$export$892596cec99bc70e).parse(strokeColor);
                                        strokeColor = `rgba(${Math.round(rgba.r * 255 * darkenFactor)},${Math.round(rgba.g * 255 * darkenFactor)},${Math.round(rgba.b * 255 * darkenFactor)},${rgba.a})`;
                                    }
                                }
                            }
                            if (strokeColor) {
                                stroke = style.getStroke();
                                stroke.setColor(strokeColor);
                                stroke.setWidth(0.5);
                            }
                            style.setZIndex(index);
                        }
                    }
                }
                if (type != 1 && layer.type == 'line') {
                    if (!('line-pattern' in paint)) color = $90723b470dfea2c1$export$9e0174a126f113d7($90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'paint', 'line-color', f, functionCache, featureState), $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'paint', 'line-opacity', f, functionCache, featureState));
                    else color = undefined;
                    const width = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'paint', 'line-width', f, functionCache, featureState);
                    if (color && width > 0) {
                        ++stylesLength;
                        style = styles[stylesLength];
                        if (!style || !style.getStroke() || style.getFill() || style.getText()) {
                            style = new (0, $97cdc16020961e75$export$2e2bcd8739ae039)({
                                stroke: new (0, $4eba39905b0caafc$export$2e2bcd8739ae039)()
                            });
                            styles[stylesLength] = style;
                        }
                        stroke = style.getStroke();
                        stroke.setLineCap($90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', 'line-cap', f, functionCache, featureState));
                        stroke.setLineJoin($90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', 'line-join', f, functionCache, featureState));
                        stroke.setMiterLimit($90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', 'line-miter-limit', f, functionCache, featureState));
                        stroke.setColor(color);
                        stroke.setWidth(width);
                        stroke.setLineDash(paint['line-dasharray'] ? $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'paint', 'line-dasharray', f, functionCache, featureState).map(function(x) {
                            return x * width;
                        }) : null);
                        if (typeof stroke.setOffset === 'function') stroke.setOffset($90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'paint', 'line-offset', f, functionCache, featureState));
                        style.setZIndex(index);
                    }
                }
                let hasImage = false;
                let text = null;
                let placementAngle = 0;
                let icon, iconImg, skipLabel;
                if ((type == 1 || type == 2) && 'icon-image' in layout) {
                    const iconImage = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', 'icon-image', f, functionCache, featureState);
                    if (iconImage) {
                        icon = typeof iconImage === 'string' ? $90723b470dfea2c1$export$3ef4668330afa3d0(iconImage, properties) : iconImage.toString();
                        let styleGeom = undefined;
                        const imageElement = getImage ? getImage(olLayer, icon) : undefined;
                        const spriteImage = $90723b470dfea2c1$export$7ff5bf59de0ba507(icon, spriteImages);
                        if (spriteData && spriteData[icon] && spriteImage || imageElement) {
                            const iconRotationAlignment = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', 'icon-rotation-alignment', f, functionCache, featureState);
                            if (type == 2) {
                                const geom = /** @type {*} */ feature.getGeometry();
                                // ol package and ol-debug.js only
                                if (geom.getFlatMidpoint || geom.getFlatMidpoints) {
                                    const extent = geom.getExtent();
                                    const size = Math.sqrt(Math.max(Math.pow((extent[2] - extent[0]) / resolution, 2), Math.pow((extent[3] - extent[1]) / resolution, 2)));
                                    if (size > 150) {
                                        //FIXME Do not hard-code a size of 150
                                        const midpoint = geom.getType() === 'MultiLineString' ? geom.getFlatMidpoints() : geom.getFlatMidpoint();
                                        if (!$90723b470dfea2c1$var$renderFeature) {
                                            $90723b470dfea2c1$var$renderFeatureCoordinates = [
                                                NaN,
                                                NaN
                                            ];
                                            $90723b470dfea2c1$var$renderFeature = new (0, $edf3df43d76225f4$export$2e2bcd8739ae039)('Point', $90723b470dfea2c1$var$renderFeatureCoordinates, [], 2, {}, undefined);
                                        }
                                        styleGeom = $90723b470dfea2c1$var$renderFeature;
                                        $90723b470dfea2c1$var$renderFeatureCoordinates[0] = midpoint[0];
                                        $90723b470dfea2c1$var$renderFeatureCoordinates[1] = midpoint[1];
                                        const placement = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', 'symbol-placement', f, functionCache, featureState);
                                        if (placement === 'line' && iconRotationAlignment === 'map') {
                                            const stride = geom.getStride();
                                            const coordinates = geom.getFlatCoordinates();
                                            for(let i = 0, ii = coordinates.length - stride; i < ii; i += stride){
                                                const x1 = coordinates[i];
                                                const y1 = coordinates[i + 1];
                                                const x2 = coordinates[i + stride];
                                                const y2 = coordinates[i + stride + 1];
                                                const minX = Math.min(x1, x2);
                                                const maxX = Math.max(x1, x2);
                                                const xM = midpoint[0];
                                                const yM = midpoint[1];
                                                const dotProduct = (y2 - y1) * (xM - x1) - (x2 - x1) * (yM - y1);
                                                if (Math.abs(dotProduct) < 0.001 && //midpoint is aligned with the segment
                                                xM <= maxX && xM >= minX //midpoint is on the segment and not outside it
                                                ) {
                                                    placementAngle = Math.atan2(y1 - y2, x2 - x1);
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            if (type !== 2 || styleGeom) {
                                const iconSize = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', 'icon-size', f, functionCache, featureState);
                                const iconColor = paint['icon-color'] !== undefined ? $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'paint', 'icon-color', f, functionCache, featureState) : null;
                                if (!iconColor || iconColor.a !== 0) {
                                    const haloColor = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'paint', 'icon-halo-color', f, functionCache, featureState);
                                    const haloWidth = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'paint', 'icon-halo-width', f, functionCache, featureState);
                                    let iconCacheKey = `${icon}.${iconSize}.${haloWidth}.${haloColor}`;
                                    if (iconColor !== null) iconCacheKey += `.${iconColor}`;
                                    iconImg = iconImageCache[iconCacheKey];
                                    if (!iconImg) {
                                        const declutterMode = $90723b470dfea2c1$var$getDeclutterMode(layer, f, 'icon', functionCache);
                                        let displacement;
                                        if ('icon-offset' in layout) {
                                            displacement = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', 'icon-offset', f, functionCache, featureState).slice(0);
                                            displacement[0] *= iconSize;
                                            displacement[1] *= -iconSize;
                                        }
                                        let color = iconColor ? [
                                            iconColor.r * 255,
                                            iconColor.g * 255,
                                            iconColor.b * 255,
                                            iconColor.a
                                        ] : undefined;
                                        if (imageElement) {
                                            const iconOptions = {
                                                color: color,
                                                rotateWithView: iconRotationAlignment === 'map',
                                                displacement: displacement,
                                                declutterMode: declutterMode,
                                                scale: iconSize
                                            };
                                            if (typeof imageElement === 'string') // it is a src URL
                                            iconOptions.src = imageElement;
                                            else {
                                                iconOptions.img = imageElement;
                                                iconOptions.imgSize = [
                                                    imageElement.width,
                                                    imageElement.height
                                                ];
                                            }
                                            iconImg = new (0, $3f49168ea08c039d$export$2e2bcd8739ae039)(iconOptions);
                                        } else {
                                            const spriteImageData = spriteData[icon];
                                            let img, size, offset;
                                            if (haloWidth) {
                                                if (spriteImageData.sdf) {
                                                    img = (0, $4f6c3bb417864b02$export$76143e2926156ae4)((0, $4f6c3bb417864b02$export$9c562940726ba358)(spriteImage.image, spriteImageData, iconColor || [
                                                        0,
                                                        0,
                                                        0,
                                                        1
                                                    ]), {
                                                        x: 0,
                                                        y: 0,
                                                        width: spriteImageData.width,
                                                        height: spriteImageData.height,
                                                        pixelRatio: spriteImageData.pixelRatio
                                                    }, haloWidth, haloColor);
                                                    color = undefined; // do not tint haloed icons
                                                } else img = (0, $4f6c3bb417864b02$export$76143e2926156ae4)(spriteImage.image, spriteImageData, haloWidth, haloColor);
                                            } else {
                                                if (spriteImageData.sdf) {
                                                    if (!spriteImage.unSDFed) {
                                                        const spriteImageUnSDFed = (0, $4f6c3bb417864b02$export$9c562940726ba358)(spriteImage.image, {
                                                            x: 0,
                                                            y: 0,
                                                            width: spriteImage.size[0],
                                                            height: spriteImage.size[1]
                                                        }, {
                                                            r: 1,
                                                            g: 1,
                                                            b: 1,
                                                            a: 1
                                                        });
                                                        spriteImage.image = spriteImageUnSDFed;
                                                        spriteImage.unSDFed = true;
                                                    }
                                                }
                                                img = spriteImage.image;
                                                size = [
                                                    spriteImageData.width,
                                                    spriteImageData.height
                                                ];
                                                offset = [
                                                    spriteImageData.x,
                                                    spriteImageData.y
                                                ];
                                            }
                                            iconImg = new (0, $3f49168ea08c039d$export$2e2bcd8739ae039)({
                                                color: color,
                                                img: img,
                                                // @ts-ignore
                                                imgSize: spriteImage.size,
                                                size: size,
                                                offset: offset,
                                                rotateWithView: iconRotationAlignment === 'map',
                                                scale: iconSize / spriteImageData.pixelRatio,
                                                displacement: displacement,
                                                declutterMode: declutterMode
                                            });
                                        }
                                        iconImageCache[iconCacheKey] = iconImg;
                                    }
                                }
                                if (iconImg) {
                                    ++stylesLength;
                                    style = styles[stylesLength];
                                    if (!style || !style.getImage() || style.getFill() || style.getStroke()) {
                                        style = new (0, $97cdc16020961e75$export$2e2bcd8739ae039)();
                                        styles[stylesLength] = style;
                                    }
                                    style.setGeometry(styleGeom);
                                    iconImg.setRotation(placementAngle + (0, $4f6c3bb417864b02$export$b1b275608b2b1b8)($90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', 'icon-rotate', f, functionCache, featureState)));
                                    iconImg.setOpacity($90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'paint', 'icon-opacity', f, functionCache, featureState));
                                    iconImg.setAnchor($90723b470dfea2c1$var$anchor[$90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', 'icon-anchor', f, functionCache, featureState)]);
                                    style.setImage(iconImg);
                                    text = style.getText();
                                    style.setText(undefined);
                                    style.setZIndex(index);
                                    hasImage = true;
                                    skipLabel = false;
                                }
                            } else skipLabel = true;
                        }
                    }
                }
                if (type == 1 && layer.type === 'circle') {
                    ++stylesLength;
                    style = styles[stylesLength];
                    if (!style || !style.getImage() || style.getFill() || style.getStroke()) {
                        style = new (0, $97cdc16020961e75$export$2e2bcd8739ae039)();
                        styles[stylesLength] = style;
                    }
                    const circleRadius = 'circle-radius' in paint ? $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'paint', 'circle-radius', f, functionCache, featureState) : 5;
                    const circleStrokeColor = $90723b470dfea2c1$export$9e0174a126f113d7($90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'paint', 'circle-stroke-color', f, functionCache, featureState), $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'paint', 'circle-stroke-opacity', f, functionCache, featureState));
                    const circleTranslate = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'paint', 'circle-translate', f, functionCache, featureState);
                    const circleColor = $90723b470dfea2c1$export$9e0174a126f113d7($90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'paint', 'circle-color', f, functionCache, featureState), $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'paint', 'circle-opacity', f, functionCache, featureState));
                    const circleStrokeWidth = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'paint', 'circle-stroke-width', f, functionCache, featureState);
                    const cache_key = circleRadius + '.' + circleStrokeColor + '.' + circleColor + '.' + circleStrokeWidth + '.' + circleTranslate[0] + '.' + circleTranslate[1];
                    iconImg = iconImageCache[cache_key];
                    if (!iconImg) {
                        iconImg = new (0, $c1968949086c96bc$export$2e2bcd8739ae039)({
                            radius: circleRadius,
                            displacement: [
                                circleTranslate[0],
                                -circleTranslate[1]
                            ],
                            stroke: circleStrokeColor && circleStrokeWidth > 0 ? new (0, $4eba39905b0caafc$export$2e2bcd8739ae039)({
                                width: circleStrokeWidth,
                                color: circleStrokeColor
                            }) : undefined,
                            fill: circleColor ? new (0, $83cca4c6d7d93d3c$export$2e2bcd8739ae039)({
                                color: circleColor
                            }) : undefined,
                            declutterMode: 'none'
                        });
                        iconImageCache[cache_key] = iconImg;
                    }
                    style.setImage(iconImg);
                    text = style.getText();
                    style.setText(undefined);
                    style.setGeometry(undefined);
                    style.setZIndex(index);
                    hasImage = true;
                }
                let label, font, textLineHeight, textSize, letterSpacing, maxTextWidth;
                if ('text-field' in layout) {
                    textSize = Math.round($90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', 'text-size', f, functionCache, featureState));
                    const fontArray = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', 'text-font', f, functionCache, featureState);
                    textLineHeight = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', 'text-line-height', f, functionCache, featureState);
                    font = (0, $01c264c2ae87dd64$export$2e2bcd8739ae039)(getFonts ? getFonts(fontArray, glStyle.metadata ? glStyle.metadata['ol:webfonts'] : undefined) : fontArray, textSize, textLineHeight);
                    if (!font.includes('sans-serif')) font += ',sans-serif';
                    letterSpacing = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', 'text-letter-spacing', f, functionCache, featureState);
                    maxTextWidth = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', 'text-max-width', f, functionCache, featureState);
                    const textField = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', 'text-field', f, functionCache, featureState);
                    if (typeof textField === 'object' && textField.sections) {
                        if (textField.sections.length === 1) label = textField.toString();
                        else label = textField.sections.reduce((acc, chunk, i)=>{
                            const fonts = chunk.fontStack ? chunk.fontStack.split(',') : fontArray;
                            const chunkFont = (0, $01c264c2ae87dd64$export$2e2bcd8739ae039)(getFonts ? getFonts(fonts) : fonts, textSize * (chunk.scale || 1), textLineHeight);
                            let text = chunk.text;
                            if (text === '\n') {
                                acc.push('\n', '');
                                return acc;
                            }
                            if (type == 2) {
                                acc.push((0, $86a2ca3c041b3852$export$b532a8ed6cbc2f82)(text, letterSpacing), chunkFont);
                                return acc;
                            }
                            text = (0, $86a2ca3c041b3852$export$db1d31f4af680217)(text, chunkFont, maxTextWidth, letterSpacing).split('\n');
                            for(let i = 0, ii = text.length; i < ii; ++i){
                                if (i > 0) acc.push('\n', '');
                                acc.push(text[i], chunkFont);
                            }
                            return acc;
                        }, []);
                    } else label = $90723b470dfea2c1$export$3ef4668330afa3d0(textField, properties).trim();
                    opacity = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'paint', 'text-opacity', f, functionCache, featureState);
                }
                if (label && opacity && !skipLabel) {
                    if (!hasImage) {
                        ++stylesLength;
                        style = styles[stylesLength];
                        if (!style || !style.getText() || style.getFill() || style.getStroke()) {
                            style = new (0, $97cdc16020961e75$export$2e2bcd8739ae039)();
                            styles[stylesLength] = style;
                        }
                        style.setImage(undefined);
                        style.setGeometry(undefined);
                    }
                    const declutterMode = $90723b470dfea2c1$var$getDeclutterMode(layer, f, 'text', functionCache);
                    if (!style.getText()) style.setText(text);
                    text = style.getText();
                    if (!text || 'getDeclutterMode' in text && text.getDeclutterMode() !== declutterMode) {
                        text = new (0, $3df0a22f11ceded5$export$2e2bcd8739ae039)({
                            padding: [
                                2,
                                2,
                                2,
                                2
                            ],
                            // @ts-ignore
                            declutterMode: declutterMode
                        });
                        style.setText(text);
                    }
                    const textTransform = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', 'text-transform', f, functionCache, featureState);
                    if (textTransform == 'uppercase') label = Array.isArray(label) ? label.map((t, i)=>i % 2 ? t : t.toUpperCase()) : label.toUpperCase();
                    else if (textTransform == 'lowercase') label = Array.isArray(label) ? label.map((t, i)=>i % 2 ? t : t.toLowerCase()) : label.toLowerCase();
                    const wrappedLabel = Array.isArray(label) ? label : type == 2 ? (0, $86a2ca3c041b3852$export$b532a8ed6cbc2f82)(label, letterSpacing) : (0, $86a2ca3c041b3852$export$db1d31f4af680217)(label, font, maxTextWidth, letterSpacing);
                    text.setText(wrappedLabel);
                    text.setFont(font);
                    text.setRotation((0, $4f6c3bb417864b02$export$b1b275608b2b1b8)($90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', 'text-rotate', f, functionCache, featureState)));
                    if (typeof text.setKeepUpright === 'function') {
                        const keepUpright = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', 'text-keep-upright', f, functionCache, featureState);
                        text.setKeepUpright(keepUpright);
                    }
                    const textAnchor = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', 'text-anchor', f, functionCache, featureState);
                    const placement = hasImage || type == 1 ? 'point' : $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', 'symbol-placement', f, functionCache, featureState);
                    let textAlign;
                    if (placement === 'line-center') {
                        text.setPlacement('line');
                        textAlign = 'center';
                    } else text.setPlacement(placement);
                    if (placement === 'line' && typeof text.setRepeat === 'function') {
                        const symbolSpacing = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', 'symbol-spacing', f, functionCache, featureState);
                        text.setRepeat(symbolSpacing * 2);
                    }
                    text.setOverflow(placement === 'point');
                    let textHaloWidth = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'paint', 'text-halo-width', f, functionCache, featureState);
                    const textOffset = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', 'text-offset', f, functionCache, featureState);
                    const textTranslate = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'paint', 'text-translate', f, functionCache, featureState);
                    // Text offset has to take halo width and line height into account
                    let vOffset = 0;
                    let hOffset = 0;
                    if (placement == 'point') {
                        textAlign = 'center';
                        if (textAnchor.indexOf('left') !== -1) {
                            textAlign = 'left';
                            hOffset = textHaloWidth;
                        } else if (textAnchor.indexOf('right') !== -1) {
                            textAlign = 'right';
                            hOffset = -textHaloWidth;
                        }
                        const textRotationAlignment = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', 'text-rotation-alignment', f, functionCache, featureState);
                        text.setRotateWithView(textRotationAlignment == 'map');
                    } else {
                        text.setMaxAngle((0, $4f6c3bb417864b02$export$b1b275608b2b1b8)($90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', 'text-max-angle', f, functionCache, featureState)) * label.length / wrappedLabel.length);
                        text.setRotateWithView(false);
                    }
                    text.setTextAlign(textAlign);
                    let textBaseline = 'middle';
                    if (textAnchor.indexOf('bottom') == 0) {
                        textBaseline = 'bottom';
                        vOffset = -textHaloWidth - 0.5 * (textLineHeight - 1) * textSize;
                    } else if (textAnchor.indexOf('top') == 0) {
                        textBaseline = 'top';
                        vOffset = textHaloWidth + 0.5 * (textLineHeight - 1) * textSize;
                    }
                    text.setTextBaseline(textBaseline);
                    const textJustify = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', 'text-justify', f, functionCache, featureState);
                    text.setJustify(textJustify === 'auto' ? undefined : textJustify);
                    text.setOffsetX(textOffset[0] * textSize + hOffset + textTranslate[0]);
                    text.setOffsetY(textOffset[1] * textSize + vOffset + textTranslate[1]);
                    const textFill = text.getFill() || new (0, $83cca4c6d7d93d3c$export$2e2bcd8739ae039)();
                    textFill.setColor($90723b470dfea2c1$export$9e0174a126f113d7($90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'paint', 'text-color', f, functionCache, featureState), opacity));
                    text.setFill(textFill);
                    const haloColor = $90723b470dfea2c1$export$9e0174a126f113d7($90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'paint', 'text-halo-color', f, functionCache, featureState), opacity);
                    if (haloColor && textHaloWidth > 0) {
                        const textStroke = text.getStroke() || new (0, $4eba39905b0caafc$export$2e2bcd8739ae039)();
                        textStroke.setColor(haloColor);
                        // spec here : https://docs.mapbox.com/mapbox-gl-js/style-spec/#paint-symbol-text-halo-width
                        // Halo width must be doubled because it is applied around the center of the text outline
                        textHaloWidth *= 2;
                        // 1/4 of text size (spec) x 2
                        const halfTextSize = 0.5 * textSize;
                        textStroke.setWidth(textHaloWidth <= halfTextSize ? textHaloWidth : halfTextSize);
                        text.setStroke(textStroke);
                    } else text.setStroke(undefined);
                    const textPadding = $90723b470dfea2c1$export$bf7199a9ebcb84a9(layer, 'layout', 'text-padding', f, functionCache, featureState);
                    const padding = text.getPadding();
                    if (textPadding !== padding[0]) {
                        padding[0] = textPadding;
                        padding[1] = textPadding;
                        padding[2] = textPadding;
                        padding[3] = textPadding;
                    }
                    style.setZIndex(index);
                }
            }
        }
        if (stylesLength > -1) {
            styles.length = stylesLength + 1;
            if ($90723b470dfea2c1$var$recordLayer) {
                if ('set' in feature) // ol/Feature
                feature.set('mapbox-layer', featureBelongsToLayer);
                else // ol/render/Feature
                feature.getProperties()['mapbox-layer'] = featureBelongsToLayer;
            }
            return styles;
        }
        return undefined;
    };
    olLayer.setStyle(styleFunction);
    olLayer.set('mapbox-layers', mapboxLayers);
    olLayer.set('mapbox-source', mapboxSource);
    olLayer.set('mapbox-featurestate', olLayer.get('mapbox-featurestate') || {});
    return styleFunction;
}
function $90723b470dfea2c1$export$b6af58973a194407(feature, resolution, olLayer, layerId) {
    const evaluateStyle = olLayer.getStyleFunction();
    if (evaluateStyle.length === 3) // @ts-ignore
    return evaluateStyle(feature, resolution, layerId);
    return undefined;
}



const $f7dd1fe8af096dfb$var$defaultShadowColor = (0, $ed234ca8eb1f5a84$export$892596cec99bc70e).parse('#000000');
const $f7dd1fe8af096dfb$var$defaultHighlightColor = (0, $ed234ca8eb1f5a84$export$892596cec99bc70e).parse('#FFFFFF');
const $f7dd1fe8af096dfb$var$defaultAccentColor = (0, $ed234ca8eb1f5a84$export$892596cec99bc70e).parse('#000000');
function $f7dd1fe8af096dfb$export$38932cf824ad7643(tileLayer) {
    return new (0, $733c124325e59ca7$export$2e2bcd8739ae039)({
        source: new (0, $c799687f236c7f28$export$2e2bcd8739ae039)({
            operationType: 'image',
            operation: (0, $9ebd86d05c6dff70$export$abf1f7e1a47af2a9),
            sources: [
                tileLayer
            ]
        })
    });
}
function $f7dd1fe8af096dfb$export$76e33ad77e40cdbc(tileLayer) {
    return new (0, $733c124325e59ca7$export$2e2bcd8739ae039)({
        source: new (0, $c799687f236c7f28$export$2e2bcd8739ae039)({
            operationType: 'image',
            operation: (0, $9ebd86d05c6dff70$export$f01104271975e695),
            sources: [
                tileLayer
            ]
        })
    });
}
function $f7dd1fe8af096dfb$export$e9d5a4f2d683374(layer, glLayer, options, functionCache) {
    layer.getSource().on('beforeoperations', function(event) {
        (0, $29b6935815fba8a6$export$56ff1d6843523eec).zoom = (0, $4f6c3bb417864b02$export$f8f663988f36f2e1)(event.resolution, options.resolutions || (0, $4f6c3bb417864b02$export$f1479b9369ff0206));
        (0, $29b6935815fba8a6$export$56ff1d6843523eec).distanceFromCenter = 0;
        const data = event.data;
        data.saturation = (0, $90723b470dfea2c1$export$bf7199a9ebcb84a9)(glLayer, 'paint', 'raster-saturation', (0, $4f6c3bb417864b02$export$952e2b7e251b8b38), functionCache);
        data.contrast = (0, $90723b470dfea2c1$export$bf7199a9ebcb84a9)(glLayer, 'paint', 'raster-contrast', (0, $4f6c3bb417864b02$export$952e2b7e251b8b38), functionCache);
        data.brightnessHigh = (0, $90723b470dfea2c1$export$bf7199a9ebcb84a9)(glLayer, 'paint', 'raster-brightness-max', (0, $4f6c3bb417864b02$export$952e2b7e251b8b38), functionCache);
        data.brightnessLow = (0, $90723b470dfea2c1$export$bf7199a9ebcb84a9)(glLayer, 'paint', 'raster-brightness-min', (0, $4f6c3bb417864b02$export$952e2b7e251b8b38), functionCache);
        data.hueRotate = (0, $90723b470dfea2c1$export$bf7199a9ebcb84a9)(glLayer, 'paint', 'raster-hue-rotate', (0, $4f6c3bb417864b02$export$952e2b7e251b8b38), functionCache);
    });
}
function $f7dd1fe8af096dfb$export$ddea3c3454e3399(layer, glSource, glLayer, options, functionCache) {
    layer.getSource().on('beforeoperations', function(event) {
        const data = event.data;
        data.resolution = (0, $2a998b085c5a7ac9$export$2d8f7b4eec383d44)(options.projection || 'EPSG:3857', event.resolution, (0, $3412ad7bd362b04c$export$c91255cadecfe081)(event.extent), 'm');
        const zoom = (0, $4f6c3bb417864b02$export$f8f663988f36f2e1)(event.resolution, options.resolutions || (0, $4f6c3bb417864b02$export$f1479b9369ff0206));
        (0, $29b6935815fba8a6$export$56ff1d6843523eec).zoom = zoom;
        (0, $29b6935815fba8a6$export$56ff1d6843523eec).distanceFromCenter = 0;
        data.zoom = zoom;
        data.encoding = glSource.encoding;
        // Hillshade method (standard, basic, combined, igor, multidirectional)
        data.method = (0, $90723b470dfea2c1$export$bf7199a9ebcb84a9)(glLayer, 'paint', 'hillshade-method', (0, $4f6c3bb417864b02$export$952e2b7e251b8b38), functionCache) || 'standard';
        data.exaggeration = (0, $90723b470dfea2c1$export$bf7199a9ebcb84a9)(glLayer, 'paint', 'hillshade-exaggeration', (0, $4f6c3bb417864b02$export$952e2b7e251b8b38), functionCache);
        // Illumination directions - normalize to array (for multidirectional)
        let dirValue = (0, $90723b470dfea2c1$export$bf7199a9ebcb84a9)(glLayer, 'paint', 'hillshade-illumination-direction', (0, $4f6c3bb417864b02$export$952e2b7e251b8b38), functionCache);
        if (dirValue === null || dirValue === undefined) dirValue = 335;
        data.azimuths = Array.isArray(dirValue) ? dirValue : [
            dirValue
        ];
        data.sunAz = data.azimuths[0];
        // Illumination altitudes - normalize to array (for basic, combined, multidirectional)
        let altValue = (0, $90723b470dfea2c1$export$bf7199a9ebcb84a9)(glLayer, 'paint', 'hillshade-illumination-altitude', (0, $4f6c3bb417864b02$export$952e2b7e251b8b38), functionCache);
        if (altValue === null || altValue === undefined) altValue = 45;
        data.altitudes = Array.isArray(altValue) ? altValue : [
            altValue
        ];
        // Helper to unwrap Color values from expression wrappers
        function unwrapColor(val) {
            if (val && val.values) return val.values[0];
            return val;
        }
        // Helper to parse color array properties.
        // colorArray values may be a single color string, a Color object,
        // or an array of color strings (for multidirectional).
        // Must distinguish ["#ff0000", "#00ff00"] from ["interpolate", ...].
        function getColorArray(property) {
            const raw = glLayer.paint?.[property];
            if (Array.isArray(raw) && raw.length > 0 && typeof raw[0] === 'string' && (0, $ed234ca8eb1f5a84$export$892596cec99bc70e).parse(raw[0]) !== undefined) // Array of color strings - parse each individually
            return raw.map((c)=>(0, $ed234ca8eb1f5a84$export$892596cec99bc70e).parse(c));
            // Single value or expression - use getValue
            let val = (0, $90723b470dfea2c1$export$bf7199a9ebcb84a9)(glLayer, 'paint', property, (0, $4f6c3bb417864b02$export$952e2b7e251b8b38), functionCache);
            val = unwrapColor(val);
            return val ? [
                val
            ] : undefined;
        }
        data.highlightColors = getColorArray('hillshade-highlight-color');
        data.highlightColor = data.highlightColors?.[0] || $f7dd1fe8af096dfb$var$defaultHighlightColor;
        if (!data.highlightColors) data.highlightColors = [
            data.highlightColor
        ];
        data.shadowColors = getColorArray('hillshade-shadow-color');
        data.shadowColor = data.shadowColors?.[0] || $f7dd1fe8af096dfb$var$defaultShadowColor;
        if (!data.shadowColors) data.shadowColors = [
            data.shadowColor
        ];
        data.accentColor = unwrapColor((0, $90723b470dfea2c1$export$bf7199a9ebcb84a9)(glLayer, 'paint', 'hillshade-accent-color', (0, $4f6c3bb417864b02$export$952e2b7e251b8b38), functionCache)) || $f7dd1fe8af096dfb$var$defaultAccentColor;
    });
}
const $f7dd1fe8af096dfb$export$29632f825287117f = [
    'raster-saturation',
    'raster-contrast',
    'raster-brightness-max',
    'raster-brightness-min',
    'raster-hue-rotate'
];
function $f7dd1fe8af096dfb$export$5ced81ebac0931cf(glLayer, layer, functionCache) {
    let zoom = null;
    return function(event) {
        if (glLayer.paint && 'raster-opacity' in glLayer.paint && event.frameState.viewState.zoom !== zoom) {
            zoom = event.frameState.viewState.zoom;
            delete functionCache[glLayer.id];
            $f7dd1fe8af096dfb$var$updateRasterLayerProperties(glLayer, layer, zoom, functionCache);
        }
    };
}
/**
 * Updates raster layer opacity from style properties.
 * @param {Object} glLayer The Mapbox/MapLibre Style layer object.
 * @param {import("ol/layer/Base.js").default} layer The OpenLayers layer.
 * @param {number} zoom Current zoom level.
 * @param {Object} functionCache Cache for style functions.
 */ function $f7dd1fe8af096dfb$var$updateRasterLayerProperties(glLayer, layer, zoom, functionCache) {
    (0, $29b6935815fba8a6$export$56ff1d6843523eec).zoom = zoom;
    (0, $29b6935815fba8a6$export$56ff1d6843523eec).distanceFromCenter = 0;
    const opacity = (0, $90723b470dfea2c1$export$bf7199a9ebcb84a9)(glLayer, 'paint', 'raster-opacity', (0, $4f6c3bb417864b02$export$952e2b7e251b8b38), functionCache);
    layer.setOpacity(opacity);
}





/**
 * @typedef {Object} FeatureIdentifier
 * @property {string|number} id The feature id.
 * @property {string} source The source id.
 */ /**
 * @typedef {Object} Options
 * @property {string} [accessToken] Access token for 'mapbox://' urls.
 * @property {function(string, import("./util.js").ResourceType): (Request|string|Response|Promise<Request|string|Response>|void)} [transformRequest]
 * Function for controlling how `ol-mapbox-style` fetches resources. Can be used for modifying
 * the url, adding headers or setting credentials options. Called with the url and the resource
 * type as arguments, this function is supposed to return a `Request`, a url `string` or a `Response`, or a promise tehereof.
 * Without a return value the original request will not be modified.
 * @property {string} [projection='EPSG:3857'] Only useful when working with non-standard projections.
 * Code of a projection registered with OpenLayers. All sources of the style must be provided in this
 * projection. The projection must also have a valid extent defined, which will be used to determine the
 * origin and resolutions of the tile grid for all tiled sources of the style. When provided, the bbox
 * placeholder in tile and geojson urls changes: the default is `{bbox-epsg-3857}`, when projection is e.g.
 * set to `EPSG:4326`, the bbox placeholder will be `{bbox-epsg-4326}`.
 * @property {Array<number>} [resolutions] Only useful when working with non-standard projections.
 * Resolutions for mapping resolution to the `zoom` used in the Mapbox/MapLibre style.
 * @property {string} [styleUrl] URL of the Mapbox GL style. Required for styles that were provided
 * as object, when they contain a relative sprite url, or sources referencing data by relative url.
 * @property {string} [webfonts] Template for resolving webfonts. Can be used to specify where to fetch
 * web fonts when no `ol:webfonts` metadata is set in the style object. See `getFonts()` and the
 * "Font handling" section in `README.md` for details.
 * @property {function(VectorLayer|VectorTileLayer, string):HTMLImageElement|HTMLCanvasElement|string|undefined} [getImage=undefined]
 * Function that returns an image for an icon name. If the result is an HTMLImageElement, it must already be
 * loaded. The layer can be used to call layer.changed() when the loading and processing of the image has finished.
 * This function be used for icons not in the sprite or to override sprite icons.
 * @property {string} [accessTokenParam='access_token'] Access token param. For internal use.
 */ /**
 * @typedef {Object} ApplyStyleOptions
 * @property {string} [source=''] Source. Default is `''`, which causes the first source in the
 * style to be used.
 * @property {Array<string>} [layers] Layers. If no source is provided, the layers with the
 * provided ids will be used from the style's `layers` array. All layers need to use the same source.
 * @property {boolean} [updateSource=true] Update or create vector (tile) layer source with parameters
 * specified for the source in the mapbox style definition.
 */ const $e46a4b1c356c9a29$var$SUPPORTED_LAYER_TYPES = [
    'background',
    'circle',
    'fill',
    'fill-extrusion',
    'line',
    'symbol',
    'raster',
    'hillshade'
];
/**
 * @param {import("ol/proj/Projection.js").default} projection Projection.
 * @param {number} [tileSize] Tile size.
 * @return {Array<number>} Resolutions.
 */ function $e46a4b1c356c9a29$var$getTileResolutions(projection, tileSize = 512) {
    return projection.getExtent() ? (0, $258117a93d01826e$export$38500bbeccc864ff)({
        extent: projection.getExtent(),
        tileSize: tileSize,
        maxZoom: 22
    }).getResolutions() : (0, $4f6c3bb417864b02$export$f1479b9369ff0206);
}
/**
 * @param {string} styleUrl Style URL.
 * @param {Options} options Options.
 * @return {Options} Completed options with accessToken and accessTokenParam.
 */ function $e46a4b1c356c9a29$var$completeOptions(styleUrl, options) {
    if (!options.accessToken) {
        options = Object.assign({}, options);
        const searchParams = new URL(styleUrl).searchParams;
        // The last search parameter is the access token
        searchParams.forEach((value, key)=>{
            options.accessToken = value;
            options.accessTokenParam = key;
        });
    }
    return options;
}
function $e46a4b1c356c9a29$export$d63a6b7859608045(layer, glStyle, sourceOrLayersOrOptions = '', optionsOrPath = {}, resolutions) {
    let styleUrl, sourceId;
    /** @type {Options&ApplyStyleOptions} */ let options;
    let sourceOrLayers;
    let updateSource = true;
    if (typeof sourceOrLayersOrOptions !== 'string' && !Array.isArray(sourceOrLayersOrOptions)) {
        options = sourceOrLayersOrOptions;
        sourceOrLayers = options.source || options.layers;
        optionsOrPath = options;
    } else sourceOrLayers = sourceOrLayersOrOptions;
    if (typeof optionsOrPath === 'string') {
        styleUrl = optionsOrPath;
        options = {};
    } else {
        styleUrl = optionsOrPath.styleUrl;
        options = optionsOrPath;
    }
    if (options.updateSource === false) updateSource = false;
    if (!resolutions) resolutions = options.resolutions;
    if (!styleUrl && typeof glStyle === 'string' && !glStyle.trim().startsWith('{')) styleUrl = glStyle;
    if (styleUrl) {
        styleUrl = styleUrl.startsWith('data:') ? location.href : (0, $10d6e9cfb77b7759$export$c295124411c04466)(styleUrl, options.accessToken);
        options = $e46a4b1c356c9a29$var$completeOptions(styleUrl, options);
    }
    return new Promise(function(resolve, reject) {
        // TODO: figure out where best place to check source type is
        // Note that the source arg is an array of gl layer ids and each must be
        // dereferenced to get source type to validate
        (0, $4f6c3bb417864b02$export$2b5651466f978e42)(glStyle, options).then(function(glStyle) {
            if (glStyle.version != 8) return reject(new Error('glStyle version 8 required.'));
            if (!(layer instanceof (0, $ebf91b069eda61ff$export$2e2bcd8739ae039) || layer instanceof (0, $28d5c8cb633b2bb5$export$2e2bcd8739ae039))) return reject(new Error('Can only apply to VectorLayer or VectorTileLayer'));
            const type = layer instanceof (0, $28d5c8cb633b2bb5$export$2e2bcd8739ae039) ? 'vector' : 'geojson';
            if (!sourceOrLayers) {
                sourceId = glStyle.layers.find(function(layer) {
                    return layer.source && glStyle.sources[layer.source].type === type;
                }).source;
                sourceOrLayers = sourceId;
            } else if (Array.isArray(sourceOrLayers)) sourceId = glStyle.layers.find(function(layer) {
                return layer.id === sourceOrLayers[0];
            }).source;
            else sourceId = sourceOrLayers;
            if (!sourceId) return reject(new Error(`No ${type} source found in the glStyle.`));
            function assignSource() {
                if (!updateSource) return Promise.resolve();
                if (layer instanceof (0, $28d5c8cb633b2bb5$export$2e2bcd8739ae039)) return $e46a4b1c356c9a29$export$d8c8afdddc27b338(glStyle.sources[sourceId], styleUrl, options).then(function(source) {
                    const targetSource = layer.getSource();
                    if (!targetSource) layer.setSource(source);
                    else if (source !== targetSource) {
                        targetSource.setTileUrlFunction(source.getTileUrlFunction());
                        if (typeof targetSource.setUrls === 'function' && typeof source.getUrls === 'function') // to get correct keys for tile cache and queue
                        targetSource.setUrls(source.getUrls());
                        //@ts-ignore
                        if (!targetSource.format_) //@ts-ignore
                        targetSource.format_ = source.format_;
                        if (!targetSource.getAttributions()) targetSource.setAttributions(source.getAttributions());
                        if (targetSource.getTileLoadFunction() === (0, $b191c0e6dd9e9d60$export$7a0df80a606b730e)) targetSource.setTileLoadFunction(source.getTileLoadFunction());
                        if ((0, $2a998b085c5a7ac9$export$fe091d73a555748b)(targetSource.getProjection(), source.getProjection())) //@ts-ignore
                        targetSource.tileGrid = source.getTileGrid();
                    }
                    const tileGrid = layer.getSource().getTileGrid();
                    if (!isFinite(layer.getMaxResolution()) && !isFinite(layer.getMinZoom()) && tileGrid.getMinZoom() > 0) layer.setMaxResolution((0, $4f6c3bb417864b02$export$94fb592f1183c995)(Math.max(0, tileGrid.getMinZoom() - 1e-12), tileGrid.getResolutions()));
                });
                const glSource = glStyle.sources[sourceId];
                let source = layer.getSource();
                if (!source || source.get('mapbox-source') !== glSource) source = $e46a4b1c356c9a29$var$setupGeoJSONSource(glSource, styleUrl, options);
                const targetSource = /** @type {VectorSource} */ layer.getSource();
                if (!targetSource) layer.setSource(source);
                else if (source !== targetSource) {
                    if (!targetSource.getAttributions()) targetSource.setAttributions(source.getAttributions());
                    //@ts-ignore
                    if (!targetSource.format_) //@ts-ignore
                    targetSource.format_ = source.getFormat();
                    //@ts-ignore
                    targetSource.url_ = source.getUrl();
                }
                return Promise.resolve();
            }
            let spriteScale, style;
            const spriteData = {};
            /** @type {import('./stylefunction.js').SpriteImageUrl} */ const spriteImageUrl = {};
            function onChange() {
                if (!style && (!glStyle.sprite || spriteData)) {
                    if (options.projection && !resolutions) {
                        const projection = (0, $2a998b085c5a7ac9$export$3988ae62b71be9a3)(options.projection);
                        const units = projection.getUnits();
                        if (units !== 'm') resolutions = (0, $4f6c3bb417864b02$export$f1479b9369ff0206).map((resolution)=>resolution / (0, $8ebfe5645312696b$export$1482081eec883108)[units]);
                    }
                    let layerProperty;
                    const source = layer.getSource();
                    if (source instanceof (0, $b191c0e6dd9e9d60$export$2e2bcd8739ae039)) //@ts-ignore
                    {
                        if (source.format_ instanceof (0, $76637151dba7e2e2$export$2e2bcd8739ae039)) //@ts-ignore
                        layerProperty = source.format_.layerName_;
                    }
                    style = (0, $90723b470dfea2c1$export$8775234cf93fa7a5)(layer, glStyle, sourceOrLayers, resolutions, spriteData, spriteImageUrl, (fonts, templateUrl = options.webfonts)=>(0, $86a2ca3c041b3852$export$cbcfe4007f417765)(fonts, templateUrl), options.getImage, layerProperty);
                    if (!layer.getStyle()) reject(new Error(`Nothing to show for source [${sourceId}]`));
                    else assignSource().then(resolve).catch(reject);
                } else if (style) {
                    layer.setStyle(style);
                    assignSource().then(resolve).catch(reject);
                } else reject(new Error('Something went wrong trying to apply style.'));
            }
            if (glStyle.sprite) {
                const sprites = (0, $10d6e9cfb77b7759$export$d9ae4eecff2acce1)(glStyle.sprite, options.accessToken, styleUrl || location.href);
                spriteScale = (0, $013e07c1ef6d00ad$export$98fcef3dc9973292) ? 1 : window.devicePixelRatio >= 1.5 ? 0.5 : 1;
                const sizeFactor = spriteScale == 0.5 ? '@2x' : '';
                Promise.all(sprites.map(function(sprite) {
                    const spriteBaseUrl = new URL(sprite.url);
                    let spriteUrl = spriteBaseUrl.origin + spriteBaseUrl.pathname + sizeFactor + '.json' + spriteBaseUrl.search;
                    return new Promise(function(resolve, reject) {
                        (0, $4f6c3bb417864b02$export$c3f39970a2f25d16)('Sprite', spriteUrl, options).then(resolve).catch(function(error) {
                            spriteUrl = spriteBaseUrl.origin + spriteBaseUrl.pathname + '.json' + spriteBaseUrl.search;
                            (0, $4f6c3bb417864b02$export$c3f39970a2f25d16)('Sprite', spriteUrl, options).then(resolve).catch(reject);
                        });
                    }).then(function(spritesJson) {
                        if (spritesJson === undefined) reject(new Error('No sprites found.'));
                        let imageUrl;
                        imageUrl = spriteBaseUrl.origin + spriteBaseUrl.pathname + sizeFactor + '.png' + spriteBaseUrl.search;
                        if (options.transformRequest) {
                            const transformed = options.transformRequest(imageUrl, 'SpriteImage') || imageUrl;
                            if (transformed instanceof Request || transformed instanceof Promise) imageUrl = transformed;
                        }
                        spriteImageUrl[sprite.id] = imageUrl;
                        // add sprite data with prefix according to spec
                        for(const spriteName in spritesJson){
                            const key = sprite.id == 'default' ? spriteName : `${sprite.id}:${spriteName}`;
                            spriteData[key] = spritesJson[spriteName];
                        }
                    }).catch(function(err) {
                        reject(new Error(`Sprites cannot be loaded: ${spriteUrl}: ${err.message}`));
                    });
                })).then(onChange).catch(reject);
            } else onChange();
        }).catch(reject);
    });
}
function $e46a4b1c356c9a29$var$setFirstBackground(mapOrLayer, glStyle, options) {
    glStyle.layers.some(function(layer) {
        if (layer.type === 'background') {
            if (mapOrLayer instanceof (0, $7bdbe21729fecf84$export$2e2bcd8739ae039)) {
                mapOrLayer.setBackground(function(resolution) {
                    return $e46a4b1c356c9a29$var$getBackgroundColor(layer, resolution, options, {});
                });
                return true;
            }
            if (mapOrLayer instanceof (0, $19f0d4d634ca7fe4$export$2e2bcd8739ae039) || mapOrLayer instanceof (0, $c087d5d4d6aeb943$export$2e2bcd8739ae039)) {
                mapOrLayer.getLayers().insertAt(0, $e46a4b1c356c9a29$var$setupBackgroundLayer(layer, options, {}));
                return true;
            }
        }
    });
}
function $e46a4b1c356c9a29$export$8959df0a6ed22f13(mapOrLayer, glStyle, options = {}) {
    return (0, $4f6c3bb417864b02$export$2b5651466f978e42)(glStyle, options).then(function(glStyle) {
        $e46a4b1c356c9a29$var$setFirstBackground(mapOrLayer, glStyle, options);
    });
}
const $e46a4b1c356c9a29$var$REF_INHERITED_PROPS = [
    'type',
    'source',
    'source-layer',
    'minzoom',
    'maxzoom',
    'filter',
    'layout'
];
function $e46a4b1c356c9a29$var$resolveRef(layers, glLayer) {
    if (!glLayer.ref) return glLayer;
    const refLayer = layers.find((layer)=>layer.id === glLayer.ref);
    if (!refLayer) return glLayer;
    const resolved = Object.assign({}, glLayer);
    for (const key of $e46a4b1c356c9a29$var$REF_INHERITED_PROPS)if (!(key in resolved) && key in refLayer) resolved[key] = refLayer[key];
    return resolved;
}
function $e46a4b1c356c9a29$var$extentFromTileJSON(tileJSON, projection) {
    const bounds = tileJSON.bounds;
    if (bounds) {
        const ll = (0, $2a998b085c5a7ac9$export$b15d9668511529b9)([
            bounds[0],
            bounds[1]
        ], projection);
        const tr = (0, $2a998b085c5a7ac9$export$b15d9668511529b9)([
            bounds[2],
            bounds[3]
        ], projection);
        return [
            ll[0],
            ll[1],
            tr[0],
            tr[1]
        ];
    }
    return (0, $2a998b085c5a7ac9$export$3988ae62b71be9a3)(projection).getExtent();
}
function $e46a4b1c356c9a29$var$sourceOptionsFromTileJSON(glSource, tileJSON, options) {
    const tileJSONSource = new (0, $527758ca463865d7$export$2e2bcd8739ae039)({
        tileJSON: tileJSON,
        tileSize: glSource.tileSize || tileJSON.tileSize || 512
    });
    const tileJSONDoc = tileJSONSource.getTileJSON();
    const tileGrid = tileJSONSource.getTileGrid();
    const projection = (0, $2a998b085c5a7ac9$export$3988ae62b71be9a3)(options.projection || 'EPSG:3857');
    const extent = $e46a4b1c356c9a29$var$extentFromTileJSON(tileJSONDoc, projection);
    const projectionExtent = projection.getExtent();
    const minZoom = tileJSONDoc.minzoom || 0;
    const maxZoom = tileJSONDoc.maxzoom || 22;
    /** @type {import("ol/source/VectorTile.js").Options<import("ol/render/Feature.js").default>} */ const sourceOptions = {
        attributions: tileJSONSource.getAttributions(),
        projection: projection,
        tileGrid: new (0, $56db44221d298c30$export$2e2bcd8739ae039)({
            origin: projectionExtent ? (0, $3412ad7bd362b04c$export$cb1538b07e6964ff)(projectionExtent) : tileGrid.getOrigin(0),
            extent: extent || tileGrid.getExtent(),
            minZoom: minZoom,
            resolutions: $e46a4b1c356c9a29$var$getTileResolutions(projection, tileJSON.tileSize).slice(0, maxZoom + 1),
            tileSize: tileGrid.getTileSize(0)
        })
    };
    if (Array.isArray(tileJSONDoc.tiles)) sourceOptions.urls = tileJSONDoc.tiles;
    else sourceOptions.url = tileJSONDoc.tiles;
    return sourceOptions;
}
function $e46a4b1c356c9a29$var$getBackgroundColor(glLayer, resolution, options, functionCache) {
    const background = {
        id: glLayer.id,
        type: glLayer.type
    };
    const paint = glLayer.paint || {};
    background['paint'] = paint;
    (0, $29b6935815fba8a6$export$56ff1d6843523eec).zoom = (0, $4f6c3bb417864b02$export$f8f663988f36f2e1)(resolution, options.resolutions || (0, $4f6c3bb417864b02$export$f1479b9369ff0206));
    (0, $29b6935815fba8a6$export$56ff1d6843523eec).distanceFromCenter = 0;
    let opacity;
    const bg = (0, $90723b470dfea2c1$export$bf7199a9ebcb84a9)(background, 'paint', 'background-color', (0, $4f6c3bb417864b02$export$952e2b7e251b8b38), functionCache);
    if (paint['background-opacity'] !== undefined) opacity = (0, $90723b470dfea2c1$export$bf7199a9ebcb84a9)(background, 'paint', 'background-opacity', (0, $4f6c3bb417864b02$export$952e2b7e251b8b38), functionCache);
    return (0, $90723b470dfea2c1$export$bf7199a9ebcb84a9)(background, 'layout', 'visibility', (0, $4f6c3bb417864b02$export$952e2b7e251b8b38), functionCache) === 'none' ? undefined : (0, $90723b470dfea2c1$export$9e0174a126f113d7)(bg, opacity);
}
/**
 * @param {Object} glLayer Mapbox/MapLibre Style layer object.
 * @param {Options} options Options.
 * @param {Object} functionCache Cache for functions.
 * @return {Layer} OpenLayers layer.
 */ function $e46a4b1c356c9a29$var$setupBackgroundLayer(glLayer, options, functionCache) {
    const div = (0, $013e07c1ef6d00ad$export$98fcef3dc9973292) ? /** @type { HTMLDivElement } */ {
        style: {}
    } : document.createElement('div');
    div.className = 'ol-mapbox-style-background';
    div.style.position = 'absolute';
    div.style.width = '100%';
    div.style.height = '100%';
    return new (0, $7bdbe21729fecf84$export$2e2bcd8739ae039)({
        source: new (0, $039754a80ce105f8$export$2e2bcd8739ae039)({}),
        render (frameState) {
            const color = $e46a4b1c356c9a29$var$getBackgroundColor(glLayer, frameState.viewState.resolution, options, functionCache);
            div.style.backgroundColor = color;
            return div;
        }
    });
}
function $e46a4b1c356c9a29$export$d8c8afdddc27b338(glSource, styleUrl, options) {
    return new Promise(function(resolve, reject) {
        (0, $4f6c3bb417864b02$export$53a539a0cb0d8ede)(glSource, styleUrl, options).then(function({ tileJson: tileJson, tileLoadFunction: tileLoadFunction }) {
            const sourceOptions = $e46a4b1c356c9a29$var$sourceOptionsFromTileJSON(glSource, tileJson, options);
            sourceOptions.tileLoadFunction = tileLoadFunction;
            sourceOptions.format = new (0, $76637151dba7e2e2$export$2e2bcd8739ae039)({
                layerName: 'mvt:layer'
            });
            const source = new (0, $b191c0e6dd9e9d60$export$2e2bcd8739ae039)(sourceOptions);
            source.set('mapbox-source', glSource);
            resolve(source);
        }).catch(reject);
    });
}
function $e46a4b1c356c9a29$var$setupVectorLayer(glSource, styleUrl, options) {
    const layer = new (0, $28d5c8cb633b2bb5$export$2e2bcd8739ae039)({
        declutter: true,
        visible: false
    });
    $e46a4b1c356c9a29$export$d8c8afdddc27b338(glSource, styleUrl, options).then(function(source) {
        layer.setSource(source);
    }).catch(function(error) {
        layer.setSource(undefined);
    });
    return layer;
}
function $e46a4b1c356c9a29$var$getBboxTemplate(projection) {
    const projCode = projection ? projection.getCode() : 'EPSG:3857';
    return `{bbox-${projCode.toLowerCase().replace(/[^a-z0-9]/g, '-')}}`;
}
function $e46a4b1c356c9a29$var$setupRasterSource(glSource, styleUrl, options) {
    return new Promise(function(resolve, reject) {
        (0, $4f6c3bb417864b02$export$53a539a0cb0d8ede)(glSource, styleUrl, options).then(function({ tileJson: tileJson, tileLoadFunction: tileLoadFunction }) {
            const source = new (0, $527758ca463865d7$export$2e2bcd8739ae039)({
                interpolate: options.interpolate === undefined ? true : options.interpolate,
                transition: 0,
                crossOrigin: 'anonymous',
                tileJSON: tileJson
            });
            //@ts-ignore
            source.tileGrid = $e46a4b1c356c9a29$var$sourceOptionsFromTileJSON(glSource, tileJson, options).tileGrid;
            if (options.projection) //@ts-ignore
            source.projection = (0, $2a998b085c5a7ac9$export$3988ae62b71be9a3)(options.projection);
            const getTileUrl = source.getTileUrlFunction();
            if (tileLoadFunction) source.setTileLoadFunction(tileLoadFunction);
            source.setTileUrlFunction(function(tileCoord, pixelRatio, projection) {
                const bboxTemplate = $e46a4b1c356c9a29$var$getBboxTemplate(projection);
                let src = getTileUrl(tileCoord, pixelRatio, projection);
                if (src.indexOf(bboxTemplate) != -1) {
                    const bbox = source.getTileGrid().getTileCoordExtent(tileCoord);
                    src = src.replace(bboxTemplate, bbox.toString());
                }
                return src;
            });
            source.set('mapbox-source', glSource);
            resolve(source);
        }).catch(function(error) {
            reject(error);
        });
    });
}
function $e46a4b1c356c9a29$var$setupRasterLayer(glSource, styleUrl, options) {
    const layer = new (0, $356faab3821ea36b$export$2e2bcd8739ae039)();
    $e46a4b1c356c9a29$var$setupRasterSource(glSource, styleUrl, options).then(function(source) {
        layer.setSource(source);
    }).catch(function() {
        layer.setSource(undefined);
    });
    return layer;
}
/**
 * @param {Object} glSource glStyle source.
 * @param {string} styleUrl Style URL.
 * @param {Options} options Options.
 * @return {VectorSource} Configured vector source.
 */ function $e46a4b1c356c9a29$var$setupGeoJSONSource(glSource, styleUrl, options) {
    const geoJsonFormat = options.projection ? new (0, $efdc8ee71ecdd4b6$export$2e2bcd8739ae039)({
        dataProjection: options.projection
    }) : new (0, $efdc8ee71ecdd4b6$export$2e2bcd8739ae039)();
    const data = glSource.data;
    const sourceOptions = {};
    if (typeof data == 'string') {
        const [geoJsonUrl] = (0, $10d6e9cfb77b7759$export$19109ee3fbff0f51)(data, options.accessToken, options.accessTokenParam || 'access_token', styleUrl || location.href);
        if (/\{bbox-[0-9a-z-]+\}/.test(geoJsonUrl)) {
            const extentUrl = (extent, resolution, projection)=>{
                const bboxTemplate = $e46a4b1c356c9a29$var$getBboxTemplate(projection);
                return geoJsonUrl.replace(bboxTemplate, `${extent.join(',')}`);
            };
            const source = new (0, $747f9d9b478d4c9f$export$2e2bcd8739ae039)({
                attributions: glSource.attribution,
                format: geoJsonFormat,
                loader: (extent, resolution, projection, success, failure)=>{
                    const url = typeof extentUrl === 'function' ? extentUrl(extent, resolution, projection) : extentUrl;
                    (0, $4f6c3bb417864b02$export$c3f39970a2f25d16)('GeoJSON', url, options).then((json)=>{
                        const features = /** @type {*} */ source.getFormat().readFeatures(json, {
                            featureProjection: projection
                        });
                        source.addFeatures(features);
                        success(features);
                    }).catch((response)=>{
                        source.removeLoadedExtent(extent);
                        failure();
                    });
                },
                strategy: (0, $70d62d5d3836dc81$export$bf67010aacbe66fa)
            });
            source.set('mapbox-source', glSource);
            return source;
        }
        const source = new (0, $747f9d9b478d4c9f$export$2e2bcd8739ae039)({
            attributions: glSource.attribution,
            format: geoJsonFormat,
            url: geoJsonUrl,
            loader: (extent, resolution, projection, success, failure)=>{
                (0, $4f6c3bb417864b02$export$c3f39970a2f25d16)('GeoJSON', geoJsonUrl, options).then((json)=>{
                    const features = /** @type {*} */ source.getFormat().readFeatures(json, {
                        featureProjection: projection
                    });
                    source.addFeatures(features);
                    success(features);
                }).catch((response)=>{
                    source.removeLoadedExtent(extent);
                    failure();
                });
            }
        });
        return source;
    }
    sourceOptions.features = geoJsonFormat.readFeatures(data, {
        featureProjection: (0, $2a998b085c5a7ac9$export$3973b77d5f6f2790)() || 'EPSG:3857'
    });
    const source = new (0, $747f9d9b478d4c9f$export$2e2bcd8739ae039)(Object.assign({
        attributions: glSource.attribution,
        format: geoJsonFormat
    }, sourceOptions));
    source.set('mapbox-source', glSource);
    return /** @type {VectorSource} */ source;
}
function $e46a4b1c356c9a29$var$setupGeoJSONLayer(glSource, styleUrl, options) {
    return new (0, $ebf91b069eda61ff$export$2e2bcd8739ae039)({
        declutter: true,
        source: $e46a4b1c356c9a29$var$setupGeoJSONSource(glSource, styleUrl, options),
        visible: false
    });
}
function $e46a4b1c356c9a29$var$manageVisibility(layer, mapOrGroup, functionCache) {
    function onChange() {
        const glStyle = mapOrGroup.get('mapbox-style');
        if (!glStyle) return;
        const mapboxLayers = (0, $ed234ca8eb1f5a84$export$4f143e2847fe5618)(glStyle.layers);
        const layerMapboxLayerids = layer.get('mapbox-layers');
        const visible = mapboxLayers.filter(function(mapboxLayer) {
            return layerMapboxLayerids.includes(mapboxLayer.id);
        }).some(function(mapboxLayer) {
            return !mapboxLayer.layout || (0, $90723b470dfea2c1$export$bf7199a9ebcb84a9)(mapboxLayer, 'layout', 'visibility', (0, $4f6c3bb417864b02$export$952e2b7e251b8b38), functionCache) === 'visible';
        });
        if (layer.get('visible') !== visible) layer.setVisible(visible);
    }
    layer.on('change', onChange);
    onChange();
}
function $e46a4b1c356c9a29$export$d02668d24c725be1(glStyle, styleUrl, glLayer, options) {
    glLayer = $e46a4b1c356c9a29$var$resolveRef(glStyle.layers, glLayer);
    const functionCache = (0, $4f6c3bb417864b02$export$fba1d5e26ba27516)(glStyle);
    const type = glLayer.type;
    let glSourceId = glLayer.source;
    const glSource = glStyle.sources[glSourceId];
    let layer;
    if (type == 'background') {
        layer = $e46a4b1c356c9a29$var$setupBackgroundLayer(glLayer, options, functionCache);
        // background layers do not have a source
        glSourceId = undefined;
    } else if (glSource.type == 'vector') layer = $e46a4b1c356c9a29$var$setupVectorLayer(glSource, styleUrl, options);
    else if (glSource.type == 'raster') {
        const requiresOperations = !!Object.keys(glLayer.paint || {}).find((key)=>{
            return (0, $f7dd1fe8af096dfb$export$29632f825287117f).includes(key);
        });
        if (requiresOperations) {
            const tileLayer = $e46a4b1c356c9a29$var$setupRasterLayer(glSource, styleUrl, options);
            layer = (0, $f7dd1fe8af096dfb$export$38932cf824ad7643)(tileLayer);
            (0, $f7dd1fe8af096dfb$export$e9d5a4f2d683374)(layer, glLayer, options, functionCache);
        } else layer = $e46a4b1c356c9a29$var$setupRasterLayer(glSource, styleUrl, options);
        layer.setVisible(glLayer.layout ? (0, $90723b470dfea2c1$export$bf7199a9ebcb84a9)(glLayer, 'layout', 'visibility', (0, $4f6c3bb417864b02$export$952e2b7e251b8b38), functionCache) !== 'none' : true);
        layer.on('prerender', (0, $f7dd1fe8af096dfb$export$5ced81ebac0931cf)(glLayer, layer, functionCache));
    } else if (glSource.type == 'geojson') layer = $e46a4b1c356c9a29$var$setupGeoJSONLayer(glSource, styleUrl, options);
    else if (glSource.type == 'raster-dem' && glLayer.type == 'hillshade') {
        const tileLayer = $e46a4b1c356c9a29$var$setupRasterLayer(glSource, styleUrl, options);
        layer = (0, $f7dd1fe8af096dfb$export$76e33ad77e40cdbc)(tileLayer);
        (0, $f7dd1fe8af096dfb$export$ddea3c3454e3399)(layer, glSource, glLayer, options, functionCache);
        layer.setVisible(glLayer.layout ? (0, $90723b470dfea2c1$export$bf7199a9ebcb84a9)(glLayer, 'layout', 'visibility', (0, $4f6c3bb417864b02$export$952e2b7e251b8b38), functionCache) !== 'none' : true);
    }
    if (layer) layer.set('mapbox-source', glSourceId);
    return layer;
}
/**
 * @param {*} glStyle Mapbox/MapLibre Style.
 * @param {Map|LayerGroup} mapOrGroup Map or layer group.
 * @param {string} styleUrl Style URL.
 * @param {Options} options Options.
 * @return {Promise} Promise that resolves when the style is loaded.
 */ function $e46a4b1c356c9a29$var$processStyle(glStyle, mapOrGroup, styleUrl, options) {
    if (glStyle.schema) Object.assign((0, $29b6935815fba8a6$export$812e807713593a71), Object.keys(glStyle.schema).reduce((config, key)=>{
        config[key] = glStyle.schema[key]?.default;
        return config;
    }, {}));
    const promises = [];
    let view = null;
    if (mapOrGroup instanceof (0, $19f0d4d634ca7fe4$export$2e2bcd8739ae039)) {
        view = mapOrGroup.getView();
        if (!view.isDef() && !view.getRotation() && !view.getResolutions()) {
            const projection = options.projection ? (0, $2a998b085c5a7ac9$export$3988ae62b71be9a3)(options.projection) : view.getProjection();
            view = new (0, $0ab5c72f1ca22f62$export$2e2bcd8739ae039)(Object.assign(view.getProperties(), {
                maxResolution: (0, $4f6c3bb417864b02$export$f1479b9369ff0206)[0] / (0, $8ebfe5645312696b$export$1482081eec883108)[projection.getUnits()],
                projection: options.projection || view.getProjection()
            }));
            mapOrGroup.setView(view);
        }
        if ('center' in glStyle && !view.getCenter()) view.setCenter((0, $2a998b085c5a7ac9$export$b15d9668511529b9)(glStyle.center, view.getProjection()));
        if ('zoom' in glStyle && view.getZoom() === undefined) view.setResolution((0, $4f6c3bb417864b02$export$f1479b9369ff0206)[0] / (0, $8ebfe5645312696b$export$1482081eec883108)[view.getProjection().getUnits()] / Math.pow(2, glStyle.zoom));
        if (!view.getCenter() || view.getZoom() === undefined) view.fit(view.getProjection().getExtent(), {
            nearest: true,
            size: mapOrGroup.getSize()
        });
    }
    mapOrGroup.set('mapbox-style', glStyle);
    mapOrGroup.set('mapbox-metadata', {
        styleUrl: styleUrl,
        options: options
    });
    const glLayers = glStyle.layers;
    let layerIds = [];
    let layer, glSourceId, id;
    for(let i = 0, ii = glLayers.length; i < ii; ++i){
        const glLayer = $e46a4b1c356c9a29$var$resolveRef(glLayers, glLayers[i]);
        const type = glLayer.type;
        if (!$e46a4b1c356c9a29$var$SUPPORTED_LAYER_TYPES.includes(type)) {
            //FIXME Unsupported layer type
            // eslint-disable-next-line no-console
            console.warn(`layers[${i}].type "${type}" not supported`);
            continue;
        } else {
            id = glLayer.source;
            // this technique assumes gl layers will be in a particular order
            if (!id || id != glSourceId) {
                if (layerIds.length) {
                    promises.push($e46a4b1c356c9a29$export$b62907cd3c5fa3f4(layer, layerIds, glStyle, styleUrl, mapOrGroup, options));
                    layerIds = [];
                }
                layer = $e46a4b1c356c9a29$export$d02668d24c725be1(glStyle, styleUrl, glLayer, options);
                if (!(layer instanceof (0, $ebf91b069eda61ff$export$2e2bcd8739ae039) || layer instanceof (0, $28d5c8cb633b2bb5$export$2e2bcd8739ae039))) layerIds = [];
                glSourceId = layer.get('mapbox-source');
            }
            layerIds.push(glLayer.id);
        }
    }
    promises.push($e46a4b1c356c9a29$export$b62907cd3c5fa3f4(layer, layerIds, glStyle, styleUrl, mapOrGroup, options));
    return Promise.all(promises);
}
function $e46a4b1c356c9a29$export$5635d7ef4b8fee1c(mapOrGroupOrElement, style, options = {}) {
    let promise;
    /** @type {Map|LayerGroup} */ let mapOrGroup;
    if (0, $013e07c1ef6d00ad$export$98fcef3dc9973292) {
        if (!(mapOrGroupOrElement instanceof (0, $19f0d4d634ca7fe4$export$2e2bcd8739ae039)) && !(mapOrGroupOrElement instanceof (0, $c087d5d4d6aeb943$export$2e2bcd8739ae039))) throw new Error('ol-mapbox-style in a web worker requires a Map or a LayerGroup as first argument');
        mapOrGroup = mapOrGroupOrElement;
    } else if (typeof mapOrGroupOrElement === 'string' || mapOrGroupOrElement instanceof HTMLElement) mapOrGroup = new (0, $19f0d4d634ca7fe4$export$2e2bcd8739ae039)({
        target: mapOrGroupOrElement
    });
    else mapOrGroup = mapOrGroupOrElement;
    if (typeof style === 'string') {
        const styleUrl = style.startsWith('data:') ? location.href : (0, $10d6e9cfb77b7759$export$c295124411c04466)(style, options.accessToken);
        options = $e46a4b1c356c9a29$var$completeOptions(styleUrl, options);
        promise = new Promise(function(resolve, reject) {
            (0, $4f6c3bb417864b02$export$2b5651466f978e42)(style, options).then(function(glStyle) {
                $e46a4b1c356c9a29$var$processStyle(glStyle, mapOrGroup, styleUrl, options).then(function() {
                    resolve(mapOrGroup);
                }).catch(reject);
            }).catch(function(err) {
                reject(new Error(`Could not load ${style}: ${err.message}`));
            });
        });
    } else promise = new Promise(function(resolve, reject) {
        $e46a4b1c356c9a29$var$processStyle(style, mapOrGroup, !options.styleUrl || options.styleUrl.startsWith('data:') ? location.href : (0, $10d6e9cfb77b7759$export$c295124411c04466)(options.styleUrl, options.accessToken), options).then(function() {
            resolve(mapOrGroup);
        }).catch(reject);
    });
    return promise;
}
function $e46a4b1c356c9a29$export$b62907cd3c5fa3f4(layer, layerIds, glStyle, styleUrl, mapOrGroup, options = {}) {
    let minZoom = 24;
    let maxZoom = 0;
    const glLayers = glStyle.layers;
    for(let i = 0, ii = glLayers.length; i < ii; ++i){
        const glLayer = glLayers[i];
        if (layerIds.indexOf(glLayer.id) !== -1) {
            minZoom = Math.min('minzoom' in glLayer ? glLayer.minzoom : 0, minZoom);
            maxZoom = Math.max('maxzoom' in glLayer ? glLayer.maxzoom : 24, maxZoom);
        }
    }
    return new Promise(function(resolve, reject) {
        const setStyle = function() {
            const source = layer.getSource();
            if (!source || source.getState() === 'error') {
                reject(new Error('Error accessing data for source ' + layer.get('mapbox-source')));
                return;
            }
            if ('getTileGrid' in source) {
                const tileGrid = /** @type {import("ol/source/Tile.js").default|import("ol/source/VectorTile.js").default} */ source.getTileGrid();
                if (tileGrid) {
                    const sourceMinZoom = tileGrid.getMinZoom();
                    if (minZoom > 0 || sourceMinZoom > 0) layer.setMaxResolution(Math.min((0, $4f6c3bb417864b02$export$94fb592f1183c995)(Math.max(0, minZoom - 1e-12), (0, $4f6c3bb417864b02$export$f1479b9369ff0206)), (0, $4f6c3bb417864b02$export$94fb592f1183c995)(Math.max(0, sourceMinZoom - 1e-12), tileGrid.getResolutions())));
                    if (maxZoom < 24) layer.setMinResolution((0, $4f6c3bb417864b02$export$94fb592f1183c995)(maxZoom, (0, $4f6c3bb417864b02$export$f1479b9369ff0206)));
                }
            } else if (minZoom > 0) layer.setMaxResolution((0, $4f6c3bb417864b02$export$94fb592f1183c995)(Math.max(0, minZoom - 1e-12), (0, $4f6c3bb417864b02$export$f1479b9369ff0206)));
            if (source instanceof (0, $747f9d9b478d4c9f$export$2e2bcd8739ae039) || source instanceof (0, $b191c0e6dd9e9d60$export$2e2bcd8739ae039)) $e46a4b1c356c9a29$export$d63a6b7859608045(/** @type {import("ol/layer/Vector.js").default|import("ol/layer/VectorTile.js").default} */ layer, glStyle, layerIds, Object.assign({
                styleUrl: styleUrl
            }, options)).then(function() {
                $e46a4b1c356c9a29$var$manageVisibility(layer, mapOrGroup, (0, $4f6c3bb417864b02$export$fba1d5e26ba27516)(glStyle));
                resolve();
            }).catch(reject);
            else resolve();
        };
        layer.set('mapbox-layers', layerIds);
        const layers = mapOrGroup.getLayers();
        if (layers.getArray().indexOf(layer) === -1) layers.push(layer);
        if (layer.getSource()) setStyle();
        else layer.once('change:source', setStyle);
    });
}
function $e46a4b1c356c9a29$export$9b04d3706d6abeb0(mapOrGroup, layerId) {
    const style = mapOrGroup.get('mapbox-style');
    const layerStyle = style.layers.find(function(layer) {
        return layer.id === layerId;
    });
    return layerStyle;
}
function $e46a4b1c356c9a29$export$1580f922a08f5726(mapOrGroup, mapboxLayer, beforeLayerId) {
    const glStyle = mapOrGroup.get('mapbox-style');
    const mapboxLayers = glStyle.layers;
    let spliceIndex;
    let sourceIndex = -1;
    if (beforeLayerId !== undefined) {
        const beforeMapboxLayer = $e46a4b1c356c9a29$export$9b04d3706d6abeb0(mapOrGroup, beforeLayerId);
        if (beforeMapboxLayer === undefined) throw new Error(`Layer with id "${beforeLayerId}" not found.`);
        spliceIndex = mapboxLayers.indexOf(beforeMapboxLayer);
    } else spliceIndex = mapboxLayers.length;
    let sourceOffset;
    if (spliceIndex > 0 && mapboxLayers[spliceIndex - 1].source === mapboxLayer.source) {
        sourceIndex = spliceIndex - 1;
        sourceOffset = -1;
    } else if (spliceIndex < mapboxLayers.length && mapboxLayers[spliceIndex].source === mapboxLayer.source) {
        sourceIndex = spliceIndex;
        sourceOffset = 0;
    }
    if (sourceIndex === -1) {
        const { options: options, styleUrl: styleUrl } = mapOrGroup.get('mapbox-metadata');
        const layer = $e46a4b1c356c9a29$export$d02668d24c725be1(glStyle, styleUrl, mapboxLayer, options);
        if (beforeLayerId) {
            const beforeLayer = $e46a4b1c356c9a29$export$f5b74d0d242cec02(mapOrGroup, beforeLayerId);
            const beforeLayerIndex = mapOrGroup.getLayers().getArray().indexOf(beforeLayer);
            mapOrGroup.getLayers().insertAt(beforeLayerIndex, layer);
        }
        mapboxLayers.splice(spliceIndex, 0, mapboxLayer);
        return $e46a4b1c356c9a29$export$b62907cd3c5fa3f4(layer, [
            mapboxLayer.id
        ], glStyle, styleUrl, mapOrGroup, options);
    }
    if (mapboxLayers.some((layer)=>layer.id === mapboxLayer.id)) throw new Error(`Layer with id "${mapboxLayer.id}" already exists.`);
    const sourceLayerId = mapboxLayers[sourceIndex].id;
    const args = (0, $90723b470dfea2c1$export$ce8063ac6ec145f8)[(0, $4f6c3bb417864b02$export$2e9c16762be40bb0)(mapOrGroup.get('mapbox-style'), $e46a4b1c356c9a29$export$f5b74d0d242cec02(mapOrGroup, sourceLayerId))];
    mapboxLayers.splice(spliceIndex, 0, mapboxLayer);
    if (args) {
        const [olLayer, glStyle, sourceOrLayers, resolutions, spriteData, spriteImageUrl, getFonts, getImage] = args;
        if (Array.isArray(sourceOrLayers)) {
            const layerIndex = sourceOrLayers.indexOf(sourceLayerId) + sourceOffset;
            sourceOrLayers.splice(layerIndex, 0, mapboxLayer.id);
        }
        (0, $90723b470dfea2c1$export$8775234cf93fa7a5)(olLayer, glStyle, sourceOrLayers, resolutions, spriteData, spriteImageUrl, getFonts, getImage);
    } else $e46a4b1c356c9a29$export$f5b74d0d242cec02(mapOrGroup, mapboxLayers[sourceIndex].id).changed();
    return Promise.resolve();
}
function $e46a4b1c356c9a29$export$b73b57f3f51d7d2c(mapOrGroup, mapboxLayer) {
    const glStyle = mapOrGroup.get('mapbox-style');
    const mapboxLayers = glStyle.layers;
    const index = mapboxLayers.findIndex(function(layer) {
        return layer.id === mapboxLayer.id;
    });
    if (index === -1) throw new Error(`Layer with id "${mapboxLayer.id}" not found.`);
    const oldLayer = mapboxLayers[index];
    if (oldLayer.source !== mapboxLayer.source) throw new Error('Updated layer and previous version must use the same source.');
    delete (0, $4f6c3bb417864b02$export$fba1d5e26ba27516)(glStyle)[mapboxLayer.id];
    delete (0, $4f6c3bb417864b02$export$330c4a8ebe9a8d1e)(glStyle)[mapboxLayer.id];
    mapboxLayers[index] = mapboxLayer;
    const args = (0, $90723b470dfea2c1$export$ce8063ac6ec145f8)[(0, $4f6c3bb417864b02$export$2e9c16762be40bb0)(mapOrGroup.get('mapbox-style'), $e46a4b1c356c9a29$export$f5b74d0d242cec02(mapOrGroup, mapboxLayer.id))];
    if (args) {
        (0, $90723b470dfea2c1$export$8775234cf93fa7a5).apply(undefined, args);
        return Promise.resolve();
    }
    const layer = $e46a4b1c356c9a29$export$f5b74d0d242cec02(mapOrGroup, mapboxLayer.id);
    const { options: options, styleUrl: styleUrl } = mapOrGroup.get('mapbox-metadata');
    return $e46a4b1c356c9a29$export$b62907cd3c5fa3f4(layer, [
        mapboxLayer.id
    ], glStyle, styleUrl, mapOrGroup, options);
}
function $e46a4b1c356c9a29$export$5dd9fc9b8369ac23(mapOrGroup, id, mapboxSource) {
    const currentSource = $e46a4b1c356c9a29$export$dd2b6e807fb37ba3(mapOrGroup, id);
    const layers = /** @type {Array<VectorLayer|TileLayer|VectorTileLayer>} */ mapOrGroup.getLayers().getArray().filter(function(layer) {
        return (layer instanceof (0, $ebf91b069eda61ff$export$2e2bcd8739ae039) || layer instanceof (0, $356faab3821ea36b$export$2e2bcd8739ae039) || layer instanceof (0, $28d5c8cb633b2bb5$export$2e2bcd8739ae039)) && layer.getSource() === currentSource;
    });
    const metadata = mapOrGroup.get('mapbox-metadata');
    let newSourcePromise;
    switch(mapboxSource.type){
        case 'vector':
            newSourcePromise = $e46a4b1c356c9a29$export$d8c8afdddc27b338(mapboxSource, metadata.styleUrl, metadata.options);
            break;
        case 'geojson':
            newSourcePromise = Promise.resolve($e46a4b1c356c9a29$var$setupGeoJSONSource(mapboxSource, metadata.styleUrl, metadata.options));
            break;
        case 'raster':
        case 'raster-dem':
            newSourcePromise = $e46a4b1c356c9a29$var$setupRasterSource(mapboxSource, metadata.styleUrl, metadata.options);
            break;
        default:
            return Promise.reject(new Error('Unsupported source type ' + mapboxSource.type));
    }
    newSourcePromise.then(function(newSource) {
        layers.forEach(function(layer) {
            layer.setSource(newSource);
        });
    });
    return newSourcePromise;
}
function $e46a4b1c356c9a29$export$58a28e5dd6d8a0e2(mapOrGroup, mapboxLayerIdOrLayer) {
    const mapboxLayerId = typeof mapboxLayerIdOrLayer === 'string' ? mapboxLayerIdOrLayer : mapboxLayerIdOrLayer.id;
    const layer = $e46a4b1c356c9a29$export$f5b74d0d242cec02(mapOrGroup, mapboxLayerId);
    /** @type {Array<Object>} */ const layerMapboxLayers = layer.get('mapbox-layers');
    if (layerMapboxLayers.length === 1) throw new Error('Cannot remove last Mapbox layer from an OpenLayers layer.');
    layerMapboxLayers.splice(layerMapboxLayers.indexOf(mapboxLayerId), 1);
    const glStyle = mapOrGroup.get('mapbox-style');
    const layers = glStyle.layers;
    layers.splice(layers.findIndex((layer)=>layer.id === mapboxLayerId), 1);
    const args = (0, $90723b470dfea2c1$export$ce8063ac6ec145f8)[(0, $4f6c3bb417864b02$export$2e9c16762be40bb0)(glStyle, layer)];
    if (args) {
        const [olLayer, glStyle, sourceOrLayers, resolutions, spriteData, spriteImageUrl, getFonts, getImage] = args;
        if (Array.isArray(sourceOrLayers)) sourceOrLayers.splice(sourceOrLayers.findIndex((layer)=>layer === mapboxLayerId), 1);
        (0, $90723b470dfea2c1$export$8775234cf93fa7a5)(olLayer, glStyle, sourceOrLayers, resolutions, spriteData, spriteImageUrl, getFonts, getImage);
    } else $e46a4b1c356c9a29$export$f5b74d0d242cec02(mapOrGroup, mapboxLayerId).changed();
}
function $e46a4b1c356c9a29$export$f5b74d0d242cec02(map, layerId) {
    const layers = map.getLayers().getArray();
    for(let i = 0, ii = layers.length; i < ii; ++i){
        const mapboxLayers = layers[i].get('mapbox-layers');
        if (mapboxLayers && mapboxLayers.indexOf(layerId) !== -1) return /** @type {Layer} */ layers[i];
    }
    return undefined;
}
function $e46a4b1c356c9a29$export$61f6a9c831786408(map, sourceId) {
    const result = [];
    const layers = map.getLayers().getArray();
    for(let i = 0, ii = layers.length; i < ii; ++i)if (layers[i].get('mapbox-source') === sourceId) result.push(/** @type {Layer} */ layers[i]);
    return result;
}
function $e46a4b1c356c9a29$export$dd2b6e807fb37ba3(map, sourceId) {
    const layers = map.getLayers().getArray();
    for(let i = 0, ii = layers.length; i < ii; ++i){
        const source = /** @type {Layer} */ layers[i].getSource();
        if (layers[i].get('mapbox-source') === sourceId) return source;
    }
    return undefined;
}
function $e46a4b1c356c9a29$export$bed5a5469370c50d(mapOrLayer, feature, state) {
    const layers = 'getLayers' in mapOrLayer ? $e46a4b1c356c9a29$export$61f6a9c831786408(mapOrLayer, feature.source) : [
        mapOrLayer
    ];
    for(let i = 0, ii = layers.length; i < ii; ++i){
        const featureState = layers[i].get('mapbox-featurestate');
        if (featureState) {
            if (state) featureState[feature.id] = state;
            else delete featureState[feature.id];
            layers[i].changed();
        } else throw new Error(`Map or layer for source "${feature.source}" not found.`);
    }
}
function $e46a4b1c356c9a29$export$c8c54cead17ad7fa(mapOrLayer, feature) {
    const layers = 'getLayers' in mapOrLayer ? $e46a4b1c356c9a29$export$61f6a9c831786408(mapOrLayer, feature.source) : [
        mapOrLayer
    ];
    for(let i = 0, ii = layers.length; i < ii; ++i){
        const featureState = layers[i].get('mapbox-featurestate');
        if (featureState && featureState[feature.id]) return featureState[feature.id];
    }
    return undefined;
}









/** @typedef {import("ol/Map.js").default} Map */ /**
 * Event emitted on configuration or loading error.
 */ class $4171a8b46894fc3e$var$ErrorEvent extends (0, $bc90848f8b15fa29$export$2e2bcd8739ae039) {
    /**
   * @param {Error} error error object.
   */ constructor(error){
        super((0, $8bf15f3d9474ce85$export$2e2bcd8739ae039).ERROR);
        /**
     * @type {Error}
     */ this.error = error;
    }
}
class $4171a8b46894fc3e$export$2e2bcd8739ae039 extends (0, $28d5c8cb633b2bb5$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Layer options.  At a minimum, `styleUrl` and `accessToken`
   * must be provided.
   */ constructor(options){
        const declutter = 'declutter' in options ? options.declutter : true;
        const source = new (0, $b191c0e6dd9e9d60$export$2e2bcd8739ae039)({
            state: 'loading',
            format: new (0, $76637151dba7e2e2$export$2e2bcd8739ae039)({
                layerName: 'mvt:layer'
            })
        });
        super({
            source: source,
            background: options.background === false ? null : options.background,
            declutter: declutter,
            extent: options.extent,
            className: options.className,
            opacity: options.opacity,
            visible: options.visible,
            zIndex: options.zIndex,
            minResolution: options.minResolution,
            maxResolution: options.maxResolution,
            minZoom: options.minZoom,
            maxZoom: options.maxZoom,
            renderOrder: options.renderOrder,
            renderBuffer: options.renderBuffer,
            renderMode: options.renderMode,
            map: options.map,
            updateWhileAnimating: options.updateWhileAnimating,
            updateWhileInteracting: options.updateWhileInteracting,
            preload: options.preload,
            useInterimTilesOnError: options.useInterimTilesOnError,
            properties: options.properties
        });
        if (options.accessToken) this.accessToken = options.accessToken;
        const url = options.styleUrl;
        const promises = [
            (0, $e46a4b1c356c9a29$export$d63a6b7859608045)(this, url, options.layers || options.source, {
                accessToken: this.accessToken
            })
        ];
        if (this.getBackground() === undefined) promises.push((0, $e46a4b1c356c9a29$export$8959df0a6ed22f13)(this, options.styleUrl, {
            accessToken: this.accessToken
        }));
        Promise.all(promises).then(()=>{
            source.setState('ready');
        }).catch((error)=>{
            this.dispatchEvent(new $4171a8b46894fc3e$var$ErrorEvent(error));
            const source = this.getSource();
            source.setState('error');
        });
    }
}






var $7ae1bfb84f8f0c4f$exports = {};
$7ae1bfb84f8f0c4f$exports = JSON.parse("{\"version\":8,\"name\":\"kiinteisto-avoin\",\"center\":[24.91769,60.169455],\"zoom\":15,\"glyphs\":\"https://beta-karttakuva.maanmittauslaitos.fi/glyphs/{fontstack}/{range}.pbf\",\"sources\":{\"rasteritaustakartta\":{\"type\":\"raster\",\"tileSize\":256,\"tiles\":[\"https://avoin-karttakuva.maanmittauslaitos.fi/avoin/wmts/1.0.0/taustakartta/default/WGS84_Pseudo-Mercator/{z}/{y}/{x}.png?api-key=7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2\"]},\"kiinteisto-avoin\":{\"type\":\"vector\",\"url\":\"https://avoin-karttakuva.maanmittauslaitos.fi/kiinteisto-avoin/v3/kiinteistojaotus/WGS84_Pseudo-Mercator/tilejson.json?api-key=7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2\"}},\"layers\":[{\"id\":\"background\",\"type\":\"background\",\"paint\":{\"background-color\":\"white\"}},{\"id\":\"taustakartta\",\"type\":\"raster\",\"source\":\"rasteritaustakartta\"},{\"id\":\"PalstanSijaintitiedot\",\"type\":\"fill\",\"source\":\"kiinteisto-avoin\",\"source-layer\":\"PalstanSijaintitiedot\",\"minzoom\":9,\"paint\":{\"fill-color\":\"rgba(255,255,255,0.05)\"}},{\"id\":\"KiinteistorajanSijaintitiedot\",\"type\":\"line\",\"source\":\"kiinteisto-avoin\",\"source-layer\":\"KiinteistorajanSijaintitiedot\",\"filter\":[\"==\",[\"geometry-type\"],\"LineString\"],\"minzoom\":9,\"paint\":{\"line-color\":\"rgba(255,0,0,1)\",\"line-width\":1}},{\"id\":\"RajamerkinSijaintitiedot\",\"type\":\"circle\",\"source\":\"kiinteisto-avoin\",\"source-layer\":\"RajamerkinSijaintitiedot\",\"minzoom\":11,\"filter\":[\"==\",[\"geometry-type\"],\"Point\"],\"paint\":{\"circle-stroke-color\":\"rgba(255,255,255,1)\",\"circle-color\":\"rgba(255,0,0,1)\",\"circle-radius\":3}},{\"id\":\"KiinteistotunnuksenSijaintitiedot\",\"type\":\"symbol\",\"source\":\"kiinteisto-avoin\",\"source-layer\":\"KiinteistotunnuksenSijaintitiedot\",\"minzoom\":12,\"layout\":{\"text-field\":\"{kiinteistotunnuksenEsitysmuoto}\",\"text-font\":[\"Liberation Sans NLSFI\"],\"symbol-placement\":\"point\",\"text-size\":16},\"paint\":{\"text-color\":\"#000\",\"text-halo-color\":\"#fff\",\"text-halo-width\":1.5,\"text-halo-blur\":1}},{\"id\":\"RajamerkinSijaintitiedot_tunnus\",\"type\":\"symbol\",\"source\":\"kiinteisto-avoin\",\"source-layer\":\"RajamerkinSijaintitiedot\",\"minzoom\":12,\"layout\":{\"text-field\":\"{numero}\",\"text-font\":[\"Liberation Sans NLSFI\"],\"symbol-placement\":\"point\",\"text-size\":12},\"paint\":{\"text-color\":\"#800000\",\"text-halo-color\":\"#fff\",\"text-halo-width\":1.5,\"text-halo-blur\":1}}],\"id\":\"kiinteisto-avoin\"}");


// only boundaries
//import style from './kiinteistojaotus.json';
// let's create the map
const $0cf146259d57657d$var$map = new (0, $19f0d4d634ca7fe4$export$2e2bcd8739ae039)({
    target: 'map'
});
(0, $e46a4b1c356c9a29$export$5635d7ef4b8fee1c)($0cf146259d57657d$var$map, (0, (/*@__PURE__*/$parcel$interopDefault($7ae1bfb84f8f0c4f$exports)))).then(function(map) {
// done
});


//# sourceMappingURL=build-ol-webmercator.039701be.js.map
